/** DO NOT EDIT - THIS FILE IS AUTOGENERATED BY graphql-to-typescript-converter */
import { gql } from '@ppl/utils/graphql.utils';

export type UUID = string;

export type StepChecklistVisibilityFilterJSONString = string;

export type ReportSchemaJSONString = string;

export type ReportScheduleSchemaJSONString = string;

export type ProductPriceListPriceSettingsJSONString = string;

export type ProcessSchemaJSONString = string;

export type Long = string;

export type JSONString = string;

export type InterfacePreviewSettingsJSONString = string;

export type InterfacePreviewCustomSettingsJSONString = string;

export type ID = string;

export type FitnessIndicatorSettingsJSONString = string;

export type FieldOptionsPropertyJSONString = string;

export type FieldMappingTemplateJSONString = string;

export type EntityTypeSettingsJSONString = string;

export type EntityTypeFieldMappingJSONString = string;

export type EntitySettingsDefaultListColumnsJSONString = string;

export type EntityScoringSettingsJSONString = string;

export type EntityHealthSettingsJSONString = string;

export type EntityApiName = string;

export type EmailSequenceSchemaJSONString = string;

export type DrilldownFilterJSONString = string;

export type DateTime = string;

export type GqlDate = string;

export type ComplexEventIdType = string;

export type BetterDashboardSchemaJSONString = string;

export type Base64 = string;

export type SiblingBoxRelationType = AggregationRelation | HardcodedRelation;

export type SessionMetadata = GenericSessionMetadata | ProfileSessionMetadata;

export type ReportValueField = CalculatedField | ConvertedCurrencyField | SummaryField;

export type ReportSettings = BetterDashboardSchema | DashboardSchema | ForecastSchema | ReportSchema;

export type ReportHistory = ReportComparisonDatesHistory | ReportHistoricalTrendHistory;

export type ProcessTrigger = ProcessManualTrigger | ProcessOnlineFormTrigger | ProcessRecordTrigger | ProcessScheduleTrigger;

export type OrgChartContactUnion = ContactEntity | GhostContactEntity;

export type OnlineFormItem = OnlineFormContainer | OnlineFormSection;

export type LeadOpportunityEntity = LeadEntity | OpportunityEntity;

export type InterfacePreviewSettings = ListChart | ReportChart;

export type ForecastPipelineViewItems = OpportunityArchivePipelineViewItems | OpportunityPipelineViewItems;

export type ForecastPipelineViewItem = PipelineArchiveViewItem | PipelineViewItem;

export type FieldOptionsProperty = AccountCardProperty | AdvancedFormulaProperty | ClosingDateProperty | ContactAccountCardProperty | ContactCardProperty | CurrencyForeignProperty | CurrencyProperty | DueDateProperty | FileUploadProperty | FloatProperty | GenderProperty | IntegerProperty | LinkedItemsProperty | LookupSettingsProperty | MultiSelectProperty | OnlineFormProductServicesProperty | OpptyCardProperty | ParentAccountCardProperty | ProductPriceProperty | ProjectAccountCardProperty | ProjectContactCardProperty | RollupProperty | TextAreaProperty;

export type DashboardChartSeriesItem = DashboardChartSeriesValueItem | DashboardChartSeriesXYItem;

export type DashboardChartData = DashboardAgendaData | DashboardGridData | DashboardInsightsData | DashboardKpiData | DashboardKpiListData | DashboardListChartData | DashboardOpportunitiesTrendData | DashboardPipelineConversionsChartData | DashboardReportChartData | DashboardTargetData | DashboardTileData;

export type DashboardChart = DashboardAgenda | DashboardGrid | DashboardInsights | DashboardKpi | DashboardKpiList | DashboardOpportunitiesTrend | DashboardPipelineConversionsChart | DashboardQuickLinks | DashboardReportChart | DashboardSection | DashboardTarget | DashboardTargetTab | DashboardTile | ForecastSchema | ReportSchema;

export type ConversionsOpportunityTakenPath = ConversionsOpportunityAmountTakenPath | ConversionsOpportunityCountTakenPath;

export type ConversionsOpportunityCreatedPath = ConversionsOpportunityAmountCreatedPath | ConversionsOpportunityCountCreatedPath;

export type ConversionsLeadTakenPath = ConversionLeadAmountPath | ConversionsLeadCountTakenPath;

export type ConversionLeadCreatedPath = ConversionLeadAmountPath | ConversionLeadCountCreatedPath;

export type ConversionGraphItem = ConversionGraphAmountItem | ConversionGraphCountItem;

export type ChangeLogValueObject = ChangeLogAccountClassValue | ChangeLogAttendeeEmailsValue | ChangeLogBooleanValue | ChangeLogDateValue | ChangeLogDatetimeValue | ChangeLogDropdownValue | ChangeLogEntityListValue | ChangeLogFloatValue | ChangeLogForeignCurrencyValue | ChangeLogGenderValue | ChangeLogGeoLocationValue | ChangeLogIntValue | ChangeLogLabelFlagValue | ChangeLogLeadStatusValue | ChangeLogMeetingValue | ChangeLogMultiCheckboxValue | ChangeLogOpptyStatusValue | ChangeLogPriorityValue | ChangeLogQuoteStatusValue | ChangeLogShareModeValue | ChangeLogStringValue | ChangeLogTagsValue | ChangeLogTaskStatusValue | ChangeLogUuidValue;

export type ApprovalProcessTrigger = ApprovalProcessManualTrigger | ApprovalProcessRecordTrigger;

export type AiScreenView = AccountCompactView | AccountListView | ActivityListView | CalendarView | ContactCompactView | ContactListView | CustomEntityListView | FeedView | LeadBoardView | LeadCompactView | LeadListView | NavigatorView | OnlineFormTypeDetailView | OnlineFormTypeListView | OpportunityCompactView | OpportunityListView | PipelineView | ProcessDetailView | ProcessListView | ProcessTemplatesView | ProjectListView | QuoteBoardView | QuoteListView | RecordDetailView | ReportView | TaskBoardView;

export type AiMessageData = AiExampleData | AiSuggestionData;

export type AiAssistantTaskAction = AiAssistantCreateEmailAction | AiAssistantCreateNoteAction | AiAssistantCreateRecordAction | AiAssistantUpdateFormAction;

export interface VisibleBoxInterface {
  __typename?: string;
  displayFields: DisplayFieldItem[];
  name: string;
}

export type VisibleBoxInterfaceImplementors = ReportMainBox | ReportSiblingBox;

export interface ViewReportTab {
  __typename?: string;
  chart: ReportChart;
  currencyId: UUID;
  frozenPanes: FrozenPaneType;
  history: ReportHistory | null;
  reportValueFields: ReportValueField[];
}

export type ViewReportTabImplementors = ViewPivotReportTab | ViewTableReportTab;

export interface ViewItemInterface {
  __typename?: string;
  id: ID;
}

export type ViewItemInterfaceImplementors = AccountCompactViewItem | AppointmentCalendarViewItem | ContactCompactViewItem | CustomEntityCompactViewItem | DataGridViewItem | DataGridViewItemWithAvailability | DocumentDataGridViewItem | LeadArchiveBoardViewItem | LeadBoardViewItem | LeadCompactViewItem | OpportunityArchiveCompactViewItem | OpportunityBubbleViewItem | OpportunityCompactViewItem | PipelineArchiveViewItem | PipelineViewItem | ProductDataItem | ProjectCompactViewItem | QuoteArchiveBoardViewItem | QuoteBoardViewItem | QuoteCompactViewItem | TaskBoardViewItem | TaskCalendarViewItem | WhiteSpaceDataItem;

export interface TimeframeProfileInterface {
  __typename?: string;
  filter: TimeframeFilterTab;
}

export type TimeframeProfileInterfaceImplementors = TimeframePivotReportProfile | TimeframeTableReportProfile;

export interface TeamPipelineHubInterface {
  __typename?: string;
  id: ID;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export type TeamPipelineHubInterfaceImplementors = AiAssistantTeamPipelineHubItemEntity | AiVoyagerTwoTeamPipelineHubItemEntity | AlfrescoPipelineHubItemEntity | DomainExtractorTeamPipelineHubItemEntity | HubspotTeamPipelineHubItemEntity | JiraSyncTeamPipelineHubItemEntity | LocationTrackingPipelineHubItemEntity | MsDynamicsTeamPipelineHubItemEntity | ProductPricingPipelineHubItemEntity | SalesforceTeamPipelineHubItemEntity | SqlExportTeamPipelineHubItemEntity | TeamPipelineHubItemEntity | WhatsAppTeamPipelineHubItemEntity | ZendeskTeamPipelineHubItemEntity;

export interface TargetTabInterface {
  __typename?: string;
  targetPeriodCurrent: PeriodOption;
  targetValueFieldId: ID;
}

export type TargetTabInterfaceImplementors = NavigatorTargetTab | OpportunityArchiveTargetTab | OpportunityPreviewTargetTab | OpportunityReportTargetTab;

export interface TargetProfileInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  target: TargetTabInterfaceImplementors;
}

export type TargetProfileInterfaceImplementors = LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityPreviewProfile;

export interface TableReportTabsInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  view: ViewTableReportTab;
}

export type TableReportTabsInterfaceImplementors = AccountTableReportProfile | ActivityTableReportProfile | ContactTableReportProfile | CustomEntityTableReportProfile | EmailTableReportProfile | FeedTableReportProfile | LeadOpportunityTableReportProfile | NoteTableReportProfile | ProductTableReportProfile | ProjectTableReportProfile | QuoteTableReportProfile | TimeframeTableReportProfile;

export interface SnapshotIndexedDataInterface {
  __typename?: string;
  items: ViewItemInterfaceImplementors[];
  sessionId: string;
  total: number;
}

export type SnapshotIndexedDataInterfaceImplementors = AccountActivityTabDataGridView | AccountArchiveDataGridViewItems | AccountChildAccountTabDataGridView | AccountCloudObjectTabDataGridView | AccountCompactViewItems | AccountContactTabDataGridView | AccountDataGridViewItems | AccountDrilldownDataGridViewItems | AccountHierarchyTabDataGridView | AccountLeadTabDataGridView | AccountNoteTabDataGridView | AccountOpportunityTabDataGridView | AccountProductPricingTabDataGridView | AccountProjectTabDataGridView | AccountQuoteTabDataGridView | ActivityDataGridViewItems | ActivityDrilldownDataGridViewItems | ActivityTaskBoardColumnItems | ApprovalDataGridViewItems | CloudObjectDataGridViewItems | CompanyDocumentsDataGridViewItems | ContactActivityTabDataGridView | ContactArchiveDataGridViewItems | ContactCloudObjectTabDataGridView | ContactCompactViewItems | ContactDataGridViewItems | ContactLeadTabDataGridView | ContactNoteTabDataGridView | ContactOpportunityTabDataGridView | ContactProjectTabDataGridView | ContactQuoteTabDataGridView | CustomEntityActivityTabDataGridView | CustomEntityCloudObjectTabDataGridView | CustomEntityCompactViewItems | CustomEntityDataGridViewItems | CustomEntityNoteTabDataGridView | CustomOpportunityDataGridViewItems | ForecastDataGridViewItems | GenericDrilldownDataGridViewItems | GroupTargetDataGridViewItems | LeadActivityTabDataGridView | LeadArchiveBoardColumnItems | LeadArchiveDataGridViewItems | LeadBoardColumnItems | LeadCloudObjectTabDataGridView | LeadCompactViewItems | LeadDataGridViewItems | LeadNoteTabDataGridView | LookUpTabDataGridView | LookupDataView | OpportunityActivityTabDataGridView | OpportunityAndLeadDataGridViewItems | OpportunityArchiveCompactViewItems | OpportunityArchiveDataGridViewItems | OpportunityArchivePipelineColumnItems | OpportunityCloudObjectTabDataGridView | OpportunityCompactViewItems | OpportunityDataGridViewItems | OpportunityDrilldownDataGridViewItems | OpportunityNoteTabDataGridView | OpportunityPipelineColumnItems | OpportunityQuoteTabDataGridView | ProductCategoriesOfAccountDataGridViewItems | ProductCategoryTrendDataView | ProductDataGridViewItems | ProductTrendDataView | ProductWhiteSpaceDataView | ProductsOfAccountDataGridViewItems | ProjectActivityTabDataGridView | ProjectActivityTabObjectiveView | ProjectCloudObjectTabDataGridView | ProjectCompactViewItems | ProjectDataGridViewItems | ProjectDrilldownDataGridViewItems | ProjectNoteTabDataGridView | ProjectOpportunityTabDataGridView | QuoteActivityTabDataGridView | QuoteArchiveBoardColumnItems | QuoteArchiveDataGridViewItems | QuoteBoardColumnItems | QuoteCloudObjectTabDataGridView | QuoteCompactViewItems | QuoteDataGridViewItems | QuoteNoteTabDataGridView | RecordDocumentsDataGridViewItems | TargetDataGridViewItems;

export interface SnapshotDateRangedDataInterface {
  __typename?: string;
  items: ViewItemInterfaceImplementors[];
  sessionId: string;
}

export type SnapshotDateRangedDataInterfaceImplementors = OpportunityBubbleViewItems;

export interface SnapshotBaseDataInterface {
  __typename?: string;
  sessionId: string;
}

export type SnapshotBaseDataInterfaceImplementors = LeadArchiveBoardViewItems | LeadBoardViewItems | OpportunityArchivePipelineViewItems | OpportunityPipelineViewItems | QuoteArchiveBoardViewItems | QuoteBoardViewItems;

export interface SiblingBoxInterface {
  __typename?: string;
  calculationFieldId: ID | null;
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
  lookupFieldId: UUID | null;
  relation: SiblingBoxRelationType | null;
}

export type SiblingBoxInterfaceImplementors = FilterSiblingBox | ReportSiblingBox;

export interface SearchResultItemInterface {
  __typename?: string;
  datetime: DateTime | null;
  id: ID;
  isDeleted: boolean;
}

export type SearchResultItemInterfaceImplementors = AccountSearchResultItem | AppointmentSearchResultItem | CloudObjectSearchResultItem | ContactSearchResultItem | CustomEntitySearchResultItem | LeadSearchResultItem | NoteSearchResultItem | OpportunitySearchResultItem | ProjectSearchResultItem | QuoteSearchResultItem | TaskSearchResultItem;

export interface Screen {
  __typename?: string;
  name: string;
}

export type ScreenImplementors = AccountArchiveScreen | AccountPreviewScreen | ActivityPreviewScreen | ApprovalPreviewScreen | BetterNavigatorScreen | ContactArchiveScreen | ContactPreviewScreen | ConversionsScreen | CustomEntityPreviewScreen | FeedEmailScreen | FeedScreen | IndicatorsScreen | InsightsScreen | LeadArchiveScreen | LeadPreviewScreen | LifeCycleScreen | NavigatorScreen | OpportunityArchiveScreen | OpportunityPreviewScreen | ProjectPreviewScreen | QuoteArchiveScreen | QuotePreviewScreen;

export interface ScheduleInterface {
  __typename?: string;
  date: DateTime | null;
  dayOfMonth: number[] | null;
  dayOfWeek: number[] | null;
  timeOfDay: number | null;
}

export type ScheduleInterfaceImplementors = FieldAiValueUpdateSchedule | ProcessScheduleTrigger | ReportSchedule;

export interface RoleTabInterface {
  __typename?: string;
  showMyItems: boolean;
}

export type RoleTabInterfaceImplementors = AccountRoleTab | ActivityRoleTab | ContactRoleTab | CustomEntityRoleTab | DashboardRole | EmailRoleTab | FeedRoleTab | LeadOpportunityRoleTab | LeadRoleTab | OpportunityRoleTab | ProfileStandardRoleTab | ProjectRoleTab | QuoteRoleTab;

export interface RoleProfileInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  role: RoleTabInterfaceImplementors;
}

export type RoleProfileInterfaceImplementors = AccountArchiveProfile | AccountDashboardProfile | AccountPivotReportProfile | AccountPreviewProfile | AccountTableReportProfile | ActivityDashboardProfile | ActivityPivotReportProfile | ActivityPreviewProfile | ActivityTableReportProfile | ContactArchiveProfile | ContactDashboardProfile | ContactPivotReportProfile | ContactPreviewProfile | ContactTableReportProfile | CustomEntityPivotReportProfile | CustomEntityPreviewProfile | CustomEntityTableReportProfile | EmailPivotReportProfile | EmailTableReportProfile | FeedPivotReportProfile | FeedTableReportProfile | LeadArchiveProfile | LeadDashboardProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | LeadPreviewProfile | OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityPreviewProfile | ProjectPivotReportProfile | ProjectPreviewProfile | ProjectTableReportProfile | QuoteArchiveProfile | QuotePreviewProfile;

export interface ReportValueFieldInterface {
  __typename?: string;
  id: UUID;
  name: string;
}

export type ReportValueFieldInterfaceImplementors = CalculatedField | SummaryField;

export interface ReportTabInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
}

export type ReportTabInterfaceImplementors = AccountPivotReportProfile | AccountTableReportProfile | ActivityPivotReportProfile | ActivityTableReportProfile | ContactPivotReportProfile | ContactTableReportProfile | CustomEntityPivotReportProfile | CustomEntityTableReportProfile | EmailPivotReportProfile | EmailTableReportProfile | FeedPivotReportProfile | FeedTableReportProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | NotePivotReportProfile | NoteTableReportProfile | ProductPivotReportProfile | ProductTableReportProfile | ProjectPivotReportProfile | ProjectTableReportProfile | QuotePivotReportProfile | QuoteTableReportProfile | TimeframePivotReportProfile | TimeframeTableReportProfile;

export interface ReportStructureItem {
  __typename?: string;
  id: ID;
  parentId: ID | null;
  sortOrder: number;
}

export type ReportStructureItemImplementors = PivotTable | ReportTable;

export interface ReportHistoryCommon {
  __typename?: string;
  fields: ReportHistoryField[];
  trackedFieldIds: UUID[];
}

export type ReportHistoryCommonImplementors = ReportComparisonDatesHistory | ReportHistoricalTrendHistory;

export interface ReportField {
  __typename?: string;
  boxId: ID;
  fieldId: ID;
}

export type ReportFieldImplementors = GroupField | SortField;

export interface ReportBoxInterface {
  __typename?: string;
  calculationFieldId: ID | null;
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
}

export type ReportBoxInterfaceImplementors = FilterSiblingBox | ReportMainBox | ReportSiblingBox;

export interface RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: string;
  isArchived: boolean;
}

export type RecentlyOpenedResultItemIsArchivedInterfaceImplementors = AccountRecentlyOpenedResultItem | ContactRecentlyOpenedResultItem | LeadRecentlyOpenedResultItem | OpportunityRecentlyOpenedResultItem | QuoteRecentlyOpenedResultItem;

export interface RecentlyOpenedResultItemInterface {
  __typename?: string;
  id: ID;
  isDeleted: boolean;
  openedAt: DateTime;
}

export type RecentlyOpenedResultItemInterfaceImplementors = AccountRecentlyOpenedResultItem | AppointmentRecentlyOpenedResultItem | ContactRecentlyOpenedResultItem | CustomEntityRecentlyOpenedResultItem | LeadRecentlyOpenedResultItem | OpportunityRecentlyOpenedResultItem | ProjectRecentlyOpenedResultItem | QuoteRecentlyOpenedResultItem | TaskRecentlyOpenedResultItem;

export interface QuoteReportProfileInterface {
  __typename?: string;
  filter: QuoteFilterTab;
  quoteProcess: UUID[] | null;
  role: QuoteRoleTab;
}

export type QuoteReportProfileInterfaceImplementors = QuotePivotReportProfile;

export interface QuoteProfileInterface {
  __typename?: string;
  filter: QuoteFilterTab;
  quoteProcess: UUID[] | null;
}

export type QuoteProfileInterfaceImplementors = QuoteArchiveProfile | QuotePreviewProfile | QuoteTableReportProfile;

export interface QuickFilterInterface {
  __typename?: string;
  quickFilter: QuickFilterTab;
}

export type QuickFilterInterfaceImplementors = AccountArchiveProfile | AccountPivotReportProfile | AccountPreviewProfile | AccountTableReportProfile | ActivityPivotReportProfile | ActivityPreviewProfile | ActivityTableReportProfile | BetterForecastSchema | ContactArchiveProfile | ContactPivotReportProfile | ContactPreviewProfile | ContactTableReportProfile | ConversionsProfile | CustomEntityPivotReportProfile | CustomEntityPreviewProfile | CustomEntityTableReportProfile | EmailPivotReportProfile | EmailTableReportProfile | FeedPivotReportProfile | FeedTableReportProfile | IndicatorsProfile | InsightsProfile | LeadArchiveProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | LeadPreviewProfile | LifeCycleProfile | NotePivotReportProfile | NoteTableReportProfile | OpportunityArchiveProfile | OpportunityPreviewProfile | ProductPivotReportProfile | ProductTableReportProfile | ProjectPivotReportProfile | ProjectPreviewProfile | ProjectTableReportProfile | QuoteArchiveProfile | QuotePivotReportProfile | QuotePreviewProfile | QuoteTableReportProfile | TimeframePivotReportProfile | TimeframeTableReportProfile;

export interface ProjectProfileInterface {
  __typename?: string;
  filter: ProjectFilterTab;
  role: ProjectRoleTab;
}

export type ProjectProfileInterfaceImplementors = ProjectPivotReportProfile | ProjectPreviewProfile | ProjectTableReportProfile;

export interface ProfileTabsInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
}

export type ProfileTabsInterfaceImplementors = AccountArchiveProfile | AccountDashboardProfile | AccountPivotReportProfile | AccountPreviewProfile | AccountTableReportProfile | ActivityDashboardProfile | ActivityPivotReportProfile | ActivityPreviewProfile | ActivityTableReportProfile | ApprovalPreviewProfile | BetterNavigatorPreviewProfile | ContactArchiveProfile | ContactDashboardProfile | ContactPivotReportProfile | ContactPreviewProfile | ContactTableReportProfile | ConversionsProfile | CustomEntityPivotReportProfile | CustomEntityPreviewProfile | CustomEntityTableReportProfile | EmailPivotReportProfile | EmailTableReportProfile | FeedEmailPreviewProfile | FeedPivotReportProfile | FeedPreviewProfile | FeedTableReportProfile | IndicatorsProfile | InsightsProfile | LeadArchiveProfile | LeadDashboardProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | LeadPreviewProfile | LifeCycleProfile | NavigatorPreviewProfile | NotePivotReportProfile | NoteTableReportProfile | OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityForecastProfile | OpportunityPreviewProfile | ProductPivotReportProfile | ProductTableReportProfile | ProjectPivotReportProfile | ProjectPreviewProfile | ProjectTableReportProfile | QuoteArchiveProfile | QuotePivotReportProfile | QuotePreviewProfile | QuoteTableReportProfile | TimeframePivotReportProfile | TimeframeTableReportProfile;

export interface ProfileScreen {
  __typename?: string;
  activeProfile: ProfileInterfaceImplementors;
  draftProfile: ProfileInterfaceImplementors | null;
  profiles: ProfileInterfaceImplementors[];
}

export type ProfileScreenImplementors = AccountArchiveScreen | AccountPreviewScreen | ActivityPreviewScreen | ApprovalPreviewScreen | BetterNavigatorScreen | ContactArchiveScreen | ContactPreviewScreen | ConversionsScreen | CustomEntityPreviewScreen | FeedEmailScreen | FeedScreen | IndicatorsScreen | InsightsScreen | LeadArchiveScreen | LeadPreviewScreen | LifeCycleScreen | NavigatorScreen | OpportunityArchiveScreen | OpportunityPreviewScreen | ProjectPreviewScreen | QuoteArchiveScreen | QuotePreviewScreen;

export interface ProfileInterface {
  __typename?: string;
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  useLang: boolean;
}

export type ProfileInterfaceImplementors = AccountArchiveScreenProfile | AccountPreviewScreenProfile | ActivityPreviewScreenProfile | ApprovalPreviewScreenProfile | BetterNavigatorScreenProfile | ContactArchiveScreenProfile | ContactPreviewScreenProfile | ConversionsScreenProfile | CustomEntityPreviewScreenProfile | FeedDetailScreenProfile | FeedEmailDetailScreenProfile | FeedEmailScreenProfile | FeedScreenProfile | IndicatorsScreenProfile | InsightsScreenProfile | LeadArchiveScreenProfile | LeadPreviewScreenProfile | LifeCycleScreenProfile | NavigatorScreenProfile | OpportunityArchiveScreenProfile | OpportunityPreviewScreenProfile | ProjectPreviewScreenProfile | QuoteArchiveScreenProfile | QuotePreviewScreenProfile;

export interface ProfileFilterTabCustomFilterInterface {
  __typename?: string;
  formula: string | null;
  isCustom: boolean;
  operator: FilterGroupOperator;
}

export type ProfileFilterTabCustomFilterInterfaceImplementors = AccountFilterTab | ActivityFilterTab | ContactFilterTab | CustomEntityFilterTab | EmailFilterTab | FeedFilterTab | LeadFilterTab | LeadOpportunityFilterTab | NoteFilterTab | OpportunityFilterTab | OpportunityKPIFilterTab | ProductFilterTab | ProfileFilterTab | ProjectFilterTab | QuoteFilterTab | TimeframeFilterTab;

export interface ProfileFilterBoxTabsInterface {
  __typename?: string;
  filter: ProfileFilterBoxTabInterfaceImplementors;
}

export type ProfileFilterBoxTabsInterfaceImplementors = AccountArchiveProfile | AccountDashboardProfile | AccountPivotReportProfile | AccountPreviewProfile | AccountTableReportProfile | ActivityDashboardProfile | ActivityPivotReportProfile | ActivityPreviewProfile | ActivityTableReportProfile | ApprovalPreviewProfile | ContactArchiveProfile | ContactDashboardProfile | ContactPivotReportProfile | ContactPreviewProfile | ContactTableReportProfile | ConversionsProfile | CustomEntityPivotReportProfile | CustomEntityPreviewProfile | CustomEntityTableReportProfile | EmailPivotReportProfile | EmailTableReportProfile | FeedPivotReportProfile | FeedTableReportProfile | IndicatorsProfile | InsightsProfile | LeadArchiveProfile | LeadDashboardProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | LeadPreviewProfile | LifeCycleProfile | NotePivotReportProfile | NoteTableReportProfile | OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityForecastProfile | OpportunityPreviewProfile | ProductPivotReportProfile | ProductTableReportProfile | ProjectPivotReportProfile | ProjectPreviewProfile | ProjectTableReportProfile | QuoteArchiveProfile | QuotePivotReportProfile | QuotePreviewProfile | QuoteTableReportProfile | TimeframePivotReportProfile | TimeframeTableReportProfile;

export interface ProfileFilterBoxTabInterface {
  __typename?: string;
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  isEnabled: boolean;
}

export type ProfileFilterBoxTabInterfaceImplementors = AccountFilterTab | ActivityFilterTab | ContactFilterTab | CustomEntityFilterTab | EmailFilterTab | FeedFilterTab | LeadFilterTab | LeadOpportunityFilterTab | NoteFilterTab | OpportunityFilterTab | OpportunityKPIFilterTab | ProcessFilterNode | ProductFilterTab | ProfileFilterTab | ProjectFilterTab | QuoteFilterTab | TimeframeFilterTab;

export interface ProfileFilterBaseInterface {
  __typename?: string;
  isEnabled: boolean;
}

export type ProfileFilterBaseInterfaceImplementors = AccountFilterTab | ActivityFilterTab | ContactFilterTab | CustomEntityFilterTab | DashboardFilter | EmailFilterTab | FeedEmailPreviewFilterTab | FeedFilterTab | FeedPreviewFilterTab | LeadFilterTab | LeadOpportunityFilterTab | NavigatorProfileFilterTab | NoteFilterTab | OpportunityFilterTab | OpportunityKPIFilterTab | ProductFilterTab | ProfileFilterTab | ProjectFilterTab | QuoteFilterTab | TimeframeFilterTab;

export interface ProductProfileInterface {
  __typename?: string;
  filter: ProductFilterTab;
}

export type ProductProfileInterfaceImplementors = ProductPivotReportProfile | ProductTableReportProfile;

export interface ProcessScheduleInterface {
  __typename?: string;
  schedule: ProcessNodeSchedule | null;
}

export type ProcessScheduleInterfaceImplementors = ProcessArchiveRecordNode | ProcessChangeOwnershipNode | ProcessCopyRecordNode | ProcessCreateRecordNode | ProcessCreateRelatedRecordNode | ProcessEnrollEmailSequenceNode | ProcessLinkRecordNode | ProcessQualifyRecordNode | ProcessSendEmailNode | ProcessSendWebhookNode | ProcessTriggerProcessNode | ProcessUnarchiveRecordNode | ProcessUnenrollEmailSequenceNode | ProcessUpdateAiFieldsNode | ProcessUpdateRecordNode | ProcessUpdateRelatedRecordNode;

export interface ProcessResultStatus {
  __typename?: string;
  reason: string | null;
  status: ProcessStatusEnum;
}

export type ProcessResultStatusImplementors = ProcessAffectedByConditionResultPayload | ProcessEvaluationResultPayload | ProcessTestEmailResultPayload;

export interface ProcessNodeInterface {
  __typename?: string;
  id: ID;
  name: string;
  parentId: ID | null;
}

export type ProcessNodeInterfaceImplementors = ProcessArchiveRecordNode | ProcessChangeOwnershipNode | ProcessCopyRecordNode | ProcessCreateRecordNode | ProcessCreateRelatedRecordNode | ProcessEnrollEmailSequenceNode | ProcessFilterNode | ProcessLinkRecordNode | ProcessQualifyRecordNode | ProcessSendEmailNode | ProcessSendWebhookNode | ProcessTriggerProcessNode | ProcessUnarchiveRecordNode | ProcessUnenrollEmailSequenceNode | ProcessUpdateAiFieldsNode | ProcessUpdateRecordNode | ProcessUpdateRelatedRecordNode;

export interface ProcessActorInterface {
  __typename?: string;
  actor: ProcessRecordTriggerActorEnum;
  actorUnits: UUID[];
  actorUsers: UUID[];
}

export type ProcessActorInterfaceImplementors = ApprovalProcessManualTrigger | ApprovalProcessRecordTrigger | ProcessManualTrigger | ProcessRecordTrigger;

export interface PivotReportTabsInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  view: ViewPivotReportTab;
}

export type PivotReportTabsInterfaceImplementors = AccountPivotReportProfile | ActivityPivotReportProfile | ContactPivotReportProfile | CustomEntityPivotReportProfile | EmailPivotReportProfile | FeedPivotReportProfile | LeadOpportunityPivotReportProfile | NotePivotReportProfile | ProductPivotReportProfile | ProjectPivotReportProfile | QuotePivotReportProfile | TimeframePivotReportProfile;

export interface PipelineProfileInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  salesPipeline: ID[] | null;
}

export type PipelineProfileInterfaceImplementors = ConversionsProfile | IndicatorsProfile | InsightsProfile | LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile | LifeCycleProfile | OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityForecastProfile | OpportunityPreviewProfile;

export interface OverdueTaskOverview {
  __typename?: string;
  dueDate: GqlDate | null;
  id: ID;
  subject: string;
}

export type OverdueTaskOverviewImplementors = NotificationTaskOverview | OverdueTaskOverviewAgenda;

export interface OpportunityProfileInterface {
  __typename?: string;
  filter: OpportunityFilterTab;
  salesPipeline: ID[] | null;
}

export type OpportunityProfileInterfaceImplementors = LifeCycleProfile | OpportunityForecastProfile;

export interface OpportunityKPIProfileInterface {
  __typename?: string;
  filter: OpportunityKPIFilterTab;
  leadProcess: UUID[] | null;
  salesPipeline: ID[] | null;
}

export type OpportunityKPIProfileInterfaceImplementors = ConversionsProfile | IndicatorsProfile | InsightsProfile;

export interface OnlineFormFieldInterface {
  __typename?: string;
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export type OnlineFormFieldInterfaceImplementors = OnlineFormCheckboxField | OnlineFormDateField | OnlineFormDateTimeField | OnlineFormDropdownField | OnlineFormEmailField | OnlineFormFileUploadField | OnlineFormFloatField | OnlineFormInputField | OnlineFormIntegerField | OnlineFormMultiselectCheckboxField | OnlineFormPhoneField | OnlineFormProductsServicesField | OnlineFormRadioField | OnlineFormRatingField | OnlineFormTextAreaField;

export interface NotificationTargetEntityInterface {
  __typename?: string;
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
}

export type NotificationTargetEntityInterfaceImplementors = ApprovalResponseNotificationEntity | ClientNotificationEntity | CustomEntityNotificationEntity | DocumentNotificationEntity | NotificationEntity | TextMessageConversationNotificationEntity;

export interface NotificationEntityInterface {
  __typename?: string;
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
}

export type NotificationEntityInterfaceImplementors = ApprovalResponseNotificationEntity | CustomEntityNotificationEntity | NotificationEntity | ProjectStatusChangeNotificationEntity | TaskStatusChangeNotificationEntity | TextMessageConversationNotificationEntity;

export interface NoteProfileInterface {
  __typename?: string;
  filter: NoteFilterTab;
}

export type NoteProfileInterfaceImplementors = NotePivotReportProfile | NoteTableReportProfile;

export interface NavigatorAgendaItemInterface {
  __typename?: string;
  date: GqlDate;
  linkedId: ID;
  name: string;
}

export type NavigatorAgendaItemInterfaceImplementors = AgendaAppointment | AgendaDueDateTask | AgendaOpportunityClosingDate | AgendaOpportunityVelocity | AgendaRecurrentAppointmentVirtualOccurence;

export interface MapViewInterface {
  __typename?: string;
  entityId: ID;
  entityType: EntityNameEnum;
  entityTypeId: UUID;
  geoLocation: GeoLocationEntity;
  name: string;
  value: number | null;
}

export type MapViewInterfaceImplementors = LeadMapViewItem | MapViewItem | OpportunityMapViewItem;

export interface ListingViewInterface {
  __typename?: string;
  total: number;
}

export type ListingViewInterfaceImplementors = AccountActivityTabCalendarView | AccountActivityTabDataGridView | AccountArchiveDataGridViewItems | AccountChildAccountTabDataGridView | AccountCloudObjectTabDataGridView | AccountCompactViewItems | AccountContactTabDataGridView | AccountDataGridViewItems | AccountDrilldownDataGridViewItems | AccountHierarchyTabDataGridView | AccountLeadTabDataGridView | AccountNoteTabDataGridView | AccountOpportunityTabDataGridView | AccountProductPricingTabDataGridView | AccountProjectTabDataGridView | AccountQuoteTabDataGridView | ActivityCalendarViewItems | ActivityDataGridViewItems | ActivityDetailCalendarViewItems | ActivityDrilldownDataGridViewItems | ActivityTaskBoardColumnItems | ApprovalDataGridViewItems | CloudObjectDataGridViewItems | CompanyDocumentsDataGridViewItems | ContactActivityTabCalendarView | ContactActivityTabDataGridView | ContactArchiveDataGridViewItems | ContactCloudObjectTabDataGridView | ContactCompactViewItems | ContactDataGridViewItems | ContactLeadTabDataGridView | ContactNoteTabDataGridView | ContactOpportunityTabDataGridView | ContactProjectTabDataGridView | ContactQuoteTabDataGridView | CustomEntityActivityTabCalendarView | CustomEntityActivityTabDataGridView | CustomEntityCloudObjectTabDataGridView | CustomEntityCompactViewItems | CustomEntityDataGridViewItems | CustomEntityNoteTabDataGridView | CustomOpportunityDataGridViewItems | ForecastDataGridViewItems | GenericDrilldownDataGridViewItems | GroupTargetDataGridViewItems | LeadActivityTabCalendarView | LeadActivityTabDataGridView | LeadArchiveBoardViewItems | LeadArchiveDataGridViewItems | LeadBoardViewItems | LeadCloudObjectTabDataGridView | LeadCompactViewItems | LeadDataGridViewItems | LeadNoteTabDataGridView | LookUpTabDataGridView | LookupDataView | OpportunityActivityTabCalendarView | OpportunityActivityTabDataGridView | OpportunityAndLeadDataGridViewItems | OpportunityArchiveCompactViewItems | OpportunityArchiveDataGridViewItems | OpportunityArchivePipelineViewItems | OpportunityBubbleViewItems | OpportunityCloudObjectTabDataGridView | OpportunityCompactViewItems | OpportunityDataGridViewItems | OpportunityDrilldownDataGridViewItems | OpportunityNoteTabDataGridView | OpportunityPipelineViewItems | OpportunityQuoteTabDataGridView | ProductCategoriesOfAccountDataGridViewItems | ProductCategoryTrendDataView | ProductDataGridViewItems | ProductTrendDataView | ProductWhiteSpaceDataView | ProductsOfAccountDataGridViewItems | ProjectActivityTabCalendarView | ProjectActivityTabDataGridView | ProjectActivityTabObjectiveView | ProjectCloudObjectTabDataGridView | ProjectCompactViewItems | ProjectDataGridViewItems | ProjectDrilldownDataGridViewItems | ProjectNoteTabDataGridView | ProjectOpportunityTabDataGridView | QuoteActivityTabCalendarView | QuoteActivityTabDataGridView | QuoteArchiveBoardViewItems | QuoteArchiveDataGridViewItems | QuoteBoardViewItems | QuoteCloudObjectTabDataGridView | QuoteCompactViewItems | QuoteDataGridViewItems | QuoteNoteTabDataGridView | RecordDocumentsDataGridViewItems | TargetDataGridViewItems;

export interface ListViewInterface {
  __typename?: string;
  displayColumn: UUID[];
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export type ListViewInterfaceImplementors = AccountListView | ActivityListView | ContactListView | CustomEntityListView | LeadListView | OpportunityListView | ProjectListView | QuoteListView;

export interface LeadProfileInterface {
  __typename?: string;
  filter: LeadFilterTab;
  leadProcess: UUID[] | null;
}

export type LeadProfileInterfaceImplementors = LeadArchiveProfile | LeadDashboardProfile | LeadPreviewProfile;

export interface LeadOpptyPipelineProfileInterface {
  __typename?: string;
  filter: ProfileFilterBaseInterfaceImplementors;
  leadProcess: UUID[] | null;
  salesPipeline: ID[] | null;
}

export type LeadOpptyPipelineProfileInterfaceImplementors = LifeCycleProfile | OpportunityDashboardProfile | OpportunityForecastProfile;

export interface LeadOpportunityReportProfileInterface {
  __typename?: string;
  filter: LeadOpportunityFilterTab;
  leadProcess: UUID[] | null;
  role: LeadOpportunityRoleTab;
  salesPipeline: ID[] | null;
}

export type LeadOpportunityReportProfileInterfaceImplementors = LeadOpportunityPivotReportProfile | LeadOpportunityTableReportProfile;

export interface LeadOpportunityProfileInterface {
  __typename?: string;
  filter: LeadOpportunityFilterTab;
  role: OpportunityRoleTab;
  salesPipeline: ID[] | null;
}

export type LeadOpportunityProfileInterfaceImplementors = OpportunityArchiveProfile | OpportunityDashboardProfile | OpportunityPreviewProfile;

export interface InterfaceFieldData {
  __typename?: string;
  fieldId: UUID;
}

export type InterfaceFieldDataImplementors = AccountClassInterfaceFieldData | ActivityStatusInterfaceFieldData | AttendeesInterfaceFieldData | BooleanInterfaceFieldData | CurrencyForeignInterfaceFieldData | DateInterfaceFieldData | DateRangeInterfaceFieldData | DateTimeInterfaceFieldData | DateTimeRangeInterfaceFieldData | DaysInStepInterfaceFieldData | DecimalInterfaceFieldData | EntityInterfaceFieldData | EntityListInterfaceFieldData | FitnessIndicatorsInterfaceFieldData | FitnessInterfaceFieldData | GenderInterfaceFieldData | IntInterfaceFieldData | LabelFlagInterfaceFieldData | LeadStatusInterfaceFieldData | LinkedItemTypesInterfaceFieldData | OpptyStatusInterfaceFieldData | OptionsInterfaceFieldData | OrgRelationshipTypeInterfaceFieldData | PipelineInterfaceFieldData | ProjectStatusInterfaceFieldData | QuoteStatusInterfaceFieldData | ScoringCategoryInterfaceFieldData | ScoringStatusInterfaceFieldData | ShareActorInterfaceFieldData | ShareModeInterfaceFieldData | SocialNetworksInterfaceFieldData | StringInterfaceFieldData | TaskPriorityInterfaceFieldData | TaskStatusInterfaceFieldData;

export interface InsightItemInterface {
  __typename?: string;
  isDeleted: boolean;
  kpiData: InsightItemKPIData;
  picture: string | null;
}

export type InsightItemInterfaceImplementors = InsightClientItem | InsightSalesUnitItem;

export interface IndicatorItemInterface {
  __typename?: string;
  isDeleted: boolean;
  kpiValue: number;
  picture: string | null;
}

export type IndicatorItemInterfaceImplementors = IndicatorClientItem | IndicatorSalesUnitItem;

export interface HubItemRuleSettingsInterface {
  __typename?: string;
  deduplication: HubItemDeduplicationSetting | null;
  externalRuleSetting: HubItemExternalRuleSetting;
  fieldMappings: HubItemFieldMapping[];
  filterMapping: HubItemFilterMapping | null;
  id: UUID;
  localRuleSetting: HubItemLocalRuleSetting;
  name: string;
  ownerMapping: HubItemFieldMapping | null;
  ownerMappingExtended: HubItemFieldMapping | null;
  pipelines: HubItemFieldMapping[] | null;
  salesUnitMapping: HubItemFieldMapping | null;
  syncDirection: SyncDirectionEnum;
  syncFiles: boolean | null;
  syncNotes: boolean | null;
}

export type HubItemRuleSettingsInterfaceImplementors = HubItemRelationRuleSettings | HubItemRuleSettings;

export interface GridViewFolderCountInterface {
  __typename?: string;
  entityTypeFolderCounts: CloudObjectFolderCount[];
}

export type GridViewFolderCountInterfaceImplementors = AccountCloudObjectTabDataGridView | CompanyDocumentsDataGridViewItems | ContactCloudObjectTabDataGridView | CustomEntityCloudObjectTabDataGridView | LeadCloudObjectTabDataGridView | OpportunityCloudObjectTabDataGridView | ProjectCloudObjectTabDataGridView | QuoteCloudObjectTabDataGridView | RecordDocumentsDataGridViewItems;

export interface GlobalSearchCount {
  __typename?: string;
  accountCount: number;
  appointmentCount: number;
  cloudObjectCount: number;
  contactCount: number;
  customEntityCount: CustomEntityCount[];
  leadCount: number;
  noteCount: number;
  opportunityCount: number;
  projectCount: number;
  quoteCount: number;
  taskCount: number;
}

export type GlobalSearchCountImplementors = SearchConnection;

export interface GenericIntegrationStorageService {
  __typename?: string;
  listFolder: RemoteStorageFileListResultConnection | null;
}

export type GenericIntegrationStorageServiceImplementors = AlfrescoIntegrationStorageService;

export interface FormItemInterface {
  __typename?: string;
  id: UUID;
  kind: FormItemKindEnum;
  onMobile: boolean | null;
}

export type FormItemInterfaceImplementors = FormContainer | FormSeparator | FormSubsection | HardCodedContainer | StepFieldsContainer;

export interface FormContainerItemInterface {
  __typename?: string;
  kind: FormContainerItemKind;
}

export type FormContainerItemInterfaceImplementors = FormField | WebResource;

export interface ForeignCurrencyOption {
  __typename?: string;
  includeForeignCurrency: boolean | null;
}

export type ForeignCurrencyOptionImplementors = CsvOptions | XlsxOptions;

export interface ForecastTabItem {
  __typename?: string;
  id: ID;
}

export type ForecastTabItemImplementors = OpportunityForecastProfileTab;

export interface ForecastDataItemInterface {
  __typename?: string;
  column: ForecastColumnItem[];
  quota: number | null;
}

export type ForecastDataItemInterfaceImplementors = ForecastDataItem | ForecastGroupItem | ForecastSumItem;

export interface FilterFieldRuleInterface {
  __typename?: string;
  field: string;
  id: UUID | null;
  operator: FieldOperator | null;
  values: string[][] | null;
}

export type FilterFieldRuleInterfaceImplementors = EntityHealthFieldFilterRule | FieldFilterRule;

export interface FilterBoxInterface {
  __typename?: string;
  entity: string;
  id: string;
  lookupFieldId: UUID | null;
}

export type FilterBoxInterfaceImplementors = EntityHealthFilterBox | EntityHealthMainFilterBox | FilterBox | MainFilterBox;

export interface FeedTextMessageInterface {
  __typename?: string;
  actor: FeedActor | null;
  direction: EmailDirectionEnum;
  itemsInConversationCount: number | null;
  phoneType: PhoneTypeEnum | null;
  recipientPhoneNumber: string | null;
  textConversationId: ID;
  textMessageStatus: TextMessageStatusEnum;
}

export type FeedTextMessageInterfaceImplementors = FeedTextMessageCreated;

export interface FeedTaskInterface {
  __typename?: string;
  description: string | null;
  dueDate: GqlDate | null;
  hasRecurrence: boolean;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  priority: PriorityEnum;
  reminder: DateTime | null;
  taskStatus: TaskStatusEnum | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedTaskInterfaceImplementors = FeedTaskAdded | FeedTaskCreated;

export interface FeedReportProfileInterface {
  __typename?: string;
  filter: FeedFilterTab;
  role: FeedRoleTab;
}

export type FeedReportProfileInterfaceImplementors = FeedPivotReportProfile | FeedTableReportProfile;

export interface FeedQuoteInterface {
  __typename?: string;
  expirationDate: DateTime | null;
  foreignCurrencyValue: CurrencyForeignData | null;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  quoteStatus: QuoteStatusEnum;
  totalAmount: number | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedQuoteInterfaceImplementors = FeedQuoteAdded;

export interface FeedProjectInterface {
  __typename?: string;
  description: string | null;
  endDate: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  projectStatus: ProjectStatusEnum;
  startDate: DateTime;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedProjectInterfaceImplementors = FeedProjectAdded;

export interface FeedOpportunityInterface {
  __typename?: string;
  closingDate: GqlDate;
  daysInStep: number;
  foreignCurrencyValue: CurrencyForeignData | null;
  hasRecurrence: boolean;
  label: number;
  opportunityStatus: OpptyStatusEnum | null;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  value: number | null;
  warningLevel: WarningLevelEnum | null;
}

export type FeedOpportunityInterfaceImplementors = FeedOpportunityAdded | FeedOpportunityCreated;

export interface FeedOnlineFormInterface {
  __typename?: string;
  actor: FeedActor | null;
  onlineFormTypeId: ID;
}

export type FeedOnlineFormInterfaceImplementors = FeedOnlineFormSubmitted;

export interface FeedLeadInterface {
  __typename?: string;
  daysInQueue: number;
  label: number;
  leadStatus: LeadStatusEnum;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  warningLevel: WarningLevelEnum | null;
}

export type FeedLeadInterfaceImplementors = FeedLeadAdded | FeedLeadCreated;

export interface FeedItemWithTargetUnitInterface {
  __typename?: string;
  targetUnitId: ID;
  targetUnitIsDeleted: boolean | null;
  targetUnitName: string;
  targetUnitPictureUrl: string | null;
}

export type FeedItemWithTargetUnitInterfaceImplementors = FeedUnitAssignedAsEditor | FeedUnitAssignedAsWatcher;

export interface FeedItemWithTargetClientInterface {
  __typename?: string;
  targetClientId: ID | null;
  targetClientIsDeleted: boolean | null;
  targetClientName: string | null;
  targetClientPictureUrl: string | null;
}

export type FeedItemWithTargetClientInterfaceImplementors = FeedClientAssignedAsEditor | FeedClientAssignedAsWatcher | FeedOwnershipChanged;

export interface FeedItemWithStep {
  __typename?: string;
  stepName: string;
  stepOrder: number;
}

export type FeedItemWithStepImplementors = FeedOpportunityMove | FeedQuoteMove;

export interface FeedItemWithEntitySpecificData {
  __typename?: string;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  value: number | null;
}

export type FeedItemWithEntitySpecificDataImplementors = FeedClientAssignedAsEditor | FeedClientAssignedAsWatcher | FeedLeadOpportunityLost | FeedLeadOpportunityReactivate | FeedLeadQualification | FeedOpportunityBackToLead | FeedOpportunityMove | FeedOpportunityWon | FeedOwnershipChanged | FeedQuoteAccepted | FeedQuoteLost | FeedQuoteMove | FeedQuoteReactivate | FeedUnitAssignedAsEditor | FeedUnitAssignedAsWatcher;

export interface FeedItemWithAttachedPictures {
  __typename?: string;
  attachmentsPictures: AttachmentsPictureEntity[];
}

export type FeedItemWithAttachedPicturesImplementors = FeedEmailAdded | FeedEmailCreated | FeedMemoAdded | FeedMemoCreated | FeedScheduledEmailAdded;

export interface FeedItemInterface {
  __typename?: string;
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export type FeedItemInterfaceImplementors = FeedAccountCreated | FeedAppointmentAdded | FeedAppointmentCanceled | FeedAppointmentCreated | FeedChildAccountAdded | FeedClientAssignedAsEditor | FeedClientAssignedAsWatcher | FeedCloudObjectAdded | FeedContactAdded | FeedContactCreated | FeedCustomEntityAdded | FeedEmailAdded | FeedEmailCreated | FeedInvitationToAppointment | FeedLeadAdded | FeedLeadCreated | FeedLeadOpportunityLost | FeedLeadOpportunityReactivate | FeedLeadQualification | FeedMassEmailCreated | FeedMemoAdded | FeedMemoCreated | FeedNoteAdded | FeedOnlineFormSubmitted | FeedOpportunityAdded | FeedOpportunityBackToLead | FeedOpportunityCreated | FeedOpportunityMove | FeedOpportunityWon | FeedOwnershipChanged | FeedProjectAdded | FeedProjectStatusChange | FeedQuoteAccepted | FeedQuoteAdded | FeedQuoteLost | FeedQuoteMove | FeedQuoteReactivate | FeedQuoteStatusChange | FeedResponseToAppointmentInvitation | FeedScheduledEmailAdded | FeedScheduledMassEmailCreated | FeedTaskAdded | FeedTaskCreated | FeedTaskStatusChange | FeedTextMessageCreated | FeedUnitAssignedAsEditor | FeedUnitAssignedAsWatcher;

export interface FeedEmailInterface {
  __typename?: string;
  bodySummary: string;
  canChangeContentSharing: boolean;
  cc: string;
  contentShareMode: ContentShareModeEnum;
  direction: EmailDirectionEnum;
  hasTrackingEvent: boolean;
  isContentAvailable: boolean;
  isTracked: boolean;
  itemsInThreadCount: number | null;
  parentEmailId: ID | null;
  recipient: string;
  sender: string;
  senderId: ID | null;
  senderIsDeleted: boolean | null;
  senderName: string | null;
  senderPictureUrl: string | null;
  senderType: EntityNameEnum | null;
  sentiment: EmailSentimentEnum | null;
  wasBounced: boolean;
}

export type FeedEmailInterfaceImplementors = FeedEmailAdded | FeedEmailCreated | FeedScheduledEmailAdded;

export interface FeedCustomEntityInterface {
  __typename?: string;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedCustomEntityInterfaceImplementors = FeedCustomEntityAdded;

export interface FeedContactInterface {
  __typename?: string;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedContactInterfaceImplementors = FeedContactAdded | FeedContactCreated;

export interface FeedAppointmentInterface {
  __typename?: string;
  appointmentStatus: ActivityStatusEnum | null;
  description: string | null;
  endDate: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  reminder: DateTime | null;
  startDate: DateTime;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedAppointmentInterfaceImplementors = FeedAppointmentAdded | FeedAppointmentCreated;

export interface FeedAccountInterface {
  __typename?: string;
  industryName: string | null;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export type FeedAccountInterfaceImplementors = FeedAccountCreated | FeedChildAccountAdded;

export interface FavoriteResultItemIsArchivedInterface {
  __typename?: string;
  isArchived: boolean;
}

export type FavoriteResultItemIsArchivedInterfaceImplementors = AccountFavoriteResultItem | ContactFavoriteResultItem | LeadFavoriteResultItem | OpportunityFavoriteResultItem | QuoteFavoriteResultItem;

export interface FavoriteResultItemInterface {
  __typename?: string;
  id: ID;
  isDeleted: boolean;
}

export type FavoriteResultItemInterfaceImplementors = AccountFavoriteResultItem | ContactFavoriteResultItem | CustomEntityFavoriteResultItem | LeadFavoriteResultItem | OpportunityFavoriteResultItem | ProjectFavoriteResultItem | QuoteFavoriteResultItem | ReportFavoriteResultItem;

export interface EntityScoringRule {
  __typename?: string;
  conditions: EntityScoringRuleFilter;
  expiration: number;
  expirationEnabled: boolean;
  expirationUnit: EntityScoringRuleExpirationUnitEnum;
  id: UUID;
  isEnabled: boolean;
  name: string;
  score: number;
  scoreMultiplier: boolean;
  useLang: boolean;
}

export type EntityScoringRuleImplementors = EntityScoringActivityRule | EntityScoringEmailRule | EntityScoringFieldRule;

export interface EmailSequenceNode {
  __typename?: string;
  condition: EmailSequenceNodeCondition;
  dayOffset: number;
  id: UUID;
}

export type EmailSequenceNodeImplementors = EmailSequenceCreateRecordNode | EmailSequenceSendEmailNode;

export interface EmailSequenceCountStats {
  __typename?: string;
  clickCount: number;
  openCount: number;
  replyCount: number;
  sentCount: number;
  unsubscribeCount: number;
}

export type EmailSequenceCountStatsImplementors = EmailSequencePeriodStats | EmailSequenceStats | EmailSequenceStepStats;

export interface EmailProfileInterface {
  __typename?: string;
  filter: EmailFilterTab;
  role: EmailRoleTab;
}

export type EmailProfileInterfaceImplementors = EmailPivotReportProfile | EmailTableReportProfile;

export interface EmailDataInterface {
  __typename?: string;
  attachments: UUID[];
  bcc: SendEmailRecipient[];
  body: string;
  cc: SendEmailRecipient[];
  emailTemplateId: UUID | null;
  recipients: SendEmailRecipient[];
  signature: string | null;
  subject: string;
}

export type EmailDataInterfaceImplementors = EmailSequenceNodeEmail | ProcessNodeEmail | ScheduledReportEmail;

export interface DashboardViewInterface {
  __typename?: string;
  drilldownFields: ID[];
}

export type DashboardViewInterfaceImplementors = AccountDashboardProfileView | ActivityDashboardProfileView | ContactDashboardProfileView | LeadDashboardProfileView | OpportunityDashboardProfileView;

export interface DashboardTabItem {
  __typename?: string;
  id: ID;
}

export type DashboardTabItemImplementors = AccountDashboardProfileTab | ActivityDashboardProfileTab | ContactDashboardProfileTab | LeadDashboardProfileTab | OpportunityDashboardProfileTab;

export interface DashboardGraphItemInterface {
  __typename?: string;
  name: string;
}

export type DashboardGraphItemInterfaceImplementors = DashboardGraphGauge | DashboardGraphSeries;

export interface DashboardGraphEntityInterface {
  __typename?: string;
  entityId: UUID | null;
  sessionId: UUID | null;
}

export type DashboardGraphEntityInterfaceImplementors = DashboardGraphGauge | DashboardGraphSeriesItem;

export interface DashboardChartId {
  __typename?: string;
  error: DashboardChartError | null;
  id: string | null;
}

export type DashboardChartIdImplementors = DashboardAgendaData | DashboardGridData | DashboardInsightsData | DashboardKpiData | DashboardKpiListData | DashboardListChartData | DashboardOpportunitiesTrendData | DashboardPipelineConversionsChartData | DashboardReportChartData | DashboardTargetData | DashboardTileData;

export interface CustomEntityProfileInterface {
  __typename?: string;
  filter: CustomEntityFilterTab;
  role: CustomEntityRoleTab;
}

export type CustomEntityProfileInterfaceImplementors = CustomEntityPivotReportProfile | CustomEntityPreviewProfile | CustomEntityTableReportProfile;

export interface ContactProfileInterface {
  __typename?: string;
  filter: ContactFilterTab;
  role: ContactRoleTab;
}

export type ContactProfileInterfaceImplementors = ContactArchiveProfile | ContactDashboardProfile | ContactPivotReportProfile | ContactPreviewProfile | ContactTableReportProfile;

export interface CompactViewInterface {
  __typename?: string;
  feedListingOptions: FeedTabDataGridViewOptions;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export type CompactViewInterfaceImplementors = AccountCompactView | ContactCompactView | LeadCompactView | OpportunityCompactView;

export interface ColumnFormattingFilterFieldRuleInterface {
  __typename?: string;
  field: string | null;
  id: UUID | null;
  operator: FieldOperator | null;
  values: string[][] | null;
}

export type ColumnFormattingFilterFieldRuleInterfaceImplementors = ColumnFormattingFieldFilterRule;

export interface CalendarViewItemInterface {
  __typename?: string;
  badgeColor: number | null;
  id: ID;
  ownerColor: number | null;
}

export type CalendarViewItemInterfaceImplementors = AppointmentCalendarViewItem | AppointmentRecurrenceOccurrenceCalendarViewItem | TaskCalendarViewItem;

export interface BoardViewInterface {
  __typename?: string;
  searchQuery: string | null;
}

export type BoardViewInterfaceImplementors = LeadBoardView | PipelineView | QuoteBoardView | TaskBoardView;

export interface ApprovalProfileInterface {
  __typename?: string;
  filter: ActivityFilterTab;
}

export type ApprovalProfileInterfaceImplementors = ApprovalPreviewProfile;

export interface ApiErrorBase {
  __typename?: string;
  code: number;
  message: string | null;
  name: string;
}

export type ApiErrorBaseImplementors = EntityValidationError | FieldError | StepChecklistError;

export interface AiTask {
  __typename?: string;
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  status: AiTaskStatus;
  text: string | null;
}

export type AiTaskImplementors = AiAssistantTask | AiOnlineFormTask | AiProcessTask | AiRecordSuggestionsTask | AiRecordSummaryTask | AiReportTask;

export interface ActivityViewItemInterface {
  __typename?: string;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
}

export type ActivityViewItemInterfaceImplementors = AccountActivityTabCalendarView | ActivityCalendarViewItems | ActivityDetailCalendarViewItems | ContactActivityTabCalendarView | CustomEntityActivityTabCalendarView | LeadActivityTabCalendarView | OpportunityActivityTabCalendarView | ProjectActivityTabCalendarView | QuoteActivityTabCalendarView;

export interface ActivityProfileInterface {
  __typename?: string;
  filter: ActivityFilterTab;
  role: ActivityRoleTab;
}

export type ActivityProfileInterfaceImplementors = ActivityDashboardProfile | ActivityPivotReportProfile | ActivityPreviewProfile | ActivityTableReportProfile;

export interface ActivityAgendaItemInterface {
  __typename?: string;
  date: GqlDate;
  linkedId: ID;
  name: string;
}

export type ActivityAgendaItemInterfaceImplementors = AgendaAppointment | AgendaDueDateTask | AgendaRecurrentAppointmentVirtualOccurence;

export interface ActivityAgendaInterface {
  __typename?: string;
  agenda: ActivityAgenda;
}

export type ActivityAgendaInterfaceImplementors = AccountActivityTabCalendarView | AccountActivityTabTaskBoardView | ActivityCalendarViewItems | ActivityTaskBoardViewItems | ContactActivityTabCalendarView | ContactActivityTabTaskBoardView | CustomEntityActivityTabCalendarView | CustomEntityActivityTabTaskBoardView | LeadActivityTabCalendarView | LeadActivityTabTaskBoardView | OpportunityActivityTabCalendarView | OpportunityActivityTabTaskBoardView | ProjectActivityTabCalendarView | ProjectActivityTabTaskBoardView | QuoteActivityTabCalendarView | QuoteActivityTabTaskBoardView;

export interface AccountProfileInterface {
  __typename?: string;
  filter: AccountFilterTab;
  role: AccountRoleTab;
}

export type AccountProfileInterfaceImplementors = AccountArchiveProfile | AccountDashboardProfile | AccountPivotReportProfile | AccountPreviewProfile | AccountTableReportProfile;

export enum YearComparisonPeriodEnum {
  Custom = 'Custom',
  YearPrevious = 'YearPrevious'
}

export enum WorkingDaysUpdateMode {
  DontUpdate = 'DontUpdate',
  UpdateDueDate = 'UpdateDueDate',
  UpdateDuration = 'UpdateDuration',
  UpdateStartDate = 'UpdateStartDate'
}

export enum WhiteSpaceAccountTypeEnum {
  Comparison = 'Comparison',
  Selected = 'Selected',
  Similar = 'Similar'
}

export enum WarningLevelEnum {
  Error = 'Error',
  Notice = 'Notice',
  Ok = 'Ok',
  Warning = 'Warning'
}

export enum VatCheckResultEnum {
  ResultInvalid = 'ResultInvalid',
  ResultUnavailable = 'ResultUnavailable',
  ResultValid = 'ResultValid'
}

export enum ValidationLevel {
  FULL = 'FULL',
  INCLUDE_CONDITIONAL_FIELD_REQUIREMENTS = 'INCLUDE_CONDITIONAL_FIELD_REQUIREMENTS',
  SKIP_ALL = 'SKIP_ALL',
  SKIP_FIELD_VALUE_VALIDATION = 'SKIP_FIELD_VALUE_VALIDATION',
  SKIP_INVALID_RECALCULATIONS = 'SKIP_INVALID_RECALCULATIONS',
  SKIP_READONLY_VALIDATION = 'SKIP_READONLY_VALIDATION',
  SKIP_RECALCULATION = 'SKIP_RECALCULATION',
  SKIP_RELATIONSHIP_VALIDATION = 'SKIP_RELATIONSHIP_VALIDATION',
  SKIP_STEP_CHECKLIST_VALIDATION = 'SKIP_STEP_CHECKLIST_VALIDATION',
  SKIP_UNCHANGED_FIELDS = 'SKIP_UNCHANGED_FIELDS',
  SKIP_UNIQUE_VALIDATION = 'SKIP_UNIQUE_VALIDATION',
  SKIP_USER_DEFINED_VALIDATIONS = 'SKIP_USER_DEFINED_VALIDATIONS'
}

export enum UserRolePermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum UserRecalculationStateEnum {
  InProgress = 'InProgress',
  NoRecalculation = 'NoRecalculation',
  Pending = 'Pending'
}

export enum UserReactionEnum {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

export enum UserProfilePermsEnum {
  ApiAdmin = 'ApiAdmin',
  Create = 'Create',
  Delete = 'Delete',
  Disable = 'Disable',
  EditPicture = 'EditPicture',
  Enable = 'Enable',
  Read = 'Read',
  Restore = 'Restore',
  SetSuperAdmin = 'SetSuperAdmin',
  Write = 'Write'
}

export enum UserLanguage {
  de = 'de',
  en = 'en',
  es_es = 'es_es',
  pt_br = 'pt_br'
}

export enum UpsertResultStatus {
  Created = 'Created',
  NotFound = 'NotFound',
  Retrieved = 'Retrieved',
  Updated = 'Updated'
}

export enum UploadSourceEnum {
  EmailTemplate = 'EmailTemplate',
  RichTextEditor = 'RichTextEditor'
}

export enum UpdateProductPriceListActionEnum {
  DontUpdatePrices = 'DontUpdatePrices',
  UpdateAll = 'UpdateAll',
  UpdateAllExceptModified = 'UpdateAllExceptModified'
}

export enum UpdateFieldsModeEnum {
  UpdateAll = 'UpdateAll',
  UpdateEmpty = 'UpdateEmpty',
  UpdateIgnoreEmpty = 'UpdateIgnoreEmpty'
}

export enum UnitRoleEnum {
  Manager = 'Manager',
  Member = 'Member'
}

export enum UIView {
  Board = 'Board',
  BubbleChart = 'BubbleChart',
  Calendar = 'Calendar',
  Card = 'Card',
  Compact = 'Compact',
  Feed = 'Feed',
  Gantt = 'Gantt',
  Grid = 'Grid',
  Map = 'Map',
  Matrix = 'Matrix',
  Navigator = 'Navigator',
  Objective = 'Objective',
  Pipeline = 'Pipeline',
  Reports = 'Reports',
  TaskBoard = 'TaskBoard',
  Thumbnail = 'Thumbnail',
  Tree = 'Tree',
  Trend = 'Trend',
  WhiteSpace = 'WhiteSpace'
}

export enum TwoFAType {
  AUTH_APP = 'AUTH_APP',
  BACKUP_CODES = 'BACKUP_CODES',
  DUMMY = 'DUMMY',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export enum TwilioCallerStatus {
  FAILED = 'FAILED',
  VERIFIED = 'VERIFIED',
  VERIFYING = 'VERIFYING'
}

export enum TranslationLabelTypeEnum {
  Data = 'Data',
  Field = 'Field',
  FormDescription = 'FormDescription',
  FormField = 'FormField'
}

export enum TierModules {
  OneToManyActivities = 'OneToManyActivities',
  accHierarchy = 'accHierarchy',
  accountContactRelations = 'accountContactRelations',
  activitiesMultiLink = 'activitiesMultiLink',
  addCompanyEmails = 'addCompanyEmails',
  advancedReports = 'advancedReports',
  apiAccess = 'apiAccess',
  archive = 'archive',
  audit = 'audit',
  auditLogData = 'auditLogData',
  bubbleChart = 'bubbleChart',
  bulkEdit = 'bulkEdit',
  businessCardScanner = 'businessCardScanner',
  buyingCenter = 'buyingCenter',
  calling = 'calling',
  changeLog = 'changeLog',
  customActivityTypes = 'customActivityTypes',
  dashboard = 'dashboard',
  desktopApp = 'desktopApp',
  documents = 'documents',
  editionBusiness = 'editionBusiness',
  editionEnterprise = 'editionEnterprise',
  editionFreemium = 'editionFreemium',
  editionMobileStandalone = 'editionMobileStandalone',
  editionPersonalPlus = 'editionPersonalPlus',
  editionStarter = 'editionStarter',
  editionUnlimited = 'editionUnlimited',
  entityHealth = 'entityHealth',
  exchange = 'exchange',
  export = 'export',
  fieldLevelSecurity = 'fieldLevelSecurity',
  fieldsFormsProductsCustomization = 'fieldsFormsProductsCustomization',
  fieldsFormsRollup = 'fieldsFormsRollup',
  forecast = 'forecast',
  formViews = 'formViews',
  fullcontactIntegration = 'fullcontactIntegration',
  gmailInbox = 'gmailInbox',
  google = 'google',
  googleForms = 'googleForms',
  googleTemplates = 'googleTemplates',
  historyReports = 'historyReports',
  homeScreen = 'homeScreen',
  hrm = 'hrm',
  inAppNotif = 'inAppNotif',
  insights = 'insights',
  laco250 = 'laco250',
  maps = 'maps',
  matrix = 'matrix',
  merge = 'merge',
  mobile = 'mobile',
  mobileReports = 'mobileReports',
  msSharepointIntegration = 'msSharepointIntegration',
  multipleCurrency = 'multipleCurrency',
  multiplePipelines = 'multiplePipelines',
  multipleRoles = 'multipleRoles',
  multipleUnits = 'multipleUnits',
  notes = 'notes',
  office = 'office',
  office365 = 'office365',
  orgChart = 'orgChart',
  pandaDoc = 'pandaDoc',
  reccuringTasks = 'reccuringTasks',
  salesActions = 'salesActions',
  salesActivities = 'salesActivities',
  scheduledReports = 'scheduledReports',
  singleMobileApp = 'singleMobileApp',
  targetKp = 'targetKp',
  taskboard = 'taskboard',
  tasks500 = 'tasks500',
  thumbnailView = 'thumbnailView',
  timeZone = 'timeZone',
  timeline = 'timeline'
}

export enum TextModificationFunction {
  ChangeTone = 'ChangeTone',
  EnhanceAndComplete = 'EnhanceAndComplete',
  MakeLonger = 'MakeLonger',
  MakeShorter = 'MakeShorter',
  Rephrase = 'Rephrase',
  SummarizeIntoBulletPoints = 'SummarizeIntoBulletPoints',
  SummarizeIntoParagraph = 'SummarizeIntoParagraph',
  TextCorrection = 'TextCorrection'
}

export enum TextMessageStatusEnum {
  Failed = 'Failed',
  Received = 'Received',
  Seen = 'Seen',
  Sending = 'Sending',
  Sent = 'Sent'
}

export enum TemplateStatusInProcess {
  Deleted = 'Deleted',
  Ok = 'Ok',
  Unavailable = 'Unavailable'
}

export enum TemplateSourceEnum {
  Google = 'Google',
  Microsoft = 'Microsoft'
}

export enum TemplateErrorTypeEnum {
  Missing = 'Missing',
  NotAvailable = 'NotAvailable'
}

export enum TeamSpaceStatusReason {
  STATUS_REASON_DISABLED_BY_ADMIN_ACTION = 'STATUS_REASON_DISABLED_BY_ADMIN_ACTION',
  STATUS_REASON_DISABLED_BY_AUTOMATIC_CLEANUP = 'STATUS_REASON_DISABLED_BY_AUTOMATIC_CLEANUP',
  STATUS_REASON_DISABLED_BY_DUNNING = 'STATUS_REASON_DISABLED_BY_DUNNING',
  STATUS_REASON_DISABLED_BY_MANUAL_DUNNING = 'STATUS_REASON_DISABLED_BY_MANUAL_DUNNING',
  STATUS_REASON_DISABLED_BY_RESET = 'STATUS_REASON_DISABLED_BY_RESET',
  STATUS_REASON_DISABLED_BY_TAKEOVER = 'STATUS_REASON_DISABLED_BY_TAKEOVER',
  STATUS_REASON_PENDING_UPGRADE = 'STATUS_REASON_PENDING_UPGRADE',
  STATUS_REASON_READY = 'STATUS_REASON_READY',
  STATUS_REASON_SCHEDULED_MAINTENANCE = 'STATUS_REASON_SCHEDULED_MAINTENANCE',
  STATUS_REASON_UPGRADE_FAILED = 'STATUS_REASON_UPGRADE_FAILED',
  STATUS_REASON_UPGRADING = 'STATUS_REASON_UPGRADING'
}

export enum TeamSpaceStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  MAINTENANCE = 'MAINTENANCE'
}

export enum TeamSpacePermsEnum {
  AdminAccess = 'AdminAccess',
  ApiAdmin = 'ApiAdmin',
  Create = 'Create',
  Delete = 'Delete',
  EditPicture = 'EditPicture',
  Reactivate = 'Reactivate',
  Read = 'Read',
  ResetSpace = 'ResetSpace',
  Restore = 'Restore',
  Suspend = 'Suspend',
  SuspendWithReason = 'SuspendWithReason',
  ToggleFeaturePromotion = 'ToggleFeaturePromotion',
  ToggleReleaseNote = 'ToggleReleaseNote',
  UpdateName = 'UpdateName',
  Write = 'Write'
}

export enum TeamSpaceFlags {
  Default = 'Default',
  HighSecurity = 'HighSecurity',
  UseCoevera = 'UseCoevera'
}

export enum TeamPipelineHubItemStatusEnum {
  Active = 'Active',
  Error = 'Error',
  PendingConfiguration = 'PendingConfiguration',
  RequestedAdd = 'RequestedAdd',
  RequestedRemove = 'RequestedRemove'
}

export enum TaskStatusEnum {
  Completed = 'Completed',
  Deferred = 'Deferred',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Waiting = 'Waiting'
}

export enum TargetsPeriodTypeEnum {
  CalendarYear = 'CalendarYear',
  FinancialYear = 'FinancialYear'
}

export enum TargetsPeriodFragmentTypeEnum {
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year'
}

export enum TargetsMetricPeriodEnum {
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export enum TargetsMetricEnum {
  LeadsNew = 'LeadsNew',
  LeadsQualified = 'LeadsQualified',
  OpportunitiesNew = 'OpportunitiesNew',
  OpportunitiesWon = 'OpportunitiesWon',
  Quota = 'Quota',
  UnweightedTarget = 'UnweightedTarget',
  UnweightedTargetByVelocity = 'UnweightedTargetByVelocity'
}

export enum TargetsChartGranularityEnum {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export enum TargetValueType {
  Balanced = 'Balanced',
  Ranked = 'Ranked',
  Unweighted = 'Unweighted',
  Weighted = 'Weighted',
  Won = 'Won'
}

export enum TargetTypeEnum {
  GroupFromExisting = 'GroupFromExisting',
  GroupFromUser = 'GroupFromUser',
  Simulated = 'Simulated',
  User = 'User'
}

export enum TargetStatusEnum {
  Draft = 'Draft',
  Finished = 'Finished',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export enum TargetStatus {
  Healthy = 'Healthy',
  Problem = 'Problem',
  Reached = 'Reached',
  SetGoal = 'SetGoal'
}

export enum TargetSourceKind {
  All = 'All',
  My = 'My'
}

export enum TargetCalculationTypeEnum {
  LeadCreated = 'LeadCreated',
  LeadQualified = 'LeadQualified',
  Revenue = 'Revenue'
}

export enum TagSupportedEntitiesEnum {
  Account = 'Account',
  Appointment = 'Appointment',
  Contact = 'Contact',
  Email = 'Email',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  Process = 'Process',
  Project = 'Project',
  Task = 'Task'
}

export enum SyncDirectionEnum {
  BiDirectional = 'BiDirectional',
  ExternalToPipeliner = 'ExternalToPipeliner',
  PipelinerToExternal = 'PipelinerToExternal'
}

export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Disabled = 'Disabled'
}

export enum SubscriptionProductTier {
  Business = 'Business',
  BusinessCloud = 'BusinessCloud',
  Enterprise = 'Enterprise',
  EnterpriseCloud = 'EnterpriseCloud',
  Freemium = 'Freemium',
  MobileStandalone = 'MobileStandalone',
  MobileStandaloneCloud = 'MobileStandaloneCloud',
  OldContinuityBusiness = 'OldContinuityBusiness',
  OldContinuityStarter = 'OldContinuityStarter',
  OldLegacyProductArithmeticaWithMobile = 'OldLegacyProductArithmeticaWithMobile',
  OldLegacyProductArithmeticaWithoutMobile = 'OldLegacyProductArithmeticaWithoutMobile',
  OldProduct = 'OldProduct',
  PersonalPlus = 'PersonalPlus',
  Starter = 'Starter',
  StarterCloud = 'StarterCloud',
  UnlimitedCloud = 'UnlimitedCloud'
}

export enum SubscriptionPermsEnum {
  Cancel = 'Cancel',
  ChangeProcessedNotifications = 'ChangeProcessedNotifications',
  Create = 'Create',
  CreateSpace = 'CreateSpace',
  CreateSpaceRequest = 'CreateSpaceRequest',
  Delete = 'Delete',
  EditPicture = 'EditPicture',
  EditSubscriptionAdmins = 'EditSubscriptionAdmins',
  Enable = 'Enable',
  Partner = 'Partner',
  PurchaseAdditionalLicenses = 'PurchaseAdditionalLicenses',
  PurchaseCallingCredit = 'PurchaseCallingCredit',
  PurchaseExtras = 'PurchaseExtras',
  Read = 'Read',
  RenewalEstimate = 'RenewalEstimate',
  RequestCancellation = 'RequestCancellation',
  Restore = 'Restore',
  UpgradeToCommercial = 'UpgradeToCommercial',
  Write = 'Write',
  WriteBasic = 'WriteBasic'
}

export enum SubscriptionCompanyFocus {
  IT = 'IT',
  NotSet = 'NotSet',
  Other = 'Other',
  SalesManagement = 'SalesManagement',
  SalesOperations = 'SalesOperations',
  Selling = 'Selling'
}

export enum SubscriptionClassification {
  Freemium = 'Freemium',
  Internal = 'Internal',
  Partner = 'Partner',
  Standard = 'Standard',
  Testing = 'Testing',
  Trial = 'Trial'
}

export enum StorylanePermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum StepChecklistVisibilityEnum {
  Always = 'Always',
  Condition = 'Condition'
}

export enum StepChecklistValidationEnum {
  RelatedActivityCompleted = 'RelatedActivityCompleted',
  RelatedActivityLinked = 'RelatedActivityLinked',
  Required = 'Required'
}

export enum StepChecklistTypeEnum {
  ActivityType = 'ActivityType',
  AttachDocument = 'AttachDocument',
  CreateInfluenceMap = 'CreateInfluenceMap',
  CreateNote = 'CreateNote',
  Default = 'Default',
  EnrollToEmailSequence = 'EnrollToEmailSequence',
  FieldType = 'FieldType',
  MapSalesRole = 'MapSalesRole',
  RunProcess = 'RunProcess',
  SendEmail = 'SendEmail',
  UseDocumentTemplate = 'UseDocumentTemplate'
}

export enum StepChecklistDocumentFormatEnum {
  Default = 'Default',
  Pdf = 'Pdf'
}

export enum SortOrder {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum SizeCalculatedBy {
  BalancedValue = 'BalancedValue',
  RankedValue = 'RankedValue',
  UnweightedValue = 'UnweightedValue',
  WeightedValue = 'WeightedValue'
}

export enum SiblingRelationType {
  Aggregation = 'Aggregation',
  All = 'All',
  Custom = 'Custom',
  LastActivityComment = 'LastActivityComment',
  LastFinishedActivity = 'LastFinishedActivity',
  LastLostOpportunity = 'LastLostOpportunity',
  LastMessage = 'LastMessage',
  LastNote = 'LastNote',
  LastOnlineFormResponse = 'LastOnlineFormResponse',
  LastWonOpportunity = 'LastWonOpportunity',
  NextOpenOpportunity = 'NextOpenOpportunity',
  NextScheduledActivity = 'NextScheduledActivity',
  NoRelation = 'NoRelation',
  Primary = 'Primary',
  Sender = 'Sender'
}

export enum SharingRoleEnum {
  Editor = 'Editor',
  Watcher = 'Watcher'
}

export enum ShareModeParamsEnum {
  ShareToIncludedUsers = 'ShareToIncludedUsers',
  ShareToUnitManagers = 'ShareToUnitManagers'
}

export enum ShareModeEnum {
  AllEdit = 'AllEdit',
  AllView = 'AllView',
  Private = 'Private',
  Standard = 'Standard'
}

export enum ShareActorEnum {
  Editor = 'Editor',
  Owner = 'Owner',
  Unassigned = 'Unassigned',
  Unit = 'Unit',
  Watcher = 'Watcher'
}

export enum SetProductPriceListOperation {
  All = 'All',
  DontSet = 'DontSet',
  Selected = 'Selected'
}

export enum SessionPolicyType {
  DailyTimeout = 'DailyTimeout',
  IdleTimeout = 'IdleTimeout',
  IpWhitelist = 'IpWhitelist',
  MaxSessionTime = 'MaxSessionTime',
  Require2FAOnEveryLogin = 'Require2FAOnEveryLogin'
}

export enum ServiceStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Failed = 'Failed'
}

export enum ServiceMappingType {
  Exchange = 'Exchange',
  Google = 'Google',
  O365 = 'O365'
}

export enum ScreenTypeEnum {
  AccountArchivescreen = 'AccountArchivescreen',
  Accountscreen = 'Accountscreen',
  Activityscreen = 'Activityscreen',
  Approvalscreen = 'Approvalscreen',
  Archivescreen = 'Archivescreen',
  Auditscreen = 'Auditscreen',
  BetterNavigatorscreen = 'BetterNavigatorscreen',
  ContactArchivescreen = 'ContactArchivescreen',
  Contactscreen = 'Contactscreen',
  Conversionsscreen = 'Conversionsscreen',
  CustomEntityscreen = 'CustomEntityscreen',
  FeedDetailScreen = 'FeedDetailScreen',
  FeedEmailDetailScreen = 'FeedEmailDetailScreen',
  FeedEmailscreen = 'FeedEmailscreen',
  Feedscreen = 'Feedscreen',
  Feedscreen2 = 'Feedscreen2',
  Forecastscreen = 'Forecastscreen',
  Hrmscreen = 'Hrmscreen',
  Indicatorsscreen = 'Indicatorsscreen',
  Insightsscreen = 'Insightsscreen',
  LeadArchivescreen = 'LeadArchivescreen',
  Leadscreen = 'Leadscreen',
  Lifecyclescreen = 'Lifecyclescreen',
  Navigator = 'Navigator',
  Pipelinescreen = 'Pipelinescreen',
  ProductScreen = 'ProductScreen',
  Projectscreen = 'Projectscreen',
  QuoteArchivescreen = 'QuoteArchivescreen',
  Quotescreen = 'Quotescreen',
  TargetScreen = 'TargetScreen',
  Timelinescreen = 'Timelinescreen'
}

export enum ScreenType {
  AccountArchiveScreen = 'AccountArchiveScreen',
  AccountScreen = 'AccountScreen',
  ActivityScreen = 'ActivityScreen',
  ApprovalScreen = 'ApprovalScreen',
  ArchiveScreen = 'ArchiveScreen',
  AuditScreen = 'AuditScreen',
  BetterNavigatorScreen = 'BetterNavigatorScreen',
  ContactArchiveScreen = 'ContactArchiveScreen',
  ContactScreen = 'ContactScreen',
  ConversionsScreen = 'ConversionsScreen',
  CustomEntityScreen = 'CustomEntityScreen',
  FeedDetailScreen = 'FeedDetailScreen',
  FeedEmailDetailScreen = 'FeedEmailDetailScreen',
  FeedEmailScreen = 'FeedEmailScreen',
  FeedScreen = 'FeedScreen',
  FeedScreen2 = 'FeedScreen2',
  ForecastScreen = 'ForecastScreen',
  HomeScreen = 'HomeScreen',
  HrmScreen = 'HrmScreen',
  IndicatorsScreen = 'IndicatorsScreen',
  InsightsScreen = 'InsightsScreen',
  LeadArchiveScreen = 'LeadArchiveScreen',
  LeadScreen = 'LeadScreen',
  LifecycleScreen = 'LifecycleScreen',
  OpportunityScreen = 'OpportunityScreen',
  ProductScreen = 'ProductScreen',
  ProjectScreen = 'ProjectScreen',
  QuoteArchiveScreen = 'QuoteArchiveScreen',
  QuoteScreen = 'QuoteScreen',
  TargetScreen = 'TargetScreen',
  TimeLineScreen = 'TimeLineScreen'
}

export enum ScheduledAppointmentDrilldownEnum {
  Completed = 'Completed',
  Created = 'Created',
  Upcoming = 'Upcoming'
}

export enum RollupRelationTypeEnum {
  Lookup = 'Lookup',
  LookupRelated = 'LookupRelated',
  System = 'System'
}

export enum RollupFieldAggregationFunctionEnum {
  Average = 'Average',
  Count = 'Count',
  First = 'First',
  Last = 'Last',
  Max = 'Max',
  Min = 'Min',
  Sum = 'Sum'
}

export enum RollbackMethod {
  ROLLBACK_ALL = 'ROLLBACK_ALL',
  ROLLBACK_FAILED = 'ROLLBACK_FAILED'
}

export enum RevenueScheduleValueTypeEnum {
  OpportunityValue = 'OpportunityValue',
  ProductAmount = 'ProductAmount'
}

export enum RevenueSchedulePeriodTypeEnum {
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year'
}

export enum ResponseSummaryRelationCategory {
  Responded = 'Responded',
  Sent = 'Sent',
  SentAndNotResponded = 'SentAndNotResponded',
  UnknownRespondents = 'UnknownRespondents'
}

export enum ResponseAcceptanceThresholdType {
  CustomCondition = 'CustomCondition',
  ProductsLimits = 'ProductsLimits',
  TotalResponses = 'TotalResponses'
}

export enum RequestMethodEnum {
  Get = 'Get',
  Post = 'Post'
}

export enum ReportXlsxType {
  full = 'full',
  simplified = 'simplified'
}

export enum ReportTypeEnum {
  AdvancedReport = 'AdvancedReport',
  DashboardReport = 'DashboardReport',
  ForecastReport = 'ForecastReport',
  TableReport = 'TableReport'
}

export enum ReportTotalPosition {
  Bottom = 'Bottom',
  Top = 'Top'
}

export enum ReportHistorySpecialValue {
  FirstValue = 'FirstValue',
  PreviousValue = 'PreviousValue'
}

export enum ReportHistoryDynamicDateUnit {
  Day = 'Day',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export enum ReportHistoryDynamicDateOperation {
  Add = 'Add',
  EndOf = 'EndOf',
  Set = 'Set',
  StartOf = 'StartOf',
  Subtract = 'Subtract'
}

export enum ReportContent {
  All = 'All',
  Charts = 'Charts',
  Table = 'Table'
}

export enum ReportChartType {
  Bar = 'Bar',
  Bubble = 'Bubble',
  Column = 'Column',
  Line = 'Line',
  MultiColumn = 'MultiColumn',
  MultiLine = 'MultiLine',
  Pie = 'Pie',
  Sankey = 'Sankey',
  ScatterPlot = 'ScatterPlot',
  Scorecard = 'Scorecard',
  StackedBar = 'StackedBar',
  StackedColumn = 'StackedColumn'
}

export enum ReminderStatusEnum {
  Dismissed = 'Dismissed',
  Scheduled = 'Scheduled',
  Snoozed = 'Snoozed'
}

export enum ReleaseNotePermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum RelationType {
  MANY_TO_MANY_VECTOR = 'MANY_TO_MANY_VECTOR',
  MANY_TO_ONE_SCALAR = 'MANY_TO_ONE_SCALAR',
  NO_RELATION = 'NO_RELATION'
}

export enum RecurrenceTypeEnum {
  AfterNDays = 'AfterNDays',
  AfterNMonths = 'AfterNMonths',
  AfterNWeeks = 'AfterNWeeks',
  AfterNYears = 'AfterNYears',
  Daily = 'Daily',
  MonthlyAbsolute = 'MonthlyAbsolute',
  MonthlyRelative = 'MonthlyRelative',
  NotSet = 'NotSet',
  Weekly = 'Weekly',
  YearlyAbsolute = 'YearlyAbsolute',
  YearlyRelative = 'YearlyRelative'
}

export enum RecurrenceConditionEnum {
  Lost = 'Lost',
  Won = 'Won'
}

export enum RecordOwnershipEnum {
  AllEditable = 'AllEditable',
  AllVisibleItems = 'AllVisibleItems',
  OnlyOwnedItems = 'OnlyOwnedItems'
}

export enum RecordConversionOperationEnum {
  Archive = 'Archive',
  Delete = 'Delete',
  Nothing = 'Nothing'
}

export enum RecentlyOpenedEntityType {
  Account = 'Account',
  Appointment = 'Appointment',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  Project = 'Project',
  Quote = 'Quote',
  Task = 'Task'
}

export enum ReadOnlyPermsEnum {
  Read = 'Read'
}

export enum QuoteStatusEnum {
  Accepted = 'Accepted',
  Lost = 'Lost',
  Open = 'Open'
}

export enum QuoteKpiEnum {
  Accept = 'Accept',
  Archive = 'Archive',
  Create = 'Create',
  LastMove = 'LastMove'
}

export enum QuoteGroupBy {
  Account = 'Account',
  Contact = 'Contact',
  ExpirationDate = 'ExpirationDate',
  NoGrouping = 'NoGrouping',
  Owner = 'Owner',
  Unit = 'Unit'
}

export enum ProjectTypeIconEnum {
  Account = 'Account',
  GeneralIcon = 'GeneralIcon'
}

export enum ProjectStatusEnum {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export enum ProjectObjectiveStatusEnum {
  AtRisk = 'AtRisk',
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export enum ProjectKpiEnum {
  ProjectCompleted = 'ProjectCompleted'
}

export enum ProjectGanttPeriod {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly'
}

export enum ProfileTypeEnum {
  Dynamic = 'Dynamic',
  Static = 'Static'
}

export enum ProfileShareMode {
  Private = 'Private',
  Public = 'Public',
  SelectedUnitsAndUsers = 'SelectedUnitsAndUsers'
}

export enum ProductTypeEnum {
  CustomAddon = 'CustomAddon',
  License = 'License',
  LicenseAddon = 'LicenseAddon',
  Other = 'Other',
  SpaceAddon = 'SpaceAddon',
  SubscriptionAddon = 'SubscriptionAddon'
}

export enum ProductTabEnum {
  Category = 'Category',
  Product = 'Product'
}

export enum ProductSerieTypeEnum {
  LostAmount = 'LostAmount',
  LostQuantity = 'LostQuantity',
  OpenAmount = 'OpenAmount',
  OpenQuantity = 'OpenQuantity',
  WonAmount = 'WonAmount',
  WonQuantity = 'WonQuantity'
}

export enum ProductPriceListTypeEnum {
  Scheduled = 'Scheduled',
  Standard = 'Standard'
}

export enum ProductPriceListStatusEnum {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled'
}

export enum ProductPriceListPriceSourceEnum {
  Customer = 'Customer',
  PriceList = 'PriceList',
  PriceSchedule = 'PriceSchedule'
}

export enum ProductPriceListPriceAccessEnum {
  All = 'All',
  NoAccess = 'NoAccess',
  Role = 'Role'
}

export enum ProductListTypeEnum {
  Dynamic = 'Dynamic',
  Static = 'Static'
}

export enum ProcessWebhookTimeFormat {
  ISO8601 = 'ISO8601',
  Timestamp = 'Timestamp'
}

export enum ProcessWebhookRequestType {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export enum ProcessWebhookRequestFormat {
  JSON = 'JSON',
  Text = 'Text',
  XML = 'XML'
}

export enum ProcessTypeEnum {
  Personal = 'Personal',
  Space = 'Space'
}

export enum ProcessTriggerTypeEnum {
  ProcessManualTrigger = 'ProcessManualTrigger',
  ProcessOnlineFormTrigger = 'ProcessOnlineFormTrigger',
  ProcessRecordTrigger = 'ProcessRecordTrigger',
  ProcessScheduleTrigger = 'ProcessScheduleTrigger'
}

export enum ProcessStatusEnum {
  Error = 'Error',
  Expired = 'Expired',
  Ok = 'Ok',
  Scheduled = 'Scheduled',
  Warning = 'Warning'
}

export enum ProcessRecordTriggerEventEnum {
  Create = 'Create',
  CreateOrUpdate = 'CreateOrUpdate',
  Delete = 'Delete',
  EmailReceived = 'EmailReceived',
  EmailSent = 'EmailSent',
  Update = 'Update'
}

export enum ProcessRecordTriggerActorEnum {
  AnyUser = 'AnyUser',
  ApplicationsOnly = 'ApplicationsOnly',
  ProcessOwner = 'ProcessOwner',
  SelectedUnitsAndUsers = 'SelectedUnitsAndUsers'
}

export enum ProcessRecordNodeRelationEnum {
  Account = 'Account',
  ActiveQuote = 'ActiveQuote',
  Appointment = 'Appointment',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Email = 'Email',
  Lead = 'Lead',
  Lookup = 'Lookup',
  LookupRelated = 'LookupRelated',
  OnlineForm = 'OnlineForm',
  Opportunity = 'Opportunity',
  OpptyProductRelation = 'OpptyProductRelation',
  ParentAccount = 'ParentAccount',
  ParentAccountNoReplace = 'ParentAccountNoReplace',
  PrimaryAccount = 'PrimaryAccount',
  PrimaryContact = 'PrimaryContact',
  PrimaryInContact = 'PrimaryInContact',
  PrimaryInLead = 'PrimaryInLead',
  PrimaryInOpportunity = 'PrimaryInOpportunity',
  PrimaryInQuote = 'PrimaryInQuote',
  PrimaryLookup = 'PrimaryLookup',
  PrimaryLookupRelated = 'PrimaryLookupRelated',
  Project = 'Project',
  Quote = 'Quote',
  Task = 'Task'
}

export enum ProcessRecordIdentificationType {
  Field = 'Field',
  Filter = 'Filter'
}

export enum ProcessNodeScheduleUnitEnum {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  Week = 'Week',
  WorkingDay = 'WorkingDay'
}

export enum ProcessNodeEmailSender {
  ActorEmail = 'ActorEmail',
  ApproverEmail = 'ApproverEmail',
  CompanyEmail = 'CompanyEmail',
  RecordOwnerEmail = 'RecordOwnerEmail'
}

export enum ProcessEntityOperationEnum {
  Custom = 'Custom',
  CustomAddToExisting = 'CustomAddToExisting',
  CustomAndTriggered = 'CustomAndTriggered',
  CustomRemoveExisting = 'CustomRemoveExisting',
  CustomReplaceExisting = 'CustomReplaceExisting',
  CustomUpdateOnlyCode = 'CustomUpdateOnlyCode',
  CustomUpdateValueAndCode = 'CustomUpdateValueAndCode',
  ProcessOwner = 'ProcessOwner',
  TriggerActor = 'TriggerActor',
  TriggeredPrimaryRecordOwner = 'TriggeredPrimaryRecordOwner',
  TriggeredRecord = 'TriggeredRecord',
  TriggeredRecordAccountAddToExisting = 'TriggeredRecordAccountAddToExisting',
  TriggeredRecordAccountRemoveExisting = 'TriggeredRecordAccountRemoveExisting',
  TriggeredRecordAccountReplaceExisting = 'TriggeredRecordAccountReplaceExisting',
  TriggeredRecordAccountValue = 'TriggeredRecordAccountValue',
  TriggeredRecordAddToExisting = 'TriggeredRecordAddToExisting',
  TriggeredRecordField = 'TriggeredRecordField',
  TriggeredRecordOwner = 'TriggeredRecordOwner',
  TriggeredRecordOwnerAddToExisting = 'TriggeredRecordOwnerAddToExisting',
  TriggeredRecordOwnerReplaceExisting = 'TriggeredRecordOwnerReplaceExisting',
  TriggeredRecordParentAccountAddToExisting = 'TriggeredRecordParentAccountAddToExisting',
  TriggeredRecordParentAccountRemoveExisting = 'TriggeredRecordParentAccountRemoveExisting',
  TriggeredRecordParentAccountReplaceExisting = 'TriggeredRecordParentAccountReplaceExisting',
  TriggeredRecordParentAccountValue = 'TriggeredRecordParentAccountValue',
  TriggeredRecordPrimaryAccountAddToExisting = 'TriggeredRecordPrimaryAccountAddToExisting',
  TriggeredRecordPrimaryAccountRemoveExisting = 'TriggeredRecordPrimaryAccountRemoveExisting',
  TriggeredRecordPrimaryAccountReplaceExisting = 'TriggeredRecordPrimaryAccountReplaceExisting',
  TriggeredRecordPrimaryAccountValue = 'TriggeredRecordPrimaryAccountValue',
  TriggeredRecordPrimaryContactAddToExisting = 'TriggeredRecordPrimaryContactAddToExisting',
  TriggeredRecordPrimaryContactRemoveExisting = 'TriggeredRecordPrimaryContactRemoveExisting',
  TriggeredRecordPrimaryContactReplaceExisting = 'TriggeredRecordPrimaryContactReplaceExisting',
  TriggeredRecordPrimaryContactValue = 'TriggeredRecordPrimaryContactValue',
  TriggeredRecordRemoveExisting = 'TriggeredRecordRemoveExisting',
  TriggeredRecordValue = 'TriggeredRecordValue',
  TriggeredRecordValueAddToExisting = 'TriggeredRecordValueAddToExisting',
  TriggeredRecordValueCustomAddToExisting = 'TriggeredRecordValueCustomAddToExisting',
  TriggeredRecordValueCustomRemoveExisting = 'TriggeredRecordValueCustomRemoveExisting',
  TriggeredRecordValueCustomReplaceExisting = 'TriggeredRecordValueCustomReplaceExisting',
  TriggeredRecordValueRemoveExisting = 'TriggeredRecordValueRemoveExisting',
  TriggeredRecordValueReplaceExisting = 'TriggeredRecordValueReplaceExisting',
  TriggeredRecordValueUpdateOnlyCode = 'TriggeredRecordValueUpdateOnlyCode',
  TriggeredRecordValueUpdateValueAndCode = 'TriggeredRecordValueUpdateValueAndCode',
  Unassigned = 'Unassigned'
}

export enum ProcessDeactivationReasonEnum {
  DisabledFeature = 'DisabledFeature',
  Manual = 'Manual',
  NoReason = 'NoReason',
  TooManyErrors = 'TooManyErrors'
}

export enum ProcessChangeOwnershipAssigneeType {
  Client = 'Client',
  SalesUnit = 'SalesUnit'
}

export enum ProcessActionTypeIconEnum {
  ArchiveRecord = 'ArchiveRecord',
  CreateRecord = 'CreateRecord',
  ManualTrigger = 'ManualTrigger',
  RecordChangedTrigger = 'RecordChangedTrigger',
  ScheduledTrigger = 'ScheduledTrigger',
  SendEmail = 'SendEmail',
  SendWebhook = 'SendWebhook',
  UpdateRecord = 'UpdateRecord'
}

export enum PriorityEnum {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum PrimitiveType {
  BLOB = 'BLOB',
  BOOL = 'BOOL',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  DECIMAL = 'DECIMAL',
  DOUBLE = 'DOUBLE',
  DYNAMIC = 'DYNAMIC',
  ENUM = 'ENUM',
  INT = 'INT',
  LIST = 'LIST',
  OBJECT = 'OBJECT',
  STRING = 'STRING',
  TSVECTOR = 'TSVECTOR',
  UUID = 'UUID'
}

export enum PipelinePerformanceSerieType {
  Conversion = 'Conversion',
  Lost = 'Lost',
  Open = 'Open',
  Qualified = 'Qualified',
  Velocity = 'Velocity',
  WinProbability = 'WinProbability',
  WinRatio = 'WinRatio',
  Won = 'Won'
}

export enum PipelinePerformanceChartType {
  AvgVelocityByStep = 'AvgVelocityByStep',
  AvgVelocityByUser = 'AvgVelocityByUser',
  ConversionRateByStep = 'ConversionRateByStep',
  ConversionRateByUser = 'ConversionRateByUser',
  PipelineOverviewByStep = 'PipelineOverviewByStep',
  PipelineOverviewByUser = 'PipelineOverviewByUser',
  QualifiedLeadsByUser = 'QualifiedLeadsByUser',
  WinProbabilityByStep = 'WinProbabilityByStep',
  WinRateByUser = 'WinRateByUser',
  WonOpportunitiesByUser = 'WonOpportunitiesByUser'
}

export enum PipelinePerformanceAggregationType {
  AllOpportunities = 'AllOpportunities',
  AllOpportunitiesCount = 'AllOpportunitiesCount',
  AvgDealSize = 'AvgDealSize',
  AvgVelocity = 'AvgVelocity',
  ConversionRate = 'ConversionRate',
  LostOpportunities = 'LostOpportunities',
  LostOpportunitiesCount = 'LostOpportunitiesCount',
  OpenOpportunities = 'OpenOpportunities',
  OpenOpportunitiesCount = 'OpenOpportunitiesCount',
  QualifiedLeads = 'QualifiedLeads',
  WinRate = 'WinRate',
  WonOpportunities = 'WonOpportunities',
  WonOpportunitiesCount = 'WonOpportunitiesCount'
}

export enum PhoneTypeEnum {
  Calling = 'Calling',
  CallingSmsCompany = 'CallingSmsCompany',
  CallingSmsPersonal = 'CallingSmsPersonal',
  CallingSmsUnassigned = 'CallingSmsUnassigned',
  WhatsAppCompany = 'WhatsAppCompany',
  WhatsAppPersonal = 'WhatsAppPersonal'
}

export enum PeriodValueTypeEnum {
  CompareValue = 'CompareValue',
  CurrentValue = 'CurrentValue'
}

export enum PeriodKind {
  All = 'All',
  Custom = 'Custom',
  Days14Next = 'Days14Next',
  Days30Next = 'Days30Next',
  Days30Previous = 'Days30Previous',
  Days7Next = 'Days7Next',
  Days7Previous = 'Days7Previous',
  FinancialYearCurrent = 'FinancialYearCurrent',
  FinancialYearNext = 'FinancialYearNext',
  FinancialYearPrevious = 'FinancialYearPrevious',
  FinancialYearQuarter1 = 'FinancialYearQuarter1',
  FinancialYearQuarter2 = 'FinancialYearQuarter2',
  FinancialYearQuarter3 = 'FinancialYearQuarter3',
  FinancialYearQuarter4 = 'FinancialYearQuarter4',
  Month3Last = 'Month3Last',
  MonthCurrent = 'MonthCurrent',
  MonthCurrentInPreviousYear = 'MonthCurrentInPreviousYear',
  MonthNext = 'MonthNext',
  MonthPrevious = 'MonthPrevious',
  Quarter1 = 'Quarter1',
  Quarter2 = 'Quarter2',
  Quarter3 = 'Quarter3',
  Quarter4 = 'Quarter4',
  Quarter4Previous = 'Quarter4Previous',
  QuarterCurrent = 'QuarterCurrent',
  QuarterCurrentInPreviousYear = 'QuarterCurrentInPreviousYear',
  QuarterNext = 'QuarterNext',
  QuarterPrevious = 'QuarterPrevious',
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  UpToToday = 'UpToToday',
  Week2Last = 'Week2Last',
  Week4Last = 'Week4Last',
  WeekCurrent = 'WeekCurrent',
  WeekNext = 'WeekNext',
  WeekPrevious = 'WeekPrevious',
  Year3Last = 'Year3Last',
  YearCurrent = 'YearCurrent',
  YearNext = 'YearNext',
  YearPrevious = 'YearPrevious',
  Yesterday = 'Yesterday'
}

export enum PeriodGranularity {
  Day = 'Day',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export enum PeriodCompareKind {
  Custom = 'Custom',
  DoNotCompare = 'DoNotCompare',
  PreviousPeriod = 'PreviousPeriod',
  PreviousYear = 'PreviousYear'
}

export enum PartnerTier {
  Gold = 'Gold',
  Platinum = 'Platinum',
  Silver = 'Silver'
}

export enum PartnerTargetCustomers {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
  Soho = 'Soho'
}

export enum PartnerPermsEnum {
  Create = 'Create',
  CreateTrial = 'CreateTrial',
  Delete = 'Delete',
  Disable = 'Disable',
  Enable = 'Enable',
  InviteUsers = 'InviteUsers',
  Read = 'Read',
  Write = 'Write',
  WriteBasic = 'WriteBasic'
}

export enum PartnerCompanySize {
  Size1001to5000 = 'Size1001to5000',
  Size11to50 = 'Size11to50',
  Size1to10 = 'Size1to10',
  Size201to500 = 'Size201to500',
  Size5001to10000 = 'Size5001to10000',
  Size501to1000 = 'Size501to1000',
  Size51to200 = 'Size51to200',
  SizeAbove10000 = 'SizeAbove10000'
}

export enum PartnerCompanyFocus {
  Accounting = 'Accounting',
  Crm = 'Crm',
  HelpDesk = 'HelpDesk',
  HostedApps = 'HostedApps',
  Marketing = 'Marketing',
  Process = 'Process',
  Training = 'Training'
}

export enum PartnerActiveCustomers {
  Size101to200 = 'Size101to200',
  Size11to50 = 'Size11to50',
  Size1to10 = 'Size1to10',
  Size201to1000 = 'Size201to1000',
  Size51to100 = 'Size51to100',
  SizeAbove1000 = 'SizeAbove1000'
}

export enum OrgRelationshipTypeEnum {
  Moderate = 'Moderate',
  NoRelationship = 'NoRelationship',
  Strong = 'Strong',
  Weak = 'Weak'
}

export enum OrgChartContactRelation {
  Subordinate = 'Subordinate',
  Supervisor = 'Supervisor'
}

export enum OrgChartAssistantRelation {
  Assistant = 'Assistant',
  Subordinate = 'Subordinate'
}

export enum OrderTypeOfSaleEnum {
  New = 'New',
  OneTimeFee = 'OneTimeFee',
  Other = 'Other',
  RecurringUpsell = 'RecurringUpsell',
  Renewal = 'Renewal',
  TierUpdate = 'TierUpdate'
}

export enum OrderStatusEnum {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Open = 'Open',
  OpenOverdue = 'OpenOverdue'
}

export enum OrderRelatedDocumentTypeEnum {
  Credit = 'Credit',
  Payment = 'Payment'
}

export enum OrderRelatedDocumentPermsEnum {
  Delete = 'Delete',
  Read = 'Read'
}

export enum OrderPermsEnum {
  Cancel = 'Cancel',
  ChangeInvoiceBilling = 'ChangeInvoiceBilling',
  ConfirmPayment = 'ConfirmPayment',
  FixMrr = 'FixMrr',
  Pay = 'Pay',
  Read = 'Read',
  ViewHistory = 'ViewHistory'
}

export enum OrderHistoryStatusEnum {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  New = 'New',
  PayOrderRepeat = 'PayOrderRepeat',
  PaymentPending = 'PaymentPending',
  PaymentReview = 'PaymentReview',
  Unknown = 'Unknown'
}

export enum OrderByEnum {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum OrderActionEnum {
  AdditionalServices = 'AdditionalServices',
  Downgrade = 'Downgrade',
  DowngradeAdmin = 'DowngradeAdmin',
  Purchase = 'Purchase',
  PurchaseAdmin = 'PurchaseAdmin',
  PurchaseLoggedUser = 'PurchaseLoggedUser',
  Renew = 'Renew',
  TierUpdate = 'TierUpdate',
  Upgrade = 'Upgrade',
  UpgradeAdmin = 'UpgradeAdmin',
  UpgradeCommercial = 'UpgradeCommercial',
  UpgradeCommercialAdmin = 'UpgradeCommercialAdmin'
}

export enum OpptyStatusEnum {
  Lost = 'Lost',
  Open = 'Open',
  Won = 'Won'
}

export enum OpportunityGroupBy {
  Account = 'Account',
  ClosingDate = 'ClosingDate',
  Contact = 'Contact',
  NoGrouping = 'NoGrouping',
  Owner = 'Owner',
  Unit = 'Unit'
}

export enum OpportunityForecastQuotaSplitType {
  Custom = 'Custom',
  Evenly = 'Evenly',
  HistoricalPerformance = 'HistoricalPerformance'
}

export enum OnlineFormTypeDetailResponseGridSortBy {
  EntityName = 'EntityName',
  ResponseDate = 'ResponseDate',
  ResponseValue = 'ResponseValue'
}

export enum OnlineFormTypeDetailGridSortBy {
  CountOfResponses = 'CountOfResponses',
  EntityName = 'EntityName',
  ResponseDate = 'ResponseDate',
  ResponseValue = 'ResponseValue',
  SentDate = 'SentDate'
}

export enum OnlineFormPrefillTypeEnum {
  Custom = 'Custom',
  Field = 'Field'
}

export enum OnlineFormNotificationRecipientType {
  Custom = 'Custom',
  Owner = 'Owner',
  PrimaryRecordOwner = 'PrimaryRecordOwner'
}

export enum OnlineFormConfirmationPageType {
  ConfirmationPage = 'ConfirmationPage',
  ExternalUrl = 'ExternalUrl'
}

export enum OnlineFormButtonPositionEnum {
  Left = 'Left',
  Middle = 'Middle',
  Right = 'Right'
}

export enum OfficeTemplateTypeEnum {
  Excel = 'Excel',
  Word = 'Word'
}

export enum O365SettingTypeEnum {
  Calendar = 'Calendar',
  Contacts = 'Contacts',
  Mail = 'Mail',
  Tasks = 'Tasks'
}

export enum NumberOfSalesPeople {
  Group2to4 = 'Group2to4',
  Individual = 'Individual',
  Team11to25 = 'Team11to25',
  Team26to50 = 'Team26to50',
  Team5to10 = 'Team5to10',
  TeamOver50 = 'TeamOver50'
}

export enum NotificationSettingType {
  Action = 'Action',
  ActionWithNotice = 'ActionWithNotice',
  Notice = 'Notice'
}

export enum NotificationSettingStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export enum NotificationSettingSettingTypeEnum {
  Addon = 'Addon',
  License = 'License'
}

export enum NotificationSettingService {
  OrderDunning = 'OrderDunning',
  SubscriptionRenewal = 'SubscriptionRenewal'
}

export enum NotificationSettingPermsEnum {
  Read = 'Read',
  Write = 'Write'
}

export enum NotificationRenewalPermsEnum {
  ChangeProcessed = 'ChangeProcessed'
}

export enum NotificationEventEnum {
  ApprovalDelegate = 'ApprovalDelegate',
  ApprovalRequest = 'ApprovalRequest',
  ApprovalResponse = 'ApprovalResponse',
  AssignedAsEditor = 'AssignedAsEditor',
  AssignedAsWatcher = 'AssignedAsWatcher',
  AutomatizerEmailSendRequest = 'AutomatizerEmailSendRequest',
  BackToLead = 'BackToLead',
  Canceled = 'Canceled',
  Comment = 'Comment',
  Create = 'Create',
  EmailBounced = 'EmailBounced',
  EmailFailed = 'EmailFailed',
  EmailOpen = 'EmailOpen',
  EmailReceived = 'EmailReceived',
  EmailSent = 'EmailSent',
  EmailSequencesEmailSendRequest = 'EmailSequencesEmailSendRequest',
  InvitationConfirmed = 'InvitationConfirmed',
  InvitationReceived = 'InvitationReceived',
  InvitationRejected = 'InvitationRejected',
  LinkedAppointment = 'LinkedAppointment',
  LinkedChildAccount = 'LinkedChildAccount',
  LinkedCloudObject = 'LinkedCloudObject',
  LinkedContact = 'LinkedContact',
  LinkedLead = 'LinkedLead',
  LinkedMemo = 'LinkedMemo',
  LinkedNote = 'LinkedNote',
  LinkedOpportunity = 'LinkedOpportunity',
  LinkedProject = 'LinkedProject',
  LinkedQuote = 'LinkedQuote',
  LinkedTask = 'LinkedTask',
  Lost = 'Lost',
  OwnershipChangedToColleague = 'OwnershipChangedToColleague',
  OwnershipChangedToMe = 'OwnershipChangedToMe',
  OwnershipReleased = 'OwnershipReleased',
  Qualified = 'Qualified',
  Reactivated = 'Reactivated',
  StatusChanged = 'StatusChanged',
  StepChanged = 'StepChanged',
  TextMessageReceived = 'TextMessageReceived',
  TextMessageSent = 'TextMessageSent',
  Won = 'Won'
}

export enum NotificationEventActionTypeEnum {
  ApprovalDelegation = 'ApprovalDelegation',
  ApprovalProcessError = 'ApprovalProcessError',
  ApprovalProcessWarning = 'ApprovalProcessWarning',
  ApprovalRequest = 'ApprovalRequest',
  ApprovalResponse = 'ApprovalResponse',
  Bounced = 'Bounced',
  Comment = 'Comment',
  Create = 'Create',
  Errors = 'Errors',
  Invitation = 'Invitation',
  IsActive = 'IsActive',
  LinkedItem = 'LinkedItem',
  Move = 'Move',
  OwnershipAndSalesTeamChange = 'OwnershipAndSalesTeamChange',
  Qualification = 'Qualification',
  Responses = 'Responses',
  StatusChange = 'StatusChange',
  Tracking = 'Tracking',
  Warnings = 'Warnings'
}

export enum NotificationEntityGroupsEnum {
  AccountsAndContacts = 'AccountsAndContacts',
  Activities = 'Activities',
  ApprovalProcesses = 'ApprovalProcesses',
  CallingAndMessaging = 'CallingAndMessaging',
  CustomEntities = 'CustomEntities',
  EmailSequences = 'EmailSequences',
  Emails = 'Emails',
  Feeds = 'Feeds',
  LeadsAndOpportunities = 'LeadsAndOpportunities',
  OnlineForms = 'OnlineForms',
  ProcessBuilder = 'ProcessBuilder',
  Projects = 'Projects',
  Quotes = 'Quotes',
  WhatsApp = 'WhatsApp'
}

export enum MultiMatchEnum {
  OnlyReturn = 'OnlyReturn',
  RaiseError = 'RaiseError',
  SkipUpdate = 'SkipUpdate',
  UpdateAll = 'UpdateAll',
  UpdateNewest = 'UpdateNewest',
  UpdateNewestIgnoreEmpty = 'UpdateNewestIgnoreEmpty',
  UpdateOldest = 'UpdateOldest'
}

export enum MsStorageIntegrationTypeEnum {
  OneDrive = 'OneDrive',
  SharePoint = 'SharePoint'
}

export enum MediaTypeEnum {
  Audio = 'Audio',
  Transcription = 'Transcription',
  Video = 'Video'
}

export enum MediaStatusEnum {
  NoRecording = 'NoRecording',
  Transcoding = 'Transcoding',
  TranscriptionCompleted = 'TranscriptionCompleted',
  TranscriptionInProgress = 'TranscriptionInProgress',
  Uploaded = 'Uploaded',
  Uploading = 'Uploading'
}

export enum MatchingOperatorEnum {
  eq = 'eq',
  ieq = 'ieq'
}

export enum MatchSimilarityLevelEnum {
  Exact = 'Exact',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum MasterRecordResolutionEnum {
  CustomCondition = 'CustomCondition',
  LatestCreatedRecord = 'LatestCreatedRecord',
  MostPopulatedRecord = 'MostPopulatedRecord',
  OldestCreatedRecord = 'OldestCreatedRecord'
}

export enum MassEmailRelationCategory {
  All = 'All',
  Bounced = 'Bounced',
  Clicked = 'Clicked',
  NotOpened = 'NotOpened',
  NotSent = 'NotSent',
  Opened = 'Opened',
  Replied = 'Replied',
  Unsubscribed = 'Unsubscribed'
}

export enum MassEmailDetailGridSortyBy {
  Email = 'Email',
  EmailCountInThread = 'EmailCountInThread',
  Name = 'Name',
  Owner = 'Owner'
}

export enum ManageUserDataActionEnum {
  ChangeOwnership = 'ChangeOwnership',
  Delete = 'Delete',
  SetToPrivate = 'SetToPrivate'
}

export enum LookupVisualizationType {
  Card = 'Card',
  MultiSelection = 'MultiSelection'
}

export enum LookupPrimaryRelationResolutionEnum {
  FirstAddedIntoLookup = 'FirstAddedIntoLookup',
  LastAddedIntoLookup = 'LastAddedIntoLookup',
  LatestCreatedWithinLookup = 'LatestCreatedWithinLookup',
  OldestCreatedWithinLookup = 'OldestCreatedWithinLookup'
}

export enum LookupEntityTypeEnum {
  Account = 'Account',
  Appointment = 'Appointment',
  Client = 'Client',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  OpptyProductRelation = 'OpptyProductRelation',
  Product = 'Product',
  Project = 'Project',
  Quote = 'Quote',
  Task = 'Task'
}

export enum LoginType {
  PipelinerLogin = 'PipelinerLogin',
  QR = 'QR'
}

export enum LinkedEntityType {
  Account = 'Account',
  Appointment = 'Appointment',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Email = 'Email',
  Lead = 'Lead',
  Memo = 'Memo',
  Opportunity = 'Opportunity',
  Project = 'Project',
  Quote = 'Quote',
  Step = 'Step',
  Task = 'Task'
}

export enum LicEntityPermsEnum {
  AdminAccess = 'AdminAccess',
  AdminAutomationHub = 'AdminAutomationHub',
  AdminSetAutomationHub = 'AdminSetAutomationHub',
  ApiAdmin = 'ApiAdmin',
  Create = 'Create',
  Delete = 'Delete',
  EditPicture = 'EditPicture',
  Partner = 'Partner',
  Reactivate = 'Reactivate',
  Read = 'Read',
  ResetSpace = 'ResetSpace',
  Restore = 'Restore',
  Suspend = 'Suspend',
  SuspendWithReason = 'SuspendWithReason',
  ToggleFeaturePromotion = 'ToggleFeaturePromotion',
  ToggleReleaseNote = 'ToggleReleaseNote',
  UpdateName = 'UpdateName',
  Write = 'Write'
}

export enum LeadStatusEnum {
  Lost = 'Lost',
  Open = 'Open',
  Qualified = 'Qualified'
}

export enum LeadOpptyKpiEnum {
  CreateLeads = 'CreateLeads',
  CreateOppty = 'CreateOppty',
  LastMove = 'LastMove',
  LoseLead = 'LoseLead',
  LoseOppty = 'LoseOppty',
  QualifyLead = 'QualifyLead',
  WinOppty = 'WinOppty'
}

export enum LeadGroupBy {
  Account = 'Account',
  Contact = 'Contact',
  NoGrouping = 'NoGrouping',
  Owner = 'Owner',
  Unit = 'Unit'
}

export enum LastActivityInterval {
  Last14days = 'Last14days',
  Last24hours = 'Last24hours',
  Last7days = 'Last7days'
}

export enum LabelFlagEnum {
  Hot = 'Hot',
  Priority = 'Priority',
  Stalled = 'Stalled'
}

export enum InviteeResponseEnum {
  Accepted = 'Accepted',
  NoResponse = 'NoResponse',
  Rejected = 'Rejected'
}

export enum InterfaceDetailWidgetKind {
  AiSummary = 'AiSummary',
  Approval = 'Approval',
  DuplicateChecker = 'DuplicateChecker',
  EmailSequences = 'EmailSequences',
  EntityHealth = 'EntityHealth',
  EntityScoring = 'EntityScoring',
  Fitness = 'Fitness',
  Hubspot = 'Hubspot',
  Owner = 'Owner',
  Processes = 'Processes',
  RevenueSchedule = 'RevenueSchedule',
  Sharing = 'Sharing',
  Social = 'Social',
  StaticProfiles = 'StaticProfiles',
  Status = 'Status',
  StepChecklist = 'StepChecklist',
  Tags = 'Tags'
}

export enum InterfaceDetailTabKind {
  Accounts = 'Accounts',
  Activities = 'Activities',
  BuyingCenter = 'BuyingCenter',
  Contacts = 'Contacts',
  Detail = 'Detail',
  Documents = 'Documents',
  Feeds = 'Feeds',
  Leads = 'Leads',
  Lookup = 'Lookup',
  LookupRelated = 'LookupRelated',
  Notes = 'Notes',
  Opportunities = 'Opportunities',
  OrgChart = 'OrgChart',
  ProductPricing = 'ProductPricing',
  Products = 'Products',
  Projects = 'Projects',
  Quotes = 'Quotes',
  RelationGraph = 'RelationGraph'
}

export enum IntegrationLogFilterPeriodEnum {
  Custom = 'Custom',
  Last2Days = 'Last2Days',
  Last7Days = 'Last7Days',
  LastHour = 'LastHour',
  Today = 'Today'
}

export enum IntegrationJournalLogStatusEnum {
  error = 'error',
  success = 'success',
  warning = 'warning'
}

export enum IntegrationEventStatusEnum {
  Error = 'Error',
  Success = 'Success',
  Warning = 'Warning'
}

export enum IntegrationAnalyticsRunsGroupByEnum {
  Integration = 'Integration',
  Space = 'Space',
  Status = 'Status',
  User = 'User'
}

export enum IntegrationAnalyticsOperationsGroupByEnum {
  Operation = 'Operation',
  OperationType = 'OperationType'
}

export enum IntegrationAnalyticsGranularityEnum {
  Day = 'Day',
  Hour = 'Hour'
}

export enum IntegrationAnalyticsFilterPeriodEnum {
  Custom = 'Custom',
  Last30Days = 'Last30Days',
  Last6Months = 'Last6Months',
  Last7Days = 'Last7Days',
  Last90Days = 'Last90Days',
  Today = 'Today'
}

export enum IntegrationAnalyticsApiCallsGroupByEnum {
  Integration = 'Integration',
  Space = 'Space',
  Status = 'Status',
  User = 'User'
}

export enum InsightsReportBy {
  BySalesUnit = 'BySalesUnit',
  ByUsers = 'ByUsers',
  MyResults = 'MyResults'
}

export enum InsightsKPITrend {
  Falling = 'Falling',
  Rising = 'Rising',
  Stalling = 'Stalling'
}

export enum InsightsKPI {
  CompletingActivities = 'CompletingActivities',
  CreatingActivities = 'CreatingActivities',
  CreatingLeads = 'CreatingLeads',
  CreatingOppties = 'CreatingOppties',
  LeadAverageTimeSpent = 'LeadAverageTimeSpent',
  LosingLeads = 'LosingLeads',
  LosingOppties = 'LosingOppties',
  LostAmount = 'LostAmount',
  OpptyAverageSize = 'OpptyAverageSize',
  OpptyAverageTimeSpent = 'OpptyAverageTimeSpent',
  OpptySalesVelocity = 'OpptySalesVelocity',
  OpptyWinRate = 'OpptyWinRate',
  QualifyingLeads = 'QualifyingLeads',
  SendingEmails = 'SendingEmails',
  WinningOppties = 'WinningOppties',
  WonAmount = 'WonAmount'
}

export enum InfluenceTypeEnum {
  Negative = 'Negative',
  Positive = 'Positive'
}

export enum IndicatorsReportBy {
  BySalesUnit = 'BySalesUnit',
  ByUsers = 'ByUsers'
}

export enum ImportSeparatorEnum {
  Auto = 'Auto',
  Colon = 'Colon',
  Comma = 'Comma',
  Semicolon = 'Semicolon',
  Tab = 'Tab'
}

export enum ImportMultipleCheckboxSeparatorEnum {
  Colon = 'Colon',
  Comma = 'Comma',
  Pipe = 'Pipe',
  Semicolon = 'Semicolon',
  Tab = 'Tab'
}

export enum ImportMaskEntityTypeEnum {
  Account = 'Account',
  Client = 'Client',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  Product = 'Product',
  ProductPriceListPrice = 'ProductPriceListPrice'
}

export enum ImportFieldMappingType {
  CalculateValue = 'CalculateValue',
  ColumnIndex = 'ColumnIndex',
  UseDefaultValues = 'UseDefaultValues'
}

export enum ImportEnclosureEnum {
  Apostrophe = 'Apostrophe',
  Auto = 'Auto',
  NoEnclosure = 'NoEnclosure',
  QuestionMark = 'QuestionMark'
}

export enum ImportDateFormatEnum {
  Auto = 'Auto',
  DD_MM_YYYY = 'DD_MM_YYYY',
  MM_DD_YYYY = 'MM_DD_YYYY',
  YYYY_DD_MM = 'YYYY_DD_MM',
  YYYY_MM_DD = 'YYYY_MM_DD'
}

export enum ImapLoginTypeEnum {
  Gmail = 'Gmail',
  Imap = 'Imap',
  MsExchange = 'MsExchange',
  O365 = 'O365',
  SendGrid = 'SendGrid'
}

export enum IdentityProviderType {
  GoogleAccount = 'GoogleAccount',
  MSADFS = 'MSADFS',
  MicrosoftAccount = 'MicrosoftAccount',
  MicrosoftIdentityPlatform = 'MicrosoftIdentityPlatform',
  OAuth2 = 'OAuth2',
  OpenID = 'OpenID'
}

export enum IdentityProviderPermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  EditVerifiedEmailDomains = 'EditVerifiedEmailDomains',
  Read = 'Read',
  Restore = 'Restore',
  Write = 'Write'
}

export enum HowToType {
  Article = 'Article',
  Ebook = 'Ebook',
  Intercom = 'Intercom',
  SupportForm = 'SupportForm',
  Video = 'Video'
}

export enum HowToPermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum HowToCategory {
  AccountsHierarchy = 'AccountsHierarchy',
  AccountsRelations = 'AccountsRelations',
  Applications = 'Applications',
  ApprovalProcess = 'ApprovalProcess',
  AutomationHub = 'AutomationHub',
  BaseCurrency = 'BaseCurrency',
  CompanyEmails = 'CompanyEmails',
  CompanyPhoneNumbers = 'CompanyPhoneNumbers',
  ContactsRelations = 'ContactsRelations',
  Currencies = 'Currencies',
  EmailSequenceEditor = 'EmailSequenceEditor',
  ExchangeRates = 'ExchangeRates',
  FieldsAndForms = 'FieldsAndForms',
  FieldsAndFormsAccountHealth = 'FieldsAndFormsAccountHealth',
  FieldsAndFormsFieldPermissions = 'FieldsAndFormsFieldPermissions',
  FieldsAndFormsFitness = 'FieldsAndFormsFitness',
  FieldsAndFormsLeadScoring = 'FieldsAndFormsLeadScoring',
  FieldsAndFormsSettings = 'FieldsAndFormsSettings',
  FieldsAndFormsTags = 'FieldsAndFormsTags',
  FieldsAndFormsWebResources = 'FieldsAndFormsWebResources',
  Forecasts = 'Forecasts',
  GlobalSettings = 'GlobalSettings',
  LeadProcesses = 'LeadProcesses',
  OnlineForms = 'OnlineForms',
  Pipelines = 'Pipelines',
  PriceLists = 'PriceLists',
  ProcessEditor = 'ProcessEditor',
  ProductCategories = 'ProductCategories',
  Products = 'Products',
  QuoteProcesses = 'QuoteProcesses',
  Roles = 'Roles',
  SalesRoles = 'SalesRoles',
  Targets = 'Targets',
  Units = 'Units',
  Users = 'Users'
}

export enum HighlightPeriodEnum {
  Custom = 'Custom',
  Last14Days = 'Last14Days',
  Last30Days = 'Last30Days',
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  Last7Days = 'Last7Days',
  LastYear = 'LastYear'
}

export enum HardcodedContainerTypeEnum {
  AccountName = 'AccountName',
  ContactName = 'ContactName',
  MessageToSalesTeam = 'MessageToSalesTeam',
  ProductName = 'ProductName'
}

export enum HardcodedAggregationType {
  Average = 'Average',
  Max = 'Max',
  Sum = 'Sum'
}

export enum GroupOption {
  AutoIntervals = 'AutoIntervals',
  Combinations = 'Combinations',
  Daily = 'Daily',
  FirstLetter = 'FirstLetter',
  ManualIntervals = 'ManualIntervals',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Values = 'Values',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export enum GoogleSyncSettingTypeEnum {
  Calendar = 'Calendar',
  Contacts = 'Contacts',
  Gmail = 'Gmail',
  Mail = 'Mail',
  Tasks = 'Tasks'
}

export enum GlobalSearchType {
  Account = 'Account',
  Activity = 'Activity',
  Any = 'Any',
  CloudObject = 'CloudObject',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Note = 'Note',
  Opportunity = 'Opportunity',
  Project = 'Project',
  Quote = 'Quote'
}

export enum GlobalSearchSorting {
  Alphabetically = 'Alphabetically',
  BestMatch = 'BestMatch',
  CreatedDate = 'CreatedDate',
  DataGrouping = 'DataGrouping',
  LastSeen = 'LastSeen',
  ModifiedDate = 'ModifiedDate'
}

export enum GenericServiceTypeEnum {
  Hubspot = 'Hubspot',
  Jira = 'Jira',
  MsDynamics = 'MsDynamics',
  PandaDoc = 'PandaDoc',
  Salesforce = 'Salesforce',
  Zendesk = 'Zendesk'
}

export enum GenderEnum {
  Female = 'Female',
  Male = 'Male',
  NonBinary = 'NonBinary',
  Unknown = 'Unknown'
}

export enum FrozenPaneType {
  FirstCol = 'FirstCol',
  FirstRow = 'FirstRow',
  FirstRowCol = 'FirstRowCol',
  NoRowCol = 'NoRowCol'
}

export enum FormTypeEnum {
  Edit = 'Edit',
  Lost = 'Lost'
}

export enum FormItemKindEnum {
  Container = 'Container',
  HardcodedContainer = 'HardcodedContainer',
  Separator = 'Separator',
  StepFieldsContainer = 'StepFieldsContainer',
  Subsection = 'Subsection'
}

export enum FormContainerItemKind {
  Field = 'Field',
  WebResource = 'WebResource'
}

export enum ForecastValueComparisonEnum {
  Forecast = 'Forecast',
  NoComparison = 'NoComparison',
  Prediction = 'Prediction',
  PreviousPeriod = 'PreviousPeriod',
  PreviousYear = 'PreviousYear',
  Quota = 'Quota'
}

export enum ForecastType {
  Accounts = 'Accounts',
  ProductCategories = 'ProductCategories',
  Products = 'Products',
  SalesUnits = 'SalesUnits',
  Users = 'Users'
}

export enum ForecastPeriodKind {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly'
}

export enum ForecastPerformanceComparisonType {
  AveragePerformance = 'AveragePerformance',
  PreviousPeriod = 'PreviousPeriod',
  WeightedAveragePerformance = 'WeightedAveragePerformance'
}

export enum ForecastOpenValueTypeEnum {
  Balanced = 'Balanced',
  Ranked = 'Ranked',
  Unweighted = 'Unweighted',
  Weighted = 'Weighted'
}

export enum ForecastColumnsType {
  LostValueUnweighted = 'LostValueUnweighted',
  OpenValueBalanced = 'OpenValueBalanced',
  OpenValueRanked = 'OpenValueRanked',
  OpenValueUnweighted = 'OpenValueUnweighted',
  OpenValueWeighted = 'OpenValueWeighted',
  WonOpenValueUnweighted = 'WonOpenValueUnweighted',
  WonOpenValueVsQuotaUnweighted = 'WonOpenValueVsQuotaUnweighted',
  WonOpenVsForecast = 'WonOpenVsForecast',
  WonValueCurrentPeriod = 'WonValueCurrentPeriod',
  WonValueSamePeriodInPreviousYear = 'WonValueSamePeriodInPreviousYear',
  WonValueSamePeriodInPreviousYearPercentage = 'WonValueSamePeriodInPreviousYearPercentage',
  WonValueVsQuota = 'WonValueVsQuota',
  WonVsForecast = 'WonVsForecast'
}

export enum ForecastBaseValueEnum {
  Lost = 'Lost',
  Open = 'Open',
  Prediction = 'Prediction',
  Won = 'Won',
  WonOpen = 'WonOpen'
}

export enum FitnessPeriodEnum {
  CurrentMonth = 'CurrentMonth',
  CurrentWeek = 'CurrentWeek',
  LastTwoWeeks = 'LastTwoWeeks'
}

export enum FitnessIndicatorTypeEnum {
  ClosingDateOverdue = 'ClosingDateOverdue',
  Custom = 'Custom',
  LowEmailEngagement = 'LowEmailEngagement',
  LowEmailOutreach = 'LowEmailOutreach',
  ManyClosingDateUpdates = 'ManyClosingDateUpdates',
  MovedToPreviousStep = 'MovedToPreviousStep',
  NoFollowUp = 'NoFollowUp',
  RankingDecrease = 'RankingDecrease',
  SalesCycleOverdue = 'SalesCycleOverdue',
  SalesStepVelocityOverdue = 'SalesStepVelocityOverdue',
  TasksOverdue = 'TasksOverdue',
  ValueDecrease = 'ValueDecrease'
}

export enum FirstDayOfWeekEnum {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum FilterGroupOperator {
  And = 'And',
  Custom = 'Custom',
  Or = 'Or'
}

export enum FilterFieldDescriptorRequestor {
  LookupFilter = 'LookupFilter',
  SequenceFilter = 'SequenceFilter'
}

export enum FileTypeEnum {
  Audio = 'Audio',
  Custom = 'Custom',
  Document = 'Document',
  Drawing = 'Drawing',
  Image = 'Image',
  Pdf = 'Pdf',
  Presentation = 'Presentation',
  Spreadsheet = 'Spreadsheet',
  Video = 'Video'
}

export enum FieldSystemType {
  COMPUTED = 'COMPUTED',
  CUSTOM = 'CUSTOM',
  PROTECTED = 'PROTECTED',
  SYSTEM = 'SYSTEM',
  VIRTUAL = 'VIRTUAL'
}

export enum FieldRelationTypeEnum {
  Lookup = 'Lookup',
  LookupRelated = 'LookupRelated',
  System = 'System'
}

export enum FieldOperator {
  Between = 'Between',
  BetweenNot = 'BetweenNot',
  Contains = 'Contains',
  ContainsNot = 'ContainsNot',
  EndsWith = 'EndsWith',
  Has = 'Has',
  HasNot = 'HasNot',
  In = 'In',
  InNot = 'InNot',
  Is = 'Is',
  IsEmpty = 'IsEmpty',
  IsNot = 'IsNot',
  IsNotEmpty = 'IsNotEmpty',
  Less = 'Less',
  LessOrEqual = 'LessOrEqual',
  More = 'More',
  MoreOrEqual = 'MoreOrEqual',
  Nop = 'Nop',
  RelativePeriod = 'RelativePeriod',
  RelativePeriodNot = 'RelativePeriodNot',
  StartsWith = 'StartsWith'
}

export enum FieldMappingOperationTypeEnum {
  Conversion = 'Conversion',
  Default = 'Default',
  FollowUp = 'FollowUp',
  Parent = 'Parent',
  Qualification = 'Qualification',
  QualificationAndAutocreate = 'QualificationAndAutocreate'
}

export enum FieldMappingOperationEnum {
  Custom = 'Custom',
  SourceRecordValue = 'SourceRecordValue'
}

export enum FeedViewTypeEnum {
  Card = 'Card',
  List = 'List'
}

export enum FeedStreamTypeEnum {
  All = 'All',
  BestRankedOpportunities = 'BestRankedOpportunities',
  Customers = 'Customers',
  Documents = 'Documents',
  Emails = 'Emails',
  Favorite = 'Favorite',
  HotOpportunities = 'HotOpportunities',
  MassEmail = 'MassEmail',
  OnlineFormResponses = 'OnlineFormResponses',
  RecentEmails = 'RecentEmails',
  RecentMassEmails = 'RecentMassEmails',
  ScheduledEmails = 'ScheduledEmails',
  Unlinked = 'Unlinked'
}

export enum FeedEmailTypeEnum {
  Automated = 'Automated',
  Bounced = 'Bounced',
  Clicked = 'Clicked',
  Incoming = 'Incoming',
  NotOpened = 'NotOpened',
  Opened = 'Opened',
  Outgoing = 'Outgoing',
  Unsubscribed = 'Unsubscribed'
}

export enum FeaturePromotionEnum {
  BuyingCenter = 'BuyingCenter',
  CalendarIntegration = 'CalendarIntegration',
  DocumentPlugin = 'DocumentPlugin',
  EmailIntegration = 'EmailIntegration',
  EmailPlugin = 'EmailPlugin',
  OrgChart = 'OrgChart',
  TargetDetail = 'TargetDetail'
}

export enum FavoriteRecordsType {
  Account = 'Account',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  Project = 'Project',
  Quote = 'Quote',
  Report = 'Report'
}

export enum ExchangeSyncSettingTypeEnum {
  Calendar = 'Calendar',
  Contacts = 'Contacts',
  Tasks = 'Tasks'
}

export enum ExchangeAuthMethodTypeEnum {
  Basic = 'Basic',
  OAUTH = 'OAUTH'
}

export enum EventEnum {
  AccountAll = 'AccountAll',
  AccountCreate = 'AccountCreate',
  AccountDelete = 'AccountDelete',
  AccountDocumentLinked = 'AccountDocumentLinked',
  AccountOwnerChanged = 'AccountOwnerChanged',
  AccountUpdate = 'AccountUpdate',
  ActivityRelationAll = 'ActivityRelationAll',
  ActivityRelationCreate = 'ActivityRelationCreate',
  ActivityRelationDelete = 'ActivityRelationDelete',
  ActivityRelationUpdate = 'ActivityRelationUpdate',
  All = 'All',
  AppointmentAll = 'AppointmentAll',
  AppointmentComment = 'AppointmentComment',
  AppointmentCreate = 'AppointmentCreate',
  AppointmentDelete = 'AppointmentDelete',
  AppointmentDocumentLinked = 'AppointmentDocumentLinked',
  AppointmentOwnerChanged = 'AppointmentOwnerChanged',
  AppointmentUpdate = 'AppointmentUpdate',
  ContactAccountRelationAll = 'ContactAccountRelationAll',
  ContactAccountRelationCreate = 'ContactAccountRelationCreate',
  ContactAccountRelationDelete = 'ContactAccountRelationDelete',
  ContactAccountRelationUpdate = 'ContactAccountRelationUpdate',
  ContactAll = 'ContactAll',
  ContactCreate = 'ContactCreate',
  ContactDelete = 'ContactDelete',
  ContactDocumentLinked = 'ContactDocumentLinked',
  ContactOwnerChanged = 'ContactOwnerChanged',
  ContactUpdate = 'ContactUpdate',
  CurrencyAll = 'CurrencyAll',
  CurrencyCreate = 'CurrencyCreate',
  CurrencyDelete = 'CurrencyDelete',
  CurrencyExchangeRateAll = 'CurrencyExchangeRateAll',
  CurrencyExchangeRateCreate = 'CurrencyExchangeRateCreate',
  CurrencyExchangeRateDelete = 'CurrencyExchangeRateDelete',
  CurrencyExchangeRateUpdate = 'CurrencyExchangeRateUpdate',
  CurrencyExchangeRatesListAll = 'CurrencyExchangeRatesListAll',
  CurrencyExchangeRatesListCreate = 'CurrencyExchangeRatesListCreate',
  CurrencyExchangeRatesListDelete = 'CurrencyExchangeRatesListDelete',
  CurrencyExchangeRatesListUpdate = 'CurrencyExchangeRatesListUpdate',
  CurrencyUpdate = 'CurrencyUpdate',
  CustomEntityAll = 'CustomEntityAll',
  CustomEntityCreate = 'CustomEntityCreate',
  CustomEntityDelete = 'CustomEntityDelete',
  CustomEntityDocumentLinked = 'CustomEntityDocumentLinked',
  CustomEntityOwnerChanged = 'CustomEntityOwnerChanged',
  CustomEntityUpdate = 'CustomEntityUpdate',
  EmailAll = 'EmailAll',
  EmailCreate = 'EmailCreate',
  EmailDelete = 'EmailDelete',
  EmailDocumentLinked = 'EmailDocumentLinked',
  EmailUpdate = 'EmailUpdate',
  LeadAll = 'LeadAll',
  LeadBackToLead = 'LeadBackToLead',
  LeadCreate = 'LeadCreate',
  LeadDelete = 'LeadDelete',
  LeadDocumentLinked = 'LeadDocumentLinked',
  LeadLost = 'LeadLost',
  LeadOpptyAccountRelationAll = 'LeadOpptyAccountRelationAll',
  LeadOpptyAccountRelationCreate = 'LeadOpptyAccountRelationCreate',
  LeadOpptyAccountRelationDelete = 'LeadOpptyAccountRelationDelete',
  LeadOpptyAccountRelationUpdate = 'LeadOpptyAccountRelationUpdate',
  LeadOpptyContactRelationAll = 'LeadOpptyContactRelationAll',
  LeadOpptyContactRelationCreate = 'LeadOpptyContactRelationCreate',
  LeadOpptyContactRelationDelete = 'LeadOpptyContactRelationDelete',
  LeadOpptyContactRelationUpdate = 'LeadOpptyContactRelationUpdate',
  LeadOwnerChanged = 'LeadOwnerChanged',
  LeadUpdate = 'LeadUpdate',
  MemoAll = 'MemoAll',
  MemoComment = 'MemoComment',
  MemoCreate = 'MemoCreate',
  MemoDelete = 'MemoDelete',
  MemoDocumentLinked = 'MemoDocumentLinked',
  MemoUpdate = 'MemoUpdate',
  MessageAll = 'MessageAll',
  MessageCreate = 'MessageCreate',
  MessageDelete = 'MessageDelete',
  MessageDocumentLinked = 'MessageDocumentLinked',
  MessageUpdate = 'MessageUpdate',
  NoteAll = 'NoteAll',
  NoteCreate = 'NoteCreate',
  NoteDelete = 'NoteDelete',
  NoteUpdate = 'NoteUpdate',
  OpportunityAll = 'OpportunityAll',
  OpportunityCreate = 'OpportunityCreate',
  OpportunityDelete = 'OpportunityDelete',
  OpportunityDocumentLinked = 'OpportunityDocumentLinked',
  OpportunityLost = 'OpportunityLost',
  OpportunityMove = 'OpportunityMove',
  OpportunityOwnerChanged = 'OpportunityOwnerChanged',
  OpportunityQualify = 'OpportunityQualify',
  OpportunityUpdate = 'OpportunityUpdate',
  OpportunityWon = 'OpportunityWon',
  OpptyProductRelationAll = 'OpptyProductRelationAll',
  OpptyProductRelationCreate = 'OpptyProductRelationCreate',
  OpptyProductRelationDelete = 'OpptyProductRelationDelete',
  OpptyProductRelationUpdate = 'OpptyProductRelationUpdate',
  ProductAll = 'ProductAll',
  ProductCreate = 'ProductCreate',
  ProductDelete = 'ProductDelete',
  ProductPriceListAll = 'ProductPriceListAll',
  ProductPriceListCreate = 'ProductPriceListCreate',
  ProductPriceListDelete = 'ProductPriceListDelete',
  ProductPriceListPriceAll = 'ProductPriceListPriceAll',
  ProductPriceListPriceCreate = 'ProductPriceListPriceCreate',
  ProductPriceListPriceDelete = 'ProductPriceListPriceDelete',
  ProductPriceListPriceUpdate = 'ProductPriceListPriceUpdate',
  ProductPriceListUpdate = 'ProductPriceListUpdate',
  ProductUpdate = 'ProductUpdate',
  ProjectAll = 'ProjectAll',
  ProjectCreate = 'ProjectCreate',
  ProjectDelete = 'ProjectDelete',
  ProjectDocumentLinked = 'ProjectDocumentLinked',
  ProjectOwnerChanged = 'ProjectOwnerChanged',
  ProjectUpdate = 'ProjectUpdate',
  QuoteAccountRelationAll = 'QuoteAccountRelationAll',
  QuoteAccountRelationCreate = 'QuoteAccountRelationCreate',
  QuoteAccountRelationDelete = 'QuoteAccountRelationDelete',
  QuoteAccountRelationUpdate = 'QuoteAccountRelationUpdate',
  QuoteAll = 'QuoteAll',
  QuoteContactRelationAll = 'QuoteContactRelationAll',
  QuoteContactRelationCreate = 'QuoteContactRelationCreate',
  QuoteContactRelationDelete = 'QuoteContactRelationDelete',
  QuoteContactRelationUpdate = 'QuoteContactRelationUpdate',
  QuoteCreate = 'QuoteCreate',
  QuoteDelete = 'QuoteDelete',
  QuoteDocumentLinked = 'QuoteDocumentLinked',
  QuoteLost = 'QuoteLost',
  QuoteMove = 'QuoteMove',
  QuoteOwnerChanged = 'QuoteOwnerChanged',
  QuoteUpdate = 'QuoteUpdate',
  QuoteWon = 'QuoteWon',
  TaskAll = 'TaskAll',
  TaskComment = 'TaskComment',
  TaskCreate = 'TaskCreate',
  TaskDelete = 'TaskDelete',
  TaskDocumentLinked = 'TaskDocumentLinked',
  TaskOwnerChanged = 'TaskOwnerChanged',
  TaskUpdate = 'TaskUpdate'
}

export enum EntitySubtypeKind {
  Appointment = 'Appointment',
  Email = 'Email',
  Lead = 'Lead',
  Memo = 'Memo',
  Opportunity = 'Opportunity',
  Quote = 'Quote',
  Task = 'Task',
  Timeframe = 'Timeframe'
}

export enum EntityScoringTrendEnum {
  Decreasing = 'Decreasing',
  Increasing = 'Increasing',
  NoChange = 'NoChange'
}

export enum EntityScoringRuleExpirationUnitEnum {
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month',
  Week = 'Week'
}

export enum EntityScoringRuleEmailEventTypeEnum {
  Bounced = 'Bounced',
  Clicked = 'Clicked',
  Opened = 'Opened',
  Replied = 'Replied',
  Sent = 'Sent',
  Unsubscribed = 'Unsubscribed'
}

export enum EntityPermsEnum {
  AdminAutomationHub = 'AdminAutomationHub',
  AdminSetAutomationHub = 'AdminSetAutomationHub',
  ApiAdmin = 'ApiAdmin',
  Archive = 'Archive',
  BackToLead = 'BackToLead',
  Call = 'Call',
  CancelApproval = 'CancelApproval',
  ChangeLeadProcess = 'ChangeLeadProcess',
  ChangePipeline = 'ChangePipeline',
  ChangeQuoteProcess = 'ChangeQuoteProcess',
  Complete = 'Complete',
  ContentOwnership = 'ContentOwnership',
  ContentRead = 'ContentRead',
  Copy = 'Copy',
  Create = 'Create',
  DelegateApproval = 'DelegateApproval',
  Delete = 'Delete',
  Invitee = 'Invitee',
  ManageUserData = 'ManageUserData',
  Merge = 'Merge',
  Move = 'Move',
  Ownership = 'Ownership',
  Qualify = 'Qualify',
  Reactivate = 'Reactivate',
  Read = 'Read',
  ReadCopy = 'ReadCopy',
  ReassignClient = 'ReassignClient',
  Release = 'Release',
  Reopen = 'Reopen',
  ResetPasswordClient = 'ResetPasswordClient',
  RespondToApproval = 'RespondToApproval',
  Restore = 'Restore',
  ResubmitApproval = 'ResubmitApproval',
  StepDocuments = 'StepDocuments',
  Take = 'Take',
  UnitMembership = 'UnitMembership',
  UserAndRoles = 'UserAndRoles',
  Write = 'Write'
}

export enum EntityNameEnum {
  Account = 'Account',
  AccountDataExRelation = 'AccountDataExRelation',
  AccountKPI = 'AccountKPI',
  AccountProductPricing = 'AccountProductPricing',
  AccountRole = 'AccountRole',
  AccountSharingClientRelation = 'AccountSharingClientRelation',
  AccountSharingSalesUnitRelation = 'AccountSharingSalesUnitRelation',
  AccountSocialRelation = 'AccountSocialRelation',
  AccountType = 'AccountType',
  Activity = 'Activity',
  ActivityComment = 'ActivityComment',
  ActivityDataExRelation = 'ActivityDataExRelation',
  ActivityDetail = 'ActivityDetail',
  ActivityKPI = 'ActivityKPI',
  ActivityRelation = 'ActivityRelation',
  ActivityType = 'ActivityType',
  AiAgent = 'AiAgent',
  AiBalance = 'AiBalance',
  AiEvent = 'AiEvent',
  AiEventJournal = 'AiEventJournal',
  AllowedAccountType = 'AllowedAccountType',
  AllowedCompanyPhone = 'AllowedCompanyPhone',
  AllowedContactType = 'AllowedContactType',
  AllowedLeadType = 'AllowedLeadType',
  AllowedPipeline = 'AllowedPipeline',
  AllowedQuoteType = 'AllowedQuoteType',
  ApiAccess = 'ApiAccess',
  Application = 'Application',
  Appointment = 'Appointment',
  AppointmentClientInviteesRelation = 'AppointmentClientInviteesRelation',
  AppointmentContactInviteesRelation = 'AppointmentContactInviteesRelation',
  AppointmentInviteeNotifyQueue = 'AppointmentInviteeNotifyQueue',
  AppointmentReminder = 'AppointmentReminder',
  AppointmentSchedule = 'AppointmentSchedule',
  AppointmentType = 'AppointmentType',
  Approval = 'Approval',
  ApprovalApprover = 'ApprovalApprover',
  ApprovalProcess = 'ApprovalProcess',
  ApprovalProcessActivityLogLine = 'ApprovalProcessActivityLogLine',
  AuditLog = 'AuditLog',
  AutomationHubApp = 'AutomationHubApp',
  AutomationHubCategory = 'AutomationHubCategory',
  AutomationHubItem = 'AutomationHubItem',
  ChatConversation = 'ChatConversation',
  Client = 'Client',
  ClientExcludedOppty = 'ClientExcludedOppty',
  ClientFavorite = 'ClientFavorite',
  ClientSetting = 'ClientSetting',
  ClientStoryRead = 'ClientStoryRead',
  CloudObject = 'CloudObject',
  CloudObjectFolder = 'CloudObjectFolder',
  CloudObjectRelation = 'CloudObjectRelation',
  CloudObjectStepRelation = 'CloudObjectStepRelation',
  CloudObjectTemplate = 'CloudObjectTemplate',
  CompanyEmail = 'CompanyEmail',
  Contact = 'Contact',
  ContactAccountAccountRoleRelation = 'ContactAccountAccountRoleRelation',
  ContactAccountRelation = 'ContactAccountRelation',
  ContactDataExRelation = 'ContactDataExRelation',
  ContactKPI = 'ContactKPI',
  ContactRelation = 'ContactRelation',
  ContactRelationType = 'ContactRelationType',
  ContactSharingClientRelation = 'ContactSharingClientRelation',
  ContactSharingSalesUnitRelation = 'ContactSharingSalesUnitRelation',
  ContactSocialRelation = 'ContactSocialRelation',
  ContactType = 'ContactType',
  Country = 'Country',
  CpActivity = 'CpActivity',
  CpCallLog = 'CpCallLog',
  CpCalling = 'CpCalling',
  CpClient = 'CpClient',
  CpProduct = 'CpProduct',
  CpProfile = 'CpProfile',
  CpTeamSpaceClient = 'CpTeamSpaceClient',
  Currency = 'Currency',
  CurrencyExchangeRate = 'CurrencyExchangeRate',
  CurrencyExchangeRatesList = 'CurrencyExchangeRatesList',
  CustomEntity = 'CustomEntity',
  CustomEntityDataExRelation = 'CustomEntityDataExRelation',
  CustomEntityKPI = 'CustomEntityKPI',
  CustomEntityRelation = 'CustomEntityRelation',
  CustomEntityRelationData = 'CustomEntityRelationData',
  CustomEntitySharingClientRelation = 'CustomEntitySharingClientRelation',
  CustomEntitySharingSalesUnitRelation = 'CustomEntitySharingSalesUnitRelation',
  CustomEntityType = 'CustomEntityType',
  Data = 'Data',
  Ebook = 'Ebook',
  Email = 'Email',
  EmailContentSharingClientRelation = 'EmailContentSharingClientRelation',
  EmailContentSharingSalesUnitRelation = 'EmailContentSharingSalesUnitRelation',
  EmailSequence = 'EmailSequence',
  EmailSequenceActivityLog = 'EmailSequenceActivityLog',
  EmailSequenceActivityLogLine = 'EmailSequenceActivityLogLine',
  EmailSequenceEnrolled = 'EmailSequenceEnrolled',
  EmailSequenceEnrolledStatus = 'EmailSequenceEnrolledStatus',
  EmailSequenceSettings = 'EmailSequenceSettings',
  EmailTemplate = 'EmailTemplate',
  EmailTemplateFolder = 'EmailTemplateFolder',
  EmailTemplateSharingClientRelation = 'EmailTemplateSharingClientRelation',
  EmailTemplateSharingSalesUnitRelation = 'EmailTemplateSharingSalesUnitRelation',
  Entity = 'Entity',
  EntityFitness = 'EntityFitness',
  EntityFitnessIndicator = 'EntityFitnessIndicator',
  EntityHealth = 'EntityHealth',
  EntityHealthSettingsHistory = 'EntityHealthSettingsHistory',
  EntityScoring = 'EntityScoring',
  EntitySettings = 'EntitySettings',
  EntityType = 'EntityType',
  Field = 'Field',
  FieldMapping = 'FieldMapping',
  FieldPermission = 'FieldPermission',
  FieldSequence = 'FieldSequence',
  Forecast = 'Forecast',
  ForecastSharingClientRelation = 'ForecastSharingClientRelation',
  ForecastSharingSalesUnitRelation = 'ForecastSharingSalesUnitRelation',
  FormView = 'FormView',
  FormViewSharingClientRelation = 'FormViewSharingClientRelation',
  FormViewSharingSalesUnitRelation = 'FormViewSharingSalesUnitRelation',
  GhostContact = 'GhostContact',
  GhostContactAccountAccountRoleRelation = 'GhostContactAccountAccountRoleRelation',
  GhostContactAccountRelation = 'GhostContactAccountRelation',
  GhostLeadOpptyContactRelation = 'GhostLeadOpptyContactRelation',
  GhostLeadOpptyContactSalesRoleRelation = 'GhostLeadOpptyContactSalesRoleRelation',
  HowTo = 'HowTo',
  ImportMappingMask = 'ImportMappingMask',
  InterfacePreview = 'InterfacePreview',
  Lead = 'Lead',
  LeadOppty = 'LeadOppty',
  LeadOpptyAccountRelation = 'LeadOpptyAccountRelation',
  LeadOpptyContactGroupRelation = 'LeadOpptyContactGroupRelation',
  LeadOpptyContactRelation = 'LeadOpptyContactRelation',
  LeadOpptyContactSalesRoleRelation = 'LeadOpptyContactSalesRoleRelation',
  LeadOpptyDataExRelation = 'LeadOpptyDataExRelation',
  LeadOpptyKPI = 'LeadOpptyKPI',
  LeadOpptyProjectRelation = 'LeadOpptyProjectRelation',
  LeadOpptySharingClientRelation = 'LeadOpptySharingClientRelation',
  LeadOpptySharingSalesUnitRelation = 'LeadOpptySharingSalesUnitRelation',
  LeadOpptyStepCheckListRelation = 'LeadOpptyStepCheckListRelation',
  LeadOpptyType = 'LeadOpptyType',
  LeadProcess = 'LeadProcess',
  LeadType = 'LeadType',
  MasterRight = 'MasterRight',
  Media = 'Media',
  Memo = 'Memo',
  MemoComment = 'MemoComment',
  Message = 'Message',
  MessageRelation = 'MessageRelation',
  MessageSharingClientRelation = 'MessageSharingClientRelation',
  MessageSharingSalesUnitRelation = 'MessageSharingSalesUnitRelation',
  Note = 'Note',
  NotificationSetting = 'NotificationSetting',
  OnlineForm = 'OnlineForm',
  OnlineFormActivityLogLine = 'OnlineFormActivityLogLine',
  OnlineFormDataExRelation = 'OnlineFormDataExRelation',
  OnlineFormRelation = 'OnlineFormRelation',
  OnlineFormStyle = 'OnlineFormStyle',
  OnlineFormType = 'OnlineFormType',
  OnlineFormTypeEmailRelation = 'OnlineFormTypeEmailRelation',
  Opportunity = 'Opportunity',
  OpportunityType = 'OpportunityType',
  OpptyProductRelation = 'OpptyProductRelation',
  OpptyProductRelationDataExRelation = 'OpptyProductRelationDataExRelation',
  OpptyProductRelationRevenueSchedule = 'OpptyProductRelationRevenueSchedule',
  OpptyProductRelationRevenueSchedulePeriod = 'OpptyProductRelationRevenueSchedulePeriod',
  OpptyProductRelationType = 'OpptyProductRelationType',
  OpptyRecurrence = 'OpptyRecurrence',
  OpptyRevenueSchedule = 'OpptyRevenueSchedule',
  OpptyRevenueSchedulePeriod = 'OpptyRevenueSchedulePeriod',
  Order = 'Order',
  OrderHistory = 'OrderHistory',
  OrderItem = 'OrderItem',
  OrderRelatedDocument = 'OrderRelatedDocument',
  OrderTempData = 'OrderTempData',
  OrderTempDataItem = 'OrderTempDataItem',
  ParentAccountRelationType = 'ParentAccountRelationType',
  Partner = 'Partner',
  Payment = 'Payment',
  PaymentAdditionalData = 'PaymentAdditionalData',
  PaymentTerm = 'PaymentTerm',
  Phone = 'Phone',
  Pipeline = 'Pipeline',
  Process = 'Process',
  ProcessActivityLog = 'ProcessActivityLog',
  ProcessActivityLogLine = 'ProcessActivityLogLine',
  ProcessChangeOwnerLog = 'ProcessChangeOwnerLog',
  ProcessScheduledAction = 'ProcessScheduledAction',
  ProcessTemplate = 'ProcessTemplate',
  Product = 'Product',
  ProductCategory = 'ProductCategory',
  ProductDataExRelation = 'ProductDataExRelation',
  ProductPipelineRelation = 'ProductPipelineRelation',
  ProductPriceList = 'ProductPriceList',
  ProductPriceListPrice = 'ProductPriceListPrice',
  ProductType = 'ProductType',
  Profile = 'Profile',
  ProfileDraft = 'ProfileDraft',
  ProfileRelation = 'ProfileRelation',
  ProfileSharingClientRelation = 'ProfileSharingClientRelation',
  ProfileSharingSalesUnitRelation = 'ProfileSharingSalesUnitRelation',
  Project = 'Project',
  ProjectContactRelation = 'ProjectContactRelation',
  ProjectDataExRelation = 'ProjectDataExRelation',
  ProjectKPI = 'ProjectKPI',
  ProjectObjective = 'ProjectObjective',
  ProjectSharingClientRelation = 'ProjectSharingClientRelation',
  ProjectSharingSalesUnitRelation = 'ProjectSharingSalesUnitRelation',
  ProjectType = 'ProjectType',
  PurchasedProduct = 'PurchasedProduct',
  Quote = 'Quote',
  QuoteAccountRelation = 'QuoteAccountRelation',
  QuoteContactRelation = 'QuoteContactRelation',
  QuoteDataExRelation = 'QuoteDataExRelation',
  QuoteKPI = 'QuoteKPI',
  QuoteProcess = 'QuoteProcess',
  QuoteSharingClientRelation = 'QuoteSharingClientRelation',
  QuoteSharingSalesUnitRelation = 'QuoteSharingSalesUnitRelation',
  QuoteType = 'QuoteType',
  ReleaseNote = 'ReleaseNote',
  Report = 'Report',
  ReportFolder = 'ReportFolder',
  ReportSchedule = 'ReportSchedule',
  ReportSharingClientRelation = 'ReportSharingClientRelation',
  ReportSharingSalesUnitRelation = 'ReportSharingSalesUnitRelation',
  RevenueRecognition = 'RevenueRecognition',
  SalesRole = 'SalesRole',
  SalesUnit = 'SalesUnit',
  SalesUnitClientRelation = 'SalesUnitClientRelation',
  SapiUser = 'SapiUser',
  SpaceSetting = 'SpaceSetting',
  State = 'State',
  Step = 'Step',
  StepChecklist = 'StepChecklist',
  StepChecklistSalesRoleRelation = 'StepChecklistSalesRoleRelation',
  Storylane = 'Storylane',
  Subscription = 'Subscription',
  SubscriptionHubItem = 'SubscriptionHubItem',
  SubscriptionNotification = 'SubscriptionNotification',
  SubscriptionRepresentative = 'SubscriptionRepresentative',
  SubscriptionSDR = 'SubscriptionSDR',
  Supplier = 'Supplier',
  Tag = 'Tag',
  TagRelation = 'TagRelation',
  Target = 'Target',
  TargetRelation = 'TargetRelation',
  Task = 'Task',
  TaskRecurrence = 'TaskRecurrence',
  TaskReminder = 'TaskReminder',
  TaskSharingClientRelation = 'TaskSharingClientRelation',
  TaskSharingSalesUnitRelation = 'TaskSharingSalesUnitRelation',
  TaskType = 'TaskType',
  TeamPipelineHubItem = 'TeamPipelineHubItem',
  TeamPipelineHubItemBase = 'TeamPipelineHubItemBase',
  TeamSpace = 'TeamSpace',
  TeamSpaceClient = 'TeamSpaceClient',
  TeamSpaceClientSetting = 'TeamSpaceClientSetting',
  TeamSpaceProperty = 'TeamSpaceProperty',
  TeamSpaceRegion = 'TeamSpaceRegion',
  TextMessage = 'TextMessage',
  TextMessageConversation = 'TextMessageConversation',
  TextMessageConversationRelations = 'TextMessageConversationRelations',
  Timeframe = 'Timeframe',
  Translation = 'Translation',
  Type = 'Type',
  UnsubscribedPhone = 'UnsubscribedPhone',
  UserProfile = 'UserProfile',
  UserRole = 'UserRole',
  Webhook = 'Webhook',
  WebhookEvent = 'WebhookEvent',
  Webresource = 'Webresource'
}

export enum EntityLacotaType {
  Account = 'Account',
  Appointment = 'Appointment',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  Project = 'Project',
  Quote = 'Quote',
  Task = 'Task'
}

export enum EntityIconEnum {
  AccountingSystem = 'AccountingSystem',
  Appointment = 'Appointment',
  AssetManagementSystem = 'AssetManagementSystem',
  Call = 'Call',
  ContactManagement = 'ContactManagement',
  ContentManagementSystems = 'ContentManagementSystems',
  DataAnalytics = 'DataAnalytics',
  DocumentManagement = 'DocumentManagement',
  ErpSystems = 'ErpSystems',
  EventManagement = 'EventManagement',
  GeneralIcon = 'GeneralIcon',
  InventorySystems = 'InventorySystems',
  Mail = 'Mail',
  MarketingCommunicationSystems = 'MarketingCommunicationSystems',
  Message = 'Message',
  OrderProcessing = 'OrderProcessing',
  ReturnMerchandiseAuthorizationSystems = 'ReturnMerchandiseAuthorizationSystems',
  SalesAutomatization = 'SalesAutomatization',
  SmsMessaging = 'SmsMessaging',
  Task = 'Task',
  TicketingIntegration = 'TicketingIntegration',
  Warehouses = 'Warehouses',
  WebServices = 'WebServices',
  Workflow = 'Workflow'
}

export enum EntityHealthTrendEnum {
  Critical = 'Critical',
  Decreasing = 'Decreasing',
  Increasing = 'Increasing',
  NoChange = 'NoChange'
}

export enum EntityHealthIndicatorEnum {
  Critical = 'Critical',
  Error = 'Error',
  Ok = 'Ok'
}

export enum EntityHealthCalculationTypeEnum {
  Manual = 'Manual',
  Priority = 'Priority'
}

export enum EmailTypeEnum {
  Mass = 'Mass',
  Standard = 'Standard'
}

export enum EmailTrackingEventTypeEnum {
  Clicked = 'Clicked',
  Opened = 'Opened',
  Sent = 'Sent',
  Unsubscribed = 'Unsubscribed'
}

export enum EmailTextTone {
  Casual = 'Casual',
  Cold = 'Cold',
  Confident = 'Confident',
  Friendly = 'Friendly',
  Neutral = 'Neutral',
  Professional = 'Professional'
}

export enum EmailTemplatesFilterEnum {
  All = 'All',
  Html = 'Html',
  My = 'My',
  SharingUrl = 'SharingUrl',
  Text = 'Text',
  Wysiwyg = 'Wysiwyg'
}

export enum EmailTemplateTypeEnum {
  HtmlTemplate = 'HtmlTemplate',
  TextTemplate = 'TextTemplate',
  WysiwygTemplate = 'WysiwygTemplate'
}

export enum EmailTemplateStatisticsGridColumnEnum {
  Bounced = 'Bounced',
  Clicked = 'Clicked',
  Modified = 'Modified',
  Name = 'Name',
  Opened = 'Opened',
  Replied = 'Replied',
  Sent = 'Sent',
  Unsubscribed = 'Unsubscribed'
}

export enum EmailServiceTypeEnum {
  GoogleEmail = 'GoogleEmail',
  O365Email = 'O365Email',
  SendGrid = 'SendGrid'
}

export enum EmailSequenceTimelinePeriodEnum {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export enum EmailSequenceStatsRecipientTypeEnum {
  Bounce = 'Bounce',
  Click = 'Click',
  CreateLead = 'CreateLead',
  CreateTask = 'CreateTask',
  CreateText = 'CreateText',
  CurrentEnroll = 'CurrentEnroll',
  Enroll = 'Enroll',
  NotOpen = 'NotOpen',
  Open = 'Open',
  Reply = 'Reply',
  Sent = 'Sent',
  Unenroll = 'Unenroll',
  Unsubscribe = 'Unsubscribe'
}

export enum EmailSequenceStatsPeriodEnum {
  All = 'All',
  Last30Days = 'Last30Days',
  Last7Days = 'Last7Days',
  Last90Days = 'Last90Days',
  LastYear = 'LastYear'
}

export enum EmailSequenceNodeEmailSender {
  ActorEmail = 'ActorEmail',
  CompanyEmail = 'CompanyEmail',
  RecordOwnerEmail = 'RecordOwnerEmail'
}

export enum EmailSequenceNodeConditionActionEnum {
  Always = 'Always',
  Custom = 'Custom',
  NoClick = 'NoClick',
  NoReply = 'NoReply',
  NotOpen = 'NotOpen',
  TaskCompleted = 'TaskCompleted',
  TaskNotCompleted = 'TaskNotCompleted',
  TaskNotUpdated = 'TaskNotUpdated'
}

export enum EmailSequenceEndReasonEnum {
  Finished = 'Finished',
  NoReason = 'NoReason',
  Unenrolled = 'Unenrolled'
}

export enum EmailSequenceDeactivationReasonEnum {
  DisabledFeature = 'DisabledFeature',
  Manual = 'Manual',
  NoReason = 'NoReason',
  TooManyErrors = 'TooManyErrors'
}

export enum EmailSentimentEnum {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

export enum EmailLength {
  Long = 'Long',
  Short = 'Short',
  Standard = 'Standard'
}

export enum EmailIntegrationEnum {
  Active = 'Active',
  Disabled = 'Disabled',
  Idle = 'Idle',
  Suspended = 'Suspended'
}

export enum EmailEventTypeEnum {
  Bounce = 'Bounce',
  BounceSoft = 'BounceSoft',
  Click = 'Click',
  Open = 'Open',
  Reply = 'Reply',
  Unsubscribe = 'Unsubscribe'
}

export enum EmailDirectionEnum {
  IncomingEmail = 'IncomingEmail',
  OutgoingEmail = 'OutgoingEmail'
}

export enum EmailAccountFeatureEnum {
  CanSyncBounces = 'CanSyncBounces',
  CanSyncIncoming = 'CanSyncIncoming'
}

export enum EbookSourceTypeEnum {
  File = 'File',
  Url = 'Url'
}

export enum EbookPermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum DropDownAutoselectEnum {
  NoSelect = 'NoSelect',
  SelectFirst = 'SelectFirst',
  SelectOnlyIfOneItem = 'SelectOnlyIfOneItem'
}

export enum DisplayParamEnum {
  DoNotShowIfEmpty = 'DoNotShowIfEmpty',
  FullScreen = 'FullScreen'
}

export enum DisplayOption {
  AsEntityType = 'AsEntityType',
  AsIs = 'AsIs',
  AsNumeric = 'AsNumeric',
  AsPicture = 'AsPicture',
  CompactView = 'CompactView',
  Custom = 'Custom',
  Mixed = 'Mixed',
  Natural = 'Natural',
  RollupRawData = 'RollupRawData'
}

export enum DayName {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum DateWeekEnum {
  Week1 = 'Week1',
  Week2 = 'Week2',
  Week3 = 'Week3',
  Week4 = 'Week4',
  WeekLast = 'WeekLast'
}

export enum DateMonthEnum {
  Month1 = 'Month1',
  Month10 = 'Month10',
  Month11 = 'Month11',
  Month12 = 'Month12',
  Month2 = 'Month2',
  Month3 = 'Month3',
  Month4 = 'Month4',
  Month5 = 'Month5',
  Month6 = 'Month6',
  Month7 = 'Month7',
  Month8 = 'Month8',
  Month9 = 'Month9'
}

export enum DateDayOfWeekEnum {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum DateDayEnum {
  Day1 = 'Day1',
  Day10 = 'Day10',
  Day11 = 'Day11',
  Day12 = 'Day12',
  Day13 = 'Day13',
  Day14 = 'Day14',
  Day15 = 'Day15',
  Day16 = 'Day16',
  Day17 = 'Day17',
  Day18 = 'Day18',
  Day19 = 'Day19',
  Day2 = 'Day2',
  Day20 = 'Day20',
  Day21 = 'Day21',
  Day22 = 'Day22',
  Day23 = 'Day23',
  Day24 = 'Day24',
  Day25 = 'Day25',
  Day26 = 'Day26',
  Day27 = 'Day27',
  Day28 = 'Day28',
  Day29 = 'Day29',
  Day3 = 'Day3',
  Day30 = 'Day30',
  Day31 = 'Day31',
  Day4 = 'Day4',
  Day5 = 'Day5',
  Day6 = 'Day6',
  Day7 = 'Day7',
  Day8 = 'Day8',
  Day9 = 'Day9'
}

export enum DashboardTargetTypeEnum {
  Gauge = 'Gauge',
  ProgressBar = 'ProgressBar',
  Radial = 'Radial',
  Target = 'Target'
}

export enum DashboardKpiIndicatorEnum {
  ActivityCompleted = 'ActivityCompleted',
  ActivityCreated = 'ActivityCreated',
  ActivityEmailsSent = 'ActivityEmailsSent',
  Custom = 'Custom',
  LeadAverageVelocity = 'LeadAverageVelocity',
  LeadCreated = 'LeadCreated',
  LeadLost = 'LeadLost',
  LeadQualified = 'LeadQualified',
  OpportunityAverageSize = 'OpportunityAverageSize',
  OpportunityAverageVelocity = 'OpportunityAverageVelocity',
  OpportunityCreated = 'OpportunityCreated',
  OpportunityLost = 'OpportunityLost',
  OpportunityLostAmount = 'OpportunityLostAmount',
  OpportunitySalesVelocity = 'OpportunitySalesVelocity',
  OpportunityWinRate = 'OpportunityWinRate',
  OpportunityWon = 'OpportunityWon',
  OpportunityWonAmount = 'OpportunityWonAmount'
}

export enum DashboardGraphValueType {
  Currency = 'Currency',
  Date = 'Date',
  Float = 'Float',
  Integer = 'Integer',
  Marker = 'Marker',
  Percentage = 'Percentage',
  String = 'String'
}

export enum DashboardGraphSeriesType {
  Bar = 'Bar',
  Column = 'Column',
  Funnel = 'Funnel',
  Gauge = 'Gauge',
  Pie = 'Pie'
}

export enum DashboardGraphOpportunityNameType {
  AccountClassNumberOfOpportunities = 'AccountClassNumberOfOpportunities',
  AccountClassOpportunitiesTotalValue = 'AccountClassOpportunitiesTotalValue',
  BalancedVsGoal = 'BalancedVsGoal',
  ComparisonAccountClassTotalValue = 'ComparisonAccountClassTotalValue',
  ComparisonOpportunityStatus = 'ComparisonOpportunityStatus',
  CountOfOpenOpportunitiesByFitness = 'CountOfOpenOpportunitiesByFitness',
  CountOfOverdueOpportunities = 'CountOfOverdueOpportunities',
  CountOfRankedOpportunities = 'CountOfRankedOpportunities',
  LastLostOpportunities = 'LastLostOpportunities',
  LastWonOpportunities = 'LastWonOpportunities',
  PipelineConversionAndDropOffRates = 'PipelineConversionAndDropOffRates',
  PipelineOverview = 'PipelineOverview',
  PipelineVelocity = 'PipelineVelocity',
  RankedVsGoal = 'RankedVsGoal',
  RatioOfRankedOpportunities = 'RatioOfRankedOpportunities',
  SumOfUpcomingClosingDates = 'SumOfUpcomingClosingDates',
  TopAccountsByLostOpportunities = 'TopAccountsByLostOpportunities',
  TopAccountsByOpenOpportunities = 'TopAccountsByOpenOpportunities',
  TopAccountsByWonOpportunities = 'TopAccountsByWonOpportunities',
  TopLostOpportunities = 'TopLostOpportunities',
  TopLostReasons = 'TopLostReasons',
  TopWonOpportunities = 'TopWonOpportunities',
  TotalValueOfRankedOpportunities = 'TotalValueOfRankedOpportunities',
  UnweightedVsGoal = 'UnweightedVsGoal',
  WeightedVsGoal = 'WeightedVsGoal',
  WinRateByOpportunityValue = 'WinRateByOpportunityValue',
  WonVsGoal = 'WonVsGoal'
}

export enum DashboardGraphLeadNameType {
  CountOfLeadsByAccountClass = 'CountOfLeadsByAccountClass',
  CountOfLeadsByRanking = 'CountOfLeadsByRanking',
  CountOfOpenLeadsByFitness = 'CountOfOpenLeadsByFitness',
  CountOfOpenLeadsByLabel = 'CountOfOpenLeadsByLabel',
  LeadsDaysInQueue = 'LeadsDaysInQueue'
}

export enum DashboardGraphContactNameType {
  CountOfContactsBySalesUnit = 'CountOfContactsBySalesUnit',
  TopContactsByActivities = 'TopContactsByActivities',
  TopContactsByLostOpportunities = 'TopContactsByLostOpportunities',
  TopContactsByWonOpportunities = 'TopContactsByWonOpportunities',
  TopOwnersByContacts = 'TopOwnersByContacts'
}

export enum DashboardGraphActivityNameType {
  ComparisonActivityTypes = 'ComparisonActivityTypes',
  ComparisonTaskDue = 'ComparisonTaskDue',
  ComparisonTaskStatus = 'ComparisonTaskStatus',
  TopOwnersByActivities = 'TopOwnersByActivities',
  TopUnitsByActivities = 'TopUnitsByActivities'
}

export enum DashboardGraphAccountNameType {
  CountOfAccountsByAccountClass = 'CountOfAccountsByAccountClass',
  CountOfAccountsBySalesUnit = 'CountOfAccountsBySalesUnit',
  TopAccountIndustries = 'TopAccountIndustries',
  TopAccountIndustriesByWonValue = 'TopAccountIndustriesByWonValue',
  TopAccountsByActivities = 'TopAccountsByActivities',
  TopAccountsByLostOpportunities = 'TopAccountsByLostOpportunities',
  TopAccountsByNumberOfContacts = 'TopAccountsByNumberOfContacts',
  TopAccountsByWonOpportunities = 'TopAccountsByWonOpportunities',
  TopOwnersByAccounts = 'TopOwnersByAccounts'
}

export enum DashboardChartError {
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  NotEnoughPermissions = 'NotEnoughPermissions',
  Unavailable = 'Unavailable'
}

export enum DashboardAgendaPeriodEnum {
  Custom = 'Custom',
  Upcoming30Days = 'Upcoming30Days',
  Upcoming7Days = 'Upcoming7Days'
}

export enum CustomEntityFunctionalityEnum {
  Activities = 'Activities',
  Documents = 'Documents',
  GlobalSearch = 'GlobalSearch',
  Notes = 'Notes'
}

export enum CurrencyFormattingEnum {
  ConvertedValue = 'ConvertedValue',
  RecordValue = 'RecordValue',
  RecordValueConvertedValue = 'RecordValueConvertedValue'
}

export enum CurrencyDisplayOptionEnum {
  Code = 'Code',
  Symbol = 'Symbol'
}

export enum CsvQuotechar {
  apostrophe = 'apostrophe',
  quotation = 'quotation'
}

export enum CsvDelimiter {
  colon = 'colon',
  comma = 'comma',
  semicolon = 'semicolon',
  tab = 'tab'
}

export enum ConversionsKpi {
  AssignedLeads = 'AssignedLeads',
  AssignedOpportunities = 'AssignedOpportunities',
  CreatedLeads = 'CreatedLeads',
  CreatedOpportunities = 'CreatedOpportunities',
  LostLeads = 'LostLeads',
  LostOpportunities = 'LostOpportunities',
  QualifiedLeads = 'QualifiedLeads',
  QualifiedLostLeads = 'QualifiedLostLeads',
  UnconvertedQualifiedLeads = 'UnconvertedQualifiedLeads',
  UnqualifiedAssignedLeads = 'UnqualifiedAssignedLeads',
  UnqualifiedAssignedOpportunities = 'UnqualifiedAssignedOpportunities',
  UnqualifiedLeads = 'UnqualifiedLeads',
  UnqualifiedOpportunities = 'UnqualifiedOpportunities',
  WonOpportunities = 'WonOpportunities'
}

export enum ConversionValueType {
  ConversionAmount = 'ConversionAmount',
  ConversionCount = 'ConversionCount'
}

export enum ConversionReportBy {
  MyResults = 'MyResults',
  SalesTeam = 'SalesTeam'
}

export enum ContentShareModeEnum {
  Custom = 'Custom',
  Private = 'Private',
  Public = 'Public'
}

export enum ContentShareModeConfigEnum {
  Custom = 'Custom',
  PrivateOnly = 'PrivateOnly',
  PublicOnly = 'PublicOnly'
}

export enum ContentManagementEventTypeEnum {
  Click = 'Click',
  ReactionNegative = 'ReactionNegative',
  ReactionNeutral = 'ReactionNeutral',
  ReactionPositive = 'ReactionPositive',
  View = 'View'
}

export enum ContentManagementEntityTypeEnum {
  Ebook = 'Ebook',
  HowTo = 'HowTo',
  ReleaseNote = 'ReleaseNote',
  Storylane = 'Storylane'
}

export enum ContactSyncMethodEnum {
  Bidirectional = 'Bidirectional',
  ExchangeToPipeliner = 'ExchangeToPipeliner',
  PipelinerToExchange = 'PipelinerToExchange'
}

export enum ContactKpiEnum {
  Archive = 'Archive',
  CreateContact = 'CreateContact',
  FirstEmailSent = 'FirstEmailSent',
  LastEmailSent = 'LastEmailSent'
}

export enum ContactDeletionProtectionEnum {
  AlwaysDeleteInPipeliner = 'AlwaysDeleteInPipeliner',
  NeverDeleteInPipeliner = 'NeverDeleteInPipeliner'
}

export enum ColumnAlignment {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right'
}

export enum CloudObjectTypeEnum {
  AlfrescoFile = 'AlfrescoFile',
  BoxFile = 'BoxFile',
  DropboxFile = 'DropboxFile',
  ExternalURL = 'ExternalURL',
  GoogleDriveFile = 'GoogleDriveFile',
  OneDriveFile = 'OneDriveFile',
  S3File = 'S3File',
  S3FileUpload = 'S3FileUpload',
  S3Image = 'S3Image',
  SharepointFile = 'SharepointFile',
  UrlFile = 'UrlFile'
}

export enum CloudObjectTemplateStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum CloudObjectFolderType {
  Company = 'Company',
  Record = 'Record'
}

export enum ClientTypeEnum {
  Customer = 'Customer',
  Support = 'Support'
}

export enum ChatConversationTypeEnum {
  AiChat = 'AiChat',
  AiRecordDetail = 'AiRecordDetail'
}

export enum ChangeLogTypeEnum {
  Create = 'Create',
  Delete = 'Delete',
  Restore = 'Restore',
  Submitted = 'Submitted',
  Update = 'Update'
}

export enum ChangeLogSourceEnum {
  Api = 'Api',
  Mobile = 'Mobile'
}

export enum CallLogStatusEnum {
  Busy = 'Busy',
  Canceled = 'Canceled',
  CanceledByGeoRestrictions = 'CanceledByGeoRestrictions',
  CanceledByInsufficientCredit = 'CanceledByInsufficientCredit',
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Initiated = 'Initiated',
  NoAnswer = 'NoAnswer'
}

export enum CalendarPeriod {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  WorkWeek = 'WorkWeek'
}

export enum CRUDLicEntityPermsEnum {
  Create = 'Create',
  Delete = 'Delete',
  Read = 'Read',
  Write = 'Write'
}

export enum BulkUpdateOperationEnum {
  AddToExisting = 'AddToExisting',
  RemoveExisting = 'RemoveExisting',
  ReplaceExisting = 'ReplaceExisting',
  UpdateOnlyCode = 'UpdateOnlyCode',
  UpdateValueAndCode = 'UpdateValueAndCode'
}

export enum BaseEntityTypeEnum {
  Account = 'Account',
  Appointment = 'Appointment',
  Contact = 'Contact',
  CustomEntity = 'CustomEntity',
  Lead = 'Lead',
  OnlineForm = 'OnlineForm',
  Opportunity = 'Opportunity',
  OpptyProductRelation = 'OpptyProductRelation',
  Product = 'Product',
  Project = 'Project',
  Quote = 'Quote',
  Task = 'Task'
}

export enum AutomationHubTierEnum {
  Custom = 'Custom',
  Free = 'Free',
  Paid = 'Paid'
}

export enum AutomationHubScope {
  Space = 'Space',
  User = 'User'
}

export enum AutomationHubItemLiveStatus {
  Error = 'Error',
  OK = 'OK',
  Warning = 'Warning'
}

export enum AuditLogTypeEnum {
  AccountRelationsCreate = 'AccountRelationsCreate',
  AccountRelationsDelete = 'AccountRelationsDelete',
  AccountRelationsUpdate = 'AccountRelationsUpdate',
  AccountsHierarchyCreate = 'AccountsHierarchyCreate',
  AccountsHierarchyDelete = 'AccountsHierarchyDelete',
  AccountsHierarchyUpdate = 'AccountsHierarchyUpdate',
  ApiAppActivated = 'ApiAppActivated',
  ApiAppCreated = 'ApiAppCreated',
  ApiAppDeactivated = 'ApiAppDeactivated',
  ApiAppDeleted = 'ApiAppDeleted',
  ApiAppNewAccessGenerated = 'ApiAppNewAccessGenerated',
  ApiAppPersmissionsUpdate = 'ApiAppPersmissionsUpdate',
  ApiAppUpdated = 'ApiAppUpdated',
  AutomationHubActivate = 'AutomationHubActivate',
  AutomationHubDeactivate = 'AutomationHubDeactivate',
  AutomationHubUpdate = 'AutomationHubUpdate',
  ChangeDefaultSalesUnit = 'ChangeDefaultSalesUnit',
  CompanyEmailAdd = 'CompanyEmailAdd',
  CompanyEmailDisable = 'CompanyEmailDisable',
  CompanyEmailEnable = 'CompanyEmailEnable',
  CompanyEmailReactivate = 'CompanyEmailReactivate',
  CompanyEmailRemove = 'CompanyEmailRemove',
  CompanyPhoneAdd = 'CompanyPhoneAdd',
  CompanyPhoneAssign = 'CompanyPhoneAssign',
  CompanyPhoneReactivate = 'CompanyPhoneReactivate',
  CompanyPhoneRemove = 'CompanyPhoneRemove',
  CompanyPhoneUnassign = 'CompanyPhoneUnassign',
  ContactRelationsCreate = 'ContactRelationsCreate',
  ContactRelationsDelete = 'ContactRelationsDelete',
  ContactRelationsUpdate = 'ContactRelationsUpdate',
  CurrencyCreate = 'CurrencyCreate',
  CurrencyDelete = 'CurrencyDelete',
  CurrencyUpdate = 'CurrencyUpdate',
  CustomEntityCreate = 'CustomEntityCreate',
  CustomEntityDelete = 'CustomEntityDelete',
  CustomEntityRename = 'CustomEntityRename',
  CustomEntityUpdate = 'CustomEntityUpdate',
  EmailBlacklistUpdate = 'EmailBlacklistUpdate',
  EmailSequenceActivate = 'EmailSequenceActivate',
  EmailSequenceCreate = 'EmailSequenceCreate',
  EmailSequenceDeactivate = 'EmailSequenceDeactivate',
  EmailSequenceDelete = 'EmailSequenceDelete',
  EmailSequenceUpdate = 'EmailSequenceUpdate',
  ExchangeRateCreate = 'ExchangeRateCreate',
  ExchangeRateDelete = 'ExchangeRateDelete',
  ExchangeRateUpdate = 'ExchangeRateUpdate',
  ExportDataAccount = 'ExportDataAccount',
  ExportDataContact = 'ExportDataContact',
  ExportDataLead = 'ExportDataLead',
  ExportDataOpportunity = 'ExportDataOpportunity',
  ExportDataReport = 'ExportDataReport',
  FieldCreate = 'FieldCreate',
  FieldDelete = 'FieldDelete',
  FieldUpdate = 'FieldUpdate',
  FieldUpdateFLS = 'FieldUpdateFLS',
  FinancialYearUpdate = 'FinancialYearUpdate',
  FirstDayOfWeekUpdate = 'FirstDayOfWeekUpdate',
  FormCreate = 'FormCreate',
  FormDelete = 'FormDelete',
  FormEntityCustomNameChanged = 'FormEntityCustomNameChanged',
  FormPublish = 'FormPublish',
  FormUpdate = 'FormUpdate',
  IntegrationActivate = 'IntegrationActivate',
  IntegrationDeactivate = 'IntegrationDeactivate',
  LeadProcessCreate = 'LeadProcessCreate',
  LeadProcessDelete = 'LeadProcessDelete',
  LeadProcessUpdate = 'LeadProcessUpdate',
  PipelineCreate = 'PipelineCreate',
  PipelineDelete = 'PipelineDelete',
  PipelineUpdate = 'PipelineUpdate',
  ProcessCreate = 'ProcessCreate',
  ProcessDelete = 'ProcessDelete',
  ProcessUpdate = 'ProcessUpdate',
  ProductCategoryCreate = 'ProductCategoryCreate',
  ProductCategoryDelete = 'ProductCategoryDelete',
  ProductCategoryUpdate = 'ProductCategoryUpdate',
  ProductPriceListCreate = 'ProductPriceListCreate',
  ProductPriceListDelete = 'ProductPriceListDelete',
  ProductPriceListUpdate = 'ProductPriceListUpdate',
  RemovedUserFromSalesunit = 'RemovedUserFromSalesunit',
  RoleCreate = 'RoleCreate',
  RoleDelete = 'RoleDelete',
  RoleUpdate = 'RoleUpdate',
  SalesRolesCreate = 'SalesRolesCreate',
  SalesRolesDelete = 'SalesRolesDelete',
  SalesRolesUpdate = 'SalesRolesUpdate',
  SpaceReset = 'SpaceReset',
  TimezoneUpdate = 'TimezoneUpdate',
  UndoFormFields = 'UndoFormFields',
  UnitCreate = 'UnitCreate',
  UnitDelete = 'UnitDelete',
  UnitUpdate = 'UnitUpdate',
  UserActivate = 'UserActivate',
  UserAssignedRole = 'UserAssignedRole',
  UserDeactivate = 'UserDeactivate',
  UserInvite = 'UserInvite',
  UserMovedToUnit = 'UserMovedToUnit',
  UserReassignedData = 'UserReassignedData',
  UserResetPassword = 'UserResetPassword',
  WebResourceCreate = 'WebResourceCreate',
  WebResourceDelete = 'WebResourceDelete',
  WebResourceUpdate = 'WebResourceUpdate',
  WorkingDaysUpdate = 'WorkingDaysUpdate'
}

export enum AuditLogCategoryEnum {
  AutomationHub = 'AutomationHub',
  Automatizer = 'Automatizer',
  Common = 'Common',
  CompanyEmail = 'CompanyEmail',
  CompanyPhone = 'CompanyPhone',
  Currency = 'Currency',
  EmailSequence = 'EmailSequence',
  Entity = 'Entity',
  Export = 'Export',
  LeadProcess = 'LeadProcess',
  Pipeline = 'Pipeline',
  Product = 'Product',
  Roles = 'Roles',
  SalesUnit = 'SalesUnit',
  Setting = 'Setting',
  User = 'User',
  UserSetting = 'UserSetting'
}

export enum AudioStatus {
  NoRecording = 'NoRecording',
  TranscriptionCompleted = 'TranscriptionCompleted',
  TranscriptionEmpty = 'TranscriptionEmpty',
  TranscriptionError = 'TranscriptionError',
  TranscriptionInProgress = 'TranscriptionInProgress',
  UploadError = 'UploadError',
  Uploaded = 'Uploaded',
  Uploading = 'Uploading'
}

export enum AsyncJobStatusEnum {
  Completed = 'Completed',
  Expired = 'Expired',
  InProgress = 'InProgress'
}

export enum ApprovalStatusEnum {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum ApprovalScreenVisibilityEnum {
  All = 'All',
  MyLockedRecords = 'MyLockedRecords',
  NeedMyApproval = 'NeedMyApproval'
}

export enum ApprovalProcessTriggerTypeEnum {
  Manual = 'Manual',
  RecordChange = 'RecordChange'
}

export enum ApprovalProcessRecordTriggerEventEnum {
  Create = 'Create',
  CreateOrUpdate = 'CreateOrUpdate',
  Update = 'Update'
}

export enum ApprovalProcessRecordLock {
  ManagersAndApproversCanEdit = 'ManagersAndApproversCanEdit',
  ManagersCanEdit = 'ManagersCanEdit'
}

export enum ApprovalProcessExpirationResult {
  Approve = 'Approve',
  Reject = 'Reject'
}

export enum ApprovalProcessApproverType {
  Owner = 'Owner',
  SalesUnitManager = 'SalesUnitManager',
  User = 'User'
}

export enum AppointmentScheduleTypeEnum {
  Group = 'Group',
  OneToOne = 'OneToOne'
}

export enum AppointmentScheduleReminderOffsetTypeEnum {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Week = 'Week'
}

export enum AppointmentSchedulePlanningTypeEnum {
  Infinite = 'Infinite',
  Offset = 'Offset',
  Period = 'Period'
}

export enum AppointmentScheduleLocationTypeEnum {
  Custom = 'Custom',
  Microsoft = 'Microsoft',
  Zoom = 'Zoom'
}

export enum AppointmentScheduleInviteeType {
  Client = 'Client',
  Contact = 'Contact',
  Email = 'Email'
}

export enum AppointmentScheduleConfirmationPageTypeEnum {
  ConfirmationPage = 'ConfirmationPage',
  ExternalUrl = 'ExternalUrl'
}

export enum AppointmentMeetingTypeEnum {
  MsTeams = 'MsTeams',
  Zoom = 'Zoom'
}

export enum AppointmentInviteeTypeEnum {
  Scheduled = 'Scheduled',
  Standard = 'Standard'
}

export enum AppThemeEnum {
  Calm = 'Calm',
  Classic = 'Classic',
  Coevera = 'Coevera',
  Legacy = 'Legacy',
  Lively = 'Lively',
  Solid = 'Solid',
  Wise = 'Wise'
}

export enum ApiPermissionEnum {
  Disabled = 'Disabled',
  Read = 'Read',
  Write = 'Write'
}

export enum ApiAccessTypeEnum {
  Basic = 'Basic',
  OAuth = 'OAuth'
}

export enum AiTextAnalysisSentimentEnum {
  Mixed = 'Mixed',
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

export enum AiTextAnalysisInformationTypeEnum {
  Address = 'Address',
  Email = 'Email',
  Name = 'Name',
  Phone = 'Phone',
  URL = 'URL'
}

export enum AiTaskStatus {
  Canceled = 'Canceled',
  Finished = 'Finished',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export enum AiRecordSuggestionType {
  Alert = 'Alert',
  DataEnrichment = 'DataEnrichment',
  News = 'News'
}

export enum AiPromptTopics {
  AnalyzeDataOnThisScreen = 'AnalyzeDataOnThisScreen',
  AnalyzeSelectedChart = 'AnalyzeSelectedChart',
  AnalyzeThisPipeline = 'AnalyzeThisPipeline',
  AnalyzeThisReport = 'AnalyzeThisReport',
  HowDoIMoveThisForward = 'HowDoIMoveThisForward',
  ShowMeExamples = 'ShowMeExamples',
  ShowMeMoreExamples = 'ShowMeMoreExamples',
  ShowMeMoreSuggestions = 'ShowMeMoreSuggestions',
  ShowMeSuggestions = 'ShowMeSuggestions',
  ShowMeSummary = 'ShowMeSummary',
  ShowMeTheWinLossPrediction = 'ShowMeTheWinLossPrediction',
  WhatShouldIDoNext = 'WhatShouldIDoNext'
}

export enum AiOutputLanguage {
  English = 'English',
  French = 'French',
  German = 'German',
  Italian = 'Italian',
  Portuguese = 'Portuguese',
  Spanish = 'Spanish'
}

export enum AiOnlineFormItemType {
  Field = 'Field',
  Form = 'Form',
  Header = 'Header',
  Image = 'Image'
}

export enum AiCreditInfoStatus {
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum AiConversationItemActor {
  System = 'System',
  User = 'User'
}

export enum AiCategorizeEmailsSelectionType {
  Last30Days = 'Last30Days',
  Last7Days = 'Last7Days',
  Selection = 'Selection'
}

export enum AggregationOperator {
  Average = 'Average',
  Count = 'Count',
  Max = 'Max',
  Min = 'Min',
  RunningCount = 'RunningCount',
  RunningSum = 'RunningSum',
  Sum = 'Sum'
}

export enum AggregationComparisonType {
  ColumnTotal = 'ColumnTotal',
  Field = 'Field',
  GrandTotal = 'GrandTotal',
  RowTotal = 'RowTotal'
}

export enum AffectedProcessesOperationType {
  delete = 'delete',
  save = 'save',
  sharing = 'sharing'
}

export enum AdvancedFormulaTypeEnum {
  bool = 'bool',
  currency = 'currency',
  date = 'date',
  datetime = 'datetime',
  float = 'float',
  integer = 'integer',
  string = 'string'
}

export enum AdvancedFormulaDisplayOptionEnum {
  Custom = 'Custom',
  Days = 'Days',
  Months = 'Months',
  Number = 'Number',
  Percentage = 'Percentage',
  Years = 'Years'
}

export enum ActivityTypeIconEnum {
  AccountingSystem = 'AccountingSystem',
  Appointment = 'Appointment',
  AssetManagementSystem = 'AssetManagementSystem',
  Call = 'Call',
  ContactManagement = 'ContactManagement',
  ContentManagementSystems = 'ContentManagementSystems',
  DataAnalytics = 'DataAnalytics',
  DocumentManagement = 'DocumentManagement',
  ErpSystems = 'ErpSystems',
  EventManagement = 'EventManagement',
  GeneralIcon = 'GeneralIcon',
  InventorySystems = 'InventorySystems',
  Mail = 'Mail',
  MarketingCommunicationSystems = 'MarketingCommunicationSystems',
  Message = 'Message',
  OrderProcessing = 'OrderProcessing',
  ReturnMerchandiseAuthorizationSystems = 'ReturnMerchandiseAuthorizationSystems',
  SalesAutomatization = 'SalesAutomatization',
  SmsMessaging = 'SmsMessaging',
  Task = 'Task',
  TicketingIntegration = 'TicketingIntegration',
  Warehouses = 'Warehouses',
  WebServices = 'WebServices',
  Workflow = 'Workflow'
}

export enum ActivityStatusEnum {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Deferred = 'Deferred',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Waiting = 'Waiting'
}

export enum ActivityKpiEnum {
  ActivityCompleted = 'ActivityCompleted',
  ActivityCreate = 'ActivityCreate'
}

export enum ActivityGroupBy {
  ActivityType = 'ActivityType',
  NoGrouping = 'NoGrouping',
  Owner = 'Owner',
  Unit = 'Unit'
}

export enum AccountMatrixDateDisplayEnum {
  DaysFromToday = 'DaysFromToday',
  MonthsFromToday = 'MonthsFromToday'
}

export enum AccountMatrixAccountDisplayEnum {
  Account = 'Account',
  AccountClass = 'AccountClass',
  EntityHealth = 'EntityHealth',
  Owner = 'Owner'
}

export enum AccountKpiEnum {
  Archive = 'Archive',
  CreateAccount = 'CreateAccount',
  FirstEmailSent = 'FirstEmailSent',
  LastEmailSent = 'LastEmailSent'
}

export enum AccountClassEnum {
  ClassA = 'ClassA',
  ClassB = 'ClassB',
  ClassC = 'ClassC',
  ClassD = 'ClassD',
  NoClass = 'NoClass'
}

export enum AccessPipelinesEnum {
  All = 'All',
  Selected = 'Selected'
}

export enum AccessLevelProcessBuilderEnum {
  FullAccess = 'FullAccess',
  NoAccess = 'NoAccess',
  Personal = 'Personal'
}

export enum AccessLevelPipelineEnum {
  AllNoDocuments = 'AllNoDocuments',
  AllWithDocuments = 'AllWithDocuments',
  NoPipeline = 'NoPipeline',
  Selected = 'Selected'
}

export enum AccessLevelFieldEnum {
  FullAccess = 'FullAccess',
  NoAccess = 'NoAccess',
  Readonly = 'Readonly'
}

export enum AccessLevelEntityEnum {
  All = 'All',
  Editor = 'Editor',
  EditorOrUnitManger = 'EditorOrUnitManger',
  NoAccess = 'NoAccess',
  Readonly = 'Readonly'
}

export enum AccessLevelEmailSequenceEnum {
  FullAccess = 'FullAccess',
  NoAccess = 'NoAccess',
  Personal = 'Personal'
}

export enum AccessLevelCompanyEmailsEnum {
  All = 'All',
  NoAccess = 'NoAccess',
  Selected = 'Selected'
}

export enum AccessLevelCommonRecordsEnumEnum {
  All = 'All',
  NoAccess = 'NoAccess',
  Readonly = 'Readonly'
}

export enum AccessEntityTypesEnum {
  All = 'All',
  Selected = 'Selected'
}

export enum AccessDirectionEnum {
  All = 'All',
  Current = 'Current',
  CurrentAndParent = 'CurrentAndParent',
  CurrentAndParentAndSubunit = 'CurrentAndParentAndSubunit',
  CurrentAndSubunit = 'CurrentAndSubunit',
  Owned = 'Owned'
}

export interface XlsxOptionsParams {
  __typename?: 'XlsxOptionsParams';
  includeForeignCurrency?: boolean | null;
  type?: ReportXlsxType | null;
}

export interface WorkingDaysInput {
  __typename?: 'WorkingDaysInput';
  updateMode: WorkingDaysUpdateMode;
  workingDays: DayName[];
}

export interface WhiteSpaceViewSettingsParams {
  __typename?: 'WhiteSpaceViewSettingsParams';
  showOnlyWhiteSpaceColumns: boolean;
}

export interface WebresourceOrderByInput {
  __typename?: 'WebresourceOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  requestMethod?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface WebresourceFilterInput {
  __typename?: 'WebresourceFilterInput';
  AND?: WebresourceFilterInput[] | null;
  NOT?: WebresourceFilterInput | null;
  OR?: WebresourceFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  displayParam?: DisplayParamEnumFilterInput | null;
  entity?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  requestMethod?: RequestMethodEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
  url?: EntityFilterStringField | null;
}

export interface WebhookOrderByNestedInput {
  __typename?: 'WebhookOrderByNestedInput';
  applicationId?: OrderByEnum | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  insecureSsl?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface WebhookOrderByInput {
  __typename?: 'WebhookOrderByInput';
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  insecureSsl?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface WebhookFilterInput {
  __typename?: 'WebhookFilterInput';
  AND?: WebhookFilterInput[] | null;
  NOT?: WebhookFilterInput | null;
  OR?: WebhookFilterInput[] | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  insecureSsl?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  signature?: EntityFilterStringField | null;
  url?: EntityFilterStringField | null;
}

export interface WebhookEventOrderByInput {
  __typename?: 'WebhookEventOrderByInput';
  created?: OrderByEnum | null;
  event?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  webhook?: WebhookOrderByNestedInput[] | null;
  webhookId?: OrderByEnum | null;
}

export interface WebhookEventFilterInput {
  __typename?: 'WebhookEventFilterInput';
  AND?: WebhookEventFilterInput[] | null;
  NOT?: WebhookEventFilterInput | null;
  OR?: WebhookEventFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  event?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  webhook?: WebhookFilterInput | null;
  webhookId?: EntityFilterStringField | null;
}

export interface WebResourceParams {
  __typename?: 'WebResourceParams';
  description?: string | null;
  id: string;
  label: string;
  size: number;
}

export interface VerifyPhoneNumberTeamSpaceClientSettingInput {
  __typename?: 'VerifyPhoneNumberTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  number: string;
}

export interface ValidateProcessesInput {
  __typename?: 'ValidateProcessesInput';
  clientMutationId?: string | null;
}

export interface ValidateFormulaReportFieldsParams {
  __typename?: 'ValidateFormulaReportFieldsParams';
  calculatedFields: CalculatedFieldParams[];
  summaryFields: SummaryFieldParams[];
}

export interface UserTargetListingOptionsParams {
  __typename?: 'UserTargetListingOptionsParams';
  filterByGroupTarget?: UUID[] | null;
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByStatus?: TargetStatusEnum[] | null;
  filterByTargetCalculationType?: TargetCalculationTypeEnum | null;
}

export interface UploadSourceEnumFilterInput {
  __typename?: 'UploadSourceEnumFilterInput';
  NOT?: UploadSourceEnumFilterInput | null;
  eq?: UploadSourceEnum[] | null;
}

export interface UpdateWhiteSpaceComparisonSettingInput {
  __typename?: 'UpdateWhiteSpaceComparisonSettingInput';
  accountId: UUID;
  clientMutationId?: string | null;
  comparisonIds: UUID[];
}

export interface UpdateWhiteSpaceComparisonProductSettingInput {
  __typename?: 'UpdateWhiteSpaceComparisonProductSettingInput';
  accountId: UUID;
  clientMutationId?: string | null;
  productIds: UUID[];
}

export interface UpdateWebhookInput {
  __typename?: 'UpdateWebhookInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  events?: EventEnum[] | null;
  id: ID;
  insecureSsl?: boolean | null;
  modified?: DateTime | null;
  options?: JSONString | null;
  signature?: ID | null;
  url?: string | null;
}

export interface UpdateWebhookEventInput {
  __typename?: 'UpdateWebhookEventInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  event?: EventEnum | null;
  id: ID;
  modified?: DateTime | null;
  webhookId?: ID | null;
}

export interface UpdateUnsubscribedPhoneInput {
  __typename?: 'UpdateUnsubscribedPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  phone?: string | null;
  revision?: number | null;
}

export interface UpdateUISettingsInput {
  __typename?: 'UpdateUISettingsInput';
  accountArchiveQuickFilterOpen?: boolean | null;
  accountArchiveRecentProfiles?: UUID[] | null;
  accountDetailCollapsed?: boolean | null;
  accountDetailTabs?: InterfaceDetailUserTabParams[] | null;
  accountDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  accountEntityTypePriorities?: ID[] | null;
  accountPreviewCollapsed?: boolean | null;
  accountPreviewHealthProfileId?: UUID | null;
  accountProductPricingGridColumns?: GridColumnsInput[] | null;
  accountProductPricingSortBy?: ID | null;
  accountProductPricingSortOrder?: SortOrder | null;
  accountQuickFilterOpen?: boolean | null;
  accountRecentApprovalProcesses?: UUID[] | null;
  accountRecentEmailSequences?: ID[] | null;
  accountRecentProcesses?: UUID[] | null;
  accountRecentProfiles?: UUID[] | null;
  accountRecentTags?: UUID[] | null;
  accountStaticProfiles?: UUID[] | null;
  accountsActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  accountsArchiveGridChanges?: GridHighlightChangesParams | null;
  accountsArchiveGridColumns?: GridColumnsInput[] | null;
  accountsArchiveUseProfileColumns?: boolean | null;
  accountsArchiveView?: UIView | null;
  accountsChildAccountsFilter?: AccountTabDataGridViewOptionsParams | null;
  accountsContactsFilter?: ContactTabDataGridViewOptionsParams | null;
  accountsDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  accountsGridChanges?: GridHighlightChangesParams | null;
  accountsGridColumns?: GridColumnsInput[] | null;
  accountsHierarchyFilter?: AccountHierarchyTabDataGridViewOptionsParams | null;
  accountsLeadsFilter?: RelatedLeadTabDataGridViewOptionsParams | null;
  accountsNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  accountsOpportunitiesFilter?: RelatedOpportunityTabDataGridViewOptionsParams | null;
  accountsProductpricingFilter?: AccountProductPricingTabDataGridViewOptionsParams | null;
  accountsProductsFilter?: ProductTabDataGridViewOptionsParams | null;
  accountsProductsTrendViewSelectedCategories?: UUID[] | null;
  accountsProductsTrendViewSelectedProducts?: UUID[] | null;
  accountsProductsTrendViewSeriesTypeCategories?: ProductSerieTypeEnum | null;
  accountsProductsTrendViewSeriesTypeProducts?: ProductSerieTypeEnum | null;
  accountsProductsTrendViewSortOrder?: SortOrder | null;
  accountsProductsWhiteSpaceSimilarSettings?: SimilarAccountsParams | null;
  accountsProductsWhiteSpaceViewSettings?: WhiteSpaceViewSettingsParams | null;
  accountsProjectsFilter?: ProjectTabDataGridViewOptionsParams | null;
  accountsQuotesFilter?: RelatedQuoteTabDataGridViewOptionsParams | null;
  accountsUseProfileColumns?: boolean | null;
  accountsView?: UIView | null;
  activeFeedEmailScreenTypes?: DetailFeedActiveScreenTypeParams[] | null;
  activitiesCalendarPeriod?: CalendarPeriod | null;
  activitiesGridChanges?: GridHighlightChangesParams | null;
  activitiesGridColumns?: GridColumnsInput[] | null;
  activitiesUseProfileColumns?: boolean | null;
  activitiesView?: UIView | null;
  activityDetailFilter?: ActivityDetailFilterOptionsParams | null;
  activityPreviewCollapsed?: boolean | null;
  activityQuickFilterOpen?: boolean | null;
  activityRecentProfiles?: UUID[] | null;
  addinShowArchivedRecordsAccount?: boolean | null;
  addinShowArchivedRecordsContact?: boolean | null;
  addinShowArchivedRecordsLead?: boolean | null;
  addinShowArchivedRecordsOpportunity?: boolean | null;
  adminProductsAndServicesGridColumns?: GridColumnsInput[] | null;
  adminProductsAndServicesSortBy?: ID | null;
  adminProductsAndServicesSortOrder?: SortOrder | null;
  aiAssistantFavoritePrompts?: AiAssistantFavoritePromptsParams[] | null;
  aiAssistantPrompts?: AiAssistantPromptParams[] | null;
  aiOutputLanguage?: AiOutputLanguage | null;
  aiUpdateOnlineFormRecentPrompts?: string[] | null;
  appointmentEntityTypePriorities?: ID[] | null;
  appointmentPreviewCollapsed?: boolean | null;
  appointmentRecentProcesses?: UUID[] | null;
  approvalProcessesGridColumns?: GridColumnsInput[] | null;
  approvalsFilter?: ApprovalsListingOptionsParams | null;
  approvalsGridColumns?: GridColumnsInput[] | null;
  approvalsSortBy?: ID | null;
  approvalsSortOrder?: SortOrder | null;
  archiveGridChanges?: GridHighlightChangesParams | null;
  archiveGridColumns?: GridColumnsInput[] | null;
  archiveShowLeads?: boolean | null;
  archiveUseProfileColumns?: boolean | null;
  archiveView?: UIView | null;
  attachRecordDocumentsGridColumns?: GridColumnsInput[] | null;
  attachRecordDocumentsSortBy?: ID | null;
  attachRecordDocumentsSortOrder?: SortOrder | null;
  betterNavigatorQuickFilterOpen?: boolean | null;
  betterNavigatorRecentProfiles?: UUID[] | null;
  bottomBarOpen?: boolean | null;
  calendarColorsRules?: CalendarColorRuleParams[] | null;
  calendarColorsUsers?: CalendarColorUserParams[] | null;
  clientMutationId?: string | null;
  companyDocumentsGridColumns?: GridColumnsInput[] | null;
  companyDocumentsSortBy?: ID | null;
  companyDocumentsSortOrder?: SortOrder | null;
  contactArchiveQuickFilterOpen?: boolean | null;
  contactArchiveRecentProfiles?: UUID[] | null;
  contactDetailCollapsed?: boolean | null;
  contactDetailTabs?: InterfaceDetailUserTabParams[] | null;
  contactDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  contactEntityTypePriorities?: ID[] | null;
  contactPreviewCollapsed?: boolean | null;
  contactQuickFilterOpen?: boolean | null;
  contactRecentApprovalProcesses?: UUID[] | null;
  contactRecentEmailSequences?: ID[] | null;
  contactRecentProcesses?: UUID[] | null;
  contactRecentProfiles?: UUID[] | null;
  contactRecentTags?: UUID[] | null;
  contactStaticProfiles?: UUID[] | null;
  contactsActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  contactsArchiveGridChanges?: GridHighlightChangesParams | null;
  contactsArchiveGridColumns?: GridColumnsInput[] | null;
  contactsArchiveUseProfileColumns?: boolean | null;
  contactsArchiveView?: UIView | null;
  contactsDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  contactsGridChanges?: GridHighlightChangesParams | null;
  contactsGridColumns?: GridColumnsInput[] | null;
  contactsLeadsFilter?: LeadTabDataGridViewOptionsParams | null;
  contactsNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  contactsOpportunitiesFilter?: OpportunityTabDataGridViewOptionsParams | null;
  contactsProjectsFilter?: ProjectTabDataGridViewOptionsParams | null;
  contactsQuotesFilter?: QuoteTabDataGridViewOptionsParams | null;
  contactsUseProfileColumns?: boolean | null;
  contactsView?: UIView | null;
  conversionsQuickFilterOpen?: boolean | null;
  conversionsRecentProfiles?: UUID[] | null;
  copyReportSchedule?: boolean | null;
  copyReportSharing?: boolean | null;
  currencyDisplayOption?: CurrencyDisplayOptionEnum | null;
  currencyFormatting?: CurrencyFormattingEnum | null;
  defaultCurrencyId?: UUID | null;
  detailActivitiesGridChanges?: GridHighlightChangesParams | null;
  detailActivitiesGridColumns?: GridColumnsInput[] | null;
  detailActivitiesSortBy?: ID | null;
  detailActivitiesSortOrder?: SortOrder | null;
  detailActivitiesView?: UIView | null;
  detailChildAccountsGridChanges?: GridHighlightChangesParams | null;
  detailChildAccountsGridColumns?: GridColumnsInput[] | null;
  detailChildAccountsSortBy?: ID | null;
  detailChildAccountsSortOrder?: SortOrder | null;
  detailContactsGridChanges?: GridHighlightChangesParams | null;
  detailContactsGridColumns?: GridColumnsInput[] | null;
  detailContactsSortBy?: ID | null;
  detailContactsSortOrder?: SortOrder | null;
  detailDocumentsGridColumns?: GridColumnsInput[] | null;
  detailDocumentsSortBy?: ID | null;
  detailDocumentsSortOrder?: SortOrder | null;
  detailDocumentsView?: UIView | null;
  detailFeedActiveProfiles?: DetailFeedActiveProfileParams[] | null;
  detailFeedEmailActiveProfiles?: DetailFeedActiveProfileParams[] | null;
  detailFeedsEmailView?: FeedViewTypeEnum | null;
  detailFeedsView?: FeedViewTypeEnum | null;
  detailLeadsGridChanges?: GridHighlightChangesParams | null;
  detailLeadsGridColumns?: GridColumnsInput[] | null;
  detailLeadsSortBy?: ID | null;
  detailLeadsSortOrder?: SortOrder | null;
  detailNotesGridColumns?: GridColumnsInput[] | null;
  detailNotesSortBy?: ID | null;
  detailNotesSortOrder?: SortOrder | null;
  detailOpportunitiesGridChanges?: GridHighlightChangesParams | null;
  detailOpportunitiesGridColumns?: GridColumnsInput[] | null;
  detailOpportunitiesSortBy?: ID | null;
  detailOpportunitiesSortOrder?: SortOrder | null;
  detailProductCategoriesTreeColumns?: GridColumnsInput[] | null;
  detailProductsGridColumns?: GridColumnsInput[] | null;
  detailProductsSortBy?: ID | null;
  detailProductsSortOrder?: SortOrder | null;
  detailProductsTab?: ProductTabEnum | null;
  detailProductsView?: UIView | null;
  detailProjectActivitiesView?: UIView | null;
  detailProjectsGridChanges?: GridHighlightChangesParams | null;
  detailProjectsGridColumns?: GridColumnsInput[] | null;
  detailProjectsSortBy?: ID | null;
  detailProjectsSortOrder?: SortOrder | null;
  detailProjectsView?: UIView | null;
  detailQuotesGridChanges?: GridHighlightChangesParams | null;
  detailQuotesGridColumns?: GridColumnsInput[] | null;
  detailQuotesSortBy?: ID | null;
  detailQuotesSortOrder?: SortOrder | null;
  detailSideBarDisplayLabels?: boolean | null;
  detailSideBarLeft?: boolean | null;
  documentManagementHideEmptyFolders?: boolean | null;
  drilldownAccountsFilter?: AccountDrilldownFilterParams | null;
  drilldownAccountsGridChanges?: GridHighlightChangesParams | null;
  drilldownAccountsGridColumns?: GridColumnsInput[] | null;
  drilldownAccountsSortBy?: ID | null;
  drilldownAccountsSortOrder?: SortOrder | null;
  drilldownActivitiesFilter?: ActivityDrilldownFilterParams | null;
  drilldownActivitiesGridChanges?: GridHighlightChangesParams | null;
  drilldownActivitiesGridColumns?: GridColumnsInput[] | null;
  drilldownActivitiesSortBy?: ID | null;
  drilldownActivitiesSortOrder?: SortOrder | null;
  drilldownContactFilter?: ContactDrilldownFilterParams | null;
  drilldownContactsGridChanges?: GridHighlightChangesParams | null;
  drilldownContactsGridColumns?: GridColumnsInput[] | null;
  drilldownContactsSortBy?: ID | null;
  drilldownContactsSortOrder?: SortOrder | null;
  drilldownDocumentsFilter?: CloudObjectDrilldownFilterParams | null;
  drilldownDocumentsGridColumns?: GridColumnsInput[] | null;
  drilldownDocumentsSortBy?: ID | null;
  drilldownDocumentsSortOrder?: SortOrder | null;
  drilldownEmailFilter?: EmailDrilldownFilterParams | null;
  drilldownEmailsGridColumns?: GridColumnsInput[] | null;
  drilldownEmailsSortBy?: ID | null;
  drilldownEmailsSortOrder?: SortOrder | null;
  drilldownLeadsFilter?: LeadDrilldownFilterParams | null;
  drilldownLeadsGridChanges?: GridHighlightChangesParams | null;
  drilldownLeadsGridColumns?: GridColumnsInput[] | null;
  drilldownLeadsOpportunitiesFilter?: LeadOpptyDrilldownFilterParams | null;
  drilldownLeadsOpportunitiesGridChanges?: GridHighlightChangesParams | null;
  drilldownLeadsOpportunitiesGridColumns?: GridColumnsInput[] | null;
  drilldownLeadsOpportunitiesSortBy?: ID | null;
  drilldownLeadsOpportunitiesSortOrder?: SortOrder | null;
  drilldownLeadsSortBy?: ID | null;
  drilldownLeadsSortOrder?: SortOrder | null;
  drilldownMessagesGridChanges?: GridHighlightChangesParams | null;
  drilldownMessagesGridColumns?: GridColumnsInput[] | null;
  drilldownMessagesSortBy?: ID | null;
  drilldownMessagesSortOrder?: SortOrder | null;
  drilldownNotesGridChanges?: GridHighlightChangesParams | null;
  drilldownNotesGridColumns?: GridColumnsInput[] | null;
  drilldownNotesSortBy?: ID | null;
  drilldownNotesSortOrder?: SortOrder | null;
  drilldownOpportunitiesFilter?: OpportunityDrilldownFilterParams | null;
  drilldownOpportunitiesGridChanges?: GridHighlightChangesParams | null;
  drilldownOpportunitiesGridColumns?: GridColumnsInput[] | null;
  drilldownOpportunitiesSortBy?: ID | null;
  drilldownOpportunitiesSortOrder?: SortOrder | null;
  drilldownProductsGridChanges?: GridHighlightChangesParams | null;
  drilldownProductsGridColumns?: GridColumnsInput[] | null;
  drilldownProductsSortBy?: ID | null;
  drilldownProductsSortOrder?: SortOrder | null;
  drilldownProjectsFilter?: ProjectDrilldownFilterParams | null;
  drilldownProjectsGridChanges?: GridHighlightChangesParams | null;
  drilldownProjectsGridColumns?: GridColumnsInput[] | null;
  drilldownProjectsSortBy?: ID | null;
  drilldownProjectsSortOrder?: SortOrder | null;
  drilldownQuotesFilter?: QuoteDrilldownFilterParams | null;
  drilldownQuotesGridChanges?: GridHighlightChangesParams | null;
  drilldownQuotesGridColumns?: GridColumnsInput[] | null;
  drilldownQuotesSortBy?: ID | null;
  drilldownQuotesSortOrder?: SortOrder | null;
  drilldownTextMessagesFilter?: TextMessageDrilldownFilterParams | null;
  drilldownTextMessagesGridColumns?: GridColumnsInput[] | null;
  drilldownTextMessagesSortBy?: ID | null;
  drilldownTextMessagesSortOrder?: SortOrder | null;
  duplicateCheckerManualMergeFields?: DuplicateCheckerManualMergeFieldsParams[] | null;
  duplicateCheckerMatchSettings?: DuplicateCheckerMatchSettingsParams[] | null;
  emailConversationSortOrder?: SortOrder | null;
  emailSequencesGridColumns?: GridColumnsInput[] | null;
  emailSequencesSortBy?: ID | null;
  emailSequencesSortOrder?: SortOrder | null;
  emailTemplatesHideEmptyFolders?: boolean | null;
  emailTemplatesStatisticsFilter?: EmailTemplatesStatisticsFilterParams | null;
  emailTemplatesStatisticsSortBy?: EmailTemplateStatisticsGridColumnEnum | null;
  emailTemplatesStatisticsSortOrder?: SortOrder | null;
  entityHealthCategoryDayOffset?: number | null;
  entityHealthHistoryDayOffset?: number | null;
  featurePromotions?: FeaturePromotionEnum[] | null;
  feedScreenType?: ScreenTypeEnum | null;
  feedStreamType?: FeedStreamTypeEnum | null;
  feedsDetailFilter?: FeedTabDataGridViewOptionsParams | null;
  feedsEmailDetailFilter?: FeedEmailTabDataGridViewOptionsParams | null;
  feedsEmailRecentProfiles?: UUID[] | null;
  feedsEmailView?: FeedViewTypeEnum | null;
  feedsRecentProfiles?: UUID[] | null;
  feedsView?: FeedViewTypeEnum | null;
  forecastQuickFilterOpen?: boolean | null;
  forecastsCreated?: boolean | null;
  forecastsDetailView?: UIView | null;
  forecastsFilter?: ForecastListingOptionsParams | null;
  forecastsGridChanges?: GridHighlightChangesParams | null;
  forecastsGridColumns?: GridColumnsInput[] | null;
  forecastsSortBy?: ID | null;
  forecastsSortOrder?: SortOrder | null;
  formViews?: FormViewOptionsParams[] | null;
  globalSearchFilter?: GlobalSearchFilterParams | null;
  globalSearchRecords?: GlobalSearchSearchTypeParams[] | null;
  globalSearchSorting?: GlobalSearchSorting | null;
  importSettingsAccounts?: ImportSettingsOptionsParams | null;
  importSettingsClients?: ImportSettingsOptionsParams | null;
  importSettingsContacts?: ImportSettingsOptionsParams | null;
  importSettingsLeads?: ImportSettingsOptionsParams | null;
  importSettingsOpportunities?: ImportSettingsOptionsParams | null;
  importSettingsPriceLists?: ImportSettingsOptionsParams | null;
  importSettingsProducts?: ImportSettingsOptionsParams | null;
  indicatorsQuickFilterOpen?: boolean | null;
  indicatorsRecentProfiles?: UUID[] | null;
  insightsQuickFilterOpen?: boolean | null;
  insightsRecentProfiles?: UUID[] | null;
  lastSelectedPriceListId?: UUID | null;
  leadArchiveQuickFilterOpen?: boolean | null;
  leadArchiveRecentProfiles?: UUID[] | null;
  leadDetailCollapsed?: boolean | null;
  leadDetailTabs?: InterfaceDetailUserTabParams[] | null;
  leadDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  leadEntityTypePriorities?: EntityTypeProcessPrioritiesParams[] | null;
  leadPreviewCollapsed?: boolean | null;
  leadProcessPriorities?: ID[] | null;
  leadQuickFilterOpen?: boolean | null;
  leadRecentApprovalProcesses?: UUID[] | null;
  leadRecentEmailSequences?: ID[] | null;
  leadRecentProcesses?: UUID[] | null;
  leadRecentProfiles?: UUID[] | null;
  leadRecentTags?: UUID[] | null;
  leadStaticProfiles?: UUID[] | null;
  leadsActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  leadsArchiveGridChanges?: GridHighlightChangesParams | null;
  leadsArchiveGridColumns?: GridColumnsInput[] | null;
  leadsArchiveUseProfileColumns?: boolean | null;
  leadsArchiveView?: UIView | null;
  leadsDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  leadsGridChanges?: GridHighlightChangesParams | null;
  leadsGridColumns?: GridColumnsInput[] | null;
  leadsNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  leadsStepOpen?: boolean | null;
  leadsUseProfileColumns?: boolean | null;
  leadsView?: UIView | null;
  lifecycleRecentProfiles?: UUID[] | null;
  lookupAccountsGridColumns?: GridColumnsInput[] | null;
  lookupAccountsSortBy?: ID | null;
  lookupAccountsSortOrder?: SortOrder | null;
  lookupActivitiesGridColumns?: GridColumnsInput[] | null;
  lookupActivitiesSortBy?: ID | null;
  lookupActivitiesSortOrder?: SortOrder | null;
  lookupClientsGridColumns?: GridColumnsInput[] | null;
  lookupClientsSortBy?: ID | null;
  lookupClientsSortOrder?: SortOrder | null;
  lookupContactsGridColumns?: GridColumnsInput[] | null;
  lookupContactsSortBy?: ID | null;
  lookupContactsSortOrder?: SortOrder | null;
  lookupDocumentsGridColumns?: GridColumnsInput[] | null;
  lookupDocumentsSortBy?: ID | null;
  lookupDocumentsSortOrder?: SortOrder | null;
  lookupLeadsGridColumns?: GridColumnsInput[] | null;
  lookupLeadsOpportunitiesGridColumns?: GridColumnsInput[] | null;
  lookupLeadsOpportunitiesSortBy?: ID | null;
  lookupLeadsOpportunitiesSortOrder?: SortOrder | null;
  lookupLeadsSortBy?: ID | null;
  lookupLeadsSortOrder?: SortOrder | null;
  lookupNotesGridColumns?: GridColumnsInput[] | null;
  lookupNotesSortBy?: ID | null;
  lookupNotesSortOrder?: SortOrder | null;
  lookupOpportunitiesGridColumns?: GridColumnsInput[] | null;
  lookupOpportunitiesSortBy?: ID | null;
  lookupOpportunitiesSortOrder?: SortOrder | null;
  lookupProductsAndServicesGridColumns?: GridColumnsInput[] | null;
  lookupProductsAndServicesSortBy?: ID | null;
  lookupProductsAndServicesSortOrder?: SortOrder | null;
  lookupProductsAndServicesWithPriceGridColumns?: GridColumnsInput[] | null;
  lookupProductsAndServicesWithPriceSortBy?: ID | null;
  lookupProductsAndServicesWithPriceSortOrder?: SortOrder | null;
  lookupProjectsGridColumns?: GridColumnsInput[] | null;
  lookupProjectsSortBy?: ID | null;
  lookupProjectsSortOrder?: SortOrder | null;
  lookupQuotesGridColumns?: GridColumnsInput[] | null;
  lookupQuotesSortBy?: ID | null;
  lookupQuotesSortOrder?: SortOrder | null;
  massEmailDetailGridColumns?: GridColumnsInput[] | null;
  massEmailDetailGridSortBy?: MassEmailDetailGridSortyBy | null;
  massEmailDetailGridSortOrder?: SortOrder | null;
  navigatorQuickFilterOpen?: boolean | null;
  navigatorRecentProfiles?: UUID[] | null;
  navigatorTrendChartSeries?: TargetValueType[] | null;
  notificationSettings?: NotificationSettingsParams | null;
  onlineFormTypeDetailRespondedGridColumns?: GridColumnsInput[] | null;
  onlineFormTypeDetailRespondedGridSortBy?: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailRespondedGridSortOrder?: SortOrder | null;
  onlineFormTypeDetailRespondedUnknownGridColumns?: GridColumnsInput[] | null;
  onlineFormTypeDetailRespondedUnknownGridSortBy?: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailRespondedUnknownGridSortOrder?: SortOrder | null;
  onlineFormTypeDetailResponseGridColumns?: GridColumnsInput[] | null;
  onlineFormTypeDetailResponseGridSortBy?: OnlineFormTypeDetailResponseGridSortBy | null;
  onlineFormTypeDetailResponseGridSortOrder?: SortOrder | null;
  onlineFormTypeDetailSentGridColumns?: GridColumnsInput[] | null;
  onlineFormTypeDetailSentGridSortBy?: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailSentGridSortOrder?: SortOrder | null;
  onlineFormTypeDetailSentNotRespondedGridColumns?: GridColumnsInput[] | null;
  onlineFormTypeDetailSentNotRespondedGridSortBy?: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailSentNotRespondedGridSortOrder?: SortOrder | null;
  onlineFormTypesGridColumns?: GridColumnsInput[] | null;
  onlineFormTypesSortBy?: ID | null;
  onlineFormTypesSortOrder?: SortOrder | null;
  opportunitiesActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  opportunitiesBubbleChartPeriod?: string | null;
  opportunitiesDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  opportunitiesGridChanges?: GridHighlightChangesParams | null;
  opportunitiesGridColumns?: GridColumnsInput[] | null;
  opportunitiesNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  opportunitiesQuotesFilter?: QuoteTabDataGridViewOptionsParams | null;
  opportunitiesShowLeads?: boolean | null;
  opportunitiesUseProfileColumns?: boolean | null;
  opportunitiesView?: UIView | null;
  opportunityArchiveQuickFilterOpen?: boolean | null;
  opportunityArchiveRecentProfiles?: UUID[] | null;
  opportunityDetailCollapsed?: boolean | null;
  opportunityDetailTabs?: InterfaceDetailUserTabParams[] | null;
  opportunityDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  opportunityPreviewCollapsed?: boolean | null;
  opportunityQuickFilterOpen?: boolean | null;
  opportunityRecentApprovalProcesses?: UUID[] | null;
  opportunityRecentEmailSequences?: ID[] | null;
  opportunityRecentProcesses?: UUID[] | null;
  opportunityRecentProfiles?: UUID[] | null;
  opportunityRecentTags?: UUID[] | null;
  opportunityStaticProfiles?: UUID[] | null;
  performanceQuickFilterOpen?: boolean | null;
  pipelinePriorities?: ID[] | null;
  previewPinnedCharts?: PreviewPinnedChartsParams[] | null;
  previewPinnedFields?: PreviewPinnedFieldsParams[] | null;
  processDetailCreateBackupCopy?: boolean | null;
  processTabFilter?: ProcessTabDataGridViewOptionsParams | null;
  processesGridColumns?: GridColumnsInput[] | null;
  processesSortBy?: ID | null;
  processesSortOrder?: SortOrder | null;
  productEntityTypePriorities?: ID[] | null;
  productsServicesGridColumns?: GridColumnsInput[] | null;
  projectActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  projectActivitiesObjectiveGridChanges?: GridHighlightChangesParams | null;
  projectActivitiesObjectiveGridColumns?: GridColumnsInput[] | null;
  projectDetailCollapsed?: boolean | null;
  projectDetailTabs?: InterfaceDetailUserTabParams[] | null;
  projectDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  projectEntityTypePriorities?: ID[] | null;
  projectGanttPeriod?: ProjectGanttPeriodOptionsParams[] | null;
  projectGridChanges?: GridHighlightChangesParams | null;
  projectGridColumns?: GridColumnsInput[] | null;
  projectObjectiveOpen?: ID[] | null;
  projectPreviewCollapsed?: boolean | null;
  projectQuickFilterOpen?: boolean | null;
  projectRecentEmailSequences?: ID[] | null;
  projectRecentProcesses?: UUID[] | null;
  projectRecentProfiles?: UUID[] | null;
  projectRecentTags?: UUID[] | null;
  projectStaticProfiles?: UUID[] | null;
  projectUseProfileColumns?: boolean | null;
  projectsDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  projectsNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  projectsOpportunitiesFilter?: OpportunityTabDataGridViewOptionsParams | null;
  qualifiedStepOpen?: boolean | null;
  quoteArchiveQuickFilterOpen?: boolean | null;
  quoteArchiveRecentProfiles?: UUID[] | null;
  quoteDetailCollapsed?: boolean | null;
  quoteDetailTabs?: InterfaceDetailUserTabParams[] | null;
  quoteDetailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  quoteEntityTypePriorities?: EntityTypeProcessPrioritiesParams[] | null;
  quotePreviewCollapsed?: boolean | null;
  quoteProcessPriorities?: ID[] | null;
  quoteQuickFilterOpen?: boolean | null;
  quoteRecentApprovalProcesses?: UUID[] | null;
  quoteRecentProcesses?: UUID[] | null;
  quoteRecentProfiles?: UUID[] | null;
  quoteStaticProfiles?: UUID[] | null;
  quotesActivitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  quotesArchiveGridChanges?: GridHighlightChangesParams | null;
  quotesArchiveGridColumns?: GridColumnsInput[] | null;
  quotesArchiveUseProfileColumns?: boolean | null;
  quotesArchiveView?: UIView | null;
  quotesDocumentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  quotesGridChanges?: GridHighlightChangesParams | null;
  quotesGridColumns?: GridColumnsInput[] | null;
  quotesNotesFilter?: NoteTabDataGridViewOptionsParams | null;
  quotesUseProfileColumns?: boolean | null;
  quotesView?: UIView | null;
  recentCloudObjects?: ID[] | null;
  recentlyOpened?: RecentlyOpenedEntityParams[] | null;
  recordDocumentsGridColumns?: GridColumnsInput[] | null;
  recordDocumentsSortBy?: ID | null;
  recordDocumentsSortOrder?: SortOrder | null;
  reportPdfOptions?: PdfOptionsParams | null;
  reportQuickFilterOpen?: boolean | null;
  reportsHideEmptyFolders?: boolean | null;
  showCopyConfirmation?: boolean | null;
  showMapLegend?: boolean | null;
  showOnlyFavoriteProfiles?: boolean | null;
  showOrgChartInfluences?: boolean | null;
  showRecordTooltips?: boolean | null;
  skipOnlineFormDownloadWarning?: boolean | null;
  speechToTextLanguage?: string | null;
  targetsGroupTargetsFilter?: TargetListingOptionsParams | null;
  targetsGroupTargetsGridColumns?: GridColumnsInput[] | null;
  targetsGroupTargetsSortBy?: ID | null;
  targetsGroupTargetsSortOrder?: SortOrder | null;
  targetsGroupUserTargetsGridColumns?: GridColumnsInput[] | null;
  targetsGroupUserTargetsSortBy?: ID | null;
  targetsGroupUserTargetsSortOrder?: SortOrder | null;
  targetsSimulatedTargetsFilter?: SimulatedTargetListingOptionsParams | null;
  targetsSimulatedTargetsGridColumns?: GridColumnsInput[] | null;
  targetsSimulatedTargetsSortBy?: ID | null;
  targetsSimulatedTargetsSortOrder?: SortOrder | null;
  targetsUserTargetsFilter?: UserTargetListingOptionsParams | null;
  targetsUserTargetsGridColumns?: GridColumnsInput[] | null;
  targetsUserTargetsSortBy?: ID | null;
  targetsUserTargetsSortOrder?: SortOrder | null;
  taskEntityTypePriorities?: ID[] | null;
  taskPreviewCollapsed?: boolean | null;
  taskRecentProcesses?: UUID[] | null;
  templatesGridColumns?: GridColumnsInput[] | null;
  templatesSortBy?: ID | null;
  templatesSortOrder?: SortOrder | null;
  useBetterNavigator?: boolean | null;
}

export interface UpdateTranslationDraftInput {
  __typename?: 'UpdateTranslationDraftInput';
  clientMutationId?: string | null;
  idKey: string;
  translationDeDe: string;
  translationEnUs: string;
  translationEsEs: string;
  translationPtBr: string;
}

export interface UpdateTimeframeInput {
  __typename?: 'UpdateTimeframeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  stepId?: ID | null;
  timeframe?: number | null;
}

export interface UpdateTextMessageInput {
  __typename?: 'UpdateTextMessageInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  chatConversationId?: ID | null;
  clientMutationId?: string | null;
  content?: string | null;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  id: ID;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
  textMessageConversationId?: ID | null;
}

export interface UpdateTextMessageConversationRelationsInput {
  __typename?: 'UpdateTextMessageConversationRelationsInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  textMessageConversationId?: ID | null;
}

export interface UpdateTextMessageConversationInput {
  __typename?: 'UpdateTextMessageConversationInput';
  accountRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  created?: DateTime | null;
  id: ID;
  leadRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  messages?: CreateOrUpdateTextMessageNoTextMessageConversationBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  phoneId?: ID | null;
  projectRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  quoteRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  recipientAccountId?: ID | null;
  recipientContactId?: ID | null;
  recipientPhoneNumber?: string | null;
  revision?: number | null;
}

export interface UpdateTeamSpaceClientSettingInput {
  __typename?: 'UpdateTeamSpaceClientSettingInput';
  calling?: JSONString | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dropbox?: DropboxSettingsInput | null;
  emailAliases?: string | null;
  emailAutomatizerEnabled?: boolean | null;
  emailAutomatizerOwnerAccountEnabled?: boolean | null;
  emailAutomatizerUserAccountEnabled?: boolean | null;
  emailConf?: EmailConfFieldInput | null;
  emailDefaultContentSharingMode?: ContentShareModeEnum | null;
  emailEmailSequenceEnabled?: boolean | null;
  emailEmailSequenceOwnerAccountEnabled?: boolean | null;
  emailEmailSequenceUserAccountEnabled?: boolean | null;
  emailFetchSettings?: number | null;
  emailImapFolder1?: string | null;
  emailImapFolder2?: string | null;
  emailIntegration?: EmailIntegrationEnum | null;
  emailMassEmailClientIds?: ID[] | null;
  emailMassEmailEnabled?: boolean | null;
  emailNotificationsSettings?: NotificationSettingsParams | null;
  googleDrive?: GoogleDriveSettingsInput | null;
  microsoftOneDrive?: MicrosoftOneDriveSettingsInput | null;
  microsoftSharePoint?: MicrosoftOneDriveSettingsInput | null;
  modified?: DateTime | null;
  pandaDocIsEnabled?: boolean | null;
}

export interface UpdateTaskSharingSalesUnitRelationInput {
  __typename?: 'UpdateTaskSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId?: ID | null;
  unitId?: ID | null;
}

export interface UpdateTaskSharingClientRelationInput {
  __typename?: 'UpdateTaskSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId?: ID | null;
}

export interface UpdateTaskReminderNoTaskBackrefInput {
  __typename?: 'UpdateTaskReminderNoTaskBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  setDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface UpdateTaskReminderInput {
  __typename?: 'UpdateTaskReminderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  setDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
  taskId?: ID | null;
}

export interface UpdateTaskRecurrenceNoTaskBackrefInput {
  __typename?: 'UpdateTaskRecurrenceNoTaskBackrefInput';
  applyRecurrence?: boolean | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface UpdateTaskRecurrenceInput {
  __typename?: 'UpdateTaskRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  id: ID;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  taskId?: ID | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface UpdateTaskInput {
  __typename?: 'UpdateTaskInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  callDuration?: number | null;
  callId?: ID | null;
  callOutcomeId?: ID | null;
  callSid?: string | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  dueDate?: GqlDate | null;
  duration?: number | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  id: ID;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  mediaTranscriptionId?: UUID | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  ownerId?: ID | null;
  priority?: PriorityEnum | null;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateTaskSharingClientRelationNoTaskBackrefInput[] | null;
  sharingUnits?: CreateTaskSharingSalesUnitRelationNoTaskBackrefInput[] | null;
  startDate?: GqlDate | null;
  status?: TaskStatusEnum | null;
  subject?: string | null;
  tags?: CreateTagRelationNoTaskBackrefInput[] | null;
  taskRecurrence?: UpdateTaskRecurrenceNoTaskBackrefInput | null;
  unitId?: ID | null;
}

export interface UpdateTargetSettingsInput {
  __typename?: 'UpdateTargetSettingsInput';
  calculatedIndicators: TargetsIndicatorsParams;
  chartGranularity: TargetsChartGranularityEnum;
  customIndicators: TargetsIndicatorsParams;
  id: UUID;
  leadsEnabled: boolean;
  targetValueLocked: boolean;
  workingTimeEnabled: boolean;
}

export interface UpdateTargetRelationInput {
  __typename?: 'UpdateTargetRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  groupTargetId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  userTargetId?: ID | null;
}

export interface UpdateTargetInput {
  __typename?: 'UpdateTargetInput';
  currencyId: UUID;
  description?: string | null;
  existingTargetsIds?: UUID[] | null;
  filter?: FieldFilterParams | null;
  id: UUID;
  name: string;
  ownerId?: UUID | null;
  period: TargetsPeriodParams;
  pipelineLeadProcessId?: UUID | null;
  targetClientIds?: UUID[] | null;
}

export interface UpdateTagRelationInput {
  __typename?: 'UpdateTagRelationInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id: ID;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId?: ID | null;
  taskId?: ID | null;
}

export interface UpdateTagInput {
  __typename?: 'UpdateTagInput';
  allowedEntityTypeIds?: JSONString | null;
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  id: ID;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  useLang?: boolean | null;
}

export interface UpdateStepInput {
  __typename?: 'UpdateStepInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id: ID;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  percent?: number | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateOrUpdateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface UpdateStepChecklistSalesRoleRelationInput {
  __typename?: 'UpdateStepChecklistSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
  stepChecklistId?: ID | null;
}

export interface UpdateStepChecklistInput {
  __typename?: 'UpdateStepChecklistInput';
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate?: CreateCloudObjectTemplateInput | null;
  cloudObjectTemplateId?: ID | null;
  created?: DateTime | null;
  description?: string | null;
  emailSequenceId?: ID | null;
  fieldId?: ID | null;
  id: ID;
  itemType?: StepChecklistTypeEnum | null;
  itemValidation?: StepChecklistValidationEnum | null;
  label?: string | null;
  labelUseLang?: boolean | null;
  modified?: DateTime | null;
  processId?: ID | null;
  revision?: number | null;
  salesRoles?: CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput[] | null;
  sendEmailFieldId?: ID | null;
  sendEmailTemplateId?: ID | null;
  stepId?: ID | null;
  visibilityCondition?: StepChecklistVisibilityFilterJSONString | null;
  visibilityType?: StepChecklistVisibilityEnum | null;
}

export interface UpdateSpaceSettingInput {
  __typename?: 'UpdateSpaceSettingInput';
  attachmentFileExtensions?: AttachmentFileExtensionParams | null;
  attachmentMaxSize?: number | null;
  clientMutationId?: string | null;
  cloudEnabled?: boolean | null;
  dynamicFinancialYear?: FinancialDateStartParams | null;
  emailAttachmentEnabled?: boolean | null;
  emailAttachmentMaxSize?: number | null;
  emailDomainBlacklisting?: string[] | null;
  emailNotificationsDefault?: boolean | null;
  fileAttachmentUploadEnabled?: boolean | null;
  firstDayOfWeek?: FirstDayOfWeekEnum | null;
  theme?: AppThemeEnum | null;
  timezone?: string | null;
  workingDays?: WorkingDaysInput | null;
}

export interface UpdateSpaceNameInUrlCloudObjectTemplateInput {
  __typename?: 'UpdateSpaceNameInUrlCloudObjectTemplateInput';
  clientMutationId?: string | null;
  oldSpaceName: string;
}

export interface UpdateSpaceNameInUrlCloudObjectInput {
  __typename?: 'UpdateSpaceNameInUrlCloudObjectInput';
  clientMutationId?: string | null;
  oldSpaceName: string;
}

export interface UpdateScreenSettingsInput {
  __typename?: 'UpdateScreenSettingsInput';
  clientMutationId?: string | null;
  key: string;
  value: string;
}

export interface UpdateScheduledEmailInput {
  __typename?: 'UpdateScheduledEmailInput';
  attachments?: UUID[] | null;
  bcc?: SendEmailRecipientParams[] | null;
  cc?: SendEmailRecipientParams[] | null;
  clientMutationId?: string | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: UUID[] | null;
  contentSharingUnits?: UUID[] | null;
  emailTemplateId?: UUID | null;
  enrollEmailSequenceId?: UUID | null;
  html: string;
  id: UUID;
  isHtmlTemplate?: boolean | null;
  isLinkEntitiesEnabled?: boolean | null;
  linkedItems?: SendEmailLinkedEntityParams[] | null;
  logEmailAsTask?: SendEmailFollowupTaskSettingsParams | null;
  logFollowUpTask?: SendEmailFollowupTaskSettingsParams | null;
  massMailWithLinkedRecords?: boolean | null;
  personifyBy?: PersonificationEntityDataParams | null;
  primaryEntity?: EntityNameEnum | null;
  recipients?: SendEmailRecipientParams[] | null;
  replyTo?: UUID | null;
  sendAt: DateTime;
  sendToUnsubscribed?: boolean | null;
  service?: SendEmailServiceParams | null;
  standardMailLinkedItems?: SendEmailLinkedEntityParams[] | null;
  subject: string;
}

export interface UpdateSalesUnitInput {
  __typename?: 'UpdateSalesUnitInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  parentId?: ID | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  revision?: number | null;
}

export interface UpdateSalesRoleInput {
  __typename?: 'UpdateSalesRoleInput';
  clientMutationId?: string | null;
  colorCode?: number | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateRevenueScheduleSettingInput {
  __typename?: 'UpdateRevenueScheduleSettingInput';
  clientMutationId?: string | null;
  isEnabled: boolean;
  periodType: RevenueSchedulePeriodTypeEnum;
  valueType: RevenueScheduleValueTypeEnum;
}

export interface UpdateReportSharingSalesUnitRelationInput {
  __typename?: 'UpdateReportSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  reportId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateReportSharingClientRelationInput {
  __typename?: 'UpdateReportSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  reportId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateReportScheduleNoReportBackrefInput {
  __typename?: 'UpdateReportScheduleNoReportBackrefInput';
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  settings?: ReportScheduleSchemaJSONString | null;
}

export interface UpdateReportScheduleInput {
  __typename?: 'UpdateReportScheduleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  ownerId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
  settings?: ReportScheduleSchemaJSONString | null;
}

export interface UpdateReportInput {
  __typename?: 'UpdateReportInput';
  accessLink?: string | null;
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  reportsFolderId?: ID | null;
  revision?: number | null;
  settings?: ReportSchemaJSONString | null;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharingClients?: CreateReportSharingClientRelationNoReportBackrefInput[] | null;
  sharingUnits?: CreateReportSharingSalesUnitRelationNoReportBackrefInput[] | null;
  syncEnabled?: boolean | null;
  type?: ReportTypeEnum | null;
}

export interface UpdateReportFolderInput {
  __typename?: 'UpdateReportFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  parentReportFolderId?: ID | null;
  revision?: number | null;
}

export interface UpdateRelationFieldTabSettingsInput {
  __typename?: 'UpdateRelationFieldTabSettingsInput';
  changes: GridHighlightChangesParams;
  clientMutationId?: string | null;
  fieldId: UUID;
  filter: RelationFieldTabSettingsFilterParams;
  gridColumns: GridColumnsInput[];
  gridSortBy: UUID;
  gridSortOrder: SortOrder;
  id?: ID | null;
  type?: FieldRelationTypeEnum | null;
}

export interface UpdateQuoteSharingSalesUnitRelationInput {
  __typename?: 'UpdateQuoteSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateQuoteSharingClientRelationInput {
  __typename?: 'UpdateQuoteSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateQuoteProfileInput {
  __typename?: 'UpdateQuoteProfileInput';
  clientMutationId?: string | null;
  data?: QuoteProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateQuoteProcessInput {
  __typename?: 'UpdateQuoteProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoQuoteProcessBackrefInput[] | null;
}

export interface UpdateQuoteKPIInput {
  __typename?: 'UpdateQuoteKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  kpi?: QuoteKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateQuoteInput {
  __typename?: 'UpdateQuoteInput';
  accountRelations?: CreateQuoteAccountRelationNoQuoteBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateQuoteContactRelationNoQuoteBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  expirationDate?: GqlDate | null;
  id: ID;
  isActiveInOpportunity?: boolean | null;
  isArchived?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyId?: ID | null;
  ownerId?: ID | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOrUpdateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteTypeId?: ID | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateQuoteSharingClientRelationNoQuoteBackrefInput[] | null;
  sharingUnits?: CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoQuoteBackrefInput[] | null;
  stepId?: ID | null;
  totalAmount?: CurrencyForeignFieldInput | null;
  unitId?: ID | null;
  version?: number | null;
}

export interface UpdateQuoteDraftProfileInput {
  __typename?: 'UpdateQuoteDraftProfileInput';
  clientMutationId?: string | null;
  data?: QuoteProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateQuoteDataExRelationInput {
  __typename?: 'UpdateQuoteDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateQuoteContactRelationInput {
  __typename?: 'UpdateQuoteContactRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateQuoteArchiveProfileInput {
  __typename?: 'UpdateQuoteArchiveProfileInput';
  clientMutationId?: string | null;
  data?: QuoteArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateQuoteArchiveDraftProfileInput {
  __typename?: 'UpdateQuoteArchiveDraftProfileInput';
  clientMutationId?: string | null;
  data?: QuoteArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateQuoteAccountRelationInput {
  __typename?: 'UpdateQuoteAccountRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateProjectSharingSalesUnitRelationInput {
  __typename?: 'UpdateProjectSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateProjectSharingClientRelationInput {
  __typename?: 'UpdateProjectSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateProjectProfileInput {
  __typename?: 'UpdateProjectProfileInput';
  clientMutationId?: string | null;
  data?: ProjectProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateProjectObjectiveSortInput {
  __typename?: 'UpdateProjectObjectiveSortInput';
  beforeId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  sessionIdToUpdate?: string | null;
}

export interface UpdateProjectObjectiveInput {
  __typename?: 'UpdateProjectObjectiveInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  projectId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface UpdateProjectObjectiveActivitiesSortInput {
  __typename?: 'UpdateProjectObjectiveActivitiesSortInput';
  beforeId?: ID | null;
  clientMutationId?: string | null;
  ids: ID[];
  objectiveId?: ID | null;
  projectId: ID;
  sessionIdToUpdate?: string | null;
}

export interface UpdateProjectKPIInput {
  __typename?: 'UpdateProjectKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  kpi?: ProjectKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateProjectInput {
  __typename?: 'UpdateProjectInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactRelations?: CreateProjectContactRelationNoProjectBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  endDate?: GqlDate | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  projectTypeId?: ID | null;
  revenueGoal?: CurrencyForeignFieldInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateProjectSharingClientRelationNoProjectBackrefInput[] | null;
  sharingUnits?: CreateProjectSharingSalesUnitRelationNoProjectBackrefInput[] | null;
  startDate?: GqlDate | null;
  staticProfiles?: CreateProfileRelationNoProjectBackrefInput[] | null;
  tags?: CreateTagRelationNoProjectBackrefInput[] | null;
  unitId?: ID | null;
}

export interface UpdateProjectDraftProfileInput {
  __typename?: 'UpdateProjectDraftProfileInput';
  clientMutationId?: string | null;
  data?: ProjectProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateProjectContactRelationInput {
  __typename?: 'UpdateProjectContactRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
}

export interface UpdateProfileSharingSalesUnitRelationInput {
  __typename?: 'UpdateProfileSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  profileId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateProfileSharingClientRelationInput {
  __typename?: 'UpdateProfileSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  profileId?: ID | null;
  revision?: number | null;
}

export interface UpdateProfileRelationInput {
  __typename?: 'UpdateProfileRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface UpdateProfileInput {
  __typename?: 'UpdateProfileInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entity?: ScreenTypeEnum | null;
  entityApiName?: string | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  settings?: JSONString | null;
  shareMode?: ShareModeEnum | null;
  syncEnabled?: boolean | null;
  type?: ProfileTypeEnum | null;
  useLang?: boolean | null;
}

export interface UpdateProductPriceListPriceInput {
  __typename?: 'UpdateProductPriceListPriceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  price?: number | null;
  productId?: ID | null;
  productPriceListId?: ID | null;
  revision?: number | null;
  settings?: ProductPriceListPriceSettingsJSONString | null;
}

export interface UpdateProductPriceListInput {
  __typename?: 'UpdateProductPriceListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  endDate?: GqlDate | null;
  id: ID;
  isActive?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  productPriceListPrices?: CreateProductPriceListPriceNoProductPriceListBackrefInput[] | null;
  revision?: number | null;
  rules?: JSONString | null;
  startDate?: GqlDate | null;
  type?: ProductPriceListTypeEnum | null;
}

export interface UpdateProductPipelineRelationInput {
  __typename?: 'UpdateProductPipelineRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  pipelineId?: ID | null;
  productId?: ID | null;
  revision?: number | null;
}

export interface UpdateProductInput {
  __typename?: 'UpdateProductInput';
  allowedPipelines?: AccessPipelinesEnum | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  pictureSourceUrl?: string | null;
  productCategoryId?: ID | null;
  productPipelineRelations?: CreateProductPipelineRelationNoProductBackrefInput[] | null;
  productPipelines?: ProductPipelinesInput | null;
  productTypeId?: ID | null;
  revision?: number | null;
  sku?: string | null;
  unitSymbol?: string | null;
}

export interface UpdateProductCategoryInput {
  __typename?: 'UpdateProductCategoryInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  parentId?: ID | null;
  productRelations?: CreateProductNoProductCategoryBackrefInput[] | null;
  revision?: number | null;
}

export interface UpdateProcessTemplateInput {
  __typename?: 'UpdateProcessTemplateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  isRecommended?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  settings?: ProcessSchemaJSONString | null;
}

export interface UpdateProcessInput {
  __typename?: 'UpdateProcessInput';
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: ProcessSchemaJSONString | null;
  tags?: CreateTagRelationNoProcessBackrefInput[] | null;
  type?: ProcessTypeEnum | null;
}

export interface UpdateProcessActivityLogLineInput {
  __typename?: 'UpdateProcessActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  id: ID;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  processActivityLogId?: ID | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateProcessActivityLogInput {
  __typename?: 'UpdateProcessActivityLogInput';
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  cpuRunTime?: number | null;
  created?: DateTime | null;
  endTime?: DateTime | null;
  id: ID;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  parentProcessIds?: JSONString | null;
  processId?: ID | null;
  runId?: ID | null;
  startTime?: DateTime | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdatePriorityApprovalProcessInput {
  __typename?: 'UpdatePriorityApprovalProcessInput';
  clientMutationId?: string | null;
  entity: BaseEntityTypeEnum;
  id: ID;
  newIndex: number;
}

export interface UpdatePipelineInput {
  __typename?: 'UpdatePipelineInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoPipelineBackrefInput[] | null;
}

export interface UpdatePhoneInput {
  __typename?: 'UpdatePhoneInput';
  created?: DateTime | null;
  forwardCallsToPhone?: string | null;
  forwardMessagesToEmail?: string | null;
  id: ID;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  phoneNumber?: string | null;
  twilioCallerSid?: string | null;
  type?: PhoneTypeEnum | null;
}

export interface UpdateParentAccountRelationTypeInput {
  __typename?: 'UpdateParentAccountRelationTypeInput';
  childLabel?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  parentLabel?: string | null;
  revision?: number | null;
}

export interface UpdateOpptyRevenueScheduleNoIdBackrefInput {
  __typename?: 'UpdateOpptyRevenueScheduleNoIdBackrefInput';
  cancelationDate?: GqlDate | null;
  created?: DateTime | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface UpdateOpptyRecurrenceNoOpptyBackrefInput {
  __typename?: 'UpdateOpptyRecurrenceNoOpptyBackrefInput';
  applyRecurrence?: boolean | null;
  condition?: number | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  stepId?: ID | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface UpdateOpptyRecurrenceInput {
  __typename?: 'UpdateOpptyRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  condition?: number | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  id: ID;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  opptyId?: ID | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  stepId?: ID | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface UpdateOpptyProductRelationRevenueScheduleNoIdBackrefInput {
  __typename?: 'UpdateOpptyProductRelationRevenueScheduleNoIdBackrefInput';
  cancelationDate?: GqlDate | null;
  created?: DateTime | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface UpdateOpptyProductRelationInput {
  __typename?: 'UpdateOpptyProductRelationInput';
  amount?: number | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  id: ID;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  opptyId?: ID | null;
  opptyProductRelationTypeId?: ID | null;
  pairedOpptyProductRelation?: CreateOpptyProductRelationInput | null;
  pairedOpptyProductRelationId?: ID | null;
  price?: number | null;
  quantity?: number | null;
  quoteId?: ID | null;
  revenueSchedule?: UpdateOpptyProductRelationRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  sectionId?: ID | null;
  sortOrder?: number | null;
}

export interface UpdateOpptyProductRelationDataExRelationInput {
  __typename?: 'UpdateOpptyProductRelationDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  opptyProductRelation?: CreateOpptyProductRelationInput | null;
  opptyProductRelationId?: ID | null;
  revision?: number | null;
}

export interface UpdateOpportunityProfileInput {
  __typename?: 'UpdateOpportunityProfileInput';
  clientMutationId?: string | null;
  data?: OpportunityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateOpportunityInput {
  __typename?: 'UpdateOpportunityInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  activeQuoteId?: ID | null;
  clientMutationId?: string | null;
  closingDate?: GqlDate | null;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  isArchived?: boolean | null;
  isValueAutoCalculate?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyRecurrence?: UpdateOpptyRecurrenceNoOpptyBackrefInput | null;
  opptyTypeId?: ID | null;
  ownerId?: ID | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOrUpdateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteRelations?: CreateQuoteNoOpptyBackrefInput[] | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revenueSchedule?: UpdateOpptyRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId?: ID | null;
  tags?: CreateTagRelationNoOpptyBackrefInput[] | null;
  unitId?: ID | null;
  value?: CurrencyForeignFieldInput | null;
  wasQualified?: boolean | null;
  wonDate?: DateTime | null;
}

export interface UpdateOpportunityDraftProfileInput {
  __typename?: 'UpdateOpportunityDraftProfileInput';
  clientMutationId?: string | null;
  data?: OpportunityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateOnlineFormTypeInput {
  __typename?: 'UpdateOnlineFormTypeInput';
  autoPrefillWithJavascript?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customRecaptcha?: CustomRecaptcha | null;
  description?: string | null;
  entityApiName?: string | null;
  entityType?: BaseEntityTypeEnum | null;
  formEdit?: JSONString | null;
  id: ID;
  isEnabled?: boolean | null;
  isReadonly?: boolean | null;
  lastSchemaChange?: DateTime | null;
  lastStatusChange?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  notificationsStatus?: JSONString | null;
  ownerId?: ID | null;
  revision?: number | null;
  styleId?: ID | null;
}

export interface UpdateOnlineFormTypeEmailRelationInput {
  __typename?: 'UpdateOnlineFormTypeEmailRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormTypeId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateOnlineFormStyleInput {
  __typename?: 'UpdateOnlineFormStyleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: JSONString | null;
  useLang?: boolean | null;
}

export interface UpdateOnlineFormRelationInput {
  __typename?: 'UpdateOnlineFormRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  isPrimary?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateOnlineFormInput {
  __typename?: 'UpdateOnlineFormInput';
  accountRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  customFields?: JSONString | null;
  emailId?: ID | null;
  fieldIds?: JSONString | null;
  id: ID;
  leadRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  modified?: DateTime | null;
  onlineFormTypeId?: ID | null;
  opportunityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  projectRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  quoteRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateOnlineFormDataExRelationInput {
  __typename?: 'UpdateOnlineFormDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  revision?: number | null;
}

export interface UpdateOnlineFormActivityLogLineInput {
  __typename?: 'UpdateOnlineFormActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  id: ID;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateNoteInput {
  __typename?: 'UpdateNoteInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note?: string | null;
  ownerId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateNavigatorProfileInput {
  __typename?: 'UpdateNavigatorProfileInput';
  clientMutationId?: string | null;
  data?: NavigatorProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateNavigatorDraftProfileInput {
  __typename?: 'UpdateNavigatorDraftProfileInput';
  clientMutationId?: string | null;
  data?: NavigatorProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateMessageSharingSalesUnitRelationInput {
  __typename?: 'UpdateMessageSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  messageId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateMessageSharingClientRelationInput {
  __typename?: 'UpdateMessageSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  messageId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateMessageRelationInput {
  __typename?: 'UpdateMessageRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface UpdateMemoInput {
  __typename?: 'UpdateMemoInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  clientMutationId?: string | null;
  comments?: CreateMemoCommentNoMemoBackrefInput[] | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  ownerId?: ID | null;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject?: string | null;
}

export interface UpdateMemoCommentInput {
  __typename?: 'UpdateMemoCommentInput';
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id: ID;
  memoId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface UpdateMediaInput {
  __typename?: 'UpdateMediaInput';
  activityId?: ID | null;
  callId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  data?: JSONString | null;
  description?: string | null;
  errorCode?: number | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  status?: MediaStatusEnum | null;
  type?: MediaTypeEnum | null;
}

export interface UpdateMasterRightInput {
  __typename?: 'UpdateMasterRightInput';
  accessAccountRelationTypes?: boolean | null;
  accessAccounts?: boolean | null;
  accessAiAutomatizer?: boolean | null;
  accessAiOnlineForms?: boolean | null;
  accessAiRecordDetail?: boolean | null;
  accessAiReports?: boolean | null;
  accessAiSmartField?: boolean | null;
  accessAppointmentScheduler?: boolean | null;
  accessAppointmentSchedulerManagement?: boolean | null;
  accessApprovalProcesses?: boolean | null;
  accessApprovalProcessesManagement?: boolean | null;
  accessApprovals?: boolean | null;
  accessArchive?: boolean | null;
  accessAudit?: boolean | null;
  accessAuditLog?: boolean | null;
  accessBulkUpdate?: boolean | null;
  accessCalling?: boolean | null;
  accessCallingCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  accessCallingPurchasePhone?: boolean | null;
  accessCompanyEmails?: AccessLevelCompanyEmailsEnum | null;
  accessContacts?: boolean | null;
  accessDocumentManagement?: boolean | null;
  accessDocumentManagementCompany?: boolean | null;
  accessDocumentManagementRecord?: boolean | null;
  accessDuplicateChecker?: boolean | null;
  accessEntityAccount?: AccessLevelEntityEnum | null;
  accessEntityAccountCopy?: boolean | null;
  accessEntityAccountDelete?: boolean | null;
  accessEntityAccountDirection?: AccessDirectionEnum | null;
  accessEntityAccountPrivate?: boolean | null;
  accessEntityAccountTagCreate?: boolean | null;
  accessEntityAccountTypes?: AccessEntityTypesEnum | null;
  accessEntityAppointment?: AccessLevelEntityEnum | null;
  accessEntityAppointmentDelete?: boolean | null;
  accessEntityAppointmentDirection?: AccessDirectionEnum | null;
  accessEntityAppointmentTagCreate?: boolean | null;
  accessEntityBetterNavigator?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned?: boolean | null;
  accessEntityBetterNavigatorDeleteOwned?: boolean | null;
  accessEntityBetterNavigatorSharingCustom?: boolean | null;
  accessEntityBetterNavigatorSharingPublic?: boolean | null;
  accessEntityContact?: AccessLevelEntityEnum | null;
  accessEntityContactCopy?: boolean | null;
  accessEntityContactDelete?: boolean | null;
  accessEntityContactDirection?: AccessDirectionEnum | null;
  accessEntityContactPrivate?: boolean | null;
  accessEntityContactTagCreate?: boolean | null;
  accessEntityContactTypes?: AccessEntityTypesEnum | null;
  accessEntityDashboard?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityDashboardDeleteNotOwned?: boolean | null;
  accessEntityDashboardDeleteOwned?: boolean | null;
  accessEntityDashboardSharingCustom?: boolean | null;
  accessEntityDashboardSharingPublic?: boolean | null;
  accessEntityEmailContentShareMode?: ContentShareModeConfigEnum | null;
  accessEntityEmailDeleteNotOwned?: boolean | null;
  accessEntityEmailSequence?: AccessLevelEmailSequenceEnum | null;
  accessEntityEmailTemplate?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder?: boolean | null;
  accessEntityEmailTemplateDeleteNotOwned?: boolean | null;
  accessEntityEmailTemplateDeleteOwned?: boolean | null;
  accessEntityEmailTemplateSharingCustom?: boolean | null;
  accessEntityEmailTemplateSharingPublic?: boolean | null;
  accessEntityForecast?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityForecastDeleteNotOwned?: boolean | null;
  accessEntityForecastDeleteOwned?: boolean | null;
  accessEntityForecastEditNotOwned?: boolean | null;
  accessEntityForecastSharingCustom?: boolean | null;
  accessEntityForecastSharingPublic?: boolean | null;
  accessEntityFormView?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityFormViewDeleteNotOwned?: boolean | null;
  accessEntityFormViewDeleteOwned?: boolean | null;
  accessEntityFormViewSharingCustom?: boolean | null;
  accessEntityFormViewSharingPublic?: boolean | null;
  accessEntityLead?: AccessLevelEntityEnum | null;
  accessEntityLeadCopy?: boolean | null;
  accessEntityLeadDelete?: boolean | null;
  accessEntityLeadDirection?: AccessDirectionEnum | null;
  accessEntityLeadPrivate?: boolean | null;
  accessEntityLeadTagCreate?: boolean | null;
  accessEntityLeadTypes?: AccessEntityTypesEnum | null;
  accessEntityMessageTagCreate?: boolean | null;
  accessEntityOppty?: AccessLevelEntityEnum | null;
  accessEntityOpptyCopy?: boolean | null;
  accessEntityOpptyDelete?: boolean | null;
  accessEntityOpptyDirection?: AccessDirectionEnum | null;
  accessEntityOpptyPrivate?: boolean | null;
  accessEntityOpptyTagCreate?: boolean | null;
  accessEntityPipeline?: AccessLevelPipelineEnum | null;
  accessEntityProcess?: AccessLevelProcessBuilderEnum | null;
  accessEntityProfile?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityProfileDefaultScreenProfiles?: ScreensDefaultProfilesParamsParams | null;
  accessEntityProfileDeleteNotOwned?: boolean | null;
  accessEntityProfileDeleteOwned?: boolean | null;
  accessEntityProfileSharingCustom?: boolean | null;
  accessEntityProfileSharingPublic?: boolean | null;
  accessEntityProject?: AccessLevelEntityEnum | null;
  accessEntityProjectCopy?: boolean | null;
  accessEntityProjectDelete?: boolean | null;
  accessEntityProjectDirection?: AccessDirectionEnum | null;
  accessEntityProjectPrivate?: boolean | null;
  accessEntityProjectTagCreate?: boolean | null;
  accessEntityQuote?: AccessLevelEntityEnum | null;
  accessEntityQuoteCopy?: boolean | null;
  accessEntityQuoteDelete?: boolean | null;
  accessEntityQuoteDirection?: AccessDirectionEnum | null;
  accessEntityQuoteTypes?: AccessEntityTypesEnum | null;
  accessEntityReport?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityReportCreateDeleteFolder?: boolean | null;
  accessEntityReportDeleteNotOwned?: boolean | null;
  accessEntityReportDeleteOwned?: boolean | null;
  accessEntityReportPrivate?: boolean | null;
  accessEntityReportScheduleCreate?: boolean | null;
  accessEntityReportScheduleManagement?: boolean | null;
  accessEntityReportSharingCustom?: boolean | null;
  accessEntityReportSharingPublic?: boolean | null;
  accessEntityTarget?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityTargetDeleteNotOwned?: boolean | null;
  accessEntityTargetDeleteOwned?: boolean | null;
  accessEntityTask?: AccessLevelEntityEnum | null;
  accessEntityTaskDelete?: boolean | null;
  accessEntityTaskDirection?: AccessDirectionEnum | null;
  accessEntityTaskTagCreate?: boolean | null;
  accessEntityTaskUnassigned?: boolean | null;
  accessExport?: boolean | null;
  accessFeeds?: boolean | null;
  accessForeignCurrencies?: boolean | null;
  accessFormAndFields?: boolean | null;
  accessGlobalSettings?: boolean | null;
  accessHomeScreen?: boolean | null;
  accessImport?: boolean | null;
  accessInsights?: boolean | null;
  accessLeads?: boolean | null;
  accessOnlineForms?: boolean | null;
  accessOnlineFormsManagement?: boolean | null;
  accessOpportunity?: boolean | null;
  accessPipelineConfiguration?: boolean | null;
  accessPrint?: boolean | null;
  accessProductsServices?: boolean | null;
  accessProjects?: boolean | null;
  accessQuotes?: boolean | null;
  accessSalesRoles?: boolean | null;
  accessSecurity?: boolean | null;
  accessUnits?: boolean | null;
  accessUserAndRoles?: boolean | null;
  accessVoyagerAi?: boolean | null;
  accessWhatsAppCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  allowedAccountTypes?: CreateAllowedAccountTypeNoMasterRightBackrefInput[] | null;
  allowedCompanyEmails?: CreateAllowedCompanyEmailNoMasterRightBackrefInput[] | null;
  allowedCompanyPhones?: CreateAllowedCompanyPhoneNoMasterRightBackrefInput[] | null;
  allowedContactTypes?: CreateAllowedContactTypeNoMasterRightBackrefInput[] | null;
  allowedLeadTypes?: CreateAllowedLeadTypeNoMasterRightBackrefInput[] | null;
  allowedPipelines?: CreateAllowedPipelineNoMasterRightBackrefInput[] | null;
  allowedQuoteTypes?: CreateAllowedQuoteTypeNoMasterRightBackrefInput[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntities?: CustomEntityMasterRightParams[] | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateLinkedItemsEmailInput {
  __typename?: 'UpdateLinkedItemsEmailInput';
  clientMutationId?: string | null;
  emailId: UUID;
  linkedItems: SendEmailLinkedEntityParams[];
}

export interface UpdateLifeCycleProfileInput {
  __typename?: 'UpdateLifeCycleProfileInput';
  clientMutationId?: string | null;
  data?: LifeCycleProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateLifeCycleDraftProfileInput {
  __typename?: 'UpdateLifeCycleDraftProfileInput';
  clientMutationId?: string | null;
  data?: LifeCycleProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateLeadProfileInput {
  __typename?: 'UpdateLeadProfileInput';
  clientMutationId?: string | null;
  data?: LeadProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateLeadProcessInput {
  __typename?: 'UpdateLeadProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoLeadProcessBackrefInput[] | null;
}

export interface UpdateLeadOpptyStepCheckListRelationInput {
  __typename?: 'UpdateLeadOpptyStepCheckListRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id: ID;
  itemChecked?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note?: CreateNoteInput | null;
  noteId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  stepChecklistId?: ID | null;
}

export interface UpdateLeadOpptySharingSalesUnitRelationInput {
  __typename?: 'UpdateLeadOpptySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateLeadOpptySharingClientRelationInput {
  __typename?: 'UpdateLeadOpptySharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateLeadOpptyKPIInput {
  __typename?: 'UpdateLeadOpptyKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  kpi?: LeadOpptyKpiEnum | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'UpdateLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyContactRelation?: CreateLeadOpptyContactRelationInput | null;
  leadOpptyContactRelationId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
}

export interface UpdateLeadOpptyContactRelationInput {
  __typename?: 'UpdateLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  isPrimary?: boolean | null;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
  salesRoles?: CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput[] | null;
}

export interface UpdateLeadOpptyContactGroupRelationInput {
  __typename?: 'UpdateLeadOpptyContactGroupRelationInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  groupPosition?: JSONString | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateLeadOpptyAccountRelationInput {
  __typename?: 'UpdateLeadOpptyAccountRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isPrimary?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateLeadInput {
  __typename?: 'UpdateLeadInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  isArchived?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  leadTypeId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId?: ID | null;
  tags?: CreateTagRelationNoLeadBackrefInput[] | null;
  unitId?: ID | null;
}

export interface UpdateLeadDraftProfileInput {
  __typename?: 'UpdateLeadDraftProfileInput';
  clientMutationId?: string | null;
  data?: LeadProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateLeadArchiveProfileInput {
  __typename?: 'UpdateLeadArchiveProfileInput';
  clientMutationId?: string | null;
  data?: LeadArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateLeadArchiveDraftProfileInput {
  __typename?: 'UpdateLeadArchiveDraftProfileInput';
  clientMutationId?: string | null;
  data?: LeadArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateInsightsProfileInput {
  __typename?: 'UpdateInsightsProfileInput';
  clientMutationId?: string | null;
  data?: InsightsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateInsightsDraftProfileInput {
  __typename?: 'UpdateInsightsDraftProfileInput';
  clientMutationId?: string | null;
  data?: InsightsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateIndicatorsProfileInput {
  __typename?: 'UpdateIndicatorsProfileInput';
  clientMutationId?: string | null;
  data?: IndicatorsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateIndicatorsDraftProfileInput {
  __typename?: 'UpdateIndicatorsDraftProfileInput';
  clientMutationId?: string | null;
  data?: IndicatorsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateImportMappingMaskInput {
  __typename?: 'UpdateImportMappingMaskInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  entityType?: ImportMaskEntityTypeEnum | null;
  id: ID;
  mapping?: JSONString | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  relationTypes?: JSONString | null;
  revision?: number | null;
  shareMode?: ProfileShareMode | null;
  sharingClients?: UUID[] | null;
  sharingUnits?: UUID[] | null;
}

export interface UpdateGhostLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'UpdateGhostLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostLeadOpptyContactRelation?: CreateGhostLeadOpptyContactRelationInput | null;
  ghostLeadOpptyContactRelationId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
}

export interface UpdateGhostLeadOpptyContactRelationInput {
  __typename?: 'UpdateGhostLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact?: CreateGhostContactInput | null;
  ghostContactId?: ID | null;
  id: ID;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  revision?: number | null;
  salesRoles?: CreateGhostLeadOpptyContactSalesRoleRelationNoGhostLeadOpptyContactRelationBackrefInput[] | null;
}

export interface UpdateGhostContactInput {
  __typename?: 'UpdateGhostContactInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  position?: string | null;
  revision?: number | null;
}

export interface UpdateGhostContactAccountRelationInput {
  __typename?: 'UpdateGhostContactAccountRelationInput';
  accountId?: ID | null;
  accountRoles?: CreateGhostContactAccountAccountRoleRelationNoGhostContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact?: CreateGhostContactInput | null;
  ghostContactId?: ID | null;
  id: ID;
  isAssistant?: boolean | null;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  revision?: number | null;
}

export interface UpdateGhostContactAccountAccountRoleRelationInput {
  __typename?: 'UpdateGhostContactAccountAccountRoleRelationInput';
  accountRoleId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostContactAccountRelation?: CreateGhostContactAccountRelationInput | null;
  ghostContactAccountRelationId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateFormViewSharingSalesUnitRelationInput {
  __typename?: 'UpdateFormViewSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateFormViewSharingClientRelationInput {
  __typename?: 'UpdateFormViewSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateFormViewInput {
  __typename?: 'UpdateFormViewInput';
  accountTypeId?: ID | null;
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  hiddenItemIds?: UUID[] | null;
  id: ID;
  itemColors?: FormViewItemColorInput[] | null;
  leadTypeId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyTypeId?: ID | null;
  ownerId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateFormViewSharingClientRelationNoFormViewBackrefInput[] | null;
  sharingUnits?: CreateFormViewSharingSalesUnitRelationNoFormViewBackrefInput[] | null;
  useLang?: boolean | null;
}

export interface UpdateForecastInput {
  __typename?: 'UpdateForecastInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  settings?: JSONString | null;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharedClients?: UUID[] | null;
  sharedUnits?: UUID[] | null;
}

export interface UpdateFieldMappingInput {
  __typename?: 'UpdateFieldMappingInput';
  id: UUID;
  mapping?: FieldMappingTemplateParams | null;
  typeMappings?: EntityTypeFieldMappingParams[] | null;
}

export interface UpdateFeedProfileInput {
  __typename?: 'UpdateFeedProfileInput';
  clientMutationId?: string | null;
  data?: FeedProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateFeedEmailProfileInput {
  __typename?: 'UpdateFeedEmailProfileInput';
  clientMutationId?: string | null;
  data?: FeedEmailProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateFeedEmailDraftProfileInput {
  __typename?: 'UpdateFeedEmailDraftProfileInput';
  clientMutationId?: string | null;
  data?: FeedEmailProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateFeedEmailDetailProfileInput {
  __typename?: 'UpdateFeedEmailDetailProfileInput';
  clientMutationId?: string | null;
  data?: FeedEmailDetailProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateFeedDraftProfileInput {
  __typename?: 'UpdateFeedDraftProfileInput';
  clientMutationId?: string | null;
  data?: FeedProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateFeedDetailProfileInput {
  __typename?: 'UpdateFeedDetailProfileInput';
  clientMutationId?: string | null;
  data?: FeedDetailProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateEntityScoringInput {
  __typename?: 'UpdateEntityScoringInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityScoringSettingsJSONString | null;
  sortOrder?: number | null;
  useLang?: boolean | null;
}

export interface UpdateEntityHealthInput {
  __typename?: 'UpdateEntityHealthInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isEnabled?: boolean | null;
  lastRecalculation?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  settings?: EntityHealthSettingsJSONString | null;
  typeId?: ID | null;
}

export interface UpdateEntityFitnessInput {
  __typename?: 'UpdateEntityFitnessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  indicatorRelations?: CreateOrUpdateEntityFitnessIndicatorNoEntityFitnessBackrefInput[] | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateEntityFitnessIndicatorInput {
  __typename?: 'UpdateEntityFitnessIndicatorInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  descriptionUseLang?: boolean | null;
  entityFitnessId?: ID | null;
  howToFix?: string | null;
  howToFixUseLang?: boolean | null;
  id: ID;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  nameUseLang?: boolean | null;
  revision?: number | null;
  settings?: FitnessIndicatorSettingsJSONString | null;
  type?: FitnessIndicatorTypeEnum | null;
}

export interface UpdateEntityCustomNameSettingInput {
  __typename?: 'UpdateEntityCustomNameSettingInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  plural?: string | null;
  singular?: string | null;
}

export interface UpdateEmailThreadContentShareModeEmailInput {
  __typename?: 'UpdateEmailThreadContentShareModeEmailInput';
  clientMutationId?: string | null;
  contentShareClients: UUID[];
  contentShareMode: ContentShareModeEnum;
  contentShareUnits: UUID[];
  threadId: string;
}

export interface UpdateEmailTemplateSharingSalesUnitRelationInput {
  __typename?: 'UpdateEmailTemplateSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateEmailTemplateSharingClientRelationInput {
  __typename?: 'UpdateEmailTemplateSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateEmailTemplateInput {
  __typename?: 'UpdateEmailTemplateInput';
  body?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  emailTemplateFolderId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  recentColors?: number[] | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateEmailTemplateSharingClientRelationNoEmailTemplateBackrefInput[] | null;
  sharingUnits?: CreateEmailTemplateSharingSalesUnitRelationNoEmailTemplateBackrefInput[] | null;
  sharingUrlIsEnabled?: boolean | null;
  sharingUrlSettings?: JSONString | null;
  subject?: string | null;
  type?: EmailTemplateTypeEnum | null;
}

export interface UpdateEmailTemplateFolderInput {
  __typename?: 'UpdateEmailTemplateFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  parentEmailTemplateFolderId?: ID | null;
  revision?: number | null;
}

export interface UpdateEmailSequenceInput {
  __typename?: 'UpdateEmailSequenceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: EmailSequenceSchemaJSONString | null;
  type?: ProcessTypeEnum | null;
}

export interface UpdateEmailSequenceEnrolledInput {
  __typename?: 'UpdateEmailSequenceEnrolledInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailSequenceActivityLogId?: ID | null;
  emailSequenceId?: ID | null;
  endReason?: EmailSequenceEndReasonEnum | null;
  endTime?: DateTime | null;
  excludedFromStats?: boolean | null;
  id: ID;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  projectId?: ID | null;
  startTime?: DateTime | null;
}

export interface UpdateEmailSequenceActivityLogLineInput {
  __typename?: 'UpdateEmailSequenceActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceActivityLogId?: ID | null;
  id: ID;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateEmailSequenceActivityLogInput {
  __typename?: 'UpdateEmailSequenceActivityLogInput';
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceId?: ID | null;
  endTime?: DateTime | null;
  id: ID;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  startTime?: DateTime | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateEmailNotificationsSettingOnExistingUsersInput {
  __typename?: 'UpdateEmailNotificationsSettingOnExistingUsersInput';
  clientMutationId?: string | null;
  enabled: boolean;
}

export interface UpdateEmailInput {
  __typename?: 'UpdateEmailInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  additionalHeaders?: JSONString | null;
  body?: string | null;
  bodySummary?: string | null;
  cc?: string | null;
  clientMutationId?: string | null;
  companyEmailId?: ID | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: CreateEmailContentSharingClientRelationNoEmailBackrefInput[] | null;
  contentSharingUnits?: CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput[] | null;
  contentType?: string | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  dateSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  errorCode?: number | null;
  id: ID;
  isTracked?: boolean | null;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  originalId?: string | null;
  ownerId?: ID | null;
  parentEmailId?: ID | null;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  scheduleSettings?: JSONString | null;
  sendAt?: DateTime | null;
  sender?: string | null;
  senderAccountId?: ID | null;
  senderClientId?: ID | null;
  senderContactId?: ID | null;
  sentiment?: EmailSentimentEnum | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject?: string | null;
  tags?: CreateTagRelationNoEmailBackrefInput[] | null;
  templateId?: ID | null;
  threadId?: ID | null;
  to?: string | null;
  type?: EmailTypeEnum | null;
  uid?: string | null;
}

export interface UpdateEmailEventInput {
  __typename?: 'UpdateEmailEventInput';
  additionalData?: JSONString | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  type?: EmailEventTypeEnum | null;
  url?: string | null;
}

export interface UpdateEmailContentSharingSalesUnitRelationInput {
  __typename?: 'UpdateEmailContentSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateEmailContentSharingClientRelationInput {
  __typename?: 'UpdateEmailContentSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateDraftWebresourceInput {
  __typename?: 'UpdateDraftWebresourceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  displayParam?: number | null;
  entity?: string | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  requestMethod?: RequestMethodEnum | null;
  revision?: number | null;
  url?: string | null;
}

export interface UpdateDraftTranslationInput {
  __typename?: 'UpdateDraftTranslationInput';
  accountTypeId?: ID | null;
  appointmentTypeId?: ID | null;
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  dataId?: ID | null;
  deDe?: string | null;
  enUs?: string | null;
  esEs?: string | null;
  fieldId?: ID | null;
  formType?: FormTypeEnum | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  labelType?: TranslationLabelTypeEnum | null;
  leadTypeId?: ID | null;
  modified?: DateTime | null;
  opptyProductRelationTypeId?: ID | null;
  opptyTypeId?: ID | null;
  productTypeId?: ID | null;
  projectTypeId?: ID | null;
  ptBr?: string | null;
  revision?: number | null;
  taskTypeId?: ID | null;
}

export interface UpdateDraftTaskTypeInput {
  __typename?: 'UpdateDraftTaskTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ActivityTypeIconEnum | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateDraftQuoteTypeInput {
  __typename?: 'UpdateDraftQuoteTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formLostEnabled?: boolean | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftProjectTypeInput {
  __typename?: 'UpdateDraftProjectTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ProjectTypeIconEnum | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftProductTypeInput {
  __typename?: 'UpdateDraftProductTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateDraftOpptyProductRelationTypeInput {
  __typename?: 'UpdateDraftOpptyProductRelationTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateDraftOpportunityTypeInput {
  __typename?: 'UpdateDraftOpportunityTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  pipelineId?: ID | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftLeadTypeInput {
  __typename?: 'UpdateDraftLeadTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formLostEnabled?: boolean | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftInterfacePreviewInput {
  __typename?: 'UpdateDraftInterfacePreviewInput';
  cardFieldIds?: UUID[] | null;
  charts?: InterfacePreviewChartInput[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  detailTabs?: InterfaceDetailTabParams[] | null;
  detailWidgets?: InterfaceDetailWidgetParams[] | null;
  fieldIds?: UUID[] | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  settings?: InterfacePreviewCustomSettingsJSONString | null;
}

export interface UpdateDraftFieldSequenceInput {
  __typename?: 'UpdateDraftFieldSequenceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  filter?: JSONString | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  pattern?: string | null;
  sequenceSetId?: ID | null;
  sortOrder?: number | null;
}

export interface UpdateDraftFieldPermissionInput {
  __typename?: 'UpdateDraftFieldPermissionInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  permissionLevel?: AccessLevelFieldEnum | null;
  revision?: number | null;
}

export interface UpdateDraftFieldOptions {
  __typename?: 'UpdateDraftFieldOptions';
  lookupPrimaryRelationResolution?: LookupPrimaryRelationResolutionEnum | null;
}

export interface UpdateDraftFieldInput {
  __typename?: 'UpdateDraftFieldInput';
  advancedFormula?: AdvancedFormulaPropertyParams | null;
  aiOptions?: FieldAiOptionsParams | null;
  calcFormula?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataSet?: FieldDataSetItem[] | null;
  defaultValue?: string | null;
  fieldPermissions?: FieldPermissionNoFieldBackrefInput[] | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  lookup?: LookupPropertyParams | null;
  modified?: DateTime | null;
  name?: string | null;
  nameTranslations?: JSONString | null;
  options?: FieldOptionsPropertyJSONString | null;
  parentOptionsFieldId?: ID | null;
  rollup?: RollupPropertyParams | null;
  sequence?: SequencePropertyParams | null;
  useInGlobalSearch?: boolean | null;
  useLang?: number | null;
}

export interface UpdateDraftEntitySettingsInput {
  __typename?: 'UpdateDraftEntitySettingsInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  defaultListColumns?: EntitySettingsDefaultListColumnsJSONString | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateDraftDataInput {
  __typename?: 'UpdateDraftDataInput';
  allowedBy?: JSONString | null;
  calcValue?: number | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  optionName?: string | null;
  optionNameTranslations?: JSONString | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface UpdateDraftCustomEntityTypeInput {
  __typename?: 'UpdateDraftCustomEntityTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftCustomEntityRelationInput {
  __typename?: 'UpdateDraftCustomEntityRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityFilter1?: JSONString | null;
  entityFilter2?: JSONString | null;
  field1Id?: ID | null;
  field2Id?: ID | null;
  hasIsPrimary?: boolean | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  showRelated1?: boolean | null;
  showRelated2?: boolean | null;
  showTab1?: boolean | null;
  showTab2?: boolean | null;
  tabName1?: string | null;
  tabName2?: string | null;
}

export interface UpdateDraftContactTypeInput {
  __typename?: 'UpdateDraftContactTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDraftAppointmentTypeInput {
  __typename?: 'UpdateDraftAppointmentTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ActivityTypeIconEnum | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface UpdateDraftAccountTypeInput {
  __typename?: 'UpdateDraftAccountTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityTypeSettingsJSONString | null;
}

export interface UpdateDataInput {
  __typename?: 'UpdateDataInput';
  allowedBy?: JSONString | null;
  calcValue?: number | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  optionName?: string | null;
  optionNameTranslations?: JSONString | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface UpdateCustomEntityUiSettingsInput {
  __typename?: 'UpdateCustomEntityUiSettingsInput';
  clientMutationId?: string | null;
  entityApiName: string;
  values: CustomEntityUISettingsInput;
}

export interface UpdateCustomEntityTypeDraftInput {
  __typename?: 'UpdateCustomEntityTypeDraftInput';
  entityApiName: string;
  formEdit?: string | null;
  id: ID;
  isDeleted?: boolean | null;
  isReadonly?: boolean | null;
  name?: string | null;
  settings?: EntityTypeSettingsParams | null;
}

export interface UpdateCustomEntitySharingSalesUnitRelationInput {
  __typename?: 'UpdateCustomEntitySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateCustomEntitySharingClientRelationInput {
  __typename?: 'UpdateCustomEntitySharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateCustomEntityRelationDataInput {
  __typename?: 'UpdateCustomEntityRelationDataInput';
  account1Id?: ID | null;
  account2Id?: ID | null;
  activity1Id?: ID | null;
  activity2Id?: ID | null;
  client1Id?: ID | null;
  client2Id?: ID | null;
  clientMutationId?: string | null;
  contact1Id?: ID | null;
  contact2Id?: ID | null;
  created?: DateTime | null;
  customEntity1Id?: ID | null;
  customEntity2Id?: ID | null;
  customEntityRelationId?: ID | null;
  id: ID;
  isPrimary?: boolean | null;
  leadOppty1Id?: ID | null;
  leadOppty2Id?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation1?: CreateOpptyProductRelationInput | null;
  opptyProductRelation1Id?: ID | null;
  opptyProductRelation2?: CreateOpptyProductRelationInput | null;
  opptyProductRelation2Id?: ID | null;
  product1Id?: ID | null;
  product2Id?: ID | null;
  project1Id?: ID | null;
  project2Id?: ID | null;
  quote1Id?: ID | null;
  quote2Id?: ID | null;
  revision?: number | null;
}

export interface UpdateCustomEntityProfileInput {
  __typename?: 'UpdateCustomEntityProfileInput';
  clientMutationId?: string | null;
  data?: CustomEntityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateCustomEntityMetaMutationInput {
  __typename?: 'UpdateCustomEntityMetaMutationInput';
  clientMutationId?: string | null;
  entityApiName: string;
  functionalities?: CustomEntityFunctionalityEnum[] | null;
  icon?: EntityIconEnum | null;
  namePlural?: string | null;
  nameSingular?: string | null;
}

export interface UpdateCustomEntityInput {
  __typename?: 'UpdateCustomEntityInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput[] | null;
  sharingUnits?: CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoCustomEntityBackrefInput[] | null;
  typeId?: ID | null;
  unitId?: ID | null;
}

export interface UpdateCustomEntityDraftProfileInput {
  __typename?: 'UpdateCustomEntityDraftProfileInput';
  clientMutationId?: string | null;
  data?: CustomEntityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateCustomEntityDataExRelationInput {
  __typename?: 'UpdateCustomEntityDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateCurrencyInput {
  __typename?: 'UpdateCurrencyInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRates?: CreateCurrencyExchangeRateNoCurrencyBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateCurrencyExchangeRatesListInput {
  __typename?: 'UpdateCurrencyExchangeRatesListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRates?: CreateCurrencyExchangeRateNoCurrencyExchangeRateListBackrefInput[] | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  validFrom?: DateTime | null;
}

export interface UpdateCurrencyExchangeRateInput {
  __typename?: 'UpdateCurrencyExchangeRateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRateListId?: ID | null;
  currencyId?: ID | null;
  exchangeRate?: number | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateConversionsProfileInput {
  __typename?: 'UpdateConversionsProfileInput';
  clientMutationId?: string | null;
  data?: ConversionsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateConversionsDraftProfileInput {
  __typename?: 'UpdateConversionsDraftProfileInput';
  clientMutationId?: string | null;
  data?: ConversionsProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateContactSocialRelationNoIdBackrefInput {
  __typename?: 'UpdateContactSocialRelationNoIdBackrefInput';
  angellistUrl?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface UpdateContactSocialRelationInput {
  __typename?: 'UpdateContactSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id: ID;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface UpdateContactSharingSalesUnitRelationInput {
  __typename?: 'UpdateContactSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateContactSharingClientRelationInput {
  __typename?: 'UpdateContactSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateContactRelationTypeInput {
  __typename?: 'UpdateContactRelationTypeInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateContactRelationLabelInput {
  __typename?: 'UpdateContactRelationLabelInput';
  clientMutationId?: string | null;
  contactRelation?: CreateContactRelationInput | null;
  contactRelationId?: ID | null;
  contactRelationTypeId?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateContactRelationInput {
  __typename?: 'UpdateContactRelationInput';
  clientMutationId?: string | null;
  contact1Id?: ID | null;
  contact2Id?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateContactProfileInput {
  __typename?: 'UpdateContactProfileInput';
  clientMutationId?: string | null;
  data?: ContactProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateContactKPIInput {
  __typename?: 'UpdateContactKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  kpi?: ContactKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateContactInput {
  __typename?: 'UpdateContactInput';
  accountPosition?: string | null;
  accountRelations?: CreateContactAccountRelationNoContactBackrefInput[] | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  contactTypeId?: ID | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  exchangeEntityId?: string | null;
  firstName?: string | null;
  gapiEntityId?: string | null;
  gender?: GenderEnum | null;
  id: ID;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  lastName?: string | null;
  middleName?: string | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  ownerId?: ID | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  position?: string | null;
  primaryAccountAccountRoles?: UUID[] | null;
  primaryAccountRelationship?: string | null;
  quickAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateContactSharingClientRelationNoContactBackrefInput[] | null;
  sharingUnits?: CreateContactSharingSalesUnitRelationNoContactBackrefInput[] | null;
  socialMedia?: UpdateContactSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoContactBackrefInput[] | null;
  tags?: CreateTagRelationNoContactBackrefInput[] | null;
  title?: string | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface UpdateContactDraftProfileInput {
  __typename?: 'UpdateContactDraftProfileInput';
  clientMutationId?: string | null;
  data?: ContactProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateContactArchiveProfileInput {
  __typename?: 'UpdateContactArchiveProfileInput';
  clientMutationId?: string | null;
  data?: ContactArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateContactArchiveDraftProfileInput {
  __typename?: 'UpdateContactArchiveDraftProfileInput';
  clientMutationId?: string | null;
  data?: ContactArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateContactAccountRelationInput {
  __typename?: 'UpdateContactAccountRelationInput';
  accountId?: ID | null;
  accountRoles?: CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  isAssistant?: boolean | null;
  isPrimary?: boolean | null;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
}

export interface UpdateContactAccountAccountRoleRelationInput {
  __typename?: 'UpdateContactAccountAccountRoleRelationInput';
  accountRoleId?: ID | null;
  clientMutationId?: string | null;
  contactAccountRelation?: CreateContactAccountRelationInput | null;
  contactAccountRelationId?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateCompanyEntityEmailInput {
  __typename?: 'UpdateCompanyEntityEmailInput';
  apiKey?: string | null;
  authCode?: string | null;
  email?: string | null;
  enabled?: boolean | null;
  id: UUID;
  redirectUri?: string | null;
  syncEmailReplies?: boolean | null;
}

export interface UpdateCloudObjectTemplateInput {
  __typename?: 'UpdateCloudObjectTemplateInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  content?: Base64 | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename?: string | null;
  id: ID;
  isPublic?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: CloudObjectTemplateStatusEnum | null;
  templateEntityApiName?: string | null;
  templateEntityName?: EntityNameEnum | null;
  uploadSource?: UploadSourceEnum | null;
}

export interface UpdateCloudObjectStepRelationInput {
  __typename?: 'UpdateCloudObjectStepRelationInput';
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepId?: ID | null;
}

export interface UpdateCloudObjectRelationInput {
  __typename?: 'UpdateCloudObjectRelationInput';
  accountId?: ID | null;
  activityId?: ID | null;
  approvalProcessId?: ID | null;
  callId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectFolderId?: ID | null;
  cloudObjectId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailSequenceId?: ID | null;
  emailTemplateId?: ID | null;
  fieldMappingId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  mediaId?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  processId?: ID | null;
  processTemplateId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportSchedule?: CreateReportScheduleInput | null;
  reportScheduleId?: ID | null;
  revision?: number | null;
  textMessage?: CreateTextMessageInput | null;
  textMessageId?: ID | null;
}

export interface UpdateCloudObjectInput {
  __typename?: 'UpdateCloudObjectInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename?: string | null;
  id: ID;
  isPublic?: boolean | null;
  modified?: DateTime | null;
  params?: JSONString | null;
  revision?: number | null;
  uploadSource?: UploadSourceEnum | null;
  url?: string | null;
}

export interface UpdateCloudObjectFolderInput {
  __typename?: 'UpdateCloudObjectFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  onlineFormTypeId?: ID | null;
  parentCloudObjectFolderId?: ID | null;
  revision?: number | null;
}

export interface UpdateClientStoryReadInput {
  __typename?: 'UpdateClientStoryReadInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  messageId?: ID | null;
  modified?: DateTime | null;
  noFollow?: boolean | null;
  ownerId?: ID | null;
  readAt?: DateTime | null;
  revision?: number | null;
}

export interface UpdateClientSettingInput {
  __typename?: 'UpdateClientSettingInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  value?: JSONString | null;
}

export interface UpdateClientInput {
  __typename?: 'UpdateClientInput';
  accountFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  appointmentFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  clientMutationId?: string | null;
  contactFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  created?: DateTime | null;
  defaultUnitId?: ID | null;
  id: ID;
  leadFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  opportunityFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  position?: string | null;
  profileFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  reportFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  revision?: number | null;
  taskFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  type?: ClientTypeEnum | null;
  unitMembership?: CreateSalesUnitClientRelationNoClientBackrefInput[] | null;
}

export interface UpdateClientFavoriteInput {
  __typename?: 'UpdateClientFavoriteInput';
  accountId?: ID | null;
  activityId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
}

export interface UpdateClientExcludedOpptyInput {
  __typename?: 'UpdateClientExcludedOpptyInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isExcluded?: boolean | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface UpdateChatConversationInput {
  __typename?: 'UpdateChatConversationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  messages?: CreateOrUpdateTextMessageNoChatConversationBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  type?: ChatConversationTypeEnum | null;
}

export interface UpdateCallInput {
  __typename?: 'UpdateCallInput';
  accountId?: ID | null;
  audioStatus?: AudioStatus | null;
  callerId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation?: CreateOpptyProductRelationInput | null;
  opptyProductRelationId?: ID | null;
  phoneNumber?: string | null;
  productId?: ID | null;
  transcriptionId?: string | null;
  transcriptionLanguage?: string | null;
  transcriptionSummary?: string | null;
  twilioCallLogId?: ID | null;
}

export interface UpdateBetterNavigatorProfileInput {
  __typename?: 'UpdateBetterNavigatorProfileInput';
  clientMutationId?: string | null;
  data?: BetterNavigatorProfileDataInput | null;
  id: ID;
  name?: string | null;
  syncEnabled?: boolean | null;
}

export interface UpdateBetterNavigatorDraftProfileInput {
  __typename?: 'UpdateBetterNavigatorDraftProfileInput';
  clientMutationId?: string | null;
  data?: BetterNavigatorProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateAutomationHubItemInput {
  __typename?: 'UpdateAutomationHubItemInput';
  automationHubAppId?: number | null;
  automationHubCategoryId?: number | null;
  clientMutationId?: string | null;
  configurationUrl?: string | null;
  deprecatedByItemId?: number | null;
  description?: string | null;
  hasLastRun?: boolean | null;
  hasLogs?: boolean | null;
  id: ID;
  integrationAnalyticsEnabled?: boolean | null;
  isBeta?: boolean | null;
  isBundle?: boolean | null;
  isVisible?: boolean | null;
  logoUrl?: string | null;
  minApiVersion?: number | null;
  name?: string | null;
  parentId?: ID | null;
  ranking?: number | null;
  websiteUrl?: string | null;
}

export interface UpdateArchiveProfileInput {
  __typename?: 'UpdateArchiveProfileInput';
  clientMutationId?: string | null;
  data?: ArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateArchiveDraftProfileInput {
  __typename?: 'UpdateArchiveDraftProfileInput';
  clientMutationId?: string | null;
  data?: ArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateApprovalProcessInput {
  __typename?: 'UpdateApprovalProcessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id: ID;
  isEnabled?: boolean | null;
  lastSchemaChange?: DateTime | null;
  lastStatusChange?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: JSONString | null;
}

export interface UpdateApprovalProcessActivityLogLineInput {
  __typename?: 'UpdateApprovalProcessActivityLogLineInput';
  approvalId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  data?: JSONString | null;
  executedAt?: DateTime | null;
  id: ID;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateApprovalInput {
  __typename?: 'UpdateApprovalInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId?: ID | null;
  approvalProcessId?: ID | null;
  approvalStatus?: ApprovalStatusEnum | null;
  approvers?: CreateApprovalApproverNoApprovalBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface UpdateApprovalApproverInput {
  __typename?: 'UpdateApprovalApproverInput';
  approvalId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  status?: ApprovalStatusEnum | null;
}

export interface UpdateAppointmentScheduleInput {
  __typename?: 'UpdateAppointmentScheduleInput';
  additionalFieldsData?: AppointmentScheduleAdditionalFieldParams[] | null;
  appointmentDescription?: string | null;
  appointmentDuration?: number | null;
  appointmentInviteesData?: AppointmentScheduleInviteeParams[] | null;
  appointmentLocation?: string | null;
  appointmentLocationType?: AppointmentScheduleLocationTypeEnum | null;
  appointmentOwnerId?: ID | null;
  appointmentSubject?: string | null;
  appointmentSubjectUsesScheduleName?: boolean | null;
  appointmentTypeId?: ID | null;
  availabilityData?: AppointmentScheduleAvailabilityParams | null;
  availabilityTzid?: string | null;
  bufferTimeAfter?: number | null;
  bufferTimeBefore?: number | null;
  clientMutationId?: string | null;
  confirmationPageType?: AppointmentScheduleConfirmationPageTypeEnum | null;
  confirmationPageUrl?: string | null;
  created?: DateTime | null;
  id: ID;
  isEnabled?: boolean | null;
  minimumNoticeTime?: number | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  planningDayOffset?: number | null;
  planningPeriodFrom?: GqlDate | null;
  planningPeriodTo?: GqlDate | null;
  planningType?: AppointmentSchedulePlanningTypeEnum | null;
  reminderEmailEnabled?: boolean | null;
  reminderEmailOffset?: number | null;
  reminderEmailOffsetType?: AppointmentScheduleReminderOffsetTypeEnum | null;
  replyCompanyEmailId?: ID | null;
  scheduleName?: string | null;
  timeIncrement?: number | null;
  type?: AppointmentScheduleTypeEnum | null;
  url?: string | null;
}

export interface UpdateAppointmentReminderNoAppointmentBackrefInput {
  __typename?: 'UpdateAppointmentReminderNoAppointmentBackrefInput';
  created?: DateTime | null;
  endDateOffset?: number | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface UpdateAppointmentReminderInput {
  __typename?: 'UpdateAppointmentReminderInput';
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  endDateOffset?: number | null;
  id: ID;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface UpdateAppointmentInviteeResponseInput {
  __typename?: 'UpdateAppointmentInviteeResponseInput';
  clientMutationId?: string | null;
  emailFrom: string;
  message: string;
}

export interface UpdateAppointmentInput {
  __typename?: 'UpdateAppointmentInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  duration?: number | null;
  endDate?: DateTime | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  id: ID;
  inviteesCanEdit?: boolean | null;
  inviteesClients?: CreateAppointmentClientInviteesRelationNoAppointmentBackrefInput[] | null;
  inviteesContacts?: CreateAppointmentContactInviteesRelationNoAppointmentBackrefInput[] | null;
  isRecurrenceActive?: boolean | null;
  isRecurrenceException?: boolean | null;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  location?: string | null;
  mediaTranscriptionId?: UUID | null;
  meetingUrl?: AppointmentMeetingInput | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  occurenceDate?: DateTime | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  organizer?: string | null;
  ownerId?: ID | null;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  recurrenceMasterId?: ID | null;
  recurrenceRule?: string | null;
  recurrenceTzid?: string | null;
  revision?: number | null;
  scheduleId?: ID | null;
  scheduleTzid?: string | null;
  startDate?: DateTime | null;
  subject?: string | null;
  tags?: CreateTagRelationNoAppointmentBackrefInput[] | null;
  unitId?: ID | null;
}

export interface UpdateAppointmentContactInviteesRelationInput {
  __typename?: 'UpdateAppointmentContactInviteesRelationInput';
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  email?: string | null;
  firstName?: string | null;
  id: ID;
  inviteeType?: AppointmentInviteeTypeEnum | null;
  lastName?: string | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface UpdateAppointmentClientInviteesRelationInput {
  __typename?: 'UpdateAppointmentClientInviteesRelationInput';
  appointmentId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface UpdateApiAccessInput {
  __typename?: 'UpdateApiAccessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  email?: string | null;
  id: ID;
  isActive?: boolean | null;
  lastUsed?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  permissions?: ApiAccessPermissionsInput | null;
}

export interface UpdateAllowedQuoteTypeInput {
  __typename?: 'UpdateAllowedQuoteTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  quoteTypeId?: ID | null;
  revision?: number | null;
}

export interface UpdateAllowedPipelineInput {
  __typename?: 'UpdateAllowedPipelineInput';
  accessStepDocuments?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  pipelineId?: ID | null;
  revision?: number | null;
}

export interface UpdateAllowedLeadTypeInput {
  __typename?: 'UpdateAllowedLeadTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  leadTypeId?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAllowedContactTypeInput {
  __typename?: 'UpdateAllowedContactTypeInput';
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAllowedCompanyPhoneInput {
  __typename?: 'UpdateAllowedCompanyPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  phoneId?: ID | null;
  revision?: number | null;
}

export interface UpdateAllowedCompanyEmailInput {
  __typename?: 'UpdateAllowedCompanyEmailInput';
  clientMutationId?: string | null;
  companyEmailId?: ID | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAllowedAccountTypeInput {
  __typename?: 'UpdateAllowedAccountTypeInput';
  accountTypeId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateActivityRelationInput {
  __typename?: 'UpdateActivityRelationInput';
  accountId?: ID | null;
  activityId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  projectObjective?: CreateProjectObjectiveInput | null;
  projectObjectiveId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface UpdateActivityProfileInput {
  __typename?: 'UpdateActivityProfileInput';
  clientMutationId?: string | null;
  data?: ActivityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateActivityKPIInput {
  __typename?: 'UpdateActivityKPIInput';
  activityId?: ID | null;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  kpi?: ActivityKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateActivityGeoLocationInput {
  __typename?: 'UpdateActivityGeoLocationInput';
  activityId: UUID;
  clientMutationId?: string | null;
  lat: number;
  lng: number;
}

export interface UpdateActivityDraftProfileInput {
  __typename?: 'UpdateActivityDraftProfileInput';
  clientMutationId?: string | null;
  data?: ActivityProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateActivityCommentInput {
  __typename?: 'UpdateActivityCommentInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface UpdateAccountSocialRelationNoIdBackrefInput {
  __typename?: 'UpdateAccountSocialRelationNoIdBackrefInput';
  angellistUrl?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface UpdateAccountSocialRelationInput {
  __typename?: 'UpdateAccountSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id: ID;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface UpdateAccountSharingSalesUnitRelationInput {
  __typename?: 'UpdateAccountSharingSalesUnitRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface UpdateAccountSharingClientRelationInput {
  __typename?: 'UpdateAccountSharingClientRelationInput';
  accountId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface UpdateAccountRoleInput {
  __typename?: 'UpdateAccountRoleInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAccountRelationTypeInput {
  __typename?: 'UpdateAccountRelationTypeInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id: ID;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAccountRelationLabelInput {
  __typename?: 'UpdateAccountRelationLabelInput';
  accountRelation?: CreateAccountRelationInput | null;
  accountRelationId?: ID | null;
  accountRelationTypeId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAccountRelationInput {
  __typename?: 'UpdateAccountRelationInput';
  account1Id?: ID | null;
  account2Id?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface UpdateAccountProfileInput {
  __typename?: 'UpdateAccountProfileInput';
  clientMutationId?: string | null;
  data?: AccountProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateAccountProductPricingInput {
  __typename?: 'UpdateAccountProductPricingInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId?: ID | null;
  id: ID;
  modified?: DateTime | null;
  price?: number | null;
  productId?: ID | null;
  revision?: number | null;
}

export interface UpdateAccountKPIInput {
  __typename?: 'UpdateAccountKPIInput';
  accountId?: ID | null;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  kpi?: AccountKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface UpdateAccountInput {
  __typename?: 'UpdateAccountInput';
  accountClass?: AccountClassEnum | null;
  accountTypeId?: ID | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  customerTypeId?: ID | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  homePage?: string | null;
  id: ID;
  industryId?: ID | null;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  parentAccountId?: ID | null;
  parentAccountRelationTypeId?: ID | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  quickParentAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateAccountSharingClientRelationNoAccountBackrefInput[] | null;
  sharingUnits?: CreateAccountSharingSalesUnitRelationNoAccountBackrefInput[] | null;
  socialMedia?: UpdateAccountSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoAccountBackrefInput[] | null;
  tags?: CreateTagRelationNoAccountBackrefInput[] | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface UpdateAccountDraftProfileInput {
  __typename?: 'UpdateAccountDraftProfileInput';
  clientMutationId?: string | null;
  data?: AccountProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateAccountArchiveProfileInput {
  __typename?: 'UpdateAccountArchiveProfileInput';
  clientMutationId?: string | null;
  data?: AccountArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UpdateAccountArchiveDraftProfileInput {
  __typename?: 'UpdateAccountArchiveDraftProfileInput';
  clientMutationId?: string | null;
  data?: AccountArchiveProfileDataInput | null;
  id: ID;
  name?: string | null;
}

export interface UnsubscribedPhoneOrderByInput {
  __typename?: 'UnsubscribedPhoneOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  phone?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface UnsubscribedPhoneFilterInput {
  __typename?: 'UnsubscribedPhoneFilterInput';
  AND?: UnsubscribedPhoneFilterInput[] | null;
  NOT?: UnsubscribedPhoneFilterInput | null;
  OR?: UnsubscribedPhoneFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  phone?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface UnlinkCustomEntityRelationDataInput {
  __typename?: 'UnlinkCustomEntityRelationDataInput';
  clientMutationId?: string | null;
  entityId: UUID;
  fieldId: UUID;
  ids: UUID[];
  type?: FieldRelationTypeEnum | null;
}

export interface UnitRoleEnumFilterInput {
  __typename?: 'UnitRoleEnumFilterInput';
  NOT?: UnitRoleEnumFilterInput | null;
  eq?: UnitRoleEnum[] | null;
}

export interface UnenrollEmailSequenceInput {
  __typename?: 'UnenrollEmailSequenceInput';
  clientMutationId?: string | null;
  emailSequencesEnrolledFilter?: EmailSequenceEnrolledFilterInput | null;
  enrollmentIds?: UUID[] | null;
  entityIds?: UUID[] | null;
  ids: UUID[];
}

export interface UndoDraftProfileInput {
  __typename?: 'UndoDraftProfileInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  screenType: ScreenType;
}

export interface TypeOrderByInput {
  __typename?: 'TypeOrderByInput';
  containerSize?: OrderByEnum | null;
  defaultValue?: OrderByEnum | null;
  flag?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isFilterable?: OrderByEnum | null;
  isGroupable?: OrderByEnum | null;
  isSelectable?: OrderByEnum | null;
  isSortable?: OrderByEnum | null;
}

export interface TypeFilterInput {
  __typename?: 'TypeFilterInput';
  AND?: TypeFilterInput[] | null;
  NOT?: TypeFilterInput | null;
  OR?: TypeFilterInput[] | null;
  containerSize?: EntityFilterNumberField | null;
  defaultValue?: EntityFilterStringField | null;
  flag?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isFilterable?: boolean | null;
  isGroupable?: boolean | null;
  isSelectable?: boolean | null;
  isSortable?: boolean | null;
  primitiveType?: PrimitiveTypeFilterInput | null;
  relationType?: RelationTypeFilterInput | null;
}

export interface TranslationOrderByInput {
  __typename?: 'TranslationOrderByInput';
  accountType?: AccountTypeOrderByNestedInput[] | null;
  accountTypeId?: OrderByEnum | null;
  appointmentType?: AppointmentTypeOrderByNestedInput[] | null;
  appointmentTypeId?: OrderByEnum | null;
  contactType?: ContactTypeOrderByNestedInput[] | null;
  contactTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  deDe?: OrderByEnum | null;
  enUs?: OrderByEnum | null;
  esEs?: OrderByEnum | null;
  field?: FieldOrderByNestedInput[] | null;
  fieldId?: OrderByEnum | null;
  formType?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  labelType?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyProductRelationType?: OpptyProductRelationTypeOrderByNestedInput[] | null;
  opptyProductRelationTypeId?: OrderByEnum | null;
  opptyType?: OpportunityTypeOrderByNestedInput[] | null;
  opptyTypeId?: OrderByEnum | null;
  productType?: ProductTypeOrderByNestedInput[] | null;
  productTypeId?: OrderByEnum | null;
  projectType?: ProjectTypeOrderByNestedInput[] | null;
  projectTypeId?: OrderByEnum | null;
  ptBr?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  taskType?: TaskTypeOrderByNestedInput[] | null;
  taskTypeId?: OrderByEnum | null;
}

export interface TranslationLabelTypeEnumFilterInput {
  __typename?: 'TranslationLabelTypeEnumFilterInput';
  NOT?: TranslationLabelTypeEnumFilterInput | null;
  eq?: TranslationLabelTypeEnum[] | null;
}

export interface TranslationFilterInput {
  __typename?: 'TranslationFilterInput';
  AND?: TranslationFilterInput[] | null;
  NOT?: TranslationFilterInput | null;
  OR?: TranslationFilterInput[] | null;
  accountType?: AccountTypeFilterInput | null;
  accountTypeId?: EntityFilterStringField | null;
  appointmentType?: AppointmentTypeFilterInput | null;
  appointmentTypeId?: EntityFilterStringField | null;
  contactType?: ContactTypeFilterInput | null;
  contactTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  deDe?: EntityFilterStringField | null;
  enUs?: EntityFilterStringField | null;
  esEs?: EntityFilterStringField | null;
  field?: FieldFilterInput | null;
  fieldId?: EntityFilterStringField | null;
  formType?: FormTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  labelType?: TranslationLabelTypeEnumFilterInput | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  opptyProductRelationType?: OpptyProductRelationTypeFilterInput | null;
  opptyProductRelationTypeId?: EntityFilterStringField | null;
  opptyType?: OpportunityTypeFilterInput | null;
  opptyTypeId?: EntityFilterStringField | null;
  productType?: ProductTypeFilterInput | null;
  productTypeId?: EntityFilterStringField | null;
  projectType?: ProjectTypeFilterInput | null;
  projectTypeId?: EntityFilterStringField | null;
  ptBr?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  taskType?: TaskTypeFilterInput | null;
  taskTypeId?: EntityFilterStringField | null;
}

export interface TrackContentManagementEventInput {
  __typename?: 'TrackContentManagementEventInput';
  clientMutationId?: string | null;
  entityId: number;
  entityType: ContentManagementEntityTypeEnum;
  eventType?: ContentManagementEventTypeEnum | null;
}

export interface TokenInput {
  __typename?: 'TokenInput';
  accessToken: string;
}

export interface ToggleStateTeamPipelineHubItemInput {
  __typename?: 'ToggleStateTeamPipelineHubItemInput';
  clientMutationId?: string | null;
  configuration?: string | null;
  id: ID;
  isEnabled: boolean;
  wasEnabled?: boolean | null;
}

export interface TimeframeOrderByInput {
  __typename?: 'TimeframeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  timeframe?: OrderByEnum | null;
}

export interface TimeframeFilterInput {
  __typename?: 'TimeframeFilterInput';
  AND?: TimeframeFilterInput[] | null;
  NOT?: TimeframeFilterInput | null;
  OR?: TimeframeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  timeframe?: EntityFilterNumberField | null;
}

export interface TextMessageStatusEnumFilterInput {
  __typename?: 'TextMessageStatusEnumFilterInput';
  NOT?: TextMessageStatusEnumFilterInput | null;
  eq?: TextMessageStatusEnum[] | null;
}

export interface TextMessageOrderByNestedInput {
  __typename?: 'TextMessageOrderByNestedInput';
  chatConversationId?: OrderByEnum | null;
  content?: OrderByEnum | null;
  created?: OrderByEnum | null;
  datetimeSent?: OrderByEnum | null;
  direction?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  messageSid?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  textMessageConversationId?: OrderByEnum | null;
}

export interface TextMessageOrderByInput {
  __typename?: 'TextMessageOrderByInput';
  chatConversation?: ChatConversationOrderByNestedInput[] | null;
  chatConversationId?: OrderByEnum | null;
  content?: OrderByEnum | null;
  created?: OrderByEnum | null;
  datetimeSent?: OrderByEnum | null;
  direction?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  messageSid?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  textMessageConversation?: TextMessageConversationOrderByNestedInput[] | null;
  textMessageConversationId?: OrderByEnum | null;
}

export interface TextMessageNotificationSettingsParams {
  __typename?: 'TextMessageNotificationSettingsParams';
  IsActive: boolean;
  LinkedItem?: boolean | null;
}

export interface TextMessageFilterInput {
  __typename?: 'TextMessageFilterInput';
  AND?: TextMessageFilterInput[] | null;
  NOT?: TextMessageFilterInput | null;
  OR?: TextMessageFilterInput[] | null;
  attachments?: CloudObjectRelationFilterInput | null;
  chatConversation?: ChatConversationFilterInput | null;
  chatConversationId?: EntityFilterStringField | null;
  content?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  datetimeSent?: EntityFilterDateTimeField | null;
  direction?: EmailDirectionEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  messageSid?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  status?: TextMessageStatusEnumFilterInput | null;
  textMessageConversation?: TextMessageConversationFilterInput | null;
  textMessageConversationId?: EntityFilterStringField | null;
}

export interface TextMessageDrilldownFilterParams {
  __typename?: 'TextMessageDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface TextMessageConversationRelationsOrderByInput {
  __typename?: 'TextMessageConversationRelationsOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  textMessageConversation?: TextMessageConversationOrderByNestedInput[] | null;
  textMessageConversationId?: OrderByEnum | null;
}

export interface TextMessageConversationRelationsFilterInput {
  __typename?: 'TextMessageConversationRelationsFilterInput';
  AND?: TextMessageConversationRelationsFilterInput[] | null;
  NOT?: TextMessageConversationRelationsFilterInput | null;
  OR?: TextMessageConversationRelationsFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  textMessageConversation?: TextMessageConversationFilterInput | null;
  textMessageConversationId?: EntityFilterStringField | null;
}

export interface TextMessageConversationOrderByNestedInput {
  __typename?: 'TextMessageConversationOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  phoneId?: OrderByEnum | null;
  recipientAccountId?: OrderByEnum | null;
  recipientContactId?: OrderByEnum | null;
  recipientPhoneNumber?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface TextMessageConversationOrderByInput {
  __typename?: 'TextMessageConversationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  phone?: PhoneOrderByNestedInput[] | null;
  phoneId?: OrderByEnum | null;
  recipientAccount?: AccountOrderByNestedInput[] | null;
  recipientAccountId?: OrderByEnum | null;
  recipientContact?: ContactOrderByNestedInput[] | null;
  recipientContactId?: OrderByEnum | null;
  recipientPhoneNumber?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface TextMessageConversationFilterInput {
  __typename?: 'TextMessageConversationFilterInput';
  AND?: TextMessageConversationFilterInput[] | null;
  NOT?: TextMessageConversationFilterInput | null;
  OR?: TextMessageConversationFilterInput[] | null;
  accountRelations?: TextMessageConversationRelationsFilterInput | null;
  contactRelations?: TextMessageConversationRelationsFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadRelations?: TextMessageConversationRelationsFilterInput | null;
  messages?: TextMessageFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  opportunityRelations?: TextMessageConversationRelationsFilterInput | null;
  phone?: PhoneFilterInput | null;
  phoneId?: EntityFilterStringField | null;
  projectRelations?: TextMessageConversationRelationsFilterInput | null;
  quoteRelations?: TextMessageConversationRelationsFilterInput | null;
  recipientAccount?: AccountFilterInput | null;
  recipientAccountId?: EntityFilterStringField | null;
  recipientContact?: ContactFilterInput | null;
  recipientContactId?: EntityFilterStringField | null;
  recipientPhoneNumber?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface TestProcessWebhookInput {
  __typename?: 'TestProcessWebhookInput';
  clientMutationId?: string | null;
  entityId?: UUID | null;
  entityType?: EntityNameEnum | null;
  id: ID;
  sampleData: boolean;
  webhook: ProcessWebhookParams;
}

export interface TestApprovalProcessWebhookInput {
  __typename?: 'TestApprovalProcessWebhookInput';
  clientMutationId?: string | null;
  entityId?: UUID | null;
  entityType?: EntityNameEnum | null;
  id: ID;
  sampleData: boolean;
  webhook: ProcessWebhookParams;
}

export interface TeamSpaceStatusReasonFilterInput {
  __typename?: 'TeamSpaceStatusReasonFilterInput';
  NOT?: TeamSpaceStatusReasonFilterInput | null;
  eq?: TeamSpaceStatusReason[] | null;
}

export interface TeamSpaceStatusFilterInput {
  __typename?: 'TeamSpaceStatusFilterInput';
  NOT?: TeamSpaceStatusFilterInput | null;
  eq?: TeamSpaceStatus[] | null;
}

export interface TeamSpaceOrderByInput {
  __typename?: 'TeamSpaceOrderByInput';
  dbVersion?: OrderByEnum | null;
  flags?: OrderByEnum | null;
  id?: OrderByEnum | null;
  name?: OrderByEnum | null;
  regionName?: OrderByEnum | null;
  size?: OrderByEnum | null;
  status?: OrderByEnum | null;
  subscription?: SubscriptionOrderByNestedInput[] | null;
  subscriptionId?: OrderByEnum | null;
  version?: OrderByEnum | null;
}

export interface TeamSpaceFlagsFilterInput {
  __typename?: 'TeamSpaceFlagsFilterInput';
  NOT?: TeamSpaceFlagsFilterInput | null;
  eq?: TeamSpaceFlags[] | null;
}

export interface TeamSpaceFilterInput {
  __typename?: 'TeamSpaceFilterInput';
  AND?: TeamSpaceFilterInput[] | null;
  NOT?: TeamSpaceFilterInput | null;
  OR?: TeamSpaceFilterInput[] | null;
  dbVersion?: EntityFilterNumberField | null;
  flags?: TeamSpaceFlagsFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  name?: EntityFilterStringField | null;
  pictureUrl?: EntityFilterStringField | null;
  regionName?: string | null;
  size?: EntityFilterNumberField | null;
  status?: TeamSpaceStatusFilterInput | null;
  statusReason?: TeamSpaceStatusReasonFilterInput | null;
  subscription?: SubscriptionFilterInput | null;
  subscriptionId?: EntityFilterNumberField | null;
  version?: EntityFilterNumberField | null;
}

export interface TaskTypeOrderByNestedInput {
  __typename?: 'TaskTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface TaskTypeOrderByInput {
  __typename?: 'TaskTypeOrderByInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface TaskTypeFilterInput {
  __typename?: 'TaskTypeFilterInput';
  AND?: TaskTypeFilterInput[] | null;
  NOT?: TaskTypeFilterInput | null;
  OR?: TaskTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  icon?: ActivityTypeIconEnumFilterInput | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface TaskStatusEnumFilterInput {
  __typename?: 'TaskStatusEnumFilterInput';
  NOT?: TaskStatusEnumFilterInput | null;
  eq?: TaskStatusEnum[] | null;
}

export interface TaskSharingSalesUnitRelationOrderByInput {
  __typename?: 'TaskSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  taskId?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface TaskSharingSalesUnitRelationFilterInput {
  __typename?: 'TaskSharingSalesUnitRelationFilterInput';
  AND?: TaskSharingSalesUnitRelationFilterInput[] | null;
  NOT?: TaskSharingSalesUnitRelationFilterInput | null;
  OR?: TaskSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  task?: TaskFilterInput | null;
  taskId?: EntityFilterStringField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface TaskSharingClientRelationOrderByInput {
  __typename?: 'TaskSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  taskId?: OrderByEnum | null;
}

export interface TaskSharingClientRelationFilterInput {
  __typename?: 'TaskSharingClientRelationFilterInput';
  AND?: TaskSharingClientRelationFilterInput[] | null;
  NOT?: TaskSharingClientRelationFilterInput | null;
  OR?: TaskSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  task?: TaskFilterInput | null;
  taskId?: EntityFilterStringField | null;
}

export interface TaskReminderOrderByNestedInput {
  __typename?: 'TaskReminderOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  setDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  taskId?: OrderByEnum | null;
}

export interface TaskReminderOrderByInput {
  __typename?: 'TaskReminderOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  setDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  taskId?: OrderByEnum | null;
}

export interface TaskReminderFilterInput {
  __typename?: 'TaskReminderFilterInput';
  AND?: TaskReminderFilterInput[] | null;
  NOT?: TaskReminderFilterInput | null;
  OR?: TaskReminderFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  setDate?: EntityFilterDateTimeField | null;
  status?: ReminderStatusEnumFilterInput | null;
  task?: TaskFilterInput | null;
  taskId?: EntityFilterStringField | null;
}

export interface TaskRecurrenceOrderByNestedInput {
  __typename?: 'TaskRecurrenceOrderByNestedInput';
  created?: OrderByEnum | null;
  day?: OrderByEnum | null;
  dayOfWeek?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  month?: OrderByEnum | null;
  occurEvery?: OrderByEnum | null;
  occurrencesCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  taskId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  week?: OrderByEnum | null;
}

export interface TaskRecurrenceOrderByInput {
  __typename?: 'TaskRecurrenceOrderByInput';
  created?: OrderByEnum | null;
  day?: OrderByEnum | null;
  dayOfWeek?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  month?: OrderByEnum | null;
  occurEvery?: OrderByEnum | null;
  occurrencesCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  taskId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  week?: OrderByEnum | null;
}

export interface TaskRecurrenceFilterInput {
  __typename?: 'TaskRecurrenceFilterInput';
  AND?: TaskRecurrenceFilterInput[] | null;
  NOT?: TaskRecurrenceFilterInput | null;
  OR?: TaskRecurrenceFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  day?: DateDayEnumFilterInput | null;
  dayOfWeek?: DateDayOfWeekEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  month?: DateMonthEnumFilterInput | null;
  occurEvery?: EntityFilterNumberField | null;
  occurrencesCount?: EntityFilterNumberField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
  taskId?: EntityFilterStringField | null;
  type?: RecurrenceTypeEnumFilterInput | null;
  week?: DateWeekEnumFilterInput | null;
}

export interface TaskOrderByNestedInput {
  __typename?: 'TaskOrderByNestedInput';
  activityTypeId?: OrderByEnum | null;
  callDuration?: OrderByEnum | null;
  callId?: OrderByEnum | null;
  callOutcomeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  dueDate?: OrderByEnum | null;
  duration?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  priority?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface TaskOrderByInput {
  __typename?: 'TaskOrderByInput';
  activityType?: TaskTypeOrderByNestedInput[] | null;
  activityTypeId?: OrderByEnum | null;
  call?: CallOrderByNestedInput[] | null;
  callDuration?: OrderByEnum | null;
  callId?: OrderByEnum | null;
  callOutcome?: DataOrderByNestedInput[] | null;
  callOutcomeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  dueDate?: OrderByEnum | null;
  duration?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  priority?: OrderByEnum | null;
  reminder?: TaskReminderOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  taskRecurrence?: TaskRecurrenceOrderByNestedInput[] | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface TaskFilterInput {
  __typename?: 'TaskFilterInput';
  AND?: TaskFilterInput[] | null;
  NOT?: TaskFilterInput | null;
  OR?: TaskFilterInput[] | null;
  accountRelations?: ActivityRelationFilterInput | null;
  activityType?: TaskTypeFilterInput | null;
  activityTypeId?: EntityFilterStringField | null;
  call?: CallFilterInput | null;
  callDuration?: EntityFilterNumberField | null;
  callId?: EntityFilterStringField | null;
  callOutcome?: DataFilterInput | null;
  callOutcomeId?: EntityFilterStringField | null;
  comments?: ActivityCommentFilterInput | null;
  contactRelations?: ActivityRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  customEntityRelations?: ActivityRelationFilterInput | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  duration?: EntityFilterNumberField | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadRelations?: ActivityRelationFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  o365EntityId?: string | null;
  opportunityRelations?: ActivityRelationFilterInput | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  priority?: PriorityEnumFilterInput | null;
  projectRelations?: ActivityRelationFilterInput | null;
  quoteRelations?: ActivityRelationFilterInput | null;
  reminder?: TaskReminderFilterInput | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: TaskSharingClientRelationFilterInput | null;
  sharingUnits?: TaskSharingSalesUnitRelationFilterInput | null;
  status?: TaskStatusEnumFilterInput | null;
  subject?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
  tags?: TagRelationFilterInput | null;
  taskRecurrence?: TaskRecurrenceFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface TargetsPeriodParams {
  __typename?: 'TargetsPeriodParams';
  fragmentIndex?: number | null;
  fragmentType: TargetsPeriodFragmentTypeEnum;
  type: TargetsPeriodTypeEnum;
  year: number;
}

export interface TargetsIndicatorsParams {
  __typename?: 'TargetsIndicatorsParams';
  holidaysPerYear?: number | null;
  leadAverageEngagementTime?: number | null;
  leadAverageEngagementsBeforeLost?: number | null;
  leadAverageEngagementsBeforeQualify?: number | null;
  leadAverageEngagementsBeforeQualifyLost?: number | null;
  leadClosedCount?: number | null;
  leadQualificationRate?: number | null;
  leadSalesTimeToLose?: number | null;
  leadSalesTimeToQualify?: number | null;
  nonSellingHoursPerWeek?: number | null;
  opportunityAverageEngagementTime?: number | null;
  opportunityAverageSize?: number | null;
  opportunityAverageVelocity?: number | null;
  opportunityClosedCount?: number | null;
  opportunitySalesTimeToLose?: number | null;
  opportunitySalesTimeToWin?: number | null;
  opportunityWinRate?: number | null;
  opptyAverageEngagementsBeforeLost?: number | null;
  opptyAverageEngagementsBeforeWon?: number | null;
  opptyAverageEngagementsBeforeWonLost?: number | null;
  sickDaysPerYear?: number | null;
  target?: number | null;
  targetUserWorkingDaysTotal?: number | null;
  targetUserYearsInWork?: number | null;
  vacationDaysPerYear?: number | null;
  workingHoursPerWeek?: number | null;
}

export interface TargetTypeEnumFilterInput {
  __typename?: 'TargetTypeEnumFilterInput';
  NOT?: TargetTypeEnumFilterInput | null;
  eq?: TargetTypeEnum[] | null;
}

export interface TargetRelationOrderByInput {
  __typename?: 'TargetRelationOrderByInput';
  created?: OrderByEnum | null;
  groupTarget?: TargetOrderByNestedInput[] | null;
  groupTargetId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  userTarget?: TargetOrderByNestedInput[] | null;
  userTargetId?: OrderByEnum | null;
}

export interface TargetRelationFilterInput {
  __typename?: 'TargetRelationFilterInput';
  AND?: TargetRelationFilterInput[] | null;
  NOT?: TargetRelationFilterInput | null;
  OR?: TargetRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  groupTarget?: TargetFilterInput | null;
  groupTargetId?: EntityFilterStringField | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  userTarget?: TargetFilterInput | null;
  userTargetId?: EntityFilterStringField | null;
}

export interface TargetPreviewViewTabParams {
  __typename?: 'TargetPreviewViewTabParams';
  gridColumns?: GridColumnsOutputParams[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface TargetPreviewProfileParams {
  __typename?: 'TargetPreviewProfileParams';
  filter: TargetFilterTabParams;
  view: TargetPreviewViewTabParams;
}

export interface TargetOrderByNestedInput {
  __typename?: 'TargetOrderByNestedInput';
  calculationType?: OrderByEnum | null;
  created?: OrderByEnum | null;
  daysLeft?: OrderByEnum | null;
  description?: OrderByEnum | null;
  estimatedTarget?: OrderByEnum | null;
  finishedDate?: OrderByEnum | null;
  hasParentGroupTarget?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  periodFragmentIndex?: OrderByEnum | null;
  periodFragmentType?: OrderByEnum | null;
  periodFrom?: OrderByEnum | null;
  periodTo?: OrderByEnum | null;
  periodType?: OrderByEnum | null;
  periodYear?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  target?: OrderByEnum | null;
  targetClientId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  virtualPeriodFrom?: OrderByEnum | null;
  virtualPeriodTo?: OrderByEnum | null;
}

export interface TargetOrderByInput {
  __typename?: 'TargetOrderByInput';
  calculationType?: OrderByEnum | null;
  created?: OrderByEnum | null;
  daysLeft?: OrderByEnum | null;
  description?: OrderByEnum | null;
  estimatedTarget?: OrderByEnum | null;
  finishedDate?: OrderByEnum | null;
  hasParentGroupTarget?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  periodFragmentIndex?: OrderByEnum | null;
  periodFragmentType?: OrderByEnum | null;
  periodFrom?: OrderByEnum | null;
  periodTo?: OrderByEnum | null;
  periodType?: OrderByEnum | null;
  periodYear?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  target?: OrderByEnum | null;
  targetClient?: ClientOrderByNestedInput[] | null;
  targetClientId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  virtualPeriodFrom?: OrderByEnum | null;
  virtualPeriodTo?: OrderByEnum | null;
}

export interface TargetListingOptionsParams {
  __typename?: 'TargetListingOptionsParams';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByStatus?: TargetStatusEnum[] | null;
  filterByTargetCalculationType?: TargetCalculationTypeEnum | null;
}

export interface TargetFilterTabParams {
  __typename?: 'TargetFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface TargetFilterInput {
  __typename?: 'TargetFilterInput';
  AND?: TargetFilterInput[] | null;
  NOT?: TargetFilterInput | null;
  OR?: TargetFilterInput[] | null;
  calculationType?: TargetCalculationTypeEnumFilterInput | null;
  childTargets?: TargetRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currency?: CurrencyFilterInput | null;
  currencyId?: EntityFilterStringField | null;
  daysLeft?: number | null;
  description?: EntityFilterStringField | null;
  estimatedTarget?: number | null;
  finishedDate?: GqlDate | null;
  globalSearchQuery?: string | null;
  hasParentGroupTarget?: boolean | null;
  id?: EntityFilterStringField | null;
  isActive?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  periodFragmentIndex?: number | null;
  periodFragmentType?: TargetsPeriodFragmentTypeEnum | null;
  periodType?: TargetsPeriodTypeEnum | null;
  periodYear?: number | null;
  revision?: EntityFilterNumberField | null;
  status?: TargetStatusEnum | null;
  target?: number | null;
  targetClient?: ClientFilterInput | null;
  targetClientId?: EntityFilterStringField | null;
  type?: TargetTypeEnumFilterInput | null;
  virtualPeriodFrom?: GqlDate | null;
  virtualPeriodTo?: GqlDate | null;
}

export interface TargetCalculationTypeEnumFilterInput {
  __typename?: 'TargetCalculationTypeEnumFilterInput';
  NOT?: TargetCalculationTypeEnumFilterInput | null;
  eq?: TargetCalculationTypeEnum[] | null;
}

export interface TagTabDataGridViewOptionsParams {
  __typename?: 'TagTabDataGridViewOptionsParams';
  allowedEntityTypeIds?: UUID[] | null;
}

export interface TagSupportedEntitiesEnumFilterInput {
  __typename?: 'TagSupportedEntitiesEnumFilterInput';
  NOT?: TagSupportedEntitiesEnumFilterInput | null;
  eq?: TagSupportedEntitiesEnum[] | null;
}

export interface TagRelationOrderByInput {
  __typename?: 'TagRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  appointmentId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  process?: ProcessOrderByNestedInput[] | null;
  processId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  tag?: TagOrderByNestedInput[] | null;
  tagId?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  taskId?: OrderByEnum | null;
}

export interface TagRelationFilterInput {
  __typename?: 'TagRelationFilterInput';
  AND?: TagRelationFilterInput[] | null;
  NOT?: TagRelationFilterInput | null;
  OR?: TagRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  appointmentId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  process?: ProcessFilterInput | null;
  processId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  tag?: TagFilterInput | null;
  tagId?: EntityFilterStringField | null;
  task?: TaskFilterInput | null;
  taskId?: EntityFilterStringField | null;
}

export interface TagOrderByNestedInput {
  __typename?: 'TagOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creatorId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  supportedEntities?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface TagOrderByInput {
  __typename?: 'TagOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creator?: ClientOrderByNestedInput[] | null;
  creatorId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  supportedEntities?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface TagFilterInput {
  __typename?: 'TagFilterInput';
  AND?: TagFilterInput[] | null;
  NOT?: TagFilterInput | null;
  OR?: TagFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  creator?: ClientFilterInput | null;
  creatorId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  supportedEntities?: TagSupportedEntitiesEnumFilterInput | null;
  useLang?: boolean | null;
}

export interface SyncClientWithUserTableInput {
  __typename?: 'SyncClientWithUserTableInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface SwitchProfileFavoriteStatusInput {
  __typename?: 'SwitchProfileFavoriteStatusInput';
  clientMutationId?: string | null;
  profileId: ID;
  value: boolean;
}

export interface SuspendOnlineFormsInput {
  __typename?: 'SuspendOnlineFormsInput';
  clientMutationId?: string | null;
}

export interface SuspendAutomatizerInput {
  __typename?: 'SuspendAutomatizerInput';
  clientMutationId?: string | null;
}

export interface SummaryFieldParams {
  __typename?: 'SummaryFieldParams';
  id: UUID;
  name: string;
  rollup: RollupPropertyParams;
}

export interface SubscriptionStatusFilterInput {
  __typename?: 'SubscriptionStatusFilterInput';
  NOT?: SubscriptionStatusFilterInput | null;
  eq?: SubscriptionStatus[] | null;
}

export interface SubscriptionProductTierFilterInput {
  __typename?: 'SubscriptionProductTierFilterInput';
  NOT?: SubscriptionProductTierFilterInput | null;
  eq?: SubscriptionProductTier[] | null;
}

export interface SubscriptionOrderByNestedInput {
  __typename?: 'SubscriptionOrderByNestedInput';
  agreedToGtac?: OrderByEnum | null;
  aiFreeMonthlyCredits?: OrderByEnum | null;
  aiOverageLimit?: OrderByEnum | null;
  anniversaryDate?: OrderByEnum | null;
  awsAccountId?: OrderByEnum | null;
  awsCustomerId?: OrderByEnum | null;
  billingCountryName?: OrderByEnum | null;
  classification?: OrderByEnum | null;
  contactEmail?: OrderByEnum | null;
  created?: OrderByEnum | null;
  crmAccountId?: OrderByEnum | null;
  customPrice?: OrderByEnum | null;
  discount?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  fromCampaign?: OrderByEnum | null;
  id?: OrderByEnum | null;
  lastVatCheckDate?: OrderByEnum | null;
  licensesPurchased?: OrderByEnum | null;
  licensesUsed?: OrderByEnum | null;
  manualInstructions?: OrderByEnum | null;
  manualOrderDunning?: OrderByEnum | null;
  manuallyHandled?: OrderByEnum | null;
  name?: OrderByEnum | null;
  numberOfSalesPeople?: OrderByEnum | null;
  partnerCommissionAmountEur?: OrderByEnum | null;
  partnerCommissionAmountGbp?: OrderByEnum | null;
  partnerCommissionAmountUsd?: OrderByEnum | null;
  partnerLtvAmountEur?: OrderByEnum | null;
  partnerLtvAmountGbp?: OrderByEnum | null;
  partnerLtvAmountUsd?: OrderByEnum | null;
  partnerName?: OrderByEnum | null;
  paymentTermsId?: OrderByEnum | null;
  referralPartnerId?: OrderByEnum | null;
  referralPartnerRepresentativeId?: OrderByEnum | null;
  representativeEmail?: OrderByEnum | null;
  representativeId?: OrderByEnum | null;
  representativeName?: OrderByEnum | null;
  requiredIdpId?: OrderByEnum | null;
  sdrEmail?: OrderByEnum | null;
  sdrId?: OrderByEnum | null;
  sdrName?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  supplierId?: OrderByEnum | null;
  tier?: OrderByEnum | null;
  vatCheckResult?: OrderByEnum | null;
  vatCode?: OrderByEnum | null;
}

export interface SubscriptionFilterInput {
  __typename?: 'SubscriptionFilterInput';
  AND?: SubscriptionFilterInput[] | null;
  NOT?: SubscriptionFilterInput | null;
  OR?: SubscriptionFilterInput[] | null;
  agreedToGtac?: boolean | null;
  aiFreeMonthlyCredits?: EntityFilterNumberField | null;
  aiOverageLimit?: EntityFilterNumberField | null;
  anniversaryDate?: GqlDate | null;
  awsAccountId?: EntityFilterStringField | null;
  awsCustomerId?: EntityFilterStringField | null;
  billingAddress?: EntityFilterStringField | null;
  billingCity?: EntityFilterStringField | null;
  billingCompany?: EntityFilterStringField | null;
  billingCountryId?: EntityFilterStringField | null;
  billingCountryName?: string | null;
  billingEmails?: EntityFilterStringField | null;
  billingFax?: EntityFilterStringField | null;
  billingFirstName?: EntityFilterStringField | null;
  billingLastName?: EntityFilterStringField | null;
  billingPhone?: EntityFilterStringField | null;
  billingPostalCode?: EntityFilterStringField | null;
  billingStateId?: EntityFilterStringField | null;
  billingVatCode?: EntityFilterStringField | null;
  classification?: SubscriptionClassificationFilterInput | null;
  contactEmail?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  crmAccountId?: EntityFilterStringField | null;
  customPrice?: EntityFilterNumberField | null;
  discount?: EntityFilterNumberField | null;
  endDate?: EntityFilterDateTimeField | null;
  focus?: SubscriptionCompanyFocusFilterInput | null;
  fromCampaign?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  lastVatCheckDate?: DateTime | null;
  licensesPurchased?: EntityFilterNumberField | null;
  licensesUsed?: number | null;
  manualInstructions?: EntityFilterStringField | null;
  manualOrderDunning?: boolean | null;
  manuallyHandled?: boolean | null;
  name?: EntityFilterStringField | null;
  numberOfSalesPeople?: NumberOfSalesPeopleFilterInput | null;
  partnerCommissionAmountEur?: string | null;
  partnerCommissionAmountGbp?: string | null;
  partnerCommissionAmountUsd?: string | null;
  partnerLtvAmountEur?: string | null;
  partnerLtvAmountGbp?: string | null;
  partnerLtvAmountUsd?: string | null;
  partnerName?: string | null;
  paymentTermsId?: EntityFilterNumberField | null;
  referralPartner?: PartnerFilterInput | null;
  referralPartnerId?: EntityFilterNumberField | null;
  referralPartnerRepresentativeId?: EntityFilterNumberField | null;
  representativeEmail?: string | null;
  representativeId?: EntityFilterNumberField | null;
  representativeName?: string | null;
  requiredIdpId?: EntityFilterNumberField | null;
  sdrEmail?: string | null;
  sdrId?: EntityFilterNumberField | null;
  sdrName?: string | null;
  startDate?: EntityFilterDateTimeField | null;
  status?: SubscriptionStatusFilterInput | null;
  supplierId?: EntityFilterNumberField | null;
  tier?: SubscriptionProductTierFilterInput | null;
  vatCheckResult?: VatCheckResultEnum | null;
  vatCode?: string | null;
}

export interface SubscriptionCompanyFocusFilterInput {
  __typename?: 'SubscriptionCompanyFocusFilterInput';
  NOT?: SubscriptionCompanyFocusFilterInput | null;
  eq?: SubscriptionCompanyFocus[] | null;
}

export interface SubscriptionClassificationFilterInput {
  __typename?: 'SubscriptionClassificationFilterInput';
  NOT?: SubscriptionClassificationFilterInput | null;
  eq?: SubscriptionClassification[] | null;
}

export interface StorylaneOrderByInput {
  __typename?: 'StorylaneOrderByInput';
  actionUrl?: OrderByEnum | null;
  category?: OrderByEnum | null;
  exploreAll?: OrderByEnum | null;
  id?: OrderByEnum | null;
  minApiVersion?: OrderByEnum | null;
  pictureUrl?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  title?: OrderByEnum | null;
  uniqueViewCount?: OrderByEnum | null;
  viewCount?: OrderByEnum | null;
}

export interface StorylaneFilterInput {
  __typename?: 'StorylaneFilterInput';
  AND?: StorylaneFilterInput[] | null;
  NOT?: StorylaneFilterInput | null;
  OR?: StorylaneFilterInput[] | null;
  actionUrl?: EntityFilterStringField | null;
  category?: EntityFilterStringField | null;
  exploreAll?: boolean | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  minApiVersion?: EntityFilterNumberField | null;
  pictureUrl?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  title?: EntityFilterStringField | null;
  uniqueViewCount?: number | null;
  viewCount?: number | null;
}

export interface StopSingleProcessScheduledActionInput {
  __typename?: 'StopSingleProcessScheduledActionInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface StopProcessScheduledActionsInput {
  __typename?: 'StopProcessScheduledActionsInput';
  bulkFilter?: BulkOperationInput | null;
  clientMutationId?: string | null;
  processIds?: ID[] | null;
  scheduledActionsFilter?: ProcessScheduledActionFilterInput | null;
}

export interface StopManualTriggerProcessInput {
  __typename?: 'StopManualTriggerProcessInput';
  clientMutationId?: string | null;
  id: ID;
  sessionId: UUID;
}

export interface StopEnrollmentEmailSequenceInput {
  __typename?: 'StopEnrollmentEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
  sessionId: UUID;
}

export interface StepParams {
  __typename?: 'StepParams';
  containers?: FormContainerParams[] | null;
  id: string;
}

export interface StepOrderByNestedInput {
  __typename?: 'StepOrderByNestedInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  hasReadonlyForm?: OrderByEnum | null;
  hasVersionIncrement?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadProcessId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  percent?: OrderByEnum | null;
  pipelineId?: OrderByEnum | null;
  quoteProcessId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  timeframe?: OrderByEnum | null;
}

export interface StepOrderByInput {
  __typename?: 'StepOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  hasReadonlyForm?: OrderByEnum | null;
  hasVersionIncrement?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadProcess?: LeadProcessOrderByNestedInput[] | null;
  leadProcessId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  percent?: OrderByEnum | null;
  pipeline?: PipelineOrderByNestedInput[] | null;
  pipelineId?: OrderByEnum | null;
  quoteProcess?: QuoteProcessOrderByNestedInput[] | null;
  quoteProcessId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  timeframe?: OrderByEnum | null;
}

export interface StepMappingInput {
  __typename?: 'StepMappingInput';
  sourceStepId: UUID;
  targetStepId: UUID;
}

export interface StepFilterInput {
  __typename?: 'StepFilterInput';
  AND?: StepFilterInput[] | null;
  NOT?: StepFilterInput | null;
  OR?: StepFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectStepRelationFilterInput | null;
  globalSearchQuery?: string | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadProcess?: LeadProcessFilterInput | null;
  leadProcessId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  percent?: EntityFilterNumberField | null;
  pipeline?: PipelineFilterInput | null;
  pipelineId?: EntityFilterStringField | null;
  quoteProcess?: QuoteProcessFilterInput | null;
  quoteProcessId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
  stepChecklists?: StepChecklistFilterInput | null;
  timeframe?: EntityFilterNumberField | null;
}

export interface StepFieldsContainerParams {
  __typename?: 'StepFieldsContainerParams';
  id: UUID;
  label: string;
  onMobile?: boolean | null;
  steps?: StepParams[] | null;
  useLang?: boolean | null;
}

export interface StepChecklistVisibilityEnumFilterInput {
  __typename?: 'StepChecklistVisibilityEnumFilterInput';
  NOT?: StepChecklistVisibilityEnumFilterInput | null;
  eq?: StepChecklistVisibilityEnum[] | null;
}

export interface StepChecklistValidationEnumFilterInput {
  __typename?: 'StepChecklistValidationEnumFilterInput';
  NOT?: StepChecklistValidationEnumFilterInput | null;
  eq?: StepChecklistValidationEnum[] | null;
}

export interface StepChecklistTypeEnumFilterInput {
  __typename?: 'StepChecklistTypeEnumFilterInput';
  NOT?: StepChecklistTypeEnumFilterInput | null;
  eq?: StepChecklistTypeEnum[] | null;
}

export interface StepChecklistSalesRoleRelationOrderByInput {
  __typename?: 'StepChecklistSalesRoleRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  salesRole?: SalesRoleOrderByNestedInput[] | null;
  salesRoleId?: OrderByEnum | null;
  stepChecklist?: StepChecklistOrderByNestedInput[] | null;
  stepChecklistId?: OrderByEnum | null;
}

export interface StepChecklistSalesRoleRelationFilterInput {
  __typename?: 'StepChecklistSalesRoleRelationFilterInput';
  AND?: StepChecklistSalesRoleRelationFilterInput[] | null;
  NOT?: StepChecklistSalesRoleRelationFilterInput | null;
  OR?: StepChecklistSalesRoleRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  salesRole?: SalesRoleFilterInput | null;
  salesRoleId?: EntityFilterStringField | null;
  stepChecklist?: StepChecklistFilterInput | null;
  stepChecklistId?: EntityFilterStringField | null;
}

export interface StepChecklistOrderByNestedInput {
  __typename?: 'StepChecklistOrderByNestedInput';
  activityTypeId?: OrderByEnum | null;
  cloudObjectFormat?: OrderByEnum | null;
  cloudObjectTemplateId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  emailSequenceId?: OrderByEnum | null;
  fieldId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  itemType?: OrderByEnum | null;
  itemValidation?: OrderByEnum | null;
  label?: OrderByEnum | null;
  labelUseLang?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  processId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sendEmailFieldId?: OrderByEnum | null;
  sendEmailTemplateId?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  stepId?: OrderByEnum | null;
  visibilityType?: OrderByEnum | null;
}

export interface StepChecklistOrderByInput {
  __typename?: 'StepChecklistOrderByInput';
  activityTypeId?: OrderByEnum | null;
  appointmentType?: AppointmentTypeOrderByNestedInput[] | null;
  cloudObjectFormat?: OrderByEnum | null;
  cloudObjectTemplate?: CloudObjectTemplateOrderByNestedInput[] | null;
  cloudObjectTemplateId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  emailSequence?: EmailSequenceOrderByNestedInput[] | null;
  emailSequenceId?: OrderByEnum | null;
  field?: FieldOrderByNestedInput[] | null;
  fieldId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  itemType?: OrderByEnum | null;
  itemValidation?: OrderByEnum | null;
  label?: OrderByEnum | null;
  labelUseLang?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  process?: ProcessOrderByNestedInput[] | null;
  processId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sendEmailField?: FieldOrderByNestedInput[] | null;
  sendEmailFieldId?: OrderByEnum | null;
  sendEmailTemplate?: EmailTemplateOrderByNestedInput[] | null;
  sendEmailTemplateId?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  taskType?: TaskTypeOrderByNestedInput[] | null;
  visibilityType?: OrderByEnum | null;
}

export interface StepChecklistFilterInput {
  __typename?: 'StepChecklistFilterInput';
  AND?: StepChecklistFilterInput[] | null;
  NOT?: StepChecklistFilterInput | null;
  OR?: StepChecklistFilterInput[] | null;
  activityTypeId?: EntityFilterStringField | null;
  appointmentType?: AppointmentTypeFilterInput | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnumFilterInput | null;
  cloudObjectTemplate?: CloudObjectTemplateFilterInput | null;
  cloudObjectTemplateId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  emailSequence?: EmailSequenceFilterInput | null;
  emailSequenceId?: EntityFilterStringField | null;
  field?: FieldFilterInput | null;
  fieldId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  itemType?: StepChecklistTypeEnumFilterInput | null;
  itemValidation?: StepChecklistValidationEnumFilterInput | null;
  label?: EntityFilterStringField | null;
  labelUseLang?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  process?: ProcessFilterInput | null;
  processId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  salesRoles?: StepChecklistSalesRoleRelationFilterInput | null;
  sendEmailField?: FieldFilterInput | null;
  sendEmailFieldId?: EntityFilterStringField | null;
  sendEmailTemplate?: EmailTemplateFilterInput | null;
  sendEmailTemplateId?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  taskType?: TaskTypeFilterInput | null;
  visibilityType?: StepChecklistVisibilityEnumFilterInput | null;
}

export interface StepChecklistDocumentFormatEnumFilterInput {
  __typename?: 'StepChecklistDocumentFormatEnumFilterInput';
  NOT?: StepChecklistDocumentFormatEnumFilterInput | null;
  eq?: StepChecklistDocumentFormatEnum[] | null;
}

export interface SqlExportRunInput {
  __typename?: 'SqlExportRunInput';
  clientMutationId?: string | null;
}

export interface SqlExportResetPasswordInput {
  __typename?: 'SqlExportResetPasswordInput';
  clientMutationId?: string | null;
}

export interface SqlExportConfigInput {
  __typename?: 'SqlExportConfigInput';
  clientMutationId?: string | null;
  config: SqlExportConfigEntityInput[];
}

export interface SqlExportConfigFieldInput {
  __typename?: 'SqlExportConfigFieldInput';
  cannotRemove?: boolean | null;
  chosen: boolean;
  columnName?: string | null;
  fieldId: string;
  fieldName?: string | null;
  relationActiveWhenEntities?: string[] | null;
  translateFieldName?: boolean | null;
}

export interface SqlExportConfigEntityInput {
  __typename?: 'SqlExportConfigEntityInput';
  chosen: boolean;
  entityName: string;
  fields: SqlExportConfigFieldInput[];
  isRelation?: boolean | null;
  relationActiveWhenEntities?: string[] | null;
  tableName?: string | null;
}

export interface SpawnUnprocessedRunsMutationInput {
  __typename?: 'SpawnUnprocessedRunsMutationInput';
  clientMutationId?: string | null;
}

export interface SimulatedTargetListingOptionsParams {
  __typename?: 'SimulatedTargetListingOptionsParams';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByTargetCalculationType?: TargetCalculationTypeEnum | null;
}

export interface SimulatedTargetIndicatorsParams {
  __typename?: 'SimulatedTargetIndicatorsParams';
  leadClosedCount?: number | null;
  leadCreatedCount?: number | null;
  leadQualifiedCount?: number | null;
  opportunityAverageVelocity?: number | null;
  opportunityClosedCount?: number | null;
  opportunityWonAmount?: number | null;
  opportunityWonCount?: number | null;
  target: number;
}

export interface SimilarAccountsParams {
  __typename?: 'SimilarAccountsParams';
  byFields: boolean;
  fieldIds: UUID[];
}

export interface SharingRoleEnumFilterInput {
  __typename?: 'SharingRoleEnumFilterInput';
  NOT?: SharingRoleEnumFilterInput | null;
  eq?: SharingRoleEnum[] | null;
}

export interface SharingRecord {
  __typename?: 'SharingRecord';
  id: UUID;
  role: SharingRoleEnum;
}

export interface ShareModeParamsEnumFilterInput {
  __typename?: 'ShareModeParamsEnumFilterInput';
  NOT?: ShareModeParamsEnumFilterInput | null;
  eq?: ShareModeParamsEnum[] | null;
}

export interface ShareModeEnumFilterInput {
  __typename?: 'ShareModeEnumFilterInput';
  NOT?: ShareModeEnumFilterInput | null;
  eq?: ShareModeEnum[] | null;
}

export interface SetTaskStatusInput {
  __typename?: 'SetTaskStatusInput';
  clientMutationId?: string | null;
  id: ID;
  newStatus: TaskStatusEnum;
}

export interface SetSettingsGenericTeamSpaceClientSettingInput {
  __typename?: 'SetSettingsGenericTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  encrypt?: boolean | null;
  service: string;
  settings?: string | null;
}

export interface SetScheduleReportInput {
  __typename?: 'SetScheduleReportInput';
  clientMutationId?: string | null;
  id: ID;
  settings: ReportScheduleSchemaParams;
}

export interface SetReminderTaskInput {
  __typename?: 'SetReminderTaskInput';
  clientMutationId?: string | null;
  id: ID;
  setDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface SetReminderAppointmentInput {
  __typename?: 'SetReminderAppointmentInput';
  clientMutationId?: string | null;
  endDateOffset?: number | null;
  id: ID;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface SetProductPriceList {
  __typename?: 'SetProductPriceList';
  operation: SetProductPriceListOperation;
  priceListIds: UUID[];
}

export interface SetPrimaryLookupRelationInput {
  __typename?: 'SetPrimaryLookupRelationInput';
  clientMutationId?: string | null;
  id: ID;
  lookupFieldId: ID;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
}

export interface SetOpptyExcludedInput {
  __typename?: 'SetOpptyExcludedInput';
  clientMutationId?: string | null;
  makeExcluded: boolean;
  opptyId: UUID;
  ownerId?: UUID | null;
}

export interface SetEntitySyncSettingsStatusOptionClientInput {
  __typename?: 'SetEntitySyncSettingsStatusOptionClientInput';
  clientMutationId?: string | null;
  name: string;
  optionType: string;
  value: string;
}

export interface SetEntitySyncSettingsClientInput {
  __typename?: 'SetEntitySyncSettingsClientInput';
  clientMutationId?: string | null;
  name: string;
  onlyWhenOlderThan?: number | null;
  value: string;
}

export interface SetEntityFavoriteInput {
  __typename?: 'SetEntityFavoriteInput';
  accountId?: UUID | null;
  activityId?: UUID | null;
  clientMutationId?: string | null;
  contactId?: UUID | null;
  customEntityId?: UUID | null;
  leadOpptyId?: UUID | null;
  makeFavorite: boolean;
  ownerId?: UUID | null;
  profileId?: UUID | null;
  projectId?: UUID | null;
  quoteId?: UUID | null;
  reportId?: UUID | null;
}

export interface SetClientSettingInput {
  __typename?: 'SetClientSettingInput';
  clientMutationId?: string | null;
  name: string;
  value: string;
}

export interface SetAsFailedAutomationHubItemInput {
  __typename?: 'SetAsFailedAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ServiceAuthorizeTeamSpaceClientSettingInput {
  __typename?: 'ServiceAuthorizeTeamSpaceClientSettingInput';
  authCode: string;
  clientMutationId?: string | null;
  redirectUrl?: string | null;
  service: GenericServiceTypeEnum;
  url: string;
}

export interface SequencePropertyParams {
  __typename?: 'SequencePropertyParams';
  defaultItem: SequenceItemPropertyParams;
  items: SequenceItemPropertyParams[];
}

export interface SequenceParticlePropertyParams {
  __typename?: 'SequenceParticlePropertyParams';
  month: number;
  sequenceNumber: number;
  year: number;
}

export interface SequenceItemPropertyParams {
  __typename?: 'SequenceItemPropertyParams';
  filter?: FieldFilterParams | null;
  id?: ID | null;
  lastParticle?: SequenceParticlePropertyParams | null;
  pattern: string;
}

export interface SendgridDeactivateTeamSpaceClientSettingInput {
  __typename?: 'SendgridDeactivateTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
}

export interface SendgridActivateTeamSpaceClientSettingInput {
  __typename?: 'SendgridActivateTeamSpaceClientSettingInput';
  apiKey: string;
  clientMutationId?: string | null;
  email: string;
  syncEmailReplies: boolean;
}

export interface SendTextMessageRecipientParams {
  __typename?: 'SendTextMessageRecipientParams';
  accountId?: UUID | null;
  contactId?: UUID | null;
  customEntityIds?: CustomEntityIDParams[] | null;
  leadId?: UUID | null;
  opportunityId?: UUID | null;
  phoneNumber: string;
  primary?: EntityLacotaType | null;
  projectId?: UUID | null;
  quoteId?: UUID | null;
}

export interface SendTextMessageInput {
  __typename?: 'SendTextMessageInput';
  attachments?: UUID[] | null;
  body: string;
  clientMutationId?: string | null;
  linkedItems?: SendEmailLinkedEntityParams[] | null;
  recipient: SendTextMessageRecipientParams;
  senderPhoneId: UUID;
}

export interface SendReportInput {
  __typename?: 'SendReportInput';
  clientMutationId?: string | null;
  email: ScheduledReportEmailParams;
  followUp?: EmailFollowUpTaskParams | null;
  id: ID;
  skipEmpty?: boolean | null;
}

export interface SendMassTextMessageInput {
  __typename?: 'SendMassTextMessageInput';
  attachments?: UUID[] | null;
  body: string;
  clientMutationId?: string | null;
  linkRecords?: boolean | null;
  recipients: SendTextMessageRecipientParams[];
  senderPhoneId: UUID;
}

export interface SendInvitationsAppointmentInput {
  __typename?: 'SendInvitationsAppointmentInput';
  clientMutationId?: string | null;
  emails: string[];
  id: ID;
}

export interface SendFeaturePromotionEmailInput {
  __typename?: 'SendFeaturePromotionEmailInput';
  clientMutationId?: string | null;
  description?: string | null;
  featureName: string;
}

export interface SendEmailToSupportInput {
  __typename?: 'SendEmailToSupportInput';
  clientMutationId?: string | null;
  description?: string | null;
}

export interface SendEmailServiceParams {
  __typename?: 'SendEmailServiceParams';
  companyAccountId?: UUID | null;
  personalAccount?: EmailServiceTypeEnum | null;
  personalAccountClientId?: UUID | null;
}

export interface SendEmailRecipientParams {
  __typename?: 'SendEmailRecipientParams';
  accountId?: UUID | null;
  address: string;
  contactId?: UUID | null;
  customEntityIds?: CustomEntityIDParams[] | null;
  leadId?: UUID | null;
  opportunityId?: UUID | null;
  primary?: EntityLacotaType | null;
  projectId?: UUID | null;
  quoteId?: UUID | null;
}

export interface SendEmailLinkedEntityParams {
  __typename?: 'SendEmailLinkedEntityParams';
  accountId?: UUID | null;
  contactId?: UUID | null;
  customEntityId?: CustomEntityIDParams | null;
  leadOpptyId?: UUID | null;
  projectId?: UUID | null;
  quoteId?: UUID | null;
}

export interface SendEmailInputParams {
  __typename?: 'SendEmailInputParams';
  attachments?: UUID[] | null;
  bcc?: SendEmailRecipientParams[] | null;
  cc?: SendEmailRecipientParams[] | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: UUID[] | null;
  contentSharingUnits?: UUID[] | null;
  emailTemplateId?: UUID | null;
  enrollEmailSequenceId?: UUID | null;
  html: string;
  massMail?: boolean | null;
  massMailWithLinkedRecords?: boolean | null;
  personifyBy?: PersonificationEntityDataParams | null;
  recipients?: SendEmailRecipientParams[] | null;
  replyTo?: UUID | null;
  sendToUnsubscribed?: boolean | null;
  service?: SendEmailServiceParams | null;
  standardEmailLinkOnlyAdditionalItems?: boolean | null;
  standardMailAdditionalLinkedItems?: SendEmailLinkedEntityParams[] | null;
  subject: string;
  testMail?: boolean | null;
  tracked?: boolean | null;
}

export interface SendEmailInput {
  __typename?: 'SendEmailInput';
  attachments?: UUID[] | null;
  bcc?: SendEmailRecipientParams[] | null;
  cc?: SendEmailRecipientParams[] | null;
  clientMutationId?: string | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: UUID[] | null;
  contentSharingUnits?: UUID[] | null;
  emailTemplateId?: UUID | null;
  enrollEmailSequenceId?: UUID | null;
  html: string;
  massMail?: boolean | null;
  massMailWithLinkedRecords?: boolean | null;
  personifyBy?: PersonificationEntityDataParams | null;
  recipients?: SendEmailRecipientParams[] | null;
  replyTo?: UUID | null;
  sendToUnsubscribed?: boolean | null;
  service?: SendEmailServiceParams | null;
  standardEmailLinkOnlyAdditionalItems?: boolean | null;
  standardMailAdditionalLinkedItems?: SendEmailLinkedEntityParams[] | null;
  subject: string;
  testMail?: boolean | null;
  tracked?: boolean | null;
}

export interface SendEmailFollowupTaskSettingsParams {
  __typename?: 'SendEmailFollowupTaskSettingsParams';
  description: string;
  dueDate: DateTime;
  status: TaskStatusEnum;
  subject: string;
  taskTypeId: UUID;
}

export interface SelectionEntityParams {
  __typename?: 'SelectionEntityParams';
  entityApiName?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
}

export interface ScreensDefaultProfilesParamsParams {
  __typename?: 'ScreensDefaultProfilesParamsParams';
  Accountscreen: UUID;
  Activityscreen: UUID;
  Archivescreen: UUID;
  BetterNavigatorscreen: UUID;
  Contactscreen: UUID;
  Conversionsscreen: UUID;
  Feedscreen2: UUID;
  Indicatorsscreen: UUID;
  Insightsscreen: UUID;
  LeadArchivescreen: UUID;
  Leadscreen: UUID;
  Lifecyclescreen: UUID;
  Navigator: UUID;
  Pipelinescreen: UUID;
  Projectscreen: UUID;
  QuoteArchivescreen: UUID;
  Quotescreen: UUID;
}

export interface ScreenTypeEnumFilterInput {
  __typename?: 'ScreenTypeEnumFilterInput';
  NOT?: ScreenTypeEnumFilterInput | null;
  eq?: ScreenTypeEnum[] | null;
}

export interface ScheduledReportEmailParams {
  __typename?: 'ScheduledReportEmailParams';
  attachments: UUID[];
  bcc: SendEmailRecipientParams[];
  body: string;
  cc: SendEmailRecipientParams[];
  emailTemplateId?: UUID | null;
  linkRecipients?: boolean | null;
  recipients: SendEmailRecipientParams[];
  reportAttachment?: ScheduledReportEmailAttachmentParams | null;
  service: SendEmailServiceParams;
  signature?: string | null;
  subject: string;
}

export interface ScheduledReportEmailAttachmentParams {
  __typename?: 'ScheduledReportEmailAttachmentParams';
  compress?: boolean | null;
  formatCsv?: CsvOptionsParams | null;
  formatHtml?: boolean | null;
  formatPdf?: PdfOptionsParams | null;
  formatXlsx?: XlsxOptionsParams | null;
  isPasswordEncrypted?: boolean | null;
  password?: string | null;
}

export interface ScheduleIntegrationInitSyncInput {
  __typename?: 'ScheduleIntegrationInitSyncInput';
  clientMutationId?: string | null;
  ruleId: UUID;
  serviceType: GenericServiceTypeEnum;
  syncDirection: SyncDirectionEnum;
}

export interface ScheduleEmailInput {
  __typename?: 'ScheduleEmailInput';
  attachments?: UUID[] | null;
  bcc?: SendEmailRecipientParams[] | null;
  cc?: SendEmailRecipientParams[] | null;
  clientMutationId?: string | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: UUID[] | null;
  contentSharingUnits?: UUID[] | null;
  emailTemplateId?: UUID | null;
  enrollEmailSequenceId?: UUID | null;
  html: string;
  isHtmlTemplate?: boolean | null;
  isLinkEntitiesEnabled?: boolean | null;
  linkedItems?: SendEmailLinkedEntityParams[] | null;
  logEmailAsTask?: SendEmailFollowupTaskSettingsParams | null;
  logFollowUpTask?: SendEmailFollowupTaskSettingsParams | null;
  massMail?: boolean | null;
  massMailWithLinkedRecords?: boolean | null;
  personifyBy?: PersonificationEntityDataParams | null;
  primaryEntity?: EntityNameEnum | null;
  recipients?: SendEmailRecipientParams[] | null;
  replyTo?: UUID | null;
  sendAt: DateTime;
  sendToUnsubscribed?: boolean | null;
  service?: SendEmailServiceParams | null;
  standardEmailLinkOnlyAdditionalItems?: boolean | null;
  standardMailAdditionalLinkedItems?: SendEmailLinkedEntityParams[] | null;
  subject: string;
}

export interface SankeyDrilldownInput {
  __typename?: 'SankeyDrilldownInput';
  linkNodeId?: string | null;
  nodeIds: string[];
}

export interface SalesUnitOrderByNestedInput {
  __typename?: 'SalesUnitOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface SalesUnitOrderByInput {
  __typename?: 'SalesUnitOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parent?: SalesUnitOrderByNestedInput[] | null;
  parentId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface SalesUnitFilterInput {
  __typename?: 'SalesUnitFilterInput';
  AND?: SalesUnitFilterInput[] | null;
  NOT?: SalesUnitFilterInput | null;
  OR?: SalesUnitFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  parent?: SalesUnitFilterInput | null;
  parentId?: EntityFilterStringField | null;
  picture?: CloudObjectFilterInput | null;
  pictureId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface SalesUnitClientRelationOrderByInput {
  __typename?: 'SalesUnitClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  unitRole?: OrderByEnum | null;
}

export interface SalesUnitClientRelationFilterInput {
  __typename?: 'SalesUnitClientRelationFilterInput';
  AND?: SalesUnitClientRelationFilterInput[] | null;
  NOT?: SalesUnitClientRelationFilterInput | null;
  OR?: SalesUnitClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  unitRole?: UnitRoleEnumFilterInput | null;
}

export interface SalesRoleOrderByNestedInput {
  __typename?: 'SalesRoleOrderByNestedInput';
  colorCode?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface SalesRoleOrderByInput {
  __typename?: 'SalesRoleOrderByInput';
  colorCode?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface SalesRoleFilterInput {
  __typename?: 'SalesRoleFilterInput';
  AND?: SalesRoleFilterInput[] | null;
  NOT?: SalesRoleFilterInput | null;
  OR?: SalesRoleFilterInput[] | null;
  colorCode?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface RollupPropertyParams {
  __typename?: 'RollupPropertyParams';
  aggregationFunction: RollupFieldAggregationFunctionEnum;
  entityApiName?: string | null;
  entityRelationId?: ID | null;
  fieldId?: ID | null;
  filter?: FieldFilterParams | null;
  sortFieldId?: ID | null;
  targetEntity: EntityNameEnum;
}

export interface RevenueSchedulePeriodTypeEnumFilterInput {
  __typename?: 'RevenueSchedulePeriodTypeEnumFilterInput';
  NOT?: RevenueSchedulePeriodTypeEnumFilterInput | null;
  eq?: RevenueSchedulePeriodTypeEnum[] | null;
}

export interface RetryMediaTranscriptionInput {
  __typename?: 'RetryMediaTranscriptionInput';
  clientMutationId?: string | null;
  entityId: ID;
}

export interface ResubmitCheckApprovalInput {
  __typename?: 'ResubmitCheckApprovalInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ResubmitApprovalInput {
  __typename?: 'ResubmitApprovalInput';
  clientMutationId?: string | null;
  comment?: string | null;
  id: ID;
}

export interface RestoreTaskInput {
  __typename?: 'RestoreTaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreQuoteInput {
  __typename?: 'RestoreQuoteInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreProjectInput {
  __typename?: 'RestoreProjectInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreOpportunityInput {
  __typename?: 'RestoreOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreLeadInput {
  __typename?: 'RestoreLeadInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreDataInput {
  __typename?: 'RestoreDataInput';
  clientMutationId?: string | null;
  id: ID;
  sortOrder: number;
}

export interface RestoreContactInput {
  __typename?: 'RestoreContactInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreClientInput {
  __typename?: 'RestoreClientInput';
  clientMutationId?: string | null;
  entity?: UpdateClientInput | null;
  id: ID;
}

export interface RestoreAppointmentInput {
  __typename?: 'RestoreAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RestoreAccountInput {
  __typename?: 'RestoreAccountInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ResponseAcceptanceThresholdProductsLimitsParams {
  __typename?: 'ResponseAcceptanceThresholdProductsLimitsParams';
  limits: OnlineFormProductsResponseLimitParams[];
  operator: FilterGroupOperator;
}

export interface ResponseAcceptanceThresholdCustomConditionParams {
  __typename?: 'ResponseAcceptanceThresholdCustomConditionParams';
  formula: string;
  maxValueForAllResponses: number;
  maxValuePerResponse: number;
}

export interface RespondToApprovalInput {
  __typename?: 'RespondToApprovalInput';
  clientMutationId?: string | null;
  comment?: string | null;
  id: ID;
  status: ApprovalStatusEnum;
}

export interface RespondToAppointmentInvitationInput {
  __typename?: 'RespondToAppointmentInvitationInput';
  clientMutationId?: string | null;
  id: ID;
  response: InviteeResponseEnum;
}

export interface ResetStepStatisticsEmailSequenceInput {
  __typename?: 'ResetStepStatisticsEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ResetStatisticsEmailSequenceInput {
  __typename?: 'ResetStatisticsEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ResetPasswordClientInput {
  __typename?: 'ResetPasswordClientInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ResetEmailNotificationsStatusInput {
  __typename?: 'ResetEmailNotificationsStatusInput';
  clientMutationId?: string | null;
}

export interface RequestRemoveAutomationHubItemInput {
  __typename?: 'RequestRemoveAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RequestMethodEnumFilterInput {
  __typename?: 'RequestMethodEnumFilterInput';
  NOT?: RequestMethodEnumFilterInput | null;
  eq?: RequestMethodEnum[] | null;
}

export interface RequestMediaTranscriptionInput {
  __typename?: 'RequestMediaTranscriptionInput';
  clientMutationId?: string | null;
  description: string;
  fileType: CloudObjectTypeEnum;
  transcriptionLanguage: string;
  url: string;
}

export interface RequestCustomSolutionAutomationHubItemInput {
  __typename?: 'RequestCustomSolutionAutomationHubItemInput';
  clientMutationId?: string | null;
  details: string;
  name: string;
}

export interface RequestAddAutomationHubItemInput {
  __typename?: 'RequestAddAutomationHubItemInput';
  clientMutationId?: string | null;
  configuration?: JSONString | null;
  id: ID;
}

export interface ReportTypeEnumFilterInput {
  __typename?: 'ReportTypeEnumFilterInput';
  NOT?: ReportTypeEnumFilterInput | null;
  eq?: ReportTypeEnum[] | null;
}

export interface ReportSharingSalesUnitRelationOrderByInput {
  __typename?: 'ReportSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  report?: ReportOrderByNestedInput[] | null;
  reportId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ReportSharingSalesUnitRelationFilterInput {
  __typename?: 'ReportSharingSalesUnitRelationFilterInput';
  AND?: ReportSharingSalesUnitRelationFilterInput[] | null;
  NOT?: ReportSharingSalesUnitRelationFilterInput | null;
  OR?: ReportSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  report?: ReportFilterInput | null;
  reportId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ReportSharingClientRelationOrderByInput {
  __typename?: 'ReportSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  report?: ReportOrderByNestedInput[] | null;
  reportId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface ReportSharingClientRelationFilterInput {
  __typename?: 'ReportSharingClientRelationFilterInput';
  AND?: ReportSharingClientRelationFilterInput[] | null;
  NOT?: ReportSharingClientRelationFilterInput | null;
  OR?: ReportSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  report?: ReportFilterInput | null;
  reportId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface ReportScheduleSchemaParams {
  __typename?: 'ReportScheduleSchemaParams';
  email: ScheduledReportEmailParams;
  followUp?: EmailFollowUpTaskParams | null;
  schedule: ReportScheduleParams;
  skipEmpty: boolean;
  timezone?: string | null;
  workingDaysOnly?: boolean | null;
}

export interface ReportScheduleParams {
  __typename?: 'ReportScheduleParams';
  date?: DateTime | null;
  dayOfMonth?: number[] | null;
  dayOfWeek?: number[] | null;
  timeOfDay?: number | null;
}

export interface ReportScheduleOrderByNestedInput {
  __typename?: 'ReportScheduleOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  reportId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ReportScheduleOrderByInput {
  __typename?: 'ReportScheduleOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  report?: ReportOrderByNestedInput[] | null;
  reportId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ReportScheduleFilterInput {
  __typename?: 'ReportScheduleFilterInput';
  AND?: ReportScheduleFilterInput[] | null;
  NOT?: ReportScheduleFilterInput | null;
  OR?: ReportScheduleFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  report?: ReportFilterInput | null;
  reportId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ReportOrderByNestedInput {
  __typename?: 'ReportOrderByNestedInput';
  accessLink?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  reportsFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  syncEnabled?: OrderByEnum | null;
  syncEntityId?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ReportOrderByInput {
  __typename?: 'ReportOrderByInput';
  accessLink?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  reportsFolder?: ReportFolderOrderByNestedInput[] | null;
  reportsFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  schedule?: ReportScheduleOrderByNestedInput[] | null;
  shareMode?: OrderByEnum | null;
  syncEnabled?: OrderByEnum | null;
  syncEntity?: ProfileOrderByNestedInput[] | null;
  syncEntityId?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ReportFolderOrderByNestedInput {
  __typename?: 'ReportFolderOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentReportFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ReportFolderOrderByInput {
  __typename?: 'ReportFolderOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentReportFolder?: ReportFolderOrderByNestedInput[] | null;
  parentReportFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ReportFolderFilterInput {
  __typename?: 'ReportFolderFilterInput';
  AND?: ReportFolderFilterInput[] | null;
  NOT?: ReportFolderFilterInput | null;
  OR?: ReportFolderFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  parentReportFolder?: ReportFolderFilterInput | null;
  parentReportFolderId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ReportFilterInput {
  __typename?: 'ReportFilterInput';
  AND?: ReportFilterInput[] | null;
  NOT?: ReportFilterInput | null;
  OR?: ReportFilterInput[] | null;
  accessLink?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  reportsFolder?: ReportFolderFilterInput | null;
  reportsFolderId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  schedule?: ReportScheduleFilterInput | null;
  shareMode?: ShareModeEnumFilterInput | null;
  shareModeParams?: ShareModeParamsEnumFilterInput | null;
  sharingClients?: ReportSharingClientRelationFilterInput | null;
  sharingUnits?: ReportSharingSalesUnitRelationFilterInput | null;
  syncEnabled?: boolean | null;
  syncEntity?: ProfileFilterInput | null;
  syncEntityId?: EntityFilterStringField | null;
  type?: ReportTypeEnumFilterInput | null;
}

export interface ReopenProjectInput {
  __typename?: 'ReopenProjectInput';
  clientMutationId?: string | null;
  endDate: GqlDate;
  id: ID;
  startDate: GqlDate;
}

export interface RemoveTargetInput {
  __typename?: 'RemoveTargetInput';
  childTargetId: UUID;
  clientMutationId?: string | null;
  parentTargetId: UUID;
}

export interface RemoveScheduleReportInput {
  __typename?: 'RemoveScheduleReportInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RemoveReminderTaskInput {
  __typename?: 'RemoveReminderTaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RemoveReminderAppointmentInput {
  __typename?: 'RemoveReminderAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface RemoveRecordsFromExistingStaticProfilesProfileInput {
  __typename?: 'RemoveRecordsFromExistingStaticProfilesProfileInput';
  clientMutationId?: string | null;
  profileIds: UUID[];
  recordIds: BulkOperationInput;
}

export interface RemoveQuoteProcessStepInput {
  __typename?: 'RemoveQuoteProcessStepInput';
  clientMutationId?: string | null;
  id: ID;
  moveDocuments: boolean;
  moveStepFields: boolean;
  stepId: ID;
  targetStepId: ID;
}

export interface RemovePipelineStepInput {
  __typename?: 'RemovePipelineStepInput';
  clientMutationId?: string | null;
  id: ID;
  moveDocuments: boolean;
  moveStepFields: boolean;
  stepId: ID;
  targetStepId: ID;
}

export interface RemoveLeadProcessStepInput {
  __typename?: 'RemoveLeadProcessStepInput';
  clientMutationId?: string | null;
  id: ID;
  moveDocuments: boolean;
  moveStepFields: boolean;
  stepId: ID;
  targetStepId: ID;
}

export interface RemoveClientFromUnitClientInput {
  __typename?: 'RemoveClientFromUnitClientInput';
  clientMutationId?: string | null;
  id: ID;
  unitId: ID;
}

export interface RemoveAutomationHubItemInput {
  __typename?: 'RemoveAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ReminderStatusEnumFilterInput {
  __typename?: 'ReminderStatusEnumFilterInput';
  NOT?: ReminderStatusEnumFilterInput | null;
  eq?: ReminderStatusEnum[] | null;
}

export interface ReloadCloudObjectTemplateInput {
  __typename?: 'ReloadCloudObjectTemplateInput';
  clientMutationId?: string | null;
  entityId: ID;
  sessionId: UUID;
  templateId: ID;
}

export interface ReleaseOwnershipTaskInput {
  __typename?: 'ReleaseOwnershipTaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ReleaseOwnershipLeadInput {
  __typename?: 'ReleaseOwnershipLeadInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ReleaseNoteOrderByInput {
  __typename?: 'ReleaseNoteOrderByInput';
  actionLabel?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  lastUserReaction?: OrderByEnum | null;
  publishedAt?: OrderByEnum | null;
  reactionNegativeCount?: OrderByEnum | null;
  reactionNeutralCount?: OrderByEnum | null;
  reactionPositiveCount?: OrderByEnum | null;
  tag?: OrderByEnum | null;
  title?: OrderByEnum | null;
  uniqueViewCount?: OrderByEnum | null;
  url?: OrderByEnum | null;
  viewCount?: OrderByEnum | null;
}

export interface ReleaseNoteFilterInput {
  __typename?: 'ReleaseNoteFilterInput';
  AND?: ReleaseNoteFilterInput[] | null;
  NOT?: ReleaseNoteFilterInput | null;
  OR?: ReleaseNoteFilterInput[] | null;
  actionLabel?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  isActive?: boolean | null;
  lastUserReaction?: UserReactionEnum | null;
  publishedAt?: EntityFilterDateTimeField | null;
  reactionNegativeCount?: number | null;
  reactionNeutralCount?: number | null;
  reactionPositiveCount?: number | null;
  tag?: EntityFilterStringField | null;
  title?: EntityFilterStringField | null;
  uniqueViewCount?: number | null;
  url?: EntityFilterStringField | null;
  viewCount?: number | null;
}

export interface RelationTypeFilterInput {
  __typename?: 'RelationTypeFilterInput';
  NOT?: RelationTypeFilterInput | null;
  eq?: RelationType[] | null;
}

export interface RelationFieldTabSettingsFilterParams {
  __typename?: 'RelationFieldTabSettingsFilterParams';
  ownerId?: UUID[] | null;
}

export interface RelatedQuoteTabDataGridViewOptionsParams {
  __typename?: 'RelatedQuoteTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  relatedQuotes: boolean;
  searchQuery?: string | null;
}

export interface RelatedOpportunityTabDataGridViewOptionsParams {
  __typename?: 'RelatedOpportunityTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByPipelineId?: ID[] | null;
  filterByStatus?: OpptyStatusEnum[] | null;
  filterByTags?: ID[] | null;
  relatedOpportunities: boolean;
  searchQuery?: string | null;
}

export interface RelatedLeadTabDataGridViewOptionsParams {
  __typename?: 'RelatedLeadTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStatus?: LeadStatusEnum[] | null;
  filterByTags?: ID[] | null;
  relatedLeads: boolean;
  searchQuery?: string | null;
}

export interface RelatedEntityReportFilterParams {
  __typename?: 'RelatedEntityReportFilterParams';
  directRelations?: boolean | null;
  entityType: EntityNameEnum;
  id: UUID;
}

export interface RefreshTokenInput {
  __typename?: 'RefreshTokenInput';
  refreshToken: string;
}

export interface RefreshIndexesInput {
  __typename?: 'RefreshIndexesInput';
  clientMutationId?: string | null;
  dryRun?: boolean | null;
}

export interface RecurrenceTypeEnumFilterInput {
  __typename?: 'RecurrenceTypeEnumFilterInput';
  NOT?: RecurrenceTypeEnumFilterInput | null;
  eq?: RecurrenceTypeEnum[] | null;
}

export interface RecurrenceConditionEnumFilterInput {
  __typename?: 'RecurrenceConditionEnumFilterInput';
  NOT?: RecurrenceConditionEnumFilterInput | null;
  eq?: RecurrenceConditionEnum[] | null;
}

export interface RectangleParams {
  __typename?: 'RectangleParams';
  height: number;
  width: number;
  x: number;
  y: number;
}

export interface RecordConversionOptions {
  __typename?: 'RecordConversionOptions';
  archiveAllRelatedAccounts?: boolean | null;
  archiveAllRelatedContacts?: boolean | null;
  archiveAllRelatedLeads?: boolean | null;
  archiveAllRelatedOpportunities?: boolean | null;
  archiveAllRelatedQuotes?: boolean | null;
  completeAllRelatedProjects?: boolean | null;
  completeAllRelatedTasks?: boolean | null;
}

export interface RecentlyOpenedEntityParams {
  __typename?: 'RecentlyOpenedEntityParams';
  dateTime?: DateTime | null;
  entityApiName?: string | null;
  entityName?: RecentlyOpenedEntityType | null;
  id?: ID | null;
}

export interface RecalculateEntityScoringSingleInput {
  __typename?: 'RecalculateEntityScoringSingleInput';
  clientMutationId?: string | null;
  entityId: UUID;
  entityType: EntityNameEnum;
}

export interface RecalculateEntityScoringInput {
  __typename?: 'RecalculateEntityScoringInput';
  clientMutationId?: string | null;
  entityType: BaseEntityTypeEnum;
}

export interface RecalculateEntityHealthSingleInput {
  __typename?: 'RecalculateEntityHealthSingleInput';
  clientMutationId?: string | null;
  entityId: UUID;
  entityType: BaseEntityTypeEnum;
}

export interface RecalculateEntityHealthAllInput {
  __typename?: 'RecalculateEntityHealthAllInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ReassignClientInput {
  __typename?: 'ReassignClientInput';
  clientMutationId?: string | null;
  id: ID;
  newEmail: string;
}

export interface ReactivateQuoteInput {
  __typename?: 'ReactivateQuoteInput';
  clientMutationId?: string | null;
  closingDate?: GqlDate | null;
  id: UUID;
}

export interface ReactivateLeadOpptyInput {
  __typename?: 'ReactivateLeadOpptyInput';
  clientMutationId?: string | null;
  closingDate?: GqlDate | null;
  id: UUID;
}

export interface ReactivateLeadInput {
  __typename?: 'ReactivateLeadInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ReactivateContactInput {
  __typename?: 'ReactivateContactInput';
  clientMutationId?: string | null;
  id: UUID;
}

export interface ReactivateAccountInput {
  __typename?: 'ReactivateAccountInput';
  clientMutationId?: string | null;
  id: UUID;
}

export interface QuotesNotificationSettingsParams {
  __typename?: 'QuotesNotificationSettingsParams';
  IsActive: boolean;
  LinkedItem: boolean;
  Move: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface QuoteTypeOrderByNestedInput {
  __typename?: 'QuoteTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  formLostEnabled?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  quoteProcessId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteTypeOrderByInput {
  __typename?: 'QuoteTypeOrderByInput';
  created?: OrderByEnum | null;
  formLostEnabled?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  quoteProcess?: QuoteProcessOrderByNestedInput[] | null;
  quoteProcessId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteTypeFilterInput {
  __typename?: 'QuoteTypeFilterInput';
  AND?: QuoteTypeFilterInput[] | null;
  NOT?: QuoteTypeFilterInput | null;
  OR?: QuoteTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  formLostEnabled?: boolean | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  quoteProcess?: QuoteProcessFilterInput | null;
  quoteProcessId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface QuoteTabDataGridViewOptionsParams {
  __typename?: 'QuoteTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  searchQuery?: string | null;
}

export interface QuoteStatusEnumFilterInput {
  __typename?: 'QuoteStatusEnumFilterInput';
  NOT?: QuoteStatusEnumFilterInput | null;
  eq?: QuoteStatusEnum[] | null;
}

export interface QuoteSharingSalesUnitRelationOrderByInput {
  __typename?: 'QuoteSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface QuoteSharingSalesUnitRelationFilterInput {
  __typename?: 'QuoteSharingSalesUnitRelationFilterInput';
  AND?: QuoteSharingSalesUnitRelationFilterInput[] | null;
  NOT?: QuoteSharingSalesUnitRelationFilterInput | null;
  OR?: QuoteSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface QuoteSharingClientRelationOrderByInput {
  __typename?: 'QuoteSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface QuoteSharingClientRelationFilterInput {
  __typename?: 'QuoteSharingClientRelationFilterInput';
  AND?: QuoteSharingClientRelationFilterInput[] | null;
  NOT?: QuoteSharingClientRelationFilterInput | null;
  OR?: QuoteSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface QuoteRoleTabParams {
  __typename?: 'QuoteRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface QuoteProfileDataInput {
  __typename?: 'QuoteProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: QuotePreviewProfileParams;
}

export interface QuoteProcessOrderByNestedInput {
  __typename?: 'QuoteProcessOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteProcessOrderByInput {
  __typename?: 'QuoteProcessOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteProcessFilterInput {
  __typename?: 'QuoteProcessFilterInput';
  AND?: QuoteProcessFilterInput[] | null;
  NOT?: QuoteProcessFilterInput | null;
  OR?: QuoteProcessFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface QuotePreviewViewTabParams {
  __typename?: 'QuotePreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  groupBy?: QuoteGroupBy | null;
  showExtraFieldIds?: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface QuotePreviewProfileParams {
  __typename?: 'QuotePreviewProfileParams';
  filter: QuoteFilterTabParams;
  quickFilter: QuickFilterTabParams;
  quoteProcess?: UUID[] | null;
  role: QuoteRoleTabParams;
  view: QuotePreviewViewTabParams;
}

export interface QuoteOrderByNestedInput {
  __typename?: 'QuoteOrderByNestedInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  expirationDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  productPriceListId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  quoteNumber?: OrderByEnum | null;
  quoteTypeId?: OrderByEnum | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepId?: OrderByEnum | null;
  totalAmount?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  version?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface QuoteOrderByInput {
  __typename?: 'QuoteOrderByInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  expirationDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  productPriceList?: ProductPriceListOrderByNestedInput[] | null;
  productPriceListId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  quoteNumber?: OrderByEnum | null;
  quoteType?: QuoteTypeOrderByNestedInput[] | null;
  quoteTypeId?: OrderByEnum | null;
  reasonOfClose?: DataOrderByNestedInput[] | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  totalAmount?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  version?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface QuoteKpiEnumFilterInput {
  __typename?: 'QuoteKpiEnumFilterInput';
  NOT?: QuoteKpiEnumFilterInput | null;
  eq?: QuoteKpiEnum[] | null;
}

export interface QuoteKPIOrderByInput {
  __typename?: 'QuoteKPIOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface QuoteKPIFilterInput {
  __typename?: 'QuoteKPIFilterInput';
  AND?: QuoteKPIFilterInput[] | null;
  NOT?: QuoteKPIFilterInput | null;
  OR?: QuoteKPIFilterInput[] | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: QuoteKpiEnumFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface QuoteFilterTabParams {
  __typename?: 'QuoteFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface QuoteFilterInput {
  __typename?: 'QuoteFilterInput';
  AND?: QuoteFilterInput[] | null;
  NOT?: QuoteFilterInput | null;
  OR?: QuoteFilterInput[] | null;
  accountRelations?: QuoteAccountRelationFilterInput | null;
  contactRelations?: QuoteContactRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isArchived?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  pipelineId?: EntityFilterStringField | null;
  primaryAccount?: AccountFilterInput | null;
  primaryContact?: ContactFilterInput | null;
  productCurrency?: CurrencyFilterInput | null;
  productCurrencyId?: EntityFilterStringField | null;
  productPriceList?: ProductPriceListFilterInput | null;
  productPriceListId?: EntityFilterStringField | null;
  productRelations?: OpptyProductRelationFilterInput | null;
  quickAccountEmail?: EntityFilterStringField | null;
  quickAccountName?: EntityFilterStringField | null;
  quickAccountPhone?: EntityFilterStringField | null;
  quickContactName?: EntityFilterStringField | null;
  quickEmail?: EntityFilterStringField | null;
  quickPhone?: EntityFilterStringField | null;
  quoteNumber?: EntityFilterStringField | null;
  quoteType?: QuoteTypeFilterInput | null;
  quoteTypeId?: EntityFilterStringField | null;
  reasonOfClose?: DataFilterInput | null;
  reasonOfCloseDescription?: EntityFilterStringField | null;
  reasonOfCloseId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: QuoteSharingClientRelationFilterInput | null;
  sharingUnits?: QuoteSharingSalesUnitRelationFilterInput | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  status?: QuoteStatusEnumFilterInput | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  version?: EntityFilterNumberField | null;
  withCustom?: CustomField[] | null;
}

export interface QuoteDrilldownFilterParams {
  __typename?: 'QuoteDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface QuoteDataExRelationOrderByInput {
  __typename?: 'QuoteDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteDataExRelationFilterInput {
  __typename?: 'QuoteDataExRelationFilterInput';
  AND?: QuoteDataExRelationFilterInput[] | null;
  NOT?: QuoteDataExRelationFilterInput | null;
  OR?: QuoteDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface QuoteContactRelationOrderByInput {
  __typename?: 'QuoteContactRelationOrderByInput';
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteContactRelationFilterInput {
  __typename?: 'QuoteContactRelationFilterInput';
  AND?: QuoteContactRelationFilterInput[] | null;
  NOT?: QuoteContactRelationFilterInput | null;
  OR?: QuoteContactRelationFilterInput[] | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface QuoteArchiveProfileParams {
  __typename?: 'QuoteArchiveProfileParams';
  filter: QuoteFilterTabParams;
  quickFilter: QuickFilterTabParams;
  quoteProcess?: UUID[] | null;
  role: QuoteRoleTabParams;
  view: QuotePreviewViewTabParams;
}

export interface QuoteArchiveProfileDataInput {
  __typename?: 'QuoteArchiveProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: QuoteArchiveProfileParams;
}

export interface QuoteAccountRelationOrderByInput {
  __typename?: 'QuoteAccountRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface QuoteAccountRelationFilterInput {
  __typename?: 'QuoteAccountRelationFilterInput';
  AND?: QuoteAccountRelationFilterInput[] | null;
  NOT?: QuoteAccountRelationFilterInput | null;
  OR?: QuoteAccountRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface QuickMergeDuplicatesInput {
  __typename?: 'QuickMergeDuplicatesInput';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  input: BulkOperationInput;
  masterRecordResolution?: MasterRecordResolutionEnum | null;
  masterRecordResolutionCustomConditions?: FieldFilterParams | null;
}

export interface QuickFilterTabParams {
  __typename?: 'QuickFilterTabParams';
  filterFieldOrder: UUID[];
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
}

export interface QuickAttachFilesForOnlineFormInput {
  __typename?: 'QuickAttachFilesForOnlineFormInput';
  clientMutationId?: string | null;
  onlineFormIds: UUID[];
}

export interface QualifyLeadInput {
  __typename?: 'QualifyLeadInput';
  clientMutationId?: string | null;
  entity: UpdateOpportunityInput;
}

export interface PurchasePhoneInput {
  __typename?: 'PurchasePhoneInput';
  clientMutationId?: string | null;
  forwardCallsToPhone?: string | null;
  forwardMessagesToEmail?: string | null;
  name: string;
  phoneNumber: string;
  type: PhoneTypeEnum;
}

export interface PublishDeleteDraftsInput {
  __typename?: 'PublishDeleteDraftsInput';
  Accounts?: boolean | null;
  AccountsContacts?: boolean | null;
  Activities?: boolean | null;
  Appointments?: boolean | null;
  Contacts?: boolean | null;
  CustomEntities?: string[] | null;
  LeadsOpportunities?: boolean | null;
  ProductsOpptyProductRelations?: boolean | null;
  Projects?: boolean | null;
  Quotes?: boolean | null;
  Tasks?: boolean | null;
}

export interface PromoteGhostContactInput {
  __typename?: 'PromoteGhostContactInput';
  clientMutationId?: string | null;
  entity: CreateOrUpdateContactInput;
  id: ID;
}

export interface ProlongStoredReportSessionInput {
  __typename?: 'ProlongStoredReportSessionInput';
  clientMutationId?: string | null;
  sessionIds: string[];
  sessionIdsToPurge: string[];
}

export interface ProjectsNotificationSettingsParams {
  __typename?: 'ProjectsNotificationSettingsParams';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface ProjectTypeOrderByNestedInput {
  __typename?: 'ProjectTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProjectTypeOrderByInput {
  __typename?: 'ProjectTypeOrderByInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProjectTypeIconEnumFilterInput {
  __typename?: 'ProjectTypeIconEnumFilterInput';
  NOT?: ProjectTypeIconEnumFilterInput | null;
  eq?: ProjectTypeIconEnum[] | null;
}

export interface ProjectTypeFilterInput {
  __typename?: 'ProjectTypeFilterInput';
  AND?: ProjectTypeFilterInput[] | null;
  NOT?: ProjectTypeFilterInput | null;
  OR?: ProjectTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  icon?: ProjectTypeIconEnumFilterInput | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProjectTabDataGridViewOptionsParams {
  __typename?: 'ProjectTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByPeriod?: PeriodOptionParams | null;
  filterByProjectStatus?: ProjectStatusEnum[] | null;
  filterByTags?: ID[] | null;
  searchQuery?: string | null;
}

export interface ProjectStatusEnumFilterInput {
  __typename?: 'ProjectStatusEnumFilterInput';
  NOT?: ProjectStatusEnumFilterInput | null;
  eq?: ProjectStatusEnum[] | null;
}

export interface ProjectSharingSalesUnitRelationOrderByInput {
  __typename?: 'ProjectSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ProjectSharingSalesUnitRelationFilterInput {
  __typename?: 'ProjectSharingSalesUnitRelationFilterInput';
  AND?: ProjectSharingSalesUnitRelationFilterInput[] | null;
  NOT?: ProjectSharingSalesUnitRelationFilterInput | null;
  OR?: ProjectSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ProjectSharingClientRelationOrderByInput {
  __typename?: 'ProjectSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface ProjectSharingClientRelationFilterInput {
  __typename?: 'ProjectSharingClientRelationFilterInput';
  AND?: ProjectSharingClientRelationFilterInput[] | null;
  NOT?: ProjectSharingClientRelationFilterInput | null;
  OR?: ProjectSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface ProjectRoleTabParams {
  __typename?: 'ProjectRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ProjectProfileDataInput {
  __typename?: 'ProjectProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: ProjectPreviewProfileParams;
}

export interface ProjectPreviewViewTabParams {
  __typename?: 'ProjectPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ProjectPreviewProfileParams {
  __typename?: 'ProjectPreviewProfileParams';
  filter: ProjectFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: ProjectRoleTabParams;
  view: ProjectPreviewViewTabParams;
}

export interface ProjectOrderByNestedInput {
  __typename?: 'ProjectOrderByNestedInput';
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  projectTypeId?: OrderByEnum | null;
  revenueGoal?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface ProjectOrderByInput {
  __typename?: 'ProjectOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  projectType?: ProjectTypeOrderByNestedInput[] | null;
  projectTypeId?: OrderByEnum | null;
  revenueGoal?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface ProjectObjectiveOrderByNestedInput {
  __typename?: 'ProjectObjectiveOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
}

export interface ProjectObjectiveOrderByInput {
  __typename?: 'ProjectObjectiveOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
}

export interface ProjectObjectiveFilterInput {
  __typename?: 'ProjectObjectiveFilterInput';
  AND?: ProjectObjectiveFilterInput[] | null;
  NOT?: ProjectObjectiveFilterInput | null;
  OR?: ProjectObjectiveFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
}

export interface ProjectKpiEnumFilterInput {
  __typename?: 'ProjectKpiEnumFilterInput';
  NOT?: ProjectKpiEnumFilterInput | null;
  eq?: ProjectKpiEnum[] | null;
}

export interface ProjectKPIOrderByInput {
  __typename?: 'ProjectKPIOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ProjectKPIFilterInput {
  __typename?: 'ProjectKPIFilterInput';
  AND?: ProjectKPIFilterInput[] | null;
  NOT?: ProjectKPIFilterInput | null;
  OR?: ProjectKPIFilterInput[] | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: ProjectKpiEnumFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ProjectGanttPeriodOptionsParams {
  __typename?: 'ProjectGanttPeriodOptionsParams';
  period: ProjectGanttPeriod;
  projectId: ID;
}

export interface ProjectFilterTabParams {
  __typename?: 'ProjectFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ProjectFilterInput {
  __typename?: 'ProjectFilterInput';
  AND?: ProjectFilterInput[] | null;
  NOT?: ProjectFilterInput | null;
  OR?: ProjectFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contactRelations?: ProjectContactRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  enrolledEmailSequences?: number | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  primaryContact?: ContactFilterInput | null;
  projectType?: ProjectTypeFilterInput | null;
  projectTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: ProjectSharingClientRelationFilterInput | null;
  sharingUnits?: ProjectSharingSalesUnitRelationFilterInput | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  status?: ProjectStatusEnumFilterInput | null;
  tags?: TagRelationFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface ProjectDrilldownFilterParams {
  __typename?: 'ProjectDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface ProjectDataExRelationOrderByInput {
  __typename?: 'ProjectDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProjectDataExRelationFilterInput {
  __typename?: 'ProjectDataExRelationFilterInput';
  AND?: ProjectDataExRelationFilterInput[] | null;
  NOT?: ProjectDataExRelationFilterInput | null;
  OR?: ProjectDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProjectContactRelationOrderByInput {
  __typename?: 'ProjectContactRelationOrderByInput';
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProjectContactRelationFilterInput {
  __typename?: 'ProjectContactRelationFilterInput';
  AND?: ProjectContactRelationFilterInput[] | null;
  NOT?: ProjectContactRelationFilterInput | null;
  OR?: ProjectContactRelationFilterInput[] | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProfileTypeEnumFilterInput {
  __typename?: 'ProfileTypeEnumFilterInput';
  NOT?: ProfileTypeEnumFilterInput | null;
  eq?: ProfileTypeEnum[] | null;
}

export interface ProfileStandardRoleTabParams {
  __typename?: 'ProfileStandardRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ProfileSharingSalesUnitRelationOrderByInput {
  __typename?: 'ProfileSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  profile?: ProfileOrderByNestedInput[] | null;
  profileId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ProfileSharingSalesUnitRelationFilterInput {
  __typename?: 'ProfileSharingSalesUnitRelationFilterInput';
  AND?: ProfileSharingSalesUnitRelationFilterInput[] | null;
  NOT?: ProfileSharingSalesUnitRelationFilterInput | null;
  OR?: ProfileSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  profile?: ProfileFilterInput | null;
  profileId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ProfileSharingClientRelationOrderByInput {
  __typename?: 'ProfileSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  profile?: ProfileOrderByNestedInput[] | null;
  profileId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProfileSharingClientRelationFilterInput {
  __typename?: 'ProfileSharingClientRelationFilterInput';
  AND?: ProfileSharingClientRelationFilterInput[] | null;
  NOT?: ProfileSharingClientRelationFilterInput | null;
  OR?: ProfileSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  profile?: ProfileFilterInput | null;
  profileId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProfileRelationOrderByInput {
  __typename?: 'ProfileRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  profile?: ProfileOrderByNestedInput[] | null;
  profileId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
}

export interface ProfileRelationFilterInput {
  __typename?: 'ProfileRelationFilterInput';
  AND?: ProfileRelationFilterInput[] | null;
  NOT?: ProfileRelationFilterInput | null;
  OR?: ProfileRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  profile?: ProfileFilterInput | null;
  profileId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
}

export interface ProfileOrderByNestedInput {
  __typename?: 'ProfileOrderByNestedInput';
  created?: OrderByEnum | null;
  entity?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  syncEnabled?: OrderByEnum | null;
  syncEntityId?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface ProfileOrderByInput {
  __typename?: 'ProfileOrderByInput';
  created?: OrderByEnum | null;
  entity?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  syncEnabled?: OrderByEnum | null;
  syncEntity?: ReportOrderByNestedInput[] | null;
  syncEntityId?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface ProfileFilterTabParams {
  __typename?: 'ProfileFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ProfileFilterInput {
  __typename?: 'ProfileFilterInput';
  AND?: ProfileFilterInput[] | null;
  NOT?: ProfileFilterInput | null;
  OR?: ProfileFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entity?: ScreenTypeEnumFilterInput | null;
  entityApiName?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  syncEnabled?: boolean | null;
  syncEntity?: ReportFilterInput | null;
  syncEntityId?: EntityFilterStringField | null;
  type?: ProfileTypeEnumFilterInput | null;
  useLang?: boolean | null;
}

export interface ProductTypeOrderByNestedInput {
  __typename?: 'ProductTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyProductRelationTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductTypeOrderByInput {
  __typename?: 'ProductTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyProductRelationType?: OpptyProductRelationTypeOrderByNestedInput[] | null;
  opptyProductRelationTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductTypeFilterInput {
  __typename?: 'ProductTypeFilterInput';
  AND?: ProductTypeFilterInput[] | null;
  NOT?: ProductTypeFilterInput | null;
  OR?: ProductTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  opptyProductRelationType?: OpptyProductRelationTypeFilterInput | null;
  opptyProductRelationTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProductTabDataGridViewOptionsParams {
  __typename?: 'ProductTabDataGridViewOptionsParams';
  filterByPeriod: PeriodOptionParams;
  filterByPipelineId?: UUID[] | null;
  filterByProductCategoryId?: UUID[] | null;
  showChildProducts: boolean;
}

export interface ProductSectionParams {
  __typename?: 'ProductSectionParams';
  id: ID;
  name: string;
}

export interface ProductPriceListTypeEnumFilterInput {
  __typename?: 'ProductPriceListTypeEnumFilterInput';
  NOT?: ProductPriceListTypeEnumFilterInput | null;
  eq?: ProductPriceListTypeEnum[] | null;
}

export interface ProductPriceListPriceOrderByInput {
  __typename?: 'ProductPriceListPriceOrderByInput';
  created?: OrderByEnum | null;
  currency?: CurrencyOrderByNestedInput[] | null;
  currencyId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  price?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  productPriceList?: ProductPriceListOrderByNestedInput[] | null;
  productPriceListId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductPriceListPriceFilterInput {
  __typename?: 'ProductPriceListPriceFilterInput';
  AND?: ProductPriceListPriceFilterInput[] | null;
  NOT?: ProductPriceListPriceFilterInput | null;
  OR?: ProductPriceListPriceFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  currency?: CurrencyFilterInput | null;
  currencyId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  price?: EntityFilterNumberField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  productPriceList?: ProductPriceListFilterInput | null;
  productPriceListId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProductPriceListOrderByNestedInput {
  __typename?: 'ProductPriceListOrderByNestedInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  isDefault?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ProductPriceListOrderByInput {
  __typename?: 'ProductPriceListOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  isDefault?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ProductPriceListFilterInput {
  __typename?: 'ProductPriceListFilterInput';
  AND?: ProductPriceListFilterInput[] | null;
  NOT?: ProductPriceListFilterInput | null;
  OR?: ProductPriceListFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isActive?: boolean | null;
  isDefault?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  productPriceListPrices?: ProductPriceListPriceFilterInput | null;
  revision?: EntityFilterNumberField | null;
  status?: ProductPriceListStatusEnum | null;
  type?: ProductPriceListTypeEnumFilterInput | null;
}

export interface ProductPipelinesInput {
  __typename?: 'ProductPipelinesInput';
  allowedPipelines: AccessPipelinesEnum;
  pipelines: ID[];
}

export interface ProductPipelineRelationOrderByInput {
  __typename?: 'ProductPipelineRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pipeline?: PipelineOrderByNestedInput[] | null;
  pipelineId?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductPipelineRelationFilterInput {
  __typename?: 'ProductPipelineRelationFilterInput';
  AND?: ProductPipelineRelationFilterInput[] | null;
  NOT?: ProductPipelineRelationFilterInput | null;
  OR?: ProductPipelineRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  pipeline?: PipelineFilterInput | null;
  pipelineId?: EntityFilterStringField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProductOrderByNestedInput {
  __typename?: 'ProductOrderByNestedInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  productCategoryId?: OrderByEnum | null;
  productTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sku?: OrderByEnum | null;
  unitSymbol?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface ProductOrderByInput {
  __typename?: 'ProductOrderByInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  productCategory?: ProductCategoryOrderByNestedInput[] | null;
  productCategoryId?: OrderByEnum | null;
  productType?: ProductTypeOrderByNestedInput[] | null;
  productTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sku?: OrderByEnum | null;
  unitSymbol?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface ProductFilterInput {
  __typename?: 'ProductFilterInput';
  AND?: ProductFilterInput[] | null;
  NOT?: ProductFilterInput | null;
  OR?: ProductFilterInput[] | null;
  allowedForPipeline?: UUID | null;
  allowedPipelines?: AccessPipelinesEnumFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isTypeDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  picture?: CloudObjectFilterInput | null;
  pictureId?: EntityFilterStringField | null;
  productCategory?: ProductCategoryFilterInput | null;
  productCategoryId?: EntityFilterStringField | null;
  productPipelineRelations?: ProductPipelineRelationFilterInput | null;
  productType?: ProductTypeFilterInput | null;
  productTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sku?: EntityFilterStringField | null;
  unitSymbol?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface ProductDataExRelationOrderByInput {
  __typename?: 'ProductDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductDataExRelationFilterInput {
  __typename?: 'ProductDataExRelationFilterInput';
  AND?: ProductDataExRelationFilterInput[] | null;
  NOT?: ProductDataExRelationFilterInput | null;
  OR?: ProductDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProductCategoryOrderByNestedInput {
  __typename?: 'ProductCategoryOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductCategoryOrderByInput {
  __typename?: 'ProductCategoryOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parent?: ProductCategoryOrderByNestedInput[] | null;
  parentId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ProductCategoryFilterInput {
  __typename?: 'ProductCategoryFilterInput';
  AND?: ProductCategoryFilterInput[] | null;
  NOT?: ProductCategoryFilterInput | null;
  OR?: ProductCategoryFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  parent?: ProductCategoryFilterInput | null;
  parentId?: EntityFilterStringField | null;
  productRelations?: ProductFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface ProcessWebhookParams {
  __typename?: 'ProcessWebhookParams';
  advancedContent?: string | null;
  basicAuth?: ProcessWebhookBasicAuthParams | null;
  headers?: ProcessWebhookHeaderParams[] | null;
  requestFormat: ProcessWebhookRequestFormat;
  requestType: ProcessWebhookRequestType;
  simpleContent?: string[] | null;
  timeFormat: ProcessWebhookTimeFormat;
  url: string;
}

export interface ProcessWebhookHeaderParams {
  __typename?: 'ProcessWebhookHeaderParams';
  encrypted?: boolean | null;
  key?: string | null;
  value?: string | null;
}

export interface ProcessWebhookBasicAuthParams {
  __typename?: 'ProcessWebhookBasicAuthParams';
  password?: string | null;
  username?: string | null;
}

export interface ProcessTypeEnumFilterInput {
  __typename?: 'ProcessTypeEnumFilterInput';
  NOT?: ProcessTypeEnumFilterInput | null;
  eq?: ProcessTypeEnum[] | null;
}

export interface ProcessTemplateOrderByNestedInput {
  __typename?: 'ProcessTemplateOrderByNestedInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isRecommended?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
}

export interface ProcessTemplateOrderByInput {
  __typename?: 'ProcessTemplateOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isRecommended?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
}

export interface ProcessTemplateFilterInput {
  __typename?: 'ProcessTemplateFilterInput';
  AND?: ProcessTemplateFilterInput[] | null;
  NOT?: ProcessTemplateFilterInput | null;
  OR?: ProcessTemplateFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isRecommended?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  triggerEntityName?: EntityNameEnum | null;
  triggerType?: ProcessTriggerTypeEnum | null;
}

export interface ProcessTabDataGridViewOptionsParams {
  __typename?: 'ProcessTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStatus?: ProcessStatusEnum[] | null;
  filterByTagIds?: ID[] | null;
  showActive: boolean;
  showInactive: boolean;
}

export interface ProcessStatusEnumFilterInput {
  __typename?: 'ProcessStatusEnumFilterInput';
  NOT?: ProcessStatusEnumFilterInput | null;
  eq?: ProcessStatusEnum[] | null;
}

export interface ProcessScheduledActionOrderByInput {
  __typename?: 'ProcessScheduledActionOrderByInput';
  actionName?: OrderByEnum | null;
  actor?: ClientOrderByNestedInput[] | null;
  actorId?: OrderByEnum | null;
  application?: ClientOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  entityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  process?: ProcessOrderByNestedInput[] | null;
  processId?: OrderByEnum | null;
  scheduledDate?: OrderByEnum | null;
  triggeredDate?: OrderByEnum | null;
}

export interface ProcessScheduledActionFilterInput {
  __typename?: 'ProcessScheduledActionFilterInput';
  AND?: ProcessScheduledActionFilterInput[] | null;
  NOT?: ProcessScheduledActionFilterInput | null;
  OR?: ProcessScheduledActionFilterInput[] | null;
  actionName?: EntityFilterStringField | null;
  actor?: ClientFilterInput | null;
  actorId?: EntityFilterStringField | null;
  application?: ClientFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  entityApiName?: EntityFilterStringField | null;
  entityId?: EntityFilterStringField | null;
  entityName?: EntityNameEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  process?: ProcessFilterInput | null;
  processId?: EntityFilterStringField | null;
  scheduledDate?: EntityFilterDateTimeField | null;
  triggeredDate?: EntityFilterDateTimeField | null;
}

export interface ProcessOrderByNestedInput {
  __typename?: 'ProcessOrderByNestedInput';
  created?: OrderByEnum | null;
  deactivationReason?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastProcessRun?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  recordTriggerEvent?: OrderByEnum | null;
  status?: OrderByEnum | null;
  triggerEntityApiName?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ProcessOrderByInput {
  __typename?: 'ProcessOrderByInput';
  created?: OrderByEnum | null;
  deactivationReason?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastProcessRun?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  recordTriggerEvent?: OrderByEnum | null;
  status?: OrderByEnum | null;
  triggerEntityApiName?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ProcessFilterInput {
  __typename?: 'ProcessFilterInput';
  AND?: ProcessFilterInput[] | null;
  NOT?: ProcessFilterInput | null;
  OR?: ProcessFilterInput[] | null;
  activityLogs?: ProcessActivityLogFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  deactivationReason?: ProcessDeactivationReasonEnumFilterInput | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  lastProcessRun?: DateTime | null;
  lastSchemaChange?: EntityFilterDateTimeField | null;
  lastStatusChange?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  recordTriggerEvent?: ProcessRecordTriggerEventEnum | null;
  status?: ProcessStatusEnum | null;
  tags?: TagRelationFilterInput | null;
  triggerEntityApiName?: string | null;
  triggerEntityName?: EntityNameEnum | null;
  triggerType?: ProcessTriggerTypeEnum | null;
  type?: ProcessTypeEnumFilterInput | null;
}

export interface ProcessEntityTemplateParams {
  __typename?: 'ProcessEntityTemplateParams';
  input: JSONString;
  operations: ProcessEntityOperationParams[];
}

export interface ProcessEntityOperationParams {
  __typename?: 'ProcessEntityOperationParams';
  extras?: ProcessEntityOperationExtrasParams | null;
  fieldId: UUID;
  mapping?: EntityOperationMappingParams | null;
  operation?: ProcessEntityOperationEnum | null;
  triggeredLookupRelationFieldId?: UUID | null;
  triggeredRecordFieldId?: UUID | null;
}

export interface ProcessEntityOperationExtrasParams {
  __typename?: 'ProcessEntityOperationExtrasParams';
  keepOwnerAsEditor?: boolean | null;
  sendInvitations?: boolean | null;
}

export interface ProcessDescriptionInput {
  __typename?: 'ProcessDescriptionInput';
  clientMutationId?: string | null;
  ids: UUID[];
  name: string;
}

export interface ProcessDeactivationReasonEnumFilterInput {
  __typename?: 'ProcessDeactivationReasonEnumFilterInput';
  NOT?: ProcessDeactivationReasonEnumFilterInput | null;
  eq?: ProcessDeactivationReasonEnum[] | null;
}

export interface ProcessBuilderNotificationSettingsParams {
  __typename?: 'ProcessBuilderNotificationSettingsParams';
  Errors: boolean;
  IsActive: boolean;
  Warnings: boolean;
}

export interface ProcessActivityLogOrderByNestedInput {
  __typename?: 'ProcessActivityLogOrderByNestedInput';
  actorId?: OrderByEnum | null;
  applicationId?: OrderByEnum | null;
  cpuRunTime?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTestRun?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  processId?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ProcessActivityLogOrderByInput {
  __typename?: 'ProcessActivityLogOrderByInput';
  actor?: ClientOrderByNestedInput[] | null;
  actorId?: OrderByEnum | null;
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  cpuRunTime?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTestRun?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  process?: ProcessOrderByNestedInput[] | null;
  processId?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ProcessActivityLogLineOrderByInput {
  __typename?: 'ProcessActivityLogLineOrderByInput';
  created?: OrderByEnum | null;
  executedAt?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  processActivityLog?: ProcessActivityLogOrderByNestedInput[] | null;
  processActivityLogId?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ProcessActivityLogLineFilterInput {
  __typename?: 'ProcessActivityLogLineFilterInput';
  AND?: ProcessActivityLogLineFilterInput[] | null;
  NOT?: ProcessActivityLogLineFilterInput | null;
  OR?: ProcessActivityLogLineFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  executedAt?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isVisible?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  processActivityLog?: ProcessActivityLogFilterInput | null;
  processActivityLogId?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface ProcessActivityLogFilterInput {
  __typename?: 'ProcessActivityLogFilterInput';
  AND?: ProcessActivityLogFilterInput[] | null;
  NOT?: ProcessActivityLogFilterInput | null;
  OR?: ProcessActivityLogFilterInput[] | null;
  actor?: ClientFilterInput | null;
  actorId?: EntityFilterStringField | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  cpuRunTime?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  endTime?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isTestRun?: boolean | null;
  lines?: ProcessActivityLogLineFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  process?: ProcessFilterInput | null;
  processId?: EntityFilterStringField | null;
  recordName?: string | null;
  runId?: EntityFilterStringField | null;
  startTime?: EntityFilterDateTimeField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface PriorityEnumFilterInput {
  __typename?: 'PriorityEnumFilterInput';
  NOT?: PriorityEnumFilterInput | null;
  eq?: PriorityEnum[] | null;
}

export interface PrimitiveTypeFilterInput {
  __typename?: 'PrimitiveTypeFilterInput';
  NOT?: PrimitiveTypeFilterInput | null;
  eq?: PrimitiveType[] | null;
}

export interface PreviewPinnedFieldsParams {
  __typename?: 'PreviewPinnedFieldsParams';
  entityTypeId: UUID;
  pinnedFields: UUID[];
}

export interface PreviewPinnedChartsParams {
  __typename?: 'PreviewPinnedChartsParams';
  entityTypeId: UUID;
  pinnedCharts: ID[];
}

export interface PositionParams {
  __typename?: 'PositionParams';
  x: number;
  y: number;
}

export interface PollMessagesInput {
  __typename?: 'PollMessagesInput';
  id: ID;
  since?: DateTime | null;
}

export interface PipelineOrderByNestedInput {
  __typename?: 'PipelineOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface PipelineOrderByInput {
  __typename?: 'PipelineOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface PipelineFilterInput {
  __typename?: 'PipelineFilterInput';
  AND?: PipelineFilterInput[] | null;
  NOT?: PipelineFilterInput | null;
  OR?: PipelineFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface PhoneTypeEnumFilterInput {
  __typename?: 'PhoneTypeEnumFilterInput';
  NOT?: PhoneTypeEnumFilterInput | null;
  eq?: PhoneTypeEnum[] | null;
}

export interface PhoneOrderByNestedInput {
  __typename?: 'PhoneOrderByNestedInput';
  created?: OrderByEnum | null;
  enabled?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  phoneNumber?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  twilioCallerSid?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface PhoneOrderByInput {
  __typename?: 'PhoneOrderByInput';
  created?: OrderByEnum | null;
  enabled?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  phoneNumber?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  twilioCallerSid?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface PhoneFilterInput {
  __typename?: 'PhoneFilterInput';
  AND?: PhoneFilterInput[] | null;
  NOT?: PhoneFilterInput | null;
  OR?: PhoneFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  enabled?: boolean | null;
  errorCode?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  phoneNumber?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  twilioCallerSid?: EntityFilterStringField | null;
  type?: PhoneTypeEnumFilterInput | null;
}

export interface PersonificationEntityDataParams {
  __typename?: 'PersonificationEntityDataParams';
  accountId?: UUID | null;
  contactId?: UUID | null;
  customEntityIds?: CustomEntityIDParams[] | null;
  leadId?: UUID | null;
  opportunityId?: UUID | null;
  primary?: EntityLacotaType | null;
  projectId?: UUID | null;
  quoteId?: UUID | null;
}

export interface PersonalizeBodyForSharingEmailTemplateInput {
  __typename?: 'PersonalizeBodyForSharingEmailTemplateInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface PersonalizeBodyEmailTemplateInput {
  __typename?: 'PersonalizeBodyEmailTemplateInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityId?: UUID | null;
  entityType?: EntityNameEnum | null;
  id: ID;
}

export interface PeriodOptionParams {
  __typename?: 'PeriodOptionParams';
  period: PeriodKind;
  periodCustomFrom?: GqlDate | null;
  periodCustomTo?: GqlDate | null;
}

export interface PeriodCompareOptionParams {
  __typename?: 'PeriodCompareOptionParams';
  period: PeriodCompareKind;
  periodCustomFrom?: GqlDate | null;
  periodCustomTo?: GqlDate | null;
}

export interface PdfOptionsParams {
  __typename?: 'PdfOptionsParams';
  content: ReportContent;
  landscape: boolean;
  pageHeight: number;
  pageNumbers: boolean;
  pageWidth: number;
  scale: number;
}

export interface PartnerTierFilterInput {
  __typename?: 'PartnerTierFilterInput';
  NOT?: PartnerTierFilterInput | null;
  eq?: PartnerTier[] | null;
}

export interface PartnerTargetCustomersFilterInput {
  __typename?: 'PartnerTargetCustomersFilterInput';
  NOT?: PartnerTargetCustomersFilterInput | null;
  eq?: PartnerTargetCustomers[] | null;
}

export interface PartnerFilterInput {
  __typename?: 'PartnerFilterInput';
  AND?: PartnerFilterInput[] | null;
  NOT?: PartnerFilterInput | null;
  OR?: PartnerFilterInput[] | null;
  activeCustomers?: PartnerActiveCustomersFilterInput | null;
  agreedToGtac?: EntityFilterNumberField | null;
  commissionAmountEur?: string | null;
  commissionAmountGbp?: string | null;
  commissionAmountUsd?: string | null;
  companiesRepresented?: EntityFilterStringField | null;
  companyFocus?: PartnerCompanyFocusFilterInput | null;
  companySize?: PartnerCompanySizeFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  crmAccountId?: EntityFilterStringField | null;
  deleted?: EntityFilterDateTimeField | null;
  email?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  isDeleted?: boolean | null;
  landingPage?: EntityFilterStringField | null;
  ltvAmountEur?: string | null;
  ltvAmountGbp?: string | null;
  ltvAmountUsd?: string | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  representativeId?: EntityFilterNumberField | null;
  state?: EntityFilterStringField | null;
  status?: EntityFilterStringField | null;
  subscriptionsCount?: number | null;
  targetCustomers?: PartnerTargetCustomersFilterInput | null;
  tier?: PartnerTierFilterInput | null;
  type?: EntityFilterNumberField | null;
  url?: EntityFilterStringField | null;
  yearFounded?: EntityFilterNumberField | null;
}

export interface PartnerCompanySizeFilterInput {
  __typename?: 'PartnerCompanySizeFilterInput';
  NOT?: PartnerCompanySizeFilterInput | null;
  eq?: PartnerCompanySize[] | null;
}

export interface PartnerCompanyFocusFilterInput {
  __typename?: 'PartnerCompanyFocusFilterInput';
  NOT?: PartnerCompanyFocusFilterInput | null;
  eq?: PartnerCompanyFocus[] | null;
}

export interface PartnerActiveCustomersFilterInput {
  __typename?: 'PartnerActiveCustomersFilterInput';
  NOT?: PartnerActiveCustomersFilterInput | null;
  eq?: PartnerActiveCustomers[] | null;
}

export interface ParentAccountRelationTypeOrderByNestedInput {
  __typename?: 'ParentAccountRelationTypeOrderByNestedInput';
  childLabel?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  parentLabel?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ParentAccountRelationTypeOrderByInput {
  __typename?: 'ParentAccountRelationTypeOrderByInput';
  childLabel?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  parentLabel?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ParentAccountRelationTypeFilterInput {
  __typename?: 'ParentAccountRelationTypeFilterInput';
  AND?: ParentAccountRelationTypeFilterInput[] | null;
  NOT?: ParentAccountRelationTypeFilterInput | null;
  OR?: ParentAccountRelationTypeFilterInput[] | null;
  childLabel?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  parentLabel?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OrgRelationshipTypeEnumFilterInput {
  __typename?: 'OrgRelationshipTypeEnumFilterInput';
  NOT?: OrgRelationshipTypeEnumFilterInput | null;
  eq?: OrgRelationshipTypeEnum[] | null;
}

export interface OrgChartLeadOpptyNodeInput {
  __typename?: 'OrgChartLeadOpptyNodeInput';
  comment?: string | null;
  contact: UUID;
  groupId?: ID | null;
  parentContact?: UUID | null;
  position?: PositionParams | null;
  relationship?: OrgRelationshipTypeEnum | null;
  salesRoles?: UUID[] | null;
}

export interface OrgChartLeadOpptyGroupEntityInput {
  __typename?: 'OrgChartLeadOpptyGroupEntityInput';
  color: number;
  id?: ID | null;
  name: string;
  position: RectangleParams;
}

export interface OrgChartFilterInput {
  __typename?: 'OrgChartFilterInput';
  skipAttached?: boolean | null;
  skipDetached?: boolean | null;
}

export interface OrgChartContactNodeInput {
  __typename?: 'OrgChartContactNodeInput';
  accountRoles?: UUID[] | null;
  comment?: string | null;
  contact: UUID;
  parentContact?: UUID | null;
  relation?: OrgChartAssistantRelation | null;
  relationship?: OrgRelationshipTypeEnum | null;
  sibling?: boolean | null;
}

export interface OrderRelatedDocumentOrderByInput {
  __typename?: 'OrderRelatedDocumentOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  remainingBalance?: OrderByEnum | null;
}

export interface OrderRelatedDocumentFilterInput {
  __typename?: 'OrderRelatedDocumentFilterInput';
  AND?: OrderRelatedDocumentFilterInput[] | null;
  NOT?: OrderRelatedDocumentFilterInput | null;
  OR?: OrderRelatedDocumentFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  remainingBalance?: EntityFilterNumberField | null;
}

export interface OrderHistoryOrderByInput {
  __typename?: 'OrderHistoryOrderByInput';
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  orderId?: OrderByEnum | null;
}

export interface OrderHistoryFilterInput {
  __typename?: 'OrderHistoryFilterInput';
  AND?: OrderHistoryFilterInput[] | null;
  NOT?: OrderHistoryFilterInput | null;
  OR?: OrderHistoryFilterInput[] | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  orderId?: EntityFilterNumberField | null;
}

export interface OpptyStatusEnumFilterInput {
  __typename?: 'OpptyStatusEnumFilterInput';
  NOT?: OpptyStatusEnumFilterInput | null;
  eq?: OpptyStatusEnum[] | null;
}

export interface OpptyRevenueSchedulePeriodOrderByInput {
  __typename?: 'OpptyRevenueSchedulePeriodOrderByInput';
  created?: OrderByEnum | null;
  date?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyRevenueSchedule?: OpptyRevenueScheduleOrderByNestedInput[] | null;
  opptyRevenueScheduleId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  value?: OrderByEnum | null;
}

export interface OpptyRevenueSchedulePeriodFilterInput {
  __typename?: 'OpptyRevenueSchedulePeriodFilterInput';
  AND?: OpptyRevenueSchedulePeriodFilterInput[] | null;
  NOT?: OpptyRevenueSchedulePeriodFilterInput | null;
  OR?: OpptyRevenueSchedulePeriodFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  opptyRevenueSchedule?: OpptyRevenueScheduleFilterInput | null;
  opptyRevenueScheduleId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  transactionId?: EntityFilterStringField | null;
  value?: EntityFilterNumberField | null;
}

export interface OpptyRevenueScheduleOrderByNestedInput {
  __typename?: 'OpptyRevenueScheduleOrderByNestedInput';
  cancelationDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  periodCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
}

export interface OpptyRevenueScheduleOrderByInput {
  __typename?: 'OpptyRevenueScheduleOrderByInput';
  cancelationDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  periodCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
}

export interface OpptyRevenueScheduleFilterInput {
  __typename?: 'OpptyRevenueScheduleFilterInput';
  AND?: OpptyRevenueScheduleFilterInput[] | null;
  NOT?: OpptyRevenueScheduleFilterInput | null;
  OR?: OpptyRevenueScheduleFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  periodCount?: EntityFilterNumberField | null;
  periodType?: RevenueSchedulePeriodTypeEnumFilterInput | null;
  periods?: OpptyRevenueSchedulePeriodFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface OpptyRecurrenceOrderByNestedInput {
  __typename?: 'OpptyRecurrenceOrderByNestedInput';
  condition?: OrderByEnum | null;
  created?: OrderByEnum | null;
  day?: OrderByEnum | null;
  dayOfWeek?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  month?: OrderByEnum | null;
  occurEvery?: OrderByEnum | null;
  occurrencesCount?: OrderByEnum | null;
  opptyId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  stepId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  week?: OrderByEnum | null;
}

export interface OpptyRecurrenceOrderByInput {
  __typename?: 'OpptyRecurrenceOrderByInput';
  condition?: OrderByEnum | null;
  created?: OrderByEnum | null;
  day?: OrderByEnum | null;
  dayOfWeek?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  month?: OrderByEnum | null;
  occurEvery?: OrderByEnum | null;
  occurrencesCount?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  week?: OrderByEnum | null;
}

export interface OpptyRecurrenceFilterInput {
  __typename?: 'OpptyRecurrenceFilterInput';
  AND?: OpptyRecurrenceFilterInput[] | null;
  NOT?: OpptyRecurrenceFilterInput | null;
  OR?: OpptyRecurrenceFilterInput[] | null;
  condition?: RecurrenceConditionEnumFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  day?: DateDayEnumFilterInput | null;
  dayOfWeek?: DateDayOfWeekEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  month?: DateMonthEnumFilterInput | null;
  occurEvery?: EntityFilterNumberField | null;
  occurrencesCount?: EntityFilterNumberField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  type?: RecurrenceTypeEnumFilterInput | null;
  week?: DateWeekEnumFilterInput | null;
}

export interface OpptyProductRelationTypeOrderByNestedInput {
  __typename?: 'OpptyProductRelationTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OpptyProductRelationTypeOrderByInput {
  __typename?: 'OpptyProductRelationTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  productType?: ProductTypeOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
}

export interface OpptyProductRelationTypeFilterInput {
  __typename?: 'OpptyProductRelationTypeFilterInput';
  AND?: OpptyProductRelationTypeFilterInput[] | null;
  NOT?: OpptyProductRelationTypeFilterInput | null;
  OR?: OpptyProductRelationTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  productType?: ProductTypeFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface OpptyProductRelationRevenueSchedulePeriodOrderByInput {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodOrderByInput';
  created?: OrderByEnum | null;
  date?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyProductRelationRevenueSchedule?: OpptyProductRelationRevenueScheduleOrderByNestedInput[] | null;
  opptyProductRelationRevenueScheduleId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  value?: OrderByEnum | null;
}

export interface OpptyProductRelationRevenueSchedulePeriodFilterInput {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodFilterInput';
  AND?: OpptyProductRelationRevenueSchedulePeriodFilterInput[] | null;
  NOT?: OpptyProductRelationRevenueSchedulePeriodFilterInput | null;
  OR?: OpptyProductRelationRevenueSchedulePeriodFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  opptyProductRelationRevenueSchedule?: OpptyProductRelationRevenueScheduleFilterInput | null;
  opptyProductRelationRevenueScheduleId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  transactionId?: EntityFilterStringField | null;
  value?: EntityFilterNumberField | null;
}

export interface OpptyProductRelationRevenueScheduleOrderByNestedInput {
  __typename?: 'OpptyProductRelationRevenueScheduleOrderByNestedInput';
  cancelationDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  periodCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
}

export interface OpptyProductRelationRevenueScheduleOrderByInput {
  __typename?: 'OpptyProductRelationRevenueScheduleOrderByInput';
  cancelationDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  periodCount?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
}

export interface OpptyProductRelationRevenueScheduleFilterInput {
  __typename?: 'OpptyProductRelationRevenueScheduleFilterInput';
  AND?: OpptyProductRelationRevenueScheduleFilterInput[] | null;
  NOT?: OpptyProductRelationRevenueScheduleFilterInput | null;
  OR?: OpptyProductRelationRevenueScheduleFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  periodCount?: EntityFilterNumberField | null;
  periodType?: RevenueSchedulePeriodTypeEnumFilterInput | null;
  periods?: OpptyProductRelationRevenueSchedulePeriodFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface OpptyProductRelationOrderByNestedInput {
  __typename?: 'OpptyProductRelationOrderByNestedInput';
  amount?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  discountPercentage?: OrderByEnum | null;
  discountValue?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineFormFieldId?: OrderByEnum | null;
  onlineFormId?: OrderByEnum | null;
  opptyId?: OrderByEnum | null;
  opptyProductRelationTypeId?: OrderByEnum | null;
  pairedOpptyProductRelationId?: OrderByEnum | null;
  price?: OrderByEnum | null;
  productId?: OrderByEnum | null;
  quantity?: OrderByEnum | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OpptyProductRelationOrderByInput {
  __typename?: 'OpptyProductRelationOrderByInput';
  amount?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  discountPercentage?: OrderByEnum | null;
  discountValue?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineForm?: OnlineFormOrderByNestedInput[] | null;
  onlineFormField?: FieldOrderByNestedInput[] | null;
  onlineFormFieldId?: OrderByEnum | null;
  onlineFormId?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  opptyProductRelationType?: OpptyProductRelationTypeOrderByNestedInput[] | null;
  opptyProductRelationTypeId?: OrderByEnum | null;
  pairedOpptyProductRelation?: OpptyProductRelationOrderByNestedInput[] | null;
  pairedOpptyProductRelationId?: OrderByEnum | null;
  price?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  quantity?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revenueSchedule?: OpptyProductRelationRevenueScheduleOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OpptyProductRelationFilterInput {
  __typename?: 'OpptyProductRelationFilterInput';
  AND?: OpptyProductRelationFilterInput[] | null;
  NOT?: OpptyProductRelationFilterInput | null;
  OR?: OpptyProductRelationFilterInput[] | null;
  amount?: EntityFilterNumberField | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  discountPercentage?: number | null;
  discountValue?: number | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  onlineForm?: OnlineFormFilterInput | null;
  onlineFormField?: FieldFilterInput | null;
  onlineFormFieldId?: EntityFilterStringField | null;
  onlineFormId?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  opptyProductRelationType?: OpptyProductRelationTypeFilterInput | null;
  opptyProductRelationTypeId?: EntityFilterStringField | null;
  pairedOpptyProductRelation?: OpptyProductRelationFilterInput | null;
  pairedOpptyProductRelationId?: EntityFilterStringField | null;
  price?: EntityFilterNumberField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  quantity?: EntityFilterNumberField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revenueSchedule?: OpptyProductRelationRevenueScheduleFilterInput | null;
  revision?: EntityFilterNumberField | null;
  sectionId?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  withCustom?: CustomField[] | null;
}

export interface OpptyProductRelationDataExRelationOrderByInput {
  __typename?: 'OpptyProductRelationDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyProductRelation?: OpptyProductRelationOrderByNestedInput[] | null;
  opptyProductRelationId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OpptyProductRelationDataExRelationFilterInput {
  __typename?: 'OpptyProductRelationDataExRelationFilterInput';
  AND?: OpptyProductRelationDataExRelationFilterInput[] | null;
  NOT?: OpptyProductRelationDataExRelationFilterInput | null;
  OR?: OpptyProductRelationDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  opptyProductRelation?: OpptyProductRelationFilterInput | null;
  opptyProductRelationId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OpportunityTypeOrderByNestedInput {
  __typename?: 'OpportunityTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  pipelineId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OpportunityTypeOrderByInput {
  __typename?: 'OpportunityTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  pipeline?: PipelineOrderByNestedInput[] | null;
  pipelineId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OpportunityTypeFilterInput {
  __typename?: 'OpportunityTypeFilterInput';
  AND?: OpportunityTypeFilterInput[] | null;
  NOT?: OpportunityTypeFilterInput | null;
  OR?: OpportunityTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  pipeline?: PipelineFilterInput | null;
  pipelineId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OpportunityTabDataGridViewOptionsParams {
  __typename?: 'OpportunityTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByPipelineId?: ID[] | null;
  filterByStatus?: OpptyStatusEnum[] | null;
  filterByTags?: ID[] | null;
  searchQuery?: string | null;
}

export interface OpportunityRoleTabParams {
  __typename?: 'OpportunityRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface OpportunityReportTargetTabParams {
  __typename?: 'OpportunityReportTargetTabParams';
  goal: number;
  isVisible: boolean;
  showTargetOnTop?: boolean | null;
  targetPeriodCompare: PeriodCompareOptionParams;
  targetPeriodCurrent: PeriodOptionParams;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
}

export interface OpportunityProfileDataInput {
  __typename?: 'OpportunityProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: OpportunityPreviewProfileParams;
}

export interface OpportunityPreviewViewTabParams {
  __typename?: 'OpportunityPreviewViewTabParams';
  bubbleChartSizeCalculatedBy: SizeCalculatedBy;
  gridColumns: GridColumnsOutputParams[];
  groupBy: OpportunityGroupBy;
  showCardFitness: boolean;
  showCardLabels: boolean;
  showCardRanking: boolean;
  showCardValue: boolean;
  showCardVelocity: boolean;
  showExcludedItems: boolean;
  showExtraFieldIds?: UUID[] | null;
  showOutsideTarget: boolean;
  showUnassignedLead: boolean;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface OpportunityPreviewTargetTabParams {
  __typename?: 'OpportunityPreviewTargetTabParams';
  goal: number;
  showTargetOnTop?: boolean | null;
  targetDefinition?: UUID | null;
  targetPeriodCompare: PeriodCompareOptionParams;
  targetPeriodCurrent: PeriodOptionParams;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
  targetValueType: TargetValueType;
}

export interface OpportunityPreviewProfileParams {
  __typename?: 'OpportunityPreviewProfileParams';
  filter: LeadOpportunityFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: OpportunityRoleTabParams;
  salesPipeline?: ID[] | null;
  target: OpportunityPreviewTargetTabParams;
  view: OpportunityPreviewViewTabParams;
}

export interface OpportunityOrderByNestedInput {
  __typename?: 'OpportunityOrderByNestedInput';
  activeQuoteId?: OrderByEnum | null;
  closingDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isValueAutoCalculate?: OrderByEnum | null;
  labelFlag?: OrderByEnum | null;
  leadSourceId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyTypeId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  productPriceListId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  ranking?: OrderByEnum | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepId?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  value?: OrderByEnum | null;
  wasQualified?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OpportunityOrderByInput {
  __typename?: 'OpportunityOrderByInput';
  activeQuote?: QuoteOrderByNestedInput[] | null;
  activeQuoteId?: OrderByEnum | null;
  closingDate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isValueAutoCalculate?: OrderByEnum | null;
  labelFlag?: OrderByEnum | null;
  leadSource?: DataOrderByNestedInput[] | null;
  leadSourceId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyRecurrence?: OpptyRecurrenceOrderByNestedInput[] | null;
  opptyType?: OpportunityTypeOrderByNestedInput[] | null;
  opptyTypeId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  productPriceList?: ProductPriceListOrderByNestedInput[] | null;
  productPriceListId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  ranking?: OrderByEnum | null;
  reasonOfClose?: DataOrderByNestedInput[] | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revenueSchedule?: OpptyRevenueScheduleOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  value?: OrderByEnum | null;
  wasQualified?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OpportunityKPIFilterTabParams {
  __typename?: 'OpportunityKPIFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface OpportunityForecastViewParams {
  __typename?: 'OpportunityForecastViewParams';
  column: ForecastColumnsType[];
  drilldownFields: ID[];
  field: ID;
  graphHeight?: number | null;
  groupBy?: ID | null;
  hideEmptyRows: boolean;
  isDrilldownEnabled: boolean;
  owner: ForecastOwnerParams[];
  period: ForecastPeriodOptionParams;
  quota: OpportunityForecastQuotaParams;
  rollUpPeriod?: ForecastPeriodKind | null;
  showGraph: boolean;
}

export interface OpportunityForecastQuotaParams {
  __typename?: 'OpportunityForecastQuotaParams';
  comparisonType: ForecastPerformanceComparisonType;
  isEnabled: boolean;
  items: OpportunityForecastQuotaItemParams[];
  value: number;
}

export interface OpportunityForecastQuotaItemValueParams {
  __typename?: 'OpportunityForecastQuotaItemValueParams';
  date: GqlDate;
  value: number;
}

export interface OpportunityForecastQuotaItemParams {
  __typename?: 'OpportunityForecastQuotaItemParams';
  id: ID;
  splitType: OpportunityForecastQuotaSplitType;
  values: OpportunityForecastQuotaItemValueParams[];
}

export interface OpportunityForecastPropertiesParams {
  __typename?: 'OpportunityForecastPropertiesParams';
  type: ForecastType;
}

export interface OpportunityForecastProfileParams {
  __typename?: 'OpportunityForecastProfileParams';
  filter: OpportunityFilterTabParams;
  leadProcess?: UUID[] | null;
  properties: OpportunityForecastPropertiesParams;
  salesPipeline?: ID[] | null;
  view: OpportunityForecastViewParams;
}

export interface OpportunityFilterTabParams {
  __typename?: 'OpportunityFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface OpportunityFilterInput {
  __typename?: 'OpportunityFilterInput';
  AND?: OpportunityFilterInput[] | null;
  NOT?: OpportunityFilterInput | null;
  OR?: OpportunityFilterInput[] | null;
  accountRelations?: LeadOpptyAccountRelationFilterInput | null;
  activeQuote?: QuoteFilterInput | null;
  activeQuoteId?: EntityFilterStringField | null;
  contactRelations?: LeadOpptyContactRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  enrolledEmailSequences?: number | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isArchived?: boolean | null;
  isDeleted?: boolean | null;
  isValueAutoCalculate?: boolean | null;
  labelFlag?: LabelFlagEnumFilterInput | null;
  leadSource?: DataFilterInput | null;
  leadSourceId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  opptyRecurrence?: OpptyRecurrenceFilterInput | null;
  opptyType?: OpportunityTypeFilterInput | null;
  opptyTypeId?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  pipelineId?: EntityFilterStringField | null;
  primaryAccount?: AccountFilterInput | null;
  primaryContact?: ContactFilterInput | null;
  productCurrency?: CurrencyFilterInput | null;
  productCurrencyId?: EntityFilterStringField | null;
  productPriceList?: ProductPriceListFilterInput | null;
  productPriceListId?: EntityFilterStringField | null;
  productRelations?: OpptyProductRelationFilterInput | null;
  quickAccountEmail?: EntityFilterStringField | null;
  quickAccountName?: EntityFilterStringField | null;
  quickAccountPhone?: EntityFilterStringField | null;
  quickContactName?: EntityFilterStringField | null;
  quickEmail?: EntityFilterStringField | null;
  quickPhone?: EntityFilterStringField | null;
  quoteRelations?: QuoteFilterInput | null;
  ranking?: EntityFilterNumberField | null;
  reasonOfClose?: DataFilterInput | null;
  reasonOfCloseDescription?: EntityFilterStringField | null;
  reasonOfCloseId?: EntityFilterStringField | null;
  relatedEntities?: EntityFilterRelatedField[] | null;
  revenueSchedule?: OpptyRevenueScheduleFilterInput | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: LeadOpptySharingClientRelationFilterInput | null;
  sharingUnits?: LeadOpptySharingSalesUnitRelationFilterInput | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  status?: OpptyStatusEnumFilterInput | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
  tags?: TagRelationFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  wasQualified?: boolean | null;
  withCustom?: CustomField[] | null;
}

export interface OpportunityDrilldownFilterParams {
  __typename?: 'OpportunityDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface OpportunityDashboardProfileViewParams {
  __typename?: 'OpportunityDashboardProfileViewParams';
  drilldownFields: ID[];
  graphs: DashboardGraphOpportunityNameType[];
}

export interface OpportunityDashboardProfileParams {
  __typename?: 'OpportunityDashboardProfileParams';
  filter: LeadOpportunityFilterTabParams;
  leadProcess?: UUID[] | null;
  role: OpportunityRoleTabParams;
  salesPipeline?: ID[] | null;
  target: OpportunityReportTargetTabParams;
  view: OpportunityDashboardProfileViewParams;
}

export interface OpportunityArchiveViewTabParams {
  __typename?: 'OpportunityArchiveViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  groupBy: OpportunityGroupBy;
  showCardFitness: boolean;
  showCardLabels: boolean;
  showCardRanking: boolean;
  showCardValue: boolean;
  showExtraFieldIds?: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface OpportunityArchiveTargetTabParams {
  __typename?: 'OpportunityArchiveTargetTabParams';
  showTargetOnTop?: boolean | null;
  targetPeriodCompare: PeriodCompareOptionParams;
  targetPeriodCurrent: PeriodOptionParams;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
}

export interface OpportunityArchiveProfileParams {
  __typename?: 'OpportunityArchiveProfileParams';
  filter: LeadOpportunityFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: OpportunityRoleTabParams;
  salesPipeline?: ID[] | null;
  target: OpportunityArchiveTargetTabParams;
  view: OpportunityArchiveViewTabParams;
}

export interface OnlineFormsNotificationSettingsParams {
  __typename?: 'OnlineFormsNotificationSettingsParams';
  Errors: boolean;
  IsActive: boolean;
  Responses: boolean;
  Warnings: boolean;
}

export interface OnlineFormTypeTabDataGridViewOptionsParams {
  __typename?: 'OnlineFormTypeTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStatus?: ProcessStatusEnum[] | null;
  showActive: boolean;
  showInactive: boolean;
}

export interface OnlineFormTypeOrderByNestedInput {
  __typename?: 'OnlineFormTypeOrderByNestedInput';
  autoPrefillWithJavascript?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  lastResponseBy?: OrderByEnum | null;
  lastResponseDate?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  responseAcceptanceThreshold?: OrderByEnum | null;
  responseCount?: OrderByEnum | null;
  responseRate?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sentCount?: OrderByEnum | null;
  sentUniqueCount?: OrderByEnum | null;
  status?: OrderByEnum | null;
  styleId?: OrderByEnum | null;
}

export interface OnlineFormTypeOrderByInput {
  __typename?: 'OnlineFormTypeOrderByInput';
  autoPrefillWithJavascript?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  lastResponseBy?: OrderByEnum | null;
  lastResponseDate?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  responseAcceptanceThreshold?: OrderByEnum | null;
  responseCount?: OrderByEnum | null;
  responseRate?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sentCount?: OrderByEnum | null;
  sentUniqueCount?: OrderByEnum | null;
  status?: OrderByEnum | null;
  style?: OnlineFormStyleOrderByNestedInput[] | null;
  styleId?: OrderByEnum | null;
}

export interface OnlineFormTypeFilterInput {
  __typename?: 'OnlineFormTypeFilterInput';
  AND?: OnlineFormTypeFilterInput[] | null;
  NOT?: OnlineFormTypeFilterInput | null;
  OR?: OnlineFormTypeFilterInput[] | null;
  activityLogs?: OnlineFormFilterInput | null;
  autoPrefillWithJavascript?: boolean | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  entityApiName?: EntityFilterStringField | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  isReadonly?: boolean | null;
  lastResponseBy?: string | null;
  lastResponseDate?: DateTime | null;
  lastSchemaChange?: EntityFilterDateTimeField | null;
  lastStatusChange?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  responseAcceptanceThreshold?: number | null;
  responseCount?: number | null;
  responseRate?: number | null;
  revision?: EntityFilterNumberField | null;
  sentCount?: number | null;
  sentUniqueCount?: number | null;
  status?: ProcessStatusEnum | null;
  style?: OnlineFormStyleFilterInput | null;
  styleId?: EntityFilterStringField | null;
}

export interface OnlineFormTypeEmailRelationOrderByInput {
  __typename?: 'OnlineFormTypeEmailRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineFormType?: OnlineFormTypeOrderByNestedInput[] | null;
  onlineFormTypeId?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OnlineFormTypeEmailRelationFilterInput {
  __typename?: 'OnlineFormTypeEmailRelationFilterInput';
  AND?: OnlineFormTypeEmailRelationFilterInput[] | null;
  NOT?: OnlineFormTypeEmailRelationFilterInput | null;
  OR?: OnlineFormTypeEmailRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  onlineFormType?: OnlineFormTypeFilterInput | null;
  onlineFormTypeId?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OnlineFormStyleOrderByNestedInput {
  __typename?: 'OnlineFormStyleOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface OnlineFormStyleOrderByInput {
  __typename?: 'OnlineFormStyleOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface OnlineFormStyleFilterInput {
  __typename?: 'OnlineFormStyleFilterInput';
  AND?: OnlineFormStyleFilterInput[] | null;
  NOT?: OnlineFormStyleFilterInput | null;
  OR?: OnlineFormStyleFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  useLang?: boolean | null;
}

export interface OnlineFormSettingsParams {
  __typename?: 'OnlineFormSettingsParams';
  attachFiles: boolean;
  attachResponseAsPdf: boolean;
  autolinkEnabled: boolean;
  autolinkFormFieldId?: ID | null;
  autolinkRecordFieldId?: ID | null;
  checkForExistingResponse: boolean;
  confirmationPageMessage?: string | null;
  confirmationPageTitle?: string | null;
  confirmationPageType: OnlineFormConfirmationPageType;
  confirmationPageUrl?: string | null;
  createRecordEnabled: boolean;
  createRecordForm?: ProcessEntityTemplateParams | null;
  createRelatedRecords: OnlineFormRelatedRecordSettingsParams[];
  limitToSingleResponse: boolean;
  linkOrCreateRelatedRecords: OnlineFormRelatedRecordSettingsParams[];
  linkRecordEnabled: boolean;
  linkRelatedRecords: OnlineFormRelatedRecordSettingsParams[];
  maxTotalUploadedFilesSize: number;
  notificationEmails: string[];
  notificationEnabled: boolean;
  notificationLimitEmails: string[];
  notificationLimitEnabled: boolean;
  notificationLimitRecipientType: OnlineFormNotificationRecipientType[];
  notificationRecipientType: OnlineFormNotificationRecipientType[];
  productsCurrencyId: ID;
  productsPriceListId?: ID | null;
  productsResponseLimits: OnlineFormProductsResponseLimitParams[];
  productsResponseLimitsEnabled: boolean;
  productsShowGrandTotal: boolean;
  productsTotalResponseLimits: OnlineFormProductsResponseLimitParams[];
  productsTotalResponseLimitsEnabled: boolean;
  recordIdentificationEnabled: boolean;
  recordIdentificationMessage?: string | null;
  recordIdentificationTitle?: string | null;
  recordIdentificationType: OnlineFormConfirmationPageType;
  recordIdentificationUrl?: string | null;
  responseAcceptanceDateLimitDate?: DateTime | null;
  responseAcceptanceDateLimitEnabled: boolean;
  responseAcceptanceDateLimitMessage?: string | null;
  responseAcceptanceDateLimitTitle?: string | null;
  responseAcceptanceThresholdCustomCondition?: ResponseAcceptanceThresholdCustomConditionParams | null;
  responseAcceptanceThresholdEnabled: boolean;
  responseAcceptanceThresholdMessage?: string | null;
  responseAcceptanceThresholdNoOfResponses?: number | null;
  responseAcceptanceThresholdProductsLimits?: ResponseAcceptanceThresholdProductsLimitsParams | null;
  responseAcceptanceThresholdTitle?: string | null;
  responseAcceptanceThresholdType: ResponseAcceptanceThresholdType;
  showQuestionNumbers: boolean;
  singlePageContent: boolean;
  updateOrCreateRelatedRecords: OnlineFormRelatedRecordSettingsParams[];
  updateRecordEnabled: boolean;
  updateRecordForm?: ProcessEntityTemplateParams | null;
  updateRelatedRecords: OnlineFormRelatedRecordSettingsParams[];
}

export interface OnlineFormRelationOrderByInput {
  __typename?: 'OnlineFormRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineForm?: OnlineFormOrderByNestedInput[] | null;
  onlineFormId?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OnlineFormRelationFilterInput {
  __typename?: 'OnlineFormRelationFilterInput';
  AND?: OnlineFormRelationFilterInput[] | null;
  NOT?: OnlineFormRelationFilterInput | null;
  OR?: OnlineFormRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  onlineForm?: OnlineFormFilterInput | null;
  onlineFormId?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OnlineFormRelatedRecordSettingsParams {
  __typename?: 'OnlineFormRelatedRecordSettingsParams';
  createForm?: ProcessEntityTemplateParams | null;
  id: ID;
  linkAll: boolean;
  linkFormFieldId?: ID | null;
  linkRecordFieldId?: ID | null;
  relation: ProcessRecordNodeRelationEnum;
  relationLookupFieldId?: string | null;
  updateForm?: ProcessEntityTemplateParams | null;
}

export interface OnlineFormProductsResponseLimitParams {
  __typename?: 'OnlineFormProductsResponseLimitParams';
  enabled: boolean;
  fieldId: ID;
  quantity: number;
}

export interface OnlineFormProductServicesPropertyParams {
  __typename?: 'OnlineFormProductServicesPropertyParams';
  dynamicProductsFilter?: FieldFilterParams | null;
  fields: ID[];
  maxSelectedProducts?: number | null;
  productListType: ProductListTypeEnum;
  productSelectionLimitEnabled: boolean;
  showProductImages: boolean;
  showTotalAmount: boolean;
  staticProducts?: ID[] | null;
}

export interface OnlineFormOrderByNestedInput {
  __typename?: 'OnlineFormOrderByNestedInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineFormTypeId?: OrderByEnum | null;
  productPriceListId?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OnlineFormOrderByInput {
  __typename?: 'OnlineFormOrderByInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineFormType?: OnlineFormTypeOrderByNestedInput[] | null;
  onlineFormTypeId?: OrderByEnum | null;
  productPriceList?: ProductPriceListOrderByNestedInput[] | null;
  productPriceListId?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface OnlineFormFilterInput {
  __typename?: 'OnlineFormFilterInput';
  AND?: OnlineFormFilterInput[] | null;
  NOT?: OnlineFormFilterInput | null;
  OR?: OnlineFormFilterInput[] | null;
  accountRelations?: OnlineFormRelationFilterInput | null;
  contactRelations?: OnlineFormRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  customEntityRelations?: OnlineFormRelationFilterInput | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadRelations?: OnlineFormRelationFilterInput | null;
  lines?: OnlineFormActivityLogLineFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  onlineFormType?: OnlineFormTypeFilterInput | null;
  onlineFormTypeId?: EntityFilterStringField | null;
  opportunityRelations?: OnlineFormRelationFilterInput | null;
  productCurrency?: CurrencyFilterInput | null;
  productCurrencyId?: EntityFilterStringField | null;
  productPriceList?: ProductPriceListFilterInput | null;
  productPriceListId?: EntityFilterStringField | null;
  projectRelations?: OnlineFormRelationFilterInput | null;
  quoteRelations?: OnlineFormRelationFilterInput | null;
  recordName?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  status?: ProcessStatusEnumFilterInput | null;
  withCustom?: CustomField[] | null;
}

export interface OnlineFormDataExRelationOrderByInput {
  __typename?: 'OnlineFormDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineForm?: OnlineFormOrderByNestedInput[] | null;
  onlineFormId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface OnlineFormDataExRelationFilterInput {
  __typename?: 'OnlineFormDataExRelationFilterInput';
  AND?: OnlineFormDataExRelationFilterInput[] | null;
  NOT?: OnlineFormDataExRelationFilterInput | null;
  OR?: OnlineFormDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  onlineForm?: OnlineFormFilterInput | null;
  onlineFormId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface OnlineFormActivityLogLineOrderByInput {
  __typename?: 'OnlineFormActivityLogLineOrderByInput';
  created?: OrderByEnum | null;
  executedAt?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineForm?: OnlineFormOrderByNestedInput[] | null;
  onlineFormId?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface OnlineFormActivityLogLineFilterInput {
  __typename?: 'OnlineFormActivityLogLineFilterInput';
  AND?: OnlineFormActivityLogLineFilterInput[] | null;
  NOT?: OnlineFormActivityLogLineFilterInput | null;
  OR?: OnlineFormActivityLogLineFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  executedAt?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isVisible?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  onlineForm?: OnlineFormFilterInput | null;
  onlineFormId?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface O365SetSettingsTeamSpaceClientSettingInput {
  __typename?: 'O365SetSettingsTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  deleteProtection?: ContactDeletionProtectionEnum | null;
  folder?: string | null;
  recordOwnership?: RecordOwnershipEnum | null;
  service: O365SettingTypeEnum;
  syncArchived: boolean;
  syncMethod?: ContactSyncMethodEnum | null;
  syncPrivate: boolean;
}

export interface O365EnableTeamSpaceClientSettingInput {
  __typename?: 'O365EnableTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: O365SettingTypeEnum;
}

export interface O365DisableTeamSpaceClientSettingInput {
  __typename?: 'O365DisableTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: O365SettingTypeEnum;
}

export interface O365AuthorizeTeamSpaceClientSettingInput {
  __typename?: 'O365AuthorizeTeamSpaceClientSettingInput';
  authCode: string;
  clientMutationId?: string | null;
  redirectUri?: string | null;
  service: O365SettingTypeEnum;
}

export interface NumberOfSalesPeopleFilterInput {
  __typename?: 'NumberOfSalesPeopleFilterInput';
  NOT?: NumberOfSalesPeopleFilterInput | null;
  eq?: NumberOfSalesPeople[] | null;
}

export interface NotificationSettingsParams {
  __typename?: 'NotificationSettingsParams';
  AccountsAndContacts: AccountsAndContactsNotificationSettingsParams;
  Activities: ActivitiesNotificationSettingsParams;
  ApprovalProcesses?: ApprovalProcessesNotificationSettingsParams | null;
  CallingAndMessaging?: TextMessageNotificationSettingsParams | null;
  CustomEntities: CustomEntitiesNotificationSettingParams[];
  EmailSequences?: EmailSequencesNotificationSettingsParams | null;
  Emails: EmailNotificationSettingsParams;
  Feeds: FeedsNotificationSettingsParams;
  LeadsAndOpportunities: LeadsAndOpportunitiesNotificationSettingsParams;
  OnlineForms?: OnlineFormsNotificationSettingsParams | null;
  ProcessBuilder?: ProcessBuilderNotificationSettingsParams | null;
  Projects?: ProjectsNotificationSettingsParams | null;
  Quotes?: QuotesNotificationSettingsParams | null;
  WhatsApp?: TextMessageNotificationSettingsParams | null;
}

export interface NoteTabDataGridViewOptionsParams {
  __typename?: 'NoteTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  searchQuery?: string | null;
}

export interface NoteOrderByNestedInput {
  __typename?: 'NoteOrderByNestedInput';
  accountId?: OrderByEnum | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  note?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  projectId?: OrderByEnum | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface NoteOrderByInput {
  __typename?: 'NoteOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  note?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface NoteFilterInput {
  __typename?: 'NoteFilterInput';
  AND?: NoteFilterInput[] | null;
  NOT?: NoteFilterInput | null;
  OR?: NoteFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  note?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface NavigatorTargetTabParams {
  __typename?: 'NavigatorTargetTabParams';
  goal: number;
  targetPeriodCompare: PeriodCompareOptionParams;
  targetPeriodCurrent: PeriodOptionParams;
  targetValueFieldId: ID;
  targetValueType: TargetValueType;
}

export interface NavigatorProfileFilterTabParams {
  __typename?: 'NavigatorProfileFilterTabParams';
  filterByOwnerId?: ID | null;
  filterByUnitIds?: ID[] | null;
  isEnabled: boolean;
}

export interface NavigatorProfileDataInput {
  __typename?: 'NavigatorProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: NavigatorPreviewProfileParams;
}

export interface NavigatorPreviewProfileParams {
  __typename?: 'NavigatorPreviewProfileParams';
  filter: NavigatorProfileFilterTabParams;
  role: ProfileStandardRoleTabParams;
  salesPipeline?: ID[] | null;
  target: NavigatorTargetTabParams;
}

export interface MoveQuoteInput {
  __typename?: 'MoveQuoteInput';
  archiveQuoteIds?: UUID[] | null;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: UpdateQuoteInput;
  winOpportunityIds?: UUID[] | null;
}

export interface MovePipelineStepInput {
  __typename?: 'MovePipelineStepInput';
  clientMutationId?: string | null;
  id: ID;
  nextStepId: ID;
  stepId: ID;
}

export interface MoveOpportunityInput {
  __typename?: 'MoveOpportunityInput';
  acceptQuoteIds?: UUID[] | null;
  archiveQuoteIds?: UUID[] | null;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: UpdateOpportunityInput;
  memoText?: string | null;
}

export interface MoveLeadInput {
  __typename?: 'MoveLeadInput';
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: UpdateLeadInput;
  memoText?: string | null;
}

export interface MoveCloudObjectsInput {
  __typename?: 'MoveCloudObjectsInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  entityId?: UUID | null;
  entityType?: BaseEntityTypeEnum | null;
  folderId?: UUID | null;
}

export interface MigratePipelineInput {
  __typename?: 'MigratePipelineInput';
  clientMutationId?: string | null;
  id: ID;
  stepMappings: StepMappingInput[];
  targetPipelineId: ID;
}

export interface MicrosoftOneDriveSettingsInput {
  __typename?: 'MicrosoftOneDriveSettingsInput';
  microsoftOneDriveAccessToken?: string | null;
  microsoftOneDriveRefreshToken?: string | null;
}

export interface MessageSharingSalesUnitRelationOrderByInput {
  __typename?: 'MessageSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  messageId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface MessageSharingSalesUnitRelationFilterInput {
  __typename?: 'MessageSharingSalesUnitRelationFilterInput';
  AND?: MessageSharingSalesUnitRelationFilterInput[] | null;
  NOT?: MessageSharingSalesUnitRelationFilterInput | null;
  OR?: MessageSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  memo?: MemoFilterInput | null;
  messageId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface MessageSharingClientRelationOrderByInput {
  __typename?: 'MessageSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  messageId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MessageSharingClientRelationFilterInput {
  __typename?: 'MessageSharingClientRelationFilterInput';
  AND?: MessageSharingClientRelationFilterInput[] | null;
  NOT?: MessageSharingClientRelationFilterInput | null;
  OR?: MessageSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  memo?: MemoFilterInput | null;
  messageId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface MessageRelationOrderByInput {
  __typename?: 'MessageRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  messageId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MessageRelationFilterInput {
  __typename?: 'MessageRelationFilterInput';
  AND?: MessageRelationFilterInput[] | null;
  NOT?: MessageRelationFilterInput | null;
  OR?: MessageRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  email?: EmailFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  memo?: MemoFilterInput | null;
  messageId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface MergeDuplicatesFieldParams {
  __typename?: 'MergeDuplicatesFieldParams';
  entityId: UUID;
  fieldId: UUID;
}

export interface MergeContactInput {
  __typename?: 'MergeContactInput';
  clientMutationId?: string | null;
  master: UpdateContactInput;
  slaveId: ID;
}

export interface MergeAccountInput {
  __typename?: 'MergeAccountInput';
  clientMutationId?: string | null;
  master: UpdateAccountInput;
  slaveId: ID;
}

export interface MemoOrderByNestedInput {
  __typename?: 'MemoOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  subject?: OrderByEnum | null;
}

export interface MemoOrderByInput {
  __typename?: 'MemoOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  subject?: OrderByEnum | null;
}

export interface MemoFilterInput {
  __typename?: 'MemoFilterInput';
  AND?: MemoFilterInput[] | null;
  NOT?: MemoFilterInput | null;
  OR?: MemoFilterInput[] | null;
  accountRelations?: MessageRelationFilterInput | null;
  comments?: MemoCommentFilterInput | null;
  contactRelations?: MessageRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  customEntityRelations?: MessageRelationFilterInput | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadRelations?: MessageRelationFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  opportunityRelations?: MessageRelationFilterInput | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  projectRelations?: MessageRelationFilterInput | null;
  quoteRelations?: MessageRelationFilterInput | null;
  revision?: EntityFilterNumberField | null;
  sharingClients?: MessageSharingClientRelationFilterInput | null;
  sharingUnits?: MessageSharingSalesUnitRelationFilterInput | null;
  subject?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
}

export interface MemoCommentOrderByInput {
  __typename?: 'MemoCommentOrderByInput';
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  memoId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MemoCommentFilterInput {
  __typename?: 'MemoCommentFilterInput';
  AND?: MemoCommentFilterInput[] | null;
  NOT?: MemoCommentFilterInput | null;
  OR?: MemoCommentFilterInput[] | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  memo?: MemoFilterInput | null;
  memoId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface MediaTypeEnumFilterInput {
  __typename?: 'MediaTypeEnumFilterInput';
  NOT?: MediaTypeEnumFilterInput | null;
  eq?: MediaTypeEnum[] | null;
}

export interface MediaStatusEnumFilterInput {
  __typename?: 'MediaStatusEnumFilterInput';
  NOT?: MediaStatusEnumFilterInput | null;
  eq?: MediaStatusEnum[] | null;
}

export interface MediaOrderByNestedInput {
  __typename?: 'MediaOrderByNestedInput';
  activityId?: OrderByEnum | null;
  callId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MediaOrderByInput {
  __typename?: 'MediaOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  call?: CallOrderByNestedInput[] | null;
  callId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface MediaFilterInput {
  __typename?: 'MediaFilterInput';
  AND?: MediaFilterInput[] | null;
  NOT?: MediaFilterInput | null;
  OR?: MediaFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  call?: CallFilterInput | null;
  callId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  errorCode?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  status?: MediaStatusEnumFilterInput | null;
  task?: TaskFilterInput | null;
  type?: MediaTypeEnumFilterInput | null;
}

export interface MatchingInput {
  __typename?: 'MatchingInput';
  identityKey: string[];
  onMultiMatch: MultiMatchEnum;
  thirdPartyKey?: string | null;
}

export interface MasterRightOrderByNestedInput {
  __typename?: 'MasterRightOrderByNestedInput';
  accessAccountRelationTypes?: OrderByEnum | null;
  accessAccounts?: OrderByEnum | null;
  accessAiAutomatizer?: OrderByEnum | null;
  accessAiOnlineForms?: OrderByEnum | null;
  accessAiRecordDetail?: OrderByEnum | null;
  accessAiReports?: OrderByEnum | null;
  accessAiSmartField?: OrderByEnum | null;
  accessAppointmentScheduler?: OrderByEnum | null;
  accessAppointmentSchedulerManagement?: OrderByEnum | null;
  accessApprovalProcesses?: OrderByEnum | null;
  accessApprovalProcessesManagement?: OrderByEnum | null;
  accessApprovals?: OrderByEnum | null;
  accessArchive?: OrderByEnum | null;
  accessAudit?: OrderByEnum | null;
  accessAuditLog?: OrderByEnum | null;
  accessBulkUpdate?: OrderByEnum | null;
  accessCalling?: OrderByEnum | null;
  accessCallingCompanyPhone?: OrderByEnum | null;
  accessCallingPurchasePhone?: OrderByEnum | null;
  accessCompanyEmails?: OrderByEnum | null;
  accessContacts?: OrderByEnum | null;
  accessDocumentManagement?: OrderByEnum | null;
  accessDocumentManagementCompany?: OrderByEnum | null;
  accessDocumentManagementRecord?: OrderByEnum | null;
  accessDuplicateChecker?: OrderByEnum | null;
  accessEntityAccount?: OrderByEnum | null;
  accessEntityAccountCopy?: OrderByEnum | null;
  accessEntityAccountDelete?: OrderByEnum | null;
  accessEntityAccountDirection?: OrderByEnum | null;
  accessEntityAccountPrivate?: OrderByEnum | null;
  accessEntityAccountTagCreate?: OrderByEnum | null;
  accessEntityAppointment?: OrderByEnum | null;
  accessEntityAppointmentDelete?: OrderByEnum | null;
  accessEntityAppointmentDirection?: OrderByEnum | null;
  accessEntityAppointmentTagCreate?: OrderByEnum | null;
  accessEntityBetterNavigator?: OrderByEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned?: OrderByEnum | null;
  accessEntityBetterNavigatorDeleteOwned?: OrderByEnum | null;
  accessEntityBetterNavigatorSharingCustom?: OrderByEnum | null;
  accessEntityBetterNavigatorSharingPublic?: OrderByEnum | null;
  accessEntityContact?: OrderByEnum | null;
  accessEntityContactCopy?: OrderByEnum | null;
  accessEntityContactDelete?: OrderByEnum | null;
  accessEntityContactDirection?: OrderByEnum | null;
  accessEntityContactPrivate?: OrderByEnum | null;
  accessEntityContactTagCreate?: OrderByEnum | null;
  accessEntityDashboard?: OrderByEnum | null;
  accessEntityDashboardDeleteNotOwned?: OrderByEnum | null;
  accessEntityDashboardDeleteOwned?: OrderByEnum | null;
  accessEntityDashboardSharingCustom?: OrderByEnum | null;
  accessEntityDashboardSharingPublic?: OrderByEnum | null;
  accessEntityEmailContentShareMode?: OrderByEnum | null;
  accessEntityEmailDeleteNotOwned?: OrderByEnum | null;
  accessEntityEmailSequence?: OrderByEnum | null;
  accessEntityEmailTemplate?: OrderByEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder?: OrderByEnum | null;
  accessEntityEmailTemplateDeleteNotOwned?: OrderByEnum | null;
  accessEntityEmailTemplateDeleteOwned?: OrderByEnum | null;
  accessEntityEmailTemplateSharingCustom?: OrderByEnum | null;
  accessEntityEmailTemplateSharingPublic?: OrderByEnum | null;
  accessEntityForecast?: OrderByEnum | null;
  accessEntityForecastDeleteNotOwned?: OrderByEnum | null;
  accessEntityForecastDeleteOwned?: OrderByEnum | null;
  accessEntityForecastEditNotOwned?: OrderByEnum | null;
  accessEntityForecastSharingCustom?: OrderByEnum | null;
  accessEntityForecastSharingPublic?: OrderByEnum | null;
  accessEntityFormView?: OrderByEnum | null;
  accessEntityFormViewDeleteNotOwned?: OrderByEnum | null;
  accessEntityFormViewDeleteOwned?: OrderByEnum | null;
  accessEntityFormViewSharingCustom?: OrderByEnum | null;
  accessEntityFormViewSharingPublic?: OrderByEnum | null;
  accessEntityLead?: OrderByEnum | null;
  accessEntityLeadCopy?: OrderByEnum | null;
  accessEntityLeadDelete?: OrderByEnum | null;
  accessEntityLeadDirection?: OrderByEnum | null;
  accessEntityLeadPrivate?: OrderByEnum | null;
  accessEntityLeadTagCreate?: OrderByEnum | null;
  accessEntityMessageTagCreate?: OrderByEnum | null;
  accessEntityOppty?: OrderByEnum | null;
  accessEntityOpptyCopy?: OrderByEnum | null;
  accessEntityOpptyDelete?: OrderByEnum | null;
  accessEntityOpptyDirection?: OrderByEnum | null;
  accessEntityOpptyPrivate?: OrderByEnum | null;
  accessEntityOpptyTagCreate?: OrderByEnum | null;
  accessEntityPipeline?: OrderByEnum | null;
  accessEntityProcess?: OrderByEnum | null;
  accessEntityProfile?: OrderByEnum | null;
  accessEntityProfileDeleteNotOwned?: OrderByEnum | null;
  accessEntityProfileDeleteOwned?: OrderByEnum | null;
  accessEntityProfileSharingCustom?: OrderByEnum | null;
  accessEntityProfileSharingPublic?: OrderByEnum | null;
  accessEntityProject?: OrderByEnum | null;
  accessEntityProjectCopy?: OrderByEnum | null;
  accessEntityProjectDelete?: OrderByEnum | null;
  accessEntityProjectDirection?: OrderByEnum | null;
  accessEntityProjectPrivate?: OrderByEnum | null;
  accessEntityProjectTagCreate?: OrderByEnum | null;
  accessEntityQuote?: OrderByEnum | null;
  accessEntityQuoteCopy?: OrderByEnum | null;
  accessEntityQuoteDelete?: OrderByEnum | null;
  accessEntityQuoteDirection?: OrderByEnum | null;
  accessEntityReport?: OrderByEnum | null;
  accessEntityReportCreateDeleteFolder?: OrderByEnum | null;
  accessEntityReportDeleteNotOwned?: OrderByEnum | null;
  accessEntityReportDeleteOwned?: OrderByEnum | null;
  accessEntityReportPrivate?: OrderByEnum | null;
  accessEntityReportScheduleCreate?: OrderByEnum | null;
  accessEntityReportScheduleManagement?: OrderByEnum | null;
  accessEntityReportSharingCustom?: OrderByEnum | null;
  accessEntityReportSharingPublic?: OrderByEnum | null;
  accessEntityTarget?: OrderByEnum | null;
  accessEntityTargetDeleteNotOwned?: OrderByEnum | null;
  accessEntityTargetDeleteOwned?: OrderByEnum | null;
  accessEntityTask?: OrderByEnum | null;
  accessEntityTaskDelete?: OrderByEnum | null;
  accessEntityTaskDirection?: OrderByEnum | null;
  accessEntityTaskTagCreate?: OrderByEnum | null;
  accessEntityTaskUnassigned?: OrderByEnum | null;
  accessExport?: OrderByEnum | null;
  accessFeeds?: OrderByEnum | null;
  accessForeignCurrencies?: OrderByEnum | null;
  accessFormAndFields?: OrderByEnum | null;
  accessGlobalSettings?: OrderByEnum | null;
  accessHomeScreen?: OrderByEnum | null;
  accessImport?: OrderByEnum | null;
  accessInsights?: OrderByEnum | null;
  accessLeads?: OrderByEnum | null;
  accessOnlineForms?: OrderByEnum | null;
  accessOnlineFormsManagement?: OrderByEnum | null;
  accessOpportunity?: OrderByEnum | null;
  accessPipelineConfiguration?: OrderByEnum | null;
  accessPrint?: OrderByEnum | null;
  accessProductsServices?: OrderByEnum | null;
  accessProjects?: OrderByEnum | null;
  accessQuotes?: OrderByEnum | null;
  accessSalesRoles?: OrderByEnum | null;
  accessSecurity?: OrderByEnum | null;
  accessUnits?: OrderByEnum | null;
  accessUserAndRoles?: OrderByEnum | null;
  accessVoyagerAi?: OrderByEnum | null;
  accessWhatsAppCompanyPhone?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MasterRightOrderByInput {
  __typename?: 'MasterRightOrderByInput';
  accessAccountRelationTypes?: OrderByEnum | null;
  accessAccounts?: OrderByEnum | null;
  accessAiAutomatizer?: OrderByEnum | null;
  accessAiOnlineForms?: OrderByEnum | null;
  accessAiRecordDetail?: OrderByEnum | null;
  accessAiReports?: OrderByEnum | null;
  accessAiSmartField?: OrderByEnum | null;
  accessAppointmentScheduler?: OrderByEnum | null;
  accessAppointmentSchedulerManagement?: OrderByEnum | null;
  accessApprovalProcesses?: OrderByEnum | null;
  accessApprovalProcessesManagement?: OrderByEnum | null;
  accessApprovals?: OrderByEnum | null;
  accessArchive?: OrderByEnum | null;
  accessAudit?: OrderByEnum | null;
  accessAuditLog?: OrderByEnum | null;
  accessBulkUpdate?: OrderByEnum | null;
  accessCalling?: OrderByEnum | null;
  accessCallingCompanyPhone?: OrderByEnum | null;
  accessCallingPurchasePhone?: OrderByEnum | null;
  accessCompanyEmails?: OrderByEnum | null;
  accessContacts?: OrderByEnum | null;
  accessDocumentManagement?: OrderByEnum | null;
  accessDocumentManagementCompany?: OrderByEnum | null;
  accessDocumentManagementRecord?: OrderByEnum | null;
  accessDuplicateChecker?: OrderByEnum | null;
  accessEntityAccount?: OrderByEnum | null;
  accessEntityAccountCopy?: OrderByEnum | null;
  accessEntityAccountDelete?: OrderByEnum | null;
  accessEntityAccountDirection?: OrderByEnum | null;
  accessEntityAccountPrivate?: OrderByEnum | null;
  accessEntityAccountTagCreate?: OrderByEnum | null;
  accessEntityAppointment?: OrderByEnum | null;
  accessEntityAppointmentDelete?: OrderByEnum | null;
  accessEntityAppointmentDirection?: OrderByEnum | null;
  accessEntityAppointmentTagCreate?: OrderByEnum | null;
  accessEntityBetterNavigator?: OrderByEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned?: OrderByEnum | null;
  accessEntityBetterNavigatorDeleteOwned?: OrderByEnum | null;
  accessEntityBetterNavigatorSharingCustom?: OrderByEnum | null;
  accessEntityBetterNavigatorSharingPublic?: OrderByEnum | null;
  accessEntityContact?: OrderByEnum | null;
  accessEntityContactCopy?: OrderByEnum | null;
  accessEntityContactDelete?: OrderByEnum | null;
  accessEntityContactDirection?: OrderByEnum | null;
  accessEntityContactPrivate?: OrderByEnum | null;
  accessEntityContactTagCreate?: OrderByEnum | null;
  accessEntityDashboard?: OrderByEnum | null;
  accessEntityDashboardDeleteNotOwned?: OrderByEnum | null;
  accessEntityDashboardDeleteOwned?: OrderByEnum | null;
  accessEntityDashboardSharingCustom?: OrderByEnum | null;
  accessEntityDashboardSharingPublic?: OrderByEnum | null;
  accessEntityEmailContentShareMode?: OrderByEnum | null;
  accessEntityEmailDeleteNotOwned?: OrderByEnum | null;
  accessEntityEmailSequence?: OrderByEnum | null;
  accessEntityEmailTemplate?: OrderByEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder?: OrderByEnum | null;
  accessEntityEmailTemplateDeleteNotOwned?: OrderByEnum | null;
  accessEntityEmailTemplateDeleteOwned?: OrderByEnum | null;
  accessEntityEmailTemplateSharingCustom?: OrderByEnum | null;
  accessEntityEmailTemplateSharingPublic?: OrderByEnum | null;
  accessEntityForecast?: OrderByEnum | null;
  accessEntityForecastDeleteNotOwned?: OrderByEnum | null;
  accessEntityForecastDeleteOwned?: OrderByEnum | null;
  accessEntityForecastEditNotOwned?: OrderByEnum | null;
  accessEntityForecastSharingCustom?: OrderByEnum | null;
  accessEntityForecastSharingPublic?: OrderByEnum | null;
  accessEntityFormView?: OrderByEnum | null;
  accessEntityFormViewDeleteNotOwned?: OrderByEnum | null;
  accessEntityFormViewDeleteOwned?: OrderByEnum | null;
  accessEntityFormViewSharingCustom?: OrderByEnum | null;
  accessEntityFormViewSharingPublic?: OrderByEnum | null;
  accessEntityLead?: OrderByEnum | null;
  accessEntityLeadCopy?: OrderByEnum | null;
  accessEntityLeadDelete?: OrderByEnum | null;
  accessEntityLeadDirection?: OrderByEnum | null;
  accessEntityLeadPrivate?: OrderByEnum | null;
  accessEntityLeadTagCreate?: OrderByEnum | null;
  accessEntityMessageTagCreate?: OrderByEnum | null;
  accessEntityOppty?: OrderByEnum | null;
  accessEntityOpptyCopy?: OrderByEnum | null;
  accessEntityOpptyDelete?: OrderByEnum | null;
  accessEntityOpptyDirection?: OrderByEnum | null;
  accessEntityOpptyPrivate?: OrderByEnum | null;
  accessEntityOpptyTagCreate?: OrderByEnum | null;
  accessEntityPipeline?: OrderByEnum | null;
  accessEntityProcess?: OrderByEnum | null;
  accessEntityProfile?: OrderByEnum | null;
  accessEntityProfileDeleteNotOwned?: OrderByEnum | null;
  accessEntityProfileDeleteOwned?: OrderByEnum | null;
  accessEntityProfileSharingCustom?: OrderByEnum | null;
  accessEntityProfileSharingPublic?: OrderByEnum | null;
  accessEntityProject?: OrderByEnum | null;
  accessEntityProjectCopy?: OrderByEnum | null;
  accessEntityProjectDelete?: OrderByEnum | null;
  accessEntityProjectDirection?: OrderByEnum | null;
  accessEntityProjectPrivate?: OrderByEnum | null;
  accessEntityProjectTagCreate?: OrderByEnum | null;
  accessEntityQuote?: OrderByEnum | null;
  accessEntityQuoteCopy?: OrderByEnum | null;
  accessEntityQuoteDelete?: OrderByEnum | null;
  accessEntityQuoteDirection?: OrderByEnum | null;
  accessEntityReport?: OrderByEnum | null;
  accessEntityReportCreateDeleteFolder?: OrderByEnum | null;
  accessEntityReportDeleteNotOwned?: OrderByEnum | null;
  accessEntityReportDeleteOwned?: OrderByEnum | null;
  accessEntityReportPrivate?: OrderByEnum | null;
  accessEntityReportScheduleCreate?: OrderByEnum | null;
  accessEntityReportScheduleManagement?: OrderByEnum | null;
  accessEntityReportSharingCustom?: OrderByEnum | null;
  accessEntityReportSharingPublic?: OrderByEnum | null;
  accessEntityTarget?: OrderByEnum | null;
  accessEntityTargetDeleteNotOwned?: OrderByEnum | null;
  accessEntityTargetDeleteOwned?: OrderByEnum | null;
  accessEntityTask?: OrderByEnum | null;
  accessEntityTaskDelete?: OrderByEnum | null;
  accessEntityTaskDirection?: OrderByEnum | null;
  accessEntityTaskTagCreate?: OrderByEnum | null;
  accessEntityTaskUnassigned?: OrderByEnum | null;
  accessExport?: OrderByEnum | null;
  accessFeeds?: OrderByEnum | null;
  accessForeignCurrencies?: OrderByEnum | null;
  accessFormAndFields?: OrderByEnum | null;
  accessGlobalSettings?: OrderByEnum | null;
  accessHomeScreen?: OrderByEnum | null;
  accessImport?: OrderByEnum | null;
  accessInsights?: OrderByEnum | null;
  accessLeads?: OrderByEnum | null;
  accessOnlineForms?: OrderByEnum | null;
  accessOnlineFormsManagement?: OrderByEnum | null;
  accessOpportunity?: OrderByEnum | null;
  accessPipelineConfiguration?: OrderByEnum | null;
  accessPrint?: OrderByEnum | null;
  accessProductsServices?: OrderByEnum | null;
  accessProjects?: OrderByEnum | null;
  accessQuotes?: OrderByEnum | null;
  accessSalesRoles?: OrderByEnum | null;
  accessSecurity?: OrderByEnum | null;
  accessUnits?: OrderByEnum | null;
  accessUserAndRoles?: OrderByEnum | null;
  accessVoyagerAi?: OrderByEnum | null;
  accessWhatsAppCompanyPhone?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface MasterRightFilterInput {
  __typename?: 'MasterRightFilterInput';
  AND?: MasterRightFilterInput[] | null;
  NOT?: MasterRightFilterInput | null;
  OR?: MasterRightFilterInput[] | null;
  accessAccountRelationTypes?: boolean | null;
  accessAccounts?: boolean | null;
  accessAiAutomatizer?: boolean | null;
  accessAiOnlineForms?: boolean | null;
  accessAiRecordDetail?: boolean | null;
  accessAiReports?: boolean | null;
  accessAiSmartField?: boolean | null;
  accessAppointmentScheduler?: boolean | null;
  accessAppointmentSchedulerManagement?: boolean | null;
  accessApprovalProcesses?: boolean | null;
  accessApprovalProcessesManagement?: boolean | null;
  accessApprovals?: boolean | null;
  accessArchive?: boolean | null;
  accessAudit?: boolean | null;
  accessAuditLog?: boolean | null;
  accessBulkUpdate?: boolean | null;
  accessCalling?: boolean | null;
  accessCallingCompanyPhone?: AccessLevelCompanyEmailsEnumFilterInput | null;
  accessCallingPurchasePhone?: boolean | null;
  accessCompanyEmails?: AccessLevelCompanyEmailsEnumFilterInput | null;
  accessContacts?: boolean | null;
  accessDocumentManagement?: boolean | null;
  accessDocumentManagementCompany?: boolean | null;
  accessDocumentManagementRecord?: boolean | null;
  accessDuplicateChecker?: boolean | null;
  accessEntityAccount?: AccessLevelEntityEnumFilterInput | null;
  accessEntityAccountCopy?: boolean | null;
  accessEntityAccountDelete?: boolean | null;
  accessEntityAccountDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityAccountPrivate?: boolean | null;
  accessEntityAccountTagCreate?: boolean | null;
  accessEntityAccountTypes?: AccessEntityTypesEnumFilterInput | null;
  accessEntityAppointment?: AccessLevelEntityEnumFilterInput | null;
  accessEntityAppointmentDelete?: boolean | null;
  accessEntityAppointmentDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityAppointmentTagCreate?: boolean | null;
  accessEntityBetterNavigator?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityBetterNavigatorDeleteNotOwned?: boolean | null;
  accessEntityBetterNavigatorDeleteOwned?: boolean | null;
  accessEntityBetterNavigatorSharingCustom?: boolean | null;
  accessEntityBetterNavigatorSharingPublic?: boolean | null;
  accessEntityContact?: AccessLevelEntityEnumFilterInput | null;
  accessEntityContactCopy?: boolean | null;
  accessEntityContactDelete?: boolean | null;
  accessEntityContactDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityContactPrivate?: boolean | null;
  accessEntityContactTagCreate?: boolean | null;
  accessEntityContactTypes?: AccessEntityTypesEnumFilterInput | null;
  accessEntityDashboard?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityDashboardDeleteNotOwned?: boolean | null;
  accessEntityDashboardDeleteOwned?: boolean | null;
  accessEntityDashboardSharingCustom?: boolean | null;
  accessEntityDashboardSharingPublic?: boolean | null;
  accessEntityEmailContentShareMode?: ContentShareModeConfigEnumFilterInput | null;
  accessEntityEmailDeleteNotOwned?: boolean | null;
  accessEntityEmailSequence?: AccessLevelEmailSequenceEnumFilterInput | null;
  accessEntityEmailTemplate?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityEmailTemplateCreateDeleteFolder?: boolean | null;
  accessEntityEmailTemplateDeleteNotOwned?: boolean | null;
  accessEntityEmailTemplateDeleteOwned?: boolean | null;
  accessEntityEmailTemplateSharingCustom?: boolean | null;
  accessEntityEmailTemplateSharingPublic?: boolean | null;
  accessEntityForecast?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityForecastDeleteNotOwned?: boolean | null;
  accessEntityForecastDeleteOwned?: boolean | null;
  accessEntityForecastEditNotOwned?: boolean | null;
  accessEntityForecastSharingCustom?: boolean | null;
  accessEntityForecastSharingPublic?: boolean | null;
  accessEntityFormView?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityFormViewDeleteNotOwned?: boolean | null;
  accessEntityFormViewDeleteOwned?: boolean | null;
  accessEntityFormViewSharingCustom?: boolean | null;
  accessEntityFormViewSharingPublic?: boolean | null;
  accessEntityLead?: AccessLevelEntityEnumFilterInput | null;
  accessEntityLeadCopy?: boolean | null;
  accessEntityLeadDelete?: boolean | null;
  accessEntityLeadDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityLeadPrivate?: boolean | null;
  accessEntityLeadTagCreate?: boolean | null;
  accessEntityLeadTypes?: AccessEntityTypesEnumFilterInput | null;
  accessEntityMessageTagCreate?: boolean | null;
  accessEntityOppty?: AccessLevelEntityEnumFilterInput | null;
  accessEntityOpptyCopy?: boolean | null;
  accessEntityOpptyDelete?: boolean | null;
  accessEntityOpptyDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityOpptyPrivate?: boolean | null;
  accessEntityOpptyTagCreate?: boolean | null;
  accessEntityPipeline?: AccessLevelPipelineEnumFilterInput | null;
  accessEntityProcess?: AccessLevelProcessBuilderEnumFilterInput | null;
  accessEntityProfile?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityProfileDeleteNotOwned?: boolean | null;
  accessEntityProfileDeleteOwned?: boolean | null;
  accessEntityProfileSharingCustom?: boolean | null;
  accessEntityProfileSharingPublic?: boolean | null;
  accessEntityProject?: AccessLevelEntityEnumFilterInput | null;
  accessEntityProjectCopy?: boolean | null;
  accessEntityProjectDelete?: boolean | null;
  accessEntityProjectDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityProjectPrivate?: boolean | null;
  accessEntityProjectTagCreate?: boolean | null;
  accessEntityQuote?: AccessLevelEntityEnumFilterInput | null;
  accessEntityQuoteCopy?: boolean | null;
  accessEntityQuoteDelete?: boolean | null;
  accessEntityQuoteDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityQuoteTypes?: AccessEntityTypesEnumFilterInput | null;
  accessEntityReport?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityReportCreateDeleteFolder?: boolean | null;
  accessEntityReportDeleteNotOwned?: boolean | null;
  accessEntityReportDeleteOwned?: boolean | null;
  accessEntityReportPrivate?: boolean | null;
  accessEntityReportScheduleCreate?: boolean | null;
  accessEntityReportScheduleManagement?: boolean | null;
  accessEntityReportSharingCustom?: boolean | null;
  accessEntityReportSharingPublic?: boolean | null;
  accessEntityTarget?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  accessEntityTargetDeleteNotOwned?: boolean | null;
  accessEntityTargetDeleteOwned?: boolean | null;
  accessEntityTask?: AccessLevelEntityEnumFilterInput | null;
  accessEntityTaskDelete?: boolean | null;
  accessEntityTaskDirection?: AccessDirectionEnumFilterInput | null;
  accessEntityTaskTagCreate?: boolean | null;
  accessEntityTaskUnassigned?: boolean | null;
  accessExport?: boolean | null;
  accessFeeds?: boolean | null;
  accessForeignCurrencies?: boolean | null;
  accessFormAndFields?: boolean | null;
  accessGlobalSettings?: boolean | null;
  accessHomeScreen?: boolean | null;
  accessImport?: boolean | null;
  accessInsights?: boolean | null;
  accessLeads?: boolean | null;
  accessOnlineForms?: boolean | null;
  accessOnlineFormsManagement?: boolean | null;
  accessOpportunity?: boolean | null;
  accessPipelineConfiguration?: boolean | null;
  accessPrint?: boolean | null;
  accessProductsServices?: boolean | null;
  accessProjects?: boolean | null;
  accessQuotes?: boolean | null;
  accessSalesRoles?: boolean | null;
  accessSecurity?: boolean | null;
  accessUnits?: boolean | null;
  accessUserAndRoles?: boolean | null;
  accessVoyagerAi?: boolean | null;
  accessWhatsAppCompanyPhone?: AccessLevelCompanyEmailsEnumFilterInput | null;
  allowedAccountTypes?: AllowedAccountTypeFilterInput | null;
  allowedCompanyEmails?: AllowedCompanyEmailFilterInput | null;
  allowedCompanyPhones?: AllowedCompanyPhoneFilterInput | null;
  allowedContactTypes?: AllowedContactTypeFilterInput | null;
  allowedLeadTypes?: AllowedLeadTypeFilterInput | null;
  allowedPipelines?: AllowedPipelineFilterInput | null;
  allowedQuoteTypes?: AllowedQuoteTypeFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface MarkNotificationsRevisionSeenInput {
  __typename?: 'MarkNotificationsRevisionSeenInput';
  clientMutationId?: string | null;
  revision: number;
}

export interface MarkNotificationsAsReadInput {
  __typename?: 'MarkNotificationsAsReadInput';
  clientMutationId?: string | null;
  groupCursor: ID;
}

export interface MarkAllNotificationsAsReadInput {
  __typename?: 'MarkAllNotificationsAsReadInput';
  clientMutationId?: string | null;
  revision: number;
}

export interface ManualMergeDuplicatesInput {
  __typename?: 'ManualMergeDuplicatesInput';
  clientMutationId?: string | null;
  entity: EntityNameEnum;
  entityApiName?: string | null;
  entityIds: UUID[];
  fieldIds: MergeDuplicatesFieldParams[];
  masterEntityId: UUID;
}

export interface ManageUserDataClientInput {
  __typename?: 'ManageUserDataClientInput';
  action: ManageUserDataActionEnum;
  clientMutationId?: string | null;
  emailTemplates: boolean;
  formViews: boolean;
  ids: UUID[];
  importTemplates: boolean;
  newOwnerId?: UUID | null;
  profiles: boolean;
  reports: boolean;
}

export interface ManageSharingTaskInput {
  __typename?: 'ManageSharingTaskInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateTaskSharingClientRelationNoTaskBackrefInput[] | null;
  sharingUnits?: CreateTaskSharingSalesUnitRelationNoTaskBackrefInput[] | null;
}

export interface ManageSharingQuoteInput {
  __typename?: 'ManageSharingQuoteInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateQuoteSharingClientRelationNoQuoteBackrefInput[] | null;
  sharingUnits?: CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput[] | null;
}

export interface ManageSharingProjectInput {
  __typename?: 'ManageSharingProjectInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateProjectSharingClientRelationNoProjectBackrefInput[] | null;
  sharingUnits?: CreateProjectSharingSalesUnitRelationNoProjectBackrefInput[] | null;
}

export interface ManageSharingOpportunityInput {
  __typename?: 'ManageSharingOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
}

export interface ManageSharingLeadInput {
  __typename?: 'ManageSharingLeadInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
}

export interface ManageSharingEmailInput {
  __typename?: 'ManageSharingEmailInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
}

export interface ManageSharingCustomEntityInput {
  __typename?: 'ManageSharingCustomEntityInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput[] | null;
  sharingUnits?: CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput[] | null;
}

export interface ManageSharingContactInput {
  __typename?: 'ManageSharingContactInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateContactSharingClientRelationNoContactBackrefInput[] | null;
  sharingUnits?: CreateContactSharingSalesUnitRelationNoContactBackrefInput[] | null;
}

export interface ManageSharingAccountInput {
  __typename?: 'ManageSharingAccountInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ShareModeEnum;
  sharingClients?: CreateAccountSharingClientRelationNoAccountBackrefInput[] | null;
  sharingUnits?: CreateAccountSharingSalesUnitRelationNoAccountBackrefInput[] | null;
}

export interface ManageContentSharingEmailInput {
  __typename?: 'ManageContentSharingEmailInput';
  clientMutationId?: string | null;
  id: ID;
  shareMode: ContentShareModeEnum;
  sharingClients?: CreateEmailContentSharingClientRelationNoEmailBackrefInput[] | null;
  sharingUnits?: CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput[] | null;
}

export interface MakeProfileActiveInput {
  __typename?: 'MakeProfileActiveInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  profileId: ID;
  screenType: ScreenType;
}

export interface MainFilterBoxParams {
  __typename?: 'MainFilterBoxParams';
  entity: string;
  filterFields: FieldFilterRuleParams[];
  id: string;
  lookupFieldId?: UUID | null;
}

export interface LookupPropertyParams {
  __typename?: 'LookupPropertyParams';
  entityApiName?: string | null;
  entityType?: LookupEntityTypeEnum | null;
  filter?: FieldFilterParams | null;
  hasPrimaryRelation?: boolean | null;
  oppositeLookupFieldId?: UUID | null;
  showRelated: boolean;
  tabName: string;
}

export interface LookupItemInput {
  __typename?: 'LookupItemInput';
  id: UUID;
  isPrimary?: boolean | null;
}

export interface ListFolderInput {
  __typename?: 'ListFolderInput';
  created?: DateTime | null;
  description?: string | null;
  id?: string | null;
  isFile?: boolean | null;
  mimeType?: string | null;
  name?: string | null;
  url?: string | null;
}

export interface LinkCustomEntityRelationDataInput {
  __typename?: 'LinkCustomEntityRelationDataInput';
  clientMutationId?: string | null;
  entityId: UUID;
  fieldId: UUID;
  ids: UUID[];
  type?: FieldRelationTypeEnum | null;
}

export interface LifeCycleProfileViewTabParams {
  __typename?: 'LifeCycleProfileViewTabParams';
  calculateOpptyByFieldId?: UUID | null;
  period: PeriodOptionParams;
}

export interface LifeCycleProfileParams {
  __typename?: 'LifeCycleProfileParams';
  filter: OpportunityFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  salesPipeline?: ID[] | null;
  view: LifeCycleProfileViewTabParams;
}

export interface LifeCycleProfileDataInput {
  __typename?: 'LifeCycleProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: LifeCycleProfileParams;
}

export interface LeadsAndOpportunitiesNotificationSettingsParams {
  __typename?: 'LeadsAndOpportunitiesNotificationSettingsParams';
  IsActive: boolean;
  LinkedItem: boolean;
  Move: boolean;
  OwnershipAndSalesTeamChange: boolean;
  Qualification: boolean;
  StatusChange: boolean;
}

export interface LeadTypeOrderByNestedInput {
  __typename?: 'LeadTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  formLostEnabled?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  leadProcessId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadTypeOrderByInput {
  __typename?: 'LeadTypeOrderByInput';
  created?: OrderByEnum | null;
  formLostEnabled?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  leadProcess?: LeadProcessOrderByNestedInput[] | null;
  leadProcessId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadTypeFilterInput {
  __typename?: 'LeadTypeFilterInput';
  AND?: LeadTypeFilterInput[] | null;
  NOT?: LeadTypeFilterInput | null;
  OR?: LeadTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  formLostEnabled?: boolean | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  leadProcess?: LeadProcessFilterInput | null;
  leadProcessId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface LeadTabDataGridViewOptionsParams {
  __typename?: 'LeadTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStatus?: LeadStatusEnum[] | null;
  filterByTags?: ID[] | null;
  searchQuery?: string | null;
}

export interface LeadStatusEnumFilterInput {
  __typename?: 'LeadStatusEnumFilterInput';
  NOT?: LeadStatusEnumFilterInput | null;
  eq?: LeadStatusEnum[] | null;
}

export interface LeadRoleTabParams {
  __typename?: 'LeadRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
  showUnassignedItems: boolean;
}

export interface LeadProfileDataInput {
  __typename?: 'LeadProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: LeadPreviewProfileParams;
}

export interface LeadProcessOrderByNestedInput {
  __typename?: 'LeadProcessOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadProcessOrderByInput {
  __typename?: 'LeadProcessOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadProcessFilterInput {
  __typename?: 'LeadProcessFilterInput';
  AND?: LeadProcessFilterInput[] | null;
  NOT?: LeadProcessFilterInput | null;
  OR?: LeadProcessFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface LeadPreviewViewTabParams {
  __typename?: 'LeadPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  groupBy?: LeadGroupBy | null;
  showCardFitness?: boolean | null;
  showCardLabels?: boolean | null;
  showCardRanking?: boolean | null;
  showCardVelocity?: boolean | null;
  showExtraFieldIds?: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface LeadPreviewProfileParams {
  __typename?: 'LeadPreviewProfileParams';
  filter: LeadFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  role: LeadRoleTabParams;
  view: LeadPreviewViewTabParams;
}

export interface LeadOrderByNestedInput {
  __typename?: 'LeadOrderByNestedInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  labelFlag?: OrderByEnum | null;
  leadSourceId?: OrderByEnum | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  ranking?: OrderByEnum | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepId?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface LeadOrderByInput {
  __typename?: 'LeadOrderByInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  labelFlag?: OrderByEnum | null;
  leadSource?: DataOrderByNestedInput[] | null;
  leadSourceId?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  quickAccountEmail?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  quickAccountPhone?: OrderByEnum | null;
  quickContactName?: OrderByEnum | null;
  quickEmail?: OrderByEnum | null;
  quickPhone?: OrderByEnum | null;
  ranking?: OrderByEnum | null;
  reasonOfClose?: DataOrderByNestedInput[] | null;
  reasonOfCloseDescription?: OrderByEnum | null;
  reasonOfCloseId?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  status?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface LeadOpptyStepCheckListRelationOrderByInput {
  __typename?: 'LeadOpptyStepCheckListRelationOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  cloudObject?: CloudObjectOrderByNestedInput[] | null;
  cloudObjectId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  itemChecked?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  note?: NoteOrderByNestedInput[] | null;
  noteId?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  stepChecklist?: StepChecklistOrderByNestedInput[] | null;
  stepChecklistId?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface LeadOpptyStepCheckListRelationFilterInput {
  __typename?: 'LeadOpptyStepCheckListRelationFilterInput';
  AND?: LeadOpptyStepCheckListRelationFilterInput[] | null;
  NOT?: LeadOpptyStepCheckListRelationFilterInput | null;
  OR?: LeadOpptyStepCheckListRelationFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  cloudObject?: CloudObjectFilterInput | null;
  cloudObjectId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  itemChecked?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  note?: NoteFilterInput | null;
  noteId?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  stepChecklist?: StepChecklistFilterInput | null;
  stepChecklistId?: EntityFilterStringField | null;
  task?: TaskFilterInput | null;
}

export interface LeadOpptySharingSalesUnitRelationOrderByInput {
  __typename?: 'LeadOpptySharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface LeadOpptySharingSalesUnitRelationFilterInput {
  __typename?: 'LeadOpptySharingSalesUnitRelationFilterInput';
  AND?: LeadOpptySharingSalesUnitRelationFilterInput[] | null;
  NOT?: LeadOpptySharingSalesUnitRelationFilterInput | null;
  OR?: LeadOpptySharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface LeadOpptySharingClientRelationOrderByInput {
  __typename?: 'LeadOpptySharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface LeadOpptySharingClientRelationFilterInput {
  __typename?: 'LeadOpptySharingClientRelationFilterInput';
  AND?: LeadOpptySharingClientRelationFilterInput[] | null;
  NOT?: LeadOpptySharingClientRelationFilterInput | null;
  OR?: LeadOpptySharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface LeadOpptyOrderByInput {
  __typename?: 'LeadOpptyOrderByInput';
  id?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
}

export interface LeadOpptyKpiEnumFilterInput {
  __typename?: 'LeadOpptyKpiEnumFilterInput';
  NOT?: LeadOpptyKpiEnumFilterInput | null;
  eq?: LeadOpptyKpiEnum[] | null;
}

export interface LeadOpptyKPIOrderByInput {
  __typename?: 'LeadOpptyKPIOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface LeadOpptyKPIFilterInput {
  __typename?: 'LeadOpptyKPIFilterInput';
  AND?: LeadOpptyKPIFilterInput[] | null;
  NOT?: LeadOpptyKPIFilterInput | null;
  OR?: LeadOpptyKPIFilterInput[] | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: LeadOpptyKpiEnumFilterInput | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface LeadOpptyFilterInput {
  __typename?: 'LeadOpptyFilterInput';
  AND?: LeadOpptyFilterInput[] | null;
  NOT?: LeadOpptyFilterInput | null;
  OR?: LeadOpptyFilterInput[] | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  relatedEntities?: EntityFilterRelatedField[] | null;
}

export interface LeadOpptyDrilldownFilterParams {
  __typename?: 'LeadOpptyDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface LeadOpptyDataExRelationOrderByInput {
  __typename?: 'LeadOpptyDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyDataExRelationFilterInput {
  __typename?: 'LeadOpptyDataExRelationFilterInput';
  AND?: LeadOpptyDataExRelationFilterInput[] | null;
  NOT?: LeadOpptyDataExRelationFilterInput | null;
  OR?: LeadOpptyDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface LeadOpptyContactSalesRoleRelationOrderByInput {
  __typename?: 'LeadOpptyContactSalesRoleRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyContactRelation?: LeadOpptyContactRelationOrderByNestedInput[] | null;
  leadOpptyContactRelationId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  salesRole?: SalesRoleOrderByNestedInput[] | null;
  salesRoleId?: OrderByEnum | null;
}

export interface LeadOpptyContactSalesRoleRelationFilterInput {
  __typename?: 'LeadOpptyContactSalesRoleRelationFilterInput';
  AND?: LeadOpptyContactSalesRoleRelationFilterInput[] | null;
  NOT?: LeadOpptyContactSalesRoleRelationFilterInput | null;
  OR?: LeadOpptyContactSalesRoleRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadOpptyContactRelation?: LeadOpptyContactRelationFilterInput | null;
  leadOpptyContactRelationId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  salesRole?: SalesRoleFilterInput | null;
  salesRoleId?: EntityFilterStringField | null;
}

export interface LeadOpptyContactRelationOrderByNestedInput {
  __typename?: 'LeadOpptyContactRelationOrderByNestedInput';
  comment?: OrderByEnum | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  leadOpptyContactGroupRelationId?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  relationship?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyContactRelationOrderByInput {
  __typename?: 'LeadOpptyContactRelationOrderByInput';
  comment?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyContactGroupRelation?: LeadOpptyContactGroupRelationOrderByNestedInput[] | null;
  leadOpptyContactGroupRelationId?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  relationship?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyContactRelationFilterInput {
  __typename?: 'LeadOpptyContactRelationFilterInput';
  AND?: LeadOpptyContactRelationFilterInput[] | null;
  NOT?: LeadOpptyContactRelationFilterInput | null;
  OR?: LeadOpptyContactRelationFilterInput[] | null;
  comment?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyContactGroupRelation?: LeadOpptyContactGroupRelationFilterInput | null;
  leadOpptyContactGroupRelationId?: EntityFilterStringField | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  relationship?: OrgRelationshipTypeEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
  salesRoles?: LeadOpptyContactSalesRoleRelationFilterInput | null;
}

export interface LeadOpptyContactGroupRelationOrderByNestedInput {
  __typename?: 'LeadOpptyContactGroupRelationOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyContactGroupRelationOrderByInput {
  __typename?: 'LeadOpptyContactGroupRelationOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyContactGroupRelationFilterInput {
  __typename?: 'LeadOpptyContactGroupRelationFilterInput';
  AND?: LeadOpptyContactGroupRelationFilterInput[] | null;
  NOT?: LeadOpptyContactGroupRelationFilterInput | null;
  OR?: LeadOpptyContactGroupRelationFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface LeadOpptyAccountRelationOrderByInput {
  __typename?: 'LeadOpptyAccountRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
}

export interface LeadOpptyAccountRelationFilterInput {
  __typename?: 'LeadOpptyAccountRelationFilterInput';
  AND?: LeadOpptyAccountRelationFilterInput[] | null;
  NOT?: LeadOpptyAccountRelationFilterInput | null;
  OR?: LeadOpptyAccountRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface LeadOpportunityFilterTabParams {
  __typename?: 'LeadOpportunityFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface LeadFilterTabParams {
  __typename?: 'LeadFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface LeadFilterInput {
  __typename?: 'LeadFilterInput';
  AND?: LeadFilterInput[] | null;
  NOT?: LeadFilterInput | null;
  OR?: LeadFilterInput[] | null;
  accountRelations?: LeadOpptyAccountRelationFilterInput | null;
  contactRelations?: LeadOpptyContactRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  enrolledEmailSequences?: number | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isArchived?: boolean | null;
  isDeleted?: boolean | null;
  labelFlag?: LabelFlagEnumFilterInput | null;
  leadSource?: DataFilterInput | null;
  leadSourceId?: EntityFilterStringField | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  primaryAccount?: AccountFilterInput | null;
  primaryContact?: ContactFilterInput | null;
  quickAccountEmail?: EntityFilterStringField | null;
  quickAccountName?: EntityFilterStringField | null;
  quickAccountPhone?: EntityFilterStringField | null;
  quickContactName?: EntityFilterStringField | null;
  quickEmail?: EntityFilterStringField | null;
  quickPhone?: EntityFilterStringField | null;
  ranking?: EntityFilterNumberField | null;
  reasonOfClose?: DataFilterInput | null;
  reasonOfCloseDescription?: EntityFilterStringField | null;
  reasonOfCloseId?: EntityFilterStringField | null;
  relatedEntities?: EntityFilterRelatedField[] | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: LeadOpptySharingClientRelationFilterInput | null;
  sharingUnits?: LeadOpptySharingSalesUnitRelationFilterInput | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  status?: LeadStatusEnumFilterInput | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
  tags?: TagRelationFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface LeadDrilldownFilterParams {
  __typename?: 'LeadDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface LeadDashboardProfileViewParams {
  __typename?: 'LeadDashboardProfileViewParams';
  drilldownFields: ID[];
  graphs: DashboardGraphLeadNameType[];
}

export interface LeadDashboardProfileParams {
  __typename?: 'LeadDashboardProfileParams';
  filter: LeadFilterTabParams;
  leadProcess?: UUID[] | null;
  role: LeadRoleTabParams;
  view: LeadDashboardProfileViewParams;
}

export interface LeadArchiveProfileParams {
  __typename?: 'LeadArchiveProfileParams';
  filter: LeadFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  role: LeadRoleTabParams;
  view: LeadPreviewViewTabParams;
}

export interface LeadArchiveProfileDataInput {
  __typename?: 'LeadArchiveProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: LeadArchiveProfileParams;
}

export interface LabelFlagEnumFilterInput {
  __typename?: 'LabelFlagEnumFilterInput';
  NOT?: LabelFlagEnumFilterInput | null;
  eq?: LabelFlagEnum[] | null;
}

export interface InviteeResponseEnumFilterInput {
  __typename?: 'InviteeResponseEnumFilterInput';
  NOT?: InviteeResponseEnumFilterInput | null;
  eq?: InviteeResponseEnum[] | null;
}

export interface InterfacePreviewOrderByInput {
  __typename?: 'InterfacePreviewOrderByInput';
  accountType?: AccountTypeOrderByNestedInput[] | null;
  accountTypeId?: OrderByEnum | null;
  appointmentType?: AppointmentTypeOrderByNestedInput[] | null;
  appointmentTypeId?: OrderByEnum | null;
  contactType?: ContactTypeOrderByNestedInput[] | null;
  contactTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntityType?: CustomEntityTypeOrderByNestedInput[] | null;
  customEntityTypeId?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyType?: OpportunityTypeOrderByNestedInput[] | null;
  opptyTypeId?: OrderByEnum | null;
  productType?: ProductTypeOrderByNestedInput[] | null;
  productTypeId?: OrderByEnum | null;
  projectType?: ProjectTypeOrderByNestedInput[] | null;
  projectTypeId?: OrderByEnum | null;
  quoteType?: QuoteTypeOrderByNestedInput[] | null;
  quoteTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  taskType?: TaskTypeOrderByNestedInput[] | null;
  taskTypeId?: OrderByEnum | null;
}

export interface InterfacePreviewFilterInput {
  __typename?: 'InterfacePreviewFilterInput';
  AND?: InterfacePreviewFilterInput[] | null;
  NOT?: InterfacePreviewFilterInput | null;
  OR?: InterfacePreviewFilterInput[] | null;
  accountType?: AccountTypeFilterInput | null;
  accountTypeId?: EntityFilterStringField | null;
  appointmentType?: AppointmentTypeFilterInput | null;
  appointmentTypeId?: EntityFilterStringField | null;
  contactType?: ContactTypeFilterInput | null;
  contactTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntityType?: CustomEntityTypeFilterInput | null;
  customEntityTypeId?: EntityFilterStringField | null;
  entityApiName?: string | null;
  entityType?: BaseEntityTypeEnum | null;
  entityTypeId?: UUID | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  opptyType?: OpportunityTypeFilterInput | null;
  opptyTypeId?: EntityFilterStringField | null;
  productType?: ProductTypeFilterInput | null;
  productTypeId?: EntityFilterStringField | null;
  projectType?: ProjectTypeFilterInput | null;
  projectTypeId?: EntityFilterStringField | null;
  quoteType?: QuoteTypeFilterInput | null;
  quoteTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  taskType?: TaskTypeFilterInput | null;
  taskTypeId?: EntityFilterStringField | null;
}

export interface InterfacePreviewChartInput {
  __typename?: 'InterfacePreviewChartInput';
  description?: string | null;
  entityType: EntityNameEnum;
  filter?: ProfileFilterTabParams | null;
  id: UUID;
  name?: string | null;
  settings?: InterfacePreviewSettingsJSONString | null;
}

export interface InterfaceDetailWidgetParams {
  __typename?: 'InterfaceDetailWidgetParams';
  kind: InterfaceDetailWidgetKind;
  visible: boolean;
}

export interface InterfaceDetailUserWidgetParams {
  __typename?: 'InterfaceDetailUserWidgetParams';
  entityTypeId: ID;
  kind: InterfaceDetailWidgetKind;
}

export interface InterfaceDetailUserTabParams {
  __typename?: 'InterfaceDetailUserTabParams';
  entityTypeId: ID;
  kind: InterfaceDetailTabKind;
  lookupFieldId?: UUID | null;
}

export interface InterfaceDetailTabParams {
  __typename?: 'InterfaceDetailTabParams';
  kind: InterfaceDetailTabKind;
  lookupFieldId?: UUID | null;
  visible: boolean;
}

export interface IntEnumItemParams {
  __typename?: 'IntEnumItemParams';
  key: string;
  value: number;
}

export interface InsightsScreenOptionsParams {
  __typename?: 'InsightsScreenOptionsParams';
  reportBy: InsightsReportBy;
}

export interface InsightsProfileViewTabParams {
  __typename?: 'InsightsProfileViewTabParams';
  calculateOpptyByFieldId?: UUID | null;
  period: PeriodOptionParams;
  periodGranularity: PeriodGranularity;
  showDeletedUnits: boolean;
  showInactiveClients: boolean;
  sortBy: InsightsKPI;
}

export interface InsightsProfileParams {
  __typename?: 'InsightsProfileParams';
  filter: OpportunityKPIFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  salesPipeline?: ID[] | null;
  view: InsightsProfileViewTabParams;
}

export interface InsightsProfileDataInput {
  __typename?: 'InsightsProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: InsightsProfileParams;
}

export interface InitializeMobileCallTaskInput {
  __typename?: 'InitializeMobileCallTaskInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface InitializeMobileCallOpportunityInput {
  __typename?: 'InitializeMobileCallOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface InitializeMobileCallLeadInput {
  __typename?: 'InitializeMobileCallLeadInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface InitializeMobileCallContactInput {
  __typename?: 'InitializeMobileCallContactInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface InitializeMobileCallAppointmentInput {
  __typename?: 'InitializeMobileCallAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface InitializeMobileCallAccountInput {
  __typename?: 'InitializeMobileCallAccountInput';
  clientMutationId?: string | null;
  id: ID;
  initAsync?: boolean | null;
  name: string;
  phoneNumber: string;
}

export interface IndicatorsProfileViewTabParams {
  __typename?: 'IndicatorsProfileViewTabParams';
  calculateOpptyByFieldId?: UUID | null;
  period: PeriodOptionParams;
  periodGranularity: PeriodGranularity;
  showDeletedUnits: boolean;
  showInactiveClients: boolean;
}

export interface IndicatorsProfileParams {
  __typename?: 'IndicatorsProfileParams';
  filter: OpportunityKPIFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  salesPipeline?: ID[] | null;
  view: IndicatorsProfileViewTabParams;
}

export interface IndicatorsProfileDataInput {
  __typename?: 'IndicatorsProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: IndicatorsProfileParams;
}

export interface IndicatorScreenOptionsParams {
  __typename?: 'IndicatorScreenOptionsParams';
  activeKpiTab: InsightsKPI;
  reportBy: IndicatorsReportBy;
}

export interface IncomingSmsForPhoneInput {
  __typename?: 'IncomingSmsForPhoneInput';
  body: string;
  clientMutationId?: string | null;
  messageSid: string;
  notifyEmail?: string | null;
  phoneSid: string;
  sourceNumber: string;
}

export interface ImportSettingsOptionsParams {
  __typename?: 'ImportSettingsOptionsParams';
  autoCreateAccounts: boolean;
  autoCreateContacts: boolean;
  columnsContainHeaders: boolean;
  dateFormat: ImportDateFormatEnum;
  deduplicateAccounts: boolean;
  deduplicateContacts: boolean;
  enclosure: ImportEnclosureEnum;
  encoding: string;
  groupByFieldId?: ID | null;
  multipleCheckboxSeparator: ImportMultipleCheckboxSeparatorEnum;
  separator: ImportSeparatorEnum;
}

export interface ImportMaskEntityTypeEnumFilterInput {
  __typename?: 'ImportMaskEntityTypeEnumFilterInput';
  NOT?: ImportMaskEntityTypeEnumFilterInput | null;
  eq?: ImportMaskEntityTypeEnum[] | null;
}

export interface ImportMappingMaskOrderByInput {
  __typename?: 'ImportMappingMaskOrderByInput';
  created?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
}

export interface ImportMappingMaskFilterInput {
  __typename?: 'ImportMappingMaskFilterInput';
  AND?: ImportMappingMaskFilterInput[] | null;
  NOT?: ImportMappingMaskFilterInput | null;
  OR?: ImportMappingMaskFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityApiName?: EntityFilterStringField | null;
  entityType?: ImportMaskEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
}

export interface HubItemValueMappingParams {
  __typename?: 'HubItemValueMappingParams';
  direction: SyncDirectionEnum;
  externalValue?: string | null;
  localValue?: string | null;
}

export interface HubItemRuleSettingsParams {
  __typename?: 'HubItemRuleSettingsParams';
  autoSync: boolean;
  deduplication?: HubItemDeduplicationSettingParams | null;
  externalRuleSetting: HubItemExternalRuleSettingParams;
  fieldMappings: HubItemFieldMappingParams[];
  filterMapping?: HubItemFilterMappingParams | null;
  id: UUID;
  localRuleSetting: HubItemLocalRuleSettingParams;
  name: string;
  ownerMapping?: HubItemFieldMappingParams | null;
  ownerMappingExtended?: HubItemFieldMappingParams | null;
  pipelines?: HubItemFieldMappingParams[] | null;
  relationSettings: HubItemRelationRuleSettingsParams[];
  salesUnitMapping?: HubItemFieldMappingParams | null;
  syncDirection: SyncDirectionEnum;
  syncFiles?: boolean | null;
  syncNotes?: boolean | null;
}

export interface HubItemRelationRuleSettingsParams {
  __typename?: 'HubItemRelationRuleSettingsParams';
  deduplication?: HubItemDeduplicationSettingParams | null;
  externalRuleSetting: HubItemExternalRuleSettingParams;
  fieldMappings: HubItemFieldMappingParams[];
  filterMapping?: HubItemFilterMappingParams | null;
  id: UUID;
  localRuleSetting: HubItemLocalRuleSettingParams;
  lookupFieldMappings?: HubItemFieldMappingParams | null;
  name: string;
  ownerMapping?: HubItemFieldMappingParams | null;
  ownerMappingExtended?: HubItemFieldMappingParams | null;
  pipelines?: HubItemFieldMappingParams[] | null;
  relationFieldMappings: HubItemFieldMappingParams[];
  salesUnitMapping?: HubItemFieldMappingParams | null;
  syncDirection: SyncDirectionEnum;
  syncFiles?: boolean | null;
  syncNotes?: boolean | null;
}

export interface HubItemLocalRuleSettingParams {
  __typename?: 'HubItemLocalRuleSettingParams';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  entityTypeId?: UUID | null;
  events: HubItemEventSettingParams;
}

export interface HubItemIntegrationSyncConfigParams {
  __typename?: 'HubItemIntegrationSyncConfigParams';
  rules: HubItemRuleSettingsParams[];
}

export interface HubItemIntegrationFilterTabParams {
  __typename?: 'HubItemIntegrationFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface HubItemFilterMappingParams {
  __typename?: 'HubItemFilterMappingParams';
  externalFilter?: HubItemIntegrationFilterTabParams | null;
  localFilter?: HubItemIntegrationFilterTabParams | null;
}

export interface HubItemFieldMappingSettingParams {
  __typename?: 'HubItemFieldMappingSettingParams';
  externalFallbackValue?: JSONString | null;
  localFallbackValue?: JSONString | null;
  valuesMapping?: HubItemValueMappingParams[] | null;
}

export interface HubItemFieldMappingParams {
  __typename?: 'HubItemFieldMappingParams';
  externalFieldId?: ID | null;
  localFieldId?: UUID | null;
  setting?: HubItemFieldMappingSettingParams | null;
  syncDirection: SyncDirectionEnum;
}

export interface HubItemExternalRuleSettingParams {
  __typename?: 'HubItemExternalRuleSettingParams';
  entity: string;
  entityTypeId?: string | null;
  events: HubItemEventSettingParams;
}

export interface HubItemEventSettingParams {
  __typename?: 'HubItemEventSettingParams';
  create: boolean;
  delete: boolean;
  update: boolean;
}

export interface HubItemDeduplicationSettingParams {
  __typename?: 'HubItemDeduplicationSettingParams';
  fields: HubItemDeduplicationFieldMappingParams[];
}

export interface HubItemDeduplicationFieldMappingParams {
  __typename?: 'HubItemDeduplicationFieldMappingParams';
  externalFieldId?: ID | null;
  localFieldId?: UUID | null;
  operator: MatchingOperatorEnum;
}

export interface HowToTypeFilterInput {
  __typename?: 'HowToTypeFilterInput';
  NOT?: HowToTypeFilterInput | null;
  eq?: HowToType[] | null;
}

export interface HowToOrderByInput {
  __typename?: 'HowToOrderByInput';
  actionText?: OrderByEnum | null;
  actionUrl?: OrderByEnum | null;
  category?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  minApiVersion?: OrderByEnum | null;
  resourceUrl?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  title?: OrderByEnum | null;
  type?: OrderByEnum | null;
  uniqueViewCount?: OrderByEnum | null;
  viewCount?: OrderByEnum | null;
}

export interface HowToFilterInput {
  __typename?: 'HowToFilterInput';
  AND?: HowToFilterInput[] | null;
  NOT?: HowToFilterInput | null;
  OR?: HowToFilterInput[] | null;
  actionText?: EntityFilterStringField | null;
  actionUrl?: EntityFilterStringField | null;
  category?: HowToCategoryFilterInput | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  minApiVersion?: EntityFilterNumberField | null;
  resourceUrl?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  title?: EntityFilterStringField | null;
  type?: HowToTypeFilterInput | null;
  uniqueViewCount?: number | null;
  viewCount?: number | null;
}

export interface HowToCategoryFilterInput {
  __typename?: 'HowToCategoryFilterInput';
  NOT?: HowToCategoryFilterInput | null;
  eq?: HowToCategory[] | null;
}

export interface HealthCategoryParams {
  __typename?: 'HealthCategoryParams';
  color: number;
  id: UUID;
  label: string;
  useLang: boolean;
  value: number;
}

export interface HardCodedRelationParams {
  __typename?: 'HardCodedRelationParams';
  kind: SiblingRelationType;
}

export interface HardCodedContainerParams {
  __typename?: 'HardCodedContainerParams';
  id: UUID;
  inAddin?: boolean | null;
  onMobile?: boolean | null;
  type: HardcodedContainerTypeEnum;
}

export interface GroupChildIdParams {
  __typename?: 'GroupChildIdParams';
  childTargetId: UUID;
  parentTargetId: UUID;
}

export interface GridHighlightChangesParams {
  __typename?: 'GridHighlightChangesParams';
  columns?: UUID[] | null;
  customPeriodValue?: number | null;
  isEnabled?: boolean | null;
  period: HighlightPeriodEnum;
  showOnlyRecordsWithChanges: boolean;
}

export interface GridColumnsOutputParams {
  __typename?: 'GridColumnsOutputParams';
  fieldId: string;
  frozen: boolean;
  pixels: boolean;
  width: number;
}

export interface GridColumnsInput {
  __typename?: 'GridColumnsInput';
  fieldId: string;
  frozen: boolean;
  pixels: boolean;
  width: number;
}

export interface GoogleSetSettingsTeamSpaceClientSettingInput {
  __typename?: 'GoogleSetSettingsTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  deleteProtection?: ContactDeletionProtectionEnum | null;
  folder?: string | null;
  recordOwnership?: RecordOwnershipEnum | null;
  service: GoogleSyncSettingTypeEnum;
  syncMethod?: ContactSyncMethodEnum | null;
  syncPrivate: boolean;
}

export interface GoogleEnableTeamSpaceClientSettingInput {
  __typename?: 'GoogleEnableTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: GoogleSyncSettingTypeEnum;
}

export interface GoogleDriveSettingsInput {
  __typename?: 'GoogleDriveSettingsInput';
  googleDriveAccessToken?: string | null;
  googleDriveRefreshToken?: string | null;
}

export interface GoogleDisableTeamSpaceClientSettingInput {
  __typename?: 'GoogleDisableTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: GoogleSyncSettingTypeEnum;
}

export interface GoogleDeactivateTeamSpaceClientSettingInput {
  __typename?: 'GoogleDeactivateTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: GoogleSyncSettingTypeEnum;
}

export interface GoogleAuthorizeTeamSpaceClientSettingInput {
  __typename?: 'GoogleAuthorizeTeamSpaceClientSettingInput';
  authCode: string;
  clientMutationId?: string | null;
  redirectUri: string;
  service: GoogleSyncSettingTypeEnum;
}

export interface GmailActivateTeamSpaceClientSettingInput {
  __typename?: 'GmailActivateTeamSpaceClientSettingInput';
  authCode: string;
  clientMutationId?: string | null;
}

export interface GlobalSearchSearchTypeParams {
  __typename?: 'GlobalSearchSearchTypeParams';
  entityApiName?: string | null;
  type: GlobalSearchType;
}

export interface GlobalSearchFilterParams {
  __typename?: 'GlobalSearchFilterParams';
  created?: PeriodOptionParams | null;
  includeArchived?: boolean | null;
  includeDeleted?: boolean | null;
  includeDeletedAndArchivedRecords?: boolean | null;
  modified?: PeriodOptionParams | null;
  ownerIds: string[];
  salesUnitIds: string[];
}

export interface GhostLeadOpptyContactSalesRoleRelationOrderByInput {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationOrderByInput';
  created?: OrderByEnum | null;
  ghostLeadOpptyContactRelation?: GhostLeadOpptyContactRelationOrderByNestedInput[] | null;
  ghostLeadOpptyContactRelationId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  salesRole?: SalesRoleOrderByNestedInput[] | null;
  salesRoleId?: OrderByEnum | null;
}

export interface GhostLeadOpptyContactSalesRoleRelationFilterInput {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationFilterInput';
  AND?: GhostLeadOpptyContactSalesRoleRelationFilterInput[] | null;
  NOT?: GhostLeadOpptyContactSalesRoleRelationFilterInput | null;
  OR?: GhostLeadOpptyContactSalesRoleRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  ghostLeadOpptyContactRelation?: GhostLeadOpptyContactRelationFilterInput | null;
  ghostLeadOpptyContactRelationId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  salesRole?: SalesRoleFilterInput | null;
  salesRoleId?: EntityFilterStringField | null;
}

export interface GhostLeadOpptyContactRelationOrderByNestedInput {
  __typename?: 'GhostLeadOpptyContactRelationOrderByNestedInput';
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  ghostContactId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyContactGroupRelationId?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostLeadOpptyContactRelationOrderByInput {
  __typename?: 'GhostLeadOpptyContactRelationOrderByInput';
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  ghostContact?: GhostContactOrderByNestedInput[] | null;
  ghostContactId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyContactGroupRelation?: LeadOpptyContactGroupRelationOrderByNestedInput[] | null;
  leadOpptyContactGroupRelationId?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
}

export interface GhostLeadOpptyContactRelationFilterInput {
  __typename?: 'GhostLeadOpptyContactRelationFilterInput';
  AND?: GhostLeadOpptyContactRelationFilterInput[] | null;
  NOT?: GhostLeadOpptyContactRelationFilterInput | null;
  OR?: GhostLeadOpptyContactRelationFilterInput[] | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  ghostContact?: GhostContactFilterInput | null;
  ghostContactId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyContactGroupRelation?: LeadOpptyContactGroupRelationFilterInput | null;
  leadOpptyContactGroupRelationId?: EntityFilterStringField | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  revision?: EntityFilterNumberField | null;
  salesRoles?: GhostLeadOpptyContactSalesRoleRelationFilterInput | null;
}

export interface GhostContactOrderByNestedInput {
  __typename?: 'GhostContactOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  position?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostContactOrderByInput {
  __typename?: 'GhostContactOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  position?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostContactFilterInput {
  __typename?: 'GhostContactFilterInput';
  AND?: GhostContactFilterInput[] | null;
  NOT?: GhostContactFilterInput | null;
  OR?: GhostContactFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  position?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface GhostContactAccountRelationOrderByNestedInput {
  __typename?: 'GhostContactAccountRelationOrderByNestedInput';
  accountId?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  ghostContactId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isAssistant?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isSibling?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  position?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostContactAccountRelationOrderByInput {
  __typename?: 'GhostContactAccountRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  ghostContact?: GhostContactOrderByNestedInput[] | null;
  ghostContactId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isAssistant?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isSibling?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  position?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostContactAccountRelationFilterInput {
  __typename?: 'GhostContactAccountRelationFilterInput';
  AND?: GhostContactAccountRelationFilterInput[] | null;
  NOT?: GhostContactAccountRelationFilterInput | null;
  OR?: GhostContactAccountRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  accountRoles?: GhostContactAccountAccountRoleRelationFilterInput | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  ghostContact?: GhostContactFilterInput | null;
  ghostContactId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isAssistant?: boolean | null;
  isDeleted?: boolean | null;
  isSibling?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  position?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface GhostContactAccountAccountRoleRelationOrderByInput {
  __typename?: 'GhostContactAccountAccountRoleRelationOrderByInput';
  accountRole?: AccountRoleOrderByNestedInput[] | null;
  accountRoleId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  ghostContactAccountRelation?: GhostContactAccountRelationOrderByNestedInput[] | null;
  ghostContactAccountRelationId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface GhostContactAccountAccountRoleRelationFilterInput {
  __typename?: 'GhostContactAccountAccountRoleRelationFilterInput';
  AND?: GhostContactAccountAccountRoleRelationFilterInput[] | null;
  NOT?: GhostContactAccountAccountRoleRelationFilterInput | null;
  OR?: GhostContactAccountAccountRoleRelationFilterInput[] | null;
  accountRole?: AccountRoleFilterInput | null;
  accountRoleId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  ghostContactAccountRelation?: GhostContactAccountRelationFilterInput | null;
  ghostContactAccountRelationId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface GetTokenInput {
  __typename?: 'GetTokenInput';
  authCode: string;
  expState?: string | null;
  redirectUri: string;
}

export interface GetPrintReportUrlInput {
  __typename?: 'GetPrintReportUrlInput';
  clientMutationId?: string | null;
  id: ID;
  options: PdfOptionsParams;
  sessionId: UUID;
}

export interface GetPrintReportStatusInput {
  __typename?: 'GetPrintReportStatusInput';
  clientMutationId?: string | null;
  requestId: UUID;
}

export interface GetFileInput {
  __typename?: 'GetFileInput';
  fileIds: string[];
}

export interface GetBulkDownloadUrlInput {
  __typename?: 'GetBulkDownloadUrlInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  entityId?: UUID | null;
  entityType?: EntityNameEnum | null;
}

export interface GetBulkDownloadStatusInput {
  __typename?: 'GetBulkDownloadStatusInput';
  clientMutationId?: string | null;
  requestId: UUID;
}

export interface GetAuthUrlInput {
  __typename?: 'GetAuthUrlInput';
  redirectUri: string;
}

export interface GenerateNewApiAccessInput {
  __typename?: 'GenerateNewApiAccessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface GenerateClientDefaultDataInput {
  __typename?: 'GenerateClientDefaultDataInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface GenderEnumFilterInput {
  __typename?: 'GenderEnumFilterInput';
  NOT?: GenderEnumFilterInput | null;
  eq?: GenderEnum[] | null;
}

export interface FormulaValidatorParams {
  __typename?: 'FormulaValidatorParams';
  expression: string;
  message: string;
}

export interface FormViewSharingSalesUnitRelationOrderByInput {
  __typename?: 'FormViewSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  formView?: FormViewOrderByNestedInput[] | null;
  formViewId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface FormViewSharingSalesUnitRelationFilterInput {
  __typename?: 'FormViewSharingSalesUnitRelationFilterInput';
  AND?: FormViewSharingSalesUnitRelationFilterInput[] | null;
  NOT?: FormViewSharingSalesUnitRelationFilterInput | null;
  OR?: FormViewSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  formView?: FormViewFilterInput | null;
  formViewId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface FormViewSharingClientRelationOrderByInput {
  __typename?: 'FormViewSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  formView?: FormViewOrderByNestedInput[] | null;
  formViewId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface FormViewSharingClientRelationFilterInput {
  __typename?: 'FormViewSharingClientRelationFilterInput';
  AND?: FormViewSharingClientRelationFilterInput[] | null;
  NOT?: FormViewSharingClientRelationFilterInput | null;
  OR?: FormViewSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  formView?: FormViewFilterInput | null;
  formViewId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface FormViewOrderByNestedInput {
  __typename?: 'FormViewOrderByNestedInput';
  accountTypeId?: OrderByEnum | null;
  contactTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyTypeId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface FormViewOrderByInput {
  __typename?: 'FormViewOrderByInput';
  accountType?: AccountTypeOrderByNestedInput[] | null;
  accountTypeId?: OrderByEnum | null;
  contactType?: ContactTypeOrderByNestedInput[] | null;
  contactTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  opptyType?: OpportunityTypeOrderByNestedInput[] | null;
  opptyTypeId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface FormViewOptionsParams {
  __typename?: 'FormViewOptionsParams';
  createViewId?: UUID | null;
  editViewId?: UUID | null;
  entityTypeId: UUID;
}

export interface FormViewItemColorInput {
  __typename?: 'FormViewItemColorInput';
  color: number;
  id: UUID;
}

export interface FormViewFilterInput {
  __typename?: 'FormViewFilterInput';
  AND?: FormViewFilterInput[] | null;
  NOT?: FormViewFilterInput | null;
  OR?: FormViewFilterInput[] | null;
  accountType?: AccountTypeFilterInput | null;
  accountTypeId?: EntityFilterStringField | null;
  contactType?: ContactTypeFilterInput | null;
  contactTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  opptyType?: OpportunityTypeFilterInput | null;
  opptyTypeId?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: FormViewSharingClientRelationFilterInput | null;
  sharingUnits?: FormViewSharingSalesUnitRelationFilterInput | null;
  useLang?: boolean | null;
}

export interface FormTypeEnumFilterInput {
  __typename?: 'FormTypeEnumFilterInput';
  NOT?: FormTypeEnumFilterInput | null;
  eq?: FormTypeEnum[] | null;
}

export interface FormSeparatorParams {
  __typename?: 'FormSeparatorParams';
  description?: string | null;
  id: UUID;
  label: string;
  onMobile?: boolean | null;
  useLang?: boolean | null;
}

export interface FormParams {
  __typename?: 'FormParams';
  items?: FormItemInterfaceParams[] | null;
  label: string;
  useLang?: boolean | null;
}

export interface FormItemInterfaceParams {
  __typename?: 'FormItemInterfaceParams';
  Container?: FormContainerParams | null;
  HardcodedContainer?: HardCodedContainerParams | null;
  Separator?: FormSeparatorParams | null;
  StepFieldsContainer?: StepFieldsContainerParams | null;
  Subsection?: FormSeparatorParams | null;
}

export interface FormFieldParams {
  __typename?: 'FormFieldParams';
  allowedEntities?: string[] | null;
  description?: string | null;
  descriptionTranslated?: string | null;
  descriptionTranslations?: JSONString | null;
  dropdownAutoselect?: DropDownAutoselectEnum | null;
  id: string;
  inAddin?: boolean | null;
  label: string;
  labelTranslated?: string | null;
  labelTranslations?: JSONString | null;
  lookupVisualization?: LookupVisualizationType | null;
  onMobile?: boolean | null;
  opptyValueAutoCalculateDefault?: boolean | null;
  productSections?: ProductSectionParams[] | null;
  readonly?: boolean | null;
  readonlyRules?: FieldFilterParams | null;
  requiredRules?: FieldFilterParams | null;
  showFixedValue?: boolean | null;
  subLabel?: string | null;
  subLabelUseLang?: boolean | null;
  useLang?: boolean | null;
  validators?: FieldValidatorParams | null;
  visibilityRules?: FieldFilterParams | null;
}

export interface FormContainerParams {
  __typename?: 'FormContainerParams';
  columns?: FormColumnParams[] | null;
  id: UUID;
  onMobile?: boolean | null;
}

export interface FormContainerItemInterfaceParams {
  __typename?: 'FormContainerItemInterfaceParams';
  Field?: FormFieldParams | null;
  WebResource?: WebResourceParams | null;
}

export interface FormColumnParams {
  __typename?: 'FormColumnParams';
  id: UUID;
  items?: FormContainerItemInterfaceParams[] | null;
  size: number;
}

export interface ForecastPreviewViewTabParams {
  __typename?: 'ForecastPreviewViewTabParams';
  gridColumns?: GridColumnsOutputParams[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ForecastPreviewProfileParams {
  __typename?: 'ForecastPreviewProfileParams';
  filter: ForecastFilterTabParams;
  view: ForecastPreviewViewTabParams;
}

export interface ForecastPeriodOptionParams {
  __typename?: 'ForecastPeriodOptionParams';
  financialYear?: boolean | null;
  period: ForecastPeriodKind;
  periodFrom: GqlDate;
  periodTo: GqlDate;
}

export interface ForecastPerformanceItemParams {
  __typename?: 'ForecastPerformanceItemParams';
  dateTime: DateTime;
  period: GqlDate;
  value: number;
}

export interface ForecastOwnerParams {
  __typename?: 'ForecastOwnerParams';
  forecastPerformance: ForecastPerformanceItemParams[];
  id: ID;
  isActive: boolean;
}

export interface ForecastOrderByInput {
  __typename?: 'ForecastOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  field?: FieldOrderByNestedInput[] | null;
  fieldId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastType?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  pipeline?: PipelineOrderByNestedInput[] | null;
  pipelineId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
}

export interface ForecastListingOptionsParams {
  __typename?: 'ForecastListingOptionsParams';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
}

export interface ForecastItemValueParams {
  __typename?: 'ForecastItemValueParams';
  date: GqlDate;
  quota?: number | null;
  value?: number | null;
}

export interface ForecastItemParams {
  __typename?: 'ForecastItemParams';
  entityId: UUID;
  entityType: EntityNameEnum;
  id: ID;
  isActive: boolean;
  parentId?: ID | null;
  quotaSplitType: OpportunityForecastQuotaSplitType;
  values: ForecastItemValueParams[];
}

export interface ForecastGroupParams {
  __typename?: 'ForecastGroupParams';
  groupId?: string | null;
}

export interface ForecastFilterTabParams {
  __typename?: 'ForecastFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ForecastFilterInput {
  __typename?: 'ForecastFilterInput';
  AND?: ForecastFilterInput[] | null;
  NOT?: ForecastFilterInput | null;
  OR?: ForecastFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  field?: FieldFilterInput | null;
  fieldId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lastType?: ForecastType | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  pipeline?: PipelineFilterInput | null;
  pipelineId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  shareModeParams?: ShareModeParamsEnumFilterInput | null;
}

export interface FitnessIndicatorTypeEnumFilterInput {
  __typename?: 'FitnessIndicatorTypeEnumFilterInput';
  NOT?: FitnessIndicatorTypeEnumFilterInput | null;
  eq?: FitnessIndicatorTypeEnum[] | null;
}

export interface FinishTargetInput {
  __typename?: 'FinishTargetInput';
  applyToChildren: boolean;
  clientMutationId?: string | null;
  id: UUID;
}

export interface FinancialDateStartParams {
  __typename?: 'FinancialDateStartParams';
  day: number;
  month: number;
}

export interface FinalizeConfigurationAutomationHubItemInput {
  __typename?: 'FinalizeConfigurationAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface FilterBoxParams {
  __typename?: 'FilterBoxParams';
  entity: string;
  filterFields: FieldFilterRuleParams[];
  id: string;
  lookupFieldId?: UUID | null;
  relation?: HardCodedRelationParams | null;
}

export interface FillMultipleCloudObjectTemplatesInput {
  __typename?: 'FillMultipleCloudObjectTemplatesInput';
  asPdf: boolean;
  clientMutationId?: string | null;
  currencyToBaseValue?: boolean | null;
  entityApiName?: string | null;
  entityIds: ID[];
  entityName: EntityNameEnum;
  opptyProductRelationIds?: string[] | null;
  save: boolean;
  sessionId?: UUID | null;
  templateIds: ID[];
}

export interface FillCloudObjectTemplateInput {
  __typename?: 'FillCloudObjectTemplateInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityId: ID;
  entityName: EntityNameEnum;
  templateContent: Base64;
  templateSource?: TemplateSourceEnum | null;
}

export interface FieldValueOptionFilterInput {
  __typename?: 'FieldValueOptionFilterInput';
  excludeArchived?: boolean | null;
  excludeNonArchived?: boolean | null;
  labelContains?: string | null;
  leadProcessIds?: UUID[] | null;
  pipelineIds?: UUID[] | null;
  quoteProcessIds?: UUID[] | null;
  value?: string | null;
  valueIn?: string[] | null;
}

export interface FieldValidatorParams {
  __typename?: 'FieldValidatorParams';
  flagEnum?: IntEnumItemParams[] | null;
  formula?: FormulaValidatorParams | null;
  intEnum?: IntEnumItemParams[] | null;
  isDaterange?: boolean | null;
  isEmail?: boolean | null;
  isParentAccountRelationType?: boolean | null;
  isUrl?: boolean | null;
  maxValue?: string | null;
  minValue?: string | null;
  nullable?: boolean | null;
  required?: boolean | null;
  requiredCombined?: string | null;
  requiredExactlyOne?: boolean | null;
  requiredMinItems?: number | null;
  requiredOnlyOnCurrentStep?: boolean | null;
}

export interface FieldSequenceOrderByInput {
  __typename?: 'FieldSequenceOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
}

export interface FieldSequenceFilterInput {
  __typename?: 'FieldSequenceFilterInput';
  AND?: FieldSequenceFilterInput[] | null;
  NOT?: FieldSequenceFilterInput | null;
  OR?: FieldSequenceFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  pattern?: EntityFilterStringField | null;
  sequenceSetId?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
}

export interface FieldPermissionOrderByInput {
  __typename?: 'FieldPermissionOrderByInput';
  created?: OrderByEnum | null;
  field?: FieldOrderByNestedInput[] | null;
  fieldId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  permissionLevel?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface FieldPermissionNoFieldBackrefInput {
  __typename?: 'FieldPermissionNoFieldBackrefInput';
  masterRightId: UUID;
  permissionLevel: AccessLevelFieldEnum;
}

export interface FieldPermissionFilterInput {
  __typename?: 'FieldPermissionFilterInput';
  AND?: FieldPermissionFilterInput[] | null;
  NOT?: FieldPermissionFilterInput | null;
  OR?: FieldPermissionFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityName?: string | null;
  field?: FieldFilterInput | null;
  fieldId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  permissionLevel?: AccessLevelFieldEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface FieldOrderByNestedInput {
  __typename?: 'FieldOrderByNestedInput';
  apiName?: OrderByEnum | null;
  calcFormula?: OrderByEnum | null;
  columnName?: OrderByEnum | null;
  columnSource?: OrderByEnum | null;
  compositeFieldId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  dataSetId?: OrderByEnum | null;
  defaultValue?: OrderByEnum | null;
  entityName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isUnique?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentOptionsFieldId?: OrderByEnum | null;
  relationId?: OrderByEnum | null;
  relationWithEntityId?: OrderByEnum | null;
  sequencePattern?: OrderByEnum | null;
  sharedWithFieldId?: OrderByEnum | null;
  systemReadonly?: OrderByEnum | null;
  systemRequired?: OrderByEnum | null;
  systemType?: OrderByEnum | null;
  typeId?: OrderByEnum | null;
  useInGlobalSearch?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface FieldOrderByInput {
  __typename?: 'FieldOrderByInput';
  apiName?: OrderByEnum | null;
  calcFormula?: OrderByEnum | null;
  columnName?: OrderByEnum | null;
  columnSource?: OrderByEnum | null;
  compositeFieldId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  dataSetId?: OrderByEnum | null;
  defaultValue?: OrderByEnum | null;
  entityName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isUnique?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentOptionsFieldId?: OrderByEnum | null;
  relationId?: OrderByEnum | null;
  relationWithEntityId?: OrderByEnum | null;
  sequencePattern?: OrderByEnum | null;
  sharedWithFieldId?: OrderByEnum | null;
  systemReadonly?: OrderByEnum | null;
  systemRequired?: OrderByEnum | null;
  systemType?: OrderByEnum | null;
  typeId?: OrderByEnum | null;
  useInGlobalSearch?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface FieldMappingTemplateParams {
  __typename?: 'FieldMappingTemplateParams';
  input: JSONString;
  operations: FieldMappingOperationParams[];
}

export interface FieldMappingOrderByNestedInput {
  __typename?: 'FieldMappingOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isSystem?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface FieldMappingOrderByInput {
  __typename?: 'FieldMappingOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isSystem?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface FieldMappingOperationTypeEnumFilterInput {
  __typename?: 'FieldMappingOperationTypeEnumFilterInput';
  NOT?: FieldMappingOperationTypeEnumFilterInput | null;
  eq?: FieldMappingOperationTypeEnum[] | null;
}

export interface FieldMappingOperationParams {
  __typename?: 'FieldMappingOperationParams';
  fieldId: ID;
  mapping?: EntityOperationMappingParams | null;
  operation?: FieldMappingOperationEnum | null;
  triggeredRecordFieldId?: UUID | null;
}

export interface FieldMappingFilterInput {
  __typename?: 'FieldMappingFilterInput';
  AND?: FieldMappingFilterInput[] | null;
  NOT?: FieldMappingFilterInput | null;
  OR?: FieldMappingFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isSystem?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  operation?: FieldMappingOperationTypeEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface FieldFilterRuleParams {
  __typename?: 'FieldFilterRuleParams';
  field: string;
  id?: UUID | null;
  operator?: FieldOperator | null;
  values?: string[][] | null;
}

export interface FieldFilterParams {
  __typename?: 'FieldFilterParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface FieldFilterInput {
  __typename?: 'FieldFilterInput';
  AND?: FieldFilterInput[] | null;
  NOT?: FieldFilterInput | null;
  OR?: FieldFilterInput[] | null;
  apiName?: EntityFilterStringField | null;
  calcFormula?: EntityFilterStringField | null;
  columnName?: EntityFilterStringField | null;
  columnSource?: EntityFilterNumberField | null;
  compositeFieldId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  dataSetId?: EntityFilterStringField | null;
  defaultValue?: EntityFilterStringField | null;
  entityName?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isUnique?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  parentOptionsFieldId?: EntityFilterStringField | null;
  relationId?: EntityFilterStringField | null;
  relationWithEntityId?: EntityFilterStringField | null;
  sequencePattern?: EntityFilterStringField | null;
  sequenceSetId?: EntityFilterStringField | null;
  sharedWithFieldId?: EntityFilterStringField | null;
  systemReadonly?: boolean | null;
  systemRequired?: boolean | null;
  systemType?: EntityFilterNumberField | null;
  typeId?: EntityFilterStringField | null;
  useInGlobalSearch?: boolean | null;
  useLang?: EntityFilterNumberField | null;
}

export interface FieldDataSetItem {
  __typename?: 'FieldDataSetItem';
  allowedBy?: ID[] | null;
  calcValue: number;
  id?: UUID | null;
  optionName: string;
  optionNameTranslations?: JSONString | null;
}

export interface FieldAiValueUpdateScheduleParams {
  __typename?: 'FieldAiValueUpdateScheduleParams';
  date?: DateTime | null;
  dayOfMonth?: number[] | null;
  dayOfWeek?: number[] | null;
  timeOfDay?: number | null;
}

export interface FieldAiValueUpdateOptionsParams {
  __typename?: 'FieldAiValueUpdateOptionsParams';
  autoUpdateOnRecordCreate: boolean;
  autoUpdateOnRecordUpdate: boolean;
  autoUpdateSchedule?: FieldAiValueUpdateScheduleParams | null;
  autoUpdateScheduled: boolean;
  manualEnabled: boolean;
}

export interface FieldAiOptionsRelatedRecordParams {
  __typename?: 'FieldAiOptionsRelatedRecordParams';
  entityRelationId?: ID | null;
  filter?: FieldFilterParams | null;
  targetEntity: EntityNameEnum;
  targetEntityApiName?: string | null;
}

export interface FieldAiOptionsParams {
  __typename?: 'FieldAiOptionsParams';
  general: FieldAiGeneralOptionsParams;
  isEnabled: boolean;
  valueUpdate: FieldAiValueUpdateOptionsParams;
}

export interface FieldAiGeneralOptionsParams {
  __typename?: 'FieldAiGeneralOptionsParams';
  dataSourcesEnabled: boolean;
  prompt: string;
  recordDataEnabled: boolean;
  recordDocumentsEnabled: boolean;
  recordDocumentsFilter?: FieldFilterParams | null;
  relatedRecords: FieldAiOptionsRelatedRecordParams[];
  relatedRecordsEnabled: boolean;
  webSearchEnabled: boolean;
}

export interface FeedsNotificationSettingsParams {
  __typename?: 'FeedsNotificationSettingsParams';
  Comment: boolean;
  Create: boolean;
  IsActive: boolean;
}

export interface FeedTabEntityTypeOptionsParams {
  __typename?: 'FeedTabEntityTypeOptionsParams';
  showAccount: boolean;
  showActivities: boolean;
  showActivityTypeIds?: ID[] | null;
  showContact: boolean;
  showCustomEntities?: string[] | null;
  showDocument: boolean;
  showEmail: boolean;
  showEmailSentiments?: EmailSentimentEnum[] | null;
  showEmailTagIds?: UUID[] | null;
  showEmailType?: FeedEmailTypeEnum[] | null;
  showLead: boolean;
  showMassEmail: boolean;
  showMemo: boolean;
  showNote: boolean;
  showOnlineForm?: boolean | null;
  showOpportunity: boolean;
  showProject: boolean;
  showQuote?: boolean | null;
  showScheduledEmail?: boolean | null;
  showTextMessage?: boolean | null;
  showWhatsAppMessage?: boolean | null;
}

export interface FeedTabDataGridViewOptionsParams {
  __typename?: 'FeedTabDataGridViewOptionsParams';
  entityTypes: FeedTabEntityTypeOptionsParams;
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyFavorite: boolean;
  showOnlyMy: boolean;
}

export interface FeedProfileDataInput {
  __typename?: 'FeedProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: FeedPreviewProfileParams;
}

export interface FeedPreviewViewTabParams {
  __typename?: 'FeedPreviewViewTabParams';
  entityTypes: FeedTabEntityTypeOptionsParams;
}

export interface FeedPreviewProfileParams {
  __typename?: 'FeedPreviewProfileParams';
  filter: FeedPreviewFilterTabParams;
  role: ProfileStandardRoleTabParams;
  view: FeedPreviewViewTabParams;
}

export interface FeedPreviewFilterTabParams {
  __typename?: 'FeedPreviewFilterTabParams';
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  isEnabled: boolean;
  showOnlyFavorite: boolean;
}

export interface FeedFilterSenderParams {
  __typename?: 'FeedFilterSenderParams';
  entity: EntityNameEnum;
  id: ID;
}

export interface FeedEmailTabEntityTypeOptionsParams {
  __typename?: 'FeedEmailTabEntityTypeOptionsParams';
  showEmail: boolean;
  showEmailSentiments?: EmailSentimentEnum[] | null;
  showEmailTagIds?: UUID[] | null;
  showEmailType?: FeedEmailTypeEnum[] | null;
  showMassEmail: boolean;
  showScheduledEmail?: boolean | null;
}

export interface FeedEmailTabDataGridViewOptionsParams {
  __typename?: 'FeedEmailTabDataGridViewOptionsParams';
  entityTypes: FeedEmailTabEntityTypeOptionsParams;
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyMy: boolean;
}

export interface FeedEmailProfileDataInput {
  __typename?: 'FeedEmailProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: FeedEmailPreviewProfileParams;
}

export interface FeedEmailPreviewViewTabParams {
  __typename?: 'FeedEmailPreviewViewTabParams';
  entityTypes: FeedEmailTabEntityTypeOptionsParams;
}

export interface FeedEmailPreviewProfileParams {
  __typename?: 'FeedEmailPreviewProfileParams';
  filter: FeedEmailPreviewFilterTabParams;
  role: ProfileStandardRoleTabParams;
  view: FeedEmailPreviewViewTabParams;
}

export interface FeedEmailPreviewFilterTabParams {
  __typename?: 'FeedEmailPreviewFilterTabParams';
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  isEnabled: boolean;
}

export interface FeedEmailDetailProfileParams {
  __typename?: 'FeedEmailDetailProfileParams';
  entityTypes: FeedEmailTabEntityTypeOptionsParams;
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyMy: boolean;
}

export interface FeedEmailDetailProfileDataInput {
  __typename?: 'FeedEmailDetailProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: FeedEmailDetailProfileParams;
}

export interface FeedDetailProfileParams {
  __typename?: 'FeedDetailProfileParams';
  entityTypes: FeedTabEntityTypeOptionsParams;
  filterByPeriod: PeriodOptionParams;
  filterBySender?: FeedFilterSenderParams[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyFavorite: boolean;
  showOnlyMy: boolean;
}

export interface FeedDetailProfileDataInput {
  __typename?: 'FeedDetailProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: FeedDetailProfileParams;
}

export interface ExecuteManualTriggerProcessInput {
  __typename?: 'ExecuteManualTriggerProcessInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  id: ID;
  immediate?: boolean | null;
}

export interface ExecuteApprovalProcessInput {
  __typename?: 'ExecuteApprovalProcessInput';
  approvalProcessId: UUID;
  entityId: UUID;
}

export interface ExchangeSetSettingsTeamSpaceClientSettingInput {
  __typename?: 'ExchangeSetSettingsTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  deleteProtection?: ContactDeletionProtectionEnum | null;
  folder?: string | null;
  recordOwnership?: RecordOwnershipEnum | null;
  service: ExchangeSyncSettingTypeEnum;
  syncMethod?: ContactSyncMethodEnum | null;
}

export interface ExchangeDeactivateTeamSpaceClientSettingInput {
  __typename?: 'ExchangeDeactivateTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: ExchangeSyncSettingTypeEnum;
}

export interface ExchangeAuthorizeTeamSpaceClientSettingInput {
  __typename?: 'ExchangeAuthorizeTeamSpaceClientSettingInput';
  advancedOptions?: ExchangeAuthAdvancedOptions | null;
  authCode?: string | null;
  clientMutationId?: string | null;
  email: string;
  password?: string | null;
  redirectUri?: string | null;
  service: ExchangeSyncSettingTypeEnum;
}

export interface ExchangeAuthAdvancedOptions {
  __typename?: 'ExchangeAuthAdvancedOptions';
  domain?: string | null;
  server?: string | null;
  username?: string | null;
}

export interface ExchangeActivateTeamSpaceClientSettingInput {
  __typename?: 'ExchangeActivateTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  folder?: string | null;
  service: ExchangeSyncSettingTypeEnum;
}

export interface EvaluateProcessInput {
  __typename?: 'EvaluateProcessInput';
  clientMutationId?: string | null;
  id: ID;
  persistRecords: boolean;
  settings: ProcessSchemaJSONString;
  triggerEntityApiName?: string | null;
  triggerEntityId?: UUID | null;
  triggerEntityType?: EntityNameEnum | null;
}

export interface EvaluateProcessEmailInput {
  __typename?: 'EvaluateProcessEmailInput';
  clientMutationId?: string | null;
  email: SendEmailInputParams;
  id: ID;
  recordTriggerType?: ProcessRecordTriggerEventEnum | null;
}

export interface EvaluateEmailSequenceNodeInput {
  __typename?: 'EvaluateEmailSequenceNodeInput';
  activityLogId: UUID;
  clientMutationId?: string | null;
  nodeId: UUID;
}

export interface EvaluateEmailSequenceInput {
  __typename?: 'EvaluateEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
  persistRecords: boolean;
  settings: EmailSequenceSchemaJSONString;
  triggerEntityId: UUID;
  triggerEntityType: EntityNameEnum;
}

export interface EvaluateEmailSequenceEmailInput {
  __typename?: 'EvaluateEmailSequenceEmailInput';
  clientMutationId?: string | null;
  email: SendEmailInputParams;
  id: ID;
}

export interface EvaluateApprovalProcessEmailInput {
  __typename?: 'EvaluateApprovalProcessEmailInput';
  clientMutationId?: string | null;
  email: SendEmailInputParams;
  id: ID;
  recordTriggerType?: ProcessRecordTriggerEventEnum | null;
}

export interface EntityTypeSettingsParams {
  __typename?: 'EntityTypeSettingsParams';
  allowedAppointmentTypeIds?: ID[] | null;
  allowedTaskTypeIds?: ID[] | null;
}

export interface EntityTypeProcessPrioritiesParams {
  __typename?: 'EntityTypeProcessPrioritiesParams';
  priorities: UUID[];
  processId: UUID;
}

export interface EntityTypeFieldMappingParams {
  __typename?: 'EntityTypeFieldMappingParams';
  mapping?: FieldMappingTemplateParams | null;
  sourceTypeIds?: ID[] | null;
  targetTypeIds?: ID[] | null;
}

export interface EntitySubtypeItemParams {
  __typename?: 'EntitySubtypeItemParams';
  formId?: ID[] | null;
  kind: EntitySubtypeKind;
}

export interface EntitySettingsOrderByInput {
  __typename?: 'EntitySettingsOrderByInput';
  created?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  entityName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EntitySettingsFilterInput {
  __typename?: 'EntitySettingsFilterInput';
  AND?: EntitySettingsFilterInput[] | null;
  NOT?: EntitySettingsFilterInput | null;
  OR?: EntitySettingsFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityApiName?: string | null;
  entityName?: EntityNameEnum | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface EntityScoringOrderByInput {
  __typename?: 'EntityScoringOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  useLang?: OrderByEnum | null;
}

export interface EntityScoringFilterInput {
  __typename?: 'EntityScoringFilterInput';
  AND?: EntityScoringFilterInput[] | null;
  NOT?: EntityScoringFilterInput | null;
  OR?: EntityScoringFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
  useLang?: boolean | null;
}

export interface EntityReportFilterParams {
  __typename?: 'EntityReportFilterParams';
  entityTypeIds?: UUID[] | null;
  excludeArchived?: boolean | null;
  excludeIds?: UUID[] | null;
  relatedEntity?: RelatedEntityReportFilterParams | null;
  searchQuery?: string | null;
}

export interface EntityOrderByInput {
  __typename?: 'EntityOrderByInput';
  abstractEntityId?: OrderByEnum | null;
  accessMode?: OrderByEnum | null;
  allowsMultipleRelation?: OrderByEnum | null;
  created?: OrderByEnum | null;
  defaultViewFieldId?: OrderByEnum | null;
  entityName?: OrderByEnum | null;
  entityType?: OrderByEnum | null;
  hasDraft?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  namePlural?: OrderByEnum | null;
  nameSingular?: OrderByEnum | null;
  preferenceOrder?: OrderByEnum | null;
  tableDataEx?: OrderByEnum | null;
  tableEx?: OrderByEnum | null;
  tableName?: OrderByEnum | null;
}

export interface EntityOperationMappingParams {
  __typename?: 'EntityOperationMappingParams';
  options?: EntityOperationMappingOptionParams[] | null;
}

export interface EntityOperationMappingOptionParams {
  __typename?: 'EntityOperationMappingOptionParams';
  sourceValue: string;
  targetValue?: string | null;
}

export interface EntityNameEnumFilterInput {
  __typename?: 'EntityNameEnumFilterInput';
  NOT?: EntityNameEnumFilterInput | null;
  eq?: EntityNameEnum[] | null;
}

export interface EntityMappingInput {
  __typename?: 'EntityMappingInput';
  flagToDelete?: boolean | null;
  foreignEntityId?: string | null;
  pipelinerEntityId: UUID;
}

export interface EntityHealthSettingsParams {
  __typename?: 'EntityHealthSettingsParams';
  calculationType: EntityHealthCalculationTypeEnum;
  categories: HealthCategoryParams[];
  criticalHealthIndicators: EntityHealthFieldConfigurationParams;
  healthIndicators: EntityHealthFieldConfigurationParams;
}

export interface EntityHealthPlannerInput {
  __typename?: 'EntityHealthPlannerInput';
  clientMutationId?: string | null;
}

export interface EntityHealthOrderByInput {
  __typename?: 'EntityHealthOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastRecalculation?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  type?: AccountTypeOrderByNestedInput[] | null;
  typeId?: OrderByEnum | null;
}

export interface EntityHealthMainFilterBoxParams {
  __typename?: 'EntityHealthMainFilterBoxParams';
  entity: string;
  filterFields: EntityHealthFieldFilterRuleParams[];
  id: string;
  lookupFieldId?: UUID | null;
}

export interface EntityHealthFilterInput {
  __typename?: 'EntityHealthFilterInput';
  AND?: EntityHealthFilterInput[] | null;
  NOT?: EntityHealthFilterInput | null;
  OR?: EntityHealthFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  lastRecalculation?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  type?: AccountTypeFilterInput | null;
  typeId?: EntityFilterStringField | null;
}

export interface EntityHealthFilterBoxParams {
  __typename?: 'EntityHealthFilterBoxParams';
  entity: string;
  filterFields: EntityHealthFieldFilterRuleParams[];
  id: string;
  lookupFieldId?: UUID | null;
  relation?: HardCodedRelationParams | null;
}

export interface EntityHealthFieldFilterRuleParams {
  __typename?: 'EntityHealthFieldFilterRuleParams';
  description: string;
  field: string;
  id: UUID;
  operator?: FieldOperator | null;
  score: number;
  values?: string[][] | null;
}

export interface EntityHealthFieldConfigurationParams {
  __typename?: 'EntityHealthFieldConfigurationParams';
  filterMainBox: EntityHealthMainFilterBoxParams;
  filterSiblingBoxes: EntityHealthFilterBoxParams[];
}

export interface EntityFitnessOrderByNestedInput {
  __typename?: 'EntityFitnessOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EntityFitnessOrderByInput {
  __typename?: 'EntityFitnessOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyType?: OpportunityTypeOrderByNestedInput[] | null;
  opptyTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EntityFitnessIndicatorOrderByInput {
  __typename?: 'EntityFitnessIndicatorOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  descriptionUseLang?: OrderByEnum | null;
  entityFitness?: EntityFitnessOrderByNestedInput[] | null;
  entityFitnessId?: OrderByEnum | null;
  howToFix?: OrderByEnum | null;
  howToFixUseLang?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  nameUseLang?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface EntityFitnessIndicatorFilterInput {
  __typename?: 'EntityFitnessIndicatorFilterInput';
  AND?: EntityFitnessIndicatorFilterInput[] | null;
  NOT?: EntityFitnessIndicatorFilterInput | null;
  OR?: EntityFitnessIndicatorFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  descriptionUseLang?: boolean | null;
  entityFitness?: EntityFitnessFilterInput | null;
  entityFitnessId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  howToFix?: EntityFilterStringField | null;
  howToFixUseLang?: boolean | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  nameUseLang?: boolean | null;
  revision?: EntityFilterNumberField | null;
  type?: FitnessIndicatorTypeEnumFilterInput | null;
}

export interface EntityFitnessFilterInput {
  __typename?: 'EntityFitnessFilterInput';
  AND?: EntityFitnessFilterInput[] | null;
  NOT?: EntityFitnessFilterInput | null;
  OR?: EntityFitnessFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityType?: BaseEntityTypeEnum | null;
  entityTypeId?: UUID | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  indicatorRelations?: EntityFitnessIndicatorFilterInput | null;
  isDeleted?: boolean | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  opptyType?: OpportunityTypeFilterInput | null;
  opptyTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface EntityFilterStringField {
  __typename?: 'EntityFilterStringField';
  contains?: string[] | null;
  empty?: boolean | null;
  ends?: string[] | null;
  eq?: string[] | null;
  icontains?: string[] | null;
  iends?: string[] | null;
  ieq?: string[] | null;
  istarts?: string[] | null;
  null?: boolean | null;
  starts?: string[] | null;
}

export interface EntityFilterRelatedField {
  __typename?: 'EntityFilterRelatedField';
  entity?: EntityLacotaType | null;
  entityIds?: UUID[] | null;
}

export interface EntityFilterNumberField {
  __typename?: 'EntityFilterNumberField';
  between?: number[] | null;
  eq?: string[] | null;
  gt?: number | null;
  gte?: number | null;
  lt?: number | null;
  lte?: number | null;
  null?: boolean | null;
}

export interface EntityFilterInput {
  __typename?: 'EntityFilterInput';
  AND?: EntityFilterInput[] | null;
  NOT?: EntityFilterInput | null;
  OR?: EntityFilterInput[] | null;
  abstractEntityId?: EntityFilterStringField | null;
  accessMode?: EntityFilterNumberField | null;
  allowsMultipleRelation?: boolean | null;
  created?: EntityFilterDateTimeField | null;
  defaultViewFieldId?: EntityFilterStringField | null;
  entityName?: EntityFilterStringField | null;
  entityType?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  hasDraft?: boolean | null;
  icon?: EntityFilterNumberField | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  namePlural?: EntityFilterStringField | null;
  nameSingular?: EntityFilterStringField | null;
  preferenceOrder?: EntityFilterNumberField | null;
  tableDataEx?: EntityFilterStringField | null;
  tableEx?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
}

export interface EntityFilterDateTimeField {
  __typename?: 'EntityFilterDateTimeField';
  between?: DateTime[] | null;
  eq?: string[] | null;
  gt?: DateTime | null;
  gte?: DateTime | null;
  lt?: DateTime | null;
  lte?: DateTime | null;
  null?: boolean | null;
}

export interface EntityDocumentOptions {
  __typename?: 'EntityDocumentOptions';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByRecordName?: string | null;
  filterByRecordType: string[];
  hideEmptyFolders?: boolean | null;
  newFolderIds?: UUID[] | null;
}

export interface EnrollEmailSequenceInput {
  __typename?: 'EnrollEmailSequenceInput';
  bulkFilter?: BulkOperationInput | null;
  clientMutationId?: string | null;
  id: ID;
  immediate?: boolean | null;
  recipients?: SendEmailRecipientParams[] | null;
}

export interface EnableProcessInput {
  __typename?: 'EnableProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface EnableOnlineFormTypeInput {
  __typename?: 'EnableOnlineFormTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface EnableEmailSequenceInput {
  __typename?: 'EnableEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface EnableApprovalProcessInput {
  __typename?: 'EnableApprovalProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface EmailTypeEnumFilterInput {
  __typename?: 'EmailTypeEnumFilterInput';
  NOT?: EmailTypeEnumFilterInput | null;
  eq?: EmailTypeEnum[] | null;
}

export interface EmailTemplatesStatisticsFilterParams {
  __typename?: 'EmailTemplatesStatisticsFilterParams';
  filterByFolders?: string[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByTemplate: EmailTemplatesFilterEnum;
}

export interface EmailTemplateTypeEnumFilterInput {
  __typename?: 'EmailTemplateTypeEnumFilterInput';
  NOT?: EmailTemplateTypeEnumFilterInput | null;
  eq?: EmailTemplateTypeEnum[] | null;
}

export interface EmailTemplateSharingSalesUnitRelationOrderByInput {
  __typename?: 'EmailTemplateSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  emailTemplate?: EmailTemplateOrderByNestedInput[] | null;
  emailTemplateId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface EmailTemplateSharingSalesUnitRelationFilterInput {
  __typename?: 'EmailTemplateSharingSalesUnitRelationFilterInput';
  AND?: EmailTemplateSharingSalesUnitRelationFilterInput[] | null;
  NOT?: EmailTemplateSharingSalesUnitRelationFilterInput | null;
  OR?: EmailTemplateSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  emailTemplate?: EmailTemplateFilterInput | null;
  emailTemplateId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface EmailTemplateSharingClientRelationOrderByInput {
  __typename?: 'EmailTemplateSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  emailTemplate?: EmailTemplateOrderByNestedInput[] | null;
  emailTemplateId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface EmailTemplateSharingClientRelationFilterInput {
  __typename?: 'EmailTemplateSharingClientRelationFilterInput';
  AND?: EmailTemplateSharingClientRelationFilterInput[] | null;
  NOT?: EmailTemplateSharingClientRelationFilterInput | null;
  OR?: EmailTemplateSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  emailTemplate?: EmailTemplateFilterInput | null;
  emailTemplateId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface EmailTemplateOrderByNestedInput {
  __typename?: 'EmailTemplateOrderByNestedInput';
  created?: OrderByEnum | null;
  emailTemplateFolderId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  sharingUrlIsEnabled?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface EmailTemplateOrderByInput {
  __typename?: 'EmailTemplateOrderByInput';
  created?: OrderByEnum | null;
  emailTemplateFolder?: EmailTemplateFolderOrderByNestedInput[] | null;
  emailTemplateFolderId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  sharingUrlIsEnabled?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface EmailTemplateFolderOrderByNestedInput {
  __typename?: 'EmailTemplateFolderOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentEmailTemplateFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EmailTemplateFolderOrderByInput {
  __typename?: 'EmailTemplateFolderOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentEmailTemplateFolder?: EmailTemplateFolderOrderByNestedInput[] | null;
  parentEmailTemplateFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EmailTemplateFolderFilterInput {
  __typename?: 'EmailTemplateFolderFilterInput';
  AND?: EmailTemplateFolderFilterInput[] | null;
  NOT?: EmailTemplateFolderFilterInput | null;
  OR?: EmailTemplateFolderFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  parentEmailTemplateFolder?: EmailTemplateFolderFilterInput | null;
  parentEmailTemplateFolderId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface EmailTemplateFilterInput {
  __typename?: 'EmailTemplateFilterInput';
  AND?: EmailTemplateFilterInput[] | null;
  NOT?: EmailTemplateFilterInput | null;
  OR?: EmailTemplateFilterInput[] | null;
  body?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  documents?: CloudObjectRelationFilterInput | null;
  emailTemplateFolder?: EmailTemplateFolderFilterInput | null;
  emailTemplateFolderId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: EmailTemplateSharingClientRelationFilterInput | null;
  sharingUnits?: EmailTemplateSharingSalesUnitRelationFilterInput | null;
  sharingUrlIsEnabled?: boolean | null;
  subject?: EntityFilterStringField | null;
  type?: EmailTemplateTypeEnumFilterInput | null;
}

export interface EmailServiceTypeEnumFilterInput {
  __typename?: 'EmailServiceTypeEnumFilterInput';
  NOT?: EmailServiceTypeEnumFilterInput | null;
  eq?: EmailServiceTypeEnum[] | null;
}

export interface EmailSequencesNotificationSettingsParams {
  __typename?: 'EmailSequencesNotificationSettingsParams';
  Errors: boolean;
  IsActive: boolean;
  Warnings: boolean;
}

export interface EmailSequenceTabDataGridViewOptionsParams {
  __typename?: 'EmailSequenceTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStatus?: ProcessStatusEnum[] | null;
  filterByTagIds?: ID[] | null;
  showActive: boolean;
  showInactive: boolean;
}

export interface EmailSequenceOrderByNestedInput {
  __typename?: 'EmailSequenceOrderByNestedInput';
  bounceRate?: OrderByEnum | null;
  clickRate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  createdCount?: OrderByEnum | null;
  deactivationReason?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrollCount?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastEmailSequenceRun?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  openRate?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  replyRate?: OrderByEnum | null;
  sentCount?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepCount?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerFieldId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  unsubscribeRate?: OrderByEnum | null;
}

export interface EmailSequenceOrderByInput {
  __typename?: 'EmailSequenceOrderByInput';
  bounceRate?: OrderByEnum | null;
  clickRate?: OrderByEnum | null;
  created?: OrderByEnum | null;
  createdCount?: OrderByEnum | null;
  deactivationReason?: OrderByEnum | null;
  description?: OrderByEnum | null;
  enrollCount?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastEmailSequenceRun?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  openRate?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  replyRate?: OrderByEnum | null;
  sentCount?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepCount?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerFieldId?: OrderByEnum | null;
  type?: OrderByEnum | null;
  unsubscribeRate?: OrderByEnum | null;
}

export interface EmailSequenceFilterInput {
  __typename?: 'EmailSequenceFilterInput';
  AND?: EmailSequenceFilterInput[] | null;
  NOT?: EmailSequenceFilterInput | null;
  OR?: EmailSequenceFilterInput[] | null;
  activityLogs?: EmailSequenceActivityLogFilterInput | null;
  bounceRate?: number | null;
  clickRate?: number | null;
  created?: EntityFilterDateTimeField | null;
  createdCount?: number | null;
  deactivationReason?: EmailSequenceDeactivationReasonEnumFilterInput | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  enrollCount?: number | null;
  enrolled?: EmailSequenceEnrolledFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  lastEmailSequenceRun?: DateTime | null;
  lastSchemaChange?: EntityFilterDateTimeField | null;
  lastStatusChange?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  openRate?: number | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  replyRate?: number | null;
  sentCount?: number | null;
  status?: ProcessStatusEnum | null;
  stepCount?: number | null;
  triggerEntityName?: EntityNameEnum | null;
  triggerFieldId?: UUID | null;
  type?: ProcessTypeEnumFilterInput | null;
  unsubscribeRate?: number | null;
}

export interface EmailSequenceEnrolledOrderByInput {
  __typename?: 'EmailSequenceEnrolledOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  actor?: ClientOrderByNestedInput[] | null;
  actorId?: OrderByEnum | null;
  address?: OrderByEnum | null;
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  emailSequence?: EmailSequenceOrderByNestedInput[] | null;
  emailSequenceActivityLog?: EmailSequenceActivityLogOrderByNestedInput[] | null;
  emailSequenceActivityLogId?: OrderByEnum | null;
  emailSequenceId?: OrderByEnum | null;
  endReason?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  entityName?: OrderByEnum | null;
  excludedFromStats?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
  stepCount?: OrderByEnum | null;
  stepIndex?: OrderByEnum | null;
}

export interface EmailSequenceEnrolledFilterInput {
  __typename?: 'EmailSequenceEnrolledFilterInput';
  AND?: EmailSequenceEnrolledFilterInput[] | null;
  NOT?: EmailSequenceEnrolledFilterInput | null;
  OR?: EmailSequenceEnrolledFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  actor?: ClientFilterInput | null;
  actorId?: EntityFilterStringField | null;
  address?: EntityFilterStringField | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  emailSequence?: EmailSequenceFilterInput | null;
  emailSequenceActivityLog?: EmailSequenceActivityLogFilterInput | null;
  emailSequenceActivityLogId?: EntityFilterStringField | null;
  emailSequenceId?: EntityFilterStringField | null;
  endReason?: EmailSequenceEndReasonEnumFilterInput | null;
  endTime?: EntityFilterDateTimeField | null;
  entityId?: EntityFilterStringField | null;
  entityName?: EntityNameEnum | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  excludedFromStats?: boolean | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  startTime?: EntityFilterDateTimeField | null;
  status?: ProcessStatusEnum | null;
  stepCount?: EntityFilterNumberField | null;
  stepIndex?: number | null;
}

export interface EmailSequenceEndReasonEnumFilterInput {
  __typename?: 'EmailSequenceEndReasonEnumFilterInput';
  NOT?: EmailSequenceEndReasonEnumFilterInput | null;
  eq?: EmailSequenceEndReasonEnum[] | null;
}

export interface EmailSequenceDeactivationReasonEnumFilterInput {
  __typename?: 'EmailSequenceDeactivationReasonEnumFilterInput';
  NOT?: EmailSequenceDeactivationReasonEnumFilterInput | null;
  eq?: EmailSequenceDeactivationReasonEnum[] | null;
}

export interface EmailSequenceActivityLogOrderByNestedInput {
  __typename?: 'EmailSequenceActivityLogOrderByNestedInput';
  actorId?: OrderByEnum | null;
  applicationId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  emailSequenceId?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTestRun?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  recordEmail?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface EmailSequenceActivityLogOrderByInput {
  __typename?: 'EmailSequenceActivityLogOrderByInput';
  actor?: ClientOrderByNestedInput[] | null;
  actorId?: OrderByEnum | null;
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  emailSequence?: EmailSequenceOrderByNestedInput[] | null;
  emailSequenceId?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTestRun?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  recordEmail?: OrderByEnum | null;
  recordName?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface EmailSequenceActivityLogLineOrderByInput {
  __typename?: 'EmailSequenceActivityLogLineOrderByInput';
  created?: OrderByEnum | null;
  emailSequenceActivityLog?: EmailSequenceActivityLogOrderByNestedInput[] | null;
  emailSequenceActivityLogId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface EmailSequenceActivityLogLineFilterInput {
  __typename?: 'EmailSequenceActivityLogLineFilterInput';
  AND?: EmailSequenceActivityLogLineFilterInput[] | null;
  NOT?: EmailSequenceActivityLogLineFilterInput | null;
  OR?: EmailSequenceActivityLogLineFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  emailSequenceActivityLog?: EmailSequenceActivityLogFilterInput | null;
  emailSequenceActivityLogId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isVisible?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  sortOrder?: EntityFilterNumberField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface EmailSequenceActivityLogFilterInput {
  __typename?: 'EmailSequenceActivityLogFilterInput';
  AND?: EmailSequenceActivityLogFilterInput[] | null;
  NOT?: EmailSequenceActivityLogFilterInput | null;
  OR?: EmailSequenceActivityLogFilterInput[] | null;
  actor?: ClientFilterInput | null;
  actorId?: EntityFilterStringField | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  emailSequence?: EmailSequenceFilterInput | null;
  emailSequenceId?: EntityFilterStringField | null;
  endTime?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isTestRun?: boolean | null;
  lines?: EmailSequenceActivityLogLineFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  recordEmail?: string | null;
  recordName?: string | null;
  startTime?: EntityFilterDateTimeField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface EmailSentimentEnumFilterInput {
  __typename?: 'EmailSentimentEnumFilterInput';
  NOT?: EmailSentimentEnumFilterInput | null;
  eq?: EmailSentimentEnum[] | null;
}

export interface EmailOrderByNestedInput {
  __typename?: 'EmailOrderByNestedInput';
  bodySummary?: OrderByEnum | null;
  cc?: OrderByEnum | null;
  companyEmailId?: OrderByEnum | null;
  contentShareMode?: OrderByEnum | null;
  contentType?: OrderByEnum | null;
  created?: OrderByEnum | null;
  dateSent?: OrderByEnum | null;
  direction?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTracked?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  parentEmailId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sendAt?: OrderByEnum | null;
  sender?: OrderByEnum | null;
  senderAccountId?: OrderByEnum | null;
  senderClientId?: OrderByEnum | null;
  senderContactId?: OrderByEnum | null;
  sentiment?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  templateId?: OrderByEnum | null;
  to?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface EmailOrderByInput {
  __typename?: 'EmailOrderByInput';
  bodySummary?: OrderByEnum | null;
  cc?: OrderByEnum | null;
  companyEmail?: CompanyEmailOrderByNestedInput[] | null;
  companyEmailId?: OrderByEnum | null;
  contentShareMode?: OrderByEnum | null;
  contentType?: OrderByEnum | null;
  created?: OrderByEnum | null;
  dateSent?: OrderByEnum | null;
  direction?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTracked?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  parentEmail?: EmailOrderByNestedInput[] | null;
  parentEmailId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sendAt?: OrderByEnum | null;
  sender?: OrderByEnum | null;
  senderAccount?: AccountOrderByNestedInput[] | null;
  senderAccountId?: OrderByEnum | null;
  senderClient?: ClientOrderByNestedInput[] | null;
  senderClientId?: OrderByEnum | null;
  senderContact?: ContactOrderByNestedInput[] | null;
  senderContactId?: OrderByEnum | null;
  sentiment?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  template?: EmailTemplateOrderByNestedInput[] | null;
  templateId?: OrderByEnum | null;
  to?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface EmailNotificationSettingsParams {
  __typename?: 'EmailNotificationSettingsParams';
  Bounced?: boolean | null;
  IsActive: boolean;
  LinkedItem?: boolean | null;
  Tracking?: boolean | null;
}

export interface EmailFollowUpTaskParams {
  __typename?: 'EmailFollowUpTaskParams';
  dueDate?: GqlDate | null;
  dueDateOffset?: number | null;
  taskTypeId: ID;
}

export interface EmailFilterInput {
  __typename?: 'EmailFilterInput';
  AND?: EmailFilterInput[] | null;
  NOT?: EmailFilterInput | null;
  OR?: EmailFilterInput[] | null;
  accountRelations?: MessageRelationFilterInput | null;
  body?: EntityFilterStringField | null;
  bodySummary?: EntityFilterStringField | null;
  cc?: EntityFilterStringField | null;
  companyEmail?: CompanyEmailFilterInput | null;
  companyEmailId?: EntityFilterStringField | null;
  contactRelations?: MessageRelationFilterInput | null;
  contentShareMode?: ContentShareModeEnumFilterInput | null;
  contentSharingClients?: EmailContentSharingClientRelationFilterInput | null;
  contentSharingUnits?: EmailContentSharingSalesUnitRelationFilterInput | null;
  contentType?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntityRelations?: MessageRelationFilterInput | null;
  dateSent?: EntityFilterDateTimeField | null;
  direction?: EmailDirectionEnumFilterInput | null;
  documents?: CloudObjectRelationFilterInput | null;
  errorCode?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isTracked?: boolean | null;
  leadRelations?: MessageRelationFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  opportunityRelations?: MessageRelationFilterInput | null;
  originalId?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  parentEmail?: EmailFilterInput | null;
  parentEmailId?: EntityFilterStringField | null;
  projectRelations?: MessageRelationFilterInput | null;
  quoteRelations?: MessageRelationFilterInput | null;
  revision?: EntityFilterNumberField | null;
  sendAt?: EntityFilterDateTimeField | null;
  sender?: EntityFilterStringField | null;
  senderAccount?: AccountFilterInput | null;
  senderAccountId?: EntityFilterStringField | null;
  senderClient?: ClientFilterInput | null;
  senderClientId?: EntityFilterStringField | null;
  senderContact?: ContactFilterInput | null;
  senderContactId?: EntityFilterStringField | null;
  sentiment?: EmailSentimentEnumFilterInput | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: MessageSharingClientRelationFilterInput | null;
  sharingUnits?: MessageSharingSalesUnitRelationFilterInput | null;
  subject?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
  tags?: TagRelationFilterInput | null;
  template?: EmailTemplateFilterInput | null;
  templateId?: EntityFilterStringField | null;
  threadId?: EntityFilterStringField | null;
  to?: EntityFilterStringField | null;
  type?: EmailTypeEnumFilterInput | null;
  uid?: EntityFilterStringField | null;
}

export interface EmailEventTypeEnumFilterInput {
  __typename?: 'EmailEventTypeEnumFilterInput';
  NOT?: EmailEventTypeEnumFilterInput | null;
  eq?: EmailEventTypeEnum[] | null;
}

export interface EmailEventOrderByInput {
  __typename?: 'EmailEventOrderByInput';
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  type?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface EmailEventFilterInput {
  __typename?: 'EmailEventFilterInput';
  AND?: EmailEventFilterInput[] | null;
  NOT?: EmailEventFilterInput | null;
  OR?: EmailEventFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  type?: EmailEventTypeEnumFilterInput | null;
  url?: EntityFilterStringField | null;
}

export interface EmailDrilldownFilterParams {
  __typename?: 'EmailDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface EmailDirectionEnumFilterInput {
  __typename?: 'EmailDirectionEnumFilterInput';
  NOT?: EmailDirectionEnumFilterInput | null;
  eq?: EmailDirectionEnum[] | null;
}

export interface EmailContentSharingSalesUnitRelationOrderByInput {
  __typename?: 'EmailContentSharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface EmailContentSharingSalesUnitRelationFilterInput {
  __typename?: 'EmailContentSharingSalesUnitRelationFilterInput';
  AND?: EmailContentSharingSalesUnitRelationFilterInput[] | null;
  NOT?: EmailContentSharingSalesUnitRelationFilterInput | null;
  OR?: EmailContentSharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface EmailContentSharingClientRelationOrderByInput {
  __typename?: 'EmailContentSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface EmailContentSharingClientRelationFilterInput {
  __typename?: 'EmailContentSharingClientRelationFilterInput';
  AND?: EmailContentSharingClientRelationFilterInput[] | null;
  NOT?: EmailContentSharingClientRelationFilterInput | null;
  OR?: EmailContentSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  emailId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface EmailConfFieldInput {
  __typename?: 'EmailConfFieldInput';
  brand: ImapLoginTypeEnum;
  isUsingOauth?: boolean | null;
  password?: string | null;
  port?: number | null;
  server?: string | null;
  ssl?: boolean | null;
  username: string;
}

export interface EditFilledCloudObjectTemplateInput {
  __typename?: 'EditFilledCloudObjectTemplateInput';
  clientMutationId?: string | null;
  currencyToBaseValue?: boolean | null;
  entityApiName?: string | null;
  entityId: ID;
  entityName: EntityNameEnum;
  integrationType: MsStorageIntegrationTypeEnum;
  opptyProductRelationIds?: string[] | null;
  sessionId: UUID;
  templateId: ID;
}

export interface EditCloudObjectTemplateInput {
  __typename?: 'EditCloudObjectTemplateInput';
  clientMutationId?: string | null;
  integrationType: MsStorageIntegrationTypeEnum;
  templateId: ID;
}

export interface EbookSourceTypeEnumFilterInput {
  __typename?: 'EbookSourceTypeEnumFilterInput';
  NOT?: EbookSourceTypeEnumFilterInput | null;
  eq?: EbookSourceTypeEnum[] | null;
}

export interface EbookOrderByInput {
  __typename?: 'EbookOrderByInput';
  category?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  previewImageUrl?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  sourceType?: OrderByEnum | null;
  sourceUrl?: OrderByEnum | null;
  title?: OrderByEnum | null;
  uniqueViewCount?: OrderByEnum | null;
  viewCount?: OrderByEnum | null;
}

export interface EbookFilterInput {
  __typename?: 'EbookFilterInput';
  AND?: EbookFilterInput[] | null;
  NOT?: EbookFilterInput | null;
  OR?: EbookFilterInput[] | null;
  category?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  previewImageUrl?: EntityFilterStringField | null;
  sortOrder?: EntityFilterNumberField | null;
  sourceType?: EbookSourceTypeEnumFilterInput | null;
  sourceUrl?: EntityFilterStringField | null;
  title?: EntityFilterStringField | null;
  uniqueViewCount?: number | null;
  viewCount?: number | null;
}

export interface DuplicateMediaRecordingMp3Input {
  __typename?: 'DuplicateMediaRecordingMp3Input';
  clientMutationId?: string | null;
  entityId: ID;
  filename: string;
}

export interface DuplicateCheckerSettingsParams {
  __typename?: 'DuplicateCheckerSettingsParams';
  fieldIds: ID[];
  isEnabled: boolean;
  masterRecordResolution: MasterRecordResolutionEnum;
  masterRecordResolutionCustomConditions?: FieldFilterParams | null;
  matchSimilarityLevel: MatchSimilarityLevelEnum;
}

export interface DuplicateCheckerMatchSettingsParams {
  __typename?: 'DuplicateCheckerMatchSettingsParams';
  entity?: EntityNameEnum | null;
  entityApiName?: string | null;
  filter?: FieldFilterParams | null;
  masterRecordResolution?: MasterRecordResolutionEnum | null;
  masterRecordResolutionCustomConditions?: FieldFilterParams | null;
  matchSimilarityLevel?: MatchSimilarityLevelEnum | null;
}

export interface DuplicateCheckerManualMergeFieldsParams {
  __typename?: 'DuplicateCheckerManualMergeFieldsParams';
  entity?: EntityNameEnum | null;
  entityApiName?: string | null;
  fieldIds: UUID[];
}

export interface DuplicateCheckerEntitySettingsParams {
  __typename?: 'DuplicateCheckerEntitySettingsParams';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  settings: DuplicateCheckerSettingsParams;
}

export interface DropboxSettingsInput {
  __typename?: 'DropboxSettingsInput';
  dropboxAccessToken?: string | null;
}

export interface DisplayParamEnumFilterInput {
  __typename?: 'DisplayParamEnumFilterInput';
  NOT?: DisplayParamEnumFilterInput | null;
  eq?: DisplayParamEnum[] | null;
}

export interface DisplayColumnParams {
  __typename?: 'DisplayColumnParams';
  displayOption: DisplayOption;
  fieldId: ID;
}

export interface DisableProcessInput {
  __typename?: 'DisableProcessInput';
  clientMutationId?: string | null;
  disableScheduledActivities?: boolean | null;
  id: ID;
}

export interface DisableOnlineFormTypeInput {
  __typename?: 'DisableOnlineFormTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DisableEmailSequenceInput {
  __typename?: 'DisableEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DisableApprovalProcessInput {
  __typename?: 'DisableApprovalProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DetailFeedActiveScreenTypeParams {
  __typename?: 'DetailFeedActiveScreenTypeParams';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  screenType: ScreenTypeEnum;
}

export interface DetailFeedActiveProfileParams {
  __typename?: 'DetailFeedActiveProfileParams';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  profileId: UUID;
}

export interface DeleteZoomMeetingInput {
  __typename?: 'DeleteZoomMeetingInput';
  clientMutationId?: string | null;
  joinUrl: string;
}

export interface DeleteWebhookInput {
  __typename?: 'DeleteWebhookInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteWebhookEventInput {
  __typename?: 'DeleteWebhookEventInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteUnsubscribedPhoneInput {
  __typename?: 'DeleteUnsubscribedPhoneInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTimeframeInput {
  __typename?: 'DeleteTimeframeInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteTextMessageConversationRelationsInput {
  __typename?: 'DeleteTextMessageConversationRelationsInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteTaskSharingSalesUnitRelationInput {
  __typename?: 'DeleteTaskSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTaskSharingClientRelationInput {
  __typename?: 'DeleteTaskSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTaskReminderInput {
  __typename?: 'DeleteTaskReminderInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTaskRecurrenceInput {
  __typename?: 'DeleteTaskRecurrenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTaskInput {
  __typename?: 'DeleteTaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTargetRelationInput {
  __typename?: 'DeleteTargetRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTargetInput {
  __typename?: 'DeleteTargetInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTagRelationInput {
  __typename?: 'DeleteTagRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteTagInput {
  __typename?: 'DeleteTagInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteStepInput {
  __typename?: 'DeleteStepInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteStepChecklistSalesRoleRelationInput {
  __typename?: 'DeleteStepChecklistSalesRoleRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteStepChecklistInput {
  __typename?: 'DeleteStepChecklistInput';
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteSalesUnitInput {
  __typename?: 'DeleteSalesUnitInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteSalesRoleInput {
  __typename?: 'DeleteSalesRoleInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteReportSharingSalesUnitRelationInput {
  __typename?: 'DeleteReportSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteReportSharingClientRelationInput {
  __typename?: 'DeleteReportSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteReportScheduleInput {
  __typename?: 'DeleteReportScheduleInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteReportInput {
  __typename?: 'DeleteReportInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteReportFolderInput {
  __typename?: 'DeleteReportFolderInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteSharingSalesUnitRelationInput {
  __typename?: 'DeleteQuoteSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteSharingClientRelationInput {
  __typename?: 'DeleteQuoteSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteProcessInput {
  __typename?: 'DeleteQuoteProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteKPIInput {
  __typename?: 'DeleteQuoteKPIInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteInput {
  __typename?: 'DeleteQuoteInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteDataExRelationInput {
  __typename?: 'DeleteQuoteDataExRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteContactRelationInput {
  __typename?: 'DeleteQuoteContactRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteQuoteAccountRelationInput {
  __typename?: 'DeleteQuoteAccountRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProjectSharingSalesUnitRelationInput {
  __typename?: 'DeleteProjectSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProjectSharingClientRelationInput {
  __typename?: 'DeleteProjectSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProjectObjectiveInput {
  __typename?: 'DeleteProjectObjectiveInput';
  clientMutationId?: string | null;
  deleteActivities?: boolean | null;
  id: ID;
  moveActivitiesToObjectiveId?: ID | null;
}

export interface DeleteProjectKPIInput {
  __typename?: 'DeleteProjectKPIInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProjectInput {
  __typename?: 'DeleteProjectInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProjectContactRelationInput {
  __typename?: 'DeleteProjectContactRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProfileSharingSalesUnitRelationInput {
  __typename?: 'DeleteProfileSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProfileSharingClientRelationInput {
  __typename?: 'DeleteProfileSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProfileRelationInput {
  __typename?: 'DeleteProfileRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteProfileInput {
  __typename?: 'DeleteProfileInput';
  clientMutationId?: string | null;
  profileId: ID;
}

export interface DeleteProductPriceListPriceInput {
  __typename?: 'DeleteProductPriceListPriceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProductPriceListInput {
  __typename?: 'DeleteProductPriceListInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProductPipelineRelationInput {
  __typename?: 'DeleteProductPipelineRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProductInput {
  __typename?: 'DeleteProductInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProductCategoryInput {
  __typename?: 'DeleteProductCategoryInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProcessTemplateInput {
  __typename?: 'DeleteProcessTemplateInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProcessInput {
  __typename?: 'DeleteProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProcessActivityLogLineInput {
  __typename?: 'DeleteProcessActivityLogLineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteProcessActivityLogInput {
  __typename?: 'DeleteProcessActivityLogInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeletePipelineInput {
  __typename?: 'DeletePipelineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeletePhoneNumberTeamSpaceClientSettingInput {
  __typename?: 'DeletePhoneNumberTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  number: string;
}

export interface DeletePhoneInput {
  __typename?: 'DeletePhoneInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteParentAccountRelationTypeInput {
  __typename?: 'DeleteParentAccountRelationTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOpptyRecurrenceInput {
  __typename?: 'DeleteOpptyRecurrenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOpptyProductRelationInput {
  __typename?: 'DeleteOpptyProductRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOpptyProductRelationDataExRelationInput {
  __typename?: 'DeleteOpptyProductRelationDataExRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOpportunityInput {
  __typename?: 'DeleteOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOnlineFormTypeInput {
  __typename?: 'DeleteOnlineFormTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOnlineFormTypeEmailRelationInput {
  __typename?: 'DeleteOnlineFormTypeEmailRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteOnlineFormStyleInput {
  __typename?: 'DeleteOnlineFormStyleInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOnlineFormRelationInput {
  __typename?: 'DeleteOnlineFormRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteOnlineFormInput {
  __typename?: 'DeleteOnlineFormInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOnlineFormDataExRelationInput {
  __typename?: 'DeleteOnlineFormDataExRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteOnlineFormActivityLogLineInput {
  __typename?: 'DeleteOnlineFormActivityLogLineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteNoteInput {
  __typename?: 'DeleteNoteInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteMessageSharingSalesUnitRelationInput {
  __typename?: 'DeleteMessageSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
  messageId?: ID | null;
}

export interface DeleteMessageSharingClientRelationInput {
  __typename?: 'DeleteMessageSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
  messageId?: ID | null;
}

export interface DeleteMessageRelationInput {
  __typename?: 'DeleteMessageRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
  messageId?: ID | null;
}

export interface DeleteMemoInput {
  __typename?: 'DeleteMemoInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteMemoCommentInput {
  __typename?: 'DeleteMemoCommentInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteMeetingAppointmentInput {
  __typename?: 'DeleteMeetingAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
  joinUrl: string;
}

export interface DeleteMediaInput {
  __typename?: 'DeleteMediaInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteMasterRightInput {
  __typename?: 'DeleteMasterRightInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteLeadProcessInput {
  __typename?: 'DeleteLeadProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteLeadOpptyStepCheckListRelationInput {
  __typename?: 'DeleteLeadOpptyStepCheckListRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptySharingSalesUnitRelationInput {
  __typename?: 'DeleteLeadOpptySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptySharingClientRelationInput {
  __typename?: 'DeleteLeadOpptySharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptyKPIInput {
  __typename?: 'DeleteLeadOpptyKPIInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'DeleteLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteLeadOpptyContactRelationInput {
  __typename?: 'DeleteLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptyContactGroupRelationInput {
  __typename?: 'DeleteLeadOpptyContactGroupRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadOpptyAccountRelationInput {
  __typename?: 'DeleteLeadOpptyAccountRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteLeadInput {
  __typename?: 'DeleteLeadInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteImportMappingMaskInput {
  __typename?: 'DeleteImportMappingMaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteGhostLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'DeleteGhostLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteGhostLeadOpptyContactRelationInput {
  __typename?: 'DeleteGhostLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteGhostContactInput {
  __typename?: 'DeleteGhostContactInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteGhostContactAccountRelationInput {
  __typename?: 'DeleteGhostContactAccountRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteGhostContactAccountAccountRoleRelationInput {
  __typename?: 'DeleteGhostContactAccountAccountRoleRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteFormViewSharingSalesUnitRelationInput {
  __typename?: 'DeleteFormViewSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteFormViewSharingClientRelationInput {
  __typename?: 'DeleteFormViewSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteFormViewInput {
  __typename?: 'DeleteFormViewInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteForecastInput {
  __typename?: 'DeleteForecastInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteFieldMappingInput {
  __typename?: 'DeleteFieldMappingInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEntityScoringInput {
  __typename?: 'DeleteEntityScoringInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEntityFitnessIndicatorInput {
  __typename?: 'DeleteEntityFitnessIndicatorInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailTemplateSharingSalesUnitRelationInput {
  __typename?: 'DeleteEmailTemplateSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailTemplateSharingClientRelationInput {
  __typename?: 'DeleteEmailTemplateSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailTemplateInput {
  __typename?: 'DeleteEmailTemplateInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailTemplateFolderInput {
  __typename?: 'DeleteEmailTemplateFolderInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailSequenceInput {
  __typename?: 'DeleteEmailSequenceInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailSequenceEnrolledInput {
  __typename?: 'DeleteEmailSequenceEnrolledInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailSequenceActivityLogLineInput {
  __typename?: 'DeleteEmailSequenceActivityLogLineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailSequenceActivityLogInput {
  __typename?: 'DeleteEmailSequenceActivityLogInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailInput {
  __typename?: 'DeleteEmailInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailEventInput {
  __typename?: 'DeleteEmailEventInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailContentSharingSalesUnitRelationInput {
  __typename?: 'DeleteEmailContentSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteEmailContentSharingClientRelationInput {
  __typename?: 'DeleteEmailContentSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteDraftWebresourceInput {
  __typename?: 'DeleteDraftWebresourceInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftTranslationInput {
  __typename?: 'DeleteDraftTranslationInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftTaskTypeInput {
  __typename?: 'DeleteDraftTaskTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftQuoteTypeInput {
  __typename?: 'DeleteDraftQuoteTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftProjectTypeInput {
  __typename?: 'DeleteDraftProjectTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftProductTypeInput {
  __typename?: 'DeleteDraftProductTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftOpptyProductRelationTypeInput {
  __typename?: 'DeleteDraftOpptyProductRelationTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftOpportunityTypeInput {
  __typename?: 'DeleteDraftOpportunityTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftLeadTypeInput {
  __typename?: 'DeleteDraftLeadTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftInterfacePreviewInput {
  __typename?: 'DeleteDraftInterfacePreviewInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftFieldSequenceInput {
  __typename?: 'DeleteDraftFieldSequenceInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftFieldPermissionInput {
  __typename?: 'DeleteDraftFieldPermissionInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftFieldInput {
  __typename?: 'DeleteDraftFieldInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftEntitySettingsInput {
  __typename?: 'DeleteDraftEntitySettingsInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftDataInput {
  __typename?: 'DeleteDraftDataInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftCustomEntityTypeInput {
  __typename?: 'DeleteDraftCustomEntityTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftCustomEntityRelationInput {
  __typename?: 'DeleteDraftCustomEntityRelationInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftContactTypeInput {
  __typename?: 'DeleteDraftContactTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftAppointmentTypeInput {
  __typename?: 'DeleteDraftAppointmentTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDraftAccountTypeInput {
  __typename?: 'DeleteDraftAccountTypeInput';
  clientMutationId?: string | null;
  id?: ID | null;
}

export interface DeleteDataInput {
  __typename?: 'DeleteDataInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCustomEntitySharingSalesUnitRelationInput {
  __typename?: 'DeleteCustomEntitySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCustomEntitySharingClientRelationInput {
  __typename?: 'DeleteCustomEntitySharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCustomEntityRelationDataInput {
  __typename?: 'DeleteCustomEntityRelationDataInput';
  activity1Id?: ID | null;
  activity2Id?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  leadOppty1Id?: ID | null;
  leadOppty2Id?: ID | null;
}

export interface DeleteCustomEntityMetaMutationInput {
  __typename?: 'DeleteCustomEntityMetaMutationInput';
  clientMutationId?: string | null;
  entityApiName: string;
}

export interface DeleteCustomEntityInput {
  __typename?: 'DeleteCustomEntityInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCustomEntityDataExRelationInput {
  __typename?: 'DeleteCustomEntityDataExRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCurrencyInput {
  __typename?: 'DeleteCurrencyInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCurrencyExchangeRatesListInput {
  __typename?: 'DeleteCurrencyExchangeRatesListInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCurrencyExchangeRateInput {
  __typename?: 'DeleteCurrencyExchangeRateInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactSocialRelationInput {
  __typename?: 'DeleteContactSocialRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactSharingSalesUnitRelationInput {
  __typename?: 'DeleteContactSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactSharingClientRelationInput {
  __typename?: 'DeleteContactSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactRelationTypeInput {
  __typename?: 'DeleteContactRelationTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactRelationLabelInput {
  __typename?: 'DeleteContactRelationLabelInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactRelationInput {
  __typename?: 'DeleteContactRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactKPIInput {
  __typename?: 'DeleteContactKPIInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactInput {
  __typename?: 'DeleteContactInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactAccountRelationInput {
  __typename?: 'DeleteContactAccountRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteContactAccountAccountRoleRelationInput {
  __typename?: 'DeleteContactAccountAccountRoleRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCompanyEmailInput {
  __typename?: 'DeleteCompanyEmailInput';
  clientMutationId?: string | null;
  enabled?: boolean | null;
  id: ID;
}

export interface DeleteCloudObjectsInput {
  __typename?: 'DeleteCloudObjectsInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
}

export interface DeleteCloudObjectTemplateInput {
  __typename?: 'DeleteCloudObjectTemplateInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCloudObjectStepRelationInput {
  __typename?: 'DeleteCloudObjectStepRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCloudObjectRelationInput {
  __typename?: 'DeleteCloudObjectRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
  messageId?: ID | null;
}

export interface DeleteCloudObjectInput {
  __typename?: 'DeleteCloudObjectInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCloudObjectFolderInput {
  __typename?: 'DeleteCloudObjectFolderInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteClientStoryReadInput {
  __typename?: 'DeleteClientStoryReadInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  messageId?: ID | null;
}

export interface DeleteClientSettingInput {
  __typename?: 'DeleteClientSettingInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteClientInput {
  __typename?: 'DeleteClientInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteClientFavoriteInput {
  __typename?: 'DeleteClientFavoriteInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteClientExcludedOpptyInput {
  __typename?: 'DeleteClientExcludedOpptyInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteChatConversationInput {
  __typename?: 'DeleteChatConversationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteCallInput {
  __typename?: 'DeleteCallInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteAutomationHubItemInput {
  __typename?: 'DeleteAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteApprovalProcessInput {
  __typename?: 'DeleteApprovalProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteApprovalProcessActivityLogLineInput {
  __typename?: 'DeleteApprovalProcessActivityLogLineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteApprovalInput {
  __typename?: 'DeleteApprovalInput';
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteApprovalApproverInput {
  __typename?: 'DeleteApprovalApproverInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAppointmentScheduleInput {
  __typename?: 'DeleteAppointmentScheduleInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAppointmentReminderInput {
  __typename?: 'DeleteAppointmentReminderInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAppointmentInput {
  __typename?: 'DeleteAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAppointmentContactInviteesRelationInput {
  __typename?: 'DeleteAppointmentContactInviteesRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAppointmentClientInviteesRelationInput {
  __typename?: 'DeleteAppointmentClientInviteesRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteApiAccessInput {
  __typename?: 'DeleteApiAccessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedQuoteTypeInput {
  __typename?: 'DeleteAllowedQuoteTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedPipelineInput {
  __typename?: 'DeleteAllowedPipelineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedLeadTypeInput {
  __typename?: 'DeleteAllowedLeadTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedContactTypeInput {
  __typename?: 'DeleteAllowedContactTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedCompanyPhoneInput {
  __typename?: 'DeleteAllowedCompanyPhoneInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedCompanyEmailInput {
  __typename?: 'DeleteAllowedCompanyEmailInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAllowedAccountTypeInput {
  __typename?: 'DeleteAllowedAccountTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteActivityRelationInput {
  __typename?: 'DeleteActivityRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
  leadOpptyId?: ID | null;
}

export interface DeleteActivityKPIInput {
  __typename?: 'DeleteActivityKPIInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteActivityCommentInput {
  __typename?: 'DeleteActivityCommentInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountSocialRelationInput {
  __typename?: 'DeleteAccountSocialRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountSharingSalesUnitRelationInput {
  __typename?: 'DeleteAccountSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountSharingClientRelationInput {
  __typename?: 'DeleteAccountSharingClientRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountRoleInput {
  __typename?: 'DeleteAccountRoleInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountRelationTypeInput {
  __typename?: 'DeleteAccountRelationTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountRelationLabelInput {
  __typename?: 'DeleteAccountRelationLabelInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountRelationInput {
  __typename?: 'DeleteAccountRelationInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountProductPricingInput {
  __typename?: 'DeleteAccountProductPricingInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountKPIInput {
  __typename?: 'DeleteAccountKPIInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DeleteAccountInput {
  __typename?: 'DeleteAccountInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface DelegateApprovalInput {
  __typename?: 'DelegateApprovalInput';
  clientId: UUID;
  clientMutationId?: string | null;
  comment?: string | null;
  id: ID;
}

export interface DeactivateConferencingTeamSpaceClientSettingInput {
  __typename?: 'DeactivateConferencingTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
  service: AppointmentMeetingTypeEnum;
}

export interface DateWeekEnumFilterInput {
  __typename?: 'DateWeekEnumFilterInput';
  NOT?: DateWeekEnumFilterInput | null;
  eq?: DateWeekEnum[] | null;
}

export interface DateMonthEnumFilterInput {
  __typename?: 'DateMonthEnumFilterInput';
  NOT?: DateMonthEnumFilterInput | null;
  eq?: DateMonthEnum[] | null;
}

export interface DateDayOfWeekEnumFilterInput {
  __typename?: 'DateDayOfWeekEnumFilterInput';
  NOT?: DateDayOfWeekEnumFilterInput | null;
  eq?: DateDayOfWeekEnum[] | null;
}

export interface DateDayEnumFilterInput {
  __typename?: 'DateDayEnumFilterInput';
  NOT?: DateDayEnumFilterInput | null;
  eq?: DateDayEnum[] | null;
}

export interface DataSetValueParams {
  __typename?: 'DataSetValueParams';
  calcValue: number;
  id: string;
  optionName: string;
}

export interface DataOrderByNestedInput {
  __typename?: 'DataOrderByNestedInput';
  calcValue?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  optionName?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
}

export interface DataOrderByInput {
  __typename?: 'DataOrderByInput';
  calcValue?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  optionName?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
}

export interface DataFilterInput {
  __typename?: 'DataFilterInput';
  AND?: DataFilterInput[] | null;
  NOT?: DataFilterInput | null;
  OR?: DataFilterInput[] | null;
  calcValue?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  optionName?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
}

export interface DataCollection {
  __typename?: 'DataCollection';
  excludedIds: UUID[];
  includedIds: UUID[];
  sessionIds: string[];
}

export interface DashboardRoleParams {
  __typename?: 'DashboardRoleParams';
  isEnabled: boolean;
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface DashboardItemParams {
  __typename?: 'DashboardItemParams';
  chart: JSONString;
  color?: number | null;
  description?: string | null;
  descriptionUseLang: boolean;
  headerColor?: number | null;
  id: ID;
  name?: string | null;
  nameUseLang: boolean;
  position: RectangleParams;
}

export interface DashboardFilterParams {
  __typename?: 'DashboardFilterParams';
  isEnabled: boolean;
  ownerIds: ID[];
  unitIds: ID[];
}

export interface CustomRecaptcha {
  __typename?: 'CustomRecaptcha';
  secretKey: string;
  siteKey: string;
}

export interface CustomField {
  __typename?: 'CustomField';
  between?: number[] | null;
  contains?: string[] | null;
  empty?: boolean | null;
  ends?: string[] | null;
  eq?: string[] | null;
  field: string;
  gt?: number | null;
  gte?: number | null;
  icontains?: string[] | null;
  iends?: string[] | null;
  ieq?: string[] | null;
  istarts?: string[] | null;
  lt?: number | null;
  lte?: number | null;
  null?: boolean | null;
  starts?: string[] | null;
}

export interface CustomEntityUISettingsInput {
  __typename?: 'CustomEntityUISettingsInput';
  activitiesFilter?: ActivityTabDataGridViewOptionsParams | null;
  customEntityStaticProfiles?: UUID[] | null;
  detailCollapsed?: boolean | null;
  detailTabs?: InterfaceDetailUserTabParams[] | null;
  detailWidgets?: InterfaceDetailUserWidgetParams[] | null;
  documentsFilter?: CloudObjectTabDataGridViewOptionsParams | null;
  drilldownFilter?: CustomEntityDrilldownFilterParams | null;
  drilldownGridChanges?: GridHighlightChangesParams | null;
  drilldownGridColumns?: GridColumnsOutputParams[] | null;
  drilldownSortBy?: ID | null;
  drilldownSortOrder?: SortOrder | null;
  entityTypePriorities?: ID[] | null;
  gridChanges?: GridHighlightChangesParams | null;
  gridColumns?: GridColumnsOutputParams[] | null;
  importSettings?: ImportSettingsOptionsParams | null;
  lookupGridColumns?: GridColumnsOutputParams[] | null;
  lookupSortBy?: ID | null;
  lookupSortOrder?: SortOrder | null;
  notesFilter?: NoteTabDataGridViewOptionsParams | null;
  quickFilterOpen?: boolean | null;
  recentProcesses?: UUID[] | null;
  recentProfiles?: ID[] | null;
  useProfileColumns?: boolean | null;
}

export interface CustomEntityTypeOrderByNestedInput {
  __typename?: 'CustomEntityTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
}

export interface CustomEntityTypeOrderByInput {
  __typename?: 'CustomEntityTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
}

export interface CustomEntityTypeFilterInput {
  __typename?: 'CustomEntityTypeFilterInput';
  AND?: CustomEntityTypeFilterInput[] | null;
  NOT?: CustomEntityTypeFilterInput | null;
  OR?: CustomEntityTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
}

export interface CustomEntitySharingSalesUnitRelationOrderByInput {
  __typename?: 'CustomEntitySharingSalesUnitRelationOrderByInput';
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface CustomEntitySharingSalesUnitRelationFilterInput {
  __typename?: 'CustomEntitySharingSalesUnitRelationFilterInput';
  AND?: CustomEntitySharingSalesUnitRelationFilterInput[] | null;
  NOT?: CustomEntitySharingSalesUnitRelationFilterInput | null;
  OR?: CustomEntitySharingSalesUnitRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface CustomEntitySharingClientRelationOrderByInput {
  __typename?: 'CustomEntitySharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface CustomEntitySharingClientRelationFilterInput {
  __typename?: 'CustomEntitySharingClientRelationFilterInput';
  AND?: CustomEntitySharingClientRelationFilterInput[] | null;
  NOT?: CustomEntitySharingClientRelationFilterInput | null;
  OR?: CustomEntitySharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface CustomEntityRoleTabParams {
  __typename?: 'CustomEntityRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface CustomEntityRelationOrderByNestedInput {
  __typename?: 'CustomEntityRelationOrderByNestedInput';
  created?: OrderByEnum | null;
  field1Id?: OrderByEnum | null;
  field2Id?: OrderByEnum | null;
  hasIsPrimary?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  showRelated1?: OrderByEnum | null;
  showRelated2?: OrderByEnum | null;
  showTab1?: OrderByEnum | null;
  showTab2?: OrderByEnum | null;
  tabName1?: OrderByEnum | null;
  tabName2?: OrderByEnum | null;
}

export interface CustomEntityRelationOrderByInput {
  __typename?: 'CustomEntityRelationOrderByInput';
  created?: OrderByEnum | null;
  field1?: FieldOrderByNestedInput[] | null;
  field1Id?: OrderByEnum | null;
  field2?: FieldOrderByNestedInput[] | null;
  field2Id?: OrderByEnum | null;
  hasIsPrimary?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  showRelated1?: OrderByEnum | null;
  showRelated2?: OrderByEnum | null;
  showTab1?: OrderByEnum | null;
  showTab2?: OrderByEnum | null;
  tabName1?: OrderByEnum | null;
  tabName2?: OrderByEnum | null;
}

export interface CustomEntityRelationFilterInput {
  __typename?: 'CustomEntityRelationFilterInput';
  AND?: CustomEntityRelationFilterInput[] | null;
  NOT?: CustomEntityRelationFilterInput | null;
  OR?: CustomEntityRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  field1?: FieldFilterInput | null;
  field1Id?: EntityFilterStringField | null;
  field2?: FieldFilterInput | null;
  field2Id?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  hasIsPrimary?: boolean | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  showRelated1?: boolean | null;
  showRelated2?: boolean | null;
  showTab1?: boolean | null;
  showTab2?: boolean | null;
  tabName1?: EntityFilterStringField | null;
  tabName2?: EntityFilterStringField | null;
}

export interface CustomEntityRelationDataOrderByInput {
  __typename?: 'CustomEntityRelationDataOrderByInput';
  account1?: AccountOrderByNestedInput[] | null;
  account1Id?: OrderByEnum | null;
  account2?: AccountOrderByNestedInput[] | null;
  account2Id?: OrderByEnum | null;
  activity1Id?: OrderByEnum | null;
  activity2Id?: OrderByEnum | null;
  appointment1?: AppointmentOrderByNestedInput[] | null;
  appointment2?: AppointmentOrderByNestedInput[] | null;
  client1?: ClientOrderByNestedInput[] | null;
  client1Id?: OrderByEnum | null;
  client2?: ClientOrderByNestedInput[] | null;
  client2Id?: OrderByEnum | null;
  contact1?: ContactOrderByNestedInput[] | null;
  contact1Id?: OrderByEnum | null;
  contact2?: ContactOrderByNestedInput[] | null;
  contact2Id?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity1?: CustomEntityOrderByNestedInput[] | null;
  customEntity1Id?: OrderByEnum | null;
  customEntity2?: CustomEntityOrderByNestedInput[] | null;
  customEntity2Id?: OrderByEnum | null;
  customEntityRelation?: CustomEntityRelationOrderByNestedInput[] | null;
  customEntityRelationId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  lead1?: LeadOrderByNestedInput[] | null;
  lead2?: LeadOrderByNestedInput[] | null;
  leadOppty1Id?: OrderByEnum | null;
  leadOppty2Id?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty1?: OpportunityOrderByNestedInput[] | null;
  oppty2?: OpportunityOrderByNestedInput[] | null;
  opptyProductRelation1?: OpptyProductRelationOrderByNestedInput[] | null;
  opptyProductRelation1Id?: OrderByEnum | null;
  opptyProductRelation2?: OpptyProductRelationOrderByNestedInput[] | null;
  opptyProductRelation2Id?: OrderByEnum | null;
  product1?: ProductOrderByNestedInput[] | null;
  product1Id?: OrderByEnum | null;
  product2?: ProductOrderByNestedInput[] | null;
  product2Id?: OrderByEnum | null;
  project1?: ProjectOrderByNestedInput[] | null;
  project1Id?: OrderByEnum | null;
  project2?: ProjectOrderByNestedInput[] | null;
  project2Id?: OrderByEnum | null;
  quote1?: QuoteOrderByNestedInput[] | null;
  quote1Id?: OrderByEnum | null;
  quote2?: QuoteOrderByNestedInput[] | null;
  quote2Id?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task1?: TaskOrderByNestedInput[] | null;
  task2?: TaskOrderByNestedInput[] | null;
}

export interface CustomEntityRelationDataFilterInput {
  __typename?: 'CustomEntityRelationDataFilterInput';
  AND?: CustomEntityRelationDataFilterInput[] | null;
  NOT?: CustomEntityRelationDataFilterInput | null;
  OR?: CustomEntityRelationDataFilterInput[] | null;
  account1?: AccountFilterInput | null;
  account1Id?: EntityFilterStringField | null;
  account2?: AccountFilterInput | null;
  account2Id?: EntityFilterStringField | null;
  activity1Id?: EntityFilterStringField | null;
  activity2Id?: EntityFilterStringField | null;
  appointment1?: AppointmentFilterInput | null;
  appointment2?: AppointmentFilterInput | null;
  client1?: ClientFilterInput | null;
  client1Id?: EntityFilterStringField | null;
  client2?: ClientFilterInput | null;
  client2Id?: EntityFilterStringField | null;
  contact1?: ContactFilterInput | null;
  contact1Id?: EntityFilterStringField | null;
  contact2?: ContactFilterInput | null;
  contact2Id?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity1?: CustomEntityFilterInput | null;
  customEntity1Id?: EntityFilterStringField | null;
  customEntity2?: CustomEntityFilterInput | null;
  customEntity2Id?: EntityFilterStringField | null;
  customEntityRelation?: CustomEntityRelationFilterInput | null;
  customEntityRelationId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  lead1?: LeadFilterInput | null;
  lead2?: LeadFilterInput | null;
  leadOppty1Id?: EntityFilterStringField | null;
  leadOppty2Id?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty1?: OpportunityFilterInput | null;
  oppty2?: OpportunityFilterInput | null;
  opptyProductRelation1?: OpptyProductRelationFilterInput | null;
  opptyProductRelation1Id?: EntityFilterStringField | null;
  opptyProductRelation2?: OpptyProductRelationFilterInput | null;
  opptyProductRelation2Id?: EntityFilterStringField | null;
  product1?: ProductFilterInput | null;
  product1Id?: EntityFilterStringField | null;
  product2?: ProductFilterInput | null;
  product2Id?: EntityFilterStringField | null;
  project1?: ProjectFilterInput | null;
  project1Id?: EntityFilterStringField | null;
  project2?: ProjectFilterInput | null;
  project2Id?: EntityFilterStringField | null;
  quote1?: QuoteFilterInput | null;
  quote1Id?: EntityFilterStringField | null;
  quote2?: QuoteFilterInput | null;
  quote2Id?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  task1?: TaskFilterInput | null;
  task2?: TaskFilterInput | null;
}

export interface CustomEntityProfileDataInput {
  __typename?: 'CustomEntityProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: CustomEntityPreviewProfileParams;
}

export interface CustomEntityPreviewViewTabParams {
  __typename?: 'CustomEntityPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface CustomEntityPreviewProfileParams {
  __typename?: 'CustomEntityPreviewProfileParams';
  filter: CustomEntityFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: CustomEntityRoleTabParams;
  view: CustomEntityPreviewViewTabParams;
}

export interface CustomEntityOrderByNestedInput {
  __typename?: 'CustomEntityOrderByNestedInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  typeId?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface CustomEntityOrderByInput {
  __typename?: 'CustomEntityOrderByInput';
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  type?: CustomEntityTypeOrderByNestedInput[] | null;
  typeId?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface CustomEntityMasterRightParams {
  __typename?: 'CustomEntityMasterRightParams';
  accessCopy: boolean;
  accessDelete: boolean;
  accessDirection: AccessDirectionEnum;
  accessEntityTypes: AccessEntityTypesEnum;
  accessLevel: AccessLevelEntityEnum;
  accessPrivate: boolean;
  allowedEntityTypeIds: ID[];
  defaultProfileId: ID;
  entityApiName: string;
  navigationAccess: boolean;
}

export interface CustomEntityIDParams {
  __typename?: 'CustomEntityIDParams';
  entityApiName: string;
  id: UUID;
}

export interface CustomEntityFilterTabParams {
  __typename?: 'CustomEntityFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface CustomEntityFilterInput {
  __typename?: 'CustomEntityFilterInput';
  AND?: CustomEntityFilterInput[] | null;
  NOT?: CustomEntityFilterInput | null;
  OR?: CustomEntityFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: CustomEntitySharingClientRelationFilterInput | null;
  sharingUnits?: CustomEntitySharingSalesUnitRelationFilterInput | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  tableName?: EntityFilterStringField | null;
  type?: CustomEntityTypeFilterInput | null;
  typeId?: EntityFilterStringField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface CustomEntityDrilldownFilterParams {
  __typename?: 'CustomEntityDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface CustomEntityDataExRelationOrderByInput {
  __typename?: 'CustomEntityDataExRelationOrderByInput';
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface CustomEntityDataExRelationFilterInput {
  __typename?: 'CustomEntityDataExRelationFilterInput';
  AND?: CustomEntityDataExRelationFilterInput[] | null;
  NOT?: CustomEntityDataExRelationFilterInput | null;
  OR?: CustomEntityDataExRelationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface CustomEntityApiAccessPermissionInput {
  __typename?: 'CustomEntityApiAccessPermissionInput';
  access: ApiPermissionEnum;
  entityApiName: string;
}

export interface CustomEntitiesNotificationSettingParams {
  __typename?: 'CustomEntitiesNotificationSettingParams';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
  entityApiName: string;
}

export interface CurrencyOrderByNestedInput {
  __typename?: 'CurrencyOrderByNestedInput';
  code?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isBase?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  symbol?: OrderByEnum | null;
}

export interface CurrencyOrderByInput {
  __typename?: 'CurrencyOrderByInput';
  code?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isBase?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  symbol?: OrderByEnum | null;
}

export interface CurrencyForeignFieldInput {
  __typename?: 'CurrencyForeignFieldInput';
  baseValue?: number | null;
  currencyId: ID;
  valueForeign?: number | null;
}

export interface CurrencyFilterInput {
  __typename?: 'CurrencyFilterInput';
  AND?: CurrencyFilterInput[] | null;
  NOT?: CurrencyFilterInput | null;
  OR?: CurrencyFilterInput[] | null;
  code?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRates?: CurrencyExchangeRateFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isBase?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  symbol?: EntityFilterStringField | null;
}

export interface CurrencyExchangeRatesListOrderByNestedInput {
  __typename?: 'CurrencyExchangeRatesListOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  validFrom?: OrderByEnum | null;
}

export interface CurrencyExchangeRatesListOrderByInput {
  __typename?: 'CurrencyExchangeRatesListOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  validFrom?: OrderByEnum | null;
}

export interface CurrencyExchangeRatesListFilterInput {
  __typename?: 'CurrencyExchangeRatesListFilterInput';
  AND?: CurrencyExchangeRatesListFilterInput[] | null;
  NOT?: CurrencyExchangeRatesListFilterInput | null;
  OR?: CurrencyExchangeRatesListFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRates?: CurrencyExchangeRateFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  validFrom?: EntityFilterDateTimeField | null;
}

export interface CurrencyExchangeRateOrderByInput {
  __typename?: 'CurrencyExchangeRateOrderByInput';
  created?: OrderByEnum | null;
  currency?: CurrencyOrderByNestedInput[] | null;
  currencyExchangeRateList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRateListId?: OrderByEnum | null;
  currencyId?: OrderByEnum | null;
  exchangeRate?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface CurrencyExchangeRateFilterInput {
  __typename?: 'CurrencyExchangeRateFilterInput';
  AND?: CurrencyExchangeRateFilterInput[] | null;
  NOT?: CurrencyExchangeRateFilterInput | null;
  OR?: CurrencyExchangeRateFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  currency?: CurrencyFilterInput | null;
  currencyExchangeRateList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRateListId?: EntityFilterStringField | null;
  currencyId?: EntityFilterStringField | null;
  exchangeRate?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface CsvOptionsParams {
  __typename?: 'CsvOptionsParams';
  delimiter?: CsvDelimiter | null;
  encoding?: string | null;
  includeForeignCurrency?: boolean | null;
  quotechar?: CsvQuotechar | null;
}

export interface CreateZoomMeetingInput {
  __typename?: 'CreateZoomMeetingInput';
  clientMutationId?: string | null;
}

export interface CreateWebhookInput {
  __typename?: 'CreateWebhookInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  events: EventEnum[];
  insecureSsl: boolean;
  modified?: DateTime | null;
  options?: JSONString | null;
  signature?: ID | null;
  url: string;
}

export interface CreateWebhookEventInput {
  __typename?: 'CreateWebhookEventInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  event: EventEnum;
  modified?: DateTime | null;
  webhookId: ID;
}

export interface CreateUnsubscribedPhoneInput {
  __typename?: 'CreateUnsubscribedPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  phone?: string | null;
  revision?: number | null;
}

export interface CreateTimeframeInput {
  __typename?: 'CreateTimeframeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  leadOpptyId: ID;
  modified?: DateTime | null;
  stepId: ID;
  timeframe: number;
}

export interface CreateTextMessageNoTextMessageConversationBackrefInput {
  __typename?: 'CreateTextMessageNoTextMessageConversationBackrefInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  chatConversationId?: ID | null;
  content: string;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction: EmailDirectionEnum;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
}

export interface CreateTextMessageNoChatConversationBackrefInput {
  __typename?: 'CreateTextMessageNoChatConversationBackrefInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  content: string;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction: EmailDirectionEnum;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
  textMessageConversationId?: ID | null;
}

export interface CreateTextMessageInput {
  __typename?: 'CreateTextMessageInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  chatConversationId?: ID | null;
  clientMutationId?: string | null;
  content: string;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction: EmailDirectionEnum;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
  textMessageConversationId?: ID | null;
}

export interface CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput {
  __typename?: 'CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateTextMessageConversationRelationsInput {
  __typename?: 'CreateTextMessageConversationRelationsInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  textMessageConversationId: ID;
}

export interface CreateTextMessageConversationInput {
  __typename?: 'CreateTextMessageConversationInput';
  accountRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  created?: DateTime | null;
  leadRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  messages?: CreateTextMessageNoTextMessageConversationBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  phoneId: ID;
  projectRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  quoteRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  recipientAccountId?: ID | null;
  recipientContactId?: ID | null;
  recipientPhoneNumber?: string | null;
  revision?: number | null;
}

export interface CreateTaskSharingSalesUnitRelationNoTaskBackrefInput {
  __typename?: 'CreateTaskSharingSalesUnitRelationNoTaskBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateTaskSharingSalesUnitRelationInput {
  __typename?: 'CreateTaskSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId: ID;
  unitId: ID;
}

export interface CreateTaskSharingClientRelationNoTaskBackrefInput {
  __typename?: 'CreateTaskSharingClientRelationNoTaskBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateTaskSharingClientRelationInput {
  __typename?: 'CreateTaskSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId: ID;
}

export interface CreateTaskReminderNoTaskBackrefInput {
  __typename?: 'CreateTaskReminderNoTaskBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  setDate: DateTime;
  status?: ReminderStatusEnum | null;
}

export interface CreateTaskReminderInput {
  __typename?: 'CreateTaskReminderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  setDate: DateTime;
  status?: ReminderStatusEnum | null;
  taskId: ID;
}

export interface CreateTaskRecurrenceNoTaskBackrefInput {
  __typename?: 'CreateTaskRecurrenceNoTaskBackrefInput';
  applyRecurrence?: boolean | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate: GqlDate;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateTaskRecurrenceInput {
  __typename?: 'CreateTaskRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate: GqlDate;
  taskId: ID;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateTaskInput {
  __typename?: 'CreateTaskInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  callDuration?: number | null;
  callId?: ID | null;
  callOutcomeId?: ID | null;
  callSid?: string | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  dueDate?: GqlDate | null;
  duration?: number | null;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  mediaTranscriptionId?: UUID | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  ownerId?: ID | null;
  priority?: PriorityEnum | null;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  reminder?: CreateTaskReminderNoTaskBackrefInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateTaskSharingClientRelationNoTaskBackrefInput[] | null;
  sharingUnits?: CreateTaskSharingSalesUnitRelationNoTaskBackrefInput[] | null;
  startDate?: GqlDate | null;
  status?: TaskStatusEnum | null;
  subject: string;
  tags?: CreateTagRelationNoTaskBackrefInput[] | null;
  taskRecurrence?: CreateTaskRecurrenceNoTaskBackrefInput | null;
  unitId?: ID | null;
}

export interface CreateTargetRelationNoGroupTargetBackrefInput {
  __typename?: 'CreateTargetRelationNoGroupTargetBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  userTargetId: ID;
}

export interface CreateTargetRelationInput {
  __typename?: 'CreateTargetRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  groupTargetId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  userTargetId: ID;
}

export interface CreateTargetInput {
  __typename?: 'CreateTargetInput';
  calculationType: TargetCalculationTypeEnum;
  currencyId: UUID;
  description?: string | null;
  existingTargetsIds?: UUID[] | null;
  filter?: FieldFilterParams | null;
  fromSimulatedTargetId?: UUID | null;
  isActive: boolean;
  name: string;
  ownerId?: UUID | null;
  period: TargetsPeriodParams;
  pipelineLeadProcessId?: UUID | null;
  simulatedIndicators?: SimulatedTargetIndicatorsParams | null;
  targetClientIds?: UUID[] | null;
  targetClientTargetValues?: number[] | null;
  targetType: TargetTypeEnum;
  targetValue?: number | null;
}

export interface CreateTagRelationNoTaskBackrefInput {
  __typename?: 'CreateTagRelationNoTaskBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
}

export interface CreateTagRelationNoProjectBackrefInput {
  __typename?: 'CreateTagRelationNoProjectBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoProcessBackrefInput {
  __typename?: 'CreateTagRelationNoProcessBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoOpptyBackrefInput {
  __typename?: 'CreateTagRelationNoOpptyBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoLeadBackrefInput {
  __typename?: 'CreateTagRelationNoLeadBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoEmailBackrefInput {
  __typename?: 'CreateTagRelationNoEmailBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoContactBackrefInput {
  __typename?: 'CreateTagRelationNoContactBackrefInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoAppointmentBackrefInput {
  __typename?: 'CreateTagRelationNoAppointmentBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationNoAccountBackrefInput {
  __typename?: 'CreateTagRelationNoAccountBackrefInput';
  appointmentId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagRelationInput {
  __typename?: 'CreateTagRelationInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId: ID;
  taskId?: ID | null;
}

export interface CreateTagInput {
  __typename?: 'CreateTagInput';
  allowedEntityTypeIds?: JSONString | null;
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  creatorId?: ID | null;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  supportedEntities?: number | null;
  useLang?: boolean | null;
}

export interface CreateStepNoQuoteProcessBackrefInput {
  __typename?: 'CreateStepNoQuoteProcessBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name: string;
  percent?: number | null;
  pipelineId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateStepNoPipelineBackrefInput {
  __typename?: 'CreateStepNoPipelineBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name: string;
  percent?: number | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateStepNoLeadProcessBackrefInput {
  __typename?: 'CreateStepNoLeadProcessBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  modified?: DateTime | null;
  name: string;
  percent?: number | null;
  pipelineId?: ID | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateStepInput {
  __typename?: 'CreateStepInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name: string;
  percent?: number | null;
  pipelineId?: ID | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput {
  __typename?: 'CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
}

export interface CreateStepChecklistSalesRoleRelationInput {
  __typename?: 'CreateStepChecklistSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
  stepChecklistId: ID;
}

export interface CreateStepChecklistNoStepBackrefInput {
  __typename?: 'CreateStepChecklistNoStepBackrefInput';
  activityTypeId?: ID | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate?: CreateCloudObjectTemplateInput | null;
  cloudObjectTemplateId?: ID | null;
  created?: DateTime | null;
  description?: string | null;
  emailSequenceId?: ID | null;
  fieldId?: ID | null;
  itemType?: StepChecklistTypeEnum | null;
  itemValidation?: StepChecklistValidationEnum | null;
  label?: string | null;
  labelUseLang?: boolean | null;
  modified?: DateTime | null;
  processId?: ID | null;
  revision?: number | null;
  salesRoles?: CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput[] | null;
  sendEmailFieldId?: ID | null;
  sendEmailTemplateId?: ID | null;
  visibilityCondition: StepChecklistVisibilityFilterJSONString;
  visibilityType?: StepChecklistVisibilityEnum | null;
}

export interface CreateStepChecklistInput {
  __typename?: 'CreateStepChecklistInput';
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate?: CreateCloudObjectTemplateInput | null;
  cloudObjectTemplateId?: ID | null;
  created?: DateTime | null;
  description?: string | null;
  emailSequenceId?: ID | null;
  fieldId?: ID | null;
  itemType?: StepChecklistTypeEnum | null;
  itemValidation?: StepChecklistValidationEnum | null;
  label?: string | null;
  labelUseLang?: boolean | null;
  modified?: DateTime | null;
  processId?: ID | null;
  revision?: number | null;
  salesRoles?: CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput[] | null;
  sendEmailFieldId?: ID | null;
  sendEmailTemplateId?: ID | null;
  stepId: ID;
  visibilityCondition: StepChecklistVisibilityFilterJSONString;
  visibilityType?: StepChecklistVisibilityEnum | null;
}

export interface CreateSalesUnitInput {
  __typename?: 'CreateSalesUnitInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  parentId?: ID | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  revision?: number | null;
}

export interface CreateSalesUnitClientRelationNoClientBackrefInput {
  __typename?: 'CreateSalesUnitClientRelationNoClientBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
  unitRole?: UnitRoleEnum | null;
}

export interface CreateSalesUnitClientRelationInput {
  __typename?: 'CreateSalesUnitClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
  unitRole?: UnitRoleEnum | null;
}

export interface CreateSalesRoleInput {
  __typename?: 'CreateSalesRoleInput';
  clientMutationId?: string | null;
  colorCode: number;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateReportSharingSalesUnitRelationNoReportBackrefInput {
  __typename?: 'CreateReportSharingSalesUnitRelationNoReportBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateReportSharingSalesUnitRelationInput {
  __typename?: 'CreateReportSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  reportId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateReportSharingClientRelationNoReportBackrefInput {
  __typename?: 'CreateReportSharingClientRelationNoReportBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateReportSharingClientRelationInput {
  __typename?: 'CreateReportSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  reportId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateReportScheduleNoReportBackrefInput {
  __typename?: 'CreateReportScheduleNoReportBackrefInput';
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  settings: ReportScheduleSchemaJSONString;
}

export interface CreateReportScheduleInput {
  __typename?: 'CreateReportScheduleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId: ID;
  reportId: ID;
  revision?: number | null;
  settings: ReportScheduleSchemaJSONString;
}

export interface CreateReportInput {
  __typename?: 'CreateReportInput';
  accessLink?: string | null;
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  reportsFolderId: ID;
  revision?: number | null;
  schedule?: CreateReportScheduleNoReportBackrefInput | null;
  settings: ReportSchemaJSONString;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharingClients?: CreateReportSharingClientRelationNoReportBackrefInput[] | null;
  sharingUnits?: CreateReportSharingSalesUnitRelationNoReportBackrefInput[] | null;
  type: ReportTypeEnum;
}

export interface CreateReportFolderInput {
  __typename?: 'CreateReportFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  parentReportFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput {
  __typename?: 'CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateQuoteSharingSalesUnitRelationInput {
  __typename?: 'CreateQuoteSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  quoteId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateQuoteSharingClientRelationNoQuoteBackrefInput {
  __typename?: 'CreateQuoteSharingClientRelationNoQuoteBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateQuoteSharingClientRelationInput {
  __typename?: 'CreateQuoteSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  quoteId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateQuoteProfileInput {
  __typename?: 'CreateQuoteProfileInput';
  clientMutationId?: string | null;
  data?: QuoteProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateQuoteProcessInput {
  __typename?: 'CreateQuoteProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  steps: CreateStepNoQuoteProcessBackrefInput[];
}

export interface CreateQuoteNoOpptyBackrefInput {
  __typename?: 'CreateQuoteNoOpptyBackrefInput';
  accountRelations?: CreateQuoteAccountRelationNoQuoteBackrefInput[] | null;
  contactRelations?: CreateQuoteContactRelationNoQuoteBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  expirationDate?: GqlDate | null;
  isActiveInOpportunity?: boolean | null;
  isArchived?: boolean | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteTypeId?: ID | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateQuoteSharingClientRelationNoQuoteBackrefInput[] | null;
  sharingUnits?: CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoQuoteBackrefInput[] | null;
  stepId: ID;
  totalAmount?: CurrencyForeignFieldInput | null;
  unitId?: ID | null;
  version?: number | null;
}

export interface CreateQuoteKPIInput {
  __typename?: 'CreateQuoteKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  kpi: QuoteKpiEnum;
  modified?: DateTime | null;
  ownerId: ID;
  quoteId: ID;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateQuoteInput {
  __typename?: 'CreateQuoteInput';
  accountRelations?: CreateQuoteAccountRelationNoQuoteBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateQuoteContactRelationNoQuoteBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  expirationDate?: GqlDate | null;
  isActiveInOpportunity?: boolean | null;
  isArchived?: boolean | null;
  modified?: DateTime | null;
  name: string;
  opptyId?: ID | null;
  ownerId: ID;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteTypeId?: ID | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateQuoteSharingClientRelationNoQuoteBackrefInput[] | null;
  sharingUnits?: CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoQuoteBackrefInput[] | null;
  stepId: ID;
  totalAmount?: CurrencyForeignFieldInput | null;
  unitId?: ID | null;
  version?: number | null;
}

export interface CreateQuoteDataExRelationInput {
  __typename?: 'CreateQuoteDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId: ID;
  dataSetId: ID;
  modified?: DateTime | null;
  quoteId: ID;
  revision?: number | null;
}

export interface CreateQuoteContactRelationNoQuoteBackrefInput {
  __typename?: 'CreateQuoteContactRelationNoQuoteBackrefInput';
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateQuoteContactRelationInput {
  __typename?: 'CreateQuoteContactRelationInput';
  clientMutationId?: string | null;
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  quoteId: ID;
  revision?: number | null;
}

export interface CreateQuoteArchiveProfileInput {
  __typename?: 'CreateQuoteArchiveProfileInput';
  clientMutationId?: string | null;
  data?: QuoteArchiveProfileDataInput | null;
  name: string;
}

export interface CreateQuoteAccountRelationNoQuoteBackrefInput {
  __typename?: 'CreateQuoteAccountRelationNoQuoteBackrefInput';
  accountId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateQuoteAccountRelationInput {
  __typename?: 'CreateQuoteAccountRelationInput';
  accountId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  quoteId: ID;
  revision?: number | null;
}

export interface CreateProjectSharingSalesUnitRelationNoProjectBackrefInput {
  __typename?: 'CreateProjectSharingSalesUnitRelationNoProjectBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateProjectSharingSalesUnitRelationInput {
  __typename?: 'CreateProjectSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  projectId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateProjectSharingClientRelationNoProjectBackrefInput {
  __typename?: 'CreateProjectSharingClientRelationNoProjectBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateProjectSharingClientRelationInput {
  __typename?: 'CreateProjectSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  projectId: ID;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateProjectProfileInput {
  __typename?: 'CreateProjectProfileInput';
  clientMutationId?: string | null;
  data?: ProjectProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateProjectObjectiveTaskInput {
  __typename?: 'CreateProjectObjectiveTaskInput';
  beforeId?: ID | null;
  clientMutationId?: string | null;
  entity: CreateTaskInput;
  objectiveId?: ID | null;
  projectId: ID;
  sessionIdToUpdate?: string | null;
}

export interface CreateProjectObjectiveInput {
  __typename?: 'CreateProjectObjectiveInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  projectId: ID;
  revision?: number | null;
  sortOrder: number;
}

export interface CreateProjectObjectiveAppointmentInput {
  __typename?: 'CreateProjectObjectiveAppointmentInput';
  beforeId?: ID | null;
  clientMutationId?: string | null;
  entity: CreateAppointmentInput;
  objectiveId?: ID | null;
  projectId: ID;
  sessionIdToUpdate?: string | null;
}

export interface CreateProjectKPIInput {
  __typename?: 'CreateProjectKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  kpi: ProjectKpiEnum;
  modified?: DateTime | null;
  ownerId: ID;
  projectId: ID;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateProjectInput {
  __typename?: 'CreateProjectInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactRelations?: CreateProjectContactRelationNoProjectBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  endDate: GqlDate;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  projectTypeId?: ID | null;
  revenueGoal?: CurrencyForeignFieldInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateProjectSharingClientRelationNoProjectBackrefInput[] | null;
  sharingUnits?: CreateProjectSharingSalesUnitRelationNoProjectBackrefInput[] | null;
  startDate?: GqlDate | null;
  staticProfiles?: CreateProfileRelationNoProjectBackrefInput[] | null;
  tags?: CreateTagRelationNoProjectBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateProjectContactRelationNoProjectBackrefInput {
  __typename?: 'CreateProjectContactRelationNoProjectBackrefInput';
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateProjectContactRelationInput {
  __typename?: 'CreateProjectContactRelationInput';
  clientMutationId?: string | null;
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  projectId: ID;
  revision?: number | null;
}

export interface CreateProfileSharingSalesUnitRelationInput {
  __typename?: 'CreateProfileSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  profileId: ID;
  revision?: number | null;
  unitId: ID;
}

export interface CreateProfileSharingClientRelationInput {
  __typename?: 'CreateProfileSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  profileId: ID;
  revision?: number | null;
}

export interface CreateProfileRelationNoQuoteBackrefInput {
  __typename?: 'CreateProfileRelationNoQuoteBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
}

export interface CreateProfileRelationNoProjectBackrefInput {
  __typename?: 'CreateProfileRelationNoProjectBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  quoteId?: ID | null;
}

export interface CreateProfileRelationNoLeadOpptyBackrefInput {
  __typename?: 'CreateProfileRelationNoLeadOpptyBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateProfileRelationNoCustomEntityBackrefInput {
  __typename?: 'CreateProfileRelationNoCustomEntityBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateProfileRelationNoContactBackrefInput {
  __typename?: 'CreateProfileRelationNoContactBackrefInput';
  accountId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateProfileRelationNoAccountBackrefInput {
  __typename?: 'CreateProfileRelationNoAccountBackrefInput';
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateProfileRelationInput {
  __typename?: 'CreateProfileRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateProfileInput {
  __typename?: 'CreateProfileInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entity: ScreenTypeEnum;
  entityApiName?: string | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  revision?: number | null;
  settings: JSONString;
  shareMode?: ShareModeEnum | null;
  type?: ProfileTypeEnum | null;
  useLang?: boolean | null;
}

export interface CreateProductPriceListPriceNoProductPriceListBackrefInput {
  __typename?: 'CreateProductPriceListPriceNoProductPriceListBackrefInput';
  created?: DateTime | null;
  currencyId: ID;
  modified?: DateTime | null;
  price?: number | null;
  productId: ID;
  revision?: number | null;
  settings: ProductPriceListPriceSettingsJSONString;
}

export interface CreateProductPriceListPriceInput {
  __typename?: 'CreateProductPriceListPriceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId: ID;
  modified?: DateTime | null;
  price?: number | null;
  productId: ID;
  productPriceListId: ID;
  revision?: number | null;
  settings: ProductPriceListPriceSettingsJSONString;
}

export interface CreateProductPriceListInput {
  __typename?: 'CreateProductPriceListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  endDate?: GqlDate | null;
  isActive?: boolean | null;
  modified?: DateTime | null;
  name: string;
  productPriceListPrices?: CreateProductPriceListPriceNoProductPriceListBackrefInput[] | null;
  revision?: number | null;
  rules?: JSONString | null;
  startDate?: GqlDate | null;
  type?: ProductPriceListTypeEnum | null;
}

export interface CreateProductPipelineRelationNoProductBackrefInput {
  __typename?: 'CreateProductPipelineRelationNoProductBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  pipelineId: ID;
  revision?: number | null;
}

export interface CreateProductPipelineRelationInput {
  __typename?: 'CreateProductPipelineRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  pipelineId: ID;
  productId: ID;
  revision?: number | null;
}

export interface CreateProductNoProductCategoryBackrefInput {
  __typename?: 'CreateProductNoProductCategoryBackrefInput';
  allowedPipelines?: AccessPipelinesEnum | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  modified?: DateTime | null;
  name: string;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  pictureSourceUrl?: string | null;
  productPipelineRelations?: CreateProductPipelineRelationNoProductBackrefInput[] | null;
  productPipelines?: ProductPipelinesInput | null;
  productTypeId?: ID | null;
  revision?: number | null;
  sku?: string | null;
  unitSymbol?: string | null;
}

export interface CreateProductInput {
  __typename?: 'CreateProductInput';
  allowedPipelines?: AccessPipelinesEnum | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  modified?: DateTime | null;
  name: string;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  pictureSourceUrl?: string | null;
  productCategoryId?: ID | null;
  productPipelineRelations?: CreateProductPipelineRelationNoProductBackrefInput[] | null;
  productPipelines?: ProductPipelinesInput | null;
  productTypeId?: ID | null;
  revision?: number | null;
  sku?: string | null;
  unitSymbol?: string | null;
}

export interface CreateProductCategoryInput {
  __typename?: 'CreateProductCategoryInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  parentId?: ID | null;
  productRelations?: CreateProductNoProductCategoryBackrefInput[] | null;
  revision?: number | null;
}

export interface CreateProcessTemplateInput {
  __typename?: 'CreateProcessTemplateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  isRecommended?: boolean | null;
  modified?: DateTime | null;
  name: string;
  settings: ProcessSchemaJSONString;
}

export interface CreateProcessInput {
  __typename?: 'CreateProcessInput';
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  settings?: ProcessSchemaJSONString | null;
  tags?: CreateTagRelationNoProcessBackrefInput[] | null;
  type: ProcessTypeEnum;
}

export interface CreateProcessFromTemplateInput {
  __typename?: 'CreateProcessFromTemplateInput';
  description: string;
  name: string;
  ownerId: ID;
  processTemplateId: ID;
  type: ProcessTypeEnum;
}

export interface CreateProcessActivityLogLineInput {
  __typename?: 'CreateProcessActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  processActivityLogId: ID;
  sortOrder: number;
  status?: ProcessStatusEnum | null;
}

export interface CreateProcessActivityLogInput {
  __typename?: 'CreateProcessActivityLogInput';
  actorId?: ID | null;
  applicationId: ID;
  clientMutationId?: string | null;
  cpuRunTime?: number | null;
  created?: DateTime | null;
  endTime?: DateTime | null;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  parentProcessIds?: JSONString | null;
  processId: ID;
  runId?: ID | null;
  startTime: DateTime;
  status: ProcessStatusEnum;
}

export interface CreatePipelineInput {
  __typename?: 'CreatePipelineInput';
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  steps: CreateStepNoPipelineBackrefInput[];
}

export interface CreatePhoneInput {
  __typename?: 'CreatePhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  enabled: boolean;
  errorCode?: number | null;
  modified?: DateTime | null;
  name: string;
  ownerId?: ID | null;
  phoneNumber?: string | null;
  revision?: number | null;
  twilioCallerSid?: string | null;
  type: PhoneTypeEnum;
}

export interface CreateParentAccountRelationTypeInput {
  __typename?: 'CreateParentAccountRelationTypeInput';
  childLabel: string;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  parentLabel: string;
  revision?: number | null;
}

export interface CreateOrUpdateWebhookInput {
  __typename?: 'CreateOrUpdateWebhookInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  events?: EventEnum[] | null;
  id?: ID | null;
  insecureSsl?: boolean | null;
  modified?: DateTime | null;
  options?: JSONString | null;
  signature?: ID | null;
  url?: string | null;
}

export interface CreateOrUpdateWebhookEventInput {
  __typename?: 'CreateOrUpdateWebhookEventInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  event?: EventEnum | null;
  id?: ID | null;
  modified?: DateTime | null;
  webhookId?: ID | null;
}

export interface CreateOrUpdateUnsubscribedPhoneInput {
  __typename?: 'CreateOrUpdateUnsubscribedPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  phone?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateTimeframeInput {
  __typename?: 'CreateOrUpdateTimeframeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  stepId?: ID | null;
  timeframe?: number | null;
}

export interface CreateOrUpdateTextMessageNoTextMessageConversationBackrefInput {
  __typename?: 'CreateOrUpdateTextMessageNoTextMessageConversationBackrefInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  chatConversationId?: ID | null;
  content?: string | null;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  id?: ID | null;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
}

export interface CreateOrUpdateTextMessageNoChatConversationBackrefInput {
  __typename?: 'CreateOrUpdateTextMessageNoChatConversationBackrefInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  content?: string | null;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  id?: ID | null;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
  textMessageConversationId?: ID | null;
}

export interface CreateOrUpdateTextMessageInput {
  __typename?: 'CreateOrUpdateTextMessageInput';
  attachments?: CreateCloudObjectRelationNoBackrefInput[] | null;
  chatConversationId?: ID | null;
  clientMutationId?: string | null;
  content?: string | null;
  created?: DateTime | null;
  datetimeSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  id?: ID | null;
  messageSid?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
  score?: number | null;
  status?: TextMessageStatusEnum | null;
  textMessageConversationId?: ID | null;
}

export interface CreateOrUpdateTextMessageConversationRelationsInput {
  __typename?: 'CreateOrUpdateTextMessageConversationRelationsInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  textMessageConversationId?: ID | null;
}

export interface CreateOrUpdateTextMessageConversationInput {
  __typename?: 'CreateOrUpdateTextMessageConversationInput';
  accountRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  created?: DateTime | null;
  id?: ID | null;
  leadRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  messages?: CreateOrUpdateTextMessageNoTextMessageConversationBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  phoneId?: ID | null;
  projectRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  quoteRelations?: CreateTextMessageConversationRelationsNoTextMessageConversationBackrefInput[] | null;
  recipientAccountId?: ID | null;
  recipientContactId?: ID | null;
  recipientPhoneNumber?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateTeamSpaceClientSettingInput {
  __typename?: 'CreateOrUpdateTeamSpaceClientSettingInput';
  calling?: JSONString | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dropbox?: DropboxSettingsInput | null;
  emailAliases?: string | null;
  emailAutomatizerEnabled?: boolean | null;
  emailAutomatizerOwnerAccountEnabled?: boolean | null;
  emailAutomatizerUserAccountEnabled?: boolean | null;
  emailConf?: EmailConfFieldInput | null;
  emailDefaultContentSharingMode?: ContentShareModeEnum | null;
  emailEmailSequenceEnabled?: boolean | null;
  emailEmailSequenceOwnerAccountEnabled?: boolean | null;
  emailEmailSequenceUserAccountEnabled?: boolean | null;
  emailFetchSettings?: number | null;
  emailImapFolder1?: string | null;
  emailImapFolder2?: string | null;
  emailIntegration?: EmailIntegrationEnum | null;
  emailMassEmailClientIds?: ID[] | null;
  emailMassEmailEnabled?: boolean | null;
  emailNotificationsSettings?: NotificationSettingsParams | null;
  googleDrive?: GoogleDriveSettingsInput | null;
  id?: ID | null;
  microsoftOneDrive?: MicrosoftOneDriveSettingsInput | null;
  microsoftSharePoint?: MicrosoftOneDriveSettingsInput | null;
  modified?: DateTime | null;
  pandaDocIsEnabled?: boolean | null;
}

export interface CreateOrUpdateTeamPipelineHubItemInput {
  __typename?: 'CreateOrUpdateTeamPipelineHubItemInput';
  clientMutationId?: string | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  teamSpaceId?: ID | null;
}

export interface CreateOrUpdateTaskSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateTaskSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId?: ID | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateTaskSharingClientRelationInput {
  __typename?: 'CreateOrUpdateTaskSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  taskId?: ID | null;
}

export interface CreateOrUpdateTaskReminderInput {
  __typename?: 'CreateOrUpdateTaskReminderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  setDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
  taskId?: ID | null;
}

export interface CreateOrUpdateTaskRecurrenceInput {
  __typename?: 'CreateOrUpdateTaskRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  id?: ID | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  taskId?: ID | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateOrUpdateTaskInput {
  __typename?: 'CreateOrUpdateTaskInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  callDuration?: number | null;
  callId?: ID | null;
  callOutcomeId?: ID | null;
  callSid?: string | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  dueDate?: GqlDate | null;
  duration?: number | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  id?: ID | null;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  mediaTranscriptionId?: UUID | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  ownerId?: ID | null;
  priority?: PriorityEnum | null;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  reminder?: UpdateTaskReminderNoTaskBackrefInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateTaskSharingClientRelationNoTaskBackrefInput[] | null;
  sharingUnits?: CreateTaskSharingSalesUnitRelationNoTaskBackrefInput[] | null;
  startDate?: GqlDate | null;
  status?: TaskStatusEnum | null;
  subject?: string | null;
  tags?: CreateTagRelationNoTaskBackrefInput[] | null;
  taskRecurrence?: UpdateTaskRecurrenceNoTaskBackrefInput | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateTargetRelationInput {
  __typename?: 'CreateOrUpdateTargetRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  groupTargetId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  userTargetId?: ID | null;
}

export interface CreateOrUpdateTargetInput {
  __typename?: 'CreateOrUpdateTargetInput';
  calculationType?: TargetCalculationTypeEnum | null;
  childTargets?: CreateTargetRelationNoGroupTargetBackrefInput[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId?: ID | null;
  description?: string | null;
  id?: ID | null;
  isActive?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  periodFrom?: GqlDate | null;
  periodTo?: GqlDate | null;
  revision?: number | null;
  targetClientId?: ID | null;
  type?: TargetTypeEnum | null;
}

export interface CreateOrUpdateTagRelationInput {
  __typename?: 'CreateOrUpdateTagRelationInput';
  accountId?: ID | null;
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  processId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  tagId?: ID | null;
  taskId?: ID | null;
}

export interface CreateOrUpdateTagInput {
  __typename?: 'CreateOrUpdateTagInput';
  allowedEntityTypeIds?: JSONString | null;
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  supportedEntities?: number | null;
  useLang?: boolean | null;
}

export interface CreateOrUpdateStepNoQuoteProcessBackrefInput {
  __typename?: 'CreateOrUpdateStepNoQuoteProcessBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id?: ID | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  percent?: number | null;
  pipelineId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateOrUpdateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateOrUpdateStepNoPipelineBackrefInput {
  __typename?: 'CreateOrUpdateStepNoPipelineBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id?: ID | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  percent?: number | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateOrUpdateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateOrUpdateStepNoLeadProcessBackrefInput {
  __typename?: 'CreateOrUpdateStepNoLeadProcessBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  percent?: number | null;
  pipelineId?: ID | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateOrUpdateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateOrUpdateStepInput {
  __typename?: 'CreateOrUpdateStepInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput[] | null;
  hasReadonlyForm?: boolean | null;
  hasVersionIncrement?: boolean | null;
  id?: ID | null;
  leadProcessId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  percent?: number | null;
  pipelineId?: ID | null;
  quoteProcessId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepChecklists?: CreateOrUpdateStepChecklistNoStepBackrefInput[] | null;
  timeframe?: number | null;
}

export interface CreateOrUpdateStepChecklistSalesRoleRelationInput {
  __typename?: 'CreateOrUpdateStepChecklistSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
  stepChecklistId?: ID | null;
}

export interface CreateOrUpdateStepChecklistNoStepBackrefInput {
  __typename?: 'CreateOrUpdateStepChecklistNoStepBackrefInput';
  activityTypeId?: ID | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate?: CreateCloudObjectTemplateInput | null;
  cloudObjectTemplateId?: ID | null;
  created?: DateTime | null;
  description?: string | null;
  emailSequenceId?: ID | null;
  fieldId?: ID | null;
  id?: ID | null;
  itemType?: StepChecklistTypeEnum | null;
  itemValidation?: StepChecklistValidationEnum | null;
  label?: string | null;
  labelUseLang?: boolean | null;
  modified?: DateTime | null;
  processId?: ID | null;
  revision?: number | null;
  salesRoles?: CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput[] | null;
  sendEmailFieldId?: ID | null;
  sendEmailTemplateId?: ID | null;
  visibilityCondition?: StepChecklistVisibilityFilterJSONString | null;
  visibilityType?: StepChecklistVisibilityEnum | null;
}

export interface CreateOrUpdateStepChecklistInput {
  __typename?: 'CreateOrUpdateStepChecklistInput';
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  cloudObjectFormat?: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate?: CreateCloudObjectTemplateInput | null;
  cloudObjectTemplateId?: ID | null;
  created?: DateTime | null;
  description?: string | null;
  emailSequenceId?: ID | null;
  fieldId?: ID | null;
  id?: ID | null;
  itemType?: StepChecklistTypeEnum | null;
  itemValidation?: StepChecklistValidationEnum | null;
  label?: string | null;
  labelUseLang?: boolean | null;
  modified?: DateTime | null;
  processId?: ID | null;
  revision?: number | null;
  salesRoles?: CreateStepChecklistSalesRoleRelationNoStepChecklistBackrefInput[] | null;
  sendEmailFieldId?: ID | null;
  sendEmailTemplateId?: ID | null;
  stepId?: ID | null;
  visibilityCondition?: StepChecklistVisibilityFilterJSONString | null;
  visibilityType?: StepChecklistVisibilityEnum | null;
}

export interface CreateOrUpdateSalesUnitInput {
  __typename?: 'CreateOrUpdateSalesUnitInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  parentId?: ID | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateSalesRoleInput {
  __typename?: 'CreateOrUpdateSalesRoleInput';
  clientMutationId?: string | null;
  colorCode?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateReportSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateReportSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  reportId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateReportSharingClientRelationInput {
  __typename?: 'CreateOrUpdateReportSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  reportId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateReportScheduleInput {
  __typename?: 'CreateOrUpdateReportScheduleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
  settings?: ReportScheduleSchemaJSONString | null;
}

export interface CreateOrUpdateReportInput {
  __typename?: 'CreateOrUpdateReportInput';
  accessLink?: string | null;
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  reportsFolderId?: ID | null;
  revision?: number | null;
  schedule?: UpdateReportScheduleNoReportBackrefInput | null;
  settings?: ReportSchemaJSONString | null;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharingClients?: CreateReportSharingClientRelationNoReportBackrefInput[] | null;
  sharingUnits?: CreateReportSharingSalesUnitRelationNoReportBackrefInput[] | null;
  syncEnabled?: boolean | null;
  type?: ReportTypeEnum | null;
}

export interface CreateOrUpdateReportFolderInput {
  __typename?: 'CreateOrUpdateReportFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  parentReportFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateQuoteSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateQuoteSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateQuoteSharingClientRelationInput {
  __typename?: 'CreateOrUpdateQuoteSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateQuoteProcessInput {
  __typename?: 'CreateOrUpdateQuoteProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoQuoteProcessBackrefInput[] | null;
}

export interface CreateOrUpdateQuoteKPIInput {
  __typename?: 'CreateOrUpdateQuoteKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: QuoteKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateQuoteInput {
  __typename?: 'CreateOrUpdateQuoteInput';
  accountRelations?: CreateQuoteAccountRelationNoQuoteBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateQuoteContactRelationNoQuoteBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  expirationDate?: GqlDate | null;
  id?: ID | null;
  isActiveInOpportunity?: boolean | null;
  isArchived?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyId?: ID | null;
  ownerId?: ID | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOrUpdateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteTypeId?: ID | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateQuoteSharingClientRelationNoQuoteBackrefInput[] | null;
  sharingUnits?: CreateQuoteSharingSalesUnitRelationNoQuoteBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoQuoteBackrefInput[] | null;
  stepId?: ID | null;
  totalAmount?: CurrencyForeignFieldInput | null;
  unitId?: ID | null;
  version?: number | null;
}

export interface CreateOrUpdateQuoteDataExRelationInput {
  __typename?: 'CreateOrUpdateQuoteDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateQuoteContactRelationInput {
  __typename?: 'CreateOrUpdateQuoteContactRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateQuoteAccountRelationInput {
  __typename?: 'CreateOrUpdateQuoteAccountRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateProjectSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateProjectSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateProjectSharingClientRelationInput {
  __typename?: 'CreateOrUpdateProjectSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateProjectObjectiveInput {
  __typename?: 'CreateOrUpdateProjectObjectiveInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  projectId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateOrUpdateProjectKPIInput {
  __typename?: 'CreateOrUpdateProjectKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: ProjectKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  projectId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateProjectInput {
  __typename?: 'CreateOrUpdateProjectInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactRelations?: CreateProjectContactRelationNoProjectBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  endDate?: GqlDate | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  projectTypeId?: ID | null;
  revenueGoal?: CurrencyForeignFieldInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateProjectSharingClientRelationNoProjectBackrefInput[] | null;
  sharingUnits?: CreateProjectSharingSalesUnitRelationNoProjectBackrefInput[] | null;
  startDate?: GqlDate | null;
  staticProfiles?: CreateProfileRelationNoProjectBackrefInput[] | null;
  tags?: CreateTagRelationNoProjectBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateProjectContactRelationInput {
  __typename?: 'CreateOrUpdateProjectContactRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateProfileSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateProfileSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  profileId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateProfileSharingClientRelationInput {
  __typename?: 'CreateOrUpdateProfileSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  profileId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateProfileRelationInput {
  __typename?: 'CreateOrUpdateProfileRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
}

export interface CreateOrUpdateProfileInput {
  __typename?: 'CreateOrUpdateProfileInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entity?: ScreenTypeEnum | null;
  entityApiName?: string | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  settings?: JSONString | null;
  shareMode?: ShareModeEnum | null;
  syncEnabled?: boolean | null;
  type?: ProfileTypeEnum | null;
  useLang?: boolean | null;
}

export interface CreateOrUpdateProductPriceListPriceInput {
  __typename?: 'CreateOrUpdateProductPriceListPriceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  price?: number | null;
  productId?: ID | null;
  productPriceListId?: ID | null;
  revision?: number | null;
  settings?: ProductPriceListPriceSettingsJSONString | null;
}

export interface CreateOrUpdateProductPriceListInput {
  __typename?: 'CreateOrUpdateProductPriceListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  endDate?: GqlDate | null;
  id?: ID | null;
  isActive?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  productPriceListPrices?: CreateProductPriceListPriceNoProductPriceListBackrefInput[] | null;
  revision?: number | null;
  rules?: JSONString | null;
  startDate?: GqlDate | null;
  type?: ProductPriceListTypeEnum | null;
}

export interface CreateOrUpdateProductPipelineRelationInput {
  __typename?: 'CreateOrUpdateProductPipelineRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  pipelineId?: ID | null;
  productId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateProductInput {
  __typename?: 'CreateOrUpdateProductInput';
  allowedPipelines?: AccessPipelinesEnum | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  pictureSourceUrl?: string | null;
  productCategoryId?: ID | null;
  productPipelineRelations?: CreateProductPipelineRelationNoProductBackrefInput[] | null;
  productPipelines?: ProductPipelinesInput | null;
  productTypeId?: ID | null;
  revision?: number | null;
  sku?: string | null;
  unitSymbol?: string | null;
}

export interface CreateOrUpdateProductCategoryInput {
  __typename?: 'CreateOrUpdateProductCategoryInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  parentId?: ID | null;
  productRelations?: CreateProductNoProductCategoryBackrefInput[] | null;
  revision?: number | null;
}

export interface CreateOrUpdateProcessTemplateInput {
  __typename?: 'CreateOrUpdateProcessTemplateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  isRecommended?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  settings?: ProcessSchemaJSONString | null;
}

export interface CreateOrUpdateProcessInput {
  __typename?: 'CreateOrUpdateProcessInput';
  aiConversation?: AiConversationItemParams[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: ProcessSchemaJSONString | null;
  tags?: CreateTagRelationNoProcessBackrefInput[] | null;
  type?: ProcessTypeEnum | null;
}

export interface CreateOrUpdateProcessActivityLogLineInput {
  __typename?: 'CreateOrUpdateProcessActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  id?: ID | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  processActivityLogId?: ID | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateProcessActivityLogInput {
  __typename?: 'CreateOrUpdateProcessActivityLogInput';
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  cpuRunTime?: number | null;
  created?: DateTime | null;
  endTime?: DateTime | null;
  id?: ID | null;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  parentProcessIds?: JSONString | null;
  processId?: ID | null;
  runId?: ID | null;
  startTime?: DateTime | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdatePipelineInput {
  __typename?: 'CreateOrUpdatePipelineInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoPipelineBackrefInput[] | null;
}

export interface CreateOrUpdatePhoneInput {
  __typename?: 'CreateOrUpdatePhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  enabled?: boolean | null;
  errorCode?: number | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  phoneNumber?: string | null;
  revision?: number | null;
  twilioCallerSid?: string | null;
  type?: PhoneTypeEnum | null;
}

export interface CreateOrUpdateParentAccountRelationTypeInput {
  __typename?: 'CreateOrUpdateParentAccountRelationTypeInput';
  childLabel?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  parentLabel?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateOpptyRevenueSchedulePeriodInput {
  __typename?: 'CreateOrUpdateOpptyRevenueSchedulePeriodInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  date?: GqlDate | null;
  id?: ID | null;
  modified?: DateTime | null;
  opptyRevenueSchedule?: CreateOpptyRevenueScheduleInput | null;
  opptyRevenueScheduleId?: ID | null;
  revision?: number | null;
  transactionId?: ID | null;
  value?: number | null;
}

export interface CreateOrUpdateOpptyRevenueScheduleInput {
  __typename?: 'CreateOrUpdateOpptyRevenueScheduleInput';
  cancelationDate?: GqlDate | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOrUpdateOpptyRecurrenceInput {
  __typename?: 'CreateOrUpdateOpptyRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  condition?: number | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  id?: ID | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  opptyId?: ID | null;
  revision?: number | null;
  startDate?: GqlDate | null;
  stepId?: ID | null;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateOrUpdateOpptyProductRelationRevenueSchedulePeriodInput {
  __typename?: 'CreateOrUpdateOpptyProductRelationRevenueSchedulePeriodInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  date?: GqlDate | null;
  id?: ID | null;
  modified?: DateTime | null;
  opptyProductRelationRevenueSchedule?: CreateOpptyProductRelationRevenueScheduleInput | null;
  opptyProductRelationRevenueScheduleId?: ID | null;
  revision?: number | null;
  transactionId?: ID | null;
  value?: number | null;
}

export interface CreateOrUpdateOpptyProductRelationRevenueScheduleInput {
  __typename?: 'CreateOrUpdateOpptyProductRelationRevenueScheduleInput';
  cancelationDate?: GqlDate | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOrUpdateOpptyProductRelationNoBackrefInput {
  __typename?: 'CreateOrUpdateOpptyProductRelationNoBackrefInput';
  amount?: number | null;
  comment?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  id?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  opptyProductRelationTypeId?: ID | null;
  pairedOpptyProductRelation?: CreateOpptyProductRelationInput | null;
  pairedOpptyProductRelationId?: ID | null;
  price?: number | null;
  productId?: ID | null;
  quantity?: number | null;
  revenueSchedule?: UpdateOpptyProductRelationRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  sectionId?: ID | null;
  sortOrder?: number | null;
}

export interface CreateOrUpdateOpptyProductRelationInput {
  __typename?: 'CreateOrUpdateOpptyProductRelationInput';
  amount?: number | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  id?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  opptyId?: ID | null;
  opptyProductRelationTypeId?: ID | null;
  pairedOpptyProductRelation?: CreateOpptyProductRelationInput | null;
  pairedOpptyProductRelationId?: ID | null;
  price?: number | null;
  productId?: ID | null;
  quantity?: number | null;
  quoteId?: ID | null;
  revenueSchedule?: UpdateOpptyProductRelationRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  sectionId?: ID | null;
  sortOrder?: number | null;
}

export interface CreateOrUpdateOpptyProductRelationDataExRelationInput {
  __typename?: 'CreateOrUpdateOpptyProductRelationDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation?: CreateOpptyProductRelationInput | null;
  opptyProductRelationId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateOpportunityInput {
  __typename?: 'CreateOrUpdateOpportunityInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  activeQuoteId?: ID | null;
  clientMutationId?: string | null;
  closingDate?: GqlDate | null;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  isArchived?: boolean | null;
  isValueAutoCalculate?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyRecurrence?: UpdateOpptyRecurrenceNoOpptyBackrefInput | null;
  opptyTypeId?: ID | null;
  ownerId?: ID | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOrUpdateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteRelations?: CreateQuoteNoOpptyBackrefInput[] | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revenueSchedule?: UpdateOpptyRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId?: ID | null;
  tags?: CreateTagRelationNoOpptyBackrefInput[] | null;
  unitId?: ID | null;
  value?: CurrencyForeignFieldInput | null;
  wasQualified?: boolean | null;
  wonDate?: DateTime | null;
}

export interface CreateOrUpdateOnlineFormTypeInput {
  __typename?: 'CreateOrUpdateOnlineFormTypeInput';
  autoPrefillWithJavascript?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customRecaptcha?: CustomRecaptcha | null;
  description?: string | null;
  entityApiName?: string | null;
  entityType?: BaseEntityTypeEnum | null;
  formEdit?: JSONString | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  isReadonly?: boolean | null;
  lastSchemaChange?: DateTime | null;
  lastStatusChange?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  notificationsStatus?: JSONString | null;
  ownerId?: ID | null;
  revision?: number | null;
  styleId?: ID | null;
}

export interface CreateOrUpdateOnlineFormTypeEmailRelationInput {
  __typename?: 'CreateOrUpdateOnlineFormTypeEmailRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormTypeId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateOnlineFormStyleInput {
  __typename?: 'CreateOrUpdateOnlineFormStyleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: JSONString | null;
  useLang?: boolean | null;
}

export interface CreateOrUpdateOnlineFormRelationInput {
  __typename?: 'CreateOrUpdateOnlineFormRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateOnlineFormInput {
  __typename?: 'CreateOrUpdateOnlineFormInput';
  accountRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  customFields?: JSONString | null;
  emailId?: ID | null;
  fieldIds?: JSONString | null;
  id?: ID | null;
  leadRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  modified?: DateTime | null;
  onlineFormTypeId?: ID | null;
  opportunityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  projectRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  quoteRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateOnlineFormDataExRelationInput {
  __typename?: 'CreateOrUpdateOnlineFormDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateOnlineFormActivityLogLineInput {
  __typename?: 'CreateOrUpdateOnlineFormActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  id?: ID | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  onlineFormId?: ID | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateNoteInput {
  __typename?: 'CreateOrUpdateNoteInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note?: string | null;
  ownerId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateMessageSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateMessageSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateMessageSharingClientRelationInput {
  __typename?: 'CreateOrUpdateMessageSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateMessageRelationInput {
  __typename?: 'CreateOrUpdateMessageRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateMemoInput {
  __typename?: 'CreateOrUpdateMemoInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  clientMutationId?: string | null;
  comments?: CreateMemoCommentNoMemoBackrefInput[] | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  ownerId?: ID | null;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject?: string | null;
}

export interface CreateOrUpdateMemoCommentInput {
  __typename?: 'CreateOrUpdateMemoCommentInput';
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  memoId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateMediaInput {
  __typename?: 'CreateOrUpdateMediaInput';
  activityId?: ID | null;
  callId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  data?: JSONString | null;
  description?: string | null;
  errorCode?: number | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: MediaStatusEnum | null;
  type?: MediaTypeEnum | null;
}

export interface CreateOrUpdateMasterRightInput {
  __typename?: 'CreateOrUpdateMasterRightInput';
  accessAccountRelationTypes?: boolean | null;
  accessAccounts?: boolean | null;
  accessAiAutomatizer?: boolean | null;
  accessAiOnlineForms?: boolean | null;
  accessAiRecordDetail?: boolean | null;
  accessAiReports?: boolean | null;
  accessAiSmartField?: boolean | null;
  accessAppointmentScheduler?: boolean | null;
  accessAppointmentSchedulerManagement?: boolean | null;
  accessApprovalProcesses?: boolean | null;
  accessApprovalProcessesManagement?: boolean | null;
  accessApprovals?: boolean | null;
  accessArchive?: boolean | null;
  accessAudit?: boolean | null;
  accessAuditLog?: boolean | null;
  accessBulkUpdate?: boolean | null;
  accessCalling?: boolean | null;
  accessCallingCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  accessCallingPurchasePhone?: boolean | null;
  accessCompanyEmails?: AccessLevelCompanyEmailsEnum | null;
  accessContacts?: boolean | null;
  accessDocumentManagement?: boolean | null;
  accessDocumentManagementCompany?: boolean | null;
  accessDocumentManagementRecord?: boolean | null;
  accessDuplicateChecker?: boolean | null;
  accessEntityAccount?: AccessLevelEntityEnum | null;
  accessEntityAccountCopy?: boolean | null;
  accessEntityAccountDelete?: boolean | null;
  accessEntityAccountDirection?: AccessDirectionEnum | null;
  accessEntityAccountPrivate?: boolean | null;
  accessEntityAccountTagCreate?: boolean | null;
  accessEntityAccountTypes?: AccessEntityTypesEnum | null;
  accessEntityAppointment?: AccessLevelEntityEnum | null;
  accessEntityAppointmentDelete?: boolean | null;
  accessEntityAppointmentDirection?: AccessDirectionEnum | null;
  accessEntityAppointmentTagCreate?: boolean | null;
  accessEntityBetterNavigator?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned?: boolean | null;
  accessEntityBetterNavigatorDeleteOwned?: boolean | null;
  accessEntityBetterNavigatorSharingCustom?: boolean | null;
  accessEntityBetterNavigatorSharingPublic?: boolean | null;
  accessEntityContact?: AccessLevelEntityEnum | null;
  accessEntityContactCopy?: boolean | null;
  accessEntityContactDelete?: boolean | null;
  accessEntityContactDirection?: AccessDirectionEnum | null;
  accessEntityContactPrivate?: boolean | null;
  accessEntityContactTagCreate?: boolean | null;
  accessEntityContactTypes?: AccessEntityTypesEnum | null;
  accessEntityDashboard?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityDashboardDeleteNotOwned?: boolean | null;
  accessEntityDashboardDeleteOwned?: boolean | null;
  accessEntityDashboardSharingCustom?: boolean | null;
  accessEntityDashboardSharingPublic?: boolean | null;
  accessEntityEmailContentShareMode?: ContentShareModeConfigEnum | null;
  accessEntityEmailDeleteNotOwned?: boolean | null;
  accessEntityEmailSequence?: AccessLevelEmailSequenceEnum | null;
  accessEntityEmailTemplate?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder?: boolean | null;
  accessEntityEmailTemplateDeleteNotOwned?: boolean | null;
  accessEntityEmailTemplateDeleteOwned?: boolean | null;
  accessEntityEmailTemplateSharingCustom?: boolean | null;
  accessEntityEmailTemplateSharingPublic?: boolean | null;
  accessEntityForecast?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityForecastDeleteNotOwned?: boolean | null;
  accessEntityForecastDeleteOwned?: boolean | null;
  accessEntityForecastEditNotOwned?: boolean | null;
  accessEntityForecastSharingCustom?: boolean | null;
  accessEntityForecastSharingPublic?: boolean | null;
  accessEntityFormView?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityFormViewDeleteNotOwned?: boolean | null;
  accessEntityFormViewDeleteOwned?: boolean | null;
  accessEntityFormViewSharingCustom?: boolean | null;
  accessEntityFormViewSharingPublic?: boolean | null;
  accessEntityLead?: AccessLevelEntityEnum | null;
  accessEntityLeadCopy?: boolean | null;
  accessEntityLeadDelete?: boolean | null;
  accessEntityLeadDirection?: AccessDirectionEnum | null;
  accessEntityLeadPrivate?: boolean | null;
  accessEntityLeadTagCreate?: boolean | null;
  accessEntityLeadTypes?: AccessEntityTypesEnum | null;
  accessEntityMessageTagCreate?: boolean | null;
  accessEntityOppty?: AccessLevelEntityEnum | null;
  accessEntityOpptyCopy?: boolean | null;
  accessEntityOpptyDelete?: boolean | null;
  accessEntityOpptyDirection?: AccessDirectionEnum | null;
  accessEntityOpptyPrivate?: boolean | null;
  accessEntityOpptyTagCreate?: boolean | null;
  accessEntityPipeline?: AccessLevelPipelineEnum | null;
  accessEntityProcess?: AccessLevelProcessBuilderEnum | null;
  accessEntityProfile?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityProfileDefaultScreenProfiles?: ScreensDefaultProfilesParamsParams | null;
  accessEntityProfileDeleteNotOwned?: boolean | null;
  accessEntityProfileDeleteOwned?: boolean | null;
  accessEntityProfileSharingCustom?: boolean | null;
  accessEntityProfileSharingPublic?: boolean | null;
  accessEntityProject?: AccessLevelEntityEnum | null;
  accessEntityProjectCopy?: boolean | null;
  accessEntityProjectDelete?: boolean | null;
  accessEntityProjectDirection?: AccessDirectionEnum | null;
  accessEntityProjectPrivate?: boolean | null;
  accessEntityProjectTagCreate?: boolean | null;
  accessEntityQuote?: AccessLevelEntityEnum | null;
  accessEntityQuoteCopy?: boolean | null;
  accessEntityQuoteDelete?: boolean | null;
  accessEntityQuoteDirection?: AccessDirectionEnum | null;
  accessEntityQuoteTypes?: AccessEntityTypesEnum | null;
  accessEntityReport?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityReportCreateDeleteFolder?: boolean | null;
  accessEntityReportDeleteNotOwned?: boolean | null;
  accessEntityReportDeleteOwned?: boolean | null;
  accessEntityReportPrivate?: boolean | null;
  accessEntityReportScheduleCreate?: boolean | null;
  accessEntityReportScheduleManagement?: boolean | null;
  accessEntityReportSharingCustom?: boolean | null;
  accessEntityReportSharingPublic?: boolean | null;
  accessEntityTarget?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityTargetDeleteNotOwned?: boolean | null;
  accessEntityTargetDeleteOwned?: boolean | null;
  accessEntityTask?: AccessLevelEntityEnum | null;
  accessEntityTaskDelete?: boolean | null;
  accessEntityTaskDirection?: AccessDirectionEnum | null;
  accessEntityTaskTagCreate?: boolean | null;
  accessEntityTaskUnassigned?: boolean | null;
  accessExport?: boolean | null;
  accessFeeds?: boolean | null;
  accessForeignCurrencies?: boolean | null;
  accessFormAndFields?: boolean | null;
  accessGlobalSettings?: boolean | null;
  accessHomeScreen?: boolean | null;
  accessImport?: boolean | null;
  accessInsights?: boolean | null;
  accessLeads?: boolean | null;
  accessOnlineForms?: boolean | null;
  accessOnlineFormsManagement?: boolean | null;
  accessOpportunity?: boolean | null;
  accessPipelineConfiguration?: boolean | null;
  accessPrint?: boolean | null;
  accessProductsServices?: boolean | null;
  accessProjects?: boolean | null;
  accessQuotes?: boolean | null;
  accessSalesRoles?: boolean | null;
  accessSecurity?: boolean | null;
  accessUnits?: boolean | null;
  accessUserAndRoles?: boolean | null;
  accessVoyagerAi?: boolean | null;
  accessWhatsAppCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  allowedAccountTypes?: CreateAllowedAccountTypeNoMasterRightBackrefInput[] | null;
  allowedCompanyEmails?: CreateAllowedCompanyEmailNoMasterRightBackrefInput[] | null;
  allowedCompanyPhones?: CreateAllowedCompanyPhoneNoMasterRightBackrefInput[] | null;
  allowedContactTypes?: CreateAllowedContactTypeNoMasterRightBackrefInput[] | null;
  allowedLeadTypes?: CreateAllowedLeadTypeNoMasterRightBackrefInput[] | null;
  allowedPipelines?: CreateAllowedPipelineNoMasterRightBackrefInput[] | null;
  allowedQuoteTypes?: CreateAllowedQuoteTypeNoMasterRightBackrefInput[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntities?: CustomEntityMasterRightParams[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateLeadProcessInput {
  __typename?: 'CreateOrUpdateLeadProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  steps?: CreateOrUpdateStepNoLeadProcessBackrefInput[] | null;
}

export interface CreateOrUpdateLeadOpptyStepCheckListRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptyStepCheckListRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id?: ID | null;
  itemChecked?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note?: CreateNoteInput | null;
  noteId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  stepChecklistId?: ID | null;
}

export interface CreateOrUpdateLeadOpptySharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateLeadOpptySharingClientRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptySharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateLeadOpptyKPIInput {
  __typename?: 'CreateOrUpdateLeadOpptyKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: LeadOpptyKpiEnum | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyContactRelation?: CreateLeadOpptyContactRelationInput | null;
  leadOpptyContactRelationId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
}

export interface CreateOrUpdateLeadOpptyContactRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
  salesRoles?: CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput[] | null;
}

export interface CreateOrUpdateLeadOpptyContactGroupRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptyContactGroupRelationInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  groupPosition?: JSONString | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateLeadOpptyAccountRelationInput {
  __typename?: 'CreateOrUpdateLeadOpptyAccountRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateLeadInput {
  __typename?: 'CreateOrUpdateLeadInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  isArchived?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  leadTypeId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId?: ID | null;
  tags?: CreateTagRelationNoLeadBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateImportMappingMaskInput {
  __typename?: 'CreateOrUpdateImportMappingMaskInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  entityType?: ImportMaskEntityTypeEnum | null;
  id?: ID | null;
  mapping?: JSONString | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  relationTypes?: JSONString | null;
  revision?: number | null;
  shareMode?: ProfileShareMode | null;
  sharingClients?: UUID[] | null;
  sharingUnits?: UUID[] | null;
}

export interface CreateOrUpdateGhostLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'CreateOrUpdateGhostLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostLeadOpptyContactRelation?: CreateGhostLeadOpptyContactRelationInput | null;
  ghostLeadOpptyContactRelationId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId?: ID | null;
}

export interface CreateOrUpdateGhostLeadOpptyContactRelationInput {
  __typename?: 'CreateOrUpdateGhostLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact?: CreateGhostContactInput | null;
  ghostContactId?: ID | null;
  id?: ID | null;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  revision?: number | null;
  salesRoles?: CreateGhostLeadOpptyContactSalesRoleRelationNoGhostLeadOpptyContactRelationBackrefInput[] | null;
}

export interface CreateOrUpdateGhostContactInput {
  __typename?: 'CreateOrUpdateGhostContactInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  position?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateGhostContactAccountRelationInput {
  __typename?: 'CreateOrUpdateGhostContactAccountRelationInput';
  accountId?: ID | null;
  accountRoles?: CreateGhostContactAccountAccountRoleRelationNoGhostContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact?: CreateGhostContactInput | null;
  ghostContactId?: ID | null;
  id?: ID | null;
  isAssistant?: boolean | null;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  revision?: number | null;
}

export interface CreateOrUpdateGhostContactAccountAccountRoleRelationInput {
  __typename?: 'CreateOrUpdateGhostContactAccountAccountRoleRelationInput';
  accountRoleId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostContactAccountRelation?: CreateGhostContactAccountRelationInput | null;
  ghostContactAccountRelationId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateFormViewSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateFormViewSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateFormViewSharingClientRelationInput {
  __typename?: 'CreateOrUpdateFormViewSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateFormViewInput {
  __typename?: 'CreateOrUpdateFormViewInput';
  accountTypeId?: ID | null;
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  hiddenItemIds?: UUID[] | null;
  id?: ID | null;
  itemColors?: FormViewItemColorInput[] | null;
  leadTypeId?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  opptyTypeId?: ID | null;
  ownerId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateFormViewSharingClientRelationNoFormViewBackrefInput[] | null;
  sharingUnits?: CreateFormViewSharingSalesUnitRelationNoFormViewBackrefInput[] | null;
  useLang?: boolean | null;
}

export interface CreateOrUpdateForecastInput {
  __typename?: 'CreateOrUpdateForecastInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  settings?: JSONString | null;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharedClients?: UUID[] | null;
  sharedUnits?: UUID[] | null;
}

export interface CreateOrUpdateFieldMappingInput {
  __typename?: 'CreateOrUpdateFieldMappingInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  isSystem?: boolean | null;
  mapping?: FieldMappingTemplateJSONString | null;
  modified?: DateTime | null;
  operation?: FieldMappingOperationTypeEnum | null;
  revision?: number | null;
  typeMappings?: EntityTypeFieldMappingJSONString[] | null;
}

export interface CreateOrUpdateEntityScoringInput {
  __typename?: 'CreateOrUpdateEntityScoringInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityType?: BaseEntityTypeEnum | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  revision?: number | null;
  settings?: EntityScoringSettingsJSONString | null;
  sortOrder?: number | null;
  useLang?: boolean | null;
}

export interface CreateOrUpdateEntityHealthInput {
  __typename?: 'CreateOrUpdateEntityHealthInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  lastRecalculation?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  settings?: EntityHealthSettingsJSONString | null;
  typeId?: ID | null;
}

export interface CreateOrUpdateEntityFitnessInput {
  __typename?: 'CreateOrUpdateEntityFitnessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  indicatorRelations?: CreateOrUpdateEntityFitnessIndicatorNoEntityFitnessBackrefInput[] | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateEntityFitnessIndicatorNoEntityFitnessBackrefInput {
  __typename?: 'CreateOrUpdateEntityFitnessIndicatorNoEntityFitnessBackrefInput';
  created?: DateTime | null;
  description?: string | null;
  descriptionUseLang?: boolean | null;
  howToFix?: string | null;
  howToFixUseLang?: boolean | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  nameUseLang?: boolean | null;
  revision?: number | null;
  settings?: FitnessIndicatorSettingsJSONString | null;
  type?: FitnessIndicatorTypeEnum | null;
}

export interface CreateOrUpdateEntityFitnessIndicatorInput {
  __typename?: 'CreateOrUpdateEntityFitnessIndicatorInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  descriptionUseLang?: boolean | null;
  entityFitnessId?: ID | null;
  howToFix?: string | null;
  howToFixUseLang?: boolean | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  nameUseLang?: boolean | null;
  revision?: number | null;
  settings?: FitnessIndicatorSettingsJSONString | null;
  type?: FitnessIndicatorTypeEnum | null;
}

export interface CreateOrUpdateEmailTemplateSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateEmailTemplateSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateEmailTemplateSharingClientRelationInput {
  __typename?: 'CreateOrUpdateEmailTemplateSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateEmailTemplateInput {
  __typename?: 'CreateOrUpdateEmailTemplateInput';
  body?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  emailTemplateFolderId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  recentColors?: number[] | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateEmailTemplateSharingClientRelationNoEmailTemplateBackrefInput[] | null;
  sharingUnits?: CreateEmailTemplateSharingSalesUnitRelationNoEmailTemplateBackrefInput[] | null;
  sharingUrlIsEnabled?: boolean | null;
  sharingUrlSettings?: JSONString | null;
  subject?: string | null;
  type?: EmailTemplateTypeEnum | null;
}

export interface CreateOrUpdateEmailTemplateFolderInput {
  __typename?: 'CreateOrUpdateEmailTemplateFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  parentEmailTemplateFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateEmailSequenceInput {
  __typename?: 'CreateOrUpdateEmailSequenceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: EmailSequenceSchemaJSONString | null;
  type?: ProcessTypeEnum | null;
}

export interface CreateOrUpdateEmailSequenceEnrolledInput {
  __typename?: 'CreateOrUpdateEmailSequenceEnrolledInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailSequenceActivityLogId?: ID | null;
  emailSequenceId?: ID | null;
  endReason?: EmailSequenceEndReasonEnum | null;
  endTime?: DateTime | null;
  excludedFromStats?: boolean | null;
  id?: ID | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  projectId?: ID | null;
  startTime?: DateTime | null;
}

export interface CreateOrUpdateEmailSequenceActivityLogLineInput {
  __typename?: 'CreateOrUpdateEmailSequenceActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceActivityLogId?: ID | null;
  id?: ID | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateEmailSequenceActivityLogInput {
  __typename?: 'CreateOrUpdateEmailSequenceActivityLogInput';
  actorId?: ID | null;
  applicationId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceId?: ID | null;
  endTime?: DateTime | null;
  id?: ID | null;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  startTime?: DateTime | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateEmailInput {
  __typename?: 'CreateOrUpdateEmailInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  additionalHeaders?: JSONString | null;
  body?: string | null;
  bodySummary?: string | null;
  cc?: string | null;
  clientMutationId?: string | null;
  companyEmailId?: ID | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: CreateEmailContentSharingClientRelationNoEmailBackrefInput[] | null;
  contentSharingUnits?: CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput[] | null;
  contentType?: string | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  dateSent?: DateTime | null;
  direction?: EmailDirectionEnum | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  errorCode?: number | null;
  id?: ID | null;
  isTracked?: boolean | null;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  originalId?: string | null;
  ownerId?: ID | null;
  parentEmailId?: ID | null;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  scheduleSettings?: JSONString | null;
  sendAt?: DateTime | null;
  sender?: string | null;
  senderAccountId?: ID | null;
  senderClientId?: ID | null;
  senderContactId?: ID | null;
  sentiment?: EmailSentimentEnum | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject?: string | null;
  tags?: CreateTagRelationNoEmailBackrefInput[] | null;
  templateId?: ID | null;
  threadId?: ID | null;
  to?: string | null;
  type?: EmailTypeEnum | null;
  uid?: string | null;
}

export interface CreateOrUpdateEmailEventInput {
  __typename?: 'CreateOrUpdateEmailEventInput';
  additionalData?: JSONString | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  type?: EmailEventTypeEnum | null;
  url?: string | null;
}

export interface CreateOrUpdateEmailContentSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateEmailContentSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateEmailContentSharingClientRelationInput {
  __typename?: 'CreateOrUpdateEmailContentSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateCustomEntitySharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateCustomEntitySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateCustomEntitySharingClientRelationInput {
  __typename?: 'CreateOrUpdateCustomEntitySharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateCustomEntityRelationDataInput {
  __typename?: 'CreateOrUpdateCustomEntityRelationDataInput';
  account1Id?: ID | null;
  account2Id?: ID | null;
  activity1Id?: ID | null;
  activity2Id?: ID | null;
  client1Id?: ID | null;
  client2Id?: ID | null;
  clientMutationId?: string | null;
  contact1Id?: ID | null;
  contact2Id?: ID | null;
  created?: DateTime | null;
  customEntity1Id?: ID | null;
  customEntity2Id?: ID | null;
  customEntityRelationId?: ID | null;
  id?: ID | null;
  isPrimary?: boolean | null;
  leadOppty1Id?: ID | null;
  leadOppty2Id?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation1?: CreateOpptyProductRelationInput | null;
  opptyProductRelation1Id?: ID | null;
  opptyProductRelation2?: CreateOpptyProductRelationInput | null;
  opptyProductRelation2Id?: ID | null;
  product1Id?: ID | null;
  product2Id?: ID | null;
  project1Id?: ID | null;
  project2Id?: ID | null;
  quote1Id?: ID | null;
  quote2Id?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateCustomEntityInput {
  __typename?: 'CreateOrUpdateCustomEntityInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput[] | null;
  sharingUnits?: CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoCustomEntityBackrefInput[] | null;
  typeId?: ID | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateCustomEntityDataExRelationInput {
  __typename?: 'CreateOrUpdateCustomEntityDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  dataId?: ID | null;
  dataSetId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateCurrencyInput {
  __typename?: 'CreateOrUpdateCurrencyInput';
  clientMutationId?: string | null;
  code?: string | null;
  created?: DateTime | null;
  currencyExchangeRates?: CreateCurrencyExchangeRateNoCurrencyBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  symbol?: string | null;
}

export interface CreateOrUpdateCurrencyExchangeRatesListInput {
  __typename?: 'CreateOrUpdateCurrencyExchangeRatesListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRates?: CreateCurrencyExchangeRateNoCurrencyExchangeRateListBackrefInput[] | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  validFrom?: DateTime | null;
}

export interface CreateOrUpdateCurrencyExchangeRateInput {
  __typename?: 'CreateOrUpdateCurrencyExchangeRateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRateListId?: ID | null;
  currencyId?: ID | null;
  exchangeRate?: number | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateContactSocialRelationInput {
  __typename?: 'CreateOrUpdateContactSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id?: ID | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateOrUpdateContactSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateContactSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateContactSharingClientRelationInput {
  __typename?: 'CreateOrUpdateContactSharingClientRelationInput';
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateContactRelationTypeInput {
  __typename?: 'CreateOrUpdateContactRelationTypeInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateContactRelationLabelInput {
  __typename?: 'CreateOrUpdateContactRelationLabelInput';
  clientMutationId?: string | null;
  contactRelation?: CreateContactRelationInput | null;
  contactRelationId?: ID | null;
  contactRelationTypeId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateContactRelationInput {
  __typename?: 'CreateOrUpdateContactRelationInput';
  clientMutationId?: string | null;
  contact1Id?: ID | null;
  contact2Id?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateContactKPIInput {
  __typename?: 'CreateOrUpdateContactKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: ContactKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateContactInput {
  __typename?: 'CreateOrUpdateContactInput';
  accountPosition?: string | null;
  accountRelations?: CreateContactAccountRelationNoContactBackrefInput[] | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  contactTypeId?: ID | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  exchangeEntityId?: string | null;
  firstName?: string | null;
  gapiEntityId?: string | null;
  gender?: GenderEnum | null;
  id?: ID | null;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  lastName?: string | null;
  middleName?: string | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  ownerId?: ID | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  position?: string | null;
  primaryAccountAccountRoles?: UUID[] | null;
  primaryAccountRelationship?: string | null;
  quickAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateContactSharingClientRelationNoContactBackrefInput[] | null;
  sharingUnits?: CreateContactSharingSalesUnitRelationNoContactBackrefInput[] | null;
  socialMedia?: UpdateContactSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoContactBackrefInput[] | null;
  tags?: CreateTagRelationNoContactBackrefInput[] | null;
  title?: string | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface CreateOrUpdateContactAccountRelationInput {
  __typename?: 'CreateOrUpdateContactAccountRelationInput';
  accountId?: ID | null;
  accountRoles?: CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  isAssistant?: boolean | null;
  isPrimary?: boolean | null;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
}

export interface CreateOrUpdateContactAccountAccountRoleRelationInput {
  __typename?: 'CreateOrUpdateContactAccountAccountRoleRelationInput';
  accountRoleId?: ID | null;
  clientMutationId?: string | null;
  contactAccountRelation?: CreateContactAccountRelationInput | null;
  contactAccountRelationId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateCompanyEmailInput {
  __typename?: 'CreateOrUpdateCompanyEmailInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  email?: string | null;
  enabled?: boolean | null;
  errorCode?: number | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  pictureUrl?: string | null;
  serviceType?: EmailServiceTypeEnum | null;
  settings?: JSONString | null;
  token?: string | null;
}

export interface CreateOrUpdateCloudObjectTemplateInput {
  __typename?: 'CreateOrUpdateCloudObjectTemplateInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  content?: Base64 | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename?: string | null;
  id?: ID | null;
  isPublic?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: CloudObjectTemplateStatusEnum | null;
  templateEntityApiName?: string | null;
  templateEntityName?: EntityNameEnum | null;
  type?: CloudObjectTypeEnum | null;
  uploadSource?: UploadSourceEnum | null;
  url?: string | null;
}

export interface CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput {
  __typename?: 'CreateOrUpdateCloudObjectStepRelationNoStepBackrefInput';
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateOrUpdateCloudObjectStepRelationInput {
  __typename?: 'CreateOrUpdateCloudObjectStepRelationInput';
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepId?: ID | null;
}

export interface CreateOrUpdateCloudObjectRelationInput {
  __typename?: 'CreateOrUpdateCloudObjectRelationInput';
  accountId?: ID | null;
  activityId?: ID | null;
  approvalProcessId?: ID | null;
  callId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectFolderId?: ID | null;
  cloudObjectId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailSequenceId?: ID | null;
  emailTemplateId?: ID | null;
  fieldMappingId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  mediaId?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  processId?: ID | null;
  processTemplateId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportSchedule?: CreateReportScheduleInput | null;
  reportScheduleId?: ID | null;
  revision?: number | null;
  textMessage?: CreateTextMessageInput | null;
  textMessageId?: ID | null;
}

export interface CreateOrUpdateCloudObjectInput {
  __typename?: 'CreateOrUpdateCloudObjectInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  content?: Base64 | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename?: string | null;
  id?: ID | null;
  isPublic?: boolean | null;
  mimeType?: string | null;
  modified?: DateTime | null;
  params?: JSONString | null;
  revision?: number | null;
  type?: CloudObjectTypeEnum | null;
  uploadSource?: UploadSourceEnum | null;
  url?: string | null;
}

export interface CreateOrUpdateCloudObjectFolderInput {
  __typename?: 'CreateOrUpdateCloudObjectFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  entityType?: BaseEntityTypeEnum | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  onlineFormTypeId?: ID | null;
  parentCloudObjectFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateClientStoryReadInput {
  __typename?: 'CreateOrUpdateClientStoryReadInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  noFollow?: boolean | null;
  ownerId?: ID | null;
  readAt?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateClientSettingInput {
  __typename?: 'CreateOrUpdateClientSettingInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  revision?: number | null;
  value?: JSONString | null;
}

export interface CreateOrUpdateClientInput {
  __typename?: 'CreateOrUpdateClientInput';
  accountFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  appointmentFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  clientMutationId?: string | null;
  contactFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  created?: DateTime | null;
  defaultUnitId?: ID | null;
  email?: string | null;
  firstName?: string | null;
  id?: ID | null;
  lastActive?: DateTime | null;
  lastName?: string | null;
  leadFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  masterRightId?: ID | null;
  middleName?: string | null;
  modified?: DateTime | null;
  opportunityFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  phone?: string | null;
  position?: string | null;
  profileFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  region?: string | null;
  reportFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  revision?: number | null;
  taskFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  timezone?: string | null;
  type?: ClientTypeEnum | null;
  unitMembership?: CreateSalesUnitClientRelationNoClientBackrefInput[] | null;
}

export interface CreateOrUpdateClientFavoriteInput {
  __typename?: 'CreateOrUpdateClientFavoriteInput';
  accountId?: ID | null;
  activityId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateClientExcludedOpptyInput {
  __typename?: 'CreateOrUpdateClientExcludedOpptyInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isExcluded?: boolean | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateChatConversationInput {
  __typename?: 'CreateOrUpdateChatConversationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  messages?: CreateOrUpdateTextMessageNoChatConversationBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  type?: ChatConversationTypeEnum | null;
}

export interface CreateOrUpdateCallInput {
  __typename?: 'CreateOrUpdateCallInput';
  accountId?: ID | null;
  audioStatus?: AudioStatus | null;
  callerId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation?: CreateOpptyProductRelationInput | null;
  opptyProductRelationId?: ID | null;
  phoneNumber?: string | null;
  productId?: ID | null;
  transcriptionId?: string | null;
  transcriptionLanguage?: string | null;
  transcriptionSummary?: string | null;
  twilioCallLogId?: ID | null;
}

export interface CreateOrUpdateAutomationHubItemInput {
  __typename?: 'CreateOrUpdateAutomationHubItemInput';
  automationHubAppId?: number | null;
  automationHubCategoryId?: number | null;
  clientMutationId?: string | null;
  configurationUrl?: string | null;
  deprecatedByItemId?: number | null;
  description?: string | null;
  hasLastRun?: boolean | null;
  hasLogs?: boolean | null;
  id?: ID | null;
  integrationAnalyticsEnabled?: boolean | null;
  isBeta?: boolean | null;
  isBundle?: boolean | null;
  isVisible?: boolean | null;
  logoUrl?: string | null;
  minApiVersion?: number | null;
  name?: string | null;
  parentId?: ID | null;
  ranking?: number | null;
  scope?: AutomationHubScope | null;
  tier?: AutomationHubTierEnum | null;
  websiteUrl?: string | null;
}

export interface CreateOrUpdateApprovalProcessInput {
  __typename?: 'CreateOrUpdateApprovalProcessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  lastSchemaChange?: DateTime | null;
  lastStatusChange?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  settings?: JSONString | null;
}

export interface CreateOrUpdateApprovalProcessActivityLogLineInput {
  __typename?: 'CreateOrUpdateApprovalProcessActivityLogLineInput';
  approvalId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  data?: JSONString | null;
  executedAt?: DateTime | null;
  id?: ID | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateApprovalInput {
  __typename?: 'CreateOrUpdateApprovalInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId?: ID | null;
  approvalProcessId?: ID | null;
  approvalStatus?: ApprovalStatusEnum | null;
  approvers?: CreateApprovalApproverNoApprovalBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOrUpdateApprovalApproverInput {
  __typename?: 'CreateOrUpdateApprovalApproverInput';
  approvalId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: ApprovalStatusEnum | null;
}

export interface CreateOrUpdateAppointmentScheduleInput {
  __typename?: 'CreateOrUpdateAppointmentScheduleInput';
  additionalFieldsData?: AppointmentScheduleAdditionalFieldParams[] | null;
  appointmentDescription?: string | null;
  appointmentDuration?: number | null;
  appointmentInviteesData?: AppointmentScheduleInviteeParams[] | null;
  appointmentLocation?: string | null;
  appointmentLocationType?: AppointmentScheduleLocationTypeEnum | null;
  appointmentOwnerId?: ID | null;
  appointmentSubject?: string | null;
  appointmentSubjectUsesScheduleName?: boolean | null;
  appointmentTypeId?: ID | null;
  availabilityData?: AppointmentScheduleAvailabilityParams | null;
  availabilityTzid?: string | null;
  bufferTimeAfter?: number | null;
  bufferTimeBefore?: number | null;
  clientMutationId?: string | null;
  confirmationPageType?: AppointmentScheduleConfirmationPageTypeEnum | null;
  confirmationPageUrl?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  isEnabled?: boolean | null;
  minimumNoticeTime?: number | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  planningDayOffset?: number | null;
  planningPeriodFrom?: GqlDate | null;
  planningPeriodTo?: GqlDate | null;
  planningType?: AppointmentSchedulePlanningTypeEnum | null;
  reminderEmailEnabled?: boolean | null;
  reminderEmailOffset?: number | null;
  reminderEmailOffsetType?: AppointmentScheduleReminderOffsetTypeEnum | null;
  replyCompanyEmailId?: ID | null;
  scheduleName?: string | null;
  timeIncrement?: number | null;
  type?: AppointmentScheduleTypeEnum | null;
  url?: string | null;
}

export interface CreateOrUpdateAppointmentReminderInput {
  __typename?: 'CreateOrUpdateAppointmentReminderInput';
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  endDateOffset?: number | null;
  id?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface CreateOrUpdateAppointmentInput {
  __typename?: 'CreateOrUpdateAppointmentInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  duration?: number | null;
  endDate?: DateTime | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  id?: ID | null;
  inviteesCanEdit?: boolean | null;
  inviteesClients?: CreateAppointmentClientInviteesRelationNoAppointmentBackrefInput[] | null;
  inviteesContacts?: CreateAppointmentContactInviteesRelationNoAppointmentBackrefInput[] | null;
  isRecurrenceActive?: boolean | null;
  isRecurrenceException?: boolean | null;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  location?: string | null;
  mediaTranscriptionId?: UUID | null;
  meetingUrl?: AppointmentMeetingInput | null;
  modified?: DateTime | null;
  o365EntityId?: string | null;
  occurenceDate?: DateTime | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  organizer?: string | null;
  ownerId?: ID | null;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  recurrenceMasterId?: ID | null;
  recurrenceRule?: string | null;
  recurrenceTzid?: string | null;
  reminder?: UpdateAppointmentReminderNoAppointmentBackrefInput | null;
  revision?: number | null;
  scheduleId?: ID | null;
  scheduleTzid?: string | null;
  startDate?: DateTime | null;
  subject?: string | null;
  tags?: CreateTagRelationNoAppointmentBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateAppointmentContactInviteesRelationInput {
  __typename?: 'CreateOrUpdateAppointmentContactInviteesRelationInput';
  appointmentId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  email?: string | null;
  firstName?: string | null;
  id?: ID | null;
  inviteeType?: AppointmentInviteeTypeEnum | null;
  lastName?: string | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateOrUpdateAppointmentClientInviteesRelationInput {
  __typename?: 'CreateOrUpdateAppointmentClientInviteesRelationInput';
  appointmentId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateOrUpdateApiAccessInput {
  __typename?: 'CreateOrUpdateApiAccessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  email?: string | null;
  id?: ID | null;
  isActive?: boolean | null;
  lastUsed?: DateTime | null;
  modified?: DateTime | null;
  name?: string | null;
  permissions?: ApiAccessPermissionsInput | null;
}

export interface CreateOrUpdateAllowedQuoteTypeInput {
  __typename?: 'CreateOrUpdateAllowedQuoteTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  quoteTypeId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedPipelineInput {
  __typename?: 'CreateOrUpdateAllowedPipelineInput';
  accessStepDocuments?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  pipelineId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedLeadTypeInput {
  __typename?: 'CreateOrUpdateAllowedLeadTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  leadTypeId?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedContactTypeInput {
  __typename?: 'CreateOrUpdateAllowedContactTypeInput';
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedCompanyPhoneInput {
  __typename?: 'CreateOrUpdateAllowedCompanyPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  phoneId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedCompanyEmailInput {
  __typename?: 'CreateOrUpdateAllowedCompanyEmailInput';
  clientMutationId?: string | null;
  companyEmailId?: ID | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAllowedAccountTypeInput {
  __typename?: 'CreateOrUpdateAllowedAccountTypeInput';
  accountTypeId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  masterRightId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateActivityRelationInput {
  __typename?: 'CreateOrUpdateActivityRelationInput';
  accountId?: ID | null;
  activityId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  id?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  projectObjective?: CreateProjectObjectiveInput | null;
  projectObjectiveId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateOrUpdateActivityKPIInput {
  __typename?: 'CreateOrUpdateActivityKPIInput';
  activityId?: ID | null;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: ActivityKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateActivityCommentInput {
  __typename?: 'CreateOrUpdateActivityCommentInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountSocialRelationInput {
  __typename?: 'CreateOrUpdateAccountSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id?: ID | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateOrUpdateAccountSharingSalesUnitRelationInput {
  __typename?: 'CreateOrUpdateAccountSharingSalesUnitRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateAccountSharingClientRelationInput {
  __typename?: 'CreateOrUpdateAccountSharingClientRelationInput';
  accountId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateOrUpdateAccountRoleInput {
  __typename?: 'CreateOrUpdateAccountRoleInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountRelationTypeInput {
  __typename?: 'CreateOrUpdateAccountRelationTypeInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  id?: ID | null;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountRelationLabelInput {
  __typename?: 'CreateOrUpdateAccountRelationLabelInput';
  accountRelation?: CreateAccountRelationInput | null;
  accountRelationId?: ID | null;
  accountRelationTypeId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountRelationInput {
  __typename?: 'CreateOrUpdateAccountRelationInput';
  account1Id?: ID | null;
  account2Id?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountProductPricingInput {
  __typename?: 'CreateOrUpdateAccountProductPricingInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId?: ID | null;
  id?: ID | null;
  modified?: DateTime | null;
  price?: number | null;
  productId?: ID | null;
  revision?: number | null;
}

export interface CreateOrUpdateAccountKPIInput {
  __typename?: 'CreateOrUpdateAccountKPIInput';
  accountId?: ID | null;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id?: ID | null;
  kpi?: AccountKpiEnum | null;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateOrUpdateAccountInput {
  __typename?: 'CreateOrUpdateAccountInput';
  accountClass?: AccountClassEnum | null;
  accountTypeId?: ID | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  customerTypeId?: ID | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  homePage?: string | null;
  id?: ID | null;
  industryId?: ID | null;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId?: ID | null;
  parentAccountId?: ID | null;
  parentAccountRelationTypeId?: ID | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  quickParentAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateAccountSharingClientRelationNoAccountBackrefInput[] | null;
  sharingUnits?: CreateAccountSharingSalesUnitRelationNoAccountBackrefInput[] | null;
  socialMedia?: UpdateAccountSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoAccountBackrefInput[] | null;
  tags?: CreateTagRelationNoAccountBackrefInput[] | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface CreateOpptyRevenueScheduleNoIdBackrefInput {
  __typename?: 'CreateOpptyRevenueScheduleNoIdBackrefInput';
  cancelationDate?: GqlDate | null;
  created?: DateTime | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOpptyRevenueScheduleInput {
  __typename?: 'CreateOpptyRevenueScheduleInput';
  cancelationDate?: GqlDate | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOpptyRecurrenceNoOpptyBackrefInput {
  __typename?: 'CreateOpptyRecurrenceNoOpptyBackrefInput';
  applyRecurrence?: boolean | null;
  condition?: number | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  revision?: number | null;
  startDate: GqlDate;
  stepId: ID;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateOpptyRecurrenceInput {
  __typename?: 'CreateOpptyRecurrenceInput';
  applyRecurrence?: boolean | null;
  clientMutationId?: string | null;
  condition?: number | null;
  created?: DateTime | null;
  day?: DateDayEnum | null;
  dayOfWeek?: number | null;
  endDate?: GqlDate | null;
  modified?: DateTime | null;
  month?: DateMonthEnum | null;
  occurEvery?: number | null;
  occurrencesCount?: number | null;
  opptyId: ID;
  revision?: number | null;
  startDate: GqlDate;
  stepId: ID;
  type?: RecurrenceTypeEnum | null;
  week?: DateWeekEnum | null;
}

export interface CreateOpptyProductRelationRevenueScheduleNoIdBackrefInput {
  __typename?: 'CreateOpptyProductRelationRevenueScheduleNoIdBackrefInput';
  cancelationDate?: GqlDate | null;
  created?: DateTime | null;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOpptyProductRelationRevenueScheduleInput {
  __typename?: 'CreateOpptyProductRelationRevenueScheduleInput';
  cancelationDate?: GqlDate | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  id: ID;
  isDeleted?: boolean | null;
  modified?: DateTime | null;
  periodCount?: number | null;
  periodType?: RevenueSchedulePeriodTypeEnum | null;
  revision?: number | null;
  startDate?: GqlDate | null;
}

export interface CreateOpptyProductRelationNoBackrefInput {
  __typename?: 'CreateOpptyProductRelationNoBackrefInput';
  amount?: number | null;
  comment?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  opptyProductRelationTypeId?: ID | null;
  pairedOpptyProductRelation?: CreateOpptyProductRelationInput | null;
  pairedOpptyProductRelationId?: ID | null;
  price?: number | null;
  productId: ID;
  quantity?: number | null;
  revenueSchedule?: CreateOpptyProductRelationRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  sectionId?: ID | null;
  sortOrder?: number | null;
}

export interface CreateOpptyProductRelationInput {
  __typename?: 'CreateOpptyProductRelationInput';
  amount?: number | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  opptyId?: ID | null;
  opptyProductRelationTypeId?: ID | null;
  pairedOpptyProductRelation?: CreateOpptyProductRelationInput | null;
  pairedOpptyProductRelationId?: ID | null;
  price?: number | null;
  productId: ID;
  quantity?: number | null;
  quoteId?: ID | null;
  revenueSchedule?: CreateOpptyProductRelationRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  sectionId?: ID | null;
  sortOrder?: number | null;
}

export interface CreateOpptyProductRelationDataExRelationInput {
  __typename?: 'CreateOpptyProductRelationDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId: ID;
  dataSetId: ID;
  modified?: DateTime | null;
  opptyProductRelation: CreateOpptyProductRelationInput;
  opptyProductRelationId: ID;
  revision?: number | null;
}

export interface CreateOpportunityProfileInput {
  __typename?: 'CreateOpportunityProfileInput';
  clientMutationId?: string | null;
  data?: OpportunityProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateOpportunityInput {
  __typename?: 'CreateOpportunityInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  activeQuoteId?: ID | null;
  clientMutationId?: string | null;
  closingDate: GqlDate;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  isArchived?: boolean | null;
  isValueAutoCalculate?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  opptyRecurrence?: CreateOpptyRecurrenceNoOpptyBackrefInput | null;
  opptyTypeId?: ID | null;
  ownerId: ID;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  productRelations?: CreateOpptyProductRelationNoBackrefInput[] | null;
  productSections?: JSONString | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  quoteRelations?: CreateQuoteNoOpptyBackrefInput[] | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revenueSchedule?: CreateOpptyRevenueScheduleNoIdBackrefInput | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId: ID;
  tags?: CreateTagRelationNoOpptyBackrefInput[] | null;
  unitId?: ID | null;
  value?: CurrencyForeignFieldInput | null;
  wasQualified?: boolean | null;
  wonDate?: DateTime | null;
}

export interface CreateOnlineFormTypeInput {
  __typename?: 'CreateOnlineFormTypeInput';
  autoPrefillWithJavascript?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customRecaptcha?: CustomRecaptcha | null;
  description?: string | null;
  entityApiName?: string | null;
  entityType: BaseEntityTypeEnum;
  formEdit: JSONString;
  isEnabled: boolean;
  isReadonly: boolean;
  lastSchemaChange?: DateTime | null;
  lastStatusChange?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  notificationsStatus?: JSONString | null;
  ownerId: ID;
  revision?: number | null;
  styleId: ID;
}

export interface CreateOnlineFormTypeEmailRelationInput {
  __typename?: 'CreateOnlineFormTypeEmailRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailId: ID;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormTypeId: ID;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOnlineFormStyleInput {
  __typename?: 'CreateOnlineFormStyleInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings?: JSONString | null;
  useLang?: boolean | null;
}

export interface CreateOnlineFormRelationNoOnlineFormBackrefInput {
  __typename?: 'CreateOnlineFormRelationNoOnlineFormBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  isPrimary: boolean;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOnlineFormRelationInput {
  __typename?: 'CreateOnlineFormRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  isPrimary: boolean;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  onlineFormId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateOnlineFormInput {
  __typename?: 'CreateOnlineFormInput';
  accountRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  customFields?: JSONString | null;
  emailId?: ID | null;
  fieldIds: JSONString;
  leadRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  modified?: DateTime | null;
  onlineFormTypeId: ID;
  opportunityRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  productCurrencyId?: ID | null;
  productPriceListId?: ID | null;
  projectRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  quoteRelations?: CreateOnlineFormRelationNoOnlineFormBackrefInput[] | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateOnlineFormDataExRelationInput {
  __typename?: 'CreateOnlineFormDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataId: ID;
  dataSetId: ID;
  modified?: DateTime | null;
  onlineFormId: ID;
  revision?: number | null;
}

export interface CreateOnlineFormActivityLogLineInput {
  __typename?: 'CreateOnlineFormActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  executedAt?: DateTime | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  onlineFormId: ID;
  sortOrder: number;
  status?: ProcessStatusEnum | null;
}

export interface CreateNoteInput {
  __typename?: 'CreateNoteInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note: string;
  ownerId: ID;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateNewCustomEntityMutationInput {
  __typename?: 'CreateNewCustomEntityMutationInput';
  clientMutationId?: string | null;
  functionalities: CustomEntityFunctionalityEnum[];
  icon: EntityIconEnum;
  nameFieldName: string;
  nameFieldSequence?: SequencePropertyParams | null;
  nameFieldType: string;
  namePlural: string;
  nameSingular: string;
}

export interface CreateNavigatorProfileInput {
  __typename?: 'CreateNavigatorProfileInput';
  clientMutationId?: string | null;
  data?: NavigatorProfileDataInput | null;
  name: string;
}

export interface CreateMsTeamsMeetingInput {
  __typename?: 'CreateMsTeamsMeetingInput';
  clientMutationId?: string | null;
}

export interface CreateMessageSharingSalesUnitRelationNoMessageBackrefInput {
  __typename?: 'CreateMessageSharingSalesUnitRelationNoMessageBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateMessageSharingSalesUnitRelationInput {
  __typename?: 'CreateMessageSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  messageId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateMessageSharingClientRelationNoMessageBackrefInput {
  __typename?: 'CreateMessageSharingClientRelationNoMessageBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateMessageSharingClientRelationInput {
  __typename?: 'CreateMessageSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  messageId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateMessageRelationNoMessageBackrefInput {
  __typename?: 'CreateMessageRelationNoMessageBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateMessageRelationInput {
  __typename?: 'CreateMessageRelationInput';
  accountId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  messageId: ID;
  modified?: DateTime | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
}

export interface CreateMemoInput {
  __typename?: 'CreateMemoInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  clientMutationId?: string | null;
  comments?: CreateMemoCommentNoMemoBackrefInput[] | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  ownerId: ID;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject: string;
}

export interface CreateMemoCommentNoMemoBackrefInput {
  __typename?: 'CreateMemoCommentNoMemoBackrefInput';
  comment: string;
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
}

export interface CreateMemoCommentInput {
  __typename?: 'CreateMemoCommentInput';
  clientMutationId?: string | null;
  comment: string;
  created?: DateTime | null;
  memoId: ID;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
}

export interface CreateMediaTranscriptionPdfInput {
  __typename?: 'CreateMediaTranscriptionPdfInput';
  clientMutationId?: string | null;
  entityId: ID;
  filename: string;
}

export interface CreateMasterRightInput {
  __typename?: 'CreateMasterRightInput';
  accessAccountRelationTypes?: boolean | null;
  accessAccounts?: boolean | null;
  accessAiAutomatizer?: boolean | null;
  accessAiOnlineForms?: boolean | null;
  accessAiRecordDetail?: boolean | null;
  accessAiReports?: boolean | null;
  accessAiSmartField?: boolean | null;
  accessAppointmentScheduler?: boolean | null;
  accessAppointmentSchedulerManagement?: boolean | null;
  accessApprovalProcesses?: boolean | null;
  accessApprovalProcessesManagement?: boolean | null;
  accessApprovals?: boolean | null;
  accessArchive?: boolean | null;
  accessAudit?: boolean | null;
  accessAuditLog?: boolean | null;
  accessBulkUpdate?: boolean | null;
  accessCalling?: boolean | null;
  accessCallingCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  accessCallingPurchasePhone?: boolean | null;
  accessCompanyEmails?: AccessLevelCompanyEmailsEnum | null;
  accessContacts?: boolean | null;
  accessDocumentManagement?: boolean | null;
  accessDocumentManagementCompany?: boolean | null;
  accessDocumentManagementRecord?: boolean | null;
  accessDuplicateChecker?: boolean | null;
  accessEntityAccount?: AccessLevelEntityEnum | null;
  accessEntityAccountCopy?: boolean | null;
  accessEntityAccountDelete?: boolean | null;
  accessEntityAccountDirection?: AccessDirectionEnum | null;
  accessEntityAccountPrivate?: boolean | null;
  accessEntityAccountTagCreate?: boolean | null;
  accessEntityAccountTypes?: AccessEntityTypesEnum | null;
  accessEntityAppointment?: AccessLevelEntityEnum | null;
  accessEntityAppointmentDelete?: boolean | null;
  accessEntityAppointmentDirection?: AccessDirectionEnum | null;
  accessEntityAppointmentTagCreate?: boolean | null;
  accessEntityBetterNavigator?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned?: boolean | null;
  accessEntityBetterNavigatorDeleteOwned?: boolean | null;
  accessEntityBetterNavigatorSharingCustom?: boolean | null;
  accessEntityBetterNavigatorSharingPublic?: boolean | null;
  accessEntityContact?: AccessLevelEntityEnum | null;
  accessEntityContactCopy?: boolean | null;
  accessEntityContactDelete?: boolean | null;
  accessEntityContactDirection?: AccessDirectionEnum | null;
  accessEntityContactPrivate?: boolean | null;
  accessEntityContactTagCreate?: boolean | null;
  accessEntityContactTypes?: AccessEntityTypesEnum | null;
  accessEntityDashboard?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityDashboardDeleteNotOwned?: boolean | null;
  accessEntityDashboardDeleteOwned?: boolean | null;
  accessEntityDashboardSharingCustom?: boolean | null;
  accessEntityDashboardSharingPublic?: boolean | null;
  accessEntityEmailContentShareMode?: ContentShareModeConfigEnum | null;
  accessEntityEmailDeleteNotOwned?: boolean | null;
  accessEntityEmailSequence?: AccessLevelEmailSequenceEnum | null;
  accessEntityEmailTemplate?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder?: boolean | null;
  accessEntityEmailTemplateDeleteNotOwned?: boolean | null;
  accessEntityEmailTemplateDeleteOwned?: boolean | null;
  accessEntityEmailTemplateSharingCustom?: boolean | null;
  accessEntityEmailTemplateSharingPublic?: boolean | null;
  accessEntityForecast?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityForecastDeleteNotOwned?: boolean | null;
  accessEntityForecastDeleteOwned?: boolean | null;
  accessEntityForecastEditNotOwned?: boolean | null;
  accessEntityForecastSharingCustom?: boolean | null;
  accessEntityForecastSharingPublic?: boolean | null;
  accessEntityFormView?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityFormViewDeleteNotOwned?: boolean | null;
  accessEntityFormViewDeleteOwned?: boolean | null;
  accessEntityFormViewSharingCustom?: boolean | null;
  accessEntityFormViewSharingPublic?: boolean | null;
  accessEntityLead?: AccessLevelEntityEnum | null;
  accessEntityLeadCopy?: boolean | null;
  accessEntityLeadDelete?: boolean | null;
  accessEntityLeadDirection?: AccessDirectionEnum | null;
  accessEntityLeadPrivate?: boolean | null;
  accessEntityLeadTagCreate?: boolean | null;
  accessEntityLeadTypes?: AccessEntityTypesEnum | null;
  accessEntityMessageTagCreate?: boolean | null;
  accessEntityOppty?: AccessLevelEntityEnum | null;
  accessEntityOpptyCopy?: boolean | null;
  accessEntityOpptyDelete?: boolean | null;
  accessEntityOpptyDirection?: AccessDirectionEnum | null;
  accessEntityOpptyPrivate?: boolean | null;
  accessEntityOpptyTagCreate?: boolean | null;
  accessEntityPipeline?: AccessLevelPipelineEnum | null;
  accessEntityProcess?: AccessLevelProcessBuilderEnum | null;
  accessEntityProfile?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityProfileDefaultScreenProfiles?: ScreensDefaultProfilesParamsParams | null;
  accessEntityProfileDeleteNotOwned?: boolean | null;
  accessEntityProfileDeleteOwned?: boolean | null;
  accessEntityProfileSharingCustom?: boolean | null;
  accessEntityProfileSharingPublic?: boolean | null;
  accessEntityProject?: AccessLevelEntityEnum | null;
  accessEntityProjectCopy?: boolean | null;
  accessEntityProjectDelete?: boolean | null;
  accessEntityProjectDirection?: AccessDirectionEnum | null;
  accessEntityProjectPrivate?: boolean | null;
  accessEntityProjectTagCreate?: boolean | null;
  accessEntityQuote?: AccessLevelEntityEnum | null;
  accessEntityQuoteCopy?: boolean | null;
  accessEntityQuoteDelete?: boolean | null;
  accessEntityQuoteDirection?: AccessDirectionEnum | null;
  accessEntityQuoteTypes?: AccessEntityTypesEnum | null;
  accessEntityReport?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityReportCreateDeleteFolder?: boolean | null;
  accessEntityReportDeleteNotOwned?: boolean | null;
  accessEntityReportDeleteOwned?: boolean | null;
  accessEntityReportPrivate?: boolean | null;
  accessEntityReportScheduleCreate?: boolean | null;
  accessEntityReportScheduleManagement?: boolean | null;
  accessEntityReportSharingCustom?: boolean | null;
  accessEntityReportSharingPublic?: boolean | null;
  accessEntityTarget?: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityTargetDeleteNotOwned?: boolean | null;
  accessEntityTargetDeleteOwned?: boolean | null;
  accessEntityTask?: AccessLevelEntityEnum | null;
  accessEntityTaskDelete?: boolean | null;
  accessEntityTaskDirection?: AccessDirectionEnum | null;
  accessEntityTaskTagCreate?: boolean | null;
  accessEntityTaskUnassigned?: boolean | null;
  accessExport?: boolean | null;
  accessFeeds?: boolean | null;
  accessForeignCurrencies?: boolean | null;
  accessFormAndFields?: boolean | null;
  accessGlobalSettings?: boolean | null;
  accessHomeScreen?: boolean | null;
  accessImport?: boolean | null;
  accessInsights?: boolean | null;
  accessLeads?: boolean | null;
  accessOnlineForms?: boolean | null;
  accessOnlineFormsManagement?: boolean | null;
  accessOpportunity?: boolean | null;
  accessPipelineConfiguration?: boolean | null;
  accessPrint?: boolean | null;
  accessProductsServices?: boolean | null;
  accessProjects?: boolean | null;
  accessQuotes?: boolean | null;
  accessSalesRoles?: boolean | null;
  accessSecurity?: boolean | null;
  accessUnits?: boolean | null;
  accessUserAndRoles?: boolean | null;
  accessVoyagerAi?: boolean | null;
  accessWhatsAppCompanyPhone?: AccessLevelCompanyEmailsEnum | null;
  allowedAccountTypes?: CreateAllowedAccountTypeNoMasterRightBackrefInput[] | null;
  allowedCompanyEmails?: CreateAllowedCompanyEmailNoMasterRightBackrefInput[] | null;
  allowedCompanyPhones?: CreateAllowedCompanyPhoneNoMasterRightBackrefInput[] | null;
  allowedContactTypes?: CreateAllowedContactTypeNoMasterRightBackrefInput[] | null;
  allowedLeadTypes?: CreateAllowedLeadTypeNoMasterRightBackrefInput[] | null;
  allowedPipelines?: CreateAllowedPipelineNoMasterRightBackrefInput[] | null;
  allowedQuoteTypes?: CreateAllowedQuoteTypeNoMasterRightBackrefInput[] | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntities?: CustomEntityMasterRightParams[] | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateLifeCycleProfileInput {
  __typename?: 'CreateLifeCycleProfileInput';
  clientMutationId?: string | null;
  data?: LifeCycleProfileDataInput | null;
  name: string;
}

export interface CreateLeadProfileInput {
  __typename?: 'CreateLeadProfileInput';
  clientMutationId?: string | null;
  data?: LeadProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateLeadProcessInput {
  __typename?: 'CreateLeadProcessInput';
  clientMutationId?: string | null;
  color?: number | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  steps: CreateStepNoLeadProcessBackrefInput[];
}

export interface CreateLeadOpptyStepCheckListRelationInput {
  __typename?: 'CreateLeadOpptyStepCheckListRelationInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  emailId?: ID | null;
  itemChecked?: boolean | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  note?: CreateNoteInput | null;
  noteId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  stepChecklistId: ID;
}

export interface CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput {
  __typename?: 'CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateLeadOpptySharingSalesUnitRelationInput {
  __typename?: 'CreateLeadOpptySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  leadOpptyId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput {
  __typename?: 'CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateLeadOpptySharingClientRelationInput {
  __typename?: 'CreateLeadOpptySharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  leadOpptyId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateLeadOpptyKPIInput {
  __typename?: 'CreateLeadOpptyKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  kpi: LeadOpptyKpiEnum;
  leadOpptyId: ID;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput {
  __typename?: 'CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
}

export interface CreateLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'CreateLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  leadOpptyContactRelation?: CreateLeadOpptyContactRelationInput | null;
  leadOpptyContactRelationId?: ID | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
}

export interface CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput {
  __typename?: 'CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput';
  comment?: string | null;
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
  salesRoles?: CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput[] | null;
}

export interface CreateLeadOpptyContactRelationInput {
  __typename?: 'CreateLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  contactId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId: ID;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
  salesRoles?: CreateLeadOpptyContactSalesRoleRelationNoLeadOpptyContactRelationBackrefInput[] | null;
}

export interface CreateLeadOpptyContactGroupRelationInput {
  __typename?: 'CreateLeadOpptyContactGroupRelationInput';
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  groupPosition: JSONString;
  leadOpptyId: ID;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput {
  __typename?: 'CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput';
  accountId: ID;
  created?: DateTime | null;
  isPrimary: boolean;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateLeadOpptyAccountRelationInput {
  __typename?: 'CreateLeadOpptyAccountRelationInput';
  accountId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  isPrimary: boolean;
  leadOpptyId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateLeadInput {
  __typename?: 'CreateLeadInput';
  accountRelations?: CreateLeadOpptyAccountRelationNoLeadOpptyBackrefInput[] | null;
  clientMutationId?: string | null;
  contactRelations?: CreateLeadOpptyContactRelationNoLeadOpptyBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  isArchived?: boolean | null;
  labelFlag?: number | null;
  leadSourceId?: ID | null;
  leadTypeId?: ID | null;
  lostDate?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  ownerId?: ID | null;
  quickAccountEmail?: string | null;
  quickAccountName?: string | null;
  quickAccountPhone?: string | null;
  quickContactName?: string | null;
  quickEmail?: string | null;
  quickPhone?: string | null;
  ranking?: number | null;
  reasonOfCloseDescription?: string | null;
  reasonOfCloseId?: ID | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateLeadOpptySharingClientRelationNoLeadOpptyBackrefInput[] | null;
  sharingUnits?: CreateLeadOpptySharingSalesUnitRelationNoLeadOpptyBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoLeadOpptyBackrefInput[] | null;
  stepId?: ID | null;
  tags?: CreateTagRelationNoLeadBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateLeadArchiveProfileInput {
  __typename?: 'CreateLeadArchiveProfileInput';
  clientMutationId?: string | null;
  data?: LeadArchiveProfileDataInput | null;
  name: string;
}

export interface CreateInsightsProfileInput {
  __typename?: 'CreateInsightsProfileInput';
  clientMutationId?: string | null;
  data?: InsightsProfileDataInput | null;
  name: string;
}

export interface CreateIndicatorsProfileInput {
  __typename?: 'CreateIndicatorsProfileInput';
  clientMutationId?: string | null;
  data?: IndicatorsProfileDataInput | null;
  name: string;
}

export interface CreateImportMappingMaskInput {
  __typename?: 'CreateImportMappingMaskInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  entityType: ImportMaskEntityTypeEnum;
  mapping: JSONString;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  relationTypes?: JSONString | null;
  revision?: number | null;
  shareMode?: ProfileShareMode | null;
  sharingClients?: UUID[] | null;
  sharingUnits?: UUID[] | null;
}

export interface CreateImageInput {
  __typename?: 'CreateImageInput';
  content: string;
  filename: string;
  uploadSource?: UploadSourceEnum | null;
}

export interface CreateGhostLeadOpptyContactSalesRoleRelationNoGhostLeadOpptyContactRelationBackrefInput {
  __typename?: 'CreateGhostLeadOpptyContactSalesRoleRelationNoGhostLeadOpptyContactRelationBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
}

export interface CreateGhostLeadOpptyContactSalesRoleRelationInput {
  __typename?: 'CreateGhostLeadOpptyContactSalesRoleRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostLeadOpptyContactRelation: CreateGhostLeadOpptyContactRelationInput;
  ghostLeadOpptyContactRelationId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  salesRoleId: ID;
}

export interface CreateGhostLeadOpptyContactRelationInput {
  __typename?: 'CreateGhostLeadOpptyContactRelationInput';
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact: CreateGhostContactInput;
  ghostContactId: ID;
  leadOpptyContactGroupRelation?: CreateLeadOpptyContactGroupRelationInput | null;
  leadOpptyContactGroupRelationId?: ID | null;
  leadOpptyId: ID;
  modified?: DateTime | null;
  positionInGroup?: JSONString | null;
  revision?: number | null;
  salesRoles?: CreateGhostLeadOpptyContactSalesRoleRelationNoGhostLeadOpptyContactRelationBackrefInput[] | null;
}

export interface CreateGhostContactInput {
  __typename?: 'CreateGhostContactInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  position?: string | null;
  revision?: number | null;
}

export interface CreateGhostContactAccountRelationInput {
  __typename?: 'CreateGhostContactAccountRelationInput';
  accountId: ID;
  accountRoles?: CreateGhostContactAccountAccountRoleRelationNoGhostContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  ghostContact: CreateGhostContactInput;
  ghostContactId: ID;
  isAssistant?: boolean | null;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  revision?: number | null;
}

export interface CreateGhostContactAccountAccountRoleRelationNoGhostContactAccountRelationBackrefInput {
  __typename?: 'CreateGhostContactAccountAccountRoleRelationNoGhostContactAccountRelationBackrefInput';
  accountRoleId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateGhostContactAccountAccountRoleRelationInput {
  __typename?: 'CreateGhostContactAccountAccountRoleRelationInput';
  accountRoleId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  ghostContactAccountRelation: CreateGhostContactAccountRelationInput;
  ghostContactAccountRelationId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateFormViewSharingSalesUnitRelationNoFormViewBackrefInput {
  __typename?: 'CreateFormViewSharingSalesUnitRelationNoFormViewBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateFormViewSharingSalesUnitRelationInput {
  __typename?: 'CreateFormViewSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateFormViewSharingClientRelationNoFormViewBackrefInput {
  __typename?: 'CreateFormViewSharingClientRelationNoFormViewBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateFormViewSharingClientRelationInput {
  __typename?: 'CreateFormViewSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  formViewId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateFormViewInput {
  __typename?: 'CreateFormViewInput';
  accountTypeId?: ID | null;
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  hiddenItemIds: UUID[];
  itemColors: FormViewItemColorInput[];
  leadTypeId?: ID | null;
  modified?: DateTime | null;
  name: string;
  opptyTypeId?: ID | null;
  ownerId: ID;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateFormViewSharingClientRelationNoFormViewBackrefInput[] | null;
  sharingUnits?: CreateFormViewSharingSalesUnitRelationNoFormViewBackrefInput[] | null;
  useLang?: boolean | null;
}

export interface CreateForecastInput {
  __typename?: 'CreateForecastInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  revision?: number | null;
  settings: JSONString;
  shareMode?: ShareModeEnum | null;
  shareModeParams?: number | null;
  sharedClients: UUID[];
  sharedUnits: UUID[];
}

export interface CreateFieldMappingInput {
  __typename?: 'CreateFieldMappingInput';
  operation?: FieldMappingOperationTypeEnum | null;
  sourceEntityApiName?: string | null;
  sourceEntityName: EntityNameEnum;
  targetEntityApiName?: string | null;
  targetEntityName: EntityNameEnum;
}

export interface CreateFeedProfileInput {
  __typename?: 'CreateFeedProfileInput';
  clientMutationId?: string | null;
  data?: FeedProfileDataInput | null;
  name: string;
}

export interface CreateFeedEmailProfileInput {
  __typename?: 'CreateFeedEmailProfileInput';
  clientMutationId?: string | null;
  data?: FeedEmailProfileDataInput | null;
  name: string;
}

export interface CreateFeedEmailDetailProfileInput {
  __typename?: 'CreateFeedEmailDetailProfileInput';
  clientMutationId?: string | null;
  data?: FeedEmailDetailProfileDataInput | null;
  name: string;
}

export interface CreateFeedDetailProfileInput {
  __typename?: 'CreateFeedDetailProfileInput';
  clientMutationId?: string | null;
  data?: FeedDetailProfileDataInput | null;
  name: string;
}

export interface CreateEntityScoringInput {
  __typename?: 'CreateEntityScoringInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityType: BaseEntityTypeEnum;
  isEnabled: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings: EntityScoringSettingsJSONString;
  sortOrder: number;
  useLang?: boolean | null;
}

export interface CreateEntityFitnessIndicatorInput {
  __typename?: 'CreateEntityFitnessIndicatorInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description: string;
  descriptionUseLang: boolean;
  entityFitnessId: ID;
  howToFix: string;
  howToFixUseLang: boolean;
  isEnabled: boolean;
  modified?: DateTime | null;
  name: string;
  nameUseLang: boolean;
  revision?: number | null;
  settings: FitnessIndicatorSettingsJSONString;
  type: FitnessIndicatorTypeEnum;
}

export interface CreateEmptyOfficeTemplateInput {
  __typename?: 'CreateEmptyOfficeTemplateInput';
  clientMutationId?: string | null;
  integrationType: MsStorageIntegrationTypeEnum;
  templateType: OfficeTemplateTypeEnum;
}

export interface CreateEmailTemplateSharingSalesUnitRelationNoEmailTemplateBackrefInput {
  __typename?: 'CreateEmailTemplateSharingSalesUnitRelationNoEmailTemplateBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateEmailTemplateSharingSalesUnitRelationInput {
  __typename?: 'CreateEmailTemplateSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateEmailTemplateSharingClientRelationNoEmailTemplateBackrefInput {
  __typename?: 'CreateEmailTemplateSharingClientRelationNoEmailTemplateBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateEmailTemplateSharingClientRelationInput {
  __typename?: 'CreateEmailTemplateSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailTemplateId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateEmailTemplateInput {
  __typename?: 'CreateEmailTemplateInput';
  body?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  emailTemplateFolderId?: ID | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  recentColors?: number[] | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateEmailTemplateSharingClientRelationNoEmailTemplateBackrefInput[] | null;
  sharingUnits?: CreateEmailTemplateSharingSalesUnitRelationNoEmailTemplateBackrefInput[] | null;
  sharingUrlIsEnabled?: boolean | null;
  sharingUrlSettings?: JSONString | null;
  subject: string;
  type: EmailTemplateTypeEnum;
}

export interface CreateEmailTemplateFolderInput {
  __typename?: 'CreateEmailTemplateFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  parentEmailTemplateFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateEmailSequenceInput {
  __typename?: 'CreateEmailSequenceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  settings?: EmailSequenceSchemaJSONString | null;
  type: ProcessTypeEnum;
}

export interface CreateEmailSequenceEnrolledInput {
  __typename?: 'CreateEmailSequenceEnrolledInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId: ID;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  emailSequenceActivityLogId: ID;
  emailSequenceId: ID;
  endReason?: EmailSequenceEndReasonEnum | null;
  endTime?: DateTime | null;
  excludedFromStats?: boolean | null;
  leadId?: ID | null;
  modified?: DateTime | null;
  opptyId?: ID | null;
  projectId?: ID | null;
  startTime: DateTime;
}

export interface CreateEmailSequenceActivityLogLineInput {
  __typename?: 'CreateEmailSequenceActivityLogLineInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceActivityLogId: ID;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder: number;
  status?: ProcessStatusEnum | null;
}

export interface CreateEmailSequenceActivityLogInput {
  __typename?: 'CreateEmailSequenceActivityLogInput';
  actorId?: ID | null;
  applicationId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailSequenceId: ID;
  endTime?: DateTime | null;
  isTestRun?: boolean | null;
  modified?: DateTime | null;
  startTime: DateTime;
  status: ProcessStatusEnum;
}

export interface CreateEmailInput {
  __typename?: 'CreateEmailInput';
  accountRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  additionalHeaders?: JSONString | null;
  body?: string | null;
  bodySummary?: string | null;
  cc?: string | null;
  clientMutationId?: string | null;
  companyEmailId?: ID | null;
  contactRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  contentShareMode?: ContentShareModeEnum | null;
  contentSharingClients?: CreateEmailContentSharingClientRelationNoEmailBackrefInput[] | null;
  contentSharingUnits?: CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput[] | null;
  contentType?: string | null;
  created?: DateTime | null;
  customEntityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  dateSent?: DateTime | null;
  direction: EmailDirectionEnum;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  errorCode?: number | null;
  isTracked?: boolean | null;
  leadRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  modified?: DateTime | null;
  opportunityRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  originalId?: string | null;
  ownerId?: ID | null;
  parentEmailId?: ID | null;
  projectRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  quoteRelations?: CreateMessageRelationNoMessageBackrefInput[] | null;
  revision?: number | null;
  scheduleSettings?: JSONString | null;
  sendAt?: DateTime | null;
  sender?: string | null;
  senderAccountId?: ID | null;
  senderClientId?: ID | null;
  senderContactId?: ID | null;
  sentiment?: EmailSentimentEnum | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateMessageSharingClientRelationNoMessageBackrefInput[] | null;
  sharingUnits?: CreateMessageSharingSalesUnitRelationNoMessageBackrefInput[] | null;
  subject?: string | null;
  tags?: CreateTagRelationNoEmailBackrefInput[] | null;
  templateId?: ID | null;
  threadId?: ID | null;
  to?: string | null;
  type?: EmailTypeEnum | null;
  uid: string;
}

export interface CreateEmailEventInput {
  __typename?: 'CreateEmailEventInput';
  additionalData?: JSONString | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId: ID;
  modified?: DateTime | null;
  type?: EmailEventTypeEnum | null;
  url?: string | null;
}

export interface CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput {
  __typename?: 'CreateEmailContentSharingSalesUnitRelationNoEmailBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateEmailContentSharingSalesUnitRelationInput {
  __typename?: 'CreateEmailContentSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateEmailContentSharingClientRelationNoEmailBackrefInput {
  __typename?: 'CreateEmailContentSharingClientRelationNoEmailBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateEmailContentSharingClientRelationInput {
  __typename?: 'CreateEmailContentSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  emailId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateDraftWebresourceInput {
  __typename?: 'CreateDraftWebresourceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  displayParam: number;
  entity: string;
  modified?: DateTime | null;
  name: string;
  requestMethod?: RequestMethodEnum | null;
  revision?: number | null;
  url?: string | null;
}

export interface CreateDraftTranslationInput {
  __typename?: 'CreateDraftTranslationInput';
  accountTypeId?: ID | null;
  appointmentTypeId?: ID | null;
  clientMutationId?: string | null;
  contactTypeId?: ID | null;
  created?: DateTime | null;
  dataId?: ID | null;
  deDe?: string | null;
  enUs?: string | null;
  esEs?: string | null;
  fieldId?: ID | null;
  formType?: FormTypeEnum | null;
  labelType: TranslationLabelTypeEnum;
  leadTypeId?: ID | null;
  modified?: DateTime | null;
  opptyProductRelationTypeId?: ID | null;
  opptyTypeId?: ID | null;
  productTypeId?: ID | null;
  projectTypeId?: ID | null;
  ptBr?: string | null;
  revision?: number | null;
  taskTypeId?: ID | null;
}

export interface CreateDraftTaskTypeInput {
  __typename?: 'CreateDraftTaskTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ActivityTypeIconEnum | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateDraftQuoteTypeInput {
  __typename?: 'CreateDraftQuoteTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formLostEnabled: boolean;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  quoteProcessId: ID;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftProjectTypeInput {
  __typename?: 'CreateDraftProjectTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ProjectTypeIconEnum | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftProductTypeInput {
  __typename?: 'CreateDraftProductTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateDraftOpportunityTypeInput {
  __typename?: 'CreateDraftOpportunityTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  pipelineId: ID;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftLeadTypeInput {
  __typename?: 'CreateDraftLeadTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  formLostEnabled: boolean;
  isReadonly: boolean;
  leadProcessId: ID;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftFieldSequenceInput {
  __typename?: 'CreateDraftFieldSequenceInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  filter?: JSONString | null;
  modified?: DateTime | null;
  pattern: string;
  sequenceSetId: ID;
  sortOrder?: number | null;
}

export interface CreateDraftFieldPermissionInput {
  __typename?: 'CreateDraftFieldPermissionInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  fieldId: ID;
  masterRightId: ID;
  modified?: DateTime | null;
  permissionLevel?: AccessLevelFieldEnum | null;
  revision?: number | null;
}

export interface CreateDraftFieldInput {
  __typename?: 'CreateDraftFieldInput';
  advancedFormula?: AdvancedFormulaPropertyParams | null;
  aiOptions?: FieldAiOptionsParams | null;
  calcFormula?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataSet?: FieldDataSetItem[] | null;
  dataSetId?: ID | null;
  defaultValue?: string | null;
  entityName: string;
  fieldPermissions?: FieldPermissionNoFieldBackrefInput[] | null;
  isUnique?: boolean | null;
  lookup?: LookupPropertyParams | null;
  mapDependency?: string | null;
  modified?: DateTime | null;
  name: string;
  nameTranslations?: JSONString | null;
  options?: FieldOptionsPropertyJSONString | null;
  parentOptionsFieldId?: ID | null;
  rollup?: RollupPropertyParams | null;
  sequence?: SequencePropertyParams | null;
  sequencePattern?: string | null;
  typeId: string;
  useInGlobalSearch?: boolean | null;
}

export interface CreateDraftDataInput {
  __typename?: 'CreateDraftDataInput';
  allowedBy?: JSONString | null;
  calcValue?: number | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataSetId: ID;
  modified?: DateTime | null;
  optionName: string;
  optionNameTranslations?: JSONString | null;
  revision?: number | null;
  sortOrder: number;
}

export interface CreateDraftCustomEntityTypeInput {
  __typename?: 'CreateDraftCustomEntityTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftCustomEntityRelationInput {
  __typename?: 'CreateDraftCustomEntityRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityFilter1?: JSONString | null;
  entityFilter2?: JSONString | null;
  field1Id: ID;
  field2Id: ID;
  hasIsPrimary?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  showRelated1?: boolean | null;
  showRelated2?: boolean | null;
  showTab1: boolean;
  showTab2: boolean;
  tabName1: string;
  tabName2: string;
}

export interface CreateDraftContactTypeInput {
  __typename?: 'CreateDraftContactTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDraftAppointmentTypeInput {
  __typename?: 'CreateDraftAppointmentTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  icon?: ActivityTypeIconEnum | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
}

export interface CreateDraftAccountTypeInput {
  __typename?: 'CreateDraftAccountTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isReadonly: boolean;
  modified?: DateTime | null;
  name: string;
  revision?: number | null;
  settings: EntityTypeSettingsJSONString;
}

export interface CreateDataInput {
  __typename?: 'CreateDataInput';
  allowedBy?: JSONString | null;
  calcValue?: number | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  dataSetId: ID;
  isPublished?: boolean | null;
  modified?: DateTime | null;
  optionName: string;
  optionNameTranslations?: JSONString | null;
  revision?: number | null;
  sortOrder: number;
}

export interface CreateCustomEntityTypeDraftInput {
  __typename?: 'CreateCustomEntityTypeDraftInput';
  entityApiName: string;
  isReadonly: boolean;
  name: string;
  settings?: EntityTypeSettingsParams | null;
}

export interface CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput {
  __typename?: 'CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateCustomEntitySharingSalesUnitRelationInput {
  __typename?: 'CreateCustomEntitySharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput {
  __typename?: 'CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateCustomEntitySharingClientRelationInput {
  __typename?: 'CreateCustomEntitySharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId: ID;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateCustomEntityRelationDataInput {
  __typename?: 'CreateCustomEntityRelationDataInput';
  account1Id?: ID | null;
  account2Id?: ID | null;
  activity1Id?: ID | null;
  activity2Id?: ID | null;
  client1Id?: ID | null;
  client2Id?: ID | null;
  clientMutationId?: string | null;
  contact1Id?: ID | null;
  contact2Id?: ID | null;
  created?: DateTime | null;
  customEntity1Id?: ID | null;
  customEntity2Id?: ID | null;
  customEntityRelationId: ID;
  isPrimary?: boolean | null;
  leadOppty1Id?: ID | null;
  leadOppty2Id?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation1?: CreateOpptyProductRelationInput | null;
  opptyProductRelation1Id?: ID | null;
  opptyProductRelation2?: CreateOpptyProductRelationInput | null;
  opptyProductRelation2Id?: ID | null;
  product1Id?: ID | null;
  product2Id?: ID | null;
  project1Id?: ID | null;
  project2Id?: ID | null;
  quote1Id?: ID | null;
  quote2Id?: ID | null;
  revision?: number | null;
}

export interface CreateCustomEntityProfileInput {
  __typename?: 'CreateCustomEntityProfileInput';
  clientMutationId?: string | null;
  data?: CustomEntityProfileDataInput | null;
  entityApiName: string;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateCustomEntityInput {
  __typename?: 'CreateCustomEntityInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  modified?: DateTime | null;
  name?: string | null;
  ownerId: ID;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateCustomEntitySharingClientRelationNoCustomEntityBackrefInput[] | null;
  sharingUnits?: CreateCustomEntitySharingSalesUnitRelationNoCustomEntityBackrefInput[] | null;
  staticProfiles?: CreateProfileRelationNoCustomEntityBackrefInput[] | null;
  typeId?: ID | null;
  unitId?: ID | null;
}

export interface CreateCustomEntityDataExRelationInput {
  __typename?: 'CreateCustomEntityDataExRelationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  customEntityId: ID;
  dataId: ID;
  dataSetId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateCurrencyInput {
  __typename?: 'CreateCurrencyInput';
  clientMutationId?: string | null;
  code: string;
  created?: DateTime | null;
  currencyExchangeRates: CreateCurrencyExchangeRateNoCurrencyBackrefInput[];
  modified?: DateTime | null;
  revision?: number | null;
  symbol?: string | null;
}

export interface CreateCurrencyExchangeRatesListInput {
  __typename?: 'CreateCurrencyExchangeRatesListInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRates: CreateCurrencyExchangeRateNoCurrencyExchangeRateListBackrefInput[];
  modified?: DateTime | null;
  revision?: number | null;
  validFrom: DateTime;
}

export interface CreateCurrencyExchangeRateNoCurrencyExchangeRateListBackrefInput {
  __typename?: 'CreateCurrencyExchangeRateNoCurrencyExchangeRateListBackrefInput';
  created?: DateTime | null;
  currencyId: ID;
  exchangeRate?: number | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateCurrencyExchangeRateNoCurrencyBackrefInput {
  __typename?: 'CreateCurrencyExchangeRateNoCurrencyBackrefInput';
  created?: DateTime | null;
  currencyExchangeRateListId: ID;
  exchangeRate?: number | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateCurrencyExchangeRateInput {
  __typename?: 'CreateCurrencyExchangeRateInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyExchangeRateListId: ID;
  currencyId: ID;
  exchangeRate?: number | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateConversionsProfileInput {
  __typename?: 'CreateConversionsProfileInput';
  clientMutationId?: string | null;
  data?: ConversionsProfileDataInput | null;
  name: string;
}

export interface CreateContactSocialRelationNoIdBackrefInput {
  __typename?: 'CreateContactSocialRelationNoIdBackrefInput';
  angellistUrl?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateContactSocialRelationInput {
  __typename?: 'CreateContactSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id: ID;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateContactSharingSalesUnitRelationNoContactBackrefInput {
  __typename?: 'CreateContactSharingSalesUnitRelationNoContactBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateContactSharingSalesUnitRelationInput {
  __typename?: 'CreateContactSharingSalesUnitRelationInput';
  clientMutationId?: string | null;
  contactId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateContactSharingClientRelationNoContactBackrefInput {
  __typename?: 'CreateContactSharingClientRelationNoContactBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateContactSharingClientRelationInput {
  __typename?: 'CreateContactSharingClientRelationInput';
  clientId: ID;
  clientMutationId?: string | null;
  contactId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateContactRelationTypeInput {
  __typename?: 'CreateContactRelationTypeInput';
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateContactRelationLabelInput {
  __typename?: 'CreateContactRelationLabelInput';
  clientMutationId?: string | null;
  contactRelation: CreateContactRelationInput;
  contactRelationId: ID;
  contactRelationTypeId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateContactRelationInput {
  __typename?: 'CreateContactRelationInput';
  clientMutationId?: string | null;
  contact1Id: ID;
  contact2Id: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateContactProfileInput {
  __typename?: 'CreateContactProfileInput';
  clientMutationId?: string | null;
  data?: ContactProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateContactKPIInput {
  __typename?: 'CreateContactKPIInput';
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId: ID;
  created?: DateTime | null;
  kpi: ContactKpiEnum;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateContactInput {
  __typename?: 'CreateContactInput';
  accountPosition?: string | null;
  accountRelations?: CreateContactAccountRelationNoContactBackrefInput[] | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  contactTypeId?: ID | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  firstName?: string | null;
  gender?: GenderEnum | null;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  lastName?: string | null;
  middleName?: string | null;
  modified?: DateTime | null;
  ownerId: ID;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  position?: string | null;
  primaryAccountAccountRoles?: UUID[] | null;
  primaryAccountRelationship?: string | null;
  quickAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateContactSharingClientRelationNoContactBackrefInput[] | null;
  sharingUnits?: CreateContactSharingSalesUnitRelationNoContactBackrefInput[] | null;
  socialMedia?: CreateContactSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoContactBackrefInput[] | null;
  tags?: CreateTagRelationNoContactBackrefInput[] | null;
  title?: string | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface CreateContactArchiveProfileInput {
  __typename?: 'CreateContactArchiveProfileInput';
  clientMutationId?: string | null;
  data?: ContactArchiveProfileDataInput | null;
  name: string;
}

export interface CreateContactAccountRelationNoContactBackrefInput {
  __typename?: 'CreateContactAccountRelationNoContactBackrefInput';
  accountId: ID;
  accountRoles?: CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput[] | null;
  comment?: string | null;
  created?: DateTime | null;
  isAssistant?: boolean | null;
  isPrimary: boolean;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
}

export interface CreateContactAccountRelationInput {
  __typename?: 'CreateContactAccountRelationInput';
  accountId: ID;
  accountRoles?: CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId: ID;
  created?: DateTime | null;
  isAssistant?: boolean | null;
  isPrimary: boolean;
  isSibling?: boolean | null;
  modified?: DateTime | null;
  position?: string | null;
  relationship?: OrgRelationshipTypeEnum | null;
  revision?: number | null;
}

export interface CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput {
  __typename?: 'CreateContactAccountAccountRoleRelationNoContactAccountRelationBackrefInput';
  accountRoleId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateContactAccountAccountRoleRelationInput {
  __typename?: 'CreateContactAccountAccountRoleRelationInput';
  accountRoleId: ID;
  clientMutationId?: string | null;
  contactAccountRelation: CreateContactAccountRelationInput;
  contactAccountRelationId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateCompanyEntityEmailInput {
  __typename?: 'CreateCompanyEntityEmailInput';
  apiKey?: string | null;
  authCode?: string | null;
  email?: string | null;
  redirectUri?: string | null;
  serviceType: EmailServiceTypeEnum;
  syncEmailReplies?: boolean | null;
}

export interface CreateCloudObjectTemplateInput {
  __typename?: 'CreateCloudObjectTemplateInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  content?: Base64 | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename: string;
  isPublic?: boolean | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: CloudObjectTemplateStatusEnum | null;
  templateEntityApiName?: string | null;
  templateEntityName: EntityNameEnum;
  type: CloudObjectTypeEnum;
  uploadSource?: UploadSourceEnum | null;
  url?: string | null;
}

export interface CreateCloudObjectStepRelationNoStepBackrefInput {
  __typename?: 'CreateCloudObjectStepRelationNoStepBackrefInput';
  cloudObject: CreateCloudObjectInput;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateCloudObjectStepRelationInput {
  __typename?: 'CreateCloudObjectStepRelationInput';
  clientMutationId?: string | null;
  cloudObject: CreateCloudObjectInput;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  sortOrder?: number | null;
  stepId: ID;
}

export interface CreateCloudObjectRelationNoBackrefInput {
  __typename?: 'CreateCloudObjectRelationNoBackrefInput';
  callId?: ID | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectFolderId?: ID | null;
  cloudObjectId?: ID | null;
  created?: DateTime | null;
  mediaId?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  revision?: number | null;
}

export interface CreateCloudObjectRelationInput {
  __typename?: 'CreateCloudObjectRelationInput';
  accountId?: ID | null;
  activityId?: ID | null;
  approvalProcessId?: ID | null;
  callId?: ID | null;
  clientMutationId?: string | null;
  cloudObject?: CreateCloudObjectInput | null;
  cloudObjectFolderId?: ID | null;
  cloudObjectId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  emailSequenceId?: ID | null;
  emailTemplateId?: ID | null;
  fieldMappingId?: ID | null;
  leadOpptyId?: ID | null;
  mediaId?: ID | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  onlineFormFieldId?: ID | null;
  onlineFormId?: ID | null;
  processId?: ID | null;
  processTemplateId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportSchedule?: CreateReportScheduleInput | null;
  reportScheduleId?: ID | null;
  revision?: number | null;
  textMessage?: CreateTextMessageInput | null;
  textMessageId?: ID | null;
}

export interface CreateCloudObjectInput {
  __typename?: 'CreateCloudObjectInput';
  applicationId?: ID | null;
  clientMutationId?: string | null;
  companyCloudObjectFolderId?: ID | null;
  content?: Base64 | null;
  created?: DateTime | null;
  creatorId?: ID | null;
  filename: string;
  isPublic?: boolean | null;
  mimeType?: string | null;
  modified?: DateTime | null;
  params?: JSONString | null;
  revision?: number | null;
  type: CloudObjectTypeEnum;
  uploadSource?: UploadSourceEnum | null;
  url?: string | null;
}

export interface CreateCloudObjectFolderInput {
  __typename?: 'CreateCloudObjectFolderInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  entityApiName?: string | null;
  entityType?: BaseEntityTypeEnum | null;
  modified?: DateTime | null;
  name: string;
  onlineFormTypeId?: ID | null;
  parentCloudObjectFolderId?: ID | null;
  revision?: number | null;
}

export interface CreateClientStoryReadInput {
  __typename?: 'CreateClientStoryReadInput';
  activityId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  messageId?: ID | null;
  modified?: DateTime | null;
  noFollow?: boolean | null;
  ownerId: ID;
  readAt: DateTime;
  revision?: number | null;
}

export interface CreateClientSettingInput {
  __typename?: 'CreateClientSettingInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  revision?: number | null;
  value: JSONString;
}

export interface CreateClientInput {
  __typename?: 'CreateClientInput';
  accountFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  appointmentFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  clientMutationId?: string | null;
  contactFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  created?: DateTime | null;
  defaultUnitId: ID;
  email: string;
  firstName?: string | null;
  lastActive?: DateTime | null;
  lastName?: string | null;
  leadFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  masterRightId: ID;
  middleName?: string | null;
  modified?: DateTime | null;
  opportunityFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  phone?: string | null;
  position?: string | null;
  profileFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  region?: string | null;
  reportFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  revision?: number | null;
  taskFavorite?: CreateClientFavoriteNoOwnerBackrefInput[] | null;
  timezone?: string | null;
  type?: ClientTypeEnum | null;
  unitMembership: CreateSalesUnitClientRelationNoClientBackrefInput[];
}

export interface CreateClientFavoriteNoOwnerBackrefInput {
  __typename?: 'CreateClientFavoriteNoOwnerBackrefInput';
  accountId?: ID | null;
  activityId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
}

export interface CreateClientFavoriteInput {
  __typename?: 'CreateClientFavoriteInput';
  accountId?: ID | null;
  activityId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  ownerId: ID;
  profileId?: ID | null;
  projectId?: ID | null;
  quoteId?: ID | null;
  reportId?: ID | null;
  revision?: number | null;
}

export interface CreateClientExcludedOpptyInput {
  __typename?: 'CreateClientExcludedOpptyInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  isExcluded: boolean;
  modified?: DateTime | null;
  opptyId: ID;
  ownerId: ID;
  revision?: number | null;
}

export interface CreateChatSuggestionInput {
  __typename?: 'CreateChatSuggestionInput';
  clientMutationId?: string | null;
  conversationId?: string | null;
  suggestionId: string;
}

export interface CreateChatConversationInput {
  __typename?: 'CreateChatConversationInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  messages?: CreateTextMessageNoChatConversationBackrefInput[] | null;
  modified?: DateTime | null;
  ownerId: ID;
  type?: ChatConversationTypeEnum | null;
}

export interface CreateCallInput {
  __typename?: 'CreateCallInput';
  accountId?: ID | null;
  audioStatus?: AudioStatus | null;
  callerId: ID;
  clientId?: ID | null;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  opptyProductRelation?: CreateOpptyProductRelationInput | null;
  opptyProductRelationId?: ID | null;
  phoneNumber?: string | null;
  productId?: ID | null;
  transcriptionId?: string | null;
  transcriptionLanguage?: string | null;
  transcriptionSummary?: string | null;
  twilioCallLogId: ID;
}

export interface CreateBetterNavigatorProfileInput {
  __typename?: 'CreateBetterNavigatorProfileInput';
  clientMutationId?: string | null;
  data?: BetterNavigatorProfileDataInput | null;
  name: string;
}

export interface CreateAutomationHubItemInput {
  __typename?: 'CreateAutomationHubItemInput';
  automationHubAppId: number;
  automationHubCategoryId: number;
  clientMutationId?: string | null;
  configurationUrl?: string | null;
  deprecatedByItemId?: number | null;
  description?: string | null;
  hasLastRun: boolean;
  hasLogs: boolean;
  integrationAnalyticsEnabled?: boolean | null;
  isBeta: boolean;
  isBundle: boolean;
  isVisible: boolean;
  logoUrl: string;
  minApiVersion: number;
  name: string;
  parentId?: ID | null;
  ranking: number;
  scope: AutomationHubScope;
  tier: AutomationHubTierEnum;
  websiteUrl?: string | null;
}

export interface CreateArchiveProfileInput {
  __typename?: 'CreateArchiveProfileInput';
  clientMutationId?: string | null;
  data?: ArchiveProfileDataInput | null;
  name: string;
}

export interface CreateApprovalProcessInput {
  __typename?: 'CreateApprovalProcessInput';
  description?: string | null;
  name: string;
  ownerId?: UUID | null;
  settings?: JSONString | null;
}

export interface CreateApprovalProcessActivityLogLineInput {
  __typename?: 'CreateApprovalProcessActivityLogLineInput';
  approvalId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  data: JSONString;
  executedAt?: DateTime | null;
  isVisible?: boolean | null;
  modified?: DateTime | null;
  sortOrder: number;
  status?: ProcessStatusEnum | null;
}

export interface CreateApprovalInput {
  __typename?: 'CreateApprovalInput';
  accountId?: ID | null;
  actorId?: ID | null;
  applicationId: ID;
  approvalProcessId: ID;
  approvalStatus?: ApprovalStatusEnum | null;
  approvers?: CreateApprovalApproverNoApprovalBackrefInput[] | null;
  clientMutationId?: string | null;
  comment?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  quoteId?: ID | null;
  revision?: number | null;
  status?: ProcessStatusEnum | null;
}

export interface CreateApprovalApproverNoApprovalBackrefInput {
  __typename?: 'CreateApprovalApproverNoApprovalBackrefInput';
  clientId: ID;
  comment?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: ApprovalStatusEnum | null;
}

export interface CreateApprovalApproverInput {
  __typename?: 'CreateApprovalApproverInput';
  approvalId: ID;
  clientId: ID;
  clientMutationId?: string | null;
  comment?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  status?: ApprovalStatusEnum | null;
}

export interface CreateAppointmentScheduleInput {
  __typename?: 'CreateAppointmentScheduleInput';
  additionalFieldsData: AppointmentScheduleAdditionalFieldParams[];
  appointmentDescription: string;
  appointmentDuration?: number | null;
  appointmentInviteesData: AppointmentScheduleInviteeParams[];
  appointmentLocation: string;
  appointmentLocationType?: AppointmentScheduleLocationTypeEnum | null;
  appointmentOwnerId: ID;
  appointmentSubject: string;
  appointmentSubjectUsesScheduleName: boolean;
  appointmentTypeId: ID;
  availabilityData: AppointmentScheduleAvailabilityParams;
  availabilityTzid?: string | null;
  bufferTimeAfter: number;
  bufferTimeBefore: number;
  clientMutationId?: string | null;
  confirmationPageType?: AppointmentScheduleConfirmationPageTypeEnum | null;
  confirmationPageUrl?: string | null;
  created?: DateTime | null;
  isEnabled: boolean;
  minimumNoticeTime: number;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  planningDayOffset: number;
  planningPeriodFrom?: GqlDate | null;
  planningPeriodTo?: GqlDate | null;
  planningType?: AppointmentSchedulePlanningTypeEnum | null;
  reminderEmailEnabled: boolean;
  reminderEmailOffset: number;
  reminderEmailOffsetType?: AppointmentScheduleReminderOffsetTypeEnum | null;
  replyCompanyEmailId?: ID | null;
  scheduleName: string;
  timeIncrement: number;
  type?: AppointmentScheduleTypeEnum | null;
  url: string;
}

export interface CreateAppointmentReminderNoAppointmentBackrefInput {
  __typename?: 'CreateAppointmentReminderNoAppointmentBackrefInput';
  created?: DateTime | null;
  endDateOffset: number;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface CreateAppointmentReminderInput {
  __typename?: 'CreateAppointmentReminderInput';
  appointmentId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  endDateOffset: number;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  snoozeDate?: DateTime | null;
  status?: ReminderStatusEnum | null;
}

export interface CreateAppointmentInput {
  __typename?: 'CreateAppointmentInput';
  accountRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  activityTypeId?: ID | null;
  clientMutationId?: string | null;
  comments?: CreateActivityCommentNoActivityBackrefInput[] | null;
  contactRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customEntityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  customFields?: JSONString | null;
  description?: string | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  duration?: number | null;
  endDate: DateTime;
  inviteesCanEdit?: boolean | null;
  inviteesClients?: CreateAppointmentClientInviteesRelationNoAppointmentBackrefInput[] | null;
  inviteesContacts?: CreateAppointmentContactInviteesRelationNoAppointmentBackrefInput[] | null;
  isRecurrenceActive?: boolean | null;
  isRecurrenceException?: boolean | null;
  leadRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  location?: string | null;
  mediaTranscriptionId?: UUID | null;
  meetingUrl?: AppointmentMeetingInput | null;
  modified?: DateTime | null;
  occurenceDate?: DateTime | null;
  opportunityRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  organizer?: string | null;
  ownerId: ID;
  projectRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  quoteRelations?: CreateActivityRelationNoActivityBackrefInput[] | null;
  recurrenceMasterId?: ID | null;
  recurrenceRule?: string | null;
  recurrenceTzid?: string | null;
  reminder?: CreateAppointmentReminderNoAppointmentBackrefInput | null;
  revision?: number | null;
  scheduleId?: ID | null;
  scheduleTzid?: string | null;
  startDate?: DateTime | null;
  subject: string;
  tags?: CreateTagRelationNoAppointmentBackrefInput[] | null;
  unitId?: ID | null;
}

export interface CreateAppointmentContactInviteesRelationNoAppointmentBackrefInput {
  __typename?: 'CreateAppointmentContactInviteesRelationNoAppointmentBackrefInput';
  contactId?: ID | null;
  created?: DateTime | null;
  email: string;
  firstName?: string | null;
  inviteeType?: AppointmentInviteeTypeEnum | null;
  lastName?: string | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateAppointmentContactInviteesRelationInput {
  __typename?: 'CreateAppointmentContactInviteesRelationInput';
  appointmentId: ID;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  email: string;
  firstName?: string | null;
  inviteeType?: AppointmentInviteeTypeEnum | null;
  lastName?: string | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateAppointmentClientInviteesRelationNoAppointmentBackrefInput {
  __typename?: 'CreateAppointmentClientInviteesRelationNoAppointmentBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateAppointmentClientInviteesRelationInput {
  __typename?: 'CreateAppointmentClientInviteesRelationInput';
  appointmentId: ID;
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  response?: InviteeResponseEnum | null;
  revision?: number | null;
}

export interface CreateApiAccessInput {
  __typename?: 'CreateApiAccessInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  email?: string | null;
  isActive?: boolean | null;
  lastUsed?: DateTime | null;
  modified?: DateTime | null;
  name: string;
  permissions?: ApiAccessPermissionsInput | null;
}

export interface CreateAndLinkPdfToEntityInput {
  __typename?: 'CreateAndLinkPdfToEntityInput';
  clientMutationId?: string | null;
  content: string;
  entityApiName?: string | null;
  entityId: ID;
  entityName: EntityNameEnum;
  filename: string;
}

export interface CreateAllowedQuoteTypeNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedQuoteTypeNoMasterRightBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  quoteTypeId: ID;
  revision?: number | null;
}

export interface CreateAllowedQuoteTypeInput {
  __typename?: 'CreateAllowedQuoteTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  quoteTypeId: ID;
  revision?: number | null;
}

export interface CreateAllowedPipelineNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedPipelineNoMasterRightBackrefInput';
  accessStepDocuments?: boolean | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  pipelineId: ID;
  revision?: number | null;
}

export interface CreateAllowedPipelineInput {
  __typename?: 'CreateAllowedPipelineInput';
  accessStepDocuments?: boolean | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  pipelineId: ID;
  revision?: number | null;
}

export interface CreateAllowedLeadTypeNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedLeadTypeNoMasterRightBackrefInput';
  created?: DateTime | null;
  leadTypeId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedLeadTypeInput {
  __typename?: 'CreateAllowedLeadTypeInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  leadTypeId: ID;
  masterRightId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedContactTypeNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedContactTypeNoMasterRightBackrefInput';
  contactTypeId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedContactTypeInput {
  __typename?: 'CreateAllowedContactTypeInput';
  clientMutationId?: string | null;
  contactTypeId: ID;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedCompanyPhoneNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedCompanyPhoneNoMasterRightBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  phoneId: ID;
  revision?: number | null;
}

export interface CreateAllowedCompanyPhoneInput {
  __typename?: 'CreateAllowedCompanyPhoneInput';
  clientMutationId?: string | null;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  phoneId: ID;
  revision?: number | null;
}

export interface CreateAllowedCompanyEmailNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedCompanyEmailNoMasterRightBackrefInput';
  companyEmailId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedCompanyEmailInput {
  __typename?: 'CreateAllowedCompanyEmailInput';
  clientMutationId?: string | null;
  companyEmailId: ID;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedAccountTypeNoMasterRightBackrefInput {
  __typename?: 'CreateAllowedAccountTypeNoMasterRightBackrefInput';
  accountTypeId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAllowedAccountTypeInput {
  __typename?: 'CreateAllowedAccountTypeInput';
  accountTypeId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  masterRightId: ID;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateActivityRelationNoActivityBackrefInput {
  __typename?: 'CreateActivityRelationNoActivityBackrefInput';
  accountId?: ID | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  projectObjective?: CreateProjectObjectiveInput | null;
  projectObjectiveId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateActivityRelationInput {
  __typename?: 'CreateActivityRelationInput';
  accountId?: ID | null;
  activityId: ID;
  clientMutationId?: string | null;
  contactId?: ID | null;
  created?: DateTime | null;
  customEntityId?: ID | null;
  leadOpptyId?: ID | null;
  modified?: DateTime | null;
  projectId?: ID | null;
  projectObjective?: CreateProjectObjectiveInput | null;
  projectObjectiveId?: ID | null;
  quoteId?: ID | null;
  revision?: number | null;
  sortOrder?: number | null;
}

export interface CreateActivityProfileInput {
  __typename?: 'CreateActivityProfileInput';
  clientMutationId?: string | null;
  data?: ActivityProfileDataInput | null;
  name: string;
}

export interface CreateActivityKPIInput {
  __typename?: 'CreateActivityKPIInput';
  activityId: ID;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  kpi: ActivityKpiEnum;
  modified?: DateTime | null;
  ownerId?: ID | null;
  revision?: number | null;
  unitId: ID;
}

export interface CreateActivityCommentNoActivityBackrefInput {
  __typename?: 'CreateActivityCommentNoActivityBackrefInput';
  comment: string;
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
}

export interface CreateActivityCommentInput {
  __typename?: 'CreateActivityCommentInput';
  activityId: ID;
  clientMutationId?: string | null;
  comment: string;
  created?: DateTime | null;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
}

export interface CreateAccountSocialRelationNoIdBackrefInput {
  __typename?: 'CreateAccountSocialRelationNoIdBackrefInput';
  angellistUrl?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateAccountSocialRelationInput {
  __typename?: 'CreateAccountSocialRelationInput';
  angellistUrl?: string | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  crunchbaseUrl?: string | null;
  disqusUrl?: string | null;
  facebookId?: string | null;
  facebookUrl?: string | null;
  flickrUrl?: string | null;
  foursquareUrl?: string | null;
  googleId?: string | null;
  googlePlusUrl?: string | null;
  gravatarUrl?: string | null;
  id: ID;
  kloutUrl?: string | null;
  linkedinId?: string | null;
  linkedinUrl?: string | null;
  modified?: DateTime | null;
  pinterestUrl?: string | null;
  quoraUrl?: string | null;
  redditUrl?: string | null;
  revision?: number | null;
  skypeUrl?: string | null;
  slideshareUrl?: string | null;
  twitterId?: string | null;
  twitterUrl?: string | null;
  vimeoUrl?: string | null;
  wordpressUrl?: string | null;
  xingUrl?: string | null;
  yahooUrl?: string | null;
  yelpUrl?: string | null;
  youtubeUrl?: string | null;
}

export interface CreateAccountSharingSalesUnitRelationNoAccountBackrefInput {
  __typename?: 'CreateAccountSharingSalesUnitRelationNoAccountBackrefInput';
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateAccountSharingSalesUnitRelationInput {
  __typename?: 'CreateAccountSharingSalesUnitRelationInput';
  accountId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
  unitId: ID;
}

export interface CreateAccountSharingClientRelationNoAccountBackrefInput {
  __typename?: 'CreateAccountSharingClientRelationNoAccountBackrefInput';
  clientId: ID;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateAccountSharingClientRelationInput {
  __typename?: 'CreateAccountSharingClientRelationInput';
  accountId: ID;
  clientId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
  role?: SharingRoleEnum | null;
}

export interface CreateAccountRoleInput {
  __typename?: 'CreateAccountRoleInput';
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  label: string;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAccountRelationTypeInput {
  __typename?: 'CreateAccountRelationTypeInput';
  clientMutationId?: string | null;
  color: number;
  created?: DateTime | null;
  label?: string | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAccountRelationLabelInput {
  __typename?: 'CreateAccountRelationLabelInput';
  accountRelation: CreateAccountRelationInput;
  accountRelationId: ID;
  accountRelationTypeId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAccountRelationInput {
  __typename?: 'CreateAccountRelationInput';
  account1Id: ID;
  account2Id: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  modified?: DateTime | null;
  revision?: number | null;
}

export interface CreateAccountProfileInput {
  __typename?: 'CreateAccountProfileInput';
  clientMutationId?: string | null;
  data?: AccountProfileDataInput | null;
  name: string;
  staticDataInput?: BulkOperationInput | null;
  type?: ProfileTypeEnum | null;
}

export interface CreateAccountProductPricingInput {
  __typename?: 'CreateAccountProductPricingInput';
  accountId: ID;
  clientMutationId?: string | null;
  created?: DateTime | null;
  currencyId: ID;
  modified?: DateTime | null;
  price?: number | null;
  productId: ID;
  revision?: number | null;
}

export interface CreateAccountKPIInput {
  __typename?: 'CreateAccountKPIInput';
  accountId: ID;
  applicationId?: ID | null;
  clientId?: ID | null;
  clientMutationId?: string | null;
  created?: DateTime | null;
  kpi: AccountKpiEnum;
  modified?: DateTime | null;
  ownerId: ID;
  revision?: number | null;
  unitId?: ID | null;
}

export interface CreateAccountInput {
  __typename?: 'CreateAccountInput';
  accountClass?: AccountClassEnum | null;
  accountTypeId?: ID | null;
  address?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  comments?: string | null;
  country?: string | null;
  created?: DateTime | null;
  currencyExchangeRatesListId?: ID | null;
  customFields?: JSONString | null;
  customerTypeId?: ID | null;
  documents?: CreateCloudObjectRelationNoBackrefInput[] | null;
  email1?: string | null;
  email2?: string | null;
  email3?: string | null;
  email4?: string | null;
  email5?: string | null;
  homePage?: string | null;
  industryId?: ID | null;
  isArchived?: boolean | null;
  isUnsubscribed?: boolean | null;
  modified?: DateTime | null;
  name: string;
  ownerId: ID;
  parentAccountId?: ID | null;
  parentAccountRelationTypeId?: ID | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  phone5?: string | null;
  picture?: CreateCloudObjectInput | null;
  pictureId?: ID | null;
  quickParentAccountName?: string | null;
  revision?: number | null;
  shareMode?: ShareModeEnum | null;
  sharingClients?: CreateAccountSharingClientRelationNoAccountBackrefInput[] | null;
  sharingUnits?: CreateAccountSharingSalesUnitRelationNoAccountBackrefInput[] | null;
  socialMedia?: CreateAccountSocialRelationNoIdBackrefInput | null;
  stateProvince?: string | null;
  staticProfiles?: CreateProfileRelationNoAccountBackrefInput[] | null;
  tags?: CreateTagRelationNoAccountBackrefInput[] | null;
  unitId?: ID | null;
  zipCode?: string | null;
}

export interface CreateAccountArchiveProfileInput {
  __typename?: 'CreateAccountArchiveProfileInput';
  clientMutationId?: string | null;
  data?: AccountArchiveProfileDataInput | null;
  name: string;
}

export interface CpClientOrderByInput {
  __typename?: 'CpClientOrderByInput';
  email?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
}

export interface CpClientFilterInput {
  __typename?: 'CpClientFilterInput';
  AND?: CpClientFilterInput[] | null;
  NOT?: CpClientFilterInput | null;
  OR?: CpClientFilterInput[] | null;
  email?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  isDeleted?: boolean | null;
  spaces?: TeamSpaceFilterInput | null;
}

export interface CopyTaskTypeInput {
  __typename?: 'CopyTaskTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyTaskInput {
  __typename?: 'CopyTaskInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyTargetInput {
  __typename?: 'CopyTargetInput';
  clientMutationId?: string | null;
  id: UUID;
  name: string;
}

export interface CopyReportInput {
  __typename?: 'CopyReportInput';
  clientMutationId?: string | null;
  copySchedule?: boolean | null;
  copySharing?: boolean | null;
  id: ID;
  name: string;
  settings?: ReportSchemaJSONString | null;
}

export interface CopyQuoteTypeInput {
  __typename?: 'CopyQuoteTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyQuoteStaticProfileInput {
  __typename?: 'CopyQuoteStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyQuoteProcessInput {
  __typename?: 'CopyQuoteProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyQuoteInput {
  __typename?: 'CopyQuoteInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
  targetStepId?: ID | null;
}

export interface CopyProjectTypeInput {
  __typename?: 'CopyProjectTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyProjectStaticProfileInput {
  __typename?: 'CopyProjectStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyProjectObjectiveInput {
  __typename?: 'CopyProjectObjectiveInput';
  clientMutationId?: string | null;
  copyTasks: boolean;
  id: ID;
}

export interface CopyProjectInput {
  __typename?: 'CopyProjectInput';
  clientMutationId?: string | null;
  id: ID;
  objectivesAndTasks?: boolean | null;
  skipCopySuffix?: boolean | null;
}

export interface CopyProductTypeInput {
  __typename?: 'CopyProductTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyProcessInput {
  __typename?: 'CopyProcessInput';
  clientMutationId?: string | null;
  description?: string | null;
  id: ID;
  name: string;
  ownerId?: UUID | null;
  settings?: ProcessSchemaJSONString | null;
  type?: ProcessTypeEnum | null;
}

export interface CopyPipelineInput {
  __typename?: 'CopyPipelineInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyOpportunityStaticProfileInput {
  __typename?: 'CopyOpportunityStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyOpportunityInput {
  __typename?: 'CopyOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
  targetStepId?: ID | null;
}

export interface CopyNoteInput {
  __typename?: 'CopyNoteInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyLeadTypeInput {
  __typename?: 'CopyLeadTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyLeadStaticProfileInput {
  __typename?: 'CopyLeadStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyLeadProcessInput {
  __typename?: 'CopyLeadProcessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyLeadInput {
  __typename?: 'CopyLeadInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
}

export interface CopyCustomEntityTypeInput {
  __typename?: 'CopyCustomEntityTypeInput';
  clientMutationId?: string | null;
  entityApiName: string;
  id: ID;
}

export interface CopyCustomEntityStaticProfileInput {
  __typename?: 'CopyCustomEntityStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyCustomEntityInput {
  __typename?: 'CopyCustomEntityInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
}

export interface CopyContactTypeInput {
  __typename?: 'CopyContactTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyContactStaticProfileInput {
  __typename?: 'CopyContactStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyContactInput {
  __typename?: 'CopyContactInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
}

export interface CopyAppointmentTypeInput {
  __typename?: 'CopyAppointmentTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyAppointmentInput {
  __typename?: 'CopyAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyApiAccessInput {
  __typename?: 'CopyApiAccessInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyAccountTypeInput {
  __typename?: 'CopyAccountTypeInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface CopyAccountStaticProfileInput {
  __typename?: 'CopyAccountStaticProfileInput';
  clientMutationId?: string | null;
  id: ID;
  name?: string | null;
}

export interface CopyAccountInput {
  __typename?: 'CopyAccountInput';
  clientMutationId?: string | null;
  id: ID;
  skipCopySuffix?: boolean | null;
}

export interface ConversionsProfileViewTabParams {
  __typename?: 'ConversionsProfileViewTabParams';
  calculateOpptyByFieldId?: UUID | null;
  conversionValue: ConversionValueType;
  period: PeriodOptionParams;
  reportBy: ConversionReportBy;
}

export interface ConversionsProfileParams {
  __typename?: 'ConversionsProfileParams';
  filter: OpportunityKPIFilterTabParams;
  leadProcess?: UUID[] | null;
  quickFilter: QuickFilterTabParams;
  salesPipeline?: ID[] | null;
  view: ConversionsProfileViewTabParams;
}

export interface ConversionsProfileDataInput {
  __typename?: 'ConversionsProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: ConversionsProfileParams;
}

export interface ContentShareModeEnumFilterInput {
  __typename?: 'ContentShareModeEnumFilterInput';
  NOT?: ContentShareModeEnumFilterInput | null;
  eq?: ContentShareModeEnum[] | null;
}

export interface ContentShareModeConfigEnumFilterInput {
  __typename?: 'ContentShareModeConfigEnumFilterInput';
  NOT?: ContentShareModeConfigEnumFilterInput | null;
  eq?: ContentShareModeConfigEnum[] | null;
}

export interface ContactTypeOrderByNestedInput {
  __typename?: 'ContactTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactTypeOrderByInput {
  __typename?: 'ContactTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactTypeFilterInput {
  __typename?: 'ContactTypeFilterInput';
  AND?: ContactTypeFilterInput[] | null;
  NOT?: ContactTypeFilterInput | null;
  OR?: ContactTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactTabDataGridViewOptionsParams {
  __typename?: 'ContactTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByStats?: AccountContactTabDataGridQuickFilterParams | null;
  filterByTags?: ID[] | null;
  relatedContacts: boolean;
  searchQuery?: string | null;
  showArchivedRecords?: boolean | null;
}

export interface ContactSocialRelationOrderByNestedInput {
  __typename?: 'ContactSocialRelationOrderByNestedInput';
  angellistUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  crunchbaseUrl?: OrderByEnum | null;
  disqusUrl?: OrderByEnum | null;
  facebookUrl?: OrderByEnum | null;
  flickrUrl?: OrderByEnum | null;
  foursquareUrl?: OrderByEnum | null;
  googlePlusUrl?: OrderByEnum | null;
  gravatarUrl?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  kloutUrl?: OrderByEnum | null;
  linkedinUrl?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pinterestUrl?: OrderByEnum | null;
  quoraUrl?: OrderByEnum | null;
  redditUrl?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  skypeUrl?: OrderByEnum | null;
  slideshareUrl?: OrderByEnum | null;
  twitterUrl?: OrderByEnum | null;
  vimeoUrl?: OrderByEnum | null;
  wordpressUrl?: OrderByEnum | null;
  xingUrl?: OrderByEnum | null;
  yahooUrl?: OrderByEnum | null;
  yelpUrl?: OrderByEnum | null;
  youtubeUrl?: OrderByEnum | null;
}

export interface ContactSocialRelationOrderByInput {
  __typename?: 'ContactSocialRelationOrderByInput';
  angellistUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  crunchbaseUrl?: OrderByEnum | null;
  disqusUrl?: OrderByEnum | null;
  facebookUrl?: OrderByEnum | null;
  flickrUrl?: OrderByEnum | null;
  foursquareUrl?: OrderByEnum | null;
  googlePlusUrl?: OrderByEnum | null;
  gravatarUrl?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  kloutUrl?: OrderByEnum | null;
  linkedinUrl?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pinterestUrl?: OrderByEnum | null;
  quoraUrl?: OrderByEnum | null;
  redditUrl?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  skypeUrl?: OrderByEnum | null;
  slideshareUrl?: OrderByEnum | null;
  twitterUrl?: OrderByEnum | null;
  vimeoUrl?: OrderByEnum | null;
  wordpressUrl?: OrderByEnum | null;
  xingUrl?: OrderByEnum | null;
  yahooUrl?: OrderByEnum | null;
  yelpUrl?: OrderByEnum | null;
  youtubeUrl?: OrderByEnum | null;
}

export interface ContactSocialRelationFilterInput {
  __typename?: 'ContactSocialRelationFilterInput';
  AND?: ContactSocialRelationFilterInput[] | null;
  NOT?: ContactSocialRelationFilterInput | null;
  OR?: ContactSocialRelationFilterInput[] | null;
  angellistUrl?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  crunchbaseUrl?: EntityFilterStringField | null;
  disqusUrl?: EntityFilterStringField | null;
  facebookId?: EntityFilterStringField | null;
  facebookUrl?: EntityFilterStringField | null;
  flickrUrl?: EntityFilterStringField | null;
  foursquareUrl?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  googleId?: EntityFilterStringField | null;
  googlePlusUrl?: EntityFilterStringField | null;
  gravatarUrl?: EntityFilterStringField | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kloutUrl?: EntityFilterStringField | null;
  linkedinId?: EntityFilterStringField | null;
  linkedinUrl?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  pinterestUrl?: EntityFilterStringField | null;
  quoraUrl?: EntityFilterStringField | null;
  redditUrl?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  skypeUrl?: EntityFilterStringField | null;
  slideshareUrl?: EntityFilterStringField | null;
  twitterId?: EntityFilterStringField | null;
  twitterUrl?: EntityFilterStringField | null;
  vimeoUrl?: EntityFilterStringField | null;
  wordpressUrl?: EntityFilterStringField | null;
  xingUrl?: EntityFilterStringField | null;
  yahooUrl?: EntityFilterStringField | null;
  yelpUrl?: EntityFilterStringField | null;
  youtubeUrl?: EntityFilterStringField | null;
}

export interface ContactSharingSalesUnitRelationOrderByInput {
  __typename?: 'ContactSharingSalesUnitRelationOrderByInput';
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ContactSharingSalesUnitRelationFilterInput {
  __typename?: 'ContactSharingSalesUnitRelationFilterInput';
  AND?: ContactSharingSalesUnitRelationFilterInput[] | null;
  NOT?: ContactSharingSalesUnitRelationFilterInput | null;
  OR?: ContactSharingSalesUnitRelationFilterInput[] | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ContactSharingClientRelationOrderByInput {
  __typename?: 'ContactSharingClientRelationOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface ContactSharingClientRelationFilterInput {
  __typename?: 'ContactSharingClientRelationFilterInput';
  AND?: ContactSharingClientRelationFilterInput[] | null;
  NOT?: ContactSharingClientRelationFilterInput | null;
  OR?: ContactSharingClientRelationFilterInput[] | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface ContactRoleTabParams {
  __typename?: 'ContactRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ContactRelationTypeOrderByNestedInput {
  __typename?: 'ContactRelationTypeOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactRelationTypeOrderByInput {
  __typename?: 'ContactRelationTypeOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactRelationTypeFilterInput {
  __typename?: 'ContactRelationTypeFilterInput';
  AND?: ContactRelationTypeFilterInput[] | null;
  NOT?: ContactRelationTypeFilterInput | null;
  OR?: ContactRelationTypeFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  label?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactRelationOrderByNestedInput {
  __typename?: 'ContactRelationOrderByNestedInput';
  contact1Id?: OrderByEnum | null;
  contact2Id?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactRelationOrderByInput {
  __typename?: 'ContactRelationOrderByInput';
  contact1?: ContactOrderByNestedInput[] | null;
  contact1Id?: OrderByEnum | null;
  contact2?: ContactOrderByNestedInput[] | null;
  contact2Id?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactRelationLabelOrderByInput {
  __typename?: 'ContactRelationLabelOrderByInput';
  contactRelation?: ContactRelationOrderByNestedInput[] | null;
  contactRelationId?: OrderByEnum | null;
  contactRelationType?: ContactRelationTypeOrderByNestedInput[] | null;
  contactRelationTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactRelationLabelFilterInput {
  __typename?: 'ContactRelationLabelFilterInput';
  AND?: ContactRelationLabelFilterInput[] | null;
  NOT?: ContactRelationLabelFilterInput | null;
  OR?: ContactRelationLabelFilterInput[] | null;
  contactRelation?: ContactRelationFilterInput | null;
  contactRelationId?: EntityFilterStringField | null;
  contactRelationType?: ContactRelationTypeFilterInput | null;
  contactRelationTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactRelationFilterInput {
  __typename?: 'ContactRelationFilterInput';
  AND?: ContactRelationFilterInput[] | null;
  NOT?: ContactRelationFilterInput | null;
  OR?: ContactRelationFilterInput[] | null;
  contact1?: ContactFilterInput | null;
  contact1Id?: EntityFilterStringField | null;
  contact2?: ContactFilterInput | null;
  contact2Id?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactProfileDataInput {
  __typename?: 'ContactProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: ContactPreviewProfileParams;
}

export interface ContactPreviewViewTabParams {
  __typename?: 'ContactPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ContactPreviewProfileParams {
  __typename?: 'ContactPreviewProfileParams';
  filter: ContactFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: ContactRoleTabParams;
  view: ContactPreviewViewTabParams;
}

export interface ContactOrderByNestedInput {
  __typename?: 'ContactOrderByNestedInput';
  address?: OrderByEnum | null;
  city?: OrderByEnum | null;
  comments?: OrderByEnum | null;
  contactTypeId?: OrderByEnum | null;
  country?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  email1?: OrderByEnum | null;
  email2?: OrderByEnum | null;
  email3?: OrderByEnum | null;
  email4?: OrderByEnum | null;
  email5?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  firstName?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  gender?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastName?: OrderByEnum | null;
  middleName?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  phone1?: OrderByEnum | null;
  phone2?: OrderByEnum | null;
  phone3?: OrderByEnum | null;
  phone4?: OrderByEnum | null;
  phone5?: OrderByEnum | null;
  position?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  stateProvince?: OrderByEnum | null;
  title?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
  zipCode?: OrderByEnum | null;
}

export interface ContactOrderByInput {
  __typename?: 'ContactOrderByInput';
  address?: OrderByEnum | null;
  city?: OrderByEnum | null;
  comments?: OrderByEnum | null;
  contactType?: ContactTypeOrderByNestedInput[] | null;
  contactTypeId?: OrderByEnum | null;
  country?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  email1?: OrderByEnum | null;
  email2?: OrderByEnum | null;
  email3?: OrderByEnum | null;
  email4?: OrderByEnum | null;
  email5?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  firstName?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  gender?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastName?: OrderByEnum | null;
  middleName?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  phone1?: OrderByEnum | null;
  phone2?: OrderByEnum | null;
  phone3?: OrderByEnum | null;
  phone4?: OrderByEnum | null;
  phone5?: OrderByEnum | null;
  position?: OrderByEnum | null;
  quickAccountName?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  socialMedia?: ContactSocialRelationOrderByNestedInput[] | null;
  stateProvince?: OrderByEnum | null;
  title?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
  zipCode?: OrderByEnum | null;
}

export interface ContactLineOfInfluenceInput {
  __typename?: 'ContactLineOfInfluenceInput';
  comment?: string | null;
  contact1Id: UUID;
  contact2Id: UUID;
  type?: InfluenceTypeEnum | null;
}

export interface ContactKpiEnumFilterInput {
  __typename?: 'ContactKpiEnumFilterInput';
  NOT?: ContactKpiEnumFilterInput | null;
  eq?: ContactKpiEnum[] | null;
}

export interface ContactKPIOrderByInput {
  __typename?: 'ContactKPIOrderByInput';
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ContactKPIFilterInput {
  __typename?: 'ContactKPIFilterInput';
  AND?: ContactKPIFilterInput[] | null;
  NOT?: ContactKPIFilterInput | null;
  OR?: ContactKPIFilterInput[] | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: ContactKpiEnumFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ContactFilterTabParams {
  __typename?: 'ContactFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ContactFilterInput {
  __typename?: 'ContactFilterInput';
  AND?: ContactFilterInput[] | null;
  NOT?: ContactFilterInput | null;
  OR?: ContactFilterInput[] | null;
  accountRelations?: ContactAccountRelationFilterInput | null;
  address?: EntityFilterStringField | null;
  city?: EntityFilterStringField | null;
  comments?: EntityFilterStringField | null;
  contactType?: ContactTypeFilterInput | null;
  contactTypeId?: EntityFilterStringField | null;
  country?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  email1?: EntityFilterStringField | null;
  email2?: EntityFilterStringField | null;
  email3?: EntityFilterStringField | null;
  email4?: EntityFilterStringField | null;
  email5?: EntityFilterStringField | null;
  enrolledEmailSequences?: number | null;
  exchangeEntityId?: string | null;
  firstName?: EntityFilterStringField | null;
  gapiEntityId?: string | null;
  gender?: GenderEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isArchived?: boolean | null;
  isDeleted?: boolean | null;
  lastName?: EntityFilterStringField | null;
  middleName?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  o365EntityId?: string | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  phone1?: EntityFilterStringField | null;
  phone2?: EntityFilterStringField | null;
  phone3?: EntityFilterStringField | null;
  phone4?: EntityFilterStringField | null;
  phone5?: EntityFilterStringField | null;
  picture?: CloudObjectFilterInput | null;
  pictureId?: EntityFilterStringField | null;
  position?: EntityFilterStringField | null;
  primaryAccount?: AccountFilterInput | null;
  quickAccountName?: EntityFilterStringField | null;
  relatedEntities?: EntityFilterRelatedField[] | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: ContactSharingClientRelationFilterInput | null;
  sharingUnits?: ContactSharingSalesUnitRelationFilterInput | null;
  socialMedia?: ContactSocialRelationFilterInput | null;
  stateProvince?: EntityFilterStringField | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  tags?: TagRelationFilterInput | null;
  title?: EntityFilterStringField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
  zipCode?: EntityFilterStringField | null;
}

export interface ContactDrilldownFilterParams {
  __typename?: 'ContactDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface ContactDataExRelationOrderByInput {
  __typename?: 'ContactDataExRelationOrderByInput';
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactDataExRelationFilterInput {
  __typename?: 'ContactDataExRelationFilterInput';
  AND?: ContactDataExRelationFilterInput[] | null;
  NOT?: ContactDataExRelationFilterInput | null;
  OR?: ContactDataExRelationFilterInput[] | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactDashboardProfileViewParams {
  __typename?: 'ContactDashboardProfileViewParams';
  drilldownFields: ID[];
  graphs: DashboardGraphContactNameType[];
}

export interface ContactDashboardProfileParams {
  __typename?: 'ContactDashboardProfileParams';
  filter: ContactFilterTabParams;
  role: ContactRoleTabParams;
  view: ContactDashboardProfileViewParams;
}

export interface ContactArchiveProfileParams {
  __typename?: 'ContactArchiveProfileParams';
  filter: ContactFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: ContactRoleTabParams;
  view: ContactPreviewViewTabParams;
}

export interface ContactArchiveProfileDataInput {
  __typename?: 'ContactArchiveProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: ContactArchiveProfileParams;
}

export interface ContactAccountRelationOrderByNestedInput {
  __typename?: 'ContactAccountRelationOrderByNestedInput';
  accountId?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isAssistant?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  isSibling?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  position?: OrderByEnum | null;
  relationship?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactAccountRelationOrderByInput {
  __typename?: 'ContactAccountRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isAssistant?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPrimary?: OrderByEnum | null;
  isSibling?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  position?: OrderByEnum | null;
  relationship?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactAccountRelationFilterInput {
  __typename?: 'ContactAccountRelationFilterInput';
  AND?: ContactAccountRelationFilterInput[] | null;
  NOT?: ContactAccountRelationFilterInput | null;
  OR?: ContactAccountRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  accountRoles?: ContactAccountAccountRoleRelationFilterInput | null;
  comment?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isAssistant?: boolean | null;
  isDeleted?: boolean | null;
  isPrimary?: boolean | null;
  isSibling?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  position?: EntityFilterStringField | null;
  relationship?: OrgRelationshipTypeEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface ContactAccountAccountRoleRelationOrderByInput {
  __typename?: 'ContactAccountAccountRoleRelationOrderByInput';
  accountRole?: AccountRoleOrderByNestedInput[] | null;
  accountRoleId?: OrderByEnum | null;
  contactAccountRelation?: ContactAccountRelationOrderByNestedInput[] | null;
  contactAccountRelationId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ContactAccountAccountRoleRelationFilterInput {
  __typename?: 'ContactAccountAccountRoleRelationFilterInput';
  AND?: ContactAccountAccountRoleRelationFilterInput[] | null;
  NOT?: ContactAccountAccountRoleRelationFilterInput | null;
  OR?: ContactAccountAccountRoleRelationFilterInput[] | null;
  accountRole?: AccountRoleFilterInput | null;
  accountRoleId?: EntityFilterStringField | null;
  contactAccountRelation?: ContactAccountRelationFilterInput | null;
  contactAccountRelationId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ConfigureTeamPipelineHubItemInput {
  __typename?: 'ConfigureTeamPipelineHubItemInput';
  clientMutationId?: string | null;
  configuration?: JSONString | null;
  id: ID;
}

export interface ConfigureSyncIntegrationTeamPipelineHubItemInput {
  __typename?: 'ConfigureSyncIntegrationTeamPipelineHubItemInput';
  clientMutationId?: string | null;
  configuration?: HubItemIntegrationSyncConfigParams | null;
  id: ID;
}

export interface CompleteTasksProjectInput {
  __typename?: 'CompleteTasksProjectInput';
  clientMutationId?: string | null;
  id: ID;
  projectObjectiveId?: UUID | null;
}

export interface CompleteProjectInput {
  __typename?: 'CompleteProjectInput';
  clientMutationId?: string | null;
  completeTasks: boolean;
  deleteUnstartedAppointments: boolean;
  id: ID;
  newEndDate?: GqlDate | null;
  newStartDate?: GqlDate | null;
}

export interface CompanyEmailOrderByNestedInput {
  __typename?: 'CompanyEmailOrderByNestedInput';
  created?: OrderByEnum | null;
  email?: OrderByEnum | null;
  enabled?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  pictureUrl?: OrderByEnum | null;
  serviceType?: OrderByEnum | null;
}

export interface CompanyEmailOrderByInput {
  __typename?: 'CompanyEmailOrderByInput';
  created?: OrderByEnum | null;
  email?: OrderByEnum | null;
  enabled?: OrderByEnum | null;
  errorCode?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  pictureUrl?: OrderByEnum | null;
  serviceType?: OrderByEnum | null;
}

export interface CompanyEmailFilterInput {
  __typename?: 'CompanyEmailFilterInput';
  AND?: CompanyEmailFilterInput[] | null;
  NOT?: CompanyEmailFilterInput | null;
  OR?: CompanyEmailFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  email?: EntityFilterStringField | null;
  enabled?: boolean | null;
  errorCode?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  pictureUrl?: EntityFilterStringField | null;
  serviceType?: EmailServiceTypeEnumFilterInput | null;
}

export interface CompanyDocumentsOptions {
  __typename?: 'CompanyDocumentsOptions';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  hideEmptyFolders?: boolean | null;
  newFolderIds?: UUID[] | null;
}

export interface CommonEntityRepositoryOrderByEntityRelationField {
  __typename?: 'CommonEntityRepositoryOrderByEntityRelationField';
  relatedEntities?: EntityFilterRelatedField[] | null;
  way?: OrderByEnum | null;
}

export interface CommonEntityRepositoryOrderByCustomField {
  __typename?: 'CommonEntityRepositoryOrderByCustomField';
  field?: string | null;
  way?: OrderByEnum | null;
}

export interface CloudObjectTypeEnumFilterInput {
  __typename?: 'CloudObjectTypeEnumFilterInput';
  NOT?: CloudObjectTypeEnumFilterInput | null;
  eq?: CloudObjectTypeEnum[] | null;
}

export interface CloudObjectTemplateStatusEnumFilterInput {
  __typename?: 'CloudObjectTemplateStatusEnumFilterInput';
  NOT?: CloudObjectTemplateStatusEnumFilterInput | null;
  eq?: CloudObjectTemplateStatusEnum[] | null;
}

export interface CloudObjectTemplateOrderByNestedInput {
  __typename?: 'CloudObjectTemplateOrderByNestedInput';
  applicationId?: OrderByEnum | null;
  companyCloudObjectFolderId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creatorId?: OrderByEnum | null;
  filename?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublic?: OrderByEnum | null;
  mimeType?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  size?: OrderByEnum | null;
  status?: OrderByEnum | null;
  templateEntityApiName?: OrderByEnum | null;
  templateEntityName?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface CloudObjectTemplateOrderByInput {
  __typename?: 'CloudObjectTemplateOrderByInput';
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  companyCloudObjectFolder?: CloudObjectFolderOrderByNestedInput[] | null;
  companyCloudObjectFolderId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creator?: ClientOrderByNestedInput[] | null;
  creatorId?: OrderByEnum | null;
  filename?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublic?: OrderByEnum | null;
  mimeType?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  size?: OrderByEnum | null;
  status?: OrderByEnum | null;
  templateEntityApiName?: OrderByEnum | null;
  templateEntityName?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface CloudObjectTemplateFilterInput {
  __typename?: 'CloudObjectTemplateFilterInput';
  AND?: CloudObjectTemplateFilterInput[] | null;
  NOT?: CloudObjectTemplateFilterInput | null;
  OR?: CloudObjectTemplateFilterInput[] | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  companyCloudObjectFolder?: CloudObjectFolderFilterInput | null;
  companyCloudObjectFolderId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  creator?: ClientFilterInput | null;
  creatorId?: EntityFilterStringField | null;
  filename?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublic?: boolean | null;
  mimeType?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  size?: EntityFilterNumberField | null;
  status?: CloudObjectTemplateStatusEnumFilterInput | null;
  templateEntityApiName?: string | null;
  templateEntityName?: EntityNameEnum | null;
  type?: CloudObjectTypeEnumFilterInput | null;
  uploadSource?: UploadSourceEnumFilterInput | null;
  url?: EntityFilterStringField | null;
}

export interface CloudObjectTabDataGridViewOptionsParams {
  __typename?: 'CloudObjectTabDataGridViewOptionsParams';
  filterByOwnerId?: UUID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByRecordName?: string | null;
  filterByRecordType: string[];
  hideEmptyFolders?: boolean | null;
  newFolderIds?: UUID[] | null;
  relatedDocuments: boolean;
  searchQuery?: string | null;
}

export interface CloudObjectStepRelationOrderByInput {
  __typename?: 'CloudObjectStepRelationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  step?: StepOrderByNestedInput[] | null;
  stepId?: OrderByEnum | null;
}

export interface CloudObjectStepRelationFilterInput {
  __typename?: 'CloudObjectStepRelationFilterInput';
  AND?: CloudObjectStepRelationFilterInput[] | null;
  NOT?: CloudObjectStepRelationFilterInput | null;
  OR?: CloudObjectStepRelationFilterInput[] | null;
  cloudObject?: CloudObjectFilterInput | null;
  cloudObjectId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
  step?: StepFilterInput | null;
  stepId?: EntityFilterStringField | null;
}

export interface CloudObjectRelationOrderByInput {
  __typename?: 'CloudObjectRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  approvalProcess?: ApprovalProcessOrderByNestedInput[] | null;
  approvalProcessId?: OrderByEnum | null;
  call?: CallOrderByNestedInput[] | null;
  callId?: OrderByEnum | null;
  cloudObjectFolder?: CloudObjectFolderOrderByNestedInput[] | null;
  cloudObjectFolderId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  emailSequence?: EmailSequenceOrderByNestedInput[] | null;
  emailSequenceId?: OrderByEnum | null;
  emailTemplate?: EmailTemplateOrderByNestedInput[] | null;
  emailTemplateId?: OrderByEnum | null;
  fieldMapping?: FieldMappingOrderByNestedInput[] | null;
  fieldMappingId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  media?: MediaOrderByNestedInput[] | null;
  mediaId?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  messageId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  onlineForm?: OnlineFormOrderByNestedInput[] | null;
  onlineFormField?: FieldOrderByNestedInput[] | null;
  onlineFormFieldId?: OrderByEnum | null;
  onlineFormId?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  process?: ProcessOrderByNestedInput[] | null;
  processId?: OrderByEnum | null;
  processTemplate?: ProcessTemplateOrderByNestedInput[] | null;
  processTemplateId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  reportSchedule?: ReportScheduleOrderByNestedInput[] | null;
  reportScheduleId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  textMessage?: TextMessageOrderByNestedInput[] | null;
  textMessageId?: OrderByEnum | null;
}

export interface CloudObjectRelationFilterInput {
  __typename?: 'CloudObjectRelationFilterInput';
  AND?: CloudObjectRelationFilterInput[] | null;
  NOT?: CloudObjectRelationFilterInput | null;
  OR?: CloudObjectRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  approvalProcess?: ApprovalProcessFilterInput | null;
  approvalProcessId?: EntityFilterStringField | null;
  call?: CallFilterInput | null;
  callId?: EntityFilterStringField | null;
  cloudObject?: CloudObjectFilterInput | null;
  cloudObjectFolder?: CloudObjectFolderFilterInput | null;
  cloudObjectFolderId?: EntityFilterStringField | null;
  cloudObjectId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  email?: EmailFilterInput | null;
  emailSequence?: EmailSequenceFilterInput | null;
  emailSequenceId?: EntityFilterStringField | null;
  emailTemplate?: EmailTemplateFilterInput | null;
  emailTemplateId?: EntityFilterStringField | null;
  fieldMapping?: FieldMappingFilterInput | null;
  fieldMappingId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  media?: MediaFilterInput | null;
  mediaId?: EntityFilterStringField | null;
  memo?: MemoFilterInput | null;
  messageId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  onlineForm?: OnlineFormFilterInput | null;
  onlineFormField?: FieldFilterInput | null;
  onlineFormFieldId?: EntityFilterStringField | null;
  onlineFormId?: EntityFilterStringField | null;
  oppty?: OpportunityFilterInput | null;
  process?: ProcessFilterInput | null;
  processId?: EntityFilterStringField | null;
  processTemplate?: ProcessTemplateFilterInput | null;
  processTemplateId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  reportSchedule?: ReportScheduleFilterInput | null;
  reportScheduleId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
  textMessage?: TextMessageFilterInput | null;
  textMessageId?: EntityFilterStringField | null;
}

export interface CloudObjectOrderByNestedInput {
  __typename?: 'CloudObjectOrderByNestedInput';
  applicationId?: OrderByEnum | null;
  companyCloudObjectFolderId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creatorId?: OrderByEnum | null;
  filename?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublic?: OrderByEnum | null;
  mimeType?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  size?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface CloudObjectOrderByInput {
  __typename?: 'CloudObjectOrderByInput';
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  companyCloudObjectFolder?: CloudObjectFolderOrderByNestedInput[] | null;
  companyCloudObjectFolderId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  creator?: ClientOrderByNestedInput[] | null;
  creatorId?: OrderByEnum | null;
  filename?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublic?: OrderByEnum | null;
  mimeType?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  size?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface CloudObjectMakePublicInput {
  __typename?: 'CloudObjectMakePublicInput';
  clientMutationId?: string | null;
  entityId: UUID;
}

export interface CloudObjectFolderOrderByNestedInput {
  __typename?: 'CloudObjectFolderOrderByNestedInput';
  created?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  onlineFormTypeId?: OrderByEnum | null;
  parentCloudObjectFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface CloudObjectFolderOrderByInput {
  __typename?: 'CloudObjectFolderOrderByInput';
  created?: OrderByEnum | null;
  entityApiName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  onlineFormType?: OnlineFormTypeOrderByNestedInput[] | null;
  onlineFormTypeId?: OrderByEnum | null;
  parentCloudObjectFolder?: CloudObjectFolderOrderByNestedInput[] | null;
  parentCloudObjectFolderId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface CloudObjectFolderFilterInput {
  __typename?: 'CloudObjectFolderFilterInput';
  AND?: CloudObjectFolderFilterInput[] | null;
  NOT?: CloudObjectFolderFilterInput | null;
  OR?: CloudObjectFolderFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  entityApiName?: EntityFilterStringField | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  onlineFormType?: OnlineFormTypeFilterInput | null;
  onlineFormTypeId?: EntityFilterStringField | null;
  parentCloudObjectFolder?: CloudObjectFolderFilterInput | null;
  parentCloudObjectFolderId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  type?: CloudObjectFolderType | null;
}

export interface CloudObjectFilterInput {
  __typename?: 'CloudObjectFilterInput';
  AND?: CloudObjectFilterInput[] | null;
  NOT?: CloudObjectFilterInput | null;
  OR?: CloudObjectFilterInput[] | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  companyCloudObjectFolder?: CloudObjectFolderFilterInput | null;
  companyCloudObjectFolderId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  creator?: ClientFilterInput | null;
  creatorId?: EntityFilterStringField | null;
  filename?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublic?: boolean | null;
  mimeType?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  size?: EntityFilterNumberField | null;
  type?: CloudObjectTypeEnumFilterInput | null;
  uploadSource?: UploadSourceEnumFilterInput | null;
  url?: EntityFilterStringField | null;
}

export interface CloudObjectDrilldownFilterParams {
  __typename?: 'CloudObjectDrilldownFilterParams';
  ownerId?: ID[] | null;
  period: PeriodOptionParams;
  recordName?: string | null;
  recordType: string[];
}

export interface ClientTypeEnumFilterInput {
  __typename?: 'ClientTypeEnumFilterInput';
  NOT?: ClientTypeEnumFilterInput | null;
  eq?: ClientTypeEnum[] | null;
}

export interface ClientStoryReadOrderByInput {
  __typename?: 'ClientStoryReadOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  created?: OrderByEnum | null;
  email?: EmailOrderByNestedInput[] | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  memo?: MemoOrderByNestedInput[] | null;
  messageId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  noFollow?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  readAt?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface ClientStoryReadFilterInput {
  __typename?: 'ClientStoryReadFilterInput';
  AND?: ClientStoryReadFilterInput[] | null;
  NOT?: ClientStoryReadFilterInput | null;
  OR?: ClientStoryReadFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  email?: EmailFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  memo?: MemoFilterInput | null;
  messageId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  noFollow?: boolean | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  readAt?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
}

export interface ClientSettingOrderByInput {
  __typename?: 'ClientSettingOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ClientSettingFilterInput {
  __typename?: 'ClientSettingFilterInput';
  AND?: ClientSettingFilterInput[] | null;
  NOT?: ClientSettingFilterInput | null;
  OR?: ClientSettingFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface ClientOrderByNestedInput {
  __typename?: 'ClientOrderByNestedInput';
  created?: OrderByEnum | null;
  defaultUnitId?: OrderByEnum | null;
  email?: OrderByEnum | null;
  firstName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastActive?: OrderByEnum | null;
  lastName?: OrderByEnum | null;
  masterRightId?: OrderByEnum | null;
  middleName?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  phone?: OrderByEnum | null;
  pictureUrl?: OrderByEnum | null;
  position?: OrderByEnum | null;
  region?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  timezone?: OrderByEnum | null;
}

export interface ClientOrderByInput {
  __typename?: 'ClientOrderByInput';
  created?: OrderByEnum | null;
  defaultUnit?: SalesUnitOrderByNestedInput[] | null;
  defaultUnitId?: OrderByEnum | null;
  email?: OrderByEnum | null;
  firstName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastActive?: OrderByEnum | null;
  lastName?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  middleName?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  phone?: OrderByEnum | null;
  pictureUrl?: OrderByEnum | null;
  position?: OrderByEnum | null;
  region?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  timezone?: OrderByEnum | null;
}

export interface ClientFilterInput {
  __typename?: 'ClientFilterInput';
  AND?: ClientFilterInput[] | null;
  NOT?: ClientFilterInput | null;
  OR?: ClientFilterInput[] | null;
  accountFavorite?: ClientFavoriteFilterInput | null;
  appointmentFavorite?: ClientFavoriteFilterInput | null;
  contactFavorite?: ClientFavoriteFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  defaultUnit?: SalesUnitFilterInput | null;
  defaultUnitId?: EntityFilterStringField | null;
  email?: EntityFilterStringField | null;
  firstName?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lastActive?: EntityFilterDateTimeField | null;
  lastName?: EntityFilterStringField | null;
  leadFavorite?: ClientFavoriteFilterInput | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  middleName?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: string | null;
  opportunityFavorite?: ClientFavoriteFilterInput | null;
  phone?: EntityFilterStringField | null;
  pictureUrl?: EntityFilterStringField | null;
  position?: EntityFilterStringField | null;
  profileFavorite?: ClientFavoriteFilterInput | null;
  region?: EntityFilterStringField | null;
  reportFavorite?: ClientFavoriteFilterInput | null;
  revision?: EntityFilterNumberField | null;
  taskFavorite?: ClientFavoriteFilterInput | null;
  timezone?: EntityFilterStringField | null;
  type?: ClientTypeEnumFilterInput | null;
  unitMembership?: SalesUnitClientRelationFilterInput | null;
}

export interface ClientFavoriteOrderByInput {
  __typename?: 'ClientFavoriteOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  profile?: ProfileOrderByNestedInput[] | null;
  profileId?: OrderByEnum | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  report?: ReportOrderByNestedInput[] | null;
  reportId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface ClientFavoriteFilterInput {
  __typename?: 'ClientFavoriteFilterInput';
  AND?: ClientFavoriteFilterInput[] | null;
  NOT?: ClientFavoriteFilterInput | null;
  OR?: ClientFavoriteFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  profile?: ProfileFilterInput | null;
  profileId?: EntityFilterStringField | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  report?: ReportFilterInput | null;
  reportId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
}

export interface ClientExcludedOpptyOrderByInput {
  __typename?: 'ClientExcludedOpptyOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isExcluded?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface ClientExcludedOpptyFilterInput {
  __typename?: 'ClientExcludedOpptyFilterInput';
  AND?: ClientExcludedOpptyFilterInput[] | null;
  NOT?: ClientExcludedOpptyFilterInput | null;
  OR?: ClientExcludedOpptyFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isExcluded?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  opptyId?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface CleanupEditedCloudObjectTemplatesInput {
  __typename?: 'CleanupEditedCloudObjectTemplatesInput';
  clientMutationId?: string | null;
  entityId: ID;
  sessionId: UUID;
}

export interface ChatConversationTypeEnumFilterInput {
  __typename?: 'ChatConversationTypeEnumFilterInput';
  NOT?: ChatConversationTypeEnumFilterInput | null;
  eq?: ChatConversationTypeEnum[] | null;
}

export interface ChatConversationOrderByNestedInput {
  __typename?: 'ChatConversationOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ChatConversationOrderByInput {
  __typename?: 'ChatConversationOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ChatConversationFilterInput {
  __typename?: 'ChatConversationFilterInput';
  AND?: ChatConversationFilterInput[] | null;
  NOT?: ChatConversationFilterInput | null;
  OR?: ChatConversationFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  messages?: TextMessageFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  type?: ChatConversationTypeEnumFilterInput | null;
}

export interface ChangeQuoteProcessInput {
  __typename?: 'ChangeQuoteProcessInput';
  clientMutationId?: string | null;
  entity: UpdateQuoteInput;
  keepOwnerAsEditor: boolean;
  transferLinkedRecords: boolean;
}

export interface ChangePipelineQuoteInput {
  __typename?: 'ChangePipelineQuoteInput';
  clientMutationId?: string | null;
  entity: UpdateQuoteInput;
  keepOwnerAsEditor: boolean;
  transferLinkedRecords: boolean;
}

export interface ChangePipelineOpportunityInput {
  __typename?: 'ChangePipelineOpportunityInput';
  clientMutationId?: string | null;
  entity: UpdateOpportunityInput;
  keepOwnerAsEditor: boolean;
  transferLinkedRecords: boolean;
}

export interface ChangeOwnershipTaskInput {
  __typename?: 'ChangeOwnershipTaskInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  unitId: ID;
}

export interface ChangeOwnershipReportInput {
  __typename?: 'ChangeOwnershipReportInput';
  clientMutationId?: string | null;
  copyScheduledReport: boolean;
  id: ID;
  keepOwnerAsWatcher: boolean;
  ownerId: ID;
}

export interface ChangeOwnershipQuoteInput {
  __typename?: 'ChangeOwnershipQuoteInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipProjectInput {
  __typename?: 'ChangeOwnershipProjectInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipOpportunityInput {
  __typename?: 'ChangeOwnershipOpportunityInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipLeadInput {
  __typename?: 'ChangeOwnershipLeadInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipCustomEntityInput {
  __typename?: 'ChangeOwnershipCustomEntityInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipContactInput {
  __typename?: 'ChangeOwnershipContactInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeOwnershipAppointmentInput {
  __typename?: 'ChangeOwnershipAppointmentInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsAttendee: boolean;
  ownerId: ID;
  unitId: ID;
}

export interface ChangeOwnershipAccountInput {
  __typename?: 'ChangeOwnershipAccountInput';
  clientMutationId?: string | null;
  id: ID;
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface ChangeLogUserParams {
  __typename?: 'ChangeLogUserParams';
  email?: string | null;
  firstName?: string | null;
  id?: number | null;
  isActive: boolean;
  isSystem: boolean;
  lastName?: string | null;
  middleName?: string | null;
  pictureUrl?: string | null;
}

export interface ChangeLogFilterParams {
  __typename?: 'ChangeLogFilterParams';
  applications?: ID[] | null;
  fields?: ID[] | null;
  period?: PeriodOptionParams | null;
  products?: ID[] | null;
  users?: ChangeLogUserParams[] | null;
}

export interface ChangeLeadProcessInput {
  __typename?: 'ChangeLeadProcessInput';
  clientMutationId?: string | null;
  entity: UpdateLeadInput;
  keepOwnerAsEditor: boolean;
  transferLinkedRecords: boolean;
}

export interface ChangeLabelFlagOpportunityInput {
  __typename?: 'ChangeLabelFlagOpportunityInput';
  clientMutationId?: string | null;
  hot: boolean;
  id: ID;
  priority: boolean;
  stalled: boolean;
}

export interface ChangeLabelFlagLeadInput {
  __typename?: 'ChangeLabelFlagLeadInput';
  clientMutationId?: string | null;
  hot: boolean;
  id: ID;
  priority: boolean;
  stalled: boolean;
}

export interface ChangeBaseCurrencyInput {
  __typename?: 'ChangeBaseCurrencyInput';
  clientMutationId?: string | null;
  newCode: string;
  newSymbol: string;
}

export interface CategorizeEmailsEntityParams {
  __typename?: 'CategorizeEmailsEntityParams';
  entity: EntityNameEnum;
  entityApiName?: string | null;
  id: UUID;
}

export interface CancelCallTeamSpaceClientSettingInput {
  __typename?: 'CancelCallTeamSpaceClientSettingInput';
  callId: string;
  clientMutationId?: string | null;
}

export interface CancelApprovalInput {
  __typename?: 'CancelApprovalInput';
  approvalFilter?: ApprovalFilterInput | null;
  approvalProcessIds?: UUID[] | null;
  bulkFilter?: BulkOperationInput | null;
}

export interface CallingDeactivateTeamSpaceClientSettingInput {
  __typename?: 'CallingDeactivateTeamSpaceClientSettingInput';
  clientMutationId?: string | null;
}

export interface CallOrderByNestedInput {
  __typename?: 'CallOrderByNestedInput';
  accountId?: OrderByEnum | null;
  callerId?: OrderByEnum | null;
  clientId?: OrderByEnum | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  opptyProductRelationId?: OrderByEnum | null;
  phoneNumber?: OrderByEnum | null;
  productId?: OrderByEnum | null;
  transcriptionId?: OrderByEnum | null;
  transcriptionLanguage?: OrderByEnum | null;
  transcriptionSummary?: OrderByEnum | null;
}

export interface CallOrderByInput {
  __typename?: 'CallOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  caller?: ClientOrderByNestedInput[] | null;
  callerId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  opptyProductRelation?: OpptyProductRelationOrderByNestedInput[] | null;
  opptyProductRelationId?: OrderByEnum | null;
  phoneNumber?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  transcriptionId?: OrderByEnum | null;
  transcriptionLanguage?: OrderByEnum | null;
  transcriptionSummary?: OrderByEnum | null;
}

export interface CallFilterInput {
  __typename?: 'CallFilterInput';
  AND?: CallFilterInput[] | null;
  NOT?: CallFilterInput | null;
  OR?: CallFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  caller?: ClientFilterInput | null;
  callerId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  opptyProductRelation?: OpptyProductRelationFilterInput | null;
  opptyProductRelationId?: EntityFilterStringField | null;
  phoneNumber?: EntityFilterStringField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  transcriptionId?: EntityFilterStringField | null;
  transcriptionLanguage?: EntityFilterStringField | null;
  transcriptionSummary?: EntityFilterStringField | null;
  twilioCallLogId?: EntityFilterStringField | null;
}

export interface CalendarColorUserParams {
  __typename?: 'CalendarColorUserParams';
  color: number;
  id?: UUID | null;
  name: string;
  rules: FieldFilterParams;
}

export interface CalendarColorRuleParams {
  __typename?: 'CalendarColorRuleParams';
  color: number;
  id: UUID;
  name: string;
  rules: FieldFilterParams;
}

export interface CalculatedFieldParams {
  __typename?: 'CalculatedFieldParams';
  advancedFormula: AdvancedFormulaPropertyParams;
  id: UUID;
  name: string;
}

export interface BulkUpdateOperationExtras {
  __typename?: 'BulkUpdateOperationExtras';
  keepOwnerAsEditor?: boolean | null;
  sendInvitations?: boolean | null;
}

export interface BulkUpdateOperation {
  __typename?: 'BulkUpdateOperation';
  extras?: BulkUpdateOperationExtras | null;
  fieldId: ID;
  operation?: BulkUpdateOperationEnum | null;
}

export interface BulkUpdateEntitiesInput {
  __typename?: 'BulkUpdateEntitiesInput';
  clientMutationId?: string | null;
  dataCollection: DataCollection;
  entity: EntityNameEnum;
  entityApiName?: string | null;
  errorsIncludeSkippedRecords: boolean;
  operations: BulkUpdateOperation[];
  updateInput: JSONString;
  validationLevel?: ValidationLevel | null;
}

export interface BulkUnlinkQuoteInput {
  __typename?: 'BulkUnlinkQuoteInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkProjectInput {
  __typename?: 'BulkUnlinkProjectInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkProductInput {
  __typename?: 'BulkUnlinkProductInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkOpportunityInput {
  __typename?: 'BulkUnlinkOpportunityInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkLeadOpptyInput {
  __typename?: 'BulkUnlinkLeadOpptyInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkLeadInput {
  __typename?: 'BulkUnlinkLeadInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkCustomEntityInput {
  __typename?: 'BulkUnlinkCustomEntityInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkContactInput {
  __typename?: 'BulkUnlinkContactInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkActivityInput {
  __typename?: 'BulkUnlinkActivityInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkUnlinkAccountInput {
  __typename?: 'BulkUnlinkAccountInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  lookupFieldId?: string | null;
  parentEntityId: ID;
  parentEntityType: EntityNameEnum;
  sessionId?: string | null;
}

export interface BulkRemoveTargetInput {
  __typename?: 'BulkRemoveTargetInput';
  clientMutationId?: string | null;
  groupChildIds: GroupChildIdParams[];
}

export interface BulkReleaseOwnershipLeadInput {
  __typename?: 'BulkReleaseOwnershipLeadInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkReactivateQuoteInput {
  __typename?: 'BulkReactivateQuoteInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  expirationDate?: GqlDate | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkReactivateOpportunityInput {
  __typename?: 'BulkReactivateOpportunityInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  closingDate?: GqlDate | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkReactivateLeadInput {
  __typename?: 'BulkReactivateLeadInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkReactivateContactInput {
  __typename?: 'BulkReactivateContactInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkReactivateAccountInput {
  __typename?: 'BulkReactivateAccountInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkQualifyLeadInput {
  __typename?: 'BulkQualifyLeadInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  entity: CreateOrUpdateOpportunityInput;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkOperationInput {
  __typename?: 'BulkOperationInput';
  excludedIds?: UUID[] | null;
  includedIds?: UUID[] | null;
  sessionId?: string | null;
}

export interface BulkMoveQuoteInput {
  __typename?: 'BulkMoveQuoteInput';
  archiveQuoteIds?: UUID[] | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: CreateOrUpdateQuoteInput;
  rollbackMethod?: RollbackMethod | null;
  winOpportunityIds?: UUID[] | null;
}

export interface BulkMoveOpportunityInput {
  __typename?: 'BulkMoveOpportunityInput';
  acceptQuoteIds?: UUID[] | null;
  archiveQuoteIds?: UUID[] | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: CreateOrUpdateOpportunityInput;
  memoText?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkMoveLeadInput {
  __typename?: 'BulkMoveLeadInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: CreateOrUpdateLeadInput;
  memoText?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkFinishUserTargetInput {
  __typename?: 'BulkFinishUserTargetInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteTargetInput {
  __typename?: 'BulkDeleteTargetInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteTagInput {
  __typename?: 'BulkDeleteTagInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteQuoteInput {
  __typename?: 'BulkDeleteQuoteInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteProjectInput {
  __typename?: 'BulkDeleteProjectInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteNoteInput {
  __typename?: 'BulkDeleteNoteInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteLeadOpptyInput {
  __typename?: 'BulkDeleteLeadOpptyInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteForecastInput {
  __typename?: 'BulkDeleteForecastInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteEmailInput {
  __typename?: 'BulkDeleteEmailInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteCustomEntityInput {
  __typename?: 'BulkDeleteCustomEntityInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteContactInput {
  __typename?: 'BulkDeleteContactInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteCompanyEmailInput {
  __typename?: 'BulkDeleteCompanyEmailInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteCloudObjectTemplateInput {
  __typename?: 'BulkDeleteCloudObjectTemplateInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteCloudObjectInput {
  __typename?: 'BulkDeleteCloudObjectInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteActivityInput {
  __typename?: 'BulkDeleteActivityInput';
  clientMutationId?: string | null;
  deleteRecurrenceMasters?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkDeleteAccountInput {
  __typename?: 'BulkDeleteAccountInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BulkChangeOwnershipQuoteInput {
  __typename?: 'BulkChangeOwnershipQuoteInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipProjectInput {
  __typename?: 'BulkChangeOwnershipProjectInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipOpportunityInput {
  __typename?: 'BulkChangeOwnershipOpportunityInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipLeadInput {
  __typename?: 'BulkChangeOwnershipLeadInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipCustomEntityInput {
  __typename?: 'BulkChangeOwnershipCustomEntityInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipContactInput {
  __typename?: 'BulkChangeOwnershipContactInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkChangeOwnershipActivityInput {
  __typename?: 'BulkChangeOwnershipActivityInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  unitId: ID;
}

export interface BulkChangeOwnershipAccountInput {
  __typename?: 'BulkChangeOwnershipAccountInput';
  clientMutationId?: string | null;
  errorsIncludeSkippedRecords?: boolean | null;
  excludedIds: ID[];
  includedIds: ID[];
  keepOwnerAsEditor: boolean;
  ownerId: ID;
  sessionId?: string | null;
  transferLinkedRecords: boolean;
  unitId: ID;
}

export interface BulkBackToLeadInput {
  __typename?: 'BulkBackToLeadInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  entity: CreateOrUpdateLeadInput;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkArchiveQuoteInput {
  __typename?: 'BulkArchiveQuoteInput';
  archiveOpportunityIds?: UUID[] | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  entity: CreateOrUpdateQuoteInput;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkArchiveOpportunityInput {
  __typename?: 'BulkArchiveOpportunityInput';
  archiveQuoteIds?: UUID[] | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: CreateOrUpdateOpportunityInput;
  memoText?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkArchiveLeadInput {
  __typename?: 'BulkArchiveLeadInput';
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity?: CreateOrUpdateLeadInput | null;
  memoText?: string | null;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkArchiveContactInput {
  __typename?: 'BulkArchiveContactInput';
  archiveAllRelatedLeads?: boolean | null;
  archiveAllRelatedOpportunities?: boolean | null;
  archiveAllRelatedQuotes?: boolean | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeAllRelatedLeadsTasks?: boolean | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  completeAllRelatedQuotesTasks?: boolean | null;
  completeAllRelatedTasks?: boolean | null;
  entity: CreateOrUpdateContactInput;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkArchiveAccountInput {
  __typename?: 'BulkArchiveAccountInput';
  archiveAllRelatedContacts?: boolean | null;
  archiveAllRelatedLeads?: boolean | null;
  archiveAllRelatedOpportunities?: boolean | null;
  archiveAllRelatedQuotes?: boolean | null;
  bulkFilter: BulkOperationInput;
  clientMutationId?: string | null;
  completeAllRelatedContactsTasks?: boolean | null;
  completeAllRelatedLeadsTasks?: boolean | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  completeAllRelatedProjects?: boolean | null;
  completeAllRelatedQuotesTasks?: boolean | null;
  completeAllRelatedTasks?: boolean | null;
  entity: CreateOrUpdateAccountInput;
  rollbackMethod?: RollbackMethod | null;
}

export interface BulkActivateUserTargetInput {
  __typename?: 'BulkActivateUserTargetInput';
  clientMutationId?: string | null;
  excludedIds: ID[];
  includedIds: ID[];
  sessionId?: string | null;
}

export interface BetterNavigatorProfileDataInput {
  __typename?: 'BetterNavigatorProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: BetterNavigatorPreviewProfileParams;
}

export interface BetterNavigatorPreviewProfileParams {
  __typename?: 'BetterNavigatorPreviewProfileParams';
  filter: DashboardFilterParams;
  items: DashboardItemParams[];
  role: DashboardRoleParams;
}

export interface BaseEntityTypeEnumFilterInput {
  __typename?: 'BaseEntityTypeEnumFilterInput';
  NOT?: BaseEntityTypeEnumFilterInput | null;
  eq?: BaseEntityTypeEnum[] | null;
}

export interface BackToLeadInput {
  __typename?: 'BackToLeadInput';
  clientMutationId?: string | null;
  entity: UpdateLeadInput;
}

export interface AutomationHubTierEnumFilterInput {
  __typename?: 'AutomationHubTierEnumFilterInput';
  NOT?: AutomationHubTierEnumFilterInput | null;
  eq?: AutomationHubTierEnum[] | null;
}

export interface AutomationHubScopeFilterInput {
  __typename?: 'AutomationHubScopeFilterInput';
  NOT?: AutomationHubScopeFilterInput | null;
  eq?: AutomationHubScope[] | null;
}

export interface AutomationHubItemOrderByInput {
  __typename?: 'AutomationHubItemOrderByInput';
  aclPermissionKey?: OrderByEnum | null;
  automationHubApp?: AutomationHubAppOrderByNestedInput[] | null;
  automationHubAppId?: OrderByEnum | null;
  automationHubCategory?: AutomationHubCategoryOrderByNestedInput[] | null;
  automationHubCategoryId?: OrderByEnum | null;
  configurationUrl?: OrderByEnum | null;
  deprecatedByItemId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  hasLastRun?: OrderByEnum | null;
  id?: OrderByEnum | null;
  integrationAnalyticsEnabled?: OrderByEnum | null;
  isBeta?: OrderByEnum | null;
  isBundle?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  logoUrl?: OrderByEnum | null;
  minApiVersion?: OrderByEnum | null;
  name?: OrderByEnum | null;
  parentId?: OrderByEnum | null;
  ranking?: OrderByEnum | null;
  websiteUrl?: OrderByEnum | null;
}

export interface AutomationHubItemFilterInput {
  __typename?: 'AutomationHubItemFilterInput';
  AND?: AutomationHubItemFilterInput[] | null;
  NOT?: AutomationHubItemFilterInput | null;
  OR?: AutomationHubItemFilterInput[] | null;
  aclPermissionKey?: EntityFilterStringField | null;
  automationHubApp?: AutomationHubAppFilterInput | null;
  automationHubAppId?: EntityFilterNumberField | null;
  automationHubCategory?: AutomationHubCategoryFilterInput | null;
  automationHubCategoryId?: EntityFilterNumberField | null;
  configurationUrl?: EntityFilterStringField | null;
  deprecatedByItemId?: EntityFilterNumberField | null;
  description?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  hasLastRun?: boolean | null;
  id?: EntityFilterNumberField | null;
  integrationAnalyticsEnabled?: boolean | null;
  isBeta?: boolean | null;
  isBundle?: boolean | null;
  isDeleted?: boolean | null;
  isVisible?: boolean | null;
  logoUrl?: EntityFilterStringField | null;
  minApiVersion?: EntityFilterNumberField | null;
  name?: EntityFilterStringField | null;
  parentId?: EntityFilterNumberField | null;
  ranking?: EntityFilterNumberField | null;
  scope?: AutomationHubScopeFilterInput | null;
  tier?: AutomationHubTierEnumFilterInput | null;
  websiteUrl?: EntityFilterStringField | null;
}

export interface AutomationHubCategoryOrderByNestedInput {
  __typename?: 'AutomationHubCategoryOrderByNestedInput';
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  name?: OrderByEnum | null;
}

export interface AutomationHubCategoryFilterInput {
  __typename?: 'AutomationHubCategoryFilterInput';
  AND?: AutomationHubCategoryFilterInput[] | null;
  NOT?: AutomationHubCategoryFilterInput | null;
  OR?: AutomationHubCategoryFilterInput[] | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  isDeleted?: boolean | null;
  name?: EntityFilterStringField | null;
}

export interface AutomationHubAppOrderByNestedInput {
  __typename?: 'AutomationHubAppOrderByNestedInput';
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  logoUrl?: OrderByEnum | null;
  name?: OrderByEnum | null;
  supportPrivacyUrl?: OrderByEnum | null;
  supportTermsUrl?: OrderByEnum | null;
  supportUrl?: OrderByEnum | null;
  websiteUrl?: OrderByEnum | null;
}

export interface AutomationHubAppFilterInput {
  __typename?: 'AutomationHubAppFilterInput';
  AND?: AutomationHubAppFilterInput[] | null;
  NOT?: AutomationHubAppFilterInput | null;
  OR?: AutomationHubAppFilterInput[] | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterNumberField | null;
  isDeleted?: boolean | null;
  logoUrl?: EntityFilterStringField | null;
  name?: EntityFilterStringField | null;
  supportPrivacyUrl?: EntityFilterStringField | null;
  supportTermsUrl?: EntityFilterStringField | null;
  supportUrl?: EntityFilterStringField | null;
  websiteUrl?: EntityFilterStringField | null;
}

export interface AuditLogOrderByInputParams {
  __typename?: 'AuditLogOrderByInputParams';
  actorEmail?: OrderByEnum | null;
  actorName?: OrderByEnum | null;
  applicationName?: OrderByEnum | null;
  category?: OrderByEnum | null;
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
}

export interface AuditLogFilterParams {
  __typename?: 'AuditLogFilterParams';
  actors?: AuditLogActorParams[] | null;
  applications?: ID[] | null;
  categories?: AuditLogCategoryEnum[] | null;
  period?: PeriodOptionParams | null;
  search?: string | null;
}

export interface AuditLogActorParams {
  __typename?: 'AuditLogActorParams';
  email?: string | null;
  isSystem: boolean;
  name?: string | null;
}

export interface AttachmentFileExtensionParams {
  __typename?: 'AttachmentFileExtensionParams';
  denied: boolean;
  list: string[];
}

export interface AttachCloudObjectRelationsToFormFolderInput {
  __typename?: 'AttachCloudObjectRelationsToFormFolderInput';
  clientMutationId?: string | null;
  cloudObjectRelationIds: UUID[];
  onlineFormId: UUID;
}

export interface ArchiveQuoteInput {
  __typename?: 'ArchiveQuoteInput';
  archiveOpportunityIds?: UUID[] | null;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  entity: UpdateQuoteInput;
}

export interface ArchiveProfileDataInput {
  __typename?: 'ArchiveProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: OpportunityArchiveProfileParams;
}

export interface ArchiveOpportunityInput {
  __typename?: 'ArchiveOpportunityInput';
  archiveQuoteIds?: UUID[] | null;
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  entity: UpdateOpportunityInput;
  memoText?: string | null;
}

export interface ArchiveLeadInput {
  __typename?: 'ArchiveLeadInput';
  clientMutationId?: string | null;
  completeActivityIds?: UUID[] | null;
  id: ID;
  memoText?: string | null;
}

export interface ArchiveContactInput {
  __typename?: 'ArchiveContactInput';
  archiveAllRelatedLeads: boolean;
  archiveAllRelatedOpportunities: boolean;
  archiveAllRelatedQuotes: boolean;
  clientMutationId?: string | null;
  completeAllRelatedLeadsTasks?: boolean | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  completeAllRelatedQuotesTasks?: boolean | null;
  completeAllRelatedTasks: boolean;
  entity: UpdateContactInput;
}

export interface ArchiveAccountInput {
  __typename?: 'ArchiveAccountInput';
  archiveAllRelatedContacts: boolean;
  archiveAllRelatedLeads: boolean;
  archiveAllRelatedOpportunities: boolean;
  archiveAllRelatedQuotes: boolean;
  clientMutationId?: string | null;
  completeAllRelatedContactsTasks?: boolean | null;
  completeAllRelatedLeadsTasks?: boolean | null;
  completeAllRelatedOpportunitiesTasks?: boolean | null;
  completeAllRelatedProjects: boolean;
  completeAllRelatedQuotesTasks?: boolean | null;
  completeAllRelatedTasks: boolean;
  entity: UpdateAccountInput;
}

export interface ApprovalsListingOptionsParams {
  __typename?: 'ApprovalsListingOptionsParams';
  type?: EntityNameEnum | null;
  visibility?: ApprovalScreenVisibilityEnum | null;
}

export interface ApprovalStatusEnumFilterInput {
  __typename?: 'ApprovalStatusEnumFilterInput';
  NOT?: ApprovalStatusEnumFilterInput | null;
  eq?: ApprovalStatusEnum[] | null;
}

export interface ApprovalProcessesNotificationSettingsParams {
  __typename?: 'ApprovalProcessesNotificationSettingsParams';
  ApprovalProcessError?: boolean | null;
  ApprovalProcessWarning?: boolean | null;
  ApprovalRequest: boolean;
  ApprovalResponse: boolean;
  IsActive: boolean;
}

export interface ApprovalProcessOrderByNestedInput {
  __typename?: 'ApprovalProcessOrderByNestedInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  priority?: OrderByEnum | null;
  status?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
}

export interface ApprovalProcessOrderByInput {
  __typename?: 'ApprovalProcessOrderByInput';
  created?: OrderByEnum | null;
  description?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  lastSchemaChange?: OrderByEnum | null;
  lastStatusChange?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  priority?: OrderByEnum | null;
  status?: OrderByEnum | null;
  triggerEntityName?: OrderByEnum | null;
  triggerType?: OrderByEnum | null;
}

export interface ApprovalProcessFilterInput {
  __typename?: 'ApprovalProcessFilterInput';
  AND?: ApprovalProcessFilterInput[] | null;
  NOT?: ApprovalProcessFilterInput | null;
  OR?: ApprovalProcessFilterInput[] | null;
  activityLogs?: ApprovalFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  entityType?: BaseEntityTypeEnumFilterInput | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  lastSchemaChange?: EntityFilterDateTimeField | null;
  lastStatusChange?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  priority?: EntityFilterNumberField | null;
  status?: ProcessStatusEnum | null;
  triggerEntityName?: EntityNameEnum | null;
  triggerType?: ApprovalProcessTriggerTypeEnum | null;
}

export interface ApprovalProcessActivityLogLineOrderByInput {
  __typename?: 'ApprovalProcessActivityLogLineOrderByInput';
  approval?: ApprovalOrderByNestedInput[] | null;
  approvalId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  executedAt?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ApprovalProcessActivityLogLineFilterInput {
  __typename?: 'ApprovalProcessActivityLogLineFilterInput';
  AND?: ApprovalProcessActivityLogLineFilterInput[] | null;
  NOT?: ApprovalProcessActivityLogLineFilterInput | null;
  OR?: ApprovalProcessActivityLogLineFilterInput[] | null;
  approval?: ApprovalFilterInput | null;
  approvalId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  executedAt?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isVisible?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  sortOrder?: EntityFilterNumberField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface ApprovalOrderByNestedInput {
  __typename?: 'ApprovalOrderByNestedInput';
  accountId?: OrderByEnum | null;
  actorId?: OrderByEnum | null;
  applicationId?: OrderByEnum | null;
  approvalProcessId?: OrderByEnum | null;
  approvalStatus?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ApprovalOrderByInput {
  __typename?: 'ApprovalOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  actor?: ClientOrderByNestedInput[] | null;
  actorId?: OrderByEnum | null;
  application?: ApplicationOrderByNestedInput[] | null;
  applicationId?: OrderByEnum | null;
  approvalProcess?: ApprovalProcessOrderByNestedInput[] | null;
  approvalProcessId?: OrderByEnum | null;
  approvalStatus?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endTime?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  startTime?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ApprovalFilterInput {
  __typename?: 'ApprovalFilterInput';
  AND?: ApprovalFilterInput[] | null;
  NOT?: ApprovalFilterInput | null;
  OR?: ApprovalFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  actor?: ClientFilterInput | null;
  actorId?: EntityFilterStringField | null;
  application?: ApplicationFilterInput | null;
  applicationId?: EntityFilterStringField | null;
  approvalProcess?: ApprovalProcessFilterInput | null;
  approvalProcessId?: EntityFilterStringField | null;
  approvalStatus?: ApprovalStatusEnumFilterInput | null;
  approvers?: ApprovalApproverFilterInput | null;
  comment?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  endTime?: EntityFilterDateTimeField | null;
  entityType?: BaseEntityTypeEnum | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  lines?: ApprovalProcessActivityLogLineFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  name?: string | null;
  oppty?: OpportunityFilterInput | null;
  ownerId?: UUID | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  startTime?: EntityFilterDateTimeField | null;
  status?: ProcessStatusEnumFilterInput | null;
}

export interface ApprovalApproverOrderByInput {
  __typename?: 'ApprovalApproverOrderByInput';
  approval?: ApprovalOrderByNestedInput[] | null;
  approvalId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface ApprovalApproverFilterInput {
  __typename?: 'ApprovalApproverFilterInput';
  AND?: ApprovalApproverFilterInput[] | null;
  NOT?: ApprovalApproverFilterInput | null;
  OR?: ApprovalApproverFilterInput[] | null;
  approval?: ApprovalFilterInput | null;
  approvalId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  status?: ApprovalStatusEnumFilterInput | null;
}

export interface AppointmentTypeOrderByNestedInput {
  __typename?: 'AppointmentTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AppointmentTypeOrderByInput {
  __typename?: 'AppointmentTypeOrderByInput';
  created?: OrderByEnum | null;
  icon?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AppointmentTypeFilterInput {
  __typename?: 'AppointmentTypeFilterInput';
  AND?: AppointmentTypeFilterInput[] | null;
  NOT?: AppointmentTypeFilterInput | null;
  OR?: AppointmentTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  icon?: ActivityTypeIconEnumFilterInput | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AppointmentScheduleTypeEnumFilterInput {
  __typename?: 'AppointmentScheduleTypeEnumFilterInput';
  NOT?: AppointmentScheduleTypeEnumFilterInput | null;
  eq?: AppointmentScheduleTypeEnum[] | null;
}

export interface AppointmentScheduleReminderOffsetTypeEnumFilterInput {
  __typename?: 'AppointmentScheduleReminderOffsetTypeEnumFilterInput';
  NOT?: AppointmentScheduleReminderOffsetTypeEnumFilterInput | null;
  eq?: AppointmentScheduleReminderOffsetTypeEnum[] | null;
}

export interface AppointmentSchedulePlanningTypeEnumFilterInput {
  __typename?: 'AppointmentSchedulePlanningTypeEnumFilterInput';
  NOT?: AppointmentSchedulePlanningTypeEnumFilterInput | null;
  eq?: AppointmentSchedulePlanningTypeEnum[] | null;
}

export interface AppointmentScheduleOrderByNestedInput {
  __typename?: 'AppointmentScheduleOrderByNestedInput';
  appointmentDescription?: OrderByEnum | null;
  appointmentDuration?: OrderByEnum | null;
  appointmentLocation?: OrderByEnum | null;
  appointmentLocationType?: OrderByEnum | null;
  appointmentOwnerId?: OrderByEnum | null;
  appointmentSubject?: OrderByEnum | null;
  appointmentSubjectUsesScheduleName?: OrderByEnum | null;
  appointmentTypeId?: OrderByEnum | null;
  bufferTimeAfter?: OrderByEnum | null;
  bufferTimeBefore?: OrderByEnum | null;
  confirmationPageType?: OrderByEnum | null;
  confirmationPageUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  minimumNoticeTime?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  planningDayOffset?: OrderByEnum | null;
  planningPeriodFrom?: OrderByEnum | null;
  planningPeriodTo?: OrderByEnum | null;
  planningType?: OrderByEnum | null;
  reminderEmailEnabled?: OrderByEnum | null;
  reminderEmailOffset?: OrderByEnum | null;
  reminderEmailOffsetType?: OrderByEnum | null;
  replyCompanyEmailId?: OrderByEnum | null;
  scheduleName?: OrderByEnum | null;
  timeIncrement?: OrderByEnum | null;
  type?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface AppointmentScheduleOrderByInput {
  __typename?: 'AppointmentScheduleOrderByInput';
  appointmentDescription?: OrderByEnum | null;
  appointmentDuration?: OrderByEnum | null;
  appointmentLocation?: OrderByEnum | null;
  appointmentLocationType?: OrderByEnum | null;
  appointmentOwner?: ClientOrderByNestedInput[] | null;
  appointmentOwnerId?: OrderByEnum | null;
  appointmentSubject?: OrderByEnum | null;
  appointmentSubjectUsesScheduleName?: OrderByEnum | null;
  appointmentType?: AppointmentTypeOrderByNestedInput[] | null;
  appointmentTypeId?: OrderByEnum | null;
  bufferTimeAfter?: OrderByEnum | null;
  bufferTimeBefore?: OrderByEnum | null;
  confirmationPageType?: OrderByEnum | null;
  confirmationPageUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isEnabled?: OrderByEnum | null;
  minimumNoticeTime?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  planningDayOffset?: OrderByEnum | null;
  planningPeriodFrom?: OrderByEnum | null;
  planningPeriodTo?: OrderByEnum | null;
  planningType?: OrderByEnum | null;
  reminderEmailEnabled?: OrderByEnum | null;
  reminderEmailOffset?: OrderByEnum | null;
  reminderEmailOffsetType?: OrderByEnum | null;
  replyCompanyEmail?: CompanyEmailOrderByNestedInput[] | null;
  replyCompanyEmailId?: OrderByEnum | null;
  scheduleName?: OrderByEnum | null;
  timeIncrement?: OrderByEnum | null;
  type?: OrderByEnum | null;
  url?: OrderByEnum | null;
}

export interface AppointmentScheduleLocationTypeEnumFilterInput {
  __typename?: 'AppointmentScheduleLocationTypeEnumFilterInput';
  NOT?: AppointmentScheduleLocationTypeEnumFilterInput | null;
  eq?: AppointmentScheduleLocationTypeEnum[] | null;
}

export interface AppointmentScheduleInviteeParams {
  __typename?: 'AppointmentScheduleInviteeParams';
  email: string;
  entityId?: ID | null;
  type: AppointmentScheduleInviteeType;
}

export interface AppointmentScheduleFilterInput {
  __typename?: 'AppointmentScheduleFilterInput';
  AND?: AppointmentScheduleFilterInput[] | null;
  NOT?: AppointmentScheduleFilterInput | null;
  OR?: AppointmentScheduleFilterInput[] | null;
  appointmentDescription?: EntityFilterStringField | null;
  appointmentDuration?: EntityFilterNumberField | null;
  appointmentLocation?: EntityFilterStringField | null;
  appointmentLocationType?: AppointmentScheduleLocationTypeEnumFilterInput | null;
  appointmentOwner?: ClientFilterInput | null;
  appointmentOwnerId?: EntityFilterStringField | null;
  appointmentSubject?: EntityFilterStringField | null;
  appointmentSubjectUsesScheduleName?: boolean | null;
  appointmentType?: AppointmentTypeFilterInput | null;
  appointmentTypeId?: EntityFilterStringField | null;
  availabilityTzid?: EntityFilterStringField | null;
  bufferTimeAfter?: EntityFilterNumberField | null;
  bufferTimeBefore?: EntityFilterNumberField | null;
  confirmationPageType?: AppointmentScheduleConfirmationPageTypeEnumFilterInput | null;
  confirmationPageUrl?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isEnabled?: boolean | null;
  minimumNoticeTime?: EntityFilterNumberField | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  planningDayOffset?: EntityFilterNumberField | null;
  planningType?: AppointmentSchedulePlanningTypeEnumFilterInput | null;
  reminderEmailEnabled?: boolean | null;
  reminderEmailOffset?: EntityFilterNumberField | null;
  reminderEmailOffsetType?: AppointmentScheduleReminderOffsetTypeEnumFilterInput | null;
  replyCompanyEmail?: CompanyEmailFilterInput | null;
  replyCompanyEmailId?: EntityFilterStringField | null;
  scheduleName?: EntityFilterStringField | null;
  timeIncrement?: EntityFilterNumberField | null;
  type?: AppointmentScheduleTypeEnumFilterInput | null;
  url?: EntityFilterStringField | null;
}

export interface AppointmentScheduleDayAvailabilityParams {
  __typename?: 'AppointmentScheduleDayAvailabilityParams';
  isEnabled: boolean;
  slots: AppointmentScheduleAvailabilitySlotParams[];
}

export interface AppointmentScheduleConfirmationPageTypeEnumFilterInput {
  __typename?: 'AppointmentScheduleConfirmationPageTypeEnumFilterInput';
  NOT?: AppointmentScheduleConfirmationPageTypeEnumFilterInput | null;
  eq?: AppointmentScheduleConfirmationPageTypeEnum[] | null;
}

export interface AppointmentScheduleAvailabilitySlotParams {
  __typename?: 'AppointmentScheduleAvailabilitySlotParams';
  end: number;
  start: number;
}

export interface AppointmentScheduleAvailabilityParams {
  __typename?: 'AppointmentScheduleAvailabilityParams';
  friday: AppointmentScheduleDayAvailabilityParams;
  monday: AppointmentScheduleDayAvailabilityParams;
  saturday: AppointmentScheduleDayAvailabilityParams;
  sunday: AppointmentScheduleDayAvailabilityParams;
  thursday: AppointmentScheduleDayAvailabilityParams;
  tuesday: AppointmentScheduleDayAvailabilityParams;
  wednesday: AppointmentScheduleDayAvailabilityParams;
}

export interface AppointmentScheduleAdditionalFieldParams {
  __typename?: 'AppointmentScheduleAdditionalFieldParams';
  fieldId: ID;
  isRequired: boolean;
  label: string;
}

export interface AppointmentReminderOrderByNestedInput {
  __typename?: 'AppointmentReminderOrderByNestedInput';
  appointmentId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endDateOffset?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  snoozeDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface AppointmentReminderOrderByInput {
  __typename?: 'AppointmentReminderOrderByInput';
  appointment?: AppointmentOrderByNestedInput[] | null;
  appointmentId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  endDateOffset?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  snoozeDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
}

export interface AppointmentReminderFilterInput {
  __typename?: 'AppointmentReminderFilterInput';
  AND?: AppointmentReminderFilterInput[] | null;
  NOT?: AppointmentReminderFilterInput | null;
  OR?: AppointmentReminderFilterInput[] | null;
  appointment?: AppointmentFilterInput | null;
  appointmentId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  endDateOffset?: EntityFilterNumberField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  snoozeDate?: EntityFilterDateTimeField | null;
  status?: ReminderStatusEnumFilterInput | null;
}

export interface AppointmentOrderByNestedInput {
  __typename?: 'AppointmentOrderByNestedInput';
  activityTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  duration?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  inviteesCanEdit?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  location?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  recurrenceMasterId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  scheduleId?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface AppointmentOrderByInput {
  __typename?: 'AppointmentOrderByInput';
  activityType?: AppointmentTypeOrderByNestedInput[] | null;
  activityTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  description?: OrderByEnum | null;
  duration?: OrderByEnum | null;
  endDate?: OrderByEnum | null;
  exchangeEntityId?: OrderByEnum | null;
  gapiEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  inviteesCanEdit?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  location?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  o365EntityId?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  recurrenceMaster?: AppointmentOrderByNestedInput[] | null;
  recurrenceMasterId?: OrderByEnum | null;
  reminder?: AppointmentReminderOrderByNestedInput[] | null;
  revision?: OrderByEnum | null;
  schedule?: AppointmentScheduleOrderByNestedInput[] | null;
  scheduleId?: OrderByEnum | null;
  startDate?: OrderByEnum | null;
  status?: OrderByEnum | null;
  subject?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
}

export interface AppointmentMeetingInput {
  __typename?: 'AppointmentMeetingInput';
  joinUrl?: string | null;
  type: AppointmentMeetingTypeEnum;
}

export interface AppointmentInviteeTypeEnumFilterInput {
  __typename?: 'AppointmentInviteeTypeEnumFilterInput';
  NOT?: AppointmentInviteeTypeEnumFilterInput | null;
  eq?: AppointmentInviteeTypeEnum[] | null;
}

export interface AppointmentFilterInput {
  __typename?: 'AppointmentFilterInput';
  AND?: AppointmentFilterInput[] | null;
  NOT?: AppointmentFilterInput | null;
  OR?: AppointmentFilterInput[] | null;
  accountRelations?: ActivityRelationFilterInput | null;
  activityType?: AppointmentTypeFilterInput | null;
  activityTypeId?: EntityFilterStringField | null;
  comments?: ActivityCommentFilterInput | null;
  contactRelations?: ActivityRelationFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  customEntityRelations?: ActivityRelationFilterInput | null;
  description?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  duration?: EntityFilterNumberField | null;
  endDate?: EntityFilterDateTimeField | null;
  exchangeEntityId?: string | null;
  gapiEntityId?: string | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  inviteesCanEdit?: boolean | null;
  inviteesClients?: AppointmentClientInviteesRelationFilterInput | null;
  inviteesContacts?: AppointmentContactInviteesRelationFilterInput | null;
  isDeleted?: boolean | null;
  isRecurrenceActive?: boolean | null;
  isRecurrenceException?: boolean | null;
  leadRelations?: ActivityRelationFilterInput | null;
  location?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  o365EntityId?: string | null;
  occurenceDate?: EntityFilterDateTimeField | null;
  opportunityRelations?: ActivityRelationFilterInput | null;
  organizer?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  projectRelations?: ActivityRelationFilterInput | null;
  quoteRelations?: ActivityRelationFilterInput | null;
  recurrenceMaster?: AppointmentFilterInput | null;
  recurrenceMasterId?: EntityFilterStringField | null;
  recurrenceRule?: EntityFilterStringField | null;
  recurrenceTzid?: EntityFilterStringField | null;
  reminder?: AppointmentReminderFilterInput | null;
  revision?: EntityFilterNumberField | null;
  schedule?: AppointmentScheduleFilterInput | null;
  scheduleId?: EntityFilterStringField | null;
  scheduleTzid?: EntityFilterStringField | null;
  startDate?: EntityFilterDateTimeField | null;
  status?: ActivityStatusEnumFilterInput | null;
  subject?: EntityFilterStringField | null;
  tableName?: EntityFilterStringField | null;
  tags?: TagRelationFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
}

export interface AppointmentContactInviteesRelationOrderByInput {
  __typename?: 'AppointmentContactInviteesRelationOrderByInput';
  appointment?: AppointmentOrderByNestedInput[] | null;
  appointmentId?: OrderByEnum | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  email?: OrderByEnum | null;
  firstName?: OrderByEnum | null;
  id?: OrderByEnum | null;
  inviteeType?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastName?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  response?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AppointmentContactInviteesRelationFilterInput {
  __typename?: 'AppointmentContactInviteesRelationFilterInput';
  AND?: AppointmentContactInviteesRelationFilterInput[] | null;
  NOT?: AppointmentContactInviteesRelationFilterInput | null;
  OR?: AppointmentContactInviteesRelationFilterInput[] | null;
  appointment?: AppointmentFilterInput | null;
  appointmentId?: EntityFilterStringField | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  email?: EntityFilterStringField | null;
  firstName?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  inviteeType?: AppointmentInviteeTypeEnumFilterInput | null;
  isDeleted?: boolean | null;
  lastName?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  response?: InviteeResponseEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface AppointmentClientInviteesRelationOrderByInput {
  __typename?: 'AppointmentClientInviteesRelationOrderByInput';
  appointment?: AppointmentOrderByNestedInput[] | null;
  appointmentId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  response?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AppointmentClientInviteesRelationFilterInput {
  __typename?: 'AppointmentClientInviteesRelationFilterInput';
  AND?: AppointmentClientInviteesRelationFilterInput[] | null;
  NOT?: AppointmentClientInviteesRelationFilterInput | null;
  OR?: AppointmentClientInviteesRelationFilterInput[] | null;
  appointment?: AppointmentFilterInput | null;
  appointmentId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  response?: InviteeResponseEnumFilterInput | null;
  revision?: EntityFilterNumberField | null;
}

export interface ApplyCustomizationInput {
  __typename?: 'ApplyCustomizationInput';
  clientMutationId?: string | null;
  customization: JSONString;
}

export interface ApplicationOrderByNestedInput {
  __typename?: 'ApplicationOrderByNestedInput';
  automationHubId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTrigger?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  usesImpersonation?: OrderByEnum | null;
}

export interface ApplicationOrderByInput {
  __typename?: 'ApplicationOrderByInput';
  automationHubId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isTrigger?: OrderByEnum | null;
  isVisible?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  usesImpersonation?: OrderByEnum | null;
}

export interface ApplicationFilterInput {
  __typename?: 'ApplicationFilterInput';
  AND?: ApplicationFilterInput[] | null;
  NOT?: ApplicationFilterInput | null;
  OR?: ApplicationFilterInput[] | null;
  automationHubId?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isTrigger?: boolean | null;
  isVisible?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  usesImpersonation?: boolean | null;
}

export interface ApiAccessTypeEnumFilterInput {
  __typename?: 'ApiAccessTypeEnumFilterInput';
  NOT?: ApiAccessTypeEnumFilterInput | null;
  eq?: ApiAccessTypeEnum[] | null;
}

export interface ApiAccessPermissionsInput {
  __typename?: 'ApiAccessPermissionsInput';
  administration: ApiAccessPermissionAdministrationTabInput;
  misc: ApiAccessPermissionMiscTabInput;
  records: ApiAccessPermissionRecordsTabInput;
}

export interface ApiAccessPermissionRecordsTabInput {
  __typename?: 'ApiAccessPermissionRecordsTabInput';
  accounts: ApiPermissionEnum;
  appointments: ApiPermissionEnum;
  contacts: ApiPermissionEnum;
  customEntities: CustomEntityApiAccessPermissionInput[];
  emails: ApiPermissionEnum;
  leads: ApiPermissionEnum;
  messages: ApiPermissionEnum;
  opportunities: ApiPermissionEnum;
  projects: ApiPermissionEnum;
  tasks: ApiPermissionEnum;
}

export interface ApiAccessPermissionMiscTabInput {
  __typename?: 'ApiAccessPermissionMiscTabInput';
  data: ApiPermissionEnum;
  documents: ApiPermissionEnum;
  others: ApiPermissionEnum;
  reports: ApiPermissionEnum;
  webhooks: ApiPermissionEnum;
}

export interface ApiAccessPermissionAdministrationTabInput {
  __typename?: 'ApiAccessPermissionAdministrationTabInput';
  automationHub: ApiPermissionEnum;
  commonList: ApiPermissionEnum;
  currencies: ApiPermissionEnum;
  fieldsAndForms: ApiPermissionEnum;
  pipelines: ApiPermissionEnum;
  productsAndPrices: ApiPermissionEnum;
  security: ApiPermissionEnum;
  settings: ApiPermissionEnum;
  unitsAndRoles: ApiPermissionEnum;
}

export interface ApiAccessOrderByInput {
  __typename?: 'ApiAccessOrderByInput';
  created?: OrderByEnum | null;
  email?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isActive?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lastUsed?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  type?: OrderByEnum | null;
}

export interface ApiAccessFilterInput {
  __typename?: 'ApiAccessFilterInput';
  AND?: ApiAccessFilterInput[] | null;
  NOT?: ApiAccessFilterInput | null;
  OR?: ApiAccessFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  email?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isActive?: boolean | null;
  isDeleted?: boolean | null;
  lastUsed?: EntityFilterDateTimeField | null;
  modified?: EntityFilterDateTimeField | null;
  type?: ApiAccessTypeEnumFilterInput | null;
}

export interface AllowedQuoteTypeOrderByInput {
  __typename?: 'AllowedQuoteTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  quoteType?: QuoteTypeOrderByNestedInput[] | null;
  quoteTypeId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedQuoteTypeFilterInput {
  __typename?: 'AllowedQuoteTypeFilterInput';
  AND?: AllowedQuoteTypeFilterInput[] | null;
  NOT?: AllowedQuoteTypeFilterInput | null;
  OR?: AllowedQuoteTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  quoteType?: QuoteTypeFilterInput | null;
  quoteTypeId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedPipelineOrderByInput {
  __typename?: 'AllowedPipelineOrderByInput';
  accessStepDocuments?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pipeline?: PipelineOrderByNestedInput[] | null;
  pipelineId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedPipelineFilterInput {
  __typename?: 'AllowedPipelineFilterInput';
  AND?: AllowedPipelineFilterInput[] | null;
  NOT?: AllowedPipelineFilterInput | null;
  OR?: AllowedPipelineFilterInput[] | null;
  accessStepDocuments?: boolean | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  pipeline?: PipelineFilterInput | null;
  pipelineId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedLeadTypeOrderByInput {
  __typename?: 'AllowedLeadTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  leadType?: LeadTypeOrderByNestedInput[] | null;
  leadTypeId?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedLeadTypeFilterInput {
  __typename?: 'AllowedLeadTypeFilterInput';
  AND?: AllowedLeadTypeFilterInput[] | null;
  NOT?: AllowedLeadTypeFilterInput | null;
  OR?: AllowedLeadTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  leadType?: LeadTypeFilterInput | null;
  leadTypeId?: EntityFilterStringField | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedContactTypeOrderByInput {
  __typename?: 'AllowedContactTypeOrderByInput';
  contactType?: ContactTypeOrderByNestedInput[] | null;
  contactTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedContactTypeFilterInput {
  __typename?: 'AllowedContactTypeFilterInput';
  AND?: AllowedContactTypeFilterInput[] | null;
  NOT?: AllowedContactTypeFilterInput | null;
  OR?: AllowedContactTypeFilterInput[] | null;
  contactType?: ContactTypeFilterInput | null;
  contactTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedCompanyPhoneOrderByInput {
  __typename?: 'AllowedCompanyPhoneOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  phone?: PhoneOrderByNestedInput[] | null;
  phoneId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedCompanyPhoneFilterInput {
  __typename?: 'AllowedCompanyPhoneFilterInput';
  AND?: AllowedCompanyPhoneFilterInput[] | null;
  NOT?: AllowedCompanyPhoneFilterInput | null;
  OR?: AllowedCompanyPhoneFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  phone?: PhoneFilterInput | null;
  phoneId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedCompanyEmailOrderByInput {
  __typename?: 'AllowedCompanyEmailOrderByInput';
  companyEmail?: CompanyEmailOrderByNestedInput[] | null;
  companyEmailId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedCompanyEmailFilterInput {
  __typename?: 'AllowedCompanyEmailFilterInput';
  AND?: AllowedCompanyEmailFilterInput[] | null;
  NOT?: AllowedCompanyEmailFilterInput | null;
  OR?: AllowedCompanyEmailFilterInput[] | null;
  companyEmail?: CompanyEmailFilterInput | null;
  companyEmailId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AllowedAccountTypeOrderByInput {
  __typename?: 'AllowedAccountTypeOrderByInput';
  accountType?: AccountTypeOrderByNestedInput[] | null;
  accountTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  masterRight?: MasterRightOrderByNestedInput[] | null;
  masterRightId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AllowedAccountTypeFilterInput {
  __typename?: 'AllowedAccountTypeFilterInput';
  AND?: AllowedAccountTypeFilterInput[] | null;
  NOT?: AllowedAccountTypeFilterInput | null;
  OR?: AllowedAccountTypeFilterInput[] | null;
  accountType?: AccountTypeFilterInput | null;
  accountTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  masterRight?: MasterRightFilterInput | null;
  masterRightId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AiUpdateReportInput {
  __typename?: 'AiUpdateReportInput';
  aiConversation: AiConversationItemParams[];
  clientMutationId?: string | null;
  parentTaskId?: string | null;
  prompt: string;
  promptTopics?: AiPromptTopics | null;
  report?: AiReportDataParams | null;
  sessionId?: string | null;
}

export interface AiUpdateProcessInput {
  __typename?: 'AiUpdateProcessInput';
  aiConversation: AiConversationItemParams[];
  clientMutationId?: string | null;
  parentTaskId?: string | null;
  process?: AiProcessDataParams | null;
  processId?: string | null;
  prompt?: string | null;
  promptTopics?: AiPromptTopics | null;
  sessionId?: string | null;
}

export interface AiUpdateOnlineFormInput {
  __typename?: 'AiUpdateOnlineFormInput';
  clientMutationId?: string | null;
  fieldId?: string | null;
  itemType: AiOnlineFormItemType;
  language?: AiOutputLanguage | null;
  onlineForm: AiOnlineFormDataParams;
  parentTaskId?: string | null;
  prompt: string;
  promptTopics?: AiPromptTopics | null;
  sessionId?: string | null;
}

export interface AiStartSuperAgentToolInput {
  __typename?: 'AiStartSuperAgentToolInput';
  clientMutationId?: string | null;
  input: string;
  name: string;
  sessionId: string;
}

export interface AiSmartValueUpdateMutationInput {
  __typename?: 'AiSmartValueUpdateMutationInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityName: EntityNameEnum;
  fieldIds: UUID[];
  selection: BulkOperationInput;
}

export interface AiScreenChatInput {
  __typename?: 'AiScreenChatInput';
  clientMutationId?: string | null;
  context: AiContextParams;
  parentTaskId?: string | null;
  prompt?: string | null;
  promptTopics?: AiPromptTopics | null;
  sessionId?: string | null;
}

export interface AiReportDataParams {
  __typename?: 'AiReportDataParams';
  description?: string | null;
  name?: string | null;
  schema: JSONString;
}

export interface AiRecordSummaryInput {
  __typename?: 'AiRecordSummaryInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityId: string;
  entityName: EntityNameEnum;
  language: AiOutputLanguage;
}

export interface AiRecordSuggestionsInput {
  __typename?: 'AiRecordSuggestionsInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityId: string;
  entityName: EntityNameEnum;
}

export interface AiRecordChatInput {
  __typename?: 'AiRecordChatInput';
  clientMutationId?: string | null;
  entityApiName?: string | null;
  entityId: string;
  entityName: EntityNameEnum;
  parentTaskId?: string | null;
  prompt: string;
  promptTopics?: AiPromptTopics | null;
  sessionId?: string | null;
  suggestionId?: string | null;
}

export interface AiProlongAskDocumentSummarySessionMutationInput {
  __typename?: 'AiProlongAskDocumentSummarySessionMutationInput';
  clientMutationId?: string | null;
  sessionId: ID;
}

export interface AiProcessDataParams {
  __typename?: 'AiProcessDataParams';
  description: string;
  name: string;
  schema: JSONString;
}

export interface AiOnlineFormFieldDraftParams {
  __typename?: 'AiOnlineFormFieldDraftParams';
  dataSet?: DataSetValueParams[] | null;
  dataSetId?: ID | null;
  id: string;
  name: string;
  options?: FieldOptionsPropertyJSONString | null;
  typeId: string;
}

export interface AiOnlineFormDataParams {
  __typename?: 'AiOnlineFormDataParams';
  description?: string | null;
  fieldDrafts: AiOnlineFormFieldDraftParams[];
  name?: string | null;
  schema: JSONString;
}

export interface AiModifyTextInput {
  __typename?: 'AiModifyTextInput';
  clientMutationId?: string | null;
  function: TextModificationFunction;
  language?: AiOutputLanguage | null;
  text: string;
  tone?: EmailTextTone | null;
}

export interface AiGenerateEmailInput {
  __typename?: 'AiGenerateEmailInput';
  clientMutationId?: string | null;
  entityId?: UUID | null;
  entityType?: EntityNameEnum | null;
  language?: AiOutputLanguage | null;
  length: EmailLength;
  service: SendEmailServiceParams;
  tone: EmailTextTone;
  topic: string;
}

export interface AiFeedEmailCreateSummaryMutationInput {
  __typename?: 'AiFeedEmailCreateSummaryMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedEmailTabDataGridViewOptionsParams;
  searchQuery?: string | null;
}

export interface AiFeedEmailCreateKeyPointsMutationInput {
  __typename?: 'AiFeedEmailCreateKeyPointsMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedEmailTabDataGridViewOptionsParams;
  searchQuery?: string | null;
}

export interface AiFeedEmailCreateEmailReplyMutationInput {
  __typename?: 'AiFeedEmailCreateEmailReplyMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedEmailTabDataGridViewOptionsParams;
  searchQuery?: string | null;
}

export interface AiFeedEmailCreateActionPointsMutationInput {
  __typename?: 'AiFeedEmailCreateActionPointsMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedEmailTabDataGridViewOptionsParams;
  searchQuery?: string | null;
}

export interface AiFeedEmailCategorizeEmailsInput {
  __typename?: 'AiFeedEmailCategorizeEmailsInput';
  clientMutationId?: string | null;
  entity?: CategorizeEmailsEntityParams | null;
  listingOptions?: FeedEmailTabDataGridViewOptionsParams | null;
  profile?: FeedEmailPreviewProfileParams | null;
  searchQuery?: string | null;
  selectionIds?: UUID[] | null;
  selectionType: AiCategorizeEmailsSelectionType;
}

export interface AiCreateSummaryMutationInput {
  __typename?: 'AiCreateSummaryMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedTabDataGridViewOptionsParams;
}

export interface AiCreateSummaryFromSelectionMutationInput {
  __typename?: 'AiCreateSummaryFromSelectionMutationInput';
  clientMutationId?: string | null;
  entities: SelectionEntityParams[];
  language?: AiOutputLanguage | null;
}

export interface AiCreateSummaryFromEmailThreadMutationInput {
  __typename?: 'AiCreateSummaryFromEmailThreadMutationInput';
  clientMutationId?: string | null;
  language?: AiOutputLanguage | null;
  threadId: UUID;
}

export interface AiCreateKeyPointsMutationInput {
  __typename?: 'AiCreateKeyPointsMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedTabDataGridViewOptionsParams;
}

export interface AiCreateKeyPointsFromSelectionMutationInput {
  __typename?: 'AiCreateKeyPointsFromSelectionMutationInput';
  clientMutationId?: string | null;
  entities: SelectionEntityParams[];
  language?: AiOutputLanguage | null;
}

export interface AiCreateKeyPointsFromEmailThreadMutationInput {
  __typename?: 'AiCreateKeyPointsFromEmailThreadMutationInput';
  clientMutationId?: string | null;
  language?: AiOutputLanguage | null;
  threadId: UUID;
}

export interface AiCreateEmailReplyMutationInput {
  __typename?: 'AiCreateEmailReplyMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedTabDataGridViewOptionsParams;
}

export interface AiCreateEmailReplyFromSelectionMutationInput {
  __typename?: 'AiCreateEmailReplyFromSelectionMutationInput';
  clientMutationId?: string | null;
  entities: SelectionEntityParams[];
  language?: AiOutputLanguage | null;
}

export interface AiCreateEmailReplyFromEmailThreadMutationInput {
  __typename?: 'AiCreateEmailReplyFromEmailThreadMutationInput';
  clientMutationId?: string | null;
  language?: AiOutputLanguage | null;
  threadId: UUID;
}

export interface AiCreateDocumentSummaryMutationInput {
  __typename?: 'AiCreateDocumentSummaryMutationInput';
  clientMutationId?: string | null;
  language?: AiOutputLanguage | null;
  selection: BulkOperationInput;
}

export interface AiCreateActionPointsMutationInput {
  __typename?: 'AiCreateActionPointsMutationInput';
  clientMutationId?: string | null;
  entityName: EntityNameEnum;
  id: UUID;
  language?: AiOutputLanguage | null;
  listingOptions: FeedTabDataGridViewOptionsParams;
}

export interface AiCreateActionPointsFromSelectionMutationInput {
  __typename?: 'AiCreateActionPointsFromSelectionMutationInput';
  clientMutationId?: string | null;
  entities: SelectionEntityParams[];
  language?: AiOutputLanguage | null;
}

export interface AiCreateActionPointsFromEmailThreadMutationInput {
  __typename?: 'AiCreateActionPointsFromEmailThreadMutationInput';
  clientMutationId?: string | null;
  language?: AiOutputLanguage | null;
  threadId: UUID;
}

export interface AiConvertHtmlMjmlInput {
  __typename?: 'AiConvertHtmlMjmlInput';
  clientMutationId?: string | null;
  html: string;
}

export interface AiConversationItemParams {
  __typename?: 'AiConversationItemParams';
  actor: AiConversationItemActor;
  text: string;
}

export interface AiContextParams {
  __typename?: 'AiContextParams';
  data?: JSONString | null;
  entityApiName?: string | null;
  entityId?: ID | null;
  entityType?: EntityNameEnum | null;
}

export interface AiChatInput {
  __typename?: 'AiChatInput';
  clientMutationId?: string | null;
  context?: AiContextParams | null;
  prompt: string;
  promptTopics?: AiPromptTopics | null;
  sessionId?: string | null;
}

export interface AiCategorizeEmailsInput {
  __typename?: 'AiCategorizeEmailsInput';
  clientMutationId?: string | null;
  entity?: CategorizeEmailsEntityParams | null;
  listingOptions?: FeedTabDataGridViewOptionsParams | null;
  profile?: FeedPreviewProfileParams | null;
  selectionIds?: UUID[] | null;
  selectionType: AiCategorizeEmailsSelectionType;
}

export interface AiCancelTaskInput {
  __typename?: 'AiCancelTaskInput';
  clientMutationId?: string | null;
  taskId: string;
}

export interface AiAssistantPromptParams {
  __typename?: 'AiAssistantPromptParams';
  entityApiName?: string | null;
  entityName?: EntityNameEnum | null;
  id: UUID;
  starred?: boolean | null;
  text: string;
  title: string;
}

export interface AiAssistantFavoritePromptsParams {
  __typename?: 'AiAssistantFavoritePromptsParams';
  entityApiName?: string | null;
  entityName?: EntityNameEnum | null;
  promptIds: UUID[];
}

export interface AiAskDocumentSummaryMutationInput {
  __typename?: 'AiAskDocumentSummaryMutationInput';
  clientMutationId?: string | null;
  disposeSessionId?: ID | null;
  prompt: string;
  selection?: BulkOperationInput | null;
  sessionId?: ID | null;
}

export interface AffectedRecordsByConditionProcessInput {
  __typename?: 'AffectedRecordsByConditionProcessInput';
  clientMutationId?: string | null;
  id: ID;
  settings: ProcessSchemaJSONString;
}

export interface AffectedProcessesSharing {
  __typename?: 'AffectedProcessesSharing';
  clients?: SharingRecord[] | null;
  mode: ShareModeEnum;
  units?: SharingRecord[] | null;
}

export interface AdvancedFormulaPropertyParams {
  __typename?: 'AdvancedFormulaPropertyParams';
  decimalPlaces?: number | null;
  displayOption?: AdvancedFormulaDisplayOptionEnum | null;
  displayOptionCustomValue?: string | null;
  formula: string;
  type: AdvancedFormulaTypeEnum;
}

export interface AddRecordsToExistingStaticProfilesProfileInput {
  __typename?: 'AddRecordsToExistingStaticProfilesProfileInput';
  clientMutationId?: string | null;
  profileIds: UUID[];
  recordIds: BulkOperationInput;
}

export interface AddPipelineStepInput {
  __typename?: 'AddPipelineStepInput';
  clientMutationId?: string | null;
  id: ID;
  nextStepId: ID;
  step: CreateStepInput;
}

export interface AddClientToUnitClientInput {
  __typename?: 'AddClientToUnitClientInput';
  clientMutationId?: string | null;
  id: ID;
  unitMembership: CreateSalesUnitClientRelationInput;
}

export interface AddCallSummarizationToDescriptionOfTaskInput {
  __typename?: 'AddCallSummarizationToDescriptionOfTaskInput';
  clientMutationId?: string | null;
  entityId: ID;
}

export interface AddAutomationHubItemInput {
  __typename?: 'AddAutomationHubItemInput';
  clientMutationId?: string | null;
  id: ID;
}

export interface ActivityTypeIconEnumFilterInput {
  __typename?: 'ActivityTypeIconEnumFilterInput';
  NOT?: ActivityTypeIconEnumFilterInput | null;
  eq?: ActivityTypeIconEnum[] | null;
}

export interface ActivityTabDataGridViewOptionsParams {
  __typename?: 'ActivityTabDataGridViewOptionsParams';
  filterByActivityTypeId?: ID[] | null;
  filterByOwnerId?: ID[] | null;
  filterByPeriod: PeriodOptionParams;
  filterByStatus: ActivityStatusEnum[];
  filterByTags?: ID[] | null;
  relatedActivities: boolean;
  searchQuery?: string | null;
  showTasksWithoutDueDate?: boolean | null;
}

export interface ActivityStatusEnumFilterInput {
  __typename?: 'ActivityStatusEnumFilterInput';
  NOT?: ActivityStatusEnumFilterInput | null;
  eq?: ActivityStatusEnum[] | null;
}

export interface ActivityRoleTabParams {
  __typename?: 'ActivityRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
  showUnassignedItems: boolean;
}

export interface ActivityRelationOrderByInput {
  __typename?: 'ActivityRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  contact?: ContactOrderByNestedInput[] | null;
  contactId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  customEntity?: CustomEntityOrderByNestedInput[] | null;
  customEntityId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  lead?: LeadOrderByNestedInput[] | null;
  leadOpptyId?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  oppty?: OpportunityOrderByNestedInput[] | null;
  project?: ProjectOrderByNestedInput[] | null;
  projectId?: OrderByEnum | null;
  projectObjective?: ProjectObjectiveOrderByNestedInput[] | null;
  projectObjectiveId?: OrderByEnum | null;
  quote?: QuoteOrderByNestedInput[] | null;
  quoteId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  sortOrder?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface ActivityRelationFilterInput {
  __typename?: 'ActivityRelationFilterInput';
  AND?: ActivityRelationFilterInput[] | null;
  NOT?: ActivityRelationFilterInput | null;
  OR?: ActivityRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  contact?: ContactFilterInput | null;
  contactId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  customEntity?: CustomEntityFilterInput | null;
  customEntityId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  lead?: LeadFilterInput | null;
  leadOpptyId?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  oppty?: OpportunityFilterInput | null;
  project?: ProjectFilterInput | null;
  projectId?: EntityFilterStringField | null;
  projectObjective?: ProjectObjectiveFilterInput | null;
  projectObjectiveId?: EntityFilterStringField | null;
  quote?: QuoteFilterInput | null;
  quoteId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  sortOrder?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
}

export interface ActivityProfileDataInput {
  __typename?: 'ActivityProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: ActivityPreviewProfileParams;
}

export interface ActivityPreviewViewTabParams {
  __typename?: 'ActivityPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  groupBy: ActivityGroupBy;
  showCardLabels?: boolean | null;
  showDueDate: boolean;
  showExtraFieldIds?: UUID[] | null;
  showLinkedItems: boolean;
  showProgress: boolean;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ActivityPreviewProfileParams {
  __typename?: 'ActivityPreviewProfileParams';
  filter: ActivityFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: ActivityRoleTabParams;
  view: ActivityPreviewViewTabParams;
}

export interface ActivityOrderByInput {
  __typename?: 'ActivityOrderByInput';
  id?: OrderByEnum | null;
}

export interface ActivityKpiEnumFilterInput {
  __typename?: 'ActivityKpiEnumFilterInput';
  NOT?: ActivityKpiEnumFilterInput | null;
  eq?: ActivityKpiEnum[] | null;
}

export interface ActivityKPIOrderByInput {
  __typename?: 'ActivityKPIOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface ActivityKPIFilterInput {
  __typename?: 'ActivityKPIFilterInput';
  AND?: ActivityKPIFilterInput[] | null;
  NOT?: ActivityKPIFilterInput | null;
  OR?: ActivityKPIFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  applicationId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: ActivityKpiEnumFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface ActivityFilterTabParams {
  __typename?: 'ActivityFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ActivityFilterInput {
  __typename?: 'ActivityFilterInput';
  AND?: ActivityFilterInput[] | null;
  NOT?: ActivityFilterInput | null;
  OR?: ActivityFilterInput[] | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
}

export interface ActivityDrilldownFilterParams {
  __typename?: 'ActivityDrilldownFilterParams';
  activityTypeId?: ID[] | null;
  ownerId?: ID[] | null;
  period: PeriodOptionParams;
  showTasksWithoutDueDate?: boolean | null;
}

export interface ActivityDetailFilterOptionsParams {
  __typename?: 'ActivityDetailFilterOptionsParams';
  showAttendeesRecords: boolean;
  showMyRecords: boolean;
  showSalesTeamRecords: boolean;
  showSalesUnitsRecords: boolean;
}

export interface ActivityDetailCalendarOptions {
  __typename?: 'ActivityDetailCalendarOptions';
  attendees?: ActivityDetailCalendarAttendess[] | null;
  filter: ActivityDetailFilterOptionsParams;
}

export interface ActivityDetailCalendarAttendess {
  __typename?: 'ActivityDetailCalendarAttendess';
  clientId?: UUID | null;
  contactId?: UUID | null;
  email?: string | null;
}

export interface ActivityDataExRelationOrderByInput {
  __typename?: 'ActivityDataExRelationOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface ActivityDataExRelationFilterInput {
  __typename?: 'ActivityDataExRelationFilterInput';
  AND?: ActivityDataExRelationFilterInput[] | null;
  NOT?: ActivityDataExRelationFilterInput | null;
  OR?: ActivityDataExRelationFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
}

export interface ActivityDashboardProfileViewParams {
  __typename?: 'ActivityDashboardProfileViewParams';
  drilldownFields: ID[];
  graphs: DashboardGraphActivityNameType[];
}

export interface ActivityDashboardProfileParams {
  __typename?: 'ActivityDashboardProfileParams';
  filter: ActivityFilterTabParams;
  role: ActivityRoleTabParams;
  view: ActivityDashboardProfileViewParams;
}

export interface ActivityCommentOrderByInput {
  __typename?: 'ActivityCommentOrderByInput';
  activityId?: OrderByEnum | null;
  appointment?: AppointmentOrderByNestedInput[] | null;
  comment?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  task?: TaskOrderByNestedInput[] | null;
}

export interface ActivityCommentFilterInput {
  __typename?: 'ActivityCommentFilterInput';
  AND?: ActivityCommentFilterInput[] | null;
  NOT?: ActivityCommentFilterInput | null;
  OR?: ActivityCommentFilterInput[] | null;
  activityId?: EntityFilterStringField | null;
  appointment?: AppointmentFilterInput | null;
  comment?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  task?: TaskFilterInput | null;
}

export interface ActivitiesNotificationSettingsParams {
  __typename?: 'ActivitiesNotificationSettingsParams';
  Comment: boolean;
  Invitation: boolean;
  IsActive: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface ActivateTargetInput {
  __typename?: 'ActivateTargetInput';
  clientMutationId?: string | null;
  id: UUID;
}

export interface AccountsHierarchyNodeInput {
  __typename?: 'AccountsHierarchyNodeInput';
  account: UUID;
  parentAccount?: UUID | null;
  relation?: UUID | null;
}

export interface AccountsAndContactsNotificationSettingsParams {
  __typename?: 'AccountsAndContactsNotificationSettingsParams';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
}

export interface AccountTypeOrderByNestedInput {
  __typename?: 'AccountTypeOrderByNestedInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountTypeOrderByInput {
  __typename?: 'AccountTypeOrderByInput';
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  isPublished?: OrderByEnum | null;
  isReadonly?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountTypeFilterInput {
  __typename?: 'AccountTypeFilterInput';
  AND?: AccountTypeFilterInput[] | null;
  NOT?: AccountTypeFilterInput | null;
  OR?: AccountTypeFilterInput[] | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  isPublished?: boolean | null;
  isReadonly?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountTabDataGridViewOptionsParams {
  __typename?: 'AccountTabDataGridViewOptionsParams';
  directChildrenOnly: boolean;
  filterByOwnerId?: ID[] | null;
  filterByTags?: ID[] | null;
  searchQuery?: string | null;
  showArchivedRecords?: boolean | null;
}

export interface AccountSocialRelationOrderByNestedInput {
  __typename?: 'AccountSocialRelationOrderByNestedInput';
  angellistUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  crunchbaseUrl?: OrderByEnum | null;
  disqusUrl?: OrderByEnum | null;
  facebookUrl?: OrderByEnum | null;
  flickrUrl?: OrderByEnum | null;
  foursquareUrl?: OrderByEnum | null;
  googlePlusUrl?: OrderByEnum | null;
  gravatarUrl?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  kloutUrl?: OrderByEnum | null;
  linkedinUrl?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pinterestUrl?: OrderByEnum | null;
  quoraUrl?: OrderByEnum | null;
  redditUrl?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  skypeUrl?: OrderByEnum | null;
  slideshareUrl?: OrderByEnum | null;
  twitterUrl?: OrderByEnum | null;
  vimeoUrl?: OrderByEnum | null;
  wordpressUrl?: OrderByEnum | null;
  xingUrl?: OrderByEnum | null;
  yahooUrl?: OrderByEnum | null;
  yelpUrl?: OrderByEnum | null;
  youtubeUrl?: OrderByEnum | null;
}

export interface AccountSocialRelationOrderByInput {
  __typename?: 'AccountSocialRelationOrderByInput';
  angellistUrl?: OrderByEnum | null;
  created?: OrderByEnum | null;
  crunchbaseUrl?: OrderByEnum | null;
  disqusUrl?: OrderByEnum | null;
  facebookUrl?: OrderByEnum | null;
  flickrUrl?: OrderByEnum | null;
  foursquareUrl?: OrderByEnum | null;
  googlePlusUrl?: OrderByEnum | null;
  gravatarUrl?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  kloutUrl?: OrderByEnum | null;
  linkedinUrl?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  pinterestUrl?: OrderByEnum | null;
  quoraUrl?: OrderByEnum | null;
  redditUrl?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  skypeUrl?: OrderByEnum | null;
  slideshareUrl?: OrderByEnum | null;
  twitterUrl?: OrderByEnum | null;
  vimeoUrl?: OrderByEnum | null;
  wordpressUrl?: OrderByEnum | null;
  xingUrl?: OrderByEnum | null;
  yahooUrl?: OrderByEnum | null;
  yelpUrl?: OrderByEnum | null;
  youtubeUrl?: OrderByEnum | null;
}

export interface AccountSocialRelationFilterInput {
  __typename?: 'AccountSocialRelationFilterInput';
  AND?: AccountSocialRelationFilterInput[] | null;
  NOT?: AccountSocialRelationFilterInput | null;
  OR?: AccountSocialRelationFilterInput[] | null;
  angellistUrl?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  crunchbaseUrl?: EntityFilterStringField | null;
  disqusUrl?: EntityFilterStringField | null;
  facebookId?: EntityFilterStringField | null;
  facebookUrl?: EntityFilterStringField | null;
  flickrUrl?: EntityFilterStringField | null;
  foursquareUrl?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  googleId?: EntityFilterStringField | null;
  googlePlusUrl?: EntityFilterStringField | null;
  gravatarUrl?: EntityFilterStringField | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kloutUrl?: EntityFilterStringField | null;
  linkedinId?: EntityFilterStringField | null;
  linkedinUrl?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  pinterestUrl?: EntityFilterStringField | null;
  quoraUrl?: EntityFilterStringField | null;
  redditUrl?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  skypeUrl?: EntityFilterStringField | null;
  slideshareUrl?: EntityFilterStringField | null;
  twitterId?: EntityFilterStringField | null;
  twitterUrl?: EntityFilterStringField | null;
  vimeoUrl?: EntityFilterStringField | null;
  wordpressUrl?: EntityFilterStringField | null;
  xingUrl?: EntityFilterStringField | null;
  yahooUrl?: EntityFilterStringField | null;
  yelpUrl?: EntityFilterStringField | null;
  youtubeUrl?: EntityFilterStringField | null;
}

export interface AccountSharingSalesUnitRelationOrderByInput {
  __typename?: 'AccountSharingSalesUnitRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface AccountSharingSalesUnitRelationFilterInput {
  __typename?: 'AccountSharingSalesUnitRelationFilterInput';
  AND?: AccountSharingSalesUnitRelationFilterInput[] | null;
  NOT?: AccountSharingSalesUnitRelationFilterInput | null;
  OR?: AccountSharingSalesUnitRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface AccountSharingClientRelationOrderByInput {
  __typename?: 'AccountSharingClientRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  role?: OrderByEnum | null;
}

export interface AccountSharingClientRelationFilterInput {
  __typename?: 'AccountSharingClientRelationFilterInput';
  AND?: AccountSharingClientRelationFilterInput[] | null;
  NOT?: AccountSharingClientRelationFilterInput | null;
  OR?: AccountSharingClientRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
  role?: SharingRoleEnumFilterInput | null;
}

export interface AccountRoleTabParams {
  __typename?: 'AccountRoleTabParams';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface AccountRoleOrderByNestedInput {
  __typename?: 'AccountRoleOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRoleOrderByInput {
  __typename?: 'AccountRoleOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRoleFilterInput {
  __typename?: 'AccountRoleFilterInput';
  AND?: AccountRoleFilterInput[] | null;
  NOT?: AccountRoleFilterInput | null;
  OR?: AccountRoleFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  label?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountRelationTypeOrderByNestedInput {
  __typename?: 'AccountRelationTypeOrderByNestedInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRelationTypeOrderByInput {
  __typename?: 'AccountRelationTypeOrderByInput';
  color?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  label?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRelationTypeFilterInput {
  __typename?: 'AccountRelationTypeFilterInput';
  AND?: AccountRelationTypeFilterInput[] | null;
  NOT?: AccountRelationTypeFilterInput | null;
  OR?: AccountRelationTypeFilterInput[] | null;
  color?: EntityFilterNumberField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  label?: EntityFilterStringField | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountRelationOrderByNestedInput {
  __typename?: 'AccountRelationOrderByNestedInput';
  account1Id?: OrderByEnum | null;
  account2Id?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRelationOrderByInput {
  __typename?: 'AccountRelationOrderByInput';
  account1?: AccountOrderByNestedInput[] | null;
  account1Id?: OrderByEnum | null;
  account2?: AccountOrderByNestedInput[] | null;
  account2Id?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRelationLabelOrderByInput {
  __typename?: 'AccountRelationLabelOrderByInput';
  accountRelation?: AccountRelationOrderByNestedInput[] | null;
  accountRelationId?: OrderByEnum | null;
  accountRelationType?: AccountRelationTypeOrderByNestedInput[] | null;
  accountRelationTypeId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountRelationLabelFilterInput {
  __typename?: 'AccountRelationLabelFilterInput';
  AND?: AccountRelationLabelFilterInput[] | null;
  NOT?: AccountRelationLabelFilterInput | null;
  OR?: AccountRelationLabelFilterInput[] | null;
  accountRelation?: AccountRelationFilterInput | null;
  accountRelationId?: EntityFilterStringField | null;
  accountRelationType?: AccountRelationTypeFilterInput | null;
  accountRelationTypeId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountRelationFilterInput {
  __typename?: 'AccountRelationFilterInput';
  AND?: AccountRelationFilterInput[] | null;
  NOT?: AccountRelationFilterInput | null;
  OR?: AccountRelationFilterInput[] | null;
  account1?: AccountFilterInput | null;
  account1Id?: EntityFilterStringField | null;
  account2?: AccountFilterInput | null;
  account2Id?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountProfileDataInput {
  __typename?: 'AccountProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: AccountPreviewProfileParams;
}

export interface AccountProductPricingTabDataGridViewOptionsParams {
  __typename?: 'AccountProductPricingTabDataGridViewOptionsParams';
  filterByProductCategoryId?: ID[] | null;
  searchQuery?: string | null;
}

export interface AccountProductPricingOrderByInput {
  __typename?: 'AccountProductPricingOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currency?: CurrencyOrderByNestedInput[] | null;
  currencyId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  price?: OrderByEnum | null;
  product?: ProductOrderByNestedInput[] | null;
  productId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountProductPricingFilterInput {
  __typename?: 'AccountProductPricingFilterInput';
  AND?: AccountProductPricingFilterInput[] | null;
  NOT?: AccountProductPricingFilterInput | null;
  OR?: AccountProductPricingFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  currency?: CurrencyFilterInput | null;
  currencyId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  price?: EntityFilterNumberField | null;
  product?: ProductFilterInput | null;
  productId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountPreviewViewTabParams {
  __typename?: 'AccountPreviewViewTabParams';
  gridColumns: GridColumnsOutputParams[];
  matrix: AccountMatrixViewParams;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface AccountPreviewProfileParams {
  __typename?: 'AccountPreviewProfileParams';
  filter: AccountFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: AccountRoleTabParams;
  view: AccountPreviewViewTabParams;
}

export interface AccountOrderByNestedInput {
  __typename?: 'AccountOrderByNestedInput';
  accountClass?: OrderByEnum | null;
  accountTypeId?: OrderByEnum | null;
  address?: OrderByEnum | null;
  city?: OrderByEnum | null;
  comments?: OrderByEnum | null;
  country?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  customerTypeId?: OrderByEnum | null;
  email1?: OrderByEnum | null;
  email2?: OrderByEnum | null;
  email3?: OrderByEnum | null;
  email4?: OrderByEnum | null;
  email5?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  healthCategory?: OrderByEnum | null;
  healthStatus?: OrderByEnum | null;
  homePage?: OrderByEnum | null;
  id?: OrderByEnum | null;
  industryId?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  ownerId?: OrderByEnum | null;
  parentAccountId?: OrderByEnum | null;
  parentAccountRelationTypeId?: OrderByEnum | null;
  phone1?: OrderByEnum | null;
  phone2?: OrderByEnum | null;
  phone3?: OrderByEnum | null;
  phone4?: OrderByEnum | null;
  phone5?: OrderByEnum | null;
  quickParentAccountName?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  stateProvince?: OrderByEnum | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
  zipCode?: OrderByEnum | null;
}

export interface AccountOrderByInput {
  __typename?: 'AccountOrderByInput';
  accountClass?: OrderByEnum | null;
  accountType?: AccountTypeOrderByNestedInput[] | null;
  accountTypeId?: OrderByEnum | null;
  address?: OrderByEnum | null;
  city?: OrderByEnum | null;
  comments?: OrderByEnum | null;
  country?: OrderByEnum | null;
  created?: OrderByEnum | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListOrderByNestedInput[] | null;
  currencyExchangeRatesListId?: OrderByEnum | null;
  customerType?: DataOrderByNestedInput[] | null;
  customerTypeId?: OrderByEnum | null;
  email1?: OrderByEnum | null;
  email2?: OrderByEnum | null;
  email3?: OrderByEnum | null;
  email4?: OrderByEnum | null;
  email5?: OrderByEnum | null;
  enrolledEmailSequences?: OrderByEnum | null;
  healthCategory?: OrderByEnum | null;
  healthStatus?: OrderByEnum | null;
  homePage?: OrderByEnum | null;
  id?: OrderByEnum | null;
  industry?: DataOrderByNestedInput[] | null;
  industryId?: OrderByEnum | null;
  isArchived?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  name?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  parentAccount?: AccountOrderByNestedInput[] | null;
  parentAccountId?: OrderByEnum | null;
  parentAccountRelationType?: ParentAccountRelationTypeOrderByNestedInput[] | null;
  parentAccountRelationTypeId?: OrderByEnum | null;
  phone1?: OrderByEnum | null;
  phone2?: OrderByEnum | null;
  phone3?: OrderByEnum | null;
  phone4?: OrderByEnum | null;
  phone5?: OrderByEnum | null;
  quickParentAccountName?: OrderByEnum | null;
  relatedEntities?: CommonEntityRepositoryOrderByEntityRelationField | null;
  revision?: OrderByEnum | null;
  shareMode?: OrderByEnum | null;
  socialMedia?: AccountSocialRelationOrderByNestedInput[] | null;
  stateProvince?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
  withCustom?: CommonEntityRepositoryOrderByCustomField | null;
  zipCode?: OrderByEnum | null;
}

export interface AccountMatrixViewParams {
  __typename?: 'AccountMatrixViewParams';
  axisX: AccountMatrixAxisParams;
  axisY: AccountMatrixAxisParams;
  bubbleDisplay: AccountMatrixAccountDisplayEnum;
  showAccountNames: boolean;
  showSegmentationGrid: boolean;
}

export interface AccountMatrixAxisParams {
  __typename?: 'AccountMatrixAxisParams';
  dateDisplay?: AccountMatrixDateDisplayEnum | null;
  fieldId: ID;
  maximum?: number | null;
  minimum?: number | null;
  selectedOptions?: ID[] | null;
  sortOrder: SortOrder;
}

export interface AccountKpiEnumFilterInput {
  __typename?: 'AccountKpiEnumFilterInput';
  NOT?: AccountKpiEnumFilterInput | null;
  eq?: AccountKpiEnum[] | null;
}

export interface AccountKPIOrderByInput {
  __typename?: 'AccountKPIOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  client?: ClientOrderByNestedInput[] | null;
  clientId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  owner?: ClientOrderByNestedInput[] | null;
  ownerId?: OrderByEnum | null;
  revision?: OrderByEnum | null;
  unit?: SalesUnitOrderByNestedInput[] | null;
  unitId?: OrderByEnum | null;
}

export interface AccountKPIFilterInput {
  __typename?: 'AccountKPIFilterInput';
  AND?: AccountKPIFilterInput[] | null;
  NOT?: AccountKPIFilterInput | null;
  OR?: AccountKPIFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  applicationId?: EntityFilterStringField | null;
  client?: ClientFilterInput | null;
  clientId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  kpi?: AccountKpiEnumFilterInput | null;
  modified?: EntityFilterDateTimeField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  revision?: EntityFilterNumberField | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
}

export interface AccountHierarchyTabDataGridViewOptionsParams {
  __typename?: 'AccountHierarchyTabDataGridViewOptionsParams';
  filterByOwnerId?: ID[] | null;
  filterByTags?: ID[] | null;
  searchQuery?: string | null;
  showArchivedRecords?: boolean | null;
}

export interface AccountFilterTabParams {
  __typename?: 'AccountFilterTabParams';
  filterMainBox: MainFilterBoxParams;
  filterSiblingBoxes: FilterBoxParams[];
  formula?: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface AccountFilterInput {
  __typename?: 'AccountFilterInput';
  AND?: AccountFilterInput[] | null;
  NOT?: AccountFilterInput | null;
  OR?: AccountFilterInput[] | null;
  accountClass?: AccountClassEnumFilterInput | null;
  accountType?: AccountTypeFilterInput | null;
  accountTypeId?: EntityFilterStringField | null;
  address?: EntityFilterStringField | null;
  city?: EntityFilterStringField | null;
  comments?: EntityFilterStringField | null;
  country?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  currencyExchangeRatesList?: CurrencyExchangeRatesListFilterInput | null;
  currencyExchangeRatesListId?: EntityFilterStringField | null;
  customerType?: DataFilterInput | null;
  customerTypeId?: EntityFilterStringField | null;
  documents?: CloudObjectRelationFilterInput | null;
  email1?: EntityFilterStringField | null;
  email2?: EntityFilterStringField | null;
  email3?: EntityFilterStringField | null;
  email4?: EntityFilterStringField | null;
  email5?: EntityFilterStringField | null;
  enrolledEmailSequences?: number | null;
  globalSearchQuery?: string | null;
  healthCategory?: EntityFilterStringField | null;
  healthStatus?: EntityFilterNumberField | null;
  homePage?: EntityFilterStringField | null;
  id?: EntityFilterStringField | null;
  industry?: DataFilterInput | null;
  industryId?: EntityFilterStringField | null;
  isArchived?: boolean | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  name?: EntityFilterStringField | null;
  owner?: ClientFilterInput | null;
  ownerId?: EntityFilterStringField | null;
  parentAccount?: AccountFilterInput | null;
  parentAccountId?: EntityFilterStringField | null;
  parentAccountRelationType?: ParentAccountRelationTypeFilterInput | null;
  parentAccountRelationTypeId?: EntityFilterStringField | null;
  phone1?: EntityFilterStringField | null;
  phone2?: EntityFilterStringField | null;
  phone3?: EntityFilterStringField | null;
  phone4?: EntityFilterStringField | null;
  phone5?: EntityFilterStringField | null;
  picture?: CloudObjectFilterInput | null;
  pictureId?: EntityFilterStringField | null;
  quickParentAccountName?: EntityFilterStringField | null;
  relatedEntities?: EntityFilterRelatedField[] | null;
  revision?: EntityFilterNumberField | null;
  shareMode?: ShareModeEnumFilterInput | null;
  sharingClients?: AccountSharingClientRelationFilterInput | null;
  sharingUnits?: AccountSharingSalesUnitRelationFilterInput | null;
  socialMedia?: AccountSocialRelationFilterInput | null;
  stateProvince?: EntityFilterStringField | null;
  staticProfiles?: ProfileRelationFilterInput | null;
  tags?: TagRelationFilterInput | null;
  unit?: SalesUnitFilterInput | null;
  unitId?: EntityFilterStringField | null;
  withCustom?: CustomField[] | null;
  zipCode?: EntityFilterStringField | null;
}

export interface AccountDrilldownFilterParams {
  __typename?: 'AccountDrilldownFilterParams';
  ownerId?: ID[] | null;
}

export interface AccountDataExRelationOrderByInput {
  __typename?: 'AccountDataExRelationOrderByInput';
  account?: AccountOrderByNestedInput[] | null;
  accountId?: OrderByEnum | null;
  created?: OrderByEnum | null;
  data?: DataOrderByNestedInput[] | null;
  dataId?: OrderByEnum | null;
  id?: OrderByEnum | null;
  isDeleted?: OrderByEnum | null;
  modified?: OrderByEnum | null;
  revision?: OrderByEnum | null;
}

export interface AccountDataExRelationFilterInput {
  __typename?: 'AccountDataExRelationFilterInput';
  AND?: AccountDataExRelationFilterInput[] | null;
  NOT?: AccountDataExRelationFilterInput | null;
  OR?: AccountDataExRelationFilterInput[] | null;
  account?: AccountFilterInput | null;
  accountId?: EntityFilterStringField | null;
  created?: EntityFilterDateTimeField | null;
  data?: DataFilterInput | null;
  dataId?: EntityFilterStringField | null;
  dataSetId?: EntityFilterStringField | null;
  globalSearchQuery?: string | null;
  id?: EntityFilterStringField | null;
  isDeleted?: boolean | null;
  modified?: EntityFilterDateTimeField | null;
  revision?: EntityFilterNumberField | null;
}

export interface AccountDashboardProfileViewParams {
  __typename?: 'AccountDashboardProfileViewParams';
  drilldownFields: ID[];
  graphs: DashboardGraphAccountNameType[];
}

export interface AccountDashboardProfileParams {
  __typename?: 'AccountDashboardProfileParams';
  filter: AccountFilterTabParams;
  role: AccountRoleTabParams;
  view: AccountDashboardProfileViewParams;
}

export interface AccountContactTabDataGridQuickFilterParams {
  __typename?: 'AccountContactTabDataGridQuickFilterParams';
  filterByContactsContactedInLastThirtyDays?: boolean | null;
  filterByContactsWithoutJobTitle?: boolean | null;
  filterByRelationship?: OrgRelationshipTypeEnum | null;
  filterByRole?: UUID | null;
}

export interface AccountClassEnumFilterInput {
  __typename?: 'AccountClassEnumFilterInput';
  NOT?: AccountClassEnumFilterInput | null;
  eq?: AccountClassEnum[] | null;
}

export interface AccountArchiveProfileParams {
  __typename?: 'AccountArchiveProfileParams';
  filter: AccountFilterTabParams;
  quickFilter: QuickFilterTabParams;
  role: AccountRoleTabParams;
  view: AccountPreviewViewTabParams;
}

export interface AccountArchiveProfileDataInput {
  __typename?: 'AccountArchiveProfileDataInput';
  shareMode: ProfileShareMode;
  sharedUnits: ID[];
  sharedUsers: ID[];
  tabs: AccountArchiveProfileParams;
}

export interface AccessPipelinesEnumFilterInput {
  __typename?: 'AccessPipelinesEnumFilterInput';
  NOT?: AccessPipelinesEnumFilterInput | null;
  eq?: AccessPipelinesEnum[] | null;
}

export interface AccessLevelProcessBuilderEnumFilterInput {
  __typename?: 'AccessLevelProcessBuilderEnumFilterInput';
  NOT?: AccessLevelProcessBuilderEnumFilterInput | null;
  eq?: AccessLevelProcessBuilderEnum[] | null;
}

export interface AccessLevelPipelineEnumFilterInput {
  __typename?: 'AccessLevelPipelineEnumFilterInput';
  NOT?: AccessLevelPipelineEnumFilterInput | null;
  eq?: AccessLevelPipelineEnum[] | null;
}

export interface AccessLevelFieldEnumFilterInput {
  __typename?: 'AccessLevelFieldEnumFilterInput';
  NOT?: AccessLevelFieldEnumFilterInput | null;
  eq?: AccessLevelFieldEnum[] | null;
}

export interface AccessLevelEntityEnumFilterInput {
  __typename?: 'AccessLevelEntityEnumFilterInput';
  NOT?: AccessLevelEntityEnumFilterInput | null;
  eq?: AccessLevelEntityEnum[] | null;
}

export interface AccessLevelEmailSequenceEnumFilterInput {
  __typename?: 'AccessLevelEmailSequenceEnumFilterInput';
  NOT?: AccessLevelEmailSequenceEnumFilterInput | null;
  eq?: AccessLevelEmailSequenceEnum[] | null;
}

export interface AccessLevelCompanyEmailsEnumFilterInput {
  __typename?: 'AccessLevelCompanyEmailsEnumFilterInput';
  NOT?: AccessLevelCompanyEmailsEnumFilterInput | null;
  eq?: AccessLevelCompanyEmailsEnum[] | null;
}

export interface AccessLevelCommonRecordsEnumEnumFilterInput {
  __typename?: 'AccessLevelCommonRecordsEnumEnumFilterInput';
  NOT?: AccessLevelCommonRecordsEnumEnumFilterInput | null;
  eq?: AccessLevelCommonRecordsEnumEnum[] | null;
}

export interface AccessEntityTypesEnumFilterInput {
  __typename?: 'AccessEntityTypesEnumFilterInput';
  NOT?: AccessEntityTypesEnumFilterInput | null;
  eq?: AccessEntityTypesEnum[] | null;
}

export interface AccessDirectionEnumFilterInput {
  __typename?: 'AccessDirectionEnumFilterInput';
  NOT?: AccessDirectionEnumFilterInput | null;
  eq?: AccessDirectionEnum[] | null;
}

export interface ZendeskTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'ZendeskTeamPipelineHubItemEntity';
  accessToken: string | null;
  baseUrl: string | null;
  configuration: HubItemIntegrationSyncConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isAuthenticated: boolean | null;
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface XlsxOptions extends ForeignCurrencyOption {
  __typename?: 'XlsxOptions';
  includeForeignCurrency: boolean | null;
  type: ReportXlsxType | null;
}

export interface WonStepExtractView  {
  __typename?: 'WonStepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInPipeline: number;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
  successRateCount: number;
  successRateSession: UUID | null;
  successRateTotalCount: number;
  successRateTotalSession: UUID | null;
  totalOpportunitiesSession: UUID | null;
  wonArchiveOpportunitiesValue: number;
}

export interface WhiteSpaceViewSettings  {
  __typename?: 'WhiteSpaceViewSettings';
  showOnlyWhiteSpaceColumns: boolean;
}

export interface WhiteSpaceValue  {
  __typename?: 'WhiteSpaceValue';
  detailOpptyId: UUID | null;
  lost: number | null;
  open: number | null;
  won: number | null;
}

export interface WhiteSpaceDataItem extends ViewItemInterface {
  __typename?: 'WhiteSpaceDataItem';
  accountType: WhiteSpaceAccountTypeEnum;
  id: ID;
  name: string;
  pictureUrl: string | null;
  values: WhiteSpaceValue[];
}

export interface WhiteSpaceColumnItem  {
  __typename?: 'WhiteSpaceColumnItem';
  id: UUID;
  isInComparison: boolean;
  name: string;
}

export interface WhatsAppTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'WhatsAppTeamPipelineHubItemEntity';
  configuration: WhatsAppHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface WhatsAppSettingsOutput  {
  __typename?: 'WhatsAppSettingsOutput';
  enabled: ServiceStatus;
  errorCode: number | null;
  id: ID;
  name: string;
  phoneNumber: string | null;
}

export interface WhatsAppServiceActivationData  {
  __typename?: 'WhatsAppServiceActivationData';
  qrCode: string;
  token: string;
}

export interface WhatsAppService  {
  __typename?: 'WhatsAppService';
  activateCompany: WhatsAppServiceActivationData;
  activatePersonal: WhatsAppServiceActivationData;
  checkActivationStatus: boolean;
  checkIfAccountExists: boolean;
  checkIfActivationLimitReached: boolean;
  reconnectAccount: WhatsAppServiceActivationData;
}

export interface WhatsAppHubItemConfig  {
  __typename?: 'WhatsAppHubItemConfig';
  agreeWithUnipileTermsAndPolicies: boolean;
  agreeWithWhatsAppTermsAndPolicies: boolean;
}

export interface WebresourceRepository  {
  __typename?: 'WebresourceRepository';
  getAll: WebresourceEntity[];
  getByCriteria: WebresourceEntityConnection | null;
  getById: WebresourceEntity | null;
  getByIds: WebresourceEntity[];
  getDraftById: WebresourceEntity;
  getDrafts: WebresourceEntity[];
  getPublished: WebresourceEntity[];
}

export interface WebresourceEntityEdge  {
  __typename?: 'WebresourceEntityEdge';
  cursor: string;
  node: WebresourceEntity | null;
}

export interface WebresourceEntityConnection  {
  __typename?: 'WebresourceEntityConnection';
  edges: WebresourceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface WebresourceEntity  {
  __typename?: 'WebresourceEntity';
  created: DateTime | null;
  displayParam: number;
  entity: string;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  modified: DateTime | null;
  name: string;
  requestMethod: RequestMethodEnum | null;
  revision: number | null;
  url: string | null;
}

export interface WebhookRepository  {
  __typename?: 'WebhookRepository';
  getAll: WebhookEntity[];
  getByCriteria: WebhookEntityConnection | null;
  getById: WebhookEntity | null;
  getByIds: WebhookEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface WebhookEventRepository  {
  __typename?: 'WebhookEventRepository';
  getAll: WebhookEventEntity[];
  getByCriteria: WebhookEventEntityConnection | null;
  getById: WebhookEventEntity | null;
  getByIds: WebhookEventEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface WebhookEventEntityEdge  {
  __typename?: 'WebhookEventEntityEdge';
  cursor: string;
  node: WebhookEventEntity | null;
}

export interface WebhookEventEntityConnection  {
  __typename?: 'WebhookEventEntityConnection';
  edges: WebhookEventEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface WebhookEventEntity  {
  __typename?: 'WebhookEventEntity';
  created: DateTime | null;
  event: EventEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  webhook: WebhookEntity | null;
  webhookId: ID;
}

export interface WebhookEntityEdge  {
  __typename?: 'WebhookEntityEdge';
  cursor: string;
  node: WebhookEntity | null;
}

export interface WebhookEntityConnection  {
  __typename?: 'WebhookEntityConnection';
  edges: WebhookEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface WebhookEntity  {
  __typename?: 'WebhookEntity';
  application: ApplicationEntity | null;
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  events: EventEnum[];
  id: ID;
  insecureSsl: boolean;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  options: JSONString | null;
  signature: ID | null;
  url: string;
}

export interface WebResource extends FormContainerItemInterface {
  __typename?: 'WebResource';
  description: string | null;
  id: string;
  kind: FormContainerItemKind;
  label: string;
  size: number;
}

export interface ViewerSalesUnits  {
  __typename?: 'ViewerSalesUnits';
  manager: ID[];
  member: ID[];
}

export interface Viewer  {
  __typename?: 'Viewer';
  accessControl: Acl;
  apiAccess: ApiAccessEntity | null;
  applicationId: ID;
  id: ID | null;
  salesUnitMembership: ViewerSalesUnits;
  uiSettings: UISettings;
}

export interface ViewTableReportTab extends ViewReportTab {
  __typename?: 'ViewTableReportTab';
  chart: ReportChart;
  currencyId: UUID;
  frozenPanes: FrozenPaneType;
  groupFields: GroupField[];
  history: ReportHistory | null;
  keepLineBreaks: boolean;
  reportValueFields: ReportValueField[];
  sortFields: SortField[];
  total: TableReportTotal;
}

export interface ViewPivotReportTab extends ViewReportTab {
  __typename?: 'ViewPivotReportTab';
  aggregationFields: AggregationField[];
  chart: ReportChart;
  columnFields: PivotField[];
  currencyId: UUID;
  drilldownFields: DisplayFieldItem[];
  frozenPanes: FrozenPaneType;
  history: ReportHistory | null;
  isDrilldownEnabled: boolean;
  reportValueFields: ReportValueField[];
  rowFields: PivotField[];
  rowNumberColumnWidth: number | null;
  rowValueColumnWidth: number | null;
  total: PivotReportTotal;
}

export interface ViewItemGroup  {
  __typename?: 'ViewItemGroup';
  count: number;
  entityApiName: string | null;
  entityName: EntityNameEnum;
  name: string;
}

export interface VerifyPhoneNumberTeamSpaceClientSettingPayload  {
  __typename?: 'VerifyPhoneNumberTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: VerifyPhoneNumberOutput;
}

export interface VerifyPhoneNumberOutput  {
  __typename?: 'VerifyPhoneNumberOutput';
  callSid: string | null;
  status: TwilioCallerStatus;
  verificationCode: string | null;
}

export interface ValidateProcessesPayload  {
  __typename?: 'ValidateProcessesPayload';
  clientMutationId: string | null;
  result: string | null;
}

export interface ValidateAdvancedFormulaPayload  {
  __typename?: 'ValidateAdvancedFormulaPayload';
  errors: ValidateAdvancedFormulaError[] | null;
  isValid: boolean;
}

export interface ValidateAdvancedFormulaError  {
  __typename?: 'ValidateAdvancedFormulaError';
  message: string;
  messageTokens: string[];
  type: number;
}

export interface UserTargetListingOptions  {
  __typename?: 'UserTargetListingOptions';
  filterByGroupTarget: UUID[] | null;
  filterByOwnerId: UUID[] | null;
  filterByPeriod: PeriodOption;
  filterByStatus: TargetStatusEnum[] | null;
  filterByTargetCalculationType: TargetCalculationTypeEnum | null;
}

export interface UserRoleEntity  {
  __typename?: 'UserRoleEntity';
  aiManagement: boolean | null;
  assigmentPossibilities: boolean | null;
  auditAccess: boolean | null;
  automatizerProcessDescriptions: boolean | null;
  dunningServiceAccess: boolean | null;
  dunningServiceChange: boolean | null;
  dunningServiceEmailRecipient: boolean | null;
  helpEditorManagement: boolean | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: UserRolePermsEnum[];
  integrationAnalyticsLogsAccess: boolean | null;
  isDeleteProtected: boolean | null;
  kpiDashboardAccess: boolean | null;
  name: string | null;
  notificationRenewalServiceAccess: boolean | null;
  notificationRenewalServiceChange: boolean | null;
  notificationRenewalServiceEmailRecipient: boolean | null;
  orderManagementAccess: boolean | null;
  orderManagementCancel: boolean | null;
  orderManagementChange: boolean | null;
  orderManagementConfirm: boolean | null;
  orderManagementDelete: boolean | null;
  orderManagementDeleteConfirmation: boolean | null;
  partnerAccess: boolean | null;
  partnerChange: boolean | null;
  partnerDisable: boolean | null;
  paymentTermsManagement: boolean | null;
  sapiUserManagementAccess: boolean | null;
  sapiUserManagementChange: boolean | null;
  sapiUserManagementDelete: boolean | null;
  subscriptionAssignment: boolean | null;
  subscriptionSdr: boolean | null;
  subscriptionSpaceAdminView: boolean | null;
  subscriptionSpaceAutomationHubItemManagement: boolean | null;
  subscriptionSpaceCancel: boolean | null;
  subscriptionSpaceChange: boolean | null;
  subscriptionSpaceCustomerSupport: boolean | null;
  subscriptionSpaceModulesManagement: boolean | null;
  systemMaintenance: boolean | null;
  userManagementAccess: boolean | null;
  userManagementChange: boolean | null;
  userManagementDefineRoles: boolean | null;
  userManagementDisable: boolean | null;
}

export interface UserProfileEntity  {
  __typename?: 'UserProfileEntity';
  administrator: boolean | null;
  availableIdentityProviders: IdentityProviderEntity[] | null;
  businessFunction: string | null;
  city: string | null;
  company: string | null;
  country: string | null;
  created: DateTime | null;
  currentIdp: IdentityProviderEntity | null;
  defaultIdp: IdentityProviderEntity | null;
  defaultIdpId: number | null;
  email: string | null;
  firstName: string | null;
  firstname: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: UserProfilePermsEnum[];
  intercomUserHash: string | null;
  isDeleted: boolean | null;
  language: UserLanguage | null;
  lastLogin: DateTime | null;
  lastName: string | null;
  lastname: string | null;
  locale: string | null;
  middleName: string | null;
  middlename: string | null;
  modified: DateTime | null;
  name: string | null;
  newsletter: boolean | null;
  partnerId: number | null;
  partners: PartnerEntity[] | null;
  passwordChangedAt: DateTime | null;
  pictureUrl: string | null;
  spaces: TeamSpaceEntity[] | null;
  stateProvince: string | null;
  subscriptions: SubscriptionEntity[] | null;
  telephone: string | null;
  timezone: number | null;
  timezoneAutodetect: boolean | null;
  timezoneName: string | null;
  userRole: UserRoleEntity | null;
  userRoleId: number | null;
}

export interface UpsertTaskPayload  {
  __typename?: 'UpsertTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity[];
  status: UpsertResultStatus;
}

export interface UpsertQuotePayload  {
  __typename?: 'UpsertQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity[];
  status: UpsertResultStatus;
}

export interface UpsertProjectPayload  {
  __typename?: 'UpsertProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity[];
  status: UpsertResultStatus;
}

export interface UpsertProductPayload  {
  __typename?: 'UpsertProductPayload';
  clientMutationId: string | null;
  result: ProductEntity[];
  status: UpsertResultStatus;
}

export interface UpsertOpptyProductRelationPayload  {
  __typename?: 'UpsertOpptyProductRelationPayload';
  clientMutationId: string | null;
  result: OpptyProductRelationEntity[];
  status: UpsertResultStatus;
}

export interface UpsertOpportunityPayload  {
  __typename?: 'UpsertOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity[];
  status: UpsertResultStatus;
}

export interface UpsertOnlineFormPayload  {
  __typename?: 'UpsertOnlineFormPayload';
  clientMutationId: string | null;
  result: OnlineFormEntity[];
  status: UpsertResultStatus;
}

export interface UpsertLeadPayload  {
  __typename?: 'UpsertLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity[];
  status: UpsertResultStatus;
}

export interface UpsertCustomEntityPayload  {
  __typename?: 'UpsertCustomEntityPayload';
  clientMutationId: string | null;
  result: CustomEntityEntity[];
  status: UpsertResultStatus;
}

export interface UpsertContactPayload  {
  __typename?: 'UpsertContactPayload';
  clientMutationId: string | null;
  result: ContactEntity[];
  status: UpsertResultStatus;
}

export interface UpsertCallPayload  {
  __typename?: 'UpsertCallPayload';
  clientMutationId: string | null;
  result: CallEntity[];
  status: UpsertResultStatus;
}

export interface UpsertAppointmentPayload  {
  __typename?: 'UpsertAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity[];
  status: UpsertResultStatus;
}

export interface UpsertAccountPayload  {
  __typename?: 'UpsertAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity[];
  status: UpsertResultStatus;
}

export interface UploadedCloudObjectTemplateResult  {
  __typename?: 'UploadedCloudObjectTemplateResult';
  error: string | null;
  resultUrl: string | null;
}

export interface UpdateWhiteSpaceComparisonSettingPayload  {
  __typename?: 'UpdateWhiteSpaceComparisonSettingPayload';
  clientMutationId: string | null;
}

export interface UpdateWhiteSpaceComparisonProductSettingPayload  {
  __typename?: 'UpdateWhiteSpaceComparisonProductSettingPayload';
  clientMutationId: string | null;
}

export interface UpdateWebresourcePayload  {
  __typename?: 'UpdateWebresourcePayload';
  clientMutationId: string | null;
  webresource: WebresourceEntity;
}

export interface UpdateWebhookPayload  {
  __typename?: 'UpdateWebhookPayload';
  clientMutationId: string | null;
  webhook: WebhookEntity | null;
}

export interface UpdateWebhookEventPayload  {
  __typename?: 'UpdateWebhookEventPayload';
  clientMutationId: string | null;
  webhookEvent: WebhookEventEntity | null;
}

export interface UpdateUnsubscribedPhonePayload  {
  __typename?: 'UpdateUnsubscribedPhonePayload';
  clientMutationId: string | null;
  unsubscribedPhone: UnsubscribedPhoneEntity | null;
}

export interface UpdateUISettingsPayload  {
  __typename?: 'UpdateUISettingsPayload';
  clientMutationId: string | null;
}

export interface UpdateTranslationPayload  {
  __typename?: 'UpdateTranslationPayload';
  clientMutationId: string | null;
  translation: TranslationEntity;
}

export interface UpdateTimeframePayload  {
  __typename?: 'UpdateTimeframePayload';
  clientMutationId: string | null;
  timeframe: TimeframeEntity | null;
}

export interface UpdateTextMessagePayload  {
  __typename?: 'UpdateTextMessagePayload';
  clientMutationId: string | null;
  textMessage: TextMessageEntity | null;
}

export interface UpdateTextMessageConversationRelationsPayload  {
  __typename?: 'UpdateTextMessageConversationRelationsPayload';
  clientMutationId: string | null;
  textMessageConversationRelations: TextMessageConversationRelationsEntity | null;
}

export interface UpdateTextMessageConversationPayload  {
  __typename?: 'UpdateTextMessageConversationPayload';
  clientMutationId: string | null;
  textMessageConversation: TextMessageConversationEntity | null;
}

export interface UpdateTeamSpaceClientSettingPayload  {
  __typename?: 'UpdateTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  teamSpaceClientSetting: TeamSpaceClientSettingEntity | null;
}

export interface UpdateTaskTypePayload  {
  __typename?: 'UpdateTaskTypePayload';
  clientMutationId: string | null;
  taskType: TaskTypeEntity;
}

export interface UpdateTaskSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateTaskSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  taskSharingSalesUnitRelation: TaskSharingSalesUnitRelationEntity | null;
}

export interface UpdateTaskSharingClientRelationPayload  {
  __typename?: 'UpdateTaskSharingClientRelationPayload';
  clientMutationId: string | null;
  taskSharingClientRelation: TaskSharingClientRelationEntity | null;
}

export interface UpdateTaskReminderPayload  {
  __typename?: 'UpdateTaskReminderPayload';
  clientMutationId: string | null;
  taskReminder: TaskReminderEntity | null;
}

export interface UpdateTaskRecurrencePayload  {
  __typename?: 'UpdateTaskRecurrencePayload';
  clientMutationId: string | null;
  taskRecurrence: TaskRecurrenceEntity | null;
}

export interface UpdateTaskPayload  {
  __typename?: 'UpdateTaskPayload';
  clientMutationId: string | null;
  task: TaskEntity | null;
}

export interface UpdateTargetRelationPayload  {
  __typename?: 'UpdateTargetRelationPayload';
  clientMutationId: string | null;
  targetRelation: TargetRelationEntity | null;
}

export interface UpdateTargetPayload  {
  __typename?: 'UpdateTargetPayload';
  target: TargetEntity | null;
}

export interface UpdateTagRelationPayload  {
  __typename?: 'UpdateTagRelationPayload';
  clientMutationId: string | null;
  tagRelation: TagRelationEntity | null;
}

export interface UpdateTagPayload  {
  __typename?: 'UpdateTagPayload';
  clientMutationId: string | null;
  tag: TagEntity | null;
}

export interface UpdateStepPayload  {
  __typename?: 'UpdateStepPayload';
  clientMutationId: string | null;
  step: StepEntity | null;
}

export interface UpdateStepChecklistSalesRoleRelationPayload  {
  __typename?: 'UpdateStepChecklistSalesRoleRelationPayload';
  clientMutationId: string | null;
  stepChecklistSalesRoleRelation: StepChecklistSalesRoleRelationEntity | null;
}

export interface UpdateStepChecklistPayload  {
  __typename?: 'UpdateStepChecklistPayload';
  clientMutationId: string | null;
  stepChecklist: StepChecklistEntity | null;
}

export interface UpdateSpaceSettingPayload  {
  __typename?: 'UpdateSpaceSettingPayload';
  clientMutationId: string | null;
  spaceSetting: SpaceSettings;
}

export interface UpdateSpaceNameInUrlCloudObjectTemplatePayload  {
  __typename?: 'UpdateSpaceNameInUrlCloudObjectTemplatePayload';
  clientMutationId: string | null;
}

export interface UpdateSpaceNameInUrlCloudObjectPayload  {
  __typename?: 'UpdateSpaceNameInUrlCloudObjectPayload';
  clientMutationId: string | null;
}

export interface UpdateScreenSettingsPayload  {
  __typename?: 'UpdateScreenSettingsPayload';
  clientMutationId: string | null;
}

export interface UpdateScheduledEmailPayload  {
  __typename?: 'UpdateScheduledEmailPayload';
  clientMutationId: string | null;
  messageId: UUID;
}

export interface UpdateSalesUnitPayload  {
  __typename?: 'UpdateSalesUnitPayload';
  clientMutationId: string | null;
  salesUnit: SalesUnitEntity | null;
}

export interface UpdateSalesRolePayload  {
  __typename?: 'UpdateSalesRolePayload';
  clientMutationId: string | null;
  salesRole: SalesRoleEntity | null;
}

export interface UpdateRevenueScheduleSettingPayload  {
  __typename?: 'UpdateRevenueScheduleSettingPayload';
  clientMutationId: string | null;
  revenueScheduleSetting: RevenueScheduleSetting;
}

export interface UpdateReportSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateReportSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  reportSharingSalesUnitRelation: ReportSharingSalesUnitRelationEntity | null;
}

export interface UpdateReportSharingClientRelationPayload  {
  __typename?: 'UpdateReportSharingClientRelationPayload';
  clientMutationId: string | null;
  reportSharingClientRelation: ReportSharingClientRelationEntity | null;
}

export interface UpdateReportSchedulePayload  {
  __typename?: 'UpdateReportSchedulePayload';
  clientMutationId: string | null;
  reportSchedule: ReportScheduleEntity | null;
}

export interface UpdateReportPayload  {
  __typename?: 'UpdateReportPayload';
  clientMutationId: string | null;
  report: ReportEntity | null;
}

export interface UpdateReportFolderPayload  {
  __typename?: 'UpdateReportFolderPayload';
  clientMutationId: string | null;
  reportFolder: ReportFolderEntity | null;
}

export interface UpdateRelationFieldTabSettingsPayload  {
  __typename?: 'UpdateRelationFieldTabSettingsPayload';
  clientMutationId: string | null;
}

export interface UpdateQuoteTypePayload  {
  __typename?: 'UpdateQuoteTypePayload';
  clientMutationId: string | null;
  quoteType: QuoteTypeEntity;
}

export interface UpdateQuoteSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateQuoteSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  quoteSharingSalesUnitRelation: QuoteSharingSalesUnitRelationEntity | null;
}

export interface UpdateQuoteSharingClientRelationPayload  {
  __typename?: 'UpdateQuoteSharingClientRelationPayload';
  clientMutationId: string | null;
  quoteSharingClientRelation: QuoteSharingClientRelationEntity | null;
}

export interface UpdateQuoteProfilePayload  {
  __typename?: 'UpdateQuoteProfilePayload';
  clientMutationId: string | null;
  profile: QuotePreviewScreenProfile | null;
}

export interface UpdateQuoteProcessPayload  {
  __typename?: 'UpdateQuoteProcessPayload';
  clientMutationId: string | null;
  quoteProcess: QuoteProcessEntity | null;
}

export interface UpdateQuotePayload  {
  __typename?: 'UpdateQuotePayload';
  clientMutationId: string | null;
  quote: QuoteEntity | null;
}

export interface UpdateQuoteKPIPayload  {
  __typename?: 'UpdateQuoteKPIPayload';
  clientMutationId: string | null;
  quoteKpi: QuoteKPIEntity | null;
}

export interface UpdateQuoteDraftProfilePayload  {
  __typename?: 'UpdateQuoteDraftProfilePayload';
  clientMutationId: string | null;
  profile: QuotePreviewScreenProfile | null;
}

export interface UpdateQuoteDataExRelationPayload  {
  __typename?: 'UpdateQuoteDataExRelationPayload';
  clientMutationId: string | null;
  quoteDataExRelation: QuoteDataExRelationEntity | null;
}

export interface UpdateQuoteContactRelationPayload  {
  __typename?: 'UpdateQuoteContactRelationPayload';
  clientMutationId: string | null;
  quoteContactRelation: QuoteContactRelationEntity | null;
}

export interface UpdateQuoteArchiveProfilePayload  {
  __typename?: 'UpdateQuoteArchiveProfilePayload';
  clientMutationId: string | null;
  profile: QuoteArchiveScreenProfile | null;
}

export interface UpdateQuoteArchiveDraftProfilePayload  {
  __typename?: 'UpdateQuoteArchiveDraftProfilePayload';
  clientMutationId: string | null;
  profile: QuoteArchiveScreenProfile | null;
}

export interface UpdateQuoteAccountRelationPayload  {
  __typename?: 'UpdateQuoteAccountRelationPayload';
  clientMutationId: string | null;
  quoteAccountRelation: QuoteAccountRelationEntity | null;
}

export interface UpdateProjectTypePayload  {
  __typename?: 'UpdateProjectTypePayload';
  clientMutationId: string | null;
  projectType: ProjectTypeEntity;
}

export interface UpdateProjectSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateProjectSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  projectSharingSalesUnitRelation: ProjectSharingSalesUnitRelationEntity | null;
}

export interface UpdateProjectSharingClientRelationPayload  {
  __typename?: 'UpdateProjectSharingClientRelationPayload';
  clientMutationId: string | null;
  projectSharingClientRelation: ProjectSharingClientRelationEntity | null;
}

export interface UpdateProjectProfilePayload  {
  __typename?: 'UpdateProjectProfilePayload';
  clientMutationId: string | null;
  profile: ProjectPreviewScreenProfile | null;
}

export interface UpdateProjectPayload  {
  __typename?: 'UpdateProjectPayload';
  clientMutationId: string | null;
  project: ProjectEntity | null;
}

export interface UpdateProjectObjectiveSortPayload  {
  __typename?: 'UpdateProjectObjectiveSortPayload';
  clientMutationId: string | null;
  result: ProjectObjectiveEntity | null;
}

export interface UpdateProjectObjectivePayload  {
  __typename?: 'UpdateProjectObjectivePayload';
  clientMutationId: string | null;
  projectObjective: ProjectObjectiveEntity | null;
}

export interface UpdateProjectObjectiveActivitiesSortPayload  {
  __typename?: 'UpdateProjectObjectiveActivitiesSortPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface UpdateProjectKPIPayload  {
  __typename?: 'UpdateProjectKPIPayload';
  clientMutationId: string | null;
  projectKpi: ProjectKPIEntity | null;
}

export interface UpdateProjectDraftProfilePayload  {
  __typename?: 'UpdateProjectDraftProfilePayload';
  clientMutationId: string | null;
  profile: ProjectPreviewScreenProfile | null;
}

export interface UpdateProjectContactRelationPayload  {
  __typename?: 'UpdateProjectContactRelationPayload';
  clientMutationId: string | null;
  projectContactRelation: ProjectContactRelationEntity | null;
}

export interface UpdateProfileSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateProfileSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  profileSharingSalesUnitRelation: ProfileSharingSalesUnitRelationEntity | null;
}

export interface UpdateProfileSharingClientRelationPayload  {
  __typename?: 'UpdateProfileSharingClientRelationPayload';
  clientMutationId: string | null;
  profileSharingClientRelation: ProfileSharingClientRelationEntity | null;
}

export interface UpdateProfileRelationPayload  {
  __typename?: 'UpdateProfileRelationPayload';
  clientMutationId: string | null;
  profileRelation: ProfileRelationEntity | null;
}

export interface UpdateProfilePayload  {
  __typename?: 'UpdateProfilePayload';
  clientMutationId: string | null;
  profile: ProfileEntity | null;
}

export interface UpdateProductTypePayload  {
  __typename?: 'UpdateProductTypePayload';
  clientMutationId: string | null;
  productType: ProductTypeEntity;
}

export interface UpdateProductPriceListPricePayload  {
  __typename?: 'UpdateProductPriceListPricePayload';
  clientMutationId: string | null;
  productPriceListPrice: ProductPriceListPriceEntity | null;
}

export interface UpdateProductPriceListPayload  {
  __typename?: 'UpdateProductPriceListPayload';
  clientMutationId: string | null;
  productPriceList: ProductPriceListEntity | null;
}

export interface UpdateProductPipelineRelationPayload  {
  __typename?: 'UpdateProductPipelineRelationPayload';
  clientMutationId: string | null;
  productPipelineRelation: ProductPipelineRelationEntity | null;
}

export interface UpdateProductPayload  {
  __typename?: 'UpdateProductPayload';
  clientMutationId: string | null;
  product: ProductEntity | null;
}

export interface UpdateProductCategoryPayload  {
  __typename?: 'UpdateProductCategoryPayload';
  clientMutationId: string | null;
  productCategory: ProductCategoryEntity | null;
}

export interface UpdateProcessTemplatePayload  {
  __typename?: 'UpdateProcessTemplatePayload';
  clientMutationId: string | null;
  processTemplate: ProcessTemplateEntity | null;
}

export interface UpdateProcessPayload  {
  __typename?: 'UpdateProcessPayload';
  clientMutationId: string | null;
  process: ProcessEntity | null;
}

export interface UpdateProcessActivityLogPayload  {
  __typename?: 'UpdateProcessActivityLogPayload';
  clientMutationId: string | null;
  processActivityLog: ProcessActivityLogEntity | null;
}

export interface UpdateProcessActivityLogLinePayload  {
  __typename?: 'UpdateProcessActivityLogLinePayload';
  clientMutationId: string | null;
  processActivityLogLine: ProcessActivityLogLineEntity | null;
}

export interface UpdatePriorityApprovalProcessPayload  {
  __typename?: 'UpdatePriorityApprovalProcessPayload';
  clientMutationId: string | null;
}

export interface UpdatePipelinePayload  {
  __typename?: 'UpdatePipelinePayload';
  clientMutationId: string | null;
  pipeline: PipelineEntity | null;
}

export interface UpdatePhonePayload  {
  __typename?: 'UpdatePhonePayload';
  phone: PhoneEntity | null;
}

export interface UpdateParentAccountRelationTypePayload  {
  __typename?: 'UpdateParentAccountRelationTypePayload';
  clientMutationId: string | null;
  parentAccountRelationType: ParentAccountRelationTypeEntity | null;
}

export interface UpdateOpptyRecurrencePayload  {
  __typename?: 'UpdateOpptyRecurrencePayload';
  clientMutationId: string | null;
  opptyRecurrence: OpptyRecurrenceEntity | null;
}

export interface UpdateOpptyProductRelationTypePayload  {
  __typename?: 'UpdateOpptyProductRelationTypePayload';
  clientMutationId: string | null;
  opptyProductRelationType: OpptyProductRelationTypeEntity;
}

export interface UpdateOpptyProductRelationPayload  {
  __typename?: 'UpdateOpptyProductRelationPayload';
  clientMutationId: string | null;
  opptyProductRelation: OpptyProductRelationEntity | null;
}

export interface UpdateOpptyProductRelationDataExRelationPayload  {
  __typename?: 'UpdateOpptyProductRelationDataExRelationPayload';
  clientMutationId: string | null;
  opptyProductRelationDataExRelation: OpptyProductRelationDataExRelationEntity | null;
}

export interface UpdateOpportunityTypePayload  {
  __typename?: 'UpdateOpportunityTypePayload';
  clientMutationId: string | null;
  opportunityType: OpportunityTypeEntity;
}

export interface UpdateOpportunityProfilePayload  {
  __typename?: 'UpdateOpportunityProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityPreviewScreenProfile | null;
}

export interface UpdateOpportunityPayload  {
  __typename?: 'UpdateOpportunityPayload';
  clientMutationId: string | null;
  opportunity: OpportunityEntity | null;
}

export interface UpdateOpportunityDraftProfilePayload  {
  __typename?: 'UpdateOpportunityDraftProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityPreviewScreenProfile | null;
}

export interface UpdateOnlineFormTypePayload  {
  __typename?: 'UpdateOnlineFormTypePayload';
  clientMutationId: string | null;
  onlineFormType: OnlineFormTypeEntity | null;
}

export interface UpdateOnlineFormTypeEmailRelationPayload  {
  __typename?: 'UpdateOnlineFormTypeEmailRelationPayload';
  clientMutationId: string | null;
  onlineFormTypeEmailRelation: OnlineFormTypeEmailRelationEntity | null;
}

export interface UpdateOnlineFormStylePayload  {
  __typename?: 'UpdateOnlineFormStylePayload';
  clientMutationId: string | null;
  onlineFormStyle: OnlineFormStyleEntity | null;
}

export interface UpdateOnlineFormRelationPayload  {
  __typename?: 'UpdateOnlineFormRelationPayload';
  clientMutationId: string | null;
  onlineFormRelation: OnlineFormRelationEntity | null;
}

export interface UpdateOnlineFormPayload  {
  __typename?: 'UpdateOnlineFormPayload';
  clientMutationId: string | null;
  onlineForm: OnlineFormEntity | null;
}

export interface UpdateOnlineFormDataExRelationPayload  {
  __typename?: 'UpdateOnlineFormDataExRelationPayload';
  clientMutationId: string | null;
  onlineFormDataExRelation: OnlineFormDataExRelationEntity | null;
}

export interface UpdateOnlineFormActivityLogLinePayload  {
  __typename?: 'UpdateOnlineFormActivityLogLinePayload';
  clientMutationId: string | null;
  onlineFormActivityLogLine: OnlineFormActivityLogLineEntity | null;
}

export interface UpdateNotePayload  {
  __typename?: 'UpdateNotePayload';
  clientMutationId: string | null;
  note: NoteEntity | null;
}

export interface UpdateNavigatorProfilePayload  {
  __typename?: 'UpdateNavigatorProfilePayload';
  clientMutationId: string | null;
  profile: NavigatorScreenProfile | null;
}

export interface UpdateNavigatorDraftProfilePayload  {
  __typename?: 'UpdateNavigatorDraftProfilePayload';
  clientMutationId: string | null;
  profile: NavigatorScreenProfile | null;
}

export interface UpdateMessagingPhonePayload  {
  __typename?: 'UpdateMessagingPhonePayload';
  phone: PhoneEntity | null;
}

export interface UpdateMessageSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateMessageSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  messageSharingSalesUnitRelation: MessageSharingSalesUnitRelationEntity | null;
}

export interface UpdateMessageSharingClientRelationPayload  {
  __typename?: 'UpdateMessageSharingClientRelationPayload';
  clientMutationId: string | null;
  messageSharingClientRelation: MessageSharingClientRelationEntity | null;
}

export interface UpdateMessageRelationPayload  {
  __typename?: 'UpdateMessageRelationPayload';
  clientMutationId: string | null;
  messageRelation: MessageRelationEntity | null;
}

export interface UpdateMemoPayload  {
  __typename?: 'UpdateMemoPayload';
  clientMutationId: string | null;
  memo: MemoEntity | null;
}

export interface UpdateMemoCommentPayload  {
  __typename?: 'UpdateMemoCommentPayload';
  clientMutationId: string | null;
  memoComment: MemoCommentEntity | null;
}

export interface UpdateMediaPayload  {
  __typename?: 'UpdateMediaPayload';
  clientMutationId: string | null;
  media: MediaEntity | null;
}

export interface UpdateMasterRightPayload  {
  __typename?: 'UpdateMasterRightPayload';
  clientMutationId: string | null;
  masterRight: MasterRightEntity | null;
}

export interface UpdateLinkedItemsEmailPayload  {
  __typename?: 'UpdateLinkedItemsEmailPayload';
  clientMutationId: string | null;
  result: EmailLinkedItem[];
}

export interface UpdateLifeCycleProfilePayload  {
  __typename?: 'UpdateLifeCycleProfilePayload';
  clientMutationId: string | null;
  profile: LifeCycleScreenProfile | null;
}

export interface UpdateLifeCycleDraftProfilePayload  {
  __typename?: 'UpdateLifeCycleDraftProfilePayload';
  clientMutationId: string | null;
  profile: LifeCycleScreenProfile | null;
}

export interface UpdateLeadTypePayload  {
  __typename?: 'UpdateLeadTypePayload';
  clientMutationId: string | null;
  leadType: LeadTypeEntity;
}

export interface UpdateLeadProfilePayload  {
  __typename?: 'UpdateLeadProfilePayload';
  clientMutationId: string | null;
  profile: LeadPreviewScreenProfile | null;
}

export interface UpdateLeadProcessPayload  {
  __typename?: 'UpdateLeadProcessPayload';
  clientMutationId: string | null;
  leadProcess: LeadProcessEntity | null;
}

export interface UpdateLeadPayload  {
  __typename?: 'UpdateLeadPayload';
  clientMutationId: string | null;
  lead: LeadEntity | null;
}

export interface UpdateLeadOpptyStepCheckListRelationPayload  {
  __typename?: 'UpdateLeadOpptyStepCheckListRelationPayload';
  clientMutationId: string | null;
  leadOpptyStepCheckListRelation: LeadOpptyStepCheckListRelationEntity | null;
}

export interface UpdateLeadOpptySharingSalesUnitRelationPayload  {
  __typename?: 'UpdateLeadOpptySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingSalesUnitRelation: LeadOpptySharingSalesUnitRelationEntity | null;
}

export interface UpdateLeadOpptySharingClientRelationPayload  {
  __typename?: 'UpdateLeadOpptySharingClientRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingClientRelation: LeadOpptySharingClientRelationEntity | null;
}

export interface UpdateLeadOpptyKPIPayload  {
  __typename?: 'UpdateLeadOpptyKPIPayload';
  clientMutationId: string | null;
  leadOpptyKpi: LeadOpptyKPIEntity | null;
}

export interface UpdateLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'UpdateLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactSalesRoleRelation: LeadOpptyContactSalesRoleRelationEntity | null;
}

export interface UpdateLeadOpptyContactRelationPayload  {
  __typename?: 'UpdateLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactRelation: LeadOpptyContactRelationEntity | null;
}

export interface UpdateLeadOpptyContactGroupRelationPayload  {
  __typename?: 'UpdateLeadOpptyContactGroupRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationEntity | null;
}

export interface UpdateLeadOpptyAccountRelationPayload  {
  __typename?: 'UpdateLeadOpptyAccountRelationPayload';
  clientMutationId: string | null;
  leadOpptyAccountRelation: LeadOpptyAccountRelationEntity | null;
}

export interface UpdateLeadDraftProfilePayload  {
  __typename?: 'UpdateLeadDraftProfilePayload';
  clientMutationId: string | null;
  profile: LeadPreviewScreenProfile | null;
}

export interface UpdateLeadArchiveProfilePayload  {
  __typename?: 'UpdateLeadArchiveProfilePayload';
  clientMutationId: string | null;
  profile: LeadArchiveScreenProfile | null;
}

export interface UpdateLeadArchiveDraftProfilePayload  {
  __typename?: 'UpdateLeadArchiveDraftProfilePayload';
  clientMutationId: string | null;
  profile: LeadArchiveScreenProfile | null;
}

export interface UpdateInterfacePreviewPayload  {
  __typename?: 'UpdateInterfacePreviewPayload';
  clientMutationId: string | null;
  interfacePreview: InterfacePreviewEntity;
}

export interface UpdateInsightsProfilePayload  {
  __typename?: 'UpdateInsightsProfilePayload';
  clientMutationId: string | null;
  profile: InsightsScreenProfile | null;
}

export interface UpdateInsightsDraftProfilePayload  {
  __typename?: 'UpdateInsightsDraftProfilePayload';
  clientMutationId: string | null;
  profile: InsightsScreenProfile | null;
}

export interface UpdateIndicatorsProfilePayload  {
  __typename?: 'UpdateIndicatorsProfilePayload';
  clientMutationId: string | null;
  profile: IndicatorsScreenProfile | null;
}

export interface UpdateIndicatorsDraftProfilePayload  {
  __typename?: 'UpdateIndicatorsDraftProfilePayload';
  clientMutationId: string | null;
  profile: IndicatorsScreenProfile | null;
}

export interface UpdateImportMappingMaskPayload  {
  __typename?: 'UpdateImportMappingMaskPayload';
  clientMutationId: string | null;
  importMappingMask: ImportMappingMaskEntity | null;
}

export interface UpdateGhostLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'UpdateGhostLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactSalesRoleRelation: GhostLeadOpptyContactSalesRoleRelationEntity | null;
}

export interface UpdateGhostLeadOpptyContactRelationPayload  {
  __typename?: 'UpdateGhostLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactRelation: GhostLeadOpptyContactRelationEntity | null;
}

export interface UpdateGhostContactPayload  {
  __typename?: 'UpdateGhostContactPayload';
  clientMutationId: string | null;
  ghostContact: GhostContactEntity | null;
}

export interface UpdateGhostContactAccountRelationPayload  {
  __typename?: 'UpdateGhostContactAccountRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountRelation: GhostContactAccountRelationEntity | null;
}

export interface UpdateGhostContactAccountAccountRoleRelationPayload  {
  __typename?: 'UpdateGhostContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountAccountRoleRelation: GhostContactAccountAccountRoleRelationEntity | null;
}

export interface UpdateFormViewSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateFormViewSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  formViewSharingSalesUnitRelation: FormViewSharingSalesUnitRelationEntity | null;
}

export interface UpdateFormViewSharingClientRelationPayload  {
  __typename?: 'UpdateFormViewSharingClientRelationPayload';
  clientMutationId: string | null;
  formViewSharingClientRelation: FormViewSharingClientRelationEntity | null;
}

export interface UpdateFormViewPayload  {
  __typename?: 'UpdateFormViewPayload';
  clientMutationId: string | null;
  formView: FormViewEntity | null;
}

export interface UpdateForecastPayload  {
  __typename?: 'UpdateForecastPayload';
  clientMutationId: string | null;
  forecast: ForecastEntity | null;
}

export interface UpdateFieldSequencePayload  {
  __typename?: 'UpdateFieldSequencePayload';
  clientMutationId: string | null;
  fieldSequence: FieldSequenceEntity;
}

export interface UpdateFieldPermissionPayload  {
  __typename?: 'UpdateFieldPermissionPayload';
  clientMutationId: string | null;
  fieldPermission: FieldPermissionEntity;
}

export interface UpdateFieldPayload  {
  __typename?: 'UpdateFieldPayload';
  clientMutationId: string | null;
  field: FieldEntity;
}

export interface UpdateFieldMappingPayload  {
  __typename?: 'UpdateFieldMappingPayload';
  fieldMapping: FieldMappingEntity | null;
}

export interface UpdateFeedProfilePayload  {
  __typename?: 'UpdateFeedProfilePayload';
  clientMutationId: string | null;
  profile: FeedScreenProfile | null;
}

export interface UpdateFeedEmailProfilePayload  {
  __typename?: 'UpdateFeedEmailProfilePayload';
  clientMutationId: string | null;
  profile: FeedEmailScreenProfile | null;
}

export interface UpdateFeedEmailDraftProfilePayload  {
  __typename?: 'UpdateFeedEmailDraftProfilePayload';
  clientMutationId: string | null;
  profile: FeedEmailScreenProfile | null;
}

export interface UpdateFeedEmailDetailProfilePayload  {
  __typename?: 'UpdateFeedEmailDetailProfilePayload';
  clientMutationId: string | null;
  profile: FeedEmailDetailScreenProfile | null;
}

export interface UpdateFeedDraftProfilePayload  {
  __typename?: 'UpdateFeedDraftProfilePayload';
  clientMutationId: string | null;
  profile: FeedScreenProfile | null;
}

export interface UpdateFeedDetailProfilePayload  {
  __typename?: 'UpdateFeedDetailProfilePayload';
  clientMutationId: string | null;
  profile: FeedDetailScreenProfile | null;
}

export interface UpdateEntitySettingsPayload  {
  __typename?: 'UpdateEntitySettingsPayload';
  clientMutationId: string | null;
  entitySettings: EntitySettingsEntity;
}

export interface UpdateEntityScoringPayload  {
  __typename?: 'UpdateEntityScoringPayload';
  clientMutationId: string | null;
  entityScoring: EntityScoringEntity | null;
}

export interface UpdateEntityHealthPayload  {
  __typename?: 'UpdateEntityHealthPayload';
  clientMutationId: string | null;
  entityHealth: EntityHealthEntity | null;
}

export interface UpdateEntityFitnessPayload  {
  __typename?: 'UpdateEntityFitnessPayload';
  clientMutationId: string | null;
  entityFitness: EntityFitnessEntity | null;
}

export interface UpdateEntityFitnessIndicatorPayload  {
  __typename?: 'UpdateEntityFitnessIndicatorPayload';
  clientMutationId: string | null;
  entityFitnessIndicator: EntityFitnessIndicatorEntity | null;
}

export interface UpdateEntityCustomNameSettingPayload  {
  __typename?: 'UpdateEntityCustomNameSettingPayload';
  clientMutationId: string | null;
  entityCustomNames: EntityCustomNameSetting[];
}

export interface UpdateEmailThreadContentShareModeEmailPayload  {
  __typename?: 'UpdateEmailThreadContentShareModeEmailPayload';
  clientMutationId: string | null;
  result: UUID[];
}

export interface UpdateEmailTemplateSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateEmailTemplateSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingSalesUnitRelation: EmailTemplateSharingSalesUnitRelationEntity | null;
}

export interface UpdateEmailTemplateSharingClientRelationPayload  {
  __typename?: 'UpdateEmailTemplateSharingClientRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingClientRelation: EmailTemplateSharingClientRelationEntity | null;
}

export interface UpdateEmailTemplatePayload  {
  __typename?: 'UpdateEmailTemplatePayload';
  clientMutationId: string | null;
  emailTemplate: EmailTemplateEntity | null;
}

export interface UpdateEmailTemplateFolderPayload  {
  __typename?: 'UpdateEmailTemplateFolderPayload';
  clientMutationId: string | null;
  emailTemplateFolder: EmailTemplateFolderEntity | null;
}

export interface UpdateEmailSequencePayload  {
  __typename?: 'UpdateEmailSequencePayload';
  clientMutationId: string | null;
  emailSequence: EmailSequenceEntity | null;
}

export interface UpdateEmailSequenceEnrolledPayload  {
  __typename?: 'UpdateEmailSequenceEnrolledPayload';
  clientMutationId: string | null;
  emailSequenceEnrolled: EmailSequenceEnrolledEntity | null;
}

export interface UpdateEmailSequenceActivityLogPayload  {
  __typename?: 'UpdateEmailSequenceActivityLogPayload';
  clientMutationId: string | null;
  emailSequenceActivityLog: EmailSequenceActivityLogEntity | null;
}

export interface UpdateEmailSequenceActivityLogLinePayload  {
  __typename?: 'UpdateEmailSequenceActivityLogLinePayload';
  clientMutationId: string | null;
  emailSequenceActivityLogLine: EmailSequenceActivityLogLineEntity | null;
}

export interface UpdateEmailPayload  {
  __typename?: 'UpdateEmailPayload';
  clientMutationId: string | null;
  email: EmailEntity | null;
}

export interface UpdateEmailNotificationsSettingOnExistingUsersPayload  {
  __typename?: 'UpdateEmailNotificationsSettingOnExistingUsersPayload';
  clientMutationId: string | null;
}

export interface UpdateEmailEventPayload  {
  __typename?: 'UpdateEmailEventPayload';
  clientMutationId: string | null;
  emailEvent: EmailEventEntity | null;
}

export interface UpdateEmailContentSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateEmailContentSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailContentSharingSalesUnitRelation: EmailContentSharingSalesUnitRelationEntity | null;
}

export interface UpdateEmailContentSharingClientRelationPayload  {
  __typename?: 'UpdateEmailContentSharingClientRelationPayload';
  clientMutationId: string | null;
  emailContentSharingClientRelation: EmailContentSharingClientRelationEntity | null;
}

export interface UpdateDuplicateCheckerSettings  {
  __typename?: 'UpdateDuplicateCheckerSettings';
  success: boolean;
}

export interface UpdateDraftWebresourcePayload  {
  __typename?: 'UpdateDraftWebresourcePayload';
  clientMutationId: string | null;
  webresource: WebresourceEntity;
}

export interface UpdateDraftTranslationPayload  {
  __typename?: 'UpdateDraftTranslationPayload';
  clientMutationId: string | null;
  translation: TranslationEntity;
}

export interface UpdateDraftTaskTypePayload  {
  __typename?: 'UpdateDraftTaskTypePayload';
  clientMutationId: string | null;
  taskType: TaskTypeEntity;
}

export interface UpdateDraftQuoteTypePayload  {
  __typename?: 'UpdateDraftQuoteTypePayload';
  clientMutationId: string | null;
  quoteType: QuoteTypeEntity;
}

export interface UpdateDraftProjectTypePayload  {
  __typename?: 'UpdateDraftProjectTypePayload';
  clientMutationId: string | null;
  projectType: ProjectTypeEntity;
}

export interface UpdateDraftProductTypePayload  {
  __typename?: 'UpdateDraftProductTypePayload';
  clientMutationId: string | null;
  productType: ProductTypeEntity;
}

export interface UpdateDraftOpptyProductRelationTypePayload  {
  __typename?: 'UpdateDraftOpptyProductRelationTypePayload';
  clientMutationId: string | null;
  opptyProductRelationType: OpptyProductRelationTypeEntity;
}

export interface UpdateDraftOpportunityTypePayload  {
  __typename?: 'UpdateDraftOpportunityTypePayload';
  clientMutationId: string | null;
  opportunityType: OpportunityTypeEntity;
}

export interface UpdateDraftLeadTypePayload  {
  __typename?: 'UpdateDraftLeadTypePayload';
  clientMutationId: string | null;
  leadType: LeadTypeEntity;
}

export interface UpdateDraftInterfacePreviewPayload  {
  __typename?: 'UpdateDraftInterfacePreviewPayload';
  clientMutationId: string | null;
  interfacePreview: InterfacePreviewEntity;
}

export interface UpdateDraftFieldSequencePayload  {
  __typename?: 'UpdateDraftFieldSequencePayload';
  clientMutationId: string | null;
  fieldSequence: FieldSequenceEntity;
}

export interface UpdateDraftFieldPermissionPayload  {
  __typename?: 'UpdateDraftFieldPermissionPayload';
  clientMutationId: string | null;
  fieldPermission: FieldPermissionEntity;
}

export interface UpdateDraftFieldPayload  {
  __typename?: 'UpdateDraftFieldPayload';
  clientMutationId: string | null;
  field: FieldEntity;
}

export interface UpdateDraftEntitySettingsPayload  {
  __typename?: 'UpdateDraftEntitySettingsPayload';
  clientMutationId: string | null;
  entitySettings: EntitySettingsEntity;
}

export interface UpdateDraftDataPayload  {
  __typename?: 'UpdateDraftDataPayload';
  clientMutationId: string | null;
  data: DataEntity;
}

export interface UpdateDraftCustomEntityTypePayload  {
  __typename?: 'UpdateDraftCustomEntityTypePayload';
  customEntityType: CustomEntityTypeEntity;
}

export interface UpdateDraftCustomEntityRelationPayload  {
  __typename?: 'UpdateDraftCustomEntityRelationPayload';
  clientMutationId: string | null;
  customEntityRelation: CustomEntityRelationEntity;
}

export interface UpdateDraftContactTypePayload  {
  __typename?: 'UpdateDraftContactTypePayload';
  clientMutationId: string | null;
  contactType: ContactTypeEntity;
}

export interface UpdateDraftAppointmentTypePayload  {
  __typename?: 'UpdateDraftAppointmentTypePayload';
  appointmentType: AppointmentTypeEntity;
  clientMutationId: string | null;
}

export interface UpdateDraftAccountTypePayload  {
  __typename?: 'UpdateDraftAccountTypePayload';
  accountType: AccountTypeEntity;
  clientMutationId: string | null;
}

export interface UpdateDetailSettingsTargetPayload  {
  __typename?: 'UpdateDetailSettingsTargetPayload';
  result: TargetEntity[];
}

export interface UpdateDataPayload  {
  __typename?: 'UpdateDataPayload';
  clientMutationId: string | null;
  data: DataEntity | null;
}

export interface UpdateCustomEntityUiSettingsPayload  {
  __typename?: 'UpdateCustomEntityUiSettingsPayload';
  clientMutationId: string | null;
}

export interface UpdateCustomEntityTypePayload  {
  __typename?: 'UpdateCustomEntityTypePayload';
  clientMutationId: string | null;
  customEntityType: CustomEntityTypeEntity;
}

export interface UpdateCustomEntitySharingSalesUnitRelationPayload  {
  __typename?: 'UpdateCustomEntitySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  customEntitySharingSalesUnitRelation: CustomEntitySharingSalesUnitRelationEntity | null;
}

export interface UpdateCustomEntitySharingClientRelationPayload  {
  __typename?: 'UpdateCustomEntitySharingClientRelationPayload';
  clientMutationId: string | null;
  customEntitySharingClientRelation: CustomEntitySharingClientRelationEntity | null;
}

export interface UpdateCustomEntityRelationPayload  {
  __typename?: 'UpdateCustomEntityRelationPayload';
  clientMutationId: string | null;
  customEntityRelation: CustomEntityRelationEntity;
}

export interface UpdateCustomEntityRelationDataPayload  {
  __typename?: 'UpdateCustomEntityRelationDataPayload';
  clientMutationId: string | null;
  customEntityRelationData: CustomEntityRelationDataEntity | null;
}

export interface UpdateCustomEntityProfilePayload  {
  __typename?: 'UpdateCustomEntityProfilePayload';
  clientMutationId: string | null;
  profile: CustomEntityPreviewScreenProfile | null;
}

export interface UpdateCustomEntityPayload  {
  __typename?: 'UpdateCustomEntityPayload';
  clientMutationId: string | null;
  customEntity: CustomEntityEntity | null;
}

export interface UpdateCustomEntityMetaMutationPayload  {
  __typename?: 'UpdateCustomEntityMetaMutationPayload';
  clientMutationId: string | null;
  entity: CustomEntityDescriptor;
}

export interface UpdateCustomEntityDraftProfilePayload  {
  __typename?: 'UpdateCustomEntityDraftProfilePayload';
  clientMutationId: string | null;
  profile: CustomEntityPreviewScreenProfile | null;
}

export interface UpdateCustomEntityDataExRelationPayload  {
  __typename?: 'UpdateCustomEntityDataExRelationPayload';
  clientMutationId: string | null;
  customEntityDataExRelation: CustomEntityDataExRelationEntity | null;
}

export interface UpdateCurrencyPayload  {
  __typename?: 'UpdateCurrencyPayload';
  clientMutationId: string | null;
  currency: CurrencyEntity | null;
}

export interface UpdateCurrencyExchangeRatesListPayload  {
  __typename?: 'UpdateCurrencyExchangeRatesListPayload';
  clientMutationId: string | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
}

export interface UpdateCurrencyExchangeRatePayload  {
  __typename?: 'UpdateCurrencyExchangeRatePayload';
  clientMutationId: string | null;
  currencyExchangeRate: CurrencyExchangeRateEntity | null;
}

export interface UpdateConversionsProfilePayload  {
  __typename?: 'UpdateConversionsProfilePayload';
  clientMutationId: string | null;
  profile: ConversionsScreenProfile | null;
}

export interface UpdateConversionsDraftProfilePayload  {
  __typename?: 'UpdateConversionsDraftProfilePayload';
  clientMutationId: string | null;
  profile: ConversionsScreenProfile | null;
}

export interface UpdateContactTypePayload  {
  __typename?: 'UpdateContactTypePayload';
  clientMutationId: string | null;
  contactType: ContactTypeEntity;
}

export interface UpdateContactSocialRelationPayload  {
  __typename?: 'UpdateContactSocialRelationPayload';
  clientMutationId: string | null;
  contactSocialRelation: ContactSocialRelationEntity | null;
}

export interface UpdateContactSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateContactSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  contactSharingSalesUnitRelation: ContactSharingSalesUnitRelationEntity | null;
}

export interface UpdateContactSharingClientRelationPayload  {
  __typename?: 'UpdateContactSharingClientRelationPayload';
  clientMutationId: string | null;
  contactSharingClientRelation: ContactSharingClientRelationEntity | null;
}

export interface UpdateContactRelationTypePayload  {
  __typename?: 'UpdateContactRelationTypePayload';
  clientMutationId: string | null;
  contactRelationType: ContactRelationTypeEntity | null;
}

export interface UpdateContactRelationPayload  {
  __typename?: 'UpdateContactRelationPayload';
  clientMutationId: string | null;
  contactRelation: ContactRelationEntity | null;
}

export interface UpdateContactRelationLabelPayload  {
  __typename?: 'UpdateContactRelationLabelPayload';
  clientMutationId: string | null;
  contactRelationLabel: ContactRelationLabelEntity | null;
}

export interface UpdateContactProfilePayload  {
  __typename?: 'UpdateContactProfilePayload';
  clientMutationId: string | null;
  profile: ContactPreviewScreenProfile | null;
}

export interface UpdateContactPayload  {
  __typename?: 'UpdateContactPayload';
  clientMutationId: string | null;
  contact: ContactEntity | null;
}

export interface UpdateContactKPIPayload  {
  __typename?: 'UpdateContactKPIPayload';
  clientMutationId: string | null;
  contactKpi: ContactKPIEntity | null;
}

export interface UpdateContactDraftProfilePayload  {
  __typename?: 'UpdateContactDraftProfilePayload';
  clientMutationId: string | null;
  profile: ContactPreviewScreenProfile | null;
}

export interface UpdateContactArchiveProfilePayload  {
  __typename?: 'UpdateContactArchiveProfilePayload';
  clientMutationId: string | null;
  profile: ContactArchiveScreenProfile | null;
}

export interface UpdateContactArchiveDraftProfilePayload  {
  __typename?: 'UpdateContactArchiveDraftProfilePayload';
  clientMutationId: string | null;
  profile: ContactArchiveScreenProfile | null;
}

export interface UpdateContactAccountRelationPayload  {
  __typename?: 'UpdateContactAccountRelationPayload';
  clientMutationId: string | null;
  contactAccountRelation: ContactAccountRelationEntity | null;
}

export interface UpdateContactAccountAccountRoleRelationPayload  {
  __typename?: 'UpdateContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  contactAccountAccountRoleRelation: ContactAccountAccountRoleRelationEntity | null;
}

export interface UpdateCompanyEmailPayload  {
  __typename?: 'UpdateCompanyEmailPayload';
  companyEmail: CompanyEmailEntity | null;
}

export interface UpdateCloudObjectTemplatePayload  {
  __typename?: 'UpdateCloudObjectTemplatePayload';
  clientMutationId: string | null;
  cloudObjectTemplate: CloudObjectTemplateEntity | null;
}

export interface UpdateCloudObjectStepRelationPayload  {
  __typename?: 'UpdateCloudObjectStepRelationPayload';
  clientMutationId: string | null;
  cloudObjectStepRelation: CloudObjectStepRelationEntity | null;
}

export interface UpdateCloudObjectRelationPayload  {
  __typename?: 'UpdateCloudObjectRelationPayload';
  clientMutationId: string | null;
  cloudObjectRelation: CloudObjectRelationEntity | null;
}

export interface UpdateCloudObjectPayload  {
  __typename?: 'UpdateCloudObjectPayload';
  clientMutationId: string | null;
  cloudObject: CloudObjectEntity | null;
}

export interface UpdateCloudObjectFolderPayload  {
  __typename?: 'UpdateCloudObjectFolderPayload';
  clientMutationId: string | null;
  cloudObjectFolder: CloudObjectFolderEntity | null;
}

export interface UpdateClientStoryReadPayload  {
  __typename?: 'UpdateClientStoryReadPayload';
  clientMutationId: string | null;
  clientStoryRead: ClientStoryReadEntity | null;
}

export interface UpdateClientSettingPayload  {
  __typename?: 'UpdateClientSettingPayload';
  clientMutationId: string | null;
  clientSetting: ClientSettingEntity | null;
}

export interface UpdateClientPayload  {
  __typename?: 'UpdateClientPayload';
  client: ClientEntity | null;
  clientMutationId: string | null;
}

export interface UpdateClientFavoritePayload  {
  __typename?: 'UpdateClientFavoritePayload';
  clientFavorite: ClientFavoriteEntity | null;
  clientMutationId: string | null;
}

export interface UpdateClientExcludedOpptyPayload  {
  __typename?: 'UpdateClientExcludedOpptyPayload';
  clientExcludedOppty: ClientExcludedOpptyEntity | null;
  clientMutationId: string | null;
}

export interface UpdateChatConversationPayload  {
  __typename?: 'UpdateChatConversationPayload';
  chatConversation: ChatConversationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateCallPayload  {
  __typename?: 'UpdateCallPayload';
  call: CallEntity | null;
  clientMutationId: string | null;
}

export interface UpdateBetterNavigatorProfilePayload  {
  __typename?: 'UpdateBetterNavigatorProfilePayload';
  clientMutationId: string | null;
  profile: BetterNavigatorScreenProfile | null;
}

export interface UpdateBetterNavigatorDraftProfilePayload  {
  __typename?: 'UpdateBetterNavigatorDraftProfilePayload';
  clientMutationId: string | null;
  profile: BetterNavigatorScreenProfile | null;
}

export interface UpdateAutomationHubItemPayload  {
  __typename?: 'UpdateAutomationHubItemPayload';
  automationHubItem: AutomationHubItemEntity | null;
  clientMutationId: string | null;
}

export interface UpdateArchiveProfilePayload  {
  __typename?: 'UpdateArchiveProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityArchiveScreenProfile | null;
}

export interface UpdateArchiveDraftProfilePayload  {
  __typename?: 'UpdateArchiveDraftProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityArchiveScreenProfile | null;
}

export interface UpdateApprovalProcessPayload  {
  __typename?: 'UpdateApprovalProcessPayload';
  approvalProcess: ApprovalProcessEntity | null;
  clientMutationId: string | null;
}

export interface UpdateApprovalProcessActivityLogLinePayload  {
  __typename?: 'UpdateApprovalProcessActivityLogLinePayload';
  approvalProcessActivityLogLine: ApprovalProcessActivityLogLineEntity | null;
  clientMutationId: string | null;
}

export interface UpdateApprovalPayload  {
  __typename?: 'UpdateApprovalPayload';
  approval: ApprovalEntity | null;
  clientMutationId: string | null;
}

export interface UpdateApprovalApproverPayload  {
  __typename?: 'UpdateApprovalApproverPayload';
  approvalApprover: ApprovalApproverEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAppointmentTypePayload  {
  __typename?: 'UpdateAppointmentTypePayload';
  appointmentType: AppointmentTypeEntity;
  clientMutationId: string | null;
}

export interface UpdateAppointmentSchedulePayload  {
  __typename?: 'UpdateAppointmentSchedulePayload';
  appointmentSchedule: AppointmentScheduleEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAppointmentReminderPayload  {
  __typename?: 'UpdateAppointmentReminderPayload';
  appointmentReminder: AppointmentReminderEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAppointmentPayload  {
  __typename?: 'UpdateAppointmentPayload';
  appointment: AppointmentEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAppointmentInviteeResponsePayload  {
  __typename?: 'UpdateAppointmentInviteeResponsePayload';
  clientMutationId: string | null;
}

export interface UpdateAppointmentContactInviteesRelationPayload  {
  __typename?: 'UpdateAppointmentContactInviteesRelationPayload';
  appointmentContactInviteesRelation: AppointmentContactInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAppointmentClientInviteesRelationPayload  {
  __typename?: 'UpdateAppointmentClientInviteesRelationPayload';
  appointmentClientInviteesRelation: AppointmentClientInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateApiAccessPayload  {
  __typename?: 'UpdateApiAccessPayload';
  apiAccess: ApiAccessEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedQuoteTypePayload  {
  __typename?: 'UpdateAllowedQuoteTypePayload';
  allowedQuoteType: AllowedQuoteTypeEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedPipelinePayload  {
  __typename?: 'UpdateAllowedPipelinePayload';
  allowedPipeline: AllowedPipelineEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedLeadTypePayload  {
  __typename?: 'UpdateAllowedLeadTypePayload';
  allowedLeadType: AllowedLeadTypeEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedContactTypePayload  {
  __typename?: 'UpdateAllowedContactTypePayload';
  allowedContactType: AllowedContactTypeEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedCompanyPhonePayload  {
  __typename?: 'UpdateAllowedCompanyPhonePayload';
  allowedCompanyPhone: AllowedCompanyPhoneEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedCompanyEmailPayload  {
  __typename?: 'UpdateAllowedCompanyEmailPayload';
  allowedCompanyEmail: AllowedCompanyEmailEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAllowedAccountTypePayload  {
  __typename?: 'UpdateAllowedAccountTypePayload';
  allowedAccountType: AllowedAccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface UpdateActivityRelationPayload  {
  __typename?: 'UpdateActivityRelationPayload';
  activityRelation: ActivityRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateActivityProfilePayload  {
  __typename?: 'UpdateActivityProfilePayload';
  clientMutationId: string | null;
  profile: ActivityPreviewScreenProfile | null;
}

export interface UpdateActivityKPIPayload  {
  __typename?: 'UpdateActivityKPIPayload';
  activityKpi: ActivityKPIEntity | null;
  clientMutationId: string | null;
}

export interface UpdateActivityGeoLocationPayload  {
  __typename?: 'UpdateActivityGeoLocationPayload';
  clientMutationId: string | null;
  entity: ActivityEntity;
}

export interface UpdateActivityDraftProfilePayload  {
  __typename?: 'UpdateActivityDraftProfilePayload';
  clientMutationId: string | null;
  profile: ActivityPreviewScreenProfile | null;
}

export interface UpdateActivityCommentPayload  {
  __typename?: 'UpdateActivityCommentPayload';
  activityComment: ActivityCommentEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountTypePayload  {
  __typename?: 'UpdateAccountTypePayload';
  accountType: AccountTypeEntity;
  clientMutationId: string | null;
}

export interface UpdateAccountSocialRelationPayload  {
  __typename?: 'UpdateAccountSocialRelationPayload';
  accountSocialRelation: AccountSocialRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountSharingSalesUnitRelationPayload  {
  __typename?: 'UpdateAccountSharingSalesUnitRelationPayload';
  accountSharingSalesUnitRelation: AccountSharingSalesUnitRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountSharingClientRelationPayload  {
  __typename?: 'UpdateAccountSharingClientRelationPayload';
  accountSharingClientRelation: AccountSharingClientRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountRolePayload  {
  __typename?: 'UpdateAccountRolePayload';
  accountRole: AccountRoleEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountRelationTypePayload  {
  __typename?: 'UpdateAccountRelationTypePayload';
  accountRelationType: AccountRelationTypeEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountRelationPayload  {
  __typename?: 'UpdateAccountRelationPayload';
  accountRelation: AccountRelationEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountRelationLabelPayload  {
  __typename?: 'UpdateAccountRelationLabelPayload';
  accountRelationLabel: AccountRelationLabelEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountProfilePayload  {
  __typename?: 'UpdateAccountProfilePayload';
  clientMutationId: string | null;
  profile: AccountPreviewScreenProfile | null;
}

export interface UpdateAccountProductPricingPayload  {
  __typename?: 'UpdateAccountProductPricingPayload';
  accountProductPricing: AccountProductPricingEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountPayload  {
  __typename?: 'UpdateAccountPayload';
  account: AccountEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountKPIPayload  {
  __typename?: 'UpdateAccountKPIPayload';
  accountKpi: AccountKPIEntity | null;
  clientMutationId: string | null;
}

export interface UpdateAccountDraftProfilePayload  {
  __typename?: 'UpdateAccountDraftProfilePayload';
  clientMutationId: string | null;
  profile: AccountPreviewScreenProfile | null;
}

export interface UpdateAccountArchiveProfilePayload  {
  __typename?: 'UpdateAccountArchiveProfilePayload';
  clientMutationId: string | null;
  profile: AccountArchiveScreenProfile | null;
}

export interface UpdateAccountArchiveDraftProfilePayload  {
  __typename?: 'UpdateAccountArchiveDraftProfilePayload';
  clientMutationId: string | null;
  profile: AccountArchiveScreenProfile | null;
}

export interface UnsubscribedPhoneRepository  {
  __typename?: 'UnsubscribedPhoneRepository';
  getAll: UnsubscribedPhoneEntity[];
  getByCriteria: UnsubscribedPhoneEntityConnection | null;
  getById: UnsubscribedPhoneEntity | null;
  getByIds: UnsubscribedPhoneEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface UnsubscribedPhoneEntityEdge  {
  __typename?: 'UnsubscribedPhoneEntityEdge';
  cursor: string;
  node: UnsubscribedPhoneEntity | null;
}

export interface UnsubscribedPhoneEntityConnection  {
  __typename?: 'UnsubscribedPhoneEntityConnection';
  edges: UnsubscribedPhoneEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface UnsubscribedPhoneEntity  {
  __typename?: 'UnsubscribedPhoneEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  phone: string | null;
  revision: number | null;
}

export interface UnlinkCustomEntityRelationDataPayload  {
  __typename?: 'UnlinkCustomEntityRelationDataPayload';
  clientMutationId: string | null;
}

export interface UnenrollEmailSequencePayload  {
  __typename?: 'UnenrollEmailSequencePayload';
  clientMutationId: string | null;
  result: number;
}

export interface UndoDraftsMutation  {
  __typename?: 'UndoDraftsMutation';
  undoneDataCount: number | null;
  undoneEntitySettingsCount: number | null;
  undoneFieldCount: number | null;
  undoneFieldPermissionCount: number | null;
  undoneInterfacePreviewCount: number | null;
  undoneResourceCount: number | null;
  undoneTranslationsCount: number | null;
  undoneTypesCount: number | null;
}

export interface UndoDraftProfilePayload  {
  __typename?: 'UndoDraftProfilePayload';
  clientMutationId: string | null;
}

export interface UISettings  {
  __typename?: 'UISettings';
  accountArchiveQuickFilterOpen: boolean | null;
  accountArchiveRecentProfiles: UUID[] | null;
  accountDetailCollapsed: boolean | null;
  accountDetailTabs: InterfaceDetailUserTab[] | null;
  accountDetailWidgets: InterfaceDetailUserWidget[] | null;
  accountEntityTypePriorities: ID[] | null;
  accountPreviewCollapsed: boolean | null;
  accountPreviewHealthProfileId: UUID | null;
  accountProductPricingGridColumns: GridColumnsOutput[] | null;
  accountProductPricingSortBy: ID | null;
  accountProductPricingSortOrder: SortOrder | null;
  accountQuickFilterOpen: boolean | null;
  accountRecentApprovalProcesses: UUID[] | null;
  accountRecentEmailSequences: ID[] | null;
  accountRecentProcesses: UUID[] | null;
  accountRecentProfiles: UUID[] | null;
  accountRecentTags: UUID[] | null;
  accountStaticProfiles: UUID[] | null;
  accountsActivitiesFilter: ActivityTabDataGridViewOptions | null;
  accountsArchiveGridChanges: GridHighlightChanges;
  accountsArchiveGridColumns: GridColumnsOutput[] | null;
  accountsArchiveUseProfileColumns: boolean | null;
  accountsArchiveView: UIView | null;
  accountsChildAccountsFilter: AccountTabDataGridViewOptions | null;
  accountsContactsFilter: ContactTabDataGridViewOptions | null;
  accountsDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  accountsGridChanges: GridHighlightChanges;
  accountsGridColumns: GridColumnsOutput[] | null;
  accountsHierarchyFilter: AccountHierarchyTabDataGridViewOptions | null;
  accountsLeadsFilter: RelatedLeadTabDataGridViewOptions | null;
  accountsNotesFilter: NoteTabDataGridViewOptions | null;
  accountsOpportunitiesFilter: RelatedOpportunityTabDataGridViewOptions | null;
  accountsProductpricingFilter: AccountProductPricingTabDataGridViewOptions | null;
  accountsProductsFilter: ProductTabDataGridViewOptions | null;
  accountsProductsTrendViewSelectedCategories: UUID[] | null;
  accountsProductsTrendViewSelectedProducts: UUID[] | null;
  accountsProductsTrendViewSeriesTypeCategories: ProductSerieTypeEnum | null;
  accountsProductsTrendViewSeriesTypeProducts: ProductSerieTypeEnum | null;
  accountsProductsTrendViewSortOrder: SortOrder | null;
  accountsProductsWhiteSpaceComparisonIds: UUID[];
  accountsProductsWhiteSpaceComparisonProductIds: UUID[];
  accountsProductsWhiteSpaceSimilarSettings: SimilarAccountsOutputParams;
  accountsProductsWhiteSpaceViewSettings: WhiteSpaceViewSettings;
  accountsProjectsFilter: ProjectTabDataGridViewOptions | null;
  accountsQuotesFilter: RelatedQuoteTabDataGridViewOptions | null;
  accountsUseProfileColumns: boolean | null;
  accountsView: UIView | null;
  activeFeedEmailScreenTypes: DetailFeedActiveScreenType[] | null;
  activitiesCalendarPeriod: CalendarPeriod | null;
  activitiesGridChanges: GridHighlightChanges;
  activitiesGridColumns: GridColumnsOutput[] | null;
  activitiesUseProfileColumns: boolean | null;
  activitiesView: UIView | null;
  activityDetailFilter: ActivityDetailFilterOptions | null;
  activityPreviewCollapsed: boolean | null;
  activityQuickFilterOpen: boolean | null;
  activityRecentProfiles: UUID[] | null;
  addinShowArchivedRecordsAccount: boolean | null;
  addinShowArchivedRecordsContact: boolean | null;
  addinShowArchivedRecordsLead: boolean | null;
  addinShowArchivedRecordsOpportunity: boolean | null;
  adminProductsAndServicesGridColumns: GridColumnsOutput[] | null;
  adminProductsAndServicesSortBy: ID | null;
  adminProductsAndServicesSortOrder: SortOrder | null;
  aiAssistantFavoritePrompts: AiAssistantFavoritePrompts[] | null;
  aiAssistantPrompts: AiAssistantPrompt[] | null;
  aiOutputLanguage: AiOutputLanguage | null;
  aiUpdateOnlineFormRecentPrompts: string[] | null;
  appointmentEntityTypePriorities: ID[] | null;
  appointmentPreviewCollapsed: boolean | null;
  appointmentRecentProcesses: UUID[] | null;
  approvalProcessesGridColumns: GridColumnsOutput[] | null;
  approvalsFilter: ApprovalsListingOptions;
  approvalsGridColumns: GridColumnsOutput[] | null;
  approvalsSortBy: ID | null;
  approvalsSortOrder: SortOrder | null;
  archiveGridChanges: GridHighlightChanges;
  archiveGridColumns: GridColumnsOutput[] | null;
  archiveShowLeads: boolean | null;
  archiveUseProfileColumns: boolean | null;
  archiveView: UIView | null;
  attachRecordDocumentsGridColumns: GridColumnsOutput[] | null;
  attachRecordDocumentsSortBy: ID | null;
  attachRecordDocumentsSortOrder: SortOrder | null;
  betterNavigatorQuickFilterOpen: boolean | null;
  betterNavigatorRecentProfiles: UUID[] | null;
  bottomBarOpen: boolean | null;
  calendarColorsRules: CalendarColorRule[] | null;
  calendarColorsUsers: CalendarColorUser[] | null;
  companyDocumentsGridColumns: GridColumnsOutput[] | null;
  companyDocumentsSortBy: ID | null;
  companyDocumentsSortOrder: SortOrder | null;
  contactArchiveQuickFilterOpen: boolean | null;
  contactArchiveRecentProfiles: UUID[] | null;
  contactDetailCollapsed: boolean | null;
  contactDetailTabs: InterfaceDetailUserTab[] | null;
  contactDetailWidgets: InterfaceDetailUserWidget[] | null;
  contactEntityTypePriorities: ID[] | null;
  contactPreviewCollapsed: boolean | null;
  contactQuickFilterOpen: boolean | null;
  contactRecentApprovalProcesses: UUID[] | null;
  contactRecentEmailSequences: ID[] | null;
  contactRecentProcesses: UUID[] | null;
  contactRecentProfiles: UUID[] | null;
  contactRecentTags: UUID[] | null;
  contactStaticProfiles: UUID[] | null;
  contactsActivitiesFilter: ActivityTabDataGridViewOptions | null;
  contactsArchiveGridChanges: GridHighlightChanges;
  contactsArchiveGridColumns: GridColumnsOutput[] | null;
  contactsArchiveUseProfileColumns: boolean | null;
  contactsArchiveView: UIView | null;
  contactsDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  contactsGridChanges: GridHighlightChanges;
  contactsGridColumns: GridColumnsOutput[] | null;
  contactsLeadsFilter: LeadTabDataGridViewOptions | null;
  contactsNotesFilter: NoteTabDataGridViewOptions | null;
  contactsOpportunitiesFilter: OpportunityTabDataGridViewOptions | null;
  contactsProjectsFilter: ProjectTabDataGridViewOptions | null;
  contactsQuotesFilter: QuoteTabDataGridViewOptions | null;
  contactsUseProfileColumns: boolean | null;
  contactsView: UIView | null;
  conversionsQuickFilterOpen: boolean | null;
  conversionsRecentProfiles: UUID[] | null;
  copyReportSchedule: boolean | null;
  copyReportSharing: boolean | null;
  currencyDisplayOption: CurrencyDisplayOptionEnum | null;
  currencyFormatting: CurrencyFormattingEnum | null;
  customEntity: CustomEntityValue[];
  defaultCurrencyId: UUID | null;
  detailActivitiesGridChanges: GridHighlightChanges;
  detailActivitiesGridColumns: GridColumnsOutput[] | null;
  detailActivitiesSortBy: ID | null;
  detailActivitiesSortOrder: SortOrder | null;
  detailActivitiesView: UIView | null;
  detailChildAccountsGridChanges: GridHighlightChanges;
  detailChildAccountsGridColumns: GridColumnsOutput[] | null;
  detailChildAccountsSortBy: ID | null;
  detailChildAccountsSortOrder: SortOrder | null;
  detailContactsGridChanges: GridHighlightChanges;
  detailContactsGridColumns: GridColumnsOutput[] | null;
  detailContactsSortBy: ID | null;
  detailContactsSortOrder: SortOrder | null;
  detailDocumentsGridColumns: GridColumnsOutput[] | null;
  detailDocumentsSortBy: ID | null;
  detailDocumentsSortOrder: SortOrder | null;
  detailDocumentsView: UIView | null;
  detailFeedActiveProfiles: DetailFeedActiveProfile[] | null;
  detailFeedEmailActiveProfiles: DetailFeedActiveProfile[] | null;
  detailFeedsEmailView: FeedViewTypeEnum | null;
  detailFeedsView: FeedViewTypeEnum | null;
  detailLeadsGridChanges: GridHighlightChanges;
  detailLeadsGridColumns: GridColumnsOutput[] | null;
  detailLeadsSortBy: ID | null;
  detailLeadsSortOrder: SortOrder | null;
  detailNotesGridColumns: GridColumnsOutput[] | null;
  detailNotesSortBy: ID | null;
  detailNotesSortOrder: SortOrder | null;
  detailOpportunitiesGridChanges: GridHighlightChanges;
  detailOpportunitiesGridColumns: GridColumnsOutput[] | null;
  detailOpportunitiesSortBy: ID | null;
  detailOpportunitiesSortOrder: SortOrder | null;
  detailProductCategoriesTreeColumns: GridColumnsOutput[] | null;
  detailProductsGridColumns: GridColumnsOutput[] | null;
  detailProductsSortBy: ID | null;
  detailProductsSortOrder: SortOrder | null;
  detailProductsTab: ProductTabEnum | null;
  detailProductsView: UIView | null;
  detailProjectActivitiesView: UIView | null;
  detailProjectsGridChanges: GridHighlightChanges;
  detailProjectsGridColumns: GridColumnsOutput[] | null;
  detailProjectsSortBy: ID | null;
  detailProjectsSortOrder: SortOrder | null;
  detailProjectsView: UIView | null;
  detailQuotesGridChanges: GridHighlightChanges;
  detailQuotesGridColumns: GridColumnsOutput[] | null;
  detailQuotesSortBy: ID | null;
  detailQuotesSortOrder: SortOrder | null;
  detailSideBarDisplayLabels: boolean | null;
  detailSideBarLeft: boolean | null;
  documentManagementHideEmptyFolders: boolean | null;
  drilldownAccountsFilter: AccountDrilldownFilter | null;
  drilldownAccountsGridChanges: GridHighlightChanges;
  drilldownAccountsGridColumns: GridColumnsOutput[] | null;
  drilldownAccountsSortBy: ID | null;
  drilldownAccountsSortOrder: SortOrder | null;
  drilldownActivitiesFilter: ActivityDrilldownFilter | null;
  drilldownActivitiesGridChanges: GridHighlightChanges;
  drilldownActivitiesGridColumns: GridColumnsOutput[] | null;
  drilldownActivitiesSortBy: ID | null;
  drilldownActivitiesSortOrder: SortOrder | null;
  drilldownContactFilter: ContactDrilldownFilter | null;
  drilldownContactsGridChanges: GridHighlightChanges;
  drilldownContactsGridColumns: GridColumnsOutput[] | null;
  drilldownContactsSortBy: ID | null;
  drilldownContactsSortOrder: SortOrder | null;
  drilldownDocumentsFilter: CloudObjectDrilldownFilter | null;
  drilldownDocumentsGridColumns: GridColumnsOutput[] | null;
  drilldownDocumentsSortBy: ID | null;
  drilldownDocumentsSortOrder: SortOrder | null;
  drilldownEmailFilter: EmailDrilldownFilter | null;
  drilldownEmailsGridColumns: GridColumnsOutput[] | null;
  drilldownEmailsSortBy: ID | null;
  drilldownEmailsSortOrder: SortOrder | null;
  drilldownLeadsFilter: LeadDrilldownFilter | null;
  drilldownLeadsGridChanges: GridHighlightChanges;
  drilldownLeadsGridColumns: GridColumnsOutput[] | null;
  drilldownLeadsOpportunitiesFilter: LeadOpptyDrilldownFilter | null;
  drilldownLeadsOpportunitiesGridChanges: GridHighlightChanges;
  drilldownLeadsOpportunitiesGridColumns: GridColumnsOutput[] | null;
  drilldownLeadsOpportunitiesSortBy: ID | null;
  drilldownLeadsOpportunitiesSortOrder: SortOrder | null;
  drilldownLeadsSortBy: ID | null;
  drilldownLeadsSortOrder: SortOrder | null;
  drilldownMessagesGridChanges: GridHighlightChanges;
  drilldownMessagesGridColumns: GridColumnsOutput[] | null;
  drilldownMessagesSortBy: ID | null;
  drilldownMessagesSortOrder: SortOrder | null;
  drilldownNotesGridChanges: GridHighlightChanges;
  drilldownNotesGridColumns: GridColumnsOutput[] | null;
  drilldownNotesSortBy: ID | null;
  drilldownNotesSortOrder: SortOrder | null;
  drilldownOpportunitiesFilter: OpportunityDrilldownFilter | null;
  drilldownOpportunitiesGridChanges: GridHighlightChanges;
  drilldownOpportunitiesGridColumns: GridColumnsOutput[] | null;
  drilldownOpportunitiesSortBy: ID | null;
  drilldownOpportunitiesSortOrder: SortOrder | null;
  drilldownProductsGridChanges: GridHighlightChanges;
  drilldownProductsGridColumns: GridColumnsOutput[] | null;
  drilldownProductsSortBy: ID | null;
  drilldownProductsSortOrder: SortOrder | null;
  drilldownProjectsFilter: ProjectDrilldownFilter | null;
  drilldownProjectsGridChanges: GridHighlightChanges;
  drilldownProjectsGridColumns: GridColumnsOutput[] | null;
  drilldownProjectsSortBy: ID | null;
  drilldownProjectsSortOrder: SortOrder | null;
  drilldownQuotesFilter: QuoteDrilldownFilter | null;
  drilldownQuotesGridChanges: GridHighlightChanges;
  drilldownQuotesGridColumns: GridColumnsOutput[] | null;
  drilldownQuotesSortBy: ID | null;
  drilldownQuotesSortOrder: SortOrder | null;
  drilldownTextMessagesFilter: TextMessageDrilldownFilter | null;
  drilldownTextMessagesGridColumns: GridColumnsOutput[] | null;
  drilldownTextMessagesSortBy: ID | null;
  drilldownTextMessagesSortOrder: SortOrder | null;
  duplicateCheckerManualMergeFields: DuplicateCheckerManualMergeFields[] | null;
  duplicateCheckerMatchSettings: DuplicateCheckerMatchSettings[] | null;
  emailConversationSortOrder: SortOrder | null;
  emailSequencesGridColumns: GridColumnsOutput[] | null;
  emailSequencesSortBy: ID | null;
  emailSequencesSortOrder: SortOrder | null;
  emailTemplatesHideEmptyFolders: boolean | null;
  emailTemplatesStatisticsFilter: EmailTemplatesStatisticsFilter | null;
  emailTemplatesStatisticsSortBy: EmailTemplateStatisticsGridColumnEnum | null;
  emailTemplatesStatisticsSortOrder: SortOrder | null;
  entityHealthCategoryDayOffset: number | null;
  entityHealthHistoryDayOffset: number | null;
  featurePromotions: FeaturePromotionEnum[];
  feedScreenType: ScreenTypeEnum | null;
  feedStreamType: FeedStreamTypeEnum | null;
  feedsDetailFilter: FeedTabDataGridViewOptions | null;
  feedsEmailDetailFilter: FeedEmailTabDataGridViewOptions | null;
  feedsEmailRecentProfiles: UUID[] | null;
  feedsEmailView: FeedViewTypeEnum | null;
  feedsRecentProfiles: UUID[] | null;
  feedsView: FeedViewTypeEnum | null;
  forecastQuickFilterOpen: boolean | null;
  forecastsCreated: boolean | null;
  forecastsDetailView: UIView | null;
  forecastsFilter: ForecastListingOptions | null;
  forecastsGridChanges: GridHighlightChanges;
  forecastsGridColumns: GridColumnsOutput[] | null;
  forecastsSortBy: ID | null;
  forecastsSortOrder: SortOrder | null;
  formViews: FormViewOptions[] | null;
  globalSearchFilter: GlobalSearchFilter;
  globalSearchRecords: GlobalSearchSearchType[] | null;
  globalSearchSorting: GlobalSearchSorting | null;
  importSettingsAccounts: ImportSettingsOptions | null;
  importSettingsClients: ImportSettingsOptions | null;
  importSettingsContacts: ImportSettingsOptions | null;
  importSettingsLeads: ImportSettingsOptions | null;
  importSettingsOpportunities: ImportSettingsOptions | null;
  importSettingsPriceLists: ImportSettingsOptions | null;
  importSettingsProducts: ImportSettingsOptions | null;
  indicatorsQuickFilterOpen: boolean | null;
  indicatorsRecentProfiles: UUID[] | null;
  insightsQuickFilterOpen: boolean | null;
  insightsRecentProfiles: UUID[] | null;
  lastSelectedPriceListId: UUID | null;
  leadArchiveQuickFilterOpen: boolean | null;
  leadArchiveRecentProfiles: UUID[] | null;
  leadDetailCollapsed: boolean | null;
  leadDetailTabs: InterfaceDetailUserTab[] | null;
  leadDetailWidgets: InterfaceDetailUserWidget[] | null;
  leadEntityTypePriorities: EntityTypeProcessPriorities[] | null;
  leadPreviewCollapsed: boolean | null;
  leadProcessPriorities: ID[] | null;
  leadQuickFilterOpen: boolean | null;
  leadRecentApprovalProcesses: UUID[] | null;
  leadRecentEmailSequences: ID[] | null;
  leadRecentProcesses: UUID[] | null;
  leadRecentProfiles: UUID[] | null;
  leadRecentTags: UUID[] | null;
  leadStaticProfiles: UUID[] | null;
  leadsActivitiesFilter: ActivityTabDataGridViewOptions | null;
  leadsArchiveGridChanges: GridHighlightChanges;
  leadsArchiveGridColumns: GridColumnsOutput[] | null;
  leadsArchiveUseProfileColumns: boolean | null;
  leadsArchiveView: UIView | null;
  leadsDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  leadsGridChanges: GridHighlightChanges;
  leadsGridColumns: GridColumnsOutput[] | null;
  leadsNotesFilter: NoteTabDataGridViewOptions | null;
  leadsStepOpen: boolean | null;
  leadsUseProfileColumns: boolean | null;
  leadsView: UIView | null;
  lifecycleRecentProfiles: UUID[] | null;
  lookupAccountsGridColumns: GridColumnsOutput[] | null;
  lookupAccountsSortBy: ID | null;
  lookupAccountsSortOrder: SortOrder | null;
  lookupActivitiesGridColumns: GridColumnsOutput[] | null;
  lookupActivitiesSortBy: ID | null;
  lookupActivitiesSortOrder: SortOrder | null;
  lookupClientsGridColumns: GridColumnsOutput[] | null;
  lookupClientsSortBy: ID | null;
  lookupClientsSortOrder: SortOrder | null;
  lookupContactsGridColumns: GridColumnsOutput[] | null;
  lookupContactsSortBy: ID | null;
  lookupContactsSortOrder: SortOrder | null;
  lookupDocumentsGridColumns: GridColumnsOutput[] | null;
  lookupDocumentsSortBy: ID | null;
  lookupDocumentsSortOrder: SortOrder | null;
  lookupLeadsGridColumns: GridColumnsOutput[] | null;
  lookupLeadsOpportunitiesGridColumns: GridColumnsOutput[] | null;
  lookupLeadsOpportunitiesSortBy: ID | null;
  lookupLeadsOpportunitiesSortOrder: SortOrder | null;
  lookupLeadsSortBy: ID | null;
  lookupLeadsSortOrder: SortOrder | null;
  lookupNotesGridColumns: GridColumnsOutput[] | null;
  lookupNotesSortBy: ID | null;
  lookupNotesSortOrder: SortOrder | null;
  lookupOpportunitiesGridColumns: GridColumnsOutput[] | null;
  lookupOpportunitiesSortBy: ID | null;
  lookupOpportunitiesSortOrder: SortOrder | null;
  lookupProductsAndServicesGridColumns: GridColumnsOutput[] | null;
  lookupProductsAndServicesSortBy: ID | null;
  lookupProductsAndServicesSortOrder: SortOrder | null;
  lookupProductsAndServicesWithPriceGridColumns: GridColumnsOutput[] | null;
  lookupProductsAndServicesWithPriceSortBy: ID | null;
  lookupProductsAndServicesWithPriceSortOrder: SortOrder | null;
  lookupProjectsGridColumns: GridColumnsOutput[] | null;
  lookupProjectsSortBy: ID | null;
  lookupProjectsSortOrder: SortOrder | null;
  lookupQuotesGridColumns: GridColumnsOutput[] | null;
  lookupQuotesSortBy: ID | null;
  lookupQuotesSortOrder: SortOrder | null;
  massEmailDetailGridColumns: GridColumnsOutput[] | null;
  massEmailDetailGridSortBy: MassEmailDetailGridSortyBy | null;
  massEmailDetailGridSortOrder: SortOrder | null;
  navigatorQuickFilterOpen: boolean | null;
  navigatorRecentProfiles: UUID[] | null;
  navigatorTrendChartSeries: TargetValueType[];
  notificationSettings: NotificationSettings | null;
  onlineFormTypeDetailRespondedGridColumns: GridColumnsOutput[] | null;
  onlineFormTypeDetailRespondedGridSortBy: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailRespondedGridSortOrder: SortOrder | null;
  onlineFormTypeDetailRespondedUnknownGridColumns: GridColumnsOutput[] | null;
  onlineFormTypeDetailRespondedUnknownGridSortBy: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailRespondedUnknownGridSortOrder: SortOrder | null;
  onlineFormTypeDetailResponseGridColumns: GridColumnsOutput[] | null;
  onlineFormTypeDetailResponseGridSortBy: OnlineFormTypeDetailResponseGridSortBy | null;
  onlineFormTypeDetailResponseGridSortOrder: SortOrder | null;
  onlineFormTypeDetailSentGridColumns: GridColumnsOutput[] | null;
  onlineFormTypeDetailSentGridSortBy: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailSentGridSortOrder: SortOrder | null;
  onlineFormTypeDetailSentNotRespondedGridColumns: GridColumnsOutput[] | null;
  onlineFormTypeDetailSentNotRespondedGridSortBy: OnlineFormTypeDetailGridSortBy | null;
  onlineFormTypeDetailSentNotRespondedGridSortOrder: SortOrder | null;
  onlineFormTypesGridColumns: GridColumnsOutput[] | null;
  onlineFormTypesSortBy: ID | null;
  onlineFormTypesSortOrder: SortOrder | null;
  opportunitiesActivitiesFilter: ActivityTabDataGridViewOptions | null;
  opportunitiesBubbleChartPeriod: string | null;
  opportunitiesDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  opportunitiesGridChanges: GridHighlightChanges;
  opportunitiesGridColumns: GridColumnsOutput[] | null;
  opportunitiesNotesFilter: NoteTabDataGridViewOptions | null;
  opportunitiesQuotesFilter: QuoteTabDataGridViewOptions | null;
  opportunitiesShowLeads: boolean | null;
  opportunitiesUseProfileColumns: boolean | null;
  opportunitiesView: UIView | null;
  opportunityArchiveQuickFilterOpen: boolean | null;
  opportunityArchiveRecentProfiles: UUID[] | null;
  opportunityDetailCollapsed: boolean | null;
  opportunityDetailTabs: InterfaceDetailUserTab[] | null;
  opportunityDetailWidgets: InterfaceDetailUserWidget[] | null;
  opportunityPreviewCollapsed: boolean | null;
  opportunityQuickFilterOpen: boolean | null;
  opportunityRecentApprovalProcesses: UUID[] | null;
  opportunityRecentEmailSequences: ID[] | null;
  opportunityRecentProcesses: UUID[] | null;
  opportunityRecentProfiles: UUID[] | null;
  opportunityRecentTags: UUID[] | null;
  opportunityStaticProfiles: UUID[] | null;
  performanceQuickFilterOpen: boolean | null;
  pipelinePriorities: ID[] | null;
  previewPinnedCharts: PreviewPinnedCharts[] | null;
  previewPinnedFields: PreviewPinnedFields[] | null;
  processDetailCreateBackupCopy: boolean | null;
  processTabFilter: ProcessTabDataGridViewOptions | null;
  processesGridColumns: GridColumnsOutput[] | null;
  processesSortBy: ID | null;
  processesSortOrder: SortOrder | null;
  productEntityTypePriorities: ID[] | null;
  productsServicesGridColumns: GridColumnsOutput[] | null;
  projectActivitiesFilter: ActivityTabDataGridViewOptions | null;
  projectActivitiesObjectiveGridChanges: GridHighlightChanges;
  projectActivitiesObjectiveGridColumns: GridColumnsOutput[] | null;
  projectDetailCollapsed: boolean | null;
  projectDetailTabs: InterfaceDetailUserTab[] | null;
  projectDetailWidgets: InterfaceDetailUserWidget[] | null;
  projectEntityTypePriorities: ID[] | null;
  projectGanttPeriod: ProjectGanttPeriodOptions[] | null;
  projectGridChanges: GridHighlightChanges;
  projectGridColumns: GridColumnsOutput[] | null;
  projectObjectiveOpen: ID[] | null;
  projectPreviewCollapsed: boolean | null;
  projectQuickFilterOpen: boolean | null;
  projectRecentEmailSequences: ID[] | null;
  projectRecentProcesses: UUID[] | null;
  projectRecentProfiles: UUID[] | null;
  projectRecentTags: UUID[] | null;
  projectStaticProfiles: UUID[] | null;
  projectUseProfileColumns: boolean | null;
  projectsDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  projectsNotesFilter: NoteTabDataGridViewOptions | null;
  projectsOpportunitiesFilter: OpportunityTabDataGridViewOptions | null;
  qualifiedStepOpen: boolean | null;
  quoteArchiveQuickFilterOpen: boolean | null;
  quoteArchiveRecentProfiles: UUID[] | null;
  quoteDetailCollapsed: boolean | null;
  quoteDetailTabs: InterfaceDetailUserTab[] | null;
  quoteDetailWidgets: InterfaceDetailUserWidget[] | null;
  quoteEntityTypePriorities: EntityTypeProcessPriorities[] | null;
  quotePreviewCollapsed: boolean | null;
  quoteProcessPriorities: ID[] | null;
  quoteQuickFilterOpen: boolean | null;
  quoteRecentApprovalProcesses: UUID[] | null;
  quoteRecentProcesses: UUID[] | null;
  quoteRecentProfiles: UUID[] | null;
  quoteStaticProfiles: UUID[] | null;
  quotesActivitiesFilter: ActivityTabDataGridViewOptions | null;
  quotesArchiveGridChanges: GridHighlightChanges;
  quotesArchiveGridColumns: GridColumnsOutput[] | null;
  quotesArchiveUseProfileColumns: boolean | null;
  quotesArchiveView: UIView | null;
  quotesDocumentsFilter: CloudObjectTabDataGridViewOptions | null;
  quotesGridChanges: GridHighlightChanges;
  quotesGridColumns: GridColumnsOutput[] | null;
  quotesNotesFilter: NoteTabDataGridViewOptions | null;
  quotesUseProfileColumns: boolean | null;
  quotesView: UIView | null;
  recentCloudObjects: ID[] | null;
  recentlyOpened: RecentlyOpenedEntity[] | null;
  recordDocumentsGridColumns: GridColumnsOutput[] | null;
  recordDocumentsSortBy: ID | null;
  recordDocumentsSortOrder: SortOrder | null;
  relationFieldTabSettings: RelationFieldTabSettings;
  reportPdfOptions: PdfOptions | null;
  reportQuickFilterOpen: boolean | null;
  reportsHideEmptyFolders: boolean | null;
  showCopyConfirmation: boolean | null;
  showMapLegend: boolean | null;
  showOnlyFavoriteProfiles: boolean | null;
  showOrgChartInfluences: boolean | null;
  showRecordTooltips: boolean | null;
  skipOnlineFormDownloadWarning: boolean | null;
  speechToTextLanguage: string | null;
  targetsGroupTargetsFilter: TargetListingOptions | null;
  targetsGroupTargetsGridColumns: GridColumnsOutput[] | null;
  targetsGroupTargetsSortBy: ID | null;
  targetsGroupTargetsSortOrder: SortOrder | null;
  targetsGroupUserTargetsGridColumns: GridColumnsOutput[] | null;
  targetsGroupUserTargetsSortBy: ID | null;
  targetsGroupUserTargetsSortOrder: SortOrder | null;
  targetsSimulatedTargetsFilter: SimulatedTargetListingOptions | null;
  targetsSimulatedTargetsGridColumns: GridColumnsOutput[] | null;
  targetsSimulatedTargetsSortBy: ID | null;
  targetsSimulatedTargetsSortOrder: SortOrder | null;
  targetsUserTargetsFilter: UserTargetListingOptions | null;
  targetsUserTargetsGridColumns: GridColumnsOutput[] | null;
  targetsUserTargetsSortBy: ID | null;
  targetsUserTargetsSortOrder: SortOrder | null;
  taskEntityTypePriorities: ID[] | null;
  taskPreviewCollapsed: boolean | null;
  taskRecentProcesses: UUID[] | null;
  templatesGridColumns: GridColumnsOutput[] | null;
  templatesSortBy: ID | null;
  templatesSortOrder: SortOrder | null;
  useBetterNavigator: boolean | null;
}

export interface TypeRepository  {
  __typename?: 'TypeRepository';
  getAll: TypeEntity[];
  getByCriteria: TypeEntityConnection | null;
  getById: TypeEntity | null;
  getByIds: TypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TypeEntityEdge  {
  __typename?: 'TypeEntityEdge';
  cursor: string;
  node: TypeEntity | null;
}

export interface TypeEntityConnection  {
  __typename?: 'TypeEntityConnection';
  edges: TypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TypeEntity  {
  __typename?: 'TypeEntity';
  containerSize: number;
  defaultValue: string | null;
  flag: number;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isFilterable: boolean;
  isGroupable: boolean;
  isSelectable: boolean;
  isSortable: boolean;
  primitiveType: PrimitiveType;
  relationType: RelationType;
  validator: JSONString | null;
}

export interface TranslationRepository  {
  __typename?: 'TranslationRepository';
  getAll: TranslationEntity[];
  getByCriteria: TranslationEntityConnection | null;
  getById: TranslationEntity | null;
  getByIds: TranslationEntity[];
  getDraftById: TranslationEntity;
  getDrafts: TranslationEntity[];
  getPublished: TranslationEntity[];
}

export interface TranslationEntityEdge  {
  __typename?: 'TranslationEntityEdge';
  cursor: string;
  node: TranslationEntity | null;
}

export interface TranslationEntityConnection  {
  __typename?: 'TranslationEntityConnection';
  edges: TranslationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TranslationEntity  {
  __typename?: 'TranslationEntity';
  accountType: AccountTypeEntity | null;
  accountTypeId: ID | null;
  appointmentType: AppointmentTypeEntity | null;
  appointmentTypeId: ID | null;
  contactType: ContactTypeEntity | null;
  contactTypeId: ID | null;
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID | null;
  deDe: string | null;
  enUs: string | null;
  esEs: string | null;
  field: FieldEntity | null;
  fieldId: ID | null;
  formType: FormTypeEnum | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  labelType: TranslationLabelTypeEnum;
  leadType: LeadTypeEntity | null;
  leadTypeId: ID | null;
  modified: DateTime | null;
  opptyProductRelationType: OpptyProductRelationTypeEntity | null;
  opptyProductRelationTypeId: ID | null;
  opptyType: OpportunityTypeEntity | null;
  opptyTypeId: ID | null;
  productType: ProductTypeEntity | null;
  productTypeId: ID | null;
  projectType: ProjectTypeEntity | null;
  projectTypeId: ID | null;
  ptBr: string | null;
  revision: number | null;
  taskType: TaskTypeEntity | null;
  taskTypeId: ID | null;
}

export interface Translation  {
  __typename?: 'Translation';
  entity: EntityNameEnum;
  fieldId: UUID | null;
  hasDraft: boolean;
  idKey: string;
  name: string;
  originalName: string;
  translationDeDe: string;
  translationEnUs: string;
  translationEsEs: string;
  translationMarker: string;
  translationPtBr: string;
  type: TranslationLabelTypeEnum;
  useLang: string;
}

export interface TrackContentManagementEventPayload  {
  __typename?: 'TrackContentManagementEventPayload';
  clientMutationId: string | null;
  success: boolean | null;
}

export interface TopAccountEntity  {
  __typename?: 'TopAccountEntity';
  account: AccountEntity | null;
  wonAmount: number;
}

export interface TokenResult  {
  __typename?: 'TokenResult';
  accessToken: string | null;
  refreshToken: string | null;
}

export interface ToggleStateTeamPipelineHubItemPayload  {
  __typename?: 'ToggleStateTeamPipelineHubItemPayload';
  clientMutationId: string | null;
  result: TeamPipelineHubInterfaceImplementors | null;
}

export interface TimeframeTableReportProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, TableReportTabsInterface, TimeframeProfileInterface {
  __typename?: 'TimeframeTableReportProfile';
  filter: TimeframeFilterTab;
  quickFilter: QuickFilterTab;
  view: ViewTableReportTab;
}

export interface TimeframeRepository  {
  __typename?: 'TimeframeRepository';
  getAll: TimeframeEntity[];
  getByCriteria: TimeframeEntityConnection | null;
  getById: TimeframeEntity | null;
  getByIds: TimeframeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TimeframePivotReportProfile extends PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, TimeframeProfileInterface {
  __typename?: 'TimeframePivotReportProfile';
  filter: TimeframeFilterTab;
  quickFilter: QuickFilterTab;
  view: ViewPivotReportTab;
}

export interface TimeframeFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'TimeframeFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface TimeframeEntityEdge  {
  __typename?: 'TimeframeEntityEdge';
  cursor: string;
  node: TimeframeEntity | null;
}

export interface TimeframeEntityConnection  {
  __typename?: 'TimeframeEntityConnection';
  edges: TimeframeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TimeframeEntity  {
  __typename?: 'TimeframeEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  step: StepEntity | null;
  stepId: ID;
  timeframe: number;
}

export interface TextToSpeechService  {
  __typename?: 'TextToSpeechService';
  availableLanguages: TextToSpeechLanguage[];
  synthesizeSpeech: string;
}

export interface TextToSpeechLanguage  {
  __typename?: 'TextToSpeechLanguage';
  code: string;
  name: string;
  voices: string[];
}

export interface TextMessageRepository  {
  __typename?: 'TextMessageRepository';
  getAll: TextMessageEntity[];
  getByCriteria: TextMessageEntityConnection | null;
  getById: TextMessageEntity | null;
  getByIds: TextMessageEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TextMessageNotificationSettings  {
  __typename?: 'TextMessageNotificationSettings';
  IsActive: boolean;
  LinkedItem: boolean | null;
}

export interface TextMessageEntityEdge  {
  __typename?: 'TextMessageEntityEdge';
  cursor: string;
  node: TextMessageEntity | null;
}

export interface TextMessageEntityConnection  {
  __typename?: 'TextMessageEntityConnection';
  edges: TextMessageEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TextMessageEntity  {
  __typename?: 'TextMessageEntity';
  attachments: CloudObjectRelationEntityConnection | null;
  chatConversation: ChatConversationEntity | null;
  chatConversationId: ID | null;
  content: string;
  contentAsHtml: string;
  created: DateTime | null;
  creditInfo: AiCreditInfo | null;
  data: AiMessageData | null;
  datetimeSent: DateTime | null;
  direction: EmailDirectionEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  messageSid: string | null;
  modified: DateTime | null;
  revision: number | null;
  score: number | null;
  status: TextMessageStatusEnum | null;
  textMessageConversation: TextMessageConversationEntity | null;
  textMessageConversationId: ID | null;
  topicPrompts: string[] | null;
}

export interface TextMessageDrilldownFilter  {
  __typename?: 'TextMessageDrilldownFilter';
  ownerId: ID[] | null;
}

export interface TextMessageConversationRepository  {
  __typename?: 'TextMessageConversationRepository';
  getAll: TextMessageConversationEntity[];
  getByCriteria: TextMessageConversationEntityConnection | null;
  getById: TextMessageConversationEntity | null;
  getByIds: TextMessageConversationEntity[];
  getByPhone: TextMessageConversationEntity | null;
  getChangedFieldsSinceRevision: UUID[];
  pollMessages: TextMessageEntity[];
}

export interface TextMessageConversationRelationsRepository  {
  __typename?: 'TextMessageConversationRelationsRepository';
  getAll: TextMessageConversationRelationsEntity[];
  getByCriteria: TextMessageConversationRelationsEntityConnection | null;
  getById: TextMessageConversationRelationsEntity | null;
  getByIds: TextMessageConversationRelationsEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TextMessageConversationRelationsEntityEdge  {
  __typename?: 'TextMessageConversationRelationsEntityEdge';
  cursor: string;
  node: TextMessageConversationRelationsEntity | null;
}

export interface TextMessageConversationRelationsEntityConnection  {
  __typename?: 'TextMessageConversationRelationsEntityConnection';
  edges: TextMessageConversationRelationsEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TextMessageConversationRelationsEntity  {
  __typename?: 'TextMessageConversationRelationsEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
  textMessageConversation: TextMessageConversationEntity | null;
  textMessageConversationId: ID;
}

export interface TextMessageConversationNotificationEntity extends NotificationEntityInterface, NotificationTargetEntityInterface {
  __typename?: 'TextMessageConversationNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
  phoneNumber: string | null;
  phoneType: PhoneTypeEnum;
}

export interface TextMessageConversationEntityEdge  {
  __typename?: 'TextMessageConversationEntityEdge';
  cursor: string;
  node: TextMessageConversationEntity | null;
}

export interface TextMessageConversationEntityConnection  {
  __typename?: 'TextMessageConversationEntityConnection';
  edges: TextMessageConversationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TextMessageConversationEntity  {
  __typename?: 'TextMessageConversationEntity';
  accountRelations: TextMessageConversationRelationsEntityConnection | null;
  contactRelations: TextMessageConversationRelationsEntityConnection | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadRelations: TextMessageConversationRelationsEntityConnection | null;
  messages: TextMessageEntityConnection | null;
  modified: DateTime | null;
  opportunityRelations: TextMessageConversationRelationsEntityConnection | null;
  phone: PhoneEntity | null;
  phoneId: ID;
  projectRelations: TextMessageConversationRelationsEntityConnection | null;
  quoteRelations: TextMessageConversationRelationsEntityConnection | null;
  recipientAccount: AccountEntity | null;
  recipientAccountId: ID | null;
  recipientContact: ContactEntity | null;
  recipientContactId: ID | null;
  recipientPhoneNumber: string | null;
  revision: number | null;
}

export interface TextAreaProperty  {
  __typename?: 'TextAreaProperty';
  isRichText: boolean;
}

export interface TestProcessWebhookResponse  {
  __typename?: 'TestProcessWebhookResponse';
  errorMessage: string | null;
  isResponseCropped: boolean | null;
  requestBody: string;
  requestHeaders: ProcessWebhookHeader[];
  requestType: ProcessWebhookRequestType;
  responseBody: string | null;
  responseHeaders: ProcessWebhookHeader[] | null;
  statusCode: number | null;
  success: boolean;
  url: string;
  warnings: string[];
}

export interface TemplateResultCloudObject  {
  __typename?: 'TemplateResultCloudObject';
  accountId: ID | null;
  contactId: ID | null;
  filename: string;
  id: ID;
  leadOpptyId: ID | null;
  mimeType: string;
  params: string;
  relationId: ID | null;
  size: number;
  type: number;
  url: string;
}

export interface TemplateResult  {
  __typename?: 'TemplateResult';
  cloudObjects: TemplateResultCloudObject[];
  fieldErrors: FieldFillError[];
  resultUrl: string;
}

export interface TeamSpaceEntityEdge  {
  __typename?: 'TeamSpaceEntityEdge';
  cursor: string;
  node: TeamSpaceEntity | null;
}

export interface TeamSpaceEntityConnection  {
  __typename?: 'TeamSpaceEntityConnection';
  edges: TeamSpaceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TeamSpaceEntity  {
  __typename?: 'TeamSpaceEntity';
  active: TeamSpaceStatus | null;
  adminUrl: string | null;
  appBaseUrl: string | null;
  appVersion: string | null;
  automationHubItems: TeamSpaceAutomationHubItem[] | null;
  clients: CpClientEntityConnection | null;
  dbVersion: number | null;
  featurePromotionsDisabled: boolean | null;
  flags: number | null;
  formattedDbVersion: string | null;
  graphqlUrl: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: TeamSpacePermsEnum[];
  name: string | null;
  pictureUrl: string | null;
  publicRestUrl: string | null;
  regionName: string | null;
  regionUrl: string | null;
  releaseNotesDisabled: boolean | null;
  restUrl: string | null;
  size: number | null;
  status: TeamSpaceStatus | null;
  statusReason: TeamSpaceStatusReason | null;
  subscription: SubscriptionEntity | null;
  subscriptionId: ID | null;
  useCoevera: boolean | null;
  usedSize: number | null;
  version: number | null;
}

export interface TeamSpaceClientSettingRepository  {
  __typename?: 'TeamSpaceClientSettingRepository';
  get: TeamSpaceClientSettingEntity | null;
  getExchangeAuthOptions: ExchangeAuthOptionsOutput;
  getJiraAuthUrl: string;
  getServiceData: string;
  getTwilioAccessToken: string;
  getVerifyNumberStatus: TwilioCallerStatus;
  retrieveExchangeFolders: RetrieveFoldersOutput;
  retrieveGoogleFolders: RetrieveFoldersOutput;
  retrieveImapFolders: ImapFolder[];
  retrieveImapFoldersOnActiveImap: ImapFolder[];
  retrieveO365Folders: RetrieveFoldersOutput;
}

export interface TeamSpaceClientSettingEntity  {
  __typename?: 'TeamSpaceClientSettingEntity';
  calling: CallingIntegrationOutput;
  created: DateTime | null;
  dropbox: DropboxSettingsOutput | null;
  emailAliases: string | null;
  emailAutomatizerEnabled: boolean | null;
  emailAutomatizerOwnerAccountEnabled: boolean | null;
  emailAutomatizerUserAccountEnabled: boolean | null;
  emailConf: EmailConfField | null;
  emailDefaultContentSharingMode: ContentShareModeEnum | null;
  emailEmailSequenceEnabled: boolean | null;
  emailEmailSequenceOwnerAccountEnabled: boolean | null;
  emailEmailSequenceUserAccountEnabled: boolean | null;
  emailFetchSettings: number | null;
  emailImapErrorCount: number | null;
  emailImapFolder1: string | null;
  emailImapFolder2: string | null;
  emailImapLastMessageId1: string | null;
  emailImapLastMessageId2: string | null;
  emailIntegration: EmailIntegrationEnum | null;
  emailMassEmailClientIds: ID[] | null;
  emailMassEmailEnabled: boolean | null;
  emailNextRun: DateTime | null;
  emailNotificationsSettings: NotificationSettings | null;
  exchangeCalendar: ExchangeServiceSettingsOutput | null;
  exchangeContacts: ExchangeServiceSettingsOutput | null;
  exchangeTasks: ExchangeServiceSettingsOutput | null;
  googleCalendar: GoogleServiceSettingsOutput | null;
  googleContacts: GoogleServiceSettingsOutput | null;
  googleDrive: GoogleDriveSettingsOutput | null;
  googleEmail: GoogleServiceSettingsOutput | null;
  googleTasks: GoogleServiceSettingsOutput | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  microsoftOneDrive: MicrosoftOneDriveSettingsOutput | null;
  microsoftSharePoint: MicrosoftOneDriveSettingsOutput | null;
  modified: DateTime | null;
  msTeamsConferencing: ConferencingCommonSettingsOutput | null;
  o365Calendar: GoogleServiceSettingsOutput | null;
  o365Contacts: GoogleServiceSettingsOutput | null;
  o365Email: GoogleServiceSettingsOutput | null;
  o365Tasks: GoogleServiceSettingsOutput | null;
  pandaDocIsEnabled: boolean | null;
  sendgridEmail: GoogleServiceSettingsOutput;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: ID | null;
  whatsApp: WhatsAppSettingsOutput | null;
  zoomConferencing: ConferencingCommonSettingsOutput | null;
}

export interface TeamSpaceAutomationHubItem  {
  __typename?: 'TeamSpaceAutomationHubItem';
  id: number;
  name: string;
  status: TeamPipelineHubItemStatusEnum;
}

export interface TeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'TeamPipelineHubItemEntity';
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface TaskTypeRepository  {
  __typename?: 'TaskTypeRepository';
  getAll: TaskTypeEntity[];
  getByCriteria: TaskTypeEntityConnection | null;
  getById: TaskTypeEntity | null;
  getByIds: TaskTypeEntity[];
  getDraftById: TaskTypeEntity;
  getDrafts: TaskTypeEntity[];
  getPublished: TaskTypeEntity[];
}

export interface TaskTypeEntityEdge  {
  __typename?: 'TaskTypeEntityEdge';
  cursor: string;
  node: TaskTypeEntity | null;
}

export interface TaskTypeEntityConnection  {
  __typename?: 'TaskTypeEntityConnection';
  edges: TaskTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskTypeEntity  {
  __typename?: 'TaskTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  icon: ActivityTypeIconEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
}

export interface TaskStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'TaskStatusInterfaceFieldData';
  fieldId: UUID;
  taskStatus: TaskStatusEnum;
}

export interface TaskStatusChangeNotificationEntity extends NotificationEntityInterface {
  __typename?: 'TaskStatusChangeNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
  status: TaskStatusEnum;
}

export interface TaskSharingSalesUnitRelationRepository  {
  __typename?: 'TaskSharingSalesUnitRelationRepository';
  getAll: TaskSharingSalesUnitRelationEntity[];
  getByCriteria: TaskSharingSalesUnitRelationEntityConnection | null;
  getById: TaskSharingSalesUnitRelationEntity | null;
  getByIds: TaskSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TaskSharingSalesUnitRelationEntityEdge  {
  __typename?: 'TaskSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: TaskSharingSalesUnitRelationEntity | null;
}

export interface TaskSharingSalesUnitRelationEntityConnection  {
  __typename?: 'TaskSharingSalesUnitRelationEntityConnection';
  edges: TaskSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskSharingSalesUnitRelationEntity  {
  __typename?: 'TaskSharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  task: TaskEntity | null;
  taskId: ID;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface TaskSharingClientRelationRepository  {
  __typename?: 'TaskSharingClientRelationRepository';
  getAll: TaskSharingClientRelationEntity[];
  getByCriteria: TaskSharingClientRelationEntityConnection | null;
  getById: TaskSharingClientRelationEntity | null;
  getByIds: TaskSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TaskSharingClientRelationEntityEdge  {
  __typename?: 'TaskSharingClientRelationEntityEdge';
  cursor: string;
  node: TaskSharingClientRelationEntity | null;
}

export interface TaskSharingClientRelationEntityConnection  {
  __typename?: 'TaskSharingClientRelationEntityConnection';
  edges: TaskSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskSharingClientRelationEntity  {
  __typename?: 'TaskSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  task: TaskEntity | null;
  taskId: ID;
}

export interface TaskSearchResultItem extends SearchResultItemInterface {
  __typename?: 'TaskSearchResultItem';
  datetime: DateTime | null;
  dueDate: GqlDate | null;
  id: ID;
  isDeleted: boolean;
  linkedEntities: LinkedItemType[] | null;
  subject: string;
}

export interface TaskRepository  {
  __typename?: 'TaskRepository';
  aiAutoPrefill: TaskAutoPrefill;
  autoPrefill: TaskEntity;
  getAll: TaskEntity[];
  getByCriteria: TaskEntityConnection | null;
  getById: TaskEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: TaskEntity[];
  getBySession: TaskEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface TaskReminderRepository  {
  __typename?: 'TaskReminderRepository';
  getAll: TaskReminderEntity[];
  getByCriteria: TaskReminderEntityConnection | null;
  getById: TaskReminderEntity | null;
  getByIds: TaskReminderEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TaskReminderEntityEdge  {
  __typename?: 'TaskReminderEntityEdge';
  cursor: string;
  node: TaskReminderEntity | null;
}

export interface TaskReminderEntityConnection  {
  __typename?: 'TaskReminderEntityConnection';
  edges: TaskReminderEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskReminderEntity  {
  __typename?: 'TaskReminderEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  setDate: DateTime;
  status: ReminderStatusEnum | null;
  task: TaskEntity | null;
  taskId: ID;
}

export interface TaskRecurrenceRepository  {
  __typename?: 'TaskRecurrenceRepository';
  getAll: TaskRecurrenceEntity[];
  getByCriteria: TaskRecurrenceEntityConnection | null;
  getById: TaskRecurrenceEntity | null;
  getByIds: TaskRecurrenceEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TaskRecurrenceEntityEdge  {
  __typename?: 'TaskRecurrenceEntityEdge';
  cursor: string;
  node: TaskRecurrenceEntity | null;
}

export interface TaskRecurrenceEntityConnection  {
  __typename?: 'TaskRecurrenceEntityConnection';
  edges: TaskRecurrenceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskRecurrenceEntity  {
  __typename?: 'TaskRecurrenceEntity';
  created: DateTime | null;
  day: DateDayEnum | null;
  dayOfWeek: number | null;
  endDate: GqlDate | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  month: DateMonthEnum | null;
  occurEvery: number | null;
  occurrencesCount: number | null;
  revision: number | null;
  startDate: GqlDate;
  task: TaskEntity | null;
  taskId: ID;
  type: RecurrenceTypeEnum | null;
  week: DateWeekEnum | null;
}

export interface TaskRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface {
  __typename?: 'TaskRecentlyOpenedResultItem';
  dueDate: GqlDate | null;
  id: ID;
  isDeleted: boolean;
  linkedEntities: RecentlyOpenedLinkedItemType[];
  openedAt: DateTime;
  subject: string;
}

export interface TaskPriorityInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'TaskPriorityInterfaceFieldData';
  fieldId: UUID;
  taskPriority: PriorityEnum;
}

export interface TaskEntityEdge  {
  __typename?: 'TaskEntityEdge';
  cursor: string;
  node: TaskEntity | null;
}

export interface TaskEntityData  {
  __typename?: 'TaskEntityData';
  accounts: ActivityRelationEntityConnection | null;
  contacts: ActivityRelationEntityConnection | null;
  customEntities: ActivityRelationEntityConnection | null;
  entity: TaskEntity;
  fields: InterfaceFieldDataImplementors[];
  leads: ActivityRelationEntityConnection | null;
  opportunities: ActivityRelationEntityConnection | null;
}

export interface TaskEntityConnection  {
  __typename?: 'TaskEntityConnection';
  edges: TaskEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TaskEntity  {
  __typename?: 'TaskEntity';
  accountRelations: ActivityRelationEntityConnection | null;
  activeReminder: string | null;
  activityType: TaskTypeEntity | null;
  activityTypeId: ID | null;
  call: CallEntity | null;
  callDuration: number | null;
  callId: ID | null;
  callOutcome: DataEntity | null;
  callOutcomeId: ID | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  comments: ActivityCommentEntityConnection | null;
  contactRelations: ActivityRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customEntityRelations: ActivityRelationEntityConnection | null;
  customFields: JSONString;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  dueDate: GqlDate | null;
  duration: number | null;
  exchangeEntityId: string | null;
  fields: InterfaceFieldDataImplementors[];
  formattedName: string;
  gapiEntityId: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadRelations: ActivityRelationEntityConnection | null;
  mediaTranscription: MediaEntity | null;
  mediaTranscriptionId: UUID | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  o365EntityId: string | null;
  opportunityRelations: ActivityRelationEntityConnection | null;
  owner: ClientEntity | null;
  ownerId: ID | null;
  pendingScheduledActions: number | null;
  priority: PriorityEnum | null;
  projectRelations: ActivityRelationEntityConnection | null;
  quoteRelations: ActivityRelationEntityConnection | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  reminder: TaskReminderEntity | null;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: TaskSharingClientRelationEntityConnection | null;
  sharingUnits: TaskSharingSalesUnitRelationEntityConnection | null;
  startDate: GqlDate | null;
  status: TaskStatusEnum | null;
  subject: string;
  tableName: string;
  tags: TagRelationEntityConnection | null;
  taskRecurrence: TaskRecurrenceEntity | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
}

export interface TaskCalendarViewItem extends CalendarViewItemInterface, ViewItemInterface {
  __typename?: 'TaskCalendarViewItem';
  activityTypeId: ID;
  badgeColor: number | null;
  dueDate: GqlDate | null;
  id: ID;
  name: string;
  ownerColor: number | null;
  ownerId: ID | null;
  priority: PriorityEnum;
  status: ActivityStatusEnum;
  tags: number[] | null;
}

export interface TaskBoardViewItem extends ViewItemInterface {
  __typename?: 'TaskBoardViewItem';
  createdDate: GqlDate | null;
  dueDate: GqlDate | null;
  entityTypeId: UUID;
  extraFieldValues: string[];
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  id: ID;
  linkedItemNames: string | null;
  name: string;
  ownerId: ID | null;
  priority: PriorityEnum;
  role: ShareActorEnum | null;
  salesUnitId: ID;
  tags: number[] | null;
}

export interface TaskBoardView extends BoardViewInterface {
  __typename?: 'TaskBoardView';
  profile: ActivityPreviewProfile | null;
  profileId: string | null;
  searchQuery: string | null;
  sessionIds: UUID[];
  sidebarOpen: boolean;
}

export interface TaskAutoPrefill  {
  __typename?: 'TaskAutoPrefill';
  entity: TaskEntity | null;
  fieldIds: UUID[];
}

export interface TargetsUserChartData  {
  __typename?: 'TargetsUserChartData';
  targetId: UUID;
  values: TargetsChartValue[];
}

export interface TargetsSettings  {
  __typename?: 'TargetsSettings';
  calculatedIndicators: TargetsIndicators;
  chartGranularity: TargetsChartGranularityEnum;
  customIndicators: TargetsIndicators;
  filter: FieldFilter | null;
  leadsEnabled: boolean;
  period: TargetsPeriod;
  pipelineLeadProcessId: UUID | null;
  targetValueLocked: boolean;
  workingTimeEnabled: boolean;
}

export interface TargetsPeriod  {
  __typename?: 'TargetsPeriod';
  fragmentIndex: number | null;
  fragmentType: TargetsPeriodFragmentTypeEnum;
  type: TargetsPeriodTypeEnum;
  year: number;
}

export interface TargetsIndicators  {
  __typename?: 'TargetsIndicators';
  holidaysPerYear: number | null;
  leadAverageEngagementTime: number | null;
  leadAverageEngagementsBeforeLost: number | null;
  leadAverageEngagementsBeforeQualify: number | null;
  leadAverageEngagementsBeforeQualifyLost: number | null;
  leadClosedCount: number | null;
  leadQualificationRate: number | null;
  leadSalesTimeToLose: number | null;
  leadSalesTimeToQualify: number | null;
  nonSellingHoursPerWeek: number | null;
  opportunityAverageEngagementTime: number | null;
  opportunityAverageSize: number | null;
  opportunityAverageVelocity: number | null;
  opportunityClosedCount: number | null;
  opportunitySalesTimeToLose: number | null;
  opportunitySalesTimeToWin: number | null;
  opportunityWinRate: number | null;
  opptyAverageEngagementsBeforeLost: number | null;
  opptyAverageEngagementsBeforeWon: number | null;
  opptyAverageEngagementsBeforeWonLost: number | null;
  sickDaysPerYear: number | null;
  target: number | null;
  targetUserWorkingDaysTotal: number | null;
  targetUserYearsInWork: number | null;
  vacationDaysPerYear: number | null;
  workingHoursPerWeek: number | null;
}

export interface TargetsCurrentMetrics  {
  __typename?: 'TargetsCurrentMetrics';
  leadsNew: number | null;
  leadsQualified: number | null;
  opportunitiesNew: number | null;
  opportunitiesWon: number | null;
  period: TargetsMetricPeriodEnum | null;
  periodIndex: number;
  quota: number | null;
  relativeRate: number;
  unweightedTarget: number | null;
  unweightedTargetByVelocity: number | null;
}

export interface TargetsChartValue  {
  __typename?: 'TargetsChartValue';
  date: GqlDate;
  index: number;
  value: number;
}

export interface TargetsAbsolutePeriod  {
  __typename?: 'TargetsAbsolutePeriod';
  periodFrom: GqlDate;
  periodTo: GqlDate;
}

export interface TargetView  {
  __typename?: 'TargetView';
  data: TargetProfileData;
  item: TargetItem | null;
}

export interface TargetRepository  {
  __typename?: 'TargetRepository';
  getAll: TargetEntity[];
  getByCriteria: TargetEntityConnection | null;
  getById: TargetEntity | null;
  getByIds: TargetEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TargetRelationRepository  {
  __typename?: 'TargetRelationRepository';
  getAll: TargetRelationEntity[];
  getByCriteria: TargetRelationEntityConnection | null;
  getById: TargetRelationEntity | null;
  getByIds: TargetRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TargetRelationEntityEdge  {
  __typename?: 'TargetRelationEntityEdge';
  cursor: string;
  node: TargetRelationEntity | null;
}

export interface TargetRelationEntityConnection  {
  __typename?: 'TargetRelationEntityConnection';
  edges: TargetRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TargetRelationEntity  {
  __typename?: 'TargetRelationEntity';
  created: DateTime | null;
  groupTarget: TargetEntity | null;
  groupTargetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  userTarget: TargetEntity | null;
  userTargetId: ID;
}

export interface TargetProfileData  {
  __typename?: 'TargetProfileData';
  groupViewItems: GroupTargetDataGridViewItems;
  listViewItems: TargetDataGridViewItems;
  simulatedViewItems: TargetDataGridViewItems;
}

export interface TargetMetricsDrilldownModel  {
  __typename?: 'TargetMetricsDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface TargetListingOptions  {
  __typename?: 'TargetListingOptions';
  filterByOwnerId: UUID[] | null;
  filterByPeriod: PeriodOption;
  filterByStatus: TargetStatusEnum[] | null;
  filterByTargetCalculationType: TargetCalculationTypeEnum | null;
}

export interface TargetItem  {
  __typename?: 'TargetItem';
  listViewItem: DataGridViewItem | null;
}

export interface TargetEntityEdge  {
  __typename?: 'TargetEntityEdge';
  cursor: string;
  node: TargetEntity | null;
}

export interface TargetEntityConnection  {
  __typename?: 'TargetEntityConnection';
  edges: TargetEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TargetEntity  {
  __typename?: 'TargetEntity';
  absolutePeriod: TargetsAbsolutePeriod | null;
  calculationType: TargetCalculationTypeEnum | null;
  canChangeFilterSettings: boolean;
  canChangeTargetClient: boolean;
  canUpdatePeriodFragmentType: boolean;
  canUpdatePeriodTypeAndYear: boolean;
  chartData: TargetsUserChartData[];
  childTargets: TargetRelationEntityConnection | null;
  created: DateTime | null;
  currency: CurrencyEntity | null;
  currencyId: ID | null;
  currentIndicators: TargetsIndicators;
  currentMetrics: TargetsCurrentMetrics[];
  currentTargetValue: number;
  daysLeft: number;
  description: string | null;
  estimatedTarget: number | null;
  finishedDate: GqlDate | null;
  hasParentGroupTarget: boolean;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isActive: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  periodFragmentIndex: number;
  periodFragmentType: TargetsPeriodFragmentTypeEnum;
  periodFrom: GqlDate | null;
  periodTo: GqlDate | null;
  periodType: TargetsPeriodTypeEnum;
  periodYear: number;
  revision: number | null;
  settings: TargetsSettings;
  simulatedIndicators: SimulatedTargetIndicators;
  status: TargetStatusEnum | null;
  target: number | null;
  targetClient: ClientEntity | null;
  targetClientId: ID | null;
  targetGoal: number;
  type: TargetTypeEnum | null;
  virtualPeriodFrom: GqlDate | null;
  virtualPeriodTo: GqlDate | null;
}

export interface TargetDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'TargetDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface TargetChartDrilldownModel  {
  __typename?: 'TargetChartDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface TagRepository  {
  __typename?: 'TagRepository';
  getAll: TagEntity[];
  getByCriteria: TagEntityConnection | null;
  getByCustomCriteria: TagEntityConnection | null;
  getByEntityType: TagEntity[];
  getById: TagEntity | null;
  getByIds: TagEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TagRelationRepository  {
  __typename?: 'TagRelationRepository';
  getAll: TagRelationEntity[];
  getByCriteria: TagRelationEntityConnection | null;
  getById: TagRelationEntity | null;
  getByIds: TagRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface TagRelationEntityEdge  {
  __typename?: 'TagRelationEntityEdge';
  cursor: string;
  node: TagRelationEntity | null;
}

export interface TagRelationEntityConnection  {
  __typename?: 'TagRelationEntityConnection';
  edges: TagRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TagRelationEntity  {
  __typename?: 'TagRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  appointment: AppointmentEntity | null;
  appointmentId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  email: EmailEntity | null;
  emailId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadId: ID | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  opptyId: ID | null;
  process: ProcessEntity | null;
  processId: ID | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  revision: number | null;
  tag: TagEntity | null;
  tagId: ID;
  task: TaskEntity | null;
  taskId: ID | null;
}

export interface TagRelatedEntityDrilldownModel  {
  __typename?: 'TagRelatedEntityDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface TagEntityEdge  {
  __typename?: 'TagEntityEdge';
  cursor: string;
  node: TagEntity | null;
}

export interface TagEntityConnection  {
  __typename?: 'TagEntityConnection';
  edges: TagEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface TagEntity  {
  __typename?: 'TagEntity';
  allowedEntityTypeIds: UUID[] | null;
  color: number;
  created: DateTime | null;
  creator: ClientEntity | null;
  creatorId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean | null;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  supportedEntities: number | null;
  useLang: boolean | null;
}

export interface TableReportTotal  {
  __typename?: 'TableReportTotal';
  isEnabled: boolean;
  position: ReportTotalPosition;
  showAverage: boolean;
  showGrandTotal: boolean;
  showMax: boolean;
  showMin: boolean;
  showStatus: boolean;
  showSum: boolean;
}

export interface SyncWebhookPayload  {
  __typename?: 'SyncWebhookPayload';
  result: SyncWebhookOutput;
}

export interface SyncWebhookOutput  {
  __typename?: 'SyncWebhookOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncWebhookItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncWebhookItemOutput  {
  __typename?: 'SyncWebhookItemOutput';
  changedFields: string[] | null;
  entity: WebhookEntity;
}

export interface SyncWebhookEventPayload  {
  __typename?: 'SyncWebhookEventPayload';
  result: SyncWebhookEventOutput;
}

export interface SyncWebhookEventOutput  {
  __typename?: 'SyncWebhookEventOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncWebhookEventItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncWebhookEventItemOutput  {
  __typename?: 'SyncWebhookEventItemOutput';
  changedFields: string[] | null;
  entity: WebhookEventEntity;
}

export interface SyncUnsubscribedPhonePayload  {
  __typename?: 'SyncUnsubscribedPhonePayload';
  result: SyncUnsubscribedPhoneOutput;
}

export interface SyncUnsubscribedPhoneOutput  {
  __typename?: 'SyncUnsubscribedPhoneOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncUnsubscribedPhoneItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncUnsubscribedPhoneItemOutput  {
  __typename?: 'SyncUnsubscribedPhoneItemOutput';
  changedFields: string[] | null;
  entity: UnsubscribedPhoneEntity;
}

export interface SyncTimeframePayload  {
  __typename?: 'SyncTimeframePayload';
  result: SyncTimeframeOutput;
}

export interface SyncTimeframeOutput  {
  __typename?: 'SyncTimeframeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTimeframeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTimeframeItemOutput  {
  __typename?: 'SyncTimeframeItemOutput';
  changedFields: string[] | null;
  entity: TimeframeEntity;
}

export interface SyncTextMessagePayload  {
  __typename?: 'SyncTextMessagePayload';
  result: SyncTextMessageOutput;
}

export interface SyncTextMessageOutput  {
  __typename?: 'SyncTextMessageOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTextMessageItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTextMessageItemOutput  {
  __typename?: 'SyncTextMessageItemOutput';
  changedFields: string[] | null;
  entity: TextMessageEntity;
}

export interface SyncTextMessageConversationRelationsPayload  {
  __typename?: 'SyncTextMessageConversationRelationsPayload';
  result: SyncTextMessageConversationRelationsOutput;
}

export interface SyncTextMessageConversationRelationsOutput  {
  __typename?: 'SyncTextMessageConversationRelationsOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTextMessageConversationRelationsItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTextMessageConversationRelationsItemOutput  {
  __typename?: 'SyncTextMessageConversationRelationsItemOutput';
  changedFields: string[] | null;
  entity: TextMessageConversationRelationsEntity;
}

export interface SyncTextMessageConversationPayload  {
  __typename?: 'SyncTextMessageConversationPayload';
  result: SyncTextMessageConversationOutput;
}

export interface SyncTextMessageConversationOutput  {
  __typename?: 'SyncTextMessageConversationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTextMessageConversationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTextMessageConversationItemOutput  {
  __typename?: 'SyncTextMessageConversationItemOutput';
  changedFields: string[] | null;
  entity: TextMessageConversationEntity;
}

export interface SyncTeamSpaceClientSettingPayload  {
  __typename?: 'SyncTeamSpaceClientSettingPayload';
  result: SyncTeamSpaceClientSettingOutput;
}

export interface SyncTeamSpaceClientSettingOutput  {
  __typename?: 'SyncTeamSpaceClientSettingOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTeamSpaceClientSettingItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTeamSpaceClientSettingItemOutput  {
  __typename?: 'SyncTeamSpaceClientSettingItemOutput';
  changedFields: string[] | null;
  entity: TeamSpaceClientSettingEntity;
}

export interface SyncTeamPipelineHubItemPayload  {
  __typename?: 'SyncTeamPipelineHubItemPayload';
  result: SyncTeamPipelineHubItemOutput;
}

export interface SyncTeamPipelineHubItemOutput  {
  __typename?: 'SyncTeamPipelineHubItemOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTeamPipelineHubItemItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTeamPipelineHubItemItemOutput  {
  __typename?: 'SyncTeamPipelineHubItemItemOutput';
  changedFields: string[] | null;
  entity: TeamPipelineHubItemEntity;
}

export interface SyncTaskSharingSalesUnitRelationPayload  {
  __typename?: 'SyncTaskSharingSalesUnitRelationPayload';
  result: SyncTaskSharingSalesUnitRelationOutput;
}

export interface SyncTaskSharingSalesUnitRelationOutput  {
  __typename?: 'SyncTaskSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTaskSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTaskSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncTaskSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: TaskSharingSalesUnitRelationEntity;
}

export interface SyncTaskSharingClientRelationPayload  {
  __typename?: 'SyncTaskSharingClientRelationPayload';
  result: SyncTaskSharingClientRelationOutput;
}

export interface SyncTaskSharingClientRelationOutput  {
  __typename?: 'SyncTaskSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTaskSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTaskSharingClientRelationItemOutput  {
  __typename?: 'SyncTaskSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: TaskSharingClientRelationEntity;
}

export interface SyncTaskReminderPayload  {
  __typename?: 'SyncTaskReminderPayload';
  result: SyncTaskReminderOutput;
}

export interface SyncTaskReminderOutput  {
  __typename?: 'SyncTaskReminderOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTaskReminderItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTaskReminderItemOutput  {
  __typename?: 'SyncTaskReminderItemOutput';
  changedFields: string[] | null;
  entity: TaskReminderEntity;
}

export interface SyncTaskRecurrencePayload  {
  __typename?: 'SyncTaskRecurrencePayload';
  result: SyncTaskRecurrenceOutput;
}

export interface SyncTaskRecurrenceOutput  {
  __typename?: 'SyncTaskRecurrenceOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTaskRecurrenceItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTaskRecurrenceItemOutput  {
  __typename?: 'SyncTaskRecurrenceItemOutput';
  changedFields: string[] | null;
  entity: TaskRecurrenceEntity;
}

export interface SyncTaskPayload  {
  __typename?: 'SyncTaskPayload';
  result: SyncTaskOutput;
}

export interface SyncTaskOutput  {
  __typename?: 'SyncTaskOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTaskItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTaskItemOutput  {
  __typename?: 'SyncTaskItemOutput';
  changedFields: string[] | null;
  entity: TaskEntity;
}

export interface SyncTargetRelationPayload  {
  __typename?: 'SyncTargetRelationPayload';
  result: SyncTargetRelationOutput;
}

export interface SyncTargetRelationOutput  {
  __typename?: 'SyncTargetRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTargetRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTargetRelationItemOutput  {
  __typename?: 'SyncTargetRelationItemOutput';
  changedFields: string[] | null;
  entity: TargetRelationEntity;
}

export interface SyncTargetPayload  {
  __typename?: 'SyncTargetPayload';
  result: SyncTargetOutput;
}

export interface SyncTargetOutput  {
  __typename?: 'SyncTargetOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTargetItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTargetItemOutput  {
  __typename?: 'SyncTargetItemOutput';
  changedFields: string[] | null;
  entity: TargetEntity;
}

export interface SyncTagRelationPayload  {
  __typename?: 'SyncTagRelationPayload';
  result: SyncTagRelationOutput;
}

export interface SyncTagRelationOutput  {
  __typename?: 'SyncTagRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTagRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTagRelationItemOutput  {
  __typename?: 'SyncTagRelationItemOutput';
  changedFields: string[] | null;
  entity: TagRelationEntity;
}

export interface SyncTagPayload  {
  __typename?: 'SyncTagPayload';
  result: SyncTagOutput;
}

export interface SyncTagOutput  {
  __typename?: 'SyncTagOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncTagItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncTagItemOutput  {
  __typename?: 'SyncTagItemOutput';
  changedFields: string[] | null;
  entity: TagEntity;
}

export interface SyncStepPayload  {
  __typename?: 'SyncStepPayload';
  result: SyncStepOutput;
}

export interface SyncStepOutput  {
  __typename?: 'SyncStepOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncStepItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncStepItemOutput  {
  __typename?: 'SyncStepItemOutput';
  changedFields: string[] | null;
  entity: StepEntity;
}

export interface SyncStepChecklistSalesRoleRelationPayload  {
  __typename?: 'SyncStepChecklistSalesRoleRelationPayload';
  result: SyncStepChecklistSalesRoleRelationOutput;
}

export interface SyncStepChecklistSalesRoleRelationOutput  {
  __typename?: 'SyncStepChecklistSalesRoleRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncStepChecklistSalesRoleRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncStepChecklistSalesRoleRelationItemOutput  {
  __typename?: 'SyncStepChecklistSalesRoleRelationItemOutput';
  changedFields: string[] | null;
  entity: StepChecklistSalesRoleRelationEntity;
}

export interface SyncStepChecklistPayload  {
  __typename?: 'SyncStepChecklistPayload';
  result: SyncStepChecklistOutput;
}

export interface SyncStepChecklistOutput  {
  __typename?: 'SyncStepChecklistOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncStepChecklistItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncStepChecklistItemOutput  {
  __typename?: 'SyncStepChecklistItemOutput';
  changedFields: string[] | null;
  entity: StepChecklistEntity;
}

export interface SyncSalesUnitPayload  {
  __typename?: 'SyncSalesUnitPayload';
  result: SyncSalesUnitOutput;
}

export interface SyncSalesUnitOutput  {
  __typename?: 'SyncSalesUnitOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncSalesUnitItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncSalesUnitItemOutput  {
  __typename?: 'SyncSalesUnitItemOutput';
  changedFields: string[] | null;
  entity: SalesUnitEntity;
}

export interface SyncSalesRolePayload  {
  __typename?: 'SyncSalesRolePayload';
  result: SyncSalesRoleOutput;
}

export interface SyncSalesRoleOutput  {
  __typename?: 'SyncSalesRoleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncSalesRoleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncSalesRoleItemOutput  {
  __typename?: 'SyncSalesRoleItemOutput';
  changedFields: string[] | null;
  entity: SalesRoleEntity;
}

export interface SyncReportSharingSalesUnitRelationPayload  {
  __typename?: 'SyncReportSharingSalesUnitRelationPayload';
  result: SyncReportSharingSalesUnitRelationOutput;
}

export interface SyncReportSharingSalesUnitRelationOutput  {
  __typename?: 'SyncReportSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncReportSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncReportSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncReportSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: ReportSharingSalesUnitRelationEntity;
}

export interface SyncReportSharingClientRelationPayload  {
  __typename?: 'SyncReportSharingClientRelationPayload';
  result: SyncReportSharingClientRelationOutput;
}

export interface SyncReportSharingClientRelationOutput  {
  __typename?: 'SyncReportSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncReportSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncReportSharingClientRelationItemOutput  {
  __typename?: 'SyncReportSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: ReportSharingClientRelationEntity;
}

export interface SyncReportSchedulePayload  {
  __typename?: 'SyncReportSchedulePayload';
  result: SyncReportScheduleOutput;
}

export interface SyncReportScheduleOutput  {
  __typename?: 'SyncReportScheduleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncReportScheduleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncReportScheduleItemOutput  {
  __typename?: 'SyncReportScheduleItemOutput';
  changedFields: string[] | null;
  entity: ReportScheduleEntity;
}

export interface SyncReportPayload  {
  __typename?: 'SyncReportPayload';
  result: SyncReportOutput;
}

export interface SyncReportOutput  {
  __typename?: 'SyncReportOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncReportItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncReportItemOutput  {
  __typename?: 'SyncReportItemOutput';
  changedFields: string[] | null;
  entity: ReportEntity;
}

export interface SyncReportFolderPayload  {
  __typename?: 'SyncReportFolderPayload';
  result: SyncReportFolderOutput;
}

export interface SyncReportFolderOutput  {
  __typename?: 'SyncReportFolderOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncReportFolderItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncReportFolderItemOutput  {
  __typename?: 'SyncReportFolderItemOutput';
  changedFields: string[] | null;
  entity: ReportFolderEntity;
}

export interface SyncQuoteSharingSalesUnitRelationPayload  {
  __typename?: 'SyncQuoteSharingSalesUnitRelationPayload';
  result: SyncQuoteSharingSalesUnitRelationOutput;
}

export interface SyncQuoteSharingSalesUnitRelationOutput  {
  __typename?: 'SyncQuoteSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncQuoteSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: QuoteSharingSalesUnitRelationEntity;
}

export interface SyncQuoteSharingClientRelationPayload  {
  __typename?: 'SyncQuoteSharingClientRelationPayload';
  result: SyncQuoteSharingClientRelationOutput;
}

export interface SyncQuoteSharingClientRelationOutput  {
  __typename?: 'SyncQuoteSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteSharingClientRelationItemOutput  {
  __typename?: 'SyncQuoteSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: QuoteSharingClientRelationEntity;
}

export interface SyncQuoteProcessPayload  {
  __typename?: 'SyncQuoteProcessPayload';
  result: SyncQuoteProcessOutput;
}

export interface SyncQuoteProcessOutput  {
  __typename?: 'SyncQuoteProcessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteProcessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteProcessItemOutput  {
  __typename?: 'SyncQuoteProcessItemOutput';
  changedFields: string[] | null;
  entity: QuoteProcessEntity;
}

export interface SyncQuotePayload  {
  __typename?: 'SyncQuotePayload';
  result: SyncQuoteOutput;
}

export interface SyncQuoteOutput  {
  __typename?: 'SyncQuoteOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteKPIPayload  {
  __typename?: 'SyncQuoteKPIPayload';
  result: SyncQuoteKPIOutput;
}

export interface SyncQuoteKPIOutput  {
  __typename?: 'SyncQuoteKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteKPIItemOutput  {
  __typename?: 'SyncQuoteKPIItemOutput';
  changedFields: string[] | null;
  entity: QuoteKPIEntity;
}

export interface SyncQuoteItemOutput  {
  __typename?: 'SyncQuoteItemOutput';
  changedFields: string[] | null;
  entity: QuoteEntity;
}

export interface SyncQuoteDataExRelationPayload  {
  __typename?: 'SyncQuoteDataExRelationPayload';
  result: SyncQuoteDataExRelationOutput;
}

export interface SyncQuoteDataExRelationOutput  {
  __typename?: 'SyncQuoteDataExRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteDataExRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteDataExRelationItemOutput  {
  __typename?: 'SyncQuoteDataExRelationItemOutput';
  changedFields: string[] | null;
  entity: QuoteDataExRelationEntity;
}

export interface SyncQuoteContactRelationPayload  {
  __typename?: 'SyncQuoteContactRelationPayload';
  result: SyncQuoteContactRelationOutput;
}

export interface SyncQuoteContactRelationOutput  {
  __typename?: 'SyncQuoteContactRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteContactRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteContactRelationItemOutput  {
  __typename?: 'SyncQuoteContactRelationItemOutput';
  changedFields: string[] | null;
  entity: QuoteContactRelationEntity;
}

export interface SyncQuoteAccountRelationPayload  {
  __typename?: 'SyncQuoteAccountRelationPayload';
  result: SyncQuoteAccountRelationOutput;
}

export interface SyncQuoteAccountRelationOutput  {
  __typename?: 'SyncQuoteAccountRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncQuoteAccountRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncQuoteAccountRelationItemOutput  {
  __typename?: 'SyncQuoteAccountRelationItemOutput';
  changedFields: string[] | null;
  entity: QuoteAccountRelationEntity;
}

export interface SyncProjectSharingSalesUnitRelationPayload  {
  __typename?: 'SyncProjectSharingSalesUnitRelationPayload';
  result: SyncProjectSharingSalesUnitRelationOutput;
}

export interface SyncProjectSharingSalesUnitRelationOutput  {
  __typename?: 'SyncProjectSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncProjectSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: ProjectSharingSalesUnitRelationEntity;
}

export interface SyncProjectSharingClientRelationPayload  {
  __typename?: 'SyncProjectSharingClientRelationPayload';
  result: SyncProjectSharingClientRelationOutput;
}

export interface SyncProjectSharingClientRelationOutput  {
  __typename?: 'SyncProjectSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectSharingClientRelationItemOutput  {
  __typename?: 'SyncProjectSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: ProjectSharingClientRelationEntity;
}

export interface SyncProjectPayload  {
  __typename?: 'SyncProjectPayload';
  result: SyncProjectOutput;
}

export interface SyncProjectOutput  {
  __typename?: 'SyncProjectOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectObjectivePayload  {
  __typename?: 'SyncProjectObjectivePayload';
  result: SyncProjectObjectiveOutput;
}

export interface SyncProjectObjectiveOutput  {
  __typename?: 'SyncProjectObjectiveOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectObjectiveItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectObjectiveItemOutput  {
  __typename?: 'SyncProjectObjectiveItemOutput';
  changedFields: string[] | null;
  entity: ProjectObjectiveEntity;
}

export interface SyncProjectKPIPayload  {
  __typename?: 'SyncProjectKPIPayload';
  result: SyncProjectKPIOutput;
}

export interface SyncProjectKPIOutput  {
  __typename?: 'SyncProjectKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectKPIItemOutput  {
  __typename?: 'SyncProjectKPIItemOutput';
  changedFields: string[] | null;
  entity: ProjectKPIEntity;
}

export interface SyncProjectItemOutput  {
  __typename?: 'SyncProjectItemOutput';
  changedFields: string[] | null;
  entity: ProjectEntity;
}

export interface SyncProjectContactRelationPayload  {
  __typename?: 'SyncProjectContactRelationPayload';
  result: SyncProjectContactRelationOutput;
}

export interface SyncProjectContactRelationOutput  {
  __typename?: 'SyncProjectContactRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProjectContactRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProjectContactRelationItemOutput  {
  __typename?: 'SyncProjectContactRelationItemOutput';
  changedFields: string[] | null;
  entity: ProjectContactRelationEntity;
}

export interface SyncProfileSharingSalesUnitRelationPayload  {
  __typename?: 'SyncProfileSharingSalesUnitRelationPayload';
  result: SyncProfileSharingSalesUnitRelationOutput;
}

export interface SyncProfileSharingSalesUnitRelationOutput  {
  __typename?: 'SyncProfileSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProfileSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProfileSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncProfileSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: ProfileSharingSalesUnitRelationEntity;
}

export interface SyncProfileSharingClientRelationPayload  {
  __typename?: 'SyncProfileSharingClientRelationPayload';
  result: SyncProfileSharingClientRelationOutput;
}

export interface SyncProfileSharingClientRelationOutput  {
  __typename?: 'SyncProfileSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProfileSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProfileSharingClientRelationItemOutput  {
  __typename?: 'SyncProfileSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: ProfileSharingClientRelationEntity;
}

export interface SyncProfileRelationPayload  {
  __typename?: 'SyncProfileRelationPayload';
  result: SyncProfileRelationOutput;
}

export interface SyncProfileRelationOutput  {
  __typename?: 'SyncProfileRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProfileRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProfileRelationItemOutput  {
  __typename?: 'SyncProfileRelationItemOutput';
  changedFields: string[] | null;
  entity: ProfileRelationEntity;
}

export interface SyncProfilePayload  {
  __typename?: 'SyncProfilePayload';
  result: SyncProfileOutput;
}

export interface SyncProfileOutput  {
  __typename?: 'SyncProfileOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProfileItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProfileItemOutput  {
  __typename?: 'SyncProfileItemOutput';
  changedFields: string[] | null;
  entity: ProfileEntity;
}

export interface SyncProductPriceListPricePayload  {
  __typename?: 'SyncProductPriceListPricePayload';
  result: SyncProductPriceListPriceOutput;
}

export interface SyncProductPriceListPriceOutput  {
  __typename?: 'SyncProductPriceListPriceOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProductPriceListPriceItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProductPriceListPriceItemOutput  {
  __typename?: 'SyncProductPriceListPriceItemOutput';
  changedFields: string[] | null;
  entity: ProductPriceListPriceEntity;
}

export interface SyncProductPriceListPayload  {
  __typename?: 'SyncProductPriceListPayload';
  result: SyncProductPriceListOutput;
}

export interface SyncProductPriceListOutput  {
  __typename?: 'SyncProductPriceListOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProductPriceListItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProductPriceListItemOutput  {
  __typename?: 'SyncProductPriceListItemOutput';
  changedFields: string[] | null;
  entity: ProductPriceListEntity;
}

export interface SyncProductPipelineRelationPayload  {
  __typename?: 'SyncProductPipelineRelationPayload';
  result: SyncProductPipelineRelationOutput;
}

export interface SyncProductPipelineRelationOutput  {
  __typename?: 'SyncProductPipelineRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProductPipelineRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProductPipelineRelationItemOutput  {
  __typename?: 'SyncProductPipelineRelationItemOutput';
  changedFields: string[] | null;
  entity: ProductPipelineRelationEntity;
}

export interface SyncProductPayload  {
  __typename?: 'SyncProductPayload';
  result: SyncProductOutput;
}

export interface SyncProductOutput  {
  __typename?: 'SyncProductOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProductItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProductItemOutput  {
  __typename?: 'SyncProductItemOutput';
  changedFields: string[] | null;
  entity: ProductEntity;
}

export interface SyncProductCategoryPayload  {
  __typename?: 'SyncProductCategoryPayload';
  result: SyncProductCategoryOutput;
}

export interface SyncProductCategoryOutput  {
  __typename?: 'SyncProductCategoryOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProductCategoryItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProductCategoryItemOutput  {
  __typename?: 'SyncProductCategoryItemOutput';
  changedFields: string[] | null;
  entity: ProductCategoryEntity;
}

export interface SyncProcessTemplatePayload  {
  __typename?: 'SyncProcessTemplatePayload';
  result: SyncProcessTemplateOutput;
}

export interface SyncProcessTemplateOutput  {
  __typename?: 'SyncProcessTemplateOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProcessTemplateItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProcessTemplateItemOutput  {
  __typename?: 'SyncProcessTemplateItemOutput';
  changedFields: string[] | null;
  entity: ProcessTemplateEntity;
}

export interface SyncProcessPayload  {
  __typename?: 'SyncProcessPayload';
  result: SyncProcessOutput;
}

export interface SyncProcessOutput  {
  __typename?: 'SyncProcessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProcessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProcessItemOutput  {
  __typename?: 'SyncProcessItemOutput';
  changedFields: string[] | null;
  entity: ProcessEntity;
}

export interface SyncProcessActivityLogPayload  {
  __typename?: 'SyncProcessActivityLogPayload';
  result: SyncProcessActivityLogOutput;
}

export interface SyncProcessActivityLogOutput  {
  __typename?: 'SyncProcessActivityLogOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProcessActivityLogItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProcessActivityLogLinePayload  {
  __typename?: 'SyncProcessActivityLogLinePayload';
  result: SyncProcessActivityLogLineOutput;
}

export interface SyncProcessActivityLogLineOutput  {
  __typename?: 'SyncProcessActivityLogLineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncProcessActivityLogLineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncProcessActivityLogLineItemOutput  {
  __typename?: 'SyncProcessActivityLogLineItemOutput';
  changedFields: string[] | null;
  entity: ProcessActivityLogLineEntity;
}

export interface SyncProcessActivityLogItemOutput  {
  __typename?: 'SyncProcessActivityLogItemOutput';
  changedFields: string[] | null;
  entity: ProcessActivityLogEntity;
}

export interface SyncPipelinePayload  {
  __typename?: 'SyncPipelinePayload';
  result: SyncPipelineOutput;
}

export interface SyncPipelineOutput  {
  __typename?: 'SyncPipelineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncPipelineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncPipelineItemOutput  {
  __typename?: 'SyncPipelineItemOutput';
  changedFields: string[] | null;
  entity: PipelineEntity;
}

export interface SyncPhonePayload  {
  __typename?: 'SyncPhonePayload';
  result: SyncPhoneOutput;
}

export interface SyncPhoneOutput  {
  __typename?: 'SyncPhoneOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncPhoneItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncPhoneItemOutput  {
  __typename?: 'SyncPhoneItemOutput';
  changedFields: string[] | null;
  entity: PhoneEntity;
}

export interface SyncParentAccountRelationTypePayload  {
  __typename?: 'SyncParentAccountRelationTypePayload';
  result: SyncParentAccountRelationTypeOutput;
}

export interface SyncParentAccountRelationTypeOutput  {
  __typename?: 'SyncParentAccountRelationTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncParentAccountRelationTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncParentAccountRelationTypeItemOutput  {
  __typename?: 'SyncParentAccountRelationTypeItemOutput';
  changedFields: string[] | null;
  entity: ParentAccountRelationTypeEntity;
}

export interface SyncOpptyRevenueSchedulePeriodPayload  {
  __typename?: 'SyncOpptyRevenueSchedulePeriodPayload';
  result: SyncOpptyRevenueSchedulePeriodOutput;
}

export interface SyncOpptyRevenueSchedulePeriodOutput  {
  __typename?: 'SyncOpptyRevenueSchedulePeriodOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyRevenueSchedulePeriodItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyRevenueSchedulePeriodItemOutput  {
  __typename?: 'SyncOpptyRevenueSchedulePeriodItemOutput';
  changedFields: string[] | null;
  entity: OpptyRevenueSchedulePeriodEntity;
}

export interface SyncOpptyRevenueSchedulePayload  {
  __typename?: 'SyncOpptyRevenueSchedulePayload';
  result: SyncOpptyRevenueScheduleOutput;
}

export interface SyncOpptyRevenueScheduleOutput  {
  __typename?: 'SyncOpptyRevenueScheduleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyRevenueScheduleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyRevenueScheduleItemOutput  {
  __typename?: 'SyncOpptyRevenueScheduleItemOutput';
  changedFields: string[] | null;
  entity: OpptyRevenueScheduleEntity;
}

export interface SyncOpptyRecurrencePayload  {
  __typename?: 'SyncOpptyRecurrencePayload';
  result: SyncOpptyRecurrenceOutput;
}

export interface SyncOpptyRecurrenceOutput  {
  __typename?: 'SyncOpptyRecurrenceOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyRecurrenceItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyRecurrenceItemOutput  {
  __typename?: 'SyncOpptyRecurrenceItemOutput';
  changedFields: string[] | null;
  entity: OpptyRecurrenceEntity;
}

export interface SyncOpptyProductRelationRevenueSchedulePeriodPayload  {
  __typename?: 'SyncOpptyProductRelationRevenueSchedulePeriodPayload';
  result: SyncOpptyProductRelationRevenueSchedulePeriodOutput;
}

export interface SyncOpptyProductRelationRevenueSchedulePeriodOutput  {
  __typename?: 'SyncOpptyProductRelationRevenueSchedulePeriodOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyProductRelationRevenueSchedulePeriodItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyProductRelationRevenueSchedulePeriodItemOutput  {
  __typename?: 'SyncOpptyProductRelationRevenueSchedulePeriodItemOutput';
  changedFields: string[] | null;
  entity: OpptyProductRelationRevenueSchedulePeriodEntity;
}

export interface SyncOpptyProductRelationRevenueSchedulePayload  {
  __typename?: 'SyncOpptyProductRelationRevenueSchedulePayload';
  result: SyncOpptyProductRelationRevenueScheduleOutput;
}

export interface SyncOpptyProductRelationRevenueScheduleOutput  {
  __typename?: 'SyncOpptyProductRelationRevenueScheduleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyProductRelationRevenueScheduleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyProductRelationRevenueScheduleItemOutput  {
  __typename?: 'SyncOpptyProductRelationRevenueScheduleItemOutput';
  changedFields: string[] | null;
  entity: OpptyProductRelationRevenueScheduleEntity;
}

export interface SyncOpptyProductRelationPayload  {
  __typename?: 'SyncOpptyProductRelationPayload';
  result: SyncOpptyProductRelationOutput;
}

export interface SyncOpptyProductRelationOutput  {
  __typename?: 'SyncOpptyProductRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyProductRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyProductRelationItemOutput  {
  __typename?: 'SyncOpptyProductRelationItemOutput';
  changedFields: string[] | null;
  entity: OpptyProductRelationEntity;
}

export interface SyncOpptyProductRelationDataExRelationPayload  {
  __typename?: 'SyncOpptyProductRelationDataExRelationPayload';
  result: SyncOpptyProductRelationDataExRelationOutput;
}

export interface SyncOpptyProductRelationDataExRelationOutput  {
  __typename?: 'SyncOpptyProductRelationDataExRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpptyProductRelationDataExRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpptyProductRelationDataExRelationItemOutput  {
  __typename?: 'SyncOpptyProductRelationDataExRelationItemOutput';
  changedFields: string[] | null;
  entity: OpptyProductRelationDataExRelationEntity;
}

export interface SyncOpportunityPayload  {
  __typename?: 'SyncOpportunityPayload';
  result: SyncOpportunityOutput;
}

export interface SyncOpportunityOutput  {
  __typename?: 'SyncOpportunityOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOpportunityItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOpportunityItemOutput  {
  __typename?: 'SyncOpportunityItemOutput';
  changedFields: string[] | null;
  entity: OpportunityEntity;
}

export interface SyncOnlineFormTypePayload  {
  __typename?: 'SyncOnlineFormTypePayload';
  result: SyncOnlineFormTypeOutput;
}

export interface SyncOnlineFormTypeOutput  {
  __typename?: 'SyncOnlineFormTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormTypeItemOutput  {
  __typename?: 'SyncOnlineFormTypeItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormTypeEntity;
}

export interface SyncOnlineFormTypeEmailRelationPayload  {
  __typename?: 'SyncOnlineFormTypeEmailRelationPayload';
  result: SyncOnlineFormTypeEmailRelationOutput;
}

export interface SyncOnlineFormTypeEmailRelationOutput  {
  __typename?: 'SyncOnlineFormTypeEmailRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormTypeEmailRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormTypeEmailRelationItemOutput  {
  __typename?: 'SyncOnlineFormTypeEmailRelationItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormTypeEmailRelationEntity;
}

export interface SyncOnlineFormStylePayload  {
  __typename?: 'SyncOnlineFormStylePayload';
  result: SyncOnlineFormStyleOutput;
}

export interface SyncOnlineFormStyleOutput  {
  __typename?: 'SyncOnlineFormStyleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormStyleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormStyleItemOutput  {
  __typename?: 'SyncOnlineFormStyleItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormStyleEntity;
}

export interface SyncOnlineFormRelationPayload  {
  __typename?: 'SyncOnlineFormRelationPayload';
  result: SyncOnlineFormRelationOutput;
}

export interface SyncOnlineFormRelationOutput  {
  __typename?: 'SyncOnlineFormRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormRelationItemOutput  {
  __typename?: 'SyncOnlineFormRelationItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormRelationEntity;
}

export interface SyncOnlineFormPayload  {
  __typename?: 'SyncOnlineFormPayload';
  result: SyncOnlineFormOutput;
}

export interface SyncOnlineFormOutput  {
  __typename?: 'SyncOnlineFormOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormItemOutput  {
  __typename?: 'SyncOnlineFormItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormEntity;
}

export interface SyncOnlineFormDataExRelationPayload  {
  __typename?: 'SyncOnlineFormDataExRelationPayload';
  result: SyncOnlineFormDataExRelationOutput;
}

export interface SyncOnlineFormDataExRelationOutput  {
  __typename?: 'SyncOnlineFormDataExRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormDataExRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormDataExRelationItemOutput  {
  __typename?: 'SyncOnlineFormDataExRelationItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormDataExRelationEntity;
}

export interface SyncOnlineFormActivityLogLinePayload  {
  __typename?: 'SyncOnlineFormActivityLogLinePayload';
  result: SyncOnlineFormActivityLogLineOutput;
}

export interface SyncOnlineFormActivityLogLineOutput  {
  __typename?: 'SyncOnlineFormActivityLogLineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncOnlineFormActivityLogLineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncOnlineFormActivityLogLineItemOutput  {
  __typename?: 'SyncOnlineFormActivityLogLineItemOutput';
  changedFields: string[] | null;
  entity: OnlineFormActivityLogLineEntity;
}

export interface SyncNotePayload  {
  __typename?: 'SyncNotePayload';
  result: SyncNoteOutput;
}

export interface SyncNoteOutput  {
  __typename?: 'SyncNoteOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncNoteItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncNoteItemOutput  {
  __typename?: 'SyncNoteItemOutput';
  changedFields: string[] | null;
  entity: NoteEntity;
}

export interface SyncMessageSharingSalesUnitRelationPayload  {
  __typename?: 'SyncMessageSharingSalesUnitRelationPayload';
  result: SyncMessageSharingSalesUnitRelationOutput;
}

export interface SyncMessageSharingSalesUnitRelationOutput  {
  __typename?: 'SyncMessageSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMessageSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMessageSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncMessageSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: MessageSharingSalesUnitRelationEntity;
}

export interface SyncMessageSharingClientRelationPayload  {
  __typename?: 'SyncMessageSharingClientRelationPayload';
  result: SyncMessageSharingClientRelationOutput;
}

export interface SyncMessageSharingClientRelationOutput  {
  __typename?: 'SyncMessageSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMessageSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMessageSharingClientRelationItemOutput  {
  __typename?: 'SyncMessageSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: MessageSharingClientRelationEntity;
}

export interface SyncMessageRelationPayload  {
  __typename?: 'SyncMessageRelationPayload';
  result: SyncMessageRelationOutput;
}

export interface SyncMessageRelationOutput  {
  __typename?: 'SyncMessageRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMessageRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMessageRelationItemOutput  {
  __typename?: 'SyncMessageRelationItemOutput';
  changedFields: string[] | null;
  entity: MessageRelationEntity;
}

export interface SyncMemoPayload  {
  __typename?: 'SyncMemoPayload';
  result: SyncMemoOutput;
}

export interface SyncMemoOutput  {
  __typename?: 'SyncMemoOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMemoItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMemoItemOutput  {
  __typename?: 'SyncMemoItemOutput';
  changedFields: string[] | null;
  entity: MemoEntity;
}

export interface SyncMemoCommentPayload  {
  __typename?: 'SyncMemoCommentPayload';
  result: SyncMemoCommentOutput;
}

export interface SyncMemoCommentOutput  {
  __typename?: 'SyncMemoCommentOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMemoCommentItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMemoCommentItemOutput  {
  __typename?: 'SyncMemoCommentItemOutput';
  changedFields: string[] | null;
  entity: MemoCommentEntity;
}

export interface SyncMediaPayload  {
  __typename?: 'SyncMediaPayload';
  result: SyncMediaOutput;
}

export interface SyncMediaOutput  {
  __typename?: 'SyncMediaOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMediaItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMediaItemOutput  {
  __typename?: 'SyncMediaItemOutput';
  changedFields: string[] | null;
  entity: MediaEntity;
}

export interface SyncMasterRightPayload  {
  __typename?: 'SyncMasterRightPayload';
  result: SyncMasterRightOutput;
}

export interface SyncMasterRightOutput  {
  __typename?: 'SyncMasterRightOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncMasterRightItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncMasterRightItemOutput  {
  __typename?: 'SyncMasterRightItemOutput';
  changedFields: string[] | null;
  entity: MasterRightEntity;
}

export interface SyncLeadProcessPayload  {
  __typename?: 'SyncLeadProcessPayload';
  result: SyncLeadProcessOutput;
}

export interface SyncLeadProcessOutput  {
  __typename?: 'SyncLeadProcessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadProcessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadProcessItemOutput  {
  __typename?: 'SyncLeadProcessItemOutput';
  changedFields: string[] | null;
  entity: LeadProcessEntity;
}

export interface SyncLeadPayload  {
  __typename?: 'SyncLeadPayload';
  result: SyncLeadOutput;
}

export interface SyncLeadOutput  {
  __typename?: 'SyncLeadOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyStepCheckListRelationPayload  {
  __typename?: 'SyncLeadOpptyStepCheckListRelationPayload';
  result: SyncLeadOpptyStepCheckListRelationOutput;
}

export interface SyncLeadOpptyStepCheckListRelationOutput  {
  __typename?: 'SyncLeadOpptyStepCheckListRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyStepCheckListRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyStepCheckListRelationItemOutput  {
  __typename?: 'SyncLeadOpptyStepCheckListRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyStepCheckListRelationEntity;
}

export interface SyncLeadOpptySharingSalesUnitRelationPayload  {
  __typename?: 'SyncLeadOpptySharingSalesUnitRelationPayload';
  result: SyncLeadOpptySharingSalesUnitRelationOutput;
}

export interface SyncLeadOpptySharingSalesUnitRelationOutput  {
  __typename?: 'SyncLeadOpptySharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptySharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptySharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncLeadOpptySharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptySharingSalesUnitRelationEntity;
}

export interface SyncLeadOpptySharingClientRelationPayload  {
  __typename?: 'SyncLeadOpptySharingClientRelationPayload';
  result: SyncLeadOpptySharingClientRelationOutput;
}

export interface SyncLeadOpptySharingClientRelationOutput  {
  __typename?: 'SyncLeadOpptySharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptySharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptySharingClientRelationItemOutput  {
  __typename?: 'SyncLeadOpptySharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptySharingClientRelationEntity;
}

export interface SyncLeadOpptyKPIPayload  {
  __typename?: 'SyncLeadOpptyKPIPayload';
  result: SyncLeadOpptyKPIOutput;
}

export interface SyncLeadOpptyKPIOutput  {
  __typename?: 'SyncLeadOpptyKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyKPIItemOutput  {
  __typename?: 'SyncLeadOpptyKPIItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyKPIEntity;
}

export interface SyncLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'SyncLeadOpptyContactSalesRoleRelationPayload';
  result: SyncLeadOpptyContactSalesRoleRelationOutput;
}

export interface SyncLeadOpptyContactSalesRoleRelationOutput  {
  __typename?: 'SyncLeadOpptyContactSalesRoleRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyContactSalesRoleRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyContactSalesRoleRelationItemOutput  {
  __typename?: 'SyncLeadOpptyContactSalesRoleRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyContactSalesRoleRelationEntity;
}

export interface SyncLeadOpptyContactRelationPayload  {
  __typename?: 'SyncLeadOpptyContactRelationPayload';
  result: SyncLeadOpptyContactRelationOutput;
}

export interface SyncLeadOpptyContactRelationOutput  {
  __typename?: 'SyncLeadOpptyContactRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyContactRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyContactRelationItemOutput  {
  __typename?: 'SyncLeadOpptyContactRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyContactRelationEntity;
}

export interface SyncLeadOpptyContactGroupRelationPayload  {
  __typename?: 'SyncLeadOpptyContactGroupRelationPayload';
  result: SyncLeadOpptyContactGroupRelationOutput;
}

export interface SyncLeadOpptyContactGroupRelationOutput  {
  __typename?: 'SyncLeadOpptyContactGroupRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyContactGroupRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyContactGroupRelationItemOutput  {
  __typename?: 'SyncLeadOpptyContactGroupRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyContactGroupRelationEntity;
}

export interface SyncLeadOpptyAccountRelationPayload  {
  __typename?: 'SyncLeadOpptyAccountRelationPayload';
  result: SyncLeadOpptyAccountRelationOutput;
}

export interface SyncLeadOpptyAccountRelationOutput  {
  __typename?: 'SyncLeadOpptyAccountRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncLeadOpptyAccountRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncLeadOpptyAccountRelationItemOutput  {
  __typename?: 'SyncLeadOpptyAccountRelationItemOutput';
  changedFields: string[] | null;
  entity: LeadOpptyAccountRelationEntity;
}

export interface SyncLeadItemOutput  {
  __typename?: 'SyncLeadItemOutput';
  changedFields: string[] | null;
  entity: LeadEntity;
}

export interface SyncImportMappingMaskPayload  {
  __typename?: 'SyncImportMappingMaskPayload';
  result: SyncImportMappingMaskOutput;
}

export interface SyncImportMappingMaskOutput  {
  __typename?: 'SyncImportMappingMaskOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncImportMappingMaskItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncImportMappingMaskItemOutput  {
  __typename?: 'SyncImportMappingMaskItemOutput';
  changedFields: string[] | null;
  entity: ImportMappingMaskEntity;
}

export interface SyncGhostLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'SyncGhostLeadOpptyContactSalesRoleRelationPayload';
  result: SyncGhostLeadOpptyContactSalesRoleRelationOutput;
}

export interface SyncGhostLeadOpptyContactSalesRoleRelationOutput  {
  __typename?: 'SyncGhostLeadOpptyContactSalesRoleRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncGhostLeadOpptyContactSalesRoleRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncGhostLeadOpptyContactSalesRoleRelationItemOutput  {
  __typename?: 'SyncGhostLeadOpptyContactSalesRoleRelationItemOutput';
  changedFields: string[] | null;
  entity: GhostLeadOpptyContactSalesRoleRelationEntity;
}

export interface SyncGhostLeadOpptyContactRelationPayload  {
  __typename?: 'SyncGhostLeadOpptyContactRelationPayload';
  result: SyncGhostLeadOpptyContactRelationOutput;
}

export interface SyncGhostLeadOpptyContactRelationOutput  {
  __typename?: 'SyncGhostLeadOpptyContactRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncGhostLeadOpptyContactRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncGhostLeadOpptyContactRelationItemOutput  {
  __typename?: 'SyncGhostLeadOpptyContactRelationItemOutput';
  changedFields: string[] | null;
  entity: GhostLeadOpptyContactRelationEntity;
}

export interface SyncGhostContactPayload  {
  __typename?: 'SyncGhostContactPayload';
  result: SyncGhostContactOutput;
}

export interface SyncGhostContactOutput  {
  __typename?: 'SyncGhostContactOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncGhostContactItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncGhostContactItemOutput  {
  __typename?: 'SyncGhostContactItemOutput';
  changedFields: string[] | null;
  entity: GhostContactEntity;
}

export interface SyncGhostContactAccountRelationPayload  {
  __typename?: 'SyncGhostContactAccountRelationPayload';
  result: SyncGhostContactAccountRelationOutput;
}

export interface SyncGhostContactAccountRelationOutput  {
  __typename?: 'SyncGhostContactAccountRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncGhostContactAccountRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncGhostContactAccountRelationItemOutput  {
  __typename?: 'SyncGhostContactAccountRelationItemOutput';
  changedFields: string[] | null;
  entity: GhostContactAccountRelationEntity;
}

export interface SyncGhostContactAccountAccountRoleRelationPayload  {
  __typename?: 'SyncGhostContactAccountAccountRoleRelationPayload';
  result: SyncGhostContactAccountAccountRoleRelationOutput;
}

export interface SyncGhostContactAccountAccountRoleRelationOutput  {
  __typename?: 'SyncGhostContactAccountAccountRoleRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncGhostContactAccountAccountRoleRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncGhostContactAccountAccountRoleRelationItemOutput  {
  __typename?: 'SyncGhostContactAccountAccountRoleRelationItemOutput';
  changedFields: string[] | null;
  entity: GhostContactAccountAccountRoleRelationEntity;
}

export interface SyncFromCpPhonePayload  {
  __typename?: 'SyncFromCpPhonePayload';
  phone: PhoneEntity | null;
}

export interface SyncFormViewSharingSalesUnitRelationPayload  {
  __typename?: 'SyncFormViewSharingSalesUnitRelationPayload';
  result: SyncFormViewSharingSalesUnitRelationOutput;
}

export interface SyncFormViewSharingSalesUnitRelationOutput  {
  __typename?: 'SyncFormViewSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncFormViewSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncFormViewSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncFormViewSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: FormViewSharingSalesUnitRelationEntity;
}

export interface SyncFormViewSharingClientRelationPayload  {
  __typename?: 'SyncFormViewSharingClientRelationPayload';
  result: SyncFormViewSharingClientRelationOutput;
}

export interface SyncFormViewSharingClientRelationOutput  {
  __typename?: 'SyncFormViewSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncFormViewSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncFormViewSharingClientRelationItemOutput  {
  __typename?: 'SyncFormViewSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: FormViewSharingClientRelationEntity;
}

export interface SyncFormViewPayload  {
  __typename?: 'SyncFormViewPayload';
  result: SyncFormViewOutput;
}

export interface SyncFormViewOutput  {
  __typename?: 'SyncFormViewOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncFormViewItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncFormViewItemOutput  {
  __typename?: 'SyncFormViewItemOutput';
  changedFields: string[] | null;
  entity: FormViewEntity;
}

export interface SyncForecastPayload  {
  __typename?: 'SyncForecastPayload';
  result: SyncForecastOutput;
}

export interface SyncForecastOutput  {
  __typename?: 'SyncForecastOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncForecastItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncForecastItemOutput  {
  __typename?: 'SyncForecastItemOutput';
  changedFields: string[] | null;
  entity: ForecastEntity;
}

export interface SyncFieldMappingPayload  {
  __typename?: 'SyncFieldMappingPayload';
  result: SyncFieldMappingOutput;
}

export interface SyncFieldMappingOutput  {
  __typename?: 'SyncFieldMappingOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncFieldMappingItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncFieldMappingItemOutput  {
  __typename?: 'SyncFieldMappingItemOutput';
  changedFields: string[] | null;
  entity: FieldMappingEntity;
}

export interface SyncEntityScoringPayload  {
  __typename?: 'SyncEntityScoringPayload';
  result: SyncEntityScoringOutput;
}

export interface SyncEntityScoringOutput  {
  __typename?: 'SyncEntityScoringOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEntityScoringItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEntityScoringItemOutput  {
  __typename?: 'SyncEntityScoringItemOutput';
  changedFields: string[] | null;
  entity: EntityScoringEntity;
}

export interface SyncEntityHealthPayload  {
  __typename?: 'SyncEntityHealthPayload';
  result: SyncEntityHealthOutput;
}

export interface SyncEntityHealthOutput  {
  __typename?: 'SyncEntityHealthOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEntityHealthItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEntityHealthItemOutput  {
  __typename?: 'SyncEntityHealthItemOutput';
  changedFields: string[] | null;
  entity: EntityHealthEntity;
}

export interface SyncEntityFitnessPayload  {
  __typename?: 'SyncEntityFitnessPayload';
  result: SyncEntityFitnessOutput;
}

export interface SyncEntityFitnessOutput  {
  __typename?: 'SyncEntityFitnessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEntityFitnessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEntityFitnessItemOutput  {
  __typename?: 'SyncEntityFitnessItemOutput';
  changedFields: string[] | null;
  entity: EntityFitnessEntity;
}

export interface SyncEntityFitnessIndicatorPayload  {
  __typename?: 'SyncEntityFitnessIndicatorPayload';
  result: SyncEntityFitnessIndicatorOutput;
}

export interface SyncEntityFitnessIndicatorOutput  {
  __typename?: 'SyncEntityFitnessIndicatorOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEntityFitnessIndicatorItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEntityFitnessIndicatorItemOutput  {
  __typename?: 'SyncEntityFitnessIndicatorItemOutput';
  changedFields: string[] | null;
  entity: EntityFitnessIndicatorEntity;
}

export interface SyncEmailTemplateSharingSalesUnitRelationPayload  {
  __typename?: 'SyncEmailTemplateSharingSalesUnitRelationPayload';
  result: SyncEmailTemplateSharingSalesUnitRelationOutput;
}

export interface SyncEmailTemplateSharingSalesUnitRelationOutput  {
  __typename?: 'SyncEmailTemplateSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailTemplateSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailTemplateSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncEmailTemplateSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: EmailTemplateSharingSalesUnitRelationEntity;
}

export interface SyncEmailTemplateSharingClientRelationPayload  {
  __typename?: 'SyncEmailTemplateSharingClientRelationPayload';
  result: SyncEmailTemplateSharingClientRelationOutput;
}

export interface SyncEmailTemplateSharingClientRelationOutput  {
  __typename?: 'SyncEmailTemplateSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailTemplateSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailTemplateSharingClientRelationItemOutput  {
  __typename?: 'SyncEmailTemplateSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: EmailTemplateSharingClientRelationEntity;
}

export interface SyncEmailTemplatePayload  {
  __typename?: 'SyncEmailTemplatePayload';
  result: SyncEmailTemplateOutput;
}

export interface SyncEmailTemplateOutput  {
  __typename?: 'SyncEmailTemplateOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailTemplateItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailTemplateItemOutput  {
  __typename?: 'SyncEmailTemplateItemOutput';
  changedFields: string[] | null;
  entity: EmailTemplateEntity;
}

export interface SyncEmailTemplateFolderPayload  {
  __typename?: 'SyncEmailTemplateFolderPayload';
  result: SyncEmailTemplateFolderOutput;
}

export interface SyncEmailTemplateFolderOutput  {
  __typename?: 'SyncEmailTemplateFolderOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailTemplateFolderItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailTemplateFolderItemOutput  {
  __typename?: 'SyncEmailTemplateFolderItemOutput';
  changedFields: string[] | null;
  entity: EmailTemplateFolderEntity;
}

export interface SyncEmailSequencePayload  {
  __typename?: 'SyncEmailSequencePayload';
  result: SyncEmailSequenceOutput;
}

export interface SyncEmailSequenceOutput  {
  __typename?: 'SyncEmailSequenceOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailSequenceItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailSequenceItemOutput  {
  __typename?: 'SyncEmailSequenceItemOutput';
  changedFields: string[] | null;
  entity: EmailSequenceEntity;
}

export interface SyncEmailSequenceEnrolledPayload  {
  __typename?: 'SyncEmailSequenceEnrolledPayload';
  result: SyncEmailSequenceEnrolledOutput;
}

export interface SyncEmailSequenceEnrolledOutput  {
  __typename?: 'SyncEmailSequenceEnrolledOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailSequenceEnrolledItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailSequenceEnrolledItemOutput  {
  __typename?: 'SyncEmailSequenceEnrolledItemOutput';
  changedFields: string[] | null;
  entity: EmailSequenceEnrolledEntity;
}

export interface SyncEmailSequenceActivityLogPayload  {
  __typename?: 'SyncEmailSequenceActivityLogPayload';
  result: SyncEmailSequenceActivityLogOutput;
}

export interface SyncEmailSequenceActivityLogOutput  {
  __typename?: 'SyncEmailSequenceActivityLogOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailSequenceActivityLogItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailSequenceActivityLogLinePayload  {
  __typename?: 'SyncEmailSequenceActivityLogLinePayload';
  result: SyncEmailSequenceActivityLogLineOutput;
}

export interface SyncEmailSequenceActivityLogLineOutput  {
  __typename?: 'SyncEmailSequenceActivityLogLineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailSequenceActivityLogLineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailSequenceActivityLogLineItemOutput  {
  __typename?: 'SyncEmailSequenceActivityLogLineItemOutput';
  changedFields: string[] | null;
  entity: EmailSequenceActivityLogLineEntity;
}

export interface SyncEmailSequenceActivityLogItemOutput  {
  __typename?: 'SyncEmailSequenceActivityLogItemOutput';
  changedFields: string[] | null;
  entity: EmailSequenceActivityLogEntity;
}

export interface SyncEmailPayload  {
  __typename?: 'SyncEmailPayload';
  result: SyncEmailOutput;
}

export interface SyncEmailOutput  {
  __typename?: 'SyncEmailOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailItemOutput  {
  __typename?: 'SyncEmailItemOutput';
  changedFields: string[] | null;
  entity: EmailEntity;
}

export interface SyncEmailEventPayload  {
  __typename?: 'SyncEmailEventPayload';
  result: SyncEmailEventOutput;
}

export interface SyncEmailEventOutput  {
  __typename?: 'SyncEmailEventOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailEventItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailEventItemOutput  {
  __typename?: 'SyncEmailEventItemOutput';
  changedFields: string[] | null;
  entity: EmailEventEntity;
}

export interface SyncEmailContentSharingSalesUnitRelationPayload  {
  __typename?: 'SyncEmailContentSharingSalesUnitRelationPayload';
  result: SyncEmailContentSharingSalesUnitRelationOutput;
}

export interface SyncEmailContentSharingSalesUnitRelationOutput  {
  __typename?: 'SyncEmailContentSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailContentSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailContentSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncEmailContentSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: EmailContentSharingSalesUnitRelationEntity;
}

export interface SyncEmailContentSharingClientRelationPayload  {
  __typename?: 'SyncEmailContentSharingClientRelationPayload';
  result: SyncEmailContentSharingClientRelationOutput;
}

export interface SyncEmailContentSharingClientRelationOutput  {
  __typename?: 'SyncEmailContentSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncEmailContentSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncEmailContentSharingClientRelationItemOutput  {
  __typename?: 'SyncEmailContentSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: EmailContentSharingClientRelationEntity;
}

export interface SyncCustomEntitySharingSalesUnitRelationPayload  {
  __typename?: 'SyncCustomEntitySharingSalesUnitRelationPayload';
  result: SyncCustomEntitySharingSalesUnitRelationOutput;
}

export interface SyncCustomEntitySharingSalesUnitRelationOutput  {
  __typename?: 'SyncCustomEntitySharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCustomEntitySharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCustomEntitySharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncCustomEntitySharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: CustomEntitySharingSalesUnitRelationEntity;
}

export interface SyncCustomEntitySharingClientRelationPayload  {
  __typename?: 'SyncCustomEntitySharingClientRelationPayload';
  result: SyncCustomEntitySharingClientRelationOutput;
}

export interface SyncCustomEntitySharingClientRelationOutput  {
  __typename?: 'SyncCustomEntitySharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCustomEntitySharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCustomEntitySharingClientRelationItemOutput  {
  __typename?: 'SyncCustomEntitySharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: CustomEntitySharingClientRelationEntity;
}

export interface SyncCustomEntityRelationDataPayload  {
  __typename?: 'SyncCustomEntityRelationDataPayload';
  result: SyncCustomEntityRelationDataOutput;
}

export interface SyncCustomEntityRelationDataOutput  {
  __typename?: 'SyncCustomEntityRelationDataOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCustomEntityRelationDataItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCustomEntityRelationDataItemOutput  {
  __typename?: 'SyncCustomEntityRelationDataItemOutput';
  changedFields: string[] | null;
  entity: CustomEntityRelationDataEntity;
}

export interface SyncCustomEntityPayload  {
  __typename?: 'SyncCustomEntityPayload';
  result: SyncCustomEntityOutput;
}

export interface SyncCustomEntityOutput  {
  __typename?: 'SyncCustomEntityOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCustomEntityItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCustomEntityItemOutput  {
  __typename?: 'SyncCustomEntityItemOutput';
  changedFields: string[] | null;
  entity: CustomEntityEntity;
}

export interface SyncCustomEntityDataExRelationPayload  {
  __typename?: 'SyncCustomEntityDataExRelationPayload';
  result: SyncCustomEntityDataExRelationOutput;
}

export interface SyncCustomEntityDataExRelationOutput  {
  __typename?: 'SyncCustomEntityDataExRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCustomEntityDataExRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCustomEntityDataExRelationItemOutput  {
  __typename?: 'SyncCustomEntityDataExRelationItemOutput';
  changedFields: string[] | null;
  entity: CustomEntityDataExRelationEntity;
}

export interface SyncCurrencyPayload  {
  __typename?: 'SyncCurrencyPayload';
  result: SyncCurrencyOutput;
}

export interface SyncCurrencyOutput  {
  __typename?: 'SyncCurrencyOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCurrencyItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCurrencyItemOutput  {
  __typename?: 'SyncCurrencyItemOutput';
  changedFields: string[] | null;
  entity: CurrencyEntity;
}

export interface SyncCurrencyExchangeRatesListPayload  {
  __typename?: 'SyncCurrencyExchangeRatesListPayload';
  result: SyncCurrencyExchangeRatesListOutput;
}

export interface SyncCurrencyExchangeRatesListOutput  {
  __typename?: 'SyncCurrencyExchangeRatesListOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCurrencyExchangeRatesListItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCurrencyExchangeRatesListItemOutput  {
  __typename?: 'SyncCurrencyExchangeRatesListItemOutput';
  changedFields: string[] | null;
  entity: CurrencyExchangeRatesListEntity;
}

export interface SyncCurrencyExchangeRatePayload  {
  __typename?: 'SyncCurrencyExchangeRatePayload';
  result: SyncCurrencyExchangeRateOutput;
}

export interface SyncCurrencyExchangeRateOutput  {
  __typename?: 'SyncCurrencyExchangeRateOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCurrencyExchangeRateItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCurrencyExchangeRateItemOutput  {
  __typename?: 'SyncCurrencyExchangeRateItemOutput';
  changedFields: string[] | null;
  entity: CurrencyExchangeRateEntity;
}

export interface SyncContactSocialRelationPayload  {
  __typename?: 'SyncContactSocialRelationPayload';
  result: SyncContactSocialRelationOutput;
}

export interface SyncContactSocialRelationOutput  {
  __typename?: 'SyncContactSocialRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactSocialRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactSocialRelationItemOutput  {
  __typename?: 'SyncContactSocialRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactSocialRelationEntity;
}

export interface SyncContactSharingSalesUnitRelationPayload  {
  __typename?: 'SyncContactSharingSalesUnitRelationPayload';
  result: SyncContactSharingSalesUnitRelationOutput;
}

export interface SyncContactSharingSalesUnitRelationOutput  {
  __typename?: 'SyncContactSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncContactSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactSharingSalesUnitRelationEntity;
}

export interface SyncContactSharingClientRelationPayload  {
  __typename?: 'SyncContactSharingClientRelationPayload';
  result: SyncContactSharingClientRelationOutput;
}

export interface SyncContactSharingClientRelationOutput  {
  __typename?: 'SyncContactSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactSharingClientRelationItemOutput  {
  __typename?: 'SyncContactSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactSharingClientRelationEntity;
}

export interface SyncContactRelationTypePayload  {
  __typename?: 'SyncContactRelationTypePayload';
  result: SyncContactRelationTypeOutput;
}

export interface SyncContactRelationTypeOutput  {
  __typename?: 'SyncContactRelationTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactRelationTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactRelationTypeItemOutput  {
  __typename?: 'SyncContactRelationTypeItemOutput';
  changedFields: string[] | null;
  entity: ContactRelationTypeEntity;
}

export interface SyncContactRelationPayload  {
  __typename?: 'SyncContactRelationPayload';
  result: SyncContactRelationOutput;
}

export interface SyncContactRelationOutput  {
  __typename?: 'SyncContactRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactRelationLabelPayload  {
  __typename?: 'SyncContactRelationLabelPayload';
  result: SyncContactRelationLabelOutput;
}

export interface SyncContactRelationLabelOutput  {
  __typename?: 'SyncContactRelationLabelOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactRelationLabelItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactRelationLabelItemOutput  {
  __typename?: 'SyncContactRelationLabelItemOutput';
  changedFields: string[] | null;
  entity: ContactRelationLabelEntity;
}

export interface SyncContactRelationItemOutput  {
  __typename?: 'SyncContactRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactRelationEntity;
}

export interface SyncContactPayload  {
  __typename?: 'SyncContactPayload';
  result: SyncContactOutput;
}

export interface SyncContactOutput  {
  __typename?: 'SyncContactOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactKPIPayload  {
  __typename?: 'SyncContactKPIPayload';
  result: SyncContactKPIOutput;
}

export interface SyncContactKPIOutput  {
  __typename?: 'SyncContactKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactKPIItemOutput  {
  __typename?: 'SyncContactKPIItemOutput';
  changedFields: string[] | null;
  entity: ContactKPIEntity;
}

export interface SyncContactItemOutput  {
  __typename?: 'SyncContactItemOutput';
  changedFields: string[] | null;
  entity: ContactEntity;
}

export interface SyncContactAccountRelationPayload  {
  __typename?: 'SyncContactAccountRelationPayload';
  result: SyncContactAccountRelationOutput;
}

export interface SyncContactAccountRelationOutput  {
  __typename?: 'SyncContactAccountRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactAccountRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactAccountRelationItemOutput  {
  __typename?: 'SyncContactAccountRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactAccountRelationEntity;
}

export interface SyncContactAccountAccountRoleRelationPayload  {
  __typename?: 'SyncContactAccountAccountRoleRelationPayload';
  result: SyncContactAccountAccountRoleRelationOutput;
}

export interface SyncContactAccountAccountRoleRelationOutput  {
  __typename?: 'SyncContactAccountAccountRoleRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncContactAccountAccountRoleRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncContactAccountAccountRoleRelationItemOutput  {
  __typename?: 'SyncContactAccountAccountRoleRelationItemOutput';
  changedFields: string[] | null;
  entity: ContactAccountAccountRoleRelationEntity;
}

export interface SyncCompanyEmailPayload  {
  __typename?: 'SyncCompanyEmailPayload';
  result: SyncCompanyEmailOutput;
}

export interface SyncCompanyEmailOutput  {
  __typename?: 'SyncCompanyEmailOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCompanyEmailItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCompanyEmailItemOutput  {
  __typename?: 'SyncCompanyEmailItemOutput';
  changedFields: string[] | null;
  entity: CompanyEmailEntity;
}

export interface SyncCloudObjectTemplatePayload  {
  __typename?: 'SyncCloudObjectTemplatePayload';
  result: SyncCloudObjectTemplateOutput;
}

export interface SyncCloudObjectTemplateOutput  {
  __typename?: 'SyncCloudObjectTemplateOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCloudObjectTemplateItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCloudObjectTemplateItemOutput  {
  __typename?: 'SyncCloudObjectTemplateItemOutput';
  changedFields: string[] | null;
  entity: CloudObjectTemplateEntity;
}

export interface SyncCloudObjectStepRelationPayload  {
  __typename?: 'SyncCloudObjectStepRelationPayload';
  result: SyncCloudObjectStepRelationOutput;
}

export interface SyncCloudObjectStepRelationOutput  {
  __typename?: 'SyncCloudObjectStepRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCloudObjectStepRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCloudObjectStepRelationItemOutput  {
  __typename?: 'SyncCloudObjectStepRelationItemOutput';
  changedFields: string[] | null;
  entity: CloudObjectStepRelationEntity;
}

export interface SyncCloudObjectRelationPayload  {
  __typename?: 'SyncCloudObjectRelationPayload';
  result: SyncCloudObjectRelationOutput;
}

export interface SyncCloudObjectRelationOutput  {
  __typename?: 'SyncCloudObjectRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCloudObjectRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCloudObjectRelationItemOutput  {
  __typename?: 'SyncCloudObjectRelationItemOutput';
  changedFields: string[] | null;
  entity: CloudObjectRelationEntity;
}

export interface SyncCloudObjectPayload  {
  __typename?: 'SyncCloudObjectPayload';
  result: SyncCloudObjectOutput;
}

export interface SyncCloudObjectOutput  {
  __typename?: 'SyncCloudObjectOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCloudObjectItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCloudObjectItemOutput  {
  __typename?: 'SyncCloudObjectItemOutput';
  changedFields: string[] | null;
  entity: CloudObjectEntity;
}

export interface SyncCloudObjectFolderPayload  {
  __typename?: 'SyncCloudObjectFolderPayload';
  result: SyncCloudObjectFolderOutput;
}

export interface SyncCloudObjectFolderOutput  {
  __typename?: 'SyncCloudObjectFolderOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCloudObjectFolderItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCloudObjectFolderItemOutput  {
  __typename?: 'SyncCloudObjectFolderItemOutput';
  changedFields: string[] | null;
  entity: CloudObjectFolderEntity;
}

export interface SyncClientWithUserTablePayload  {
  __typename?: 'SyncClientWithUserTablePayload';
  clientMutationId: string | null;
  result: ClientEntity | null;
}

export interface SyncClientStoryReadPayload  {
  __typename?: 'SyncClientStoryReadPayload';
  result: SyncClientStoryReadOutput;
}

export interface SyncClientStoryReadOutput  {
  __typename?: 'SyncClientStoryReadOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncClientStoryReadItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncClientStoryReadItemOutput  {
  __typename?: 'SyncClientStoryReadItemOutput';
  changedFields: string[] | null;
  entity: ClientStoryReadEntity;
}

export interface SyncClientSettingPayload  {
  __typename?: 'SyncClientSettingPayload';
  result: SyncClientSettingOutput;
}

export interface SyncClientSettingOutput  {
  __typename?: 'SyncClientSettingOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncClientSettingItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncClientSettingItemOutput  {
  __typename?: 'SyncClientSettingItemOutput';
  changedFields: string[] | null;
  entity: ClientSettingEntity;
}

export interface SyncClientPayload  {
  __typename?: 'SyncClientPayload';
  result: SyncClientOutput;
}

export interface SyncClientOutput  {
  __typename?: 'SyncClientOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncClientItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncClientItemOutput  {
  __typename?: 'SyncClientItemOutput';
  changedFields: string[] | null;
  entity: ClientEntity;
}

export interface SyncClientFavoritePayload  {
  __typename?: 'SyncClientFavoritePayload';
  result: SyncClientFavoriteOutput;
}

export interface SyncClientFavoriteOutput  {
  __typename?: 'SyncClientFavoriteOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncClientFavoriteItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncClientFavoriteItemOutput  {
  __typename?: 'SyncClientFavoriteItemOutput';
  changedFields: string[] | null;
  entity: ClientFavoriteEntity;
}

export interface SyncClientExcludedOpptyPayload  {
  __typename?: 'SyncClientExcludedOpptyPayload';
  result: SyncClientExcludedOpptyOutput;
}

export interface SyncClientExcludedOpptyOutput  {
  __typename?: 'SyncClientExcludedOpptyOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncClientExcludedOpptyItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncClientExcludedOpptyItemOutput  {
  __typename?: 'SyncClientExcludedOpptyItemOutput';
  changedFields: string[] | null;
  entity: ClientExcludedOpptyEntity;
}

export interface SyncChatConversationPayload  {
  __typename?: 'SyncChatConversationPayload';
  result: SyncChatConversationOutput;
}

export interface SyncChatConversationOutput  {
  __typename?: 'SyncChatConversationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncChatConversationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncChatConversationItemOutput  {
  __typename?: 'SyncChatConversationItemOutput';
  changedFields: string[] | null;
  entity: ChatConversationEntity;
}

export interface SyncCallPayload  {
  __typename?: 'SyncCallPayload';
  result: SyncCallOutput;
}

export interface SyncCallOutput  {
  __typename?: 'SyncCallOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncCallItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncCallItemOutput  {
  __typename?: 'SyncCallItemOutput';
  changedFields: string[] | null;
  entity: CallEntity;
}

export interface SyncAutomationHubItemPayload  {
  __typename?: 'SyncAutomationHubItemPayload';
  result: SyncAutomationHubItemOutput;
}

export interface SyncAutomationHubItemOutput  {
  __typename?: 'SyncAutomationHubItemOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAutomationHubItemItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAutomationHubItemItemOutput  {
  __typename?: 'SyncAutomationHubItemItemOutput';
  changedFields: string[] | null;
  entity: AutomationHubItemEntity;
}

export interface SyncApprovalProcessPayload  {
  __typename?: 'SyncApprovalProcessPayload';
  result: SyncApprovalProcessOutput;
}

export interface SyncApprovalProcessOutput  {
  __typename?: 'SyncApprovalProcessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncApprovalProcessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncApprovalProcessItemOutput  {
  __typename?: 'SyncApprovalProcessItemOutput';
  changedFields: string[] | null;
  entity: ApprovalProcessEntity;
}

export interface SyncApprovalProcessActivityLogLinePayload  {
  __typename?: 'SyncApprovalProcessActivityLogLinePayload';
  result: SyncApprovalProcessActivityLogLineOutput;
}

export interface SyncApprovalProcessActivityLogLineOutput  {
  __typename?: 'SyncApprovalProcessActivityLogLineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncApprovalProcessActivityLogLineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncApprovalProcessActivityLogLineItemOutput  {
  __typename?: 'SyncApprovalProcessActivityLogLineItemOutput';
  changedFields: string[] | null;
  entity: ApprovalProcessActivityLogLineEntity;
}

export interface SyncApprovalPayload  {
  __typename?: 'SyncApprovalPayload';
  result: SyncApprovalOutput;
}

export interface SyncApprovalOutput  {
  __typename?: 'SyncApprovalOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncApprovalItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncApprovalItemOutput  {
  __typename?: 'SyncApprovalItemOutput';
  changedFields: string[] | null;
  entity: ApprovalEntity;
}

export interface SyncApprovalApproverPayload  {
  __typename?: 'SyncApprovalApproverPayload';
  result: SyncApprovalApproverOutput;
}

export interface SyncApprovalApproverOutput  {
  __typename?: 'SyncApprovalApproverOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncApprovalApproverItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncApprovalApproverItemOutput  {
  __typename?: 'SyncApprovalApproverItemOutput';
  changedFields: string[] | null;
  entity: ApprovalApproverEntity;
}

export interface SyncAppointmentSchedulePayload  {
  __typename?: 'SyncAppointmentSchedulePayload';
  result: SyncAppointmentScheduleOutput;
}

export interface SyncAppointmentScheduleOutput  {
  __typename?: 'SyncAppointmentScheduleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAppointmentScheduleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAppointmentScheduleItemOutput  {
  __typename?: 'SyncAppointmentScheduleItemOutput';
  changedFields: string[] | null;
  entity: AppointmentScheduleEntity;
}

export interface SyncAppointmentReminderPayload  {
  __typename?: 'SyncAppointmentReminderPayload';
  result: SyncAppointmentReminderOutput;
}

export interface SyncAppointmentReminderOutput  {
  __typename?: 'SyncAppointmentReminderOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAppointmentReminderItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAppointmentReminderItemOutput  {
  __typename?: 'SyncAppointmentReminderItemOutput';
  changedFields: string[] | null;
  entity: AppointmentReminderEntity;
}

export interface SyncAppointmentPayload  {
  __typename?: 'SyncAppointmentPayload';
  result: SyncAppointmentOutput;
}

export interface SyncAppointmentOutput  {
  __typename?: 'SyncAppointmentOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAppointmentItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAppointmentItemOutput  {
  __typename?: 'SyncAppointmentItemOutput';
  changedFields: string[] | null;
  entity: AppointmentEntity;
}

export interface SyncAppointmentContactInviteesRelationPayload  {
  __typename?: 'SyncAppointmentContactInviteesRelationPayload';
  result: SyncAppointmentContactInviteesRelationOutput;
}

export interface SyncAppointmentContactInviteesRelationOutput  {
  __typename?: 'SyncAppointmentContactInviteesRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAppointmentContactInviteesRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAppointmentContactInviteesRelationItemOutput  {
  __typename?: 'SyncAppointmentContactInviteesRelationItemOutput';
  changedFields: string[] | null;
  entity: AppointmentContactInviteesRelationEntity;
}

export interface SyncAppointmentClientInviteesRelationPayload  {
  __typename?: 'SyncAppointmentClientInviteesRelationPayload';
  result: SyncAppointmentClientInviteesRelationOutput;
}

export interface SyncAppointmentClientInviteesRelationOutput  {
  __typename?: 'SyncAppointmentClientInviteesRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAppointmentClientInviteesRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAppointmentClientInviteesRelationItemOutput  {
  __typename?: 'SyncAppointmentClientInviteesRelationItemOutput';
  changedFields: string[] | null;
  entity: AppointmentClientInviteesRelationEntity;
}

export interface SyncApiAccessPayload  {
  __typename?: 'SyncApiAccessPayload';
  result: SyncApiAccessOutput;
}

export interface SyncApiAccessOutput  {
  __typename?: 'SyncApiAccessOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncApiAccessItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncApiAccessItemOutput  {
  __typename?: 'SyncApiAccessItemOutput';
  changedFields: string[] | null;
  entity: ApiAccessEntity;
}

export interface SyncAllowedQuoteTypePayload  {
  __typename?: 'SyncAllowedQuoteTypePayload';
  result: SyncAllowedQuoteTypeOutput;
}

export interface SyncAllowedQuoteTypeOutput  {
  __typename?: 'SyncAllowedQuoteTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedQuoteTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedQuoteTypeItemOutput  {
  __typename?: 'SyncAllowedQuoteTypeItemOutput';
  changedFields: string[] | null;
  entity: AllowedQuoteTypeEntity;
}

export interface SyncAllowedPipelinePayload  {
  __typename?: 'SyncAllowedPipelinePayload';
  result: SyncAllowedPipelineOutput;
}

export interface SyncAllowedPipelineOutput  {
  __typename?: 'SyncAllowedPipelineOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedPipelineItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedPipelineItemOutput  {
  __typename?: 'SyncAllowedPipelineItemOutput';
  changedFields: string[] | null;
  entity: AllowedPipelineEntity;
}

export interface SyncAllowedLeadTypePayload  {
  __typename?: 'SyncAllowedLeadTypePayload';
  result: SyncAllowedLeadTypeOutput;
}

export interface SyncAllowedLeadTypeOutput  {
  __typename?: 'SyncAllowedLeadTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedLeadTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedLeadTypeItemOutput  {
  __typename?: 'SyncAllowedLeadTypeItemOutput';
  changedFields: string[] | null;
  entity: AllowedLeadTypeEntity;
}

export interface SyncAllowedContactTypePayload  {
  __typename?: 'SyncAllowedContactTypePayload';
  result: SyncAllowedContactTypeOutput;
}

export interface SyncAllowedContactTypeOutput  {
  __typename?: 'SyncAllowedContactTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedContactTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedContactTypeItemOutput  {
  __typename?: 'SyncAllowedContactTypeItemOutput';
  changedFields: string[] | null;
  entity: AllowedContactTypeEntity;
}

export interface SyncAllowedCompanyPhonePayload  {
  __typename?: 'SyncAllowedCompanyPhonePayload';
  result: SyncAllowedCompanyPhoneOutput;
}

export interface SyncAllowedCompanyPhoneOutput  {
  __typename?: 'SyncAllowedCompanyPhoneOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedCompanyPhoneItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedCompanyPhoneItemOutput  {
  __typename?: 'SyncAllowedCompanyPhoneItemOutput';
  changedFields: string[] | null;
  entity: AllowedCompanyPhoneEntity;
}

export interface SyncAllowedCompanyEmailPayload  {
  __typename?: 'SyncAllowedCompanyEmailPayload';
  result: SyncAllowedCompanyEmailOutput;
}

export interface SyncAllowedCompanyEmailOutput  {
  __typename?: 'SyncAllowedCompanyEmailOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedCompanyEmailItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedCompanyEmailItemOutput  {
  __typename?: 'SyncAllowedCompanyEmailItemOutput';
  changedFields: string[] | null;
  entity: AllowedCompanyEmailEntity;
}

export interface SyncAllowedAccountTypePayload  {
  __typename?: 'SyncAllowedAccountTypePayload';
  result: SyncAllowedAccountTypeOutput;
}

export interface SyncAllowedAccountTypeOutput  {
  __typename?: 'SyncAllowedAccountTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAllowedAccountTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAllowedAccountTypeItemOutput  {
  __typename?: 'SyncAllowedAccountTypeItemOutput';
  changedFields: string[] | null;
  entity: AllowedAccountTypeEntity;
}

export interface SyncActivityRelationPayload  {
  __typename?: 'SyncActivityRelationPayload';
  result: SyncActivityRelationOutput;
}

export interface SyncActivityRelationOutput  {
  __typename?: 'SyncActivityRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncActivityRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncActivityRelationItemOutput  {
  __typename?: 'SyncActivityRelationItemOutput';
  changedFields: string[] | null;
  entity: ActivityRelationEntity;
}

export interface SyncActivityKPIPayload  {
  __typename?: 'SyncActivityKPIPayload';
  result: SyncActivityKPIOutput;
}

export interface SyncActivityKPIOutput  {
  __typename?: 'SyncActivityKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncActivityKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncActivityKPIItemOutput  {
  __typename?: 'SyncActivityKPIItemOutput';
  changedFields: string[] | null;
  entity: ActivityKPIEntity;
}

export interface SyncActivityCommentPayload  {
  __typename?: 'SyncActivityCommentPayload';
  result: SyncActivityCommentOutput;
}

export interface SyncActivityCommentOutput  {
  __typename?: 'SyncActivityCommentOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncActivityCommentItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncActivityCommentItemOutput  {
  __typename?: 'SyncActivityCommentItemOutput';
  changedFields: string[] | null;
  entity: ActivityCommentEntity;
}

export interface SyncAccountSocialRelationPayload  {
  __typename?: 'SyncAccountSocialRelationPayload';
  result: SyncAccountSocialRelationOutput;
}

export interface SyncAccountSocialRelationOutput  {
  __typename?: 'SyncAccountSocialRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountSocialRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountSocialRelationItemOutput  {
  __typename?: 'SyncAccountSocialRelationItemOutput';
  changedFields: string[] | null;
  entity: AccountSocialRelationEntity;
}

export interface SyncAccountSharingSalesUnitRelationPayload  {
  __typename?: 'SyncAccountSharingSalesUnitRelationPayload';
  result: SyncAccountSharingSalesUnitRelationOutput;
}

export interface SyncAccountSharingSalesUnitRelationOutput  {
  __typename?: 'SyncAccountSharingSalesUnitRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountSharingSalesUnitRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountSharingSalesUnitRelationItemOutput  {
  __typename?: 'SyncAccountSharingSalesUnitRelationItemOutput';
  changedFields: string[] | null;
  entity: AccountSharingSalesUnitRelationEntity;
}

export interface SyncAccountSharingClientRelationPayload  {
  __typename?: 'SyncAccountSharingClientRelationPayload';
  result: SyncAccountSharingClientRelationOutput;
}

export interface SyncAccountSharingClientRelationOutput  {
  __typename?: 'SyncAccountSharingClientRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountSharingClientRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountSharingClientRelationItemOutput  {
  __typename?: 'SyncAccountSharingClientRelationItemOutput';
  changedFields: string[] | null;
  entity: AccountSharingClientRelationEntity;
}

export interface SyncAccountRolePayload  {
  __typename?: 'SyncAccountRolePayload';
  result: SyncAccountRoleOutput;
}

export interface SyncAccountRoleOutput  {
  __typename?: 'SyncAccountRoleOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountRoleItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountRoleItemOutput  {
  __typename?: 'SyncAccountRoleItemOutput';
  changedFields: string[] | null;
  entity: AccountRoleEntity;
}

export interface SyncAccountRelationTypePayload  {
  __typename?: 'SyncAccountRelationTypePayload';
  result: SyncAccountRelationTypeOutput;
}

export interface SyncAccountRelationTypeOutput  {
  __typename?: 'SyncAccountRelationTypeOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountRelationTypeItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountRelationTypeItemOutput  {
  __typename?: 'SyncAccountRelationTypeItemOutput';
  changedFields: string[] | null;
  entity: AccountRelationTypeEntity;
}

export interface SyncAccountRelationPayload  {
  __typename?: 'SyncAccountRelationPayload';
  result: SyncAccountRelationOutput;
}

export interface SyncAccountRelationOutput  {
  __typename?: 'SyncAccountRelationOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountRelationItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountRelationLabelPayload  {
  __typename?: 'SyncAccountRelationLabelPayload';
  result: SyncAccountRelationLabelOutput;
}

export interface SyncAccountRelationLabelOutput  {
  __typename?: 'SyncAccountRelationLabelOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountRelationLabelItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountRelationLabelItemOutput  {
  __typename?: 'SyncAccountRelationLabelItemOutput';
  changedFields: string[] | null;
  entity: AccountRelationLabelEntity;
}

export interface SyncAccountRelationItemOutput  {
  __typename?: 'SyncAccountRelationItemOutput';
  changedFields: string[] | null;
  entity: AccountRelationEntity;
}

export interface SyncAccountProductPricingPayload  {
  __typename?: 'SyncAccountProductPricingPayload';
  result: SyncAccountProductPricingOutput;
}

export interface SyncAccountProductPricingOutput  {
  __typename?: 'SyncAccountProductPricingOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountProductPricingItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountProductPricingItemOutput  {
  __typename?: 'SyncAccountProductPricingItemOutput';
  changedFields: string[] | null;
  entity: AccountProductPricingEntity;
}

export interface SyncAccountPayload  {
  __typename?: 'SyncAccountPayload';
  result: SyncAccountOutput;
}

export interface SyncAccountOutput  {
  __typename?: 'SyncAccountOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountKPIPayload  {
  __typename?: 'SyncAccountKPIPayload';
  result: SyncAccountKPIOutput;
}

export interface SyncAccountKPIOutput  {
  __typename?: 'SyncAccountKPIOutput';
  errors: BulkErrorResult[] | null;
  finished: boolean;
  items: SyncAccountKPIItemOutput[] | null;
  newSyncToken: string;
}

export interface SyncAccountKPIItemOutput  {
  __typename?: 'SyncAccountKPIItemOutput';
  changedFields: string[] | null;
  entity: AccountKPIEntity;
}

export interface SyncAccountItemOutput  {
  __typename?: 'SyncAccountItemOutput';
  changedFields: string[] | null;
  entity: AccountEntity;
}

export interface SwitchProfileFavoriteStatusPayload  {
  __typename?: 'SwitchProfileFavoriteStatusPayload';
  clientMutationId: string | null;
}

export interface SuspendOnlineFormsPayload  {
  __typename?: 'SuspendOnlineFormsPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface SuspendAutomatizerPayload  {
  __typename?: 'SuspendAutomatizerPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface SupportUser  {
  __typename?: 'SupportUser';
  email: string;
  invited: boolean;
  name: string;
  pictureUrl: string | null;
}

export interface SupplierEntity  {
  __typename?: 'SupplierEntity';
  id: ID | null;
  imprint: Imprint | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReadOnlyPermsEnum[];
  name: string | null;
}

export interface SummaryField extends ReportValueFieldInterface {
  __typename?: 'SummaryField';
  id: UUID;
  name: string;
  rollup: RollupProperty;
}

export interface SubscriptionRepresentativeEntity  {
  __typename?: 'SubscriptionRepresentativeEntity';
  email: string | null;
  firstName: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReadOnlyPermsEnum[];
  isDeleted: boolean | null;
  isValid: boolean | null;
  lastName: string | null;
  middleName: string | null;
  name: string | null;
}

export interface SubscriptionEntity  {
  __typename?: 'SubscriptionEntity';
  agreedToGtac: boolean | null;
  aiFreeMonthlyCredits: number | null;
  aiOverageLimit: number | null;
  anniversaryDate: GqlDate | null;
  awsAccountId: string | null;
  awsCustomerId: string | null;
  billingCountryName: string | null;
  billingDetail: BillingDetail | null;
  calling: CpCallingEntity | null;
  classification: SubscriptionClassification | null;
  classificationId: number | null;
  contactEmail: string | null;
  created: DateTime | null;
  crmAccount: CrmAccountEntity | null;
  crmAccountId: string | null;
  crmSpaceId: string | null;
  customPrice: number | null;
  discount: number | null;
  enabledLoginTypes: LoginType[] | null;
  endDate: DateTime | null;
  expiredDate: GqlDate | null;
  focus: SubscriptionCompanyFocus | null;
  fromCampaign: string | null;
  id: ID | null;
  idps: IdentityProviderEntity[] | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: SubscriptionPermsEnum[];
  lastVatCheckDate: DateTime | null;
  licensesPurchased: number | null;
  licensesUsed: number | null;
  manualInstructions: string | null;
  manualOrderDunning: boolean | null;
  manuallyHandled: boolean | null;
  modules: Module[] | null;
  mostDuePaymentDate: GqlDate | null;
  name: string | null;
  nextOrderCreationDate: GqlDate | null;
  noOfSalesPeople: NumberOfSalesPeople | null;
  numberOfSalesPeople: NumberOfSalesPeople | null;
  orders: OrderEntity[] | null;
  originalUnitPrice: number | null;
  partnerCommissionAmountEur: string | null;
  partnerCommissionAmountGbp: string | null;
  partnerCommissionAmountUsd: string | null;
  partnerLtvAmountEur: string | null;
  partnerLtvAmountGbp: string | null;
  partnerLtvAmountUsd: string | null;
  partnerName: string | null;
  paymentTermsId: ID | null;
  primaryContactEmail: string | null;
  productTier: number | null;
  rabat: number | null;
  referralPartner: PartnerEntity | null;
  referralPartnerId: ID | null;
  referralPartnerRepresentative: UserProfileEntity | null;
  referralPartnerRepresentativeId: ID | null;
  region: RegionEntity | null;
  renewal: NotificationRenewal[] | null;
  renewalEstimate: Invoice | null;
  representative: SubscriptionRepresentativeEntity | null;
  representativeEmail: string | null;
  representativeId: ID | null;
  representativeName: string | null;
  required2faTypes: TwoFAType[] | null;
  requiredIdpId: number | null;
  sdr: SubscriptionRepresentativeEntity | null;
  sdrEmail: string | null;
  sdrId: ID | null;
  sdrName: string | null;
  sessionPolicy: SessionPolicy | null;
  spaces: TeamSpaceEntity[] | null;
  startDate: DateTime | null;
  status: SubscriptionStatus | null;
  subscriptionAdmins: UserProfileEntity[] | null;
  supplier: SupplierEntity | null;
  supplierId: ID | null;
  tier: SubscriptionProductTier | null;
  unitPrice: number | null;
  vatCheckResult: VatCheckResultEnum | null;
  vatCode: string | null;
}

export interface StringInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'StringInterfaceFieldData';
  fieldId: UUID;
  stringValue: string | null;
}

export interface StorylaneRepository  {
  __typename?: 'StorylaneRepository';
  getAll: StorylaneEntity[];
  getByCriteria: StorylaneEntityConnection | null;
  getById: StorylaneEntity | null;
  getByIds: StorylaneEntity[];
}

export interface StorylaneEntityEdge  {
  __typename?: 'StorylaneEntityEdge';
  cursor: string;
  node: StorylaneEntity | null;
}

export interface StorylaneEntityConnection  {
  __typename?: 'StorylaneEntityConnection';
  edges: StorylaneEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface StorylaneEntity  {
  __typename?: 'StorylaneEntity';
  actionUrl: string | null;
  category: string | null;
  exploreAll: boolean | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: StorylanePermsEnum[];
  minApiVersion: number | null;
  pictureUrl: string | null;
  sortOrder: number | null;
  title: string | null;
  uniqueViewCount: number | null;
  viewCount: number | null;
}

export interface StopSingleProcessScheduledActionPayload  {
  __typename?: 'StopSingleProcessScheduledActionPayload';
  clientMutationId: string | null;
  result: ProcessActivityLogLineEntity | null;
}

export interface StopProcessScheduledActionsPayload  {
  __typename?: 'StopProcessScheduledActionsPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface StopManualTriggerProcessPayload  {
  __typename?: 'StopManualTriggerProcessPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface StopEnrollmentEmailSequencePayload  {
  __typename?: 'StopEnrollmentEmailSequencePayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface StepSummaryInfo  {
  __typename?: 'StepSummaryInfo';
  itemCount: number;
  readyToMoveCount: number;
  readyToMoveIds: ID[];
  stepId: ID | null;
  stepValue: number;
  velocityOverdueCount: number;
  velocityOverdueIds: ID[];
}

export interface StepRepository  {
  __typename?: 'StepRepository';
  getAll: StepEntity[];
  getByCriteria: StepEntityConnection | null;
  getById: StepEntity | null;
  getByIds: StepEntity[];
  getByLeadProcess: StepEntity[];
  getByPipeline: StepEntity[];
  getByQuoteProcess: StepEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface StepFieldsContainer extends FormItemInterface {
  __typename?: 'StepFieldsContainer';
  id: UUID;
  kind: FormItemKindEnum;
  label: string;
  onMobile: boolean | null;
  steps: Step[] | null;
  useLang: boolean | null;
}

export interface StepExtractView  {
  __typename?: 'StepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  dropOffRateCount: number;
  dropOffRateSession: UUID | null;
  dropOffRateTotalCount: number;
  dropOffRateTotalSession: UUID | null;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
  velocityOverdueCount: number;
  velocityOverdueSession: UUID | null;
}

export interface StepEntityEdge  {
  __typename?: 'StepEntityEdge';
  cursor: string;
  node: StepEntity | null;
}

export interface StepEntityConnection  {
  __typename?: 'StepEntityConnection';
  edges: StepEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface StepEntity  {
  __typename?: 'StepEntity';
  created: DateTime | null;
  description: string | null;
  documents: CloudObjectStepRelationEntityConnection | null;
  hasReadonlyForm: boolean | null;
  hasVersionIncrement: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadProcess: LeadProcessEntity | null;
  leadProcessId: ID | null;
  modified: DateTime | null;
  name: string;
  percent: number | null;
  pipeline: PipelineEntity | null;
  pipelineId: ID | null;
  quoteProcess: QuoteProcessEntity | null;
  quoteProcessId: ID | null;
  revision: number | null;
  sortOrder: number | null;
  stepChecklists: StepChecklistEntityConnection | null;
  timeframe: number | null;
}

export interface StepChecklistVisibilityFilter  {
  __typename?: 'StepChecklistVisibilityFilter';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  operator: FilterGroupOperator;
}

export interface StepChecklistSalesRoleRelationRepository  {
  __typename?: 'StepChecklistSalesRoleRelationRepository';
  getAll: StepChecklistSalesRoleRelationEntity[];
  getByCriteria: StepChecklistSalesRoleRelationEntityConnection | null;
  getById: StepChecklistSalesRoleRelationEntity | null;
  getByIds: StepChecklistSalesRoleRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface StepChecklistSalesRoleRelationEntityEdge  {
  __typename?: 'StepChecklistSalesRoleRelationEntityEdge';
  cursor: string;
  node: StepChecklistSalesRoleRelationEntity | null;
}

export interface StepChecklistSalesRoleRelationEntityConnection  {
  __typename?: 'StepChecklistSalesRoleRelationEntityConnection';
  edges: StepChecklistSalesRoleRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface StepChecklistSalesRoleRelationEntity  {
  __typename?: 'StepChecklistSalesRoleRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  salesRole: SalesRoleEntity | null;
  salesRoleId: ID;
  stepChecklist: StepChecklistEntity | null;
  stepChecklistId: ID;
}

export interface StepChecklistRepository  {
  __typename?: 'StepChecklistRepository';
  getAll: StepChecklistEntity[];
  getByCriteria: StepChecklistEntityConnection | null;
  getById: StepChecklistEntity | null;
  getByIds: StepChecklistEntity[];
  getByStep: StepChecklistEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface StepChecklistError extends ApiErrorBase {
  __typename?: 'StepChecklistError';
  code: number;
  message: string | null;
  name: string;
  stepChecklistId: UUID;
}

export interface StepChecklistEntityEdge  {
  __typename?: 'StepChecklistEntityEdge';
  cursor: string;
  node: StepChecklistEntity | null;
}

export interface StepChecklistEntityConnection  {
  __typename?: 'StepChecklistEntityConnection';
  edges: StepChecklistEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface StepChecklistEntity  {
  __typename?: 'StepChecklistEntity';
  activityTypeId: ID | null;
  appointmentType: AppointmentTypeEntity | null;
  cloudObjectFormat: StepChecklistDocumentFormatEnum | null;
  cloudObjectTemplate: CloudObjectTemplateEntity | null;
  cloudObjectTemplateId: ID | null;
  created: DateTime | null;
  description: string | null;
  emailSequence: EmailSequenceEntity | null;
  emailSequenceId: ID | null;
  field: FieldEntity | null;
  fieldId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  itemType: StepChecklistTypeEnum | null;
  itemValidation: StepChecklistValidationEnum | null;
  label: string | null;
  labelUseLang: boolean | null;
  modified: DateTime | null;
  process: ProcessEntity | null;
  processId: ID | null;
  revision: number | null;
  salesRoles: StepChecklistSalesRoleRelationEntityConnection | null;
  sendEmailField: FieldEntity | null;
  sendEmailFieldId: ID | null;
  sendEmailTemplate: EmailTemplateEntity | null;
  sendEmailTemplateId: ID | null;
  sortOrder: number;
  step: StepEntity | null;
  stepId: ID;
  taskType: TaskTypeEntity | null;
  visibilityCondition: StepChecklistVisibilityFilter;
  visibilityType: StepChecklistVisibilityEnum | null;
}

export interface StepChecklistActivityItem  {
  __typename?: 'StepChecklistActivityItem';
  activityId: ID | null;
  cloudObjectId: ID | null;
  emailId: ID | null;
  isComplete: boolean;
  itemChecked: boolean;
  noteId: ID | null;
  stepChecklistId: ID;
  stepChecklistRelationId: ID | null;
}

export interface Step  {
  __typename?: 'Step';
  containers: FormContainer[] | null;
  id: string;
}

export interface StatusInProcessOutput  {
  __typename?: 'StatusInProcessOutput';
  body: string | null;
  documents: CloudObjectEntity[] | null;
  id: UUID;
  name: string;
  status: TemplateStatusInProcess;
  subject: string | null;
  type: EmailTemplateTypeEnum;
}

export interface StaticProfileEntityDrilldownModel  {
  __typename?: 'StaticProfileEntityDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface SqlExportnHubItemConfig  {
  __typename?: 'SqlExportnHubItemConfig';
  isConfigured: boolean;
}

export interface SqlExportTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'SqlExportTeamPipelineHubItemEntity';
  configuration: SqlExportnHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface SqlExportSetup  {
  __typename?: 'SqlExportSetup';
  exportServerInfo: SqlExportServerInfo | null;
  getConfig: SqlExportConfigResult | null;
  runCheck: SqlExportRunNowInfo | null;
}

export interface SqlExportServerInfo  {
  __typename?: 'SqlExportServerInfo';
  serverUrl: string;
  userName: string;
}

export interface SqlExportRunPayload  {
  __typename?: 'SqlExportRunPayload';
  clientMutationId: string | null;
  error: boolean;
  info: string;
  isRunning: boolean;
  lastRunFinished: DateTime | null;
}

export interface SqlExportRunNowInfo  {
  __typename?: 'SqlExportRunNowInfo';
  error: boolean;
  info: string;
  isRunning: boolean;
  lastRunFinished: DateTime | null;
}

export interface SqlExportResetPasswordPayload  {
  __typename?: 'SqlExportResetPasswordPayload';
  clientMutationId: string | null;
  newPassword: string | null;
}

export interface SqlExportConfigResult  {
  __typename?: 'SqlExportConfigResult';
  config: SqlExportConfigEntity[];
}

export interface SqlExportConfigPayload  {
  __typename?: 'SqlExportConfigPayload';
  clientMutationId: string | null;
}

export interface SqlExportConfigField  {
  __typename?: 'SqlExportConfigField';
  cannotRemove: boolean;
  chosen: boolean;
  columnName: string;
  fieldId: string;
  fieldName: string;
  translateFieldName: boolean;
}

export interface SqlExportConfigEntity  {
  __typename?: 'SqlExportConfigEntity';
  chosen: boolean;
  entityName: string;
  fields: SqlExportConfigField[];
  isRelation: boolean;
  relationActiveWhenEntities: string[];
  tableName: string;
}

export interface SpeechToTextService  {
  __typename?: 'SpeechToTextService';
  debugStopTranscriptions: boolean;
  getCredentials: SpeechToTextCredentials;
}

export interface SpeechToTextCredentials  {
  __typename?: 'SpeechToTextCredentials';
  accessKeyId: string;
  expiration: DateTime;
  region: string;
  secretAccessKey: string;
  sessionToken: string;
}

export interface SpawnUnprocessedRunsMutationPayload  {
  __typename?: 'SpawnUnprocessedRunsMutationPayload';
  clientMutationId: string | null;
  spawned: number;
}

export interface SpaceSettings  {
  __typename?: 'SpaceSettings';
  attachmentFileExtensions: AttachmentFileExtension;
  attachmentMaxSize: number;
  chunkSizeExchange: number;
  cloudEnabled: boolean;
  dynamicFinancialYear: FinancialDateStart;
  emailAttachmentEnabled: boolean;
  emailAttachmentMaxSize: number;
  emailDomainBlacklisting: string[] | null;
  fileAttachmentUploadEnabled: boolean | null;
  firstDayOfWeek: DayName;
  intercomIntegration: boolean | null;
  sharepointIntegration: string | null;
  theme: AppThemeEnum;
  timezone: string;
}

export interface SortField extends ReportField {
  __typename?: 'SortField';
  boxId: ID;
  direction: SortOrder;
  fieldId: ID;
}

export interface SocialRelationData  {
  __typename?: 'SocialRelationData';
  angellistUrl: string | null;
  crunchbaseUrl: string | null;
  disqusUrl: string | null;
  facebookId: string | null;
  facebookUrl: string | null;
  flickrUrl: string | null;
  foursquareUrl: string | null;
  googleId: string | null;
  googlePlusUrl: string | null;
  gravatarUrl: string | null;
  kloutUrl: string | null;
  linkedinId: string | null;
  linkedinUrl: string | null;
  pinterestUrl: string | null;
  quoraUrl: string | null;
  redditUrl: string | null;
  skypeUrl: string | null;
  slideshareUrl: string | null;
  twitterId: string | null;
  twitterUrl: string | null;
  vimeoUrl: string | null;
  wordpressUrl: string | null;
  xingUrl: string | null;
  yahooUrl: string | null;
  yelpUrl: string | null;
  youtubeUrl: string | null;
}

export interface SocialNetworksInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'SocialNetworksInterfaceFieldData';
  fieldId: UUID;
  relations: SocialRelationData | null;
}

export interface SnapshotColumnAggr  {
  __typename?: 'SnapshotColumnAggr';
  sum: number;
}

export interface SmartFieldRelation  {
  __typename?: 'SmartFieldRelation';
  entityApiName: string | null;
  id: ID;
  isDeleted: boolean;
  mainEntity: EntityNameEnum;
  name: string;
  parentEntity: EntityNameEnum | null;
  type: string;
  useLang: boolean;
}

export interface SingleTemplateResult  {
  __typename?: 'SingleTemplateResult';
  fieldErrors: FieldFillError[];
  resultPdfUrl: string;
  resultUrl: string;
}

export interface SimulatedTargetListingOptions  {
  __typename?: 'SimulatedTargetListingOptions';
  filterByOwnerId: UUID[] | null;
  filterByPeriod: PeriodOption;
  filterByTargetCalculationType: TargetCalculationTypeEnum | null;
}

export interface SimulatedTargetIndicators  {
  __typename?: 'SimulatedTargetIndicators';
  leadClosedCount: number | null;
  leadCreatedCount: number | null;
  leadQualifiedCount: number | null;
  opportunityAverageVelocity: number | null;
  opportunityClosedCount: number | null;
  opportunityWonAmount: number | null;
  opportunityWonCount: number | null;
  target: number;
}

export interface SimilarAccountsOutputParams  {
  __typename?: 'SimilarAccountsOutputParams';
  byFields: boolean;
  fieldIds: UUID[];
}

export interface SignedUrl  {
  __typename?: 'SignedUrl';
  signedUrl: string;
  url: string;
}

export interface Sharepoint  {
  __typename?: 'Sharepoint';
  getAuthUrl: AuthUrlResult | null;
  getLogoutUrl: AuthUrlResult | null;
  getToken: TokenResult | null;
  listFolder: RemoteStorageFileListResultConnection | null;
  refreshToken: TokenResult | null;
}

export interface ShareModeInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ShareModeInterfaceFieldData';
  fieldId: UUID;
  shareMode: ShareModeEnum;
}

export interface ShareActorInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ShareActorInterfaceFieldData';
  fieldId: UUID;
  shareActor: ShareActorEnum;
}

export interface Settings  {
  __typename?: 'Settings';
  emailNotificationsDefault: boolean;
  entityCustomNames: EntityCustomNameSetting[];
  featurePromotionsDisabled: boolean;
  releaseNotesDisabled: boolean;
  revenueSchedule: RevenueScheduleSetting;
  workingDays: DayName[];
}

export interface SetTaskTypeDraftFormEdit  {
  __typename?: 'SetTaskTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetTaskStatusPayload  {
  __typename?: 'SetTaskStatusPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface SetTaskMappingsClientPayload  {
  __typename?: 'SetTaskMappingsClientPayload';
  result: EntityMapping[];
}

export interface SetSettingsGenericTeamSpaceClientSettingPayload  {
  __typename?: 'SetSettingsGenericTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface SetScheduleReportPayload  {
  __typename?: 'SetScheduleReportPayload';
  clientMutationId: string | null;
  result: ReportEntity | null;
}

export interface SetReminderTaskPayload  {
  __typename?: 'SetReminderTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface SetReminderAppointmentPayload  {
  __typename?: 'SetReminderAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface SetQuoteTypeDraftFormLost  {
  __typename?: 'SetQuoteTypeDraftFormLost';
  formEditApi: Form | null;
}

export interface SetQuoteTypeDraftFormEdit  {
  __typename?: 'SetQuoteTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetProjectTypeDraftFormEdit  {
  __typename?: 'SetProjectTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetProductTypeDraftFormEdit  {
  __typename?: 'SetProductTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetPrimaryLookupRelationPayload  {
  __typename?: 'SetPrimaryLookupRelationPayload';
  clientMutationId: string | null;
}

export interface SetOpptyProductRelationTypeDraftFormEdit  {
  __typename?: 'SetOpptyProductRelationTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetOpptyExcludedPayload  {
  __typename?: 'SetOpptyExcludedPayload';
  clientExcludedOppty: ClientExcludedOpptyEntity;
  clientMutationId: string | null;
}

export interface SetOpportunityTypeDraftFormWon  {
  __typename?: 'SetOpportunityTypeDraftFormWon';
  formApi: UUID[];
}

export interface SetOpportunityTypeDraftFormQualify  {
  __typename?: 'SetOpportunityTypeDraftFormQualify';
  formApi: UUID[];
}

export interface SetOpportunityTypeDraftFormLost  {
  __typename?: 'SetOpportunityTypeDraftFormLost';
  formEditApi: Form | null;
}

export interface SetOpportunityTypeDraftFormEdit  {
  __typename?: 'SetOpportunityTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetLeadTypeDraftFormLost  {
  __typename?: 'SetLeadTypeDraftFormLost';
  formEditApi: Form | null;
}

export interface SetLeadTypeDraftFormEdit  {
  __typename?: 'SetLeadTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetLeadOpptyNodes  {
  __typename?: 'SetLeadOpptyNodes';
  nodes: OrgChartLeadOpptyNodeEntity[] | null;
}

export interface SetLeadOpptyLinesOfInfluence  {
  __typename?: 'SetLeadOpptyLinesOfInfluence';
  lines: ContactLineOfInfluence[];
}

export interface SetLeadOpptyGroups  {
  __typename?: 'SetLeadOpptyGroups';
  groups: OrgChartLeadOpptyGroupEntity[];
}

export interface SetEventMappingsClientPayload  {
  __typename?: 'SetEventMappingsClientPayload';
  result: EntityMapping[];
}

export interface SetEntityTypeDraftFormEdit  {
  __typename?: 'SetEntityTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetEntitySyncSettingsStatusOptionClientPayload  {
  __typename?: 'SetEntitySyncSettingsStatusOptionClientPayload';
  clientMutationId: string | null;
  result: string;
}

export interface SetEntitySyncSettingsClientPayload  {
  __typename?: 'SetEntitySyncSettingsClientPayload';
  clientMutationId: string | null;
  result: string;
}

export interface SetEntityFavoritePayload  {
  __typename?: 'SetEntityFavoritePayload';
  clientFavorite: ClientFavoriteEntity;
  clientMutationId: string | null;
}

export interface SetCustomEntityTypeDraftFormEdit  {
  __typename?: 'SetCustomEntityTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetContactTypeDraftFormEdit  {
  __typename?: 'SetContactTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetContactRelationLabels  {
  __typename?: 'SetContactRelationLabels';
  success: boolean | null;
}

export interface SetContactMappingsClientPayload  {
  __typename?: 'SetContactMappingsClientPayload';
  result: EntityMapping[];
}

export interface SetClientSettingPayload  {
  __typename?: 'SetClientSettingPayload';
  clientMutationId: string | null;
  clientSetting: ClientSettingEntity;
}

export interface SetAsFailedAutomationHubItemPayload  {
  __typename?: 'SetAsFailedAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface SetAppointmentTypeDraftFormEdit  {
  __typename?: 'SetAppointmentTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetActivityTypeDraftFormEdit  {
  __typename?: 'SetActivityTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetAccountTypeDraftFormEdit  {
  __typename?: 'SetAccountTypeDraftFormEdit';
  formEditApi: Form | null;
}

export interface SetAccountRelationLabels  {
  __typename?: 'SetAccountRelationLabels';
  success: boolean | null;
}

export interface SetAccountLinesOfInfluence  {
  __typename?: 'SetAccountLinesOfInfluence';
  lines: ContactLineOfInfluence[];
}

export interface SetAccountHierarchy  {
  __typename?: 'SetAccountHierarchy';
  accountsHierarchy: AccountsHierarchyNodeEntity[] | null;
}

export interface SetAccountGraph  {
  __typename?: 'SetAccountGraph';
  orgChart: OrgChartContactNodeEntity[] | null;
}

export interface SessionPolicyIPWhiteList  {
  __typename?: 'SessionPolicyIPWhiteList';
  allowedIps: string[];
  allowedUserIds: number[];
}

export interface SessionPolicyAutoLogout  {
  __typename?: 'SessionPolicyAutoLogout';
  dailyTimeout: number;
  idleTimeout: number;
  maxSessionTime: number;
}

export interface SessionPolicy  {
  __typename?: 'SessionPolicy';
  autoLogout: SessionPolicyAutoLogout;
  enabledPolicies: SessionPolicyType[];
  ipWhitelist: SessionPolicyIPWhiteList;
  timezone: string;
}

export interface ServicesRegistry  {
  __typename?: 'ServicesRegistry';
  aiAssistant: AiAssistantService;
  calling: CallingService;
  emails: EmailService;
  fieldDescriptor: FieldDescriptor | null;
  fieldDescriptors: FieldDescriptor[];
  generatePdf: string;
  hubspot: HubspotService;
  integrations: IntegrationIDRegistry;
  notifications: NotificationService;
  pandaDoc: PandaDocService;
  remoteStorage: RemoteStorageRepository;
  speechToText: SpeechToTextService;
  textToSpeech: TextToSpeechService;
  whatsApp: WhatsAppService;
}

export interface ServiceSettings  {
  __typename?: 'ServiceSettings';
  deleteProtection: ContactDeletionProtectionEnum | null;
  folder: string | null;
  recordOwnership: RecordOwnershipEnum | null;
  syncArchived: boolean | null;
  syncMethod: ContactSyncMethodEnum | null;
  syncPrivate: boolean | null;
}

export interface ServiceFolder  {
  __typename?: 'ServiceFolder';
  id: string;
  isDefault: boolean;
  name: string;
}

export interface ServiceAuthorizeTeamSpaceClientSettingPayload  {
  __typename?: 'ServiceAuthorizeTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface SequenceProperty  {
  __typename?: 'SequenceProperty';
  defaultItem: SequenceItemProperty;
  items: SequenceItemProperty[];
}

export interface SequenceParticleProperty  {
  __typename?: 'SequenceParticleProperty';
  month: number;
  sequenceNumber: number;
  year: number;
}

export interface SequenceItemProperty  {
  __typename?: 'SequenceItemProperty';
  filter: FieldFilter | null;
  id: ID | null;
  lastParticle: SequenceParticleProperty | null;
  pattern: string;
}

export interface Sender  {
  __typename?: 'Sender';
  name: string | null;
}

export interface SendTextMessageResult  {
  __typename?: 'SendTextMessageResult';
  conversationId: UUID;
  messageId: UUID;
  wasSent: boolean;
}

export interface SendTextMessageRecipient  {
  __typename?: 'SendTextMessageRecipient';
  accountId: UUID | null;
  contactId: UUID | null;
  customEntityIds: CustomEntityID[] | null;
  leadId: UUID | null;
  opportunityId: UUID | null;
  phoneNumber: string;
  primary: EntityLacotaType | null;
  projectId: UUID | null;
  quoteId: UUID | null;
}

export interface SendTextMessagePayload  {
  __typename?: 'SendTextMessagePayload';
  clientMutationId: string | null;
  results: SendTextMessageResult;
}

export interface SendReportPayload  {
  __typename?: 'SendReportPayload';
  clientMutationId: string | null;
  result: UUID | null;
}

export interface SendMassTextMessagePayload  {
  __typename?: 'SendMassTextMessagePayload';
  clientMutationId: string | null;
  results: SendTextMessageResult[];
}

export interface SendInvitationsAppointmentPayload  {
  __typename?: 'SendInvitationsAppointmentPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface SendFeaturePromotionEmailPayload  {
  __typename?: 'SendFeaturePromotionEmailPayload';
  clientMutationId: string | null;
  wasSent: boolean;
}

export interface SendEmailToSupportPayload  {
  __typename?: 'SendEmailToSupportPayload';
  clientMutationId: string | null;
  wasSent: boolean;
}

export interface SendEmailService  {
  __typename?: 'SendEmailService';
  companyAccountId: UUID | null;
  personalAccount: EmailServiceTypeEnum | null;
  personalAccountClientId: UUID | null;
}

export interface SendEmailRecipient  {
  __typename?: 'SendEmailRecipient';
  accountId: UUID | null;
  address: string;
  contactId: UUID | null;
  customEntityIds: CustomEntityID[] | null;
  leadId: UUID | null;
  opportunityId: UUID | null;
  primary: EntityLacotaType | null;
  projectId: UUID | null;
  quoteId: UUID | null;
}

export interface SendEmailPayload  {
  __typename?: 'SendEmailPayload';
  clientMutationId: string | null;
  enroll: EmailSequenceEnrollResult | null;
  messageId: UUID;
  wasSent: boolean;
}

export interface SendEmailLinkedEntity  {
  __typename?: 'SendEmailLinkedEntity';
  accountId: UUID | null;
  contactId: UUID | null;
  customEntityId: CustomEntityID | null;
  leadOpptyId: UUID | null;
  projectId: UUID | null;
  quoteId: UUID | null;
}

export interface SendEmailFollowupTaskSettings  {
  __typename?: 'SendEmailFollowupTaskSettings';
  description: string;
  dueDate: DateTime;
  status: TaskStatusEnum;
  subject: string;
  taskTypeId: UUID;
}

export interface SearchEdge  {
  __typename?: 'SearchEdge';
  cursor: string;
  node: SearchResultItemInterfaceImplementors | null;
}

export interface SearchConnection extends GlobalSearchCount {
  __typename?: 'SearchConnection';
  accountCount: number;
  appointmentCount: number;
  cloudObjectCount: number;
  contactCount: number;
  customEntityCount: CustomEntityCount[];
  edges: SearchEdge[];
  leadCount: number;
  noteCount: number;
  opportunityCount: number;
  pageInfo: PageInfo;
  projectCount: number;
  quoteCount: number;
  taskCount: number;
}

export interface ScreensDefaultProfilesParams  {
  __typename?: 'ScreensDefaultProfilesParams';
  Accountscreen: UUID;
  Activityscreen: UUID;
  Archivescreen: UUID;
  BetterNavigatorscreen: UUID;
  Contactscreen: UUID;
  Conversionsscreen: UUID;
  Feedscreen2: UUID;
  Indicatorsscreen: UUID;
  Insightsscreen: UUID;
  LeadArchivescreen: UUID;
  Leadscreen: UUID;
  Lifecyclescreen: UUID;
  Navigator: UUID;
  Pipelinescreen: UUID;
  Projectscreen: UUID;
  QuoteArchivescreen: UUID;
  Quotescreen: UUID;
}

export interface ScreenRegistry  {
  __typename?: 'ScreenRegistry';
  account: AccountPreviewScreen | null;
  accountArchive: AccountArchiveScreen | null;
  activity: ActivityPreviewScreen | null;
  advancedGlobalSearch: AdvancedGlobalSearch;
  approval: ApprovalPreviewScreen | null;
  archive: OpportunityArchiveScreen | null;
  betterNavigator: BetterNavigatorScreen | null;
  changeLog: ChangeLogScreen;
  contact: ContactPreviewScreen | null;
  contactArchive: ContactArchiveScreen | null;
  conversions: ConversionsScreen | null;
  customEntities: CustomEntityPreviewScreen | null;
  dashboard: DashboardViews;
  detailTabs: DetailTabs;
  documentManagement: DocumentManagementScreen;
  extractViews: ExtractViews;
  favoriteRecords: FavoriteRecords;
  feed: FeedScreen | null;
  feedEmail: FeedEmailScreen | null;
  forecast: ForecastViews;
  fulltextSearch: FulltextSearch;
  globalSearch: GlobalSearch;
  indicators: IndicatorsScreen | null;
  insights: InsightsScreen | null;
  lead: LeadPreviewScreen | null;
  leadArchive: LeadArchiveScreen | null;
  lifecycle: LifeCycleScreen | null;
  navigator: NavigatorScreen | null;
  opportunity: OpportunityPreviewScreen | null;
  project: ProjectPreviewScreen | null;
  quote: QuotePreviewScreen | null;
  quoteArchive: QuoteArchiveScreen | null;
  recentlyOpened: RecentlyOpened;
  report: ReportScreen;
  target: TargetView;
}

export interface ScoringStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ScoringStatusInterfaceFieldData';
  fieldId: UUID;
  scoringStatusColor: number | null;
  scoringStatusValue: number | null;
}

export interface ScoringCategoryInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ScoringCategoryInterfaceFieldData';
  fieldId: UUID;
  scoringCategoryColor: number | null;
  scoringCategoryName: string | null;
  scoringCategoryUseLang: boolean | null;
}

export interface ScorecardData  {
  __typename?: 'ScorecardData';
  comparisonPeriod: PeriodOption | null;
  comparisonValue: number | null;
  value: number | null;
}

export interface ScheduledReportEmailAttachment  {
  __typename?: 'ScheduledReportEmailAttachment';
  compress: boolean | null;
  formatCsv: CsvOptions | null;
  formatHtml: boolean | null;
  formatPdf: PdfOptions | null;
  formatXlsx: XlsxOptions | null;
  isPasswordEncrypted: boolean | null;
  password: string | null;
}

export interface ScheduledReportEmail extends EmailDataInterface {
  __typename?: 'ScheduledReportEmail';
  attachments: UUID[];
  bcc: SendEmailRecipient[];
  body: string;
  cc: SendEmailRecipient[];
  emailTemplateId: UUID | null;
  linkRecipients: boolean | null;
  recipients: SendEmailRecipient[];
  reportAttachment: ScheduledReportEmailAttachment | null;
  service: SendEmailService;
  signature: string | null;
  subject: string;
}

export interface ScheduleIntegrationInitSyncPayload  {
  __typename?: 'ScheduleIntegrationInitSyncPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface ScheduleEmailPayload  {
  __typename?: 'ScheduleEmailPayload';
  clientMutationId: string | null;
  messageId: UUID;
}

export interface SankeyDataNode  {
  __typename?: 'SankeyDataNode';
  id: string;
  label: string | null;
}

export interface SankeyDataLink  {
  __typename?: 'SankeyDataLink';
  endId: string;
  endLabel: string | null;
  endValue: number;
  startId: string;
  startLabel: string | null;
  startValue: number;
}

export interface SankeyData  {
  __typename?: 'SankeyData';
  endField: FieldDescriptor | null;
  endNodes: SankeyDataNode[];
  endValue: number;
  links: SankeyDataLink[];
  startField: FieldDescriptor | null;
  startNodes: SankeyDataNode[];
  startValue: number;
}

export interface SalesforceTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'SalesforceTeamPipelineHubItemEntity';
  accessToken: string | null;
  baseUrl: string | null;
  configuration: HubItemIntegrationSyncConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isAuthenticated: boolean | null;
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface SalesUnitRepository  {
  __typename?: 'SalesUnitRepository';
  getAll: SalesUnitEntity[];
  getByCriteria: SalesUnitEntityConnection | null;
  getById: SalesUnitEntity | null;
  getByIds: SalesUnitEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getRoot: SalesUnitEntity;
}

export interface SalesUnitEntityEdge  {
  __typename?: 'SalesUnitEntityEdge';
  cursor: string;
  node: SalesUnitEntity | null;
}

export interface SalesUnitEntityConnection  {
  __typename?: 'SalesUnitEntityConnection';
  edges: SalesUnitEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface SalesUnitEntity  {
  __typename?: 'SalesUnitEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  parent: SalesUnitEntity | null;
  parentId: ID | null;
  picture: CloudObjectEntity | null;
  pictureId: ID | null;
  revision: number | null;
}

export interface SalesUnitClientRelationRepository  {
  __typename?: 'SalesUnitClientRelationRepository';
  getAll: SalesUnitClientRelationEntity[];
  getByCriteria: SalesUnitClientRelationEntityConnection | null;
  getById: SalesUnitClientRelationEntity | null;
  getByIds: SalesUnitClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface SalesUnitClientRelationEntityEdge  {
  __typename?: 'SalesUnitClientRelationEntityEdge';
  cursor: string;
  node: SalesUnitClientRelationEntity | null;
}

export interface SalesUnitClientRelationEntityConnection  {
  __typename?: 'SalesUnitClientRelationEntityConnection';
  edges: SalesUnitClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface SalesUnitClientRelationEntity  {
  __typename?: 'SalesUnitClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
  unitRole: UnitRoleEnum | null;
}

export interface SalesRoleRepository  {
  __typename?: 'SalesRoleRepository';
  getAll: SalesRoleEntity[];
  getByCriteria: SalesRoleEntityConnection | null;
  getById: SalesRoleEntity | null;
  getByIds: SalesRoleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface SalesRoleEntityEdge  {
  __typename?: 'SalesRoleEntityEdge';
  cursor: string;
  node: SalesRoleEntity | null;
}

export interface SalesRoleEntityConnection  {
  __typename?: 'SalesRoleEntityConnection';
  edges: SalesRoleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface SalesRoleEntity  {
  __typename?: 'SalesRoleEntity';
  colorCode: number;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  revision: number | null;
}

export interface SalesPipelineStepLifeCycle  {
  __typename?: 'SalesPipelineStepLifeCycle';
  stepName: string;
  timeToThisStep: number;
}

export interface SalesPipelineLifeCycle  {
  __typename?: 'SalesPipelineLifeCycle';
  pipelineColor: number;
  pipelineId: ID;
  pipelineName: string;
  stepsLifeCycle: SalesPipelineStepLifeCycle[];
}

export interface S3Storage  {
  __typename?: 'S3Storage';
  uploadUrl: string[];
}

export interface RollupRelation  {
  __typename?: 'RollupRelation';
  entityApiName: string | null;
  id: ID;
  isDeleted: boolean;
  mainEntity: EntityNameEnum;
  name: string;
  parentEntity: EntityNameEnum | null;
  type: RollupRelationTypeEnum;
  useLang: boolean;
}

export interface RollupProperty  {
  __typename?: 'RollupProperty';
  aggregationFunction: RollupFieldAggregationFunctionEnum;
  entityApiName: string | null;
  entityRelationId: ID | null;
  fieldId: ID | null;
  filter: FieldFilter | null;
  sortFieldId: ID | null;
  targetEntity: EntityNameEnum;
}

export interface RollupDataResult  {
  __typename?: 'RollupDataResult';
  entityId: ID;
  errorCode: number | null;
  fieldId: ID;
  hasDrilldown: boolean;
  rollupEntity: RollupDataEntity | null;
  rollupValue: JSONString | null;
}

export interface RollupDataEntity  {
  __typename?: 'RollupDataEntity';
  entityApiName: string | null;
  entityType: EntityNameEnum;
  id: ID;
}

export interface RevenueScheduleSetting  {
  __typename?: 'RevenueScheduleSetting';
  isEnabled: boolean;
  periodType: RevenueSchedulePeriodTypeEnum;
  valueType: RevenueScheduleValueTypeEnum;
}

export interface RetryMediaTranscriptionPayload  {
  __typename?: 'RetryMediaTranscriptionPayload';
  clientMutationId: string | null;
  media: MediaEntity;
}

export interface RetrieveFoldersOutput  {
  __typename?: 'RetrieveFoldersOutput';
  folders: ServiceFolder[] | null;
  selectedFolderId: string | null;
}

export interface ResubmitApprovalPayload  {
  __typename?: 'ResubmitApprovalPayload';
  clientMutationId: string | null;
}

export interface RestoreTaskPayload  {
  __typename?: 'RestoreTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface RestoreQuotePayload  {
  __typename?: 'RestoreQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface RestoreProjectPayload  {
  __typename?: 'RestoreProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity | null;
}

export interface RestoreOpportunityPayload  {
  __typename?: 'RestoreOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface RestoreLeadPayload  {
  __typename?: 'RestoreLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface RestoreDataPayload  {
  __typename?: 'RestoreDataPayload';
  clientMutationId: string | null;
  result: DataEntity | null;
}

export interface RestoreCustomEntityPayload  {
  __typename?: 'RestoreCustomEntityPayload';
  clientMutationId: string | null;
  customEntity: CustomEntityEntity | null;
}

export interface RestoreContactPayload  {
  __typename?: 'RestoreContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface RestoreClientPayload  {
  __typename?: 'RestoreClientPayload';
  clientMutationId: string | null;
  result: ClientEntity | null;
}

export interface RestoreAppointmentPayload  {
  __typename?: 'RestoreAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface RestoreAccountPayload  {
  __typename?: 'RestoreAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface ResponseAcceptanceThresholdProductsLimits  {
  __typename?: 'ResponseAcceptanceThresholdProductsLimits';
  limits: OnlineFormProductsResponseLimit[];
  operator: FilterGroupOperator;
}

export interface ResponseAcceptanceThresholdCustomCondition  {
  __typename?: 'ResponseAcceptanceThresholdCustomCondition';
  formula: string;
  maxValueForAllResponses: number;
  maxValuePerResponse: number;
}

export interface RespondToApprovalPayload  {
  __typename?: 'RespondToApprovalPayload';
  clientMutationId: string | null;
}

export interface RespondToAppointmentInvitationPayload  {
  __typename?: 'RespondToAppointmentInvitationPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface ResetStepStatisticsEmailSequencePayload  {
  __typename?: 'ResetStepStatisticsEmailSequencePayload';
  clientMutationId: string | null;
}

export interface ResetStatisticsEmailSequencePayload  {
  __typename?: 'ResetStatisticsEmailSequencePayload';
  clientMutationId: string | null;
}

export interface ResetPasswordClientPayload  {
  __typename?: 'ResetPasswordClientPayload';
  clientMutationId: string | null;
}

export interface ResetEmailNotificationsStatusPayload  {
  __typename?: 'ResetEmailNotificationsStatusPayload';
  clientMutationId: string | null;
}

export interface RequestRemoveAutomationHubItemPayload  {
  __typename?: 'RequestRemoveAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface RequestMediaTranscriptionPayload  {
  __typename?: 'RequestMediaTranscriptionPayload';
  clientMutationId: string | null;
  media: MediaEntity;
}

export interface RequestCustomSolutionAutomationHubItemPayload  {
  __typename?: 'RequestCustomSolutionAutomationHubItemPayload';
  clientMutationId: string | null;
}

export interface RequestAddAutomationHubItemPayload  {
  __typename?: 'RequestAddAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface ReportView  {
  __typename?: 'ReportView';
  report: AiReportData | null;
}

export interface ReportTable extends ReportStructureItem {
  __typename?: 'ReportTable';
  id: ID;
  mainBox: ReportMainBox;
  parentId: ID | null;
  siblingBoxes: SiblingBoxInterfaceImplementors[];
  sortOrder: number;
  tabs: TableReportTabsInterfaceImplementors;
}

export interface ReportSiblingBox extends ReportBoxInterface, SiblingBoxInterface, VisibleBoxInterface {
  __typename?: 'ReportSiblingBox';
  calculationFieldId: ID | null;
  displayFields: DisplayFieldItem[];
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
  lookupFieldId: UUID | null;
  name: string;
  relation: SiblingBoxRelationType | null;
}

export interface ReportSharingSalesUnitRelationRepository  {
  __typename?: 'ReportSharingSalesUnitRelationRepository';
  getAll: ReportSharingSalesUnitRelationEntity[];
  getByCriteria: ReportSharingSalesUnitRelationEntityConnection | null;
  getById: ReportSharingSalesUnitRelationEntity | null;
  getByIds: ReportSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ReportSharingSalesUnitRelationEntityEdge  {
  __typename?: 'ReportSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: ReportSharingSalesUnitRelationEntity | null;
}

export interface ReportSharingSalesUnitRelationEntityConnection  {
  __typename?: 'ReportSharingSalesUnitRelationEntityConnection';
  edges: ReportSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReportSharingSalesUnitRelationEntity  {
  __typename?: 'ReportSharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  report: ReportEntity | null;
  reportId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface ReportSharingClientRelationRepository  {
  __typename?: 'ReportSharingClientRelationRepository';
  getAll: ReportSharingClientRelationEntity[];
  getByCriteria: ReportSharingClientRelationEntityConnection | null;
  getById: ReportSharingClientRelationEntity | null;
  getByIds: ReportSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ReportSharingClientRelationEntityEdge  {
  __typename?: 'ReportSharingClientRelationEntityEdge';
  cursor: string;
  node: ReportSharingClientRelationEntity | null;
}

export interface ReportSharingClientRelationEntityConnection  {
  __typename?: 'ReportSharingClientRelationEntityConnection';
  edges: ReportSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReportSharingClientRelationEntity  {
  __typename?: 'ReportSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  report: ReportEntity | null;
  reportId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface ReportScreen  {
  __typename?: 'ReportScreen';
  drilldown: ReportDrilldown;
}

export interface ReportSchema  {
  __typename?: 'ReportSchema';
  isAdvancedReport: boolean | null;
  structure: ReportStructureItemImplementors[];
}

export interface ReportScheduleSchema  {
  __typename?: 'ReportScheduleSchema';
  email: ScheduledReportEmail;
  followUp: EmailFollowUpTask | null;
  schedule: ReportSchedule;
  skipEmpty: boolean;
  timezone: string | null;
  workingDaysOnly: boolean | null;
}

export interface ReportScheduleRepository  {
  __typename?: 'ReportScheduleRepository';
  getAll: ReportScheduleEntity[];
  getByCriteria: ReportScheduleEntityConnection | null;
  getById: ReportScheduleEntity | null;
  getByIds: ReportScheduleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ReportScheduleEntityEdge  {
  __typename?: 'ReportScheduleEntityEdge';
  cursor: string;
  node: ReportScheduleEntity | null;
}

export interface ReportScheduleEntityConnection  {
  __typename?: 'ReportScheduleEntityConnection';
  edges: ReportScheduleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReportScheduleEntity  {
  __typename?: 'ReportScheduleEntity';
  created: DateTime | null;
  documents: CloudObjectRelationEntity[] | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  report: ReportEntity | null;
  reportId: ID;
  reportName: string;
  reportOwnerId: UUID;
  reportType: ReportTypeEnum;
  revision: number | null;
  senderEmail: string | null;
  settings: ReportScheduleSchema | null;
}

export interface ReportSchedule extends ScheduleInterface {
  __typename?: 'ReportSchedule';
  date: DateTime | null;
  dayOfMonth: number[] | null;
  dayOfWeek: number[] | null;
  timeOfDay: number | null;
}

export interface ReportSankeyChart  {
  __typename?: 'ReportSankeyChart';
  endDate: UUID | null;
  endGroupBoxId: UUID | null;
  endGroupFieldId: UUID;
  endGroupOption: GroupOption | null;
  startDate: UUID | null;
  startGroupBoxId: UUID | null;
  startGroupFieldId: UUID;
  startGroupOption: GroupOption | null;
}

export interface ReportRepository  {
  __typename?: 'ReportRepository';
  getAll: ReportEntity[];
  getByCriteria: ReportEntityConnection | null;
  getById: ReportEntity | null;
  getByIds: ReportEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ReportMainBox extends ReportBoxInterface, VisibleBoxInterface {
  __typename?: 'ReportMainBox';
  calculationFieldId: ID | null;
  displayFields: DisplayFieldItem[];
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
  name: string;
}

export interface ReportHistoryField  {
  __typename?: 'ReportHistoryField';
  comparisonDateId: UUID | null;
  fieldId: UUID | null;
  id: UUID;
}

export interface ReportHistoryDynamicDate  {
  __typename?: 'ReportHistoryDynamicDate';
  operation: ReportHistoryDynamicDateOperation;
  unit: ReportHistoryDynamicDateUnit;
  value: number | null;
}

export interface ReportHistoryComparisonDate  {
  __typename?: 'ReportHistoryComparisonDate';
  date: GqlDate | null;
  dynamicDate: ReportHistoryDynamicDate[] | null;
  id: UUID;
  isDynamicDateCustom: boolean;
  specialValue: ReportHistorySpecialValue | null;
}

export interface ReportHistoricalTrendHistory extends ReportHistoryCommon {
  __typename?: 'ReportHistoricalTrendHistory';
  fields: ReportHistoryField[];
  period: PeriodOption;
  periodGranularity: PeriodGranularity;
  trackedFieldIds: UUID[];
}

export interface ReportFolderRepository  {
  __typename?: 'ReportFolderRepository';
  getAll: ReportFolderEntity[];
  getByCriteria: ReportFolderEntityConnection | null;
  getById: ReportFolderEntity | null;
  getByIds: ReportFolderEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ReportFolderEntityEdge  {
  __typename?: 'ReportFolderEntityEdge';
  cursor: string;
  node: ReportFolderEntity | null;
}

export interface ReportFolderEntityConnection  {
  __typename?: 'ReportFolderEntityConnection';
  edges: ReportFolderEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReportFolderEntity  {
  __typename?: 'ReportFolderEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  parentReportFolder: ReportFolderEntity | null;
  parentReportFolderId: ID | null;
  revision: number | null;
}

export interface ReportFavoriteResultItem extends FavoriteResultItemInterface {
  __typename?: 'ReportFavoriteResultItem';
  id: ID;
  isDeleted: boolean;
  isPivot: boolean;
  modified: DateTime;
  name: string;
  ownerName: string;
  reportType: ReportTypeEnum;
}

export interface ReportEntityEdge  {
  __typename?: 'ReportEntityEdge';
  cursor: string;
  node: ReportEntity | null;
}

export interface ReportEntityConnection  {
  __typename?: 'ReportEntityConnection';
  edges: ReportEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReportEntity  {
  __typename?: 'ReportEntity';
  accessLink: string | null;
  aiConversation: AiConversationItem[] | null;
  created: DateTime | null;
  description: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  reportsFolder: ReportFolderEntity | null;
  reportsFolderId: ID;
  revision: number | null;
  schedule: ReportScheduleEntity | null;
  settings: ReportSettings;
  shareMode: ShareModeEnum | null;
  shareModeParams: number | null;
  sharingClients: ReportSharingClientRelationEntityConnection | null;
  sharingUnits: ReportSharingSalesUnitRelationEntityConnection | null;
  syncEnabled: boolean | null;
  syncEntity: ProfileEntity | null;
  syncEntityId: ID | null;
  type: ReportTypeEnum;
}

export interface ReportDrilldown  {
  __typename?: 'ReportDrilldown';
  pivot: EntityDrilldownModel;
  table: EntityDrilldownModel;
}

export interface ReportComparisonDatesHistory extends ReportHistoryCommon {
  __typename?: 'ReportComparisonDatesHistory';
  comparisonDates: ReportHistoryComparisonDate[];
  fields: ReportHistoryField[];
  trackedFieldIds: UUID[];
}

export interface ReportChart  {
  __typename?: 'ReportChart';
  boxId: UUID | null;
  comparison: ChartComparison | null;
  fieldId: UUID | null;
  groupBoxId: UUID | null;
  groupByHistory: boolean | null;
  groupFieldId: UUID | null;
  groupOption: GroupOption | null;
  height: number | null;
  historyComparisonDateIds: UUID[] | null;
  isEnabled: boolean;
  operator: AggregationOperator;
  sankey: ReportSankeyChart | null;
  segmentBoxId: UUID | null;
  segmentFieldEnabled: boolean | null;
  segmentFieldId: UUID | null;
  segmentOption: GroupOption | null;
  seriesColor: number | null;
  showAllDataLabels: boolean;
  showAverage: boolean | null;
  showNegativeValues: boolean;
  showNotAvailableValues: boolean | null;
  showNumbers: boolean;
  showPercentageValues: boolean;
  sortValues: SortOrder | null;
  type: ReportChartType;
}

export interface ReopenProjectPayload  {
  __typename?: 'ReopenProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity | null;
}

export interface RemoveTargetPayload  {
  __typename?: 'RemoveTargetPayload';
  clientMutationId: string | null;
}

export interface RemoveScheduleReportPayload  {
  __typename?: 'RemoveScheduleReportPayload';
  clientMutationId: string | null;
  result: ReportEntity | null;
}

export interface RemoveReminderTaskPayload  {
  __typename?: 'RemoveReminderTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface RemoveReminderAppointmentPayload  {
  __typename?: 'RemoveReminderAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface RemoveRecordsFromExistingStaticProfilesProfilePayload  {
  __typename?: 'RemoveRecordsFromExistingStaticProfilesProfilePayload';
  clientMutationId: string | null;
}

export interface RemoveQuoteProcessStepPayload  {
  __typename?: 'RemoveQuoteProcessStepPayload';
  clientMutationId: string | null;
  result: QuoteProcessEntity | null;
}

export interface RemovePipelineStepPayload  {
  __typename?: 'RemovePipelineStepPayload';
  clientMutationId: string | null;
  result: PipelineEntity | null;
}

export interface RemoveLeadProcessStepPayload  {
  __typename?: 'RemoveLeadProcessStepPayload';
  clientMutationId: string | null;
  result: LeadProcessEntity | null;
}

export interface RemoveContactRelation  {
  __typename?: 'RemoveContactRelation';
  success: boolean | null;
}

export interface RemoveClientFromUnitClientPayload  {
  __typename?: 'RemoveClientFromUnitClientPayload';
  clientMutationId: string | null;
  result: ClientEntity | null;
}

export interface RemoveAutomationHubItemPayload  {
  __typename?: 'RemoveAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface RemoveAccountRelation  {
  __typename?: 'RemoveAccountRelation';
  success: boolean | null;
}

export interface RemoteStorageRepository  {
  __typename?: 'RemoteStorageRepository';
  availableIntegrations: IntegrationStorage[];
  dropboxBusiness: DropboxBusiness | null;
  googleDrive: GoogleDrive | null;
  integration: GenericIntegrationStorageServiceImplementors | null;
  microsoftOneDrive: OneDrive | null;
  microsoftSharepoint: Sharepoint | null;
  s3: S3Storage;
}

export interface RemoteStorageFileResult  {
  __typename?: 'RemoteStorageFileResult';
  created: DateTime | null;
  description: string | null;
  id: string | null;
  isFile: boolean | null;
  mimeType: string | null;
  name: string | null;
  url: string | null;
}

export interface RemoteStorageFileListResultEdge  {
  __typename?: 'RemoteStorageFileListResultEdge';
  cursor: string;
  node: RemoteStorageFileResult | null;
}

export interface RemoteStorageFileListResultConnection  {
  __typename?: 'RemoteStorageFileListResultConnection';
  edges: RemoteStorageFileListResultEdge[];
  pageInfo: PageInfo;
  rootFolder: RemoteStorageFileResult | null;
}

export interface ReloadCloudObjectResult  {
  __typename?: 'ReloadCloudObjectResult';
  created: DateTime;
  lastModified: DateTime;
  resultUrl: string | null;
}

export interface ReleaseOwnershipTaskPayload  {
  __typename?: 'ReleaseOwnershipTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface ReleaseOwnershipLeadPayload  {
  __typename?: 'ReleaseOwnershipLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ReleaseNoteRepository  {
  __typename?: 'ReleaseNoteRepository';
  getAll: ReleaseNoteEntity[];
  getByCriteria: ReleaseNoteEntityConnection | null;
  getById: ReleaseNoteEntity | null;
  getByIds: ReleaseNoteEntity[];
}

export interface ReleaseNoteEntityEdge  {
  __typename?: 'ReleaseNoteEntityEdge';
  cursor: string;
  node: ReleaseNoteEntity | null;
}

export interface ReleaseNoteEntityConnection  {
  __typename?: 'ReleaseNoteEntityConnection';
  edges: ReleaseNoteEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ReleaseNoteEntity  {
  __typename?: 'ReleaseNoteEntity';
  actionLabel: string | null;
  created: DateTime | null;
  description: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReleaseNotePermsEnum[];
  isActive: boolean | null;
  lastUserReaction: UserReactionEnum | null;
  publishedAt: DateTime | null;
  reactionNegativeCount: number | null;
  reactionNeutralCount: number | null;
  reactionPositiveCount: number | null;
  tag: string | null;
  title: string | null;
  uniqueViewCount: number | null;
  url: string | null;
  viewCount: number | null;
}

export interface RelationFieldTabSettingsFilter  {
  __typename?: 'RelationFieldTabSettingsFilter';
  ownerId: UUID[] | null;
}

export interface RelationFieldTabSettings  {
  __typename?: 'RelationFieldTabSettings';
  changes: GridHighlightChanges;
  fieldId: UUID;
  filter: RelationFieldTabSettingsFilter;
  gridColumns: GridColumnsOutput[];
  gridSortBy: UUID;
  gridSortOrder: SortOrder;
  id: ID | null;
}

export interface RelatedQuoteTabDataGridViewOptions  {
  __typename?: 'RelatedQuoteTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  relatedQuotes: boolean;
  searchQuery: string | null;
}

export interface RelatedOpportunityTabDataGridViewOptions  {
  __typename?: 'RelatedOpportunityTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByPipelineId: ID[] | null;
  filterByStatus: OpptyStatusEnum[] | null;
  filterByTags: ID[] | null;
  relatedOpportunities: boolean;
  searchQuery: string | null;
}

export interface RelatedLeadTabDataGridViewOptions  {
  __typename?: 'RelatedLeadTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByStatus: LeadStatusEnum[] | null;
  filterByTags: ID[] | null;
  relatedLeads: boolean;
  searchQuery: string | null;
}

export interface RegionEntity  {
  __typename?: 'RegionEntity';
  code: string | null;
  currency: string | null;
  currencySymbol: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReadOnlyPermsEnum[];
  name: number | null;
  unitPrice: number | null;
  unitPriceBasic: number | null;
  unitPriceEnterprise: number | null;
  unitPriceStarter: number | null;
  unitPriceUnlimited: number | null;
}

export interface RefreshIndexesPayload  {
  __typename?: 'RefreshIndexesPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface Rectangle  {
  __typename?: 'Rectangle';
  height: number;
  width: number;
  x: number;
  y: number;
}

export interface RecordDocumentsDataGridViewItems extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'RecordDocumentsDataGridViewItems';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface RecordDetailView  {
  __typename?: 'RecordDetailView';
  Recorddetailview_Typename: string | null;
}

export interface RecentlyOpenedLinkedItemType  {
  __typename?: 'RecentlyOpenedLinkedItemType';
  entity: LinkedEntityType;
  entityApiName: string | null;
  id: ID;
  name: string;
}

export interface RecentlyOpenedEntity  {
  __typename?: 'RecentlyOpenedEntity';
  dateTime: DateTime | null;
  entityApiName: string | null;
  entityName: RecentlyOpenedEntityType | null;
  id: ID | null;
}

export interface RecentlyOpened  {
  __typename?: 'RecentlyOpened';
  items: RecentlyOpenedResultItemInterfaceImplementors[] | null;
}

export interface RecentExecutionItem  {
  __typename?: 'RecentExecutionItem';
  description: string;
  executionDate: DateTime;
  hasAccess: boolean;
  id: UUID;
  name: string;
  status: ProcessStatusEnum;
  type: ProcessTypeEnum;
  url: string;
}

export interface RecentApprovalItem  {
  __typename?: 'RecentApprovalItem';
  approvalProcessDescription: string | null;
  approvalProcessId: UUID;
  approvalProcessName: string;
  completedDatetime: DateTime;
  id: UUID;
  status: ApprovalStatusEnum;
}

export interface RecalculateEntityScoringSinglePayload  {
  __typename?: 'RecalculateEntityScoringSinglePayload';
  clientMutationId: string | null;
  result: EntityScoringResult | null;
}

export interface RecalculateEntityScoringPayload  {
  __typename?: 'RecalculateEntityScoringPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface RecalculateEntityHealthAllPayload  {
  __typename?: 'RecalculateEntityHealthAllPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface ReassignClientPayload  {
  __typename?: 'ReassignClientPayload';
  clientMutationId: string | null;
  result: ClientEntity | null;
}

export interface ReactivateQuotePayload  {
  __typename?: 'ReactivateQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ReactivateLeadPayload  {
  __typename?: 'ReactivateLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ReactivateLeadOpptyPayload  {
  __typename?: 'ReactivateLeadOpptyPayload';
  clientMutationId: string | null;
  result: LeadOpportunityEntity | null;
}

export interface ReactivateContactPayload  {
  __typename?: 'ReactivateContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface ReactivateAccountPayload  {
  __typename?: 'ReactivateAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface QuotesNotificationSettings  {
  __typename?: 'QuotesNotificationSettings';
  IsActive: boolean;
  LinkedItem: boolean;
  Move: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface QuoteTypeRepository  {
  __typename?: 'QuoteTypeRepository';
  getAll: QuoteTypeEntity[];
  getByCriteria: QuoteTypeEntityConnection | null;
  getById: QuoteTypeEntity | null;
  getByIds: QuoteTypeEntity[];
  getByQuoteProcess: QuoteTypeEntity | null;
  getDraftById: QuoteTypeEntity;
  getDrafts: QuoteTypeEntity[];
  getPublished: QuoteTypeEntity[];
}

export interface QuoteTypeEntityEdge  {
  __typename?: 'QuoteTypeEntityEdge';
  cursor: string;
  node: QuoteTypeEntity | null;
}

export interface QuoteTypeEntityConnection  {
  __typename?: 'QuoteTypeEntityConnection';
  edges: QuoteTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteTypeEntity  {
  __typename?: 'QuoteTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  formLost: JSONString;
  formLostApi: Form | null;
  formLostEnabled: boolean;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  quoteProcess: QuoteProcessEntity | null;
  quoteProcessId: ID;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface QuoteTableReportProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, QuoteProfileInterface, ReportTabInterface, TableReportTabsInterface {
  __typename?: 'QuoteTableReportProfile';
  filter: QuoteFilterTab;
  quickFilter: QuickFilterTab;
  quoteProcess: UUID[] | null;
  role: QuoteRoleTab;
  view: ViewTableReportTab;
}

export interface QuoteTabDataGridViewOptions  {
  __typename?: 'QuoteTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  searchQuery: string | null;
}

export interface QuoteTabDataGridView  {
  __typename?: 'QuoteTabDataGridView';
  ofAccount: AccountQuoteTabDataGridView;
  ofContact: ContactQuoteTabDataGridView;
  ofOpportunity: OpportunityQuoteTabDataGridView;
}

export interface QuoteStepSummaryInfo  {
  __typename?: 'QuoteStepSummaryInfo';
  itemCount: number;
  readyToMoveCount: number;
  readyToMoveIds: ID[];
  stepId: ID | null;
}

export interface QuoteStepMetadata  {
  __typename?: 'QuoteStepMetadata';
  stepId: UUID | null;
}

export interface QuoteStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'QuoteStatusInterfaceFieldData';
  fieldId: UUID;
  quoteStatus: QuoteStatusEnum;
}

export interface QuoteSharingSalesUnitRelationRepository  {
  __typename?: 'QuoteSharingSalesUnitRelationRepository';
  getAll: QuoteSharingSalesUnitRelationEntity[];
  getByCriteria: QuoteSharingSalesUnitRelationEntityConnection | null;
  getById: QuoteSharingSalesUnitRelationEntity | null;
  getByIds: QuoteSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteSharingSalesUnitRelationEntityEdge  {
  __typename?: 'QuoteSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: QuoteSharingSalesUnitRelationEntity | null;
}

export interface QuoteSharingSalesUnitRelationEntityConnection  {
  __typename?: 'QuoteSharingSalesUnitRelationEntityConnection';
  edges: QuoteSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteSharingSalesUnitRelationEntity  {
  __typename?: 'QuoteSharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface QuoteSharingClientRelationRepository  {
  __typename?: 'QuoteSharingClientRelationRepository';
  getAll: QuoteSharingClientRelationEntity[];
  getByCriteria: QuoteSharingClientRelationEntityConnection | null;
  getById: QuoteSharingClientRelationEntity | null;
  getByIds: QuoteSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteSharingClientRelationEntityEdge  {
  __typename?: 'QuoteSharingClientRelationEntityEdge';
  cursor: string;
  node: QuoteSharingClientRelationEntity | null;
}

export interface QuoteSharingClientRelationEntityConnection  {
  __typename?: 'QuoteSharingClientRelationEntityConnection';
  edges: QuoteSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteSharingClientRelationEntity  {
  __typename?: 'QuoteSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface QuoteSearchResultItem extends SearchResultItemInterface {
  __typename?: 'QuoteSearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  owner: string | null;
}

export interface QuoteRoleTab extends RoleTabInterface {
  __typename?: 'QuoteRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface QuoteRepository  {
  __typename?: 'QuoteRepository';
  autoPrefill: QuoteEntity;
  getAll: QuoteEntity[];
  getByCriteria: QuoteEntityConnection | null;
  getById: QuoteEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: QuoteEntity[];
  getBySession: QuoteEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface, RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: 'QuoteRecentlyOpenedResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  owner: string;
}

export interface QuoteProfileData  {
  __typename?: 'QuoteProfileData';
  boardViewItems: QuoteBoardViewItems;
  listViewItems: QuoteDataGridViewItems;
}

export interface QuoteProcessRepository  {
  __typename?: 'QuoteProcessRepository';
  getAll: QuoteProcessEntity[];
  getByCriteria: QuoteProcessEntityConnection | null;
  getById: QuoteProcessEntity | null;
  getByIds: QuoteProcessEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteProcessEntityEdge  {
  __typename?: 'QuoteProcessEntityEdge';
  cursor: string;
  node: QuoteProcessEntity | null;
}

export interface QuoteProcessEntityConnection  {
  __typename?: 'QuoteProcessEntityConnection';
  edges: QuoteProcessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteProcessEntity  {
  __typename?: 'QuoteProcessEntity';
  color: number | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  quoteTypes: QuoteTypeEntity[];
  revision: number | null;
  steps: StepEntity[];
}

export interface QuotePreviewViewTab  {
  __typename?: 'QuotePreviewViewTab';
  gridColumns: GridColumnsOutput[];
  groupBy: QuoteGroupBy | null;
  showExtraFieldIds: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface QuotePreviewScreenProfile extends ProfileInterface {
  __typename?: 'QuotePreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: QuotePreviewProfile;
  useLang: boolean;
}

export interface QuotePreviewScreen extends ProfileScreen, Screen {
  __typename?: 'QuotePreviewScreen';
  activeProfile: QuotePreviewScreenProfile;
  data: QuoteProfileData;
  draftProfile: QuotePreviewScreenProfile | null;
  entityData: QuoteEntityData | null;
  item: QuoteItem | null;
  name: string;
  profiles: QuotePreviewScreenProfile[];
}

export interface QuotePreviewProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, QuoteProfileInterface, RoleProfileInterface {
  __typename?: 'QuotePreviewProfile';
  filter: QuoteFilterTab;
  quickFilter: QuickFilterTab;
  quoteProcess: UUID[] | null;
  role: QuoteRoleTab;
  view: QuotePreviewViewTab;
}

export interface QuotePivotReportProfile extends PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, QuoteReportProfileInterface, ReportTabInterface {
  __typename?: 'QuotePivotReportProfile';
  filter: QuoteFilterTab;
  quickFilter: QuickFilterTab;
  quoteProcess: UUID[] | null;
  role: QuoteRoleTab;
  view: ViewPivotReportTab;
}

export interface QuoteNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface QuoteListView extends ListViewInterface {
  __typename?: 'QuoteListView';
  displayColumn: UUID[];
  profile: QuotePreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface QuoteKPIRepository  {
  __typename?: 'QuoteKPIRepository';
  getAll: QuoteKPIEntity[];
  getByCriteria: QuoteKPIEntityConnection | null;
  getById: QuoteKPIEntity | null;
  getByIds: QuoteKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteKPIEntityEdge  {
  __typename?: 'QuoteKPIEntityEdge';
  cursor: string;
  node: QuoteKPIEntity | null;
}

export interface QuoteKPIEntityConnection  {
  __typename?: 'QuoteKPIEntityConnection';
  edges: QuoteKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteKPIEntity  {
  __typename?: 'QuoteKPIEntity';
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: QuoteKpiEnum;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
}

export interface QuoteItem  {
  __typename?: 'QuoteItem';
  boardViewItem: QuoteBoardViewItem | null;
  compactViewItem: QuoteCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
}

export interface QuoteFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'QuoteFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface QuoteFeedTabDataGridView  {
  __typename?: 'QuoteFeedTabDataGridView';
  feed: Feed;
}

export interface QuoteFeedEmailTabDataGridView  {
  __typename?: 'QuoteFeedEmailTabDataGridView';
  feed: Feed;
}

export interface QuoteFavoriteResultItem extends FavoriteResultItemInterface, FavoriteResultItemIsArchivedInterface {
  __typename?: 'QuoteFavoriteResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  owner: string;
}

export interface QuoteEntityEdge  {
  __typename?: 'QuoteEntityEdge';
  cursor: string;
  node: QuoteEntity | null;
}

export interface QuoteEntityData  {
  __typename?: 'QuoteEntityData';
  accounts: QuoteAccountRelationEntityConnection | null;
  contacts: QuoteContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: QuoteEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface QuoteEntityConnection  {
  __typename?: 'QuoteEntityConnection';
  edges: QuoteEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteEntity  {
  __typename?: 'QuoteEntity';
  accountRelations: QuoteAccountRelationEntityConnection | null;
  approval: ApprovalEntity | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  contactRelations: QuoteContactRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  expirationDate: GqlDate | null;
  fields: InterfaceFieldDataImplementors[];
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isActiveInOpportunity: boolean | null;
  isArchived: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  name: string;
  oppty: OpportunityEntity | null;
  opptyId: ID | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  primaryAccount: AccountEntity | null;
  primaryContact: ContactEntity | null;
  productCurrency: CurrencyEntity | null;
  productCurrencyId: ID | null;
  productPriceList: ProductPriceListEntity | null;
  productPriceListId: ID | null;
  productRelations: OpptyProductRelationEntityConnection | null;
  productSections: ProductSection[] | null;
  projectObjectiveActivitiesDrilldown: CompactViewDrilldownModel;
  quickAccountEmail: string | null;
  quickAccountName: string | null;
  quickAccountPhone: string | null;
  quickContactName: string | null;
  quickEmail: string | null;
  quickPhone: string | null;
  quoteNumber: string | null;
  quoteType: QuoteTypeEntity | null;
  quoteTypeId: ID | null;
  reasonOfClose: DataEntity | null;
  reasonOfCloseDescription: string | null;
  reasonOfCloseId: ID | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: QuoteSharingClientRelationEntityConnection | null;
  sharingUnits: QuoteSharingSalesUnitRelationEntityConnection | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  status: QuoteStatusEnum;
  step: StepEntity | null;
  stepChecklists: StepChecklistActivityItem[];
  stepId: ID;
  totalAmount: CurrencyForeignField | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  version: number | null;
  viewerIdsPerSalesUnit: UUID[];
}

export interface QuoteDrilldownFilter  {
  __typename?: 'QuoteDrilldownFilter';
  ownerId: ID[] | null;
}

export interface QuoteDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface QuoteDataExRelationRepository  {
  __typename?: 'QuoteDataExRelationRepository';
  getAll: QuoteDataExRelationEntity[];
  getByCriteria: QuoteDataExRelationEntityConnection | null;
  getById: QuoteDataExRelationEntity | null;
  getByIds: QuoteDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteDataExRelationEntityEdge  {
  __typename?: 'QuoteDataExRelationEntityEdge';
  cursor: string;
  node: QuoteDataExRelationEntity | null;
}

export interface QuoteDataExRelationEntityConnection  {
  __typename?: 'QuoteDataExRelationEntityConnection';
  edges: QuoteDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteDataExRelationEntity  {
  __typename?: 'QuoteDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
}

export interface QuoteContactRelationRepository  {
  __typename?: 'QuoteContactRelationRepository';
  getAll: QuoteContactRelationEntity[];
  getByCriteria: QuoteContactRelationEntityConnection | null;
  getById: QuoteContactRelationEntity | null;
  getByIds: QuoteContactRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteContactRelationEntityEdge  {
  __typename?: 'QuoteContactRelationEntityEdge';
  cursor: string;
  node: QuoteContactRelationEntity | null;
}

export interface QuoteContactRelationEntityConnection  {
  __typename?: 'QuoteContactRelationEntityConnection';
  edges: QuoteContactRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteContactRelationEntity  {
  __typename?: 'QuoteContactRelationEntity';
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  modified: DateTime | null;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
}

export interface QuoteCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteCompactViewItems';
  groups: ViewItemGroup[];
  items: QuoteCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface QuoteCompactViewItem extends ViewItemInterface {
  __typename?: 'QuoteCompactViewItem';
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  groupName: FieldDataContainer | null;
  id: ID;
  isFavorite: boolean | null;
  name: string;
  owner: string | null;
  ownerId: string | null;
  ownerPicture: string | null;
  quoteTypeId: ID;
  sortFieldValue: FieldDataContainer | null;
  sortIcon: string | null;
  unit: string;
  unitId: string;
  unitPicture: string | null;
}

export interface QuoteCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface QuoteBoardViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'QuoteBoardViewItems';
  columns: QuoteBoardColumnItems[];
  sessionId: string;
  total: number;
}

export interface QuoteBoardViewItem extends ViewItemInterface {
  __typename?: 'QuoteBoardViewItem';
  expirationDate: GqlDate | null;
  extraFieldValues: string[];
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  id: ID;
  name: string;
  quoteStepMetadata: QuoteStepMetadata[];
  value: JSONString | null;
}

export interface QuoteBoardView extends BoardViewInterface {
  __typename?: 'QuoteBoardView';
  profile: QuotePreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface QuoteBoardColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'QuoteBoardColumnItems';
  items: QuoteBoardViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: QuoteStepSummaryInfo;
  total: number;
}

export interface QuoteArchiveStepSummaryInfo  {
  __typename?: 'QuoteArchiveStepSummaryInfo';
  itemCount: number;
  stepId: ID | null;
}

export interface QuoteArchiveScreenProfile extends ProfileInterface {
  __typename?: 'QuoteArchiveScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: QuoteArchiveProfile;
  useLang: boolean;
}

export interface QuoteArchiveScreen extends ProfileScreen, Screen {
  __typename?: 'QuoteArchiveScreen';
  activeProfile: QuoteArchiveScreenProfile;
  data: QuoteArchiveProfileData;
  draftProfile: QuoteArchiveScreenProfile | null;
  entityData: QuoteArchiveEntityData | null;
  item: ArchiveQuoteItem | null;
  name: string;
  profiles: QuoteArchiveScreenProfile[];
}

export interface QuoteArchiveProfileData  {
  __typename?: 'QuoteArchiveProfileData';
  boardViewItems: QuoteArchiveBoardViewItems;
  listViewItems: QuoteArchiveDataGridViewItems;
}

export interface QuoteArchiveProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, QuoteProfileInterface, RoleProfileInterface {
  __typename?: 'QuoteArchiveProfile';
  filter: QuoteFilterTab;
  quickFilter: QuickFilterTab;
  quoteProcess: UUID[] | null;
  role: QuoteRoleTab;
  view: QuotePreviewViewTab;
}

export interface QuoteArchiveEntityData  {
  __typename?: 'QuoteArchiveEntityData';
  accounts: QuoteAccountRelationEntityConnection | null;
  contacts: QuoteContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: QuoteEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface QuoteArchiveDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteArchiveDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface QuoteArchiveBoardViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'QuoteArchiveBoardViewItems';
  columns: QuoteArchiveBoardColumnItems[];
  sessionId: string;
  total: number;
}

export interface QuoteArchiveBoardViewItem extends ViewItemInterface {
  __typename?: 'QuoteArchiveBoardViewItem';
  expirationDate: GqlDate | null;
  extraFieldValues: string[];
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  id: ID;
  name: string;
  value: JSONString | null;
}

export interface QuoteArchiveBoardColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'QuoteArchiveBoardColumnItems';
  items: QuoteArchiveBoardViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: QuoteArchiveStepSummaryInfo;
  total: number;
}

export interface QuoteActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'QuoteActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface QuoteActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'QuoteActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface QuoteActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'QuoteActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface QuoteAccountRelationRepository  {
  __typename?: 'QuoteAccountRelationRepository';
  getAll: QuoteAccountRelationEntity[];
  getByCriteria: QuoteAccountRelationEntityConnection | null;
  getById: QuoteAccountRelationEntity | null;
  getByIds: QuoteAccountRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface QuoteAccountRelationEntityEdge  {
  __typename?: 'QuoteAccountRelationEntityEdge';
  cursor: string;
  node: QuoteAccountRelationEntity | null;
}

export interface QuoteAccountRelationEntityConnection  {
  __typename?: 'QuoteAccountRelationEntityConnection';
  edges: QuoteAccountRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface QuoteAccountRelationEntity  {
  __typename?: 'QuoteAccountRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  modified: DateTime | null;
  quote: QuoteEntity | null;
  quoteId: ID;
  revision: number | null;
}

export interface QuickMergeProgress  {
  __typename?: 'QuickMergeProgress';
  completed: number;
  entity: EntityNameEnum;
  entityApiName: string | null;
  total: number;
}

export interface QuickMergeDuplicates  {
  __typename?: 'QuickMergeDuplicates';
  result: MergeRecordPayload[];
}

export interface QuickFilterTab  {
  __typename?: 'QuickFilterTab';
  filterFieldOrder: UUID[];
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
}

export interface QuickAttachFilesForOnlineFormPayload  {
  __typename?: 'QuickAttachFilesForOnlineFormPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface QualifyLeadPayload  {
  __typename?: 'QualifyLeadPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface PurchasePhonePayload  {
  __typename?: 'PurchasePhonePayload';
  clientMutationId: string | null;
  phone: PhoneEntity;
}

export interface PublishDraftsMutation  {
  __typename?: 'PublishDraftsMutation';
  publishedDataCount: number | null;
  publishedEntitySettingsCount: number | null;
  publishedFieldCount: number | null;
  publishedFieldPermissionCount: number | null;
  publishedInterfacePreviewCount: number | null;
  publishedResourceCount: number | null;
  publishedTranslationsCount: number | null;
  publishedTypesCount: number | null;
}

export interface PromoteGhostContactPayload  {
  __typename?: 'PromoteGhostContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface ProlongStoredReportSessionPayload  {
  __typename?: 'ProlongStoredReportSessionPayload';
  clientMutationId: string | null;
}

export interface ProjectsNotificationSettings  {
  __typename?: 'ProjectsNotificationSettings';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface ProjectTypeRepository  {
  __typename?: 'ProjectTypeRepository';
  getAll: ProjectTypeEntity[];
  getByCriteria: ProjectTypeEntityConnection | null;
  getById: ProjectTypeEntity | null;
  getByIds: ProjectTypeEntity[];
  getDraftById: ProjectTypeEntity;
  getDrafts: ProjectTypeEntity[];
  getPublished: ProjectTypeEntity[];
}

export interface ProjectTypeEntityEdge  {
  __typename?: 'ProjectTypeEntityEdge';
  cursor: string;
  node: ProjectTypeEntity | null;
}

export interface ProjectTypeEntityConnection  {
  __typename?: 'ProjectTypeEntityConnection';
  edges: ProjectTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectTypeEntity  {
  __typename?: 'ProjectTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  icon: ProjectTypeIconEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface ProjectTableReportProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, ProjectProfileInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'ProjectTableReportProfile';
  filter: ProjectFilterTab;
  quickFilter: QuickFilterTab;
  role: ProjectRoleTab;
  view: ViewTableReportTab;
}

export interface ProjectTabDataGridViewOptions  {
  __typename?: 'ProjectTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByPeriod: PeriodOption | null;
  filterByProjectStatus: ProjectStatusEnum[] | null;
  filterByTags: ID[] | null;
  searchQuery: string | null;
}

export interface ProjectTabDataGridView  {
  __typename?: 'ProjectTabDataGridView';
  ofAccount: AccountProjectTabDataGridView;
  ofContact: ContactProjectTabDataGridView;
}

export interface ProjectStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ProjectStatusInterfaceFieldData';
  fieldId: UUID;
  projectStatus: ProjectStatusEnum;
}

export interface ProjectStatusCount  {
  __typename?: 'ProjectStatusCount';
  completed: number;
  inProgress: number;
  notStarted: number;
  overdue: number;
}

export interface ProjectStatusChangeNotificationEntity extends NotificationEntityInterface {
  __typename?: 'ProjectStatusChangeNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
  status: ProjectStatusEnum;
}

export interface ProjectSharingSalesUnitRelationRepository  {
  __typename?: 'ProjectSharingSalesUnitRelationRepository';
  getAll: ProjectSharingSalesUnitRelationEntity[];
  getByCriteria: ProjectSharingSalesUnitRelationEntityConnection | null;
  getById: ProjectSharingSalesUnitRelationEntity | null;
  getByIds: ProjectSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectSharingSalesUnitRelationEntityEdge  {
  __typename?: 'ProjectSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: ProjectSharingSalesUnitRelationEntity | null;
}

export interface ProjectSharingSalesUnitRelationEntityConnection  {
  __typename?: 'ProjectSharingSalesUnitRelationEntityConnection';
  edges: ProjectSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectSharingSalesUnitRelationEntity  {
  __typename?: 'ProjectSharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  project: ProjectEntity | null;
  projectId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface ProjectSharingClientRelationRepository  {
  __typename?: 'ProjectSharingClientRelationRepository';
  getAll: ProjectSharingClientRelationEntity[];
  getByCriteria: ProjectSharingClientRelationEntityConnection | null;
  getById: ProjectSharingClientRelationEntity | null;
  getByIds: ProjectSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectSharingClientRelationEntityEdge  {
  __typename?: 'ProjectSharingClientRelationEntityEdge';
  cursor: string;
  node: ProjectSharingClientRelationEntity | null;
}

export interface ProjectSharingClientRelationEntityConnection  {
  __typename?: 'ProjectSharingClientRelationEntityConnection';
  edges: ProjectSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectSharingClientRelationEntity  {
  __typename?: 'ProjectSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  project: ProjectEntity | null;
  projectId: ID;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface ProjectSearchResultItem extends SearchResultItemInterface {
  __typename?: 'ProjectSearchResultItem';
  datetime: DateTime | null;
  endDate: string;
  entityTypeId: UUID;
  id: ID;
  isDeleted: boolean;
  name: string;
  startDate: string;
}

export interface ProjectRoleTab extends RoleTabInterface {
  __typename?: 'ProjectRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ProjectRepository  {
  __typename?: 'ProjectRepository';
  autoPrefill: ProjectEntity;
  getAll: ProjectEntity[];
  getByCriteria: ProjectEntityConnection | null;
  getById: ProjectEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: ProjectEntity[];
  getBySession: ProjectEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface {
  __typename?: 'ProjectRecentlyOpenedResultItem';
  endDate: GqlDate;
  entityTypeId: UUID;
  id: ID;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  startDate: GqlDate;
}

export interface ProjectProfileData  {
  __typename?: 'ProjectProfileData';
  compactViewItems: ProjectCompactViewItems;
  drilldown: ProjectDrilldownModel;
  listViewItems: ProjectDataGridViewItems;
}

export interface ProjectPreviewViewTab  {
  __typename?: 'ProjectPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ProjectPreviewScreenProfile extends ProfileInterface {
  __typename?: 'ProjectPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ProjectPreviewProfile;
  useLang: boolean;
}

export interface ProjectPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'ProjectPreviewScreen';
  activeProfile: ProjectPreviewScreenProfile;
  data: ProjectProfileData;
  draftProfile: ProjectPreviewScreenProfile | null;
  entityData: ProjectEntityData | null;
  item: ProjectItem | null;
  name: string;
  profiles: ProjectPreviewScreenProfile[];
}

export interface ProjectPreviewProfile extends ProfileFilterBoxTabsInterface, ProfileTabsInterface, ProjectProfileInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'ProjectPreviewProfile';
  filter: ProjectFilterTab;
  quickFilter: QuickFilterTab;
  role: ProjectRoleTab;
  view: ProjectPreviewViewTab;
}

export interface ProjectPivotReportProfile extends PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, ProjectProfileInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'ProjectPivotReportProfile';
  filter: ProjectFilterTab;
  quickFilter: QuickFilterTab;
  role: ProjectRoleTab;
  view: ViewPivotReportTab;
}

export interface ProjectOpportunityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectOpportunityTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: OpportunityTabDataGridViewStat[];
  total: number;
}

export interface ProjectObjectiveRepository  {
  __typename?: 'ProjectObjectiveRepository';
  getAll: ProjectObjectiveEntity[];
  getByCriteria: ProjectObjectiveEntityConnection | null;
  getById: ProjectObjectiveEntity | null;
  getByIds: ProjectObjectiveEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectObjectiveEntityEdge  {
  __typename?: 'ProjectObjectiveEntityEdge';
  cursor: string;
  node: ProjectObjectiveEntity | null;
}

export interface ProjectObjectiveEntityConnection  {
  __typename?: 'ProjectObjectiveEntityConnection';
  edges: ProjectObjectiveEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectObjectiveEntity  {
  __typename?: 'ProjectObjectiveEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  project: ProjectEntity | null;
  projectId: ID;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revision: number | null;
  sortOrder: number;
}

export interface ProjectObjectiveData  {
  __typename?: 'ProjectObjectiveData';
  completedTotal: number;
  firstActivityStartDate: GqlDate | null;
  inProgressTotal: number;
  lastActivityEndDate: GqlDate | null;
  nextPlannedActivityStartDate: GqlDate | null;
  objective: ProjectObjectiveEntity | null;
  objectiveTotal: number;
  overdueTotal: number;
  status: ProjectObjectiveStatusEnum | null;
  total: number;
}

export interface ProjectNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ProjectListView extends ListViewInterface {
  __typename?: 'ProjectListView';
  displayColumn: UUID[];
  profile: ProjectPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface ProjectKPIRepository  {
  __typename?: 'ProjectKPIRepository';
  getAll: ProjectKPIEntity[];
  getByCriteria: ProjectKPIEntityConnection | null;
  getById: ProjectKPIEntity | null;
  getByIds: ProjectKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectKPIEntityEdge  {
  __typename?: 'ProjectKPIEntityEdge';
  cursor: string;
  node: ProjectKPIEntity | null;
}

export interface ProjectKPIEntityConnection  {
  __typename?: 'ProjectKPIEntityConnection';
  edges: ProjectKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectKPIEntity  {
  __typename?: 'ProjectKPIEntity';
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: ProjectKpiEnum;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  project: ProjectEntity | null;
  projectId: ID;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
}

export interface ProjectItem  {
  __typename?: 'ProjectItem';
  listViewItem: DataGridViewItem;
}

export interface ProjectGanttPeriodOptions  {
  __typename?: 'ProjectGanttPeriodOptions';
  period: ProjectGanttPeriod;
  projectId: ID;
}

export interface ProjectFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'ProjectFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ProjectFeedTabDataGridView  {
  __typename?: 'ProjectFeedTabDataGridView';
  feed: Feed;
}

export interface ProjectFeedEmailTabDataGridView  {
  __typename?: 'ProjectFeedEmailTabDataGridView';
  feed: Feed;
}

export interface ProjectFavoriteResultItem extends FavoriteResultItemInterface {
  __typename?: 'ProjectFavoriteResultItem';
  endDate: GqlDate;
  entityTypeId: UUID;
  id: ID;
  isDeleted: boolean;
  name: string;
  startDate: GqlDate;
}

export interface ProjectEntityEdge  {
  __typename?: 'ProjectEntityEdge';
  cursor: string;
  node: ProjectEntity | null;
}

export interface ProjectEntityData  {
  __typename?: 'ProjectEntityData';
  activities: ProjectStatusCount;
  entity: ProjectEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  objectives: ObjectiveStatusCount;
  openOpportunities: LeadOpptyAccountRelationEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  revenueAchieved: number;
}

export interface ProjectEntityConnection  {
  __typename?: 'ProjectEntityConnection';
  edges: ProjectEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectEntity  {
  __typename?: 'ProjectEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  activitiesCompleted: number | null;
  activitiesTotal: number | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  completionRate: number | null;
  contactRelations: ProjectContactRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  endDate: GqlDate;
  enrolledEmailSequences: number;
  fields: InterfaceFieldDataImplementors[];
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  name: string;
  objectives: ProjectObjectiveEntity[] | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  primaryContact: ContactEntity | null;
  projectObjectiveActivitiesDrilldown: CompactViewDrilldownModel;
  projectType: ProjectTypeEntity | null;
  projectTypeId: ID | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revenueGoal: CurrencyForeignField | null;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: ProjectSharingClientRelationEntityConnection | null;
  sharingUnits: ProjectSharingSalesUnitRelationEntityConnection | null;
  startDate: GqlDate | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  status: ProjectStatusEnum;
  tags: TagRelationEntityConnection | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
}

export interface ProjectDrilldownModel  {
  __typename?: 'ProjectDrilldownModel';
  listViewItems: ProjectDrilldownDataGridViewItems;
}

export interface ProjectDrilldownFilter  {
  __typename?: 'ProjectDrilldownFilter';
  ownerId: ID[] | null;
}

export interface ProjectDrilldownDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectDrilldownDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface ProjectDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ProjectDataExRelationRepository  {
  __typename?: 'ProjectDataExRelationRepository';
  getAll: ProjectDataExRelationEntity[];
  getByCriteria: ProjectDataExRelationEntityConnection | null;
  getById: ProjectDataExRelationEntity | null;
  getByIds: ProjectDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectDataExRelationEntityEdge  {
  __typename?: 'ProjectDataExRelationEntityEdge';
  cursor: string;
  node: ProjectDataExRelationEntity | null;
}

export interface ProjectDataExRelationEntityConnection  {
  __typename?: 'ProjectDataExRelationEntityConnection';
  edges: ProjectDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectDataExRelationEntity  {
  __typename?: 'ProjectDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  project: ProjectEntity | null;
  projectId: ID;
  revision: number | null;
}

export interface ProjectData  {
  __typename?: 'ProjectData';
  objectivesCompleted: number;
  objectivesTotal: number;
  project: ProjectEntity;
}

export interface ProjectContactRelationRepository  {
  __typename?: 'ProjectContactRelationRepository';
  getAll: ProjectContactRelationEntity[];
  getByCriteria: ProjectContactRelationEntityConnection | null;
  getById: ProjectContactRelationEntity | null;
  getByIds: ProjectContactRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProjectContactRelationEntityEdge  {
  __typename?: 'ProjectContactRelationEntityEdge';
  cursor: string;
  node: ProjectContactRelationEntity | null;
}

export interface ProjectContactRelationEntityConnection  {
  __typename?: 'ProjectContactRelationEntityConnection';
  edges: ProjectContactRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProjectContactRelationEntity  {
  __typename?: 'ProjectContactRelationEntity';
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  modified: DateTime | null;
  project: ProjectEntity | null;
  projectId: ID;
  revision: number | null;
}

export interface ProjectContactCardProperty  {
  __typename?: 'ProjectContactCardProperty';
  showArchivedRecords: boolean;
}

export interface ProjectCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectCompactViewItems';
  groups: ViewItemGroup[];
  items: ProjectCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface ProjectCompactViewItem extends ViewItemInterface {
  __typename?: 'ProjectCompactViewItem';
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  id: ID;
  isFavorite: boolean | null;
  name: string;
  owner: string;
  ownerId: string;
  ownerPicture: string | null;
  unit: string;
  unitId: string;
  unitPicture: string | null;
}

export interface ProjectCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ProjectActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'ProjectActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface ProjectActivityTabObjectiveView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectActivityTabObjectiveView';
  items: DataGridViewItem[];
  objectives: ProjectObjectiveData[];
  sessionId: string;
  total: number;
}

export interface ProjectActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProjectActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface ProjectActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'ProjectActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface ProjectAccountCardProperty  {
  __typename?: 'ProjectAccountCardProperty';
  showArchivedRecords: boolean;
}

export interface ProfileStandardRoleTab extends RoleTabInterface {
  __typename?: 'ProfileStandardRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ProfileSharingSalesUnitRelationRepository  {
  __typename?: 'ProfileSharingSalesUnitRelationRepository';
  getAll: ProfileSharingSalesUnitRelationEntity[];
  getByCriteria: ProfileSharingSalesUnitRelationEntityConnection | null;
  getById: ProfileSharingSalesUnitRelationEntity | null;
  getByIds: ProfileSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProfileSharingSalesUnitRelationEntityEdge  {
  __typename?: 'ProfileSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: ProfileSharingSalesUnitRelationEntity | null;
}

export interface ProfileSharingSalesUnitRelationEntityConnection  {
  __typename?: 'ProfileSharingSalesUnitRelationEntityConnection';
  edges: ProfileSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProfileSharingSalesUnitRelationEntity  {
  __typename?: 'ProfileSharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  profile: ProfileEntity | null;
  profileId: ID;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface ProfileSharingClientRelationRepository  {
  __typename?: 'ProfileSharingClientRelationRepository';
  getAll: ProfileSharingClientRelationEntity[];
  getByCriteria: ProfileSharingClientRelationEntityConnection | null;
  getById: ProfileSharingClientRelationEntity | null;
  getByIds: ProfileSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProfileSharingClientRelationEntityEdge  {
  __typename?: 'ProfileSharingClientRelationEntityEdge';
  cursor: string;
  node: ProfileSharingClientRelationEntity | null;
}

export interface ProfileSharingClientRelationEntityConnection  {
  __typename?: 'ProfileSharingClientRelationEntityConnection';
  edges: ProfileSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProfileSharingClientRelationEntity  {
  __typename?: 'ProfileSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  profile: ProfileEntity | null;
  profileId: ID;
  revision: number | null;
}

export interface ProfileSessionMetadata  {
  __typename?: 'ProfileSessionMetadata';
  entityApiName: string | null;
  extraArgs: JSONString | null;
  groupFieldId: ID | null;
  groupOption: GroupOption | null;
  profileId: ID;
  screenType: ScreenType;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ProfileRepository  {
  __typename?: 'ProfileRepository';
  getAll: ProfileEntity[];
  getByCriteria: ProfileEntityConnection | null;
  getById: ProfileEntity | null;
  getByIds: ProfileEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getProfilesForAdminByIds: ProfileEntity[];
  getProfilesInAdmin: ProfileEntityConnection | null;
  getStaticProfilesForAdmin: DefaultProfileEntity[];
}

export interface ProfileRelationRepository  {
  __typename?: 'ProfileRelationRepository';
  getAll: ProfileRelationEntity[];
  getByCriteria: ProfileRelationEntityConnection | null;
  getById: ProfileRelationEntity | null;
  getByIds: ProfileRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProfileRelationEntityEdge  {
  __typename?: 'ProfileRelationEntityEdge';
  cursor: string;
  node: ProfileRelationEntity | null;
}

export interface ProfileRelationEntityConnection  {
  __typename?: 'ProfileRelationEntityConnection';
  edges: ProfileRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProfileRelationEntity  {
  __typename?: 'ProfileRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  profile: ProfileEntity | null;
  profileId: ID;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
}

export interface ProfileFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'ProfileFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ProfileEntityEdge  {
  __typename?: 'ProfileEntityEdge';
  cursor: string;
  node: ProfileEntity | null;
}

export interface ProfileEntityConnection  {
  __typename?: 'ProfileEntityConnection';
  edges: ProfileEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProfileEntity  {
  __typename?: 'ProfileEntity';
  created: DateTime | null;
  entity: ScreenTypeEnum;
  entityApiName: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  pipelines: UUID[];
  revision: number | null;
  settings: JSONString;
  shareMode: ShareModeEnum | null;
  syncEnabled: boolean | null;
  syncEntity: ReportEntity | null;
  syncEntityId: ID | null;
  type: ProfileTypeEnum | null;
  useLang: boolean | null;
}

export interface ProductsOfAccountDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductsOfAccountDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface ProductWhiteSpaceView  {
  __typename?: 'ProductWhiteSpaceView';
  drilldown: DrilldownModel;
  ofAccount: AccountProductWhiteSpaceView;
}

export interface ProductWhiteSpaceDataView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductWhiteSpaceDataView';
  columns: WhiteSpaceColumnItem[];
  items: WhiteSpaceDataItem[];
  sessionId: string;
  total: number;
}

export interface ProductTypeRepository  {
  __typename?: 'ProductTypeRepository';
  getAll: ProductTypeEntity[];
  getByCriteria: ProductTypeEntityConnection | null;
  getById: ProductTypeEntity | null;
  getByIds: ProductTypeEntity[];
  getDraftById: ProductTypeEntity;
  getDrafts: ProductTypeEntity[];
  getPublished: ProductTypeEntity[];
}

export interface ProductTypeEntityEdge  {
  __typename?: 'ProductTypeEntityEdge';
  cursor: string;
  node: ProductTypeEntity | null;
}

export interface ProductTypeEntityConnection  {
  __typename?: 'ProductTypeEntityConnection';
  edges: ProductTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductTypeEntity  {
  __typename?: 'ProductTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  opptyProductRelationType: OpptyProductRelationTypeEntity | null;
  opptyProductRelationTypeId: ID;
  revision: number | null;
}

export interface ProductTrendViewDrilldown  {
  __typename?: 'ProductTrendViewDrilldown';
  listViewItems: OpportunityDrilldownDataGridViewItems;
}

export interface ProductTrendView  {
  __typename?: 'ProductTrendView';
  ofAccount: AccountProductTrendView;
}

export interface ProductTrendDataView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductTrendDataView';
  items: ProductDataItem[];
  sessionId: string;
  total: number;
  totalSum: number | null;
}

export interface ProductTableReportProfile extends ProductProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, TableReportTabsInterface {
  __typename?: 'ProductTableReportProfile';
  filter: ProductFilterTab;
  quickFilter: QuickFilterTab;
  view: ViewTableReportTab;
}

export interface ProductTabDrilldown  {
  __typename?: 'ProductTabDrilldown';
  itemDrilldown: ProductTrendViewDrilldown;
}

export interface ProductTabDataGridViewOptions  {
  __typename?: 'ProductTabDataGridViewOptions';
  filterByPeriod: PeriodOption;
  filterByPipelineId: UUID[] | null;
  filterByProductCategoryId: UUID[] | null;
  showChildProducts: boolean;
}

export interface ProductTabDataGridView  {
  __typename?: 'ProductTabDataGridView';
  ofAccount: ProductsOfAccountDataGridViewItems;
}

export interface ProductSeriesView  {
  __typename?: 'ProductSeriesView';
  series: ProductGraphSeries;
}

export interface ProductSection  {
  __typename?: 'ProductSection';
  id: ID;
  name: string;
}

export interface ProductRepository  {
  __typename?: 'ProductRepository';
  getAll: ProductEntity[];
  getByCriteria: ProductEntityConnection | null;
  getById: ProductEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: ProductEntity[];
  getBySession: ProductEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getForPipeline: ProductEntity[];
}

export interface ProductPricingTabDataGridView  {
  __typename?: 'ProductPricingTabDataGridView';
  ofAccount: AccountProductPricingTabDataGridView;
}

export interface ProductPricingRegistry  {
  __typename?: 'ProductPricingRegistry';
  getAvailablePriceListsForEntity: UUID[];
  getProductPriceListPrice: ProductPriceListPriceResult[];
}

export interface ProductPricingPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'ProductPricingPipelineHubItemEntity';
  configuration: ProductPricingHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface ProductPricingHubItemConfig  {
  __typename?: 'ProductPricingHubItemConfig';
  customerPrice: boolean;
  priceSchedule: boolean;
}

export interface ProductPricingDetailTabs  {
  __typename?: 'ProductPricingDetailTabs';
  grid: ProductPricingTabDataGridView;
}

export interface ProductPriceProperty  {
  __typename?: 'ProductPriceProperty';
  decimalPlaces: number;
}

export interface ProductPriceListRepository  {
  __typename?: 'ProductPriceListRepository';
  getAll: ProductPriceListEntity[];
  getByCriteria: ProductPriceListEntityConnection | null;
  getById: ProductPriceListEntity | null;
  getByIds: ProductPriceListEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProductPriceListPriceSettings  {
  __typename?: 'ProductPriceListPriceSettings';
  access: ProductPriceListPriceAccessEnum;
  accessRoles: UUID[] | null;
}

export interface ProductPriceListPriceResult  {
  __typename?: 'ProductPriceListPriceResult';
  price: number;
  productId: ID;
  source: ProductPriceListPriceSourceEnum | null;
  sourceName: string | null;
}

export interface ProductPriceListPriceRepository  {
  __typename?: 'ProductPriceListPriceRepository';
  getAll: ProductPriceListPriceEntity[];
  getByCriteria: ProductPriceListPriceEntityConnection | null;
  getById: ProductPriceListPriceEntity | null;
  getByIds: ProductPriceListPriceEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProductPriceListPriceEntityEdge  {
  __typename?: 'ProductPriceListPriceEntityEdge';
  cursor: string;
  node: ProductPriceListPriceEntity | null;
}

export interface ProductPriceListPriceEntityConnection  {
  __typename?: 'ProductPriceListPriceEntityConnection';
  edges: ProductPriceListPriceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductPriceListPriceEntity  {
  __typename?: 'ProductPriceListPriceEntity';
  created: DateTime | null;
  currency: CurrencyEntity | null;
  currencyId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  price: number | null;
  product: ProductEntity | null;
  productId: ID;
  productPriceList: ProductPriceListEntity | null;
  productPriceListId: ID;
  revision: number | null;
  settings: ProductPriceListPriceSettings;
}

export interface ProductPriceListEntityEdge  {
  __typename?: 'ProductPriceListEntityEdge';
  cursor: string;
  node: ProductPriceListEntity | null;
}

export interface ProductPriceListEntityConnection  {
  __typename?: 'ProductPriceListEntityConnection';
  edges: ProductPriceListEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductPriceListEntity  {
  __typename?: 'ProductPriceListEntity';
  created: DateTime | null;
  description: string | null;
  endDate: GqlDate | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isActive: boolean | null;
  isDefault: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  productPriceListPrices: ProductPriceListPriceEntityConnection | null;
  revision: number | null;
  rules: FieldFilter | null;
  startDate: GqlDate | null;
  status: ProductPriceListStatusEnum;
  type: ProductPriceListTypeEnum | null;
}

export interface ProductPivotReportProfile extends PivotReportTabsInterface, ProductProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface {
  __typename?: 'ProductPivotReportProfile';
  filter: ProductFilterTab;
  quickFilter: QuickFilterTab;
  role: OpportunityRoleTab;
  view: ViewPivotReportTab;
}

export interface ProductPipelinesObject  {
  __typename?: 'ProductPipelinesObject';
  allowedPipelines: AccessPipelinesEnum;
  pipelines: ID[];
}

export interface ProductPipelineRelationRepository  {
  __typename?: 'ProductPipelineRelationRepository';
  getAll: ProductPipelineRelationEntity[];
  getByCriteria: ProductPipelineRelationEntityConnection | null;
  getById: ProductPipelineRelationEntity | null;
  getByIds: ProductPipelineRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProductPipelineRelationEntityEdge  {
  __typename?: 'ProductPipelineRelationEntityEdge';
  cursor: string;
  node: ProductPipelineRelationEntity | null;
}

export interface ProductPipelineRelationEntityConnection  {
  __typename?: 'ProductPipelineRelationEntityConnection';
  edges: ProductPipelineRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductPipelineRelationEntity  {
  __typename?: 'ProductPipelineRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  pipeline: PipelineEntity | null;
  pipelineId: ID;
  product: ProductEntity | null;
  productId: ID;
  revision: number | null;
}

export interface ProductGraphSeries  {
  __typename?: 'ProductGraphSeries';
  date: GqlDate[] | null;
  periodEnd: GqlDate | null;
  periodStart: GqlDate | null;
  series: ProductGraphItem[] | null;
}

export interface ProductGraphItem  {
  __typename?: 'ProductGraphItem';
  id: UUID | null;
  startValue: number | null;
  value: number[];
}

export interface ProductFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'ProductFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ProductEntityEdge  {
  __typename?: 'ProductEntityEdge';
  cursor: string;
  node: ProductEntity | null;
}

export interface ProductEntityData  {
  __typename?: 'ProductEntityData';
  entity: ProductEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface ProductEntityConnection  {
  __typename?: 'ProductEntityConnection';
  edges: ProductEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductEntity  {
  __typename?: 'ProductEntity';
  allowedPipelines: AccessPipelinesEnum | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  description: string | null;
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  opptyProductRelationTypeId: UUID;
  picture: CloudObjectEntity | null;
  pictureId: ID | null;
  priceListPrice: number | null;
  productCategory: ProductCategoryEntity | null;
  productCategoryId: ID | null;
  productPipelineRelations: ProductPipelineRelationEntityConnection | null;
  productPipelines: ProductPipelinesObject | null;
  productType: ProductTypeEntity | null;
  productTypeId: ID | null;
  revision: number | null;
  sku: string | null;
  unitSymbol: string | null;
}

export interface ProductDrilldownFilter  {
  __typename?: 'ProductDrilldownFilter';
  accountId: ID | null;
}

export interface ProductDetailTabs  {
  __typename?: 'ProductDetailTabs';
  drilldown: ProductTabDrilldown;
  grid: ProductTabDataGridView;
  trendView: ProductTrendView;
  whiteSpaceView: ProductWhiteSpaceView;
}

export interface ProductDataItem extends ViewItemInterface {
  __typename?: 'ProductDataItem';
  id: ID;
  name: string;
  pictureUrl: string | null;
  total: number;
  unitSymbol: string | null;
}

export interface ProductDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ProductDataExRelationRepository  {
  __typename?: 'ProductDataExRelationRepository';
  getAll: ProductDataExRelationEntity[];
  getByCriteria: ProductDataExRelationEntityConnection | null;
  getById: ProductDataExRelationEntity | null;
  getByIds: ProductDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProductDataExRelationEntityEdge  {
  __typename?: 'ProductDataExRelationEntityEdge';
  cursor: string;
  node: ProductDataExRelationEntity | null;
}

export interface ProductDataExRelationEntityConnection  {
  __typename?: 'ProductDataExRelationEntityConnection';
  edges: ProductDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductDataExRelationEntity  {
  __typename?: 'ProductDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  product: ProductEntity | null;
  productId: ID;
  revision: number | null;
}

export interface ProductCategoryTrendView  {
  __typename?: 'ProductCategoryTrendView';
  ofAccount: AccountProductCategoryTrendView;
}

export interface ProductCategoryTrendDataView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductCategoryTrendDataView';
  items: ProductDataItem[];
  sessionId: string;
  total: number;
  totalSum: number | null;
}

export interface ProductCategoryRepository  {
  __typename?: 'ProductCategoryRepository';
  getAll: ProductCategoryEntity[];
  getByCriteria: ProductCategoryEntityConnection | null;
  getById: ProductCategoryEntity | null;
  getByIds: ProductCategoryEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProductCategoryGridView  {
  __typename?: 'ProductCategoryGridView';
  ofAccount: ProductCategoriesOfAccountDataGridViewItems;
}

export interface ProductCategoryEntityEdge  {
  __typename?: 'ProductCategoryEntityEdge';
  cursor: string;
  node: ProductCategoryEntity | null;
}

export interface ProductCategoryEntityConnection  {
  __typename?: 'ProductCategoryEntityConnection';
  edges: ProductCategoryEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProductCategoryEntity  {
  __typename?: 'ProductCategoryEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  parent: ProductCategoryEntity | null;
  parentId: ID | null;
  productRelations: ProductEntityConnection | null;
  revision: number | null;
}

export interface ProductCategoryDetailTabs  {
  __typename?: 'ProductCategoryDetailTabs';
  drilldown: ProductTabDrilldown;
  grid: ProductCategoryGridView;
  trendView: ProductCategoryTrendView;
  whiteSpaceView: ProductWhiteSpaceView;
}

export interface ProductCategoriesOfAccountDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ProductCategoriesOfAccountDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface ProcessWebhookHeader  {
  __typename?: 'ProcessWebhookHeader';
  encrypted: boolean | null;
  key: string | null;
  value: string | null;
}

export interface ProcessWebhookBasicAuth  {
  __typename?: 'ProcessWebhookBasicAuth';
  password: string | null;
  username: string | null;
}

export interface ProcessWebhook  {
  __typename?: 'ProcessWebhook';
  advancedContent: string | null;
  basicAuth: ProcessWebhookBasicAuth | null;
  headers: ProcessWebhookHeader[] | null;
  requestFormat: ProcessWebhookRequestFormat;
  requestType: ProcessWebhookRequestType;
  simpleContent: string[] | null;
  timeFormat: ProcessWebhookTimeFormat;
  url: string;
}

export interface ProcessUpdateRelatedRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessUpdateRelatedRecordNode';
  entity: ProcessEntityTemplate | null;
  entityApiName: string | null;
  filter: FieldFilter | null;
  id: ID;
  name: string;
  parentId: ID | null;
  relation: ProcessRecordNodeRelationEnum;
  relationLookupFieldId: string | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
}

export interface ProcessUpdateRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessUpdateRecordNode';
  entity: ProcessEntityTemplate | null;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
}

export interface ProcessUpdateAiFieldsNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessUpdateAiFieldsNode';
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
  smartAiFieldIds: UUID[];
}

export interface ProcessUnenrollEmailSequenceNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessUnenrollEmailSequenceNode';
  emailSequenceId: UUID;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessUnarchiveRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessUnarchiveRecordNode';
  id: ID;
  name: string;
  newClosingDate: GqlDate | null;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessTriggerProcessNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessTriggerProcessNode';
  filter: FieldFilter | null;
  id: ID;
  name: string;
  parentId: ID | null;
  processId: UUID;
  relationLookupFieldId: string | null;
  schedule: ProcessNodeSchedule | null;
  triggerRelation: ProcessRecordNodeRelationEnum | null;
  triggerRelationEntityApiName: string | null;
  triggerRelationSender: boolean | null;
}

export interface ProcessTimelineResult  {
  __typename?: 'ProcessTimelineResult';
  errorCount: number;
  items: ProcessTimelineItem[];
  successCount: number;
  warningCount: number;
}

export interface ProcessTimelineItem  {
  __typename?: 'ProcessTimelineItem';
  endTime: DateTime;
  errorCount: number;
  startTime: DateTime;
  successCount: number;
  warningCount: number;
}

export interface ProcessTestEmailResultPayload extends ProcessResultStatus {
  __typename?: 'ProcessTestEmailResultPayload';
  errorCode: number | null;
  reason: string | null;
  status: ProcessStatusEnum;
  wasSent: boolean | null;
}

export interface ProcessTemplatesView  {
  __typename?: 'ProcessTemplatesView';
  actionType: ProcessActionTypeIconEnum | null;
  isRecommended: boolean;
  searchText: string | null;
}

export interface ProcessTemplateRepository  {
  __typename?: 'ProcessTemplateRepository';
  getAll: ProcessTemplateEntity[];
  getByCriteria: ProcessTemplateEntityConnection | null;
  getById: ProcessTemplateEntity | null;
  getByIds: ProcessTemplateEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProcessTemplateEntityEdge  {
  __typename?: 'ProcessTemplateEntityEdge';
  cursor: string;
  node: ProcessTemplateEntity | null;
}

export interface ProcessTemplateEntityConnection  {
  __typename?: 'ProcessTemplateEntityConnection';
  edges: ProcessTemplateEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProcessTemplateEntity  {
  __typename?: 'ProcessTemplateEntity';
  actionTypes: ProcessActionTypeIconEnum[] | null;
  created: DateTime | null;
  description: string | null;
  documents: CloudObjectRelationEntity[] | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isRecommended: boolean | null;
  modified: DateTime | null;
  name: string;
  settings: ProcessSchema | null;
  triggerEntityName: EntityNameEnum | null;
  triggerType: ProcessTriggerTypeEnum | null;
}

export interface ProcessTabDataGridViewOptions  {
  __typename?: 'ProcessTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByStatus: ProcessStatusEnum[] | null;
  filterByTagIds: ID[] | null;
  showActive: boolean;
  showInactive: boolean;
}

export interface ProcessSendWebhookNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessSendWebhookNode';
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
  webhook: ProcessWebhook;
}

export interface ProcessSendEmailNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessSendEmailNode';
  email: ProcessNodeEmail;
  id: ID;
  isMass: boolean;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessSchema  {
  __typename?: 'ProcessSchema';
  nodes: ProcessNodeInterfaceImplementors[];
  timezone: string | null;
  trigger: ProcessTrigger;
}

export interface ProcessScheduledActionRepository  {
  __typename?: 'ProcessScheduledActionRepository';
  getAll: ProcessScheduledActionEntity[];
  getByCriteria: ProcessScheduledActionEntityConnection | null;
  getById: ProcessScheduledActionEntity | null;
  getByIds: ProcessScheduledActionEntity[];
}

export interface ProcessScheduledActionEntityEdge  {
  __typename?: 'ProcessScheduledActionEntityEdge';
  cursor: string;
  node: ProcessScheduledActionEntity | null;
}

export interface ProcessScheduledActionEntityConnection  {
  __typename?: 'ProcessScheduledActionEntityConnection';
  edges: ProcessScheduledActionEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProcessScheduledActionEntity  {
  __typename?: 'ProcessScheduledActionEntity';
  actionName: string;
  actor: ClientEntity | null;
  actorId: ID | null;
  application: ApplicationEntity | null;
  applicationId: ID | null;
  entityApiName: string | null;
  entityId: ID;
  entityName: EntityNameEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  process: ProcessEntity | null;
  processId: ID;
  processUrl: string | null;
  scheduledDate: DateTime;
  triggeredDate: DateTime;
}

export interface ProcessScheduleTrigger extends ScheduleInterface {
  __typename?: 'ProcessScheduleTrigger';
  date: DateTime | null;
  dayOfMonth: number[] | null;
  dayOfWeek: number[] | null;
  entityApiName: string | null;
  entityType: EntityNameEnum;
  timeOfDay: number | null;
}

export interface ProcessRepository  {
  __typename?: 'ProcessRepository';
  convertProcessSchemasToDescriptions: string[];
  getActivityTimeline: ProcessTimelineResult;
  getAll: ProcessEntity[];
  getByCriteria: ProcessEntityConnection | null;
  getById: ProcessEntity | null;
  getByIds: ProcessEntity[];
  getByProcessCriteria: ProcessEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getProcessesWithManualTrigger: ProcessEntity[];
  getProcessesWithScheduledActions: ProcessEntity[];
  getRecentExecutions: RecentExecutionItem[];
  getTriggeringProcesses: ProcessEntity[];
}

export interface ProcessRecordTrigger extends ProcessActorInterface {
  __typename?: 'ProcessRecordTrigger';
  actor: ProcessRecordTriggerActorEnum;
  actorUnits: UUID[];
  actorUsers: UUID[];
  applications: UUID[] | null;
  changedFields: UUID[] | null;
  entityApiName: string | null;
  entityType: EntityNameEnum;
  event: ProcessRecordTriggerEventEnum;
  parentEntityType: EntityNameEnum | null;
}

export interface ProcessQualifyRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessQualifyRecordNode';
  entity: ProcessEntityTemplate | null;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessOrderBy  {
  __typename?: 'ProcessOrderBy';
  created: OrderByEnum | null;
  deactivationReason: OrderByEnum | null;
  description: OrderByEnum | null;
  id: OrderByEnum | null;
  isDeleted: OrderByEnum | null;
  isEnabled: OrderByEnum | null;
  lastProcessRun: OrderByEnum | null;
  lastSchemaChange: OrderByEnum | null;
  lastStatusChange: OrderByEnum | null;
  modified: OrderByEnum | null;
  name: OrderByEnum | null;
  owner: ClientOrderByNested[] | null;
  ownerId: OrderByEnum | null;
  recordTriggerEvent: OrderByEnum | null;
  status: OrderByEnum | null;
  triggerEntityApiName: OrderByEnum | null;
  triggerEntityName: OrderByEnum | null;
  triggerType: OrderByEnum | null;
  type: OrderByEnum | null;
}

export interface ProcessOnlineFormTrigger  {
  __typename?: 'ProcessOnlineFormTrigger';
  entityApiName: string | null;
  entityType: EntityNameEnum;
  onlineForms: UUID[];
  recordApiName: string | null;
  recordType: EntityNameEnum;
}

export interface ProcessNodeSchedule  {
  __typename?: 'ProcessNodeSchedule';
  date: DateTime | null;
  offset: number;
  offsetFieldId: UUID | null;
  offsetUnit: ProcessNodeScheduleUnitEnum;
}

export interface ProcessNodeEmail extends EmailDataInterface {
  __typename?: 'ProcessNodeEmail';
  attachments: UUID[];
  bcc: SendEmailRecipient[];
  body: string;
  cc: SendEmailRecipient[];
  emailTemplateId: UUID | null;
  isHtmlTemplate: boolean | null;
  linkRecipients: boolean | null;
  linkTriggerEntity: boolean | null;
  recipients: SendEmailRecipient[];
  sender: ProcessNodeEmailSender;
  senderCompanyEmailId: UUID | null;
  shareMode: ShareModeEnum | null;
  signature: string | null;
  subject: string;
}

export interface ProcessManualTrigger extends ProcessActorInterface {
  __typename?: 'ProcessManualTrigger';
  actor: ProcessRecordTriggerActorEnum;
  actorUnits: UUID[];
  actorUsers: UUID[];
  entityApiName: string | null;
  entityType: EntityNameEnum;
}

export interface ProcessListView  {
  __typename?: 'ProcessListView';
  fieldIds: UUID[];
  listingOptions: ProcessTabDataGridViewOptions;
  orderBy: ProcessOrderBy[];
  searchText: string | null;
}

export interface ProcessLinkRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessLinkRecordNode';
  entityApiName: string | null;
  id: ID;
  linkAll: boolean;
  name: string;
  parentId: ID | null;
  recordFieldId: UUID | null;
  recordFilter: FieldFilter | null;
  recordIdentificationType: ProcessRecordIdentificationType;
  relation: ProcessRecordNodeRelationEnum;
  relationLookupFieldId: string | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
  triggeredRecordFieldId: UUID | null;
}

export interface ProcessFilterNode extends ProcessNodeInterface, ProfileFilterBoxTabInterface {
  __typename?: 'ProcessFilterNode';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  id: ID;
  isEnabled: boolean;
  name: string;
  operator: FilterGroupOperator;
  parentId: ID | null;
}

export interface ProcessEvaluationResultPayload extends ProcessResultStatus {
  __typename?: 'ProcessEvaluationResultPayload';
  activityLogId: UUID | null;
  needsRetry: boolean;
  reason: string | null;
  status: ProcessStatusEnum;
}

export interface ProcessEntityTemplate  {
  __typename?: 'ProcessEntityTemplate';
  input: JSONString;
  operations: ProcessEntityOperation[];
}

export interface ProcessEntityOperationExtras  {
  __typename?: 'ProcessEntityOperationExtras';
  keepOwnerAsEditor: boolean | null;
  sendInvitations: boolean | null;
}

export interface ProcessEntityOperation  {
  __typename?: 'ProcessEntityOperation';
  extras: ProcessEntityOperationExtras | null;
  fieldId: UUID;
  mapping: EntityOperationMapping | null;
  operation: ProcessEntityOperationEnum | null;
  triggeredLookupRelationFieldId: UUID | null;
  triggeredRecordFieldId: UUID | null;
}

export interface ProcessEntityEdge  {
  __typename?: 'ProcessEntityEdge';
  cursor: string;
  node: ProcessEntity | null;
}

export interface ProcessEntityConnection  {
  __typename?: 'ProcessEntityConnection';
  edges: ProcessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProcessEntity  {
  __typename?: 'ProcessEntity';
  activity: ProcessTimelineResult;
  activityLogs: ProcessActivityLogEntityConnection | null;
  aiConversation: AiConversationItem[] | null;
  created: DateTime | null;
  deactivationReason: ProcessDeactivationReasonEnum | null;
  description: string | null;
  documents: CloudObjectRelationEntity[] | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean | null;
  lastProcessRun: DateTime | null;
  lastSchemaChange: DateTime | null;
  lastStatusChange: DateTime | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  recordTriggerEvent: ProcessRecordTriggerEventEnum | null;
  settings: ProcessSchema | null;
  status: ProcessStatusEnum | null;
  tags: TagRelationEntityConnection | null;
  triggerEntityApiName: string | null;
  triggerEntityName: EntityNameEnum | null;
  triggerType: ProcessTriggerTypeEnum | null;
  type: ProcessTypeEnum;
}

export interface ProcessEnrollEmailSequenceNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessEnrollEmailSequenceNode';
  emailSequenceId: UUID;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessDetailView  {
  __typename?: 'ProcessDetailView';
  process: AiProcessData | null;
}

export interface ProcessDescriptionPayload  {
  __typename?: 'ProcessDescriptionPayload';
  clientMutationId: string | null;
  url: string;
}

export interface ProcessCreateRelatedRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessCreateRelatedRecordNode';
  entity: ProcessEntityTemplate | null;
  entityApiName: string | null;
  id: ID;
  name: string;
  parentId: ID | null;
  relation: ProcessRecordNodeRelationEnum;
  relationLookupFieldId: string | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
}

export interface ProcessCreateRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessCreateRecordNode';
  entity: ProcessEntityTemplate | null;
  entityApiName: string | null;
  entityType: EntityNameEnum;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
}

export interface ProcessCopyRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessCopyRecordNode';
  entity: ProcessEntityTemplate | null;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
  triggerProcess: boolean;
  triggerProcessId: UUID | null;
}

export interface ProcessChangeOwnershipNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessChangeOwnershipNode';
  assigneeType: ProcessChangeOwnershipAssigneeType;
  clientIds: ID[];
  id: ID;
  name: string;
  parentId: ID | null;
  salesUnitIds: ID[];
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessBuilderNotificationSettings  {
  __typename?: 'ProcessBuilderNotificationSettings';
  Errors: boolean;
  IsActive: boolean;
  Warnings: boolean;
}

export interface ProcessArchiveRecordNode extends ProcessNodeInterface, ProcessScheduleInterface {
  __typename?: 'ProcessArchiveRecordNode';
  completeRelatedActivities: boolean;
  entity: ProcessEntityTemplate | null;
  id: ID;
  name: string;
  parentId: ID | null;
  schedule: ProcessNodeSchedule | null;
}

export interface ProcessAffectedByConditionResultPayload extends ProcessResultStatus {
  __typename?: 'ProcessAffectedByConditionResultPayload';
  count: AffectedByConditionCount[];
  reason: string | null;
  status: ProcessStatusEnum;
}

export interface ProcessActivityLogRepository  {
  __typename?: 'ProcessActivityLogRepository';
  getAll: ProcessActivityLogEntity[];
  getByCriteria: ProcessActivityLogEntityConnection | null;
  getById: ProcessActivityLogEntity | null;
  getByIds: ProcessActivityLogEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getDownloadUrl: string;
}

export interface ProcessActivityLogLineRepository  {
  __typename?: 'ProcessActivityLogLineRepository';
  getAll: ProcessActivityLogLineEntity[];
  getByCriteria: ProcessActivityLogLineEntityConnection | null;
  getById: ProcessActivityLogLineEntity | null;
  getByIds: ProcessActivityLogLineEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ProcessActivityLogLineEntityEdge  {
  __typename?: 'ProcessActivityLogLineEntityEdge';
  cursor: string;
  node: ProcessActivityLogLineEntity | null;
}

export interface ProcessActivityLogLineEntityConnection  {
  __typename?: 'ProcessActivityLogLineEntityConnection';
  edges: ProcessActivityLogLineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProcessActivityLogLineEntity  {
  __typename?: 'ProcessActivityLogLineEntity';
  created: DateTime | null;
  executedAt: DateTime | null;
  formattedText: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isVisible: boolean | null;
  modified: DateTime | null;
  processActivityLog: ProcessActivityLogEntity | null;
  processActivityLogId: ID;
  sortOrder: number;
  status: ProcessStatusEnum | null;
}

export interface ProcessActivityLogEntityEdge  {
  __typename?: 'ProcessActivityLogEntityEdge';
  cursor: string;
  node: ProcessActivityLogEntity | null;
}

export interface ProcessActivityLogEntityConnection  {
  __typename?: 'ProcessActivityLogEntityConnection';
  edges: ProcessActivityLogEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ProcessActivityLogEntity  {
  __typename?: 'ProcessActivityLogEntity';
  actor: ClientEntity | null;
  actorId: ID | null;
  application: ApplicationEntity | null;
  applicationId: ID;
  cpuRunTime: number | null;
  created: DateTime | null;
  endTime: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isTestRun: boolean | null;
  lines: ProcessActivityLogLineEntityConnection | null;
  modified: DateTime | null;
  parentProcessIds: JSONString | null;
  process: ProcessEntity | null;
  processId: ID;
  recordName: string | null;
  runId: ID | null;
  startTime: DateTime;
  status: ProcessStatusEnum;
}

export interface PrintReportStatus  {
  __typename?: 'PrintReportStatus';
  error: boolean | null;
  url: string | null;
}

export interface PreviewPinnedFields  {
  __typename?: 'PreviewPinnedFields';
  entityTypeId: UUID;
  pinnedFields: UUID[];
}

export interface PreviewPinnedCharts  {
  __typename?: 'PreviewPinnedCharts';
  entityTypeId: UUID;
  pinnedCharts: ID[];
}

export interface PreviewEntityHealthResult  {
  __typename?: 'PreviewEntityHealthResult';
  id: ID;
  indicators: EntityHealthIndicator[];
  name: string;
  score: number;
}

export interface Position  {
  __typename?: 'Position';
  x: number;
  y: number;
}

export interface PivotTable extends ReportStructureItem {
  __typename?: 'PivotTable';
  calculationFieldId: ID | null;
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
  parentId: ID | null;
  sortOrder: number;
  tabs: PivotReportTabsInterfaceImplementors;
}

export interface PivotReportTotal  {
  __typename?: 'PivotReportTotal';
  isEnabled: boolean;
  position: ReportTotalPosition;
}

export interface PivotField  {
  __typename?: 'PivotField';
  fieldId: ID;
  groupIntervals: GroupInterval[] | null;
  groupOption: GroupOption | null;
  sortFieldId: ID | null;
  sortOrder: SortOrder | null;
}

export interface PipelineViewItem extends ViewItemInterface {
  __typename?: 'PipelineViewItem';
  extraFieldValues: string[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  hotStalledPriorityFlag: number;
  id: ID;
  isExcluded: boolean | null;
  isWithinCurrentTarget: boolean | null;
  leadStepMetadata: LeadStepMetadata | null;
  name: string;
  opportunityStepMetadata: OpportunityStepMetadata[] | null;
  opportunityWonStepMetadata: OpportunityWonStepMetadata | null;
  ranking: number;
  role: ShareActorEnum;
  tags: number[] | null;
  value: JSONString | null;
}

export interface PipelineView extends BoardViewInterface {
  __typename?: 'PipelineView';
  includeLeadStep: boolean;
  profile: OpportunityPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface PipelineRepository  {
  __typename?: 'PipelineRepository';
  getAll: PipelineEntity[];
  getByCriteria: PipelineEntityConnection | null;
  getById: PipelineEntity | null;
  getByIds: PipelineEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getDefaultPipeline: PipelineEntity;
}

export interface PipelinePerformanceWonStepExtractView  {
  __typename?: 'PipelinePerformanceWonStepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInPipeline: number;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
  successRateCount: number;
  successRateSession: UUID | null;
  successRateTotalCount: number;
  successRateTotalSession: UUID | null;
  totalOpportunitiesSession: UUID | null;
  wonArchiveOpportunitiesValue: number;
}

export interface PipelinePerformanceStepExtractView  {
  __typename?: 'PipelinePerformanceStepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  dropOffRateCount: number;
  dropOffRateSession: UUID | null;
  dropOffRateTotalCount: number;
  dropOffRateTotalSession: UUID | null;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
  velocityOverdueCount: number;
  velocityOverdueSession: UUID | null;
}

export interface PipelinePerformanceStep  {
  __typename?: 'PipelinePerformanceStep';
  id: ID;
  isWon: boolean;
  name: string;
  percent: number;
}

export interface PipelinePerformanceLeadStepExtractView  {
  __typename?: 'PipelinePerformanceLeadStepExtractView';
  archiveLeadsCount: number;
  archiveLeadsSession: UUID | null;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  leadsCount: number;
  leadsSession: UUID | null;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
}

export interface PipelinePerformanceData  {
  __typename?: 'PipelinePerformanceData';
  aggregatedData: PipelinePerformanceAggregation[];
  color: number;
  id: ID;
  name: string;
  series: PipelinePerformanceChartSeries[] | null;
  steps: PipelinePerformanceStep[];
}

export interface PipelinePerformanceChartSeries  {
  __typename?: 'PipelinePerformanceChartSeries';
  items: PipelinePerformanceChartItem[];
  type: PipelinePerformanceSerieType;
}

export interface PipelinePerformanceChartItem  {
  __typename?: 'PipelinePerformanceChartItem';
  count: number | null;
  countConversion: number | null;
  days: number | null;
  id: ID | null;
  value: number | null;
  valueConversion: number | null;
}

export interface PipelinePerformanceAggregation  {
  __typename?: 'PipelinePerformanceAggregation';
  count: number | null;
  session: UUID | null;
  type: PipelinePerformanceAggregationType;
  value: number | null;
}

export interface PipelineInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'PipelineInterfaceFieldData';
  fieldId: UUID;
  pipelineColor: number | null;
  pipelineName: string | null;
}

export interface PipelineEntityEdge  {
  __typename?: 'PipelineEntityEdge';
  cursor: string;
  node: PipelineEntity | null;
}

export interface PipelineEntityConnection  {
  __typename?: 'PipelineEntityConnection';
  edges: PipelineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface PipelineEntity  {
  __typename?: 'PipelineEntity';
  color: number;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  opportunityTypes: OpportunityTypeEntity[];
  revision: number | null;
  steps: StepEntity[];
}

export interface PipelineArchiveViewItem extends ViewItemInterface {
  __typename?: 'PipelineArchiveViewItem';
  extraFieldValues: string[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  hotStalledPriorityFlag: number;
  id: ID;
  isExcluded: boolean | null;
  isWithinCurrentTarget: boolean | null;
  name: string;
  ranking: number;
  role: ShareActorEnum;
  tags: number[] | null;
  value: JSONString | null;
}

export interface PhoneRepository  {
  __typename?: 'PhoneRepository';
  checkForUnsubscribed: SendTextMessageRecipient[];
  getAll: PhoneEntity[];
  getAllForAdmin: PhoneEntity[];
  getByCriteria: PhoneEntityConnection | null;
  getById: PhoneEntity | null;
  getByIds: PhoneEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface PhoneEntityEdge  {
  __typename?: 'PhoneEntityEdge';
  cursor: string;
  node: PhoneEntity | null;
}

export interface PhoneEntityConnection  {
  __typename?: 'PhoneEntityConnection';
  edges: PhoneEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface PhoneEntity  {
  __typename?: 'PhoneEntity';
  callForwardingPhone: string | null;
  created: DateTime | null;
  enabled: boolean;
  errorCode: number | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  messageForwardingEmail: string | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID | null;
  phoneNumber: string | null;
  revision: number | null;
  twilioCallerSid: string | null;
  type: PhoneTypeEnum;
}

export interface PersonificationEntityData  {
  __typename?: 'PersonificationEntityData';
  accountId: UUID | null;
  contactId: UUID | null;
  customEntityIds: CustomEntityID[] | null;
  leadId: UUID | null;
  opportunityId: UUID | null;
  primary: EntityLacotaType | null;
  projectId: UUID | null;
  quoteId: UUID | null;
}

export interface PersonalizeBodyForSharingEmailTemplatePayload  {
  __typename?: 'PersonalizeBodyForSharingEmailTemplatePayload';
  clientMutationId: string | null;
  result: string | null;
}

export interface PersonalizeBodyEmailTemplatePayload  {
  __typename?: 'PersonalizeBodyEmailTemplatePayload';
  clientMutationId: string | null;
  result: string | null;
}

export interface PersonalEmailAccount  {
  __typename?: 'PersonalEmailAccount';
  clientId: UUID;
  email: string;
  service: EmailServiceTypeEnum | null;
}

export interface PeriodOption  {
  __typename?: 'PeriodOption';
  period: PeriodKind;
  periodCustomFrom: GqlDate | null;
  periodCustomTo: GqlDate | null;
}

export interface PeriodCompareOption  {
  __typename?: 'PeriodCompareOption';
  period: PeriodCompareKind;
  periodCustomFrom: GqlDate | null;
  periodCustomTo: GqlDate | null;
}

export interface PdfOptions  {
  __typename?: 'PdfOptions';
  content: ReportContent;
  landscape: boolean;
  pageHeight: number;
  pageNumbers: boolean;
  pageWidth: number;
  scale: number;
}

export interface PartnerEntity  {
  __typename?: 'PartnerEntity';
  activeCustomers: PartnerActiveCustomers | null;
  agreedToGtac: number | null;
  billingDetail: BillingDetail | null;
  commissionAmountEur: string | null;
  commissionAmountGbp: string | null;
  commissionAmountUsd: string | null;
  companiesRepresented: string | null;
  companyFocus: PartnerCompanyFocus | null;
  companySize: PartnerCompanySize | null;
  created: DateTime | null;
  crmAccountId: string | null;
  crmSpaceId: string | null;
  deleted: DateTime | null;
  email: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: PartnerPermsEnum[];
  isDeleted: boolean | null;
  landingPage: string | null;
  ltvAmountEur: string | null;
  ltvAmountGbp: string | null;
  ltvAmountUsd: string | null;
  modified: DateTime | null;
  name: string | null;
  orders: OrderEntity[] | null;
  representative: UserProfileEntity | null;
  representativeId: ID | null;
  state: string | null;
  status: string | null;
  subscriptions: SubscriptionEntity[] | null;
  subscriptionsCount: number | null;
  targetCustomers: PartnerTargetCustomers | null;
  tier: PartnerTier | null;
  type: number | null;
  url: string | null;
  users: UserProfileEntity[] | null;
  yearFounded: number | null;
}

export interface ParentAccountRelationTypeRepository  {
  __typename?: 'ParentAccountRelationTypeRepository';
  getAll: ParentAccountRelationTypeEntity[];
  getByCriteria: ParentAccountRelationTypeEntityConnection | null;
  getById: ParentAccountRelationTypeEntity | null;
  getByIds: ParentAccountRelationTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ParentAccountRelationTypeEntityEdge  {
  __typename?: 'ParentAccountRelationTypeEntityEdge';
  cursor: string;
  node: ParentAccountRelationTypeEntity | null;
}

export interface ParentAccountRelationTypeEntityConnection  {
  __typename?: 'ParentAccountRelationTypeEntityConnection';
  edges: ParentAccountRelationTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ParentAccountRelationTypeEntity  {
  __typename?: 'ParentAccountRelationTypeEntity';
  childLabel: string;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  parentLabel: string;
  revision: number | null;
}

export interface ParentAccountCardProperty  {
  __typename?: 'ParentAccountCardProperty';
  showArchivedRecords: boolean;
}

export interface PandaDocService  {
  __typename?: 'PandaDocService';
  oAuthUrl: string;
}

export interface PageInfo  {
  __typename?: 'PageInfo';
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
}

export interface OverdueTasks  {
  __typename?: 'OverdueTasks';
  overdueTasksCount: number;
  overdueTasksList: OverdueTaskOverviewAgendaConnection | null;
}

export interface OverdueTaskOverviewAgendaEdge  {
  __typename?: 'OverdueTaskOverviewAgendaEdge';
  cursor: string;
  node: OverdueTaskOverviewAgenda | null;
}

export interface OverdueTaskOverviewAgendaConnection  {
  __typename?: 'OverdueTaskOverviewAgendaConnection';
  edges: OverdueTaskOverviewAgendaEdge[];
  pageInfo: PageInfo;
}

export interface OverdueTaskOverviewAgenda extends OverdueTaskOverview {
  __typename?: 'OverdueTaskOverviewAgenda';
  dueDate: GqlDate | null;
  id: ID;
  ownerName: string;
  priority: PriorityEnum;
  reminder: DateTime | null;
  subject: string;
  taskType: ActivityTypeIconEnum;
}

export interface OrgRelationshipTypeInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'OrgRelationshipTypeInterfaceFieldData';
  fieldId: UUID;
  orgRelationshipType: OrgRelationshipTypeEnum;
}

export interface OrgChartRelation  {
  __typename?: 'OrgChartRelation';
  contact: ContactEntity | null;
  contactId: UUID;
  relatedContacts: OrgChartRelatedContact[] | null;
}

export interface OrgChartRelatedContact  {
  __typename?: 'OrgChartRelatedContact';
  account: AccountEntity | null;
  accountId: UUID;
  contact: ContactEntity | null;
  contactId: UUID;
  relation: OrgChartContactRelation;
}

export interface OrgChartLeadOpptyNodeEntity  {
  __typename?: 'OrgChartLeadOpptyNodeEntity';
  accountRoles: AccountRoleEntity[];
  comment: string | null;
  contact: OrgChartContactUnion | null;
  contactId: UUID;
  groupId: ID | null;
  parentContact: OrgChartContactUnion | null;
  parentContactId: UUID | null;
  position: Position | null;
  relationship: OrgRelationshipTypeEnum;
  salesRoles: SalesRoleEntity[] | null;
}

export interface OrgChartLeadOpptyGroupEntity  {
  __typename?: 'OrgChartLeadOpptyGroupEntity';
  color: number;
  id: ID;
  name: string;
  position: Rectangle;
}

export interface OrgChartContactNodeEntity  {
  __typename?: 'OrgChartContactNodeEntity';
  accountRoles: AccountRoleEntity[];
  comment: string | null;
  contact: OrgChartContactUnion | null;
  contactId: UUID;
  isDetached: boolean;
  parentContact: OrgChartContactUnion | null;
  parentContactId: UUID | null;
  relation: OrgChartAssistantRelation | null;
  relationship: OrgRelationshipTypeEnum;
  sibling: boolean;
}

export interface OrderRelatedDocumentEntityEdge  {
  __typename?: 'OrderRelatedDocumentEntityEdge';
  cursor: string;
  node: OrderRelatedDocumentEntity | null;
}

export interface OrderRelatedDocumentEntityConnection  {
  __typename?: 'OrderRelatedDocumentEntityConnection';
  edges: OrderRelatedDocumentEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OrderRelatedDocumentEntity  {
  __typename?: 'OrderRelatedDocumentEntity';
  amount: string | null;
  created: DateTime | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: OrderRelatedDocumentPermsEnum[];
  invoice: Invoice | null;
  number: string | null;
  remainingBalance: number | null;
  type: OrderRelatedDocumentTypeEnum | null;
}

export interface OrderHistoryEntityEdge  {
  __typename?: 'OrderHistoryEntityEdge';
  cursor: string;
  node: OrderHistoryEntity | null;
}

export interface OrderHistoryEntityConnection  {
  __typename?: 'OrderHistoryEntityConnection';
  edges: OrderHistoryEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OrderHistoryEntity  {
  __typename?: 'OrderHistoryEntity';
  comment: string | null;
  created: DateTime | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReadOnlyPermsEnum[];
  orderId: number | null;
  status: OrderHistoryStatusEnum | null;
}

export interface OrderEntity  {
  __typename?: 'OrderEntity';
  action: OrderActionEnum | null;
  amount: string | null;
  billingDetail: BillingDetail | null;
  created: DateTime | null;
  createdBy: Issuer | null;
  createdByUserId: string | null;
  currency: string | null;
  extrasIncluded: boolean | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: OrderPermsEnum[];
  invoice: Invoice | null;
  items: FeeItem[] | null;
  licensesCount: number | null;
  mrrAddonsCount: number | null;
  mrrAddonsPrice: number | null;
  mrrComment: string | null;
  mrrComments: string | null;
  mrrCount: number | null;
  mrrFrom: DateTime | null;
  mrrIsCounted: boolean | null;
  mrrIsCountedAny: boolean | null;
  mrrLicensesCount: number | null;
  mrrLicensesPrice: number | null;
  mrrMonths: number | null;
  mrrMonthsCount: number | null;
  mrrTotal: number | null;
  mrrTotalPrice: number | null;
  mrrValidFrom: DateTime | null;
  netAmount: string | null;
  note: string | null;
  number: string | null;
  orderHistory: OrderHistoryEntityConnection | null;
  orderRelatedDocuments: OrderRelatedDocumentEntityConnection | null;
  partnerCommissionAmount: string | null;
  paymentDueDate: GqlDate | null;
  productSkus: string[] | null;
  referralPartner: PartnerEntity | null;
  referralPartnerId: ID | null;
  status: OrderStatusEnum | null;
  subscription: SubscriptionEntity | null;
  subscriptionId: ID | null;
  supplier: SupplierEntity | null;
  supplierId: ID | null;
  taxAmount: string | null;
  typeOfSale: OrderTypeOfSaleEnum | null;
}

export interface OptionsInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'OptionsInterfaceFieldData';
  fieldId: UUID;
  options: string[];
}

export interface OpptyStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'OpptyStatusInterfaceFieldData';
  fieldId: UUID;
  opptyStatus: OpptyStatusEnum | null;
}

export interface OpptyRevenueScheduleRepository  {
  __typename?: 'OpptyRevenueScheduleRepository';
  getAll: OpptyRevenueScheduleEntity[];
  getByCriteria: OpptyRevenueScheduleEntityConnection | null;
  getById: OpptyRevenueScheduleEntity | null;
  getByIds: OpptyRevenueScheduleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyRevenueSchedulePeriodRepository  {
  __typename?: 'OpptyRevenueSchedulePeriodRepository';
  getAll: OpptyRevenueSchedulePeriodEntity[];
  getByCriteria: OpptyRevenueSchedulePeriodEntityConnection | null;
  getById: OpptyRevenueSchedulePeriodEntity | null;
  getByIds: OpptyRevenueSchedulePeriodEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyRevenueSchedulePeriodEntityEdge  {
  __typename?: 'OpptyRevenueSchedulePeriodEntityEdge';
  cursor: string;
  node: OpptyRevenueSchedulePeriodEntity | null;
}

export interface OpptyRevenueSchedulePeriodEntityConnection  {
  __typename?: 'OpptyRevenueSchedulePeriodEntityConnection';
  edges: OpptyRevenueSchedulePeriodEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyRevenueSchedulePeriodEntity  {
  __typename?: 'OpptyRevenueSchedulePeriodEntity';
  created: DateTime | null;
  date: GqlDate | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  opptyRevenueSchedule: OpptyRevenueScheduleEntity | null;
  opptyRevenueScheduleId: ID;
  revision: number | null;
  transactionId: ID;
  value: number | null;
}

export interface OpptyRevenueScheduleEntityEdge  {
  __typename?: 'OpptyRevenueScheduleEntityEdge';
  cursor: string;
  node: OpptyRevenueScheduleEntity | null;
}

export interface OpptyRevenueScheduleEntityConnection  {
  __typename?: 'OpptyRevenueScheduleEntityConnection';
  edges: OpptyRevenueScheduleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyRevenueScheduleEntity  {
  __typename?: 'OpptyRevenueScheduleEntity';
  cancelationDate: GqlDate | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  periodCount: number | null;
  periodType: RevenueSchedulePeriodTypeEnum | null;
  periods: OpptyRevenueSchedulePeriodEntityConnection | null;
  revision: number | null;
  startDate: GqlDate | null;
}

export interface OpptyRecurrenceRepository  {
  __typename?: 'OpptyRecurrenceRepository';
  getAll: OpptyRecurrenceEntity[];
  getByCriteria: OpptyRecurrenceEntityConnection | null;
  getById: OpptyRecurrenceEntity | null;
  getByIds: OpptyRecurrenceEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyRecurrenceEntityEdge  {
  __typename?: 'OpptyRecurrenceEntityEdge';
  cursor: string;
  node: OpptyRecurrenceEntity | null;
}

export interface OpptyRecurrenceEntityConnection  {
  __typename?: 'OpptyRecurrenceEntityConnection';
  edges: OpptyRecurrenceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyRecurrenceEntity  {
  __typename?: 'OpptyRecurrenceEntity';
  condition: number | null;
  created: DateTime | null;
  day: DateDayEnum | null;
  dayOfWeek: number | null;
  endDate: GqlDate | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  month: DateMonthEnum | null;
  occurEvery: number | null;
  occurrencesCount: number | null;
  oppty: OpportunityEntity | null;
  opptyId: ID;
  revision: number | null;
  startDate: GqlDate;
  step: StepEntity | null;
  stepId: ID;
  type: RecurrenceTypeEnum | null;
  week: DateWeekEnum | null;
}

export interface OpptyProductRelationTypeRepository  {
  __typename?: 'OpptyProductRelationTypeRepository';
  getAll: OpptyProductRelationTypeEntity[];
  getByCriteria: OpptyProductRelationTypeEntityConnection | null;
  getById: OpptyProductRelationTypeEntity | null;
  getByIds: OpptyProductRelationTypeEntity[];
  getDraftById: OpptyProductRelationTypeEntity;
  getDrafts: OpptyProductRelationTypeEntity[];
  getPublished: OpptyProductRelationTypeEntity[];
}

export interface OpptyProductRelationTypeEntityEdge  {
  __typename?: 'OpptyProductRelationTypeEntityEdge';
  cursor: string;
  node: OpptyProductRelationTypeEntity | null;
}

export interface OpptyProductRelationTypeEntityConnection  {
  __typename?: 'OpptyProductRelationTypeEntityConnection';
  edges: OpptyProductRelationTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyProductRelationTypeEntity  {
  __typename?: 'OpptyProductRelationTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  productType: ProductTypeEntity | null;
  productTypeId: UUID;
  revision: number | null;
}

export interface OpptyProductRelationRevenueScheduleRepository  {
  __typename?: 'OpptyProductRelationRevenueScheduleRepository';
  getAll: OpptyProductRelationRevenueScheduleEntity[];
  getByCriteria: OpptyProductRelationRevenueScheduleEntityConnection | null;
  getById: OpptyProductRelationRevenueScheduleEntity | null;
  getByIds: OpptyProductRelationRevenueScheduleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyProductRelationRevenueSchedulePeriodRepository  {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodRepository';
  getAll: OpptyProductRelationRevenueSchedulePeriodEntity[];
  getByCriteria: OpptyProductRelationRevenueSchedulePeriodEntityConnection | null;
  getById: OpptyProductRelationRevenueSchedulePeriodEntity | null;
  getByIds: OpptyProductRelationRevenueSchedulePeriodEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyProductRelationRevenueSchedulePeriodEntityEdge  {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodEntityEdge';
  cursor: string;
  node: OpptyProductRelationRevenueSchedulePeriodEntity | null;
}

export interface OpptyProductRelationRevenueSchedulePeriodEntityConnection  {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodEntityConnection';
  edges: OpptyProductRelationRevenueSchedulePeriodEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyProductRelationRevenueSchedulePeriodEntity  {
  __typename?: 'OpptyProductRelationRevenueSchedulePeriodEntity';
  created: DateTime | null;
  date: GqlDate | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  opptyProductRelationRevenueSchedule: OpptyProductRelationRevenueScheduleEntity | null;
  opptyProductRelationRevenueScheduleId: ID;
  revision: number | null;
  transactionId: ID;
  value: number | null;
}

export interface OpptyProductRelationRevenueScheduleEntityEdge  {
  __typename?: 'OpptyProductRelationRevenueScheduleEntityEdge';
  cursor: string;
  node: OpptyProductRelationRevenueScheduleEntity | null;
}

export interface OpptyProductRelationRevenueScheduleEntityConnection  {
  __typename?: 'OpptyProductRelationRevenueScheduleEntityConnection';
  edges: OpptyProductRelationRevenueScheduleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyProductRelationRevenueScheduleEntity  {
  __typename?: 'OpptyProductRelationRevenueScheduleEntity';
  cancelationDate: GqlDate | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  periodCount: number | null;
  periodType: RevenueSchedulePeriodTypeEnum | null;
  periods: OpptyProductRelationRevenueSchedulePeriodEntityConnection | null;
  revision: number | null;
  startDate: GqlDate | null;
}

export interface OpptyProductRelationRepository  {
  __typename?: 'OpptyProductRelationRepository';
  getAll: OpptyProductRelationEntity[];
  getByCriteria: OpptyProductRelationEntityConnection | null;
  getById: OpptyProductRelationEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: OpptyProductRelationEntity[];
  getBySession: OpptyProductRelationEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyProductRelationEntityEdge  {
  __typename?: 'OpptyProductRelationEntityEdge';
  cursor: string;
  node: OpptyProductRelationEntity | null;
}

export interface OpptyProductRelationEntityConnection  {
  __typename?: 'OpptyProductRelationEntityConnection';
  edges: OpptyProductRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyProductRelationEntity  {
  __typename?: 'OpptyProductRelationEntity';
  amount: number | null;
  comment: string | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  discountPercentage: number | null;
  discountValue: number | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  onlineForm: OnlineFormEntity | null;
  onlineFormField: FieldEntity | null;
  onlineFormFieldId: ID | null;
  onlineFormId: ID | null;
  oppty: OpportunityEntity | null;
  opptyId: ID | null;
  opptyProductRelationType: OpptyProductRelationTypeEntity | null;
  opptyProductRelationTypeId: ID | null;
  pairedOpptyProductRelation: OpptyProductRelationEntity | null;
  pairedOpptyProductRelationId: ID | null;
  price: number | null;
  product: ProductEntity | null;
  productId: ID;
  quantity: number | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revenueSchedule: OpptyProductRelationRevenueScheduleEntity | null;
  revision: number | null;
  sectionId: ID | null;
  sortOrder: number | null;
}

export interface OpptyProductRelationDrilldownFilter  {
  __typename?: 'OpptyProductRelationDrilldownFilter';
  productId: ID | null;
}

export interface OpptyProductRelationDataExRelationRepository  {
  __typename?: 'OpptyProductRelationDataExRelationRepository';
  getAll: OpptyProductRelationDataExRelationEntity[];
  getByCriteria: OpptyProductRelationDataExRelationEntityConnection | null;
  getById: OpptyProductRelationDataExRelationEntity | null;
  getByIds: OpptyProductRelationDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpptyProductRelationDataExRelationEntityEdge  {
  __typename?: 'OpptyProductRelationDataExRelationEntityEdge';
  cursor: string;
  node: OpptyProductRelationDataExRelationEntity | null;
}

export interface OpptyProductRelationDataExRelationEntityConnection  {
  __typename?: 'OpptyProductRelationDataExRelationEntityConnection';
  edges: OpptyProductRelationDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpptyProductRelationDataExRelationEntity  {
  __typename?: 'OpptyProductRelationDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  opptyProductRelation: OpptyProductRelationEntity | null;
  opptyProductRelationId: ID;
  revision: number | null;
}

export interface OpptyCardProperty  {
  __typename?: 'OpptyCardProperty';
  showArchivedRecords: boolean;
}

export interface OpportunityWonStepMetadata  {
  __typename?: 'OpportunityWonStepMetadata';
  age: number;
  comparisonTargetValue: number | null;
  currentOpptyValue: number;
  currentTargetValue: number;
  stepId: ID | null;
}

export interface OpportunityTypeRepository  {
  __typename?: 'OpportunityTypeRepository';
  getAll: OpportunityTypeEntity[];
  getByCriteria: OpportunityTypeEntityConnection | null;
  getById: OpportunityTypeEntity | null;
  getByIds: OpportunityTypeEntity[];
  getByPipeline: OpportunityTypeEntity | null;
  getDraftById: OpportunityTypeEntity;
  getDrafts: OpportunityTypeEntity[];
  getPublished: OpportunityTypeEntity[];
}

export interface OpportunityTypeEntityEdge  {
  __typename?: 'OpportunityTypeEntityEdge';
  cursor: string;
  node: OpportunityTypeEntity | null;
}

export interface OpportunityTypeEntityConnection  {
  __typename?: 'OpportunityTypeEntityConnection';
  edges: OpportunityTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpportunityTypeEntity  {
  __typename?: 'OpportunityTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  formLost: JSONString;
  formLostApi: Form | null;
  formQualify: JSONString;
  formQualifyApi: UUID[] | null;
  formWon: JSONString;
  formWonApi: UUID[] | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  pipeline: PipelineEntity | null;
  pipelineId: ID;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface OpportunityTarget  {
  __typename?: 'OpportunityTarget';
  comparisonPeriod: DatePeriod | null;
  comparisonValue: number | null;
  currentPeriod: DatePeriod;
  currentValue: number;
  goalValue: number | null;
}

export interface OpportunityTabDataGridViewStat  {
  __typename?: 'OpportunityTabDataGridViewStat';
  count: number;
  status: OpptyStatusEnum;
  value: number;
}

export interface OpportunityTabDataGridViewOptions  {
  __typename?: 'OpportunityTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByPipelineId: ID[] | null;
  filterByStatus: OpptyStatusEnum[] | null;
  filterByTags: ID[] | null;
  searchQuery: string | null;
}

export interface OpportunityTabDataGridView  {
  __typename?: 'OpportunityTabDataGridView';
  ofAccount: AccountOpportunityTabDataGridView;
  ofContact: ContactOpportunityTabDataGridView;
  ofProject: ProjectOpportunityTabDataGridView;
}

export interface OpportunityStepMetadata  {
  __typename?: 'OpportunityStepMetadata';
  age: number;
  comparisonTargetValue: number | null;
  currentOpptyValue: number;
  currentTargetValue: number;
  stepId: ID | null;
}

export interface OpportunitySearchResultItem extends SearchResultItemInterface {
  __typename?: 'OpportunitySearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  pipelineColor: number;
  pipelineName: string;
}

export interface OpportunityRoleTab extends RoleTabInterface {
  __typename?: 'OpportunityRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface OpportunityRepository  {
  __typename?: 'OpportunityRepository';
  aiAutoPrefill: OpportunityAutoPrefill;
  autoPrefill: OpportunityEntity;
  getAll: OpportunityEntity[];
  getByCriteria: OpportunityEntityConnection | null;
  getById: OpportunityEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: OpportunityEntity[];
  getBySession: OpportunityEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface OpportunityReportTargetTab extends TargetTabInterface {
  __typename?: 'OpportunityReportTargetTab';
  goal: number;
  isVisible: boolean;
  showTargetOnTop: boolean | null;
  targetPeriodCompare: PeriodCompareOption;
  targetPeriodCurrent: PeriodOption;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
}

export interface OpportunityRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface, RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: 'OpportunityRecentlyOpenedResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  pipelineColor: number;
  pipelineName: string;
}

export interface OpportunityQuoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityQuoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityProfileData  {
  __typename?: 'OpportunityProfileData';
  bubbleViewItems: OpportunityBubbleViewItems;
  compactViewItems: OpportunityCompactViewItems;
  listViewItems: OpportunityDataGridViewItems;
  mapViewItems: OpportunityMapViewItems;
  pipelineViewItems: OpportunityPipelineViewItems;
  targetView: OpportunityTarget;
}

export interface OpportunityPreviewViewTab  {
  __typename?: 'OpportunityPreviewViewTab';
  bubbleChartSizeCalculatedBy: SizeCalculatedBy;
  gridColumns: GridColumnsOutput[];
  groupBy: OpportunityGroupBy;
  showCardFitness: boolean;
  showCardLabels: boolean;
  showCardRanking: boolean;
  showCardValue: boolean;
  showCardVelocity: boolean;
  showExcludedItems: boolean;
  showExtraFieldIds: UUID[] | null;
  showOutsideTarget: boolean;
  showUnassignedLead: boolean;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface OpportunityPreviewTargetTab extends TargetTabInterface {
  __typename?: 'OpportunityPreviewTargetTab';
  goal: number;
  showTargetOnTop: boolean | null;
  targetDefinition: UUID | null;
  targetPeriodCompare: PeriodCompareOption;
  targetPeriodCurrent: PeriodOption;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
  targetValueType: TargetValueType;
}

export interface OpportunityPreviewScreenProfile extends ProfileInterface {
  __typename?: 'OpportunityPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: OpportunityPreviewProfile;
  useLang: boolean;
}

export interface OpportunityPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'OpportunityPreviewScreen';
  activeProfile: OpportunityPreviewScreenProfile;
  data: OpportunityProfileData;
  draftProfile: OpportunityPreviewScreenProfile | null;
  entityData: OpportunityEntityData | null;
  item: OpportunityItem | null;
  name: string;
  profiles: OpportunityPreviewScreenProfile[];
}

export interface OpportunityPreviewProfile extends LeadOpportunityProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface, TargetProfileInterface {
  __typename?: 'OpportunityPreviewProfile';
  filter: LeadOpportunityFilterTab;
  quickFilter: QuickFilterTab;
  role: OpportunityRoleTab;
  salesPipeline: ID[] | null;
  target: OpportunityPreviewTargetTab;
  view: OpportunityPreviewViewTab;
}

export interface OpportunityPipelineViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'OpportunityPipelineViewItems';
  columns: OpportunityPipelineColumnItems[];
  sessionId: string;
  target: OpportunityTarget;
  total: number;
}

export interface OpportunityPipelineColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'OpportunityPipelineColumnItems';
  items: PipelineViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: StepSummaryInfo;
  total: number;
}

export interface OpportunityNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityMapViewItems  {
  __typename?: 'OpportunityMapViewItems';
  compactListSessionId: string | null;
  insufficientDataItems: number | null;
  insufficientListSessionFirstItemId: ID | null;
  insufficientListSessionId: string | null;
  isResultTooLarge: boolean;
  items: MapViewInterfaceImplementors[];
  missingGeoLocationItems: number | null;
}

export interface OpportunityMapViewItem extends MapViewInterface {
  __typename?: 'OpportunityMapViewItem';
  entityId: ID;
  entityType: EntityNameEnum;
  entityTypeId: UUID;
  geoLocation: GeoLocationEntity;
  name: string;
  status: OpptyStatusEnum;
  value: number | null;
}

export interface OpportunityListView extends ListViewInterface {
  __typename?: 'OpportunityListView';
  displayColumn: UUID[];
  profile: OpportunityPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface OpportunityKPIFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'OpportunityKPIFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface OpportunityItem  {
  __typename?: 'OpportunityItem';
  bubbleViewItem: OpportunityBubbleViewItem | null;
  compactViewItem: OpportunityCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
  pipelineViewItem: PipelineViewItem | null;
}

export interface OpportunityForecastView  {
  __typename?: 'OpportunityForecastView';
  column: ForecastColumnsType[];
  drilldownFields: ID[];
  field: ID;
  graphHeight: number | null;
  groupBy: ID | null;
  hideEmptyRows: boolean;
  isDrilldownEnabled: boolean;
  owner: ForecastOwner[];
  period: ForecastPeriodOption;
  quota: OpportunityForecastQuota;
  rollUpPeriod: ForecastPeriodKind | null;
  showGraph: boolean;
}

export interface OpportunityForecastQuotaItemValue  {
  __typename?: 'OpportunityForecastQuotaItemValue';
  date: GqlDate;
  value: number;
}

export interface OpportunityForecastQuotaItem  {
  __typename?: 'OpportunityForecastQuotaItem';
  id: ID;
  splitType: OpportunityForecastQuotaSplitType;
  values: OpportunityForecastQuotaItemValue[];
}

export interface OpportunityForecastQuota  {
  __typename?: 'OpportunityForecastQuota';
  comparisonType: ForecastPerformanceComparisonType;
  isEnabled: boolean;
  items: OpportunityForecastQuotaItem[];
  value: number;
}

export interface OpportunityForecastProperties  {
  __typename?: 'OpportunityForecastProperties';
  type: ForecastType;
}

export interface OpportunityForecastProfileTab extends ForecastTabItem {
  __typename?: 'OpportunityForecastProfileTab';
  id: ID;
  opportunityForecastProfile: OpportunityForecastProfile | null;
}

export interface OpportunityForecastProfile extends LeadOpptyPipelineProfileInterface, OpportunityProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface {
  __typename?: 'OpportunityForecastProfile';
  filter: OpportunityFilterTab;
  leadProcess: UUID[] | null;
  properties: OpportunityForecastProperties;
  salesPipeline: ID[] | null;
  view: OpportunityForecastView;
}

export interface OpportunityFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'OpportunityFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface OpportunityFeedTabDataGridView  {
  __typename?: 'OpportunityFeedTabDataGridView';
  feed: Feed;
}

export interface OpportunityFeedEmailTabDataGridView  {
  __typename?: 'OpportunityFeedEmailTabDataGridView';
  feed: Feed;
}

export interface OpportunityFavoriteResultItem extends FavoriteResultItemInterface, FavoriteResultItemIsArchivedInterface {
  __typename?: 'OpportunityFavoriteResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  pipelineColor: number;
  pipelineName: string;
}

export interface OpportunityEntityEdge  {
  __typename?: 'OpportunityEntityEdge';
  cursor: string;
  node: OpportunityEntity | null;
}

export interface OpportunityEntityData  {
  __typename?: 'OpportunityEntityData';
  accounts: LeadOpptyAccountRelationEntityConnection | null;
  contactRelations: OrgChartRelation[] | null;
  contacts: LeadOpptyContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: LeadOpportunityEntity;
  fields: InterfaceFieldDataImplementors[];
  fitnessDescription: FitnessDescription;
  groups: OrgChartLeadOpptyGroupEntity[];
  isExcluded: boolean | null;
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  linesOfInfluence: ContactLineOfInfluence[];
  nodes: OrgChartLeadOpptyNodeEntity[] | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  relations: OrgChartRelation[] | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface OpportunityEntityConnection  {
  __typename?: 'OpportunityEntityConnection';
  edges: OpportunityEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OpportunityEntity  {
  __typename?: 'OpportunityEntity';
  accountRelations: LeadOpptyAccountRelationEntityConnection | null;
  activeQuote: QuoteEntity | null;
  activeQuoteId: ID | null;
  approval: ApprovalEntity | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  closingDate: GqlDate;
  contactRelations: LeadOpptyContactRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  daysInStep: number;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  enrolledEmailSequences: number;
  fields: InterfaceFieldDataImplementors[];
  fitness: WarningLevelEnum;
  fitnessDescription: FitnessDescription;
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isArchived: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  isValueAutoCalculate: boolean | null;
  labelFlag: number | null;
  leadSource: DataEntity | null;
  leadSourceId: ID | null;
  lostDate: DateTime | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  name: string;
  opptyRecurrence: OpptyRecurrenceEntity | null;
  opptyType: OpportunityTypeEntity | null;
  opptyTypeId: ID | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  primaryAccount: AccountEntity | null;
  primaryContact: ContactEntity | null;
  productCurrency: CurrencyEntity | null;
  productCurrencyId: ID | null;
  productPriceList: ProductPriceListEntity | null;
  productPriceListId: ID | null;
  productRelations: OpptyProductRelationEntityConnection | null;
  productSections: ProductSection[] | null;
  qualifyDate: DateTime | null;
  quickAccountEmail: string | null;
  quickAccountName: string | null;
  quickAccountPhone: string | null;
  quickContactName: string | null;
  quickEmail: string | null;
  quickPhone: string | null;
  quoteRelations: QuoteEntityConnection | null;
  ranking: number | null;
  reasonOfClose: DataEntity | null;
  reasonOfCloseDescription: string | null;
  reasonOfCloseId: ID | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revenueSchedule: OpptyRevenueScheduleEntity | null;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: LeadOpptySharingClientRelationEntityConnection | null;
  sharingUnits: LeadOpptySharingSalesUnitRelationEntityConnection | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  status: OpptyStatusEnum;
  step: StepEntity | null;
  stepChecklists: StepChecklistActivityItem[];
  stepId: ID;
  tableName: string;
  tags: TagRelationEntityConnection | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  value: CurrencyForeignField | null;
  viewerIdsPerSalesUnit: UUID[];
  wasQualified: boolean | null;
  wonDate: DateTime | null;
}

export interface OpportunityDrilldownFilter  {
  __typename?: 'OpportunityDrilldownFilter';
  ownerId: ID[] | null;
}

export interface OpportunityDrilldownDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityDrilldownDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface OpportunityDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityDashboardView  {
  __typename?: 'OpportunityDashboardView';
  data: DashboardGraphItemInterfaceImplementors[] | null;
}

export interface OpportunityDashboardProfileView extends DashboardViewInterface {
  __typename?: 'OpportunityDashboardProfileView';
  drilldownFields: ID[];
  graphs: DashboardGraphOpportunityNameType[];
}

export interface OpportunityDashboardProfileTab extends DashboardTabItem {
  __typename?: 'OpportunityDashboardProfileTab';
  id: ID;
  opportunityDashboardProfile: OpportunityDashboardProfile | null;
}

export interface OpportunityDashboardProfile extends LeadOpportunityProfileInterface, LeadOpptyPipelineProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, RoleProfileInterface, TargetProfileInterface {
  __typename?: 'OpportunityDashboardProfile';
  filter: LeadOpportunityFilterTab;
  leadProcess: UUID[] | null;
  role: OpportunityRoleTab;
  salesPipeline: ID[] | null;
  target: OpportunityReportTargetTab;
  view: OpportunityDashboardProfileView;
}

export interface OpportunityCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityCompactViewItems';
  groups: ViewItemGroup[];
  items: OpportunityCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityCompactViewItem extends ViewItemInterface {
  __typename?: 'OpportunityCompactViewItem';
  closingDate: GqlDate | null;
  daysInQueue: number | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  id: ID;
  isFavorite: boolean | null;
  labelFlag: number | null;
  leadTypeId: ID | null;
  name: string;
  opptyTypeId: ID | null;
  owner: string | null;
  ownerId: string | null;
  ownerPicture: string | null;
  ranking: number | null;
  sortName: FieldDataContainer;
  unit: string;
  unitId: string;
  unitPicture: string | null;
  value: string | null;
  velocity: number | null;
}

export interface OpportunityCompactView extends CompactViewInterface {
  __typename?: 'OpportunityCompactView';
  feedListingOptions: FeedTabDataGridViewOptions;
  profile: OpportunityPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface OpportunityCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityBubbleViewItems extends ListingViewInterface, SnapshotDateRangedDataInterface {
  __typename?: 'OpportunityBubbleViewItems';
  items: OpportunityBubbleViewItem[];
  maxValue: number;
  minValue: number;
  sessionId: string;
  stepSummary: StepSummaryInfo[];
  target: OpportunityTarget;
  total: number;
}

export interface OpportunityBubbleViewItem extends ViewItemInterface {
  __typename?: 'OpportunityBubbleViewItem';
  date: DateTime;
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  hotStalledPriorityFlag: number;
  id: ID;
  isExcluded: boolean | null;
  isWithinCurrentTarget: boolean;
  name: string;
  opportunityStepMetadata: OpportunityStepMetadata[] | null;
  opportunityWonStepMetadata: OpportunityWonStepMetadata | null;
  ranking: number;
  stepId: ID;
  value: number;
}

export interface OpportunityAutoPrefill  {
  __typename?: 'OpportunityAutoPrefill';
  entity: OpportunityEntity | null;
  fieldIds: UUID[];
}

export interface OpportunityArchiveViewTab  {
  __typename?: 'OpportunityArchiveViewTab';
  gridColumns: GridColumnsOutput[];
  groupBy: OpportunityGroupBy;
  showCardFitness: boolean;
  showCardLabels: boolean;
  showCardRanking: boolean;
  showCardValue: boolean;
  showExtraFieldIds: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface OpportunityArchiveTargetTab extends TargetTabInterface {
  __typename?: 'OpportunityArchiveTargetTab';
  showTargetOnTop: boolean | null;
  targetPeriodCompare: PeriodCompareOption;
  targetPeriodCurrent: PeriodOption;
  targetSource: TargetSourceKind;
  targetValueFieldId: ID;
}

export interface OpportunityArchiveTarget  {
  __typename?: 'OpportunityArchiveTarget';
  comparisonLostValue: number | null;
  comparisonPeriod: DatePeriod | null;
  comparisonWonValue: number | null;
  currentLostValue: number;
  currentPeriod: DatePeriod;
  currentWonValue: number;
}

export interface OpportunityArchiveScreenProfile extends ProfileInterface {
  __typename?: 'OpportunityArchiveScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: OpportunityArchiveProfile;
  useLang: boolean;
}

export interface OpportunityArchiveScreen extends ProfileScreen, Screen {
  __typename?: 'OpportunityArchiveScreen';
  activeProfile: OpportunityArchiveScreenProfile;
  data: OpportunityArchiveProfileData;
  draftProfile: OpportunityArchiveScreenProfile | null;
  entityData: ArchiveEntityData | null;
  item: ArchiveOpportunityItem | null;
  name: string;
  profiles: OpportunityArchiveScreenProfile[];
}

export interface OpportunityArchiveProfileData  {
  __typename?: 'OpportunityArchiveProfileData';
  compactViewItems: OpportunityArchiveCompactViewItems;
  listViewItems: OpportunityArchiveDataGridViewItems;
  mapViewItems: OpportunityMapViewItems;
  pipelineViewItems: OpportunityArchivePipelineViewItems;
}

export interface OpportunityArchiveProfile extends LeadOpportunityProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface, TargetProfileInterface {
  __typename?: 'OpportunityArchiveProfile';
  filter: LeadOpportunityFilterTab;
  quickFilter: QuickFilterTab;
  role: OpportunityRoleTab;
  salesPipeline: ID[] | null;
  target: OpportunityArchiveTargetTab;
  view: OpportunityArchiveViewTab;
}

export interface OpportunityArchivePipelineViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'OpportunityArchivePipelineViewItems';
  closedRecordsCount: number;
  columns: OpportunityArchivePipelineColumnItems[];
  sessionId: string;
  target: OpportunityArchiveTarget;
  total: number;
  wonRecordsCount: number;
}

export interface OpportunityArchivePipelineColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'OpportunityArchivePipelineColumnItems';
  items: PipelineArchiveViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: ArchiveStepSummaryInfo;
  total: number;
}

export interface OpportunityArchiveDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityArchiveDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityArchiveCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityArchiveCompactViewItems';
  groups: ViewItemGroup[];
  items: OpportunityCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityArchiveCompactViewItem extends ViewItemInterface {
  __typename?: 'OpportunityArchiveCompactViewItem';
  closingDate: GqlDate | null;
  daysInQueue: number | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  id: ID;
  isFavorite: boolean | null;
  labelFlag: number | null;
  leadTypeId: ID | null;
  name: string;
  opptyTypeId: ID | null;
  owner: string | null;
  ownerId: string | null;
  ownerPicture: string | null;
  ranking: number | null;
  sortName: FieldDataContainer;
  unit: string;
  unitId: string;
  unitPicture: string | null;
  value: string | null;
  velocity: number | null;
}

export interface OpportunityAndLeadDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityAndLeadDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface OpportunityActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'OpportunityActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface OpportunityActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'OpportunityActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface OpportunityActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'OpportunityActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface OnlineFormsNotificationSettings  {
  __typename?: 'OnlineFormsNotificationSettings';
  Errors: boolean;
  IsActive: boolean;
  Responses: boolean;
  Warnings: boolean;
}

export interface OnlineFormValueOverride  {
  __typename?: 'OnlineFormValueOverride';
  id: ID;
  label: string | null;
  sortOrder: number | null;
  visible: boolean | null;
}

export interface OnlineFormUploadedFiles  {
  __typename?: 'OnlineFormUploadedFiles';
  cloudObjects: CloudObjectEntity[];
  downloadSessionId: string | null;
  sessionId: string;
}

export interface OnlineFormTypeTabDataGridViewOptions  {
  __typename?: 'OnlineFormTypeTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByStatus: ProcessStatusEnum[] | null;
  showActive: boolean;
  showInactive: boolean;
}

export interface OnlineFormTypeRepository  {
  __typename?: 'OnlineFormTypeRepository';
  getAll: OnlineFormTypeEntity[];
  getByCriteria: OnlineFormTypeEntityConnection | null;
  getById: OnlineFormTypeEntity | null;
  getByIds: OnlineFormTypeEntity[];
  getByOnlineFormTypeCriteria: OnlineFormTypeEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormTypeOrderBy  {
  __typename?: 'OnlineFormTypeOrderBy';
  autoPrefillWithJavascript: OrderByEnum | null;
  created: OrderByEnum | null;
  description: OrderByEnum | null;
  entityApiName: OrderByEnum | null;
  id: OrderByEnum | null;
  isDeleted: OrderByEnum | null;
  isEnabled: OrderByEnum | null;
  isReadonly: OrderByEnum | null;
  lastResponseBy: OrderByEnum | null;
  lastResponseDate: OrderByEnum | null;
  lastSchemaChange: OrderByEnum | null;
  lastStatusChange: OrderByEnum | null;
  modified: OrderByEnum | null;
  name: OrderByEnum | null;
  owner: ClientOrderByNested[] | null;
  ownerId: OrderByEnum | null;
  responseAcceptanceThreshold: OrderByEnum | null;
  responseCount: OrderByEnum | null;
  responseRate: OrderByEnum | null;
  revision: OrderByEnum | null;
  sentCount: OrderByEnum | null;
  sentUniqueCount: OrderByEnum | null;
  status: OrderByEnum | null;
  style: OnlineFormStyleOrderByNested[] | null;
  styleId: OrderByEnum | null;
}

export interface OnlineFormTypeListView  {
  __typename?: 'OnlineFormTypeListView';
  fieldIds: UUID[];
  listingOptions: OnlineFormTypeTabDataGridViewOptions;
  orderBy: OnlineFormTypeOrderBy[];
  searchText: string | null;
}

export interface OnlineFormTypeEntityEdge  {
  __typename?: 'OnlineFormTypeEntityEdge';
  cursor: string;
  node: OnlineFormTypeEntity | null;
}

export interface OnlineFormTypeEntityConnection  {
  __typename?: 'OnlineFormTypeEntityConnection';
  edges: OnlineFormTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormTypeEntity  {
  __typename?: 'OnlineFormTypeEntity';
  activityLogs: OnlineFormEntityConnection | null;
  autoPrefillWithJavascript: boolean | null;
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  description: string | null;
  entityApiName: string | null;
  entityType: BaseEntityTypeEnum;
  formEdit: JSONString;
  formEditApi: OnlineForm | null;
  hasCustomRecaptcha: boolean;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  isReadonly: boolean;
  lastResponseBy: string | null;
  lastResponseDate: DateTime | null;
  lastSchemaChange: DateTime | null;
  lastStatusChange: DateTime | null;
  link: string | null;
  linkId: string;
  modified: DateTime | null;
  name: string;
  notificationsStatus: JSONString | null;
  owner: ClientEntity | null;
  ownerId: ID;
  responseAcceptanceThreshold: number | null;
  responseCount: number | null;
  responseRate: number | null;
  responseSummaries: OnlineFormResponseSummaryItemConnection | null;
  responses: OnlineFormResponseItemConnection | null;
  revision: number | null;
  sentCount: number | null;
  sentUniqueCount: number | null;
  status: ProcessStatusEnum | null;
  style: OnlineFormStyleEntity | null;
  styleId: ID;
  summarizedResponseValues: number | null;
  uploadedFiles: OnlineFormUploadedFiles;
  usedFieldIds: ID[];
}

export interface OnlineFormTypeEmailRelationRepository  {
  __typename?: 'OnlineFormTypeEmailRelationRepository';
  getAll: OnlineFormTypeEmailRelationEntity[];
  getByCriteria: OnlineFormTypeEmailRelationEntityConnection | null;
  getById: OnlineFormTypeEmailRelationEntity | null;
  getByIds: OnlineFormTypeEmailRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormTypeEmailRelationEntityEdge  {
  __typename?: 'OnlineFormTypeEmailRelationEntityEdge';
  cursor: string;
  node: OnlineFormTypeEmailRelationEntity | null;
}

export interface OnlineFormTypeEmailRelationEntityConnection  {
  __typename?: 'OnlineFormTypeEmailRelationEntityConnection';
  edges: OnlineFormTypeEmailRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormTypeEmailRelationEntity  {
  __typename?: 'OnlineFormTypeEmailRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  email: EmailEntity | null;
  emailId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  onlineFormType: OnlineFormTypeEntity | null;
  onlineFormTypeId: ID;
  oppty: OpportunityEntity | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
}

export interface OnlineFormTypeDetailView  {
  __typename?: 'OnlineFormTypeDetailView';
  onlineForm: AiOnlineFormData | null;
}

export interface OnlineFormTheme  {
  __typename?: 'OnlineFormTheme';
  imageCloudObjectId: ID | null;
}

export interface OnlineFormTextAreaField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormTextAreaField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillText: string | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormStyleSettings  {
  __typename?: 'OnlineFormStyleSettings';
  backgroundColor: string | null;
  buttonAreaPaddingHorizontal: string | null;
  buttonAreaPaddingVertical: string | null;
  buttonColor: string | null;
  buttonFontColor: string | null;
  buttonRadius: string | null;
  columnsHorizontalPadding: string | null;
  formBackgroundColor: string | null;
  formHorizontalPadding: string | null;
  formVerticalPadding: string | null;
  headerBottomMargin: string | null;
  headerDescriptionBottomMargin: string | null;
  headerHorizontalPadding: string | null;
  headerImageVerticalPadding: string | null;
  headerRibbonVisible: boolean;
  headerTitleTopPadding: string | null;
  inputBackgroundColor: string | null;
  inputBorderColor: string | null;
  inputBorderRadius: string | null;
  inputBorderWidth: string | null;
  inputFocusBackgroundColor: string | null;
  inputFocusBorderColor: string | null;
  inputFontColor: string | null;
  inputHoverBackgroundColor: string | null;
  inputHoverBorderColor: string | null;
  primaryColor: string;
  questionDescriptionBottomMargin: string | null;
  questionTitleBottomMargin: string | null;
  questionVerticalMargin: string | null;
  questionVerticalPadding: string | null;
  sectionBackgroundColor: string | null;
  sectionFontColor: string | null;
  sectionHeaderHorizontalPadding: string | null;
  sectionHeaderVerticalPadding: string | null;
  sectionPadding: string | null;
  showFooterLogo: boolean;
  titleBottomMargin: string | null;
}

export interface OnlineFormStyleRepository  {
  __typename?: 'OnlineFormStyleRepository';
  getAll: OnlineFormStyleEntity[];
  getByCriteria: OnlineFormStyleEntityConnection | null;
  getById: OnlineFormStyleEntity | null;
  getByIds: OnlineFormStyleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormStyleOrderByNested  {
  __typename?: 'OnlineFormStyleOrderByNested';
  created: OrderByEnum | null;
  id: OrderByEnum | null;
  isDeleted: OrderByEnum | null;
  modified: OrderByEnum | null;
  name: OrderByEnum | null;
  revision: OrderByEnum | null;
  useLang: OrderByEnum | null;
}

export interface OnlineFormStyleEntityEdge  {
  __typename?: 'OnlineFormStyleEntityEdge';
  cursor: string;
  node: OnlineFormStyleEntity | null;
}

export interface OnlineFormStyleEntityConnection  {
  __typename?: 'OnlineFormStyleEntityConnection';
  edges: OnlineFormStyleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormStyleEntity  {
  __typename?: 'OnlineFormStyleEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: OnlineFormStyleSettings | null;
  useLang: boolean | null;
}

export interface OnlineFormSettings  {
  __typename?: 'OnlineFormSettings';
  attachFiles: boolean;
  attachResponseAsPdf: boolean;
  autolinkEnabled: boolean;
  autolinkFormFieldId: ID | null;
  autolinkRecordFieldId: ID | null;
  checkForExistingResponse: boolean;
  confirmationPageMessage: string | null;
  confirmationPageTitle: string | null;
  confirmationPageType: OnlineFormConfirmationPageType;
  confirmationPageUrl: string | null;
  createRecordEnabled: boolean;
  createRecordForm: ProcessEntityTemplate | null;
  createRelatedRecords: OnlineFormRelatedRecordSettings[];
  limitToSingleResponse: boolean;
  linkOrCreateRelatedRecords: OnlineFormRelatedRecordSettings[];
  linkRecordEnabled: boolean;
  linkRelatedRecords: OnlineFormRelatedRecordSettings[];
  maxTotalUploadedFilesSize: number;
  notificationEmails: string[];
  notificationEnabled: boolean;
  notificationLimitEmails: string[];
  notificationLimitEnabled: boolean;
  notificationLimitRecipientType: OnlineFormNotificationRecipientType[];
  notificationRecipientType: OnlineFormNotificationRecipientType[];
  productsCurrencyId: ID;
  productsPriceListId: ID | null;
  productsResponseLimits: OnlineFormProductsResponseLimit[];
  productsResponseLimitsEnabled: boolean;
  productsShowGrandTotal: boolean;
  productsTotalResponseLimits: OnlineFormProductsResponseLimit[];
  productsTotalResponseLimitsEnabled: boolean;
  recordIdentificationEnabled: boolean;
  recordIdentificationMessage: string | null;
  recordIdentificationTitle: string | null;
  recordIdentificationType: OnlineFormConfirmationPageType;
  recordIdentificationUrl: string | null;
  responseAcceptanceDateLimitDate: DateTime | null;
  responseAcceptanceDateLimitEnabled: boolean;
  responseAcceptanceDateLimitMessage: string | null;
  responseAcceptanceDateLimitTitle: string | null;
  responseAcceptanceThresholdCustomCondition: ResponseAcceptanceThresholdCustomCondition | null;
  responseAcceptanceThresholdEnabled: boolean;
  responseAcceptanceThresholdMessage: string | null;
  responseAcceptanceThresholdNoOfResponses: number | null;
  responseAcceptanceThresholdProductsLimits: ResponseAcceptanceThresholdProductsLimits | null;
  responseAcceptanceThresholdTitle: string | null;
  responseAcceptanceThresholdType: ResponseAcceptanceThresholdType;
  showQuestionNumbers: boolean;
  singlePageContent: boolean;
  updateOrCreateRelatedRecords: OnlineFormRelatedRecordSettings[];
  updateRecordEnabled: boolean;
  updateRecordForm: ProcessEntityTemplate | null;
  updateRelatedRecords: OnlineFormRelatedRecordSettings[];
}

export interface OnlineFormSection  {
  __typename?: 'OnlineFormSection';
  description: string;
  id: ID;
  title: string;
  visible: boolean;
}

export interface OnlineFormResponseSummaryItemEdge  {
  __typename?: 'OnlineFormResponseSummaryItemEdge';
  cursor: string;
  node: OnlineFormResponseSummary | null;
}

export interface OnlineFormResponseSummaryItemConnection  {
  __typename?: 'OnlineFormResponseSummaryItemConnection';
  edges: OnlineFormResponseSummaryItemEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface OnlineFormResponseSummary  {
  __typename?: 'OnlineFormResponseSummary';
  id: ID | null;
  isAvailable: boolean | null;
  name: string | null;
  numberOfResponses: number | null;
  onlineFormIds: ID[];
  pictureUrl: string | null;
  responseDate: DateTime | null;
  sentDate: DateTime | null;
  summarizedResponseValue: number | null;
  type: EntityNameEnum | null;
}

export interface OnlineFormResponseItemEdge  {
  __typename?: 'OnlineFormResponseItemEdge';
  cursor: string;
  node: OnlineFormResponse | null;
}

export interface OnlineFormResponseItemConnection  {
  __typename?: 'OnlineFormResponseItemConnection';
  edges: OnlineFormResponseItemEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface OnlineFormResponse  {
  __typename?: 'OnlineFormResponse';
  answers: OnlineFormFieldAnswer[];
  created: DateTime;
  entityApiName: string | null;
  entityId: ID | null;
  entityIsAvailable: boolean | null;
  entityType: EntityNameEnum | null;
  name: string | null;
  onlineFormId: ID;
  pictureUrl: string | null;
}

export interface OnlineFormRepository  {
  __typename?: 'OnlineFormRepository';
  getAll: OnlineFormEntity[];
  getByCriteria: OnlineFormEntityConnection | null;
  getById: OnlineFormEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: OnlineFormEntity[];
  getBySession: OnlineFormEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getDownloadUrl: string;
}

export interface OnlineFormRelationRepository  {
  __typename?: 'OnlineFormRelationRepository';
  getAll: OnlineFormRelationEntity[];
  getByCriteria: OnlineFormRelationEntityConnection | null;
  getById: OnlineFormRelationEntity | null;
  getByIds: OnlineFormRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormRelationEntityEdge  {
  __typename?: 'OnlineFormRelationEntityEdge';
  cursor: string;
  node: OnlineFormRelationEntity | null;
}

export interface OnlineFormRelationEntityConnection  {
  __typename?: 'OnlineFormRelationEntityConnection';
  edges: OnlineFormRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormRelationEntity  {
  __typename?: 'OnlineFormRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  onlineForm: OnlineFormEntity | null;
  onlineFormId: ID;
  oppty: OpportunityEntity | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
}

export interface OnlineFormRelatedRecordSettings  {
  __typename?: 'OnlineFormRelatedRecordSettings';
  createForm: ProcessEntityTemplate | null;
  id: ID;
  linkAll: boolean;
  linkFormFieldId: ID | null;
  linkRecordFieldId: ID | null;
  relation: ProcessRecordNodeRelationEnum;
  relationLookupFieldId: string | null;
  updateForm: ProcessEntityTemplate | null;
}

export interface OnlineFormRatingField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormRatingField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillInteger: number | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  valueFrom: number;
  valueFromLabel: string | null;
  valueTo: number;
  valueToLabel: string | null;
  visible: boolean;
}

export interface OnlineFormRadioField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormRadioField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  prefillValue: ID | null;
  readOnly: boolean;
  required: boolean;
  valueOverrides: OnlineFormValueOverride[];
  visible: boolean;
}

export interface OnlineFormProductsServicesProductField  {
  __typename?: 'OnlineFormProductsServicesProductField';
  fieldId: ID;
  value: JSONString | null;
}

export interface OnlineFormProductsServicesProduct  {
  __typename?: 'OnlineFormProductsServicesProduct';
  fields: OnlineFormProductsServicesProductField[];
  id: ID;
  name: string | null;
  pictureUrl: string | null;
  price: number | null;
  unitSymbol: string | null;
}

export interface OnlineFormProductsServicesFieldOption  {
  __typename?: 'OnlineFormProductsServicesFieldOption';
  label: string | null;
  value: UUID | null;
}

export interface OnlineFormProductsServicesFieldData  {
  __typename?: 'OnlineFormProductsServicesFieldData';
  apiName: string | null;
  id: ID;
  name: string;
  options: OnlineFormProductsServicesFieldOption[] | null;
  readonly: boolean;
  systemType: FieldSystemType;
  typeId: string;
}

export interface OnlineFormProductsServicesField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormProductsServicesField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  maxSelectedProducts: number | null;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  productSelectionLimitEnabled: boolean;
  readOnly: boolean;
  required: boolean;
  showProductImages: boolean;
  showTotalAmount: boolean;
  visible: boolean;
}

export interface OnlineFormProductsResponseLimit  {
  __typename?: 'OnlineFormProductsResponseLimit';
  enabled: boolean;
  fieldId: ID;
  quantity: number;
}

export interface OnlineFormProductsDataResult  {
  __typename?: 'OnlineFormProductsDataResult';
  fields: OnlineFormProductsServicesFieldData[];
  products: OnlineFormProductsServicesProduct[];
}

export interface OnlineFormProductServicesProperty  {
  __typename?: 'OnlineFormProductServicesProperty';
  dynamicProductsFilter: FieldFilter | null;
  fields: ID[];
  maxSelectedProducts: number | null;
  productListType: ProductListTypeEnum;
  productSelectionLimitEnabled: boolean;
  showProductImages: boolean;
  showTotalAmount: boolean;
  staticProducts: ID[] | null;
}

export interface OnlineFormProductDrilldownModel  {
  __typename?: 'OnlineFormProductDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface OnlineFormPhoneField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormPhoneField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillText: string | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormPersonificationDataResult  {
  __typename?: 'OnlineFormPersonificationDataResult';
  fieldMarker: string;
  value: string;
}

export interface OnlineFormMultiselectCheckboxField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormMultiselectCheckboxField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  prefillValues: ID[] | null;
  readOnly: boolean;
  required: boolean;
  valueOverrides: OnlineFormValueOverride[];
  visible: boolean;
}

export interface OnlineFormIntegerField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormIntegerField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillInteger: number | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormInputField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormInputField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillText: string | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormHeader  {
  __typename?: 'OnlineFormHeader';
  description: string;
  showHeaderOnAllPages: boolean;
  title: string;
  visible: boolean;
}

export interface OnlineFormFooter  {
  __typename?: 'OnlineFormFooter';
  submitButtonLabel: string;
  submitButtonPosition: OnlineFormButtonPositionEnum;
}

export interface OnlineFormFloatField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormFloatField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillFloat: number | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormFileUploadField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormFileUploadField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  fileUploadOptions: FileUploadProperty;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormFieldAnswer  {
  __typename?: 'OnlineFormFieldAnswer';
  id: string;
  value: string | null;
}

export interface OnlineFormEntityEdge  {
  __typename?: 'OnlineFormEntityEdge';
  cursor: string;
  node: OnlineFormEntity | null;
}

export interface OnlineFormEntityConnection  {
  __typename?: 'OnlineFormEntityConnection';
  edges: OnlineFormEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormEntity  {
  __typename?: 'OnlineFormEntity';
  accountRelations: OnlineFormRelationEntityConnection | null;
  answers: OnlineFormFieldAnswer[];
  contactRelations: OnlineFormRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customEntityRelations: OnlineFormRelationEntityConnection | null;
  customFields: JSONString;
  email: EmailEntity | null;
  emailId: ID | null;
  fieldIds: JSONString;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadRelations: OnlineFormRelationEntityConnection | null;
  lines: OnlineFormActivityLogLineEntityConnection | null;
  modified: DateTime | null;
  onlineFormType: OnlineFormTypeEntity | null;
  onlineFormTypeId: ID;
  opportunityRelations: OnlineFormRelationEntityConnection | null;
  primaryAccount: AccountEntity | null;
  primaryAccountId: ID | null;
  primaryContact: ContactEntity | null;
  primaryContactId: ID | null;
  primaryCustomEntity: CustomEntityEntity | null;
  primaryCustomEntityId: ID | null;
  primaryLead: LeadEntity | null;
  primaryLeadOpptyId: ID | null;
  primaryOpportunity: OpportunityEntity | null;
  primaryQuote: QuoteEntity | null;
  primaryQuoteId: ID | null;
  productCurrency: CurrencyEntity | null;
  productCurrencyId: ID | null;
  productPriceList: ProductPriceListEntity | null;
  productPriceListId: ID | null;
  projectRelations: OnlineFormRelationEntityConnection | null;
  quoteRelations: OnlineFormRelationEntityConnection | null;
  recordName: string | null;
  respondedBy: string;
  responseDate: DateTime | null;
  revision: number | null;
  status: ProcessStatusEnum | null;
}

export interface OnlineFormEmailField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormEmailField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillText: string | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormDropdownField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormDropdownField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  prefillValue: ID | null;
  readOnly: boolean;
  required: boolean;
  valueOverrides: OnlineFormValueOverride[];
  visible: boolean;
}

export interface OnlineFormDateTimeField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormDateTimeField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillDateTime: DateTime | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormDateField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormDateField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillDate: GqlDate | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  visible: boolean;
}

export interface OnlineFormDataExRelationRepository  {
  __typename?: 'OnlineFormDataExRelationRepository';
  getAll: OnlineFormDataExRelationEntity[];
  getByCriteria: OnlineFormDataExRelationEntityConnection | null;
  getById: OnlineFormDataExRelationEntity | null;
  getByIds: OnlineFormDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormDataExRelationEntityEdge  {
  __typename?: 'OnlineFormDataExRelationEntityEdge';
  cursor: string;
  node: OnlineFormDataExRelationEntity | null;
}

export interface OnlineFormDataExRelationEntityConnection  {
  __typename?: 'OnlineFormDataExRelationEntityConnection';
  edges: OnlineFormDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormDataExRelationEntity  {
  __typename?: 'OnlineFormDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  onlineForm: OnlineFormEntity | null;
  onlineFormId: ID;
  revision: number | null;
}

export interface OnlineFormContainer  {
  __typename?: 'OnlineFormContainer';
  columns: OnlineFormColumn[];
  id: ID;
}

export interface OnlineFormColumn  {
  __typename?: 'OnlineFormColumn';
  fields: OnlineFormFieldInterfaceImplementors[];
  id: ID;
  size: number;
}

export interface OnlineFormCheckboxField extends OnlineFormFieldInterface {
  __typename?: 'OnlineFormCheckboxField';
  conditionalRulesFilter: FieldFilter | null;
  description: string;
  fieldId: string;
  imageCloudObjectId: ID | null;
  imageEnabled: boolean;
  name: string;
  placeholder: string | null;
  prefillBoolean: boolean | null;
  prefillEnabled: boolean;
  prefillFieldId: string | null;
  prefillLookupFieldId: ID | null;
  prefillType: OnlineFormPrefillTypeEnum;
  readOnly: boolean;
  required: boolean;
  valueDefaultChecked: boolean;
  valueLabel: string | null;
  visible: boolean;
}

export interface OnlineFormActivityLogLineRepository  {
  __typename?: 'OnlineFormActivityLogLineRepository';
  getAll: OnlineFormActivityLogLineEntity[];
  getByCriteria: OnlineFormActivityLogLineEntityConnection | null;
  getById: OnlineFormActivityLogLineEntity | null;
  getByIds: OnlineFormActivityLogLineEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface OnlineFormActivityLogLineEntityEdge  {
  __typename?: 'OnlineFormActivityLogLineEntityEdge';
  cursor: string;
  node: OnlineFormActivityLogLineEntity | null;
}

export interface OnlineFormActivityLogLineEntityConnection  {
  __typename?: 'OnlineFormActivityLogLineEntityConnection';
  edges: OnlineFormActivityLogLineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface OnlineFormActivityLogLineEntity  {
  __typename?: 'OnlineFormActivityLogLineEntity';
  created: DateTime | null;
  executedAt: DateTime | null;
  formattedText: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isVisible: boolean | null;
  modified: DateTime | null;
  onlineForm: OnlineFormEntity | null;
  onlineFormId: ID;
  sortOrder: number;
  status: ProcessStatusEnum | null;
}

export interface OnlineForm  {
  __typename?: 'OnlineForm';
  fields: OnlineFormItem[];
  footer: OnlineFormFooter;
  header: OnlineFormHeader;
  settings: OnlineFormSettings;
  theme: OnlineFormTheme;
}

export interface OneDrive  {
  __typename?: 'OneDrive';
  getAuthUrl: AuthUrlResult | null;
  getLogoutUrl: AuthUrlResult | null;
  getToken: TokenResult | null;
  listFolder: RemoteStorageFileListResultConnection | null;
  refreshToken: TokenResult | null;
}

export interface ObjectiveStatusCount  {
  __typename?: 'ObjectiveStatusCount';
  atRisk: number;
  completed: number;
  inProgress: number;
  notStarted: number;
}

export interface NotificationsDrilldownModel  {
  __typename?: 'NotificationsDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface NotificationTopOpportunity  {
  __typename?: 'NotificationTopOpportunity';
  id: ID;
  name: string;
  ownerName: string;
  value: number;
}

export interface NotificationTaskOverviewEdge  {
  __typename?: 'NotificationTaskOverviewEdge';
  cursor: string;
  node: NotificationTaskOverview | null;
}

export interface NotificationTaskOverviewConnection  {
  __typename?: 'NotificationTaskOverviewConnection';
  edges: NotificationTaskOverviewEdge[];
  pageInfo: PageInfo;
}

export interface NotificationTaskOverview extends OverdueTaskOverview {
  __typename?: 'NotificationTaskOverview';
  dueDate: GqlDate | null;
  id: ID;
  ownerName: string;
  subject: string;
}

export interface NotificationSettings  {
  __typename?: 'NotificationSettings';
  AccountsAndContacts: AccountsAndContactsNotificationSettings;
  Activities: ActivitiesNotificationSettings;
  ApprovalProcesses: ApprovalProcessesNotificationSettings | null;
  CallingAndMessaging: TextMessageNotificationSettings | null;
  CustomEntities: CustomEntitiesNotificationSetting[];
  EmailSequences: EmailSequencesNotificationSettings | null;
  Emails: EmailNotificationSettings;
  Feeds: FeedsNotificationSettings;
  LeadsAndOpportunities: LeadsAndOpportunitiesNotificationSettings;
  OnlineForms: OnlineFormsNotificationSettings | null;
  ProcessBuilder: ProcessBuilderNotificationSettings | null;
  Projects: ProjectsNotificationSettings | null;
  Quotes: QuotesNotificationSettings | null;
  WhatsApp: TextMessageNotificationSettings | null;
}

export interface NotificationSettingEntity  {
  __typename?: 'NotificationSettingEntity';
  created: DateTime | null;
  daysAfterPaymentDue: number | null;
  daysPriorEnd: number | null;
  emailBody: string | null;
  emailSubject: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: NotificationSettingPermsEnum[];
  modified: DateTime | null;
  name: string | null;
  serviceType: NotificationSettingService | null;
  settingType: NotificationSettingSettingTypeEnum | null;
  status: NotificationSettingStatus | null;
  type: NotificationSettingType | null;
}

export interface NotificationService  {
  __typename?: 'NotificationService';
  drilldown: NotificationsDrilldownModel;
  generateSessionIdFromGroupCursor: GenerateSessionIdFromGroupCursorResult;
  hasUnseenNotifications: boolean;
  notifications: NotificationConnection;
  notificationsInGroup: NotificationGroupConnection;
}

export interface NotificationRenewal  {
  __typename?: 'NotificationRenewal';
  id: string;
  instancePermissions: NotificationRenewalPermsEnum[];
  isProcessed: boolean;
  notificationSetting: NotificationSettingEntity;
  processedDate: GqlDate;
}

export interface NotificationOverdueItemEdge  {
  __typename?: 'NotificationOverdueItemEdge';
  cursor: string;
  node: NotificationOverdueItem | null;
}

export interface NotificationOverdueItemConnection  {
  __typename?: 'NotificationOverdueItemConnection';
  edges: NotificationOverdueItemEdge[];
  pageInfo: PageInfo;
}

export interface NotificationOverdueItem  {
  __typename?: 'NotificationOverdueItem';
  daysAgo: number;
  id: ID;
  name: string;
  ownerName: string;
}

export interface NotificationNode  {
  __typename?: 'NotificationNode';
  actorClientEntity: ClientNotificationEntity | null;
  application: NotificationApplication;
  count: number;
  entity: NotificationEntityInterfaceImplementors | null;
  entityApiName: string | null;
  entityKind: EntityNameEnum;
  event: NotificationEventEnum;
  groupCursor: ID | null;
  groupTotal: number;
  hasUnread: boolean;
  targetClientEntity: ClientNotificationEntity | null;
  targetEntity: NotificationTargetEntityInterfaceImplementors | null;
  targetEntityApiName: string | null;
  targetEntityKind: EntityNameEnum | null;
  time: DateTime;
}

export interface NotificationGroupNode  {
  __typename?: 'NotificationGroupNode';
  id: ID;
}

export interface NotificationGroupEdge  {
  __typename?: 'NotificationGroupEdge';
  cursor: string;
  node: NotificationGroupNode | null;
}

export interface NotificationGroupConnection  {
  __typename?: 'NotificationGroupConnection';
  edges: NotificationGroupEdge[];
  pageInfo: PageInfo;
}

export interface NotificationEntity extends NotificationEntityInterface, NotificationTargetEntityInterface {
  __typename?: 'NotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
}

export interface NotificationEdge  {
  __typename?: 'NotificationEdge';
  cursor: string;
  node: NotificationNode | null;
}

export interface NotificationConnection  {
  __typename?: 'NotificationConnection';
  edges: NotificationEdge[];
  pageInfo: PageInfo;
  revision: number;
}

export interface NotificationApplication  {
  __typename?: 'NotificationApplication';
  id: ID;
  name: string;
}

export interface NoteTableReportProfile extends NoteProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, TableReportTabsInterface {
  __typename?: 'NoteTableReportProfile';
  filter: NoteFilterTab;
  quickFilter: QuickFilterTab;
  view: ViewTableReportTab;
}

export interface NoteTabDataGridViewOptions  {
  __typename?: 'NoteTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  searchQuery: string | null;
}

export interface NoteTabDataGridView  {
  __typename?: 'NoteTabDataGridView';
  ofAccount: AccountNoteTabDataGridView;
  ofContact: ContactNoteTabDataGridView;
  ofCustomEntity: CustomEntityNoteTabDataGridView;
  ofLead: LeadNoteTabDataGridView;
  ofOpportunity: OpportunityNoteTabDataGridView;
  ofProject: ProjectNoteTabDataGridView;
  ofQuote: QuoteNoteTabDataGridView;
}

export interface NoteSearchResultItem extends SearchResultItemInterface {
  __typename?: 'NoteSearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isDeleted: boolean;
  note: string;
  noteLinkedEntity: LinkedItemType | null;
}

export interface NoteRepository  {
  __typename?: 'NoteRepository';
  getAll: NoteEntity[];
  getByCriteria: NoteEntityConnection | null;
  getById: NoteEntity | null;
  getByIds: NoteEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface NotePivotReportProfile extends NoteProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface {
  __typename?: 'NotePivotReportProfile';
  filter: NoteFilterTab;
  quickFilter: QuickFilterTab;
  view: ViewPivotReportTab;
}

export interface NoteFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'NoteFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface NoteEntityEdge  {
  __typename?: 'NoteEntityEdge';
  cursor: string;
  node: NoteEntity | null;
}

export interface NoteEntityConnection  {
  __typename?: 'NoteEntityConnection';
  edges: NoteEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface NoteEntity  {
  __typename?: 'NoteEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  note: string;
  oppty: OpportunityEntity | null;
  owner: ClientEntity | null;
  ownerId: ID;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
}

export interface NoteDrilldownFilter  {
  __typename?: 'NoteDrilldownFilter';
  ownerId: ID[] | null;
}

export interface NavigatorView  {
  __typename?: 'NavigatorView';
  profile: BetterNavigatorPreviewProfile;
  profileId: string;
}

export interface NavigatorTrendChartData  {
  __typename?: 'NavigatorTrendChartData';
  balancedValue: number;
  date: GqlDate;
  rankedValue: number;
  unweightedValue: number;
  weightedValue: number;
  wonValue: number;
}

export interface NavigatorTargetTab extends TargetTabInterface {
  __typename?: 'NavigatorTargetTab';
  goal: number;
  targetPeriodCompare: PeriodCompareOption;
  targetPeriodCurrent: PeriodOption;
  targetValueFieldId: ID;
  targetValueType: TargetValueType;
}

export interface NavigatorTargetOverviewTrendChart  {
  __typename?: 'NavigatorTargetOverviewTrendChart';
  drilldown: DrilldownModel;
  periodEnd: GqlDate | null;
  periodStart: GqlDate | null;
  remainingDays: number | null;
  todaysWonValue: number | null;
  trendChartData: NavigatorTrendChartData[] | null;
}

export interface NavigatorTargetOverviewTarget  {
  __typename?: 'NavigatorTargetOverviewTarget';
  status: TargetStatus | null;
  target: OpportunityTarget;
}

export interface NavigatorTargetOverview  {
  __typename?: 'NavigatorTargetOverview';
  target: NavigatorTargetOverviewTarget;
  trendChart: NavigatorTargetOverviewTrendChart | null;
}

export interface NavigatorSuggestions  {
  __typename?: 'NavigatorSuggestions';
  accountsWithoutBusinessCount: number;
  accountsWithoutBusinessSession: UUID | null;
  frozenAccountsCount: number;
  frozenAccountsSession: UUID | null;
  lazyOpportunitiesCount: number;
  lazyOpportunitiesSession: UUID | null;
  newLeadsCount: number;
  newLeadsSession: UUID | null;
  noLeads: boolean;
  noOpportunities: boolean;
  oldLeadsCount: number;
  oldLeadsSession: UUID | null;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
  readyToQualifyCount: number;
  readyToQualifySession: UUID | null;
}

export interface NavigatorScreenProfile extends ProfileInterface {
  __typename?: 'NavigatorScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: NavigatorPreviewProfile;
  useLang: boolean;
}

export interface NavigatorScreen extends ProfileScreen, Screen {
  __typename?: 'NavigatorScreen';
  activeProfile: NavigatorScreenProfile;
  data: NavigatorProfileData;
  draftProfile: NavigatorScreenProfile | null;
  name: string;
  profiles: NavigatorScreenProfile[];
}

export interface NavigatorProfileFilterTab extends ProfileFilterBaseInterface {
  __typename?: 'NavigatorProfileFilterTab';
  filterByOwnerId: ID | null;
  filterByUnitIds: ID[] | null;
  isEnabled: boolean;
}

export interface NavigatorProfileData  {
  __typename?: 'NavigatorProfileData';
  agenda: Agenda;
  businessOverview: NavigatorBusinessOverview;
  notifications: NavigatorNotifications;
  suggestions: NavigatorSuggestions;
  targetOverview: NavigatorTargetOverview | null;
}

export interface NavigatorPreviewProfile extends ProfileTabsInterface {
  __typename?: 'NavigatorPreviewProfile';
  filter: NavigatorProfileFilterTab;
  role: ProfileStandardRoleTab;
  salesPipeline: ID[] | null;
  target: NavigatorTargetTab;
}

export interface NavigatorNotificationsVelocityIssues  {
  __typename?: 'NavigatorNotificationsVelocityIssues';
  velocityIssuesCount: number;
  velocityIssuesList: NotificationOverdueItemConnection | null;
  velocityIssuesSession: UUID | null;
}

export interface NavigatorNotificationsTopOpenOpportunities  {
  __typename?: 'NavigatorNotificationsTopOpenOpportunities';
  topOpportunitiesCount: number;
  topOpportunitiesList: NotificationTopOpportunity[] | null;
  topOpportunitiesSession: UUID | null;
  topOpportunitiesTotalValue: number;
}

export interface NavigatorNotificationsTasks  {
  __typename?: 'NavigatorNotificationsTasks';
  allTasksCount: number;
  overdueTasksCount: number;
  overdueTasksList: NotificationTaskOverviewConnection | null;
}

export interface NavigatorNotificationsOverdueOpportunities  {
  __typename?: 'NavigatorNotificationsOverdueOpportunities';
  overdueOpportunitiesCount: number;
  overdueOpportunitiesList: NotificationOverdueItemConnection | null;
  overdueOpportunitiesSession: UUID | null;
}

export interface NavigatorNotifications  {
  __typename?: 'NavigatorNotifications';
  missedCloseDate: NavigatorNotificationsOverdueOpportunities;
  tasks: NavigatorNotificationsTasks;
  topOpenOpportunities: NavigatorNotificationsTopOpenOpportunities | null;
  velocityIssues: NavigatorNotificationsVelocityIssues;
}

export interface NavigatorBusinessOverview  {
  __typename?: 'NavigatorBusinessOverview';
  lostCount: number;
  lostSession: UUID | null;
  lostSum: number;
  openCount: number;
  openSession: UUID | null;
  openSum: number;
  wonCount: number;
  wonSession: UUID | null;
  wonSum: number;
}

export interface NavigatorAgendaItemEdge  {
  __typename?: 'NavigatorAgendaItemEdge';
  cursor: string;
  node: NavigatorAgendaItemInterfaceImplementors | null;
}

export interface NavigatorAgendaItemConnection  {
  __typename?: 'NavigatorAgendaItemConnection';
  edges: NavigatorAgendaItemEdge[];
  pageInfo: PageInfo;
}

export interface MutationPermissions  {
  __typename?: 'MutationPermissions';
  mutation: string;
  permission: EntityPermsEnum;
}

export interface MultiSelectProperty  {
  __typename?: 'MultiSelectProperty';
  advancedVisualization: boolean;
}

export interface MsDynamicsTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'MsDynamicsTeamPipelineHubItemEntity';
  accessToken: string | null;
  baseUrl: string | null;
  configuration: HubItemIntegrationSyncConfig | null;
  configurationUrlFormatted: string | null;
  expiresAt: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isAuthenticated: boolean | null;
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface MoveQuotePayload  {
  __typename?: 'MoveQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface MovePipelineStepPayload  {
  __typename?: 'MovePipelineStepPayload';
  clientMutationId: string | null;
  result: PipelineEntity | null;
}

export interface MoveOpportunityPayload  {
  __typename?: 'MoveOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface MoveLeadPayload  {
  __typename?: 'MoveLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface MoveCloudObjectsPayload  {
  __typename?: 'MoveCloudObjectsPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface Module  {
  __typename?: 'Module';
  id: string;
  isEnabled: boolean;
  name: string;
}

export interface MigratePipelinePayload  {
  __typename?: 'MigratePipelinePayload';
  clientMutationId: string | null;
}

export interface MicrosoftOneDriveSettingsOutput  {
  __typename?: 'MicrosoftOneDriveSettingsOutput';
  enabled: ServiceStatus;
  errorCode: number;
  microsoftOneDriveAccessToken: string | null;
  microsoftOneDriveRefreshToken: string | null;
}

export interface MessageSharingSalesUnitRelationRepository  {
  __typename?: 'MessageSharingSalesUnitRelationRepository';
  getAll: MessageSharingSalesUnitRelationEntity[];
  getByCriteria: MessageSharingSalesUnitRelationEntityConnection | null;
  getById: MessageSharingSalesUnitRelationEntity | null;
  getByIds: MessageSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MessageSharingSalesUnitRelationEntityEdge  {
  __typename?: 'MessageSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: MessageSharingSalesUnitRelationEntity | null;
}

export interface MessageSharingSalesUnitRelationEntityConnection  {
  __typename?: 'MessageSharingSalesUnitRelationEntityConnection';
  edges: MessageSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MessageSharingSalesUnitRelationEntity  {
  __typename?: 'MessageSharingSalesUnitRelationEntity';
  created: DateTime | null;
  email: EmailEntity | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  memo: MemoEntity | null;
  messageId: ID;
  modified: DateTime | null;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface MessageSharingClientRelationRepository  {
  __typename?: 'MessageSharingClientRelationRepository';
  getAll: MessageSharingClientRelationEntity[];
  getByCriteria: MessageSharingClientRelationEntityConnection | null;
  getById: MessageSharingClientRelationEntity | null;
  getByIds: MessageSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MessageSharingClientRelationEntityEdge  {
  __typename?: 'MessageSharingClientRelationEntityEdge';
  cursor: string;
  node: MessageSharingClientRelationEntity | null;
}

export interface MessageSharingClientRelationEntityConnection  {
  __typename?: 'MessageSharingClientRelationEntityConnection';
  edges: MessageSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MessageSharingClientRelationEntity  {
  __typename?: 'MessageSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  email: EmailEntity | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  memo: MemoEntity | null;
  messageId: ID;
  modified: DateTime | null;
  revision: number | null;
}

export interface MessageRelationRepository  {
  __typename?: 'MessageRelationRepository';
  getAll: MessageRelationEntity[];
  getByCriteria: MessageRelationEntityConnection | null;
  getById: MessageRelationEntity | null;
  getByIds: MessageRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MessageRelationEntityEdge  {
  __typename?: 'MessageRelationEntityEdge';
  cursor: string;
  node: MessageRelationEntity | null;
}

export interface MessageRelationEntityConnection  {
  __typename?: 'MessageRelationEntityConnection';
  edges: MessageRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MessageRelationEntity  {
  __typename?: 'MessageRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  email: EmailEntity | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  memo: MemoEntity | null;
  messageId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
}

export interface MessageDrilldownFilter  {
  __typename?: 'MessageDrilldownFilter';
  ownerId: ID[] | null;
}

export interface MergeRecordPayload  {
  __typename?: 'MergeRecordPayload';
  masterRecordId: UUID | null;
  missingDeletePermission: boolean;
  missingMasterWritePermission: boolean;
  success: boolean;
}

export interface MergeDuplicatesField  {
  __typename?: 'MergeDuplicatesField';
  entityId: UUID;
  fieldId: UUID;
}

export interface MergeContactPayload  {
  __typename?: 'MergeContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface MergeAccountPayload  {
  __typename?: 'MergeAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface MemoRepository  {
  __typename?: 'MemoRepository';
  getAll: MemoEntity[];
  getByCriteria: MemoEntityConnection | null;
  getById: MemoEntity | null;
  getByIds: MemoEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MemoEntityEdge  {
  __typename?: 'MemoEntityEdge';
  cursor: string;
  node: MemoEntity | null;
}

export interface MemoEntityConnection  {
  __typename?: 'MemoEntityConnection';
  edges: MemoEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MemoEntity  {
  __typename?: 'MemoEntity';
  accountRelations: MessageRelationEntityConnection | null;
  comments: MemoCommentEntityConnection | null;
  contactRelations: MessageRelationEntityConnection | null;
  created: DateTime | null;
  customEntityRelations: MessageRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadRelations: MessageRelationEntityConnection | null;
  modified: DateTime | null;
  opportunityRelations: MessageRelationEntityConnection | null;
  owner: ClientEntity | null;
  ownerId: ID;
  projectRelations: MessageRelationEntityConnection | null;
  quoteRelations: MessageRelationEntityConnection | null;
  revision: number | null;
  sharingClients: MessageSharingClientRelationEntityConnection | null;
  sharingUnits: MessageSharingSalesUnitRelationEntityConnection | null;
  subject: string;
  tableName: string;
}

export interface MemoCommentRepository  {
  __typename?: 'MemoCommentRepository';
  getAll: MemoCommentEntity[];
  getByCriteria: MemoCommentEntityConnection | null;
  getById: MemoCommentEntity | null;
  getByIds: MemoCommentEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MemoCommentEntityEdge  {
  __typename?: 'MemoCommentEntityEdge';
  cursor: string;
  node: MemoCommentEntity | null;
}

export interface MemoCommentEntityConnection  {
  __typename?: 'MemoCommentEntityConnection';
  edges: MemoCommentEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MemoCommentEntity  {
  __typename?: 'MemoCommentEntity';
  comment: string;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  memo: MemoEntity | null;
  memoId: ID;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
}

export interface MediaRepository  {
  __typename?: 'MediaRepository';
  getAll: MediaEntity[];
  getByCriteria: MediaEntityConnection | null;
  getById: MediaEntity | null;
  getByIds: MediaEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MediaEntityEdge  {
  __typename?: 'MediaEntityEdge';
  cursor: string;
  node: MediaEntity | null;
}

export interface MediaEntityConnection  {
  __typename?: 'MediaEntityConnection';
  edges: MediaEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MediaEntity  {
  __typename?: 'MediaEntity';
  activityId: ID | null;
  appointment: AppointmentEntity | null;
  audio: CloudObjectEntity | null;
  audioId: UUID | null;
  call: CallEntity | null;
  callId: ID | null;
  created: DateTime | null;
  data: JSONString | null;
  description: string | null;
  errorCode: number | null;
  getTranscriptionViewerToken: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  status: MediaStatusEnum | null;
  task: TaskEntity | null;
  transcriptionFile: CloudObjectEntity | null;
  transcriptionFileId: UUID | null;
  transcriptionId: string | null;
  transcriptionLanguage: string | null;
  transcriptionSummary: string | null;
  type: MediaTypeEnum | null;
}

export interface MasterRightRepository  {
  __typename?: 'MasterRightRepository';
  getAll: MasterRightEntity[];
  getByCriteria: MasterRightEntityConnection | null;
  getById: MasterRightEntity | null;
  getByIds: MasterRightEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface MasterRightEntityEdge  {
  __typename?: 'MasterRightEntityEdge';
  cursor: string;
  node: MasterRightEntity | null;
}

export interface MasterRightEntityConnection  {
  __typename?: 'MasterRightEntityConnection';
  edges: MasterRightEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface MasterRightEntity  {
  __typename?: 'MasterRightEntity';
  accessAccountRelationTypes: boolean | null;
  accessAccounts: boolean | null;
  accessAiAutomatizer: boolean | null;
  accessAiOnlineForms: boolean | null;
  accessAiRecordDetail: boolean | null;
  accessAiReports: boolean | null;
  accessAiSmartField: boolean | null;
  accessAppointmentScheduler: boolean | null;
  accessAppointmentSchedulerManagement: boolean | null;
  accessApprovalProcesses: boolean | null;
  accessApprovalProcessesManagement: boolean | null;
  accessApprovals: boolean | null;
  accessArchive: boolean | null;
  accessAudit: boolean | null;
  accessAuditLog: boolean | null;
  accessBulkUpdate: boolean | null;
  accessCalling: boolean | null;
  accessCallingCompanyPhone: AccessLevelCompanyEmailsEnum | null;
  accessCallingPurchasePhone: boolean | null;
  accessCompanyEmails: AccessLevelCompanyEmailsEnum | null;
  accessContacts: boolean | null;
  accessDocumentManagement: boolean | null;
  accessDocumentManagementCompany: boolean | null;
  accessDocumentManagementRecord: boolean | null;
  accessDuplicateChecker: boolean | null;
  accessEntityAccount: AccessLevelEntityEnum | null;
  accessEntityAccountCopy: boolean | null;
  accessEntityAccountDelete: boolean | null;
  accessEntityAccountDirection: AccessDirectionEnum | null;
  accessEntityAccountPrivate: boolean | null;
  accessEntityAccountTagCreate: boolean | null;
  accessEntityAccountTypes: AccessEntityTypesEnum | null;
  accessEntityAppointment: AccessLevelEntityEnum | null;
  accessEntityAppointmentDelete: boolean | null;
  accessEntityAppointmentDirection: AccessDirectionEnum | null;
  accessEntityAppointmentTagCreate: boolean | null;
  accessEntityBetterNavigator: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityBetterNavigatorDeleteNotOwned: boolean | null;
  accessEntityBetterNavigatorDeleteOwned: boolean | null;
  accessEntityBetterNavigatorSharingCustom: boolean | null;
  accessEntityBetterNavigatorSharingPublic: boolean | null;
  accessEntityContact: AccessLevelEntityEnum | null;
  accessEntityContactCopy: boolean | null;
  accessEntityContactDelete: boolean | null;
  accessEntityContactDirection: AccessDirectionEnum | null;
  accessEntityContactPrivate: boolean | null;
  accessEntityContactTagCreate: boolean | null;
  accessEntityContactTypes: AccessEntityTypesEnum | null;
  accessEntityDashboard: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityDashboardDeleteNotOwned: boolean | null;
  accessEntityDashboardDeleteOwned: boolean | null;
  accessEntityDashboardSharingCustom: boolean | null;
  accessEntityDashboardSharingPublic: boolean | null;
  accessEntityEmailContentShareMode: ContentShareModeConfigEnum | null;
  accessEntityEmailDeleteNotOwned: boolean | null;
  accessEntityEmailSequence: AccessLevelEmailSequenceEnum | null;
  accessEntityEmailTemplate: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityEmailTemplateCreateDeleteFolder: boolean | null;
  accessEntityEmailTemplateDeleteNotOwned: boolean | null;
  accessEntityEmailTemplateDeleteOwned: boolean | null;
  accessEntityEmailTemplateSharingCustom: boolean | null;
  accessEntityEmailTemplateSharingPublic: boolean | null;
  accessEntityForecast: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityForecastDeleteNotOwned: boolean | null;
  accessEntityForecastDeleteOwned: boolean | null;
  accessEntityForecastEditNotOwned: boolean | null;
  accessEntityForecastSharingCustom: boolean | null;
  accessEntityForecastSharingPublic: boolean | null;
  accessEntityFormView: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityFormViewDeleteNotOwned: boolean | null;
  accessEntityFormViewDeleteOwned: boolean | null;
  accessEntityFormViewSharingCustom: boolean | null;
  accessEntityFormViewSharingPublic: boolean | null;
  accessEntityLead: AccessLevelEntityEnum | null;
  accessEntityLeadCopy: boolean | null;
  accessEntityLeadDelete: boolean | null;
  accessEntityLeadDirection: AccessDirectionEnum | null;
  accessEntityLeadPrivate: boolean | null;
  accessEntityLeadTagCreate: boolean | null;
  accessEntityLeadTypes: AccessEntityTypesEnum | null;
  accessEntityMessageTagCreate: boolean | null;
  accessEntityOppty: AccessLevelEntityEnum | null;
  accessEntityOpptyCopy: boolean | null;
  accessEntityOpptyDelete: boolean | null;
  accessEntityOpptyDirection: AccessDirectionEnum | null;
  accessEntityOpptyPrivate: boolean | null;
  accessEntityOpptyTagCreate: boolean | null;
  accessEntityPipeline: AccessLevelPipelineEnum | null;
  accessEntityProcess: AccessLevelProcessBuilderEnum | null;
  accessEntityProfile: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityProfileDefaultScreenProfiles: ScreensDefaultProfilesParams | null;
  accessEntityProfileDeleteNotOwned: boolean | null;
  accessEntityProfileDeleteOwned: boolean | null;
  accessEntityProfileSharingCustom: boolean | null;
  accessEntityProfileSharingPublic: boolean | null;
  accessEntityProject: AccessLevelEntityEnum | null;
  accessEntityProjectCopy: boolean | null;
  accessEntityProjectDelete: boolean | null;
  accessEntityProjectDirection: AccessDirectionEnum | null;
  accessEntityProjectPrivate: boolean | null;
  accessEntityProjectTagCreate: boolean | null;
  accessEntityQuote: AccessLevelEntityEnum | null;
  accessEntityQuoteCopy: boolean | null;
  accessEntityQuoteDelete: boolean | null;
  accessEntityQuoteDirection: AccessDirectionEnum | null;
  accessEntityQuoteTypes: AccessEntityTypesEnum | null;
  accessEntityReport: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityReportCreateDeleteFolder: boolean | null;
  accessEntityReportDeleteNotOwned: boolean | null;
  accessEntityReportDeleteOwned: boolean | null;
  accessEntityReportPrivate: boolean | null;
  accessEntityReportScheduleCreate: boolean | null;
  accessEntityReportScheduleManagement: boolean | null;
  accessEntityReportSharingCustom: boolean | null;
  accessEntityReportSharingPublic: boolean | null;
  accessEntityTarget: AccessLevelCommonRecordsEnumEnum | null;
  accessEntityTargetDeleteNotOwned: boolean | null;
  accessEntityTargetDeleteOwned: boolean | null;
  accessEntityTask: AccessLevelEntityEnum | null;
  accessEntityTaskDelete: boolean | null;
  accessEntityTaskDirection: AccessDirectionEnum | null;
  accessEntityTaskTagCreate: boolean | null;
  accessEntityTaskUnassigned: boolean | null;
  accessExport: boolean | null;
  accessFeeds: boolean | null;
  accessForeignCurrencies: boolean | null;
  accessFormAndFields: boolean | null;
  accessGlobalSettings: boolean | null;
  accessHomeScreen: boolean | null;
  accessImport: boolean | null;
  accessInsights: boolean | null;
  accessLeads: boolean | null;
  accessOnlineForms: boolean | null;
  accessOnlineFormsManagement: boolean | null;
  accessOpportunity: boolean | null;
  accessPipelineConfiguration: boolean | null;
  accessPrint: boolean | null;
  accessProductsServices: boolean | null;
  accessProjects: boolean | null;
  accessQuotes: boolean | null;
  accessSalesRoles: boolean | null;
  accessSecurity: boolean | null;
  accessUnits: boolean | null;
  accessUserAndRoles: boolean | null;
  accessVoyagerAi: boolean | null;
  accessWhatsAppCompanyPhone: AccessLevelCompanyEmailsEnum | null;
  allowedAccountTypes: AllowedAccountTypeEntityConnection | null;
  allowedCompanyEmails: AllowedCompanyEmailEntityConnection | null;
  allowedCompanyPhones: AllowedCompanyPhoneEntityConnection | null;
  allowedContactTypes: AllowedContactTypeEntityConnection | null;
  allowedLeadTypes: AllowedLeadTypeEntityConnection | null;
  allowedPipelines: AllowedPipelineEntityConnection | null;
  allowedQuoteTypes: AllowedQuoteTypeEntityConnection | null;
  created: DateTime | null;
  customEntities: CustomEntityMasterRight[] | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  revision: number | null;
}

export interface MassEmailTrackingInfo  {
  __typename?: 'MassEmailTrackingInfo';
  bouncedEmailCount: number;
  clickEmailEventCount: number;
  openEmailEventCount: number;
  repliedEmailCount: number;
  sentEmailEventCount: number;
  totalEmailEventCount: number;
  unsubscribedEmailCount: number;
}

export interface MassEmailRelationItemEdge  {
  __typename?: 'MassEmailRelationItemEdge';
  cursor: string;
  node: MassEmailRelation | null;
}

export interface MassEmailRelationItemConnection  {
  __typename?: 'MassEmailRelationItemConnection';
  edges: MassEmailRelationItemEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface MassEmailRelation  {
  __typename?: 'MassEmailRelation';
  emailId: ID;
  entityType: EntityNameEnum | null;
  errorCode: number;
  id: ID | null;
  isAvailable: boolean;
  itemsInConversationCount: number;
  name: string | null;
  ownerName: string | null;
  pictureUrl: string | null;
  primaryEmail: string | null;
  sentiment: EmailSentimentEnum | null;
  tags: FeedTag[];
  wasBounced: boolean;
  wasSent: boolean;
}

export interface MarkNotificationsRevisionSeenPayload  {
  __typename?: 'MarkNotificationsRevisionSeenPayload';
  clientMutationId: string | null;
}

export interface MarkNotificationsAsReadPayload  {
  __typename?: 'MarkNotificationsAsReadPayload';
  clientMutationId: string | null;
}

export interface MarkAllNotificationsAsReadPayload  {
  __typename?: 'MarkAllNotificationsAsReadPayload';
  clientMutationId: string | null;
}

export interface MapViewItem extends MapViewInterface {
  __typename?: 'MapViewItem';
  entityId: ID;
  entityType: EntityNameEnum;
  entityTypeId: UUID;
  geoLocation: GeoLocationEntity;
  name: string;
  value: number | null;
}

export interface ManualMergeDuplicatesPayload  {
  __typename?: 'ManualMergeDuplicatesPayload';
  clientMutationId: string | null;
  result: MergeRecordPayload | null;
}

export interface ManageUserDataClientPayload  {
  __typename?: 'ManageUserDataClientPayload';
  clientMutationId: string | null;
}

export interface ManageSharingTaskPayload  {
  __typename?: 'ManageSharingTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface ManageSharingQuotePayload  {
  __typename?: 'ManageSharingQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ManageSharingProjectPayload  {
  __typename?: 'ManageSharingProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity | null;
}

export interface ManageSharingOpportunityPayload  {
  __typename?: 'ManageSharingOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface ManageSharingLeadPayload  {
  __typename?: 'ManageSharingLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ManageSharingEmailPayload  {
  __typename?: 'ManageSharingEmailPayload';
  clientMutationId: string | null;
  result: EmailEntity | null;
}

export interface ManageSharingCustomEntityPayload  {
  __typename?: 'ManageSharingCustomEntityPayload';
  clientMutationId: string | null;
  result: CustomEntityEntity | null;
}

export interface ManageSharingContactPayload  {
  __typename?: 'ManageSharingContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface ManageSharingAccountPayload  {
  __typename?: 'ManageSharingAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface ManageContentSharingEmailPayload  {
  __typename?: 'ManageContentSharingEmailPayload';
  clientMutationId: string | null;
  result: EmailEntity | null;
}

export interface MakeProfileActivePayload  {
  __typename?: 'MakeProfileActivePayload';
  clientMutationId: string | null;
}

export interface MainFilterBox extends FilterBoxInterface {
  __typename?: 'MainFilterBox';
  entity: string;
  filterFields: FieldFilterRule[];
  id: string;
  lookupFieldId: UUID | null;
}

export interface LookupSettingsProperty  {
  __typename?: 'LookupSettingsProperty';
  primaryRelationResolution: LookupPrimaryRelationResolutionEnum | null;
}

export interface LookupProperty  {
  __typename?: 'LookupProperty';
  entityApiName: string | null;
  entityType: LookupEntityTypeEnum | null;
  filter: FieldFilter | null;
  hasPrimaryRelation: boolean | null;
  oppositeLookupFieldId: UUID | null;
  showRelated: boolean;
  tabName: string;
}

export interface LookupItem  {
  __typename?: 'LookupItem';
  entityApiName: string | null;
  entityName: EntityNameEnum;
  entityTypeId: ID | null;
  id: UUID;
  isArchived: boolean | null;
  isAvailable: boolean | null;
  isDeleted: boolean | null;
  isPrimary: boolean;
  name: string | null;
  pictureUrl: string | null;
}

export interface LookupDataView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LookupDataView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LookupDataEdge  {
  __typename?: 'LookupDataEdge';
  cursor: string;
  node: LookupItem | null;
}

export interface LookupDataConnection  {
  __typename?: 'LookupDataConnection';
  edges: LookupDataEdge[];
  pageInfo: PageInfo;
}

export interface LookUpTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LookUpTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LocationTrackingPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'LocationTrackingPipelineHubItemEntity';
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface LocationTrackingMapViewItems  {
  __typename?: 'LocationTrackingMapViewItems';
  compactListSessionId: string | null;
  isResultTooLarge: boolean;
  items: MapViewInterfaceImplementors[];
  missingGeoLocationItems: number | null;
}

export interface ListChart  {
  __typename?: 'ListChart';
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface LinkedItemsProperty  {
  __typename?: 'LinkedItemsProperty';
  showArchivedRecords: boolean;
}

export interface LinkedItemTypesInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'LinkedItemTypesInterfaceFieldData';
  account: boolean;
  appointment: boolean;
  contact: boolean;
  customEntity: string[];
  fieldId: UUID;
  lead: boolean;
  opportunity: boolean;
  project: boolean;
  quote: boolean;
  task: boolean;
}

export interface LinkedItemType  {
  __typename?: 'LinkedItemType';
  entity: LinkedEntityType;
  entityApiName: string | null;
  id: ID;
  name: string;
}

export interface LinkUrl  {
  __typename?: 'LinkUrl';
  id: string;
  url: string;
}

export interface LinkCustomEntityRelationDataPayload  {
  __typename?: 'LinkCustomEntityRelationDataPayload';
  clientMutationId: string | null;
}

export interface LifeCycleScreenProfile extends ProfileInterface {
  __typename?: 'LifeCycleScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: LifeCycleProfile;
  useLang: boolean;
}

export interface LifeCycleScreen extends ProfileScreen, Screen {
  __typename?: 'LifeCycleScreen';
  activeProfile: LifeCycleScreenProfile;
  data: LifeCycleData | null;
  draftProfile: LifeCycleScreenProfile | null;
  name: string;
  profiles: LifeCycleScreenProfile[];
}

export interface LifeCycleProfileViewTab  {
  __typename?: 'LifeCycleProfileViewTab';
  calculateOpptyByFieldId: UUID | null;
  period: PeriodOption;
}

export interface LifeCycleProfile extends LeadOpptyPipelineProfileInterface, OpportunityProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface {
  __typename?: 'LifeCycleProfile';
  filter: OpportunityFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  salesPipeline: ID[] | null;
  view: LifeCycleProfileViewTab;
}

export interface LifeCycleData  {
  __typename?: 'LifeCycleData';
  drilldownData: DrilldownModel;
  drilldownLead: DrilldownModel;
  drilldownStep: DrilldownModel;
  pipelineData: PipelinePerformanceData;
  pipelineLeadsData: PipelinePerformanceData;
  pipelineStepData: PipelinePerformanceData;
  pipelines: PipelinePerformanceData[];
  pipelinesLifeCycle: SalesPipelineLifeCycle[];
}

export interface LeadsAndOpportunitiesNotificationSettings  {
  __typename?: 'LeadsAndOpportunitiesNotificationSettings';
  IsActive: boolean;
  LinkedItem: boolean;
  Move: boolean;
  OwnershipAndSalesTeamChange: boolean;
  Qualification: boolean;
  StatusChange: boolean;
}

export interface LeadTypeRepository  {
  __typename?: 'LeadTypeRepository';
  getAll: LeadTypeEntity[];
  getByCriteria: LeadTypeEntityConnection | null;
  getById: LeadTypeEntity | null;
  getByIds: LeadTypeEntity[];
  getByLeadProcess: LeadTypeEntity | null;
  getDraftById: LeadTypeEntity;
  getDrafts: LeadTypeEntity[];
  getPublished: LeadTypeEntity[];
}

export interface LeadTypeEntityEdge  {
  __typename?: 'LeadTypeEntityEdge';
  cursor: string;
  node: LeadTypeEntity | null;
}

export interface LeadTypeEntityConnection  {
  __typename?: 'LeadTypeEntityConnection';
  edges: LeadTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadTypeEntity  {
  __typename?: 'LeadTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  formLost: JSONString;
  formLostApi: Form | null;
  formLostEnabled: boolean;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  leadProcess: LeadProcessEntity | null;
  leadProcessId: ID;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface LeadTabDataGridViewStat  {
  __typename?: 'LeadTabDataGridViewStat';
  count: number;
  status: LeadStatusEnum;
}

export interface LeadTabDataGridViewOptions  {
  __typename?: 'LeadTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByStatus: LeadStatusEnum[] | null;
  filterByTags: ID[] | null;
  searchQuery: string | null;
}

export interface LeadTabDataGridView  {
  __typename?: 'LeadTabDataGridView';
  ofAccount: AccountLeadTabDataGridView;
  ofContact: ContactLeadTabDataGridView;
}

export interface LeadStepSummaryInfo  {
  __typename?: 'LeadStepSummaryInfo';
  itemCount: number;
  readyToMoveCount: number;
  readyToMoveIds: ID[];
  stepId: ID | null;
}

export interface LeadStepMetadata  {
  __typename?: 'LeadStepMetadata';
  age: number;
  stepId: UUID | null;
}

export interface LeadStepExtractView  {
  __typename?: 'LeadStepExtractView';
  archiveLeadsCount: number;
  archiveLeadsSession: UUID | null;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  leadsCount: number;
  leadsSession: UUID | null;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
}

export interface LeadStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'LeadStatusInterfaceFieldData';
  fieldId: UUID;
  leadStatus: LeadStatusEnum;
}

export interface LeadSearchResultItem extends SearchResultItemInterface {
  __typename?: 'LeadSearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  owner: string | null;
}

export interface LeadRoleTab extends RoleTabInterface {
  __typename?: 'LeadRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
  showUnassignedItems: boolean;
}

export interface LeadRepository  {
  __typename?: 'LeadRepository';
  aiAutoPrefill: LeadAutoPrefill;
  autoPrefill: LeadEntity;
  getAll: LeadEntity[];
  getByCriteria: LeadEntityConnection | null;
  getById: LeadEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: LeadEntity[];
  getBySession: LeadEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface, RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: 'LeadRecentlyOpenedResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  owner: string;
}

export interface LeadProfileData  {
  __typename?: 'LeadProfileData';
  boardViewItems: LeadBoardViewItems;
  compactViewItems: LeadCompactViewItems;
  listViewItems: LeadDataGridViewItems;
  mapViewItems: LeadMapViewItems;
}

export interface LeadProcessRepository  {
  __typename?: 'LeadProcessRepository';
  getAll: LeadProcessEntity[];
  getByCriteria: LeadProcessEntityConnection | null;
  getById: LeadProcessEntity | null;
  getByIds: LeadProcessEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadProcessEntityEdge  {
  __typename?: 'LeadProcessEntityEdge';
  cursor: string;
  node: LeadProcessEntity | null;
}

export interface LeadProcessEntityConnection  {
  __typename?: 'LeadProcessEntityConnection';
  edges: LeadProcessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadProcessEntity  {
  __typename?: 'LeadProcessEntity';
  color: number | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadTypes: LeadTypeEntity[];
  modified: DateTime | null;
  name: string;
  revision: number | null;
  steps: StepEntity[];
}

export interface LeadPreviewViewTab  {
  __typename?: 'LeadPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  groupBy: LeadGroupBy | null;
  showCardFitness: boolean | null;
  showCardLabels: boolean | null;
  showCardRanking: boolean | null;
  showCardVelocity: boolean | null;
  showExtraFieldIds: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface LeadPreviewStepExtractView  {
  __typename?: 'LeadPreviewStepExtractView';
  archiveLeadsCount: number;
  archiveLeadsSession: UUID | null;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  leadsCount: number;
  leadsSession: UUID | null;
  readyToMoveCount: number;
  readyToMoveSession: UUID | null;
}

export interface LeadPreviewScreenProfile extends ProfileInterface {
  __typename?: 'LeadPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: LeadPreviewProfile;
  useLang: boolean;
}

export interface LeadPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'LeadPreviewScreen';
  activeProfile: LeadPreviewScreenProfile;
  data: LeadProfileData;
  draftProfile: LeadPreviewScreenProfile | null;
  entityData: LeadEntityData | null;
  item: LeadItem | null;
  name: string;
  profiles: LeadPreviewScreenProfile[];
}

export interface LeadPreviewProfile extends LeadProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'LeadPreviewProfile';
  filter: LeadFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  role: LeadRoleTab;
  view: LeadPreviewViewTab;
}

export interface LeadPreviewOpportunityStepExtractView  {
  __typename?: 'LeadPreviewOpportunityStepExtractView';
  avgDaysInProcess: number;
  qualificationRateCount: number;
  qualificationRateSession: UUID | null;
  qualificationRateTotalCount: number;
}

export interface LeadOpptyStepCheckListRelationRepository  {
  __typename?: 'LeadOpptyStepCheckListRelationRepository';
  getAll: LeadOpptyStepCheckListRelationEntity[];
  getByCriteria: LeadOpptyStepCheckListRelationEntityConnection | null;
  getById: LeadOpptyStepCheckListRelationEntity | null;
  getByIds: LeadOpptyStepCheckListRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyStepCheckListRelationEntityEdge  {
  __typename?: 'LeadOpptyStepCheckListRelationEntityEdge';
  cursor: string;
  node: LeadOpptyStepCheckListRelationEntity | null;
}

export interface LeadOpptyStepCheckListRelationEntityConnection  {
  __typename?: 'LeadOpptyStepCheckListRelationEntityConnection';
  edges: LeadOpptyStepCheckListRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyStepCheckListRelationEntity  {
  __typename?: 'LeadOpptyStepCheckListRelationEntity';
  activityId: ID | null;
  appointment: AppointmentEntity | null;
  cloudObject: CloudObjectEntity | null;
  cloudObjectId: ID | null;
  created: DateTime | null;
  email: EmailEntity | null;
  emailId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  itemChecked: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  note: NoteEntity | null;
  noteId: ID | null;
  oppty: OpportunityEntity | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
  stepChecklist: StepChecklistEntity | null;
  stepChecklistId: ID;
  task: TaskEntity | null;
}

export interface LeadOpptySharingSalesUnitRelationRepository  {
  __typename?: 'LeadOpptySharingSalesUnitRelationRepository';
  getAll: LeadOpptySharingSalesUnitRelationEntity[];
  getByCriteria: LeadOpptySharingSalesUnitRelationEntityConnection | null;
  getById: LeadOpptySharingSalesUnitRelationEntity | null;
  getByIds: LeadOpptySharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptySharingSalesUnitRelationEntityEdge  {
  __typename?: 'LeadOpptySharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: LeadOpptySharingSalesUnitRelationEntity | null;
}

export interface LeadOpptySharingSalesUnitRelationEntityConnection  {
  __typename?: 'LeadOpptySharingSalesUnitRelationEntityConnection';
  edges: LeadOpptySharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptySharingSalesUnitRelationEntity  {
  __typename?: 'LeadOpptySharingSalesUnitRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface LeadOpptySharingClientRelationRepository  {
  __typename?: 'LeadOpptySharingClientRelationRepository';
  getAll: LeadOpptySharingClientRelationEntity[];
  getByCriteria: LeadOpptySharingClientRelationEntityConnection | null;
  getById: LeadOpptySharingClientRelationEntity | null;
  getByIds: LeadOpptySharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptySharingClientRelationEntityEdge  {
  __typename?: 'LeadOpptySharingClientRelationEntityEdge';
  cursor: string;
  node: LeadOpptySharingClientRelationEntity | null;
}

export interface LeadOpptySharingClientRelationEntityConnection  {
  __typename?: 'LeadOpptySharingClientRelationEntityConnection';
  edges: LeadOpptySharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptySharingClientRelationEntity  {
  __typename?: 'LeadOpptySharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface LeadOpptyRepository  {
  __typename?: 'LeadOpptyRepository';
  getAll: LeadOpptyEntity[];
  getByCriteria: LeadOpptyEntityConnection | null;
  getById: LeadOpptyEntity | null;
  getByIds: LeadOpptyEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyKPIRepository  {
  __typename?: 'LeadOpptyKPIRepository';
  getAll: LeadOpptyKPIEntity[];
  getByCriteria: LeadOpptyKPIEntityConnection | null;
  getById: LeadOpptyKPIEntity | null;
  getByIds: LeadOpptyKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyKPIEntityEdge  {
  __typename?: 'LeadOpptyKPIEntityEdge';
  cursor: string;
  node: LeadOpptyKPIEntity | null;
}

export interface LeadOpptyKPIEntityConnection  {
  __typename?: 'LeadOpptyKPIEntityConnection';
  edges: LeadOpptyKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyKPIEntity  {
  __typename?: 'LeadOpptyKPIEntity';
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: LeadOpptyKpiEnum;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  owner: ClientEntity | null;
  ownerId: ID | null;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface LeadOpptyEntityEdge  {
  __typename?: 'LeadOpptyEntityEdge';
  cursor: string;
  node: LeadOpptyEntity | null;
}

export interface LeadOpptyEntityConnection  {
  __typename?: 'LeadOpptyEntityConnection';
  edges: LeadOpptyEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyEntity  {
  __typename?: 'LeadOpptyEntity';
  customFields: JSONString;
  fields: InterfaceFieldDataImplementors[];
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  pendingScheduledActions: number | null;
}

export interface LeadOpptyDrilldownFilter  {
  __typename?: 'LeadOpptyDrilldownFilter';
  ownerId: ID[] | null;
}

export interface LeadOpptyDataExRelationRepository  {
  __typename?: 'LeadOpptyDataExRelationRepository';
  getAll: LeadOpptyDataExRelationEntity[];
  getByCriteria: LeadOpptyDataExRelationEntityConnection | null;
  getById: LeadOpptyDataExRelationEntity | null;
  getByIds: LeadOpptyDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyDataExRelationEntityEdge  {
  __typename?: 'LeadOpptyDataExRelationEntityEdge';
  cursor: string;
  node: LeadOpptyDataExRelationEntity | null;
}

export interface LeadOpptyDataExRelationEntityConnection  {
  __typename?: 'LeadOpptyDataExRelationEntityConnection';
  edges: LeadOpptyDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyDataExRelationEntity  {
  __typename?: 'LeadOpptyDataExRelationEntity';
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  revision: number | null;
}

export interface LeadOpptyContactSalesRoleRelationRepository  {
  __typename?: 'LeadOpptyContactSalesRoleRelationRepository';
  getAll: LeadOpptyContactSalesRoleRelationEntity[];
  getByCriteria: LeadOpptyContactSalesRoleRelationEntityConnection | null;
  getById: LeadOpptyContactSalesRoleRelationEntity | null;
  getByIds: LeadOpptyContactSalesRoleRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyContactSalesRoleRelationEntityEdge  {
  __typename?: 'LeadOpptyContactSalesRoleRelationEntityEdge';
  cursor: string;
  node: LeadOpptyContactSalesRoleRelationEntity | null;
}

export interface LeadOpptyContactSalesRoleRelationEntityConnection  {
  __typename?: 'LeadOpptyContactSalesRoleRelationEntityConnection';
  edges: LeadOpptyContactSalesRoleRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyContactSalesRoleRelationEntity  {
  __typename?: 'LeadOpptyContactSalesRoleRelationEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadOpptyContactRelation: LeadOpptyContactRelationEntity | null;
  leadOpptyContactRelationId: ID | null;
  modified: DateTime | null;
  revision: number | null;
  salesRole: SalesRoleEntity | null;
  salesRoleId: ID;
}

export interface LeadOpptyContactRelationRepository  {
  __typename?: 'LeadOpptyContactRelationRepository';
  getAll: LeadOpptyContactRelationEntity[];
  getByCriteria: LeadOpptyContactRelationEntityConnection | null;
  getById: LeadOpptyContactRelationEntity | null;
  getByIds: LeadOpptyContactRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyContactRelationEntityEdge  {
  __typename?: 'LeadOpptyContactRelationEntityEdge';
  cursor: string;
  node: LeadOpptyContactRelationEntity | null;
}

export interface LeadOpptyContactRelationEntityConnection  {
  __typename?: 'LeadOpptyContactRelationEntityConnection';
  edges: LeadOpptyContactRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyContactRelationEntity  {
  __typename?: 'LeadOpptyContactRelationEntity';
  comment: string | null;
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  lead: LeadEntity | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationEntity | null;
  leadOpptyContactGroupRelationId: ID | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  positionInGroup: JSONString | null;
  relationship: OrgRelationshipTypeEnum | null;
  revision: number | null;
  salesRoles: LeadOpptyContactSalesRoleRelationEntity[] | null;
}

export interface LeadOpptyContactGroupRelationRepository  {
  __typename?: 'LeadOpptyContactGroupRelationRepository';
  getAll: LeadOpptyContactGroupRelationEntity[];
  getByCriteria: LeadOpptyContactGroupRelationEntityConnection | null;
  getById: LeadOpptyContactGroupRelationEntity | null;
  getByIds: LeadOpptyContactGroupRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyContactGroupRelationEntityEdge  {
  __typename?: 'LeadOpptyContactGroupRelationEntityEdge';
  cursor: string;
  node: LeadOpptyContactGroupRelationEntity | null;
}

export interface LeadOpptyContactGroupRelationEntityConnection  {
  __typename?: 'LeadOpptyContactGroupRelationEntityConnection';
  edges: LeadOpptyContactGroupRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyContactGroupRelationEntity  {
  __typename?: 'LeadOpptyContactGroupRelationEntity';
  color: number;
  created: DateTime | null;
  groupPosition: JSONString;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  name: string;
  oppty: OpportunityEntity | null;
  revision: number | null;
}

export interface LeadOpptyAccountRelationRepository  {
  __typename?: 'LeadOpptyAccountRelationRepository';
  getAll: LeadOpptyAccountRelationEntity[];
  getByCriteria: LeadOpptyAccountRelationEntityConnection | null;
  getById: LeadOpptyAccountRelationEntity | null;
  getByIds: LeadOpptyAccountRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface LeadOpptyAccountRelationEntityEdge  {
  __typename?: 'LeadOpptyAccountRelationEntityEdge';
  cursor: string;
  node: LeadOpptyAccountRelationEntity | null;
}

export interface LeadOpptyAccountRelationEntityConnection  {
  __typename?: 'LeadOpptyAccountRelationEntityConnection';
  edges: LeadOpptyAccountRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadOpptyAccountRelationEntity  {
  __typename?: 'LeadOpptyAccountRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  lead: LeadEntity | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  revision: number | null;
}

export interface LeadOpportunityTableReportProfile extends LeadOpportunityReportProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface, TargetProfileInterface {
  __typename?: 'LeadOpportunityTableReportProfile';
  filter: LeadOpportunityFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  role: LeadOpportunityRoleTab;
  salesPipeline: ID[] | null;
  target: OpportunityReportTargetTab;
  view: ViewTableReportTab;
}

export interface LeadOpportunityRoleTab extends RoleTabInterface {
  __typename?: 'LeadOpportunityRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
  showUnassignedItems: boolean;
}

export interface LeadOpportunityPivotReportProfile extends LeadOpportunityReportProfileInterface, PipelineProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TargetProfileInterface {
  __typename?: 'LeadOpportunityPivotReportProfile';
  filter: LeadOpportunityFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  role: LeadOpportunityRoleTab;
  salesPipeline: ID[] | null;
  target: OpportunityReportTargetTab;
  view: ViewPivotReportTab;
}

export interface LeadOpportunityFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'LeadOpportunityFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface LeadNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LeadMapViewItems  {
  __typename?: 'LeadMapViewItems';
  compactListSessionId: string | null;
  insufficientDataItems: number | null;
  insufficientListSessionFirstItemId: ID | null;
  insufficientListSessionId: string | null;
  isResultTooLarge: boolean;
  items: MapViewInterfaceImplementors[];
  missingGeoLocationItems: number | null;
}

export interface LeadMapViewItem extends MapViewInterface {
  __typename?: 'LeadMapViewItem';
  entityId: ID;
  entityType: EntityNameEnum;
  entityTypeId: UUID;
  geoLocation: GeoLocationEntity;
  name: string;
  status: LeadStatusEnum;
  value: number | null;
}

export interface LeadListView extends ListViewInterface {
  __typename?: 'LeadListView';
  displayColumn: UUID[];
  profile: LeadPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface LeadItem  {
  __typename?: 'LeadItem';
  boardViewItem: LeadBoardViewItem | null;
  compactViewItem: LeadCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
}

export interface LeadFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'LeadFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface LeadFeedTabDataGridView  {
  __typename?: 'LeadFeedTabDataGridView';
  feed: Feed;
}

export interface LeadFeedEmailTabDataGridView  {
  __typename?: 'LeadFeedEmailTabDataGridView';
  feed: Feed;
}

export interface LeadFavoriteResultItem extends FavoriteResultItemInterface, FavoriteResultItemIsArchivedInterface {
  __typename?: 'LeadFavoriteResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  owner: string;
}

export interface LeadEntityEdge  {
  __typename?: 'LeadEntityEdge';
  cursor: string;
  node: LeadEntity | null;
}

export interface LeadEntityData  {
  __typename?: 'LeadEntityData';
  accounts: LeadOpptyAccountRelationEntityConnection | null;
  contactRelations: OrgChartRelation[] | null;
  contacts: LeadOpptyContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: LeadEntity;
  fields: InterfaceFieldDataImplementors[];
  fitnessDescription: FitnessDescription;
  groups: OrgChartLeadOpptyGroupEntity[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  linesOfInfluence: ContactLineOfInfluence[];
  nodes: OrgChartLeadOpptyNodeEntity[] | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  relations: OrgChartRelation[] | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface LeadEntityConnection  {
  __typename?: 'LeadEntityConnection';
  edges: LeadEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface LeadEntity  {
  __typename?: 'LeadEntity';
  accountRelations: LeadOpptyAccountRelationEntityConnection | null;
  approval: ApprovalEntity | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  contactRelations: LeadOpptyContactRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  daysInStep: number;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  enrolledEmailSequences: number;
  fields: InterfaceFieldDataImplementors[];
  fitness: WarningLevelEnum;
  fitnessDescription: FitnessDescription;
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isArchived: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  labelFlag: number | null;
  leadSource: DataEntity | null;
  leadSourceId: ID | null;
  leadType: LeadTypeEntity | null;
  leadTypeId: ID | null;
  lostDate: DateTime | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID | null;
  pendingScheduledActions: number | null;
  primaryAccount: AccountEntity | null;
  primaryContact: ContactEntity | null;
  qualifyDate: DateTime | null;
  quickAccountEmail: string | null;
  quickAccountName: string | null;
  quickAccountPhone: string | null;
  quickContactName: string | null;
  quickEmail: string | null;
  quickPhone: string | null;
  ranking: number | null;
  reasonOfClose: DataEntity | null;
  reasonOfCloseDescription: string | null;
  reasonOfCloseId: ID | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revision: number | null;
  scoring: EntityScoringResult | null;
  shareMode: ShareModeEnum | null;
  sharingClients: LeadOpptySharingClientRelationEntityConnection | null;
  sharingUnits: LeadOpptySharingSalesUnitRelationEntityConnection | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  status: LeadStatusEnum;
  step: StepEntity | null;
  stepChecklists: StepChecklistActivityItem[];
  stepId: ID | null;
  tableName: string;
  tags: TagRelationEntityConnection | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
}

export interface LeadDrilldownFilter  {
  __typename?: 'LeadDrilldownFilter';
  ownerId: ID[] | null;
}

export interface LeadDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LeadDashboardView  {
  __typename?: 'LeadDashboardView';
  data: DashboardGraphItemInterfaceImplementors[] | null;
}

export interface LeadDashboardProfileView extends DashboardViewInterface {
  __typename?: 'LeadDashboardProfileView';
  drilldownFields: ID[];
  graphs: DashboardGraphLeadNameType[];
}

export interface LeadDashboardProfileTab extends DashboardTabItem {
  __typename?: 'LeadDashboardProfileTab';
  id: ID;
  leadDashboardProfile: LeadDashboardProfile | null;
}

export interface LeadDashboardProfile extends LeadProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, RoleProfileInterface {
  __typename?: 'LeadDashboardProfile';
  filter: LeadFilterTab;
  leadProcess: UUID[] | null;
  role: LeadRoleTab;
  view: LeadDashboardProfileView;
}

export interface LeadCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadCompactViewItems';
  groups: ViewItemGroup[];
  items: LeadCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface LeadCompactViewItem extends ViewItemInterface {
  __typename?: 'LeadCompactViewItem';
  daysInQueue: number | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  fitness: WarningLevelEnum | null;
  groupName: FieldDataContainer | null;
  id: ID;
  isFavorite: boolean | null;
  labelFlag: number | null;
  leadTypeId: ID;
  name: string;
  owner: string | null;
  ownerId: string | null;
  ownerPicture: string | null;
  ranking: number | null;
  sortFieldValue: FieldDataContainer | null;
  sortIcon: string | null;
  unit: string;
  unitId: string;
  unitPicture: string | null;
}

export interface LeadCompactView extends CompactViewInterface {
  __typename?: 'LeadCompactView';
  feedListingOptions: FeedTabDataGridViewOptions;
  profile: LeadPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface LeadCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LeadBoardViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'LeadBoardViewItems';
  columns: LeadBoardColumnItems[];
  sessionId: string;
  total: number;
}

export interface LeadBoardViewItem extends ViewItemInterface {
  __typename?: 'LeadBoardViewItem';
  extraFieldValues: string[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  hotStalledPriorityFlag: number;
  id: ID;
  leadStepMetadata: LeadStepMetadata[];
  name: string;
  ranking: number;
  role: ShareActorEnum;
  tags: number[] | null;
}

export interface LeadBoardView extends BoardViewInterface {
  __typename?: 'LeadBoardView';
  includeQualifiedStep: boolean;
  profile: LeadPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface LeadBoardColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'LeadBoardColumnItems';
  items: LeadBoardViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: LeadStepSummaryInfo;
  total: number;
}

export interface LeadAutoPrefill  {
  __typename?: 'LeadAutoPrefill';
  entity: LeadEntity | null;
  fieldIds: UUID[];
}

export interface LeadArchiveStepSummaryInfo  {
  __typename?: 'LeadArchiveStepSummaryInfo';
  itemCount: number;
  stepId: ID | null;
}

export interface LeadArchiveScreenProfile extends ProfileInterface {
  __typename?: 'LeadArchiveScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: LeadArchiveProfile;
  useLang: boolean;
}

export interface LeadArchiveScreen extends ProfileScreen, Screen {
  __typename?: 'LeadArchiveScreen';
  activeProfile: LeadArchiveScreenProfile;
  data: LeadArchiveProfileData;
  draftProfile: LeadArchiveScreenProfile | null;
  entityData: LeadArchiveEntityData | null;
  item: ArchiveLeadItem | null;
  name: string;
  profiles: LeadArchiveScreenProfile[];
}

export interface LeadArchiveProfileData  {
  __typename?: 'LeadArchiveProfileData';
  boardViewItems: LeadArchiveBoardViewItems;
  listViewItems: LeadArchiveDataGridViewItems;
}

export interface LeadArchiveProfile extends LeadProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'LeadArchiveProfile';
  filter: LeadFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  role: LeadRoleTab;
  view: LeadPreviewViewTab;
}

export interface LeadArchiveEntityData  {
  __typename?: 'LeadArchiveEntityData';
  accounts: LeadOpptyAccountRelationEntityConnection | null;
  contacts: LeadOpptyContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: LeadOpportunityEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface LeadArchiveDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadArchiveDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface LeadArchiveBoardViewItems extends ListingViewInterface, SnapshotBaseDataInterface {
  __typename?: 'LeadArchiveBoardViewItems';
  columns: LeadArchiveBoardColumnItems[];
  sessionId: string;
  total: number;
}

export interface LeadArchiveBoardViewItem extends ViewItemInterface {
  __typename?: 'LeadArchiveBoardViewItem';
  extraFieldValues: string[];
  fitness: WarningLevelEnum | null;
  groupIcon: string | null;
  groupName: FieldDataContainer | null;
  hotStalledPriorityFlag: number;
  id: ID;
  name: string;
  ranking: number;
  role: ShareActorEnum;
  tags: number[] | null;
}

export interface LeadArchiveBoardColumnItems extends SnapshotIndexedDataInterface {
  __typename?: 'LeadArchiveBoardColumnItems';
  items: LeadArchiveBoardViewItem[];
  sessionId: string;
  stepDocuments: CloudObjectStepRelationEntity[];
  stepSummary: LeadArchiveStepSummaryInfo;
  total: number;
}

export interface LeadActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'LeadActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface LeadActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'LeadActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface LeadActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'LeadActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface LastContactedItem  {
  __typename?: 'LastContactedItem';
  contactedDate: GqlDate;
  entityType: EntityNameEnum;
  id: UUID;
}

export interface LabelFlagInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'LabelFlagInterfaceFieldData';
  fieldId: UUID;
  focus: boolean;
  hot: boolean;
  stalled: boolean;
}

export interface JiraSyncTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'JiraSyncTeamPipelineHubItemEntity';
  configuration: JSONString | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface Issuer  {
  __typename?: 'Issuer';
  id: ID;
  name: string | null;
}

export interface Invoice  {
  __typename?: 'Invoice';
  html: string;
  id: string;
}

export interface InterfacePreviewRepository  {
  __typename?: 'InterfacePreviewRepository';
  getAll: InterfacePreviewEntity[];
  getByCriteria: InterfacePreviewEntity[];
  getById: InterfacePreviewEntity | null;
  getByIds: InterfacePreviewEntity[];
  getDraftById: InterfacePreviewEntity;
  getDrafts: InterfacePreviewEntity[];
  getPublished: InterfacePreviewEntity[];
}

export interface InterfacePreviewEntity  {
  __typename?: 'InterfacePreviewEntity';
  accountType: AccountTypeEntity | null;
  accountTypeId: ID | null;
  appointmentType: AppointmentTypeEntity | null;
  appointmentTypeId: ID | null;
  cardFieldIds: UUID[];
  charts: InterfacePreviewChart[];
  contactType: ContactTypeEntity | null;
  contactTypeId: ID | null;
  created: DateTime | null;
  customEntityType: CustomEntityTypeEntity | null;
  customEntityTypeId: ID | null;
  detailTabs: InterfaceDetailTab[];
  detailWidgets: InterfaceDetailWidget[];
  entityApiName: string | null;
  entityType: BaseEntityTypeEnum;
  entityTypeId: UUID;
  fieldIds: UUID[];
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  leadType: LeadTypeEntity | null;
  leadTypeId: ID | null;
  modified: DateTime | null;
  opptyType: OpportunityTypeEntity | null;
  opptyTypeId: ID | null;
  productType: ProductTypeEntity | null;
  productTypeId: ID | null;
  projectType: ProjectTypeEntity | null;
  projectTypeId: ID | null;
  quoteType: QuoteTypeEntity | null;
  quoteTypeId: ID | null;
  revision: number | null;
  settings: InterfacePreviewCustomSettings;
  taskType: TaskTypeEntity | null;
  taskTypeId: ID | null;
}

export interface InterfacePreviewCustomSettings  {
  __typename?: 'InterfacePreviewCustomSettings';
  isLayoutCustomizationEnabled: boolean;
}

export interface InterfacePreviewChart  {
  __typename?: 'InterfacePreviewChart';
  description: string | null;
  entityType: EntityNameEnum;
  filter: ProfileFilterTab | null;
  id: UUID;
  name: string | null;
  settings: InterfacePreviewSettings | null;
}

export interface InterfaceFieldAttendeeData  {
  __typename?: 'InterfaceFieldAttendeeData';
  email: string;
  entityType: EntityNameEnum;
  id: UUID | null;
}

export interface InterfaceDetailWidget  {
  __typename?: 'InterfaceDetailWidget';
  kind: InterfaceDetailWidgetKind;
  visible: boolean;
}

export interface InterfaceDetailUserWidget  {
  __typename?: 'InterfaceDetailUserWidget';
  entityTypeId: ID;
  kind: InterfaceDetailWidgetKind;
}

export interface InterfaceDetailUserTab  {
  __typename?: 'InterfaceDetailUserTab';
  entityTypeId: ID;
  kind: InterfaceDetailTabKind;
  lookupFieldId: UUID | null;
}

export interface InterfaceDetailTab  {
  __typename?: 'InterfaceDetailTab';
  kind: InterfaceDetailTabKind;
  lookupFieldId: UUID | null;
  visible: boolean;
}

export interface IntegrationStorage  {
  __typename?: 'IntegrationStorage';
  cloudObjectType: CloudObjectTypeEnum;
  icon: string;
  id: number;
  name: string;
}

export interface IntegrationLogsDataNode  {
  __typename?: 'IntegrationLogsDataNode';
  adminUrl: string;
  apiCalls: number;
  appName: string;
  created: number | null;
  deleted: number | null;
  event: string | null;
  failed: number | null;
  id: ComplexEventIdType;
  nanosecondsElapsed: Long;
  spaceName: string | null;
  status: IntegrationEventStatusEnum;
  thirdPartyApiCalls: number;
  timestamp: DateTime;
  updated: number | null;
}

export interface IntegrationLogsDataEdge  {
  __typename?: 'IntegrationLogsDataEdge';
  cursor: string;
  node: IntegrationLogsDataNode | null;
}

export interface IntegrationLogsDataConnection  {
  __typename?: 'IntegrationLogsDataConnection';
  edges: IntegrationLogsDataEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface IntegrationLogs  {
  __typename?: 'IntegrationLogs';
  data: IntegrationLogsDataConnection;
  logLines: IntegrationJournalLog[];
}

export interface IntegrationJournalLog  {
  __typename?: 'IntegrationJournalLog';
  code: number | null;
  id: ID;
  message: string | null;
  operation: string;
  status: IntegrationJournalLogStatusEnum;
  timestamp: DateTime;
}

export interface IntegrationIDRegistry  {
  __typename?: 'IntegrationIDRegistry';
  companyEmailsGoogleClientId: string | null;
  companyEmailsO365ClientId: string | null;
  companyEmailsO365OauthUrl: string;
  googleCalendarClientId: string | null;
  googleContactsClientId: string | null;
  googleGmailClientId: string | null;
  googleMailClientId: string | null;
  googleOauthUrl: string;
  googleTasksClientId: string | null;
  jiraActivationUrlPrefix: string | null;
  jiraIntPublicKey: string | null;
  msTeamsOauthUrl: string | null;
  o365OauthUrl: string;
  zoomOauthUrl: string | null;
}

export interface IntegrationAnalyticsData  {
  __typename?: 'IntegrationAnalyticsData';
  apiCalls: IntegrationAnalyticsChartSeries[];
  operations: IntegrationAnalyticsChartSeries[];
  runs: IntegrationAnalyticsChartSeries[];
  thirdPartyApiCalls: IntegrationAnalyticsChartSeries[];
}

export interface IntegrationAnalyticsChartSeriesItem  {
  __typename?: 'IntegrationAnalyticsChartSeriesItem';
  timePoint: DateTime;
  value: number;
}

export interface IntegrationAnalyticsChartSeries  {
  __typename?: 'IntegrationAnalyticsChartSeries';
  items: IntegrationAnalyticsChartSeriesItem[];
  label: string;
}

export interface IntegrationAnalytics  {
  __typename?: 'IntegrationAnalytics';
  data: IntegrationAnalyticsData;
}

export interface IntegerProperty  {
  __typename?: 'IntegerProperty';
  unit: string | null;
  useThousandSeparator: boolean;
}

export interface IntInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'IntInterfaceFieldData';
  fieldId: UUID;
  intValue: number | null;
}

export interface IntEnumItem  {
  __typename?: 'IntEnumItem';
  key: string;
  value: number;
}

export interface InsightsScreenProfile extends ProfileInterface {
  __typename?: 'InsightsScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: InsightsProfile;
  useLang: boolean;
}

export interface InsightsScreenOptions  {
  __typename?: 'InsightsScreenOptions';
  reportBy: InsightsReportBy;
}

export interface InsightsScreen extends ProfileScreen, Screen {
  __typename?: 'InsightsScreen';
  activeProfile: InsightsScreenProfile;
  data: InsightsData | null;
  draftProfile: InsightsScreenProfile | null;
  name: string;
  profiles: InsightsScreenProfile[];
}

export interface InsightsProfileViewTab  {
  __typename?: 'InsightsProfileViewTab';
  calculateOpptyByFieldId: UUID | null;
  period: PeriodOption;
  periodGranularity: PeriodGranularity;
  showDeletedUnits: boolean;
  showInactiveClients: boolean;
  sortBy: InsightsKPI;
}

export interface InsightsProfile extends OpportunityKPIProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface {
  __typename?: 'InsightsProfile';
  filter: OpportunityKPIFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  salesPipeline: ID[] | null;
  view: InsightsProfileViewTab;
}

export interface InsightsData  {
  __typename?: 'InsightsData';
  drillDownIds: ID[];
  drilldown: DrilldownModel;
  highlights: InsightHighlights;
  items: InsightItemInterfaceImplementors[];
  kpiTrendItems: InsightGraph | null;
  screenOptions: InsightsScreenOptions | null;
}

export interface InsightSalesUnitItem extends InsightItemInterface {
  __typename?: 'InsightSalesUnitItem';
  isDeleted: boolean;
  kpiData: InsightItemKPIData;
  picture: string | null;
  salesUnitId: ID;
  salesUnitName: string;
}

export interface InsightItemKPIData  {
  __typename?: 'InsightItemKPIData';
  CompletingActivities: number;
  CompletingActivitiesTrend: InsightsKPITrend;
  CreatingActivities: number;
  CreatingActivitiesTrend: InsightsKPITrend;
  CreatingLeads: number;
  CreatingLeadsTrend: InsightsKPITrend;
  CreatingOppties: number;
  CreatingOpptiesTrend: InsightsKPITrend;
  LeadAverageTimeSpent: number;
  LeadAverageTimeSpentTrend: InsightsKPITrend;
  LosingLeads: number;
  LosingLeadsTrend: InsightsKPITrend;
  LosingOppties: number;
  LosingOpptiesTrend: InsightsKPITrend;
  LostAmount: number;
  LostAmountTrend: InsightsKPITrend;
  OpptyAverageSize: number;
  OpptyAverageSizeTrend: InsightsKPITrend;
  OpptyAverageTimeSpent: number;
  OpptyAverageTimeSpentTrend: InsightsKPITrend;
  OpptySalesVelocity: number;
  OpptySalesVelocityTrend: InsightsKPITrend;
  OpptyWinRate: number;
  OpptyWinRateTrend: InsightsKPITrend;
  QualifyingLeads: number;
  QualifyingLeadsTrend: InsightsKPITrend;
  SendingEmails: number;
  SendingEmailsTrend: InsightsKPITrend;
  WinningOppties: number;
  WinningOpptiesTrend: InsightsKPITrend;
  WonAmount: number;
  WonAmountTrend: InsightsKPITrend;
}

export interface InsightHighlights  {
  __typename?: 'InsightHighlights';
  bestWonOpportunityDate: DateTime | null;
  bestWonOpportunityName: string | null;
  bestWonOpportunityValue: number | null;
  clientId: ID;
  createdLeads: number;
  wonAmount: number;
  wonOppties: number;
}

export interface InsightGraphItem  {
  __typename?: 'InsightGraphItem';
  date: GqlDate;
  value: number;
}

export interface InsightGraph  {
  __typename?: 'InsightGraph';
  CompletingActivities: InsightGraphItem[];
  CreatingActivities: InsightGraphItem[];
  CreatingLeads: InsightGraphItem[];
  CreatingOppties: InsightGraphItem[];
  LeadAverageTimeSpent: InsightGraphItem[];
  LosingLeads: InsightGraphItem[];
  LosingOppties: InsightGraphItem[];
  LostAmount: InsightGraphItem[];
  OpptyAverageSize: InsightGraphItem[];
  OpptyAverageTimeSpent: InsightGraphItem[];
  OpptySalesVelocity: InsightGraphItem[];
  OpptyWinRate: InsightGraphItem[];
  QualifyingLeads: InsightGraphItem[];
  SendingEmails: InsightGraphItem[];
  WinningOppties: InsightGraphItem[];
  WonAmount: InsightGraphItem[];
  itemId: ID;
}

export interface InsightClientItem extends InsightItemInterface {
  __typename?: 'InsightClientItem';
  clientEmail: string;
  clientFirstName: string;
  clientId: ID;
  clientLastName: string;
  clientMiddleName: string;
  clientPosition: string | null;
  isDeleted: boolean;
  kpiData: InsightItemKPIData;
  picture: string | null;
}

export interface InlineEditConditionalFieldInfo  {
  __typename?: 'InlineEditConditionalFieldInfo';
  readonly: boolean | null;
  required: boolean | null;
}

export interface InitializeMobileCallTaskPayload  {
  __typename?: 'InitializeMobileCallTaskPayload';
  clientMutationId: string | null;
}

export interface InitializeMobileCallOpportunityPayload  {
  __typename?: 'InitializeMobileCallOpportunityPayload';
  clientMutationId: string | null;
}

export interface InitializeMobileCallLeadPayload  {
  __typename?: 'InitializeMobileCallLeadPayload';
  clientMutationId: string | null;
}

export interface InitializeMobileCallContactPayload  {
  __typename?: 'InitializeMobileCallContactPayload';
  clientMutationId: string | null;
}

export interface InitializeMobileCallAppointmentPayload  {
  __typename?: 'InitializeMobileCallAppointmentPayload';
  clientMutationId: string | null;
}

export interface InitializeMobileCallAccountPayload  {
  __typename?: 'InitializeMobileCallAccountPayload';
  clientMutationId: string | null;
}

export interface IndicatorsScreenProfile extends ProfileInterface {
  __typename?: 'IndicatorsScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: IndicatorsProfile;
  useLang: boolean;
}

export interface IndicatorsScreen extends ProfileScreen, Screen {
  __typename?: 'IndicatorsScreen';
  activeProfile: IndicatorsScreenProfile;
  data: IndicatorsData | null;
  draftProfile: IndicatorsScreenProfile | null;
  name: string;
  profiles: IndicatorsScreenProfile[];
}

export interface IndicatorsProfileViewTab  {
  __typename?: 'IndicatorsProfileViewTab';
  calculateOpptyByFieldId: UUID | null;
  period: PeriodOption;
  periodGranularity: PeriodGranularity;
  showDeletedUnits: boolean;
  showInactiveClients: boolean;
}

export interface IndicatorsProfile extends OpportunityKPIProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface {
  __typename?: 'IndicatorsProfile';
  filter: OpportunityKPIFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  salesPipeline: ID[] | null;
  view: IndicatorsProfileViewTab;
}

export interface IndicatorsData  {
  __typename?: 'IndicatorsData';
  drillDownIds: ID[];
  drilldown: DrilldownModel;
  drilldownActivities: ActivityDrilldownModel;
  graphItem: IndicatorGraphItem[] | null;
  items: IndicatorItemInterfaceImplementors[];
  screenOptions: IndicatorScreenOptions | null;
}

export interface IndicatorScreenOptions  {
  __typename?: 'IndicatorScreenOptions';
  activeKpiTab: InsightsKPI;
  reportBy: IndicatorsReportBy;
}

export interface IndicatorSalesUnitItem extends IndicatorItemInterface {
  __typename?: 'IndicatorSalesUnitItem';
  isDeleted: boolean;
  kpiValue: number;
  picture: string | null;
  salesUnitId: ID;
  salesUnitName: string;
}

export interface IndicatorGraphItem  {
  __typename?: 'IndicatorGraphItem';
  graphData: IndicatorGraphData[];
  itemId: ID;
}

export interface IndicatorGraphData  {
  __typename?: 'IndicatorGraphData';
  date: GqlDate;
  value: number;
}

export interface IndicatorClientItem extends IndicatorItemInterface {
  __typename?: 'IndicatorClientItem';
  clientEmail: string;
  clientFirstName: string;
  clientId: ID;
  clientLastName: string;
  clientMiddleName: string;
  clientPosition: string | null;
  isDeleted: boolean;
  kpiValue: number;
  picture: string | null;
}

export interface IncomingSmsForPhonePayload  {
  __typename?: 'IncomingSmsForPhonePayload';
  clientMutationId: string | null;
  result: UUID;
}

export interface Imprint  {
  __typename?: 'Imprint';
  companyNumber: string;
  description: string;
  email: string;
  phone: string;
  vatCode: string;
  web: string;
}

export interface ImportSettingsOptions  {
  __typename?: 'ImportSettingsOptions';
  autoCreateAccounts: boolean;
  autoCreateContacts: boolean;
  columnsContainHeaders: boolean;
  dateFormat: ImportDateFormatEnum;
  deduplicateAccounts: boolean;
  deduplicateContacts: boolean;
  enclosure: ImportEnclosureEnum;
  encoding: string;
  groupByFieldId: ID | null;
  multipleCheckboxSeparator: ImportMultipleCheckboxSeparatorEnum;
  separator: ImportSeparatorEnum;
}

export interface ImportMappingRelationType  {
  __typename?: 'ImportMappingRelationType';
  entityTypeId: ID;
  fieldId: ID;
}

export interface ImportMappingMaskRepository  {
  __typename?: 'ImportMappingMaskRepository';
  getAll: ImportMappingMaskEntity[];
  getByCriteria: ImportMappingMaskEntityConnection | null;
  getById: ImportMappingMaskEntity | null;
  getByIds: ImportMappingMaskEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getForEntityType: ImportMappingMaskEntity[];
}

export interface ImportMappingMaskItem  {
  __typename?: 'ImportMappingMaskItem';
  columnIndex: number | null;
  fieldId: ID;
  mappingType: ImportFieldMappingType;
}

export interface ImportMappingMaskEntityEdge  {
  __typename?: 'ImportMappingMaskEntityEdge';
  cursor: string;
  node: ImportMappingMaskEntity | null;
}

export interface ImportMappingMaskEntityConnection  {
  __typename?: 'ImportMappingMaskEntityConnection';
  edges: ImportMappingMaskEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ImportMappingMaskEntity  {
  __typename?: 'ImportMappingMaskEntity';
  created: DateTime | null;
  entityApiName: string | null;
  entityType: ImportMaskEntityTypeEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  mapping: JSONString;
  mappingMask: ImportMappingMaskItem[] | null;
  mappingRelationTypes: ImportMappingRelationType[] | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  relationTypes: JSONString | null;
  revision: number | null;
  shareMode: ProfileShareMode | null;
  sharingClients: ClientEntity[] | null;
  sharingUnits: SalesUnitEntity[] | null;
}

export interface ImapFolder  {
  __typename?: 'ImapFolder';
  baseFolderName: string;
  fullFolderName: string;
  id: UUID;
  isInbox: boolean;
  isOutbox: boolean;
  parentId: UUID | null;
}

export interface IdentityProviderEntity  {
  __typename?: 'IdentityProviderEntity';
  acceptUntrusted: boolean | null;
  appId: string | null;
  callbackUrl: string | null;
  description: string | null;
  domain: string | null;
  enabled: boolean | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: IdentityProviderPermsEnum[];
  metadataUrl: string | null;
  name: string | null;
  redirectUrl: string | null;
  subscription: SubscriptionEntity | null;
  subscriptionId: number | null;
  tenantId: UUID | null;
  type: IdentityProviderType | null;
  url: string | null;
  verifiedEmailDomains: string | null;
  xml: Base64 | null;
}

export interface HubspotTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'HubspotTeamPipelineHubItemEntity';
  accessToken: string | null;
  configuration: HubItemIntegrationSyncConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isAuthenticated: boolean | null;
  isEnabled: boolean;
  portalId: string | null;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface HubspotService  {
  __typename?: 'HubspotService';
  contactTimeline: HubspotContactTimeline | null;
}

export interface HubspotContactTimeline  {
  __typename?: 'HubspotContactTimeline';
  url: string;
}

export interface HubItemValueMapping  {
  __typename?: 'HubItemValueMapping';
  direction: SyncDirectionEnum;
  externalValue: string | null;
  localValue: string | null;
}

export interface HubItemRuleSettings extends HubItemRuleSettingsInterface {
  __typename?: 'HubItemRuleSettings';
  autoSync: boolean;
  deduplication: HubItemDeduplicationSetting | null;
  externalRuleSetting: HubItemExternalRuleSetting;
  fieldMappings: HubItemFieldMapping[];
  filterMapping: HubItemFilterMapping | null;
  id: UUID;
  localRuleSetting: HubItemLocalRuleSetting;
  name: string;
  ownerMapping: HubItemFieldMapping | null;
  ownerMappingExtended: HubItemFieldMapping | null;
  pipelines: HubItemFieldMapping[] | null;
  relationSettings: HubItemRelationRuleSettings[];
  salesUnitMapping: HubItemFieldMapping | null;
  syncDirection: SyncDirectionEnum;
  syncFiles: boolean | null;
  syncNotes: boolean | null;
}

export interface HubItemRelationRuleSettings extends HubItemRuleSettingsInterface {
  __typename?: 'HubItemRelationRuleSettings';
  deduplication: HubItemDeduplicationSetting | null;
  externalRuleSetting: HubItemExternalRuleSetting;
  fieldMappings: HubItemFieldMapping[];
  filterMapping: HubItemFilterMapping | null;
  id: UUID;
  localRuleSetting: HubItemLocalRuleSetting;
  lookupFieldMappings: HubItemFieldMapping | null;
  name: string;
  ownerMapping: HubItemFieldMapping | null;
  ownerMappingExtended: HubItemFieldMapping | null;
  pipelines: HubItemFieldMapping[] | null;
  relationFieldMappings: HubItemFieldMapping[];
  salesUnitMapping: HubItemFieldMapping | null;
  syncDirection: SyncDirectionEnum;
  syncFiles: boolean | null;
  syncNotes: boolean | null;
}

export interface HubItemLocalRuleSetting  {
  __typename?: 'HubItemLocalRuleSetting';
  entity: EntityNameEnum;
  entityApiName: string | null;
  entityTypeId: UUID | null;
  events: HubItemEventSetting;
}

export interface HubItemIntegrationSyncConfig  {
  __typename?: 'HubItemIntegrationSyncConfig';
  rules: HubItemRuleSettings[];
}

export interface HubItemIntegrationFilterTab  {
  __typename?: 'HubItemIntegrationFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface HubItemFilterMapping  {
  __typename?: 'HubItemFilterMapping';
  externalFilter: HubItemIntegrationFilterTab | null;
  localFilter: HubItemIntegrationFilterTab | null;
}

export interface HubItemFieldMappingSetting  {
  __typename?: 'HubItemFieldMappingSetting';
  externalFallbackValue: JSONString | null;
  localFallbackValue: JSONString | null;
  valuesMapping: HubItemValueMapping[] | null;
}

export interface HubItemFieldMapping  {
  __typename?: 'HubItemFieldMapping';
  externalFieldId: ID | null;
  localFieldId: UUID | null;
  setting: HubItemFieldMappingSetting | null;
  syncDirection: SyncDirectionEnum;
}

export interface HubItemExternalRuleSetting  {
  __typename?: 'HubItemExternalRuleSetting';
  entity: string;
  entityTypeId: string | null;
  events: HubItemEventSetting;
}

export interface HubItemEventSetting  {
  __typename?: 'HubItemEventSetting';
  create: boolean;
  delete: boolean;
  update: boolean;
}

export interface HubItemDeduplicationSetting  {
  __typename?: 'HubItemDeduplicationSetting';
  fields: HubItemDeduplicationFieldMapping[];
}

export interface HubItemDeduplicationFieldMapping  {
  __typename?: 'HubItemDeduplicationFieldMapping';
  externalFieldId: ID | null;
  localFieldId: UUID | null;
  operator: MatchingOperatorEnum;
}

export interface HowToRepository  {
  __typename?: 'HowToRepository';
  getAll: HowToEntity[];
  getByCriteria: HowToEntityConnection | null;
  getById: HowToEntity | null;
  getByIds: HowToEntity[];
}

export interface HowToEntityEdge  {
  __typename?: 'HowToEntityEdge';
  cursor: string;
  node: HowToEntity | null;
}

export interface HowToEntityConnection  {
  __typename?: 'HowToEntityConnection';
  edges: HowToEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface HowToEntity  {
  __typename?: 'HowToEntity';
  actionText: string | null;
  actionUrl: string | null;
  category: HowToCategory | null;
  description: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: HowToPermsEnum[];
  minApiVersion: number | null;
  resourceUrl: string | null;
  sortOrder: number | null;
  title: string | null;
  type: HowToType | null;
  uniqueViewCount: number | null;
  viewCount: number | null;
}

export interface HistoricalPerformanceData  {
  __typename?: 'HistoricalPerformanceData';
  id: ID;
  values: OpportunityForecastQuotaItemValue[] | null;
}

export interface HealthCategory  {
  __typename?: 'HealthCategory';
  color: number;
  id: UUID;
  label: string;
  useLang: boolean;
  value: number;
}

export interface HasEntityDraft  {
  __typename?: 'HasEntityDraft';
  entity: EntityNameEnum;
  entityApiName: string | null;
  hasDrafts: boolean;
  hasEntitySettingsDrafts: boolean;
  hasEntityTypeDrafts: boolean;
  hasFieldDrafts: boolean;
  hasInterfacePreviewDrafts: boolean;
  hasWebresourceDrafts: boolean;
}

export interface HardcodedRelation  {
  __typename?: 'HardcodedRelation';
  aggregationType: HardcodedAggregationType | null;
  onlyRowsWithRelatedRecords: boolean | null;
  relationType: SiblingRelationType;
}

export interface HardCodedRelation  {
  __typename?: 'HardCodedRelation';
  kind: SiblingRelationType;
}

export interface HardCodedContainer extends FormItemInterface {
  __typename?: 'HardCodedContainer';
  id: UUID;
  inAddin: boolean | null;
  kind: FormItemKindEnum;
  onMobile: boolean | null;
  type: HardcodedContainerTypeEnum;
}

export interface GroupTargetDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'GroupTargetDataGridViewItems';
  groups: GroupInfo[];
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface GroupInterval  {
  __typename?: 'GroupInterval';
  end: number | null;
  start: number | null;
}

export interface GroupInfo  {
  __typename?: 'GroupInfo';
  count: number;
  id: UUID;
  name: string | null;
  offset: number;
}

export interface GroupField extends ReportField {
  __typename?: 'GroupField';
  boxId: ID;
  fieldId: ID;
  groupIntervals: GroupInterval[] | null;
  groupOption: GroupOption | null;
}

export interface GridHighlightChanges  {
  __typename?: 'GridHighlightChanges';
  columns: UUID[] | null;
  customPeriodValue: number | null;
  isEnabled: boolean | null;
  period: HighlightPeriodEnum;
  showOnlyRecordsWithChanges: boolean;
}

export interface GridColumnsOutput  {
  __typename?: 'GridColumnsOutput';
  fieldId: string;
  frozen: boolean;
  pixels: boolean;
  width: number;
}

export interface GoogleServiceSettingsOutput  {
  __typename?: 'GoogleServiceSettingsOutput';
  deleteProtection: ContactDeletionProtectionEnum | null;
  email: string | null;
  enabled: ServiceStatus;
  errorCode: number;
  features: EmailAccountFeatureEnum[] | null;
  imageUrl: string | null;
  name: string | null;
  recordOwnership: RecordOwnershipEnum | null;
  syncArchived: boolean | null;
  syncMethod: ContactSyncMethodEnum | null;
  syncPrivate: boolean | null;
}

export interface GoogleDriveSettingsOutput  {
  __typename?: 'GoogleDriveSettingsOutput';
  googleDriveAccessToken: string | null;
  googleDriveRefreshToken: string | null;
}

export interface GoogleDrive  {
  __typename?: 'GoogleDrive';
  getAuthUrl: AuthUrlResult | null;
  getFileUrl: FileUrlResult | null;
  getIsTeamUser: boolean | null;
  getLogoutUrl: AuthUrlResult | null;
  getToken: TokenResult | null;
  listFolder: RemoteStorageFileListResultConnection | null;
  refreshToken: TokenResult | null;
}

export interface GoogleDeactivateTeamSpaceClientSettingPayload  {
  __typename?: 'GoogleDeactivateTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface GmailSettingsOutput  {
  __typename?: 'GmailSettingsOutput';
  email: string | null;
  emailAliases: string | null;
  emailFetchSettings: number;
  emailImapFolder1: string;
  emailImapFolder2: string | null;
}

export interface GlobalSearchSearchType  {
  __typename?: 'GlobalSearchSearchType';
  entityApiName: string | null;
  type: GlobalSearchType;
}

export interface GlobalSearchFilter  {
  __typename?: 'GlobalSearchFilter';
  created: PeriodOption | null;
  includeArchived: boolean | null;
  includeDeleted: boolean | null;
  includeDeletedAndArchivedRecords: boolean | null;
  modified: PeriodOption | null;
  ownerIds: string[];
  salesUnitIds: string[];
}

export interface GlobalSearch  {
  __typename?: 'GlobalSearch';
  items: SearchConnection | null;
}

export interface GhostLeadOpptyContactSalesRoleRelationRepository  {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationRepository';
  getAll: GhostLeadOpptyContactSalesRoleRelationEntity[];
  getByCriteria: GhostLeadOpptyContactSalesRoleRelationEntityConnection | null;
  getById: GhostLeadOpptyContactSalesRoleRelationEntity | null;
  getByIds: GhostLeadOpptyContactSalesRoleRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface GhostLeadOpptyContactSalesRoleRelationEntityEdge  {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationEntityEdge';
  cursor: string;
  node: GhostLeadOpptyContactSalesRoleRelationEntity | null;
}

export interface GhostLeadOpptyContactSalesRoleRelationEntityConnection  {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationEntityConnection';
  edges: GhostLeadOpptyContactSalesRoleRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface GhostLeadOpptyContactSalesRoleRelationEntity  {
  __typename?: 'GhostLeadOpptyContactSalesRoleRelationEntity';
  created: DateTime | null;
  ghostLeadOpptyContactRelation: GhostLeadOpptyContactRelationEntity | null;
  ghostLeadOpptyContactRelationId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  salesRole: SalesRoleEntity | null;
  salesRoleId: ID;
}

export interface GhostLeadOpptyContactRelationRepository  {
  __typename?: 'GhostLeadOpptyContactRelationRepository';
  getAll: GhostLeadOpptyContactRelationEntity[];
  getByCriteria: GhostLeadOpptyContactRelationEntityConnection | null;
  getById: GhostLeadOpptyContactRelationEntity | null;
  getByIds: GhostLeadOpptyContactRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface GhostLeadOpptyContactRelationEntityEdge  {
  __typename?: 'GhostLeadOpptyContactRelationEntityEdge';
  cursor: string;
  node: GhostLeadOpptyContactRelationEntity | null;
}

export interface GhostLeadOpptyContactRelationEntityConnection  {
  __typename?: 'GhostLeadOpptyContactRelationEntityConnection';
  edges: GhostLeadOpptyContactRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface GhostLeadOpptyContactRelationEntity  {
  __typename?: 'GhostLeadOpptyContactRelationEntity';
  comment: string | null;
  created: DateTime | null;
  ghostContact: GhostContactEntity | null;
  ghostContactId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationEntity | null;
  leadOpptyContactGroupRelationId: ID | null;
  leadOpptyId: ID;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  positionInGroup: JSONString | null;
  revision: number | null;
  salesRoles: GhostLeadOpptyContactSalesRoleRelationEntityConnection | null;
}

export interface GhostContactRepository  {
  __typename?: 'GhostContactRepository';
  getAll: GhostContactEntity[];
  getByCriteria: GhostContactEntityConnection | null;
  getById: GhostContactEntity | null;
  getByIds: GhostContactEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface GhostContactEntityEdge  {
  __typename?: 'GhostContactEntityEdge';
  cursor: string;
  node: GhostContactEntity | null;
}

export interface GhostContactEntityConnection  {
  __typename?: 'GhostContactEntityConnection';
  edges: GhostContactEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface GhostContactEntity  {
  __typename?: 'GhostContactEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  position: string | null;
  revision: number | null;
}

export interface GhostContactAccountRelationRepository  {
  __typename?: 'GhostContactAccountRelationRepository';
  getAll: GhostContactAccountRelationEntity[];
  getByCriteria: GhostContactAccountRelationEntityConnection | null;
  getById: GhostContactAccountRelationEntity | null;
  getByIds: GhostContactAccountRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface GhostContactAccountRelationEntityEdge  {
  __typename?: 'GhostContactAccountRelationEntityEdge';
  cursor: string;
  node: GhostContactAccountRelationEntity | null;
}

export interface GhostContactAccountRelationEntityConnection  {
  __typename?: 'GhostContactAccountRelationEntityConnection';
  edges: GhostContactAccountRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface GhostContactAccountRelationEntity  {
  __typename?: 'GhostContactAccountRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  accountRoles: GhostContactAccountAccountRoleRelationEntityConnection | null;
  comment: string | null;
  created: DateTime | null;
  ghostContact: GhostContactEntity | null;
  ghostContactId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isAssistant: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isSibling: boolean | null;
  modified: DateTime | null;
  position: string | null;
  revision: number | null;
}

export interface GhostContactAccountAccountRoleRelationRepository  {
  __typename?: 'GhostContactAccountAccountRoleRelationRepository';
  getAll: GhostContactAccountAccountRoleRelationEntity[];
  getByCriteria: GhostContactAccountAccountRoleRelationEntityConnection | null;
  getById: GhostContactAccountAccountRoleRelationEntity | null;
  getByIds: GhostContactAccountAccountRoleRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface GhostContactAccountAccountRoleRelationEntityEdge  {
  __typename?: 'GhostContactAccountAccountRoleRelationEntityEdge';
  cursor: string;
  node: GhostContactAccountAccountRoleRelationEntity | null;
}

export interface GhostContactAccountAccountRoleRelationEntityConnection  {
  __typename?: 'GhostContactAccountAccountRoleRelationEntityConnection';
  edges: GhostContactAccountAccountRoleRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface GhostContactAccountAccountRoleRelationEntity  {
  __typename?: 'GhostContactAccountAccountRoleRelationEntity';
  accountRole: AccountRoleEntity | null;
  accountRoleId: ID;
  created: DateTime | null;
  ghostContactAccountRelation: GhostContactAccountRelationEntity | null;
  ghostContactAccountRelationId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface GetReportResult  {
  __typename?: 'GetReportResult';
  items: DataGridViewItem[];
  sessionId: UUID;
  total: number;
}

export interface GetPrintReportUrlPayload  {
  __typename?: 'GetPrintReportUrlPayload';
  clientMutationId: string | null;
  result: UUID | null;
}

export interface GetPrintReportStatusPayload  {
  __typename?: 'GetPrintReportStatusPayload';
  clientMutationId: string | null;
  result: PrintReportStatus;
}

export interface GetBulkDownloadUrlPayload  {
  __typename?: 'GetBulkDownloadUrlPayload';
  clientMutationId: string | null;
  result: string | null;
}

export interface GetBulkDownloadStatusPayload  {
  __typename?: 'GetBulkDownloadStatusPayload';
  clientMutationId: string | null;
  result: BulkDownloadStatus;
}

export interface GeoLocationEntity  {
  __typename?: 'GeoLocationEntity';
  address: string | null;
  city: string | null;
  country: string | null;
  lat: number;
  lng: number;
  placeId: string;
  searchKey: string;
  state: string | null;
  zipCode: string | null;
}

export interface GenericSessionMetadata  {
  __typename?: 'GenericSessionMetadata';
  extraArgs: JSONString | null;
  groupFieldId: ID | null;
  groupOption: GroupOption | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface GenericDrilldownDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'GenericDrilldownDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface GenerateSessionIdFromGroupCursorResult  {
  __typename?: 'GenerateSessionIdFromGroupCursorResult';
  sessionId: string;
}

export interface GenerateOnlineFormResponsePdf  {
  __typename?: 'GenerateOnlineFormResponsePdf';
  cloudObjectId: ID;
  cloudObjectMimeType: string;
  cloudObjectName: string;
  cloudObjectUrl: string;
}

export interface GenerateNewApiAccessPayload  {
  __typename?: 'GenerateNewApiAccessPayload';
  clientMutationId: string | null;
  result: ApiAccessEntity | null;
}

export interface GenerateClientDefaultDataPayload  {
  __typename?: 'GenerateClientDefaultDataPayload';
  clientMutationId: string | null;
}

export interface GenderProperty  {
  __typename?: 'GenderProperty';
  showNonBinaryOption: boolean;
  showOnForms: boolean;
}

export interface GenderInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'GenderInterfaceFieldData';
  fieldId: UUID;
  gender: GenderEnum;
}

export interface FulltextSearchResultItem  {
  __typename?: 'FulltextSearchResultItem';
  id: ID;
  name: string;
  queryString: string;
}

export interface FulltextSearchEdge  {
  __typename?: 'FulltextSearchEdge';
  cursor: string;
  node: FulltextSearchResultItem | null;
}

export interface FulltextSearchConnection  {
  __typename?: 'FulltextSearchConnection';
  edges: FulltextSearchEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface FulltextSearch  {
  __typename?: 'FulltextSearch';
  items: FulltextSearchConnection | null;
}

export interface FormulaValidator  {
  __typename?: 'FormulaValidator';
  expression: string;
  message: string;
}

export interface FormViewSharingSalesUnitRelationRepository  {
  __typename?: 'FormViewSharingSalesUnitRelationRepository';
  getAll: FormViewSharingSalesUnitRelationEntity[];
  getByCriteria: FormViewSharingSalesUnitRelationEntityConnection | null;
  getById: FormViewSharingSalesUnitRelationEntity | null;
  getByIds: FormViewSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface FormViewSharingSalesUnitRelationEntityEdge  {
  __typename?: 'FormViewSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: FormViewSharingSalesUnitRelationEntity | null;
}

export interface FormViewSharingSalesUnitRelationEntityConnection  {
  __typename?: 'FormViewSharingSalesUnitRelationEntityConnection';
  edges: FormViewSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FormViewSharingSalesUnitRelationEntity  {
  __typename?: 'FormViewSharingSalesUnitRelationEntity';
  created: DateTime | null;
  formView: FormViewEntity | null;
  formViewId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface FormViewSharingClientRelationRepository  {
  __typename?: 'FormViewSharingClientRelationRepository';
  getAll: FormViewSharingClientRelationEntity[];
  getByCriteria: FormViewSharingClientRelationEntityConnection | null;
  getById: FormViewSharingClientRelationEntity | null;
  getByIds: FormViewSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface FormViewSharingClientRelationEntityEdge  {
  __typename?: 'FormViewSharingClientRelationEntityEdge';
  cursor: string;
  node: FormViewSharingClientRelationEntity | null;
}

export interface FormViewSharingClientRelationEntityConnection  {
  __typename?: 'FormViewSharingClientRelationEntityConnection';
  edges: FormViewSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FormViewSharingClientRelationEntity  {
  __typename?: 'FormViewSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  formView: FormViewEntity | null;
  formViewId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface FormViewRepository  {
  __typename?: 'FormViewRepository';
  getAll: FormViewEntity[];
  getByCriteria: FormViewEntityConnection | null;
  getById: FormViewEntity | null;
  getByIds: FormViewEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface FormViewOptions  {
  __typename?: 'FormViewOptions';
  createViewId: UUID | null;
  editViewId: UUID | null;
  entityTypeId: UUID;
}

export interface FormViewItemColor  {
  __typename?: 'FormViewItemColor';
  color: number;
  id: ID;
}

export interface FormViewEntityEdge  {
  __typename?: 'FormViewEntityEdge';
  cursor: string;
  node: FormViewEntity | null;
}

export interface FormViewEntityConnection  {
  __typename?: 'FormViewEntityConnection';
  edges: FormViewEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FormViewEntity  {
  __typename?: 'FormViewEntity';
  accountType: AccountTypeEntity | null;
  accountTypeId: ID | null;
  contactType: ContactTypeEntity | null;
  contactTypeId: ID | null;
  created: DateTime | null;
  entityTypeId: UUID;
  hiddenItemIds: UUID[];
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  itemColors: FormViewItemColor[];
  leadType: LeadTypeEntity | null;
  leadTypeId: ID | null;
  modified: DateTime | null;
  name: string;
  opptyType: OpportunityTypeEntity | null;
  opptyTypeId: ID | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: FormViewSharingClientRelationEntityConnection | null;
  sharingUnits: FormViewSharingSalesUnitRelationEntityConnection | null;
  useLang: boolean | null;
}

export interface FormSubsection extends FormItemInterface {
  __typename?: 'FormSubsection';
  description: string | null;
  id: UUID;
  kind: FormItemKindEnum;
  label: string;
  onMobile: boolean | null;
  useLang: boolean | null;
}

export interface FormSeparator extends FormItemInterface {
  __typename?: 'FormSeparator';
  description: string | null;
  id: UUID;
  kind: FormItemKindEnum;
  label: string;
  onMobile: boolean | null;
  useLang: boolean | null;
}

export interface FormField extends FormContainerItemInterface {
  __typename?: 'FormField';
  allowedEntities: string[] | null;
  description: string | null;
  descriptionTranslated: string | null;
  descriptionTranslations: JSONString | null;
  dropdownAutoselect: DropDownAutoselectEnum | null;
  id: string;
  inAddin: boolean | null;
  kind: FormContainerItemKind;
  label: string;
  labelTranslated: string | null;
  labelTranslations: JSONString | null;
  lookupVisualization: LookupVisualizationType | null;
  onMobile: boolean | null;
  opptyValueAutoCalculateDefault: boolean | null;
  productSections: ProductSection[] | null;
  readonly: boolean | null;
  readonlyRules: FieldFilter | null;
  requiredRules: FieldFilter | null;
  showFixedValue: boolean | null;
  subLabel: string | null;
  subLabelUseLang: boolean | null;
  useLang: boolean | null;
  validators: FieldValidator | null;
  visibilityRules: FieldFilter | null;
}

export interface FormContainer extends FormItemInterface {
  __typename?: 'FormContainer';
  columns: FormColumn[] | null;
  id: UUID;
  kind: FormItemKindEnum;
  onMobile: boolean | null;
}

export interface FormColumn  {
  __typename?: 'FormColumn';
  id: UUID;
  items: FormContainerItemInterfaceImplementors[] | null;
  size: number;
}

export interface Form  {
  __typename?: 'Form';
  items: FormItemInterfaceImplementors[] | null;
  label: string;
  useLang: boolean | null;
}

export interface ForecastViews  {
  __typename?: 'ForecastViews';
  data: ForecastProfileData;
  drilldown: DrilldownModel;
  getAll: ForecastView | null;
  getByIds: ForecastViewIds | null;
  historicalPerformance: HistoricalPerformanceData[];
  report: ForecastReport;
}

export interface ForecastViewIds  {
  __typename?: 'ForecastViewIds';
  chart: ForecastChartData[];
  data: ForecastDataItemInterfaceImplementors[];
}

export interface ForecastView  {
  __typename?: 'ForecastView';
  chart: ForecastChartData[];
  data: ForecastDataItemInterfaceImplementors[];
}

export interface ForecastTrendViewOptions  {
  __typename?: 'ForecastTrendViewOptions';
  runningTotal: boolean;
}

export interface ForecastTrendViewItem  {
  __typename?: 'ForecastTrendViewItem';
  comparisonValue: number | null;
  id: ID;
  label: string | null;
  value: number;
}

export interface ForecastSumItem extends ForecastDataItemInterface {
  __typename?: 'ForecastSumItem';
  column: ForecastColumnItem[];
  forecastPerformance: number;
  quota: number | null;
}

export interface ForecastSchema  {
  __typename?: 'ForecastSchema';
  structure: ForecastTabItemImplementors[];
}

export interface ForecastRepository  {
  __typename?: 'ForecastRepository';
  getAll: ForecastEntity[];
  getByCriteria: ForecastEntityConnection | null;
  getById: ForecastEntity | null;
  getByIds: ForecastEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ForecastReportItemChange  {
  __typename?: 'ForecastReportItemChange';
  actorId: UUID | null;
  applicationId: UUID | null;
  date: DateTime;
  newValue: number | null;
  oldValue: number | null;
  period: GqlDate;
}

export interface ForecastReportItem  {
  __typename?: 'ForecastReportItem';
  allowedEditValue: boolean | null;
  changesCount: number;
  columns: ForecastReportColumn[] | null;
  entityId: UUID | null;
  entityName: string | null;
  entityPicture: string | null;
  entityType: EntityNameEnum | null;
  id: ID;
  oldValue: number | null;
  parentId: ID | null;
  quota: number | null;
  value: number | null;
}

export interface ForecastReportData  {
  __typename?: 'ForecastReportData';
  listViewItem: DataGridViewItem | null;
  listViewItems: OpportunityDataGridViewItems;
  pipelineViewItem: ForecastPipelineViewItem | null;
  pipelineViewItems: ForecastPipelineViewItems;
  trendViewDrilldown: DrilldownModel;
  trendViewItems: ForecastTrendViewItem[];
}

export interface ForecastReportColumnGroup  {
  __typename?: 'ForecastReportColumnGroup';
  comparisonValue: number | null;
  id: string | null;
  label: string | null;
  value: number;
}

export interface ForecastReportColumn  {
  __typename?: 'ForecastReportColumn';
  comparisonValue: number | null;
  groups: ForecastReportColumnGroup[];
  id: ID;
  value: number;
}

export interface ForecastReport  {
  __typename?: 'ForecastReport';
  changes: ForecastReportItemChange[];
  data: ForecastReportData | null;
  items: ForecastReportItem[];
}

export interface ForecastProfileData  {
  __typename?: 'ForecastProfileData';
  listViewItems: ForecastDataGridViewItems;
}

export interface ForecastPipelineViewOptions  {
  __typename?: 'ForecastPipelineViewOptions';
  groupBy: OpportunityGroupBy;
  showCardFitness: boolean;
  showCardLabels: boolean;
  showCardRanking: boolean;
  showCardValue: boolean;
  showCardVelocity: boolean;
  showExtraFieldIds: UUID[] | null;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ForecastPeriodOption  {
  __typename?: 'ForecastPeriodOption';
  financialYear: boolean | null;
  period: ForecastPeriodKind;
  periodFrom: GqlDate;
  periodTo: GqlDate;
}

export interface ForecastPerformanceItem  {
  __typename?: 'ForecastPerformanceItem';
  dateTime: DateTime;
  period: GqlDate;
  value: number;
}

export interface ForecastOwner  {
  __typename?: 'ForecastOwner';
  forecastPerformance: ForecastPerformanceItem[];
  id: ID;
  isActive: boolean;
}

export interface ForecastListingOptions  {
  __typename?: 'ForecastListingOptions';
  filterByOwnerId: UUID[] | null;
  filterByPeriod: PeriodOption;
}

export interface ForecastListViewOptions  {
  __typename?: 'ForecastListViewOptions';
  columns: GridColumnsOutput[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ForecastItemValue  {
  __typename?: 'ForecastItemValue';
  date: GqlDate;
  quota: number | null;
  value: number | null;
}

export interface ForecastItem  {
  __typename?: 'ForecastItem';
  entityId: UUID;
  entityType: EntityNameEnum;
  id: ID;
  isActive: boolean;
  parentId: ID | null;
  quotaSplitType: OpportunityForecastQuotaSplitType;
  values: ForecastItemValue[];
}

export interface ForecastGroupItem extends ForecastDataItemInterface {
  __typename?: 'ForecastGroupItem';
  column: ForecastColumnItem[];
  countOfOwners: number;
  forecastPerformance: number;
  period: GqlDate;
  quota: number | null;
}

export interface ForecastEntityEdge  {
  __typename?: 'ForecastEntityEdge';
  cursor: string;
  node: ForecastEntity | null;
}

export interface ForecastEntityConnection  {
  __typename?: 'ForecastEntityConnection';
  edges: ForecastEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ForecastEntity  {
  __typename?: 'ForecastEntity';
  created: DateTime | null;
  description: string | null;
  endDate: GqlDate;
  field: FieldEntity | null;
  fieldId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lastType: ForecastType;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  pipeline: PipelineEntity | null;
  pipelineId: ID;
  revision: number | null;
  settings: BetterForecastSchema;
  shareMode: ShareModeEnum | null;
  shareModeParams: number | null;
  sharedClients: ClientEntity[];
  sharedUnits: SalesUnitEntity[];
  startDate: GqlDate;
  targetGoal: number;
  type: JSONString;
}

export interface ForecastDataItem extends ForecastDataItemInterface {
  __typename?: 'ForecastDataItem';
  column: ForecastColumnItem[];
  owner: ForecastOwner;
  period: GqlDate;
  quota: number | null;
}

export interface ForecastDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ForecastDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ForecastColumnItem  {
  __typename?: 'ForecastColumnItem';
  group: string | null;
  label: string;
  type: ForecastColumnsType;
  value: number;
}

export interface ForecastColumn  {
  __typename?: 'ForecastColumn';
  baseValue: ForecastBaseValueEnum;
  id: ID;
  openValueType: ForecastOpenValueTypeEnum | null;
  valueComparison: ForecastValueComparisonEnum | null;
}

export interface ForecastChartData  {
  __typename?: 'ForecastChartData';
  label: string;
  value: number | null;
}

export interface FloatProperty  {
  __typename?: 'FloatProperty';
  decimalPlaces: number;
  unit: string | null;
  useThousandSeparator: boolean;
}

export interface FitnessSystemRule  {
  __typename?: 'FitnessSystemRule';
  days: number | null;
  entityTypes: ID[] | null;
  isEnabled: boolean;
  period: FitnessPeriodEnum | null;
  state: WarningLevelEnum;
  value: number | null;
}

export interface FitnessInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'FitnessInterfaceFieldData';
  fieldId: UUID;
  fitness: WarningLevelEnum;
}

export interface FitnessIndicatorsInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'FitnessIndicatorsInterfaceFieldData';
  fieldId: UUID;
  fitnessIndicators: string | null;
}

export interface FitnessIndicatorSettings  {
  __typename?: 'FitnessIndicatorSettings';
  customRules: FitnessCustomRule[] | null;
  stepIds: ID[] | null;
  systemRules: FitnessSystemRule[] | null;
}

export interface FitnessDescriptionIndicator  {
  __typename?: 'FitnessDescriptionIndicator';
  fitness: WarningLevelEnum;
  indicator: EntityFitnessIndicatorEntity;
}

export interface FitnessDescriptionChangeLog  {
  __typename?: 'FitnessDescriptionChangeLog';
  amount: number | null;
  changes: FitnessDescriptionChange[] | null;
  days: number | null;
  indicator: EntityFitnessIndicatorEntity;
  period: FitnessPeriodEnum | null;
  value: number | null;
}

export interface FitnessDescriptionChange  {
  __typename?: 'FitnessDescriptionChange';
  date: GqlDate | null;
  isTitleAvailable: boolean;
  modified: DateTime;
  step: StepEntity | null;
  title: string | null;
  value: number | null;
}

export interface FitnessDescription  {
  __typename?: 'FitnessDescription';
  fitness: WarningLevelEnum;
  indicators: FitnessDescriptionIndicator[];
  isArchived: boolean;
  isWon: boolean;
}

export interface FitnessCustomRule  {
  __typename?: 'FitnessCustomRule';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isEnabled: boolean;
  operator: FilterGroupOperator;
  state: WarningLevelEnum;
}

export interface FinishTargetPayload  {
  __typename?: 'FinishTargetPayload';
  clientMutationId: string | null;
  target: TargetEntity | null;
}

export interface FinancialDateStart  {
  __typename?: 'FinancialDateStart';
  day: number;
  month: number;
}

export interface FinalizeConfigurationAutomationHubItemPayload  {
  __typename?: 'FinalizeConfigurationAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface FilterSiblingBox extends ReportBoxInterface, SiblingBoxInterface {
  __typename?: 'FilterSiblingBox';
  calculationFieldId: ID | null;
  entityApiName: string | null;
  entitySubtypes: EntitySubtypeItem[] | null;
  entityType: EntityNameEnum;
  id: ID;
  lookupFieldId: UUID | null;
  relation: SiblingBoxRelationType | null;
}

export interface FilterResult  {
  __typename?: 'FilterResult';
  count: number;
  sessionId: string | null;
}

export interface FilterFieldRelationFieldsResult  {
  __typename?: 'FilterFieldRelationFieldsResult';
  allEntityFields: boolean;
  excludeIds: UUID[];
  includeIds: UUID[];
}

export interface FilterFieldRelation  {
  __typename?: 'FilterFieldRelation';
  entity: EntityNameEnum;
  entityApiName: string | null;
  fields: FilterFieldRelationFieldsResult;
  relationField: FieldDescriptor | null;
  relationFieldId: UUID | null;
  relationType: FieldRelationTypeEnum;
}

export interface FilterBox extends FilterBoxInterface {
  __typename?: 'FilterBox';
  entity: string;
  filterFields: FieldFilterRule[];
  id: string;
  lookupFieldId: UUID | null;
  relation: HardCodedRelation | null;
}

export interface FileUrlResult  {
  __typename?: 'FileUrlResult';
  urls: LinkUrl[] | null;
}

export interface FileUploadProperty  {
  __typename?: 'FileUploadProperty';
  customFileExtensions: string[];
  fileTypes: FileTypeEnum[];
  fileTypesEnabled: boolean;
  maxFileSize: number;
  maxFiles: number;
}

export interface FileTypeExtension  {
  __typename?: 'FileTypeExtension';
  extensions: string[];
  type: FileTypeEnum;
}

export interface FieldValueOption  {
  __typename?: 'FieldValueOption';
  color: number | null;
  isArchived: boolean;
  isDeleted: boolean;
  label: string;
  labelTranslated: string;
  useLang: boolean;
  value: string | null;
}

export interface FieldValidator  {
  __typename?: 'FieldValidator';
  flagEnum: IntEnumItem[] | null;
  formula: FormulaValidator | null;
  intEnum: IntEnumItem[] | null;
  isDaterange: boolean | null;
  isEmail: boolean | null;
  isParentAccountRelationType: boolean | null;
  isUrl: boolean | null;
  maxValue: string | null;
  minValue: string | null;
  nullable: boolean | null;
  required: boolean | null;
  requiredCombined: string | null;
  requiredExactlyOne: boolean | null;
  requiredMinItems: number | null;
  requiredOnlyOnCurrentStep: boolean | null;
}

export interface FieldUseOptions  {
  __typename?: 'FieldUseOptions';
  isAvailableForAdvancedCalcFormula: boolean;
  isAvailableForAdvancedFormula: boolean;
  isAvailableForAggregation: boolean;
  isAvailableForCalculationFormula: boolean;
  isAvailableForChangeLog: boolean;
  isAvailableForHistoryReport: boolean;
  isAvailableForMerge: boolean;
  isAvailableForPivotDataField: boolean;
  isAvailableForTargetCalculation: boolean;
  isAvailableForWebresource: boolean;
  isAvailableForWhiteSpaceComparison: boolean;
  isDisplayable: boolean;
  isDisplayableOnPivot: boolean;
  isFilterable: boolean;
  isGroupable: boolean;
  isReadonlyOnRecurrentAppointment: boolean;
  isSortable: boolean;
}

export interface FieldSequenceRepository  {
  __typename?: 'FieldSequenceRepository';
  getAll: FieldSequenceEntity[];
  getByCriteria: FieldSequenceEntityConnection | null;
  getById: FieldSequenceEntity | null;
  getByIds: FieldSequenceEntity[];
  getDraftById: FieldSequenceEntity;
  getDrafts: FieldSequenceEntity[];
  getPublished: FieldSequenceEntity[];
}

export interface FieldSequenceEntityEdge  {
  __typename?: 'FieldSequenceEntityEdge';
  cursor: string;
  node: FieldSequenceEntity | null;
}

export interface FieldSequenceEntityConnection  {
  __typename?: 'FieldSequenceEntityConnection';
  edges: FieldSequenceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FieldSequenceEntity  {
  __typename?: 'FieldSequenceEntity';
  created: DateTime | null;
  filter: JSONString | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  modified: DateTime | null;
  pattern: string;
  sequenceSetId: ID;
  sortOrder: number | null;
}

export interface FieldRepository  {
  __typename?: 'FieldRepository';
  getAll: FieldEntity[];
  getByCriteria: FieldEntityConnection | null;
  getById: FieldEntity | null;
  getByIds: FieldEntity[];
  getDraftById: FieldEntity;
  getDrafts: FieldEntity[];
  getPublished: FieldEntity[];
}

export interface FieldPermissionRepository  {
  __typename?: 'FieldPermissionRepository';
  getAll: FieldPermissionEntity[];
  getByCriteria: FieldPermissionEntityConnection | null;
  getById: FieldPermissionEntity | null;
  getByIds: FieldPermissionEntity[];
  getDraftById: FieldPermissionEntity;
  getDrafts: FieldPermissionEntity[];
  getPublished: FieldPermissionEntity[];
}

export interface FieldPermissionEntityEdge  {
  __typename?: 'FieldPermissionEntityEdge';
  cursor: string;
  node: FieldPermissionEntity | null;
}

export interface FieldPermissionEntityConnection  {
  __typename?: 'FieldPermissionEntityConnection';
  edges: FieldPermissionEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FieldPermissionEntity  {
  __typename?: 'FieldPermissionEntity';
  created: DateTime | null;
  field: FieldEntity | null;
  fieldId: ID;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  permissionLevel: AccessLevelFieldEnum | null;
  revision: number | null;
}

export interface FieldMappingTemplate  {
  __typename?: 'FieldMappingTemplate';
  input: JSONString;
  operations: FieldMappingOperation[];
}

export interface FieldMappingRepository  {
  __typename?: 'FieldMappingRepository';
  getAll: FieldMappingEntity[];
  getByCriteria: FieldMappingEntityConnection | null;
  getById: FieldMappingEntity | null;
  getByIds: FieldMappingEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getForEntity: FieldMappingEntity[];
}

export interface FieldMappingOperation  {
  __typename?: 'FieldMappingOperation';
  fieldId: ID;
  mapping: EntityOperationMapping | null;
  operation: FieldMappingOperationEnum | null;
  triggeredRecordFieldId: UUID | null;
}

export interface FieldMappingEntityEdge  {
  __typename?: 'FieldMappingEntityEdge';
  cursor: string;
  node: FieldMappingEntity | null;
}

export interface FieldMappingEntityConnection  {
  __typename?: 'FieldMappingEntityConnection';
  edges: FieldMappingEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FieldMappingEntity  {
  __typename?: 'FieldMappingEntity';
  created: DateTime | null;
  documents: CloudObjectRelationEntity[] | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isSystem: boolean;
  mapping: FieldMappingTemplate | null;
  modified: DateTime | null;
  operation: FieldMappingOperationTypeEnum | null;
  revision: number | null;
  sourceEntityApiName: string | null;
  sourceEntityName: EntityNameEnum;
  targetEntityApiName: string | null;
  targetEntityName: EntityNameEnum;
  typeMappings: EntityTypeFieldMapping[] | null;
}

export interface FieldLevelPermissionEnum  {
  __typename?: 'FieldLevelPermissionEnum';
  fullAccess: string[];
  readOnly: string[];
}

export interface FieldFilterRule extends FilterFieldRuleInterface {
  __typename?: 'FieldFilterRule';
  field: string;
  id: UUID | null;
  operator: FieldOperator | null;
  values: string[][] | null;
}

export interface FieldFilter  {
  __typename?: 'FieldFilter';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface FieldFillError  {
  __typename?: 'FieldFillError';
  fieldId: ID;
  reason: TemplateErrorTypeEnum;
}

export interface FieldError extends ApiErrorBase {
  __typename?: 'FieldError';
  code: number;
  errors: FieldError[] | null;
  fieldId: UUID | null;
  fieldName: string | null;
  message: string | null;
  name: string;
}

export interface FieldEntityEdge  {
  __typename?: 'FieldEntityEdge';
  cursor: string;
  node: FieldEntity | null;
}

export interface FieldEntityConnection  {
  __typename?: 'FieldEntityConnection';
  edges: FieldEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface FieldEntity  {
  __typename?: 'FieldEntity';
  advancedFormula: AdvancedFormulaProperty | null;
  aiOptions: FieldAiOptions | null;
  apiName: string | null;
  calcFormula: string | null;
  columnName: string | null;
  columnSource: number | null;
  compositeFieldId: ID | null;
  created: DateTime | null;
  dataSet: FieldDataSetRelation[] | null;
  dataSetId: ID | null;
  defaultValue: string | null;
  entityName: string;
  fieldPermissions: FieldPermissionEntity[] | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isAvailableForAdvancedFormula: boolean;
  isAvailableForWebresource: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonlyOnRecurrentAppointment: boolean;
  isUnique: boolean | null;
  lookup: LookupProperty | null;
  modified: DateTime | null;
  name: string;
  nameTranslated: string | null;
  nameTranslations: JSONString;
  options: FieldOptionsProperty | null;
  originalDatasetFieldId: UUID | null;
  parentOptionsFieldId: ID | null;
  primitiveType: string;
  relationId: string | null;
  relationWithEntityId: string | null;
  rollup: RollupProperty | null;
  sequence: SequenceProperty | null;
  sequenceId: UUID | null;
  sequencePattern: string | null;
  sequenceSetId: ID | null;
  settings: JSONString | null;
  sharedWithFieldId: ID | null;
  sourceFieldId: string;
  sourceTypeId: string;
  systemReadonly: boolean | null;
  systemRequired: boolean | null;
  systemType: number | null;
  translatedName: string;
  typeId: string;
  useInGlobalSearch: boolean | null;
  useInInterfacePreview: boolean;
  useLang: number | null;
}

export interface FieldDescriptor  {
  __typename?: 'FieldDescriptor';
  advancedFormula: AdvancedFormulaProperty | null;
  aiOptions: FieldAiOptions | null;
  allowedEntityTypes: AllowedEntityType[];
  apiName: string | null;
  calcFormula: string | null;
  compositeFieldId: ID | null;
  dataSetId: ID | null;
  defaultValue: string | null;
  entity: EntityNameEnum | null;
  entityApiName: string | null;
  externalEntity: string | null;
  fieldUseOptions: FieldUseOptions | null;
  graphqlName: string | null;
  id: ID;
  isDeleted: boolean;
  lookup: LookupProperty | null;
  name: string;
  nameTranslated: string | null;
  nameTranslations: JSONString;
  options: FieldOptionsProperty | null;
  parentOptionsFieldId: ID | null;
  permissionLevel: AccessLevelFieldEnum;
  primitiveType: PrimitiveType;
  relatedEntity: string | null;
  rollup: RollupProperty | null;
  sequenceSetId: ID | null;
  sharedWithFieldId: ID | null;
  sourceFieldId: ID | null;
  sourceTypeId: string;
  systemReadonly: boolean | null;
  systemRequired: boolean | null;
  systemType: FieldSystemType;
  type: TypeEntity;
  typeEnumClassName: string | null;
  typeId: string;
  useLang: boolean;
  valueOptions: FieldValueOption[] | null;
}

export interface FieldDataSetRelation  {
  __typename?: 'FieldDataSetRelation';
  allowedBy: ID[] | null;
  entity: DataEntity;
}

export interface FieldDataContainer  {
  __typename?: 'FieldDataContainer';
  change: DataGridChange | null;
  displayOption: DisplayOption;
  fieldId: ID;
  value: JSONString | null;
}

export interface FieldAiValueUpdateSchedule extends ScheduleInterface {
  __typename?: 'FieldAiValueUpdateSchedule';
  date: DateTime | null;
  dayOfMonth: number[] | null;
  dayOfWeek: number[] | null;
  timeOfDay: number | null;
}

export interface FieldAiValueUpdateOptions  {
  __typename?: 'FieldAiValueUpdateOptions';
  autoUpdateOnRecordCreate: boolean;
  autoUpdateOnRecordUpdate: boolean;
  autoUpdateSchedule: FieldAiValueUpdateSchedule | null;
  autoUpdateScheduled: boolean;
  manualEnabled: boolean;
}

export interface FieldAiOptionsRelatedRecord  {
  __typename?: 'FieldAiOptionsRelatedRecord';
  entityRelationId: ID | null;
  filter: FieldFilter | null;
  targetEntity: EntityNameEnum;
  targetEntityApiName: string | null;
}

export interface FieldAiOptions  {
  __typename?: 'FieldAiOptions';
  general: FieldAiGeneralOptions;
  isEnabled: boolean;
  valueUpdate: FieldAiValueUpdateOptions;
}

export interface FieldAiGeneralOptions  {
  __typename?: 'FieldAiGeneralOptions';
  dataSourcesEnabled: boolean;
  prompt: string;
  recordDataEnabled: boolean;
  recordDocumentsEnabled: boolean;
  recordDocumentsFilter: FieldFilter | null;
  relatedRecords: FieldAiOptionsRelatedRecord[];
  relatedRecordsEnabled: boolean;
  webSearchEnabled: boolean;
}

export interface FeedsNotificationSettings  {
  __typename?: 'FeedsNotificationSettings';
  Comment: boolean;
  Create: boolean;
  IsActive: boolean;
}

export interface FeedView  {
  __typename?: 'FeedView';
  numOfLoadedItems: number;
  profile: FeedPreviewProfile;
  profileId: string;
  streamType: FeedStreamTypeEnum;
}

export interface FeedUnitAssignedAsWatcher extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithTargetUnitInterface {
  __typename?: 'FeedUnitAssignedAsWatcher';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  targetUnitId: ID;
  targetUnitIsDeleted: boolean | null;
  targetUnitName: string;
  targetUnitPictureUrl: string | null;
  value: number | null;
}

export interface FeedUnitAssignedAsEditor extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithTargetUnitInterface {
  __typename?: 'FeedUnitAssignedAsEditor';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  targetUnitId: ID;
  targetUnitIsDeleted: boolean | null;
  targetUnitName: string;
  targetUnitPictureUrl: string | null;
  value: number | null;
}

export interface FeedTextMessageCreated extends FeedItemInterface, FeedTextMessageInterface {
  __typename?: 'FeedTextMessageCreated';
  actor: FeedActor | null;
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  direction: EmailDirectionEnum;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  itemsInConversationCount: number | null;
  modified: DateTime;
  phoneType: PhoneTypeEnum | null;
  recipientPhoneNumber: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  textConversationId: ID;
  textMessageStatus: TextMessageStatusEnum;
}

export interface FeedTaskStatusChange extends FeedItemInterface {
  __typename?: 'FeedTaskStatusChange';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  status: TaskStatusEnum;
  tags: FeedTag[] | null;
}

export interface FeedTaskCreated extends FeedItemInterface, FeedTaskInterface {
  __typename?: 'FeedTaskCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  description: string | null;
  dueDate: GqlDate | null;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  hasRecurrence: boolean;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  priority: PriorityEnum;
  reminder: DateTime | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  taskStatus: TaskStatusEnum | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedTaskAdded extends FeedItemInterface, FeedTaskInterface {
  __typename?: 'FeedTaskAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  description: string | null;
  dueDate: GqlDate | null;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  hasRecurrence: boolean;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  priority: PriorityEnum;
  reminder: DateTime | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  taskStatus: TaskStatusEnum | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedTag  {
  __typename?: 'FeedTag';
  color: number;
  id: ID;
  name: string;
}

export interface FeedTableReportProfile extends FeedReportProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'FeedTableReportProfile';
  filter: FeedFilterTab;
  quickFilter: QuickFilterTab;
  role: FeedRoleTab;
  view: ViewTableReportTab;
}

export interface FeedTabEntityTypeOptions  {
  __typename?: 'FeedTabEntityTypeOptions';
  showAccount: boolean;
  showActivities: boolean;
  showActivityTypeIds: ID[] | null;
  showContact: boolean;
  showCustomEntities: string[] | null;
  showDocument: boolean;
  showEmail: boolean;
  showEmailSentiments: EmailSentimentEnum[] | null;
  showEmailTagIds: UUID[] | null;
  showEmailType: FeedEmailTypeEnum[] | null;
  showLead: boolean;
  showMassEmail: boolean;
  showMemo: boolean;
  showNote: boolean;
  showOnlineForm: boolean | null;
  showOpportunity: boolean;
  showProject: boolean;
  showQuote: boolean | null;
  showScheduledEmail: boolean | null;
  showTextMessage: boolean | null;
  showWhatsAppMessage: boolean | null;
}

export interface FeedTabDataGridViewOptions  {
  __typename?: 'FeedTabDataGridViewOptions';
  entityTypes: FeedTabEntityTypeOptions;
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyFavorite: boolean;
  showOnlyMy: boolean;
}

export interface FeedTabDataGridView  {
  __typename?: 'FeedTabDataGridView';
  activeProfile: FeedDetailScreenProfile;
  ofAccount: AccountFeedTabDataGridView;
  ofContact: ContactFeedTabDataGridView;
  ofCustomEntity: CustomEntityFeedTabDataGridView;
  ofLead: LeadFeedTabDataGridView;
  ofOpportunity: OpportunityFeedTabDataGridView;
  ofProject: ProjectFeedTabDataGridView;
  ofQuote: QuoteFeedTabDataGridView;
  profiles: FeedDetailScreenProfile[];
}

export interface FeedScreenProfile extends ProfileInterface {
  __typename?: 'FeedScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: FeedPreviewProfile;
  useLang: boolean;
}

export interface FeedScreen extends ProfileScreen, Screen {
  __typename?: 'FeedScreen';
  activeProfile: FeedScreenProfile;
  data: FeedProfileData;
  draftProfile: FeedScreenProfile | null;
  name: string;
  profiles: FeedScreenProfile[];
}

export interface FeedScheduledMassEmailCreated extends FeedItemInterface {
  __typename?: 'FeedScheduledMassEmailCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  canChangeContentSharing: boolean;
  contentShareMode: ContentShareModeEnum;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  errorCode: number;
  isContentAvailable: boolean;
  isTracked: boolean;
  modified: DateTime;
  recipientCount: number;
  sendAt: DateTime | null;
  sender: string;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  wasBounced: boolean;
}

export interface FeedScheduledEmailAdded extends FeedEmailInterface, FeedItemInterface, FeedItemWithAttachedPictures {
  __typename?: 'FeedScheduledEmailAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  attachmentsPictures: AttachmentsPictureEntity[];
  bodySummary: string;
  canChangeContentSharing: boolean;
  cc: string;
  contentShareMode: ContentShareModeEnum;
  created: DateTime;
  direction: EmailDirectionEnum;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  errorCode: number;
  hasTrackingEvent: boolean;
  isContentAvailable: boolean;
  isTracked: boolean;
  itemsInThreadCount: number | null;
  modified: DateTime;
  parentEmailId: ID | null;
  recipient: string;
  sendAt: DateTime | null;
  sender: string;
  senderId: ID | null;
  senderIsDeleted: boolean | null;
  senderName: string | null;
  senderPictureUrl: string | null;
  senderType: EntityNameEnum | null;
  sentiment: EmailSentimentEnum | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  wasBounced: boolean;
}

export interface FeedRoleTab extends RoleTabInterface {
  __typename?: 'FeedRoleTab';
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface FeedResponseToAppointmentInvitation extends FeedItemInterface {
  __typename?: 'FeedResponseToAppointmentInvitation';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  email: FeedEmailAppointmentInvitation | null;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  invitedClientId: ID | null;
  invitedClientIsDeleted: boolean | null;
  invitedClientName: string | null;
  invitedClientPictureUrl: string | null;
  modified: DateTime;
  response: InviteeResponseEnum;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedQuoteStatusChange extends FeedItemInterface {
  __typename?: 'FeedQuoteStatusChange';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  quoteStatus: QuoteStatusEnum;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedQuoteReactivate extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedQuoteReactivate';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedQuoteMove extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithStep {
  __typename?: 'FeedQuoteMove';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  stepName: string;
  stepOrder: number;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedQuoteLost extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedQuoteLost';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedQuoteAdded extends FeedItemInterface, FeedQuoteInterface {
  __typename?: 'FeedQuoteAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  expirationDate: DateTime | null;
  foreignCurrencyValue: CurrencyForeignData | null;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  quoteStatus: QuoteStatusEnum;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  totalAmount: number | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedQuoteAccepted extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedQuoteAccepted';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedProjectStatusChange extends FeedItemInterface {
  __typename?: 'FeedProjectStatusChange';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  projectStatus: ProjectStatusEnum;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedProjectAdded extends FeedItemInterface, FeedProjectInterface {
  __typename?: 'FeedProjectAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  description: string | null;
  endDate: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  projectStatus: ProjectStatusEnum;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  startDate: DateTime;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedProfileData  {
  __typename?: 'FeedProfileData';
  feed: Feed;
}

export interface FeedPreviewViewTab  {
  __typename?: 'FeedPreviewViewTab';
  entityTypes: FeedTabEntityTypeOptions;
}

export interface FeedPreviewProfile extends ProfileTabsInterface {
  __typename?: 'FeedPreviewProfile';
  filter: FeedPreviewFilterTab;
  role: ProfileStandardRoleTab;
  view: FeedPreviewViewTab;
}

export interface FeedPreviewFilterTab extends ProfileFilterBaseInterface {
  __typename?: 'FeedPreviewFilterTab';
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  isEnabled: boolean;
  showOnlyFavorite: boolean;
}

export interface FeedPivotReportProfile extends FeedReportProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'FeedPivotReportProfile';
  filter: FeedFilterTab;
  quickFilter: QuickFilterTab;
  role: FeedRoleTab;
  view: ViewPivotReportTab;
}

export interface FeedOwnershipChanged extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithTargetClientInterface {
  __typename?: 'FeedOwnershipChanged';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  targetClientId: ID | null;
  targetClientIsDeleted: boolean | null;
  targetClientName: string | null;
  targetClientPictureUrl: string | null;
  value: number | null;
}

export interface FeedOpportunityWon extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedOpportunityWon';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedOpportunityMove extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithStep {
  __typename?: 'FeedOpportunityMove';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  stepName: string;
  stepOrder: number;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedOpportunityCreated extends FeedItemInterface, FeedOpportunityInterface {
  __typename?: 'FeedOpportunityCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  closingDate: GqlDate;
  created: DateTime;
  daysInStep: number;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  hasRecurrence: boolean;
  label: number;
  modified: DateTime;
  opportunityStatus: OpptyStatusEnum | null;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  value: number | null;
  warningLevel: WarningLevelEnum | null;
}

export interface FeedOpportunityBackToLead extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedOpportunityBackToLead';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedOpportunityAdded extends FeedItemInterface, FeedOpportunityInterface {
  __typename?: 'FeedOpportunityAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  closingDate: GqlDate;
  created: DateTime;
  daysInStep: number;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  hasRecurrence: boolean;
  label: number;
  modified: DateTime;
  opportunityStatus: OpptyStatusEnum | null;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  value: number | null;
  warningLevel: WarningLevelEnum | null;
}

export interface FeedOnlineFormSubmitted extends FeedItemInterface, FeedOnlineFormInterface {
  __typename?: 'FeedOnlineFormSubmitted';
  actor: FeedActor | null;
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  onlineFormTypeId: ID;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedNoteAdded extends FeedItemInterface {
  __typename?: 'FeedNoteAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedMemoCreated extends FeedItemInterface, FeedItemWithAttachedPictures {
  __typename?: 'FeedMemoCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  attachmentsPictures: AttachmentsPictureEntity[];
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedMemoAdded extends FeedItemInterface, FeedItemWithAttachedPictures {
  __typename?: 'FeedMemoAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  attachmentsPictures: AttachmentsPictureEntity[];
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedMassEmailCreated extends FeedItemInterface {
  __typename?: 'FeedMassEmailCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  canChangeContentSharing: boolean;
  contentShareMode: ContentShareModeEnum;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  isContentAvailable: boolean;
  isTracked: boolean;
  modified: DateTime;
  recipientCount: number;
  sender: string;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  wasBounced: boolean;
}

export interface FeedLinkedEntity  {
  __typename?: 'FeedLinkedEntity';
  entity: string;
  entityApiName: EntityApiName | null;
  id: ID;
  isArchived: boolean;
  isAvailable: boolean;
  isDeleted: boolean;
  label: string;
}

export interface FeedLeadQualification extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedLeadQualification';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedLeadOpportunityReactivate extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedLeadOpportunityReactivate';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedLeadOpportunityLost extends FeedItemInterface, FeedItemWithEntitySpecificData {
  __typename?: 'FeedLeadOpportunityLost';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  value: number | null;
}

export interface FeedLeadCreated extends FeedItemInterface, FeedLeadInterface {
  __typename?: 'FeedLeadCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  daysInQueue: number;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  label: number;
  leadStatus: LeadStatusEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  warningLevel: WarningLevelEnum | null;
}

export interface FeedLeadAdded extends FeedItemInterface, FeedLeadInterface {
  __typename?: 'FeedLeadAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  daysInQueue: number;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  label: number;
  leadStatus: LeadStatusEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  ranking: number;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
  warningLevel: WarningLevelEnum | null;
}

export interface FeedItemEdge  {
  __typename?: 'FeedItemEdge';
  cursor: string;
  node: FeedItemInterfaceImplementors | null;
}

export interface FeedItemConnection  {
  __typename?: 'FeedItemConnection';
  edges: FeedItemEdge[];
  pageInfo: PageInfo;
  usedGroupIds: UUID[];
}

export interface FeedInvitationToAppointment extends FeedItemInterface {
  __typename?: 'FeedInvitationToAppointment';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  email: FeedEmailAppointmentInvitation | null;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  invitedClientId: ID | null;
  invitedClientIsDeleted: boolean | null;
  invitedClientName: string | null;
  invitedClientPictureUrl: string | null;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'FeedFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface FeedFilterSender  {
  __typename?: 'FeedFilterSender';
  entity: EntityNameEnum;
  id: ID;
}

export interface FeedEmailTabEntityTypeOptions  {
  __typename?: 'FeedEmailTabEntityTypeOptions';
  showEmail: boolean;
  showEmailSentiments: EmailSentimentEnum[] | null;
  showEmailTagIds: UUID[] | null;
  showEmailType: FeedEmailTypeEnum[] | null;
  showMassEmail: boolean;
  showScheduledEmail: boolean | null;
}

export interface FeedEmailTabDataGridViewOptions  {
  __typename?: 'FeedEmailTabDataGridViewOptions';
  entityTypes: FeedEmailTabEntityTypeOptions;
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyMy: boolean;
}

export interface FeedEmailTabDataGridView  {
  __typename?: 'FeedEmailTabDataGridView';
  activeProfile: FeedEmailDetailScreenProfile;
  ofAccount: AccountFeedEmailTabDataGridView;
  ofContact: ContactFeedEmailTabDataGridView;
  ofCustomEntity: CustomEntityFeedEmailTabDataGridView;
  ofLead: LeadFeedEmailTabDataGridView;
  ofOpportunity: OpportunityFeedEmailTabDataGridView;
  ofProject: ProjectFeedEmailTabDataGridView;
  ofQuote: QuoteFeedEmailTabDataGridView;
  profiles: FeedEmailDetailScreenProfile[];
}

export interface FeedEmailScreenProfile extends ProfileInterface {
  __typename?: 'FeedEmailScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: FeedEmailPreviewProfile;
  useLang: boolean;
}

export interface FeedEmailScreen extends ProfileScreen, Screen {
  __typename?: 'FeedEmailScreen';
  activeProfile: FeedEmailScreenProfile;
  data: FeedEmailProfileData;
  draftProfile: FeedEmailScreenProfile | null;
  name: string;
  profiles: FeedEmailScreenProfile[];
}

export interface FeedEmailProfileData  {
  __typename?: 'FeedEmailProfileData';
  feed: Feed;
}

export interface FeedEmailPreviewViewTab  {
  __typename?: 'FeedEmailPreviewViewTab';
  entityTypes: FeedEmailTabEntityTypeOptions;
}

export interface FeedEmailPreviewProfile extends ProfileTabsInterface {
  __typename?: 'FeedEmailPreviewProfile';
  filter: FeedEmailPreviewFilterTab;
  role: ProfileStandardRoleTab;
  view: FeedEmailPreviewViewTab;
}

export interface FeedEmailPreviewFilterTab extends ProfileFilterBaseInterface {
  __typename?: 'FeedEmailPreviewFilterTab';
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  isEnabled: boolean;
}

export interface FeedEmailDetailScreenProfile extends ProfileInterface {
  __typename?: 'FeedEmailDetailScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: FeedEmailDetailProfile;
  useLang: boolean;
}

export interface FeedEmailDetailProfile  {
  __typename?: 'FeedEmailDetailProfile';
  entityTypes: FeedEmailTabEntityTypeOptions;
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyMy: boolean;
}

export interface FeedEmailCreated extends FeedEmailInterface, FeedItemInterface, FeedItemWithAttachedPictures {
  __typename?: 'FeedEmailCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  attachmentsPictures: AttachmentsPictureEntity[];
  bodySummary: string;
  canChangeContentSharing: boolean;
  cc: string;
  contentShareMode: ContentShareModeEnum;
  created: DateTime;
  direction: EmailDirectionEnum;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  hasTrackingEvent: boolean;
  isContentAvailable: boolean;
  isTracked: boolean;
  itemsInThreadCount: number | null;
  modified: DateTime;
  parentEmailId: ID | null;
  recipient: string;
  sender: string;
  senderId: ID | null;
  senderIsDeleted: boolean | null;
  senderName: string | null;
  senderPictureUrl: string | null;
  senderType: EntityNameEnum | null;
  sentiment: EmailSentimentEnum | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  wasBounced: boolean;
}

export interface FeedEmailAppointmentInvitation  {
  __typename?: 'FeedEmailAppointmentInvitation';
  email: string;
  invitedContactId: ID | null;
  invitedContactName: string | null;
  invitedContactPictureUrl: string | null;
}

export interface FeedEmailAdded extends FeedEmailInterface, FeedItemInterface, FeedItemWithAttachedPictures {
  __typename?: 'FeedEmailAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  attachmentsPictures: AttachmentsPictureEntity[];
  bodySummary: string;
  canChangeContentSharing: boolean;
  cc: string;
  contentShareMode: ContentShareModeEnum;
  created: DateTime;
  direction: EmailDirectionEnum;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  hasTrackingEvent: boolean;
  isContentAvailable: boolean;
  isTracked: boolean;
  itemsInThreadCount: number | null;
  modified: DateTime;
  parentEmailId: ID | null;
  recipient: string;
  sender: string;
  senderId: ID | null;
  senderIsDeleted: boolean | null;
  senderName: string | null;
  senderPictureUrl: string | null;
  senderType: EntityNameEnum | null;
  sentiment: EmailSentimentEnum | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  wasBounced: boolean;
}

export interface FeedDetailScreenProfile extends ProfileInterface {
  __typename?: 'FeedDetailScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: FeedDetailProfile;
  useLang: boolean;
}

export interface FeedDetailProfile  {
  __typename?: 'FeedDetailProfile';
  entityTypes: FeedTabEntityTypeOptions;
  filterByPeriod: PeriodOption;
  filterBySender: FeedFilterSender[] | null;
  hasAttachment: boolean;
  relatedMessages: boolean;
  showOnlyFavorite: boolean;
  showOnlyMy: boolean;
}

export interface FeedCustomEntityAdded extends FeedCustomEntityInterface, FeedItemInterface {
  __typename?: 'FeedCustomEntityAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedContactCreated extends FeedContactInterface, FeedItemInterface {
  __typename?: 'FeedContactCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedContactAdded extends FeedContactInterface, FeedItemInterface {
  __typename?: 'FeedContactAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedCloudObjectAdded extends FeedItemInterface {
  __typename?: 'FeedCloudObjectAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedClientAssignedAsWatcher extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithTargetClientInterface {
  __typename?: 'FeedClientAssignedAsWatcher';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  targetClientId: ID | null;
  targetClientIsDeleted: boolean | null;
  targetClientName: string | null;
  targetClientPictureUrl: string | null;
  value: number | null;
}

export interface FeedClientAssignedAsEditor extends FeedItemInterface, FeedItemWithEntitySpecificData, FeedItemWithTargetClientInterface {
  __typename?: 'FeedClientAssignedAsEditor';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  foreignCurrencyValue: CurrencyForeignData | null;
  industryName: string | null;
  modified: DateTime;
  primaryAccountId: ID | null;
  primaryAccountJobName: string | null;
  primaryAccountName: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  targetClientId: ID | null;
  targetClientIsDeleted: boolean | null;
  targetClientName: string | null;
  targetClientPictureUrl: string | null;
  value: number | null;
}

export interface FeedChildAccountAdded extends FeedAccountInterface, FeedItemInterface {
  __typename?: 'FeedChildAccountAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  industryName: string | null;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedAppointmentCreated extends FeedAppointmentInterface, FeedItemInterface {
  __typename?: 'FeedAppointmentCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  appointmentStatus: ActivityStatusEnum | null;
  created: DateTime;
  description: string | null;
  endDate: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  reminder: DateTime | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  startDate: DateTime;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedAppointmentCanceled extends FeedItemInterface {
  __typename?: 'FeedAppointmentCanceled';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
}

export interface FeedAppointmentAdded extends FeedAppointmentInterface, FeedItemInterface {
  __typename?: 'FeedAppointmentAdded';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  appointmentStatus: ActivityStatusEnum | null;
  created: DateTime;
  description: string | null;
  endDate: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  reminder: DateTime | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  startDate: DateTime;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface FeedApplication  {
  __typename?: 'FeedApplication';
  id: ID;
  name: string;
}

export interface FeedActor  {
  __typename?: 'FeedActor';
  entityApiName: string | null;
  entityType: EntityNameEnum | null;
  id: ID;
  isAvailable: boolean | null;
  isDeleted: boolean | null;
  name: string | null;
  pictureUrl: string | null;
}

export interface FeedAccountCreated extends FeedAccountInterface, FeedItemInterface {
  __typename?: 'FeedAccountCreated';
  actorClientId: ID | null;
  actorClientIsDeleted: boolean | null;
  actorClientName: string | null;
  actorClientPictureUrl: string | null;
  application: FeedApplication;
  created: DateTime;
  entityActivityType: ActivityType | null;
  entityApiName: EntityApiName | null;
  entityCloudObjectsCount: number;
  entityCommentsCount: number;
  entityId: ID;
  entityLinkedEntities: FeedLinkedEntity[];
  entityName: string;
  entitySharedUsersUnits: FeedLinkedEntity[];
  entitySharedUsersUnitsCount: number;
  entityType: EntityNameEnum;
  industryName: string | null;
  modified: DateTime;
  ownerIsDeleted: boolean | null;
  ownerName: string | null;
  ownerPictureUrl: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
  sourceEntityApiName: EntityApiName | null;
  sourceEntityId: ID;
  sourceEntityType: EntityNameEnum;
  tags: FeedTag[] | null;
  unitIsDeleted: boolean | null;
  unitName: string;
  unitPictureUrl: string | null;
}

export interface Feed  {
  __typename?: 'Feed';
  items: FeedItemConnection | null;
  totalCount: number | null;
}

export interface FeeItem  {
  __typename?: 'FeeItem';
  catalogPrice: number | null;
  comment: string | null;
  discount: number | null;
  id: ID | null;
  mrrComment: string | null;
  mrrCount: number | null;
  mrrIsCounted: boolean | null;
  mrrMonthsCount: number | null;
  mrrTotal: number | null;
  mrrValidFrom: DateTime | null;
  name: string;
  price: string;
  productType: ProductTypeEnum | null;
  quantity: number;
  sku: string | null;
  subtotal: string;
  unitPrice: number;
}

export interface FeaturePermissions  {
  __typename?: 'FeaturePermissions';
  accessEntityAccountTagCreate: boolean;
  accessEntityAppointmentTagCreate: boolean;
  accessEntityContactTagCreate: boolean;
  accessEntityEmailSequences: AccessLevelProcessBuilderEnum;
  accessEntityLeadTagCreate: boolean;
  accessEntityMessageTagCreate: boolean;
  accessEntityOpptyTagCreate: boolean;
  accessEntityProcess: AccessLevelProcessBuilderEnum;
  accessEntityProjectTagCreate: boolean;
  accessEntityReportPrivate: boolean;
  accessEntityTaskTagCreate: boolean;
  accessiblePipelineIds: ID[];
  accountHierarchy: boolean;
  accounts: boolean;
  activitiesMultiLink: boolean;
  addedAutomationHubItemsIds: ID[];
  adminAccountHierarchy: boolean;
  adminAccountRelations: boolean;
  adminAccountRoles: boolean;
  adminAddCompanyEmails: boolean;
  adminAdvancedPermissions: boolean;
  adminAiAutomatizer: boolean;
  adminAiOnlineForms: boolean;
  adminAiRecordDetail: boolean;
  adminAiReports: boolean;
  adminAiSmartField: boolean;
  adminAiSuperAgent: boolean;
  adminApiAccess: boolean;
  adminAppointmentScheduler: boolean;
  adminApprovalProcesses: boolean;
  adminAuditLog: boolean;
  adminAutomationHub: boolean;
  adminCallingIntegration: boolean;
  adminCompanyEmails: boolean;
  adminContactRelations: boolean;
  adminCreateCustomEntity: boolean;
  adminCurrencies: boolean;
  adminCustomFieldsAndForms: boolean;
  adminDocumentManagement: boolean;
  adminEmailSequences: boolean;
  adminEmailTemplates: boolean;
  adminEntityHealth: boolean;
  adminEntityScoring: boolean;
  adminFieldPermissions: boolean;
  adminFieldsFormsProductsCustomization: boolean;
  adminFieldsFormsRollup: boolean;
  adminGlobalSettings: boolean;
  adminMultilanguageSupport: boolean;
  adminMultipleCurrencies: boolean;
  adminMultiplePipelines: boolean;
  adminMultipleRoles: boolean;
  adminMultipleUnits: boolean;
  adminOnlineForms: boolean;
  adminPipelines: boolean;
  adminProcessBuilder: boolean;
  adminProductsAndPrices: boolean;
  adminProjects: boolean;
  adminQuotes: boolean;
  adminRevenueSchedule: boolean;
  adminSalesActions: boolean;
  adminSalesActivities: boolean;
  adminSalesRoles: boolean;
  adminSalesUnits: boolean;
  adminSetAuditLog: boolean;
  adminSetAutomationHub: boolean;
  adminSpaceSecurity: boolean;
  adminStepDocuments: boolean;
  adminTarget: boolean;
  adminUsersAndRoles: boolean;
  adminWhatsAppIntegration: boolean;
  advancedManagementReports: boolean;
  aiAgent: boolean;
  aiAutomatizer: boolean;
  aiDocumentTools: boolean;
  aiEmailAssistant: boolean;
  aiEmailCategorization: boolean;
  aiFeedTools: boolean;
  aiHtmlToMjml: boolean;
  aiMediaTranscription: boolean;
  aiOnlineForms: boolean;
  aiRecordDetail: boolean;
  aiReports: boolean;
  aiScreenAgent: boolean;
  aiSmartField: boolean;
  aiSpeechToText: boolean;
  aiSuperAgent: boolean;
  aiTextAnalysis: boolean;
  aiTextToSpeech: boolean;
  aiTextTools: boolean;
  alfresco: boolean;
  allowBetterNavigatorCreate: boolean;
  allowBetterNavigatorSharingCustom: boolean;
  allowBetterNavigatorSharingPublic: boolean;
  allowCalling: boolean;
  allowCallingPurchasePhone: boolean;
  allowDashboardCreate: boolean;
  allowDashboardSharingCustom: boolean;
  allowDashboardSharingPublic: boolean;
  allowEmailTemplateSharingCustom: boolean;
  allowEmailTemplateSharingPublic: boolean;
  allowForecastCreate: boolean;
  allowForecastSharingCustom: boolean;
  allowForecastSharingPublic: boolean;
  allowFormViewSharingCustom: boolean;
  allowFormViewSharingPublic: boolean;
  allowProfileSharingCustom: boolean;
  allowProfileSharingPublic: boolean;
  allowReportCreate: boolean;
  allowReportSharingCustom: boolean;
  allowReportSharingPublic: boolean;
  allowTargetCreate: boolean;
  allowedCompanyEmails: ID[];
  appointmentScheduler: boolean;
  appointmentSchedulerManagement: boolean;
  approvalProcesses: boolean;
  approvalProcessesManagement: boolean;
  approvals: boolean;
  archive: boolean;
  audit: boolean;
  automatizerProcessDescriptions: boolean;
  betterNavigator: boolean;
  bubbleChart: boolean;
  bulkEdit: boolean;
  businessCardReader: boolean;
  buyingCenter: boolean;
  calling: boolean;
  callingIntegration: boolean;
  changeLog: boolean;
  contactAutocapitalization: boolean;
  contacts: boolean;
  customActivityTypes: boolean;
  customEntities: CustomEntityFeaturePermission[];
  customLookupForContactAccount: boolean;
  customerPrice: boolean;
  dashboard: boolean;
  documentManagement: boolean;
  documentManagementCompany: boolean;
  documentManagementDialog: boolean;
  documentManagementRecord: boolean;
  documentTemplates: boolean;
  documents: boolean;
  dropboxIntegration: boolean;
  duplicateChecker: boolean;
  emailContentSharing: ContentShareModeConfigEnum;
  emailSequences: boolean;
  emailSequencesIntegration: boolean;
  emailTemplates: boolean;
  enabledAutomationHubItemsIds: ID[];
  entityHealth: boolean;
  entityScoring: boolean;
  exchange: boolean;
  export: boolean;
  feeds: boolean;
  fieldMapping: boolean;
  fieldPermissions: boolean;
  fileAttachmentUpload: boolean;
  forecast: boolean;
  formViews: boolean;
  fullContactIntegration: boolean;
  googleDriveIntegration: boolean;
  googleMapsIntegration: boolean;
  historyReports: boolean;
  hubspotIntegration: boolean;
  import: boolean;
  inAppNotifications: boolean;
  insights: boolean;
  integrationsAnalytics: boolean;
  intercom: boolean;
  leads: boolean;
  managementReports: boolean;
  matrix: boolean;
  merge: boolean;
  msTeamsIntegration: boolean;
  navigator: boolean;
  notes: boolean;
  onedriveIntegration: boolean;
  onlineForms: boolean;
  onlineFormsManagement: boolean;
  opportunities: boolean;
  orgChart: boolean;
  pandaDocIntegration: boolean;
  priceSchedule: boolean;
  print: boolean;
  processBuilder: boolean;
  processBuilderIntegration: boolean;
  projects: boolean;
  quotes: boolean;
  receiveEmailsUsingBcc: boolean;
  recurringOpportunities: boolean;
  recurringTasks: boolean;
  relationGraph: boolean;
  ringcentralIntegration: boolean;
  scheduledReports: boolean;
  scheduledReportsCreate: boolean;
  scheduledReportsManagement: boolean;
  sharepointIntegration: boolean;
  sqlExport: boolean;
  stepDocuments: ID[];
  subscriptionAdmin: boolean;
  syncEmailUsingImap: boolean;
  syncExchangeAppointments: boolean;
  syncExchangeContacts: boolean;
  syncExchangeEmail: boolean;
  syncExchangeTasks: boolean;
  syncGoogleCalendar: boolean;
  syncGoogleContacts: boolean;
  syncGoogleEmailAdded: boolean;
  syncGoogleEmails: boolean;
  syncGoogleTasks: boolean;
  syncO365Calendar: boolean;
  syncO365Contacts: boolean;
  syncO365Email: boolean;
  syncO365EmailAdded: boolean;
  syncO365Tasks: boolean;
  syncSendgridEmail: boolean;
  target: boolean;
  taskBoard: boolean;
  thumbnailView: boolean;
  timeZoneChecker: boolean;
  whatsAppIntegration: boolean;
  zoomIntegration: boolean;
}

export interface FavoriteRecords  {
  __typename?: 'FavoriteRecords';
  items: FavoriteConnection | null;
}

export interface FavoriteEdge  {
  __typename?: 'FavoriteEdge';
  cursor: string;
  node: FavoriteResultItemInterfaceImplementors | null;
}

export interface FavoriteConnection  {
  __typename?: 'FavoriteConnection';
  accountCount: number | null;
  contactCount: number | null;
  customEntityCount: CustomEntityCount[] | null;
  edges: FavoriteEdge[];
  leadCount: number | null;
  opportunityCount: number | null;
  pageInfo: PageInfo;
  projectCount: number | null;
  quoteCount: number | null;
  reportCount: number | null;
  totalCount: number;
}

export interface ExtractViews  {
  __typename?: 'ExtractViews';
  account: AccountEntityData | null;
  appointment: AppointmentEntityData | null;
  archiveLeadStep: ArchiveLeadStepExtractView;
  archiveStep: ArchiveStepExtractView;
  archiveWonStep: ArchiveWonStepExtractView;
  client: ClientEntityData | null;
  contact: ContactEntityData | null;
  customEntity: CustomEntityEntityData | null;
  lead: LeadEntityData | null;
  leadArchiveLeadStep: ArchiveLeadPreviewStepExtractView;
  leadBoardOpportunityStep: LeadPreviewOpportunityStepExtractView;
  leadBoardStep: LeadPreviewStepExtractView;
  leadStep: LeadStepExtractView;
  opportunity: OpportunityEntityData | null;
  pipelinePerformanceLeadStep: PipelinePerformanceLeadStepExtractView;
  pipelinePerformanceStep: PipelinePerformanceStepExtractView;
  pipelinePerformanceWonStep: PipelinePerformanceWonStepExtractView;
  product: ProductEntityData | null;
  project: ProjectEntityData | null;
  quote: QuoteEntityData | null;
  step: StepExtractView;
  task: TaskEntityData | null;
  wonStep: WonStepExtractView;
}

export interface ExecuteManualTriggerProcessResult  {
  __typename?: 'ExecuteManualTriggerProcessResult';
  error: string | null;
  sessionId: UUID | null;
  success: boolean;
}

export interface ExecuteManualTriggerApprovalProcessPayload  {
  __typename?: 'ExecuteManualTriggerApprovalProcessPayload';
  result: ExecuteApprovalProcessResult;
}

export interface ExecuteApprovalProcessResult  {
  __typename?: 'ExecuteApprovalProcessResult';
  success: boolean;
}

export interface ExchangeServiceSettingsOutput  {
  __typename?: 'ExchangeServiceSettingsOutput';
  deleteProtection: ContactDeletionProtectionEnum | null;
  domain: string | null;
  email: string | null;
  enabled: ServiceStatus;
  errorCode: number;
  imageUrl: string | null;
  method: ExchangeAuthMethodTypeEnum;
  name: string | null;
  passwordSet: boolean;
  recordOwnership: RecordOwnershipEnum | null;
  server: string | null;
  syncMethod: ContactSyncMethodEnum | null;
  username: string;
}

export interface ExchangeAuthOptionsOutput  {
  __typename?: 'ExchangeAuthOptionsOutput';
  method: ExchangeAuthMethodTypeEnum;
  url: string | null;
}

export interface EntityValidationError extends ApiErrorBase {
  __typename?: 'EntityValidationError';
  code: number;
  entityErrors: FieldError[] | null;
  entityId: UUID | null;
  entityIndex: number | null;
  entityName: string | null;
  fieldErrors: FieldError[] | null;
  message: string | null;
  name: string;
  stepChecklistErrors: StepChecklistError[] | null;
}

export interface EntityTypeSettings  {
  __typename?: 'EntityTypeSettings';
  allowedAppointmentTypeIds: ID[] | null;
  allowedTaskTypeIds: ID[] | null;
}

export interface EntityTypeProcessPriorities  {
  __typename?: 'EntityTypeProcessPriorities';
  priorities: UUID[];
  processId: UUID;
}

export interface EntityTypeFieldMapping  {
  __typename?: 'EntityTypeFieldMapping';
  mapping: FieldMappingTemplate | null;
  sourceTypeIds: ID[] | null;
  targetTypeIds: ID[] | null;
}

export interface EntitySyncSettings  {
  __typename?: 'EntitySyncSettings';
  created: DateTime | null;
  modified: DateTime | null;
  name: string | null;
  value: string | null;
}

export interface EntitySubtypeItem  {
  __typename?: 'EntitySubtypeItem';
  formId: ID[] | null;
  kind: EntitySubtypeKind;
}

export interface EntityStepSummary  {
  __typename?: 'EntityStepSummary';
  readyToMove: boolean;
  velocityOverdue: boolean;
}

export interface EntitySettingsRepository  {
  __typename?: 'EntitySettingsRepository';
  getAll: EntitySettingsEntity[];
  getByCriteria: EntitySettingsEntity[];
  getById: EntitySettingsEntity | null;
  getByIds: EntitySettingsEntity[];
  getDraftById: EntitySettingsEntity;
  getDrafts: EntitySettingsEntity[];
  getForEntity: EntitySettingsEntity[];
  getPublished: EntitySettingsEntity[];
}

export interface EntitySettingsEntity  {
  __typename?: 'EntitySettingsEntity';
  created: DateTime | null;
  defaultListColumns: EntitySettingsDefaultListColumns;
  entityApiName: string | null;
  entityName: EntityNameEnum;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface EntitySettingsDefaultListColumns  {
  __typename?: 'EntitySettingsDefaultListColumns';
  applyToExistingUsers: boolean;
  columns: EntityListColumn[];
}

export interface EntityScoringSettings  {
  __typename?: 'EntityScoringSettings';
  categories: EntityScoringCategory[];
  filter: FieldFilter;
  rules: EntityScoringRuleImplementors[] | null;
}

export interface EntityScoringRuleFilter  {
  __typename?: 'EntityScoringRuleFilter';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  operator: FilterGroupOperator;
}

export interface EntityScoringResultRule  {
  __typename?: 'EntityScoringResultRule';
  id: UUID;
  name: string;
  trend: EntityScoringTrendEnum;
  useLang: boolean;
}

export interface EntityScoringResult  {
  __typename?: 'EntityScoringResult';
  categories: EntityScoringCategory[];
  entityScoringId: UUID;
  entityScoringName: string;
  entityScoringUseLang: boolean;
  lastCalculation: DateTime;
  rules: EntityScoringResultRule[];
  score: number;
  trend: EntityScoringTrendEnum;
}

export interface EntityScoringRepository  {
  __typename?: 'EntityScoringRepository';
  getAll: EntityScoringEntity[];
  getByCriteria: EntityScoringEntityConnection | null;
  getByEntityType: EntityScoringEntity;
  getById: EntityScoringEntity | null;
  getByIds: EntityScoringEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getRecalculationStatus: EntityScoringRecalculationStatus;
}

export interface EntityScoringRecalculationStatus  {
  __typename?: 'EntityScoringRecalculationStatus';
  calculationProgress: number | null;
  lastRecalculation: DateTime | null;
}

export interface EntityScoringFieldRule extends EntityScoringRule {
  __typename?: 'EntityScoringFieldRule';
  conditions: EntityScoringRuleFilter;
  expiration: number;
  expirationEnabled: boolean;
  expirationUnit: EntityScoringRuleExpirationUnitEnum;
  id: UUID;
  isEnabled: boolean;
  name: string;
  score: number;
  scoreMultiplier: boolean;
  scoreMultiplierFieldId: UUID | null;
  useLang: boolean;
}

export interface EntityScoringEntityEdge  {
  __typename?: 'EntityScoringEntityEdge';
  cursor: string;
  node: EntityScoringEntity | null;
}

export interface EntityScoringEntityConnection  {
  __typename?: 'EntityScoringEntityConnection';
  edges: EntityScoringEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EntityScoringEntity  {
  __typename?: 'EntityScoringEntity';
  created: DateTime | null;
  entityType: BaseEntityTypeEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: EntityScoringSettings;
  sortOrder: number;
  useLang: boolean | null;
}

export interface EntityScoringEmailRule extends EntityScoringRule {
  __typename?: 'EntityScoringEmailRule';
  conditions: EntityScoringRuleFilter;
  emailEventType: EntityScoringRuleEmailEventTypeEnum;
  expiration: number;
  expirationEnabled: boolean;
  expirationUnit: EntityScoringRuleExpirationUnitEnum;
  id: UUID;
  isEnabled: boolean;
  name: string;
  score: number;
  scoreMultiplier: boolean;
  useLang: boolean;
}

export interface EntityScoringCategory  {
  __typename?: 'EntityScoringCategory';
  color: number;
  id: UUID;
  label: string;
  useLang: boolean;
  value: number;
}

export interface EntityScoringActivityRule extends EntityScoringRule {
  __typename?: 'EntityScoringActivityRule';
  activityStatus: ActivityStatusEnum;
  conditions: EntityScoringRuleFilter;
  expiration: number;
  expirationEnabled: boolean;
  expirationUnit: EntityScoringRuleExpirationUnitEnum;
  id: UUID;
  isEnabled: boolean;
  name: string;
  score: number;
  scoreMultiplier: boolean;
  useLang: boolean;
}

export interface EntityRevisionInfo  {
  __typename?: 'EntityRevisionInfo';
  entity: EntityNameEnum;
  revision: number;
}

export interface EntityRepositoryRegistry  {
  __typename?: 'EntityRepositoryRegistry';
  account: AccountRepository | null;
  accountDataExRelation: AccountDataExRelationRepository | null;
  accountKpi: AccountKPIRepository | null;
  accountProductPricing: AccountProductPricingRepository | null;
  accountRelation: AccountRelationRepository | null;
  accountRelationLabel: AccountRelationLabelRepository | null;
  accountRelationType: AccountRelationTypeRepository | null;
  accountRole: AccountRoleRepository | null;
  accountSharingClientRelation: AccountSharingClientRelationRepository | null;
  accountSharingSalesUnitRelation: AccountSharingSalesUnitRelationRepository | null;
  accountSocialRelation: AccountSocialRelationRepository | null;
  accountType: AccountTypeRepository | null;
  activity: ActivityRepository | null;
  activityComment: ActivityCommentRepository | null;
  activityDataExRelation: ActivityDataExRelationRepository | null;
  activityKpi: ActivityKPIRepository | null;
  activityRelation: ActivityRelationRepository | null;
  allowedAccountType: AllowedAccountTypeRepository | null;
  allowedCompanyEmail: AllowedCompanyEmailRepository | null;
  allowedCompanyPhone: AllowedCompanyPhoneRepository | null;
  allowedContactType: AllowedContactTypeRepository | null;
  allowedLeadType: AllowedLeadTypeRepository | null;
  allowedPipeline: AllowedPipelineRepository | null;
  allowedQuoteType: AllowedQuoteTypeRepository | null;
  apiAccess: ApiAccessRepository | null;
  application: ApplicationRepository | null;
  appointment: AppointmentRepository | null;
  appointmentClientInviteesRelation: AppointmentClientInviteesRelationRepository | null;
  appointmentContactInviteesRelation: AppointmentContactInviteesRelationRepository | null;
  appointmentReminder: AppointmentReminderRepository | null;
  appointmentSchedule: AppointmentScheduleRepository | null;
  appointmentType: AppointmentTypeRepository | null;
  approval: ApprovalRepository | null;
  approvalApprover: ApprovalApproverRepository | null;
  approvalProcess: ApprovalProcessRepository | null;
  approvalProcessActivityLogLine: ApprovalProcessActivityLogLineRepository | null;
  automationHubItem: AutomationHubItemRepository | null;
  call: CallRepository | null;
  chatConversation: ChatConversationRepository | null;
  client: ClientRepository | null;
  clientExcludedOppty: ClientExcludedOpptyRepository | null;
  clientFavorite: ClientFavoriteRepository | null;
  clientSetting: ClientSettingRepository | null;
  clientStoryRead: ClientStoryReadRepository | null;
  cloudObject: CloudObjectRepository | null;
  cloudObjectFolder: CloudObjectFolderRepository | null;
  cloudObjectRelation: CloudObjectRelationRepository | null;
  cloudObjectStepRelation: CloudObjectStepRelationRepository | null;
  cloudObjectTemplate: CloudObjectTemplateRepository | null;
  companyEmail: CompanyEmailRepository | null;
  contact: ContactRepository | null;
  contactAccountAccountRoleRelation: ContactAccountAccountRoleRelationRepository | null;
  contactAccountRelation: ContactAccountRelationRepository | null;
  contactDataExRelation: ContactDataExRelationRepository | null;
  contactKpi: ContactKPIRepository | null;
  contactRelation: ContactRelationRepository | null;
  contactRelationLabel: ContactRelationLabelRepository | null;
  contactRelationType: ContactRelationTypeRepository | null;
  contactSharingClientRelation: ContactSharingClientRelationRepository | null;
  contactSharingSalesUnitRelation: ContactSharingSalesUnitRelationRepository | null;
  contactSocialRelation: ContactSocialRelationRepository | null;
  contactType: ContactTypeRepository | null;
  currency: CurrencyRepository | null;
  currencyExchangeRate: CurrencyExchangeRateRepository | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListRepository | null;
  customEntity: CustomEntityRepository | null;
  customEntityDataExRelation: CustomEntityDataExRelationRepository | null;
  customEntityRelation: CustomEntityRelationRepository | null;
  customEntityRelationData: CustomEntityRelationDataRepository | null;
  customEntitySharingClientRelation: CustomEntitySharingClientRelationRepository | null;
  customEntitySharingSalesUnitRelation: CustomEntitySharingSalesUnitRelationRepository | null;
  customEntityType: CustomEntityTypeRepository | null;
  data: DataRepository | null;
  ebook: EbookRepository | null;
  email: EmailRepository | null;
  emailContentSharingClientRelation: EmailContentSharingClientRelationRepository | null;
  emailContentSharingSalesUnitRelation: EmailContentSharingSalesUnitRelationRepository | null;
  emailEvent: EmailEventRepository | null;
  emailSequence: EmailSequenceRepository | null;
  emailSequenceActivityLog: EmailSequenceActivityLogRepository | null;
  emailSequenceActivityLogLine: EmailSequenceActivityLogLineRepository | null;
  emailSequenceEnrolled: EmailSequenceEnrolledRepository | null;
  emailTemplate: EmailTemplateRepository | null;
  emailTemplateFolder: EmailTemplateFolderRepository | null;
  emailTemplateSharingClientRelation: EmailTemplateSharingClientRelationRepository | null;
  emailTemplateSharingSalesUnitRelation: EmailTemplateSharingSalesUnitRelationRepository | null;
  entity: EntityRepository | null;
  entityFitness: EntityFitnessRepository | null;
  entityFitnessIndicator: EntityFitnessIndicatorRepository | null;
  entityHealth: EntityHealthRepository | null;
  entityScoring: EntityScoringRepository | null;
  entitySettings: EntitySettingsRepository | null;
  field: FieldRepository | null;
  fieldMapping: FieldMappingRepository | null;
  fieldPermission: FieldPermissionRepository | null;
  fieldSequence: FieldSequenceRepository | null;
  forecast: ForecastRepository | null;
  formView: FormViewRepository | null;
  formViewSharingClientRelation: FormViewSharingClientRelationRepository | null;
  formViewSharingSalesUnitRelation: FormViewSharingSalesUnitRelationRepository | null;
  ghostContact: GhostContactRepository | null;
  ghostContactAccountAccountRoleRelation: GhostContactAccountAccountRoleRelationRepository | null;
  ghostContactAccountRelation: GhostContactAccountRelationRepository | null;
  ghostLeadOpptyContactRelation: GhostLeadOpptyContactRelationRepository | null;
  ghostLeadOpptyContactSalesRoleRelation: GhostLeadOpptyContactSalesRoleRelationRepository | null;
  howTo: HowToRepository | null;
  importMappingMask: ImportMappingMaskRepository | null;
  interfacePreview: InterfacePreviewRepository | null;
  lead: LeadRepository | null;
  leadOppty: LeadOpptyRepository | null;
  leadOpptyAccountRelation: LeadOpptyAccountRelationRepository | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationRepository | null;
  leadOpptyContactRelation: LeadOpptyContactRelationRepository | null;
  leadOpptyContactSalesRoleRelation: LeadOpptyContactSalesRoleRelationRepository | null;
  leadOpptyDataExRelation: LeadOpptyDataExRelationRepository | null;
  leadOpptyKpi: LeadOpptyKPIRepository | null;
  leadOpptySharingClientRelation: LeadOpptySharingClientRelationRepository | null;
  leadOpptySharingSalesUnitRelation: LeadOpptySharingSalesUnitRelationRepository | null;
  leadOpptyStepCheckListRelation: LeadOpptyStepCheckListRelationRepository | null;
  leadProcess: LeadProcessRepository | null;
  leadType: LeadTypeRepository | null;
  masterRight: MasterRightRepository | null;
  media: MediaRepository | null;
  memo: MemoRepository | null;
  memoComment: MemoCommentRepository | null;
  messageRelation: MessageRelationRepository | null;
  messageSharingClientRelation: MessageSharingClientRelationRepository | null;
  messageSharingSalesUnitRelation: MessageSharingSalesUnitRelationRepository | null;
  note: NoteRepository | null;
  onlineForm: OnlineFormRepository | null;
  onlineFormActivityLogLine: OnlineFormActivityLogLineRepository | null;
  onlineFormDataExRelation: OnlineFormDataExRelationRepository | null;
  onlineFormRelation: OnlineFormRelationRepository | null;
  onlineFormStyle: OnlineFormStyleRepository | null;
  onlineFormType: OnlineFormTypeRepository | null;
  onlineFormTypeEmailRelation: OnlineFormTypeEmailRelationRepository | null;
  opportunity: OpportunityRepository | null;
  opportunityType: OpportunityTypeRepository | null;
  opptyProductRelation: OpptyProductRelationRepository | null;
  opptyProductRelationDataExRelation: OpptyProductRelationDataExRelationRepository | null;
  opptyProductRelationRevenueSchedule: OpptyProductRelationRevenueScheduleRepository | null;
  opptyProductRelationRevenueSchedulePeriod: OpptyProductRelationRevenueSchedulePeriodRepository | null;
  opptyProductRelationType: OpptyProductRelationTypeRepository | null;
  opptyRecurrence: OpptyRecurrenceRepository | null;
  opptyRevenueSchedule: OpptyRevenueScheduleRepository | null;
  opptyRevenueSchedulePeriod: OpptyRevenueSchedulePeriodRepository | null;
  parentAccountRelationType: ParentAccountRelationTypeRepository | null;
  phone: PhoneRepository | null;
  pipeline: PipelineRepository | null;
  process: ProcessRepository | null;
  processActivityLog: ProcessActivityLogRepository | null;
  processActivityLogLine: ProcessActivityLogLineRepository | null;
  processScheduledAction: ProcessScheduledActionRepository | null;
  processTemplate: ProcessTemplateRepository | null;
  product: ProductRepository | null;
  productCategory: ProductCategoryRepository | null;
  productDataExRelation: ProductDataExRelationRepository | null;
  productPipelineRelation: ProductPipelineRelationRepository | null;
  productPriceList: ProductPriceListRepository | null;
  productPriceListPrice: ProductPriceListPriceRepository | null;
  productType: ProductTypeRepository | null;
  profile: ProfileRepository | null;
  profileRelation: ProfileRelationRepository | null;
  profileSharingClientRelation: ProfileSharingClientRelationRepository | null;
  profileSharingSalesUnitRelation: ProfileSharingSalesUnitRelationRepository | null;
  project: ProjectRepository | null;
  projectContactRelation: ProjectContactRelationRepository | null;
  projectDataExRelation: ProjectDataExRelationRepository | null;
  projectKpi: ProjectKPIRepository | null;
  projectObjective: ProjectObjectiveRepository | null;
  projectSharingClientRelation: ProjectSharingClientRelationRepository | null;
  projectSharingSalesUnitRelation: ProjectSharingSalesUnitRelationRepository | null;
  projectType: ProjectTypeRepository | null;
  quote: QuoteRepository | null;
  quoteAccountRelation: QuoteAccountRelationRepository | null;
  quoteContactRelation: QuoteContactRelationRepository | null;
  quoteDataExRelation: QuoteDataExRelationRepository | null;
  quoteKpi: QuoteKPIRepository | null;
  quoteProcess: QuoteProcessRepository | null;
  quoteSharingClientRelation: QuoteSharingClientRelationRepository | null;
  quoteSharingSalesUnitRelation: QuoteSharingSalesUnitRelationRepository | null;
  quoteType: QuoteTypeRepository | null;
  releaseNote: ReleaseNoteRepository | null;
  report: ReportRepository | null;
  reportFolder: ReportFolderRepository | null;
  reportSchedule: ReportScheduleRepository | null;
  reportSharingClientRelation: ReportSharingClientRelationRepository | null;
  reportSharingSalesUnitRelation: ReportSharingSalesUnitRelationRepository | null;
  salesRole: SalesRoleRepository | null;
  salesUnit: SalesUnitRepository | null;
  salesUnitClientRelation: SalesUnitClientRelationRepository | null;
  step: StepRepository | null;
  stepChecklist: StepChecklistRepository | null;
  stepChecklistSalesRoleRelation: StepChecklistSalesRoleRelationRepository | null;
  storylane: StorylaneRepository | null;
  tag: TagRepository | null;
  tagRelation: TagRelationRepository | null;
  target: TargetRepository | null;
  targetRelation: TargetRelationRepository | null;
  task: TaskRepository | null;
  taskRecurrence: TaskRecurrenceRepository | null;
  taskReminder: TaskReminderRepository | null;
  taskSharingClientRelation: TaskSharingClientRelationRepository | null;
  taskSharingSalesUnitRelation: TaskSharingSalesUnitRelationRepository | null;
  taskType: TaskTypeRepository | null;
  teamSpaceClientSetting: TeamSpaceClientSettingRepository | null;
  textMessage: TextMessageRepository | null;
  textMessageConversation: TextMessageConversationRepository | null;
  textMessageConversationRelations: TextMessageConversationRelationsRepository | null;
  timeframe: TimeframeRepository | null;
  translation: TranslationRepository | null;
  type: TypeRepository | null;
  unsubscribedPhone: UnsubscribedPhoneRepository | null;
  webhook: WebhookRepository | null;
  webhookEvent: WebhookEventRepository | null;
  webresource: WebresourceRepository | null;
}

export interface EntityRepository  {
  __typename?: 'EntityRepository';
  getAll: EntityEntity[];
  getByCriteria: EntityEntityConnection | null;
  getById: EntityEntity | null;
  getByIds: EntityEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EntityOperationMappingOption  {
  __typename?: 'EntityOperationMappingOption';
  sourceValue: string;
  targetValue: string | null;
}

export interface EntityOperationMapping  {
  __typename?: 'EntityOperationMapping';
  options: EntityOperationMappingOption[] | null;
}

export interface EntityMapping  {
  __typename?: 'EntityMapping';
  error: BulkErrorResult | null;
  exchangeEntityId: string | null;
  flagToDelete: boolean | null;
  googleEntityId: string | null;
  o365EntityId: string | null;
  pipelinerEntityId: UUID | null;
}

export interface EntityListInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'EntityListInterfaceFieldData';
  entities: EntityData[];
  fieldId: UUID;
}

export interface EntityListColumn  {
  __typename?: 'EntityListColumn';
  fieldId: string;
  frozen: boolean;
  width: number;
}

export interface EntityInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'EntityInterfaceFieldData';
  entity: EntityData | null;
  fieldId: UUID;
}

export interface EntityInstancePermissions  {
  __typename?: 'EntityInstancePermissions';
  id: ID;
  permissions: EntityPermsEnum[];
}

export interface EntityIdNamePair  {
  __typename?: 'EntityIdNamePair';
  id: ID;
  name: string;
}

export interface EntityHealthSettings  {
  __typename?: 'EntityHealthSettings';
  calculationType: EntityHealthCalculationTypeEnum;
  categories: HealthCategory[];
  criticalHealthIndicators: EntityHealthFieldConfiguration;
  healthIndicators: EntityHealthFieldConfiguration;
}

export interface EntityHealthResult  {
  __typename?: 'EntityHealthResult';
  indicators: EntityHealthIndicator[];
  lastCalculation: DateTime;
  score: number;
  trend: EntityHealthTrendEnum;
}

export interface EntityHealthRepository  {
  __typename?: 'EntityHealthRepository';
  getAll: EntityHealthEntity[];
  getByCriteria: EntityHealthEntityConnection | null;
  getById: EntityHealthEntity | null;
  getByIds: EntityHealthEntity[];
  getByTypeId: EntityHealthEntity;
  getChangedFieldsSinceRevision: UUID[];
}

export interface EntityHealthPlannerPayload  {
  __typename?: 'EntityHealthPlannerPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface EntityHealthMainFilterBox extends FilterBoxInterface {
  __typename?: 'EntityHealthMainFilterBox';
  entity: string;
  filterFields: EntityHealthFieldFilterRule[];
  id: string;
  lookupFieldId: UUID | null;
}

export interface EntityHealthIndicatorItem  {
  __typename?: 'EntityHealthIndicatorItem';
  fieldId: UUID;
  indicator: EntityHealthIndicatorEnum;
  isCritical: boolean;
  lastChange: GqlDate | null;
  rule: EntityHealthFieldFilterRule;
  value: JSONString | null;
}

export interface EntityHealthIndicator  {
  __typename?: 'EntityHealthIndicator';
  id: ID;
  indicator: EntityHealthIndicatorEnum;
  rule: EntityHealthFieldFilterRule;
  value: JSONString | null;
}

export interface EntityHealthHistoryItem  {
  __typename?: 'EntityHealthHistoryItem';
  changes: EntityHealthHistoryChange[];
  date: GqlDate;
  score: number;
  trend: EntityHealthTrendEnum;
}

export interface EntityHealthHistoryChange  {
  __typename?: 'EntityHealthHistoryChange';
  fieldId: UUID | null;
  indicator: EntityHealthIndicatorEnum;
  ruleId: UUID;
  scoreDifference: number | null;
  value: JSONString | null;
}

export interface EntityHealthFilterBox extends FilterBoxInterface {
  __typename?: 'EntityHealthFilterBox';
  entity: string;
  filterFields: EntityHealthFieldFilterRule[];
  id: string;
  lookupFieldId: UUID | null;
  relation: HardCodedRelation | null;
}

export interface EntityHealthFieldFilterRule extends FilterFieldRuleInterface {
  __typename?: 'EntityHealthFieldFilterRule';
  description: string;
  field: string;
  id: UUID;
  operator: FieldOperator | null;
  score: number;
  values: string[][] | null;
}

export interface EntityHealthFieldConfiguration  {
  __typename?: 'EntityHealthFieldConfiguration';
  filterMainBox: EntityHealthMainFilterBox;
  filterSiblingBoxes: EntityHealthFilterBox[];
}

export interface EntityHealthEntityEdge  {
  __typename?: 'EntityHealthEntityEdge';
  cursor: string;
  node: EntityHealthEntity | null;
}

export interface EntityHealthEntityConnection  {
  __typename?: 'EntityHealthEntityConnection';
  edges: EntityHealthEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EntityHealthEntity  {
  __typename?: 'EntityHealthEntity';
  calculationProgress: number | null;
  created: DateTime | null;
  entityType: BaseEntityTypeEnum;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  lastRecalculation: DateTime | null;
  modified: DateTime | null;
  revision: number | null;
  settings: EntityHealthSettings;
  type: AccountTypeEntity | null;
  typeId: ID;
}

export interface EntityHealthCategoryItem  {
  __typename?: 'EntityHealthCategoryItem';
  categoryId: UUID;
  timeSpent: number;
}

export interface EntityHealthAnalysis  {
  __typename?: 'EntityHealthAnalysis';
  category: EntityHealthCategoryItem[];
  history: EntityHealthHistoryItem[];
  indicators: EntityHealthIndicatorItem[];
}

export interface EntityFitnessRepository  {
  __typename?: 'EntityFitnessRepository';
  getAll: EntityFitnessEntity[];
  getByCriteria: EntityFitnessEntityConnection | null;
  getByEntityType: EntityFitnessEntity;
  getById: EntityFitnessEntity | null;
  getByIds: EntityFitnessEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EntityFitnessIndicatorRepository  {
  __typename?: 'EntityFitnessIndicatorRepository';
  getAll: EntityFitnessIndicatorEntity[];
  getByCriteria: EntityFitnessIndicatorEntityConnection | null;
  getById: EntityFitnessIndicatorEntity | null;
  getByIds: EntityFitnessIndicatorEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EntityFitnessIndicatorEntityEdge  {
  __typename?: 'EntityFitnessIndicatorEntityEdge';
  cursor: string;
  node: EntityFitnessIndicatorEntity | null;
}

export interface EntityFitnessIndicatorEntityConnection  {
  __typename?: 'EntityFitnessIndicatorEntityConnection';
  edges: EntityFitnessIndicatorEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EntityFitnessIndicatorEntity  {
  __typename?: 'EntityFitnessIndicatorEntity';
  created: DateTime | null;
  description: string;
  descriptionUseLang: boolean;
  entityFitness: EntityFitnessEntity | null;
  entityFitnessId: ID;
  howToFix: string;
  howToFixUseLang: boolean;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  modified: DateTime | null;
  name: string;
  nameUseLang: boolean;
  revision: number | null;
  settings: FitnessIndicatorSettings;
  type: FitnessIndicatorTypeEnum;
}

export interface EntityFitnessEntityEdge  {
  __typename?: 'EntityFitnessEntityEdge';
  cursor: string;
  node: EntityFitnessEntity | null;
}

export interface EntityFitnessEntityConnection  {
  __typename?: 'EntityFitnessEntityConnection';
  edges: EntityFitnessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EntityFitnessEntity  {
  __typename?: 'EntityFitnessEntity';
  created: DateTime | null;
  entityType: BaseEntityTypeEnum;
  entityTypeId: UUID;
  id: ID;
  indicatorRelations: EntityFitnessIndicatorEntityConnection | null;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadType: LeadTypeEntity | null;
  leadTypeId: ID | null;
  modified: DateTime | null;
  opptyType: OpportunityTypeEntity | null;
  opptyTypeId: ID | null;
  revision: number | null;
}

export interface EntityEntityEdge  {
  __typename?: 'EntityEntityEdge';
  cursor: string;
  node: EntityEntity | null;
}

export interface EntityEntityConnection  {
  __typename?: 'EntityEntityConnection';
  edges: EntityEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EntityEntity  {
  __typename?: 'EntityEntity';
  abstractEntityId: ID;
  accessMode: number;
  allowsMultipleRelation: boolean | null;
  created: DateTime | null;
  defaultViewFieldId: ID;
  entityName: string | null;
  entityType: number;
  hasDraft: boolean;
  icon: number;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  namePlural: string | null;
  nameSingular: string | null;
  preferenceOrder: number;
  settings: JSONString | null;
  tableDataEx: string | null;
  tableEx: string | null;
  tableName: string | null;
}

export interface EntityDrilldownModel  {
  __typename?: 'EntityDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface EntityData  {
  __typename?: 'EntityData';
  entityApiName: string | null;
  entityTypeId: ID | null;
  id: UUID | null;
  isDeleted: boolean;
  name: string;
  pictureUrl: string | null;
  type: EntityNameEnum | null;
}

export interface EntityCustomNameSetting  {
  __typename?: 'EntityCustomNameSetting';
  entityName: EntityNameEnum | null;
  plural: EntityCustomName;
  singular: EntityCustomName;
}

export interface EntityCustomName  {
  __typename?: 'EntityCustomName';
  current: string | null;
  default: string;
  isDefault: boolean;
}

export interface EntityCount  {
  __typename?: 'EntityCount';
  count: number;
  entity: EntityNameEnum;
  entityApiName: string | null;
}

export interface EntityClassPermissionsListing  {
  __typename?: 'EntityClassPermissionsListing';
  account: EntityClassPermissions;
  accountDataExRelation: EntityClassPermissions;
  accountKPI: EntityClassPermissions;
  accountProductPricing: EntityClassPermissions;
  accountRole: EntityClassPermissions;
  accountSharingClientRelation: EntityClassPermissions;
  accountSharingSalesUnitRelation: EntityClassPermissions;
  accountSocialRelation: EntityClassPermissions;
  accountType: EntityClassPermissions;
  activity: EntityClassPermissions;
  activityComment: EntityClassPermissions;
  activityDataExRelation: EntityClassPermissions;
  activityKPI: EntityClassPermissions;
  activityRelation: EntityClassPermissions;
  activityType: EntityClassPermissions;
  allowedAccountType: EntityClassPermissions;
  allowedCompanyPhone: EntityClassPermissions;
  allowedContactType: EntityClassPermissions;
  allowedLeadType: EntityClassPermissions;
  allowedPipeline: EntityClassPermissions;
  allowedQuoteType: EntityClassPermissions;
  apiAccess: EntityClassPermissions;
  application: EntityClassPermissions;
  appointment: EntityClassPermissions;
  appointmentClientInviteesRelation: EntityClassPermissions;
  appointmentContactInviteesRelation: EntityClassPermissions;
  appointmentInviteeNotifyQueue: EntityClassPermissions;
  appointmentReminder: EntityClassPermissions;
  appointmentSchedule: EntityClassPermissions;
  appointmentType: EntityClassPermissions;
  approval: EntityClassPermissions;
  approvalApprover: EntityClassPermissions;
  approvalProcess: EntityClassPermissions;
  approvalProcessActivityLogLine: EntityClassPermissions;
  auditLog: EntityClassPermissions;
  chatConversation: EntityClassPermissions;
  client: EntityClassPermissions;
  clientExcludedOppty: EntityClassPermissions;
  clientFavorite: EntityClassPermissions;
  clientSetting: EntityClassPermissions;
  clientStoryRead: EntityClassPermissions;
  cloudObject: EntityClassPermissions;
  cloudObjectFolder: EntityClassPermissions;
  cloudObjectRelation: EntityClassPermissions;
  cloudObjectStepRelation: EntityClassPermissions;
  cloudObjectTemplate: EntityClassPermissions;
  companyEmail: EntityClassPermissions;
  contact: EntityClassPermissions;
  contactAccountAccountRoleRelation: EntityClassPermissions;
  contactAccountRelation: EntityClassPermissions;
  contactDataExRelation: EntityClassPermissions;
  contactKPI: EntityClassPermissions;
  contactRelation: EntityClassPermissions;
  contactRelationType: EntityClassPermissions;
  contactSharingClientRelation: EntityClassPermissions;
  contactSharingSalesUnitRelation: EntityClassPermissions;
  contactSocialRelation: EntityClassPermissions;
  contactType: EntityClassPermissions;
  currency: EntityClassPermissions;
  currencyExchangeRate: EntityClassPermissions;
  currencyExchangeRatesList: EntityClassPermissions;
  customEntity: EntityClassPermissions[];
  customEntityDataExRelation: EntityClassPermissions;
  customEntityKPI: EntityClassPermissions;
  customEntityRelation: EntityClassPermissions;
  customEntityRelationData: EntityClassPermissions;
  customEntitySharingClientRelation: EntityClassPermissions;
  customEntitySharingSalesUnitRelation: EntityClassPermissions;
  customEntityType: EntityClassPermissions;
  data: EntityClassPermissions;
  email: EntityClassPermissions;
  emailContentSharingClientRelation: EntityClassPermissions;
  emailContentSharingSalesUnitRelation: EntityClassPermissions;
  emailSequence: EntityClassPermissions;
  emailSequenceActivityLog: EntityClassPermissions;
  emailSequenceActivityLogLine: EntityClassPermissions;
  emailSequenceEnrolled: EntityClassPermissions;
  emailSequenceEnrolledStatus: EntityClassPermissions;
  emailSequenceSettings: EntityClassPermissions;
  emailTemplate: EntityClassPermissions;
  emailTemplateFolder: EntityClassPermissions;
  emailTemplateSharingClientRelation: EntityClassPermissions;
  emailTemplateSharingSalesUnitRelation: EntityClassPermissions;
  entity: EntityClassPermissions;
  entityFitness: EntityClassPermissions;
  entityFitnessIndicator: EntityClassPermissions;
  entityHealth: EntityClassPermissions;
  entityHealthSettingsHistory: EntityClassPermissions;
  entityScoring: EntityClassPermissions;
  entitySettings: EntityClassPermissions;
  entityType: EntityClassPermissions;
  field: EntityClassPermissions;
  fieldMapping: EntityClassPermissions;
  fieldPermission: EntityClassPermissions;
  fieldSequence: EntityClassPermissions;
  forecast: EntityClassPermissions;
  forecastSharingClientRelation: EntityClassPermissions;
  forecastSharingSalesUnitRelation: EntityClassPermissions;
  formView: EntityClassPermissions;
  formViewSharingClientRelation: EntityClassPermissions;
  formViewSharingSalesUnitRelation: EntityClassPermissions;
  ghostContact: EntityClassPermissions;
  ghostContactAccountAccountRoleRelation: EntityClassPermissions;
  ghostContactAccountRelation: EntityClassPermissions;
  ghostLeadOpptyContactRelation: EntityClassPermissions;
  ghostLeadOpptyContactSalesRoleRelation: EntityClassPermissions;
  importMappingMask: EntityClassPermissions;
  interfacePreview: EntityClassPermissions;
  lead: EntityClassPermissions;
  leadOppty: EntityClassPermissions;
  leadOpptyAccountRelation: EntityClassPermissions;
  leadOpptyContactGroupRelation: EntityClassPermissions;
  leadOpptyContactRelation: EntityClassPermissions;
  leadOpptyContactSalesRoleRelation: EntityClassPermissions;
  leadOpptyDataExRelation: EntityClassPermissions;
  leadOpptyKPI: EntityClassPermissions;
  leadOpptyProjectRelation: EntityClassPermissions;
  leadOpptySharingClientRelation: EntityClassPermissions;
  leadOpptySharingSalesUnitRelation: EntityClassPermissions;
  leadOpptyStepCheckListRelation: EntityClassPermissions;
  leadOpptyType: EntityClassPermissions;
  leadProcess: EntityClassPermissions;
  leadType: EntityClassPermissions;
  masterRight: EntityClassPermissions;
  media: EntityClassPermissions;
  memo: EntityClassPermissions;
  memoComment: EntityClassPermissions;
  message: EntityClassPermissions;
  messageRelation: EntityClassPermissions;
  messageSharingClientRelation: EntityClassPermissions;
  messageSharingSalesUnitRelation: EntityClassPermissions;
  note: EntityClassPermissions;
  onlineForm: EntityClassPermissions;
  onlineFormActivityLogLine: EntityClassPermissions;
  onlineFormDataExRelation: EntityClassPermissions;
  onlineFormRelation: EntityClassPermissions;
  onlineFormStyle: EntityClassPermissions;
  onlineFormType: EntityClassPermissions;
  onlineFormTypeEmailRelation: EntityClassPermissions;
  opportunity: EntityClassPermissions;
  opportunityType: EntityClassPermissions;
  opptyProductRelation: EntityClassPermissions;
  opptyProductRelationDataExRelation: EntityClassPermissions;
  opptyProductRelationRevenueSchedule: EntityClassPermissions;
  opptyProductRelationRevenueSchedulePeriod: EntityClassPermissions;
  opptyProductRelationType: EntityClassPermissions;
  opptyRecurrence: EntityClassPermissions;
  opptyRevenueSchedule: EntityClassPermissions;
  opptyRevenueSchedulePeriod: EntityClassPermissions;
  parentAccountRelationType: EntityClassPermissions;
  phone: EntityClassPermissions;
  pipeline: EntityClassPermissions;
  process: EntityClassPermissions;
  processActivityLog: EntityClassPermissions;
  processActivityLogLine: EntityClassPermissions;
  processChangeOwnerLog: EntityClassPermissions;
  processScheduledAction: EntityClassPermissions;
  processTemplate: EntityClassPermissions;
  product: EntityClassPermissions;
  productCategory: EntityClassPermissions;
  productDataExRelation: EntityClassPermissions;
  productPipelineRelation: EntityClassPermissions;
  productPriceList: EntityClassPermissions;
  productPriceListPrice: EntityClassPermissions;
  productType: EntityClassPermissions;
  profile: EntityClassPermissions;
  profileDraft: EntityClassPermissions;
  profileRelation: EntityClassPermissions;
  profileSharingClientRelation: EntityClassPermissions;
  profileSharingSalesUnitRelation: EntityClassPermissions;
  project: EntityClassPermissions;
  projectContactRelation: EntityClassPermissions;
  projectDataExRelation: EntityClassPermissions;
  projectKPI: EntityClassPermissions;
  projectObjective: EntityClassPermissions;
  projectSharingClientRelation: EntityClassPermissions;
  projectSharingSalesUnitRelation: EntityClassPermissions;
  projectType: EntityClassPermissions;
  quote: EntityClassPermissions;
  quoteAccountRelation: EntityClassPermissions;
  quoteContactRelation: EntityClassPermissions;
  quoteDataExRelation: EntityClassPermissions;
  quoteKPI: EntityClassPermissions;
  quoteProcess: EntityClassPermissions;
  quoteSharingClientRelation: EntityClassPermissions;
  quoteSharingSalesUnitRelation: EntityClassPermissions;
  quoteType: EntityClassPermissions;
  report: EntityClassPermissions;
  reportFolder: EntityClassPermissions;
  reportSchedule: EntityClassPermissions;
  reportSharingClientRelation: EntityClassPermissions;
  reportSharingSalesUnitRelation: EntityClassPermissions;
  revenueRecognition: EntityClassPermissions;
  salesRole: EntityClassPermissions;
  salesUnit: EntityClassPermissions;
  salesUnitClientRelation: EntityClassPermissions;
  spaceSetting: EntityClassPermissions;
  step: EntityClassPermissions;
  stepChecklist: EntityClassPermissions;
  stepChecklistSalesRoleRelation: EntityClassPermissions;
  subscriptionSDR: EntityClassPermissions;
  tag: EntityClassPermissions;
  tagRelation: EntityClassPermissions;
  target: EntityClassPermissions;
  targetRelation: EntityClassPermissions;
  task: EntityClassPermissions;
  taskRecurrence: EntityClassPermissions;
  taskReminder: EntityClassPermissions;
  taskSharingClientRelation: EntityClassPermissions;
  taskSharingSalesUnitRelation: EntityClassPermissions;
  taskType: EntityClassPermissions;
  teamPipelineHubItem: EntityClassPermissions;
  textMessage: EntityClassPermissions;
  textMessageConversation: EntityClassPermissions;
  textMessageConversationRelations: EntityClassPermissions;
  timeframe: EntityClassPermissions;
  translation: EntityClassPermissions;
  type: EntityClassPermissions;
  unsubscribedPhone: EntityClassPermissions;
  webhook: EntityClassPermissions;
  webhookEvent: EntityClassPermissions;
  webresource: EntityClassPermissions;
}

export interface EntityClassPermissions  {
  __typename?: 'EntityClassPermissions';
  allowedPermissions: EntityPermsEnum[];
  entity: EntityNameEnum;
  entityApiName: string | null;
  permissions: EntityPermsEnum[];
}

export interface EnableProcessPayload  {
  __typename?: 'EnableProcessPayload';
  clientMutationId: string | null;
}

export interface EnableOnlineFormTypePayload  {
  __typename?: 'EnableOnlineFormTypePayload';
  clientMutationId: string | null;
}

export interface EnableMessagingPhonePayload  {
  __typename?: 'EnableMessagingPhonePayload';
  phone: PhoneEntity | null;
}

export interface EnableEmailSequencePayload  {
  __typename?: 'EnableEmailSequencePayload';
  clientMutationId: string | null;
}

export interface EnableApprovalProcessPayload  {
  __typename?: 'EnableApprovalProcessPayload';
  clientMutationId: string | null;
}

export interface EmailTrackingEvent  {
  __typename?: 'EmailTrackingEvent';
  modified: DateTime;
  type: EmailTrackingEventTypeEnum;
  url: string | null;
}

export interface EmailTemplatesStatisticsFilter  {
  __typename?: 'EmailTemplatesStatisticsFilter';
  filterByFolders: string[] | null;
  filterByPeriod: PeriodOption;
  filterByTemplate: EmailTemplatesFilterEnum;
}

export interface EmailTemplateSharingUrlSettings  {
  __typename?: 'EmailTemplateSharingUrlSettings';
  personalizedEntityApiName: string | null;
  personalizedEntityRecordId: ID | null;
  personalizedEntityType: EntityNameEnum | null;
  url: string;
}

export interface EmailTemplateSharingSalesUnitRelationRepository  {
  __typename?: 'EmailTemplateSharingSalesUnitRelationRepository';
  getAll: EmailTemplateSharingSalesUnitRelationEntity[];
  getByCriteria: EmailTemplateSharingSalesUnitRelationEntityConnection | null;
  getById: EmailTemplateSharingSalesUnitRelationEntity | null;
  getByIds: EmailTemplateSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailTemplateSharingSalesUnitRelationEntityEdge  {
  __typename?: 'EmailTemplateSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: EmailTemplateSharingSalesUnitRelationEntity | null;
}

export interface EmailTemplateSharingSalesUnitRelationEntityConnection  {
  __typename?: 'EmailTemplateSharingSalesUnitRelationEntityConnection';
  edges: EmailTemplateSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailTemplateSharingSalesUnitRelationEntity  {
  __typename?: 'EmailTemplateSharingSalesUnitRelationEntity';
  created: DateTime | null;
  emailTemplate: EmailTemplateEntity | null;
  emailTemplateId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface EmailTemplateSharingClientRelationRepository  {
  __typename?: 'EmailTemplateSharingClientRelationRepository';
  getAll: EmailTemplateSharingClientRelationEntity[];
  getByCriteria: EmailTemplateSharingClientRelationEntityConnection | null;
  getById: EmailTemplateSharingClientRelationEntity | null;
  getByIds: EmailTemplateSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailTemplateSharingClientRelationEntityEdge  {
  __typename?: 'EmailTemplateSharingClientRelationEntityEdge';
  cursor: string;
  node: EmailTemplateSharingClientRelationEntity | null;
}

export interface EmailTemplateSharingClientRelationEntityConnection  {
  __typename?: 'EmailTemplateSharingClientRelationEntityConnection';
  edges: EmailTemplateSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailTemplateSharingClientRelationEntity  {
  __typename?: 'EmailTemplateSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  emailTemplate: EmailTemplateEntity | null;
  emailTemplateId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface EmailTemplateRepository  {
  __typename?: 'EmailTemplateRepository';
  convertWysiwygTemplateToHtml: string;
  getAffectedEmailSequences: AffectedProcessesProcessOutput[];
  getAffectedProcesses: AffectedProcessesProcessOutput[];
  getAll: EmailTemplateEntity[];
  getByCriteria: EmailTemplateEntityConnection | null;
  getById: EmailTemplateEntity | null;
  getByIds: EmailTemplateEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getStatusInEmailSequence: StatusInProcessOutput;
  getStatusInProcess: StatusInProcessOutput;
  previewPersonifiedRecords: EmailTemplatePersonificationResult;
  previewPersonifiedRecordsById: EmailTemplatePersonificationResult;
}

export interface EmailTemplatePersonificationResult  {
  __typename?: 'EmailTemplatePersonificationResult';
  disallowedFieldsIds: UUID[];
  missingFieldsIds: UUID[];
  missingRecordsIds: UUID[];
  results: EmailTemplateEntity[];
}

export interface EmailTemplateFolderRepository  {
  __typename?: 'EmailTemplateFolderRepository';
  getAll: EmailTemplateFolderEntity[];
  getByCriteria: EmailTemplateFolderEntityConnection | null;
  getById: EmailTemplateFolderEntity | null;
  getByIds: EmailTemplateFolderEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailTemplateFolderEntityEdge  {
  __typename?: 'EmailTemplateFolderEntityEdge';
  cursor: string;
  node: EmailTemplateFolderEntity | null;
}

export interface EmailTemplateFolderEntityConnection  {
  __typename?: 'EmailTemplateFolderEntityConnection';
  edges: EmailTemplateFolderEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailTemplateFolderEntity  {
  __typename?: 'EmailTemplateFolderEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  parentEmailTemplateFolder: EmailTemplateFolderEntity | null;
  parentEmailTemplateFolderId: ID | null;
  revision: number | null;
}

export interface EmailTemplateEntityEdge  {
  __typename?: 'EmailTemplateEntityEdge';
  cursor: string;
  node: EmailTemplateEntity | null;
}

export interface EmailTemplateEntityConnection  {
  __typename?: 'EmailTemplateEntityConnection';
  edges: EmailTemplateEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailTemplateEntity  {
  __typename?: 'EmailTemplateEntity';
  body: string | null;
  created: DateTime | null;
  documents: CloudObjectRelationEntityConnection | null;
  emailTemplateFolder: EmailTemplateFolderEntity | null;
  emailTemplateFolderId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  recentColors: number[] | null;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: EmailTemplateSharingClientRelationEntityConnection | null;
  sharingUnits: EmailTemplateSharingSalesUnitRelationEntityConnection | null;
  sharingUrlIsEnabled: boolean | null;
  sharingUrlSettings: EmailTemplateSharingUrlSettings | null;
  subject: string;
  trackingInfo: MassEmailTrackingInfo;
  type: EmailTemplateTypeEnum;
}

export interface EmailTableReportProfile extends EmailProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'EmailTableReportProfile';
  filter: EmailFilterTab;
  quickFilter: QuickFilterTab;
  role: EmailRoleTab;
  view: ViewTableReportTab;
}

export interface EmailService  {
  __typename?: 'EmailService';
  personalEmailAccountLimits: EmailAccountLimit | null;
}

export interface EmailSequencesNotificationSettings  {
  __typename?: 'EmailSequencesNotificationSettings';
  Errors: boolean;
  IsActive: boolean;
  Warnings: boolean;
}

export interface EmailSequenceTrigger  {
  __typename?: 'EmailSequenceTrigger';
  entityApiName: string | null;
  entityType: EntityNameEnum;
  fieldId: ID;
  relationLookupFieldId: ID | null;
}

export interface EmailSequenceStepStats extends EmailSequenceCountStats {
  __typename?: 'EmailSequenceStepStats';
  bounceCount: number;
  clickCount: number;
  conversion: number | null;
  createCount: number;
  emailTemplate: EmailTemplateEntity | null;
  openCount: number;
  replyCount: number;
  sentCount: number;
  step: EmailSequenceNodeImplementors;
  unsubscribeCount: number;
}

export interface EmailSequenceStats extends EmailSequenceCountStats {
  __typename?: 'EmailSequenceStats';
  bounceCount: number;
  bounceRecipientsCount: number;
  clickCount: number;
  clickRecipientsCount: number;
  createLeadCount: number;
  createLeadRecipientsCount: number;
  createTaskCount: number;
  createTaskRecipientsCount: number;
  createTextCount: number;
  createTextRecipientsCount: number;
  createdLeads: GenericDrilldownDataGridViewItems;
  createdTasks: GenericDrilldownDataGridViewItems;
  currentEnrollCount: number;
  enrollCount: number;
  notOpenCount: number;
  notOpenRecipientsCount: number;
  openCount: number;
  openRecipientsCount: number;
  recipients: GenericDrilldownDataGridViewItems | null;
  replyCount: number;
  replyRecipientsCount: number;
  sentCount: number;
  sentRecipientsCount: number;
  steps: EmailSequenceStepStats[];
  timeline: EmailSequencePeriodStats[];
  unenrollCount: number;
  unsubscribeCount: number;
}

export interface EmailSequenceSettings  {
  __typename?: 'EmailSequenceSettings';
  activeFrom: GqlDate | null;
  activeTo: GqlDate | null;
  autoUnenrollWhenExpired: boolean | null;
  dayOfWeek: number[];
  everyEmailStartsConversation: boolean;
  fromTimeOfDay: number;
  globalActions: EmailSequenceGlobalActionsSettings;
  timezone: string;
  toTimeOfDay: number;
  triggerProcess: boolean | null;
  triggerProcessId: UUID | null;
}

export interface EmailSequenceSendEmailNode extends EmailSequenceNode {
  __typename?: 'EmailSequenceSendEmailNode';
  condition: EmailSequenceNodeCondition;
  dayOffset: number;
  email: EmailSequenceNodeEmail;
  id: UUID;
}

export interface EmailSequenceSchema  {
  __typename?: 'EmailSequenceSchema';
  nodes: EmailSequenceNodeImplementors[];
  settings: EmailSequenceSettings;
  trigger: EmailSequenceTrigger;
}

export interface EmailSequenceRepository  {
  __typename?: 'EmailSequenceRepository';
  getAll: EmailSequenceEntity[];
  getByCriteria: EmailSequenceEntityConnection | null;
  getByEmailSequenceCriteria: EmailSequenceEntityConnection | null;
  getById: EmailSequenceEntity | null;
  getByIds: EmailSequenceEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getEmailSequencesForUnenroll: EmailSequenceEntity[];
}

export interface EmailSequencePeriodStats extends EmailSequenceCountStats {
  __typename?: 'EmailSequencePeriodStats';
  clickCount: number;
  createCount: number;
  date: GqlDate;
  enrollCount: number;
  openCount: number;
  replyCount: number;
  sentCount: number;
  unsubscribeCount: number;
}

export interface EmailSequenceNodeEmail extends EmailDataInterface {
  __typename?: 'EmailSequenceNodeEmail';
  attachments: UUID[];
  bcc: SendEmailRecipient[];
  body: string;
  cc: SendEmailRecipient[];
  emailTemplateId: UUID | null;
  isHtmlTemplate: boolean | null;
  linkRecipients: boolean | null;
  linkTriggerEntity: boolean | null;
  recipients: SendEmailRecipient[];
  sender: EmailSequenceNodeEmailSender;
  senderCompanyEmailId: UUID | null;
  shareMode: ShareModeEnum | null;
  signature: string | null;
  subject: string;
}

export interface EmailSequenceNodeCondition  {
  __typename?: 'EmailSequenceNodeCondition';
  action: EmailSequenceNodeConditionActionEnum;
  filter: EmailSequenceFilter;
}

export interface EmailSequenceGlobalActionsSettings  {
  __typename?: 'EmailSequenceGlobalActionsSettings';
  onBounce: boolean;
  onBounceUnenroll: boolean;
  onBounceUnsubscribe: boolean;
  onCondition: boolean;
  onConditionCreateEntity: boolean;
  onConditionEmail: EmailSequenceNodeEmail | null;
  onConditionEntity: ProcessEntityTemplate | null;
  onConditionFilter: EmailSequenceFilter;
  onConditionSendEmail: boolean;
  onConditionUnenroll: boolean;
  onReply: boolean;
  onReplyCreateEntity: boolean;
  onReplyEmail: EmailSequenceNodeEmail | null;
  onReplyEntity: ProcessEntityTemplate | null;
  onReplySendEmail: boolean;
  onReplyUnenroll: boolean;
  onUnsubscribe: boolean;
  onUnsubscribeCreateEntity: boolean;
  onUnsubscribeEntity: ProcessEntityTemplate | null;
}

export interface EmailSequenceFilter  {
  __typename?: 'EmailSequenceFilter';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  operator: FilterGroupOperator;
}

export interface EmailSequenceEntityEdge  {
  __typename?: 'EmailSequenceEntityEdge';
  cursor: string;
  node: EmailSequenceEntity | null;
}

export interface EmailSequenceEntityConnection  {
  __typename?: 'EmailSequenceEntityConnection';
  edges: EmailSequenceEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailSequenceEntity  {
  __typename?: 'EmailSequenceEntity';
  activityLogs: EmailSequenceActivityLogEntityConnection | null;
  bounceRate: number | null;
  clickRate: number | null;
  created: DateTime | null;
  createdCount: number;
  deactivationReason: EmailSequenceDeactivationReasonEnum | null;
  description: string | null;
  documents: CloudObjectRelationEntity[] | null;
  enrollCount: number;
  enrolled: EmailSequenceEnrolledEntityConnection | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean | null;
  lastEmailSequenceRun: DateTime | null;
  lastSchemaChange: DateTime | null;
  lastStatusChange: DateTime | null;
  modified: DateTime | null;
  name: string;
  openRate: number | null;
  owner: ClientEntity | null;
  ownerId: ID;
  replyRate: number | null;
  sentCount: number;
  settings: EmailSequenceSchema | null;
  stats: EmailSequenceStats;
  status: ProcessStatusEnum | null;
  stepCount: number | null;
  triggerEntityName: EntityNameEnum | null;
  triggerFieldId: UUID | null;
  type: ProcessTypeEnum;
  unsubscribeRate: number | null;
}

export interface EmailSequenceEnrolledRepository  {
  __typename?: 'EmailSequenceEnrolledRepository';
  getAll: EmailSequenceEnrolledEntity[];
  getByCriteria: EmailSequenceEnrolledEntityConnection | null;
  getById: EmailSequenceEnrolledEntity | null;
  getByIds: EmailSequenceEnrolledEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getEnrolledEmailSequences: EmailSequenceEnrolledEntity[];
}

export interface EmailSequenceEnrolledEntityEdge  {
  __typename?: 'EmailSequenceEnrolledEntityEdge';
  cursor: string;
  node: EmailSequenceEnrolledEntity | null;
}

export interface EmailSequenceEnrolledEntityConnection  {
  __typename?: 'EmailSequenceEnrolledEntityConnection';
  edges: EmailSequenceEnrolledEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailSequenceEnrolledEntity  {
  __typename?: 'EmailSequenceEnrolledEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  actor: ClientEntity | null;
  actorId: ID | null;
  address: string | null;
  application: ApplicationEntity | null;
  applicationId: ID;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  emailSequence: EmailSequenceEntity | null;
  emailSequenceActivityLog: EmailSequenceActivityLogEntity | null;
  emailSequenceActivityLogId: ID;
  emailSequenceId: ID;
  endReason: EmailSequenceEndReasonEnum | null;
  endTime: DateTime | null;
  entityId: ID;
  entityName: EntityNameEnum;
  entityType: BaseEntityTypeEnum;
  excludedFromStats: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadId: ID | null;
  modified: DateTime | null;
  name: string | null;
  oppty: OpportunityEntity | null;
  opptyId: ID | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  startTime: DateTime;
  status: ProcessStatusEnum | null;
  stepCount: number;
  stepIndex: number | null;
}

export interface EmailSequenceEnrollResult  {
  __typename?: 'EmailSequenceEnrollResult';
  enrolled: number;
  error: string | null;
  sessionId: UUID | null;
  skipped: number;
  unknownAddress: string[];
}

export interface EmailSequenceCreateRecordNode extends EmailSequenceNode {
  __typename?: 'EmailSequenceCreateRecordNode';
  condition: EmailSequenceNodeCondition;
  dayOffset: number;
  entity: ProcessEntityTemplate | null;
  entityType: EntityNameEnum;
  id: UUID;
}

export interface EmailSequenceActivityLogRepository  {
  __typename?: 'EmailSequenceActivityLogRepository';
  getAll: EmailSequenceActivityLogEntity[];
  getByCriteria: EmailSequenceActivityLogEntityConnection | null;
  getById: EmailSequenceActivityLogEntity | null;
  getByIds: EmailSequenceActivityLogEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getDownloadUrl: string;
}

export interface EmailSequenceActivityLogLineRepository  {
  __typename?: 'EmailSequenceActivityLogLineRepository';
  getAll: EmailSequenceActivityLogLineEntity[];
  getByCriteria: EmailSequenceActivityLogLineEntityConnection | null;
  getById: EmailSequenceActivityLogLineEntity | null;
  getByIds: EmailSequenceActivityLogLineEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailSequenceActivityLogLineEntityEdge  {
  __typename?: 'EmailSequenceActivityLogLineEntityEdge';
  cursor: string;
  node: EmailSequenceActivityLogLineEntity | null;
}

export interface EmailSequenceActivityLogLineEntityConnection  {
  __typename?: 'EmailSequenceActivityLogLineEntityConnection';
  edges: EmailSequenceActivityLogLineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailSequenceActivityLogLineEntity  {
  __typename?: 'EmailSequenceActivityLogLineEntity';
  created: DateTime | null;
  emailSequenceActivityLog: EmailSequenceActivityLogEntity | null;
  emailSequenceActivityLogId: ID;
  formattedText: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isVisible: boolean | null;
  modified: DateTime | null;
  sortOrder: number;
  status: ProcessStatusEnum | null;
}

export interface EmailSequenceActivityLogEntityEdge  {
  __typename?: 'EmailSequenceActivityLogEntityEdge';
  cursor: string;
  node: EmailSequenceActivityLogEntity | null;
}

export interface EmailSequenceActivityLogEntityConnection  {
  __typename?: 'EmailSequenceActivityLogEntityConnection';
  edges: EmailSequenceActivityLogEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailSequenceActivityLogEntity  {
  __typename?: 'EmailSequenceActivityLogEntity';
  actor: ClientEntity | null;
  actorId: ID | null;
  application: ApplicationEntity | null;
  applicationId: ID;
  created: DateTime | null;
  emailSequence: EmailSequenceEntity | null;
  emailSequenceId: ID;
  endTime: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isTestRun: boolean | null;
  lines: EmailSequenceActivityLogLineEntityConnection | null;
  modified: DateTime | null;
  recordEmail: string | null;
  recordName: string | null;
  startTime: DateTime;
  status: ProcessStatusEnum;
}

export interface EmailScheduleSettings  {
  __typename?: 'EmailScheduleSettings';
  bcc: SendEmailRecipient[];
  cc: SendEmailRecipient[];
  enrollEmailSequenceId: UUID | null;
  isHtmlTemplate: boolean;
  isLinkEntitiesEnabled: boolean;
  linkedItems: SendEmailLinkedEntity[];
  logEmailAsTask: SendEmailFollowupTaskSettings | null;
  logFollowUpTask: SendEmailFollowupTaskSettings | null;
  massMailWithLinkedRecords: boolean;
  personifyBy: PersonificationEntityData | null;
  primaryEntity: EntityNameEnum | null;
  recipients: SendEmailRecipient[];
  replyTo: string | null;
  sendToUnsubscribed: boolean;
  service: SendEmailService;
}

export interface EmailRoleTab extends RoleTabInterface {
  __typename?: 'EmailRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface EmailRepository  {
  __typename?: 'EmailRepository';
  checkForUnsubscribed: SendEmailRecipient[];
  getAll: EmailEntity[];
  getByCriteria: EmailEntityConnection | null;
  getById: EmailEntity | null;
  getByIds: EmailEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getLinkedItems: EmailLinkedItem[];
}

export interface EmailPivotReportProfile extends EmailProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'EmailPivotReportProfile';
  filter: EmailFilterTab;
  quickFilter: QuickFilterTab;
  role: EmailRoleTab;
  view: ViewPivotReportTab;
}

export interface EmailNotificationSettings  {
  __typename?: 'EmailNotificationSettings';
  Bounced: boolean | null;
  IsActive: boolean;
  LinkedItem: boolean | null;
  Tracking: boolean | null;
}

export interface EmailLinkedItem  {
  __typename?: 'EmailLinkedItem';
  entityApiName: string | null;
  entityType: EntityNameEnum;
  id: ID;
  isAvailable: boolean;
  isDeleted: boolean;
  isEditable: boolean;
  name: string | null;
}

export interface EmailFollowUpTask  {
  __typename?: 'EmailFollowUpTask';
  dueDate: GqlDate | null;
  dueDateOffset: number | null;
  taskTypeId: ID;
}

export interface EmailFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'EmailFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface EmailEventRepository  {
  __typename?: 'EmailEventRepository';
  getAll: EmailEventEntity[];
  getByCriteria: EmailEventEntity[];
  getById: EmailEventEntity | null;
  getByIds: EmailEventEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailEventEntity  {
  __typename?: 'EmailEventEntity';
  additionalData: JSONString | null;
  created: DateTime | null;
  email: EmailEntity | null;
  emailId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  type: EmailEventTypeEnum | null;
  url: string | null;
}

export interface EmailEntityEdge  {
  __typename?: 'EmailEntityEdge';
  cursor: string;
  node: EmailEntity | null;
}

export interface EmailEntityConnection  {
  __typename?: 'EmailEntityConnection';
  edges: EmailEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailEntity  {
  __typename?: 'EmailEntity';
  accountRelations: MessageRelationEntityConnection | null;
  additionalHeaders: JSONString | null;
  body: string;
  bodySummary: string;
  canChangeConversationContentShareMode: boolean;
  cc: string | null;
  companyEmail: CompanyEmailEntity | null;
  companyEmailId: ID | null;
  contactRelations: MessageRelationEntityConnection | null;
  contentShareMode: ContentShareModeEnum | null;
  contentSharingClients: EmailContentSharingClientRelationEntityConnection | null;
  contentSharingUnits: EmailContentSharingSalesUnitRelationEntityConnection | null;
  contentType: string | null;
  conversationItems: EmailConversationItemConnection | null;
  conversationSubject: string | null;
  created: DateTime | null;
  customEntityRelations: MessageRelationEntityConnection | null;
  dateSent: DateTime | null;
  direction: EmailDirectionEnum;
  documents: CloudObjectRelationEntityConnection | null;
  errorCode: number | null;
  forwardBody: string;
  hasAnyAttachment: boolean;
  hasTrackingEvent: boolean;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isContentAvailable: boolean;
  isConversationSubjectAvailable: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isTracked: boolean | null;
  leadRelations: MessageRelationEntityConnection | null;
  massEmailRelations: MassEmailRelationItemConnection | null;
  massTrackingInfo: MassEmailTrackingInfo;
  modified: DateTime | null;
  newestReadableConversationItem: EmailEntity | null;
  oldestConversationItem: EmailEntity | null;
  opportunityRelations: MessageRelationEntityConnection | null;
  originalId: string | null;
  owner: ClientEntity | null;
  ownerId: ID | null;
  parentEmail: EmailEntity | null;
  parentEmailId: ID | null;
  projectRelations: MessageRelationEntityConnection | null;
  quoteRelations: MessageRelationEntityConnection | null;
  replyBody: string;
  revision: number | null;
  scheduleSettings: EmailScheduleSettings | null;
  sendAt: DateTime | null;
  sender: string | null;
  senderAccount: AccountEntity | null;
  senderAccountId: ID | null;
  senderClient: ClientEntity | null;
  senderClientId: ID | null;
  senderContact: ContactEntity | null;
  senderContactId: ID | null;
  sentiment: EmailSentimentEnum | null;
  shareMode: ShareModeEnum | null;
  sharingClients: MessageSharingClientRelationEntityConnection | null;
  sharingUnits: MessageSharingSalesUnitRelationEntityConnection | null;
  subject: string;
  tableName: string;
  tags: TagRelationEntityConnection | null;
  template: EmailTemplateEntity | null;
  templateId: ID | null;
  threadId: ID | null;
  to: string | null;
  trackingHistory: EmailTrackingEvent[];
  type: EmailTypeEnum | null;
  uid: string;
  wasBounced: boolean;
}

export interface EmailDrilldownFilter  {
  __typename?: 'EmailDrilldownFilter';
  ownerId: ID[] | null;
}

export interface EmailConversationItemEdge  {
  __typename?: 'EmailConversationItemEdge';
  cursor: string;
  node: EmailEntity | null;
}

export interface EmailConversationItemConnection  {
  __typename?: 'EmailConversationItemConnection';
  edges: EmailConversationItemEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface EmailContentSharingSalesUnitRelationRepository  {
  __typename?: 'EmailContentSharingSalesUnitRelationRepository';
  getAll: EmailContentSharingSalesUnitRelationEntity[];
  getByCriteria: EmailContentSharingSalesUnitRelationEntityConnection | null;
  getById: EmailContentSharingSalesUnitRelationEntity | null;
  getByIds: EmailContentSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailContentSharingSalesUnitRelationEntityEdge  {
  __typename?: 'EmailContentSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: EmailContentSharingSalesUnitRelationEntity | null;
}

export interface EmailContentSharingSalesUnitRelationEntityConnection  {
  __typename?: 'EmailContentSharingSalesUnitRelationEntityConnection';
  edges: EmailContentSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailContentSharingSalesUnitRelationEntity  {
  __typename?: 'EmailContentSharingSalesUnitRelationEntity';
  created: DateTime | null;
  email: EmailEntity | null;
  emailId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface EmailContentSharingClientRelationRepository  {
  __typename?: 'EmailContentSharingClientRelationRepository';
  getAll: EmailContentSharingClientRelationEntity[];
  getByCriteria: EmailContentSharingClientRelationEntityConnection | null;
  getById: EmailContentSharingClientRelationEntity | null;
  getByIds: EmailContentSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface EmailContentSharingClientRelationEntityEdge  {
  __typename?: 'EmailContentSharingClientRelationEntityEdge';
  cursor: string;
  node: EmailContentSharingClientRelationEntity | null;
}

export interface EmailContentSharingClientRelationEntityConnection  {
  __typename?: 'EmailContentSharingClientRelationEntityConnection';
  edges: EmailContentSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EmailContentSharingClientRelationEntity  {
  __typename?: 'EmailContentSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  email: EmailEntity | null;
  emailId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface EmailConfField  {
  __typename?: 'EmailConfField';
  brand: ImapLoginTypeEnum;
  isUsingOauth: boolean | null;
  password: string | null;
  port: number | null;
  server: string | null;
  ssl: boolean | null;
  username: string;
}

export interface EmailAccountLimit  {
  __typename?: 'EmailAccountLimit';
  messagesPerDay: number;
  sentMessages: number;
}

export interface EditFilledCloudObjectResult  {
  __typename?: 'EditFilledCloudObjectResult';
  error: string | null;
  previewUrl: string | null;
  resultUrl: string | null;
}

export interface EbookRepository  {
  __typename?: 'EbookRepository';
  getAll: EbookEntity[];
  getByCriteria: EbookEntityConnection | null;
  getById: EbookEntity | null;
  getByIds: EbookEntity[];
}

export interface EbookEntityEdge  {
  __typename?: 'EbookEntityEdge';
  cursor: string;
  node: EbookEntity | null;
}

export interface EbookEntityConnection  {
  __typename?: 'EbookEntityConnection';
  edges: EbookEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface EbookEntity  {
  __typename?: 'EbookEntity';
  category: string | null;
  created: DateTime | null;
  description: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: EbookPermsEnum[];
  previewImageUrl: string | null;
  sortOrder: number | null;
  sourceType: EbookSourceTypeEnum | null;
  sourceUrl: string | null;
  title: string | null;
  uniqueViewCount: number | null;
  viewCount: number | null;
}

export interface DuplicatesListingGridViewItems  {
  __typename?: 'DuplicatesListingGridViewItems';
  actualTotal: number;
  groups: GroupInfo[];
  items: DataGridViewItem[];
  sessionId: ID;
  total: number;
}

export interface DuplicateMediaRecordingMp3Payload  {
  __typename?: 'DuplicateMediaRecordingMp3Payload';
  clientMutationId: string | null;
  result: CloudObjectEntity;
}

export interface DuplicateCheckerSettings  {
  __typename?: 'DuplicateCheckerSettings';
  fieldIds: ID[];
  isEnabled: boolean;
  masterRecordResolution: MasterRecordResolutionEnum;
  masterRecordResolutionCustomConditions: FieldFilter | null;
  matchSimilarityLevel: MatchSimilarityLevelEnum;
}

export interface DuplicateCheckerMatchSettings  {
  __typename?: 'DuplicateCheckerMatchSettings';
  entity: EntityNameEnum | null;
  entityApiName: string | null;
  filter: FieldFilter | null;
  masterRecordResolution: MasterRecordResolutionEnum | null;
  masterRecordResolutionCustomConditions: FieldFilter | null;
  matchSimilarityLevel: MatchSimilarityLevelEnum | null;
}

export interface DuplicateCheckerManualMergeFields  {
  __typename?: 'DuplicateCheckerManualMergeFields';
  entity: EntityNameEnum | null;
  entityApiName: string | null;
  fieldIds: UUID[];
}

export interface DuplicateCheckerItem  {
  __typename?: 'DuplicateCheckerItem';
  fields: string[];
  id: UUID;
  name: string | null;
}

export interface DuplicateCheckerEntitySettings  {
  __typename?: 'DuplicateCheckerEntitySettings';
  entity: EntityNameEnum;
  entityApiName: string | null;
  settings: DuplicateCheckerSettings;
}

export interface DuplicateCheckerCountResult  {
  __typename?: 'DuplicateCheckerCountResult';
  count: number;
  progress: QuickMergeProgress | null;
}

export interface DueDateProperty  {
  __typename?: 'DueDateProperty';
  isRecurrenceEnabled: boolean;
}

export interface DropboxSettingsOutput  {
  __typename?: 'DropboxSettingsOutput';
  dropboxAccessToken: string | null;
}

export interface DropboxBusiness  {
  __typename?: 'DropboxBusiness';
  getAuthUrl: AuthUrlResult | null;
  getFileUrl: FileUrlResult | null;
  getIsTeamUser: boolean | null;
  getLogoutUrl: AuthUrlResult | null;
  getToken: TokenResult | null;
  listFolder: RemoteStorageFileListResultConnection | null;
  refreshToken: TokenResult | null;
}

export interface DrilldownModel  {
  __typename?: 'DrilldownModel';
  listViewItems: OpportunityDrilldownDataGridViewItems;
}

export interface DomainExtractorTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'DomainExtractorTeamPipelineHubItemEntity';
  configuration: DomainExtractorHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface DomainExtractorHubItemConfig  {
  __typename?: 'DomainExtractorHubItemConfig';
  excludedDomains: string[];
}

export interface DocumentPreviewUrl  {
  __typename?: 'DocumentPreviewUrl';
  error: string | null;
  url: string | null;
}

export interface DocumentNotificationEntity extends NotificationTargetEntityInterface {
  __typename?: 'DocumentNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
  type: CloudObjectTypeEnum;
  url: string;
}

export interface DocumentManagementScreen  {
  __typename?: 'DocumentManagementScreen';
  companyDocuments: CompanyDocumentsDataGridViewItems;
  recordDocuments: RecordDocumentsDataGridViewItems;
}

export interface DocumentDataGridViewItem extends ViewItemInterface {
  __typename?: 'DocumentDataGridViewItem';
  data: FieldDataContainer[];
  id: ID;
  isFolder: boolean;
  isFolderEmpty: boolean | null;
}

export interface DisplayFieldItem  {
  __typename?: 'DisplayFieldItem';
  columnAlignment: ColumnAlignment | null;
  columnColor: number | null;
  columnFormatting: ColumnFormatting | null;
  columnWidth: number | null;
  displayOptions: DisplayOption | null;
  fieldId: ID;
}

export interface DisableProcessPayload  {
  __typename?: 'DisableProcessPayload';
  clientMutationId: string | null;
}

export interface DisableOnlineFormTypePayload  {
  __typename?: 'DisableOnlineFormTypePayload';
  clientMutationId: string | null;
}

export interface DisableMessagingPhonePayload  {
  __typename?: 'DisableMessagingPhonePayload';
  phone: PhoneEntity | null;
}

export interface DisableEmailSequencePayload  {
  __typename?: 'DisableEmailSequencePayload';
  clientMutationId: string | null;
}

export interface DisableApprovalProcessPayload  {
  __typename?: 'DisableApprovalProcessPayload';
  clientMutationId: string | null;
}

export interface DetailTabs  {
  __typename?: 'DetailTabs';
  account: AccountTabDataGridView;
  activity: ActivityDetailTabs;
  audit: boolean | null;
  buyingCenter: boolean | null;
  contact: ContactTabDataGridView;
  document: CloudObjectTabDataGridView;
  feed: FeedTabDataGridView;
  feedEmail: FeedEmailTabDataGridView;
  lead: LeadTabDataGridView;
  lookupData: LookUpTabDataGridView;
  note: NoteTabDataGridView;
  opportunity: OpportunityTabDataGridView;
  organizationChart: boolean | null;
  product: ProductDetailTabs;
  productCategory: ProductCategoryDetailTabs;
  productPricing: ProductPricingDetailTabs;
  project: ProjectTabDataGridView;
  quote: QuoteTabDataGridView;
}

export interface DetailFeedActiveScreenType  {
  __typename?: 'DetailFeedActiveScreenType';
  entity: EntityNameEnum;
  entityApiName: string | null;
  screenType: ScreenTypeEnum;
}

export interface DetailFeedActiveProfile  {
  __typename?: 'DetailFeedActiveProfile';
  entity: EntityNameEnum;
  entityApiName: string | null;
  profileId: UUID;
}

export interface DeleteZoomMeetingPayload  {
  __typename?: 'DeleteZoomMeetingPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface DeleteWebresourcePayload  {
  __typename?: 'DeleteWebresourcePayload';
  clientMutationId: string | null;
  webresource: WebresourceEntity | null;
}

export interface DeleteWebhookPayload  {
  __typename?: 'DeleteWebhookPayload';
  clientMutationId: string | null;
  webhook: WebhookEntity | null;
}

export interface DeleteWebhookEventPayload  {
  __typename?: 'DeleteWebhookEventPayload';
  clientMutationId: string | null;
  webhookEvent: WebhookEventEntity | null;
}

export interface DeleteUnsubscribedPhonePayload  {
  __typename?: 'DeleteUnsubscribedPhonePayload';
  clientMutationId: string | null;
  unsubscribedPhone: UnsubscribedPhoneEntity | null;
}

export interface DeleteTranslationPayload  {
  __typename?: 'DeleteTranslationPayload';
  clientMutationId: string | null;
  translation: TranslationEntity | null;
}

export interface DeleteTimeframePayload  {
  __typename?: 'DeleteTimeframePayload';
  clientMutationId: string | null;
  timeframe: TimeframeEntity | null;
}

export interface DeleteTextMessageConversationRelationsPayload  {
  __typename?: 'DeleteTextMessageConversationRelationsPayload';
  clientMutationId: string | null;
  textMessageConversationRelations: TextMessageConversationRelationsEntity | null;
}

export interface DeleteTaskTypePayload  {
  __typename?: 'DeleteTaskTypePayload';
  clientMutationId: string | null;
  taskType: TaskTypeEntity | null;
}

export interface DeleteTaskSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteTaskSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  taskSharingSalesUnitRelation: TaskSharingSalesUnitRelationEntity | null;
}

export interface DeleteTaskSharingClientRelationPayload  {
  __typename?: 'DeleteTaskSharingClientRelationPayload';
  clientMutationId: string | null;
  taskSharingClientRelation: TaskSharingClientRelationEntity | null;
}

export interface DeleteTaskReminderPayload  {
  __typename?: 'DeleteTaskReminderPayload';
  clientMutationId: string | null;
  taskReminder: TaskReminderEntity | null;
}

export interface DeleteTaskRecurrencePayload  {
  __typename?: 'DeleteTaskRecurrencePayload';
  clientMutationId: string | null;
  taskRecurrence: TaskRecurrenceEntity | null;
}

export interface DeleteTaskPayload  {
  __typename?: 'DeleteTaskPayload';
  clientMutationId: string | null;
  task: TaskEntity | null;
}

export interface DeleteTargetRelationPayload  {
  __typename?: 'DeleteTargetRelationPayload';
  clientMutationId: string | null;
  targetRelation: TargetRelationEntity | null;
}

export interface DeleteTargetPayload  {
  __typename?: 'DeleteTargetPayload';
  clientMutationId: string | null;
  target: TargetEntity | null;
}

export interface DeleteTagRelationPayload  {
  __typename?: 'DeleteTagRelationPayload';
  clientMutationId: string | null;
  tagRelation: TagRelationEntity | null;
}

export interface DeleteTagPayload  {
  __typename?: 'DeleteTagPayload';
  clientMutationId: string | null;
  tag: TagEntity | null;
}

export interface DeleteStepChecklistSalesRoleRelationPayload  {
  __typename?: 'DeleteStepChecklistSalesRoleRelationPayload';
  clientMutationId: string | null;
  stepChecklistSalesRoleRelation: StepChecklistSalesRoleRelationEntity | null;
}

export interface DeleteStepChecklistPayload  {
  __typename?: 'DeleteStepChecklistPayload';
  clientMutationId: string | null;
  stepChecklist: StepChecklistEntity | null;
}

export interface DeleteSalesUnitPayload  {
  __typename?: 'DeleteSalesUnitPayload';
  clientMutationId: string | null;
  salesUnit: SalesUnitEntity | null;
}

export interface DeleteSalesRolePayload  {
  __typename?: 'DeleteSalesRolePayload';
  clientMutationId: string | null;
  salesRole: SalesRoleEntity | null;
}

export interface DeleteReportSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteReportSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  reportSharingSalesUnitRelation: ReportSharingSalesUnitRelationEntity | null;
}

export interface DeleteReportSharingClientRelationPayload  {
  __typename?: 'DeleteReportSharingClientRelationPayload';
  clientMutationId: string | null;
  reportSharingClientRelation: ReportSharingClientRelationEntity | null;
}

export interface DeleteReportSchedulePayload  {
  __typename?: 'DeleteReportSchedulePayload';
  clientMutationId: string | null;
  reportSchedule: ReportScheduleEntity | null;
}

export interface DeleteReportPayload  {
  __typename?: 'DeleteReportPayload';
  clientMutationId: string | null;
  report: ReportEntity | null;
}

export interface DeleteReportFolderPayload  {
  __typename?: 'DeleteReportFolderPayload';
  clientMutationId: string | null;
  errors: boolean;
  reportFolder: ReportFolderEntity;
}

export interface DeleteQuoteTypePayload  {
  __typename?: 'DeleteQuoteTypePayload';
  clientMutationId: string | null;
  quoteType: QuoteTypeEntity | null;
}

export interface DeleteQuoteSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteQuoteSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  quoteSharingSalesUnitRelation: QuoteSharingSalesUnitRelationEntity | null;
}

export interface DeleteQuoteSharingClientRelationPayload  {
  __typename?: 'DeleteQuoteSharingClientRelationPayload';
  clientMutationId: string | null;
  quoteSharingClientRelation: QuoteSharingClientRelationEntity | null;
}

export interface DeleteQuoteProcessPayload  {
  __typename?: 'DeleteQuoteProcessPayload';
  clientMutationId: string | null;
  quoteProcess: QuoteProcessEntity | null;
}

export interface DeleteQuotePayload  {
  __typename?: 'DeleteQuotePayload';
  clientMutationId: string | null;
  quote: QuoteEntity | null;
}

export interface DeleteQuoteKPIPayload  {
  __typename?: 'DeleteQuoteKPIPayload';
  clientMutationId: string | null;
  quoteKpi: QuoteKPIEntity | null;
}

export interface DeleteQuoteDataExRelationPayload  {
  __typename?: 'DeleteQuoteDataExRelationPayload';
  clientMutationId: string | null;
  quoteDataExRelation: QuoteDataExRelationEntity | null;
}

export interface DeleteQuoteContactRelationPayload  {
  __typename?: 'DeleteQuoteContactRelationPayload';
  clientMutationId: string | null;
  quoteContactRelation: QuoteContactRelationEntity | null;
}

export interface DeleteQuoteAccountRelationPayload  {
  __typename?: 'DeleteQuoteAccountRelationPayload';
  clientMutationId: string | null;
  quoteAccountRelation: QuoteAccountRelationEntity | null;
}

export interface DeleteProjectTypePayload  {
  __typename?: 'DeleteProjectTypePayload';
  clientMutationId: string | null;
  projectType: ProjectTypeEntity | null;
}

export interface DeleteProjectSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteProjectSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  projectSharingSalesUnitRelation: ProjectSharingSalesUnitRelationEntity | null;
}

export interface DeleteProjectSharingClientRelationPayload  {
  __typename?: 'DeleteProjectSharingClientRelationPayload';
  clientMutationId: string | null;
  projectSharingClientRelation: ProjectSharingClientRelationEntity | null;
}

export interface DeleteProjectPayload  {
  __typename?: 'DeleteProjectPayload';
  clientMutationId: string | null;
  project: ProjectEntity | null;
}

export interface DeleteProjectObjectivePayload  {
  __typename?: 'DeleteProjectObjectivePayload';
  clientMutationId: string | null;
  result: ProjectObjectiveEntity | null;
}

export interface DeleteProjectKPIPayload  {
  __typename?: 'DeleteProjectKPIPayload';
  clientMutationId: string | null;
  projectKpi: ProjectKPIEntity | null;
}

export interface DeleteProjectContactRelationPayload  {
  __typename?: 'DeleteProjectContactRelationPayload';
  clientMutationId: string | null;
  projectContactRelation: ProjectContactRelationEntity | null;
}

export interface DeleteProfileSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteProfileSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  profileSharingSalesUnitRelation: ProfileSharingSalesUnitRelationEntity | null;
}

export interface DeleteProfileSharingClientRelationPayload  {
  __typename?: 'DeleteProfileSharingClientRelationPayload';
  clientMutationId: string | null;
  profileSharingClientRelation: ProfileSharingClientRelationEntity | null;
}

export interface DeleteProfileRelationPayload  {
  __typename?: 'DeleteProfileRelationPayload';
  clientMutationId: string | null;
  profileRelation: ProfileRelationEntity | null;
}

export interface DeleteProfilePayload  {
  __typename?: 'DeleteProfilePayload';
  clientMutationId: string | null;
}

export interface DeleteProductTypePayload  {
  __typename?: 'DeleteProductTypePayload';
  clientMutationId: string | null;
  productType: ProductTypeEntity | null;
}

export interface DeleteProductPriceListPricePayload  {
  __typename?: 'DeleteProductPriceListPricePayload';
  clientMutationId: string | null;
  productPriceListPrice: ProductPriceListPriceEntity | null;
}

export interface DeleteProductPriceListPayload  {
  __typename?: 'DeleteProductPriceListPayload';
  clientMutationId: string | null;
  productPriceList: ProductPriceListEntity | null;
}

export interface DeleteProductPipelineRelationPayload  {
  __typename?: 'DeleteProductPipelineRelationPayload';
  clientMutationId: string | null;
  productPipelineRelation: ProductPipelineRelationEntity | null;
}

export interface DeleteProductPayload  {
  __typename?: 'DeleteProductPayload';
  clientMutationId: string | null;
  product: ProductEntity | null;
}

export interface DeleteProductCategoryPayload  {
  __typename?: 'DeleteProductCategoryPayload';
  clientMutationId: string | null;
  productCategory: ProductCategoryEntity | null;
}

export interface DeleteProcessTemplatePayload  {
  __typename?: 'DeleteProcessTemplatePayload';
  clientMutationId: string | null;
  processTemplate: ProcessTemplateEntity | null;
}

export interface DeleteProcessPayload  {
  __typename?: 'DeleteProcessPayload';
  clientMutationId: string | null;
  process: ProcessEntity | null;
}

export interface DeleteProcessActivityLogPayload  {
  __typename?: 'DeleteProcessActivityLogPayload';
  clientMutationId: string | null;
  processActivityLog: ProcessActivityLogEntity | null;
}

export interface DeleteProcessActivityLogLinePayload  {
  __typename?: 'DeleteProcessActivityLogLinePayload';
  clientMutationId: string | null;
  processActivityLogLine: ProcessActivityLogLineEntity | null;
}

export interface DeletePipelinePayload  {
  __typename?: 'DeletePipelinePayload';
  clientMutationId: string | null;
  pipeline: PipelineEntity | null;
}

export interface DeletePhonePayload  {
  __typename?: 'DeletePhonePayload';
  clientMutationId: string | null;
  phone: PhoneEntity | null;
}

export interface DeletePhoneNumberTeamSpaceClientSettingPayload  {
  __typename?: 'DeletePhoneNumberTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface DeleteParentAccountRelationTypePayload  {
  __typename?: 'DeleteParentAccountRelationTypePayload';
  clientMutationId: string | null;
  parentAccountRelationType: ParentAccountRelationTypeEntity | null;
}

export interface DeleteOpptyRecurrencePayload  {
  __typename?: 'DeleteOpptyRecurrencePayload';
  clientMutationId: string | null;
  opptyRecurrence: OpptyRecurrenceEntity | null;
}

export interface DeleteOpptyProductRelationTypePayload  {
  __typename?: 'DeleteOpptyProductRelationTypePayload';
  clientMutationId: string | null;
  opptyProductRelationType: OpptyProductRelationTypeEntity | null;
}

export interface DeleteOpptyProductRelationPayload  {
  __typename?: 'DeleteOpptyProductRelationPayload';
  clientMutationId: string | null;
  opptyProductRelation: OpptyProductRelationEntity | null;
}

export interface DeleteOpptyProductRelationDataExRelationPayload  {
  __typename?: 'DeleteOpptyProductRelationDataExRelationPayload';
  clientMutationId: string | null;
  opptyProductRelationDataExRelation: OpptyProductRelationDataExRelationEntity | null;
}

export interface DeleteOpportunityTypePayload  {
  __typename?: 'DeleteOpportunityTypePayload';
  clientMutationId: string | null;
  opportunityType: OpportunityTypeEntity | null;
}

export interface DeleteOpportunityPayload  {
  __typename?: 'DeleteOpportunityPayload';
  clientMutationId: string | null;
  opportunity: OpportunityEntity | null;
}

export interface DeleteOnlineFormTypePayload  {
  __typename?: 'DeleteOnlineFormTypePayload';
  clientMutationId: string | null;
  onlineFormType: OnlineFormTypeEntity | null;
}

export interface DeleteOnlineFormTypeEmailRelationPayload  {
  __typename?: 'DeleteOnlineFormTypeEmailRelationPayload';
  clientMutationId: string | null;
  onlineFormTypeEmailRelation: OnlineFormTypeEmailRelationEntity | null;
}

export interface DeleteOnlineFormStylePayload  {
  __typename?: 'DeleteOnlineFormStylePayload';
  clientMutationId: string | null;
  onlineFormStyle: OnlineFormStyleEntity | null;
}

export interface DeleteOnlineFormRelationPayload  {
  __typename?: 'DeleteOnlineFormRelationPayload';
  clientMutationId: string | null;
  onlineFormRelation: OnlineFormRelationEntity | null;
}

export interface DeleteOnlineFormPayload  {
  __typename?: 'DeleteOnlineFormPayload';
  clientMutationId: string | null;
  onlineForm: OnlineFormEntity | null;
}

export interface DeleteOnlineFormDataExRelationPayload  {
  __typename?: 'DeleteOnlineFormDataExRelationPayload';
  clientMutationId: string | null;
  onlineFormDataExRelation: OnlineFormDataExRelationEntity | null;
}

export interface DeleteOnlineFormActivityLogLinePayload  {
  __typename?: 'DeleteOnlineFormActivityLogLinePayload';
  clientMutationId: string | null;
  onlineFormActivityLogLine: OnlineFormActivityLogLineEntity | null;
}

export interface DeleteNotePayload  {
  __typename?: 'DeleteNotePayload';
  clientMutationId: string | null;
  note: NoteEntity | null;
}

export interface DeleteMessagingPhonePayload  {
  __typename?: 'DeleteMessagingPhonePayload';
  clientMutationId: string | null;
  phone: PhoneEntity | null;
}

export interface DeleteMessageSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteMessageSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  messageSharingSalesUnitRelation: MessageSharingSalesUnitRelationEntity | null;
}

export interface DeleteMessageSharingClientRelationPayload  {
  __typename?: 'DeleteMessageSharingClientRelationPayload';
  clientMutationId: string | null;
  messageSharingClientRelation: MessageSharingClientRelationEntity | null;
}

export interface DeleteMessageRelationPayload  {
  __typename?: 'DeleteMessageRelationPayload';
  clientMutationId: string | null;
  messageRelation: MessageRelationEntity | null;
}

export interface DeleteMemoPayload  {
  __typename?: 'DeleteMemoPayload';
  clientMutationId: string | null;
  memo: MemoEntity | null;
}

export interface DeleteMemoCommentPayload  {
  __typename?: 'DeleteMemoCommentPayload';
  clientMutationId: string | null;
  memoComment: MemoCommentEntity | null;
}

export interface DeleteMeetingAppointmentPayload  {
  __typename?: 'DeleteMeetingAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface DeleteMediaPayload  {
  __typename?: 'DeleteMediaPayload';
  clientMutationId: string | null;
  media: MediaEntity | null;
}

export interface DeleteMasterRightPayload  {
  __typename?: 'DeleteMasterRightPayload';
  clientMutationId: string | null;
  masterRight: MasterRightEntity | null;
}

export interface DeleteLeadTypePayload  {
  __typename?: 'DeleteLeadTypePayload';
  clientMutationId: string | null;
  leadType: LeadTypeEntity | null;
}

export interface DeleteLeadProcessPayload  {
  __typename?: 'DeleteLeadProcessPayload';
  clientMutationId: string | null;
  leadProcess: LeadProcessEntity | null;
}

export interface DeleteLeadPayload  {
  __typename?: 'DeleteLeadPayload';
  clientMutationId: string | null;
  lead: LeadEntity | null;
}

export interface DeleteLeadOpptyStepCheckListRelationPayload  {
  __typename?: 'DeleteLeadOpptyStepCheckListRelationPayload';
  clientMutationId: string | null;
  leadOpptyStepCheckListRelation: LeadOpptyStepCheckListRelationEntity | null;
}

export interface DeleteLeadOpptySharingSalesUnitRelationPayload  {
  __typename?: 'DeleteLeadOpptySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingSalesUnitRelation: LeadOpptySharingSalesUnitRelationEntity | null;
}

export interface DeleteLeadOpptySharingClientRelationPayload  {
  __typename?: 'DeleteLeadOpptySharingClientRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingClientRelation: LeadOpptySharingClientRelationEntity | null;
}

export interface DeleteLeadOpptyKPIPayload  {
  __typename?: 'DeleteLeadOpptyKPIPayload';
  clientMutationId: string | null;
  leadOpptyKpi: LeadOpptyKPIEntity | null;
}

export interface DeleteLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'DeleteLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactSalesRoleRelation: LeadOpptyContactSalesRoleRelationEntity | null;
}

export interface DeleteLeadOpptyContactRelationPayload  {
  __typename?: 'DeleteLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactRelation: LeadOpptyContactRelationEntity | null;
}

export interface DeleteLeadOpptyContactGroupRelationPayload  {
  __typename?: 'DeleteLeadOpptyContactGroupRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationEntity | null;
}

export interface DeleteLeadOpptyAccountRelationPayload  {
  __typename?: 'DeleteLeadOpptyAccountRelationPayload';
  clientMutationId: string | null;
  leadOpptyAccountRelation: LeadOpptyAccountRelationEntity | null;
}

export interface DeleteInterfacePreviewPayload  {
  __typename?: 'DeleteInterfacePreviewPayload';
  clientMutationId: string | null;
  interfacePreview: InterfacePreviewEntity | null;
}

export interface DeleteImportMappingMaskPayload  {
  __typename?: 'DeleteImportMappingMaskPayload';
  clientMutationId: string | null;
  importMappingMask: ImportMappingMaskEntity | null;
}

export interface DeleteGhostLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'DeleteGhostLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactSalesRoleRelation: GhostLeadOpptyContactSalesRoleRelationEntity | null;
}

export interface DeleteGhostLeadOpptyContactRelationPayload  {
  __typename?: 'DeleteGhostLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactRelation: GhostLeadOpptyContactRelationEntity | null;
}

export interface DeleteGhostContactPayload  {
  __typename?: 'DeleteGhostContactPayload';
  clientMutationId: string | null;
  ghostContact: GhostContactEntity | null;
}

export interface DeleteGhostContactAccountRelationPayload  {
  __typename?: 'DeleteGhostContactAccountRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountRelation: GhostContactAccountRelationEntity | null;
}

export interface DeleteGhostContactAccountAccountRoleRelationPayload  {
  __typename?: 'DeleteGhostContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountAccountRoleRelation: GhostContactAccountAccountRoleRelationEntity | null;
}

export interface DeleteFormViewSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteFormViewSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  formViewSharingSalesUnitRelation: FormViewSharingSalesUnitRelationEntity | null;
}

export interface DeleteFormViewSharingClientRelationPayload  {
  __typename?: 'DeleteFormViewSharingClientRelationPayload';
  clientMutationId: string | null;
  formViewSharingClientRelation: FormViewSharingClientRelationEntity | null;
}

export interface DeleteFormViewPayload  {
  __typename?: 'DeleteFormViewPayload';
  clientMutationId: string | null;
  formView: FormViewEntity | null;
}

export interface DeleteForecastPayload  {
  __typename?: 'DeleteForecastPayload';
  clientMutationId: string | null;
  forecast: ForecastEntity | null;
}

export interface DeleteFieldSequencePayload  {
  __typename?: 'DeleteFieldSequencePayload';
  clientMutationId: string | null;
  fieldSequence: FieldSequenceEntity | null;
}

export interface DeleteFieldPermissionPayload  {
  __typename?: 'DeleteFieldPermissionPayload';
  clientMutationId: string | null;
  fieldPermission: FieldPermissionEntity | null;
}

export interface DeleteFieldPayload  {
  __typename?: 'DeleteFieldPayload';
  clientMutationId: string | null;
  field: FieldEntity | null;
}

export interface DeleteFieldMappingPayload  {
  __typename?: 'DeleteFieldMappingPayload';
  clientMutationId: string | null;
  fieldMapping: FieldMappingEntity | null;
}

export interface DeleteEntityScoringPayload  {
  __typename?: 'DeleteEntityScoringPayload';
  clientMutationId: string | null;
  entityScoring: EntityScoringEntity | null;
}

export interface DeleteEntityFitnessIndicatorPayload  {
  __typename?: 'DeleteEntityFitnessIndicatorPayload';
  clientMutationId: string | null;
  entityFitnessIndicator: EntityFitnessIndicatorEntity | null;
}

export interface DeleteEmailTemplateSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteEmailTemplateSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingSalesUnitRelation: EmailTemplateSharingSalesUnitRelationEntity | null;
}

export interface DeleteEmailTemplateSharingClientRelationPayload  {
  __typename?: 'DeleteEmailTemplateSharingClientRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingClientRelation: EmailTemplateSharingClientRelationEntity | null;
}

export interface DeleteEmailTemplatePayload  {
  __typename?: 'DeleteEmailTemplatePayload';
  clientMutationId: string | null;
  emailTemplate: EmailTemplateEntity | null;
}

export interface DeleteEmailTemplateFolderPayload  {
  __typename?: 'DeleteEmailTemplateFolderPayload';
  clientMutationId: string | null;
  emailTemplateFolder: EmailTemplateFolderEntity;
  errors: boolean;
}

export interface DeleteEmailSequencePayload  {
  __typename?: 'DeleteEmailSequencePayload';
  clientMutationId: string | null;
  emailSequence: EmailSequenceEntity | null;
}

export interface DeleteEmailSequenceEnrolledPayload  {
  __typename?: 'DeleteEmailSequenceEnrolledPayload';
  clientMutationId: string | null;
  emailSequenceEnrolled: EmailSequenceEnrolledEntity | null;
}

export interface DeleteEmailSequenceActivityLogPayload  {
  __typename?: 'DeleteEmailSequenceActivityLogPayload';
  clientMutationId: string | null;
  emailSequenceActivityLog: EmailSequenceActivityLogEntity | null;
}

export interface DeleteEmailSequenceActivityLogLinePayload  {
  __typename?: 'DeleteEmailSequenceActivityLogLinePayload';
  clientMutationId: string | null;
  emailSequenceActivityLogLine: EmailSequenceActivityLogLineEntity | null;
}

export interface DeleteEmailPayload  {
  __typename?: 'DeleteEmailPayload';
  clientMutationId: string | null;
  email: EmailEntity | null;
}

export interface DeleteEmailEventPayload  {
  __typename?: 'DeleteEmailEventPayload';
  clientMutationId: string | null;
  emailEvent: EmailEventEntity | null;
}

export interface DeleteEmailContentSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteEmailContentSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailContentSharingSalesUnitRelation: EmailContentSharingSalesUnitRelationEntity | null;
}

export interface DeleteEmailContentSharingClientRelationPayload  {
  __typename?: 'DeleteEmailContentSharingClientRelationPayload';
  clientMutationId: string | null;
  emailContentSharingClientRelation: EmailContentSharingClientRelationEntity | null;
}

export interface DeleteDraftWebresourcePayload  {
  __typename?: 'DeleteDraftWebresourcePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftTranslationPayload  {
  __typename?: 'DeleteDraftTranslationPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftTaskTypePayload  {
  __typename?: 'DeleteDraftTaskTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftQuoteTypePayload  {
  __typename?: 'DeleteDraftQuoteTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftProjectTypePayload  {
  __typename?: 'DeleteDraftProjectTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftProductTypePayload  {
  __typename?: 'DeleteDraftProductTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftOpportunityTypePayload  {
  __typename?: 'DeleteDraftOpportunityTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftLeadTypePayload  {
  __typename?: 'DeleteDraftLeadTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftFieldSequencePayload  {
  __typename?: 'DeleteDraftFieldSequencePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftFieldPermissionPayload  {
  __typename?: 'DeleteDraftFieldPermissionPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftFieldPayload  {
  __typename?: 'DeleteDraftFieldPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftEntitySettingsPayload  {
  __typename?: 'DeleteDraftEntitySettingsPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftDataPayload  {
  __typename?: 'DeleteDraftDataPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftCustomEntityTypePayload  {
  __typename?: 'DeleteDraftCustomEntityTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftCustomEntityRelationPayload  {
  __typename?: 'DeleteDraftCustomEntityRelationPayload';
  clientMutationId: string | null;
}

export interface DeleteDraftContactTypePayload  {
  __typename?: 'DeleteDraftContactTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftAppointmentTypePayload  {
  __typename?: 'DeleteDraftAppointmentTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDraftAccountTypePayload  {
  __typename?: 'DeleteDraftAccountTypePayload';
  clientMutationId: string | null;
}

export interface DeleteDataPayload  {
  __typename?: 'DeleteDataPayload';
  clientMutationId: string | null;
  data: DataEntity | null;
}

export interface DeleteCustomEntityTypePayload  {
  __typename?: 'DeleteCustomEntityTypePayload';
  clientMutationId: string | null;
  customEntityType: CustomEntityTypeEntity | null;
}

export interface DeleteCustomEntitySharingSalesUnitRelationPayload  {
  __typename?: 'DeleteCustomEntitySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  customEntitySharingSalesUnitRelation: CustomEntitySharingSalesUnitRelationEntity | null;
}

export interface DeleteCustomEntitySharingClientRelationPayload  {
  __typename?: 'DeleteCustomEntitySharingClientRelationPayload';
  clientMutationId: string | null;
  customEntitySharingClientRelation: CustomEntitySharingClientRelationEntity | null;
}

export interface DeleteCustomEntityRelationPayload  {
  __typename?: 'DeleteCustomEntityRelationPayload';
  clientMutationId: string | null;
  customEntityRelation: CustomEntityRelationEntity | null;
}

export interface DeleteCustomEntityRelationDataPayload  {
  __typename?: 'DeleteCustomEntityRelationDataPayload';
  clientMutationId: string | null;
  customEntityRelationData: CustomEntityRelationDataEntity | null;
}

export interface DeleteCustomEntityPayload  {
  __typename?: 'DeleteCustomEntityPayload';
  clientMutationId: string | null;
  customEntity: CustomEntityEntity | null;
}

export interface DeleteCustomEntityMetaMutationPayload  {
  __typename?: 'DeleteCustomEntityMetaMutationPayload';
  clientMutationId: string | null;
  entity: CustomEntityDescriptor;
}

export interface DeleteCustomEntityDataExRelationPayload  {
  __typename?: 'DeleteCustomEntityDataExRelationPayload';
  clientMutationId: string | null;
  customEntityDataExRelation: CustomEntityDataExRelationEntity | null;
}

export interface DeleteCurrencyPayload  {
  __typename?: 'DeleteCurrencyPayload';
  clientMutationId: string | null;
  currency: CurrencyEntity | null;
}

export interface DeleteCurrencyExchangeRatesListPayload  {
  __typename?: 'DeleteCurrencyExchangeRatesListPayload';
  clientMutationId: string | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
}

export interface DeleteCurrencyExchangeRatePayload  {
  __typename?: 'DeleteCurrencyExchangeRatePayload';
  clientMutationId: string | null;
  currencyExchangeRate: CurrencyExchangeRateEntity | null;
}

export interface DeleteContactTypePayload  {
  __typename?: 'DeleteContactTypePayload';
  clientMutationId: string | null;
  contactType: ContactTypeEntity | null;
}

export interface DeleteContactSocialRelationPayload  {
  __typename?: 'DeleteContactSocialRelationPayload';
  clientMutationId: string | null;
  contactSocialRelation: ContactSocialRelationEntity | null;
}

export interface DeleteContactSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteContactSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  contactSharingSalesUnitRelation: ContactSharingSalesUnitRelationEntity | null;
}

export interface DeleteContactSharingClientRelationPayload  {
  __typename?: 'DeleteContactSharingClientRelationPayload';
  clientMutationId: string | null;
  contactSharingClientRelation: ContactSharingClientRelationEntity | null;
}

export interface DeleteContactRelationTypePayload  {
  __typename?: 'DeleteContactRelationTypePayload';
  clientMutationId: string | null;
  contactRelationType: ContactRelationTypeEntity | null;
}

export interface DeleteContactRelationPayload  {
  __typename?: 'DeleteContactRelationPayload';
  clientMutationId: string | null;
  contactRelation: ContactRelationEntity | null;
}

export interface DeleteContactRelationLabelPayload  {
  __typename?: 'DeleteContactRelationLabelPayload';
  clientMutationId: string | null;
  contactRelationLabel: ContactRelationLabelEntity | null;
}

export interface DeleteContactPayload  {
  __typename?: 'DeleteContactPayload';
  clientMutationId: string | null;
  contact: ContactEntity | null;
}

export interface DeleteContactKPIPayload  {
  __typename?: 'DeleteContactKPIPayload';
  clientMutationId: string | null;
  contactKpi: ContactKPIEntity | null;
}

export interface DeleteContactAccountRelationPayload  {
  __typename?: 'DeleteContactAccountRelationPayload';
  clientMutationId: string | null;
  contactAccountRelation: ContactAccountRelationEntity | null;
}

export interface DeleteContactAccountAccountRoleRelationPayload  {
  __typename?: 'DeleteContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  contactAccountAccountRoleRelation: ContactAccountAccountRoleRelationEntity | null;
}

export interface DeleteCompanyEmailPayload  {
  __typename?: 'DeleteCompanyEmailPayload';
  clientMutationId: string | null;
  companyEmail: CompanyEmailEntity | null;
}

export interface DeleteCloudObjectsPayload  {
  __typename?: 'DeleteCloudObjectsPayload';
  clientMutationId: string | null;
}

export interface DeleteCloudObjectTemplatePayload  {
  __typename?: 'DeleteCloudObjectTemplatePayload';
  clientMutationId: string | null;
  cloudObjectTemplate: CloudObjectTemplateEntity | null;
}

export interface DeleteCloudObjectStepRelationPayload  {
  __typename?: 'DeleteCloudObjectStepRelationPayload';
  clientMutationId: string | null;
  cloudObjectStepRelation: CloudObjectStepRelationEntity | null;
}

export interface DeleteCloudObjectRelationPayload  {
  __typename?: 'DeleteCloudObjectRelationPayload';
  clientMutationId: string | null;
  cloudObjectRelation: CloudObjectRelationEntity | null;
}

export interface DeleteCloudObjectPayload  {
  __typename?: 'DeleteCloudObjectPayload';
  clientMutationId: string | null;
  cloudObject: CloudObjectEntity | null;
}

export interface DeleteCloudObjectFolderPayload  {
  __typename?: 'DeleteCloudObjectFolderPayload';
  clientMutationId: string | null;
  cloudObjectFolder: CloudObjectFolderEntity;
  errors: boolean;
}

export interface DeleteClientStoryReadPayload  {
  __typename?: 'DeleteClientStoryReadPayload';
  clientMutationId: string | null;
  clientStoryRead: ClientStoryReadEntity | null;
}

export interface DeleteClientSettingPayload  {
  __typename?: 'DeleteClientSettingPayload';
  clientMutationId: string | null;
  clientSetting: ClientSettingEntity | null;
}

export interface DeleteClientPayload  {
  __typename?: 'DeleteClientPayload';
  client: ClientEntity | null;
  clientMutationId: string | null;
}

export interface DeleteClientFavoritePayload  {
  __typename?: 'DeleteClientFavoritePayload';
  clientFavorite: ClientFavoriteEntity | null;
  clientMutationId: string | null;
}

export interface DeleteClientExcludedOpptyPayload  {
  __typename?: 'DeleteClientExcludedOpptyPayload';
  clientExcludedOppty: ClientExcludedOpptyEntity | null;
  clientMutationId: string | null;
}

export interface DeleteChatConversationPayload  {
  __typename?: 'DeleteChatConversationPayload';
  chatConversation: ChatConversationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteCallPayload  {
  __typename?: 'DeleteCallPayload';
  call: CallEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAutomationHubItemPayload  {
  __typename?: 'DeleteAutomationHubItemPayload';
  automationHubItem: AutomationHubItemEntity | null;
  clientMutationId: string | null;
}

export interface DeleteApprovalProcessPayload  {
  __typename?: 'DeleteApprovalProcessPayload';
  approvalProcess: ApprovalProcessEntity | null;
  clientMutationId: string | null;
}

export interface DeleteApprovalProcessActivityLogLinePayload  {
  __typename?: 'DeleteApprovalProcessActivityLogLinePayload';
  approvalProcessActivityLogLine: ApprovalProcessActivityLogLineEntity | null;
  clientMutationId: string | null;
}

export interface DeleteApprovalPayload  {
  __typename?: 'DeleteApprovalPayload';
  approval: ApprovalEntity | null;
  clientMutationId: string | null;
}

export interface DeleteApprovalApproverPayload  {
  __typename?: 'DeleteApprovalApproverPayload';
  approvalApprover: ApprovalApproverEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentTypePayload  {
  __typename?: 'DeleteAppointmentTypePayload';
  appointmentType: AppointmentTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentSchedulePayload  {
  __typename?: 'DeleteAppointmentSchedulePayload';
  appointmentSchedule: AppointmentScheduleEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentReminderPayload  {
  __typename?: 'DeleteAppointmentReminderPayload';
  appointmentReminder: AppointmentReminderEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentPayload  {
  __typename?: 'DeleteAppointmentPayload';
  appointment: AppointmentEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentContactInviteesRelationPayload  {
  __typename?: 'DeleteAppointmentContactInviteesRelationPayload';
  appointmentContactInviteesRelation: AppointmentContactInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAppointmentClientInviteesRelationPayload  {
  __typename?: 'DeleteAppointmentClientInviteesRelationPayload';
  appointmentClientInviteesRelation: AppointmentClientInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteApiAccessPayload  {
  __typename?: 'DeleteApiAccessPayload';
  apiAccess: ApiAccessEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedQuoteTypePayload  {
  __typename?: 'DeleteAllowedQuoteTypePayload';
  allowedQuoteType: AllowedQuoteTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedPipelinePayload  {
  __typename?: 'DeleteAllowedPipelinePayload';
  allowedPipeline: AllowedPipelineEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedLeadTypePayload  {
  __typename?: 'DeleteAllowedLeadTypePayload';
  allowedLeadType: AllowedLeadTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedContactTypePayload  {
  __typename?: 'DeleteAllowedContactTypePayload';
  allowedContactType: AllowedContactTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedCompanyPhonePayload  {
  __typename?: 'DeleteAllowedCompanyPhonePayload';
  allowedCompanyPhone: AllowedCompanyPhoneEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedCompanyEmailPayload  {
  __typename?: 'DeleteAllowedCompanyEmailPayload';
  allowedCompanyEmail: AllowedCompanyEmailEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAllowedAccountTypePayload  {
  __typename?: 'DeleteAllowedAccountTypePayload';
  allowedAccountType: AllowedAccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteActivityRelationPayload  {
  __typename?: 'DeleteActivityRelationPayload';
  activityRelation: ActivityRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteActivityKPIPayload  {
  __typename?: 'DeleteActivityKPIPayload';
  activityKpi: ActivityKPIEntity | null;
  clientMutationId: string | null;
}

export interface DeleteActivityCommentPayload  {
  __typename?: 'DeleteActivityCommentPayload';
  activityComment: ActivityCommentEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountTypePayload  {
  __typename?: 'DeleteAccountTypePayload';
  accountType: AccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountSocialRelationPayload  {
  __typename?: 'DeleteAccountSocialRelationPayload';
  accountSocialRelation: AccountSocialRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountSharingSalesUnitRelationPayload  {
  __typename?: 'DeleteAccountSharingSalesUnitRelationPayload';
  accountSharingSalesUnitRelation: AccountSharingSalesUnitRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountSharingClientRelationPayload  {
  __typename?: 'DeleteAccountSharingClientRelationPayload';
  accountSharingClientRelation: AccountSharingClientRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountRolePayload  {
  __typename?: 'DeleteAccountRolePayload';
  accountRole: AccountRoleEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountRelationTypePayload  {
  __typename?: 'DeleteAccountRelationTypePayload';
  accountRelationType: AccountRelationTypeEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountRelationPayload  {
  __typename?: 'DeleteAccountRelationPayload';
  accountRelation: AccountRelationEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountRelationLabelPayload  {
  __typename?: 'DeleteAccountRelationLabelPayload';
  accountRelationLabel: AccountRelationLabelEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountProductPricingPayload  {
  __typename?: 'DeleteAccountProductPricingPayload';
  accountProductPricing: AccountProductPricingEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountPayload  {
  __typename?: 'DeleteAccountPayload';
  account: AccountEntity | null;
  clientMutationId: string | null;
}

export interface DeleteAccountKPIPayload  {
  __typename?: 'DeleteAccountKPIPayload';
  accountKpi: AccountKPIEntity | null;
  clientMutationId: string | null;
}

export interface DelegateApprovalPayload  {
  __typename?: 'DelegateApprovalPayload';
  clientMutationId: string | null;
}

export interface DefaultProfileEntity  {
  __typename?: 'DefaultProfileEntity';
  entity: ScreenTypeEnum;
  entityApiName: string | null;
  id: UUID;
  name: string;
  pipelines: UUID[];
  useLang: boolean;
}

export interface DecimalInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DecimalInterfaceFieldData';
  decimalValue: number | null;
  fieldId: UUID;
}

export interface DaysInStepInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DaysInStepInterfaceFieldData';
  daysInStep: number | null;
  fieldId: UUID;
  overdueDays: number | null;
}

export interface DateTimeRangeInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DateTimeRangeInterfaceFieldData';
  endDateTime: DateTime | null;
  fieldId: UUID;
  startDateTime: DateTime | null;
}

export interface DateTimeInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DateTimeInterfaceFieldData';
  dateTime: DateTime | null;
  fieldId: UUID;
}

export interface DateRangeInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DateRangeInterfaceFieldData';
  endDate: GqlDate | null;
  fieldId: UUID;
  startDate: GqlDate | null;
}

export interface DatePeriod  {
  __typename?: 'DatePeriod';
  dateFrom: DateTime | null;
  dateTo: DateTime | null;
}

export interface DateInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'DateInterfaceFieldData';
  date: GqlDate | null;
  fieldId: UUID;
}

export interface DataSetValue  {
  __typename?: 'DataSetValue';
  calcValue: number;
  id: string;
  optionName: string;
}

export interface DataRepository  {
  __typename?: 'DataRepository';
  getAll: DataEntity[];
  getByCriteria: DataEntityConnection | null;
  getById: DataEntity | null;
  getByIds: DataEntity[];
  getDraftById: DataEntity;
  getDrafts: DataEntity[];
  getPublished: DataEntity[];
}

export interface DataGridViewItemWithAvailability extends ViewItemInterface {
  __typename?: 'DataGridViewItemWithAvailability';
  data: FieldDataContainer[];
  id: ID;
  isAvailable: boolean;
}

export interface DataGridViewItem extends ViewItemInterface {
  __typename?: 'DataGridViewItem';
  data: FieldDataContainer[];
  id: ID;
}

export interface DataGridChange  {
  __typename?: 'DataGridChange';
  applicationId: UUID;
  created: DateTime;
  newValue: ChangeLogValueObject | null;
  oldValue: ChangeLogValueObject | null;
  userId: number | null;
}

export interface DataEntityEdge  {
  __typename?: 'DataEntityEdge';
  cursor: string;
  node: DataEntity | null;
}

export interface DataEntityConnection  {
  __typename?: 'DataEntityConnection';
  edges: DataEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface DataEntity  {
  __typename?: 'DataEntity';
  allowedBy: JSONString | null;
  calcValue: number | null;
  created: DateTime | null;
  dataSetId: ID;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  modified: DateTime | null;
  optionName: string;
  optionNameTranslated: string | null;
  optionNameTranslations: JSONString;
  revision: number | null;
  sortOrder: number;
}

export interface DashboardViews  {
  __typename?: 'DashboardViews';
  data: BetterDashboardView;
  ofAccount: AccountDashboardView;
  ofActivity: ActivityDashboardView;
  ofContact: ContactDashboardView;
  ofLead: LeadDashboardView;
  ofOpportunity: OpportunityDashboardView;
}

export interface DashboardTileData extends DashboardChartId {
  __typename?: 'DashboardTileData';
  error: DashboardChartError | null;
  id: string | null;
  tileColor: number | null;
  tileId: UUID | null;
  tileValue: number | null;
}

export interface DashboardTileConditionalFormatting  {
  __typename?: 'DashboardTileConditionalFormatting';
  color: number;
  firstValue: number | null;
  operator: FieldOperator;
  secondValue: number | null;
}

export interface DashboardTileChangedRecords  {
  __typename?: 'DashboardTileChangedRecords';
  customPeriodValue: number | null;
  fieldIds: UUID[] | null;
  isEnabled: boolean | null;
  period: HighlightPeriodEnum | null;
}

export interface DashboardTile  {
  __typename?: 'DashboardTile';
  tileAggregationField: UUID | null;
  tileAggregationFunction: AggregationOperator;
  tileAggregationLookupFieldId: UUID | null;
  tileChangedRecords: DashboardTileChangedRecords;
  tileConditionalFormatting: DashboardTileConditionalFormatting[] | null;
  tileFilter: FieldFilter;
  tileId: UUID;
  tileSourceEntity: EntityNameEnum;
  tileSourceEntityApiName: string | null;
}

export interface DashboardTargetTab  {
  __typename?: 'DashboardTargetTab';
  goal: number;
  targetDefinition: UUID | null;
}

export interface DashboardTargetData extends DashboardChartId {
  __typename?: 'DashboardTargetData';
  error: DashboardChartError | null;
  id: string | null;
  targetDescription: string | null;
  targetGoal: number | null;
  targetName: string | null;
  targetValue: number | null;
}

export interface DashboardTarget  {
  __typename?: 'DashboardTarget';
  target: DashboardTargetTab | null;
  targetAggregationField: UUID | null;
  targetAggregationFunction: AggregationOperator;
  targetAggregationLookupFieldId: UUID | null;
  targetColor: number | null;
  targetFilter: FieldFilter;
  targetSourceEntity: EntityNameEnum;
  targetSourceEntityApiName: string | null;
  targetType: DashboardTargetTypeEnum;
}

export interface DashboardSection  {
  __typename?: 'DashboardSection';
  sectionAlignment: ColumnAlignment;
}

export interface DashboardSchema  {
  __typename?: 'DashboardSchema';
  structure: DashboardTabItemImplementors[];
}

export interface DashboardRole extends RoleTabInterface {
  __typename?: 'DashboardRole';
  isEnabled: boolean;
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface DashboardReportChartData extends DashboardChartId {
  __typename?: 'DashboardReportChartData';
  error: DashboardChartError | null;
  field: FieldDescriptor | null;
  groupField: FieldDescriptor | null;
  id: string | null;
  sankey: SankeyData | null;
  scorecard: ScorecardData | null;
  segmentField: FieldDescriptor | null;
  series: DashboardChartSeries[] | null;
  type: ReportChartType | null;
}

export interface DashboardReportChart  {
  __typename?: 'DashboardReportChart';
  reportId: UUID;
}

export interface DashboardQuickLinks  {
  __typename?: 'DashboardQuickLinks';
  quickLinks: DashboardQuickLink[];
}

export interface DashboardQuickLink  {
  __typename?: 'DashboardQuickLink';
  id: UUID | null;
  name: string;
  url: string;
  useLang: boolean;
}

export interface DashboardPipelineConversionsChartData extends DashboardChartId {
  __typename?: 'DashboardPipelineConversionsChartData';
  error: DashboardChartError | null;
  id: string | null;
  steps: DashboardChartStep[] | null;
}

export interface DashboardPipelineConversionsChart  {
  __typename?: 'DashboardPipelineConversionsChart';
  description: string | null;
  filter: OpportunityFilterTab | null;
  name: string;
  operator: AggregationOperator;
  salesPipeline: UUID;
}

export interface DashboardOpportunitiesTrendView  {
  __typename?: 'DashboardOpportunitiesTrendView';
  period: PeriodOption;
  periodGranularity: PeriodGranularity;
  showBalancedValue: boolean;
  showRankedValue: boolean;
  showTargetLine: boolean;
  showUnweightedValue: boolean;
  showWeightedValue: boolean;
  showWonValue: boolean;
}

export interface DashboardOpportunitiesTrendData extends DashboardChartId {
  __typename?: 'DashboardOpportunitiesTrendData';
  error: DashboardChartError | null;
  goal: number | null;
  id: string | null;
  opportunitiesTrendBalancedData: DashboardChartSeriesValueItem[];
  opportunitiesTrendRankedData: DashboardChartSeriesValueItem[];
  opportunitiesTrendUnweightedData: DashboardChartSeriesValueItem[];
  opportunitiesTrendWeightedData: DashboardChartSeriesValueItem[];
  opportunitiesTrendWonData: DashboardChartSeriesValueItem[];
}

export interface DashboardOpportunitiesTrend  {
  __typename?: 'DashboardOpportunitiesTrend';
  opportunitiesTrendFilter: FieldFilter;
  opportunitiesTrendTarget: DashboardTargetTab;
  opportunitiesTrendView: DashboardOpportunitiesTrendView;
}

export interface DashboardListChartDataEntity  {
  __typename?: 'DashboardListChartDataEntity';
  account: AccountEntity | null;
  appointment: AppointmentEntity | null;
  cloudObject: CloudObjectEntity | null;
  contact: ContactEntity | null;
  customEntity: CustomEntityEntity | null;
  lead: LeadEntity | null;
  note: NoteEntity | null;
  opportunity: OpportunityEntity | null;
  projectData: ProjectData | null;
  projectObjectiveData: ProjectObjectiveData | null;
  quote: QuoteEntity | null;
  task: TaskEntity | null;
}

export interface DashboardListChartData extends DashboardChartId {
  __typename?: 'DashboardListChartData';
  entities: DashboardListChartDataEntity[] | null;
  error: DashboardChartError | null;
  id: string | null;
  sortField: FieldDescriptor | null;
  total: number | null;
}

export interface DashboardKpiListItem  {
  __typename?: 'DashboardKpiListItem';
  color: number | null;
  id: UUID;
  kpi: DashboardKpi;
  name: string;
}

export interface DashboardKpiListData extends DashboardChartId {
  __typename?: 'DashboardKpiListData';
  error: DashboardChartError | null;
  id: string | null;
  kpiList: DashboardKpiData[];
}

export interface DashboardKpiList  {
  __typename?: 'DashboardKpiList';
  kpiList: DashboardKpiListItem[];
}

export interface DashboardKpiData extends DashboardChartId {
  __typename?: 'DashboardKpiData';
  error: DashboardChartError | null;
  id: string | null;
  kpiChartData: DashboardChartSeriesValueItem[] | null;
  kpiChartTarget: number | null;
  kpiCurrentValue: number | null;
  kpiId: UUID | null;
  kpiPreviousValue: number | null;
  kpiRelativeDifference: number | null;
}

export interface DashboardKpiCustomDefinition  {
  __typename?: 'DashboardKpiCustomDefinition';
  aggregationField: UUID | null;
  aggregationFunction: AggregationOperator;
  aggregationLookupFieldId: UUID | null;
  sourceEntity: EntityNameEnum;
  sourceEntityApiName: string | null;
}

export interface DashboardKpi  {
  __typename?: 'DashboardKpi';
  kpiCustomIndicator: DashboardKpiCustomDefinition;
  kpiFilter: FieldFilter;
  kpiId: UUID;
  kpiIndicator: DashboardKpiIndicatorEnum;
  kpiPeriodCompare: PeriodCompareOption | null;
  kpiPeriodCurrent: PeriodOption;
  kpiShowTargetLine: boolean;
  kpiTarget: DashboardTargetTab;
}

export interface DashboardItem  {
  __typename?: 'DashboardItem';
  chart: DashboardChart;
  color: number | null;
  description: string | null;
  descriptionUseLang: boolean;
  headerColor: number | null;
  id: ID;
  name: string | null;
  nameUseLang: boolean;
  position: Rectangle;
}

export interface DashboardInsightsData extends DashboardChartId {
  __typename?: 'DashboardInsightsData';
  error: DashboardChartError | null;
  id: string | null;
  insights: DashboardTileData[];
}

export interface DashboardInsights  {
  __typename?: 'DashboardInsights';
  insightTiles: DashboardInsightTile[];
}

export interface DashboardInsightTile  {
  __typename?: 'DashboardInsightTile';
  color: number | null;
  id: UUID;
  name: string;
  tile: DashboardTile;
  useLang: boolean;
}

export interface DashboardGridData extends DashboardChartId {
  __typename?: 'DashboardGridData';
  error: DashboardChartError | null;
  id: string | null;
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface DashboardGrid  {
  __typename?: 'DashboardGrid';
  gridColumns: GridColumnsOutput[];
  gridFilter: FieldFilter;
  gridShowTopRecordsOnly: boolean;
  gridShowTotal: boolean;
  gridSortBy: ID;
  gridSortOrder: SortOrder;
  gridSourceEntity: EntityNameEnum;
  gridSourceEntityApiName: string | null;
  gridTopRecords: number | null;
}

export interface DashboardGraphTooltip  {
  __typename?: 'DashboardGraphTooltip';
  legend: DashboardGraphLegend;
  value: string;
  valueType: DashboardGraphValueType;
}

export interface DashboardGraphSeriesItem extends DashboardGraphEntityInterface {
  __typename?: 'DashboardGraphSeriesItem';
  categorySessionId: UUID | null;
  color: string;
  entityId: UUID | null;
  legend: DashboardGraphLegend;
  sessionId: UUID | null;
  stacked: boolean;
  tooltip: DashboardGraphTooltip[];
  value: string;
  valueType: DashboardGraphValueType;
}

export interface DashboardGraphSeries extends DashboardGraphItemInterface {
  __typename?: 'DashboardGraphSeries';
  name: string;
  series: DashboardGraphCategories[];
  type: DashboardGraphSeriesType;
}

export interface DashboardGraphLegend  {
  __typename?: 'DashboardGraphLegend';
  label: string;
  useLang: boolean;
}

export interface DashboardGraphGauge extends DashboardGraphEntityInterface, DashboardGraphItemInterface {
  __typename?: 'DashboardGraphGauge';
  entityId: UUID | null;
  label: string;
  maxValue: number;
  name: string;
  sessionId: UUID | null;
  value: number;
}

export interface DashboardGraphCategories  {
  __typename?: 'DashboardGraphCategories';
  categories: DashboardGraphSeriesItem[];
  legend: DashboardGraphLegend | null;
}

export interface DashboardFilter extends ProfileFilterBaseInterface {
  __typename?: 'DashboardFilter';
  isEnabled: boolean;
  ownerIds: ID[];
  unitIds: ID[];
}

export interface DashboardDrilldownModel  {
  __typename?: 'DashboardDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface DashboardChartStep  {
  __typename?: 'DashboardChartStep';
  conversion: number | null;
  label: string;
  value: number | null;
}

export interface DashboardChartSeriesXYItem  {
  __typename?: 'DashboardChartSeriesXYItem';
  r: number | null;
  x: number;
  y: number;
}

export interface DashboardChartSeriesValueItem  {
  __typename?: 'DashboardChartSeriesValueItem';
  label: string | null;
  value: number | null;
}

export interface DashboardChartSeries  {
  __typename?: 'DashboardChartSeries';
  comparisonPeriod: PeriodOption | null;
  historyComparisonDateId: UUID | null;
  isAverage: boolean | null;
  items: DashboardChartSeriesItem[];
  label: string | null;
}

export interface DashboardAgendaData extends DashboardChartId {
  __typename?: 'DashboardAgendaData';
  agenda: BetterDashboardAgenda | null;
  error: DashboardChartError | null;
  id: string | null;
}

export interface DashboardAgenda  {
  __typename?: 'DashboardAgenda';
  agendaFilterActivity: FieldFilter | null;
  agendaFilterOpportunity: FieldFilter | null;
  agendaPeriod: DashboardAgendaPeriodEnum | null;
  agendaPeriodCustomDays: number;
  agendaShowAppointments: boolean | null;
  agendaShowOpportunities: boolean | null;
  agendaShowOpportunityFitness: boolean | null;
  agendaShowOverdueTasks: boolean | null;
  agendaShowTasks: boolean | null;
}

export interface CustomOpportunityDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomOpportunityDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface CustomEntityValue  {
  __typename?: 'CustomEntityValue';
  entityApiName: string;
  value: CustomEntityUISettings;
}

export interface CustomEntityUISettings  {
  __typename?: 'CustomEntityUISettings';
  activitiesFilter: ActivityTabDataGridViewOptions | null;
  customEntityStaticProfiles: UUID[];
  detailCollapsed: boolean;
  detailTabs: InterfaceDetailUserTab[] | null;
  detailWidgets: InterfaceDetailUserWidget[] | null;
  documentsFilter: CloudObjectTabDataGridViewOptions | null;
  drilldownFilter: CustomEntityDrilldownFilter | null;
  drilldownGridChanges: GridHighlightChanges;
  drilldownGridColumns: GridColumnsOutput[];
  drilldownSortBy: ID;
  drilldownSortOrder: SortOrder | null;
  entityTypePriorities: ID[] | null;
  gridChanges: GridHighlightChanges;
  gridColumns: GridColumnsOutput[];
  importSettings: ImportSettingsOptions | null;
  lookupGridColumns: GridColumnsOutput[];
  lookupSortBy: ID;
  lookupSortOrder: SortOrder | null;
  notesFilter: NoteTabDataGridViewOptions | null;
  quickFilterOpen: boolean | null;
  recentProcesses: UUID[];
  recentProfiles: ID[] | null;
  useProfileColumns: boolean;
}

export interface CustomEntityTypeRepository  {
  __typename?: 'CustomEntityTypeRepository';
  getAll: CustomEntityTypeEntity[];
  getByCriteria: CustomEntityTypeEntityConnection | null;
  getById: CustomEntityTypeEntity | null;
  getByIds: CustomEntityTypeEntity[];
  getDraftById: CustomEntityTypeEntity;
  getDrafts: CustomEntityTypeEntity[];
  getPublished: CustomEntityTypeEntity[];
}

export interface CustomEntityTypeEntityEdge  {
  __typename?: 'CustomEntityTypeEntityEdge';
  cursor: string;
  node: CustomEntityTypeEntity | null;
}

export interface CustomEntityTypeEntityConnection  {
  __typename?: 'CustomEntityTypeEntityConnection';
  edges: CustomEntityTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntityTypeEntity  {
  __typename?: 'CustomEntityTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  entityApiName: string | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  settings: EntityTypeSettings;
}

export interface CustomEntityTableReportProfile extends CustomEntityProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'CustomEntityTableReportProfile';
  filter: CustomEntityFilterTab;
  quickFilter: QuickFilterTab;
  role: CustomEntityRoleTab;
  view: ViewTableReportTab;
}

export interface CustomEntitySharingSalesUnitRelationRepository  {
  __typename?: 'CustomEntitySharingSalesUnitRelationRepository';
  getAll: CustomEntitySharingSalesUnitRelationEntity[];
  getByCriteria: CustomEntitySharingSalesUnitRelationEntityConnection | null;
  getById: CustomEntitySharingSalesUnitRelationEntity | null;
  getByIds: CustomEntitySharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CustomEntitySharingSalesUnitRelationEntityEdge  {
  __typename?: 'CustomEntitySharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: CustomEntitySharingSalesUnitRelationEntity | null;
}

export interface CustomEntitySharingSalesUnitRelationEntityConnection  {
  __typename?: 'CustomEntitySharingSalesUnitRelationEntityConnection';
  edges: CustomEntitySharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntitySharingSalesUnitRelationEntity  {
  __typename?: 'CustomEntitySharingSalesUnitRelationEntity';
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface CustomEntitySharingClientRelationRepository  {
  __typename?: 'CustomEntitySharingClientRelationRepository';
  getAll: CustomEntitySharingClientRelationEntity[];
  getByCriteria: CustomEntitySharingClientRelationEntityConnection | null;
  getById: CustomEntitySharingClientRelationEntity | null;
  getByIds: CustomEntitySharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CustomEntitySharingClientRelationEntityEdge  {
  __typename?: 'CustomEntitySharingClientRelationEntityEdge';
  cursor: string;
  node: CustomEntitySharingClientRelationEntity | null;
}

export interface CustomEntitySharingClientRelationEntityConnection  {
  __typename?: 'CustomEntitySharingClientRelationEntityConnection';
  edges: CustomEntitySharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntitySharingClientRelationEntity  {
  __typename?: 'CustomEntitySharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface CustomEntitySearchResultItem extends SearchResultItemInterface {
  __typename?: 'CustomEntitySearchResultItem';
  datetime: DateTime | null;
  entityApiName: string;
  id: ID;
  isDeleted: boolean;
  name: string;
  owner: string | null;
}

export interface CustomEntityRoleTab extends RoleTabInterface {
  __typename?: 'CustomEntityRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface CustomEntityRepository  {
  __typename?: 'CustomEntityRepository';
  autoPrefill: CustomEntityEntity;
  getAll: CustomEntityEntity[];
  getByCriteria: CustomEntityEntityConnection | null;
  getById: CustomEntityEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: CustomEntityEntity[];
  getBySession: CustomEntityEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface CustomEntityRelationRepository  {
  __typename?: 'CustomEntityRelationRepository';
  getAll: CustomEntityRelationEntity[];
  getByCriteria: CustomEntityRelationEntityConnection | null;
  getById: CustomEntityRelationEntity | null;
  getByIds: CustomEntityRelationEntity[];
  getDraftById: CustomEntityRelationEntity;
  getDrafts: CustomEntityRelationEntity[];
  getPublished: CustomEntityRelationEntity[];
}

export interface CustomEntityRelationEntityEdge  {
  __typename?: 'CustomEntityRelationEntityEdge';
  cursor: string;
  node: CustomEntityRelationEntity | null;
}

export interface CustomEntityRelationEntityConnection  {
  __typename?: 'CustomEntityRelationEntityConnection';
  edges: CustomEntityRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntityRelationEntity  {
  __typename?: 'CustomEntityRelationEntity';
  created: DateTime | null;
  entityFilter1: JSONString | null;
  entityFilter2: JSONString | null;
  field1: FieldEntity | null;
  field1Id: ID;
  field2: FieldEntity | null;
  field2Id: ID;
  hasDraft: boolean | null;
  hasIsPrimary: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  showRelated1: boolean | null;
  showRelated2: boolean | null;
  showTab1: boolean;
  showTab2: boolean;
  tabName1: string;
  tabName2: string;
}

export interface CustomEntityRelationDataRepository  {
  __typename?: 'CustomEntityRelationDataRepository';
  getAll: CustomEntityRelationDataEntity[];
  getByCriteria: CustomEntityRelationDataEntityConnection | null;
  getById: CustomEntityRelationDataEntity | null;
  getByIds: CustomEntityRelationDataEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CustomEntityRelationDataEntityEdge  {
  __typename?: 'CustomEntityRelationDataEntityEdge';
  cursor: string;
  node: CustomEntityRelationDataEntity | null;
}

export interface CustomEntityRelationDataEntityConnection  {
  __typename?: 'CustomEntityRelationDataEntityConnection';
  edges: CustomEntityRelationDataEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntityRelationDataEntity  {
  __typename?: 'CustomEntityRelationDataEntity';
  account1: AccountEntity | null;
  account1Id: ID | null;
  account2: AccountEntity | null;
  account2Id: ID | null;
  activity1Id: ID | null;
  activity2Id: ID | null;
  appointment1: AppointmentEntity | null;
  appointment2: AppointmentEntity | null;
  client1: ClientEntity | null;
  client1Id: ID | null;
  client2: ClientEntity | null;
  client2Id: ID | null;
  contact1: ContactEntity | null;
  contact1Id: ID | null;
  contact2: ContactEntity | null;
  contact2Id: ID | null;
  created: DateTime | null;
  customEntity1: CustomEntityEntity | null;
  customEntity1Id: ID | null;
  customEntity2: CustomEntityEntity | null;
  customEntity2Id: ID | null;
  customEntityRelation: CustomEntityRelationEntity | null;
  customEntityRelationId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean | null;
  lead1: LeadEntity | null;
  lead2: LeadEntity | null;
  leadOppty1Id: ID | null;
  leadOppty2Id: ID | null;
  modified: DateTime | null;
  oppty1: OpportunityEntity | null;
  oppty2: OpportunityEntity | null;
  opptyProductRelation1: OpptyProductRelationEntity | null;
  opptyProductRelation1Id: ID | null;
  opptyProductRelation2: OpptyProductRelationEntity | null;
  opptyProductRelation2Id: ID | null;
  product1: ProductEntity | null;
  product1Id: ID | null;
  product2: ProductEntity | null;
  product2Id: ID | null;
  project1: ProjectEntity | null;
  project1Id: ID | null;
  project2: ProjectEntity | null;
  project2Id: ID | null;
  quote1: QuoteEntity | null;
  quote1Id: ID | null;
  quote2: QuoteEntity | null;
  quote2Id: ID | null;
  revision: number | null;
  task1: TaskEntity | null;
  task2: TaskEntity | null;
}

export interface CustomEntityRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface {
  __typename?: 'CustomEntityRecentlyOpenedResultItem';
  entityApiName: string;
  id: ID;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  owner: string;
}

export interface CustomEntityProfileData  {
  __typename?: 'CustomEntityProfileData';
  listViewItems: CustomEntityDataGridViewItems;
}

export interface CustomEntityPreviewViewTab  {
  __typename?: 'CustomEntityPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface CustomEntityPreviewScreenProfile extends ProfileInterface {
  __typename?: 'CustomEntityPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: CustomEntityPreviewProfile;
  useLang: boolean;
}

export interface CustomEntityPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'CustomEntityPreviewScreen';
  activeProfile: CustomEntityPreviewScreenProfile;
  data: CustomEntityProfileData;
  draftProfile: CustomEntityPreviewScreenProfile | null;
  item: CustomEntityItem | null;
  name: string;
  profiles: CustomEntityPreviewScreenProfile[];
}

export interface CustomEntityPreviewProfile extends CustomEntityProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'CustomEntityPreviewProfile';
  filter: CustomEntityFilterTab;
  quickFilter: QuickFilterTab;
  role: CustomEntityRoleTab;
  view: CustomEntityPreviewViewTab;
}

export interface CustomEntityPivotReportProfile extends CustomEntityProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'CustomEntityPivotReportProfile';
  filter: CustomEntityFilterTab;
  quickFilter: QuickFilterTab;
  role: CustomEntityRoleTab;
  view: ViewPivotReportTab;
}

export interface CustomEntityNotificationEntity extends NotificationEntityInterface, NotificationTargetEntityInterface {
  __typename?: 'CustomEntityNotificationEntity';
  entityApiName: string;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
}

export interface CustomEntityNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomEntityNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface CustomEntityMasterRight  {
  __typename?: 'CustomEntityMasterRight';
  accessCopy: boolean;
  accessDelete: boolean;
  accessDirection: AccessDirectionEnum;
  accessEntityTypes: AccessEntityTypesEnum;
  accessLevel: AccessLevelEntityEnum;
  accessPrivate: boolean;
  allowedEntityTypeIds: ID[];
  defaultProfileId: ID;
  entityApiName: string;
  navigationAccess: boolean;
}

export interface CustomEntityListView extends ListViewInterface {
  __typename?: 'CustomEntityListView';
  displayColumn: UUID[];
  entityApiName: string;
  profile: CustomEntityPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface CustomEntityItem  {
  __typename?: 'CustomEntityItem';
  listViewItem: DataGridViewItem | null;
}

export interface CustomEntityID  {
  __typename?: 'CustomEntityID';
  entityApiName: string;
  id: UUID;
}

export interface CustomEntityFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'CustomEntityFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface CustomEntityFeedTabDataGridView  {
  __typename?: 'CustomEntityFeedTabDataGridView';
  feed: Feed;
}

export interface CustomEntityFeedEmailTabDataGridView  {
  __typename?: 'CustomEntityFeedEmailTabDataGridView';
  feed: Feed;
}

export interface CustomEntityFeaturePermission  {
  __typename?: 'CustomEntityFeaturePermission';
  accessPrivate: boolean;
  enabled: boolean | null;
  entityApiName: string;
}

export interface CustomEntityFavoriteResultItem extends FavoriteResultItemInterface {
  __typename?: 'CustomEntityFavoriteResultItem';
  entityApiName: string;
  id: ID;
  isDeleted: boolean;
  name: string;
  owner: string;
}

export interface CustomEntityEntityEdge  {
  __typename?: 'CustomEntityEntityEdge';
  cursor: string;
  node: CustomEntityEntity | null;
}

export interface CustomEntityEntityData  {
  __typename?: 'CustomEntityEntityData';
  entity: CustomEntityEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface CustomEntityEntityConnection  {
  __typename?: 'CustomEntityEntityConnection';
  edges: CustomEntityEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntityEntity  {
  __typename?: 'CustomEntityEntity';
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  documents: CloudObjectRelationEntityConnection | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  modified: DateTime | null;
  name: string | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: CustomEntitySharingClientRelationEntityConnection | null;
  sharingUnits: CustomEntitySharingSalesUnitRelationEntityConnection | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  tableName: string;
  type: CustomEntityTypeEntity | null;
  typeId: ID | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
}

export interface CustomEntityDrilldownFilter  {
  __typename?: 'CustomEntityDrilldownFilter';
  ownerId: ID[] | null;
}

export interface CustomEntityDescriptor  {
  __typename?: 'CustomEntityDescriptor';
  created: DateTime;
  entityApiName: string;
  functionalities: CustomEntityFunctionalityEnum[];
  icon: EntityIconEnum;
  isDeleted: boolean;
  nameFieldId: string;
  namePlural: string;
  nameSingular: string;
  preferenceOrder: number;
}

export interface CustomEntityDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomEntityDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface CustomEntityDataExRelationRepository  {
  __typename?: 'CustomEntityDataExRelationRepository';
  getAll: CustomEntityDataExRelationEntity[];
  getByCriteria: CustomEntityDataExRelationEntityConnection | null;
  getById: CustomEntityDataExRelationEntity | null;
  getByIds: CustomEntityDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CustomEntityDataExRelationEntityEdge  {
  __typename?: 'CustomEntityDataExRelationEntityEdge';
  cursor: string;
  node: CustomEntityDataExRelationEntity | null;
}

export interface CustomEntityDataExRelationEntityConnection  {
  __typename?: 'CustomEntityDataExRelationEntityConnection';
  edges: CustomEntityDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CustomEntityDataExRelationEntity  {
  __typename?: 'CustomEntityDataExRelationEntity';
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface CustomEntityCount  {
  __typename?: 'CustomEntityCount';
  count: number;
  entityApiName: string;
}

export interface CustomEntityCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomEntityCompactViewItems';
  groups: ViewItemGroup[];
  items: CustomEntityCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface CustomEntityCompactViewItem extends ViewItemInterface {
  __typename?: 'CustomEntityCompactViewItem';
  entityApiName: string | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  id: ID;
  name: string;
  sortFieldValue: FieldDataContainer | null;
}

export interface CustomEntityCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomEntityCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface CustomEntityApiAccessPermission  {
  __typename?: 'CustomEntityApiAccessPermission';
  access: ApiPermissionEnum;
  entityApiName: string;
}

export interface CustomEntityActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'CustomEntityActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface CustomEntityActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CustomEntityActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface CustomEntityActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'CustomEntityActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface CustomEntitiesNotificationSetting  {
  __typename?: 'CustomEntitiesNotificationSetting';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
  entityApiName: string;
}

export interface CurrencyRepository  {
  __typename?: 'CurrencyRepository';
  getAll: CurrencyEntity[];
  getBase: CurrencyEntity;
  getByCriteria: CurrencyEntityConnection | null;
  getById: CurrencyEntity | null;
  getByIds: CurrencyEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CurrencyProperty  {
  __typename?: 'CurrencyProperty';
  decimalPlaces: number;
}

export interface CurrencyForeignProperty  {
  __typename?: 'CurrencyForeignProperty';
  decimalPlaces: number;
}

export interface CurrencyForeignInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'CurrencyForeignInterfaceFieldData';
  currency: CurrencyForeignData | null;
  fieldId: UUID;
}

export interface CurrencyForeignField  {
  __typename?: 'CurrencyForeignField';
  baseValue: number | null;
  convertedValue: number | null;
  convertedValueCurrencyId: UUID | null;
  currencyId: ID;
  valueForeign: number | null;
}

export interface CurrencyForeignData  {
  __typename?: 'CurrencyForeignData';
  baseValue: number | null;
  convertedValue: number | null;
  convertedValueCurrencyId: UUID | null;
  currencyId: UUID | null;
  valueForeign: number | null;
}

export interface CurrencyExchangeRatesListRepository  {
  __typename?: 'CurrencyExchangeRatesListRepository';
  getAll: CurrencyExchangeRatesListEntity[];
  getByCriteria: CurrencyExchangeRatesListEntityConnection | null;
  getById: CurrencyExchangeRatesListEntity | null;
  getByIds: CurrencyExchangeRatesListEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CurrencyExchangeRatesListEntityEdge  {
  __typename?: 'CurrencyExchangeRatesListEntityEdge';
  cursor: string;
  node: CurrencyExchangeRatesListEntity | null;
}

export interface CurrencyExchangeRatesListEntityConnection  {
  __typename?: 'CurrencyExchangeRatesListEntityConnection';
  edges: CurrencyExchangeRatesListEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CurrencyExchangeRatesListEntity  {
  __typename?: 'CurrencyExchangeRatesListEntity';
  created: DateTime | null;
  currencyExchangeRates: CurrencyExchangeRateEntityConnection | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  validFrom: DateTime;
}

export interface CurrencyExchangeRateRepository  {
  __typename?: 'CurrencyExchangeRateRepository';
  getAll: CurrencyExchangeRateEntity[];
  getByCriteria: CurrencyExchangeRateEntityConnection | null;
  getById: CurrencyExchangeRateEntity | null;
  getByIds: CurrencyExchangeRateEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CurrencyExchangeRateEntityEdge  {
  __typename?: 'CurrencyExchangeRateEntityEdge';
  cursor: string;
  node: CurrencyExchangeRateEntity | null;
}

export interface CurrencyExchangeRateEntityConnection  {
  __typename?: 'CurrencyExchangeRateEntityConnection';
  edges: CurrencyExchangeRateEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CurrencyExchangeRateEntity  {
  __typename?: 'CurrencyExchangeRateEntity';
  created: DateTime | null;
  currency: CurrencyEntity | null;
  currencyExchangeRateList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRateListId: ID;
  currencyId: ID;
  exchangeRate: number | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface CurrencyEntityEdge  {
  __typename?: 'CurrencyEntityEdge';
  cursor: string;
  node: CurrencyEntity | null;
}

export interface CurrencyEntityConnection  {
  __typename?: 'CurrencyEntityConnection';
  edges: CurrencyEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CurrencyEntity  {
  __typename?: 'CurrencyEntity';
  code: string;
  created: DateTime | null;
  currencyExchangeRates: CurrencyExchangeRateEntityConnection | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isBase: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  symbol: string | null;
}

export interface CsvOptions extends ForeignCurrencyOption {
  __typename?: 'CsvOptions';
  delimiter: CsvDelimiter | null;
  encoding: string | null;
  includeForeignCurrency: boolean | null;
  quotechar: CsvQuotechar | null;
}

export interface CrmOpportunityEntity  {
  __typename?: 'CrmOpportunityEntity';
  created: DateTime;
  id: UUID;
  name: string;
  owner: CpClientEntity;
  stepName: string;
}

export interface CrmAccountEntity  {
  __typename?: 'CrmAccountEntity';
  billingDetail: BillingDetail;
  crmOpportunityEntity: CrmOpportunityEntity[];
  id: UUID;
  primaryAccountEmail: string;
  subscriptionNumber: number | null;
}

export interface CreateZoomMeetingPayload  {
  __typename?: 'CreateZoomMeetingPayload';
  clientMutationId: string | null;
  joinUrl: string;
  password: string | null;
}

export interface CreateWebresourcePayload  {
  __typename?: 'CreateWebresourcePayload';
  clientMutationId: string | null;
  webresource: WebresourceEntity | null;
}

export interface CreateWebhookPayload  {
  __typename?: 'CreateWebhookPayload';
  clientMutationId: string | null;
  webhook: WebhookEntity | null;
}

export interface CreateWebhookEventPayload  {
  __typename?: 'CreateWebhookEventPayload';
  clientMutationId: string | null;
  webhookEvent: WebhookEventEntity | null;
}

export interface CreateUnsubscribedPhonePayload  {
  __typename?: 'CreateUnsubscribedPhonePayload';
  clientMutationId: string | null;
  unsubscribedPhone: UnsubscribedPhoneEntity | null;
}

export interface CreateTranslationPayload  {
  __typename?: 'CreateTranslationPayload';
  clientMutationId: string | null;
  translation: TranslationEntity | null;
}

export interface CreateTimeframePayload  {
  __typename?: 'CreateTimeframePayload';
  clientMutationId: string | null;
  timeframe: TimeframeEntity | null;
}

export interface CreateTextMessagePayload  {
  __typename?: 'CreateTextMessagePayload';
  clientMutationId: string | null;
  textMessage: TextMessageEntity | null;
}

export interface CreateTextMessageConversationRelationsPayload  {
  __typename?: 'CreateTextMessageConversationRelationsPayload';
  clientMutationId: string | null;
  textMessageConversationRelations: TextMessageConversationRelationsEntity | null;
}

export interface CreateTextMessageConversationPayload  {
  __typename?: 'CreateTextMessageConversationPayload';
  clientMutationId: string | null;
  textMessageConversation: TextMessageConversationEntity | null;
}

export interface CreateTaskTypePayload  {
  __typename?: 'CreateTaskTypePayload';
  clientMutationId: string | null;
  taskType: TaskTypeEntity | null;
}

export interface CreateTaskSharingSalesUnitRelationPayload  {
  __typename?: 'CreateTaskSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  taskSharingSalesUnitRelation: TaskSharingSalesUnitRelationEntity | null;
}

export interface CreateTaskSharingClientRelationPayload  {
  __typename?: 'CreateTaskSharingClientRelationPayload';
  clientMutationId: string | null;
  taskSharingClientRelation: TaskSharingClientRelationEntity | null;
}

export interface CreateTaskReminderPayload  {
  __typename?: 'CreateTaskReminderPayload';
  clientMutationId: string | null;
  taskReminder: TaskReminderEntity | null;
}

export interface CreateTaskRecurrencePayload  {
  __typename?: 'CreateTaskRecurrencePayload';
  clientMutationId: string | null;
  taskRecurrence: TaskRecurrenceEntity | null;
}

export interface CreateTaskPayload  {
  __typename?: 'CreateTaskPayload';
  clientMutationId: string | null;
  task: TaskEntity | null;
}

export interface CreateTargetRelationPayload  {
  __typename?: 'CreateTargetRelationPayload';
  clientMutationId: string | null;
  targetRelation: TargetRelationEntity | null;
}

export interface CreateTargetPayload  {
  __typename?: 'CreateTargetPayload';
  target: TargetEntity | null;
}

export interface CreateTagRelationPayload  {
  __typename?: 'CreateTagRelationPayload';
  clientMutationId: string | null;
  tagRelation: TagRelationEntity | null;
}

export interface CreateTagPayload  {
  __typename?: 'CreateTagPayload';
  clientMutationId: string | null;
  tag: TagEntity | null;
}

export interface CreateStepPayload  {
  __typename?: 'CreateStepPayload';
  clientMutationId: string | null;
  step: StepEntity | null;
}

export interface CreateStepChecklistSalesRoleRelationPayload  {
  __typename?: 'CreateStepChecklistSalesRoleRelationPayload';
  clientMutationId: string | null;
  stepChecklistSalesRoleRelation: StepChecklistSalesRoleRelationEntity | null;
}

export interface CreateStepChecklistPayload  {
  __typename?: 'CreateStepChecklistPayload';
  clientMutationId: string | null;
  stepChecklist: StepChecklistEntity | null;
}

export interface CreateSalesUnitPayload  {
  __typename?: 'CreateSalesUnitPayload';
  clientMutationId: string | null;
  salesUnit: SalesUnitEntity | null;
}

export interface CreateSalesRolePayload  {
  __typename?: 'CreateSalesRolePayload';
  clientMutationId: string | null;
  salesRole: SalesRoleEntity | null;
}

export interface CreateReportSharingSalesUnitRelationPayload  {
  __typename?: 'CreateReportSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  reportSharingSalesUnitRelation: ReportSharingSalesUnitRelationEntity | null;
}

export interface CreateReportSharingClientRelationPayload  {
  __typename?: 'CreateReportSharingClientRelationPayload';
  clientMutationId: string | null;
  reportSharingClientRelation: ReportSharingClientRelationEntity | null;
}

export interface CreateReportSchedulePayload  {
  __typename?: 'CreateReportSchedulePayload';
  clientMutationId: string | null;
  reportSchedule: ReportScheduleEntity | null;
}

export interface CreateReportPayload  {
  __typename?: 'CreateReportPayload';
  clientMutationId: string | null;
  report: ReportEntity | null;
}

export interface CreateReportFolderPayload  {
  __typename?: 'CreateReportFolderPayload';
  clientMutationId: string | null;
  reportFolder: ReportFolderEntity | null;
}

export interface CreateQuoteTypePayload  {
  __typename?: 'CreateQuoteTypePayload';
  clientMutationId: string | null;
  quoteType: QuoteTypeEntity | null;
}

export interface CreateQuoteSharingSalesUnitRelationPayload  {
  __typename?: 'CreateQuoteSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  quoteSharingSalesUnitRelation: QuoteSharingSalesUnitRelationEntity | null;
}

export interface CreateQuoteSharingClientRelationPayload  {
  __typename?: 'CreateQuoteSharingClientRelationPayload';
  clientMutationId: string | null;
  quoteSharingClientRelation: QuoteSharingClientRelationEntity | null;
}

export interface CreateQuoteProfilePayload  {
  __typename?: 'CreateQuoteProfilePayload';
  clientMutationId: string | null;
  profile: QuotePreviewScreenProfile | null;
}

export interface CreateQuoteProcessPayload  {
  __typename?: 'CreateQuoteProcessPayload';
  clientMutationId: string | null;
  quoteProcess: QuoteProcessEntity | null;
}

export interface CreateQuotePayload  {
  __typename?: 'CreateQuotePayload';
  clientMutationId: string | null;
  quote: QuoteEntity | null;
}

export interface CreateQuoteKPIPayload  {
  __typename?: 'CreateQuoteKPIPayload';
  clientMutationId: string | null;
  quoteKpi: QuoteKPIEntity | null;
}

export interface CreateQuoteDataExRelationPayload  {
  __typename?: 'CreateQuoteDataExRelationPayload';
  clientMutationId: string | null;
  quoteDataExRelation: QuoteDataExRelationEntity | null;
}

export interface CreateQuoteContactRelationPayload  {
  __typename?: 'CreateQuoteContactRelationPayload';
  clientMutationId: string | null;
  quoteContactRelation: QuoteContactRelationEntity | null;
}

export interface CreateQuoteArchiveProfilePayload  {
  __typename?: 'CreateQuoteArchiveProfilePayload';
  clientMutationId: string | null;
  profile: QuoteArchiveScreenProfile | null;
}

export interface CreateQuoteAccountRelationPayload  {
  __typename?: 'CreateQuoteAccountRelationPayload';
  clientMutationId: string | null;
  quoteAccountRelation: QuoteAccountRelationEntity | null;
}

export interface CreateProjectTypePayload  {
  __typename?: 'CreateProjectTypePayload';
  clientMutationId: string | null;
  projectType: ProjectTypeEntity | null;
}

export interface CreateProjectSharingSalesUnitRelationPayload  {
  __typename?: 'CreateProjectSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  projectSharingSalesUnitRelation: ProjectSharingSalesUnitRelationEntity | null;
}

export interface CreateProjectSharingClientRelationPayload  {
  __typename?: 'CreateProjectSharingClientRelationPayload';
  clientMutationId: string | null;
  projectSharingClientRelation: ProjectSharingClientRelationEntity | null;
}

export interface CreateProjectProfilePayload  {
  __typename?: 'CreateProjectProfilePayload';
  clientMutationId: string | null;
  profile: ProjectPreviewScreenProfile | null;
}

export interface CreateProjectPayload  {
  __typename?: 'CreateProjectPayload';
  clientMutationId: string | null;
  project: ProjectEntity | null;
}

export interface CreateProjectObjectiveTaskPayload  {
  __typename?: 'CreateProjectObjectiveTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface CreateProjectObjectivePayload  {
  __typename?: 'CreateProjectObjectivePayload';
  clientMutationId: string | null;
  projectObjective: ProjectObjectiveEntity | null;
}

export interface CreateProjectObjectiveAppointmentPayload  {
  __typename?: 'CreateProjectObjectiveAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface CreateProjectKPIPayload  {
  __typename?: 'CreateProjectKPIPayload';
  clientMutationId: string | null;
  projectKpi: ProjectKPIEntity | null;
}

export interface CreateProjectContactRelationPayload  {
  __typename?: 'CreateProjectContactRelationPayload';
  clientMutationId: string | null;
  projectContactRelation: ProjectContactRelationEntity | null;
}

export interface CreateProfileSharingSalesUnitRelationPayload  {
  __typename?: 'CreateProfileSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  profileSharingSalesUnitRelation: ProfileSharingSalesUnitRelationEntity | null;
}

export interface CreateProfileSharingClientRelationPayload  {
  __typename?: 'CreateProfileSharingClientRelationPayload';
  clientMutationId: string | null;
  profileSharingClientRelation: ProfileSharingClientRelationEntity | null;
}

export interface CreateProfileRelationPayload  {
  __typename?: 'CreateProfileRelationPayload';
  clientMutationId: string | null;
  profileRelation: ProfileRelationEntity | null;
}

export interface CreateProfilePayload  {
  __typename?: 'CreateProfilePayload';
  clientMutationId: string | null;
  profile: ProfileEntity | null;
}

export interface CreateProductTypePayload  {
  __typename?: 'CreateProductTypePayload';
  clientMutationId: string | null;
  productType: ProductTypeEntity | null;
}

export interface CreateProductPriceListPricePayload  {
  __typename?: 'CreateProductPriceListPricePayload';
  clientMutationId: string | null;
  productPriceListPrice: ProductPriceListPriceEntity | null;
}

export interface CreateProductPriceListPayload  {
  __typename?: 'CreateProductPriceListPayload';
  clientMutationId: string | null;
  productPriceList: ProductPriceListEntity | null;
}

export interface CreateProductPipelineRelationPayload  {
  __typename?: 'CreateProductPipelineRelationPayload';
  clientMutationId: string | null;
  productPipelineRelation: ProductPipelineRelationEntity | null;
}

export interface CreateProductPayload  {
  __typename?: 'CreateProductPayload';
  clientMutationId: string | null;
  product: ProductEntity | null;
}

export interface CreateProductCategoryPayload  {
  __typename?: 'CreateProductCategoryPayload';
  clientMutationId: string | null;
  productCategory: ProductCategoryEntity | null;
}

export interface CreateProcessTemplatePayload  {
  __typename?: 'CreateProcessTemplatePayload';
  clientMutationId: string | null;
  processTemplate: ProcessTemplateEntity | null;
}

export interface CreateProcessPayload  {
  __typename?: 'CreateProcessPayload';
  clientMutationId: string | null;
  process: ProcessEntity | null;
}

export interface CreateProcessFromTemplatePayload  {
  __typename?: 'CreateProcessFromTemplatePayload';
  process: ProcessEntity | null;
}

export interface CreateProcessActivityLogPayload  {
  __typename?: 'CreateProcessActivityLogPayload';
  clientMutationId: string | null;
  processActivityLog: ProcessActivityLogEntity | null;
}

export interface CreateProcessActivityLogLinePayload  {
  __typename?: 'CreateProcessActivityLogLinePayload';
  clientMutationId: string | null;
  processActivityLogLine: ProcessActivityLogLineEntity | null;
}

export interface CreatePipelinePayload  {
  __typename?: 'CreatePipelinePayload';
  clientMutationId: string | null;
  pipeline: PipelineEntity | null;
}

export interface CreatePhonePayload  {
  __typename?: 'CreatePhonePayload';
  clientMutationId: string | null;
  phone: PhoneEntity | null;
}

export interface CreateParentAccountRelationTypePayload  {
  __typename?: 'CreateParentAccountRelationTypePayload';
  clientMutationId: string | null;
  parentAccountRelationType: ParentAccountRelationTypeEntity | null;
}

export interface CreateOpptyRecurrencePayload  {
  __typename?: 'CreateOpptyRecurrencePayload';
  clientMutationId: string | null;
  opptyRecurrence: OpptyRecurrenceEntity | null;
}

export interface CreateOpptyProductRelationPayload  {
  __typename?: 'CreateOpptyProductRelationPayload';
  clientMutationId: string | null;
  opptyProductRelation: OpptyProductRelationEntity | null;
}

export interface CreateOpptyProductRelationDataExRelationPayload  {
  __typename?: 'CreateOpptyProductRelationDataExRelationPayload';
  clientMutationId: string | null;
  opptyProductRelationDataExRelation: OpptyProductRelationDataExRelationEntity | null;
}

export interface CreateOpportunityTypePayload  {
  __typename?: 'CreateOpportunityTypePayload';
  clientMutationId: string | null;
  opportunityType: OpportunityTypeEntity | null;
}

export interface CreateOpportunityProfilePayload  {
  __typename?: 'CreateOpportunityProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityPreviewScreenProfile | null;
}

export interface CreateOpportunityPayload  {
  __typename?: 'CreateOpportunityPayload';
  clientMutationId: string | null;
  opportunity: OpportunityEntity | null;
}

export interface CreateOnlineFormTypePayload  {
  __typename?: 'CreateOnlineFormTypePayload';
  clientMutationId: string | null;
  onlineFormType: OnlineFormTypeEntity | null;
}

export interface CreateOnlineFormTypeEmailRelationPayload  {
  __typename?: 'CreateOnlineFormTypeEmailRelationPayload';
  clientMutationId: string | null;
  onlineFormTypeEmailRelation: OnlineFormTypeEmailRelationEntity | null;
}

export interface CreateOnlineFormStylePayload  {
  __typename?: 'CreateOnlineFormStylePayload';
  clientMutationId: string | null;
  onlineFormStyle: OnlineFormStyleEntity | null;
}

export interface CreateOnlineFormRelationPayload  {
  __typename?: 'CreateOnlineFormRelationPayload';
  clientMutationId: string | null;
  onlineFormRelation: OnlineFormRelationEntity | null;
}

export interface CreateOnlineFormPayload  {
  __typename?: 'CreateOnlineFormPayload';
  clientMutationId: string | null;
  onlineForm: OnlineFormEntity | null;
}

export interface CreateOnlineFormDataExRelationPayload  {
  __typename?: 'CreateOnlineFormDataExRelationPayload';
  clientMutationId: string | null;
  onlineFormDataExRelation: OnlineFormDataExRelationEntity | null;
}

export interface CreateOnlineFormActivityLogLinePayload  {
  __typename?: 'CreateOnlineFormActivityLogLinePayload';
  clientMutationId: string | null;
  onlineFormActivityLogLine: OnlineFormActivityLogLineEntity | null;
}

export interface CreateNotePayload  {
  __typename?: 'CreateNotePayload';
  clientMutationId: string | null;
  note: NoteEntity | null;
}

export interface CreateNewCustomEntityMutationPayload  {
  __typename?: 'CreateNewCustomEntityMutationPayload';
  clientMutationId: string | null;
  entity: CustomEntityDescriptor;
}

export interface CreateNavigatorProfilePayload  {
  __typename?: 'CreateNavigatorProfilePayload';
  clientMutationId: string | null;
  profile: NavigatorScreenProfile | null;
}

export interface CreateMsTeamsMeetingPayload  {
  __typename?: 'CreateMsTeamsMeetingPayload';
  clientMutationId: string | null;
  joinUrl: string;
}

export interface CreateMessageSharingSalesUnitRelationPayload  {
  __typename?: 'CreateMessageSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  messageSharingSalesUnitRelation: MessageSharingSalesUnitRelationEntity | null;
}

export interface CreateMessageSharingClientRelationPayload  {
  __typename?: 'CreateMessageSharingClientRelationPayload';
  clientMutationId: string | null;
  messageSharingClientRelation: MessageSharingClientRelationEntity | null;
}

export interface CreateMessageRelationPayload  {
  __typename?: 'CreateMessageRelationPayload';
  clientMutationId: string | null;
  messageRelation: MessageRelationEntity | null;
}

export interface CreateMemoPayload  {
  __typename?: 'CreateMemoPayload';
  clientMutationId: string | null;
  memo: MemoEntity | null;
}

export interface CreateMemoCommentPayload  {
  __typename?: 'CreateMemoCommentPayload';
  clientMutationId: string | null;
  memoComment: MemoCommentEntity | null;
}

export interface CreateMediaTranscriptionPdfPayload  {
  __typename?: 'CreateMediaTranscriptionPdfPayload';
  clientMutationId: string | null;
  result: CloudObjectEntity;
}

export interface CreateMasterRightPayload  {
  __typename?: 'CreateMasterRightPayload';
  clientMutationId: string | null;
  masterRight: MasterRightEntity | null;
}

export interface CreateLifeCycleProfilePayload  {
  __typename?: 'CreateLifeCycleProfilePayload';
  clientMutationId: string | null;
  profile: LifeCycleScreenProfile | null;
}

export interface CreateLeadTypePayload  {
  __typename?: 'CreateLeadTypePayload';
  clientMutationId: string | null;
  leadType: LeadTypeEntity | null;
}

export interface CreateLeadProfilePayload  {
  __typename?: 'CreateLeadProfilePayload';
  clientMutationId: string | null;
  profile: LeadPreviewScreenProfile | null;
}

export interface CreateLeadProcessPayload  {
  __typename?: 'CreateLeadProcessPayload';
  clientMutationId: string | null;
  leadProcess: LeadProcessEntity | null;
}

export interface CreateLeadPayload  {
  __typename?: 'CreateLeadPayload';
  clientMutationId: string | null;
  lead: LeadEntity | null;
}

export interface CreateLeadOpptyStepCheckListRelationPayload  {
  __typename?: 'CreateLeadOpptyStepCheckListRelationPayload';
  clientMutationId: string | null;
  leadOpptyStepCheckListRelation: LeadOpptyStepCheckListRelationEntity | null;
}

export interface CreateLeadOpptySharingSalesUnitRelationPayload  {
  __typename?: 'CreateLeadOpptySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingSalesUnitRelation: LeadOpptySharingSalesUnitRelationEntity | null;
}

export interface CreateLeadOpptySharingClientRelationPayload  {
  __typename?: 'CreateLeadOpptySharingClientRelationPayload';
  clientMutationId: string | null;
  leadOpptySharingClientRelation: LeadOpptySharingClientRelationEntity | null;
}

export interface CreateLeadOpptyKPIPayload  {
  __typename?: 'CreateLeadOpptyKPIPayload';
  clientMutationId: string | null;
  leadOpptyKpi: LeadOpptyKPIEntity | null;
}

export interface CreateLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'CreateLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactSalesRoleRelation: LeadOpptyContactSalesRoleRelationEntity | null;
}

export interface CreateLeadOpptyContactRelationPayload  {
  __typename?: 'CreateLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactRelation: LeadOpptyContactRelationEntity | null;
}

export interface CreateLeadOpptyContactGroupRelationPayload  {
  __typename?: 'CreateLeadOpptyContactGroupRelationPayload';
  clientMutationId: string | null;
  leadOpptyContactGroupRelation: LeadOpptyContactGroupRelationEntity | null;
}

export interface CreateLeadOpptyAccountRelationPayload  {
  __typename?: 'CreateLeadOpptyAccountRelationPayload';
  clientMutationId: string | null;
  leadOpptyAccountRelation: LeadOpptyAccountRelationEntity | null;
}

export interface CreateLeadArchiveProfilePayload  {
  __typename?: 'CreateLeadArchiveProfilePayload';
  clientMutationId: string | null;
  profile: LeadArchiveScreenProfile | null;
}

export interface CreateInsightsProfilePayload  {
  __typename?: 'CreateInsightsProfilePayload';
  clientMutationId: string | null;
  profile: InsightsScreenProfile | null;
}

export interface CreateIndicatorsProfilePayload  {
  __typename?: 'CreateIndicatorsProfilePayload';
  clientMutationId: string | null;
  profile: IndicatorsScreenProfile | null;
}

export interface CreateImportMappingMaskPayload  {
  __typename?: 'CreateImportMappingMaskPayload';
  clientMutationId: string | null;
  importMappingMask: ImportMappingMaskEntity | null;
}

export interface CreateImageCloudObjectTemplatePayload  {
  __typename?: 'CreateImageCloudObjectTemplatePayload';
  cloudObjectTemplate: CloudObjectTemplateEntity | null;
}

export interface CreateImageCloudObjectPayload  {
  __typename?: 'CreateImageCloudObjectPayload';
  cloudObject: CloudObjectEntity | null;
}

export interface CreateGhostLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'CreateGhostLeadOpptyContactSalesRoleRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactSalesRoleRelation: GhostLeadOpptyContactSalesRoleRelationEntity | null;
}

export interface CreateGhostLeadOpptyContactRelationPayload  {
  __typename?: 'CreateGhostLeadOpptyContactRelationPayload';
  clientMutationId: string | null;
  ghostLeadOpptyContactRelation: GhostLeadOpptyContactRelationEntity | null;
}

export interface CreateGhostContactPayload  {
  __typename?: 'CreateGhostContactPayload';
  clientMutationId: string | null;
  ghostContact: GhostContactEntity | null;
}

export interface CreateGhostContactAccountRelationPayload  {
  __typename?: 'CreateGhostContactAccountRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountRelation: GhostContactAccountRelationEntity | null;
}

export interface CreateGhostContactAccountAccountRoleRelationPayload  {
  __typename?: 'CreateGhostContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  ghostContactAccountAccountRoleRelation: GhostContactAccountAccountRoleRelationEntity | null;
}

export interface CreateFormViewSharingSalesUnitRelationPayload  {
  __typename?: 'CreateFormViewSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  formViewSharingSalesUnitRelation: FormViewSharingSalesUnitRelationEntity | null;
}

export interface CreateFormViewSharingClientRelationPayload  {
  __typename?: 'CreateFormViewSharingClientRelationPayload';
  clientMutationId: string | null;
  formViewSharingClientRelation: FormViewSharingClientRelationEntity | null;
}

export interface CreateFormViewPayload  {
  __typename?: 'CreateFormViewPayload';
  clientMutationId: string | null;
  formView: FormViewEntity | null;
}

export interface CreateForecastPayload  {
  __typename?: 'CreateForecastPayload';
  clientMutationId: string | null;
  forecast: ForecastEntity | null;
}

export interface CreateFieldSequencePayload  {
  __typename?: 'CreateFieldSequencePayload';
  clientMutationId: string | null;
  fieldSequence: FieldSequenceEntity | null;
}

export interface CreateFieldPermissionPayload  {
  __typename?: 'CreateFieldPermissionPayload';
  clientMutationId: string | null;
  fieldPermission: FieldPermissionEntity | null;
}

export interface CreateFieldPayload  {
  __typename?: 'CreateFieldPayload';
  clientMutationId: string | null;
  field: FieldEntity | null;
}

export interface CreateFieldMappingPayload  {
  __typename?: 'CreateFieldMappingPayload';
  fieldMapping: FieldMappingEntity | null;
}

export interface CreateFeedProfilePayload  {
  __typename?: 'CreateFeedProfilePayload';
  clientMutationId: string | null;
  profile: FeedScreenProfile | null;
}

export interface CreateFeedEmailProfilePayload  {
  __typename?: 'CreateFeedEmailProfilePayload';
  clientMutationId: string | null;
  profile: FeedEmailScreenProfile | null;
}

export interface CreateFeedEmailDetailProfilePayload  {
  __typename?: 'CreateFeedEmailDetailProfilePayload';
  clientMutationId: string | null;
  profile: FeedEmailDetailScreenProfile | null;
}

export interface CreateFeedDetailProfilePayload  {
  __typename?: 'CreateFeedDetailProfilePayload';
  clientMutationId: string | null;
  profile: FeedDetailScreenProfile | null;
}

export interface CreateEntityScoringPayload  {
  __typename?: 'CreateEntityScoringPayload';
  clientMutationId: string | null;
  entityScoring: EntityScoringEntity | null;
}

export interface CreateEntityFitnessIndicatorPayload  {
  __typename?: 'CreateEntityFitnessIndicatorPayload';
  clientMutationId: string | null;
  entityFitnessIndicator: EntityFitnessIndicatorEntity | null;
}

export interface CreateEmailTemplateSharingSalesUnitRelationPayload  {
  __typename?: 'CreateEmailTemplateSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingSalesUnitRelation: EmailTemplateSharingSalesUnitRelationEntity | null;
}

export interface CreateEmailTemplateSharingClientRelationPayload  {
  __typename?: 'CreateEmailTemplateSharingClientRelationPayload';
  clientMutationId: string | null;
  emailTemplateSharingClientRelation: EmailTemplateSharingClientRelationEntity | null;
}

export interface CreateEmailTemplatePayload  {
  __typename?: 'CreateEmailTemplatePayload';
  clientMutationId: string | null;
  emailTemplate: EmailTemplateEntity | null;
}

export interface CreateEmailTemplateFolderPayload  {
  __typename?: 'CreateEmailTemplateFolderPayload';
  clientMutationId: string | null;
  emailTemplateFolder: EmailTemplateFolderEntity | null;
}

export interface CreateEmailSequencePayload  {
  __typename?: 'CreateEmailSequencePayload';
  clientMutationId: string | null;
  emailSequence: EmailSequenceEntity | null;
}

export interface CreateEmailSequenceEnrolledPayload  {
  __typename?: 'CreateEmailSequenceEnrolledPayload';
  clientMutationId: string | null;
  emailSequenceEnrolled: EmailSequenceEnrolledEntity | null;
}

export interface CreateEmailSequenceActivityLogPayload  {
  __typename?: 'CreateEmailSequenceActivityLogPayload';
  clientMutationId: string | null;
  emailSequenceActivityLog: EmailSequenceActivityLogEntity | null;
}

export interface CreateEmailSequenceActivityLogLinePayload  {
  __typename?: 'CreateEmailSequenceActivityLogLinePayload';
  clientMutationId: string | null;
  emailSequenceActivityLogLine: EmailSequenceActivityLogLineEntity | null;
}

export interface CreateEmailPayload  {
  __typename?: 'CreateEmailPayload';
  clientMutationId: string | null;
  email: EmailEntity | null;
}

export interface CreateEmailEventPayload  {
  __typename?: 'CreateEmailEventPayload';
  clientMutationId: string | null;
  emailEvent: EmailEventEntity | null;
}

export interface CreateEmailContentSharingSalesUnitRelationPayload  {
  __typename?: 'CreateEmailContentSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  emailContentSharingSalesUnitRelation: EmailContentSharingSalesUnitRelationEntity | null;
}

export interface CreateEmailContentSharingClientRelationPayload  {
  __typename?: 'CreateEmailContentSharingClientRelationPayload';
  clientMutationId: string | null;
  emailContentSharingClientRelation: EmailContentSharingClientRelationEntity | null;
}

export interface CreateDraftWebresourcePayload  {
  __typename?: 'CreateDraftWebresourcePayload';
  clientMutationId: string | null;
  webresource: WebresourceEntity | null;
}

export interface CreateDraftTranslationPayload  {
  __typename?: 'CreateDraftTranslationPayload';
  clientMutationId: string | null;
  translation: TranslationEntity | null;
}

export interface CreateDraftTaskTypePayload  {
  __typename?: 'CreateDraftTaskTypePayload';
  clientMutationId: string | null;
  taskType: TaskTypeEntity | null;
}

export interface CreateDraftQuoteTypePayload  {
  __typename?: 'CreateDraftQuoteTypePayload';
  clientMutationId: string | null;
  quoteType: QuoteTypeEntity | null;
}

export interface CreateDraftProjectTypePayload  {
  __typename?: 'CreateDraftProjectTypePayload';
  clientMutationId: string | null;
  projectType: ProjectTypeEntity | null;
}

export interface CreateDraftProductTypePayload  {
  __typename?: 'CreateDraftProductTypePayload';
  clientMutationId: string | null;
  productType: ProductTypeEntity | null;
}

export interface CreateDraftOpportunityTypePayload  {
  __typename?: 'CreateDraftOpportunityTypePayload';
  clientMutationId: string | null;
  opportunityType: OpportunityTypeEntity | null;
}

export interface CreateDraftLeadTypePayload  {
  __typename?: 'CreateDraftLeadTypePayload';
  clientMutationId: string | null;
  leadType: LeadTypeEntity | null;
}

export interface CreateDraftFieldSequencePayload  {
  __typename?: 'CreateDraftFieldSequencePayload';
  clientMutationId: string | null;
  fieldSequence: FieldSequenceEntity | null;
}

export interface CreateDraftFieldPermissionsPayload  {
  __typename?: 'CreateDraftFieldPermissionsPayload';
  result: FieldPermissionEntity[];
}

export interface CreateDraftFieldPermissionPayload  {
  __typename?: 'CreateDraftFieldPermissionPayload';
  clientMutationId: string | null;
  fieldPermission: FieldPermissionEntity | null;
}

export interface CreateDraftFieldPayload  {
  __typename?: 'CreateDraftFieldPayload';
  clientMutationId: string | null;
  field: FieldEntity | null;
}

export interface CreateDraftDataPayload  {
  __typename?: 'CreateDraftDataPayload';
  clientMutationId: string | null;
  data: DataEntity | null;
}

export interface CreateDraftCustomEntityTypePayload  {
  __typename?: 'CreateDraftCustomEntityTypePayload';
  customEntityType: CustomEntityTypeEntity | null;
}

export interface CreateDraftCustomEntityRelationPayload  {
  __typename?: 'CreateDraftCustomEntityRelationPayload';
  clientMutationId: string | null;
  customEntityRelation: CustomEntityRelationEntity | null;
}

export interface CreateDraftContactTypePayload  {
  __typename?: 'CreateDraftContactTypePayload';
  clientMutationId: string | null;
  contactType: ContactTypeEntity | null;
}

export interface CreateDraftAppointmentTypePayload  {
  __typename?: 'CreateDraftAppointmentTypePayload';
  appointmentType: AppointmentTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateDraftAccountTypePayload  {
  __typename?: 'CreateDraftAccountTypePayload';
  accountType: AccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateDataPayload  {
  __typename?: 'CreateDataPayload';
  clientMutationId: string | null;
  data: DataEntity | null;
}

export interface CreateCustomEntityTypePayload  {
  __typename?: 'CreateCustomEntityTypePayload';
  clientMutationId: string | null;
  customEntityType: CustomEntityTypeEntity | null;
}

export interface CreateCustomEntitySharingSalesUnitRelationPayload  {
  __typename?: 'CreateCustomEntitySharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  customEntitySharingSalesUnitRelation: CustomEntitySharingSalesUnitRelationEntity | null;
}

export interface CreateCustomEntitySharingClientRelationPayload  {
  __typename?: 'CreateCustomEntitySharingClientRelationPayload';
  clientMutationId: string | null;
  customEntitySharingClientRelation: CustomEntitySharingClientRelationEntity | null;
}

export interface CreateCustomEntityRelationPayload  {
  __typename?: 'CreateCustomEntityRelationPayload';
  clientMutationId: string | null;
  customEntityRelation: CustomEntityRelationEntity | null;
}

export interface CreateCustomEntityRelationDataPayload  {
  __typename?: 'CreateCustomEntityRelationDataPayload';
  clientMutationId: string | null;
  customEntityRelationData: CustomEntityRelationDataEntity | null;
}

export interface CreateCustomEntityProfilePayload  {
  __typename?: 'CreateCustomEntityProfilePayload';
  clientMutationId: string | null;
  profile: CustomEntityPreviewScreenProfile | null;
}

export interface CreateCustomEntityPayload  {
  __typename?: 'CreateCustomEntityPayload';
  clientMutationId: string | null;
  customEntity: CustomEntityEntity | null;
}

export interface CreateCustomEntityDataExRelationPayload  {
  __typename?: 'CreateCustomEntityDataExRelationPayload';
  clientMutationId: string | null;
  customEntityDataExRelation: CustomEntityDataExRelationEntity | null;
}

export interface CreateCurrencyPayload  {
  __typename?: 'CreateCurrencyPayload';
  clientMutationId: string | null;
  currency: CurrencyEntity | null;
}

export interface CreateCurrencyExchangeRatesListPayload  {
  __typename?: 'CreateCurrencyExchangeRatesListPayload';
  clientMutationId: string | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
}

export interface CreateCurrencyExchangeRatePayload  {
  __typename?: 'CreateCurrencyExchangeRatePayload';
  clientMutationId: string | null;
  currencyExchangeRate: CurrencyExchangeRateEntity | null;
}

export interface CreateConversionsProfilePayload  {
  __typename?: 'CreateConversionsProfilePayload';
  clientMutationId: string | null;
  profile: ConversionsScreenProfile | null;
}

export interface CreateContactTypePayload  {
  __typename?: 'CreateContactTypePayload';
  clientMutationId: string | null;
  contactType: ContactTypeEntity | null;
}

export interface CreateContactSocialRelationPayload  {
  __typename?: 'CreateContactSocialRelationPayload';
  clientMutationId: string | null;
  contactSocialRelation: ContactSocialRelationEntity | null;
}

export interface CreateContactSharingSalesUnitRelationPayload  {
  __typename?: 'CreateContactSharingSalesUnitRelationPayload';
  clientMutationId: string | null;
  contactSharingSalesUnitRelation: ContactSharingSalesUnitRelationEntity | null;
}

export interface CreateContactSharingClientRelationPayload  {
  __typename?: 'CreateContactSharingClientRelationPayload';
  clientMutationId: string | null;
  contactSharingClientRelation: ContactSharingClientRelationEntity | null;
}

export interface CreateContactRelationTypePayload  {
  __typename?: 'CreateContactRelationTypePayload';
  clientMutationId: string | null;
  contactRelationType: ContactRelationTypeEntity | null;
}

export interface CreateContactRelationPayload  {
  __typename?: 'CreateContactRelationPayload';
  clientMutationId: string | null;
  contactRelation: ContactRelationEntity | null;
}

export interface CreateContactRelationLabelPayload  {
  __typename?: 'CreateContactRelationLabelPayload';
  clientMutationId: string | null;
  contactRelationLabel: ContactRelationLabelEntity | null;
}

export interface CreateContactProfilePayload  {
  __typename?: 'CreateContactProfilePayload';
  clientMutationId: string | null;
  profile: ContactPreviewScreenProfile | null;
}

export interface CreateContactPayload  {
  __typename?: 'CreateContactPayload';
  clientMutationId: string | null;
  contact: ContactEntity | null;
}

export interface CreateContactKPIPayload  {
  __typename?: 'CreateContactKPIPayload';
  clientMutationId: string | null;
  contactKpi: ContactKPIEntity | null;
}

export interface CreateContactArchiveProfilePayload  {
  __typename?: 'CreateContactArchiveProfilePayload';
  clientMutationId: string | null;
  profile: ContactArchiveScreenProfile | null;
}

export interface CreateContactAccountRelationPayload  {
  __typename?: 'CreateContactAccountRelationPayload';
  clientMutationId: string | null;
  contactAccountRelation: ContactAccountRelationEntity | null;
}

export interface CreateContactAccountAccountRoleRelationPayload  {
  __typename?: 'CreateContactAccountAccountRoleRelationPayload';
  clientMutationId: string | null;
  contactAccountAccountRoleRelation: ContactAccountAccountRoleRelationEntity | null;
}

export interface CreateCompanyEmailPayload  {
  __typename?: 'CreateCompanyEmailPayload';
  companyEmail: CompanyEmailEntity | null;
}

export interface CreateCloudObjectTemplatePayload  {
  __typename?: 'CreateCloudObjectTemplatePayload';
  clientMutationId: string | null;
  cloudObjectTemplate: CloudObjectTemplateEntity | null;
}

export interface CreateCloudObjectStepRelationPayload  {
  __typename?: 'CreateCloudObjectStepRelationPayload';
  clientMutationId: string | null;
  cloudObjectStepRelation: CloudObjectStepRelationEntity | null;
}

export interface CreateCloudObjectRelationPayload  {
  __typename?: 'CreateCloudObjectRelationPayload';
  clientMutationId: string | null;
  cloudObjectRelation: CloudObjectRelationEntity | null;
}

export interface CreateCloudObjectPayload  {
  __typename?: 'CreateCloudObjectPayload';
  clientMutationId: string | null;
  cloudObject: CloudObjectEntity | null;
}

export interface CreateCloudObjectFolderPayload  {
  __typename?: 'CreateCloudObjectFolderPayload';
  clientMutationId: string | null;
  cloudObjectFolder: CloudObjectFolderEntity | null;
}

export interface CreateClientStoryReadPayload  {
  __typename?: 'CreateClientStoryReadPayload';
  clientMutationId: string | null;
  clientStoryRead: ClientStoryReadEntity | null;
}

export interface CreateClientSettingPayload  {
  __typename?: 'CreateClientSettingPayload';
  clientMutationId: string | null;
  clientSetting: ClientSettingEntity | null;
}

export interface CreateClientPayload  {
  __typename?: 'CreateClientPayload';
  client: ClientEntity | null;
  clientMutationId: string | null;
}

export interface CreateClientFavoritePayload  {
  __typename?: 'CreateClientFavoritePayload';
  clientFavorite: ClientFavoriteEntity | null;
  clientMutationId: string | null;
}

export interface CreateClientExcludedOpptyPayload  {
  __typename?: 'CreateClientExcludedOpptyPayload';
  clientExcludedOppty: ClientExcludedOpptyEntity | null;
  clientMutationId: string | null;
}

export interface CreateChatSuggestionPayload  {
  __typename?: 'CreateChatSuggestionPayload';
  actions: AiAssistantTaskAction[] | null;
  clientMutationId: string | null;
  message: TextMessageEntity;
  sessionId: string;
  taskId: string | null;
}

export interface CreateChatConversationPayload  {
  __typename?: 'CreateChatConversationPayload';
  chatConversation: ChatConversationEntity | null;
  clientMutationId: string | null;
}

export interface CreateCallPayload  {
  __typename?: 'CreateCallPayload';
  call: CallEntity | null;
  clientMutationId: string | null;
}

export interface CreateBetterNavigatorProfilePayload  {
  __typename?: 'CreateBetterNavigatorProfilePayload';
  clientMutationId: string | null;
  profile: BetterNavigatorScreenProfile | null;
}

export interface CreateAutomationHubItemPayload  {
  __typename?: 'CreateAutomationHubItemPayload';
  automationHubItem: AutomationHubItemEntity | null;
  clientMutationId: string | null;
}

export interface CreateArchiveProfilePayload  {
  __typename?: 'CreateArchiveProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityArchiveScreenProfile | null;
}

export interface CreateApprovalProcessPayload  {
  __typename?: 'CreateApprovalProcessPayload';
  approvalProcess: ApprovalProcessEntity | null;
}

export interface CreateApprovalProcessActivityLogLinePayload  {
  __typename?: 'CreateApprovalProcessActivityLogLinePayload';
  approvalProcessActivityLogLine: ApprovalProcessActivityLogLineEntity | null;
  clientMutationId: string | null;
}

export interface CreateApprovalPayload  {
  __typename?: 'CreateApprovalPayload';
  approval: ApprovalEntity | null;
  clientMutationId: string | null;
}

export interface CreateApprovalApproverPayload  {
  __typename?: 'CreateApprovalApproverPayload';
  approvalApprover: ApprovalApproverEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentTypePayload  {
  __typename?: 'CreateAppointmentTypePayload';
  appointmentType: AppointmentTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentSchedulePayload  {
  __typename?: 'CreateAppointmentSchedulePayload';
  appointmentSchedule: AppointmentScheduleEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentReminderPayload  {
  __typename?: 'CreateAppointmentReminderPayload';
  appointmentReminder: AppointmentReminderEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentPayload  {
  __typename?: 'CreateAppointmentPayload';
  appointment: AppointmentEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentContactInviteesRelationPayload  {
  __typename?: 'CreateAppointmentContactInviteesRelationPayload';
  appointmentContactInviteesRelation: AppointmentContactInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateAppointmentClientInviteesRelationPayload  {
  __typename?: 'CreateAppointmentClientInviteesRelationPayload';
  appointmentClientInviteesRelation: AppointmentClientInviteesRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateApiAccessPayload  {
  __typename?: 'CreateApiAccessPayload';
  apiAccess: ApiAccessEntity | null;
  clientMutationId: string | null;
}

export interface CreateAndLinkPdfToEntityPayload  {
  __typename?: 'CreateAndLinkPdfToEntityPayload';
  clientMutationId: string | null;
  result: CloudObjectEntity | null;
}

export interface CreateAllowedQuoteTypePayload  {
  __typename?: 'CreateAllowedQuoteTypePayload';
  allowedQuoteType: AllowedQuoteTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedPipelinePayload  {
  __typename?: 'CreateAllowedPipelinePayload';
  allowedPipeline: AllowedPipelineEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedLeadTypePayload  {
  __typename?: 'CreateAllowedLeadTypePayload';
  allowedLeadType: AllowedLeadTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedContactTypePayload  {
  __typename?: 'CreateAllowedContactTypePayload';
  allowedContactType: AllowedContactTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedCompanyPhonePayload  {
  __typename?: 'CreateAllowedCompanyPhonePayload';
  allowedCompanyPhone: AllowedCompanyPhoneEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedCompanyEmailPayload  {
  __typename?: 'CreateAllowedCompanyEmailPayload';
  allowedCompanyEmail: AllowedCompanyEmailEntity | null;
  clientMutationId: string | null;
}

export interface CreateAllowedAccountTypePayload  {
  __typename?: 'CreateAllowedAccountTypePayload';
  allowedAccountType: AllowedAccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateActivityRelationPayload  {
  __typename?: 'CreateActivityRelationPayload';
  activityRelation: ActivityRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateActivityProfilePayload  {
  __typename?: 'CreateActivityProfilePayload';
  clientMutationId: string | null;
  profile: ActivityPreviewScreenProfile | null;
}

export interface CreateActivityKPIPayload  {
  __typename?: 'CreateActivityKPIPayload';
  activityKpi: ActivityKPIEntity | null;
  clientMutationId: string | null;
}

export interface CreateActivityCommentPayload  {
  __typename?: 'CreateActivityCommentPayload';
  activityComment: ActivityCommentEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountTypePayload  {
  __typename?: 'CreateAccountTypePayload';
  accountType: AccountTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountSocialRelationPayload  {
  __typename?: 'CreateAccountSocialRelationPayload';
  accountSocialRelation: AccountSocialRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountSharingSalesUnitRelationPayload  {
  __typename?: 'CreateAccountSharingSalesUnitRelationPayload';
  accountSharingSalesUnitRelation: AccountSharingSalesUnitRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountSharingClientRelationPayload  {
  __typename?: 'CreateAccountSharingClientRelationPayload';
  accountSharingClientRelation: AccountSharingClientRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountRolePayload  {
  __typename?: 'CreateAccountRolePayload';
  accountRole: AccountRoleEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountRelationTypePayload  {
  __typename?: 'CreateAccountRelationTypePayload';
  accountRelationType: AccountRelationTypeEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountRelationPayload  {
  __typename?: 'CreateAccountRelationPayload';
  accountRelation: AccountRelationEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountRelationLabelPayload  {
  __typename?: 'CreateAccountRelationLabelPayload';
  accountRelationLabel: AccountRelationLabelEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountProfilePayload  {
  __typename?: 'CreateAccountProfilePayload';
  clientMutationId: string | null;
  profile: AccountPreviewScreenProfile | null;
}

export interface CreateAccountProductPricingPayload  {
  __typename?: 'CreateAccountProductPricingPayload';
  accountProductPricing: AccountProductPricingEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountPayload  {
  __typename?: 'CreateAccountPayload';
  account: AccountEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountKPIPayload  {
  __typename?: 'CreateAccountKPIPayload';
  accountKpi: AccountKPIEntity | null;
  clientMutationId: string | null;
}

export interface CreateAccountArchiveProfilePayload  {
  __typename?: 'CreateAccountArchiveProfilePayload';
  clientMutationId: string | null;
  profile: AccountArchiveScreenProfile | null;
}

export interface CpClientEntityEdge  {
  __typename?: 'CpClientEntityEdge';
  cursor: string;
  node: CpClientEntity | null;
}

export interface CpClientEntityConnection  {
  __typename?: 'CpClientEntityConnection';
  edges: CpClientEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CpClientEntity  {
  __typename?: 'CpClientEntity';
  email: string | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: ReadOnlyPermsEnum[];
  isDeleted: boolean | null;
  spaces: TeamSpaceEntityConnection | null;
}

export interface CpCallingEntity  {
  __typename?: 'CpCallingEntity';
  aiCosts: number | null;
  credit: number | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: CRUDLicEntityPermsEnum[];
  remainingCredit: number | null;
}

export interface CopyTaskTypePayload  {
  __typename?: 'CopyTaskTypePayload';
  clientMutationId: string | null;
  result: TaskTypeEntity | null;
}

export interface CopyTaskPayload  {
  __typename?: 'CopyTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface CopyTargetPayload  {
  __typename?: 'CopyTargetPayload';
  clientMutationId: string | null;
  target: TargetEntity | null;
}

export interface CopyReportPayload  {
  __typename?: 'CopyReportPayload';
  clientMutationId: string | null;
  result: ReportEntity | null;
}

export interface CopyQuoteTypePayload  {
  __typename?: 'CopyQuoteTypePayload';
  clientMutationId: string | null;
  result: QuoteTypeEntity | null;
}

export interface CopyQuoteStaticProfilePayload  {
  __typename?: 'CopyQuoteStaticProfilePayload';
  clientMutationId: string | null;
  profile: QuotePreviewScreenProfile | null;
}

export interface CopyQuoteProcessPayload  {
  __typename?: 'CopyQuoteProcessPayload';
  clientMutationId: string | null;
  result: QuoteProcessEntity | null;
}

export interface CopyQuotePayload  {
  __typename?: 'CopyQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface CopyProjectTypePayload  {
  __typename?: 'CopyProjectTypePayload';
  clientMutationId: string | null;
  result: ProjectTypeEntity | null;
}

export interface CopyProjectStaticProfilePayload  {
  __typename?: 'CopyProjectStaticProfilePayload';
  clientMutationId: string | null;
  profile: ProjectPreviewScreenProfile | null;
}

export interface CopyProjectPayload  {
  __typename?: 'CopyProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity | null;
}

export interface CopyProjectObjectivePayload  {
  __typename?: 'CopyProjectObjectivePayload';
  clientMutationId: string | null;
  result: ProjectObjectiveEntity | null;
}

export interface CopyProductTypePayload  {
  __typename?: 'CopyProductTypePayload';
  clientMutationId: string | null;
  result: ProductTypeEntity | null;
}

export interface CopyProcessPayload  {
  __typename?: 'CopyProcessPayload';
  clientMutationId: string | null;
  result: ProcessEntity | null;
}

export interface CopyPipelinePayload  {
  __typename?: 'CopyPipelinePayload';
  clientMutationId: string | null;
  result: PipelineEntity | null;
}

export interface CopyOpportunityStaticProfilePayload  {
  __typename?: 'CopyOpportunityStaticProfilePayload';
  clientMutationId: string | null;
  profile: OpportunityPreviewScreenProfile | null;
}

export interface CopyOpportunityPayload  {
  __typename?: 'CopyOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface CopyNotePayload  {
  __typename?: 'CopyNotePayload';
  clientMutationId: string | null;
  result: NoteEntity | null;
}

export interface CopyLeadTypePayload  {
  __typename?: 'CopyLeadTypePayload';
  clientMutationId: string | null;
  result: LeadTypeEntity | null;
}

export interface CopyLeadStaticProfilePayload  {
  __typename?: 'CopyLeadStaticProfilePayload';
  clientMutationId: string | null;
  profile: LeadPreviewScreenProfile | null;
}

export interface CopyLeadProcessPayload  {
  __typename?: 'CopyLeadProcessPayload';
  clientMutationId: string | null;
  result: LeadProcessEntity | null;
}

export interface CopyLeadPayload  {
  __typename?: 'CopyLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface CopyCustomEntityTypePayload  {
  __typename?: 'CopyCustomEntityTypePayload';
  clientMutationId: string | null;
  result: CustomEntityTypeEntity | null;
}

export interface CopyCustomEntityStaticProfilePayload  {
  __typename?: 'CopyCustomEntityStaticProfilePayload';
  clientMutationId: string | null;
  profile: CustomEntityPreviewScreenProfile | null;
}

export interface CopyCustomEntityPayload  {
  __typename?: 'CopyCustomEntityPayload';
  clientMutationId: string | null;
  result: CustomEntityEntity | null;
}

export interface CopyContactTypePayload  {
  __typename?: 'CopyContactTypePayload';
  clientMutationId: string | null;
  result: ContactTypeEntity | null;
}

export interface CopyContactStaticProfilePayload  {
  __typename?: 'CopyContactStaticProfilePayload';
  clientMutationId: string | null;
  profile: ContactPreviewScreenProfile | null;
}

export interface CopyContactPayload  {
  __typename?: 'CopyContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface CopyAppointmentTypePayload  {
  __typename?: 'CopyAppointmentTypePayload';
  clientMutationId: string | null;
  result: AppointmentTypeEntity | null;
}

export interface CopyAppointmentPayload  {
  __typename?: 'CopyAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface CopyApiAccessPayload  {
  __typename?: 'CopyApiAccessPayload';
  clientMutationId: string | null;
  result: ApiAccessEntity | null;
}

export interface CopyAccountTypePayload  {
  __typename?: 'CopyAccountTypePayload';
  clientMutationId: string | null;
  result: AccountTypeEntity | null;
}

export interface CopyAccountStaticProfilePayload  {
  __typename?: 'CopyAccountStaticProfilePayload';
  clientMutationId: string | null;
  profile: AccountPreviewScreenProfile | null;
}

export interface CopyAccountPayload  {
  __typename?: 'CopyAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface ConvertedCurrencyField  {
  __typename?: 'ConvertedCurrencyField';
  fieldId: UUID;
  id: UUID;
}

export interface ConvertTaskPayload  {
  __typename?: 'ConvertTaskPayload';
  clientMutationId: string | null;
  task: TaskEntity;
}

export interface ConvertQuotePayload  {
  __typename?: 'ConvertQuotePayload';
  clientMutationId: string | null;
  quote: QuoteEntity;
}

export interface ConvertProjectPayload  {
  __typename?: 'ConvertProjectPayload';
  clientMutationId: string | null;
  project: ProjectEntity;
}

export interface ConvertOpportunityPayload  {
  __typename?: 'ConvertOpportunityPayload';
  clientMutationId: string | null;
  opportunity: OpportunityEntity;
}

export interface ConvertLeadPayload  {
  __typename?: 'ConvertLeadPayload';
  clientMutationId: string | null;
  lead: LeadEntity;
}

export interface ConvertCustomEntityPayload  {
  __typename?: 'ConvertCustomEntityPayload';
  clientMutationId: string | null;
  customEntity: CustomEntityEntity;
}

export interface ConvertContactPayload  {
  __typename?: 'ConvertContactPayload';
  clientMutationId: string | null;
  contact: ContactEntity;
}

export interface ConvertAppointmentPayload  {
  __typename?: 'ConvertAppointmentPayload';
  appointment: AppointmentEntity;
  clientMutationId: string | null;
}

export interface ConvertAccountPayload  {
  __typename?: 'ConvertAccountPayload';
  account: AccountEntity;
  clientMutationId: string | null;
}

export interface ConversionsScreenProfile extends ProfileInterface {
  __typename?: 'ConversionsScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ConversionsProfile;
  useLang: boolean;
}

export interface ConversionsScreen extends ProfileScreen, Screen {
  __typename?: 'ConversionsScreen';
  activeProfile: ConversionsScreenProfile;
  data: ConversionsData | null;
  draftProfile: ConversionsScreenProfile | null;
  name: string;
  profiles: ConversionsScreenProfile[];
}

export interface ConversionsProfileViewTab  {
  __typename?: 'ConversionsProfileViewTab';
  calculateOpptyByFieldId: UUID | null;
  conversionValue: ConversionValueType;
  period: PeriodOption;
  reportBy: ConversionReportBy;
}

export interface ConversionsProfile extends OpportunityKPIProfileInterface, PipelineProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface {
  __typename?: 'ConversionsProfile';
  filter: OpportunityKPIFilterTab;
  leadProcess: UUID[] | null;
  quickFilter: QuickFilterTab;
  salesPipeline: ID[] | null;
  view: ConversionsProfileViewTab;
}

export interface ConversionsOpportunityCountTakenPath  {
  __typename?: 'ConversionsOpportunityCountTakenPath';
  lost: number;
  open: number;
  path: number;
  won: number;
}

export interface ConversionsOpportunityCountCreatedPath  {
  __typename?: 'ConversionsOpportunityCountCreatedPath';
  lost: number;
  open: number;
  path: number;
  reassigned: number;
  won: number;
}

export interface ConversionsOpportunityAmountTakenPath  {
  __typename?: 'ConversionsOpportunityAmountTakenPath';
  lost: number;
  open: number;
  path: number;
  won: number;
}

export interface ConversionsOpportunityAmountCreatedPath  {
  __typename?: 'ConversionsOpportunityAmountCreatedPath';
  lost: number;
  open: number;
  path: number;
  reassigned: number;
  won: number;
}

export interface ConversionsLeadCountTakenPath  {
  __typename?: 'ConversionsLeadCountTakenPath';
  lost: number;
  lostQualified: number;
  openNotQualified: number;
  openQualified: number;
  path: number;
  qualified: number;
  reassignedQualified: number;
  wonQualified: number;
}

export interface ConversionsData  {
  __typename?: 'ConversionsData';
  conversionTrendItems: ConversionItemGraph;
  createdLeads: ConversionLeadCreatedPath;
  createdOpportunities: ConversionsOpportunityCreatedPath;
  drillDownIds: ID[];
  drilldown: DrilldownModel;
  takenLeads: ConversionsLeadTakenPath;
  takenOpportunities: ConversionsOpportunityTakenPath;
}

export interface ConversionLeadCountCreatedPath  {
  __typename?: 'ConversionLeadCountCreatedPath';
  lost: number;
  lostQualified: number;
  openNotQualified: number;
  openQualified: number;
  path: number;
  qualified: number;
  reassignedNotQualified: number;
  reassignedQualified: number;
  wonQualified: number;
}

export interface ConversionLeadAmountPath  {
  __typename?: 'ConversionLeadAmountPath';
  lostQualified: number;
  openQualified: number;
  qualified: number;
  reassignedQualified: number;
  wonQualified: number;
}

export interface ConversionItemGraph  {
  __typename?: 'ConversionItemGraph';
  lost: ConversionGraphItem[];
  open: ConversionGraphItem[];
  reassigned: ConversionGraphItem[];
  won: ConversionGraphItem[];
}

export interface ConversionGraphCountItem  {
  __typename?: 'ConversionGraphCountItem';
  date: GqlDate;
  value: number;
}

export interface ConversionGraphAmountItem  {
  __typename?: 'ConversionGraphAmountItem';
  date: GqlDate;
  value: number;
}

export interface ContextPanelListing  {
  __typename?: 'ContextPanelListing';
  groups: ViewItemGroup[];
  snapshotContextPanelListing: SnapshotIndexedDataInterfaceImplementors | null;
}

export interface ContactTypeRepository  {
  __typename?: 'ContactTypeRepository';
  getAll: ContactTypeEntity[];
  getByCriteria: ContactTypeEntityConnection | null;
  getById: ContactTypeEntity | null;
  getByIds: ContactTypeEntity[];
  getDraftById: ContactTypeEntity;
  getDrafts: ContactTypeEntity[];
  getPublished: ContactTypeEntity[];
}

export interface ContactTypeEntityEdge  {
  __typename?: 'ContactTypeEntityEdge';
  cursor: string;
  node: ContactTypeEntity | null;
}

export interface ContactTypeEntityConnection  {
  __typename?: 'ContactTypeEntityConnection';
  edges: ContactTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactTypeEntity  {
  __typename?: 'ContactTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface ContactTableReportProfile extends ContactProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'ContactTableReportProfile';
  filter: ContactFilterTab;
  quickFilter: QuickFilterTab;
  role: ContactRoleTab;
  view: ViewTableReportTab;
}

export interface ContactTabDataGridViewOptions  {
  __typename?: 'ContactTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByStats: AccountContactTabDataGridQuickFilter | null;
  filterByTags: ID[] | null;
  relatedContacts: boolean;
  searchQuery: string | null;
  showArchivedRecords: boolean | null;
}

export interface ContactTabDataGridView  {
  __typename?: 'ContactTabDataGridView';
  ofAccount: AccountContactTabDataGridView;
}

export interface ContactSocialRelationRepository  {
  __typename?: 'ContactSocialRelationRepository';
  getAll: ContactSocialRelationEntity[];
  getByCriteria: ContactSocialRelationEntityConnection | null;
  getById: ContactSocialRelationEntity | null;
  getByIds: ContactSocialRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactSocialRelationEntityEdge  {
  __typename?: 'ContactSocialRelationEntityEdge';
  cursor: string;
  node: ContactSocialRelationEntity | null;
}

export interface ContactSocialRelationEntityConnection  {
  __typename?: 'ContactSocialRelationEntityConnection';
  edges: ContactSocialRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactSocialRelationEntity  {
  __typename?: 'ContactSocialRelationEntity';
  angellistUrl: string | null;
  created: DateTime | null;
  crunchbaseUrl: string | null;
  disqusUrl: string | null;
  facebookId: string | null;
  facebookUrl: string | null;
  flickrUrl: string | null;
  foursquareUrl: string | null;
  googleId: string | null;
  googlePlusUrl: string | null;
  gravatarUrl: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kloutUrl: string | null;
  linkedinId: string | null;
  linkedinUrl: string | null;
  modified: DateTime | null;
  pinterestUrl: string | null;
  quoraUrl: string | null;
  redditUrl: string | null;
  revision: number | null;
  skypeUrl: string | null;
  slideshareUrl: string | null;
  twitterId: string | null;
  twitterUrl: string | null;
  vimeoUrl: string | null;
  wordpressUrl: string | null;
  xingUrl: string | null;
  yahooUrl: string | null;
  yelpUrl: string | null;
  youtubeUrl: string | null;
}

export interface ContactSharingSalesUnitRelationRepository  {
  __typename?: 'ContactSharingSalesUnitRelationRepository';
  getAll: ContactSharingSalesUnitRelationEntity[];
  getByCriteria: ContactSharingSalesUnitRelationEntityConnection | null;
  getById: ContactSharingSalesUnitRelationEntity | null;
  getByIds: ContactSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactSharingSalesUnitRelationEntityEdge  {
  __typename?: 'ContactSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: ContactSharingSalesUnitRelationEntity | null;
}

export interface ContactSharingSalesUnitRelationEntityConnection  {
  __typename?: 'ContactSharingSalesUnitRelationEntityConnection';
  edges: ContactSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactSharingSalesUnitRelationEntity  {
  __typename?: 'ContactSharingSalesUnitRelationEntity';
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface ContactSharingClientRelationRepository  {
  __typename?: 'ContactSharingClientRelationRepository';
  getAll: ContactSharingClientRelationEntity[];
  getByCriteria: ContactSharingClientRelationEntityConnection | null;
  getById: ContactSharingClientRelationEntity | null;
  getByIds: ContactSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactSharingClientRelationEntityEdge  {
  __typename?: 'ContactSharingClientRelationEntityEdge';
  cursor: string;
  node: ContactSharingClientRelationEntity | null;
}

export interface ContactSharingClientRelationEntityConnection  {
  __typename?: 'ContactSharingClientRelationEntityConnection';
  edges: ContactSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactSharingClientRelationEntity  {
  __typename?: 'ContactSharingClientRelationEntity';
  client: ClientEntity | null;
  clientId: ID;
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface ContactSearchResultItem extends SearchResultItemInterface {
  __typename?: 'ContactSearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  pictureUrl: string | null;
  primaryAccountName: string | null;
  primaryAccountPosition: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
}

export interface ContactRoleTab extends RoleTabInterface {
  __typename?: 'ContactRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface ContactRepository  {
  __typename?: 'ContactRepository';
  aiAutoPrefill: ContactAutoPrefill;
  autoPrefill: ContactEntity;
  getAll: ContactEntity[];
  getByCriteria: ContactEntityConnection | null;
  getById: ContactEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: ContactEntity[];
  getBySession: ContactEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getRelatedToAccount: ContactEntity[];
}

export interface ContactRelationTypeRepository  {
  __typename?: 'ContactRelationTypeRepository';
  getAll: ContactRelationTypeEntity[];
  getByCriteria: ContactRelationTypeEntity[];
  getById: ContactRelationTypeEntity | null;
  getByIds: ContactRelationTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactRelationTypeEntity  {
  __typename?: 'ContactRelationTypeEntity';
  color: number;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  label: string | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface ContactRelationRepository  {
  __typename?: 'ContactRelationRepository';
  getAll: ContactRelationEntity[];
  getByCriteria: ContactRelationEntity[];
  getById: ContactRelationEntity | null;
  getByIds: ContactRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactRelationLabelRepository  {
  __typename?: 'ContactRelationLabelRepository';
  getAll: ContactRelationLabelEntity[];
  getByCriteria: ContactRelationLabelEntity[];
  getById: ContactRelationLabelEntity | null;
  getByIds: ContactRelationLabelEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactRelationLabelEntity  {
  __typename?: 'ContactRelationLabelEntity';
  contactRelation: ContactRelationEntity | null;
  contactRelationId: ID;
  contactRelationType: ContactRelationTypeEntity | null;
  contactRelationTypeId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface ContactRelationGraphEdgeEntity  {
  __typename?: 'ContactRelationGraphEdgeEntity';
  account: AccountEntity | null;
  accountId: UUID | null;
  accountRelation: OrgChartContactRelation | null;
  accountRoles: AccountRoleEntity[];
  contact: ContactEntity;
  contactId: UUID;
  labels: ContactRelationTypeEntity[] | null;
  parentId: UUID | null;
  relationship: OrgRelationshipTypeEnum;
}

export interface ContactRelationEntity  {
  __typename?: 'ContactRelationEntity';
  contact1: ContactEntity | null;
  contact1Id: ID;
  contact2: ContactEntity | null;
  contact2Id: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface ContactRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface, RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: 'ContactRecentlyOpenedResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  openedAt: DateTime;
  pictureUrl: string | null;
  primaryAccountName: string | null;
  primaryAccountPosition: string | null;
  primaryEmail: string;
  primaryPhone: string;
}

export interface ContactQuoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactQuoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactProjectTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactProjectTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactProfileData  {
  __typename?: 'ContactProfileData';
  compactViewItems: ContactCompactViewItems;
  listViewItems: ContactDataGridViewItems;
  mapViewItems: ContactMapViewItems;
}

export interface ContactPreviewViewTab  {
  __typename?: 'ContactPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ContactPreviewScreenProfile extends ProfileInterface {
  __typename?: 'ContactPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ContactPreviewProfile;
  useLang: boolean;
}

export interface ContactPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'ContactPreviewScreen';
  activeProfile: ContactPreviewScreenProfile;
  data: ContactProfileData;
  draftProfile: ContactPreviewScreenProfile | null;
  entityData: ContactEntityData | null;
  item: ContactItem | null;
  name: string;
  profiles: ContactPreviewScreenProfile[];
}

export interface ContactPreviewProfile extends ContactProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'ContactPreviewProfile';
  filter: ContactFilterTab;
  quickFilter: QuickFilterTab;
  role: ContactRoleTab;
  view: ContactPreviewViewTab;
}

export interface ContactPivotReportProfile extends ContactProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'ContactPivotReportProfile';
  filter: ContactFilterTab;
  quickFilter: QuickFilterTab;
  role: ContactRoleTab;
  view: ViewPivotReportTab;
}

export interface ContactOpportunityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactOpportunityTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: OpportunityTabDataGridViewStat[];
  total: number;
}

export interface ContactNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactMapViewItems  {
  __typename?: 'ContactMapViewItems';
  compactListSessionId: string | null;
  isResultTooLarge: boolean;
  items: MapViewInterfaceImplementors[];
  missingGeoLocationItems: number | null;
}

export interface ContactListView extends ListViewInterface {
  __typename?: 'ContactListView';
  displayColumn: UUID[];
  profile: ContactPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface ContactLineOfInfluence  {
  __typename?: 'ContactLineOfInfluence';
  comment: string | null;
  contact1Id: UUID;
  contact2Id: UUID;
  type: InfluenceTypeEnum | null;
}

export interface ContactLeadTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactLeadTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: LeadTabDataGridViewStat[];
  total: number;
}

export interface ContactKPIRepository  {
  __typename?: 'ContactKPIRepository';
  getAll: ContactKPIEntity[];
  getByCriteria: ContactKPIEntityConnection | null;
  getById: ContactKPIEntity | null;
  getByIds: ContactKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactKPIEntityEdge  {
  __typename?: 'ContactKPIEntityEdge';
  cursor: string;
  node: ContactKPIEntity | null;
}

export interface ContactKPIEntityConnection  {
  __typename?: 'ContactKPIEntityConnection';
  edges: ContactKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactKPIEntity  {
  __typename?: 'ContactKPIEntity';
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: ContactKpiEnum;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
}

export interface ContactItem  {
  __typename?: 'ContactItem';
  compactViewItem: ContactCompactViewItem | null;
  listViewItem: DataGridViewItem;
}

export interface ContactFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'ContactFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ContactFeedTabDataGridView  {
  __typename?: 'ContactFeedTabDataGridView';
  feed: Feed;
}

export interface ContactFeedEmailTabDataGridView  {
  __typename?: 'ContactFeedEmailTabDataGridView';
  feed: Feed;
}

export interface ContactFavoriteResultItem extends FavoriteResultItemInterface, FavoriteResultItemIsArchivedInterface {
  __typename?: 'ContactFavoriteResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  name: string;
  pictureUrl: string | null;
  primaryAccountName: string | null;
  primaryAccountPosition: string | null;
  primaryEmail: string;
  primaryPhone: string;
}

export interface ContactEntityEdge  {
  __typename?: 'ContactEntityEdge';
  cursor: string;
  node: ContactEntity | null;
}

export interface ContactEntityData  {
  __typename?: 'ContactEntityData';
  businessOverview: BusinessOverview | null;
  colleagues: ContactEntity[];
  documents: CloudObjectRelationEntityConnection | null;
  entity: ContactEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastContacted: LastContactedItem | null;
  lastMessages: MessageRelationEntityConnection | null;
  leads: LeadOpptyContactRelationEntityConnection | null;
  notes: NoteEntityConnection | null;
  openLeads: LeadOpptyContactRelationEntityConnection | null;
  openOpportunities: LeadOpptyContactRelationEntityConnection | null;
  opportunities: LeadOpptyContactRelationEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  relationGraph: ContactRelationGraphEdgeEntity[];
  relations: OrgChartRelation[];
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface ContactEntityConnection  {
  __typename?: 'ContactEntityConnection';
  edges: ContactEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactEntity  {
  __typename?: 'ContactEntity';
  accountPosition: string | null;
  accountRelations: ContactAccountRelationEntityConnection | null;
  address: string | null;
  approval: ApprovalEntity | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  city: string | null;
  comments: string | null;
  contactType: ContactTypeEntity | null;
  contactTypeId: ID | null;
  country: string | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  documents: CloudObjectRelationEntityConnection | null;
  email1: string | null;
  email2: string | null;
  email3: string | null;
  email4: string | null;
  email5: string | null;
  enrolledEmailSequences: number;
  exchangeEntityId: string | null;
  fields: InterfaceFieldDataImplementors[];
  firstName: string | null;
  formattedName: string;
  gapiEntityId: string | null;
  gender: GenderEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isArchived: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  isUnsubscribed: boolean | null;
  lastName: string | null;
  middleName: string | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  o365EntityId: string | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  phone1: string | null;
  phone2: string | null;
  phone3: string | null;
  phone4: string | null;
  phone5: string | null;
  picture: CloudObjectEntity | null;
  pictureId: ID | null;
  position: string | null;
  primaryAccount: AccountEntity | null;
  primaryAccountAccountRoles: ContactAccountAccountRoleRelationEntity[] | null;
  primaryAccountPosition: string | null;
  primaryAccountRelationship: string | null;
  quickAccountName: string | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: ContactSharingClientRelationEntityConnection | null;
  sharingUnits: ContactSharingSalesUnitRelationEntityConnection | null;
  socialMedia: ContactSocialRelationEntity | null;
  stateProvince: string | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  tags: TagRelationEntityConnection | null;
  title: string | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
  zipCode: string | null;
}

export interface ContactDrilldownFilter  {
  __typename?: 'ContactDrilldownFilter';
  ownerId: ID[] | null;
}

export interface ContactDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactDataExRelationRepository  {
  __typename?: 'ContactDataExRelationRepository';
  getAll: ContactDataExRelationEntity[];
  getByCriteria: ContactDataExRelationEntityConnection | null;
  getById: ContactDataExRelationEntity | null;
  getByIds: ContactDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactDataExRelationEntityEdge  {
  __typename?: 'ContactDataExRelationEntityEdge';
  cursor: string;
  node: ContactDataExRelationEntity | null;
}

export interface ContactDataExRelationEntityConnection  {
  __typename?: 'ContactDataExRelationEntityConnection';
  edges: ContactDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactDataExRelationEntity  {
  __typename?: 'ContactDataExRelationEntity';
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface ContactDashboardView  {
  __typename?: 'ContactDashboardView';
  data: DashboardGraphItemInterfaceImplementors[] | null;
}

export interface ContactDashboardProfileView extends DashboardViewInterface {
  __typename?: 'ContactDashboardProfileView';
  drilldownFields: ID[];
  graphs: DashboardGraphContactNameType[];
}

export interface ContactDashboardProfileTab extends DashboardTabItem {
  __typename?: 'ContactDashboardProfileTab';
  contactDashboardProfile: ContactDashboardProfile | null;
  id: ID;
}

export interface ContactDashboardProfile extends ContactProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, RoleProfileInterface {
  __typename?: 'ContactDashboardProfile';
  filter: ContactFilterTab;
  role: ContactRoleTab;
  view: ContactDashboardProfileView;
}

export interface ContactCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactCompactViewItems';
  groups: ViewItemGroup[];
  items: ContactCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactCompactViewItem extends ViewItemInterface {
  __typename?: 'ContactCompactViewItem';
  address: string | null;
  city: string | null;
  contactPicture: string | null;
  contactTypeId: ID;
  country: string | null;
  email: string | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  id: ID;
  isFavorite: boolean | null;
  name: string;
  owner: string;
  ownerId: string;
  ownerPicture: string | null;
  phone: string | null;
  primaryAccountId: string | null;
  primaryAccountJobTitle: string | null;
  primaryAccountName: string | null;
  primaryAccountPicture: string | null;
  relatedAccounts: EntityIdNamePair[];
  sortFieldValue: FieldDataContainer | null;
  stateProvince: string | null;
  unit: string;
  unitId: string;
  unitPicture: string | null;
  zipCode: string | null;
}

export interface ContactCompactView extends CompactViewInterface {
  __typename?: 'ContactCompactView';
  feedListingOptions: FeedTabDataGridViewOptions;
  profile: ContactPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface ContactCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactCardProperty  {
  __typename?: 'ContactCardProperty';
  showArchivedRecords: boolean;
}

export interface ContactAutoPrefill  {
  __typename?: 'ContactAutoPrefill';
  entity: ContactEntity | null;
  fieldIds: UUID[];
}

export interface ContactArchiveScreenProfile extends ProfileInterface {
  __typename?: 'ContactArchiveScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ContactArchiveProfile;
  useLang: boolean;
}

export interface ContactArchiveScreen extends ProfileScreen, Screen {
  __typename?: 'ContactArchiveScreen';
  activeProfile: ContactArchiveScreenProfile;
  data: ContactArchiveProfileData;
  draftProfile: ContactArchiveScreenProfile | null;
  entityData: ContactArchiveEntityData | null;
  item: ArchiveContactItem | null;
  name: string;
  profiles: ContactArchiveScreenProfile[];
}

export interface ContactArchiveProfileData  {
  __typename?: 'ContactArchiveProfileData';
  listViewItems: ContactArchiveDataGridViewItems;
}

export interface ContactArchiveProfile extends ContactProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'ContactArchiveProfile';
  filter: ContactFilterTab;
  quickFilter: QuickFilterTab;
  role: ContactRoleTab;
  view: ContactPreviewViewTab;
}

export interface ContactArchiveEntityData  {
  __typename?: 'ContactArchiveEntityData';
  entity: ContactEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface ContactArchiveDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactArchiveDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ContactActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'ContactActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface ContactActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ContactActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface ContactActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'ContactActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface ContactAccountRelationRepository  {
  __typename?: 'ContactAccountRelationRepository';
  getAll: ContactAccountRelationEntity[];
  getByCriteria: ContactAccountRelationEntityConnection | null;
  getById: ContactAccountRelationEntity | null;
  getByIds: ContactAccountRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactAccountRelationEntityEdge  {
  __typename?: 'ContactAccountRelationEntityEdge';
  cursor: string;
  node: ContactAccountRelationEntity | null;
}

export interface ContactAccountRelationEntityConnection  {
  __typename?: 'ContactAccountRelationEntityConnection';
  edges: ContactAccountRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactAccountRelationEntity  {
  __typename?: 'ContactAccountRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  accountRoles: ContactAccountAccountRoleRelationEntity[] | null;
  comment: string | null;
  contact: ContactEntity | null;
  contactId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isAssistant: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPrimary: boolean;
  isSibling: boolean | null;
  modified: DateTime | null;
  position: string | null;
  relationship: OrgRelationshipTypeEnum | null;
  revision: number | null;
}

export interface ContactAccountCardProperty  {
  __typename?: 'ContactAccountCardProperty';
  showArchivedRecords: boolean;
}

export interface ContactAccountAccountRoleRelationRepository  {
  __typename?: 'ContactAccountAccountRoleRelationRepository';
  getAll: ContactAccountAccountRoleRelationEntity[];
  getByCriteria: ContactAccountAccountRoleRelationEntityConnection | null;
  getById: ContactAccountAccountRoleRelationEntity | null;
  getByIds: ContactAccountAccountRoleRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ContactAccountAccountRoleRelationEntityEdge  {
  __typename?: 'ContactAccountAccountRoleRelationEntityEdge';
  cursor: string;
  node: ContactAccountAccountRoleRelationEntity | null;
}

export interface ContactAccountAccountRoleRelationEntityConnection  {
  __typename?: 'ContactAccountAccountRoleRelationEntityConnection';
  edges: ContactAccountAccountRoleRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ContactAccountAccountRoleRelationEntity  {
  __typename?: 'ContactAccountAccountRoleRelationEntity';
  accountRole: AccountRoleEntity | null;
  accountRoleId: ID;
  contactAccountRelation: ContactAccountRelationEntity | null;
  contactAccountRelationId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface ConfigureTeamPipelineHubItemPayload  {
  __typename?: 'ConfigureTeamPipelineHubItemPayload';
  clientMutationId: string | null;
  result: TeamPipelineHubInterfaceImplementors | null;
}

export interface ConfigureSyncIntegrationTeamPipelineHubItemPayload  {
  __typename?: 'ConfigureSyncIntegrationTeamPipelineHubItemPayload';
  clientMutationId: string | null;
  result: TeamPipelineHubInterfaceImplementors | null;
}

export interface ConferencingCommonSettingsOutput  {
  __typename?: 'ConferencingCommonSettingsOutput';
  email: string | null;
  enabled: ServiceStatus;
  errorCode: number;
  imageUrl: string | null;
  name: string | null;
}

export interface CompanyEmailRepository  {
  __typename?: 'CompanyEmailRepository';
  getAll: CompanyEmailEntity[];
  getAllForAdmin: CompanyEmailEntity[];
  getByCriteria: CompanyEmailEntityConnection | null;
  getById: CompanyEmailEntity | null;
  getByIds: CompanyEmailEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CompanyEmailEntityEdge  {
  __typename?: 'CompanyEmailEntityEdge';
  cursor: string;
  node: CompanyEmailEntity | null;
}

export interface CompanyEmailEntityConnection  {
  __typename?: 'CompanyEmailEntityConnection';
  edges: CompanyEmailEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CompanyEmailEntity  {
  __typename?: 'CompanyEmailEntity';
  created: DateTime | null;
  email: string | null;
  enabled: boolean;
  errorCode: number | null;
  features: EmailAccountFeatureEnum[];
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  limits: EmailAccountLimit;
  modified: DateTime | null;
  name: string;
  pictureUrl: string | null;
  serviceType: EmailServiceTypeEnum;
  settings: JSONString | null;
  token: string | null;
}

export interface CompanyDocumentsDataGridViewItems extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CompanyDocumentsDataGridViewItems';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface CompactViewDrilldownModel  {
  __typename?: 'CompactViewDrilldownModel';
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface ColumnFormattingFieldFilterRule extends ColumnFormattingFilterFieldRuleInterface {
  __typename?: 'ColumnFormattingFieldFilterRule';
  boxId: ID | null;
  color: number | null;
  field: string | null;
  id: UUID | null;
  operator: FieldOperator | null;
  values: string[][] | null;
}

export interface ColumnFormatting  {
  __typename?: 'ColumnFormatting';
  filterFields: ColumnFormattingFieldFilterRule[];
  isEnabled: boolean;
}

export interface CollectionsRegistry  {
  __typename?: 'CollectionsRegistry';
  advancedFormulaData: AdvancedFormulaDataResult[];
  advancedMergeListing: AdvancedMergeListing | null;
  aiPromptTitle: string;
  aiSmartValuePreview: AiSmartValuePreview | null;
  aiSmartValueUpdate: AiSmartValueUpdateStatus | null;
  aiUpdateOnlineFormPromptSuggestions: AiPromptSuggestion[];
  aiUpdateProcessPromptSuggestions: AiPromptSuggestion[];
  aiUpdateReportPromptSuggestions: AiPromptSuggestion[];
  allSendersListing: AllSendersListing;
  allUsedCountries: string[] | null;
  asyncJobStatus: AsyncJobStatus;
  calendarItems: ActivityDetailCalendarViewItems | null;
  clientIntegration: ClientIntegrationData[];
  contextPanelListing: ContextPanelListing | null;
  customEntityDescriptors: CustomEntityDescriptor[];
  drilldownScheduledAppointments: ActivityDrilldownModel;
  duplicateCheckerCount: DuplicateCheckerCountResult;
  duplicateCheckerEntityDrilldown: EntityDrilldownModel;
  duplicateCheckerSettings: DuplicateCheckerEntitySettings[];
  duplicatesListing: DuplicatesListingGridViewItems;
  emailPersonalAccounts: PersonalEmailAccount[];
  entitiesInSession: EntityCount[];
  entityCountInSession: number;
  entityDetailCount: number | null;
  entityDrilldown: EntityDrilldownModel;
  entityIdsInSession: ID[];
  entityRevisionInfo: EntityRevisionInfo[];
  entitySessionDrilldown: EntityDrilldownModel;
  entityStepSummary: EntityStepSummary | null;
  fieldDescriptor: FieldDescriptor | null;
  fieldDescriptors: FieldDescriptor[] | null;
  fieldOriginEntities: EntityNameEnum[] | null;
  fieldPermissionSharing: UUID[];
  fileTypeExtensions: FileTypeExtension[];
  filterFieldDescriptors: FilterFieldRelation[];
  filterRecords: FilterResult;
  findNewRecordDuplicates: DuplicateCheckerItem[];
  findRecordDuplicates: DuplicateCheckerItem[];
  fitnessDescriptionChangeLog: FitnessDescriptionChangeLog;
  getReport: GetReportResult;
  getTranslations: Translation[];
  hasEmailSequenceInfiniteLoop: boolean | null;
  hasFieldsFormsDrafts: HasEntityDraft[];
  hasProcessInfiniteLoop: boolean | null;
  healthAnalysis: EntityHealthAnalysis;
  inlineEditConditionalFieldInfo: InlineEditConditionalFieldInfo | null;
  integrationStatus: IntegrationEventStatusEnum | null;
  isAppointmentScheduleUrlVacant: boolean;
  listRollupRelationAggregationFields: FieldEntity[];
  listRollupRelationSortByFields: FieldEntity[];
  listRollupRelations: RollupRelation[];
  listSmartFieldRelations: SmartFieldRelation[];
  locationTrackingMapViewItems: LocationTrackingMapViewItems;
  lookupDataConnection: LookupDataConnection | null;
  lookupDataListing: LookupDataView | null;
  onlineFormPersonificationData: OnlineFormPersonificationDataResult[];
  onlineFormProductsData: OnlineFormProductsDataResult;
  onlineFormProductsDrilldown: OnlineFormProductDrilldownModel;
  pivotFieldDescriptors: FieldDescriptor[] | null;
  previewEntityHealth: PreviewEntityHealthResult[];
  priceListHasOpenOpportunity: boolean;
  productPricing: ProductPricingRegistry;
  profileContextPanelListing: ContextPanelListing | null;
  quickMergeProgress: QuickMergeProgress | null;
  retrieveGroupRecordIndex: number | null;
  retrieveRecordIndex: number | null;
  rollupData: RollupDataResult[];
  rollupSessionId: UUID | null;
  sessionMetadata: SessionMetadata | null;
  snapshotColumnAggrValue: SnapshotColumnAggr;
  snapshotDateRangeListing: SnapshotDateRangedDataInterfaceImplementors | null;
  snapshotIndexedListing: SnapshotIndexedDataInterfaceImplementors | null;
  staticProfileEntityDrilldown: StaticProfileEntityDrilldownModel;
  tagRelatedEntityDrilldown: TagRelatedEntityDrilldownModel;
  targetChartDrilldown: TargetChartDrilldownModel;
  targetMetricsDrilldown: TargetMetricsDrilldownModel;
  validateAdvancedFormula: ValidateAdvancedFormulaPayload;
}

export interface CloudObjectTemplateRepository  {
  __typename?: 'CloudObjectTemplateRepository';
  getAll: CloudObjectTemplateEntity[];
  getByCriteria: CloudObjectTemplateEntityConnection | null;
  getById: CloudObjectTemplateEntity | null;
  getByIds: CloudObjectTemplateEntity[];
  getByIdsForApprovalProcess: CloudObjectTemplateEntity[];
  getByIdsForEmailSequence: CloudObjectTemplateEntity[];
  getByIdsForFieldMapping: CloudObjectTemplateEntity[];
  getByIdsForProcess: CloudObjectTemplateEntity[];
  getByIdsForReportSchedule: CloudObjectTemplateEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getDocumentPreviewUrl: DocumentPreviewUrl;
  getSignedUrls: SignedUrl[];
}

export interface CloudObjectTemplateEntityEdge  {
  __typename?: 'CloudObjectTemplateEntityEdge';
  cursor: string;
  node: CloudObjectTemplateEntity | null;
}

export interface CloudObjectTemplateEntityConnection  {
  __typename?: 'CloudObjectTemplateEntityConnection';
  edges: CloudObjectTemplateEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CloudObjectTemplateEntity  {
  __typename?: 'CloudObjectTemplateEntity';
  application: ApplicationEntity | null;
  applicationId: ID | null;
  companyCloudObjectFolder: CloudObjectFolderEntity | null;
  companyCloudObjectFolderId: ID | null;
  created: DateTime | null;
  creator: ClientEntity | null;
  creatorId: ID | null;
  filename: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublic: boolean | null;
  mimeType: string | null;
  modified: DateTime | null;
  revision: number | null;
  size: number;
  status: CloudObjectTemplateStatusEnum | null;
  templateEntityApiName: string | null;
  templateEntityName: EntityNameEnum;
  type: CloudObjectTypeEnum;
  uploadSource: UploadSourceEnum | null;
  url: string | null;
}

export interface CloudObjectTabDataGridViewOptions  {
  __typename?: 'CloudObjectTabDataGridViewOptions';
  filterByOwnerId: UUID[] | null;
  filterByPeriod: PeriodOption;
  filterByRecordName: string | null;
  filterByRecordType: string[];
  hideEmptyFolders: boolean | null;
  newFolderIds: UUID[] | null;
  relatedDocuments: boolean;
  searchQuery: string | null;
}

export interface CloudObjectTabDataGridView  {
  __typename?: 'CloudObjectTabDataGridView';
  ofAccount: AccountCloudObjectTabDataGridView;
  ofContact: ContactCloudObjectTabDataGridView;
  ofCustomEntity: CustomEntityCloudObjectTabDataGridView;
  ofLead: LeadCloudObjectTabDataGridView;
  ofOpportunity: OpportunityCloudObjectTabDataGridView;
  ofProject: ProjectCloudObjectTabDataGridView;
  ofQuote: QuoteCloudObjectTabDataGridView;
}

export interface CloudObjectStepRelationRepository  {
  __typename?: 'CloudObjectStepRelationRepository';
  getAll: CloudObjectStepRelationEntity[];
  getByCriteria: CloudObjectStepRelationEntityConnection | null;
  getById: CloudObjectStepRelationEntity | null;
  getByIds: CloudObjectStepRelationEntity[];
  getByStepId: CloudObjectStepRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CloudObjectStepRelationEntityEdge  {
  __typename?: 'CloudObjectStepRelationEntityEdge';
  cursor: string;
  node: CloudObjectStepRelationEntity | null;
}

export interface CloudObjectStepRelationEntityConnection  {
  __typename?: 'CloudObjectStepRelationEntityConnection';
  edges: CloudObjectStepRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CloudObjectStepRelationEntity  {
  __typename?: 'CloudObjectStepRelationEntity';
  cloudObject: CloudObjectEntity | null;
  cloudObjectId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  sortOrder: number | null;
  step: StepEntity | null;
  stepId: ID;
}

export interface CloudObjectSearchResultItem extends SearchResultItemInterface {
  __typename?: 'CloudObjectSearchResultItem';
  cloudObjectLinkedEntity: LinkedItemType | null;
  datetime: DateTime | null;
  fileName: string;
  id: ID;
  isDeleted: boolean;
  url: string;
}

export interface CloudObjectRepository  {
  __typename?: 'CloudObjectRepository';
  getAll: CloudObjectEntity[];
  getByCriteria: CloudObjectEntityConnection | null;
  getById: CloudObjectEntity | null;
  getByIds: CloudObjectEntity[];
  getByIdsForApprovalProcess: CloudObjectEntity[];
  getByIdsForEmailSequence: CloudObjectEntity[];
  getByIdsForFieldMapping: CloudObjectEntity[];
  getByIdsForOnlineFormType: CloudObjectEntity[];
  getByIdsForProcess: CloudObjectEntity[];
  getByIdsForReportSchedule: CloudObjectEntity[];
  getBySession: CloudObjectEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getDocumentPreviewUrl: DocumentPreviewUrl;
  getSignedUrls: SignedUrl[];
}

export interface CloudObjectRelationRepository  {
  __typename?: 'CloudObjectRelationRepository';
  getAll: CloudObjectRelationEntity[];
  getByCriteria: CloudObjectRelationEntityConnection | null;
  getById: CloudObjectRelationEntity | null;
  getByIds: CloudObjectRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CloudObjectRelationEntityEdge  {
  __typename?: 'CloudObjectRelationEntityEdge';
  cursor: string;
  node: CloudObjectRelationEntity | null;
}

export interface CloudObjectRelationEntityConnection  {
  __typename?: 'CloudObjectRelationEntityConnection';
  edges: CloudObjectRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CloudObjectRelationEntity  {
  __typename?: 'CloudObjectRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  activityId: ID | null;
  appointment: AppointmentEntity | null;
  approvalProcess: ApprovalProcessEntity | null;
  approvalProcessId: ID | null;
  call: CallEntity | null;
  callId: ID | null;
  cloudObject: CloudObjectEntity | null;
  cloudObjectFolder: CloudObjectFolderEntity | null;
  cloudObjectFolderId: ID | null;
  cloudObjectId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  email: EmailEntity | null;
  emailSequence: EmailSequenceEntity | null;
  emailSequenceId: ID | null;
  emailTemplate: EmailTemplateEntity | null;
  emailTemplateId: ID | null;
  fieldMapping: FieldMappingEntity | null;
  fieldMappingId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  media: MediaEntity | null;
  mediaId: ID | null;
  memo: MemoEntity | null;
  messageId: ID | null;
  modified: DateTime | null;
  onlineForm: OnlineFormEntity | null;
  onlineFormField: FieldEntity | null;
  onlineFormFieldId: ID | null;
  onlineFormId: ID | null;
  oppty: OpportunityEntity | null;
  process: ProcessEntity | null;
  processId: ID | null;
  processTemplate: ProcessTemplateEntity | null;
  processTemplateId: ID | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  reportSchedule: ReportScheduleEntity | null;
  reportScheduleId: ID | null;
  revision: number | null;
  task: TaskEntity | null;
  textMessage: TextMessageEntity | null;
  textMessageId: ID | null;
}

export interface CloudObjectMakePublicPayload  {
  __typename?: 'CloudObjectMakePublicPayload';
  clientMutationId: string | null;
  result: string;
}

export interface CloudObjectFolderRepository  {
  __typename?: 'CloudObjectFolderRepository';
  getAll: CloudObjectFolderEntity[];
  getByCriteria: CloudObjectFolderEntityConnection | null;
  getById: CloudObjectFolderEntity | null;
  getByIds: CloudObjectFolderEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface CloudObjectFolderIdCount  {
  __typename?: 'CloudObjectFolderIdCount';
  count: number;
  id: UUID | null;
}

export interface CloudObjectFolderEntityEdge  {
  __typename?: 'CloudObjectFolderEntityEdge';
  cursor: string;
  node: CloudObjectFolderEntity | null;
}

export interface CloudObjectFolderEntityConnection  {
  __typename?: 'CloudObjectFolderEntityConnection';
  edges: CloudObjectFolderEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CloudObjectFolderEntity  {
  __typename?: 'CloudObjectFolderEntity';
  created: DateTime | null;
  entityApiName: string | null;
  entityType: BaseEntityTypeEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  onlineFormType: OnlineFormTypeEntity | null;
  onlineFormTypeId: ID | null;
  parentCloudObjectFolder: CloudObjectFolderEntity | null;
  parentCloudObjectFolderId: ID | null;
  revision: number | null;
  type: CloudObjectFolderType;
}

export interface CloudObjectFolderCount  {
  __typename?: 'CloudObjectFolderCount';
  count: number;
  entityApiName: string | null;
  entityType: EntityNameEnum | null;
  folders: CloudObjectFolderIdCount[];
}

export interface CloudObjectEntityEdge  {
  __typename?: 'CloudObjectEntityEdge';
  cursor: string;
  node: CloudObjectEntity | null;
}

export interface CloudObjectEntityConnection  {
  __typename?: 'CloudObjectEntityConnection';
  edges: CloudObjectEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CloudObjectEntity  {
  __typename?: 'CloudObjectEntity';
  application: ApplicationEntity | null;
  applicationId: ID | null;
  companyCloudObjectFolder: CloudObjectFolderEntity | null;
  companyCloudObjectFolderId: ID | null;
  created: DateTime | null;
  creator: ClientEntity | null;
  creatorId: ID | null;
  dimensions: CloudObjectDimensions | null;
  duration: number | null;
  filename: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublic: boolean | null;
  mimeType: string | null;
  modified: DateTime | null;
  params: JSONString | null;
  publicUrl: string | null;
  revision: number | null;
  size: number;
  type: CloudObjectTypeEnum;
  uploadSource: UploadSourceEnum | null;
  url: string | null;
}

export interface CloudObjectDrilldownFilter  {
  __typename?: 'CloudObjectDrilldownFilter';
  ownerId: ID[] | null;
  period: PeriodOption;
  recordName: string | null;
  recordType: string[];
}

export interface CloudObjectDimensions  {
  __typename?: 'CloudObjectDimensions';
  height: number;
  width: number;
}

export interface CloudObjectDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'CloudObjectDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ClosingDateProperty  {
  __typename?: 'ClosingDateProperty';
  isRecurrenceEnabled: boolean;
}

export interface ClientStoryReadRepository  {
  __typename?: 'ClientStoryReadRepository';
  getAll: ClientStoryReadEntity[];
  getByCriteria: ClientStoryReadEntityConnection | null;
  getById: ClientStoryReadEntity | null;
  getByIds: ClientStoryReadEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ClientStoryReadEntityEdge  {
  __typename?: 'ClientStoryReadEntityEdge';
  cursor: string;
  node: ClientStoryReadEntity | null;
}

export interface ClientStoryReadEntityConnection  {
  __typename?: 'ClientStoryReadEntityConnection';
  edges: ClientStoryReadEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ClientStoryReadEntity  {
  __typename?: 'ClientStoryReadEntity';
  activityId: ID | null;
  appointment: AppointmentEntity | null;
  created: DateTime | null;
  email: EmailEntity | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  memo: MemoEntity | null;
  messageId: ID | null;
  modified: DateTime | null;
  noFollow: boolean | null;
  owner: ClientEntity | null;
  ownerId: ID;
  readAt: DateTime;
  revision: number | null;
  task: TaskEntity | null;
}

export interface ClientSettingRepository  {
  __typename?: 'ClientSettingRepository';
  get: string | null;
  getAll: ClientSettingEntity[];
  getByCriteria: ClientSettingEntityConnection | null;
  getById: ClientSettingEntity | null;
  getByIds: ClientSettingEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ClientSettingEntityEdge  {
  __typename?: 'ClientSettingEntityEdge';
  cursor: string;
  node: ClientSettingEntity | null;
}

export interface ClientSettingEntityConnection  {
  __typename?: 'ClientSettingEntityConnection';
  edges: ClientSettingEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ClientSettingEntity  {
  __typename?: 'ClientSettingEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  value: JSONString;
}

export interface ClientRepository  {
  __typename?: 'ClientRepository';
  clientEmailsInSubscription: string[];
  getAll: ClientEntity[];
  getByCriteria: ClientEntityConnection | null;
  getByEmail: ClientEntity | null;
  getById: ClientEntity | null;
  getByIds: ClientEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getContactMappings: EntityMapping[];
  getEntitySyncSettingStatus: EntitySyncSettings | null;
  getEntitySyncSettings: EntitySyncSettings | null;
  getEventMappings: EntityMapping[];
  getSupportUsers: SupportUser[];
  getTaskMappings: EntityMapping[];
}

export interface ClientOrderByNested  {
  __typename?: 'ClientOrderByNested';
  created: OrderByEnum | null;
  defaultUnitId: OrderByEnum | null;
  email: OrderByEnum | null;
  firstName: OrderByEnum | null;
  id: OrderByEnum | null;
  isDeleted: OrderByEnum | null;
  lastActive: OrderByEnum | null;
  lastName: OrderByEnum | null;
  masterRightId: OrderByEnum | null;
  middleName: OrderByEnum | null;
  modified: OrderByEnum | null;
  name: OrderByEnum | null;
  phone: OrderByEnum | null;
  pictureUrl: OrderByEnum | null;
  position: OrderByEnum | null;
  region: OrderByEnum | null;
  revision: OrderByEnum | null;
  timezone: OrderByEnum | null;
}

export interface ClientNotificationEntity extends NotificationTargetEntityInterface {
  __typename?: 'ClientNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  isDeleted: boolean | null;
  kind: EntityNameEnum;
  name: string | null;
  pictureUrl: string | null;
}

export interface ClientIntegrationData  {
  __typename?: 'ClientIntegrationData';
  hasCalendar: boolean;
  id: UUID;
}

export interface ClientFavoriteRepository  {
  __typename?: 'ClientFavoriteRepository';
  getAll: ClientFavoriteEntity[];
  getByCriteria: ClientFavoriteEntityConnection | null;
  getById: ClientFavoriteEntity | null;
  getByIds: ClientFavoriteEntity[];
  getChangedFieldsSinceRevision: UUID[];
  isEntityFavorite: boolean;
}

export interface ClientFavoriteEntityEdge  {
  __typename?: 'ClientFavoriteEntityEdge';
  cursor: string;
  node: ClientFavoriteEntity | null;
}

export interface ClientFavoriteEntityConnection  {
  __typename?: 'ClientFavoriteEntityConnection';
  edges: ClientFavoriteEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ClientFavoriteEntity  {
  __typename?: 'ClientFavoriteEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  activityId: ID | null;
  appointment: AppointmentEntity | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  owner: ClientEntity | null;
  ownerId: ID;
  profile: ProfileEntity | null;
  profileId: ID | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  report: ReportEntity | null;
  reportId: ID | null;
  revision: number | null;
  task: TaskEntity | null;
}

export interface ClientExcludedOpptyRepository  {
  __typename?: 'ClientExcludedOpptyRepository';
  getAll: ClientExcludedOpptyEntity[];
  getByCriteria: ClientExcludedOpptyEntityConnection | null;
  getById: ClientExcludedOpptyEntity | null;
  getByIds: ClientExcludedOpptyEntity[];
  getChangedFieldsSinceRevision: UUID[];
  isOpptyExcluded: boolean;
}

export interface ClientExcludedOpptyEntityEdge  {
  __typename?: 'ClientExcludedOpptyEntityEdge';
  cursor: string;
  node: ClientExcludedOpptyEntity | null;
}

export interface ClientExcludedOpptyEntityConnection  {
  __typename?: 'ClientExcludedOpptyEntityConnection';
  edges: ClientExcludedOpptyEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ClientExcludedOpptyEntity  {
  __typename?: 'ClientExcludedOpptyEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isExcluded: boolean;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  opptyId: ID;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
}

export interface ClientEntityEdge  {
  __typename?: 'ClientEntityEdge';
  cursor: string;
  node: ClientEntity | null;
}

export interface ClientEntityData  {
  __typename?: 'ClientEntityData';
  entity: ClientEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface ClientEntityConnection  {
  __typename?: 'ClientEntityConnection';
  edges: ClientEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ClientEntity  {
  __typename?: 'ClientEntity';
  accountFavorite: ClientFavoriteEntityConnection | null;
  appointmentFavorite: ClientFavoriteEntityConnection | null;
  contactFavorite: ClientFavoriteEntityConnection | null;
  created: DateTime | null;
  defaultIdp: number | null;
  defaultUnit: SalesUnitEntity | null;
  defaultUnitId: ID;
  email: string;
  firstName: string | null;
  formattedName: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lastActive: DateTime | null;
  lastName: string | null;
  leadFavorite: ClientFavoriteEntityConnection | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  middleName: string | null;
  modified: DateTime | null;
  name: string | null;
  opportunityFavorite: ClientFavoriteEntityConnection | null;
  phone: string | null;
  pictureUrl: string | null;
  position: string | null;
  profileFavorite: ClientFavoriteEntityConnection | null;
  region: string | null;
  reportFavorite: ClientFavoriteEntityConnection | null;
  revision: number | null;
  taskFavorite: ClientFavoriteEntityConnection | null;
  timezone: string | null;
  timezoneName: string | null;
  type: ClientTypeEnum | null;
  unitManagerIds: UUID[];
  unitMemberIds: UUID[];
  unitMembership: SalesUnitClientRelationEntityConnection | null;
  userProfileId: number | null;
  userRecalculationState: UserRecalculationStateEnum | null;
}

export interface CleanupEditedCloudObjectTemplatesPayload  {
  __typename?: 'CleanupEditedCloudObjectTemplatesPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface ChatConversationRepository  {
  __typename?: 'ChatConversationRepository';
  getAll: ChatConversationEntity[];
  getByCriteria: ChatConversationEntityConnection | null;
  getById: ChatConversationEntity | null;
  getByIds: ChatConversationEntity[];
  getChangedFieldsSinceRevision: UUID[];
  pollMessages: TextMessageEntity[];
}

export interface ChatConversationEntityEdge  {
  __typename?: 'ChatConversationEntityEdge';
  cursor: string;
  node: ChatConversationEntity | null;
}

export interface ChatConversationEntityConnection  {
  __typename?: 'ChatConversationEntityConnection';
  edges: ChatConversationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ChatConversationEntity  {
  __typename?: 'ChatConversationEntity';
  context: AiContext | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  messages: TextMessageEntityConnection | null;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  type: ChatConversationTypeEnum | null;
}

export interface ChartYearComparison  {
  __typename?: 'ChartYearComparison';
  customYear: number[] | null;
  period: YearComparisonPeriodEnum;
}

export interface ChartComparison  {
  __typename?: 'ChartComparison';
  dateFieldId: UUID | null;
  historyComparisonDateId: UUID | null;
  isEnabled: boolean;
  period: PeriodOption | null;
  relativeComparison: boolean;
  yearComparison: ChartYearComparison | null;
}

export interface ChangeQuoteProcessPayload  {
  __typename?: 'ChangeQuoteProcessPayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ChangePipelineQuotePayload  {
  __typename?: 'ChangePipelineQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ChangePipelineOpportunityPayload  {
  __typename?: 'ChangePipelineOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface ChangeOwnershipTaskPayload  {
  __typename?: 'ChangeOwnershipTaskPayload';
  clientMutationId: string | null;
  result: TaskEntity | null;
}

export interface ChangeOwnershipReportPayload  {
  __typename?: 'ChangeOwnershipReportPayload';
  clientMutationId: string | null;
  result: ReportEntity | null;
}

export interface ChangeOwnershipQuotePayload  {
  __typename?: 'ChangeOwnershipQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ChangeOwnershipProjectPayload  {
  __typename?: 'ChangeOwnershipProjectPayload';
  clientMutationId: string | null;
  result: ProjectEntity | null;
}

export interface ChangeOwnershipOpportunityPayload  {
  __typename?: 'ChangeOwnershipOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface ChangeOwnershipLeadPayload  {
  __typename?: 'ChangeOwnershipLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ChangeOwnershipCustomEntityPayload  {
  __typename?: 'ChangeOwnershipCustomEntityPayload';
  clientMutationId: string | null;
  result: CustomEntityEntity | null;
}

export interface ChangeOwnershipContactPayload  {
  __typename?: 'ChangeOwnershipContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface ChangeOwnershipAppointmentPayload  {
  __typename?: 'ChangeOwnershipAppointmentPayload';
  clientMutationId: string | null;
  result: AppointmentEntity | null;
}

export interface ChangeOwnershipAccountPayload  {
  __typename?: 'ChangeOwnershipAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface ChangeLogUuidValue  {
  __typename?: 'ChangeLogUuidValue';
  id: ID;
  label: string;
}

export interface ChangeLogUser  {
  __typename?: 'ChangeLogUser';
  email: string | null;
  firstName: string | null;
  id: number | null;
  isActive: boolean;
  isSystem: boolean;
  lastName: string | null;
  middleName: string | null;
  pictureUrl: string | null;
}

export interface ChangeLogTaskStatusValue  {
  __typename?: 'ChangeLogTaskStatusValue';
  taskStatusValue: TaskStatusEnum;
}

export interface ChangeLogTagsValueItem  {
  __typename?: 'ChangeLogTagsValueItem';
  color: number;
  id: ID;
  label: string;
}

export interface ChangeLogTagsValue  {
  __typename?: 'ChangeLogTagsValue';
  values: ChangeLogTagsValueItem[];
}

export interface ChangeLogStringValue  {
  __typename?: 'ChangeLogStringValue';
  stringValue: string;
}

export interface ChangeLogSourceItem  {
  __typename?: 'ChangeLogSourceItem';
  id: ID;
  name: string;
}

export interface ChangeLogShareModeValue  {
  __typename?: 'ChangeLogShareModeValue';
  shareModeValue: ShareModeEnum;
}

export interface ChangeLogScreen  {
  __typename?: 'ChangeLogScreen';
  filterProducts: ProductEntity[];
  filterUsers: ChangeLogUser[];
  items: ChangeLogItemConnection | null;
}

export interface ChangeLogQuoteStatusValue  {
  __typename?: 'ChangeLogQuoteStatusValue';
  quoteStatusValue: QuoteStatusEnum;
}

export interface ChangeLogPriorityValue  {
  __typename?: 'ChangeLogPriorityValue';
  priorityValue: PriorityEnum;
}

export interface ChangeLogOpptyStatusValue  {
  __typename?: 'ChangeLogOpptyStatusValue';
  opptyStatusValue: OpptyStatusEnum;
}

export interface ChangeLogMultiCheckboxValue  {
  __typename?: 'ChangeLogMultiCheckboxValue';
  values: ChangeLogDropdownValue[];
}

export interface ChangeLogMeetingValue  {
  __typename?: 'ChangeLogMeetingValue';
  joinUrl: string;
  type: AppointmentMeetingTypeEnum;
}

export interface ChangeLogLeadStatusValue  {
  __typename?: 'ChangeLogLeadStatusValue';
  leadStatusValue: LeadStatusEnum;
}

export interface ChangeLogLabelFlagValue  {
  __typename?: 'ChangeLogLabelFlagValue';
  flagValue: number;
}

export interface ChangeLogItemEdge  {
  __typename?: 'ChangeLogItemEdge';
  cursor: string;
  node: ChangeLogItem | null;
}

export interface ChangeLogItemConnection  {
  __typename?: 'ChangeLogItemConnection';
  edges: ChangeLogItemEdge[];
  pageInfo: PageInfo;
}

export interface ChangeLogItem  {
  __typename?: 'ChangeLogItem';
  application: ChangeLogApplication;
  changes: ChangeLogChange[] | null;
  created: DateTime;
  entityType: BaseEntityTypeEnum;
  id: ID;
  source: ChangeLogSourceEnum;
  sourceItem: ChangeLogSourceItem | null;
  type: ChangeLogTypeEnum;
  userId: number | null;
}

export interface ChangeLogIntValue  {
  __typename?: 'ChangeLogIntValue';
  intValue: number;
}

export interface ChangeLogGeoLocationValue  {
  __typename?: 'ChangeLogGeoLocationValue';
  formatted: string;
  lat: number;
  lng: number;
}

export interface ChangeLogGenderValue  {
  __typename?: 'ChangeLogGenderValue';
  genderValue: GenderEnum;
}

export interface ChangeLogForeignCurrencyValue  {
  __typename?: 'ChangeLogForeignCurrencyValue';
  baseValue: number;
  currencyId: ID;
  symbol: string;
  valueForeign: number;
}

export interface ChangeLogFloatValue  {
  __typename?: 'ChangeLogFloatValue';
  floatValue: number;
}

export interface ChangeLogEntityListValueItem  {
  __typename?: 'ChangeLogEntityListValueItem';
  entityApiName: string | null;
  entityName: EntityNameEnum;
  id: ID;
  label: string;
}

export interface ChangeLogEntityListValue  {
  __typename?: 'ChangeLogEntityListValue';
  values: ChangeLogEntityListValueItem[];
}

export interface ChangeLogDropdownValue  {
  __typename?: 'ChangeLogDropdownValue';
  id: ID;
  label: string;
}

export interface ChangeLogDatetimeValue  {
  __typename?: 'ChangeLogDatetimeValue';
  datetimeValue: DateTime;
}

export interface ChangeLogDateValue  {
  __typename?: 'ChangeLogDateValue';
  dateValue: GqlDate;
}

export interface ChangeLogChange  {
  __typename?: 'ChangeLogChange';
  fieldId: ID;
  newValue: ChangeLogValueObject | null;
  oldValue: ChangeLogValueObject | null;
}

export interface ChangeLogBooleanValue  {
  __typename?: 'ChangeLogBooleanValue';
  booleanValue: boolean;
}

export interface ChangeLogAttendeeEmailsValue  {
  __typename?: 'ChangeLogAttendeeEmailsValue';
  emails: string[];
}

export interface ChangeLogApplication  {
  __typename?: 'ChangeLogApplication';
  id: ID;
  name: string;
}

export interface ChangeLogAccountClassValue  {
  __typename?: 'ChangeLogAccountClassValue';
  accountClassValue: AccountClassEnum;
}

export interface ChangeLeadProcessPayload  {
  __typename?: 'ChangeLeadProcessPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ChangeLabelFlagOpportunityPayload  {
  __typename?: 'ChangeLabelFlagOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface ChangeLabelFlagLeadPayload  {
  __typename?: 'ChangeLabelFlagLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ChangeBaseCurrencyPayload  {
  __typename?: 'ChangeBaseCurrencyPayload';
  clientMutationId: string | null;
  result: CurrencyEntity | null;
}

export interface CancelCallTeamSpaceClientSettingPayload  {
  __typename?: 'CancelCallTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface CancelApprovalPayload  {
  __typename?: 'CancelApprovalPayload';
  result: UUID[];
}

export interface CallingService  {
  __typename?: 'CallingService';
  getAvailablePhoneNumbers: AvailablePhoneNumber[] | null;
  getCallStatus: CallLogStatusEnum;
  getCallUsageOverview: CallUsageOverview[] | null;
}

export interface CallingIntegrationOutput  {
  __typename?: 'CallingIntegrationOutput';
  enabled: ServiceStatus;
  errorCode: number;
  numbers: PhoneEntity[];
}

export interface CallingDeactivateTeamSpaceClientSettingPayload  {
  __typename?: 'CallingDeactivateTeamSpaceClientSettingPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface CallUsageOverview  {
  __typename?: 'CallUsageOverview';
  client: ClientEntity | null;
  phone: PhoneEntity | null;
  sentMessagesThisMonth: number;
  usedCreditThisMonth: number;
  usedSecondsThisMonth: number;
}

export interface CallRepository  {
  __typename?: 'CallRepository';
  getAll: CallEntity[];
  getByCriteria: CallEntityConnection | null;
  getById: CallEntity | null;
  getByIds: CallEntity[];
  getBySid: CallEntity | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface CallEntityEdge  {
  __typename?: 'CallEntityEdge';
  cursor: string;
  node: CallEntity | null;
}

export interface CallEntityConnection  {
  __typename?: 'CallEntityConnection';
  edges: CallEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface CallEntity  {
  __typename?: 'CallEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  audio: CloudObjectEntity | null;
  audioId: UUID | null;
  audioStatus: AudioStatus | null;
  caller: ClientEntity | null;
  callerId: ID;
  client: ClientEntity | null;
  clientId: ID | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  mediaTranscription: MediaEntity | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  opptyProductRelation: OpptyProductRelationEntity | null;
  opptyProductRelationId: ID | null;
  phoneNumber: string | null;
  product: ProductEntity | null;
  productId: ID | null;
  task: TaskEntity | null;
  transcriptionFile: CloudObjectEntity | null;
  transcriptionFileId: UUID | null;
  transcriptionId: string | null;
  transcriptionLanguage: string | null;
  transcriptionSummary: string | null;
  twilioCallLogId: ID;
  twilioCallSid: string;
}

export interface CalendarView  {
  __typename?: 'CalendarView';
  dateFrom: GqlDate;
  dateTo: GqlDate;
  profile: ActivityPreviewProfile;
  profileId: string;
  sidebarOpen: boolean;
}

export interface CalendarColorUser  {
  __typename?: 'CalendarColorUser';
  color: number;
  id: UUID | null;
  name: string;
  rules: FieldFilter;
}

export interface CalendarColorRule  {
  __typename?: 'CalendarColorRule';
  color: number;
  id: UUID;
  name: string;
  rules: FieldFilter;
}

export interface CalculatedField extends ReportValueFieldInterface {
  __typename?: 'CalculatedField';
  advancedFormula: AdvancedFormulaProperty;
  id: UUID;
  name: string;
}

export interface BusinessOverview  {
  __typename?: 'BusinessOverview';
  lostAmount: number;
  lostCount: number;
  openAmount: number;
  openCount: number;
  wonAmount: number;
  wonCount: number;
}

export interface BulkUpdateWebhookPayload  {
  __typename?: 'BulkUpdateWebhookPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateWebhookEventPayload  {
  __typename?: 'BulkUpdateWebhookEventPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateUnsubscribedPhonePayload  {
  __typename?: 'BulkUpdateUnsubscribedPhonePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTimeframePayload  {
  __typename?: 'BulkUpdateTimeframePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTextMessageConversationRelationsPayload  {
  __typename?: 'BulkUpdateTextMessageConversationRelationsPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTaskSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateTaskSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTaskSharingClientRelationPayload  {
  __typename?: 'BulkUpdateTaskSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTaskReminderPayload  {
  __typename?: 'BulkUpdateTaskReminderPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTaskRecurrencePayload  {
  __typename?: 'BulkUpdateTaskRecurrencePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTaskPayload  {
  __typename?: 'BulkUpdateTaskPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTargetRelationPayload  {
  __typename?: 'BulkUpdateTargetRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTargetPayload  {
  __typename?: 'BulkUpdateTargetPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTagRelationPayload  {
  __typename?: 'BulkUpdateTagRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateTagPayload  {
  __typename?: 'BulkUpdateTagPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateStepPayload  {
  __typename?: 'BulkUpdateStepPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateStepChecklistSalesRoleRelationPayload  {
  __typename?: 'BulkUpdateStepChecklistSalesRoleRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateStepChecklistPayload  {
  __typename?: 'BulkUpdateStepChecklistPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateSalesUnitPayload  {
  __typename?: 'BulkUpdateSalesUnitPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateSalesRolePayload  {
  __typename?: 'BulkUpdateSalesRolePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateResults  {
  __typename?: 'BulkUpdateResults';
  created: BulkUpdateResultMap[];
  deleted: UUID[];
  errors: BulkErrorResult[];
  errorsOnDelete: BulkErrorResult[];
  updated: UUID[];
}

export interface BulkUpdateResultMap  {
  __typename?: 'BulkUpdateResultMap';
  id: ID;
  index: number;
}

export interface BulkUpdateResult  {
  __typename?: 'BulkUpdateResult';
  count: number;
  firstEntityId: ID | null;
  notAvailableCount: number;
  sessionId: string | null;
}

export interface BulkUpdateReportSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateReportSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateReportSharingClientRelationPayload  {
  __typename?: 'BulkUpdateReportSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateReportSchedulePayload  {
  __typename?: 'BulkUpdateReportSchedulePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateReportPayload  {
  __typename?: 'BulkUpdateReportPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateReportFolderPayload  {
  __typename?: 'BulkUpdateReportFolderPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateQuoteSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteSharingClientRelationPayload  {
  __typename?: 'BulkUpdateQuoteSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteProcessPayload  {
  __typename?: 'BulkUpdateQuoteProcessPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuotePayload  {
  __typename?: 'BulkUpdateQuotePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteKPIPayload  {
  __typename?: 'BulkUpdateQuoteKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteDataExRelationPayload  {
  __typename?: 'BulkUpdateQuoteDataExRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteContactRelationPayload  {
  __typename?: 'BulkUpdateQuoteContactRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateQuoteAccountRelationPayload  {
  __typename?: 'BulkUpdateQuoteAccountRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateProjectSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectSharingClientRelationPayload  {
  __typename?: 'BulkUpdateProjectSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectPayload  {
  __typename?: 'BulkUpdateProjectPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectObjectivePayload  {
  __typename?: 'BulkUpdateProjectObjectivePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectKPIPayload  {
  __typename?: 'BulkUpdateProjectKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProjectContactRelationPayload  {
  __typename?: 'BulkUpdateProjectContactRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProfileSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateProfileSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProfileSharingClientRelationPayload  {
  __typename?: 'BulkUpdateProfileSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProfileRelationPayload  {
  __typename?: 'BulkUpdateProfileRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProfilePayload  {
  __typename?: 'BulkUpdateProfilePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProductPriceListPricePayload  {
  __typename?: 'BulkUpdateProductPriceListPricePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProductPriceListPayload  {
  __typename?: 'BulkUpdateProductPriceListPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProductPipelineRelationPayload  {
  __typename?: 'BulkUpdateProductPipelineRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProductPayload  {
  __typename?: 'BulkUpdateProductPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProductCategoryPayload  {
  __typename?: 'BulkUpdateProductCategoryPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProcessTemplatePayload  {
  __typename?: 'BulkUpdateProcessTemplatePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProcessPayload  {
  __typename?: 'BulkUpdateProcessPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProcessActivityLogPayload  {
  __typename?: 'BulkUpdateProcessActivityLogPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateProcessActivityLogLinePayload  {
  __typename?: 'BulkUpdateProcessActivityLogLinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdatePipelinePayload  {
  __typename?: 'BulkUpdatePipelinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdatePhonePayload  {
  __typename?: 'BulkUpdatePhonePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdatePayload  {
  __typename?: 'BulkUpdatePayload';
  errors: BulkUpdateResult;
  skipped: BulkUpdateResult;
  updated: BulkUpdateResult;
}

export interface BulkUpdateParentAccountRelationTypePayload  {
  __typename?: 'BulkUpdateParentAccountRelationTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOpptyRecurrencePayload  {
  __typename?: 'BulkUpdateOpptyRecurrencePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOpptyProductRelationPayload  {
  __typename?: 'BulkUpdateOpptyProductRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOpptyProductRelationDataExRelationPayload  {
  __typename?: 'BulkUpdateOpptyProductRelationDataExRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOpportunityPayload  {
  __typename?: 'BulkUpdateOpportunityPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormTypePayload  {
  __typename?: 'BulkUpdateOnlineFormTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormTypeEmailRelationPayload  {
  __typename?: 'BulkUpdateOnlineFormTypeEmailRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormStylePayload  {
  __typename?: 'BulkUpdateOnlineFormStylePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormRelationPayload  {
  __typename?: 'BulkUpdateOnlineFormRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormPayload  {
  __typename?: 'BulkUpdateOnlineFormPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormDataExRelationPayload  {
  __typename?: 'BulkUpdateOnlineFormDataExRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateOnlineFormActivityLogLinePayload  {
  __typename?: 'BulkUpdateOnlineFormActivityLogLinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateNotePayload  {
  __typename?: 'BulkUpdateNotePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMessageSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateMessageSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMessageSharingClientRelationPayload  {
  __typename?: 'BulkUpdateMessageSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMessageRelationPayload  {
  __typename?: 'BulkUpdateMessageRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMemoPayload  {
  __typename?: 'BulkUpdateMemoPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMemoCommentPayload  {
  __typename?: 'BulkUpdateMemoCommentPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMediaPayload  {
  __typename?: 'BulkUpdateMediaPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateMasterRightPayload  {
  __typename?: 'BulkUpdateMasterRightPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadProcessPayload  {
  __typename?: 'BulkUpdateLeadProcessPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadPayload  {
  __typename?: 'BulkUpdateLeadPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyStepCheckListRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptyStepCheckListRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptySharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptySharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptySharingClientRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptySharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyKPIPayload  {
  __typename?: 'BulkUpdateLeadOpptyKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptyContactSalesRoleRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyContactRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptyContactRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyContactGroupRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptyContactGroupRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateLeadOpptyAccountRelationPayload  {
  __typename?: 'BulkUpdateLeadOpptyAccountRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateImportMappingMaskPayload  {
  __typename?: 'BulkUpdateImportMappingMaskPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateGhostLeadOpptyContactSalesRoleRelationPayload  {
  __typename?: 'BulkUpdateGhostLeadOpptyContactSalesRoleRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateGhostLeadOpptyContactRelationPayload  {
  __typename?: 'BulkUpdateGhostLeadOpptyContactRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateGhostContactPayload  {
  __typename?: 'BulkUpdateGhostContactPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateGhostContactAccountRelationPayload  {
  __typename?: 'BulkUpdateGhostContactAccountRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateGhostContactAccountAccountRoleRelationPayload  {
  __typename?: 'BulkUpdateGhostContactAccountAccountRoleRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateFormViewSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateFormViewSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateFormViewSharingClientRelationPayload  {
  __typename?: 'BulkUpdateFormViewSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateFormViewPayload  {
  __typename?: 'BulkUpdateFormViewPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateForecastPayload  {
  __typename?: 'BulkUpdateForecastPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateFieldMappingPayload  {
  __typename?: 'BulkUpdateFieldMappingPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEntityScoringPayload  {
  __typename?: 'BulkUpdateEntityScoringPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEntityFitnessIndicatorPayload  {
  __typename?: 'BulkUpdateEntityFitnessIndicatorPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEntitiesPayload  {
  __typename?: 'BulkUpdateEntitiesPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload;
}

export interface BulkUpdateEmailTemplateSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateEmailTemplateSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailTemplateSharingClientRelationPayload  {
  __typename?: 'BulkUpdateEmailTemplateSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailTemplatePayload  {
  __typename?: 'BulkUpdateEmailTemplatePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailTemplateFolderPayload  {
  __typename?: 'BulkUpdateEmailTemplateFolderPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailSequencePayload  {
  __typename?: 'BulkUpdateEmailSequencePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailSequenceEnrolledPayload  {
  __typename?: 'BulkUpdateEmailSequenceEnrolledPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailSequenceActivityLogPayload  {
  __typename?: 'BulkUpdateEmailSequenceActivityLogPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailSequenceActivityLogLinePayload  {
  __typename?: 'BulkUpdateEmailSequenceActivityLogLinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailPayload  {
  __typename?: 'BulkUpdateEmailPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailEventPayload  {
  __typename?: 'BulkUpdateEmailEventPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailContentSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateEmailContentSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateEmailContentSharingClientRelationPayload  {
  __typename?: 'BulkUpdateEmailContentSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCustomEntitySharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateCustomEntitySharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCustomEntitySharingClientRelationPayload  {
  __typename?: 'BulkUpdateCustomEntitySharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCustomEntityRelationDataPayload  {
  __typename?: 'BulkUpdateCustomEntityRelationDataPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCustomEntityPayload  {
  __typename?: 'BulkUpdateCustomEntityPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCustomEntityDataExRelationPayload  {
  __typename?: 'BulkUpdateCustomEntityDataExRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCurrencyPayload  {
  __typename?: 'BulkUpdateCurrencyPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCurrencyExchangeRatesListPayload  {
  __typename?: 'BulkUpdateCurrencyExchangeRatesListPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCurrencyExchangeRatePayload  {
  __typename?: 'BulkUpdateCurrencyExchangeRatePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactSocialRelationPayload  {
  __typename?: 'BulkUpdateContactSocialRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateContactSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactSharingClientRelationPayload  {
  __typename?: 'BulkUpdateContactSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactRelationTypePayload  {
  __typename?: 'BulkUpdateContactRelationTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactRelationPayload  {
  __typename?: 'BulkUpdateContactRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactRelationLabelPayload  {
  __typename?: 'BulkUpdateContactRelationLabelPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactPayload  {
  __typename?: 'BulkUpdateContactPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactKPIPayload  {
  __typename?: 'BulkUpdateContactKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactAccountRelationPayload  {
  __typename?: 'BulkUpdateContactAccountRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateContactAccountAccountRoleRelationPayload  {
  __typename?: 'BulkUpdateContactAccountAccountRoleRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCompanyEmailPayload  {
  __typename?: 'BulkUpdateCompanyEmailPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCloudObjectTemplatePayload  {
  __typename?: 'BulkUpdateCloudObjectTemplatePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCloudObjectStepRelationPayload  {
  __typename?: 'BulkUpdateCloudObjectStepRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCloudObjectRelationPayload  {
  __typename?: 'BulkUpdateCloudObjectRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCloudObjectPayload  {
  __typename?: 'BulkUpdateCloudObjectPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCloudObjectFolderPayload  {
  __typename?: 'BulkUpdateCloudObjectFolderPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateClientStoryReadPayload  {
  __typename?: 'BulkUpdateClientStoryReadPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateClientSettingPayload  {
  __typename?: 'BulkUpdateClientSettingPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateClientPayload  {
  __typename?: 'BulkUpdateClientPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateClientFavoritePayload  {
  __typename?: 'BulkUpdateClientFavoritePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateClientExcludedOpptyPayload  {
  __typename?: 'BulkUpdateClientExcludedOpptyPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateChatConversationPayload  {
  __typename?: 'BulkUpdateChatConversationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateCallPayload  {
  __typename?: 'BulkUpdateCallPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateApprovalProcessPayload  {
  __typename?: 'BulkUpdateApprovalProcessPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateApprovalProcessActivityLogLinePayload  {
  __typename?: 'BulkUpdateApprovalProcessActivityLogLinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateApprovalPayload  {
  __typename?: 'BulkUpdateApprovalPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateApprovalApproverPayload  {
  __typename?: 'BulkUpdateApprovalApproverPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAppointmentSchedulePayload  {
  __typename?: 'BulkUpdateAppointmentSchedulePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAppointmentReminderPayload  {
  __typename?: 'BulkUpdateAppointmentReminderPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAppointmentPayload  {
  __typename?: 'BulkUpdateAppointmentPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAppointmentContactInviteesRelationPayload  {
  __typename?: 'BulkUpdateAppointmentContactInviteesRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAppointmentClientInviteesRelationPayload  {
  __typename?: 'BulkUpdateAppointmentClientInviteesRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateApiAccessPayload  {
  __typename?: 'BulkUpdateApiAccessPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedQuoteTypePayload  {
  __typename?: 'BulkUpdateAllowedQuoteTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedPipelinePayload  {
  __typename?: 'BulkUpdateAllowedPipelinePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedLeadTypePayload  {
  __typename?: 'BulkUpdateAllowedLeadTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedContactTypePayload  {
  __typename?: 'BulkUpdateAllowedContactTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedCompanyPhonePayload  {
  __typename?: 'BulkUpdateAllowedCompanyPhonePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedCompanyEmailPayload  {
  __typename?: 'BulkUpdateAllowedCompanyEmailPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAllowedAccountTypePayload  {
  __typename?: 'BulkUpdateAllowedAccountTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateActivityRelationPayload  {
  __typename?: 'BulkUpdateActivityRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateActivityKPIPayload  {
  __typename?: 'BulkUpdateActivityKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateActivityCommentPayload  {
  __typename?: 'BulkUpdateActivityCommentPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountSocialRelationPayload  {
  __typename?: 'BulkUpdateAccountSocialRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountSharingSalesUnitRelationPayload  {
  __typename?: 'BulkUpdateAccountSharingSalesUnitRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountSharingClientRelationPayload  {
  __typename?: 'BulkUpdateAccountSharingClientRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountRolePayload  {
  __typename?: 'BulkUpdateAccountRolePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountRelationTypePayload  {
  __typename?: 'BulkUpdateAccountRelationTypePayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountRelationPayload  {
  __typename?: 'BulkUpdateAccountRelationPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountRelationLabelPayload  {
  __typename?: 'BulkUpdateAccountRelationLabelPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountProductPricingPayload  {
  __typename?: 'BulkUpdateAccountProductPricingPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountPayload  {
  __typename?: 'BulkUpdateAccountPayload';
  result: BulkUpdateResults;
}

export interface BulkUpdateAccountKPIPayload  {
  __typename?: 'BulkUpdateAccountKPIPayload';
  result: BulkUpdateResults;
}

export interface BulkUnlinkQuotePayload  {
  __typename?: 'BulkUnlinkQuotePayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkProjectPayload  {
  __typename?: 'BulkUnlinkProjectPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkProductPayload  {
  __typename?: 'BulkUnlinkProductPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkOpportunityPayload  {
  __typename?: 'BulkUnlinkOpportunityPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkLeadPayload  {
  __typename?: 'BulkUnlinkLeadPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkLeadOpptyPayload  {
  __typename?: 'BulkUnlinkLeadOpptyPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkCustomEntityPayload  {
  __typename?: 'BulkUnlinkCustomEntityPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkContactPayload  {
  __typename?: 'BulkUnlinkContactPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkActivityPayload  {
  __typename?: 'BulkUnlinkActivityPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkUnlinkAccountPayload  {
  __typename?: 'BulkUnlinkAccountPayload';
  clientMutationId: string | null;
  result: number | null;
}

export interface BulkRemoveTargetPayload  {
  __typename?: 'BulkRemoveTargetPayload';
  clientMutationId: string | null;
}

export interface BulkReleaseOwnershipLeadPayload  {
  __typename?: 'BulkReleaseOwnershipLeadPayload';
  clientMutationId: string | null;
}

export interface BulkReactivateQuotePayload  {
  __typename?: 'BulkReactivateQuotePayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkReactivateOpportunityPayload  {
  __typename?: 'BulkReactivateOpportunityPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkReactivateLeadPayload  {
  __typename?: 'BulkReactivateLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkReactivateContactPayload  {
  __typename?: 'BulkReactivateContactPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkReactivateAccountPayload  {
  __typename?: 'BulkReactivateAccountPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkQualifyLeadPayload  {
  __typename?: 'BulkQualifyLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkMoveQuotePayload  {
  __typename?: 'BulkMoveQuotePayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkMoveOpportunityPayload  {
  __typename?: 'BulkMoveOpportunityPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkMoveLeadPayload  {
  __typename?: 'BulkMoveLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkFinishUserTargetPayload  {
  __typename?: 'BulkFinishUserTargetPayload';
  clientMutationId: string | null;
}

export interface BulkErrorResult  {
  __typename?: 'BulkErrorResult';
  apiError: EntityValidationError | null;
  code: number;
  entityId: ID | null;
  index: number;
  message: string;
}

export interface BulkDownloadStatus  {
  __typename?: 'BulkDownloadStatus';
  error: boolean | null;
  progress: number | null;
  url: string | null;
}

export interface BulkDeleteTargetPayload  {
  __typename?: 'BulkDeleteTargetPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteTagPayload  {
  __typename?: 'BulkDeleteTagPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteQuotePayload  {
  __typename?: 'BulkDeleteQuotePayload';
  clientMutationId: string | null;
}

export interface BulkDeleteProjectPayload  {
  __typename?: 'BulkDeleteProjectPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteNotePayload  {
  __typename?: 'BulkDeleteNotePayload';
  clientMutationId: string | null;
}

export interface BulkDeleteLeadOpptyPayload  {
  __typename?: 'BulkDeleteLeadOpptyPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteForecastPayload  {
  __typename?: 'BulkDeleteForecastPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteEmailPayload  {
  __typename?: 'BulkDeleteEmailPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteCustomEntityPayload  {
  __typename?: 'BulkDeleteCustomEntityPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteContactPayload  {
  __typename?: 'BulkDeleteContactPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteCompanyEmailPayload  {
  __typename?: 'BulkDeleteCompanyEmailPayload';
  clientMutationId: string | null;
  result: ID[];
}

export interface BulkDeleteCloudObjectTemplatePayload  {
  __typename?: 'BulkDeleteCloudObjectTemplatePayload';
  clientMutationId: string | null;
}

export interface BulkDeleteCloudObjectPayload  {
  __typename?: 'BulkDeleteCloudObjectPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteActivityPayload  {
  __typename?: 'BulkDeleteActivityPayload';
  clientMutationId: string | null;
}

export interface BulkDeleteAccountPayload  {
  __typename?: 'BulkDeleteAccountPayload';
  clientMutationId: string | null;
}

export interface BulkChangeOwnershipQuotePayload  {
  __typename?: 'BulkChangeOwnershipQuotePayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipProjectPayload  {
  __typename?: 'BulkChangeOwnershipProjectPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipOpportunityPayload  {
  __typename?: 'BulkChangeOwnershipOpportunityPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipLeadPayload  {
  __typename?: 'BulkChangeOwnershipLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipCustomEntityPayload  {
  __typename?: 'BulkChangeOwnershipCustomEntityPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipContactPayload  {
  __typename?: 'BulkChangeOwnershipContactPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipActivityPayload  {
  __typename?: 'BulkChangeOwnershipActivityPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkChangeOwnershipAccountPayload  {
  __typename?: 'BulkChangeOwnershipAccountPayload';
  clientMutationId: string | null;
  result: BulkUpdatePayload | null;
}

export interface BulkBackToLeadPayload  {
  __typename?: 'BulkBackToLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkArchiveQuotePayload  {
  __typename?: 'BulkArchiveQuotePayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkArchiveOpportunityPayload  {
  __typename?: 'BulkArchiveOpportunityPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkArchiveLeadPayload  {
  __typename?: 'BulkArchiveLeadPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkArchiveContactPayload  {
  __typename?: 'BulkArchiveContactPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkArchiveAccountPayload  {
  __typename?: 'BulkArchiveAccountPayload';
  clientMutationId: string | null;
  result: BulkUpdateResults;
}

export interface BulkActivateUserTargetPayload  {
  __typename?: 'BulkActivateUserTargetPayload';
  clientMutationId: string | null;
}

export interface BooleanInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'BooleanInterfaceFieldData';
  booleanValue: boolean | null;
  fieldId: UUID;
}

export interface BillingDetail  {
  __typename?: 'BillingDetail';
  address: string | null;
  city: string | null;
  company: string | null;
  countryId: string | null;
  emails: string[] | null;
  fax: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  postalCode: string | null;
  stateId: string | null;
  vatCode: string | null;
}

export interface BetterNavigatorScreenProfile extends ProfileInterface {
  __typename?: 'BetterNavigatorScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  syncEnabled: boolean;
  syncEntityId: UUID | null;
  tabs: BetterNavigatorPreviewProfile;
  useLang: boolean;
}

export interface BetterNavigatorScreen extends ProfileScreen, Screen {
  __typename?: 'BetterNavigatorScreen';
  activeProfile: BetterNavigatorScreenProfile;
  data: BetterNavigatorProfileData;
  draftProfile: BetterNavigatorScreenProfile | null;
  name: string;
  profiles: BetterNavigatorScreenProfile[];
}

export interface BetterNavigatorProfileData  {
  __typename?: 'BetterNavigatorProfileData';
  charts: DashboardChartData[];
  drilldown: DashboardDrilldownModel;
  drilldownKpi: DashboardDrilldownModel;
  drilldownOpportunitiesTrend: DashboardDrilldownModel;
  drilldownTarget: DashboardDrilldownModel;
  drilldownTile: DashboardDrilldownModel;
}

export interface BetterNavigatorPreviewProfile extends ProfileTabsInterface {
  __typename?: 'BetterNavigatorPreviewProfile';
  filter: DashboardFilter;
  items: DashboardItem[];
  role: DashboardRole;
}

export interface BetterForecastSchema extends QuickFilterInterface {
  __typename?: 'BetterForecastSchema';
  columns: ForecastColumn[];
  currencyId: UUID;
  dateFieldId: ID;
  endDate: GqlDate;
  fieldFilter: FieldFilter;
  fieldId: ID;
  filter: OpportunityFilterTab;
  groupBy: UUID | null;
  hideEmptyRows: boolean;
  items: ForecastItem[];
  listViewOptions: ForecastListViewOptions;
  period: ForecastPeriodKind;
  pipelineId: UUID;
  pipelineViewOptions: ForecastPipelineViewOptions;
  quickFilter: QuickFilterTab;
  quotaComparisonType: ForecastPerformanceComparisonType;
  quotaCustomMode: boolean;
  quotaSplitType: OpportunityForecastQuotaSplitType;
  startDate: GqlDate;
  trendViewOptions: ForecastTrendViewOptions;
  type: ForecastType[];
}

export interface BetterDashboardView  {
  __typename?: 'BetterDashboardView';
  charts: DashboardChartData[];
  drilldown: DashboardDrilldownModel;
  drilldownKpi: DashboardDrilldownModel;
  drilldownOpportunitiesTrend: DashboardDrilldownModel;
  drilldownTarget: DashboardDrilldownModel;
  drilldownTile: DashboardDrilldownModel;
}

export interface BetterDashboardSchema  {
  __typename?: 'BetterDashboardSchema';
  filter: DashboardFilter;
  items: DashboardItem[];
  role: DashboardRole;
}

export interface BetterDashboardAgenda  {
  __typename?: 'BetterDashboardAgenda';
  items: NavigatorAgendaItemConnection | null;
  overdueTasks: OverdueTasks;
}

export interface BackToLeadPayload  {
  __typename?: 'BackToLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface AvailablePhoneNumber  {
  __typename?: 'AvailablePhoneNumber';
  locality: string | null;
  name: string;
  phoneNumber: string;
  price: number;
  region: string | null;
}

export interface AutomationHubItemRepository  {
  __typename?: 'AutomationHubItemRepository';
  getAll: AutomationHubItemEntity[];
  getByCriteria: AutomationHubItemEntityConnection | null;
  getById: AutomationHubItemEntity | null;
  getByIds: AutomationHubItemEntity[];
}

export interface AutomationHubItemEntityEdge  {
  __typename?: 'AutomationHubItemEntityEdge';
  cursor: string;
  node: AutomationHubItemEntity | null;
}

export interface AutomationHubItemEntityConnection  {
  __typename?: 'AutomationHubItemEntityConnection';
  edges: AutomationHubItemEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AutomationHubItemEntity  {
  __typename?: 'AutomationHubItemEntity';
  aclPermissionKey: string | null;
  authUrl: string | null;
  automationHubApp: AutomationHubAppEntity | null;
  automationHubAppId: number | null;
  automationHubCategory: AutomationHubCategoryEntity | null;
  automationHubCategoryId: number | null;
  configurationUrl: string | null;
  deprecatedByItemId: number | null;
  description: string | null;
  hasLastRun: boolean | null;
  hasLogs: boolean | null;
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  integrationAnalyticsEnabled: boolean | null;
  isBeta: boolean | null;
  isBundle: boolean | null;
  isDeleted: boolean | null;
  isVisible: boolean | null;
  logoUrl: string | null;
  minApiVersion: number | null;
  name: string | null;
  parentId: ID | null;
  ranking: number | null;
  scope: AutomationHubScope | null;
  status: AutomationHubItemLiveStatus | null;
  teamSpaceItem: TeamPipelineHubInterfaceImplementors | null;
  tier: AutomationHubTierEnum | null;
  websiteUrl: string | null;
}

export interface AutomationHubCategoryEntity  {
  __typename?: 'AutomationHubCategoryEntity';
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isDeleted: boolean | null;
  name: string | null;
}

export interface AutomationHubAppEntity  {
  __typename?: 'AutomationHubAppEntity';
  id: ID | null;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isDeleted: boolean | null;
  logoUrl: string | null;
  name: string | null;
  supportPrivacyUrl: string | null;
  supportTermsUrl: string | null;
  supportUrl: string | null;
  websiteUrl: string | null;
}

export interface AuthUrlResult  {
  __typename?: 'AuthUrlResult';
  url: string | null;
}

export interface AuditLogScreen  {
  __typename?: 'AuditLogScreen';
  filterActors: AuditLogActor[];
  items: AuditLogItemConnection | null;
}

export interface AuditLogItemEdge  {
  __typename?: 'AuditLogItemEdge';
  cursor: string;
  node: AuditLogItem | null;
}

export interface AuditLogItemConnection  {
  __typename?: 'AuditLogItemConnection';
  edges: AuditLogItemEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface AuditLogItem  {
  __typename?: 'AuditLogItem';
  actor: AuditLogActor;
  application: AuditLogApplication;
  category: AuditLogCategoryEnum;
  created: DateTime;
  description: string;
  type: AuditLogTypeEnum;
}

export interface AuditLogApplication  {
  __typename?: 'AuditLogApplication';
  id: ID;
  name: string;
}

export interface AuditLogActor  {
  __typename?: 'AuditLogActor';
  email: string | null;
  isSystem: boolean;
  name: string | null;
}

export interface AttendeesInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'AttendeesInterfaceFieldData';
  attendees: InterfaceFieldAttendeeData[];
  fieldId: UUID;
}

export interface AttachmentsPictureEntity  {
  __typename?: 'AttachmentsPictureEntity';
  filename: string;
  url: string;
}

export interface AttachmentFileExtension  {
  __typename?: 'AttachmentFileExtension';
  denied: boolean;
  list: string[];
}

export interface AttachCloudObjectRelationsToFormFolderPayload  {
  __typename?: 'AttachCloudObjectRelationsToFormFolderPayload';
  clientMutationId: string | null;
  result: boolean | null;
}

export interface AsyncJobStatus  {
  __typename?: 'AsyncJobStatus';
  processed: number | null;
  result: JSONString | null;
  status: AsyncJobStatusEnum;
  total: number | null;
}

export interface ArchiveWonStepExtractView  {
  __typename?: 'ArchiveWonStepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInPipeline: number;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
  successRateCount: number;
  successRateSession: UUID | null;
  successRateTotalCount: number;
  successRateTotalSession: UUID | null;
  totalOpportunitiesSession: UUID | null;
  wonArchiveOpportunitiesValue: number;
}

export interface ArchiveStepSummaryInfo  {
  __typename?: 'ArchiveStepSummaryInfo';
  itemCount: number;
  stepId: ID | null;
  stepValue: number;
}

export interface ArchiveStepExtractView  {
  __typename?: 'ArchiveStepExtractView';
  archiveOpportunitiesCount: number;
  archiveOpportunitiesSession: UUID | null;
  archiveOpportunitiesValue: number;
  avgDaysInStep: number;
  dropOffRateCount: number;
  dropOffRateSession: UUID | null;
  dropOffRateTotalCount: number;
  dropOffRateTotalSession: UUID | null;
  id: ID | null;
  opportunitiesCount: number;
  opportunitiesSession: UUID | null;
  opportunitiesValue: number;
}

export interface ArchiveQuotePayload  {
  __typename?: 'ArchiveQuotePayload';
  clientMutationId: string | null;
  result: QuoteEntity | null;
}

export interface ArchiveQuoteItem  {
  __typename?: 'ArchiveQuoteItem';
  boardViewItem: QuoteBoardViewItem | null;
  compactViewItem: QuoteCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
}

export interface ArchiveOpportunityPayload  {
  __typename?: 'ArchiveOpportunityPayload';
  clientMutationId: string | null;
  result: OpportunityEntity | null;
}

export interface ArchiveOpportunityItem  {
  __typename?: 'ArchiveOpportunityItem';
  compactViewItem: OpportunityArchiveCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
  pipelineViewItem: PipelineArchiveViewItem | null;
}

export interface ArchiveLeadStepExtractView  {
  __typename?: 'ArchiveLeadStepExtractView';
  archiveLeadsCount: number;
  archiveLeadsSession: UUID | null;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  leadsCount: number;
  leadsSession: UUID | null;
}

export interface ArchiveLeadPreviewStepExtractView  {
  __typename?: 'ArchiveLeadPreviewStepExtractView';
  archiveLeadsCount: number;
  archiveLeadsSession: UUID | null;
  avgDaysInStep: number;
  conversionRateCount: number;
  conversionRateSession: UUID | null;
  conversionRateTotalCount: number;
  conversionRateTotalSession: UUID | null;
  leadsCount: number;
  leadsSession: UUID | null;
}

export interface ArchiveLeadPayload  {
  __typename?: 'ArchiveLeadPayload';
  clientMutationId: string | null;
  result: LeadEntity | null;
}

export interface ArchiveLeadItem  {
  __typename?: 'ArchiveLeadItem';
  boardViewItem: LeadBoardViewItem | null;
  compactViewItem: LeadCompactViewItem | null;
  listViewItem: DataGridViewItem | null;
}

export interface ArchiveEntityData  {
  __typename?: 'ArchiveEntityData';
  accounts: LeadOpptyAccountRelationEntityConnection | null;
  contacts: LeadOpptyContactRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: LeadOpportunityEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastMessages: MessageRelationEntityConnection | null;
  notes: NoteEntityConnection | null;
  plannedActivities: ActivityRelationEntityConnection | null;
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface ArchiveContactPayload  {
  __typename?: 'ArchiveContactPayload';
  clientMutationId: string | null;
  result: ContactEntity | null;
}

export interface ArchiveContactItem  {
  __typename?: 'ArchiveContactItem';
  compactViewItem: ContactCompactViewItem | null;
  listViewItem: DataGridViewItem;
}

export interface ArchiveAccountPayload  {
  __typename?: 'ArchiveAccountPayload';
  clientMutationId: string | null;
  result: AccountEntity | null;
}

export interface ArchiveAccountItem  {
  __typename?: 'ArchiveAccountItem';
  compactViewItem: AccountCompactViewItem | null;
  listViewItem: DataGridViewItem;
}

export interface ApprovalsListingOptions  {
  __typename?: 'ApprovalsListingOptions';
  type: EntityNameEnum | null;
  visibility: ApprovalScreenVisibilityEnum | null;
}

export interface ApprovalResubmitCheckResult  {
  __typename?: 'ApprovalResubmitCheckResult';
  doesResubmitCreateApproval: boolean;
}

export interface ApprovalResponseNotificationEntity extends NotificationEntityInterface, NotificationTargetEntityInterface {
  __typename?: 'ApprovalResponseNotificationEntity';
  entityApiName: string | null;
  id: UUID;
  kind: EntityNameEnum;
  name: string | null;
  status: ApprovalStatusEnum;
}

export interface ApprovalRepository  {
  __typename?: 'ApprovalRepository';
  getAll: ApprovalEntity[];
  getByCriteria: ApprovalEntityConnection | null;
  getById: ApprovalEntity | null;
  getByIds: ApprovalEntity[];
  getChangedFieldsSinceRevision: UUID[];
  getDownloadUrl: string;
  getRecentApprovals: RecentApprovalItem[];
}

export interface ApprovalProfileData  {
  __typename?: 'ApprovalProfileData';
  listViewItems: ApprovalDataGridViewItems;
}

export interface ApprovalProcessesNotificationSettings  {
  __typename?: 'ApprovalProcessesNotificationSettings';
  ApprovalProcessError: boolean | null;
  ApprovalProcessWarning: boolean | null;
  ApprovalRequest: boolean;
  ApprovalResponse: boolean;
  IsActive: boolean;
}

export interface ApprovalProcessSettings  {
  __typename?: 'ApprovalProcessSettings';
  allApprove: boolean;
  approvers: ApprovalProcessApprover[];
  canDelegate: boolean;
  expiration: boolean;
  expirationDays: number;
  expirationResult: ApprovalProcessExpirationResult;
  recordLock: ApprovalProcessRecordLock;
  salesProcessDependency: boolean;
}

export interface ApprovalProcessSchema  {
  __typename?: 'ApprovalProcessSchema';
  approveNodes: ProcessNodeInterfaceImplementors[];
  filter: ProcessFilterNode;
  rejectNodes: ProcessNodeInterfaceImplementors[];
  settings: ApprovalProcessSettings;
  trigger: ApprovalProcessTrigger;
}

export interface ApprovalProcessRepository  {
  __typename?: 'ApprovalProcessRepository';
  getAll: ApprovalProcessEntity[];
  getApprovalProcessesWithManualTrigger: ApprovalProcessEntity[];
  getByApprovalProcessCriteria: ApprovalProcessEntityConnection | null;
  getByCriteria: ApprovalProcessEntityConnection | null;
  getById: ApprovalProcessEntity | null;
  getByIds: ApprovalProcessEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ApprovalProcessRecordTrigger extends ProcessActorInterface {
  __typename?: 'ApprovalProcessRecordTrigger';
  actor: ProcessRecordTriggerActorEnum;
  actorUnits: UUID[];
  actorUsers: UUID[];
  applications: UUID[];
  entityApiName: string | null;
  entityType: EntityNameEnum;
  event: ApprovalProcessRecordTriggerEventEnum;
}

export interface ApprovalProcessManualTrigger extends ProcessActorInterface {
  __typename?: 'ApprovalProcessManualTrigger';
  actor: ProcessRecordTriggerActorEnum;
  actorUnits: UUID[];
  actorUsers: UUID[];
  entityApiName: string | null;
  entityType: EntityNameEnum;
}

export interface ApprovalProcessEntityEdge  {
  __typename?: 'ApprovalProcessEntityEdge';
  cursor: string;
  node: ApprovalProcessEntity | null;
}

export interface ApprovalProcessEntityConnection  {
  __typename?: 'ApprovalProcessEntityConnection';
  edges: ApprovalProcessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApprovalProcessEntity  {
  __typename?: 'ApprovalProcessEntity';
  activityLogs: ApprovalEntityConnection | null;
  created: DateTime | null;
  description: string | null;
  documents: CloudObjectRelationEntity[] | null;
  entityType: BaseEntityTypeEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  lastSchemaChange: DateTime | null;
  lastStatusChange: DateTime | null;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  priority: number | null;
  settings: ApprovalProcessSchema | null;
  status: ProcessStatusEnum | null;
  triggerEntityName: EntityNameEnum | null;
  triggerType: ApprovalProcessTriggerTypeEnum | null;
}

export interface ApprovalProcessApprover  {
  __typename?: 'ApprovalProcessApprover';
  id: UUID | null;
  type: ApprovalProcessApproverType;
}

export interface ApprovalProcessActivityLogLineRepository  {
  __typename?: 'ApprovalProcessActivityLogLineRepository';
  getAll: ApprovalProcessActivityLogLineEntity[];
  getByCriteria: ApprovalProcessActivityLogLineEntityConnection | null;
  getById: ApprovalProcessActivityLogLineEntity | null;
  getByIds: ApprovalProcessActivityLogLineEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ApprovalProcessActivityLogLineEntityEdge  {
  __typename?: 'ApprovalProcessActivityLogLineEntityEdge';
  cursor: string;
  node: ApprovalProcessActivityLogLineEntity | null;
}

export interface ApprovalProcessActivityLogLineEntityConnection  {
  __typename?: 'ApprovalProcessActivityLogLineEntityConnection';
  edges: ApprovalProcessActivityLogLineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApprovalProcessActivityLogLineEntity  {
  __typename?: 'ApprovalProcessActivityLogLineEntity';
  approval: ApprovalEntity | null;
  approvalId: ID;
  created: DateTime | null;
  data: JSONString;
  executedAt: DateTime | null;
  formattedText: string;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isVisible: boolean | null;
  modified: DateTime | null;
  sortOrder: number;
  status: ProcessStatusEnum | null;
}

export interface ApprovalPreviewViewTab  {
  __typename?: 'ApprovalPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ApprovalPreviewScreenProfile extends ProfileInterface {
  __typename?: 'ApprovalPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ApprovalPreviewProfile;
  useLang: boolean;
}

export interface ApprovalPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'ApprovalPreviewScreen';
  activeProfile: ApprovalPreviewScreenProfile;
  data: ApprovalProfileData;
  draftProfile: ApprovalPreviewScreenProfile | null;
  entityData: ApprovalEntityData | null;
  name: string;
  profiles: ApprovalPreviewScreenProfile[];
}

export interface ApprovalPreviewProfile extends ApprovalProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface {
  __typename?: 'ApprovalPreviewProfile';
  filter: ActivityFilterTab;
  view: ApprovalPreviewViewTab;
}

export interface ApprovalEntityEdge  {
  __typename?: 'ApprovalEntityEdge';
  cursor: string;
  node: ApprovalEntity | null;
}

export interface ApprovalEntityData  {
  __typename?: 'ApprovalEntityData';
  entity: ApprovalEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface ApprovalEntityConnection  {
  __typename?: 'ApprovalEntityConnection';
  edges: ApprovalEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApprovalEntity  {
  __typename?: 'ApprovalEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  actor: ClientEntity | null;
  actorId: ID | null;
  application: ApplicationEntity | null;
  applicationId: ID;
  approvalProcess: ApprovalProcessEntity | null;
  approvalProcessId: ID;
  approvalStatus: ApprovalStatusEnum | null;
  approvers: ApprovalApproverEntityConnection | null;
  comment: string | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  endTime: DateTime | null;
  entityType: BaseEntityTypeEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  lines: ApprovalProcessActivityLogLineEntityConnection | null;
  modified: DateTime | null;
  name: string | null;
  oppty: OpportunityEntity | null;
  ownerId: UUID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
  settings: JSONString;
  startTime: DateTime | null;
  status: ProcessStatusEnum | null;
}

export interface ApprovalDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ApprovalDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ApprovalApproverRepository  {
  __typename?: 'ApprovalApproverRepository';
  getAll: ApprovalApproverEntity[];
  getByCriteria: ApprovalApproverEntityConnection | null;
  getById: ApprovalApproverEntity | null;
  getByIds: ApprovalApproverEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ApprovalApproverEntityEdge  {
  __typename?: 'ApprovalApproverEntityEdge';
  cursor: string;
  node: ApprovalApproverEntity | null;
}

export interface ApprovalApproverEntityConnection  {
  __typename?: 'ApprovalApproverEntityConnection';
  edges: ApprovalApproverEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApprovalApproverEntity  {
  __typename?: 'ApprovalApproverEntity';
  approval: ApprovalEntity | null;
  approvalId: ID;
  client: ClientEntity | null;
  clientId: ID;
  comment: string | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  status: ApprovalStatusEnum | null;
}

export interface AppointmentTypeRepository  {
  __typename?: 'AppointmentTypeRepository';
  getAll: AppointmentTypeEntity[];
  getByCriteria: AppointmentTypeEntityConnection | null;
  getById: AppointmentTypeEntity | null;
  getByIds: AppointmentTypeEntity[];
  getDraftById: AppointmentTypeEntity;
  getDrafts: AppointmentTypeEntity[];
  getPublished: AppointmentTypeEntity[];
}

export interface AppointmentTypeEntityEdge  {
  __typename?: 'AppointmentTypeEntityEdge';
  cursor: string;
  node: AppointmentTypeEntity | null;
}

export interface AppointmentTypeEntityConnection  {
  __typename?: 'AppointmentTypeEntityConnection';
  edges: AppointmentTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentTypeEntity  {
  __typename?: 'AppointmentTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  icon: ActivityTypeIconEnum | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
}

export interface AppointmentSearchResultItem extends SearchResultItemInterface {
  __typename?: 'AppointmentSearchResultItem';
  datetime: DateTime | null;
  endDate: DateTime;
  id: ID;
  isDeleted: boolean;
  linkedEntities: LinkedItemType[] | null;
  startDate: DateTime;
  subject: string;
}

export interface AppointmentScheduleRepository  {
  __typename?: 'AppointmentScheduleRepository';
  getAll: AppointmentScheduleEntity[];
  getByCriteria: AppointmentScheduleEntityConnection | null;
  getById: AppointmentScheduleEntity | null;
  getByIds: AppointmentScheduleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AppointmentScheduleInvitee  {
  __typename?: 'AppointmentScheduleInvitee';
  email: string;
  entityId: ID | null;
  type: AppointmentScheduleInviteeType;
}

export interface AppointmentScheduleEntityEdge  {
  __typename?: 'AppointmentScheduleEntityEdge';
  cursor: string;
  node: AppointmentScheduleEntity | null;
}

export interface AppointmentScheduleEntityConnection  {
  __typename?: 'AppointmentScheduleEntityConnection';
  edges: AppointmentScheduleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentScheduleEntity  {
  __typename?: 'AppointmentScheduleEntity';
  additionalFieldsData: AppointmentScheduleAdditionalField[];
  appointmentDescription: string;
  appointmentDuration: number | null;
  appointmentInviteesData: AppointmentScheduleInvitee[];
  appointmentLocation: string;
  appointmentLocationType: AppointmentScheduleLocationTypeEnum | null;
  appointmentOwner: ClientEntity | null;
  appointmentOwnerId: ID;
  appointmentSubject: string;
  appointmentSubjectUsesScheduleName: boolean;
  appointmentType: AppointmentTypeEntity | null;
  appointmentTypeId: ID;
  availabilityData: AppointmentScheduleAvailability;
  availabilityTzid: string | null;
  availableSlots: DateTime[];
  bufferTimeAfter: number;
  bufferTimeBefore: number;
  canceledAppointmentsCount: number;
  completedAppointmentsCount: number;
  confirmationPageType: AppointmentScheduleConfirmationPageTypeEnum | null;
  confirmationPageUrl: string | null;
  created: DateTime | null;
  createdAppointmentsCount: number;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isEnabled: boolean;
  minimumNoticeTime: number;
  modified: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  planningDayOffset: number;
  planningPeriodFrom: GqlDate | null;
  planningPeriodTo: GqlDate | null;
  planningType: AppointmentSchedulePlanningTypeEnum | null;
  reminderEmailEnabled: boolean;
  reminderEmailOffset: number;
  reminderEmailOffsetType: AppointmentScheduleReminderOffsetTypeEnum | null;
  replyCompanyEmail: CompanyEmailEntity | null;
  replyCompanyEmailId: ID | null;
  scheduleName: string;
  timeIncrement: number;
  type: AppointmentScheduleTypeEnum | null;
  upcomingAppointmentsCount: number;
  url: string;
}

export interface AppointmentScheduleDayAvailability  {
  __typename?: 'AppointmentScheduleDayAvailability';
  isEnabled: boolean;
  slots: AppointmentScheduleAvailabilitySlot[];
}

export interface AppointmentScheduleAvailabilitySlot  {
  __typename?: 'AppointmentScheduleAvailabilitySlot';
  end: number;
  start: number;
}

export interface AppointmentScheduleAvailability  {
  __typename?: 'AppointmentScheduleAvailability';
  friday: AppointmentScheduleDayAvailability;
  monday: AppointmentScheduleDayAvailability;
  saturday: AppointmentScheduleDayAvailability;
  sunday: AppointmentScheduleDayAvailability;
  thursday: AppointmentScheduleDayAvailability;
  tuesday: AppointmentScheduleDayAvailability;
  wednesday: AppointmentScheduleDayAvailability;
}

export interface AppointmentScheduleAdditionalField  {
  __typename?: 'AppointmentScheduleAdditionalField';
  fieldId: ID;
  isRequired: boolean;
  label: string;
}

export interface AppointmentRepository  {
  __typename?: 'AppointmentRepository';
  aiAutoPrefill: AppointmentAutoPrefill;
  autoPrefill: AppointmentEntity;
  getAll: AppointmentEntity[];
  getByCriteria: AppointmentEntityConnection | null;
  getById: AppointmentEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: AppointmentEntity[];
  getBySession: AppointmentEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
}

export interface AppointmentReminderRepository  {
  __typename?: 'AppointmentReminderRepository';
  getAll: AppointmentReminderEntity[];
  getByCriteria: AppointmentReminderEntityConnection | null;
  getById: AppointmentReminderEntity | null;
  getByIds: AppointmentReminderEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AppointmentReminderEntityEdge  {
  __typename?: 'AppointmentReminderEntityEdge';
  cursor: string;
  node: AppointmentReminderEntity | null;
}

export interface AppointmentReminderEntityConnection  {
  __typename?: 'AppointmentReminderEntityConnection';
  edges: AppointmentReminderEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentReminderEntity  {
  __typename?: 'AppointmentReminderEntity';
  appointment: AppointmentEntity | null;
  appointmentId: ID;
  created: DateTime | null;
  endDateOffset: number;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  snoozeDate: DateTime | null;
  status: ReminderStatusEnum | null;
}

export interface AppointmentRecurrenceOccurrenceCalendarViewItem extends CalendarViewItemInterface {
  __typename?: 'AppointmentRecurrenceOccurrenceCalendarViewItem';
  badgeColor: number | null;
  endDate: DateTime;
  id: ID;
  name: string;
  occurenceDate: DateTime;
  ownerColor: number | null;
  startDate: DateTime;
  status: ActivityStatusEnum;
}

export interface AppointmentRecurrence  {
  __typename?: 'AppointmentRecurrence';
  calendarUrl: string | null;
  rrule: string;
  rruleHumanReadable: string;
}

export interface AppointmentRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface {
  __typename?: 'AppointmentRecentlyOpenedResultItem';
  endDate: DateTime;
  id: ID;
  isDeleted: boolean;
  linkedEntities: RecentlyOpenedLinkedItemType[];
  openedAt: DateTime;
  startDate: DateTime;
  subject: string;
}

export interface AppointmentMeeting  {
  __typename?: 'AppointmentMeeting';
  joinUrl: string;
  type: AppointmentMeetingTypeEnum;
}

export interface AppointmentEntityEdge  {
  __typename?: 'AppointmentEntityEdge';
  cursor: string;
  node: AppointmentEntity | null;
}

export interface AppointmentEntityData  {
  __typename?: 'AppointmentEntityData';
  accounts: ActivityRelationEntityConnection | null;
  contacts: ActivityRelationEntityConnection | null;
  customEntities: ActivityRelationEntityConnection | null;
  entity: AppointmentEntity;
  fields: InterfaceFieldDataImplementors[];
  leads: ActivityRelationEntityConnection | null;
  opportunities: ActivityRelationEntityConnection | null;
}

export interface AppointmentEntityConnection  {
  __typename?: 'AppointmentEntityConnection';
  edges: AppointmentEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentEntity  {
  __typename?: 'AppointmentEntity';
  accountRelations: ActivityRelationEntityConnection | null;
  activeReminder: string | null;
  activityType: AppointmentTypeEntity | null;
  activityTypeId: ID | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  comments: ActivityCommentEntityConnection | null;
  contactRelations: ActivityRelationEntityConnection | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customEntityRelations: ActivityRelationEntityConnection | null;
  customFields: JSONString;
  description: string | null;
  documents: CloudObjectRelationEntityConnection | null;
  duration: number | null;
  endDate: DateTime;
  exchangeEntityId: string | null;
  fields: InterfaceFieldDataImplementors[];
  formattedName: string;
  gapiEntityId: string | null;
  has3rdPartyMapping: boolean;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  inviteesCanEdit: boolean | null;
  inviteesClients: AppointmentClientInviteesRelationEntityConnection | null;
  inviteesContacts: AppointmentContactInviteesRelationEntityConnection | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isRecurrenceActive: boolean | null;
  isRecurrenceException: boolean | null;
  leadRelations: ActivityRelationEntityConnection | null;
  location: string | null;
  mediaTranscription: MediaEntity | null;
  mediaTranscriptionId: UUID | null;
  meetingUrl: AppointmentMeeting | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  o365EntityId: string | null;
  occurenceDate: DateTime | null;
  opportunityRelations: ActivityRelationEntityConnection | null;
  organizer: string | null;
  owner: ClientEntity | null;
  ownerId: ID;
  pendingScheduledActions: number | null;
  projectRelations: ActivityRelationEntityConnection | null;
  quoteRelations: ActivityRelationEntityConnection | null;
  recurrence: AppointmentRecurrence | null;
  recurrenceMaster: AppointmentEntity | null;
  recurrenceMasterId: ID | null;
  recurrenceRule: string | null;
  recurrenceTzid: string | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  reminder: AppointmentReminderEntity | null;
  revision: number | null;
  schedule: AppointmentScheduleEntity | null;
  scheduleId: ID | null;
  scheduleTzid: string | null;
  startDate: DateTime | null;
  status: ActivityStatusEnum;
  subject: string;
  tableName: string;
  tags: TagRelationEntityConnection | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
}

export interface AppointmentContactInviteesRelationRepository  {
  __typename?: 'AppointmentContactInviteesRelationRepository';
  getAll: AppointmentContactInviteesRelationEntity[];
  getByCriteria: AppointmentContactInviteesRelationEntityConnection | null;
  getById: AppointmentContactInviteesRelationEntity | null;
  getByIds: AppointmentContactInviteesRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AppointmentContactInviteesRelationEntityEdge  {
  __typename?: 'AppointmentContactInviteesRelationEntityEdge';
  cursor: string;
  node: AppointmentContactInviteesRelationEntity | null;
}

export interface AppointmentContactInviteesRelationEntityConnection  {
  __typename?: 'AppointmentContactInviteesRelationEntityConnection';
  edges: AppointmentContactInviteesRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentContactInviteesRelationEntity  {
  __typename?: 'AppointmentContactInviteesRelationEntity';
  appointment: AppointmentEntity | null;
  appointmentId: ID;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  email: string;
  firstName: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  inviteeType: AppointmentInviteeTypeEnum | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lastName: string | null;
  modified: DateTime | null;
  response: InviteeResponseEnum | null;
  revision: number | null;
}

export interface AppointmentClientInviteesRelationRepository  {
  __typename?: 'AppointmentClientInviteesRelationRepository';
  getAll: AppointmentClientInviteesRelationEntity[];
  getByCriteria: AppointmentClientInviteesRelationEntityConnection | null;
  getById: AppointmentClientInviteesRelationEntity | null;
  getByIds: AppointmentClientInviteesRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AppointmentClientInviteesRelationEntityEdge  {
  __typename?: 'AppointmentClientInviteesRelationEntityEdge';
  cursor: string;
  node: AppointmentClientInviteesRelationEntity | null;
}

export interface AppointmentClientInviteesRelationEntityConnection  {
  __typename?: 'AppointmentClientInviteesRelationEntityConnection';
  edges: AppointmentClientInviteesRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AppointmentClientInviteesRelationEntity  {
  __typename?: 'AppointmentClientInviteesRelationEntity';
  appointment: AppointmentEntity | null;
  appointmentId: ID;
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  response: InviteeResponseEnum | null;
  revision: number | null;
}

export interface AppointmentCalendarViewItem extends CalendarViewItemInterface, ViewItemInterface {
  __typename?: 'AppointmentCalendarViewItem';
  activityTypeId: ID;
  badgeColor: number | null;
  endDate: DateTime;
  id: ID;
  name: string;
  ownerColor: number | null;
  ownerId: ID;
  recurrenceMasterId: ID | null;
  startDate: DateTime;
  status: ActivityStatusEnum;
  tags: number[] | null;
}

export interface AppointmentAutoPrefill  {
  __typename?: 'AppointmentAutoPrefill';
  entity: AppointmentEntity | null;
  fieldIds: UUID[];
}

export interface ApplyCustomizationPayload  {
  __typename?: 'ApplyCustomizationPayload';
  clientMutationId: string | null;
}

export interface ApplicationUseOption  {
  __typename?: 'ApplicationUseOption';
  isAvailableForPersonalTrigger: boolean;
  isAvailableForTrigger: boolean;
  isDisplayable: boolean;
  isFilterable: boolean;
}

export interface ApplicationRepository  {
  __typename?: 'ApplicationRepository';
  getAll: ApplicationEntity[];
  getByCriteria: ApplicationEntityConnection | null;
  getById: ApplicationEntity | null;
  getByIds: ApplicationEntity[];
}

export interface ApplicationEntityEdge  {
  __typename?: 'ApplicationEntityEdge';
  cursor: string;
  node: ApplicationEntity | null;
}

export interface ApplicationEntityConnection  {
  __typename?: 'ApplicationEntityConnection';
  edges: ApplicationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApplicationEntity  {
  __typename?: 'ApplicationEntity';
  automationHubId: number | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isActive: boolean;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isTrigger: boolean;
  isVisible: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  useOptions: ApplicationUseOption;
  usesImpersonation: boolean | null;
}

export interface ApiAccessRepository  {
  __typename?: 'ApiAccessRepository';
  getAll: ApiAccessEntity[];
  getAllForAdmin: ApiAccessEntity[];
  getByCriteria: ApiAccessEntityConnection | null;
  getById: ApiAccessEntity | null;
  getByIds: ApiAccessEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ApiAccessPermissions  {
  __typename?: 'ApiAccessPermissions';
  administration: ApiAccessPermissionAdministrationTab;
  misc: ApiAccessPermissionMiscTab;
  records: ApiAccessPermissionRecordsTab;
}

export interface ApiAccessPermissionRecordsTab  {
  __typename?: 'ApiAccessPermissionRecordsTab';
  accounts: ApiPermissionEnum;
  appointments: ApiPermissionEnum;
  contacts: ApiPermissionEnum;
  customEntities: CustomEntityApiAccessPermission[];
  emails: ApiPermissionEnum;
  leads: ApiPermissionEnum;
  messages: ApiPermissionEnum;
  opportunities: ApiPermissionEnum;
  projects: ApiPermissionEnum;
  tasks: ApiPermissionEnum;
}

export interface ApiAccessPermissionMiscTab  {
  __typename?: 'ApiAccessPermissionMiscTab';
  data: ApiPermissionEnum;
  documents: ApiPermissionEnum;
  others: ApiPermissionEnum;
  reports: ApiPermissionEnum;
  webhooks: ApiPermissionEnum;
}

export interface ApiAccessPermissionAdministrationTab  {
  __typename?: 'ApiAccessPermissionAdministrationTab';
  automationHub: ApiPermissionEnum;
  commonList: ApiPermissionEnum;
  currencies: ApiPermissionEnum;
  fieldsAndForms: ApiPermissionEnum;
  pipelines: ApiPermissionEnum;
  productsAndPrices: ApiPermissionEnum;
  security: ApiPermissionEnum;
  settings: ApiPermissionEnum;
  unitsAndRoles: ApiPermissionEnum;
}

export interface ApiAccessEntityEdge  {
  __typename?: 'ApiAccessEntityEdge';
  cursor: string;
  node: ApiAccessEntity | null;
}

export interface ApiAccessEntityConnection  {
  __typename?: 'ApiAccessEntityConnection';
  edges: ApiAccessEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ApiAccessEntity  {
  __typename?: 'ApiAccessEntity';
  created: DateTime | null;
  email: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isActive: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lastUsed: DateTime | null;
  modified: DateTime | null;
  name: string | null;
  permissions: ApiAccessPermissions | null;
  plainPassword: string | null;
  type: ApiAccessTypeEnum;
  username: string | null;
}

export interface AllowedQuoteTypeRepository  {
  __typename?: 'AllowedQuoteTypeRepository';
  getAll: AllowedQuoteTypeEntity[];
  getByCriteria: AllowedQuoteTypeEntityConnection | null;
  getById: AllowedQuoteTypeEntity | null;
  getByIds: AllowedQuoteTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedQuoteTypeEntityEdge  {
  __typename?: 'AllowedQuoteTypeEntityEdge';
  cursor: string;
  node: AllowedQuoteTypeEntity | null;
}

export interface AllowedQuoteTypeEntityConnection  {
  __typename?: 'AllowedQuoteTypeEntityConnection';
  edges: AllowedQuoteTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedQuoteTypeEntity  {
  __typename?: 'AllowedQuoteTypeEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  quoteType: QuoteTypeEntity | null;
  quoteTypeId: ID;
  revision: number | null;
}

export interface AllowedPipelineRepository  {
  __typename?: 'AllowedPipelineRepository';
  getAll: AllowedPipelineEntity[];
  getByCriteria: AllowedPipelineEntityConnection | null;
  getById: AllowedPipelineEntity | null;
  getByIds: AllowedPipelineEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedPipelineInfo  {
  __typename?: 'AllowedPipelineInfo';
  accessStepDocuments: boolean;
  pipeline: PipelineEntity | null;
}

export interface AllowedPipelineEntityEdge  {
  __typename?: 'AllowedPipelineEntityEdge';
  cursor: string;
  node: AllowedPipelineEntity | null;
}

export interface AllowedPipelineEntityConnection  {
  __typename?: 'AllowedPipelineEntityConnection';
  edges: AllowedPipelineEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedPipelineEntity  {
  __typename?: 'AllowedPipelineEntity';
  accessStepDocuments: boolean | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  pipeline: PipelineEntity | null;
  pipelineId: ID;
  revision: number | null;
}

export interface AllowedLeadTypeRepository  {
  __typename?: 'AllowedLeadTypeRepository';
  getAll: AllowedLeadTypeEntity[];
  getByCriteria: AllowedLeadTypeEntityConnection | null;
  getById: AllowedLeadTypeEntity | null;
  getByIds: AllowedLeadTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedLeadTypeEntityEdge  {
  __typename?: 'AllowedLeadTypeEntityEdge';
  cursor: string;
  node: AllowedLeadTypeEntity | null;
}

export interface AllowedLeadTypeEntityConnection  {
  __typename?: 'AllowedLeadTypeEntityConnection';
  edges: AllowedLeadTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedLeadTypeEntity  {
  __typename?: 'AllowedLeadTypeEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  leadType: LeadTypeEntity | null;
  leadTypeId: ID;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  revision: number | null;
}

export interface AllowedEntityType  {
  __typename?: 'AllowedEntityType';
  entity: EntityNameEnum;
  entityApiName: string | null;
  entityTypeIds: ID[] | null;
}

export interface AllowedContactTypeRepository  {
  __typename?: 'AllowedContactTypeRepository';
  getAll: AllowedContactTypeEntity[];
  getByCriteria: AllowedContactTypeEntityConnection | null;
  getById: AllowedContactTypeEntity | null;
  getByIds: AllowedContactTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedContactTypeEntityEdge  {
  __typename?: 'AllowedContactTypeEntityEdge';
  cursor: string;
  node: AllowedContactTypeEntity | null;
}

export interface AllowedContactTypeEntityConnection  {
  __typename?: 'AllowedContactTypeEntityConnection';
  edges: AllowedContactTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedContactTypeEntity  {
  __typename?: 'AllowedContactTypeEntity';
  contactType: ContactTypeEntity | null;
  contactTypeId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  revision: number | null;
}

export interface AllowedCompanyPhoneRepository  {
  __typename?: 'AllowedCompanyPhoneRepository';
  getAll: AllowedCompanyPhoneEntity[];
  getByCriteria: AllowedCompanyPhoneEntityConnection | null;
  getById: AllowedCompanyPhoneEntity | null;
  getByIds: AllowedCompanyPhoneEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedCompanyPhoneEntityEdge  {
  __typename?: 'AllowedCompanyPhoneEntityEdge';
  cursor: string;
  node: AllowedCompanyPhoneEntity | null;
}

export interface AllowedCompanyPhoneEntityConnection  {
  __typename?: 'AllowedCompanyPhoneEntityConnection';
  edges: AllowedCompanyPhoneEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedCompanyPhoneEntity  {
  __typename?: 'AllowedCompanyPhoneEntity';
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  phone: PhoneEntity | null;
  phoneId: ID;
  revision: number | null;
}

export interface AllowedCompanyEmailRepository  {
  __typename?: 'AllowedCompanyEmailRepository';
  getAll: AllowedCompanyEmailEntity[];
  getByCriteria: AllowedCompanyEmailEntityConnection | null;
  getById: AllowedCompanyEmailEntity | null;
  getByIds: AllowedCompanyEmailEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedCompanyEmailEntityEdge  {
  __typename?: 'AllowedCompanyEmailEntityEdge';
  cursor: string;
  node: AllowedCompanyEmailEntity | null;
}

export interface AllowedCompanyEmailEntityConnection  {
  __typename?: 'AllowedCompanyEmailEntityConnection';
  edges: AllowedCompanyEmailEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedCompanyEmailEntity  {
  __typename?: 'AllowedCompanyEmailEntity';
  companyEmail: CompanyEmailEntity | null;
  companyEmailId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  revision: number | null;
}

export interface AllowedAccountTypeRepository  {
  __typename?: 'AllowedAccountTypeRepository';
  getAll: AllowedAccountTypeEntity[];
  getByCriteria: AllowedAccountTypeEntityConnection | null;
  getById: AllowedAccountTypeEntity | null;
  getByIds: AllowedAccountTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AllowedAccountTypeEntityEdge  {
  __typename?: 'AllowedAccountTypeEntityEdge';
  cursor: string;
  node: AllowedAccountTypeEntity | null;
}

export interface AllowedAccountTypeEntityConnection  {
  __typename?: 'AllowedAccountTypeEntityConnection';
  edges: AllowedAccountTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AllowedAccountTypeEntity  {
  __typename?: 'AllowedAccountTypeEntity';
  accountType: AccountTypeEntity | null;
  accountTypeId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  masterRight: MasterRightEntity | null;
  masterRightId: ID;
  modified: DateTime | null;
  revision: number | null;
}

export interface AllSendersListingEdge  {
  __typename?: 'AllSendersListingEdge';
  cursor: string;
  node: Sender | null;
}

export interface AllSendersListingConnection  {
  __typename?: 'AllSendersListingConnection';
  edges: AllSendersListingEdge[];
  pageInfo: PageInfo;
}

export interface AllSendersListing  {
  __typename?: 'AllSendersListing';
  senders: AllSendersListingConnection | null;
}

export interface AlfrescoPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'AlfrescoPipelineHubItemEntity';
  configuration: AlfrescoHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface AlfrescoIntegrationStorageService extends GenericIntegrationStorageService {
  __typename?: 'AlfrescoIntegrationStorageService';
  listFolder: RemoteStorageFileListResultConnection | null;
}

export interface AlfrescoHubItemConfig  {
  __typename?: 'AlfrescoHubItemConfig';
  clientIdOnAccountFieldId: UUID;
  clientIdOnOpportunityFieldId: UUID;
  clientRootUrl: string;
  folderUrl: string;
  password: string | null;
  userName: string;
}

export interface AiVoyagerTwoTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'AiVoyagerTwoTeamPipelineHubItemEntity';
  configuration: AiVoyagerTwoHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface AiVoyagerTwoHubItemConfig  {
  __typename?: 'AiVoyagerTwoHubItemConfig';
  automatizerAgent: boolean | null;
  onlineFormAgent: boolean | null;
  recordDetail: boolean | null;
  reportAgent: boolean | null;
  smartField: boolean | null;
  superAgent: boolean | null;
}

export interface AiUpdateReportPayload  {
  __typename?: 'AiUpdateReportPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiUpdateProcessPayload  {
  __typename?: 'AiUpdateProcessPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiUpdateOnlineFormPayload  {
  __typename?: 'AiUpdateOnlineFormPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiTextAnalysisSentiment  {
  __typename?: 'AiTextAnalysisSentiment';
  score: number;
  sentiment: AiTextAnalysisSentimentEnum;
}

export interface AiTextAnalysisInformation  {
  __typename?: 'AiTextAnalysisInformation';
  type: AiTextAnalysisInformationTypeEnum;
  value: string;
}

export interface AiTextAnalysis  {
  __typename?: 'AiTextAnalysis';
  information: AiTextAnalysisInformation[] | null;
  sentiments: AiTextAnalysisSentiment[] | null;
  tags: string[] | null;
  tone: string | null;
}

export interface AiTaskError  {
  __typename?: 'AiTaskError';
  code: number;
  reason: string;
}

export interface AiSuggestionData  {
  __typename?: 'AiSuggestionData';
  suggestions: AiRecordSuggestion[];
}

export interface AiStartSuperAgentToolPayload  {
  __typename?: 'AiStartSuperAgentToolPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiSmartValueUpdateStatus  {
  __typename?: 'AiSmartValueUpdateStatus';
  done: boolean | null;
  result: AiSmartValueUpdate | null;
}

export interface AiSmartValueUpdateMutationPayload  {
  __typename?: 'AiSmartValueUpdateMutationPayload';
  clientMutationId: string | null;
  result: AiSmartValueUpdate;
}

export interface AiSmartValueUpdate  {
  __typename?: 'AiSmartValueUpdate';
  updatedFieldsCount: number;
  updatedRecordsCount: number;
}

export interface AiSmartValuePreview  {
  __typename?: 'AiSmartValuePreview';
  credits: number;
  error: string | null;
  result: JSONString | null;
}

export interface AiScreenChatPayload  {
  __typename?: 'AiScreenChatPayload';
  clientMutationId: string | null;
  sessionId: string;
  taskId: string;
}

export interface AiReportTask extends AiTask {
  __typename?: 'AiReportTask';
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  report: AiReportData | null;
  sessionId: string | null;
  status: AiTaskStatus;
  text: string | null;
}

export interface AiReportData  {
  __typename?: 'AiReportData';
  description: string | null;
  name: string | null;
  schema: ReportSettings;
}

export interface AiRecordSummaryTask extends AiTask {
  __typename?: 'AiRecordSummaryTask';
  data: AiRecordSummaryData | null;
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  sessionId: string | null;
  status: AiTaskStatus;
  text: string | null;
}

export interface AiRecordSummaryPayload  {
  __typename?: 'AiRecordSummaryPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiRecordSummaryDataSection  {
  __typename?: 'AiRecordSummaryDataSection';
  text: string;
  title: string;
}

export interface AiRecordSummaryData  {
  __typename?: 'AiRecordSummaryData';
  sections: AiRecordSummaryDataSection[];
}

export interface AiRecordSuggestionsTask extends AiTask {
  __typename?: 'AiRecordSuggestionsTask';
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  sessionId: string | null;
  status: AiTaskStatus;
  suggestions: AiRecordSuggestion[] | null;
  text: string | null;
}

export interface AiRecordSuggestionsPayload  {
  __typename?: 'AiRecordSuggestionsPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiRecordSuggestion  {
  __typename?: 'AiRecordSuggestion';
  actions: AiAssistantTaskAction[];
  id: ID;
  text: string;
  title: string;
  type: AiRecordSuggestionType;
}

export interface AiRecordChatPayload  {
  __typename?: 'AiRecordChatPayload';
  clientMutationId: string | null;
  sessionId: string;
  taskId: string;
}

export interface AiPromptSuggestion  {
  __typename?: 'AiPromptSuggestion';
  name: string;
  prompt: string;
}

export interface AiProlongAskDocumentSummarySessionMutationPayload  {
  __typename?: 'AiProlongAskDocumentSummarySessionMutationPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface AiProcessTask extends AiTask {
  __typename?: 'AiProcessTask';
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  process: AiProcessData | null;
  sessionId: string | null;
  status: AiTaskStatus;
  text: string | null;
}

export interface AiProcessData  {
  __typename?: 'AiProcessData';
  description: string;
  name: string;
  schema: ProcessSchema;
}

export interface AiOnlineFormTask extends AiTask {
  __typename?: 'AiOnlineFormTask';
  error: AiTaskError | null;
  id: string;
  messageData: AiMessageData | null;
  result: AiOnlineFormResult | null;
  status: AiTaskStatus;
  text: string | null;
}

export interface AiOnlineFormResult  {
  __typename?: 'AiOnlineFormResult';
  image: AiOnlineFormImage | null;
  onlineForm: AiOnlineFormData;
  updatedFieldIds: string[];
}

export interface AiOnlineFormImage  {
  __typename?: 'AiOnlineFormImage';
  data: string;
  filename: string;
}

export interface AiOnlineFormFieldDraft  {
  __typename?: 'AiOnlineFormFieldDraft';
  dataSet: DataSetValue[] | null;
  dataSetId: ID | null;
  id: string;
  name: string;
  options: FieldOptionsProperty | null;
  typeId: string;
}

export interface AiOnlineFormData  {
  __typename?: 'AiOnlineFormData';
  description: string | null;
  fieldDrafts: AiOnlineFormFieldDraft[];
  name: string | null;
  schema: OnlineForm;
}

export interface AiModifyTextPayload  {
  __typename?: 'AiModifyTextPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiGenerateEmailPayload  {
  __typename?: 'AiGenerateEmailPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiFeedEmailCreateSummaryMutationPayload  {
  __typename?: 'AiFeedEmailCreateSummaryMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiFeedEmailCreateKeyPointsMutationPayload  {
  __typename?: 'AiFeedEmailCreateKeyPointsMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiFeedEmailCreateEmailReplyMutationPayload  {
  __typename?: 'AiFeedEmailCreateEmailReplyMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiFeedEmailCreateActionPointsMutationPayload  {
  __typename?: 'AiFeedEmailCreateActionPointsMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiFeedEmailCategorizeEmailsPayload  {
  __typename?: 'AiFeedEmailCategorizeEmailsPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface AiExampleData  {
  __typename?: 'AiExampleData';
  examples: AiExample[];
}

export interface AiExample  {
  __typename?: 'AiExample';
  prompt: string;
  title: string;
}

export interface AiCreditInfo  {
  __typename?: 'AiCreditInfo';
  status: AiCreditInfoStatus;
  value: number | null;
}

export interface AiCreateSummaryMutationPayload  {
  __typename?: 'AiCreateSummaryMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateSummaryFromSelectionMutationPayload  {
  __typename?: 'AiCreateSummaryFromSelectionMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateSummaryFromEmailThreadMutationPayload  {
  __typename?: 'AiCreateSummaryFromEmailThreadMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateKeyPointsMutationPayload  {
  __typename?: 'AiCreateKeyPointsMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateKeyPointsFromSelectionMutationPayload  {
  __typename?: 'AiCreateKeyPointsFromSelectionMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateKeyPointsFromEmailThreadMutationPayload  {
  __typename?: 'AiCreateKeyPointsFromEmailThreadMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateEmailReplyMutationPayload  {
  __typename?: 'AiCreateEmailReplyMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateEmailReplyFromSelectionMutationPayload  {
  __typename?: 'AiCreateEmailReplyFromSelectionMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateEmailReplyFromEmailThreadMutationPayload  {
  __typename?: 'AiCreateEmailReplyFromEmailThreadMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateDocumentSummaryMutationPayload  {
  __typename?: 'AiCreateDocumentSummaryMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateActionPointsMutationPayload  {
  __typename?: 'AiCreateActionPointsMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateActionPointsFromSelectionMutationPayload  {
  __typename?: 'AiCreateActionPointsFromSelectionMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiCreateActionPointsFromEmailThreadMutationPayload  {
  __typename?: 'AiCreateActionPointsFromEmailThreadMutationPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiConvertHtmlToMjmlTask  {
  __typename?: 'AiConvertHtmlToMjmlTask';
  error: AiTaskError | null;
  result: string | null;
  status: AiTaskStatus;
}

export interface AiConvertHtmlMjmlPayload  {
  __typename?: 'AiConvertHtmlMjmlPayload';
  clientMutationId: string | null;
  taskId: string;
}

export interface AiConversationItem  {
  __typename?: 'AiConversationItem';
  actor: AiConversationItemActor;
  text: string;
}

export interface AiContext  {
  __typename?: 'AiContext';
  data: JSONString | null;
  entityApiName: string | null;
  entityId: ID | null;
  entityType: EntityNameEnum | null;
}

export interface AiChatPayload  {
  __typename?: 'AiChatPayload';
  clientMutationId: string | null;
  sessionId: string;
  taskId: string;
}

export interface AiCategorizeEmailsPayload  {
  __typename?: 'AiCategorizeEmailsPayload';
  clientMutationId: string | null;
  result: boolean;
}

export interface AiCancelTaskPayload  {
  __typename?: 'AiCancelTaskPayload';
  canceled: boolean;
  clientMutationId: string | null;
}

export interface AiAssistantUpdateFormAction  {
  __typename?: 'AiAssistantUpdateFormAction';
  id: ID;
}

export interface AiAssistantTeamPipelineHubItemEntity extends TeamPipelineHubInterface {
  __typename?: 'AiAssistantTeamPipelineHubItemEntity';
  configuration: AiAssistantHubItemConfig | null;
  configurationUrlFormatted: string | null;
  id: ID;
  instanceFieldPermissions: FieldLevelPermissionEnum;
  instancePermissions: LicEntityPermsEnum[];
  isEnabled: boolean;
  status: TeamPipelineHubItemStatusEnum;
  teamSpace: TeamSpaceEntity | null;
  teamSpaceId: string;
}

export interface AiAssistantTask extends AiTask {
  __typename?: 'AiAssistantTask';
  childTasks: AiTaskImplementors[] | null;
  error: AiTaskError | null;
  id: string;
  message: TextMessageEntity | null;
  messageData: AiMessageData | null;
  messageId: string | null;
  newText: string | null;
  progress: string | null;
  status: AiTaskStatus;
  text: string | null;
}

export interface AiAssistantService  {
  __typename?: 'AiAssistantService';
  checkIfDocumentsMeetRequirements: boolean;
  convertHtmlToMjmlTask: AiConvertHtmlToMjmlTask | null;
  creditInfo: AiCreditInfo | null;
  onlineFormTask: AiOnlineFormTask | null;
  processTask: AiProcessTask | null;
  recordSuggestions: AiRecordSuggestionsTask | null;
  recordSuggestionsDetails: AiRecordSuggestionsTask | null;
  recordSummary: AiRecordSummaryTask | null;
  reportTask: AiReportTask | null;
  task: AiAssistantTask | null;
  textAnalysisForEmail: AiTextAnalysis;
  textAnalysisForEmailThread: AiTextAnalysis;
  textAnalysisForText: AiTextAnalysis;
}

export interface AiAssistantPrompt  {
  __typename?: 'AiAssistantPrompt';
  entityApiName: string | null;
  entityName: EntityNameEnum | null;
  id: UUID;
  starred: boolean | null;
  text: string;
  title: string;
}

export interface AiAssistantHubItemConfig  {
  __typename?: 'AiAssistantHubItemConfig';
  agreeWithTermsAndPolicies: boolean;
  agreedDate: DateTime | null;
  aiAgent: boolean;
  automatizer: boolean;
  documentTools: boolean;
  emailAssistant: boolean;
  emailCategorization: boolean;
  feedTools: boolean;
  mediaTranscription: boolean;
  reports: boolean;
  speechToText: boolean;
  textAnalysis: boolean;
  textToSpeech: boolean;
  textTools: boolean;
}

export interface AiAssistantFavoritePrompts  {
  __typename?: 'AiAssistantFavoritePrompts';
  entityApiName: string | null;
  entityName: EntityNameEnum | null;
  promptIds: UUID[];
}

export interface AiAssistantCreateRecordAction  {
  __typename?: 'AiAssistantCreateRecordAction';
  entityApiName: string | null;
  entityName: EntityNameEnum;
  id: ID;
}

export interface AiAssistantCreateNoteAction  {
  __typename?: 'AiAssistantCreateNoteAction';
  note: string;
}

export interface AiAssistantCreateEmailAction  {
  __typename?: 'AiAssistantCreateEmailAction';
  body: string;
  subject: string;
}

export interface AiAskDocumentSummaryMutationPayload  {
  __typename?: 'AiAskDocumentSummaryMutationPayload';
  clientMutationId: string | null;
  sessionId: string;
  taskId: string;
}

export interface AggregationRelation  {
  __typename?: 'AggregationRelation';
  aggregationFieldId: ID | null;
  aggregationOperator: AggregationOperator;
  operationFieldId: ID | null;
}

export interface AggregationField  {
  __typename?: 'AggregationField';
  columnColor: number | null;
  columnFormatting: ColumnFormatting | null;
  columnWidth: number | null;
  comparison: AggregationComparison;
  fieldId: UUID | null;
  id: UUID;
  name: string | null;
  operator: AggregationOperator;
}

export interface AggregationComparison  {
  __typename?: 'AggregationComparison';
  fieldId: UUID | null;
  isEnabled: boolean;
  operator: AggregationOperator;
  type: AggregationComparisonType;
}

export interface AgendaRecurrentAppointmentVirtualOccurence extends ActivityAgendaItemInterface, NavigatorAgendaItemInterface {
  __typename?: 'AgendaRecurrentAppointmentVirtualOccurence';
  appointmentType: ActivityTypeIconEnum;
  date: GqlDate;
  endDatetime: DateTime | null;
  linkedId: ID;
  name: string;
  occurenceDate: DateTime | null;
  startDatetime: DateTime | null;
}

export interface AgendaOpportunityVelocity extends NavigatorAgendaItemInterface {
  __typename?: 'AgendaOpportunityVelocity';
  date: GqlDate;
  fitness: WarningLevelEnum | null;
  linkedId: ID;
  name: string;
  opportunityLabel: number;
  opportunityRanking: number;
}

export interface AgendaOpportunityClosingDate extends NavigatorAgendaItemInterface {
  __typename?: 'AgendaOpportunityClosingDate';
  date: GqlDate;
  fitness: WarningLevelEnum | null;
  linkedId: ID;
  name: string;
  opportunityLabel: number;
  opportunityRanking: number;
}

export interface AgendaDueDateTask extends ActivityAgendaItemInterface, NavigatorAgendaItemInterface {
  __typename?: 'AgendaDueDateTask';
  date: GqlDate;
  linkedId: ID;
  name: string;
  priority: PriorityEnum;
  reminder: DateTime | null;
  taskType: ActivityTypeIconEnum;
}

export interface AgendaAppointment extends ActivityAgendaItemInterface, NavigatorAgendaItemInterface {
  __typename?: 'AgendaAppointment';
  appointmentType: ActivityTypeIconEnum;
  date: GqlDate;
  endDatetime: DateTime | null;
  isRecurrent: boolean;
  linkedId: ID;
  name: string;
  reminder: DateTime | null;
  startDatetime: DateTime | null;
}

export interface Agenda  {
  __typename?: 'Agenda';
  achievedTargetGoalPercent: number | null;
  items: NavigatorAgendaItemConnection | null;
  lastMonthResultToYearAverage: number | null;
  overdueTasks: OverdueTasks;
}

export interface AffectedProcessesProcessOutput  {
  __typename?: 'AffectedProcessesProcessOutput';
  id: UUID;
  name: string;
}

export interface AffectedByConditionCount  {
  __typename?: 'AffectedByConditionCount';
  count: number;
  id: UUID;
}

export interface AdvancedMergeListing  {
  __typename?: 'AdvancedMergeListing';
  items: DataGridViewItem[];
  masterId: UUID | null;
  preselectedFields: MergeDuplicatesField[];
  total: number;
}

export interface AdvancedGlobalSearchResult  {
  __typename?: 'AdvancedGlobalSearchResult';
  count: number | null;
  listViewItems: GenericDrilldownDataGridViewItems;
}

export interface AdvancedGlobalSearch  {
  __typename?: 'AdvancedGlobalSearch';
  items: AdvancedGlobalSearchResult;
}

export interface AdvancedFormulaProperty  {
  __typename?: 'AdvancedFormulaProperty';
  decimalPlaces: number | null;
  displayOption: AdvancedFormulaDisplayOptionEnum | null;
  displayOptionCustomValue: string | null;
  formula: string;
  type: AdvancedFormulaTypeEnum;
}

export interface AdvancedFormulaDataResult  {
  __typename?: 'AdvancedFormulaDataResult';
  entityId: ID;
  errorCode: number | null;
  fieldId: ID;
  value: JSONString | null;
}

export interface AdminRegistry  {
  __typename?: 'AdminRegistry';
  auditLog: AuditLogScreen;
  integrationAnalytics: IntegrationAnalytics;
  integrationLogs: IntegrationLogs;
  isDeferredRecalculationActive: boolean;
  spaceSettings: Settings;
  sqlExportSetup: SqlExportSetup;
}

export interface AddRecordsToExistingStaticProfilesProfilePayload  {
  __typename?: 'AddRecordsToExistingStaticProfilesProfilePayload';
  clientMutationId: string | null;
}

export interface AddPipelineStepPayload  {
  __typename?: 'AddPipelineStepPayload';
  clientMutationId: string | null;
  result: PipelineEntity | null;
}

export interface AddClientToUnitClientPayload  {
  __typename?: 'AddClientToUnitClientPayload';
  clientMutationId: string | null;
  result: ClientEntity | null;
}

export interface AddCallSummarizationToDescriptionOfTaskPayload  {
  __typename?: 'AddCallSummarizationToDescriptionOfTaskPayload';
  clientMutationId: string | null;
  task: TaskEntity | null;
}

export interface AddAutomationHubItemPayload  {
  __typename?: 'AddAutomationHubItemPayload';
  clientMutationId: string | null;
  result: AutomationHubItemEntity | null;
}

export interface ActivityType  {
  __typename?: 'ActivityType';
  icon: ActivityTypeIconEnum;
  id: ID;
  name: string;
}

export interface ActivityTaskBoardViewItems extends ActivityAgendaInterface {
  __typename?: 'ActivityTaskBoardViewItems';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface ActivityTaskBoardColumnItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ActivityTaskBoardColumnItems';
  items: TaskBoardViewItem[];
  sessionId: string;
  total: number;
}

export interface ActivityTableReportProfile extends ActivityProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'ActivityTableReportProfile';
  filter: ActivityFilterTab;
  quickFilter: QuickFilterTab;
  role: ActivityRoleTab;
  view: ViewTableReportTab;
}

export interface ActivityTabTaskBoardView  {
  __typename?: 'ActivityTabTaskBoardView';
  ofAccount: AccountActivityTabTaskBoardView;
  ofContact: ContactActivityTabTaskBoardView;
  ofCustomEntity: CustomEntityActivityTabTaskBoardView;
  ofLead: LeadActivityTabTaskBoardView;
  ofOpportunity: OpportunityActivityTabTaskBoardView;
  ofProject: ProjectActivityTabTaskBoardView;
  ofQuote: QuoteActivityTabTaskBoardView;
}

export interface ActivityTabObjectiveView  {
  __typename?: 'ActivityTabObjectiveView';
  ofProject: ProjectActivityTabObjectiveView;
}

export interface ActivityTabDataGridViewStat  {
  __typename?: 'ActivityTabDataGridViewStat';
  count: number;
  status: ActivityStatusEnum;
}

export interface ActivityTabDataGridViewOptions  {
  __typename?: 'ActivityTabDataGridViewOptions';
  filterByActivityTypeId: ID[] | null;
  filterByOwnerId: ID[] | null;
  filterByPeriod: PeriodOption;
  filterByStatus: ActivityStatusEnum[];
  filterByTags: ID[] | null;
  relatedActivities: boolean;
  searchQuery: string | null;
  showTasksWithoutDueDate: boolean | null;
}

export interface ActivityTabDataGridView  {
  __typename?: 'ActivityTabDataGridView';
  ofAccount: AccountActivityTabDataGridView;
  ofContact: ContactActivityTabDataGridView;
  ofCustomEntity: CustomEntityActivityTabDataGridView;
  ofLead: LeadActivityTabDataGridView;
  ofOpportunity: OpportunityActivityTabDataGridView;
  ofProject: ProjectActivityTabDataGridView;
  ofQuote: QuoteActivityTabDataGridView;
}

export interface ActivityTabCalendarView  {
  __typename?: 'ActivityTabCalendarView';
  ofAccount: AccountActivityTabCalendarView;
  ofContact: ContactActivityTabCalendarView;
  ofCustomEntity: CustomEntityActivityTabCalendarView;
  ofLead: LeadActivityTabCalendarView;
  ofOpportunity: OpportunityActivityTabCalendarView;
  ofProject: ProjectActivityTabCalendarView;
  ofQuote: QuoteActivityTabCalendarView;
}

export interface ActivityStatusInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'ActivityStatusInterfaceFieldData';
  activityStatus: ActivityStatusEnum;
  fieldId: UUID;
}

export interface ActivityRoleTab extends RoleTabInterface {
  __typename?: 'ActivityRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
  showUnassignedItems: boolean;
}

export interface ActivityRepository  {
  __typename?: 'ActivityRepository';
  getAll: ActivityEntity[];
  getByCriteria: ActivityEntityConnection | null;
  getById: ActivityEntity | null;
  getByIds: ActivityEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ActivityRelationRepository  {
  __typename?: 'ActivityRelationRepository';
  getAll: ActivityRelationEntity[];
  getByCriteria: ActivityRelationEntityConnection | null;
  getById: ActivityRelationEntity | null;
  getByIds: ActivityRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ActivityRelationEntityEdge  {
  __typename?: 'ActivityRelationEntityEdge';
  cursor: string;
  node: ActivityRelationEntity | null;
}

export interface ActivityRelationEntityConnection  {
  __typename?: 'ActivityRelationEntityConnection';
  edges: ActivityRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ActivityRelationEntity  {
  __typename?: 'ActivityRelationEntity';
  account: AccountEntity | null;
  accountId: ID | null;
  activityId: ID;
  appointment: AppointmentEntity | null;
  contact: ContactEntity | null;
  contactId: ID | null;
  created: DateTime | null;
  customEntity: CustomEntityEntity | null;
  customEntityId: ID | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  lead: LeadEntity | null;
  leadOpptyId: ID | null;
  modified: DateTime | null;
  oppty: OpportunityEntity | null;
  project: ProjectEntity | null;
  projectId: ID | null;
  projectObjective: ProjectObjectiveEntity | null;
  projectObjectiveId: ID | null;
  quote: QuoteEntity | null;
  quoteId: ID | null;
  revision: number | null;
  sortOrder: number | null;
  task: TaskEntity | null;
}

export interface ActivityProfileData  {
  __typename?: 'ActivityProfileData';
  calendarViewItems: ActivityCalendarViewItems;
  listViewItems: ActivityDataGridViewItems;
  taskBoardViewItems: ActivityTaskBoardViewItems;
}

export interface ActivityPreviewViewTab  {
  __typename?: 'ActivityPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  groupBy: ActivityGroupBy;
  showCardLabels: boolean | null;
  showDueDate: boolean;
  showExtraFieldIds: UUID[] | null;
  showLinkedItems: boolean;
  showProgress: boolean;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface ActivityPreviewScreenProfile extends ProfileInterface {
  __typename?: 'ActivityPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: ActivityPreviewProfile;
  useLang: boolean;
}

export interface ActivityPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'ActivityPreviewScreen';
  activeProfile: ActivityPreviewScreenProfile;
  data: ActivityProfileData;
  draftProfile: ActivityPreviewScreenProfile | null;
  item: ActivityItem | null;
  name: string;
  profiles: ActivityPreviewScreenProfile[];
}

export interface ActivityPreviewProfile extends ActivityProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'ActivityPreviewProfile';
  filter: ActivityFilterTab;
  quickFilter: QuickFilterTab;
  role: ActivityRoleTab;
  view: ActivityPreviewViewTab;
}

export interface ActivityPivotReportProfile extends ActivityProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'ActivityPivotReportProfile';
  filter: ActivityFilterTab;
  quickFilter: QuickFilterTab;
  role: ActivityRoleTab;
  view: ViewPivotReportTab;
}

export interface ActivityListView extends ListViewInterface {
  __typename?: 'ActivityListView';
  displayColumn: UUID[];
  profile: ActivityPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface ActivityKPIRepository  {
  __typename?: 'ActivityKPIRepository';
  getAll: ActivityKPIEntity[];
  getByCriteria: ActivityKPIEntityConnection | null;
  getById: ActivityKPIEntity | null;
  getByIds: ActivityKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ActivityKPIEntityEdge  {
  __typename?: 'ActivityKPIEntityEdge';
  cursor: string;
  node: ActivityKPIEntity | null;
}

export interface ActivityKPIEntityConnection  {
  __typename?: 'ActivityKPIEntityConnection';
  edges: ActivityKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ActivityKPIEntity  {
  __typename?: 'ActivityKPIEntity';
  activityId: ID;
  applicationId: ID | null;
  appointment: AppointmentEntity | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: ActivityKpiEnum;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID | null;
  revision: number | null;
  task: TaskEntity | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface ActivityItem  {
  __typename?: 'ActivityItem';
  calendarViewItem: CalendarViewItemInterfaceImplementors | null;
  listViewItem: DataGridViewItem;
  taskBoardViewItem: TaskBoardViewItem | null;
}

export interface ActivityFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'ActivityFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface ActivityEntityEdge  {
  __typename?: 'ActivityEntityEdge';
  cursor: string;
  node: ActivityEntity | null;
}

export interface ActivityEntityConnection  {
  __typename?: 'ActivityEntityConnection';
  edges: ActivityEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ActivityEntity  {
  __typename?: 'ActivityEntity';
  activeReminder: string | null;
  customFields: JSONString;
  fields: InterfaceFieldDataImplementors[];
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  mediaTranscriptionId: UUID | null;
  pendingScheduledActions: number | null;
}

export interface ActivityDrilldownModel  {
  __typename?: 'ActivityDrilldownModel';
  listViewItems: ActivityDrilldownDataGridViewItems;
}

export interface ActivityDrilldownFilter  {
  __typename?: 'ActivityDrilldownFilter';
  activityTypeId: ID[] | null;
  ownerId: ID[] | null;
  period: PeriodOption;
  showTasksWithoutDueDate: boolean | null;
}

export interface ActivityDrilldownDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ActivityDrilldownDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface ActivityDetailTabs  {
  __typename?: 'ActivityDetailTabs';
  calendar: ActivityTabCalendarView;
  grid: ActivityTabDataGridView;
  objective: ActivityTabObjectiveView;
  taskBoard: ActivityTabTaskBoardView;
}

export interface ActivityDetailFilterOptions  {
  __typename?: 'ActivityDetailFilterOptions';
  showAttendeesRecords: boolean;
  showMyRecords: boolean;
  showSalesTeamRecords: boolean;
  showSalesUnitsRecords: boolean;
}

export interface ActivityDetailCalendarViewItems extends ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'ActivityDetailCalendarViewItems';
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface ActivityDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'ActivityDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface ActivityDataExRelationRepository  {
  __typename?: 'ActivityDataExRelationRepository';
  getAll: ActivityDataExRelationEntity[];
  getByCriteria: ActivityDataExRelationEntityConnection | null;
  getById: ActivityDataExRelationEntity | null;
  getByIds: ActivityDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ActivityDataExRelationEntityEdge  {
  __typename?: 'ActivityDataExRelationEntityEdge';
  cursor: string;
  node: ActivityDataExRelationEntity | null;
}

export interface ActivityDataExRelationEntityConnection  {
  __typename?: 'ActivityDataExRelationEntityConnection';
  edges: ActivityDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ActivityDataExRelationEntity  {
  __typename?: 'ActivityDataExRelationEntity';
  activityId: ID;
  appointment: AppointmentEntity | null;
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  task: TaskEntity | null;
}

export interface ActivityDashboardView  {
  __typename?: 'ActivityDashboardView';
  data: DashboardGraphItemInterfaceImplementors[] | null;
}

export interface ActivityDashboardProfileView extends DashboardViewInterface {
  __typename?: 'ActivityDashboardProfileView';
  drilldownFields: ID[];
  graphs: DashboardGraphActivityNameType[];
}

export interface ActivityDashboardProfileTab extends DashboardTabItem {
  __typename?: 'ActivityDashboardProfileTab';
  activityDashboardProfile: ActivityDashboardProfile | null;
  id: ID;
}

export interface ActivityDashboardProfile extends ActivityProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, RoleProfileInterface {
  __typename?: 'ActivityDashboardProfile';
  filter: ActivityFilterTab;
  role: ActivityRoleTab;
  view: ActivityDashboardProfileView;
}

export interface ActivityCommentRepository  {
  __typename?: 'ActivityCommentRepository';
  getAll: ActivityCommentEntity[];
  getByCriteria: ActivityCommentEntityConnection | null;
  getById: ActivityCommentEntity | null;
  getByIds: ActivityCommentEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface ActivityCommentEntityEdge  {
  __typename?: 'ActivityCommentEntityEdge';
  cursor: string;
  node: ActivityCommentEntity | null;
}

export interface ActivityCommentEntityConnection  {
  __typename?: 'ActivityCommentEntityConnection';
  edges: ActivityCommentEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface ActivityCommentEntity  {
  __typename?: 'ActivityCommentEntity';
  activityId: ID;
  appointment: AppointmentEntity | null;
  comment: string;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  task: TaskEntity | null;
}

export interface ActivityCalendarViewItems extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'ActivityCalendarViewItems';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export interface ActivityAgendaItemEdge  {
  __typename?: 'ActivityAgendaItemEdge';
  cursor: string;
  node: ActivityAgendaItemInterfaceImplementors | null;
}

export interface ActivityAgendaItemConnection  {
  __typename?: 'ActivityAgendaItemConnection';
  edges: ActivityAgendaItemEdge[];
  pageInfo: PageInfo;
}

export interface ActivityAgenda  {
  __typename?: 'ActivityAgenda';
  items: ActivityAgendaItemConnection | null;
  overdueTasks: OverdueTasks;
}

export interface ActivitiesNotificationSettings  {
  __typename?: 'ActivitiesNotificationSettings';
  Comment: boolean;
  Invitation: boolean;
  IsActive: boolean;
  OwnershipAndSalesTeamChange: boolean;
  StatusChange: boolean;
}

export interface ActivateTargetPayload  {
  __typename?: 'ActivateTargetPayload';
  clientMutationId: string | null;
  target: TargetEntity | null;
}

export interface Acl  {
  __typename?: 'Acl';
  allowedAccountTypes: AccountTypeEntity[];
  allowedContactTypes: ContactTypeEntity[];
  allowedCustomEntityTypes: CustomEntityTypeEntity[];
  allowedLeadTypes: LeadTypeEntity[];
  allowedPipelines: AllowedPipelineInfo[];
  allowedQuoteTypes: QuoteTypeEntity[];
  allowedTierModules: TierModules[];
  bulkInstancePermissions: EntityInstancePermissions[];
  disallowedTierModules: TierModules[];
  entities: EntityClassPermissionsListing;
  features: FeaturePermissions;
  instancePermissions: EntityPermsEnum[];
  masterRight: MasterRightEntity;
  mutations: MutationPermissions[];
}

export interface AccountsHierarchyNodeEntity  {
  __typename?: 'AccountsHierarchyNodeEntity';
  account: AccountEntity | null;
  accountId: UUID;
  label: string | null;
  parentId: UUID | null;
  relation: ParentAccountRelationTypeEntity | null;
}

export interface AccountsAndContactsNotificationSettings  {
  __typename?: 'AccountsAndContactsNotificationSettings';
  IsActive: boolean;
  LinkedItem: boolean;
  OwnershipAndSalesTeamChange: boolean;
}

export interface AccountTypeRepository  {
  __typename?: 'AccountTypeRepository';
  getAll: AccountTypeEntity[];
  getByCriteria: AccountTypeEntityConnection | null;
  getById: AccountTypeEntity | null;
  getByIds: AccountTypeEntity[];
  getDraftById: AccountTypeEntity;
  getDrafts: AccountTypeEntity[];
  getPublished: AccountTypeEntity[];
}

export interface AccountTypeEntityEdge  {
  __typename?: 'AccountTypeEntityEdge';
  cursor: string;
  node: AccountTypeEntity | null;
}

export interface AccountTypeEntityConnection  {
  __typename?: 'AccountTypeEntityConnection';
  edges: AccountTypeEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountTypeEntity  {
  __typename?: 'AccountTypeEntity';
  canChangeReadonly: boolean | null;
  created: DateTime | null;
  formEdit: JSONString;
  formEditApi: Form | null;
  hasDraft: boolean | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isPublished: boolean | null;
  isReadonly: boolean;
  modified: DateTime | null;
  name: string;
  revision: number | null;
  settings: EntityTypeSettings;
}

export interface AccountTableReportProfile extends AccountProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface, TableReportTabsInterface {
  __typename?: 'AccountTableReportProfile';
  filter: AccountFilterTab;
  quickFilter: QuickFilterTab;
  role: AccountRoleTab;
  view: ViewTableReportTab;
}

export interface AccountTabDataGridViewOptions  {
  __typename?: 'AccountTabDataGridViewOptions';
  directChildrenOnly: boolean;
  filterByOwnerId: ID[] | null;
  filterByTags: ID[] | null;
  searchQuery: string | null;
  showArchivedRecords: boolean | null;
}

export interface AccountTabDataGridView  {
  __typename?: 'AccountTabDataGridView';
  accountHierarchy: AccountHierarchyTabDataGridView;
  ofAccount: AccountChildAccountTabDataGridView;
}

export interface AccountSocialRelationRepository  {
  __typename?: 'AccountSocialRelationRepository';
  getAll: AccountSocialRelationEntity[];
  getByCriteria: AccountSocialRelationEntityConnection | null;
  getById: AccountSocialRelationEntity | null;
  getByIds: AccountSocialRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountSocialRelationEntityEdge  {
  __typename?: 'AccountSocialRelationEntityEdge';
  cursor: string;
  node: AccountSocialRelationEntity | null;
}

export interface AccountSocialRelationEntityConnection  {
  __typename?: 'AccountSocialRelationEntityConnection';
  edges: AccountSocialRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountSocialRelationEntity  {
  __typename?: 'AccountSocialRelationEntity';
  angellistUrl: string | null;
  created: DateTime | null;
  crunchbaseUrl: string | null;
  disqusUrl: string | null;
  facebookId: string | null;
  facebookUrl: string | null;
  flickrUrl: string | null;
  foursquareUrl: string | null;
  googleId: string | null;
  googlePlusUrl: string | null;
  gravatarUrl: string | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kloutUrl: string | null;
  linkedinId: string | null;
  linkedinUrl: string | null;
  modified: DateTime | null;
  pinterestUrl: string | null;
  quoraUrl: string | null;
  redditUrl: string | null;
  revision: number | null;
  skypeUrl: string | null;
  slideshareUrl: string | null;
  twitterId: string | null;
  twitterUrl: string | null;
  vimeoUrl: string | null;
  wordpressUrl: string | null;
  xingUrl: string | null;
  yahooUrl: string | null;
  yelpUrl: string | null;
  youtubeUrl: string | null;
}

export interface AccountSharingSalesUnitRelationRepository  {
  __typename?: 'AccountSharingSalesUnitRelationRepository';
  getAll: AccountSharingSalesUnitRelationEntity[];
  getByCriteria: AccountSharingSalesUnitRelationEntityConnection | null;
  getById: AccountSharingSalesUnitRelationEntity | null;
  getByIds: AccountSharingSalesUnitRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountSharingSalesUnitRelationEntityEdge  {
  __typename?: 'AccountSharingSalesUnitRelationEntityEdge';
  cursor: string;
  node: AccountSharingSalesUnitRelationEntity | null;
}

export interface AccountSharingSalesUnitRelationEntityConnection  {
  __typename?: 'AccountSharingSalesUnitRelationEntityConnection';
  edges: AccountSharingSalesUnitRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountSharingSalesUnitRelationEntity  {
  __typename?: 'AccountSharingSalesUnitRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
  unit: SalesUnitEntity | null;
  unitId: ID;
}

export interface AccountSharingClientRelationRepository  {
  __typename?: 'AccountSharingClientRelationRepository';
  getAll: AccountSharingClientRelationEntity[];
  getByCriteria: AccountSharingClientRelationEntityConnection | null;
  getById: AccountSharingClientRelationEntity | null;
  getByIds: AccountSharingClientRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountSharingClientRelationEntityEdge  {
  __typename?: 'AccountSharingClientRelationEntityEdge';
  cursor: string;
  node: AccountSharingClientRelationEntity | null;
}

export interface AccountSharingClientRelationEntityConnection  {
  __typename?: 'AccountSharingClientRelationEntityConnection';
  edges: AccountSharingClientRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountSharingClientRelationEntity  {
  __typename?: 'AccountSharingClientRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  client: ClientEntity | null;
  clientId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
  role: SharingRoleEnum | null;
}

export interface AccountSearchResultItem extends SearchResultItemInterface {
  __typename?: 'AccountSearchResultItem';
  datetime: DateTime | null;
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  location: string | null;
  name: string;
  pictureUrl: string | null;
  primaryEmail: string | null;
  primaryPhone: string | null;
}

export interface AccountRoleTab extends RoleTabInterface {
  __typename?: 'AccountRoleTab';
  showManagingUnitItems: boolean;
  showMyItems: boolean;
  showMySharedItems: boolean;
}

export interface AccountRoleRepository  {
  __typename?: 'AccountRoleRepository';
  getAll: AccountRoleEntity[];
  getByCriteria: AccountRoleEntityConnection | null;
  getById: AccountRoleEntity | null;
  getByIds: AccountRoleEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountRoleEntityEdge  {
  __typename?: 'AccountRoleEntityEdge';
  cursor: string;
  node: AccountRoleEntity | null;
}

export interface AccountRoleEntityConnection  {
  __typename?: 'AccountRoleEntityConnection';
  edges: AccountRoleEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountRoleEntity  {
  __typename?: 'AccountRoleEntity';
  color: number;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  label: string;
  modified: DateTime | null;
  revision: number | null;
}

export interface AccountRepository  {
  __typename?: 'AccountRepository';
  aiAutoPrefill: AccountAutoPrefill;
  autoPrefill: AccountEntity;
  getAll: AccountEntity[];
  getByCriteria: AccountEntityConnection | null;
  getById: AccountEntity | null;
  getByIdFormatted: JSONString | null;
  getByIds: AccountEntity[];
  getBySession: AccountEntityConnection | null;
  getChangedFieldsSinceRevision: UUID[];
  getEligibleParents: AccountEntity[];
  getRelatedToContact: AccountEntity[];
}

export interface AccountRelationTypeRepository  {
  __typename?: 'AccountRelationTypeRepository';
  getAll: AccountRelationTypeEntity[];
  getByCriteria: AccountRelationTypeEntity[];
  getById: AccountRelationTypeEntity | null;
  getByIds: AccountRelationTypeEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountRelationTypeEntity  {
  __typename?: 'AccountRelationTypeEntity';
  color: number;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  label: string | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface AccountRelationRepository  {
  __typename?: 'AccountRelationRepository';
  getAll: AccountRelationEntity[];
  getByCriteria: AccountRelationEntity[];
  getById: AccountRelationEntity | null;
  getByIds: AccountRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountRelationLabelRepository  {
  __typename?: 'AccountRelationLabelRepository';
  getAll: AccountRelationLabelEntity[];
  getByCriteria: AccountRelationLabelEntity[];
  getById: AccountRelationLabelEntity | null;
  getByIds: AccountRelationLabelEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountRelationLabelEntity  {
  __typename?: 'AccountRelationLabelEntity';
  accountRelation: AccountRelationEntity | null;
  accountRelationId: ID;
  accountRelationType: AccountRelationTypeEntity | null;
  accountRelationTypeId: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface AccountRelationGraphEdgeEntity  {
  __typename?: 'AccountRelationGraphEdgeEntity';
  account: AccountEntity | null;
  accountId: UUID | null;
  accountRelation: ParentAccountRelationTypeEntity | null;
  accountRelationLabel: string | null;
  labels: AccountRelationTypeEntity[] | null;
  parent: AccountEntity | null;
  parentId: UUID | null;
}

export interface AccountRelationEntity  {
  __typename?: 'AccountRelationEntity';
  account1: AccountEntity | null;
  account1Id: ID;
  account2: AccountEntity | null;
  account2Id: ID;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface AccountRecentlyOpenedResultItem extends RecentlyOpenedResultItemInterface, RecentlyOpenedResultItemIsArchivedInterface {
  __typename?: 'AccountRecentlyOpenedResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  location: string | null;
  name: string;
  openedAt: DateTime;
  pictureUrl: string | null;
  primaryEmail: string;
  primaryPhone: string;
}

export interface AccountQuoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountQuoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountProjectTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountProjectTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountProfileData  {
  __typename?: 'AccountProfileData';
  compactViewItems: AccountCompactViewItems;
  drilldown: AccountDrilldownModel;
  listViewItems: AccountDataGridViewItems;
  mapViewItems: AccountMapViewItems;
  matrixItems: AccountMatrixViewItems;
}

export interface AccountProductWhiteSpaceView  {
  __typename?: 'AccountProductWhiteSpaceView';
  data: ProductWhiteSpaceDataView | null;
}

export interface AccountProductTrendView  {
  __typename?: 'AccountProductTrendView';
  data: ProductTrendDataView;
  drilldown: ProductTrendViewDrilldown;
  itemDrilldown: ProductTrendViewDrilldown;
  series: ProductSeriesView;
  seriesDrilldown: ProductTrendViewDrilldown;
  startValueSeriesDrilldown: ProductTrendViewDrilldown;
}

export interface AccountProductPricingTabDataGridViewOptions  {
  __typename?: 'AccountProductPricingTabDataGridViewOptions';
  filterByProductCategoryId: ID[] | null;
  searchQuery: string | null;
}

export interface AccountProductPricingTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountProductPricingTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountProductPricingRepository  {
  __typename?: 'AccountProductPricingRepository';
  getAll: AccountProductPricingEntity[];
  getByCriteria: AccountProductPricingEntityConnection | null;
  getById: AccountProductPricingEntity | null;
  getByIds: AccountProductPricingEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountProductPricingEntityEdge  {
  __typename?: 'AccountProductPricingEntityEdge';
  cursor: string;
  node: AccountProductPricingEntity | null;
}

export interface AccountProductPricingEntityConnection  {
  __typename?: 'AccountProductPricingEntityConnection';
  edges: AccountProductPricingEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountProductPricingEntity  {
  __typename?: 'AccountProductPricingEntity';
  account: AccountEntity | null;
  accountId: ID;
  created: DateTime | null;
  currency: CurrencyEntity | null;
  currencyId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  price: number | null;
  product: ProductEntity | null;
  productId: ID;
  revision: number | null;
}

export interface AccountProductCategoryTrendView  {
  __typename?: 'AccountProductCategoryTrendView';
  data: ProductCategoryTrendDataView;
  drilldown: ProductTrendViewDrilldown;
  itemDrilldown: ProductTrendViewDrilldown;
  series: ProductSeriesView;
  seriesDrilldown: ProductTrendViewDrilldown;
  startValueSeriesDrilldown: ProductTrendViewDrilldown;
}

export interface AccountPreviewViewTab  {
  __typename?: 'AccountPreviewViewTab';
  gridColumns: GridColumnsOutput[];
  matrix: AccountMatrixView;
  sortBy: ID;
  sortOrder: SortOrder;
}

export interface AccountPreviewScreenProfile extends ProfileInterface {
  __typename?: 'AccountPreviewScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: AccountPreviewProfile;
  useLang: boolean;
}

export interface AccountPreviewScreen extends ProfileScreen, Screen {
  __typename?: 'AccountPreviewScreen';
  activeProfile: AccountPreviewScreenProfile;
  data: AccountProfileData;
  draftProfile: AccountPreviewScreenProfile | null;
  entityData: AccountEntityData | null;
  item: AccountItem | null;
  name: string;
  profiles: AccountPreviewScreenProfile[];
}

export interface AccountPreviewProfile extends AccountProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'AccountPreviewProfile';
  filter: AccountFilterTab;
  quickFilter: QuickFilterTab;
  role: AccountRoleTab;
  view: AccountPreviewViewTab;
}

export interface AccountPivotReportProfile extends AccountProfileInterface, PivotReportTabsInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, ReportTabInterface, RoleProfileInterface {
  __typename?: 'AccountPivotReportProfile';
  filter: AccountFilterTab;
  quickFilter: QuickFilterTab;
  role: AccountRoleTab;
  view: ViewPivotReportTab;
}

export interface AccountOpportunityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountOpportunityTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: OpportunityTabDataGridViewStat[];
  total: number;
}

export interface AccountNoteTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountNoteTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountMatrixViewItems  {
  __typename?: 'AccountMatrixViewItems';
  drilldown: AccountDrilldownModel;
  item: AccountMatrixItem | null;
  items: AccountMatrixItems;
  limits: AccountMatrixLimits;
}

export interface AccountMatrixView  {
  __typename?: 'AccountMatrixView';
  axisX: AccountMatrixAxis;
  axisY: AccountMatrixAxis;
  bubbleDisplay: AccountMatrixAccountDisplayEnum;
  showAccountNames: boolean;
  showSegmentationGrid: boolean;
}

export interface AccountMatrixLimits  {
  __typename?: 'AccountMatrixLimits';
  limitX: AccountMatrixLimit | null;
  limitY: AccountMatrixLimit | null;
}

export interface AccountMatrixLimit  {
  __typename?: 'AccountMatrixLimit';
  maximum: number | null;
  minimum: number | null;
}

export interface AccountMatrixItems  {
  __typename?: 'AccountMatrixItems';
  isResultTooLarge: boolean;
  items: AccountMatrixItem[];
}

export interface AccountMatrixItem  {
  __typename?: 'AccountMatrixItem';
  accountClass: AccountClassEnum;
  accountPictureUrl: string | null;
  entityTypeId: UUID;
  healthStatus: number | null;
  id: ID;
  name: string;
  ownerName: string;
  ownerPictureUrl: string | null;
  valueX: string | null;
  valueY: string | null;
}

export interface AccountMatrixAxis  {
  __typename?: 'AccountMatrixAxis';
  dateDisplay: AccountMatrixDateDisplayEnum | null;
  fieldId: ID;
  maximum: number | null;
  minimum: number | null;
  selectedOptions: ID[] | null;
  sortOrder: SortOrder;
}

export interface AccountMapViewItems  {
  __typename?: 'AccountMapViewItems';
  compactListSessionId: string | null;
  isResultTooLarge: boolean;
  items: MapViewInterfaceImplementors[];
  missingGeoLocationItems: number | null;
}

export interface AccountListView extends ListViewInterface {
  __typename?: 'AccountListView';
  displayColumn: UUID[];
  profile: AccountPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
  sidebarOpen: boolean;
}

export interface AccountLeadTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountLeadTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: LeadTabDataGridViewStat[];
  total: number;
}

export interface AccountKPIRepository  {
  __typename?: 'AccountKPIRepository';
  getAll: AccountKPIEntity[];
  getByCriteria: AccountKPIEntityConnection | null;
  getById: AccountKPIEntity | null;
  getByIds: AccountKPIEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountKPIEntityEdge  {
  __typename?: 'AccountKPIEntityEdge';
  cursor: string;
  node: AccountKPIEntity | null;
}

export interface AccountKPIEntityConnection  {
  __typename?: 'AccountKPIEntityConnection';
  edges: AccountKPIEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountKPIEntity  {
  __typename?: 'AccountKPIEntity';
  account: AccountEntity | null;
  accountId: ID;
  applicationId: ID | null;
  client: ClientEntity | null;
  clientId: ID | null;
  created: DateTime | null;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  kpi: AccountKpiEnum;
  modified: DateTime | null;
  owner: ClientEntity | null;
  ownerId: ID;
  revision: number | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
}

export interface AccountItem  {
  __typename?: 'AccountItem';
  compactViewItem: AccountCompactViewItem | null;
  listViewItem: DataGridViewItem;
}

export interface AccountHierarchyTabDataGridViewOptions  {
  __typename?: 'AccountHierarchyTabDataGridViewOptions';
  filterByOwnerId: ID[] | null;
  filterByTags: ID[] | null;
  searchQuery: string | null;
  showArchivedRecords: boolean | null;
}

export interface AccountHierarchyTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountHierarchyTabDataGridView';
  items: DataGridViewItemWithAvailability[];
  sessionId: string;
  total: number;
}

export interface AccountFilterTab extends ProfileFilterBaseInterface, ProfileFilterBoxTabInterface, ProfileFilterTabCustomFilterInterface {
  __typename?: 'AccountFilterTab';
  filterMainBox: MainFilterBox;
  filterSiblingBoxes: FilterBox[];
  formula: string | null;
  isCustom: boolean;
  isEnabled: boolean;
  operator: FilterGroupOperator;
}

export interface AccountFeedTabDataGridView  {
  __typename?: 'AccountFeedTabDataGridView';
  feed: Feed;
}

export interface AccountFeedEmailTabDataGridView  {
  __typename?: 'AccountFeedEmailTabDataGridView';
  feed: Feed;
}

export interface AccountFavoriteResultItem extends FavoriteResultItemInterface, FavoriteResultItemIsArchivedInterface {
  __typename?: 'AccountFavoriteResultItem';
  id: ID;
  isArchived: boolean;
  isDeleted: boolean;
  location: string | null;
  name: string;
  pictureUrl: string | null;
  primaryEmail: string;
  primaryPhone: string;
}

export interface AccountEntityEdge  {
  __typename?: 'AccountEntityEdge';
  cursor: string;
  node: AccountEntity | null;
}

export interface AccountEntityData  {
  __typename?: 'AccountEntityData';
  accountsHierarchy: AccountsHierarchyNodeEntity[];
  businessOverview: BusinessOverview;
  contacts: ContactAccountRelationEntityConnection | null;
  documents: CloudObjectRelationEntityConnection | null;
  entity: AccountEntity;
  fields: InterfaceFieldDataImplementors[];
  lastCompletedActivities: ActivityRelationEntityConnection | null;
  lastContacted: LastContactedItem | null;
  lastMessages: MessageRelationEntityConnection | null;
  leads: LeadOpptyAccountRelationEntityConnection | null;
  linesOfInfluence: ContactLineOfInfluence[];
  notes: NoteEntityConnection | null;
  openLeads: LeadOpptyAccountRelationEntityConnection | null;
  openOpportunities: LeadOpptyAccountRelationEntityConnection | null;
  opportunities: LeadOpptyAccountRelationEntityConnection | null;
  orgChart: OrgChartContactNodeEntity[];
  plannedActivities: ActivityRelationEntityConnection | null;
  relationGraph: AccountRelationGraphEdgeEntity[];
  topAccountsInIndustry: TopAccountEntity[];
  unplannedTasks: ActivityRelationEntityConnection | null;
}

export interface AccountEntityConnection  {
  __typename?: 'AccountEntityConnection';
  edges: AccountEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountEntity  {
  __typename?: 'AccountEntity';
  accountClass: AccountClassEnum | null;
  accountType: AccountTypeEntity | null;
  accountTypeId: ID | null;
  address: string | null;
  approval: ApprovalEntity | null;
  charts: DashboardChartData[] | null;
  chartsDrilldown: CompactViewDrilldownModel;
  city: string | null;
  comments: string | null;
  country: string | null;
  created: DateTime | null;
  currencyExchangeRatesList: CurrencyExchangeRatesListEntity | null;
  currencyExchangeRatesListId: ID | null;
  customFields: JSONString;
  customerType: DataEntity | null;
  customerTypeId: ID | null;
  documents: CloudObjectRelationEntityConnection | null;
  email1: string | null;
  email2: string | null;
  email3: string | null;
  email4: string | null;
  email5: string | null;
  enrolledEmailSequences: number;
  fields: InterfaceFieldDataImplementors[];
  formattedName: string;
  health: EntityHealthResult | null;
  healthCategory: ID | null;
  healthStatus: number | null;
  homePage: string | null;
  id: ID;
  industry: DataEntity | null;
  industryId: ID | null;
  instancePermissions: EntityPermsEnum[];
  isArchived: boolean | null;
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  isFavorite: boolean;
  isUnsubscribed: boolean | null;
  modified: DateTime | null;
  modifiedByUser: DateTime | null;
  name: string;
  owner: ClientEntity | null;
  ownerId: ID;
  parentAccount: AccountEntity | null;
  parentAccountId: ID | null;
  parentAccountRelationType: ParentAccountRelationTypeEntity | null;
  parentAccountRelationTypeId: ID | null;
  pendingScheduledActions: number | null;
  phone1: string | null;
  phone2: string | null;
  phone3: string | null;
  phone4: string | null;
  phone5: string | null;
  picture: CloudObjectEntity | null;
  pictureId: ID | null;
  quickParentAccountName: string | null;
  relatedEntitiesDrilldown: CompactViewDrilldownModel;
  revision: number | null;
  shareMode: ShareModeEnum | null;
  sharingClients: AccountSharingClientRelationEntityConnection | null;
  sharingUnits: AccountSharingSalesUnitRelationEntityConnection | null;
  socialMedia: AccountSocialRelationEntity | null;
  stateProvince: string | null;
  staticProfiles: ProfileRelationEntityConnection | null;
  tags: TagRelationEntityConnection | null;
  unit: SalesUnitEntity | null;
  unitId: ID | null;
  viewerIdsPerSalesUnit: UUID[];
  zipCode: string | null;
}

export interface AccountDrilldownModel  {
  __typename?: 'AccountDrilldownModel';
  listViewItems: AccountDrilldownDataGridViewItems;
}

export interface AccountDrilldownFilter  {
  __typename?: 'AccountDrilldownFilter';
  ownerId: ID[] | null;
}

export interface AccountDrilldownDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountDrilldownDataGridViewItems';
  averageItem: FieldDataContainer[];
  items: DataGridViewItem[];
  sessionId: string;
  sumItem: FieldDataContainer[];
  total: number;
}

export interface AccountDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountDataExRelationRepository  {
  __typename?: 'AccountDataExRelationRepository';
  getAll: AccountDataExRelationEntity[];
  getByCriteria: AccountDataExRelationEntityConnection | null;
  getById: AccountDataExRelationEntity | null;
  getByIds: AccountDataExRelationEntity[];
  getChangedFieldsSinceRevision: UUID[];
}

export interface AccountDataExRelationEntityEdge  {
  __typename?: 'AccountDataExRelationEntityEdge';
  cursor: string;
  node: AccountDataExRelationEntity | null;
}

export interface AccountDataExRelationEntityConnection  {
  __typename?: 'AccountDataExRelationEntityConnection';
  edges: AccountDataExRelationEntityEdge[];
  pageInfo: PageInfo;
  totalCount: number | null;
}

export interface AccountDataExRelationEntity  {
  __typename?: 'AccountDataExRelationEntity';
  account: AccountEntity | null;
  accountId: ID;
  created: DateTime | null;
  data: DataEntity | null;
  dataId: ID;
  dataSetId: ID;
  id: ID;
  instancePermissions: EntityPermsEnum[];
  isDeleteProtected: boolean;
  isDeleted: boolean | null;
  modified: DateTime | null;
  revision: number | null;
}

export interface AccountDashboardView  {
  __typename?: 'AccountDashboardView';
  data: DashboardGraphItemInterfaceImplementors[] | null;
}

export interface AccountDashboardProfileView extends DashboardViewInterface {
  __typename?: 'AccountDashboardProfileView';
  drilldownFields: ID[];
  graphs: DashboardGraphAccountNameType[];
}

export interface AccountDashboardProfileTab extends DashboardTabItem {
  __typename?: 'AccountDashboardProfileTab';
  accountDashboardProfile: AccountDashboardProfile | null;
  id: ID;
}

export interface AccountDashboardProfile extends AccountProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, RoleProfileInterface {
  __typename?: 'AccountDashboardProfile';
  filter: AccountFilterTab;
  role: AccountRoleTab;
  view: AccountDashboardProfileView;
}

export interface AccountContactTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountContactTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  stats: AccountContactTabDataGridStats;
  total: number;
}

export interface AccountContactTabDataGridStats  {
  __typename?: 'AccountContactTabDataGridStats';
  accountRoles: AccountContactRoleTabStats[];
  contactedInLastThirtyDays: number;
  contactsWithoutJobTitleCount: number;
  relationships: AccountContactOrgRelationshipTabStats[];
}

export interface AccountContactTabDataGridQuickFilter  {
  __typename?: 'AccountContactTabDataGridQuickFilter';
  filterByContactsContactedInLastThirtyDays: boolean | null;
  filterByContactsWithoutJobTitle: boolean | null;
  filterByRelationship: OrgRelationshipTypeEnum | null;
  filterByRole: UUID | null;
}

export interface AccountContactRoleTabStats  {
  __typename?: 'AccountContactRoleTabStats';
  accountRoleId: ID | null;
  count: number;
}

export interface AccountContactOrgRelationshipTabStats  {
  __typename?: 'AccountContactOrgRelationshipTabStats';
  count: number;
  relationshipType: OrgRelationshipTypeEnum;
}

export interface AccountCompactViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountCompactViewItems';
  groups: ViewItemGroup[];
  items: AccountCompactViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountCompactViewItem extends ViewItemInterface {
  __typename?: 'AccountCompactViewItem';
  accountClass: AccountClassEnum | null;
  accountPicture: string | null;
  accountTypeId: ID;
  address: string | null;
  city: string | null;
  country: string | null;
  email: string | null;
  entityType: EntityNameEnum;
  fields: InterfaceFieldDataImplementors[];
  homePage: string | null;
  id: ID;
  industryName: string | null;
  isFavorite: boolean | null;
  name: string;
  owner: string;
  ownerId: string;
  ownerPicture: string | null;
  phone: string | null;
  sortFieldValue: FieldDataContainer | null;
  stateProvince: string | null;
  unit: string;
  unitId: string;
  unitPicture: string | null;
  zipCode: string | null;
}

export interface AccountCompactView extends CompactViewInterface {
  __typename?: 'AccountCompactView';
  feedListingOptions: FeedTabDataGridViewOptions;
  profile: AccountPreviewProfile;
  profileId: string;
  searchQuery: string | null;
  sessionId: string;
}

export interface AccountCloudObjectTabDataGridView extends GridViewFolderCountInterface, ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountCloudObjectTabDataGridView';
  entityTypeFolderCounts: CloudObjectFolderCount[];
  items: DocumentDataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountClassInterfaceFieldData extends InterfaceFieldData {
  __typename?: 'AccountClassInterfaceFieldData';
  accountClass: AccountClassEnum;
  fieldId: UUID;
}

export interface AccountChildAccountTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountChildAccountTabDataGridView';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountCardProperty  {
  __typename?: 'AccountCardProperty';
  showArchivedRecords: boolean;
}

export interface AccountAutoPrefill  {
  __typename?: 'AccountAutoPrefill';
  entity: AccountEntity | null;
  fieldIds: UUID[];
}

export interface AccountArchiveScreenProfile extends ProfileInterface {
  __typename?: 'AccountArchiveScreenProfile';
  instancePermissions: EntityPermsEnum[];
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
  owner: ClientEntity;
  profileId: ID;
  profileType: ProfileTypeEnum;
  shareMode: ProfileShareMode;
  sharedUnits: SalesUnitEntity[];
  sharedUsers: ClientEntity[];
  tabs: AccountArchiveProfile;
  useLang: boolean;
}

export interface AccountArchiveScreen extends ProfileScreen, Screen {
  __typename?: 'AccountArchiveScreen';
  activeProfile: AccountArchiveScreenProfile;
  data: AccountArchiveProfileData;
  draftProfile: AccountArchiveScreenProfile | null;
  entityData: AccountArchiveEntityData | null;
  item: ArchiveAccountItem | null;
  name: string;
  profiles: AccountArchiveScreenProfile[];
}

export interface AccountArchiveProfileData  {
  __typename?: 'AccountArchiveProfileData';
  listViewItems: AccountArchiveDataGridViewItems;
}

export interface AccountArchiveProfile extends AccountProfileInterface, ProfileFilterBoxTabsInterface, ProfileTabsInterface, QuickFilterInterface, RoleProfileInterface {
  __typename?: 'AccountArchiveProfile';
  filter: AccountFilterTab;
  quickFilter: QuickFilterTab;
  role: AccountRoleTab;
  view: AccountPreviewViewTab;
}

export interface AccountArchiveEntityData  {
  __typename?: 'AccountArchiveEntityData';
  entity: AccountEntity;
  fields: InterfaceFieldDataImplementors[];
}

export interface AccountArchiveDataGridViewItems extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountArchiveDataGridViewItems';
  items: DataGridViewItem[];
  sessionId: string;
  total: number;
}

export interface AccountActivityTabTaskBoardView extends ActivityAgendaInterface {
  __typename?: 'AccountActivityTabTaskBoardView';
  agenda: ActivityAgenda;
  completed: ActivityTaskBoardColumnItems;
  deferred: ActivityTaskBoardColumnItems;
  inProgress: ActivityTaskBoardColumnItems;
  notStarted: ActivityTaskBoardColumnItems;
  waiting: ActivityTaskBoardColumnItems;
}

export interface AccountActivityTabDataGridView extends ListingViewInterface, SnapshotIndexedDataInterface {
  __typename?: 'AccountActivityTabDataGridView';
  appointmentStats: ActivityTabDataGridViewStat[];
  items: DataGridViewItem[];
  sessionId: string;
  taskStats: ActivityTabDataGridViewStat[];
  total: number;
}

export interface AccountActivityTabCalendarView extends ActivityAgendaInterface, ActivityViewItemInterface, ListingViewInterface {
  __typename?: 'AccountActivityTabCalendarView';
  agenda: ActivityAgenda;
  appointmentItems: AppointmentCalendarViewItem[] | null;
  appointmentRecurrenceOccurrenceItems: AppointmentRecurrenceOccurrenceCalendarViewItem[] | null;
  taskItems: TaskCalendarViewItem[] | null;
  total: number;
}

export const WonStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment WonStepExtractViewFragment on WonStepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInPipeline
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
    successRateCount
    successRateSession
    successRateTotalCount
    successRateTotalSession
    totalOpportunitiesSession
    wonArchiveOpportunitiesValue
  }`)();

export const ViewItemGroupFragment = /* @__PURE__ */ (() => gql`
  fragment ViewItemGroupFragment on ViewItemGroup {
    count
    entityApiName
    entityName
    name
  }`)();

export const UpdateUISettingsPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateUISettingsPayloadFragment on UpdateUISettingsPayload {
  clientMutationId
  }`)();

export const updateUiSettingsMutation = /* @__PURE__ */ (() => gql`
  mutation updateUiSettings($input: UpdateUISettingsInput!) {
      updateUiSettings(input: $input) {
          ...UpdateUISettingsPayloadFragment
      }
  }
  ${UpdateUISettingsPayloadFragment}
`)();

export const UpdateQuoteProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateQuoteProcessPayloadFragment on UpdateQuoteProcessPayload {
  clientMutationId
  quoteProcess {
    color
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    quoteTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formLostEnabled
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      quoteProcessId
      revision
    }
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const UpdateProductCategoryPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateProductCategoryPayloadFragment on UpdateProductCategoryPayload {
  clientMutationId
  productCategory {
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    parent {
      created
      id
      isDeleteProtected
      isDeleted
      modified
      name
      parentId
      revision
    }
    parentId
    productRelations {
      totalCount
    }
    revision
  }
  }`)();

export const updateProductCategoryMutation = /* @__PURE__ */ (() => gql`
  mutation updateProductCategory($input: UpdateProductCategoryInput!,$sessionIdToUpdate: String,$validationLevel: [ValidationLevel!]) {
      updateProductCategory(input: $input,sessionIdToUpdate: $sessionIdToUpdate,validationLevel: $validationLevel) {
          ...UpdateProductCategoryPayloadFragment
      }
  }
  ${UpdateProductCategoryPayloadFragment}
`)();

export const UpdatePipelinePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdatePipelinePayloadFragment on UpdatePipelinePayload {
  clientMutationId
  pipeline {
    color
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    opportunityTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formQualify
      formQualifyApi
      formWon
      formWonApi
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      pipelineId
      revision
    }
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const UpdateLeadProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateLeadProcessPayloadFragment on UpdateLeadProcessPayload {
  clientMutationId
  leadProcess {
    color
    created
    id
    isDeleteProtected
    isDeleted
    leadTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formLostEnabled
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      leadProcessId
      modified
      name
      revision
    }
    modified
    name
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const UpdateDraftTaskTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftTaskTypePayloadFragment on UpdateDraftTaskTypePayload {
  clientMutationId
  taskType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    icon
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    revision
  }
  }`)();

export const updateDraftTaskTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftTaskType($input: UpdateDraftTaskTypeInput!) {
      updateDraftTaskType(input: $input) {
          ...UpdateDraftTaskTypePayloadFragment
      }
  }
  ${UpdateDraftTaskTypePayloadFragment}
`)();

export const UpdateDraftProductTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftProductTypePayloadFragment on UpdateDraftProductTypePayload {
  clientMutationId
  productType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    opptyProductRelationType {
      canChangeReadonly
      created
      formEdit
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      productTypeId
      revision
    }
    opptyProductRelationTypeId
    revision
  }
  }`)();

export const updateDraftProductTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftProductType($input: UpdateDraftProductTypeInput!) {
      updateDraftProductType(input: $input) {
          ...UpdateDraftProductTypePayloadFragment
      }
  }
  ${UpdateDraftProductTypePayloadFragment}
`)();

export const UpdateDraftOpptyProductRelationTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftOpptyProductRelationTypePayloadFragment on UpdateDraftOpptyProductRelationTypePayload {
  clientMutationId
  opptyProductRelationType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    productType {
      canChangeReadonly
      created
      formEdit
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      opptyProductRelationTypeId
      revision
    }
    productTypeId
    revision
  }
  }`)();

export const updateDraftOpptyProductRelationTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftOpptyProductRelationType($input: UpdateDraftOpptyProductRelationTypeInput!) {
      updateDraftOpptyProductRelationType(input: $input) {
          ...UpdateDraftOpptyProductRelationTypePayloadFragment
      }
  }
  ${UpdateDraftOpptyProductRelationTypePayloadFragment}
`)();

export const UpdateDraftCustomEntityTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftCustomEntityTypePayloadFragment on UpdateDraftCustomEntityTypePayload {
    customEntityType {
      canChangeReadonly
      created
      entityApiName
      formEdit
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
    }
  }`)();

export const updateDraftCustomEntityTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftCustomEntityType($input: UpdateCustomEntityTypeDraftInput!) {
      updateDraftCustomEntityType(input: $input) {
          ...UpdateDraftCustomEntityTypePayloadFragment
      }
  }
  ${UpdateDraftCustomEntityTypePayloadFragment}
`)();

export const UpdateDraftAppointmentTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftAppointmentTypePayloadFragment on UpdateDraftAppointmentTypePayload {
  appointmentType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    icon
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    revision
  }
  clientMutationId
  }`)();

export const updateDraftAppointmentTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftAppointmentType($input: UpdateDraftAppointmentTypeInput!) {
      updateDraftAppointmentType(input: $input) {
          ...UpdateDraftAppointmentTypePayloadFragment
      }
  }
  ${UpdateDraftAppointmentTypePayloadFragment}
`)();

export const UpdateCustomEntityUiSettingsPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateCustomEntityUiSettingsPayloadFragment on UpdateCustomEntityUiSettingsPayload {
  clientMutationId
  }`)();

export const updateCustomEntityUiSettingsMutation = /* @__PURE__ */ (() => gql`
  mutation updateCustomEntityUiSettings($input: UpdateCustomEntityUiSettingsInput!) {
      updateCustomEntityUiSettings(input: $input) {
          ...UpdateCustomEntityUiSettingsPayloadFragment
      }
  }
  ${UpdateCustomEntityUiSettingsPayloadFragment}
`)();

export const UpdateCurrencyPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateCurrencyPayloadFragment on UpdateCurrencyPayload {
  clientMutationId
  currency {
    code
    created
    currencyExchangeRates {
      totalCount
    }
    id
    isBase
    isDeleteProtected
    isDeleted
    modified
    revision
    symbol
  }
  }`)();

export const UpdateCurrencyExchangeRatesListPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateCurrencyExchangeRatesListPayloadFragment on UpdateCurrencyExchangeRatesListPayload {
  clientMutationId
  currencyExchangeRatesList {
    created
    currencyExchangeRates {
      totalCount
    }
    id
    isDeleteProtected
    isDeleted
    modified
    revision
    validFrom
  }
  }`)();

export const UpdateCompanyEmailPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateCompanyEmailPayloadFragment on UpdateCompanyEmailPayload {
    companyEmail {
      created
      email
      enabled
      errorCode
      features
      id
      isDeleteProtected
      isDeleted
      modified
      name
      pictureUrl
      serviceType
      settings
      token
    }
  }`)();

export const updateCompanyEmailMutation = /* @__PURE__ */ (() => gql`
  mutation updateCompanyEmail($input: UpdateCompanyEntityEmailInput!,$sessionIdToUpdate: String,$validationLevel: [ValidationLevel!]) {
      updateCompanyEmail(input: $input,sessionIdToUpdate: $sessionIdToUpdate,validationLevel: $validationLevel) {
          ...UpdateCompanyEmailPayloadFragment
      }
  }
  ${UpdateCompanyEmailPayloadFragment}
`)();

export const UndoDraftsMutationFragment = /* @__PURE__ */ (() => gql`
  fragment UndoDraftsMutationFragment on UndoDraftsMutation {
    undoneDataCount
    undoneEntitySettingsCount
    undoneFieldCount
    undoneFieldPermissionCount
    undoneInterfacePreviewCount
    undoneResourceCount
    undoneTranslationsCount
    undoneTypesCount
  }`)();

export const undoDraftsMutation = /* @__PURE__ */ (() => gql`
  mutation undoDrafts($input: PublishDeleteDraftsInput) {
      undoDrafts(input: $input) {
          ...UndoDraftsMutationFragment
      }
  }
  ${UndoDraftsMutationFragment}
`)();

export const TypeEntityFragment = /* @__PURE__ */ (() => gql`
  fragment TypeEntityFragment on TypeEntity {
    containerSize
    defaultValue
    flag
    id
    isDeleteProtected
    isFilterable
    isGroupable
    isSelectable
    isSortable
    primitiveType
    relationType
    validator
  }`)();

export const TextMessageNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment TextMessageNotificationSettingsFragment on TextMessageNotificationSettings {
    IsActive
    LinkedItem
  }`)();

export const TaskCalendarViewItemFragment = /* @__PURE__ */ (() => gql`
  fragment TaskCalendarViewItemFragment on TaskCalendarViewItem {
    activityTypeId
    badgeColor
    dueDate
    id
    name
    ownerColor
    ownerId
    priority
    status
    tags
  }`)();

export const SwitchProfileFavoriteStatusPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment SwitchProfileFavoriteStatusPayloadFragment on SwitchProfileFavoriteStatusPayload {
  clientMutationId
  }`)();

export const switchProfileFavoriteStatusMutation = /* @__PURE__ */ (() => gql`
  mutation switchProfileFavoriteStatus($input: SwitchProfileFavoriteStatusInput!) {
      switchProfileFavoriteStatus(input: $input) {
          ...SwitchProfileFavoriteStatusPayloadFragment
      }
  }
  ${SwitchProfileFavoriteStatusPayloadFragment}
`)();

export const StepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment StepExtractViewFragment on StepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    dropOffRateCount
    dropOffRateSession
    dropOffRateTotalCount
    dropOffRateTotalSession
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
    readyToMoveCount
    readyToMoveSession
    velocityOverdueCount
    velocityOverdueSession
  }`)();

export const ServiceSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment ServiceSettingsFragment on ServiceSettings {
    deleteProtection
    folder
    recordOwnership
    syncArchived
    syncMethod
    syncPrivate
  }`)();

export const o365SetSettingsTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation o365SetSettingsTeamSpaceClientSetting($input: O365SetSettingsTeamSpaceClientSettingInput!) {
      o365SetSettingsTeamSpaceClientSetting(input: $input) {
          ...ServiceSettingsFragment
      }
  }
  ${ServiceSettingsFragment}
`)();

export const googleSetSettingsTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation googleSetSettingsTeamSpaceClientSetting($input: GoogleSetSettingsTeamSpaceClientSettingInput!) {
      googleSetSettingsTeamSpaceClientSetting(input: $input) {
          ...ServiceSettingsFragment
      }
  }
  ${ServiceSettingsFragment}
`)();

export const ServiceFolderFragment = /* @__PURE__ */ (() => gql`
  fragment ServiceFolderFragment on ServiceFolder {
    id
    isDefault
    name
  }`)();

export const SendInvitationsAppointmentPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment SendInvitationsAppointmentPayloadFragment on SendInvitationsAppointmentPayload {
  clientMutationId
  result
  }`)();

export const sendInvitationsAppointmentMutation = /* @__PURE__ */ (() => gql`
  mutation sendInvitationsAppointment($input: SendInvitationsAppointmentInput!) {
      sendInvitationsAppointment(input: $input) {
          ...SendInvitationsAppointmentPayloadFragment
      }
  }
  ${SendInvitationsAppointmentPayloadFragment}
`)();

export const ScreensDefaultProfilesParamsFragment = /* @__PURE__ */ (() => gql`
  fragment ScreensDefaultProfilesParamsFragment on ScreensDefaultProfilesParams {
    Accountscreen
    Activityscreen
    Archivescreen
    BetterNavigatorscreen
    Contactscreen
    Conversionsscreen
    Feedscreen2
    Indicatorsscreen
    Insightsscreen
    LeadArchivescreen
    Leadscreen
    Lifecyclescreen
    Navigator
    Pipelinescreen
    Projectscreen
    QuoteArchivescreen
    Quotescreen
  }`)();

export const RetrieveFoldersOutputFragment = /* @__PURE__ */ (() => gql`
  fragment RetrieveFoldersOutputFragment on RetrieveFoldersOutput {
    folders {
      ...ServiceFolderFragment
    }
    selectedFolderId
  }
  ${ServiceFolderFragment}
`)();

export const RequestCustomSolutionAutomationHubItemPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment RequestCustomSolutionAutomationHubItemPayloadFragment on RequestCustomSolutionAutomationHubItemPayload {
  clientMutationId
  }`)();

export const requestCustomSolutionAutomationHubItemMutation = /* @__PURE__ */ (() => gql`
  mutation requestCustomSolutionAutomationHubItem($input: RequestCustomSolutionAutomationHubItemInput!) {
      requestCustomSolutionAutomationHubItem(input: $input) {
          ...RequestCustomSolutionAutomationHubItemPayloadFragment
      }
  }
  ${RequestCustomSolutionAutomationHubItemPayloadFragment}
`)();

export const ReportFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment ReportFavoriteResultItemFragment on ReportFavoriteResultItem {
    id
    isDeleted
    isPivot
    modified
    name
    ownerName
    reportType
  }`)();

export const RelatedQuoteTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment RelatedQuoteTabDataGridViewOptionsFragment on RelatedQuoteTabDataGridViewOptions {
    filterByOwnerId
    relatedQuotes
    searchQuery
  }`)();

export const RelatedOpportunityTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment RelatedOpportunityTabDataGridViewOptionsFragment on RelatedOpportunityTabDataGridViewOptions {
    filterByOwnerId
    filterByPipelineId
    filterByStatus
    filterByTags
    relatedOpportunities
    searchQuery
  }`)();

export const RelatedLeadTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment RelatedLeadTabDataGridViewOptionsFragment on RelatedLeadTabDataGridViewOptions {
    filterByOwnerId
    filterByStatus
    filterByTags
    relatedLeads
    searchQuery
  }`)();

export const RecentlyOpenedLinkedItemTypeFragment = /* @__PURE__ */ (() => gql`
  fragment RecentlyOpenedLinkedItemTypeFragment on RecentlyOpenedLinkedItemType {
    entity
    entityApiName
    id
    name
  }`)();

export const TaskRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment TaskRecentlyOpenedResultItemFragment on TaskRecentlyOpenedResultItem {
    dueDate
    id
    isDeleted
    linkedEntities {
      ...RecentlyOpenedLinkedItemTypeFragment
    }
    openedAt
    subject
  }
  ${RecentlyOpenedLinkedItemTypeFragment}
`)();

export const RecentlyOpenedEntityFragment = /* @__PURE__ */ (() => gql`
  fragment RecentlyOpenedEntityFragment on RecentlyOpenedEntity {
    dateTime
    entityApiName
    entityName
    id
  }`)();

export const QuotesNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment QuotesNotificationSettingsFragment on QuotesNotificationSettings {
    IsActive
    LinkedItem
    Move
    OwnershipAndSalesTeamChange
    StatusChange
  }`)();

export const QuoteTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteTabDataGridViewOptionsFragment on QuoteTabDataGridViewOptions {
    filterByOwnerId
    searchQuery
  }`)();

export const QuoteSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteSearchResultItemFragment on QuoteSearchResultItem {
    datetime
    id
    isArchived
    isDeleted
    name
    owner
  }`)();

export const QuoteRoleTabFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteRoleTabFragment on QuoteRoleTab {
    showManagingUnitItems
    showMyItems
    showMySharedItems
  }`)();

export const QuoteRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteRecentlyOpenedResultItemFragment on QuoteRecentlyOpenedResultItem {
    id
    isArchived
    isDeleted
    name
    openedAt
    owner
  }`)();

export const QuoteNoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteNoteTabDataGridViewFragment on QuoteNoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const QuoteFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteFilterTabFragment on QuoteFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const QuoteFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteFavoriteResultItemFragment on QuoteFavoriteResultItem {
    id
    isArchived
    isDeleted
    name
    owner
  }`)();

export const QuoteDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteDataGridViewItemsFragment on QuoteDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const QuoteCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteCloudObjectTabDataGridViewFragment on QuoteCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const QuoteArchiveProfileFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteArchiveProfileFragment on QuoteArchiveProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    quickFilter {
      filterFieldOrder
    }
    quoteProcess
    role {
      ...QuoteRoleTabFragment
    }
    view {
      groupBy
      showExtraFieldIds
      sortBy
      sortOrder
    }
  }
  ${QuoteRoleTabFragment}
`)();

export const PublishDraftsMutationFragment = /* @__PURE__ */ (() => gql`
  fragment PublishDraftsMutationFragment on PublishDraftsMutation {
    publishedDataCount
    publishedEntitySettingsCount
    publishedFieldCount
    publishedFieldPermissionCount
    publishedInterfacePreviewCount
    publishedResourceCount
    publishedTranslationsCount
    publishedTypesCount
  }`)();

export const publishDraftsMutation = /* @__PURE__ */ (() => gql`
  mutation publishDrafts($input: PublishDeleteDraftsInput) {
      publishDrafts(input: $input) {
          ...PublishDraftsMutationFragment
      }
  }
  ${PublishDraftsMutationFragment}
`)();

export const ProjectsNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectsNotificationSettingsFragment on ProjectsNotificationSettings {
    IsActive
    LinkedItem
    OwnershipAndSalesTeamChange
    StatusChange
  }`)();

export const ProjectFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectFilterTabFragment on ProjectFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const ProjectFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectFavoriteResultItemFragment on ProjectFavoriteResultItem {
    endDate
    entityTypeId
    id
    isDeleted
    name
    startDate
  }`)();

export const ProjectCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectCloudObjectTabDataGridViewFragment on ProjectCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const ProductCategoryEntityFragment = /* @__PURE__ */ (() => gql`
  fragment ProductCategoryEntityFragment on ProductCategoryEntity {
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    parentId
    productRelations {
      totalCount
    }
    revision
  }`)();

export const ProcessWebhookHeaderFragment = /* @__PURE__ */ (() => gql`
  fragment ProcessWebhookHeaderFragment on ProcessWebhookHeader {
    encrypted
    key
    value
  }`)();

export const TestProcessWebhookResponseFragment = /* @__PURE__ */ (() => gql`
  fragment TestProcessWebhookResponseFragment on TestProcessWebhookResponse {
    errorMessage
    isResponseCropped
    requestBody
    requestHeaders {
      ...ProcessWebhookHeaderFragment
    }
    requestType
    responseBody
    responseHeaders {
      ...ProcessWebhookHeaderFragment
    }
    statusCode
    success
    url
    warnings
  }
  ${ProcessWebhookHeaderFragment}
`)();

export const testProcessWebhookMutation = /* @__PURE__ */ (() => gql`
  mutation testProcessWebhook($input: TestProcessWebhookInput!) {
      testProcessWebhook(input: $input) {
          ...TestProcessWebhookResponseFragment
      }
  }
  ${TestProcessWebhookResponseFragment}
`)();

export const ProcessWebhookBasicAuthFragment = /* @__PURE__ */ (() => gql`
  fragment ProcessWebhookBasicAuthFragment on ProcessWebhookBasicAuth {
    password
    username
  }`)();

export const ProcessWebhookFragment = /* @__PURE__ */ (() => gql`
  fragment ProcessWebhookFragment on ProcessWebhook {
    advancedContent
    basicAuth {
      ...ProcessWebhookBasicAuthFragment
    }
    headers {
      ...ProcessWebhookHeaderFragment
    }
    requestFormat
    requestType
    simpleContent
    timeFormat
    url
  }
  ${ProcessWebhookBasicAuthFragment}
  ${ProcessWebhookHeaderFragment}
`)();

export const ProcessEntityOperationExtrasFragment = /* @__PURE__ */ (() => gql`
  fragment ProcessEntityOperationExtrasFragment on ProcessEntityOperationExtras {
    keepOwnerAsEditor
    sendInvitations
  }`)();

export const ProcessBuilderNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment ProcessBuilderNotificationSettingsFragment on ProcessBuilderNotificationSettings {
    Errors
    IsActive
    Warnings
  }`)();

export const PipelinePerformanceWonStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment PipelinePerformanceWonStepExtractViewFragment on PipelinePerformanceWonStepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInPipeline
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
    successRateCount
    successRateSession
    successRateTotalCount
    successRateTotalSession
    totalOpportunitiesSession
    wonArchiveOpportunitiesValue
  }`)();

export const PipelinePerformanceStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment PipelinePerformanceStepExtractViewFragment on PipelinePerformanceStepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    dropOffRateCount
    dropOffRateSession
    dropOffRateTotalCount
    dropOffRateTotalSession
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
    readyToMoveCount
    readyToMoveSession
    velocityOverdueCount
    velocityOverdueSession
  }`)();

export const PipelinePerformanceLeadStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment PipelinePerformanceLeadStepExtractViewFragment on PipelinePerformanceLeadStepExtractView {
    archiveLeadsCount
    archiveLeadsSession
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    leadsCount
    leadsSession
    readyToMoveCount
    readyToMoveSession
  }`)();

export const PeriodOptionFragment = /* @__PURE__ */ (() => gql`
  fragment PeriodOptionFragment on PeriodOption {
    period
    periodCustomFrom
    periodCustomTo
  }`)();

export const ProjectTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectTabDataGridViewOptionsFragment on ProjectTabDataGridViewOptions {
    filterByOwnerId
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterByProjectStatus
    filterByTags
    searchQuery
  }
  ${PeriodOptionFragment}
`)();

export const ProductTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment ProductTabDataGridViewOptionsFragment on ProductTabDataGridViewOptions {
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterByPipelineId
    filterByProductCategoryId
    showChildProducts
  }
  ${PeriodOptionFragment}
`)();

export const PeriodCompareOptionFragment = /* @__PURE__ */ (() => gql`
  fragment PeriodCompareOptionFragment on PeriodCompareOption {
    period
    periodCustomFrom
    periodCustomTo
  }`)();

export const PageInfoFragment = /* @__PURE__ */ (() => gql`
  fragment PageInfoFragment on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }`)();

export const OverdueTaskOverviewAgendaFragment = /* @__PURE__ */ (() => gql`
  fragment OverdueTaskOverviewAgendaFragment on OverdueTaskOverviewAgenda {
    dueDate
    id
    ownerName
    priority
    reminder
    subject
    taskType
  }`)();

export const OpptyProductRelationTypeEntityFragment = /* @__PURE__ */ (() => gql`
  fragment OpptyProductRelationTypeEntityFragment on OpptyProductRelationTypeEntity {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    productType {
      canChangeReadonly
      created
      formEdit
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      opptyProductRelationTypeId
      revision
    }
    productTypeId
    revision
  }`)();

export const OpportunityTabDataGridViewStatFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityTabDataGridViewStatFragment on OpportunityTabDataGridViewStat {
    count
    status
    value
  }`)();

export const OpportunityTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityTabDataGridViewOptionsFragment on OpportunityTabDataGridViewOptions {
    filterByOwnerId
    filterByPipelineId
    filterByStatus
    filterByTags
    searchQuery
  }`)();

export const OpportunitySearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunitySearchResultItemFragment on OpportunitySearchResultItem {
    datetime
    id
    isArchived
    isDeleted
    name
    pipelineColor
    pipelineName
  }`)();

export const OpportunityRoleTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityRoleTabFragment on OpportunityRoleTab {
    showManagingUnitItems
    showMyItems
    showMySharedItems
  }`)();

export const OpportunityReportTargetTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityReportTargetTabFragment on OpportunityReportTargetTab {
    goal
    isVisible
    showTargetOnTop
    targetPeriodCompare {
      ...PeriodCompareOptionFragment
    }
    targetPeriodCurrent {
      ...PeriodOptionFragment
    }
    targetSource
    targetValueFieldId
  }
  ${PeriodCompareOptionFragment}
  ${PeriodOptionFragment}
`)();

export const OpportunityRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityRecentlyOpenedResultItemFragment on OpportunityRecentlyOpenedResultItem {
    id
    isArchived
    isDeleted
    name
    openedAt
    pipelineColor
    pipelineName
  }`)();

export const OpportunityQuoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityQuoteTabDataGridViewFragment on OpportunityQuoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const OpportunityPreviewTargetTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityPreviewTargetTabFragment on OpportunityPreviewTargetTab {
    goal
    showTargetOnTop
    targetDefinition
    targetPeriodCompare {
      ...PeriodCompareOptionFragment
    }
    targetPeriodCurrent {
      ...PeriodOptionFragment
    }
    targetSource
    targetValueFieldId
    targetValueType
  }
  ${PeriodCompareOptionFragment}
  ${PeriodOptionFragment}
`)();

export const OpportunityNoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityNoteTabDataGridViewFragment on OpportunityNoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const OpportunityKPIFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityKPIFilterTabFragment on OpportunityKPIFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const OpportunityFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityFilterTabFragment on OpportunityFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const OpportunityFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityFavoriteResultItemFragment on OpportunityFavoriteResultItem {
    id
    isArchived
    isDeleted
    name
    pipelineColor
    pipelineName
  }`)();

export const OpportunityDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityDataGridViewItemsFragment on OpportunityDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const OpportunityCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityCloudObjectTabDataGridViewFragment on OpportunityCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const OpportunityArchiveTargetTabFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityArchiveTargetTabFragment on OpportunityArchiveTargetTab {
    showTargetOnTop
    targetPeriodCompare {
      ...PeriodCompareOptionFragment
    }
    targetPeriodCurrent {
      ...PeriodOptionFragment
    }
    targetSource
    targetValueFieldId
  }
  ${PeriodCompareOptionFragment}
  ${PeriodOptionFragment}
`)();

export const OpportunityArchiveProfileFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityArchiveProfileFragment on OpportunityArchiveProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    quickFilter {
      filterFieldOrder
    }
    role {
      ...OpportunityRoleTabFragment
    }
    salesPipeline
    target {
      showTargetOnTop
      targetSource
      targetValueFieldId
    }
    view {
      groupBy
      showCardFitness
      showCardLabels
      showCardRanking
      showCardValue
      showExtraFieldIds
      sortBy
      sortOrder
    }
  }
  ${OpportunityRoleTabFragment}
`)();

export const OpportunityArchiveDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityArchiveDataGridViewItemsFragment on OpportunityArchiveDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const OnlineFormsNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment OnlineFormsNotificationSettingsFragment on OnlineFormsNotificationSettings {
    Errors
    IsActive
    Responses
    Warnings
  }`)();

export const NotificationTopOpportunityFragment = /* @__PURE__ */ (() => gql`
  fragment NotificationTopOpportunityFragment on NotificationTopOpportunity {
    id
    name
    ownerName
    value
  }`)();

export const NotificationTaskOverviewFragment = /* @__PURE__ */ (() => gql`
  fragment NotificationTaskOverviewFragment on NotificationTaskOverview {
    dueDate
    id
    ownerName
    subject
  }`)();

export const NotificationOverdueItemFragment = /* @__PURE__ */ (() => gql`
  fragment NotificationOverdueItemFragment on NotificationOverdueItem {
    daysAgo
    id
    name
    ownerName
  }`)();

export const NoteTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment NoteTabDataGridViewOptionsFragment on NoteTabDataGridViewOptions {
    filterByOwnerId
    searchQuery
  }`)();

export const NavigatorBusinessOverviewFragment = /* @__PURE__ */ (() => gql`
  fragment NavigatorBusinessOverviewFragment on NavigatorBusinessOverview {
    lostCount
    lostSession
    lostSum
    openCount
    openSession
    openSum
    wonCount
    wonSession
    wonSum
  }`)();

export const MicrosoftOneDriveSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment MicrosoftOneDriveSettingsOutputFragment on MicrosoftOneDriveSettingsOutput {
    enabled
    errorCode
    microsoftOneDriveAccessToken
    microsoftOneDriveRefreshToken
  }`)();

export const MarkNotificationsRevisionSeenPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment MarkNotificationsRevisionSeenPayloadFragment on MarkNotificationsRevisionSeenPayload {
  clientMutationId
  }`)();

export const markNotificationsRevisionSeenMutation = /* @__PURE__ */ (() => gql`
  mutation markNotificationsRevisionSeen($input: MarkNotificationsRevisionSeenInput!) {
      markNotificationsRevisionSeen(input: $input) {
          ...MarkNotificationsRevisionSeenPayloadFragment
      }
  }
  ${MarkNotificationsRevisionSeenPayloadFragment}
`)();

export const MarkNotificationsAsReadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment MarkNotificationsAsReadPayloadFragment on MarkNotificationsAsReadPayload {
  clientMutationId
  }`)();

export const markNotificationsAsReadMutation = /* @__PURE__ */ (() => gql`
  mutation markNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
      markNotificationsAsRead(input: $input) {
          ...MarkNotificationsAsReadPayloadFragment
      }
  }
  ${MarkNotificationsAsReadPayloadFragment}
`)();

export const MarkAllNotificationsAsReadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment MarkAllNotificationsAsReadPayloadFragment on MarkAllNotificationsAsReadPayload {
  clientMutationId
  }`)();

export const markAllNotificationsAsReadMutation = /* @__PURE__ */ (() => gql`
  mutation markAllNotificationsAsRead($input: MarkAllNotificationsAsReadInput!) {
      markAllNotificationsAsRead(input: $input) {
          ...MarkAllNotificationsAsReadPayloadFragment
      }
  }
  ${MarkAllNotificationsAsReadPayloadFragment}
`)();

export const MakeProfileActivePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment MakeProfileActivePayloadFragment on MakeProfileActivePayload {
  clientMutationId
  }`)();

export const makeProfileActiveMutation = /* @__PURE__ */ (() => gql`
  mutation makeProfileActive($input: MakeProfileActiveInput!) {
      makeProfileActive(input: $input) {
          ...MakeProfileActivePayloadFragment
      }
  }
  ${MakeProfileActivePayloadFragment}
`)();

export const LinkedItemTypeFragment = /* @__PURE__ */ (() => gql`
  fragment LinkedItemTypeFragment on LinkedItemType {
    entity
    entityApiName
    id
    name
  }`)();

export const TaskSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment TaskSearchResultItemFragment on TaskSearchResultItem {
    datetime
    dueDate
    id
    isDeleted
    linkedEntities {
      ...LinkedItemTypeFragment
    }
    subject
  }
  ${LinkedItemTypeFragment}
`)();

export const NoteSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment NoteSearchResultItemFragment on NoteSearchResultItem {
    datetime
    id
    isDeleted
    note
    noteLinkedEntity {
      ...LinkedItemTypeFragment
    }
  }
  ${LinkedItemTypeFragment}
`)();

export const LinkUrlFragment = /* @__PURE__ */ (() => gql`
  fragment LinkUrlFragment on LinkUrl {
    id
    url
  }`)();

export const LifeCycleProfileViewTabFragment = /* @__PURE__ */ (() => gql`
  fragment LifeCycleProfileViewTabFragment on LifeCycleProfileViewTab {
    calculateOpptyByFieldId
    period {
      ...PeriodOptionFragment
    }
  }
  ${PeriodOptionFragment}
`)();

export const LifeCycleProfileFragment = /* @__PURE__ */ (() => gql`
  fragment LifeCycleProfileFragment on LifeCycleProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    leadProcess
    quickFilter {
      filterFieldOrder
    }
    salesPipeline
    view {
      calculateOpptyByFieldId
    }
  }`)();

export const LeadsAndOpportunitiesNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment LeadsAndOpportunitiesNotificationSettingsFragment on LeadsAndOpportunitiesNotificationSettings {
    IsActive
    LinkedItem
    Move
    OwnershipAndSalesTeamChange
    Qualification
    StatusChange
  }`)();

export const LeadTabDataGridViewStatFragment = /* @__PURE__ */ (() => gql`
  fragment LeadTabDataGridViewStatFragment on LeadTabDataGridViewStat {
    count
    status
  }`)();

export const LeadTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment LeadTabDataGridViewOptionsFragment on LeadTabDataGridViewOptions {
    filterByOwnerId
    filterByStatus
    filterByTags
    searchQuery
  }`)();

export const LeadStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadStepExtractViewFragment on LeadStepExtractView {
    archiveLeadsCount
    archiveLeadsSession
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    leadsCount
    leadsSession
    readyToMoveCount
    readyToMoveSession
  }`)();

export const LeadSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment LeadSearchResultItemFragment on LeadSearchResultItem {
    datetime
    id
    isArchived
    isDeleted
    name
    owner
  }`)();

export const LeadRoleTabFragment = /* @__PURE__ */ (() => gql`
  fragment LeadRoleTabFragment on LeadRoleTab {
    showManagingUnitItems
    showMyItems
    showMySharedItems
    showUnassignedItems
  }`)();

export const LeadRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment LeadRecentlyOpenedResultItemFragment on LeadRecentlyOpenedResultItem {
    id
    isArchived
    isDeleted
    name
    openedAt
    owner
  }`)();

export const LeadPreviewStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadPreviewStepExtractViewFragment on LeadPreviewStepExtractView {
    archiveLeadsCount
    archiveLeadsSession
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    leadsCount
    leadsSession
    readyToMoveCount
    readyToMoveSession
  }`)();

export const LeadPreviewOpportunityStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadPreviewOpportunityStepExtractViewFragment on LeadPreviewOpportunityStepExtractView {
    avgDaysInProcess
    qualificationRateCount
    qualificationRateSession
    qualificationRateTotalCount
  }`)();

export const LeadOpportunityFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment LeadOpportunityFilterTabFragment on LeadOpportunityFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const LeadNoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadNoteTabDataGridViewFragment on LeadNoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const LeadFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment LeadFilterTabFragment on LeadFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const LeadFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment LeadFavoriteResultItemFragment on LeadFavoriteResultItem {
    id
    isArchived
    isDeleted
    name
    owner
  }`)();

export const LeadDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment LeadDataGridViewItemsFragment on LeadDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const LeadCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadCloudObjectTabDataGridViewFragment on LeadCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const LeadArchiveProfileFragment = /* @__PURE__ */ (() => gql`
  fragment LeadArchiveProfileFragment on LeadArchiveProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    leadProcess
    quickFilter {
      filterFieldOrder
    }
    role {
      ...LeadRoleTabFragment
    }
    view {
      groupBy
      showCardFitness
      showCardLabels
      showCardRanking
      showCardVelocity
      showExtraFieldIds
      sortBy
      sortOrder
    }
  }
  ${LeadRoleTabFragment}
`)();

export const InsightsProfileViewTabFragment = /* @__PURE__ */ (() => gql`
  fragment InsightsProfileViewTabFragment on InsightsProfileViewTab {
    calculateOpptyByFieldId
    period {
      ...PeriodOptionFragment
    }
    periodGranularity
    showDeletedUnits
    showInactiveClients
    sortBy
  }
  ${PeriodOptionFragment}
`)();

export const InsightsProfileFragment = /* @__PURE__ */ (() => gql`
  fragment InsightsProfileFragment on InsightsProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    leadProcess
    quickFilter {
      filterFieldOrder
    }
    salesPipeline
    view {
      calculateOpptyByFieldId
      periodGranularity
      showDeletedUnits
      showInactiveClients
      sortBy
    }
  }`)();

export const InsightHighlightsFragment = /* @__PURE__ */ (() => gql`
  fragment InsightHighlightsFragment on InsightHighlights {
    bestWonOpportunityDate
    bestWonOpportunityName
    bestWonOpportunityValue
    clientId
    createdLeads
    wonAmount
    wonOppties
  }`)();

export const InsightGraphItemFragment = /* @__PURE__ */ (() => gql`
  fragment InsightGraphItemFragment on InsightGraphItem {
    date
    value
  }`)();

export const InitializeMobileCallTaskPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallTaskPayloadFragment on InitializeMobileCallTaskPayload {
  clientMutationId
  }`)();

export const initializeMobileCallTaskMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallTask($input: InitializeMobileCallTaskInput!) {
      initializeMobileCallTask(input: $input) {
          ...InitializeMobileCallTaskPayloadFragment
      }
  }
  ${InitializeMobileCallTaskPayloadFragment}
`)();

export const InitializeMobileCallOpportunityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallOpportunityPayloadFragment on InitializeMobileCallOpportunityPayload {
  clientMutationId
  }`)();

export const initializeMobileCallOpportunityMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallOpportunity($input: InitializeMobileCallOpportunityInput!) {
      initializeMobileCallOpportunity(input: $input) {
          ...InitializeMobileCallOpportunityPayloadFragment
      }
  }
  ${InitializeMobileCallOpportunityPayloadFragment}
`)();

export const InitializeMobileCallLeadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallLeadPayloadFragment on InitializeMobileCallLeadPayload {
  clientMutationId
  }`)();

export const initializeMobileCallLeadMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallLead($input: InitializeMobileCallLeadInput!) {
      initializeMobileCallLead(input: $input) {
          ...InitializeMobileCallLeadPayloadFragment
      }
  }
  ${InitializeMobileCallLeadPayloadFragment}
`)();

export const InitializeMobileCallContactPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallContactPayloadFragment on InitializeMobileCallContactPayload {
  clientMutationId
  }`)();

export const initializeMobileCallContactMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallContact($input: InitializeMobileCallContactInput!) {
      initializeMobileCallContact(input: $input) {
          ...InitializeMobileCallContactPayloadFragment
      }
  }
  ${InitializeMobileCallContactPayloadFragment}
`)();

export const InitializeMobileCallAppointmentPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallAppointmentPayloadFragment on InitializeMobileCallAppointmentPayload {
  clientMutationId
  }`)();

export const initializeMobileCallAppointmentMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallAppointment($input: InitializeMobileCallAppointmentInput!) {
      initializeMobileCallAppointment(input: $input) {
          ...InitializeMobileCallAppointmentPayloadFragment
      }
  }
  ${InitializeMobileCallAppointmentPayloadFragment}
`)();

export const InitializeMobileCallAccountPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment InitializeMobileCallAccountPayloadFragment on InitializeMobileCallAccountPayload {
  clientMutationId
  }`)();

export const initializeMobileCallAccountMutation = /* @__PURE__ */ (() => gql`
  mutation initializeMobileCallAccount($input: InitializeMobileCallAccountInput!) {
      initializeMobileCallAccount(input: $input) {
          ...InitializeMobileCallAccountPayloadFragment
      }
  }
  ${InitializeMobileCallAccountPayloadFragment}
`)();

export const IndicatorsProfileViewTabFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorsProfileViewTabFragment on IndicatorsProfileViewTab {
    calculateOpptyByFieldId
    period {
      ...PeriodOptionFragment
    }
    periodGranularity
    showDeletedUnits
    showInactiveClients
  }
  ${PeriodOptionFragment}
`)();

export const IndicatorsProfileFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorsProfileFragment on IndicatorsProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    leadProcess
    quickFilter {
      filterFieldOrder
    }
    salesPipeline
    view {
      calculateOpptyByFieldId
      periodGranularity
      showDeletedUnits
      showInactiveClients
    }
  }`)();

export const IndicatorSalesUnitItemFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorSalesUnitItemFragment on IndicatorSalesUnitItem {
    isDeleted
    kpiValue
    picture
    salesUnitId
    salesUnitName
  }`)();

export const IndicatorGraphDataFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorGraphDataFragment on IndicatorGraphData {
    date
    value
  }`)();

export const IndicatorGraphItemFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorGraphItemFragment on IndicatorGraphItem {
    graphData {
      ...IndicatorGraphDataFragment
    }
    itemId
  }
  ${IndicatorGraphDataFragment}
`)();

export const IndicatorClientItemFragment = /* @__PURE__ */ (() => gql`
  fragment IndicatorClientItemFragment on IndicatorClientItem {
    clientEmail
    clientFirstName
    clientId
    clientLastName
    clientMiddleName
    clientPosition
    isDeleted
    kpiValue
    picture
  }`)();

export const ImportSettingsOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment ImportSettingsOptionsFragment on ImportSettingsOptions {
    autoCreateAccounts
    autoCreateContacts
    columnsContainHeaders
    dateFormat
    deduplicateAccounts
    deduplicateContacts
    enclosure
    encoding
    groupByFieldId
    multipleCheckboxSeparator
    separator
  }`)();

export const ImapFolderFragment = /* @__PURE__ */ (() => gql`
  fragment ImapFolderFragment on ImapFolder {
    baseFolderName
    fullFolderName
    id
    isInbox
    isOutbox
    parentId
  }`)();

export const HardCodedRelationFragment = /* @__PURE__ */ (() => gql`
  fragment HardCodedRelationFragment on HardCodedRelation {
    kind
  }`)();

export const GridColumnsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment GridColumnsOutputFragment on GridColumnsOutput {
    fieldId
    frozen
    pixels
    width
  }`)();

export const GoogleServiceSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment GoogleServiceSettingsOutputFragment on GoogleServiceSettingsOutput {
    deleteProtection
    email
    enabled
    errorCode
    features
    imageUrl
    name
    recordOwnership
    syncArchived
    syncMethod
    syncPrivate
  }`)();

export const o365DisableTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation o365DisableTeamSpaceClientSetting($input: O365DisableTeamSpaceClientSettingInput!) {
      o365DisableTeamSpaceClientSetting(input: $input) {
          ...GoogleServiceSettingsOutputFragment
      }
  }
  ${GoogleServiceSettingsOutputFragment}
`)();

export const o365AuthorizeTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation o365AuthorizeTeamSpaceClientSetting($input: O365AuthorizeTeamSpaceClientSettingInput!) {
      o365AuthorizeTeamSpaceClientSetting(input: $input) {
          ...GoogleServiceSettingsOutputFragment
      }
  }
  ${GoogleServiceSettingsOutputFragment}
`)();

export const googleAuthorizeTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation googleAuthorizeTeamSpaceClientSetting($input: GoogleAuthorizeTeamSpaceClientSettingInput!) {
      googleAuthorizeTeamSpaceClientSetting(input: $input) {
          ...GoogleServiceSettingsOutputFragment
      }
  }
  ${GoogleServiceSettingsOutputFragment}
`)();

export const GoogleDriveSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment GoogleDriveSettingsOutputFragment on GoogleDriveSettingsOutput {
    googleDriveAccessToken
    googleDriveRefreshToken
  }`)();

export const GoogleDeactivateTeamSpaceClientSettingPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment GoogleDeactivateTeamSpaceClientSettingPayloadFragment on GoogleDeactivateTeamSpaceClientSettingPayload {
  clientMutationId
  result
  }`)();

export const googleDeactivateTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation googleDeactivateTeamSpaceClientSetting($input: GoogleDeactivateTeamSpaceClientSettingInput!) {
      googleDeactivateTeamSpaceClientSetting(input: $input) {
          ...GoogleDeactivateTeamSpaceClientSettingPayloadFragment
      }
  }
  ${GoogleDeactivateTeamSpaceClientSettingPayloadFragment}
`)();

export const GmailSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment GmailSettingsOutputFragment on GmailSettingsOutput {
    email
    emailAliases
    emailFetchSettings
    emailImapFolder1
    emailImapFolder2
  }`)();

export const gmailActivateTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation gmailActivateTeamSpaceClientSetting($input: GmailActivateTeamSpaceClientSettingInput!) {
      gmailActivateTeamSpaceClientSetting(input: $input) {
          ...GmailSettingsOutputFragment
      }
  }
  ${GmailSettingsOutputFragment}
`)();

export const GlobalSearchSearchTypeFragment = /* @__PURE__ */ (() => gql`
  fragment GlobalSearchSearchTypeFragment on GlobalSearchSearchType {
    entityApiName
    type
  }`)();

export const GlobalSearchFilterFragment = /* @__PURE__ */ (() => gql`
  fragment GlobalSearchFilterFragment on GlobalSearchFilter {
    created {
      ...PeriodOptionFragment
    }
    includeArchived
    includeDeleted
    includeDeletedAndArchivedRecords
    modified {
      ...PeriodOptionFragment
    }
    ownerIds
    salesUnitIds
  }
  ${PeriodOptionFragment}
`)();

export const FulltextSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment FulltextSearchResultItemFragment on FulltextSearchResultItem {
    id
    name
    queryString
  }`)();

export const FormViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FormViewOptionsFragment on FormViewOptions {
    createViewId
    editViewId
    entityTypeId
  }`)();

export const FinancialDateStartFragment = /* @__PURE__ */ (() => gql`
  fragment FinancialDateStartFragment on FinancialDateStart {
    day
    month
  }`)();

export const FileUrlResultFragment = /* @__PURE__ */ (() => gql`
  fragment FileUrlResultFragment on FileUrlResult {
    urls {
      ...LinkUrlFragment
    }
  }
  ${LinkUrlFragment}
`)();

export const FieldValueOptionFragment = /* @__PURE__ */ (() => gql`
  fragment FieldValueOptionFragment on FieldValueOption {
    color
    isArchived
    isDeleted
    label
    labelTranslated
    useLang
    value
  }`)();

export const FieldUseOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FieldUseOptionsFragment on FieldUseOptions {
    isAvailableForAdvancedCalcFormula
    isAvailableForAdvancedFormula
    isAvailableForAggregation
    isAvailableForCalculationFormula
    isAvailableForChangeLog
    isAvailableForHistoryReport
    isAvailableForMerge
    isAvailableForPivotDataField
    isAvailableForTargetCalculation
    isAvailableForWebresource
    isAvailableForWhiteSpaceComparison
    isDisplayable
    isDisplayableOnPivot
    isFilterable
    isGroupable
    isReadonlyOnRecurrentAppointment
    isSortable
  }`)();

export const FieldLevelPermissionEnumFragment = /* @__PURE__ */ (() => gql`
  fragment FieldLevelPermissionEnumFragment on FieldLevelPermissionEnum {
    fullAccess
    readOnly
  }`)();

export const HowToEntityFragment = /* @__PURE__ */ (() => gql`
  fragment HowToEntityFragment on HowToEntity {
    actionText
    actionUrl
    category
    description
    id
    instanceFieldPermissions {
      ...FieldLevelPermissionEnumFragment
    }
    minApiVersion
    resourceUrl
    sortOrder
    title
    type
    uniqueViewCount
    viewCount
  }
  ${FieldLevelPermissionEnumFragment}
`)();

export const FieldFilterRuleFragment = /* @__PURE__ */ (() => gql`
  fragment FieldFilterRuleFragment on FieldFilterRule {
    field
    id
    operator
    values
  }`)();

export const MainFilterBoxFragment = /* @__PURE__ */ (() => gql`
  fragment MainFilterBoxFragment on MainFilterBox {
    entity
    filterFields {
      ...FieldFilterRuleFragment
    }
    id
    lookupFieldId
  }
  ${FieldFilterRuleFragment}
`)();

export const FilterBoxFragment = /* @__PURE__ */ (() => gql`
  fragment FilterBoxFragment on FilterBox {
    entity
    filterFields {
      ...FieldFilterRuleFragment
    }
    id
    lookupFieldId
    relation {
      ...HardCodedRelationFragment
    }
  }
  ${FieldFilterRuleFragment}
  ${HardCodedRelationFragment}
`)();

export const FeedsNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment FeedsNotificationSettingsFragment on FeedsNotificationSettings {
    Comment
    Create
    IsActive
  }`)();

export const FeedTagFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTagFragment on FeedTag {
    color
    id
    name
  }`)();

export const FeedTabEntityTypeOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTabEntityTypeOptionsFragment on FeedTabEntityTypeOptions {
    showAccount
    showActivities
    showActivityTypeIds
    showContact
    showCustomEntities
    showDocument
    showEmail
    showEmailSentiments
    showEmailTagIds
    showEmailType
    showLead
    showMassEmail
    showMemo
    showNote
    showOnlineForm
    showOpportunity
    showProject
    showQuote
    showScheduledEmail
    showTextMessage
    showWhatsAppMessage
  }`)();

export const FeedPreviewViewTabFragment = /* @__PURE__ */ (() => gql`
  fragment FeedPreviewViewTabFragment on FeedPreviewViewTab {
    entityTypes {
      ...FeedTabEntityTypeOptionsFragment
    }
  }
  ${FeedTabEntityTypeOptionsFragment}
`)();

export const FeedLinkedEntityFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLinkedEntityFragment on FeedLinkedEntity {
    entity
    entityApiName
    id
    isArchived
    isAvailable
    isDeleted
    label
  }`)();

export const FeedFilterSenderFragment = /* @__PURE__ */ (() => gql`
  fragment FeedFilterSenderFragment on FeedFilterSender {
    entity
    id
  }`)();

export const FeedTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTabDataGridViewOptionsFragment on FeedTabDataGridViewOptions {
    entityTypes {
      ...FeedTabEntityTypeOptionsFragment
    }
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterBySender {
      ...FeedFilterSenderFragment
    }
    hasAttachment
    relatedMessages
    showOnlyFavorite
    showOnlyMy
  }
  ${FeedTabEntityTypeOptionsFragment}
  ${PeriodOptionFragment}
  ${FeedFilterSenderFragment}
`)();

export const FeedEmailTabEntityTypeOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FeedEmailTabEntityTypeOptionsFragment on FeedEmailTabEntityTypeOptions {
    showEmail
    showEmailSentiments
    showEmailTagIds
    showEmailType
    showMassEmail
    showScheduledEmail
  }`)();

export const FeedEmailTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment FeedEmailTabDataGridViewOptionsFragment on FeedEmailTabDataGridViewOptions {
    entityTypes {
      ...FeedEmailTabEntityTypeOptionsFragment
    }
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterBySender {
      ...FeedFilterSenderFragment
    }
    hasAttachment
    relatedMessages
    showOnlyMy
  }
  ${FeedEmailTabEntityTypeOptionsFragment}
  ${PeriodOptionFragment}
  ${FeedFilterSenderFragment}
`)();

export const FeedEmailAppointmentInvitationFragment = /* @__PURE__ */ (() => gql`
  fragment FeedEmailAppointmentInvitationFragment on FeedEmailAppointmentInvitation {
    email
    invitedContactId
    invitedContactName
    invitedContactPictureUrl
  }`)();

export const FeedApplicationFragment = /* @__PURE__ */ (() => gql`
  fragment FeedApplicationFragment on FeedApplication {
    id
    name
  }`)();

export const FeedActorFragment = /* @__PURE__ */ (() => gql`
  fragment FeedActorFragment on FeedActor {
    entityApiName
    entityType
    id
    isAvailable
    isDeleted
    name
    pictureUrl
  }`)();

export const ExchangeServiceSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment ExchangeServiceSettingsOutputFragment on ExchangeServiceSettingsOutput {
    deleteProtection
    domain
    email
    enabled
    errorCode
    imageUrl
    method
    name
    passwordSet
    recordOwnership
    server
    syncMethod
    username
  }`)();

export const exchangeDeactivateTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation exchangeDeactivateTeamSpaceClientSetting($input: ExchangeDeactivateTeamSpaceClientSettingInput!) {
      exchangeDeactivateTeamSpaceClientSetting(input: $input) {
          ...ExchangeServiceSettingsOutputFragment
      }
  }
  ${ExchangeServiceSettingsOutputFragment}
`)();

export const exchangeActivateTeamSpaceClientSettingMutation = /* @__PURE__ */ (() => gql`
  mutation exchangeActivateTeamSpaceClientSetting($input: ExchangeActivateTeamSpaceClientSettingInput!) {
      exchangeActivateTeamSpaceClientSetting(input: $input) {
          ...ExchangeServiceSettingsOutputFragment
      }
  }
  ${ExchangeServiceSettingsOutputFragment}
`)();

export const EntityTypeSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment EntityTypeSettingsFragment on EntityTypeSettings {
    allowedAppointmentTypeIds
    allowedTaskTypeIds
  }`)();

export const UpdateDraftQuoteTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftQuoteTypePayloadFragment on UpdateDraftQuoteTypePayload {
  clientMutationId
  quoteType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    formLost
    formLostApi {
      label
      useLang
    }
    formLostEnabled
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    quoteProcess {
      color
      created
      id
      isDeleteProtected
      isDeleted
      modified
      name
      revision
    }
    quoteProcessId
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftQuoteTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftQuoteType($input: UpdateDraftQuoteTypeInput!) {
      updateDraftQuoteType(input: $input) {
          ...UpdateDraftQuoteTypePayloadFragment
      }
  }
  ${UpdateDraftQuoteTypePayloadFragment}
`)();

export const UpdateDraftProjectTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftProjectTypePayloadFragment on UpdateDraftProjectTypePayload {
  clientMutationId
  projectType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    icon
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftProjectTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftProjectType($input: UpdateDraftProjectTypeInput!) {
      updateDraftProjectType(input: $input) {
          ...UpdateDraftProjectTypePayloadFragment
      }
  }
  ${UpdateDraftProjectTypePayloadFragment}
`)();

export const UpdateDraftOpportunityTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftOpportunityTypePayloadFragment on UpdateDraftOpportunityTypePayload {
  clientMutationId
  opportunityType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    formLost
    formLostApi {
      label
      useLang
    }
    formQualify
    formQualifyApi
    formWon
    formWonApi
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    pipeline {
      color
      created
      id
      isDeleteProtected
      isDeleted
      modified
      name
      revision
    }
    pipelineId
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftOpportunityTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftOpportunityType($input: UpdateDraftOpportunityTypeInput!) {
      updateDraftOpportunityType(input: $input) {
          ...UpdateDraftOpportunityTypePayloadFragment
      }
  }
  ${UpdateDraftOpportunityTypePayloadFragment}
`)();

export const UpdateDraftLeadTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftLeadTypePayloadFragment on UpdateDraftLeadTypePayload {
  clientMutationId
  leadType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    formLost
    formLostApi {
      label
      useLang
    }
    formLostEnabled
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    leadProcess {
      color
      created
      id
      isDeleteProtected
      isDeleted
      modified
      name
      revision
    }
    leadProcessId
    modified
    name
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftLeadTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftLeadType($input: UpdateDraftLeadTypeInput!) {
      updateDraftLeadType(input: $input) {
          ...UpdateDraftLeadTypePayloadFragment
      }
  }
  ${UpdateDraftLeadTypePayloadFragment}
`)();

export const UpdateDraftContactTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftContactTypePayloadFragment on UpdateDraftContactTypePayload {
  clientMutationId
  contactType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftContactTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftContactType($input: UpdateDraftContactTypeInput!) {
      updateDraftContactType(input: $input) {
          ...UpdateDraftContactTypePayloadFragment
      }
  }
  ${UpdateDraftContactTypePayloadFragment}
`)();

export const UpdateDraftAccountTypePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateDraftAccountTypePayloadFragment on UpdateDraftAccountTypePayload {
  accountType {
    canChangeReadonly
    created
    formEdit
    formEditApi {
      label
      useLang
    }
    hasDraft
    id
    isDeleteProtected
    isDeleted
    isPublished
    isReadonly
    modified
    name
    revision
    settings {
      ...EntityTypeSettingsFragment
    }
  }
  clientMutationId
  }
  ${EntityTypeSettingsFragment}
`)();

export const updateDraftAccountTypeMutation = /* @__PURE__ */ (() => gql`
  mutation updateDraftAccountType($input: UpdateDraftAccountTypeInput!) {
      updateDraftAccountType(input: $input) {
          ...UpdateDraftAccountTypePayloadFragment
      }
  }
  ${UpdateDraftAccountTypePayloadFragment}
`)();

export const EntityClassPermissionsFragment = /* @__PURE__ */ (() => gql`
  fragment EntityClassPermissionsFragment on EntityClassPermissions {
    allowedPermissions
    entity
    entityApiName
    permissions
  }`)();

export const EnableProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment EnableProcessPayloadFragment on EnableProcessPayload {
  clientMutationId
  }`)();

export const enableProcessMutation = /* @__PURE__ */ (() => gql`
  mutation enableProcess($input: EnableProcessInput!) {
      enableProcess(input: $input) {
          ...EnableProcessPayloadFragment
      }
  }
  ${EnableProcessPayloadFragment}
`)();

export const EnableEmailSequencePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment EnableEmailSequencePayloadFragment on EnableEmailSequencePayload {
  clientMutationId
  }`)();

export const enableEmailSequenceMutation = /* @__PURE__ */ (() => gql`
  mutation enableEmailSequence($input: EnableEmailSequenceInput!) {
      enableEmailSequence(input: $input) {
          ...EnableEmailSequencePayloadFragment
      }
  }
  ${EnableEmailSequencePayloadFragment}
`)();

export const EmailTemplatesStatisticsFilterFragment = /* @__PURE__ */ (() => gql`
  fragment EmailTemplatesStatisticsFilterFragment on EmailTemplatesStatisticsFilter {
    filterByFolders
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterByTemplate
  }
  ${PeriodOptionFragment}
`)();

export const EmailSequencesNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment EmailSequencesNotificationSettingsFragment on EmailSequencesNotificationSettings {
    Errors
    IsActive
    Warnings
  }`)();

export const EmailNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment EmailNotificationSettingsFragment on EmailNotificationSettings {
    Bounced
    IsActive
    LinkedItem
    Tracking
  }`)();

export const EmailConfFieldFragment = /* @__PURE__ */ (() => gql`
  fragment EmailConfFieldFragment on EmailConfField {
    brand
    isUsingOauth
    password
    port
    server
    ssl
    username
  }`)();

export const EmailAccountLimitFragment = /* @__PURE__ */ (() => gql`
  fragment EmailAccountLimitFragment on EmailAccountLimit {
    messagesPerDay
    sentMessages
  }`)();

export const DropboxSettingsOutputFragment = /* @__PURE__ */ (() => gql`
  fragment DropboxSettingsOutputFragment on DropboxSettingsOutput {
    dropboxAccessToken
  }`)();

export const DisableProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment DisableProcessPayloadFragment on DisableProcessPayload {
  clientMutationId
  }`)();

export const disableProcessMutation = /* @__PURE__ */ (() => gql`
  mutation disableProcess($input: DisableProcessInput!) {
      disableProcess(input: $input) {
          ...DisableProcessPayloadFragment
      }
  }
  ${DisableProcessPayloadFragment}
`)();

export const DisableEmailSequencePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment DisableEmailSequencePayloadFragment on DisableEmailSequencePayload {
  clientMutationId
  }`)();

export const disableEmailSequenceMutation = /* @__PURE__ */ (() => gql`
  mutation disableEmailSequence($input: DisableEmailSequenceInput!) {
      disableEmailSequence(input: $input) {
          ...DisableEmailSequencePayloadFragment
      }
  }
  ${DisableEmailSequencePayloadFragment}
`)();

export const DeleteProfilePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment DeleteProfilePayloadFragment on DeleteProfilePayload {
  clientMutationId
  }`)();

export const deleteProfileMutation = /* @__PURE__ */ (() => gql`
  mutation deleteProfile($input: DeleteProfileInput!) {
      deleteProfile(input: $input) {
          ...DeleteProfilePayloadFragment
      }
  }
  ${DeleteProfilePayloadFragment}
`)();

export const DatePeriodFragment = /* @__PURE__ */ (() => gql`
  fragment DatePeriodFragment on DatePeriod {
    dateFrom
    dateTo
  }`)();

export const OpportunityTargetFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityTargetFragment on OpportunityTarget {
    comparisonPeriod {
      ...DatePeriodFragment
    }
    comparisonValue
    currentPeriod {
      ...DatePeriodFragment
    }
    currentValue
    goalValue
  }
  ${DatePeriodFragment}
`)();

export const DataGridViewItemWithAvailabilityFragment = /* @__PURE__ */ (() => gql`
  fragment DataGridViewItemWithAvailabilityFragment on DataGridViewItemWithAvailability {
    data {
      displayOption
      fieldId
      value
    }
    id
    isAvailable
  }`)();

export const CustomEntitySearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntitySearchResultItemFragment on CustomEntitySearchResultItem {
    datetime
    entityApiName
    id
    isDeleted
    name
    owner
  }`)();

export const CustomEntityRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntityRecentlyOpenedResultItemFragment on CustomEntityRecentlyOpenedResultItem {
    entityApiName
    id
    isDeleted
    name
    openedAt
    owner
  }`)();

export const CustomEntityMasterRightFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntityMasterRightFragment on CustomEntityMasterRight {
    accessCopy
    accessDelete
    accessDirection
    accessEntityTypes
    accessLevel
    accessPrivate
    allowedEntityTypeIds
    defaultProfileId
    entityApiName
    navigationAccess
  }`)();

export const MasterRightEntityFragment = /* @__PURE__ */ (() => gql`
  fragment MasterRightEntityFragment on MasterRightEntity {
    accessAccountRelationTypes
    accessAccounts
    accessAiAutomatizer
    accessAiOnlineForms
    accessAiRecordDetail
    accessAiReports
    accessAiSmartField
    accessAppointmentScheduler
    accessAppointmentSchedulerManagement
    accessApprovalProcesses
    accessApprovalProcessesManagement
    accessApprovals
    accessArchive
    accessAudit
    accessAuditLog
    accessBulkUpdate
    accessCalling
    accessCallingCompanyPhone
    accessCallingPurchasePhone
    accessCompanyEmails
    accessContacts
    accessDocumentManagement
    accessDocumentManagementCompany
    accessDocumentManagementRecord
    accessDuplicateChecker
    accessEntityAccount
    accessEntityAccountCopy
    accessEntityAccountDelete
    accessEntityAccountDirection
    accessEntityAccountPrivate
    accessEntityAccountTagCreate
    accessEntityAccountTypes
    accessEntityAppointment
    accessEntityAppointmentDelete
    accessEntityAppointmentDirection
    accessEntityAppointmentTagCreate
    accessEntityBetterNavigator
    accessEntityBetterNavigatorDeleteNotOwned
    accessEntityBetterNavigatorDeleteOwned
    accessEntityBetterNavigatorSharingCustom
    accessEntityBetterNavigatorSharingPublic
    accessEntityContact
    accessEntityContactCopy
    accessEntityContactDelete
    accessEntityContactDirection
    accessEntityContactPrivate
    accessEntityContactTagCreate
    accessEntityContactTypes
    accessEntityDashboard
    accessEntityDashboardDeleteNotOwned
    accessEntityDashboardDeleteOwned
    accessEntityDashboardSharingCustom
    accessEntityDashboardSharingPublic
    accessEntityEmailContentShareMode
    accessEntityEmailDeleteNotOwned
    accessEntityEmailSequence
    accessEntityEmailTemplate
    accessEntityEmailTemplateCreateDeleteFolder
    accessEntityEmailTemplateDeleteNotOwned
    accessEntityEmailTemplateDeleteOwned
    accessEntityEmailTemplateSharingCustom
    accessEntityEmailTemplateSharingPublic
    accessEntityForecast
    accessEntityForecastDeleteNotOwned
    accessEntityForecastDeleteOwned
    accessEntityForecastEditNotOwned
    accessEntityForecastSharingCustom
    accessEntityForecastSharingPublic
    accessEntityFormView
    accessEntityFormViewDeleteNotOwned
    accessEntityFormViewDeleteOwned
    accessEntityFormViewSharingCustom
    accessEntityFormViewSharingPublic
    accessEntityLead
    accessEntityLeadCopy
    accessEntityLeadDelete
    accessEntityLeadDirection
    accessEntityLeadPrivate
    accessEntityLeadTagCreate
    accessEntityLeadTypes
    accessEntityMessageTagCreate
    accessEntityOppty
    accessEntityOpptyCopy
    accessEntityOpptyDelete
    accessEntityOpptyDirection
    accessEntityOpptyPrivate
    accessEntityOpptyTagCreate
    accessEntityPipeline
    accessEntityProcess
    accessEntityProfile
    accessEntityProfileDefaultScreenProfiles {
      ...ScreensDefaultProfilesParamsFragment
    }
    accessEntityProfileDeleteNotOwned
    accessEntityProfileDeleteOwned
    accessEntityProfileSharingCustom
    accessEntityProfileSharingPublic
    accessEntityProject
    accessEntityProjectCopy
    accessEntityProjectDelete
    accessEntityProjectDirection
    accessEntityProjectPrivate
    accessEntityProjectTagCreate
    accessEntityQuote
    accessEntityQuoteCopy
    accessEntityQuoteDelete
    accessEntityQuoteDirection
    accessEntityQuoteTypes
    accessEntityReport
    accessEntityReportCreateDeleteFolder
    accessEntityReportDeleteNotOwned
    accessEntityReportDeleteOwned
    accessEntityReportPrivate
    accessEntityReportScheduleCreate
    accessEntityReportScheduleManagement
    accessEntityReportSharingCustom
    accessEntityReportSharingPublic
    accessEntityTarget
    accessEntityTargetDeleteNotOwned
    accessEntityTargetDeleteOwned
    accessEntityTask
    accessEntityTaskDelete
    accessEntityTaskDirection
    accessEntityTaskTagCreate
    accessEntityTaskUnassigned
    accessExport
    accessFeeds
    accessForeignCurrencies
    accessFormAndFields
    accessGlobalSettings
    accessHomeScreen
    accessImport
    accessInsights
    accessLeads
    accessOnlineForms
    accessOnlineFormsManagement
    accessOpportunity
    accessPipelineConfiguration
    accessPrint
    accessProductsServices
    accessProjects
    accessQuotes
    accessSalesRoles
    accessSecurity
    accessUnits
    accessUserAndRoles
    accessVoyagerAi
    accessWhatsAppCompanyPhone
    allowedAccountTypes {
      totalCount
    }
    allowedCompanyEmails {
      totalCount
    }
    allowedCompanyPhones {
      totalCount
    }
    allowedContactTypes {
      totalCount
    }
    allowedLeadTypes {
      totalCount
    }
    allowedPipelines {
      totalCount
    }
    allowedQuoteTypes {
      totalCount
    }
    created
    customEntities {
      ...CustomEntityMasterRightFragment
    }
    id
    isDeleteProtected
    isDeleted
    modified
    name
    revision
  }
  ${ScreensDefaultProfilesParamsFragment}
  ${CustomEntityMasterRightFragment}
`)();

export const CustomEntityFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntityFilterTabFragment on CustomEntityFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const CustomEntityFeaturePermissionFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntityFeaturePermissionFragment on CustomEntityFeaturePermission {
    accessPrivate
    enabled
    entityApiName
  }`)();

export const FeaturePermissionsFragment = /* @__PURE__ */ (() => gql`
  fragment FeaturePermissionsFragment on FeaturePermissions {
    accessEntityAccountTagCreate
    accessEntityAppointmentTagCreate
    accessEntityContactTagCreate
    accessEntityEmailSequences
    accessEntityLeadTagCreate
    accessEntityMessageTagCreate
    accessEntityOpptyTagCreate
    accessEntityProcess
    accessEntityProjectTagCreate
    accessEntityReportPrivate
    accessEntityTaskTagCreate
    accessiblePipelineIds
    accountHierarchy
    accounts
    activitiesMultiLink
    addedAutomationHubItemsIds
    adminAccountHierarchy
    adminAccountRelations
    adminAccountRoles
    adminAddCompanyEmails
    adminAdvancedPermissions
    adminAiAutomatizer
    adminAiOnlineForms
    adminAiRecordDetail
    adminAiReports
    adminAiSmartField
    adminAiSuperAgent
    adminApiAccess
    adminAppointmentScheduler
    adminApprovalProcesses
    adminAuditLog
    adminAutomationHub
    adminCallingIntegration
    adminCompanyEmails
    adminContactRelations
    adminCreateCustomEntity
    adminCurrencies
    adminCustomFieldsAndForms
    adminDocumentManagement
    adminEmailSequences
    adminEmailTemplates
    adminEntityHealth
    adminEntityScoring
    adminFieldPermissions
    adminFieldsFormsProductsCustomization
    adminFieldsFormsRollup
    adminGlobalSettings
    adminMultilanguageSupport
    adminMultipleCurrencies
    adminMultiplePipelines
    adminMultipleRoles
    adminMultipleUnits
    adminOnlineForms
    adminPipelines
    adminProcessBuilder
    adminProductsAndPrices
    adminProjects
    adminQuotes
    adminRevenueSchedule
    adminSalesActions
    adminSalesActivities
    adminSalesRoles
    adminSalesUnits
    adminSetAuditLog
    adminSetAutomationHub
    adminSpaceSecurity
    adminStepDocuments
    adminTarget
    adminUsersAndRoles
    adminWhatsAppIntegration
    advancedManagementReports
    aiAgent
    aiAutomatizer
    aiDocumentTools
    aiEmailAssistant
    aiEmailCategorization
    aiFeedTools
    aiHtmlToMjml
    aiMediaTranscription
    aiOnlineForms
    aiRecordDetail
    aiReports
    aiScreenAgent
    aiSmartField
    aiSpeechToText
    aiSuperAgent
    aiTextAnalysis
    aiTextToSpeech
    aiTextTools
    alfresco
    allowBetterNavigatorCreate
    allowBetterNavigatorSharingCustom
    allowBetterNavigatorSharingPublic
    allowCalling
    allowCallingPurchasePhone
    allowDashboardCreate
    allowDashboardSharingCustom
    allowDashboardSharingPublic
    allowEmailTemplateSharingCustom
    allowEmailTemplateSharingPublic
    allowForecastCreate
    allowForecastSharingCustom
    allowForecastSharingPublic
    allowFormViewSharingCustom
    allowFormViewSharingPublic
    allowProfileSharingCustom
    allowProfileSharingPublic
    allowReportCreate
    allowReportSharingCustom
    allowReportSharingPublic
    allowTargetCreate
    allowedCompanyEmails
    appointmentScheduler
    appointmentSchedulerManagement
    approvalProcesses
    approvalProcessesManagement
    approvals
    archive
    audit
    automatizerProcessDescriptions
    betterNavigator
    bubbleChart
    bulkEdit
    businessCardReader
    buyingCenter
    calling
    callingIntegration
    changeLog
    contactAutocapitalization
    contacts
    customActivityTypes
    customEntities {
      ...CustomEntityFeaturePermissionFragment
    }
    customLookupForContactAccount
    customerPrice
    dashboard
    documentManagement
    documentManagementCompany
    documentManagementDialog
    documentManagementRecord
    documentTemplates
    documents
    dropboxIntegration
    duplicateChecker
    emailContentSharing
    emailSequences
    emailSequencesIntegration
    emailTemplates
    enabledAutomationHubItemsIds
    entityHealth
    entityScoring
    exchange
    export
    feeds
    fieldMapping
    fieldPermissions
    fileAttachmentUpload
    forecast
    formViews
    fullContactIntegration
    googleDriveIntegration
    googleMapsIntegration
    historyReports
    hubspotIntegration
    import
    inAppNotifications
    insights
    integrationsAnalytics
    intercom
    leads
    managementReports
    matrix
    merge
    msTeamsIntegration
    navigator
    notes
    onedriveIntegration
    onlineForms
    onlineFormsManagement
    opportunities
    orgChart
    pandaDocIntegration
    priceSchedule
    print
    processBuilder
    processBuilderIntegration
    projects
    quotes
    receiveEmailsUsingBcc
    recurringOpportunities
    recurringTasks
    relationGraph
    ringcentralIntegration
    scheduledReports
    scheduledReportsCreate
    scheduledReportsManagement
    sharepointIntegration
    sqlExport
    stepDocuments
    subscriptionAdmin
    syncEmailUsingImap
    syncExchangeAppointments
    syncExchangeContacts
    syncExchangeEmail
    syncExchangeTasks
    syncGoogleCalendar
    syncGoogleContacts
    syncGoogleEmailAdded
    syncGoogleEmails
    syncGoogleTasks
    syncO365Calendar
    syncO365Contacts
    syncO365Email
    syncO365EmailAdded
    syncO365Tasks
    syncSendgridEmail
    target
    taskBoard
    thumbnailView
    timeZoneChecker
    whatsAppIntegration
    zoomIntegration
  }
  ${CustomEntityFeaturePermissionFragment}
`)();

export const CustomEntityFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntityFavoriteResultItemFragment on CustomEntityFavoriteResultItem {
    entityApiName
    id
    isDeleted
    name
    owner
  }`)();

export const CustomEntitiesNotificationSettingFragment = /* @__PURE__ */ (() => gql`
  fragment CustomEntitiesNotificationSettingFragment on CustomEntitiesNotificationSetting {
    IsActive
    LinkedItem
    OwnershipAndSalesTeamChange
    entityApiName
  }`)();

export const CurrencyForeignDataFragment = /* @__PURE__ */ (() => gql`
  fragment CurrencyForeignDataFragment on CurrencyForeignData {
    baseValue
    convertedValue
    convertedValueCurrencyId
    currencyId
    valueForeign
  }`)();

export const CurrencyExchangeRatesListEntityFragment = /* @__PURE__ */ (() => gql`
  fragment CurrencyExchangeRatesListEntityFragment on CurrencyExchangeRatesListEntity {
    created
    currencyExchangeRates {
      totalCount
    }
    id
    isDeleteProtected
    isDeleted
    modified
    revision
    validFrom
  }`)();

export const CreateQuoteProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateQuoteProcessPayloadFragment on CreateQuoteProcessPayload {
  clientMutationId
  quoteProcess {
    color
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    quoteTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formLostEnabled
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      quoteProcessId
      revision
    }
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const CreateProductCategoryPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateProductCategoryPayloadFragment on CreateProductCategoryPayload {
  clientMutationId
  productCategory {
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    parent {
      created
      id
      isDeleteProtected
      isDeleted
      modified
      name
      parentId
      revision
    }
    parentId
    productRelations {
      totalCount
    }
    revision
  }
  }`)();

export const createProductCategoryMutation = /* @__PURE__ */ (() => gql`
  mutation createProductCategory($input: CreateProductCategoryInput!,$validationLevel: [ValidationLevel!]) {
      createProductCategory(input: $input,validationLevel: $validationLevel) {
          ...CreateProductCategoryPayloadFragment
      }
  }
  ${CreateProductCategoryPayloadFragment}
`)();

export const CreatePipelinePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreatePipelinePayloadFragment on CreatePipelinePayload {
  clientMutationId
  pipeline {
    color
    created
    id
    isDeleteProtected
    isDeleted
    modified
    name
    opportunityTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formQualify
      formQualifyApi
      formWon
      formWonApi
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      modified
      name
      pipelineId
      revision
    }
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const CreateLeadProcessPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateLeadProcessPayloadFragment on CreateLeadProcessPayload {
  clientMutationId
  leadProcess {
    color
    created
    id
    isDeleteProtected
    isDeleted
    leadTypes {
      canChangeReadonly
      created
      formEdit
      formLost
      formLostEnabled
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      isReadonly
      leadProcessId
      modified
      name
      revision
    }
    modified
    name
    revision
    steps {
      created
      description
      hasReadonlyForm
      hasVersionIncrement
      id
      isDeleteProtected
      isDeleted
      leadProcessId
      modified
      name
      percent
      pipelineId
      quoteProcessId
      revision
      sortOrder
      timeframe
    }
  }
  }`)();

export const CreateDraftFieldPermissionsPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateDraftFieldPermissionsPayloadFragment on CreateDraftFieldPermissionsPayload {
    result {
      created
      fieldId
      hasDraft
      id
      isDeleteProtected
      isDeleted
      isPublished
      masterRightId
      modified
      permissionLevel
      revision
    }
  }`)();

export const createDraftFieldPermissionsMutation = /* @__PURE__ */ (() => gql`
  mutation createDraftFieldPermissions($input: [CreateDraftFieldPermissionInput!]!) {
      createDraftFieldPermissions(input: $input) {
          ...CreateDraftFieldPermissionsPayloadFragment
      }
  }
  ${CreateDraftFieldPermissionsPayloadFragment}
`)();

export const CreateCurrencyPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateCurrencyPayloadFragment on CreateCurrencyPayload {
  clientMutationId
  currency {
    code
    created
    currencyExchangeRates {
      totalCount
    }
    id
    isBase
    isDeleteProtected
    isDeleted
    modified
    revision
    symbol
  }
  }`)();

export const CreateCompanyEmailPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment CreateCompanyEmailPayloadFragment on CreateCompanyEmailPayload {
    companyEmail {
      created
      email
      enabled
      errorCode
      features
      id
      isDeleteProtected
      isDeleted
      modified
      name
      pictureUrl
      serviceType
      settings
      token
    }
  }`)();

export const createCompanyEmailMutation = /* @__PURE__ */ (() => gql`
  mutation createCompanyEmail($input: CreateCompanyEntityEmailInput!,$validationLevel: [ValidationLevel!]) {
      createCompanyEmail(input: $input,validationLevel: $validationLevel) {
          ...CreateCompanyEmailPayloadFragment
      }
  }
  ${CreateCompanyEmailPayloadFragment}
`)();

export const ConversionsProfileViewTabFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionsProfileViewTabFragment on ConversionsProfileViewTab {
    calculateOpptyByFieldId
    conversionValue
    period {
      ...PeriodOptionFragment
    }
    reportBy
  }
  ${PeriodOptionFragment}
`)();

export const ConversionsProfileFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionsProfileFragment on ConversionsProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    leadProcess
    quickFilter {
      filterFieldOrder
    }
    salesPipeline
    view {
      calculateOpptyByFieldId
      conversionValue
      reportBy
    }
  }`)();

export const ConversionsOpportunityTakenPathFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionsOpportunityTakenPathFragment on ConversionsOpportunityTakenPath {
   ...on ConversionsOpportunityAmountTakenPath {
       lostConversionsOpportunityAmountTakenPath: lost
       openConversionsOpportunityAmountTakenPath: open
       pathConversionsOpportunityAmountTakenPath: path
       wonConversionsOpportunityAmountTakenPath: won
   }
   ...on ConversionsOpportunityCountTakenPath {
       lostConversionsOpportunityCountTakenPath: lost
       openConversionsOpportunityCountTakenPath: open
       pathConversionsOpportunityCountTakenPath: path
       wonConversionsOpportunityCountTakenPath: won
   }
  }`)();

export const ConversionsOpportunityCreatedPathFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionsOpportunityCreatedPathFragment on ConversionsOpportunityCreatedPath {
   ...on ConversionsOpportunityAmountCreatedPath {
       lostConversionsOpportunityAmountCreatedPath: lost
       openConversionsOpportunityAmountCreatedPath: open
       pathConversionsOpportunityAmountCreatedPath: path
       reassignedConversionsOpportunityAmountCreatedPath: reassigned
       wonConversionsOpportunityAmountCreatedPath: won
   }
   ...on ConversionsOpportunityCountCreatedPath {
       lostConversionsOpportunityCountCreatedPath: lost
       openConversionsOpportunityCountCreatedPath: open
       pathConversionsOpportunityCountCreatedPath: path
       reassignedConversionsOpportunityCountCreatedPath: reassigned
       wonConversionsOpportunityCountCreatedPath: won
   }
  }`)();

export const ConversionsLeadTakenPathFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionsLeadTakenPathFragment on ConversionsLeadTakenPath {
   ...on ConversionLeadAmountPath {
       lostQualifiedConversionLeadAmountPath: lostQualified
       openQualifiedConversionLeadAmountPath: openQualified
       qualifiedConversionLeadAmountPath: qualified
       reassignedQualifiedConversionLeadAmountPath: reassignedQualified
       wonQualifiedConversionLeadAmountPath: wonQualified
   }
   ...on ConversionsLeadCountTakenPath {
       lostConversionsLeadCountTakenPath: lost
       lostQualifiedConversionsLeadCountTakenPath: lostQualified
       openNotQualifiedConversionsLeadCountTakenPath: openNotQualified
       openQualifiedConversionsLeadCountTakenPath: openQualified
       pathConversionsLeadCountTakenPath: path
       qualifiedConversionsLeadCountTakenPath: qualified
       reassignedQualifiedConversionsLeadCountTakenPath: reassignedQualified
       wonQualifiedConversionsLeadCountTakenPath: wonQualified
   }
  }`)();

export const ConversionLeadCreatedPathFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionLeadCreatedPathFragment on ConversionLeadCreatedPath {
   ...on ConversionLeadAmountPath {
       lostQualifiedConversionLeadAmountPath: lostQualified
       openQualifiedConversionLeadAmountPath: openQualified
       qualifiedConversionLeadAmountPath: qualified
       reassignedQualifiedConversionLeadAmountPath: reassignedQualified
       wonQualifiedConversionLeadAmountPath: wonQualified
   }
   ...on ConversionLeadCountCreatedPath {
       lostConversionLeadCountCreatedPath: lost
       lostQualifiedConversionLeadCountCreatedPath: lostQualified
       openNotQualifiedConversionLeadCountCreatedPath: openNotQualified
       openQualifiedConversionLeadCountCreatedPath: openQualified
       pathConversionLeadCountCreatedPath: path
       qualifiedConversionLeadCountCreatedPath: qualified
       reassignedNotQualifiedConversionLeadCountCreatedPath: reassignedNotQualified
       reassignedQualifiedConversionLeadCountCreatedPath: reassignedQualified
       wonQualifiedConversionLeadCountCreatedPath: wonQualified
   }
  }`)();

export const ConversionGraphItemFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionGraphItemFragment on ConversionGraphItem {
   ...on ConversionGraphAmountItem {
       dateConversionGraphAmountItem: date
       valueConversionGraphAmountItem: value
   }
   ...on ConversionGraphCountItem {
       dateConversionGraphCountItem: date
       valueConversionGraphCountItem: value
   }
  }`)();

export const ConversionItemGraphFragment = /* @__PURE__ */ (() => gql`
  fragment ConversionItemGraphFragment on ConversionItemGraph {
    lost {
      ...ConversionGraphItemFragment
    }
    open {
      ...ConversionGraphItemFragment
    }
    reassigned {
      ...ConversionGraphItemFragment
    }
    won {
      ...ConversionGraphItemFragment
    }
  }
  ${ConversionGraphItemFragment}
`)();

export const ContactSocialRelationEntityFragment = /* @__PURE__ */ (() => gql`
  fragment ContactSocialRelationEntityFragment on ContactSocialRelationEntity {
    angellistUrl
    created
    crunchbaseUrl
    disqusUrl
    facebookId
    facebookUrl
    flickrUrl
    foursquareUrl
    googleId
    googlePlusUrl
    gravatarUrl
    id
    isDeleteProtected
    isDeleted
    kloutUrl
    linkedinId
    linkedinUrl
    modified
    pinterestUrl
    quoraUrl
    redditUrl
    revision
    skypeUrl
    slideshareUrl
    twitterId
    twitterUrl
    vimeoUrl
    wordpressUrl
    xingUrl
    yahooUrl
    yelpUrl
    youtubeUrl
  }`)();

export const ContactSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment ContactSearchResultItemFragment on ContactSearchResultItem {
    datetime
    id
    isArchived
    isDeleted
    name
    pictureUrl
    primaryAccountName
    primaryAccountPosition
    primaryEmail
    primaryPhone
  }`)();

export const ContactRoleTabFragment = /* @__PURE__ */ (() => gql`
  fragment ContactRoleTabFragment on ContactRoleTab {
    showManagingUnitItems
    showMyItems
    showMySharedItems
  }`)();

export const ContactRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment ContactRecentlyOpenedResultItemFragment on ContactRecentlyOpenedResultItem {
    id
    isArchived
    isDeleted
    name
    openedAt
    pictureUrl
    primaryAccountName
    primaryAccountPosition
    primaryEmail
    primaryPhone
  }`)();

export const ContactQuoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactQuoteTabDataGridViewFragment on ContactQuoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const ContactOpportunityTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactOpportunityTabDataGridViewFragment on ContactOpportunityTabDataGridView {
    items {
      id
    }
    sessionId
    stats {
      ...OpportunityTabDataGridViewStatFragment
    }
    total
  }
  ${OpportunityTabDataGridViewStatFragment}
`)();

export const ContactNoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactNoteTabDataGridViewFragment on ContactNoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const ContactLeadTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactLeadTabDataGridViewFragment on ContactLeadTabDataGridView {
    items {
      id
    }
    sessionId
    stats {
      ...LeadTabDataGridViewStatFragment
    }
    total
  }
  ${LeadTabDataGridViewStatFragment}
`)();

export const ContactFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment ContactFilterTabFragment on ContactFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const ContactFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment ContactFavoriteResultItemFragment on ContactFavoriteResultItem {
    id
    isArchived
    isDeleted
    name
    pictureUrl
    primaryAccountName
    primaryAccountPosition
    primaryEmail
    primaryPhone
  }`)();

export const ContactDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment ContactDataGridViewItemsFragment on ContactDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const ContactCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactCloudObjectTabDataGridViewFragment on ContactCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const ContactArchiveProfileFragment = /* @__PURE__ */ (() => gql`
  fragment ContactArchiveProfileFragment on ContactArchiveProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    quickFilter {
      filterFieldOrder
    }
    role {
      ...ContactRoleTabFragment
    }
    view {
      sortBy
      sortOrder
    }
  }
  ${ContactRoleTabFragment}
`)();

export const CloudObjectTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment CloudObjectTabDataGridViewOptionsFragment on CloudObjectTabDataGridViewOptions {
    filterByOwnerId
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterByRecordName
    filterByRecordType
    hideEmptyFolders
    newFolderIds
    relatedDocuments
    searchQuery
  }
  ${PeriodOptionFragment}
`)();

export const CloudObjectSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment CloudObjectSearchResultItemFragment on CloudObjectSearchResultItem {
    cloudObjectLinkedEntity {
      ...LinkedItemTypeFragment
    }
    datetime
    fileName
    id
    isDeleted
    url
  }
  ${LinkedItemTypeFragment}
`)();

export const ChangeBaseCurrencyPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment ChangeBaseCurrencyPayloadFragment on ChangeBaseCurrencyPayload {
  clientMutationId
  result {
    code
    created
    currencyExchangeRates {
      totalCount
    }
    id
    isBase
    isDeleteProtected
    isDeleted
    modified
    revision
    symbol
  }
  }`)();

export const changeBaseCurrencyMutation = /* @__PURE__ */ (() => gql`
  mutation changeBaseCurrency($input: ChangeBaseCurrencyInput!) {
      changeBaseCurrency(input: $input) {
          ...ChangeBaseCurrencyPayloadFragment
      }
  }
  ${ChangeBaseCurrencyPayloadFragment}
`)();

export const CallingIntegrationOutputFragment = /* @__PURE__ */ (() => gql`
  fragment CallingIntegrationOutputFragment on CallingIntegrationOutput {
    enabled
    errorCode
    numbers {
      callForwardingPhone
      created
      enabled
      errorCode
      id
      isDeleteProtected
      isDeleted
      messageForwardingEmail
      modified
      name
      ownerId
      phoneNumber
      revision
      twilioCallerSid
      type
    }
  }`)();

export const BulkUpdateResultFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUpdateResultFragment on BulkUpdateResult {
    count
    firstEntityId
    notAvailableCount
    sessionId
  }`)();

export const BulkUpdateEntitiesPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUpdateEntitiesPayloadFragment on BulkUpdateEntitiesPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkUpdateEntitiesMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUpdateEntities($input: BulkUpdateEntitiesInput!) {
      bulkUpdateEntities(input: $input) {
          ...BulkUpdateEntitiesPayloadFragment
      }
  }
  ${BulkUpdateEntitiesPayloadFragment}
`)();

export const BulkUpdateCompanyEmailPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUpdateCompanyEmailPayloadFragment on BulkUpdateCompanyEmailPayload {
    result {
      deleted
      updated
    }
  }`)();

export const bulkUpdateCompanyEmailMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUpdateCompanyEmail($deleteInput: [DeleteCompanyEmailInput!],$input: [CreateOrUpdateCompanyEmailInput!]!,$match: MatchingInput,$rollbackMethod: RollbackMethod,$validationLevel: [ValidationLevel!]) {
      bulkUpdateCompanyEmail(deleteInput: $deleteInput,input: $input,match: $match,rollbackMethod: $rollbackMethod,validationLevel: $validationLevel) {
          ...BulkUpdateCompanyEmailPayloadFragment
      }
  }
  ${BulkUpdateCompanyEmailPayloadFragment}
`)();

export const BulkUnlinkQuotePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkQuotePayloadFragment on BulkUnlinkQuotePayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkQuoteMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkQuote($input: BulkUnlinkQuoteInput!) {
      bulkUnlinkQuote(input: $input) {
          ...BulkUnlinkQuotePayloadFragment
      }
  }
  ${BulkUnlinkQuotePayloadFragment}
`)();

export const BulkUnlinkProjectPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkProjectPayloadFragment on BulkUnlinkProjectPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkProjectMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkProject($input: BulkUnlinkProjectInput!) {
      bulkUnlinkProject(input: $input) {
          ...BulkUnlinkProjectPayloadFragment
      }
  }
  ${BulkUnlinkProjectPayloadFragment}
`)();

export const BulkUnlinkProductPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkProductPayloadFragment on BulkUnlinkProductPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkProductMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkProduct($input: BulkUnlinkProductInput!) {
      bulkUnlinkProduct(input: $input) {
          ...BulkUnlinkProductPayloadFragment
      }
  }
  ${BulkUnlinkProductPayloadFragment}
`)();

export const BulkUnlinkOpportunityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkOpportunityPayloadFragment on BulkUnlinkOpportunityPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkOpportunityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkOpportunity($input: BulkUnlinkOpportunityInput!) {
      bulkUnlinkOpportunity(input: $input) {
          ...BulkUnlinkOpportunityPayloadFragment
      }
  }
  ${BulkUnlinkOpportunityPayloadFragment}
`)();

export const BulkUnlinkLeadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkLeadPayloadFragment on BulkUnlinkLeadPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkLeadMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkLead($input: BulkUnlinkLeadInput!) {
      bulkUnlinkLead(input: $input) {
          ...BulkUnlinkLeadPayloadFragment
      }
  }
  ${BulkUnlinkLeadPayloadFragment}
`)();

export const BulkUnlinkLeadOpptyPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkLeadOpptyPayloadFragment on BulkUnlinkLeadOpptyPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkLeadOpptyMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkLeadOppty($input: BulkUnlinkLeadOpptyInput!) {
      bulkUnlinkLeadOppty(input: $input) {
          ...BulkUnlinkLeadOpptyPayloadFragment
      }
  }
  ${BulkUnlinkLeadOpptyPayloadFragment}
`)();

export const BulkUnlinkCustomEntityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkCustomEntityPayloadFragment on BulkUnlinkCustomEntityPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkCustomEntityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkCustomEntity($input: BulkUnlinkCustomEntityInput!) {
      bulkUnlinkCustomEntity(input: $input) {
          ...BulkUnlinkCustomEntityPayloadFragment
      }
  }
  ${BulkUnlinkCustomEntityPayloadFragment}
`)();

export const BulkUnlinkContactPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkContactPayloadFragment on BulkUnlinkContactPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkContactMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkContact($input: BulkUnlinkContactInput!) {
      bulkUnlinkContact(input: $input) {
          ...BulkUnlinkContactPayloadFragment
      }
  }
  ${BulkUnlinkContactPayloadFragment}
`)();

export const BulkUnlinkActivityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkActivityPayloadFragment on BulkUnlinkActivityPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkActivityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkActivity($input: BulkUnlinkActivityInput!) {
      bulkUnlinkActivity(input: $input) {
          ...BulkUnlinkActivityPayloadFragment
      }
  }
  ${BulkUnlinkActivityPayloadFragment}
`)();

export const BulkUnlinkAccountPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkUnlinkAccountPayloadFragment on BulkUnlinkAccountPayload {
  clientMutationId
  result
  }`)();

export const bulkUnlinkAccountMutation = /* @__PURE__ */ (() => gql`
  mutation bulkUnlinkAccount($input: BulkUnlinkAccountInput!) {
      bulkUnlinkAccount(input: $input) {
          ...BulkUnlinkAccountPayloadFragment
      }
  }
  ${BulkUnlinkAccountPayloadFragment}
`)();

export const BulkReleaseOwnershipLeadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkReleaseOwnershipLeadPayloadFragment on BulkReleaseOwnershipLeadPayload {
  clientMutationId
  }`)();

export const bulkReleaseOwnershipLeadMutation = /* @__PURE__ */ (() => gql`
  mutation bulkReleaseOwnershipLead($input: BulkReleaseOwnershipLeadInput!) {
      bulkReleaseOwnershipLead(input: $input) {
          ...BulkReleaseOwnershipLeadPayloadFragment
      }
  }
  ${BulkReleaseOwnershipLeadPayloadFragment}
`)();

export const BulkErrorResultFragment = /* @__PURE__ */ (() => gql`
  fragment BulkErrorResultFragment on BulkErrorResult {
    apiError {
      code
      entityId
      entityIndex
      entityName
      message
      name
    }
    code
    entityId
    index
    message
  }`)();

export const BulkDeleteTargetPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteTargetPayloadFragment on BulkDeleteTargetPayload {
  clientMutationId
  }`)();

export const bulkDeleteTargetMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteTarget($input: BulkDeleteTargetInput!) {
      bulkDeleteTarget(input: $input) {
          ...BulkDeleteTargetPayloadFragment
      }
  }
  ${BulkDeleteTargetPayloadFragment}
`)();

export const BulkDeleteQuotePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteQuotePayloadFragment on BulkDeleteQuotePayload {
  clientMutationId
  }`)();

export const bulkDeleteQuoteMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteQuote($input: BulkDeleteQuoteInput!) {
      bulkDeleteQuote(input: $input) {
          ...BulkDeleteQuotePayloadFragment
      }
  }
  ${BulkDeleteQuotePayloadFragment}
`)();

export const BulkDeleteProjectPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteProjectPayloadFragment on BulkDeleteProjectPayload {
  clientMutationId
  }`)();

export const bulkDeleteProjectMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteProject($input: BulkDeleteProjectInput!) {
      bulkDeleteProject(input: $input) {
          ...BulkDeleteProjectPayloadFragment
      }
  }
  ${BulkDeleteProjectPayloadFragment}
`)();

export const BulkDeleteNotePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteNotePayloadFragment on BulkDeleteNotePayload {
  clientMutationId
  }`)();

export const bulkDeleteNoteMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteNote($input: BulkDeleteNoteInput!) {
      bulkDeleteNote(input: $input) {
          ...BulkDeleteNotePayloadFragment
      }
  }
  ${BulkDeleteNotePayloadFragment}
`)();

export const BulkDeleteLeadOpptyPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteLeadOpptyPayloadFragment on BulkDeleteLeadOpptyPayload {
  clientMutationId
  }`)();

export const bulkDeleteLeadOpptyMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteLeadOppty($input: BulkDeleteLeadOpptyInput!) {
      bulkDeleteLeadOppty(input: $input) {
          ...BulkDeleteLeadOpptyPayloadFragment
      }
  }
  ${BulkDeleteLeadOpptyPayloadFragment}
`)();

export const BulkDeleteForecastPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteForecastPayloadFragment on BulkDeleteForecastPayload {
  clientMutationId
  }`)();

export const bulkDeleteForecastMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteForecast($input: BulkDeleteForecastInput!) {
      bulkDeleteForecast(input: $input) {
          ...BulkDeleteForecastPayloadFragment
      }
  }
  ${BulkDeleteForecastPayloadFragment}
`)();

export const BulkDeleteEmailPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteEmailPayloadFragment on BulkDeleteEmailPayload {
  clientMutationId
  }`)();

export const bulkDeleteEmailMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteEmail($input: BulkDeleteEmailInput!) {
      bulkDeleteEmail(input: $input) {
          ...BulkDeleteEmailPayloadFragment
      }
  }
  ${BulkDeleteEmailPayloadFragment}
`)();

export const BulkDeleteCustomEntityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteCustomEntityPayloadFragment on BulkDeleteCustomEntityPayload {
  clientMutationId
  }`)();

export const bulkDeleteCustomEntityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteCustomEntity($input: BulkDeleteCustomEntityInput!) {
      bulkDeleteCustomEntity(input: $input) {
          ...BulkDeleteCustomEntityPayloadFragment
      }
  }
  ${BulkDeleteCustomEntityPayloadFragment}
`)();

export const BulkDeleteContactPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteContactPayloadFragment on BulkDeleteContactPayload {
  clientMutationId
  }`)();

export const bulkDeleteContactMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteContact($input: BulkDeleteContactInput!) {
      bulkDeleteContact(input: $input) {
          ...BulkDeleteContactPayloadFragment
      }
  }
  ${BulkDeleteContactPayloadFragment}
`)();

export const BulkDeleteCompanyEmailPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteCompanyEmailPayloadFragment on BulkDeleteCompanyEmailPayload {
  clientMutationId
  result
  }`)();

export const bulkDeleteCompanyEmailMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteCompanyEmail($input: BulkDeleteCompanyEmailInput!) {
      bulkDeleteCompanyEmail(input: $input) {
          ...BulkDeleteCompanyEmailPayloadFragment
      }
  }
  ${BulkDeleteCompanyEmailPayloadFragment}
`)();

export const BulkDeleteCloudObjectPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteCloudObjectPayloadFragment on BulkDeleteCloudObjectPayload {
  clientMutationId
  }`)();

export const bulkDeleteCloudObjectMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteCloudObject($input: BulkDeleteCloudObjectInput!) {
      bulkDeleteCloudObject(input: $input) {
          ...BulkDeleteCloudObjectPayloadFragment
      }
  }
  ${BulkDeleteCloudObjectPayloadFragment}
`)();

export const BulkDeleteActivityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteActivityPayloadFragment on BulkDeleteActivityPayload {
  clientMutationId
  }`)();

export const bulkDeleteActivityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteActivity($input: BulkDeleteActivityInput!) {
      bulkDeleteActivity(input: $input) {
          ...BulkDeleteActivityPayloadFragment
      }
  }
  ${BulkDeleteActivityPayloadFragment}
`)();

export const BulkDeleteAccountPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkDeleteAccountPayloadFragment on BulkDeleteAccountPayload {
  clientMutationId
  }`)();

export const bulkDeleteAccountMutation = /* @__PURE__ */ (() => gql`
  mutation bulkDeleteAccount($input: BulkDeleteAccountInput!) {
      bulkDeleteAccount(input: $input) {
          ...BulkDeleteAccountPayloadFragment
      }
  }
  ${BulkDeleteAccountPayloadFragment}
`)();

export const BulkChangeOwnershipQuotePayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipQuotePayloadFragment on BulkChangeOwnershipQuotePayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipQuoteMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipQuote($input: BulkChangeOwnershipQuoteInput!) {
      bulkChangeOwnershipQuote(input: $input) {
          ...BulkChangeOwnershipQuotePayloadFragment
      }
  }
  ${BulkChangeOwnershipQuotePayloadFragment}
`)();

export const BulkChangeOwnershipProjectPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipProjectPayloadFragment on BulkChangeOwnershipProjectPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipProjectMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipProject($input: BulkChangeOwnershipProjectInput!) {
      bulkChangeOwnershipProject(input: $input) {
          ...BulkChangeOwnershipProjectPayloadFragment
      }
  }
  ${BulkChangeOwnershipProjectPayloadFragment}
`)();

export const BulkChangeOwnershipOpportunityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipOpportunityPayloadFragment on BulkChangeOwnershipOpportunityPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipOpportunityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipOpportunity($input: BulkChangeOwnershipOpportunityInput!) {
      bulkChangeOwnershipOpportunity(input: $input) {
          ...BulkChangeOwnershipOpportunityPayloadFragment
      }
  }
  ${BulkChangeOwnershipOpportunityPayloadFragment}
`)();

export const BulkChangeOwnershipLeadPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipLeadPayloadFragment on BulkChangeOwnershipLeadPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipLeadMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipLead($input: BulkChangeOwnershipLeadInput!) {
      bulkChangeOwnershipLead(input: $input) {
          ...BulkChangeOwnershipLeadPayloadFragment
      }
  }
  ${BulkChangeOwnershipLeadPayloadFragment}
`)();

export const BulkChangeOwnershipCustomEntityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipCustomEntityPayloadFragment on BulkChangeOwnershipCustomEntityPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipCustomEntityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipCustomEntity($input: BulkChangeOwnershipCustomEntityInput!) {
      bulkChangeOwnershipCustomEntity(input: $input) {
          ...BulkChangeOwnershipCustomEntityPayloadFragment
      }
  }
  ${BulkChangeOwnershipCustomEntityPayloadFragment}
`)();

export const BulkChangeOwnershipContactPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipContactPayloadFragment on BulkChangeOwnershipContactPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipContactMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipContact($input: BulkChangeOwnershipContactInput!) {
      bulkChangeOwnershipContact(input: $input) {
          ...BulkChangeOwnershipContactPayloadFragment
      }
  }
  ${BulkChangeOwnershipContactPayloadFragment}
`)();

export const BulkChangeOwnershipActivityPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipActivityPayloadFragment on BulkChangeOwnershipActivityPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipActivityMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipActivity($input: BulkChangeOwnershipActivityInput!) {
      bulkChangeOwnershipActivity(input: $input) {
          ...BulkChangeOwnershipActivityPayloadFragment
      }
  }
  ${BulkChangeOwnershipActivityPayloadFragment}
`)();

export const BulkChangeOwnershipAccountPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment BulkChangeOwnershipAccountPayloadFragment on BulkChangeOwnershipAccountPayload {
  clientMutationId
  result {
    errors {
      ...BulkUpdateResultFragment
    }
    skipped {
      ...BulkUpdateResultFragment
    }
    updated {
      ...BulkUpdateResultFragment
    }
  }
  }
  ${BulkUpdateResultFragment}
`)();

export const bulkChangeOwnershipAccountMutation = /* @__PURE__ */ (() => gql`
  mutation bulkChangeOwnershipAccount($input: BulkChangeOwnershipAccountInput!) {
      bulkChangeOwnershipAccount(input: $input) {
          ...BulkChangeOwnershipAccountPayloadFragment
      }
  }
  ${BulkChangeOwnershipAccountPayloadFragment}
`)();

export const AutomationHubCategoryEntityFragment = /* @__PURE__ */ (() => gql`
  fragment AutomationHubCategoryEntityFragment on AutomationHubCategoryEntity {
    id
    instanceFieldPermissions {
      ...FieldLevelPermissionEnumFragment
    }
    isDeleted
    name
  }
  ${FieldLevelPermissionEnumFragment}
`)();

export const AutomationHubAppEntityFragment = /* @__PURE__ */ (() => gql`
  fragment AutomationHubAppEntityFragment on AutomationHubAppEntity {
    id
    instanceFieldPermissions {
      ...FieldLevelPermissionEnumFragment
    }
    isDeleted
    logoUrl
    name
    supportPrivacyUrl
    supportTermsUrl
    supportUrl
    websiteUrl
  }
  ${FieldLevelPermissionEnumFragment}
`)();

export const AttachmentsPictureEntityFragment = /* @__PURE__ */ (() => gql`
  fragment AttachmentsPictureEntityFragment on AttachmentsPictureEntity {
    filename
    url
  }`)();

export const AttachmentFileExtensionFragment = /* @__PURE__ */ (() => gql`
  fragment AttachmentFileExtensionFragment on AttachmentFileExtension {
    denied
    list
  }`)();

export const UpdateSpaceSettingPayloadFragment = /* @__PURE__ */ (() => gql`
  fragment UpdateSpaceSettingPayloadFragment on UpdateSpaceSettingPayload {
  clientMutationId
  spaceSetting {
    attachmentFileExtensions {
      ...AttachmentFileExtensionFragment
    }
    attachmentMaxSize
    chunkSizeExchange
    cloudEnabled
    dynamicFinancialYear {
      ...FinancialDateStartFragment
    }
    emailAttachmentEnabled
    emailAttachmentMaxSize
    emailDomainBlacklisting
    fileAttachmentUploadEnabled
    firstDayOfWeek
    intercomIntegration
    sharepointIntegration
    theme
    timezone
  }
  }
  ${AttachmentFileExtensionFragment}
  ${FinancialDateStartFragment}
`)();

export const updateSpaceSettingMutation = /* @__PURE__ */ (() => gql`
  mutation updateSpaceSetting($input: UpdateSpaceSettingInput!) {
      updateSpaceSetting(input: $input) {
          ...UpdateSpaceSettingPayloadFragment
      }
  }
  ${UpdateSpaceSettingPayloadFragment}
`)();

export const ArchiveWonStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment ArchiveWonStepExtractViewFragment on ArchiveWonStepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInPipeline
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
    successRateCount
    successRateSession
    successRateTotalCount
    successRateTotalSession
    totalOpportunitiesSession
    wonArchiveOpportunitiesValue
  }`)();

export const ArchiveStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment ArchiveStepExtractViewFragment on ArchiveStepExtractView {
    archiveOpportunitiesCount
    archiveOpportunitiesSession
    archiveOpportunitiesValue
    avgDaysInStep
    dropOffRateCount
    dropOffRateSession
    dropOffRateTotalCount
    dropOffRateTotalSession
    id
    opportunitiesCount
    opportunitiesSession
    opportunitiesValue
  }`)();

export const ArchiveLeadStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment ArchiveLeadStepExtractViewFragment on ArchiveLeadStepExtractView {
    archiveLeadsCount
    archiveLeadsSession
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    leadsCount
    leadsSession
  }`)();

export const ArchiveLeadPreviewStepExtractViewFragment = /* @__PURE__ */ (() => gql`
  fragment ArchiveLeadPreviewStepExtractViewFragment on ArchiveLeadPreviewStepExtractView {
    archiveLeadsCount
    archiveLeadsSession
    avgDaysInStep
    conversionRateCount
    conversionRateSession
    conversionRateTotalCount
    conversionRateTotalSession
    leadsCount
    leadsSession
  }`)();

export const ApprovalProcessesNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment ApprovalProcessesNotificationSettingsFragment on ApprovalProcessesNotificationSettings {
    ApprovalProcessError
    ApprovalProcessWarning
    ApprovalRequest
    ApprovalResponse
    IsActive
  }`)();

export const AppointmentSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment AppointmentSearchResultItemFragment on AppointmentSearchResultItem {
    datetime
    endDate
    id
    isDeleted
    linkedEntities {
      ...LinkedItemTypeFragment
    }
    startDate
    subject
  }
  ${LinkedItemTypeFragment}
`)();

export const AppointmentRecurrenceOccurrenceCalendarViewItemFragment = /* @__PURE__ */ (() => gql`
  fragment AppointmentRecurrenceOccurrenceCalendarViewItemFragment on AppointmentRecurrenceOccurrenceCalendarViewItem {
    badgeColor
    endDate
    id
    name
    occurenceDate
    ownerColor
    startDate
    status
  }`)();

export const AppointmentRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment AppointmentRecentlyOpenedResultItemFragment on AppointmentRecentlyOpenedResultItem {
    endDate
    id
    isDeleted
    linkedEntities {
      ...RecentlyOpenedLinkedItemTypeFragment
    }
    openedAt
    startDate
    subject
  }
  ${RecentlyOpenedLinkedItemTypeFragment}
`)();

export const AppointmentCalendarViewItemFragment = /* @__PURE__ */ (() => gql`
  fragment AppointmentCalendarViewItemFragment on AppointmentCalendarViewItem {
    activityTypeId
    badgeColor
    endDate
    id
    name
    ownerColor
    ownerId
    recurrenceMasterId
    startDate
    status
    tags
  }`)();

export const QuoteActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment QuoteActivityTabCalendarViewFragment on QuoteActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const ProjectActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment ProjectActivityTabCalendarViewFragment on ProjectActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const OpportunityActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment OpportunityActivityTabCalendarViewFragment on OpportunityActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const LeadActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment LeadActivityTabCalendarViewFragment on LeadActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const ContactActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment ContactActivityTabCalendarViewFragment on ContactActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const AllowedEntityTypeFragment = /* @__PURE__ */ (() => gql`
  fragment AllowedEntityTypeFragment on AllowedEntityType {
    entity
    entityApiName
    entityTypeIds
  }`)();

export const AgendaRecurrentAppointmentVirtualOccurenceFragment = /* @__PURE__ */ (() => gql`
  fragment AgendaRecurrentAppointmentVirtualOccurenceFragment on AgendaRecurrentAppointmentVirtualOccurence {
    appointmentType
    date
    endDatetime
    linkedId
    name
    occurenceDate
    startDatetime
  }`)();

export const AgendaOpportunityVelocityFragment = /* @__PURE__ */ (() => gql`
  fragment AgendaOpportunityVelocityFragment on AgendaOpportunityVelocity {
    date
    fitness
    linkedId
    name
    opportunityLabel
    opportunityRanking
  }`)();

export const AgendaOpportunityClosingDateFragment = /* @__PURE__ */ (() => gql`
  fragment AgendaOpportunityClosingDateFragment on AgendaOpportunityClosingDate {
    date
    fitness
    linkedId
    name
    opportunityLabel
    opportunityRanking
  }`)();

export const AgendaDueDateTaskFragment = /* @__PURE__ */ (() => gql`
  fragment AgendaDueDateTaskFragment on AgendaDueDateTask {
    date
    linkedId
    name
    priority
    reminder
    taskType
  }`)();

export const AgendaAppointmentFragment = /* @__PURE__ */ (() => gql`
  fragment AgendaAppointmentFragment on AgendaAppointment {
    appointmentType
    date
    endDatetime
    isRecurrent
    linkedId
    name
    reminder
    startDatetime
  }`)();

export const ActivityTypeFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityTypeFragment on ActivityType {
    icon
    id
    name
  }`)();

export const FeedUnitAssignedAsWatcherFragment = /* @__PURE__ */ (() => gql`
  fragment FeedUnitAssignedAsWatcherFragment on FeedUnitAssignedAsWatcher {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    targetUnitId
    targetUnitIsDeleted
    targetUnitName
    targetUnitPictureUrl
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedUnitAssignedAsEditorFragment = /* @__PURE__ */ (() => gql`
  fragment FeedUnitAssignedAsEditorFragment on FeedUnitAssignedAsEditor {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    targetUnitId
    targetUnitIsDeleted
    targetUnitName
    targetUnitPictureUrl
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedTextMessageCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTextMessageCreatedFragment on FeedTextMessageCreated {
    actor {
      ...FeedActorFragment
    }
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    direction
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    itemsInConversationCount
    modified
    phoneType
    recipientPhoneNumber
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    textConversationId
    textMessageStatus
  }
  ${FeedActorFragment}
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedTaskStatusChangeFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTaskStatusChangeFragment on FeedTaskStatusChange {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    status
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedTaskCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTaskCreatedFragment on FeedTaskCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    description
    dueDate
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    hasRecurrence
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    priority
    reminder
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    taskStatus
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedTaskAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedTaskAddedFragment on FeedTaskAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    description
    dueDate
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    hasRecurrence
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    priority
    reminder
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    taskStatus
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedScheduledMassEmailCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedScheduledMassEmailCreatedFragment on FeedScheduledMassEmailCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    canChangeContentSharing
    contentShareMode
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    errorCode
    isContentAvailable
    isTracked
    modified
    recipientCount
    sendAt
    sender
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    wasBounced
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedScheduledEmailAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedScheduledEmailAddedFragment on FeedScheduledEmailAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    attachmentsPictures {
      ...AttachmentsPictureEntityFragment
    }
    bodySummary
    canChangeContentSharing
    cc
    contentShareMode
    created
    direction
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    errorCode
    hasTrackingEvent
    isContentAvailable
    isTracked
    itemsInThreadCount
    modified
    parentEmailId
    recipient
    sendAt
    sender
    senderId
    senderIsDeleted
    senderName
    senderPictureUrl
    senderType
    sentiment
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    wasBounced
  }
  ${FeedApplicationFragment}
  ${AttachmentsPictureEntityFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedResponseToAppointmentInvitationFragment = /* @__PURE__ */ (() => gql`
  fragment FeedResponseToAppointmentInvitationFragment on FeedResponseToAppointmentInvitation {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    email {
      ...FeedEmailAppointmentInvitationFragment
    }
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    invitedClientId
    invitedClientIsDeleted
    invitedClientName
    invitedClientPictureUrl
    modified
    response
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${FeedEmailAppointmentInvitationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteStatusChangeFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteStatusChangeFragment on FeedQuoteStatusChange {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    quoteStatus
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteReactivateFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteReactivateFragment on FeedQuoteReactivate {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteMoveFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteMoveFragment on FeedQuoteMove {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    stepName
    stepOrder
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteLostFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteLostFragment on FeedQuoteLost {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteAddedFragment on FeedQuoteAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    expirationDate
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    quoteStatus
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    totalAmount
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedQuoteAcceptedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedQuoteAcceptedFragment on FeedQuoteAccepted {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedProjectStatusChangeFragment = /* @__PURE__ */ (() => gql`
  fragment FeedProjectStatusChangeFragment on FeedProjectStatusChange {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    projectStatus
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedProjectAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedProjectAddedFragment on FeedProjectAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    description
    endDate
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    projectStatus
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    startDate
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedOwnershipChangedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOwnershipChangedFragment on FeedOwnershipChanged {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    targetClientId
    targetClientIsDeleted
    targetClientName
    targetClientPictureUrl
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOpportunityWonFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOpportunityWonFragment on FeedOpportunityWon {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOpportunityMoveFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOpportunityMoveFragment on FeedOpportunityMove {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    stepName
    stepOrder
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOpportunityCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOpportunityCreatedFragment on FeedOpportunityCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    closingDate
    created
    daysInStep
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    hasRecurrence
    label
    modified
    opportunityStatus
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    ranking
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
    value
    warningLevel
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOpportunityBackToLeadFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOpportunityBackToLeadFragment on FeedOpportunityBackToLead {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOpportunityAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOpportunityAddedFragment on FeedOpportunityAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    closingDate
    created
    daysInStep
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    hasRecurrence
    label
    modified
    opportunityStatus
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    ranking
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
    value
    warningLevel
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedOnlineFormSubmittedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedOnlineFormSubmittedFragment on FeedOnlineFormSubmitted {
    actor {
      ...FeedActorFragment
    }
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    onlineFormTypeId
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedActorFragment}
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedNoteAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedNoteAddedFragment on FeedNoteAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedMemoCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedMemoCreatedFragment on FeedMemoCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    attachmentsPictures {
      ...AttachmentsPictureEntityFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${AttachmentsPictureEntityFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedMemoAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedMemoAddedFragment on FeedMemoAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    attachmentsPictures {
      ...AttachmentsPictureEntityFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${AttachmentsPictureEntityFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedMassEmailCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedMassEmailCreatedFragment on FeedMassEmailCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    canChangeContentSharing
    contentShareMode
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    isContentAvailable
    isTracked
    modified
    recipientCount
    sender
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    wasBounced
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedLeadQualificationFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLeadQualificationFragment on FeedLeadQualification {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedLeadOpportunityReactivateFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLeadOpportunityReactivateFragment on FeedLeadOpportunityReactivate {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedLeadOpportunityLostFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLeadOpportunityLostFragment on FeedLeadOpportunityLost {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedLeadCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLeadCreatedFragment on FeedLeadCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    daysInQueue
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    label
    leadStatus
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    ranking
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
    warningLevel
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedLeadAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedLeadAddedFragment on FeedLeadAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    daysInQueue
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    label
    leadStatus
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    ranking
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
    warningLevel
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedInvitationToAppointmentFragment = /* @__PURE__ */ (() => gql`
  fragment FeedInvitationToAppointmentFragment on FeedInvitationToAppointment {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    email {
      ...FeedEmailAppointmentInvitationFragment
    }
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    invitedClientId
    invitedClientIsDeleted
    invitedClientName
    invitedClientPictureUrl
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${FeedEmailAppointmentInvitationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedEmailCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedEmailCreatedFragment on FeedEmailCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    attachmentsPictures {
      ...AttachmentsPictureEntityFragment
    }
    bodySummary
    canChangeContentSharing
    cc
    contentShareMode
    created
    direction
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    hasTrackingEvent
    isContentAvailable
    isTracked
    itemsInThreadCount
    modified
    parentEmailId
    recipient
    sender
    senderId
    senderIsDeleted
    senderName
    senderPictureUrl
    senderType
    sentiment
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    wasBounced
  }
  ${FeedApplicationFragment}
  ${AttachmentsPictureEntityFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedEmailAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedEmailAddedFragment on FeedEmailAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    attachmentsPictures {
      ...AttachmentsPictureEntityFragment
    }
    bodySummary
    canChangeContentSharing
    cc
    contentShareMode
    created
    direction
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    hasTrackingEvent
    isContentAvailable
    isTracked
    itemsInThreadCount
    modified
    parentEmailId
    recipient
    sender
    senderId
    senderIsDeleted
    senderName
    senderPictureUrl
    senderType
    sentiment
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    wasBounced
  }
  ${FeedApplicationFragment}
  ${AttachmentsPictureEntityFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedCustomEntityAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedCustomEntityAddedFragment on FeedCustomEntityAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedContactCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedContactCreatedFragment on FeedContactCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    primaryEmail
    primaryPhone
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedContactAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedContactAddedFragment on FeedContactAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    primaryEmail
    primaryPhone
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedCloudObjectAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedCloudObjectAddedFragment on FeedCloudObjectAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedClientAssignedAsWatcherFragment = /* @__PURE__ */ (() => gql`
  fragment FeedClientAssignedAsWatcherFragment on FeedClientAssignedAsWatcher {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    targetClientId
    targetClientIsDeleted
    targetClientName
    targetClientPictureUrl
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedClientAssignedAsEditorFragment = /* @__PURE__ */ (() => gql`
  fragment FeedClientAssignedAsEditorFragment on FeedClientAssignedAsEditor {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    foreignCurrencyValue {
      ...CurrencyForeignDataFragment
    }
    industryName
    modified
    primaryAccountId
    primaryAccountJobName
    primaryAccountName
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    targetClientId
    targetClientIsDeleted
    targetClientName
    targetClientPictureUrl
    value
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${CurrencyForeignDataFragment}
  ${FeedTagFragment}
`)();

export const FeedChildAccountAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedChildAccountAddedFragment on FeedChildAccountAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    industryName
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    primaryEmail
    primaryPhone
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedAppointmentCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedAppointmentCreatedFragment on FeedAppointmentCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    appointmentStatus
    created
    description
    endDate
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    reminder
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    startDate
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedAppointmentCanceledFragment = /* @__PURE__ */ (() => gql`
  fragment FeedAppointmentCanceledFragment on FeedAppointmentCanceled {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedAppointmentAddedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedAppointmentAddedFragment on FeedAppointmentAdded {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    appointmentStatus
    created
    description
    endDate
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    reminder
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    startDate
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const FeedAccountCreatedFragment = /* @__PURE__ */ (() => gql`
  fragment FeedAccountCreatedFragment on FeedAccountCreated {
    actorClientId
    actorClientIsDeleted
    actorClientName
    actorClientPictureUrl
    application {
      ...FeedApplicationFragment
    }
    created
    entityActivityType {
      ...ActivityTypeFragment
    }
    entityApiName
    entityCloudObjectsCount
    entityCommentsCount
    entityId
    entityLinkedEntities {
      ...FeedLinkedEntityFragment
    }
    entityName
    entitySharedUsersUnits {
      ...FeedLinkedEntityFragment
    }
    entitySharedUsersUnitsCount
    entityType
    industryName
    modified
    ownerIsDeleted
    ownerName
    ownerPictureUrl
    primaryEmail
    primaryPhone
    sourceEntityApiName
    sourceEntityId
    sourceEntityType
    tags {
      ...FeedTagFragment
    }
    unitIsDeleted
    unitName
    unitPictureUrl
  }
  ${FeedApplicationFragment}
  ${ActivityTypeFragment}
  ${FeedLinkedEntityFragment}
  ${FeedTagFragment}
`)();

export const ActivityTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityTabDataGridViewOptionsFragment on ActivityTabDataGridViewOptions {
    filterByActivityTypeId
    filterByOwnerId
    filterByPeriod {
      ...PeriodOptionFragment
    }
    filterByStatus
    filterByTags
    relatedActivities
    searchQuery
    showTasksWithoutDueDate
  }
  ${PeriodOptionFragment}
`)();

export const ActivityFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityFilterTabFragment on ActivityFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const ActivityDetailCalendarViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityDetailCalendarViewItemsFragment on ActivityDetailCalendarViewItems {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const ActivityDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityDataGridViewItemsFragment on ActivityDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const ActivityCalendarViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment ActivityCalendarViewItemsFragment on ActivityCalendarViewItems {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export const ActivitiesNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment ActivitiesNotificationSettingsFragment on ActivitiesNotificationSettings {
    Comment
    Invitation
    IsActive
    OwnershipAndSalesTeamChange
    StatusChange
  }`)();

export const AccountsAndContactsNotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment AccountsAndContactsNotificationSettingsFragment on AccountsAndContactsNotificationSettings {
    IsActive
    LinkedItem
    OwnershipAndSalesTeamChange
  }`)();

export const NotificationSettingsFragment = /* @__PURE__ */ (() => gql`
  fragment NotificationSettingsFragment on NotificationSettings {
    AccountsAndContacts {
      ...AccountsAndContactsNotificationSettingsFragment
    }
    Activities {
      ...ActivitiesNotificationSettingsFragment
    }
    ApprovalProcesses {
      ...ApprovalProcessesNotificationSettingsFragment
    }
    CallingAndMessaging {
      ...TextMessageNotificationSettingsFragment
    }
    CustomEntities {
      ...CustomEntitiesNotificationSettingFragment
    }
    EmailSequences {
      ...EmailSequencesNotificationSettingsFragment
    }
    Emails {
      ...EmailNotificationSettingsFragment
    }
    Feeds {
      ...FeedsNotificationSettingsFragment
    }
    LeadsAndOpportunities {
      ...LeadsAndOpportunitiesNotificationSettingsFragment
    }
    OnlineForms {
      ...OnlineFormsNotificationSettingsFragment
    }
    ProcessBuilder {
      ...ProcessBuilderNotificationSettingsFragment
    }
    Projects {
      ...ProjectsNotificationSettingsFragment
    }
    Quotes {
      ...QuotesNotificationSettingsFragment
    }
    WhatsApp {
      ...TextMessageNotificationSettingsFragment
    }
  }
  ${AccountsAndContactsNotificationSettingsFragment}
  ${ActivitiesNotificationSettingsFragment}
  ${ApprovalProcessesNotificationSettingsFragment}
  ${TextMessageNotificationSettingsFragment}
  ${CustomEntitiesNotificationSettingFragment}
  ${EmailSequencesNotificationSettingsFragment}
  ${EmailNotificationSettingsFragment}
  ${FeedsNotificationSettingsFragment}
  ${LeadsAndOpportunitiesNotificationSettingsFragment}
  ${OnlineFormsNotificationSettingsFragment}
  ${ProcessBuilderNotificationSettingsFragment}
  ${ProjectsNotificationSettingsFragment}
  ${QuotesNotificationSettingsFragment}
`)();

export const AccountTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment AccountTabDataGridViewOptionsFragment on AccountTabDataGridViewOptions {
    directChildrenOnly
    filterByOwnerId
    filterByTags
    searchQuery
    showArchivedRecords
  }`)();

export const AccountSocialRelationEntityFragment = /* @__PURE__ */ (() => gql`
  fragment AccountSocialRelationEntityFragment on AccountSocialRelationEntity {
    angellistUrl
    created
    crunchbaseUrl
    disqusUrl
    facebookId
    facebookUrl
    flickrUrl
    foursquareUrl
    googleId
    googlePlusUrl
    gravatarUrl
    id
    isDeleteProtected
    isDeleted
    kloutUrl
    linkedinId
    linkedinUrl
    modified
    pinterestUrl
    quoraUrl
    redditUrl
    revision
    skypeUrl
    slideshareUrl
    twitterId
    twitterUrl
    vimeoUrl
    wordpressUrl
    xingUrl
    yahooUrl
    yelpUrl
    youtubeUrl
  }`)();

export const AccountSearchResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment AccountSearchResultItemFragment on AccountSearchResultItem {
    datetime
    id
    isArchived
    isDeleted
    location
    name
    pictureUrl
    primaryEmail
    primaryPhone
  }`)();

export const AccountRoleTabFragment = /* @__PURE__ */ (() => gql`
  fragment AccountRoleTabFragment on AccountRoleTab {
    showManagingUnitItems
    showMyItems
    showMySharedItems
  }`)();

export const AccountRecentlyOpenedResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment AccountRecentlyOpenedResultItemFragment on AccountRecentlyOpenedResultItem {
    id
    isArchived
    isDeleted
    location
    name
    openedAt
    pictureUrl
    primaryEmail
    primaryPhone
  }`)();

export const AccountQuoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountQuoteTabDataGridViewFragment on AccountQuoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const AccountProjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountProjectTabDataGridViewFragment on AccountProjectTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const AccountOpportunityTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountOpportunityTabDataGridViewFragment on AccountOpportunityTabDataGridView {
    items {
      id
    }
    sessionId
    stats {
      ...OpportunityTabDataGridViewStatFragment
    }
    total
  }
  ${OpportunityTabDataGridViewStatFragment}
`)();

export const AccountNoteTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountNoteTabDataGridViewFragment on AccountNoteTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const AccountMatrixAxisFragment = /* @__PURE__ */ (() => gql`
  fragment AccountMatrixAxisFragment on AccountMatrixAxis {
    dateDisplay
    fieldId
    maximum
    minimum
    selectedOptions
    sortOrder
  }`)();

export const AccountMatrixViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountMatrixViewFragment on AccountMatrixView {
    axisX {
      ...AccountMatrixAxisFragment
    }
    axisY {
      ...AccountMatrixAxisFragment
    }
    bubbleDisplay
    showAccountNames
    showSegmentationGrid
  }
  ${AccountMatrixAxisFragment}
`)();

export const AccountLeadTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountLeadTabDataGridViewFragment on AccountLeadTabDataGridView {
    items {
      id
    }
    sessionId
    stats {
      ...LeadTabDataGridViewStatFragment
    }
    total
  }
  ${LeadTabDataGridViewStatFragment}
`)();

export const AccountHierarchyTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment AccountHierarchyTabDataGridViewOptionsFragment on AccountHierarchyTabDataGridViewOptions {
    filterByOwnerId
    filterByTags
    searchQuery
    showArchivedRecords
  }`)();

export const AccountFilterTabFragment = /* @__PURE__ */ (() => gql`
  fragment AccountFilterTabFragment on AccountFilterTab {
    filterMainBox {
      entity
      id
      lookupFieldId
    }
    filterSiblingBoxes {
      entity
      id
      lookupFieldId
    }
    formula
    isCustom
    isEnabled
    operator
  }`)();

export const AccountFavoriteResultItemFragment = /* @__PURE__ */ (() => gql`
  fragment AccountFavoriteResultItemFragment on AccountFavoriteResultItem {
    id
    isArchived
    isDeleted
    location
    name
    pictureUrl
    primaryEmail
    primaryPhone
  }`)();

export const AccountDataGridViewItemsFragment = /* @__PURE__ */ (() => gql`
  fragment AccountDataGridViewItemsFragment on AccountDataGridViewItems {
    items {
      id
    }
    sessionId
    total
  }`)();

export const AccountContactTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountContactTabDataGridViewFragment on AccountContactTabDataGridView {
    items {
      id
    }
    sessionId
    stats {
      contactedInLastThirtyDays
      contactsWithoutJobTitleCount
    }
    total
  }`)();

export const AccountContactTabDataGridQuickFilterFragment = /* @__PURE__ */ (() => gql`
  fragment AccountContactTabDataGridQuickFilterFragment on AccountContactTabDataGridQuickFilter {
    filterByContactsContactedInLastThirtyDays
    filterByContactsWithoutJobTitle
    filterByRelationship
    filterByRole
  }`)();

export const ContactTabDataGridViewOptionsFragment = /* @__PURE__ */ (() => gql`
  fragment ContactTabDataGridViewOptionsFragment on ContactTabDataGridViewOptions {
    filterByOwnerId
    filterByStats {
      ...AccountContactTabDataGridQuickFilterFragment
    }
    filterByTags
    relatedContacts
    searchQuery
    showArchivedRecords
  }
  ${AccountContactTabDataGridQuickFilterFragment}
`)();

export const AccountCloudObjectTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountCloudObjectTabDataGridViewFragment on AccountCloudObjectTabDataGridView {
    entityTypeFolderCounts {
      count
      entityApiName
      entityType
    }
    items {
      id
      isFolder
      isFolderEmpty
    }
    sessionId
    total
  }`)();

export const AccountChildAccountTabDataGridViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountChildAccountTabDataGridViewFragment on AccountChildAccountTabDataGridView {
    items {
      id
    }
    sessionId
    total
  }`)();

export const AccountArchiveProfileFragment = /* @__PURE__ */ (() => gql`
  fragment AccountArchiveProfileFragment on AccountArchiveProfile {
    filter {
      formula
      isCustom
      isEnabled
      operator
    }
    quickFilter {
      filterFieldOrder
    }
    role {
      ...AccountRoleTabFragment
    }
    view {
      sortBy
      sortOrder
    }
  }
  ${AccountRoleTabFragment}
`)();

export const AccountActivityTabCalendarViewFragment = /* @__PURE__ */ (() => gql`
  fragment AccountActivityTabCalendarViewFragment on AccountActivityTabCalendarView {
    appointmentItems {
      ...AppointmentCalendarViewItemFragment
    }
    appointmentRecurrenceOccurrenceItems {
      ...AppointmentRecurrenceOccurrenceCalendarViewItemFragment
    }
    taskItems {
      ...TaskCalendarViewItemFragment
    }
    total
  }
  ${AppointmentCalendarViewItemFragment}
  ${AppointmentRecurrenceOccurrenceCalendarViewItemFragment}
  ${TaskCalendarViewItemFragment}
`)();

export interface Query  {
  __typename?: 'Query';
  admin: AdminRegistry;
  collections: CollectionsRegistry;
  entities: EntityRepositoryRegistry;
  screens: ScreenRegistry;
  services: ServicesRegistry;
  viewer: Viewer | null;
}
